webpackJsonp([0],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Flex__ = __webpack_require__(536);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Flex__["a"]; });




/***/ }),

/***/ 1000:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NHOldUpload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_json_stringify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_NHCore__ = __webpack_require__(8);














var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }




// import {createUuid} from 'xgui-for-react'


/**
 * 文件上传路径：
 * file模式：anonymity/docrepo/upload
 * redis模式：anonymity/zhxg-lxxt/proData/uploadRedis
 * 文件下载路径：
 * file模式：/anonymity/docrepo/download/file?attachmentId={uuid}
 * redis模式：anonymity/zhxg-lxxt/proData/downloadRedis
 */
var NHOldUpload = (_temp = _class = function (_React$Component) {
  _inherits(NHOldUpload, _React$Component);

  function NHOldUpload(props) {
    _classCallCheck(this, NHOldUpload);

    var _this = _possibleConstructorReturn(this, (NHOldUpload.__proto__ || __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default()(NHOldUpload)).call(this, props));

    _initialiseProps.call(_this);

    var fileList = props.value || props.defaultValue || props.fileList;
    _this.state = {
      fileList: fileList //上传的文件
    };
    return _this;
  }
  //设置可以传递参数的默认值


  _createClass(NHOldUpload, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {

      if ('fileList' in nextProps || 'value' in nextProps) {
        var fileList = nextProps.value || nextProps.fileList;
        if (__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_json_stringify___default()(fileList) === '[]' || typeof fileList === "undefined" || typeof fileList === 'string' && fileList.trim() === '') {
          this.setState({ fileList: [] });
        }
      }
    }

    //在组件挂载之前调用一次。如果在这个函数里面调用setState，本次的render函数可以看到更新后的state，并且只渲染一次。

  }, {
    key: 'UNSAFE_componentWillMount',
    value: function UNSAFE_componentWillMount() {

      if (this.props.fileList || this.props.value || this.props.defaultValue) {
        var propsfileList = this.props.value || this.props.fileList || this.props.defaultValue;
        var initFielList = propsfileList;
        if (typeof propsfileList === 'string') {
          initFielList = [];
          propsfileList.split(",").map(function (item) {
            initFielList.push({
              uuid: item.split(";")[0],
              name: item.split(";")[1]
            });
            return item;
          });
        }
        var fileList = [];
        initFielList.map(function (item, index) {
          fileList.push({
            uuid: item.uuid,
            uid: item.uuid,
            name: item.name,
            status: 'done',
            reponse: 'Server Error 500' // custom error message to show
            // url: 'http://www.baidu.com/xxx.png',
          });
          return item;
        });
        this.setState({
          fileList: fileList
        });
      }
    }
    //在组件挂载之后调用一次。

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}

    //判断文件是否满足要求文件格式的要求


    //文件上传之前执行的方法


    //文件上传改变事件


    //发送请求的时候的数据

  }, {
    key: 'render',
    value: function render() {
      var action = this.props.uploadType === 'file' ? 'anonymity/docrepo/upload' : window.baseUrl + '/proData/uploadRedis';
      return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_antd_lib_upload___default.a,
        {
          name: 'file'
          // accept={'application/vnd.openxmlformats-officedocument.presentationml.presentation'}  用来限制可以上传的文件，不是这种类型的会看不到
          , action: action,
          beforeUpload: this.beforeUpload,
          listType: 'text',
          onChange: this.handleChange,
          disabled: this.props.disabled,
          data: this.requestData(),
          fileList: this.state.fileList
        },
        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_antd_lib_button___default.a,
          { disabled: this.props.disabled },
          __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon___default.a, { type: 'upload' }),
          ' \u70B9\u51FB\u4E0A\u4F20'
        )
      );
    }
  }]);

  return NHOldUpload;
}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component), _class.defaultProps = {
  multiple: false, //是否支持上传多个文件，默认false
  fileList: [], //设置默认上传的内容，格式:[{uuid:'附件文档库的标志',name:'文件名称'}],只有uploadType为file(文档库)模式的时候才能使用此功能
  uploadType: 'file', //文件上传方式，file:文档库，redis:Redis缓存，如果是需要永久上传请使用文档库，如果只是暂存，建议使用redis缓存
  redisData: 30, //缓存时间,单位：分钟，设置缓存时间，意思是超过这个时间就会删除这个缓存信息
  fileCountLimit: undefined, //上传文件个数限制
  fileTypeLimit: undefined, //上传文件格式限制
  disabled: false, //是否禁用
  onChange: undefined, //值改变事件,参数：resultStr,resultList
  maxFileSize: 20 //默认上传最大大小限制20MB
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.checkTypeLimit = function (filename, fileTypeLimit) {
    for (var i = 0; i < fileTypeLimit.length; i++) {
      if (filename.toUpperCase().indexOf(fileTypeLimit[i].toUpperCase()) > -1) {
        return true;
      }
    }
    return false;
  };

  this.beforeUpload = function (file, fileList) {
    var suffixMap = {
      'word': ['.doc', '.docx'],
      'exce': ['.xls', '.xlsx'],
      'img': ['.png', '.jpeg', '.jpg', '.gif', '.bmp']
      //文件格式的限制
    };if (_this2.props.fileTypeLimit && _this2.props.fileTypeLimit.length > 0) {
      var fileTypeLimit = _this2.props.fileTypeLimit;
      for (var i = fileTypeLimit.length - 1; i >= 0; i--) {
        var list = suffixMap[fileTypeLimit[i]];
        if (list) {
          fileTypeLimit.splice(i, 1);
          for (var j = 0; j < list.length; j++) {
            fileTypeLimit.push(list[j]);
          }
        }
      }
      if (!_this2.checkTypeLimit(file.name, fileTypeLimit)) {
        __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.info("只能上传后缀为[" + fileTypeLimit.join(",") + "]格式的文件！");
        return false;
      }
    }
    //文件上传数量限制
    var fileCountLimit = _this2.props.multiple === false ? 1 : _this2.props.fileCountLimit;
    if (fileCountLimit && fileCountLimit <= _this2.state.fileList.length) {
      __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.info("最多只能上传" + fileCountLimit + "个文件！");
      return false;
    }

    //限制上传文件大小(默认上传大小限制20MB)
    var _props$maxFileSize = _this2.props.maxFileSize,
        maxFileSize = _props$maxFileSize === undefined ? 20 : _props$maxFileSize;

    var fileSize = file.size / 1024 / 1024;
    var isOverSize = fileSize > maxFileSize;

    if (isOverSize) {
      var msg = '抱歉，上传文件大小最大不能超过' + maxFileSize + 'M！';
      __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.error(msg);
      return !isOverSize;
    }

    return true;
  };

  this.handleChange = function (e) {
    var fileList = e.fileList;
    if (e.file.status === 'done') {
      //上传链接调用成功
      var response = e.file.response;
      if (_this2.props.uploadType === 'file') {
        //上传到文档库中
        if (response.meta && response.meta.statusCode === 200) {
          //导出成功
          fileList = fileList.map(function (file) {
            if (file.uid === e.file.uid) {
              file.uuid = response.data.ssbh;
            }
            return file;
          });
          _this2.getResult(fileList);
        } else {
          __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.error("文件上传失败，请重新上传！");
          fileList = _this2.filterCurrentFile(e.fileList, e.file);
        }
      } else {
        //上传到redis中缓存
        if (response.code === 200) {
          fileList = fileList.map(function (file) {
            if (file.uid === e.file.uid) {
              file.uuid = e.file.response.data;
            }
            return file;
          });
          _this2.getResult(fileList);
        } else {
          __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.error("文件上传失败，请重新上传！");
          fileList = _this2.filterCurrentFile(e.fileList, e.file);
        }
      }
    } else if (e.file.status === 'uploading') {//上传中，此时不需要做处理

    } else if (e.file.status === 'error') {
      //上传错误
      __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.error("文件由于未知原因失败，请重新上传！");
      fileList = _this2.filterCurrentFile(e.fileList, e.file);
    } else if (e.file.status === 'removed') {
      //删除
      _this2.getResult(fileList);
    }
    //beforeUpload返回false的时候，status状态值是undefined
    if (e.file.status) {
      _this2.setState({
        fileList: fileList
      });
    }
  };

  this.filterCurrentFile = function (list, currFile) {
    var fileList = [];
    list.map(function (file) {
      if (file.uid !== currFile.uid) {
        fileList.push(file);
      }
      return file;
    });
    return fileList;
  };

  this.requestData = function () {
    if (_this2.props.uploadType === 'file') {
      return { uuid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_NHCore__["c" /* createUuid */])(), type: '1' };
    } else {
      return { 'redisData': _this2.props.redisData };
    }
  };

  this.getResult = function (fileList) {
    var resultStr = '';
    var resultList = [];
    fileList.map(function (file) {
      resultList.push({
        uuid: file.uuid,
        name: file.name
      });
      resultStr += ',' + file.uuid + ';' + file.name;
      return file;
    });
    if (resultStr) {
      resultStr = resultStr.substring(1);
    }

    if (_this2.props.onChange) {
      _this2.props.onChange(resultStr, resultList);
    }
  };
}, _temp);


/***/ }),

/***/ 1001:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bdd_school; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return base_indexComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return base_printComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_Router_AsyncImport__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_SelfHelp_Bdd_pages_lydx_index__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_SelfHelp_Bdd_pages_lydx_print__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_SelfHelp_Bdd_pages_zszyjsxy_index__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_SelfHelp_Bdd_pages_zszyjsxy_print__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_SelfHelp_Bdd_pages_scjtzyxy_index__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_SelfHelp_Bdd_pages_scjtzyxy_print__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_SelfHelp_Bdd_pages_gznyzyxy_index__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_SelfHelp_Bdd_pages_gznyzyxy_print__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_SelfHelp_Bdd_pages_other_index__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_SelfHelp_Bdd_pages_other_print__ = __webpack_require__(541);












/**
 * 
 * @author qianzhiwei
 * @date 2020/09/25
 * 
 * @description 报到单学校模版配置
 * 
 * A:完全新报到单
 * 1、维护学校代码库 ：YXXT_BDD_SCHOOL【学校报到单模版】
 * 2、新增一个学校的报到单页面：在 @pages/SelfHelp/Bdd/pages 下新建学校代码库维护的代码名文件夹，包含 index 和 print 子文件夹，具体参考zszyjsxy
 * 3、配置动态路由参数 bdd_school { dm: 学校代码库常量值, mc: 学校代码库常量名, indexComponent: 报到单组件地址, printComponent: 打印单组件地址 }
 * 4、主页面编写在 print 文件夹下，index 报到单页面引用 print 下的页面即可。具体参考zszyjsxy
 * 
 * B:修改基线报到单
 * 1、复制 other 文件夹内容去新学校代码文件夹，然后子文件夹名不用修改
 * 2、修改样式文字之类的在 print 文件夹下的组件修改
 * 3、修改数据在 index 文件夹下的组件修改
 * 
 */

//报到单参数配置
var bdd_school = [{
    dm: 'lydx', mc: '联奕大学',
    // indexComponent: sync(() => import( /* webpackChunkName: 'lydx' */ '@pages/SelfHelp/Bdd/pages/lydx/index')),     //报到单
    // printComponent: sync(() => import( /* webpackChunkName: 'lydx' */ '@pages/SelfHelp/Bdd/pages/lydx/print'))      //打印单
    indexComponent: __WEBPACK_IMPORTED_MODULE_1__pages_SelfHelp_Bdd_pages_lydx_index__["default"],
    printComponent: __WEBPACK_IMPORTED_MODULE_2__pages_SelfHelp_Bdd_pages_lydx_print__["default"]
}, {
    dm: 'zszyjsxy', mc: '中山职业技术学院',
    // indexComponent: sync(() => import( /* webpackChunkName: 'zszyjsxy' */ '@pages/SelfHelp/Bdd/pages/zszyjsxy/index')),
    // printComponent: sync(() => import( /* webpackChunkName: 'zszyjsxy' */ '@pages/SelfHelp/Bdd/pages/zszyjsxy/print'))
    indexComponent: __WEBPACK_IMPORTED_MODULE_3__pages_SelfHelp_Bdd_pages_zszyjsxy_index__["a" /* default */],
    printComponent: __WEBPACK_IMPORTED_MODULE_4__pages_SelfHelp_Bdd_pages_zszyjsxy_print__["a" /* default */]
}, {
    dm: 'scjtzyxy', mc: '四川交通职业技术学院',
    // indexComponent: sync(() => import( /* webpackChunkName: 'lydx' */ '@pages/SelfHelp/Bdd/pages/scjtzyxy/index')),     //报到单
    // printComponent: sync(() => import( /* webpackChunkName: 'lydx' */ '@pages/SelfHelp/Bdd/pages/scjtzyxy/print'))      //打印单
    indexComponent: __WEBPACK_IMPORTED_MODULE_5__pages_SelfHelp_Bdd_pages_scjtzyxy_index__["a" /* default */],
    printComponent: __WEBPACK_IMPORTED_MODULE_6__pages_SelfHelp_Bdd_pages_scjtzyxy_print__["a" /* default */]
}, {
    dm: 'gznyzyxy', mc: '贵州农业职业学院',
    indexComponent: __WEBPACK_IMPORTED_MODULE_7__pages_SelfHelp_Bdd_pages_gznyzyxy_index__["a" /* default */],
    printComponent: __WEBPACK_IMPORTED_MODULE_8__pages_SelfHelp_Bdd_pages_gznyzyxy_print__["a" /* default */]
}, {
    dm: 'other', mc: '其它基线大学',
    // indexComponent: sync(() => import( /* webpackChunkName: 'lydx' */ '@pages/SelfHelp/Bdd/pages/other/index')),     //报到单
    // printComponent: sync(() => import( /* webpackChunkName: 'lydx' */ '@pages/SelfHelp/Bdd/pages/other/print'))      //打印单
    indexComponent: __WEBPACK_IMPORTED_MODULE_9__pages_SelfHelp_Bdd_pages_other_index__["a" /* default */],
    printComponent: __WEBPACK_IMPORTED_MODULE_10__pages_SelfHelp_Bdd_pages_other_print__["a" /* default */]
}];

var types = [{ value: 'index', name: '报到单' }, { value: 'print', name: '打印单' }];

var base_indexComponent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Router_AsyncImport__["a" /* asyncImport */])(function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 539));
});

var base_printComponent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_Router_AsyncImport__["a" /* asyncImport */])(function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 540));
});

/***/ }),

/***/ 1002:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OtherIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_SelfHelp_Bdd_pages_common__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_SelfHelp_Bdd_pages_gznyzyxy_print__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);





var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }









if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var schoolCode = 'gznyzyxy';
/**
 * @author qianzhiwei
 * @date 2020/09/27
 * @description 报到单
 */
var OtherIndex = (_temp = _class = function (_Component) {
    _inherits(OtherIndex, _Component);

    function OtherIndex(props) {
        _classCallCheck(this, OtherIndex);

        var _this = _possibleConstructorReturn(this, (OtherIndex.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(OtherIndex)).call(this, props));

        _this.getStudentPhotoBase64 = function (userId, callback) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/openapi/student/getStudentPhotoBase64', 'get', { xsid: userId, type: 10 }).then(function (res) {
                if (res && res.code == 200) {
                    callback(res.data);
                }
            });
        };

        _this.getCurrentSchool = function () {
            var params = {};
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])("/getCurrentXxmc", "GET", params).then(function (resData) {
                if (resData.data != null) {
                    _this.setState({ schoolName: resData.data });
                }
            });
        };

        _this.getCurrentYear = function () {
            var params = {};
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])("/zdybl/getCurrentYear", "GET", params).then(function (resData) {
                if (resData.data != null) {
                    _this.setState({ year: resData.data });
                }
            });
        };

        _this.getAccount = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (xsid == '') {}
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])("/zdybl/getAccount", "GET", { xsid: xsid }).then(function (resData) {
                if (resData.data != null) {
                    _this.setState({ account: resData.data });
                }
            });
        };

        _this.getPrintInfo = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (xsid == '') {}
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])("/zdybl/getInfoForPrint", 'GET', { xsid: xsid }).then(function (res) {
                if (res && res.data) {
                    _this.setState({ xsxx: res.data });
                }
            });
        };

        _this.getBddBz = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])('/zzbdCommon/getCssz', 'GET', { csbz: 'YXXT_BDD_BZ' }).then(function (res) {
                if (res && res.data) {
                    _this.setState({ bddbz: res.data });
                }
            });
        };

        _this.loadSfxmList = function (nextProps) {
            var xsxx = _this.state.xsxx;
            var xsid = xsxx.xsid,
                sfzjh = xsxx.sfzjh,
                xh = xsxx.xh;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/openapi/yxxt/getJfxxList', 'GET', { xsid: xsid, sfzjh: sfzjh, xh: xh }).then(function (res) {
                if (res && res.data) {
                    _this.setState({
                        sfxmList: res.data
                    });
                }
            });
        };

        _this.state = {
            xsxx: [], //学生信息
            schoolName: '', //学校名称
            year: '', //当前年度
            account: '', //默认账号
            bddbz: '',
            nr: [{
                key: 1,
                row_id: 1,
                nr: '交验录取通知书'
            }, {
                key: 2,
                row_id: 2,
                nr: '领取一卡通'
            }, {
                key: 3,
                row_id: 3,
                nr: '自愿购买保险'
            }, {
                key: 4,
                row_id: 4,
                nr: '自带床上用品检验'
            }, {
                key: 5,
                row_id: 5,
                nr: '领取宿舍钥匙'
            }, {
                key: 6,
                row_id: 6,
                nr: '参加体检'
            }],
            sfxmList: [], //缴费列表
            extraData: {} //额外参数
        };
        return _this;
    }

    _createClass(OtherIndex, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                this.getStudentPhotoBase64(userId, function (data) {
                    if (!data) return;
                    _this2.setState({
                        xsid: userId,
                        imageUrl: 'data:image/jpeg;base64,' + data
                    });
                });
            }
            this.getPrintInfo();
            this.getCurrentYear();
            this.getCurrentSchool();
            this.loadSfxmList();
            this.getAccount();
            this.getBddBz();
        }

        // 获取学生头像


        //获取当前学校


        //获取当前年度


        //获取当前账号


        //获取打印信息


        //获取报到单备注


        // 获取缴费信息

    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                xsxx = _state.xsxx,
                schoolName = _state.schoolName,
                year = _state.year,
                account = _state.account,
                bddbz = _state.bddbz,
                nr = _state.nr,
                sfxmList = _state.sfxmList,
                imageUrl = _state.imageUrl;

            var headimg = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img', { className: '_bg app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-index-__index__jbxx_icon', src: imageUrl,
                onError: function onError(e) {
                    e.target.src = stuDefault;
                }
            });
            var initFormDate = { xsxx: xsxx, schoolName: schoolName, year: year, account: account, nr: nr, bddbz: bddbz, headimg: headimg, sfxmList: sfxmList };
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5__pages_SelfHelp_Bdd_pages_common__["a" /* default */],
                    { schoolCode: schoolCode, initFormDate: initFormDate },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        'div',
                        { style: { marginLeft: "5%" } },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__pages_SelfHelp_Bdd_pages_gznyzyxy_print__["a" /* default */], { initFormDate: initFormDate })
                    )
                )
            );
        }
    }]);

    return OtherIndex;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]), _class.propTypes = {}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (OtherIndex);

/***/ }),

/***/ 1003:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OtherIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_SelfHelp_Bdd_pages_common__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_SelfHelp_Bdd_pages_other_print__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);





var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }









if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var schoolCode = 'lydx';
/**
 * @author qianzhiwei
 * @date 2020/09/27
 * @description 报到单
 */
var OtherIndex = (_temp = _class = function (_Component) {
    _inherits(OtherIndex, _Component);

    function OtherIndex(props) {
        _classCallCheck(this, OtherIndex);

        var _this = _possibleConstructorReturn(this, (OtherIndex.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(OtherIndex)).call(this, props));

        _this.getStudentPhotoBase64 = function (userId, callback) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/openapi/student/getStudentPhotoBase64', 'get', { xsid: userId, type: 10 }).then(function (res) {
                if (res && res.code == 200) {
                    callback(res.data);
                }
            });
        };

        _this.getCurrentSchool = function () {
            var params = {};
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])("/getCurrentXxmc", "GET", params).then(function (resData) {
                if (resData.data != null) {
                    _this.setState({ schoolName: resData.data });
                }
            });
        };

        _this.getCurrentYear = function () {
            var params = {};
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])("/zdybl/getCurrentYear", "GET", params).then(function (resData) {
                if (resData.data != null) {
                    _this.setState({ year: resData.data });
                }
            });
        };

        _this.getAccount = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (xsid == '') {}
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])("/zdybl/getAccount", "GET", { xsid: xsid }).then(function (resData) {
                if (resData.data != null) {
                    _this.setState({ account: resData.data });
                }
            });
        };

        _this.getPrintInfo = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (xsid == '') {}
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])("/zdybl/getInfoForPrint", 'GET', { xsid: xsid }).then(function (res) {
                if (res && res.data) {
                    _this.setState({ xsxx: res.data });
                }
            });
        };

        _this.getBddBz = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])('/zzbdCommon/getCssz', 'GET', { csbz: 'YXXT_BDD_BZ' }).then(function (res) {
                if (res && res.data) {
                    _this.setState({ bddbz: res.data });
                }
            });
        };

        _this.state = {
            xsxx: [], //学生信息
            schoolName: '', //学校名称
            year: '', //当前年度
            account: '', //默认账号
            bddbz: '',
            nr: [{
                key: 1,
                row_id: 1,
                nr: '交验录取通知书'
            }, {
                key: 2,
                row_id: 2,
                nr: '领取缴费收据'
            }, {
                key: 3,
                row_id: 3,
                nr: '购买床上用品'
            }, {
                key: 4,
                row_id: 4,
                nr: '领取宿舍钥匙'
            }, {
                key: 5,
                row_id: 5,
                nr: '领取军训服'
            }],
            extraData: {} //额外参数
        };
        return _this;
    }

    _createClass(OtherIndex, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                this.getStudentPhotoBase64(userId, function (data) {
                    if (!data) return;
                    _this2.setState({
                        xsid: userId,
                        imageUrl: 'data:image/jpeg;base64,' + data
                    });
                });
            }
            this.getPrintInfo();
            this.getCurrentYear();
            this.getCurrentSchool();
            this.getAccount();
            this.getBddBz();
        }
        // 获取学生头像


        //获取当前学校


        //获取当前年度


        //获取当前年度


        //获取打印信息


        //获取报到单备注

    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                xsxx = _state.xsxx,
                schoolName = _state.schoolName,
                year = _state.year,
                account = _state.account,
                bddbz = _state.bddbz,
                nr = _state.nr,
                imageUrl = _state.imageUrl;

            var headimg = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img', { className: '_bg app__css__app-pages-SelfHelp-Bdd-pages-other-index-__index__jbxx_icon', src: imageUrl,
                onError: function onError(e) {
                    e.target.src = stuDefault;
                }
            });
            var initFormDate = { xsxx: xsxx, schoolName: schoolName, year: year, account: account, nr: nr, bddbz: bddbz, headimg: headimg };
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5__pages_SelfHelp_Bdd_pages_common__["a" /* default */],
                    { schoolCode: schoolCode, initFormDate: initFormDate },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__pages_SelfHelp_Bdd_pages_other_print__["a" /* default */], { initFormDate: initFormDate })
                )
            );
        }
    }]);

    return OtherIndex;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]), _class.propTypes = {}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (OtherIndex);

/***/ }),

/***/ 1004:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OtherIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_SelfHelp_Bdd_pages_common__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_SelfHelp_Bdd_pages_scjtzyxy_print__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);





var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }









if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var schoolCode = 'scjtzyxy';
/**
 * @author qianzhiwei
 * @date 2020/09/27
 * @description 报到单
 */
var OtherIndex = (_temp = _class = function (_Component) {
    _inherits(OtherIndex, _Component);

    function OtherIndex(props) {
        _classCallCheck(this, OtherIndex);

        var _this = _possibleConstructorReturn(this, (OtherIndex.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(OtherIndex)).call(this, props));

        _this.getStudentPhotoBase64 = function (userId, callback) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/openapi/student/getStudentPhotoBase64', 'get', { xsid: userId, type: 10 }).then(function (res) {
                if (res && res.code == 200) {
                    callback(res.data);
                }
            });
        };

        _this.getCurrentSchool = function () {
            var params = {};
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])("/getCurrentXxmc", "GET", params).then(function (resData) {
                if (resData.data != null) {
                    _this.setState({ schoolName: resData.data });
                }
            });
        };

        _this.getCurrentYear = function () {
            var params = {};
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])("/zdybl/getCurrentYear", "GET", params).then(function (resData) {
                if (resData.data != null) {
                    _this.setState({ year: resData.data });
                }
            });
        };

        _this.getAccount = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (xsid == '') {}
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])("/zdybl/getAccount", "GET", { xsid: xsid }).then(function (resData) {
                if (resData.data != null) {
                    _this.setState({ account: resData.data });
                }
            });
        };

        _this.getPrintInfo = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (xsid == '') {}
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])("/zdybl/getInfoForPrint", 'GET', { xsid: xsid }).then(function (res) {
                if (res && res.data) {
                    _this.setState({ xsxx: res.data });
                }
            });
        };

        _this.getBddBz = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])('/zzbdCommon/getCssz', 'GET', { csbz: 'YXXT_BDD_BZ' }).then(function (res) {
                if (res && res.data) {
                    _this.setState({ bddbz: res.data });
                }
            });
        };

        _this.state = {
            xsxx: [], //学生信息
            schoolName: '', //学校名称
            year: '', //当前年度
            account: '', //默认账号
            bddbz: '',
            nr: [{
                key: 1,
                row_id: 1,
                nr: '交验录取通知书'
            }, {
                key: 2,
                row_id: 2,
                nr: '领取一卡通'
            }, {
                key: 3,
                row_id: 3,
                nr: '自愿购买保险'
            }, {
                key: 4,
                row_id: 4,
                nr: '自带床上用品检验'
            }, {
                key: 5,
                row_id: 5,
                nr: '领取宿舍钥匙'
            }, {
                key: 6,
                row_id: 6,
                nr: '参加体检'
            }],
            extraData: {} //额外参数
        };
        return _this;
    }

    _createClass(OtherIndex, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;

            if (userId) {
                this.getStudentPhotoBase64(userId, function (data) {
                    if (!data) return;
                    _this2.setState({
                        xsid: userId,
                        imageUrl: 'data:image/jpeg;base64,' + data
                    });
                });
            }
            this.getPrintInfo();
            this.getCurrentYear();
            this.getCurrentSchool();
            this.getAccount();
            this.getBddBz();
        }

        // 获取学生头像


        //获取当前学校


        //获取当前年度


        //获取当前年度


        //获取打印信息


        //获取报到单备注

    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                xsxx = _state.xsxx,
                schoolName = _state.schoolName,
                year = _state.year,
                account = _state.account,
                bddbz = _state.bddbz,
                nr = _state.nr,
                imageUrl = _state.imageUrl;

            var headimg = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img', { className: '_bg app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-index-__index__jbxx_icon', src: imageUrl,
                onError: function onError(e) {
                    e.target.src = stuDefault;
                }
            });
            var initFormDate = { xsxx: xsxx, schoolName: schoolName, year: year, account: account, nr: nr, bddbz: bddbz, headimg: headimg };
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5__pages_SelfHelp_Bdd_pages_common__["a" /* default */],
                    { schoolCode: schoolCode, initFormDate: initFormDate },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__pages_SelfHelp_Bdd_pages_scjtzyxy_print__["a" /* default */], { initFormDate: initFormDate })
                )
            );
        }
    }]);

    return OtherIndex;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]), _class.propTypes = {}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (OtherIndex);

/***/ }),

/***/ 1005:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ZszyjsxyIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_SelfHelp_Bdd_pages_common__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_SelfHelp_Bdd_pages_zszyjsxy_print__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);





var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }







if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var schoolCode = 'zszyjsxy';
/**
 * @author qianzhiwei
 * @date 2020/09/27
 * @description 报到单
 */
var ZszyjsxyIndex = (_temp = _class = function (_Component) {
    _inherits(ZszyjsxyIndex, _Component);

    function ZszyjsxyIndex(props) {
        _classCallCheck(this, ZszyjsxyIndex);

        var _this = _possibleConstructorReturn(this, (ZszyjsxyIndex.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(ZszyjsxyIndex)).call(this, props));

        _this.state = {
            extraData: {} //额外参数
        };
        return _this;
    }

    _createClass(ZszyjsxyIndex, [{
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6__pages_SelfHelp_Bdd_pages_common__["a" /* default */],
                    { schoolCode: schoolCode },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__pages_SelfHelp_Bdd_pages_zszyjsxy_print__["a" /* default */], null)
                )
            );
        }
    }]);

    return ZszyjsxyIndex;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]), _class.propTypes = {}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (ZszyjsxyIndex);

/***/ }),

/***/ 1006:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dorm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_checkbox_style__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_checkbox__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__index_css__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_getSize__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_common_NHModal__ = __webpack_require__(106);

















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }








// import SelectBox from './selectBox';
// import SelectModal from './selectModal';











if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_26_history_createHashHistory___default()();
var confirm = __WEBPACK_IMPORTED_MODULE_15_antd_lib_modal___default.a.confirm;
var CheckboxGroup = __WEBPACK_IMPORTED_MODULE_13_antd_lib_checkbox___default.a.Group;
var RadioGroup = __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default.a.Group;

/**
 * @author weishihuai
 * @date 2018/7/6
 * @time 14:41
 * @Description: 迎新网站-自助报到-宿舍分配
 */

var Dorm = function (_React$Component) {
    _inherits(Dorm, _React$Component);

    function Dorm(props) {
        _classCallCheck(this, Dorm);

        var _this = _possibleConstructorReturn(this, (Dorm.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(Dorm)).call(this, props));

        _this.getCssz = function () {
            var params = { csbz: "YXXT_SSXX_SFXSCWH" };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])('/zzbdCommon/getCssz', 'GET', params).then(function (res) {
                if (res && res.data) {
                    _this.setState({
                        cwhFlag: res.data == 'true' ? true : false
                    });
                }
            });
        };

        _this.getSsinfo = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (xsid) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])('/newStudent/queryStuInfo', 'GET', { 'xsid': xsid }).then(function (res) {
                    if (res && res.data) {
                        var stuInfo = res.data.stuInfo.userBaseInfo;
                        var stuXxcj = res.data.stuXxcj;
                        var stuSsxx = res.data.stuSsxx;
                        _this.setState({
                            stuInfo: stuInfo,
                            stuXxcj: stuXxcj,
                            stuSsxx: stuSsxx
                        });
                        if (stuSsxx == null) {
                            //如果没有宿舍信息则自动分配
                            _this.handleAutoDistributeListener();
                        }
                    }
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error("登录超时,请重新登录！");
            }
        };

        _this.queryQztjAndYlhj = function (callback) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getUrlParams('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj && kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (callback) {
                        callback(_this.state.operable);
                    }
                }
            });
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_30__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.getUrlParams = function (param) {
            return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.handleAutoDistributeListener = function () {
            _this.setState({
                autoBlLoading: true
            });
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this.getUrlParams("pkid");
            if (!xsid) {
                __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.warning("登录过期请重新登录！");
                return;
            }
            //自动分配宿舍
            var params = {
                xsid: xsid,
                zzbdhjid: zzbdhjid
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])("/zxssFe/yxwzAutoDistributeSscwxx", 'POST', params).then(function (res) {
                if (res) {
                    console.log("自动分配宿舍:", res, res.data);
                    if (res.data === 1) {
                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.info("自动分配宿舍成功！");
                        _this.setState({
                            autoBlLoading: false
                        });
                        _this.getSsinfo();
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error("自动分配宿舍失败,请稍后重试！");
                    _this.setState({
                        autoBlLoading: false
                    });
                }
            }).catch(function () {
                __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error("自动分配宿舍失败,请稍后重试！");
                _this.setState({
                    autoBlLoading: false
                });
            });
        };

        _this.state = {
            mkbz: 'GD006_5',
            hjmc: '',
            xzId: '',
            _xzId: '',
            cwsList: [], //床位数
            sfbzList: [], //收费标准
            xqList: [], //校区信息
            currentXqid: "", //当前校区ID
            fjxxList: [], //房间信息
            currentClickCwPkid: "", //当前床位信息ID
            xsssruYwxx: {}, //学生宿舍入住业务信息
            isHjLinked: false, //环节是否办理状态
            param: {}, //过滤条件
            scrollHeight: 200, //默认滚动高度
            loginUserInfo: {}, //当前登录学生信息
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            autoBlLoading: false, //自动办理按钮载入状态
            cancelLoading: false, //取消办理按钮载入状态
            zdrzLoading: false, //自动入住载入状态
            setRoom: [], //过滤房间信息
            sfbz: "", //收费标准选中值
            stuInfo: {},
            stuXxcj: {},
            stuSsxx: {},
            cwhFlag: true
        };
        return _this;
    }

    _createClass(Dorm, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var that = this;
            this.setState({ scrollHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_getSize__["a" /* default */])().windowH - 206 });
            window.onresize = function () {
                that.setState({
                    scrollHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_getSize__["a" /* default */])().windowH - 206
                });
            };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.queryQztjAndYlhj(function (operable) {
                if (operable) {
                    _this2.getSsinfo();
                    _this2.getCssz();
                }
            });
        }

        //查询前置条件和依赖环节


        //获取url中传递的参数


        //重新加载菜单


        //自动办理事件

    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                stuInfo = _state.stuInfo,
                stuXxcj = _state.stuXxcj,
                stuSsxx = _state.stuSsxx,
                cwhFlag = _state.cwhFlag;

            return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_19__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230',
                        mkbz: this.state.mkbz
                        /*   active={5}*/
                        , menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_19__components__["a" /* Flex */].Item,
                        { className: 'page_con_r ' },
                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1037811784' + ' ' + 'box'
                            },
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__pages_Assembly_titleTop__["a" /* default */], {
                                className: 'mt-20',
                                title: this.state.hjmc,
                                extra: false
                            }),
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                'div',
                                { style: { marginTop: "10px" }, className: 'jsx-1037811784'
                                },
                                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_row___default.a,
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                        {
                                            style: { textAlign: "center", padding: "10px" },
                                            span: 8
                                        },
                                        '\u59D3\u540D\uFF1A',
                                        stuInfo ? stuInfo.XM : ""
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                        {
                                            style: { textAlign: "center", padding: "10px" },
                                            span: 8
                                        },
                                        '\u6821\u533A\u540D\u79F0\uFF1A',
                                        stuSsxx ? stuSsxx.xqmc : ""
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                        {
                                            style: { textAlign: "center", padding: "10px" },
                                            span: 8
                                        },
                                        '\u697C\u680B\uFF1A',
                                        stuSsxx ? stuSsxx.ldmc : ""
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_row___default.a,
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                        {
                                            style: { textAlign: "center", padding: "10px" },
                                            span: 8
                                        },
                                        '\u697C\u5C42\uFF1A',
                                        stuSsxx ? stuSsxx.lcmc : ""
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                        {
                                            style: { textAlign: "center", padding: "10px" },
                                            span: 8
                                        },
                                        '\u623F\u95F4\u53F7\uFF1A',
                                        stuSsxx ? stuSsxx.fj : ""
                                    ),
                                    cwhFlag ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                        {
                                            style: { textAlign: "center", padding: "10px" },
                                            span: 8
                                        },
                                        '\u5E8A\u4F4D\u53F7\uFF1A',
                                        stuSsxx ? stuSsxx.cwh : ""
                                    ) : null
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1037811784' + ' ' + 'text-center mt-50'
                                },
                                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                            ),
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_styled_jsx_style___default.a, {
                                styleId: '1037811784',
                                css: ['.ant-result-title{font-size:20px!important;}']
                            })
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__common__["a" /* default */], { hjmc: "宿舍信息查看", key: 'GD006_5', mkbz: 'GD006_5', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return Dorm;
}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);



/***/ }),

/***/ 1007:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnLv; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_spin_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_spin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_input_number_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_input_number__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_radio_style__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_radio__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__utils_request__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__utils_globalUtil__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_SelfHelp_anLv_view__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_SelfHelp_common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_common_NHFormItem__ = __webpack_require__(43);






























var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }












var Dragger = __WEBPACK_IMPORTED_MODULE_28_antd_lib_upload___default.a.Dragger;






var TextArea = __WEBPACK_IMPORTED_MODULE_26_antd_lib_input___default.a.TextArea;

var FormItem = __WEBPACK_IMPORTED_MODULE_24_antd_lib_form___default.a.Item;
var baseUrl = '/api/zhxg-yxxt';

var AnLv = (_dec = __WEBPACK_IMPORTED_MODULE_24_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(AnLv, _React$Component);

    function AnLv(props) {
        _classCallCheck(this, AnLv);

        var _this = _possibleConstructorReturn(this, (AnLv.__proto__ || __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_prototype_of___default()(AnLv)).call(this, props));

        _this.queryQztjAndYlhj = function (callback) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_globalUtil__["b" /* getQueryString */])('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1' || ylhj && ylhj.length > 0 || qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                    if (callback) {
                        callback(_this.state.operable);
                    }
                }
            });
        };

        _this.loadLstdBlyy = function (dmbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHFetch__["a" /* default */])("/openapi/yxwz/getDmk", "GET", _defineProperty({ dmbz: dmbz }, 'dmbz', dmbz)).then(function (res) {
                if (!res || res.code !== 200) return __WEBPACK_IMPORTED_MODULE_21_antd_lib_message___default.a.error('系统繁忙，请联系管理员!');
                _this.setState({ blYyList: res.data });
            });
        };

        _this.onChange = function (event) {
            _this.props.form.setFieldsValue({ blyy: null }); //重置办理原因选中值
            _this.setState({ fdm: event.target.value, blYyValue: '' });
        };

        _this.onChange1 = function (event) {
            _this.setState({ blYyValue: event.target.value });
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_42__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.loadLstdInfo = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_36__utils_request__["b" /* get */])(baseUrl + '/yxwz/zzbd/lstdAhgs/getLstdInfoByXsid').then(function (res) {
                if (res && res.code === 200) {
                    if (!res.data) {
                        _this.setState({
                            data: {},
                            fileList: [],
                            submitFlag: false,
                            fdm: 1,
                            blYyValue: ''
                        });
                        _this.props.form.resetFields();
                        return;
                    }
                    var fileList = [];
                    res.data['fj'] && res.data['fj'].forEach(function (elem) {
                        //格式化对于附件取值
                        var file = {
                            uid: elem.fjid,
                            name: elem.fjmc,
                            response: {
                                data: {
                                    ssbh: elem.fjid,
                                    fjmc: elem.fjmc
                                }
                            },
                            status: 'done'
                        };
                        fileList.push(file);
                    });
                    if (res.data.shzt != '9') _this.setState({ submitFlag: true });
                    _this.setState({
                        data: res.data,
                        fdm: res.data.fdm,
                        fileList: fileList,
                        blYyValue: res.data.dklx
                    });
                    _this.props.form.setFieldsValue({ fj: { fileList: fileList } });
                } else {
                    _this.setState({ data: {}, fileList: [] });
                    _this.props.form.resetFields();
                }
            });
        };

        _this.getBase64 = function (img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        };

        _this.handlePreview = function (file) {
            var isImage = /^image\/.*$/i.test(file.type);
            if (isImage) {
                if (file) {
                    _this.getBase64(file, function (imageUrl) {
                        _this.setState({
                            previewImage: imageUrl,
                            previewVisible: true
                        });
                    });
                } else {
                    _this.setState({
                        previewImage: file.url || file.thumbUrl,
                        previewVisible: true
                    });
                }
            } else if (file && file['response'] && file['response']['data']) {
                //其他情况
                var _isImage = true;
                var fjmc = file['response']['data']['fjmc'];
                var ssbh = file['response']['data']['ssbh'];
                if (!_this.setJudge(fjmc, _this.state.judgeImgList)) {
                    _isImage = false;
                }

                if (_isImage) {
                    _this.showPreview('anonymity/docrepo/download/file?attachmentId=' + ssbh);
                } else {
                    window.open('anonymity/docrepo/download/file?attachmentId=' + ssbh);
                }
            }
        };

        _this.showPreview = function (url) {
            _this.setState({
                previewImage: url,
                previewVisible: true
            });
        };

        _this.handleCancel = function () {
            return _this.setState({ previewVisible: false });
        };

        _this.handleSubmit = function (e) {
            _this.setState({ loading: true });
            e.preventDefault();
            _this.props.form.validateFieldsAndScroll(function (err, values) {
                if (err) {
                    _this.setState({ loading: false });
                    return false;
                }
                var fj = values['fj'];
                var fjlist = [];
                if (fj) {
                    var size = fj['fileList'].length;
                    var file = fj['fileList'].filter(function (file) {
                        if (file.status === 'error') {
                            return false;
                        }
                        return true;
                    });
                    if (file.length !== size) {
                        _this.props.form.setFields({
                            fj: {
                                value: fj,
                                errors: [new Error('材料上传出错，请重新上传!')]
                            }
                        });
                        _this.setState({ loading: false });
                        return false;
                    }

                    var fileList = fj['fileList'];
                    fileList.forEach(function (element) {
                        var fjid = element.response.data.ssbh;
                        var fjmc = element.name;
                        fjlist.push({
                            fjid: fjid,
                            fjmc: fjmc
                        });
                    });
                }

                if (fjlist.length === 0) fjlist = undefined;
                console.log('附件:', fjlist);
                var blyy = values.blyy,
                    blje = values.blje,
                    sqsm = values.sqsm,
                    dkyh = values.dkyh,
                    hzjym = values.hzjym,
                    pkid = values.pkid;

                var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHCore__["b" /* getLoginUser */])().userId;
                var zzbdhjid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_globalUtil__["b" /* getQueryString */])('pkid');
                var params = {
                    fj: fjlist, //附件
                    dklx: blyy, //办理原因
                    blje: blje, //贷款金额
                    sqsm: sqsm, //申请理由
                    hzjym: hzjym, //回执检验码
                    dkyh: dkyh, //贷款银行
                    xsid: xsid, //学生id
                    zzbdhjid: zzbdhjid, //环节id
                    pkid: pkid, //流程id
                    sjly: 2, //数据来源：1.迎新现场办理\2.学生申请
                    shzt: 0 //审核状态
                };
                console.log('params:', params);
                if (!pkid) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_36__utils_request__["c" /* post */])(baseUrl + '/yxwz/zzbd/lstdAhgs/insert', params).then(function (res) {
                        _this.setState({ loading: false });
                        if (!res || res.code !== 200 || res.data != 1) return __WEBPACK_IMPORTED_MODULE_21_antd_lib_message___default.a.error("提交失败!");
                        __WEBPACK_IMPORTED_MODULE_21_antd_lib_message___default.a.success("绿色通道申请提交成功。");
                        _this.loadLstdInfo();
                        _this.reloadMenu();
                    }).catch(function (res) {
                        _this.setState({ loading: false });
                        return res;
                    });
                } else {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_36__utils_request__["c" /* post */])(baseUrl + '/yxwz/zzbd/lstdAhgs/update', params).then(function (res) {
                        _this.setState({ loading: false });
                        if (!res || res.code !== 200 || res.data != 1) return __WEBPACK_IMPORTED_MODULE_21_antd_lib_message___default.a.warning("绿色通道申请修改失败，请重试!");
                        __WEBPACK_IMPORTED_MODULE_21_antd_lib_message___default.a.success("绿色通道申请修改成功。");
                        _this.loadLstdInfo();
                        _this.reloadMenu();
                    }).catch(function (res) {
                        _this.setState({ loading: false });
                        return res;
                    });
                }
            });
        };

        _this.handleChange = function (_ref) {
            var fileList = _ref.fileList;

            var count = 0;
            fileList.map(function (elem) {
                if (elem && elem['status'] && elem['status'] === 'uploading') {
                    _this.setState({ uploading: true });
                    return;
                } else if (elem && elem['status']) {
                    count++;
                }
            });
            if (count > 0) {
                _this.setState({ uploading: false });
            }
        };

        _this.setJudge = function (name, map) {
            var flag = false;
            map.map(function (item) {
                if (name.indexOf(item) !== -1) {
                    flag = true;
                }
            });
            return flag;
        };

        _this.beforeUpload = function (file) {
            if (!(_this.setJudge(file.name, _this.state.judgeImgList) || _this.setJudge(file.name, _this.state.judgeFileList))) {
                __WEBPACK_IMPORTED_MODULE_21_antd_lib_message___default.a.error('不能上传该格式文件');
                return false;
            } else {
                return true;
            }
        };

        _this.remove = function (ssbh) {
            var url = 'api/docrepo/attachment/sourceId/delete?souerceId=' + ssbh;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHFetch__["a" /* default */])(url, "POST").then(function (res) {
                if (res.data && res.data > 0) {
                    __WEBPACK_IMPORTED_MODULE_21_antd_lib_message___default.a.success('已删除材料.');
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD005_8',
            hjmc: '',
            uploading: false,
            loading: false,
            previewVisible: false,
            fileList: [],
            checkGroup: [], //绿色通道办理原因
            data: {}, //绿色通道申请信息
            nextUrl: '',
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            fdm: 1, //默认办理方式
            judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'], //可以导入的图片格式
            judgeFileList: ['.pdf', '.PDF', '.doc', '.DOC', '.zip', '.ZIP', '.txt', '.TXT', '.xls', '.XLS', '.rar', '.RAR'], //可以导入的非图片格式
            blYyList: [], //总办理原因
            blYyValue: '', //选中的办理原因
            submitFlag: false //是否提交
        };
        return _this;
    }

    _createClass(AnLv, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.queryQztjAndYlhj(function (operable) {
                if (operable) {
                    _this2.loadLstdBlyy('AHGS_YXXT_LSTD_BLYY'); //获取办理原因
                    _this2.loadLstdInfo(); //查询申请后的信息
                }
            });
        }

        //查询前置条件和依赖环节

        // 获取办理原因


        // 选择办理方式

        // 选择办理原因


        //查询学生的绿色通道申请信息


        // 转化base64


        // 点击文件链接或预览图标时的回调


        // 关闭图片弹窗


        // 提交


        /* 附件上传与处理部分---start */
        //判断文件类型是否正常  name：文件名称  map：类型范围数组  true正常

        /* end */

        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var form = this.props.form;
            var getFieldDecorator = form.getFieldDecorator;
            var _state = this.state,
                previewImage = _state.previewImage,
                previewVisible = _state.previewVisible,
                submitFlag = _state.submitFlag,
                fdm = _state.fdm,
                data = _state.data,
                blYyList = _state.blYyList,
                blYyValue = _state.blYyValue;

            var props = {
                name: 'file',
                action: 'anonymity/docrepo/upload',
                data: { uuid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHCore__["c" /* createUuid */])(), type: '1' },

                onRemove: function onRemove(file) {
                    _this3.setState(function (_ref2) {
                        var fileList = _ref2.fileList;

                        var index = fileList.indexOf(file);
                        var newFileList = fileList.slice();
                        newFileList.splice(index, 1);
                        _this3.props.form.setFieldsValue({ fj: { fileList: newFileList } });
                        return {
                            fileList: newFileList
                        };
                    }, function () {
                        if (file.response && file.response.data && file.response.data.ssbh) {
                            _this3.remove(file.response.data.ssbh);
                        }
                    });
                },
                beforeUpload: function beforeUpload(file) {
                    if (!_this3.beforeUpload(file)) {
                        return false;
                    }
                    _this3.setState(function (_ref3) {
                        var fileList = _ref3.fileList;
                        return {
                            fileList: [].concat(_toConsumableArray(fileList), [file])
                        };
                    });
                    return true;
                },
                onChange: function onChange(file) {
                    _this3.handleChange(file);
                },
                onPreview: this.handlePreview,
                fileList: this.state.fileList
            };
            // 设置展示免缴学费
            var showList = blYyList.filter(function (item) {
                return item.FDM == fdm;
            });
            var formItemLayout = {
                labelCol: { span: 6 },
                wrapperCol: { span: 16 }
            };
            return __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                'div',
                { style: { position: 'relative' } },
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_30__components__["a" /* Flex */],
                        { className: 'w1180 mt-20', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__pages_Assembly_siderMenu__["a" /* default */], {
                            ref: "siderMenu",
                            setMenuList: this.setMenuList,
                            title: '\u81EA\u52A9\u62A5\u5230',
                            mkbz: this.state.mkbz,
                            menuType: '\u81EA\u52A9\u62A5\u5230' }),
                        __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_30__components__["a" /* Flex */].Item,
                            { className: 'page_con_r ' },
                            __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__pages_Assembly_Breadcrumb__["a" /* default */], {
                                noLine: true,
                                list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                            }),
                            __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                'div',
                                { className: 'box' },
                                __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__pages_SelfHelp_common_hint__["a" /* default */], null),
                                !submitFlag ? __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_24_antd_lib_form___default.a,
                                    { onSubmit: this.handleSubmit },
                                    __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u4FE1\u606F', extra: false }),
                                    __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                        'div',
                                        { className: 'p-sw' },
                                        __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                            'div',
                                            { style: { display: 'none' } },
                                            __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_44__components_common_NHFormItem__["a" /* default */],
                                                { id: 'pkid', initialValue: data['pkid'], form: form },
                                                __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_antd_lib_input___default.a, null)
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                            'div',
                                            { style: { marginLeft: "30px" } },
                                            __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_44__components_common_NHFormItem__["a" /* default */],
                                                { id: 'blfs', required: true, initialValue: Number(fdm), form: form,
                                                    formItemLayout: { labelCol: { span: 4 }, wrapperCol: { span: 16 } }, label: '\u529E\u7406\u65B9\u5F0F' },
                                                __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_19_antd_lib_radio___default.a.Group,
                                                    { name: 'radiogroup', onChange: this.onChange },
                                                    __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_19_antd_lib_radio___default.a,
                                                        { value: 1 },
                                                        '\u514D\u7F34\u5B66\u8D39'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_19_antd_lib_radio___default.a,
                                                        { value: 2 },
                                                        '\u7F13\u7F34\u5B66\u8D39'
                                                    )
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_44__components_common_NHFormItem__["a" /* default */],
                                                { id: 'blyy', required: true, initialValue: data['dklx'] ? data['dklx'] : null, form: form,
                                                    formItemLayout: { labelCol: { span: 4 }, wrapperCol: { span: 16 } }, label: '\u529E\u7406\u539F\u56E0' },
                                                __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_19_antd_lib_radio___default.a.Group,
                                                    { name: 'radiogroup', onChange: this.onChange1 },
                                                    showList.map(function (item) {
                                                        return __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_19_antd_lib_radio___default.a,
                                                            { value: item.DM, key: item.PXH },
                                                            item.MC
                                                        );
                                                    })
                                                )
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item', style: { marginLeft: '7%' } },
                                            fdm == 2 && __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_44__components_common_NHFormItem__["a" /* default */],
                                                { id: 'sqsm', required: true, initialValue: data['sqsm'], form: form,
                                                    formItemLayout: formItemLayout, label: '\u7533\u8BF7\u7406\u7531' },
                                                __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(TextArea, { maxLength: 50, placeholder: '\u8BF7\u586B\u5199\u7533\u8BF7\u7406\u7531' })
                                            ),
                                            blYyValue && blYyValue === 'syddk' && __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                'div',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_44__components_common_NHFormItem__["a" /* default */],
                                                    { id: 'blje', initialValue: data['blje'], form: form, formItemLayout: formItemLayout, label: '\u8D37\u6B3E\u91D1\u989D' },
                                                    __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_input_number___default.a, { style: { width: '100%' }, min: 0, max: 9999999, precision: 0, placeholder: '\u8BF7\u586B\u5199\u8D37\u6B3E\u91D1\u989D\uFF08\u5143\uFF09' })
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_44__components_common_NHFormItem__["a" /* default */],
                                                    { id: 'dkyh', initialValue: data['dkyh'], form: form, formItemLayout: formItemLayout, label: '\u8D37\u6B3E\u94F6\u884C' },
                                                    __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__components_common_NHSelect__["a" /* default */], { sign: "dmk_yxwz_dkyh", onChange: function onChange(v) {} })
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_44__components_common_NHFormItem__["a" /* default */],
                                                    { id: 'hzjym', initialValue: data['hzjym'], form: form, formItemLayout: formItemLayout, label: '\u56DE\u6267\u6821\u9A8C\u7801' },
                                                    __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_antd_lib_input___default.a, { placeholder: '\u8BF7\u8F93\u5165\u56DE\u6267\u6821\u9A8C\u7801' })
                                                )
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u6750\u6599', extra: false }),
                                    __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                        'div',
                                        { className: 'p-sw' },
                                        __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item', style: { marginLeft: '7%' } },
                                            __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                FormItem,
                                                {
                                                    labelCol: { span: 8 },
                                                    wrapperCol: { span: 16 },
                                                    label: '\u4E0A\u4F20\u53D7\u7406\u8BC1\u660E'
                                                },
                                                getFieldDecorator('fj')(__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                    Dragger,
                                                    props,
                                                    __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                        'p',
                                                        { className: 'ant-upload-drag-icon' },
                                                        __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a, { type: 'inbox' })
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_spin___default.a, { spinning: this.state.uploading }),
                                                    __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                        'p',
                                                        { className: 'ant-upload-text font-14' },
                                                        '\u70B9\u51FB\u6B64\u5904\u6216\u62D6\u62FD\u6587\u4EF6\u5230\u6B64'
                                                    )
                                                ))
                                            )
                                        )
                                    ),
                                    data['shzt'] === '9' ? __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                        'div',
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__pages_Assembly_titleTop__["a" /* default */], { title: '\u5BA1\u6838\u4FE1\u606F', extra: false }),
                                        __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                            'div',
                                            { className: 'p-sw' },
                                            __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                'div',
                                                { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                                                __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,
                                                    { gutter: 24 },
                                                    __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,
                                                        { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                                        __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                            'span',
                                                            {
                                                                style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                                            '\u5BA1\u6838\u610F\u89C1\xA0: '
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,
                                                        { span: 20 },
                                                        __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                            'span',
                                                            null,
                                                            data['shyj']
                                                        )
                                                    )
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement('br', null),
                                            __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                'div',
                                                { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                                                __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,
                                                    { gutter: 24 },
                                                    __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,
                                                        { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                                        __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                            'span',
                                                            {
                                                                style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                                            '\u5BA1\u6838\u72B6\u6001\xA0: '
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,
                                                        { span: 20 },
                                                        __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                                            'span',
                                                            { style: { color: '#0066FF' } },
                                                            '\u9A73\u56DE'
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    ) : "",
                                    __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,
                                            { type: 'primary', htmlType: 'submit' },
                                            '\u4FDD\u5B58'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__pages_SelfHelp_anLv_view__["a" /* default */], { reloadMenu: this.reloadMenu, nextUrl: this.state.nextUrl, loadLstdInfo: this.loadLstdInfo,
                                    search: this.state.search, showPreview: this.showPreview, setJudge: this.setJudge, data: data, judgeImgList: this.state.judgeImgList })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a,
                        {
                            visible: previewVisible,
                            footer: null,
                            onCancel: this.handleCancel
                        },
                        __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement('img', {
                            alt: 'example',
                            style: { width: '100%' },
                            src: previewImage
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_spin___default.a, { style: { position: 'absolute', top: '300px', left: '60%' }, spinning: this.state.loading })
                ) : __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__pages_SelfHelp_common__["a" /* default */], { hjmc: "绿色通道申请", key: "GD005_8", mkbz: 'GD005_8', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return AnLv;
}(__WEBPACK_IMPORTED_MODULE_29_react___default.a.Component)) || _class);


/***/ }),

/***/ 1008:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return View; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_globalUtil__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);













var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }








var shztList = {
    '-1': '审核不通过',
    '0': '未审核',
    '1': '审核通过',
    '2': '已办理',
    '9': '驳回'
};

var View = function (_React$Component) {
    _inherits(View, _React$Component);

    function View(props) {
        _classCallCheck(this, View);

        var _this = _possibleConstructorReturn(this, (View.__proto__ || __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default()(View)).call(this, props));

        _this.cancel = function (lstdid, shzt) {
            if (shzt !== '0') return __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warning('该申请已经审核，不能取消');
            var pkid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_globalUtil__["b" /* getQueryString */])("pkid");
            var params = {
                zzbdhjid: pkid,
                pkid: lstdid
            };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_NHFetch__["a" /* default */])("/lstd/deleteByParams", "POST", params).then(function (res) {
                if (res && res.data && res.data > 0) {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.success("取消成功");
                    _this.props.loadLstdInfo();
                    _this.props.reloadMenu();
                } else {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warning("取消异常");
                }
            });
        };

        _this.handlePreview = function (fjmc, fjid) {
            var isImage = true;
            if (!_this.props.setJudge(fjmc, _this.props.judgeImgList)) {
                isImage = false;
            }

            if (isImage) {
                _this.props.showPreview('anonymity/docrepo/download/file?attachmentId=' + fjid);
            } else {
                window.open('anonymity/docrepo/download/file?attachmentId=' + fjid);
            }
        };

        _this.state = {
            nextUrl: _this.props.nextUrl,
            search: _this.props.search
        };
        return _this;
    }

    _createClass(View, [{
        key: 'componentDidMount',
        value: function componentDidMount() {}
        // 取消申请


        // 点击文件链接或预览图标时的回调

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var data = this.props.data;

            return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u4FE1\u606F', extra: false }),
                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '20px' } },
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', marginTop: "3px", paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u529E\u7406\u539F\u56E0\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['dklxmc']
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%' } },
                        data['fdm'] && data['fdm'] == '2' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                                { gutter: 24 },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                    { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                        'span',
                                        {
                                            style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                        '\u7533\u8BF7\u7406\u7531\xA0: '
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                    { span: 20 },
                                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                        'span',
                                        null,
                                        data['sqsm']
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)
                        ),
                        data['dklx'] && data['dklx'] === 'syddk' && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                                { gutter: 24 },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                    { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                        'span',
                                        {
                                            style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                        '\u8D37\u6B3E\u91D1\u989D\xA0: '
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                    { span: 20 },
                                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                        'span',
                                        null,
                                        data['blje'] ? data['blje'] : 0,
                                        '\u5143'
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                                { gutter: 24 },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                    { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                        'span',
                                        {
                                            style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                        '\u8D37\u6B3E\u94F6\u884C\xA0: '
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                    { span: 20 },
                                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                        'span',
                                        null,
                                        data['dkyhmc'] ? data['dkyhmc'] : '暂无'
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                                { gutter: 24 },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                    { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                        'span',
                                        {
                                            style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                        '\u56DE\u6267\u6821\u9A8C\u7801\xA0: '
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                    { span: 20 },
                                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                        'span',
                                        null,
                                        data['hzjym'] ? data['hzjym'] : '暂无'
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u6750\u6599', extra: false }),
                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%' } },
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u6750\u6599\u8BC1\u660E\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                data['fj'] ? data['fj'].map(function (elem, index) {
                                    return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                        'div',
                                        { style: { marginBottom: '20px' }, key: index },
                                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                            'a',
                                            { onClick: function onClick() {
                                                    _this2.handlePreview(elem['fjmc'], elem['fjid']);
                                                } },
                                            elem['fjmc']
                                        )
                                    );
                                }) : __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'span',
                                    null,
                                    '\u6682\u65E0'
                                )
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u5BA1\u6838', extra: false }),
                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u5BA1\u6838\u610F\u89C1\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['shyj']
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u5BA1\u6838\u72B6\u6001\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'span',
                                    { style: { color: '#0066FF' } },
                                    shztList[data['shzt']]
                                )
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                    'div',
                    { className: 'text-center mt-50' },
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                        { type: 'primary', onClick: function onClick() {
                                _this2.cancel(data['pkid'], data['shzt']);
                            } },
                        '\u53D6\u6D88'
                    ),
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                )
            );
        }
    }]);

    return View;
}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);



/***/ }),

/***/ 1009:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return antiepidemic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_index__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_common_NHMultiSelect__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_common_NHCascader__ = __webpack_require__(108);












var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }



















var history = __WEBPACK_IMPORTED_MODULE_22_history_createHashHistory___default()();

var basicUrl = "api/zhxg-yxxt/yxwz";
var FormItem = __WEBPACK_IMPORTED_MODULE_10_antd_lib_form___default.a.Item;

var formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 }
};

var antiepidemic = (_dec = __WEBPACK_IMPORTED_MODULE_10_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(antiepidemic, _React$Component);

    function antiepidemic(props) {
        _classCallCheck(this, antiepidemic);

        var _this = _possibleConstructorReturn(this, (antiepidemic.__proto__ || __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_prototype_of___default()(antiepidemic)).call(this, props));

        _this.getLcIdInfo = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHFetch__["a" /* default */])("/zdybl/getXsxxAndLcidByXsid", 'GET', { xsid: xsid }).then(function (res) {
                if (res.code == "200") {
                    console.log("获取专业信息接口----------", res.data);
                    _this.setState({
                        LcidData: res.data
                    });
                } else {
                    Toast.error("获取专业信息接口失败");
                }
            });
        };

        _this.submitBtnClick = function () {
            var LcidData = _this.state.LcidData;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this.getQueryString('pkid');
            var formData = { xsid: xsid, yhid: xsid, zzbdhjid: zzbdhjid, lchjid: LcidData.LCID };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHFetch__["a" /* default */])('/zdybl/saveCustomLinkData', "POST", formData).then(function (res) {
                if (res) {
                    if (res.data == '1') {
                        // console.log('环节办理成功！');
                        //办理完成回调
                        _this.reloadMenu();
                        _this.getFydjInfo();
                    } else {
                        console.log('环节办理失败，请重试！');
                    }
                }
            });
        };

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_24__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.props.form.validateFieldsAndScroll(function (err, values) {
                console.log(_this.state.editable);
                if (!_this.state.editable) {
                    _this.setState({ editable: true });
                    return;
                }
                if (err) {
                    return;
                }

                var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["b" /* getLoginUser */])().userId;
                var zzbdhjid = _this.getUrlParams("pkid");
                values['xsid'] = xsid;
                values['zzbdhjid'] = zzbdhjid;
                var params = values;
                //请求保存或修改数据 
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHFetch__["a" /* default */])(basicUrl + '/zzbd/fydj/insertOrUpdate', 'POST', params) //   /yxwz/zzbd/fydj
                .then(function (res) {
                    if (res) {
                        if (res.data == '1') {
                            __WEBPACK_IMPORTED_MODULE_17_antd_lib_index__["message"].success('信息保存成功！');
                            _this.submitBtnClick();
                            //this.getQkpo();
                        } else {
                            __WEBPACK_IMPORTED_MODULE_17_antd_lib_index__["message"].error('信息保存失败，请重试！');
                        }
                    }
                });
            });
        };

        _this.getUrlParams = function (param) {
            return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.getFydjInfo = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["b" /* getLoginUser */])().userId;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHFetch__["a" /* default */])(basicUrl + "/zzbd/fydj/getFydjInfoByXsid", "GET", { xsid: xsid }).then(function (res) {
                if (res) {
                    if (res.data) {
                        _this.setState({ initPOvalue: res.data, editable: false });
                        _this.setFlag(res.data.jqsfyysgrzz, 'ysgr');
                        _this.setFlag(res.data.sfwcymjz, 'ymjz');
                    }
                }
            });
        };

        _this.getday = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHFetch__["a" /* default */])('/zzbdCommon/getCssz', "GET", { csbz: 'YXXT_FYDJ_HSJCSC' }).then(function (res) {
                if (res) {
                    if (res && res.code === 200) {
                        _this.setState({ day: res.data });
                    }
                }
            });
        };

        _this.setFlag = function (value, str) {
            if (str === 'ysgr') {
                if (value === '1') {
                    _this.setState({ ysgrFlag: true });
                } else {
                    _this.setState({ ysgrFlag: false });
                }
            } else if (str === 'ymjz') {
                if (value === '1') {
                    _this.setState({ ymjzFlag: true });
                } else {
                    _this.setState({ ymjzFlag: false });
                }
            }
        };

        _this.state = {
            mkbz: 'GD034',
            hjmc: '',
            editable: true,
            update: false,
            initPOvalue: {
                xsid: '',
                cfddqdmArray: [],
                cfdDetail: '',
                cfdxxdz: '',
                sfwcymjz: '',
                ymjzqkdm: '',
                hsjcjgdm: '',
                jkmysdm: '',
                xcmysdm: '',
                lxfsdm: '',
                jqsfyysgrzz: '',
                jqysgrrygxdm: '',
                jqysgrrygxdmArray: []
            },
            value: null,
            lxjtgjmcList: {},
            lxjtgjmc: '',
            ddz: {},
            options: [],
            dqddz: '',
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            isHide: true,
            ymjzFlag: true, //疫苗接种标志
            ysgrFlag: false, //疑似感染
            day: '48小时', //   xx天，默认48小时
            LcidData: {} //lchjid
        };
        return _this;
    }

    _createClass(antiepidemic, [{
        key: 'componentWillMount',
        value: function componentWillMount() {}

        //渲染前获取信息

    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.queryQztjAndYlhj();
            this.getFydjInfo();
            this.getday();
            this.getLcIdInfo();
        }

        // 确认办理


        //查询前置条件和依赖环节


        //获取url中传递的参数


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var getFieldDecorator = this.props.form.getFieldDecorator;
            var _state = this.state,
                editable = _state.editable,
                initPOvalue = _state.initPOvalue,
                lxjtgjmc = _state.lxjtgjmc,
                options = _state.options,
                dqddz = _state.dqddz,
                isHide = _state.isHide,
                ymjzFlag = _state.ymjzFlag,
                ysgrFlag = _state.ysgrFlag,
                day = _state.day;

            var str = '近' + day + '的核酸检测结果：';
            return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_12__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230'
                        /* active={3}*/
                        , mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_12__components__["a" /* Flex */].Item,
                        { className: 'page_con_r ' },
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjmc, extra: false }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_10_antd_lib_form___default.a,
                                { onSubmit: this.handleSubmit },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'div',
                                    { className: 'p-sw' },
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_12__components__["a" /* Flex */],
                                        { align: 'start', wrap: 'wrap' },
                                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                                FormItem,
                                                _extends({
                                                    labelCol: { span: 6 },
                                                    wrapperCol: { span: 18 }
                                                }, {
                                                    labelAlign: 'left',
                                                    label: '\u6765\u6821\u51FA\u53D1\u5730'
                                                }),
                                                getFieldDecorator('cfddqdmArray', {
                                                    initialValue: initPOvalue.cfddqdmArray ? initPOvalue.cfddqdmArray : [],
                                                    placeholder: '请选择',
                                                    rules: [{
                                                        required: true,
                                                        message: '请选择出发地区'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_common_NHCascader__["a" /* default */], { style: { width: 450 }, sign: "zhxg_ssq" }) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.cfdDetail ? initPOvalue.cfdDetail : ''
                                                ))
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                                FormItem,
                                                _extends({
                                                    labelCol: { span: 7 },
                                                    wrapperCol: { span: 17 }
                                                }, {
                                                    labelAlign: 'left',
                                                    label: '\u5177\u4F53\u8857\u9053\u4FE1\u606F'
                                                }),
                                                getFieldDecorator('cfdxxdz', {
                                                    initialValue: initPOvalue.cfdxxdz,
                                                    rules: [{
                                                        required: true,
                                                        message: '请填写具体街道信息'

                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { placeholder: '\u8BF7\u586B\u5199\u5177\u4F53\u8857\u9053\u4FE1\u606F' }) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.cfdxxdz
                                                ))
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                                FormItem,
                                                _extends({
                                                    labelCol: { span: 5 },
                                                    wrapperCol: { span: 19 }
                                                }, {
                                                    labelAlign: 'left',
                                                    label: '\u6765\u6821\u65B9\u5F0F'
                                                }),
                                                getFieldDecorator('lxfsdm', {
                                                    initialValue: initPOvalue.lxfsdm,
                                                    rules: [{
                                                        required: true,
                                                        message: '请填写来校方式'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_common_NHSelect__["a" /* default */], { sign: "DMK_YXXT_FYDJ_LXFS" }) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_common_NHSelect__["a" /* default */], { sign: "DMK_YXXT_FYDJ_LXFS", disabled: true }))
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u662F\u5426\u5B8C\u6210\u75AB\u82D7\u63A5\u79CD',
                                                    labelAlign: 'left'
                                                }),
                                                getFieldDecorator('sfwcymjz', {
                                                    initialValue: initPOvalue.sfwcymjz ? initPOvalue.sfwcymjz : '',
                                                    rules: [{
                                                        required: true,
                                                        message: '请选择疫苗接种情况'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_common_NHSelect__["a" /* default */], { dataSource: [{
                                                        value: '1',
                                                        label: '是'
                                                    }, {
                                                        value: '0',
                                                        label: '否'
                                                    }],
                                                    onChange: function onChange(value) {
                                                        _this2.setFlag(value, 'ymjz');
                                                    } }) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.sfwcymjz === '1' ? '是' : '否'
                                                ))
                                            ),
                                            !ymjzFlag && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    labelAlign: 'left',
                                                    label: '\u8BF7\u9009\u62E9\u75AB\u82D7\u63A5\u79CD\u60C5\u51B5'
                                                }),
                                                getFieldDecorator('ymjzqkdm', {
                                                    initialValue: initPOvalue.ymjzqkdm ? initPOvalue.ymjzqkdm : '',
                                                    rules: [{
                                                        required: true,
                                                        message: '请选择疫苗接种情况'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_common_NHSelect__["a" /* default */], { sign: "DMK_YXXT_BDQK_XGYMJZQK" }) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_common_NHSelect__["a" /* default */], { sign: "DMK_YXXT_BDQK_XGYMJZQK", disabled: true }))
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                                FormItem,
                                                _extends({
                                                    labelCol: { span: 10 },
                                                    wrapperCol: { span: 14 }
                                                }, {
                                                    labelAlign: 'left',
                                                    label: str
                                                }),
                                                getFieldDecorator('hsjcjgdm', {
                                                    initialValue: initPOvalue.hsjcjgdm ? initPOvalue.hsjcjgdm : '',
                                                    rules: [{
                                                        required: true,
                                                        message: '请选择核酸检测结果'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_common_NHSelect__["a" /* default */], { sign: "DMK_YXXT_FYDJ_SJJCJG" }) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_common_NHSelect__["a" /* default */], { sign: "DMK_YXXT_FYDJ_SJJCJG", disabled: true }))
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                                FormItem,
                                                _extends({
                                                    labelCol: { span: 6 },
                                                    wrapperCol: { span: 18 }
                                                }, {
                                                    labelAlign: 'left',
                                                    label: '\u5065\u5EB7\u7801\u989C\u8272'
                                                }),
                                                getFieldDecorator('jkmysdm', {
                                                    initialValue: initPOvalue.jkmysdm ? initPOvalue.jkmysdm : '',
                                                    rules: [{
                                                        required: true,
                                                        message: '请填写健康码'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_common_NHSelect__["a" /* default */], { sign: "DMK_YXXT_FYDJ_JKMYS" }) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_common_NHSelect__["a" /* default */], { sign: "DMK_YXXT_FYDJ_JKMYS", disabled: true }))
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                                FormItem,
                                                _extends({
                                                    labelCol: { span: 8 },
                                                    wrapperCol: { span: 16 }
                                                }, {
                                                    labelAlign: 'left',
                                                    label: '\u5927\u6570\u636E\u884C\u7A0B\u7801\u989C\u8272'
                                                }),
                                                getFieldDecorator('xcmysdm', {
                                                    initialValue: initPOvalue.xcmysdm ? initPOvalue.xcmysdm : '',
                                                    rules: [{
                                                        required: true,
                                                        message: '请填写行程码'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_common_NHSelect__["a" /* default */], { sign: "DMK_YXXT_FYDJ_XCMYS" }) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_common_NHSelect__["a" /* default */], { sign: "DMK_YXXT_FYDJ_XCMYS", disabled: true }))
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                                FormItem,
                                                _extends({
                                                    labelCol: { span: 16 },
                                                    wrapperCol: { span: 8 }
                                                }, {
                                                    labelAlign: 'left',
                                                    label: '\u8FD1\u671F\u662F\u5426\u6709\u7591\u4F3C\u611F\u67D3\u75C7\u72B6\uFF08\u672C\u4EBA\u53CA\u540C\u4F4F\u4EBA\uFF09'
                                                }),
                                                getFieldDecorator('jqsfyysgrzz', {
                                                    initialValue: initPOvalue.jqsfyysgrzz ? initPOvalue.jqsfyysgrzz : '',
                                                    rules: [{
                                                        required: true,
                                                        message: '请填写近期是否有疑似感染症状（本人及同住人）'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_common_NHSelect__["a" /* default */], { dataSource: [{
                                                        value: '1',
                                                        label: '是'
                                                    }, {
                                                        value: '0',
                                                        label: '否'
                                                    }],
                                                    onChange: function onChange(value) {
                                                        _this2.setFlag(value, 'ysgr');
                                                    } }) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.jqsfyysgrzz === '1' ? '是' : '否'
                                                ))
                                            ),
                                            ysgrFlag && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                                FormItem,
                                                _extends({
                                                    labelCol: { span: 10 },
                                                    wrapperCol: { span: 14 }
                                                }, {
                                                    labelAlign: 'left',
                                                    label: '\u8FD1\u671F\u7591\u4F3C\u611F\u67D3\u7684\u4EBA\u5458\u5173\u7CFB'
                                                }),
                                                getFieldDecorator('jqysgrrygxdmArray', {
                                                    initialValue: initPOvalue.jqysgrrygxdmArray ? initPOvalue.jqysgrrygxdmArray : [],
                                                    rules: [{
                                                        required: true,
                                                        message: '请填写近期疑似感染的人员关系'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_common_NHMultiSelect__["a" /* default */], { sign: "DMK_YXXT_FYDJ_YSGRRYGX" }) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_common_NHMultiSelect__["a" /* default */], { sign: "DMK_YXXT_FYDJ_YSGRRYGX",
                                                    disabled: true }))
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,
                                            {
                                                type: 'primary',
                                                htmlType: 'submit'
                                            },
                                            editable ? '保存' : '修改'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                )
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__common__["a" /* default */], { hjmc: "防疫登记", key: 'GD034', mkbz: 'GD034', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return antiepidemic;
}(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component)) || _class);


/***/ }),

/***/ 1010:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JhysChannel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_spin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_checkbox_style__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_checkbox__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_axios__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_SelfHelp_applyDorm_view__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_SelfHelp_common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_common_NHFormItem__ = __webpack_require__(43);
























var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }












var Dragger = __WEBPACK_IMPORTED_MODULE_22_antd_lib_upload___default.a.Dragger;







var history = __WEBPACK_IMPORTED_MODULE_33_history_createHashHistory___default()();
var TextArea = __WEBPACK_IMPORTED_MODULE_20_antd_lib_input___default.a.TextArea;

var FormItem = __WEBPACK_IMPORTED_MODULE_18_antd_lib_form___default.a.Item;
var CheckboxGroup = __WEBPACK_IMPORTED_MODULE_16_antd_lib_checkbox___default.a.Group;
var formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 }
};

var JhysChannel = (_dec = __WEBPACK_IMPORTED_MODULE_18_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(JhysChannel, _React$Component);

    function JhysChannel(props) {
        _classCallCheck(this, JhysChannel);

        var _this = _possibleConstructorReturn(this, (JhysChannel.__proto__ || __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default()(JhysChannel)).call(this, props));

        _this.updateZzbdBlzt = function () {
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHFetch__["a" /* default */])('/zzbd/updateZzbdBlzt', 'GET', { zzbdhjid: zzbdhjid, hjdm: 'GD032' }).then(function (res) {
                if (res.data) {
                    _this.reloadMenu();
                }
            });
        };

        _this.queryQztjAndYlhj = function (callback) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }if (callback) {
                        callback(_this.state.operable);
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_37__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.loadInfo = function (flag) {
            console.log(flag);
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHCore__["b" /* getLoginUser */])().userId;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHFetch__["a" /* default */])('api/zhxg-yxxt/yxwz/zzbd/xzsfzz/getXzsfzzByXsid', 'GET', { xsid: xsid }).then(function (resData) {
                if (resData && resData.data) {
                    if (flag == "edit") {
                        _this.setState({
                            edit: true
                        });
                    }
                    if (resData.data.SFZS) {
                        _this.setState({
                            sfzsValue: resData.data.SFZS
                        });
                    }
                    _this.setState({ data: resData.data });
                    var fileList = [];
                    var oldFileList = [];
                    if (resData.data && resData.data['WSSQFJ']) {
                        //格式化对于附件取值
                        var file = {};
                        oldFileList = JSON.parse(resData.data['WSSQFJ']);
                        if (oldFileList.length > 0) {
                            oldFileList.map(function (item, index) {
                                console.log(item, index);
                                file = {
                                    uid: item.fjid,
                                    name: item.fjmc,
                                    response: {
                                        data: {
                                            ssbh: item.fjid,
                                            fjmc: item.fjmc
                                        }
                                    },
                                    status: 'done'
                                };
                                fileList.push(file);
                            });
                        }
                        console.log("file", fileList);
                    }
                    _this.setState({ fileList: fileList, oldFileList: oldFileList });
                    _this.props.form.setFieldsValue({ wssqfj: { fileList: _this.state.fileList } });
                } else {
                    _this.setState({ data: {}, edit: true });
                    _this.setState({ fileList: [] });
                    _this.props.form.resetFields();
                }
            });
        };

        _this.getBase64 = function (img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        };

        _this.handlePreview = function (file) {
            var isImage = /^image\/.*$/i.test(file.type);
            if (isImage) {
                if (file) {
                    _this.getBase64(file, function (imageUrl) {
                        _this.setState({
                            previewImage: imageUrl,
                            previewVisible: true
                        });
                    });
                } else {
                    _this.setState({
                        previewImage: file.url || file.thumbUrl,
                        previewVisible: true
                    });
                }
            } else if (file && file['response'] && file['response']['data']) {
                //其他情况
                var _isImage = true;
                var fjmc = file['response']['data']['fjmc'];
                var ssbh = file['response']['data']['ssbh'];
                if (!_this.setJudge(fjmc, _this.state.judgeImgList)) {
                    _isImage = false;
                }

                if (_isImage) {
                    _this.showPreview('anonymity/docrepo/download/file?attachmentId=' + ssbh);
                } else {
                    window.open('anonymity/docrepo/download/file?attachmentId=' + ssbh);
                }
            }
        };

        _this.showPreview = function (url) {
            _this.setState({
                previewImage: url,
                previewVisible: true
            });
        };

        _this.handleCancel = function () {
            return _this.setState({ previewVisible: false });
        };

        _this.handleSubmit = function (e) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error("登录已过期，请重新登录！");
                return;
            }
            _this.setState({ loading: true, saveloading: true });
            e.preventDefault();
            _this.props.form.validateFieldsAndScroll(function (err, values) {
                if (err) {
                    _this.setState({ loading: false, saveloading: false });
                    return false;
                }
                console.log("提交数据----------------", values);
                var pkid = values['pkid'];
                var params = {};
                if (values['sfzs'] == 0) {
                    // 附件
                    // const wssqfj = values['wssqfj'];
                    // let isEmpty = false;
                    // if(wssqfj){
                    //     if(wssqfj['fileList'] && wssqfj['fileList'].length>0){
                    //         isEmpty = false;
                    //     }else{
                    //         isEmpty = true;
                    //     }
                    // }else{
                    //     isEmpty = true;
                    // }
                    // if(isEmpty){
                    //     this.props.form.setFields({
                    //         wssqfj:{
                    //             value:undefined,
                    //             errors:[new Error('请上传附件')],
                    //         }
                    //     });
                    //     this.setState({loading:false,saveloading:false});
                    //     return false;
                    // }

                    // let size = wssqfj['fileList'].length;
                    // let file = wssqfj['fileList'].filter((file) => {
                    //     if (file.status==='error') {
                    //         return false;
                    //     }
                    //     return true;
                    // });
                    // if(file.length!=size){
                    //     this.props.form.setFields({
                    //         wssqfj:{
                    //             value:wssqfj,
                    //             errors:[new Error('附件上传出错，请重新上传.')],
                    //         }
                    //     });
                    //     this.setState({loading:false,saveloading:false});
                    //     return false;
                    // }
                    // let fjid = '';
                    // let fjmc = '';
                    // let fileList = wssqfj['fileList'];
                    // let fjlist = [];
                    // for(let i=0;i<fileList.length;i++){
                    //     fjid = fileList[i].response.data.ssbh;
                    //     fjmc = fileList[i].name;
                    //     fjlist.push({
                    //         fjid:fjid,
                    //         fjmc:fjmc
                    //     });
                    // }
                    // let fjIdAndMc = JSON.stringify(fjlist);
                    // let wsdz = values['wsdz'];
                    // let jhr = values['jhr'];
                    // let jhrgx = values['jhrgx'];
                    // let jhrdh = values['jhrdh'];

                    var sfzs = values['sfzs'];
                    var shzt = '1';

                    params = {
                        // wssqfj:fjIdAndMc,
                        // wsdz:wsdz,
                        // jhrgx:jhrgx,
                        // jhr:jhr,
                        // jhrdh:jhrdh,
                        xsid: xsid,
                        sfzs: sfzs,
                        shzt: shzt
                    };
                } else {
                    var _sfzs = values['sfzs'];
                    var _shzt = '0';
                    params = {
                        xsid: xsid,
                        sfzs: _sfzs,
                        shzt: _shzt
                    };
                }

                console.log(params);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHFetch__["a" /* default */])('api/zhxg-yxxt/yxwz/zzbd/xzsfzz/updateXzsfzz', "POST", params).then(function (res) {
                    if (res) {
                        if (res.data == '1') {
                            __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.success("是否选择住宿申请保存成功。");
                            _this.loadInfo();
                            _this.reloadMenu();
                            _this.setState({ loading: false, edit: false, saveloading: false });
                        } else {
                            _this.setState({ loading: false, saveloading: false });
                        }
                    } else {
                        _this.setState({ loading: false, saveloading: false });
                    }
                }).catch(function (res) {
                    _this.setState({ loading: false, saveloading: false });
                    return res;
                });
            });
        };

        _this.handleChange = function (_ref) {
            var fileList = _ref.fileList;

            var count = 0;
            fileList.map(function (elem) {
                if (elem && elem['status'] && elem['status'] === 'uploading') {
                    _this.setState({ uploading: true });
                    return;
                } else if (elem && elem['status']) {
                    count++;
                }
            });
            if (count > 0) {
                _this.setState({ uploading: false });
            }
        };

        _this.setJudge = function (name, map) {
            var flag = false;
            map.map(function (item) {
                if (name.indexOf(item) !== -1) {
                    flag = true;
                }
            });
            return flag;
        };

        _this.beforeUpload = function (file) {
            if (!(_this.setJudge(file.name, _this.state.judgeImgList) || _this.setJudge(file.name, _this.state.judgeFileList))) {
                __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error('不能上传该格式文件');
                return false;
            } else {
                return true;
            }
        };

        _this.remove = function (ssbh) {
            var url = 'api/docrepo/attachment/sourceId/delete?souerceId=' + ssbh;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHFetch__["a" /* default */])(url, "POST").then(function (res) {
                if (res.data && res.data > 0) {
                    __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.success('已删除材料.');
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.sfzsOnChange = function (e) {
            _this.setState({
                sfzsValue: e.target.value
            });
        };

        _this.state = {
            mkbz: 'GD032',
            hjmc: '',
            uploading: false,
            loading: false,
            previewVisible: false,
            fileList: [],
            data: {}, //绿色通道申请信息
            nextUrl: '',
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            sqlyFlag: false, //申请理由flag
            jymFlag: false, //6位数回执校验码flag
            judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'], //可以导入的图片格式
            judgeFileList: ['.pdf', '.PDF', '.doc', '.DOC', '.zip', '.ZIP', '.txt', '.TXT', '.xls', '.XLS', '.rar', '.RAR'], //可以导入的非图片格式
            sfzsValue: "", //是否住宿
            edit: "",
            oldFileList: {},
            saveloading: false
        };
        return _this;
    }

    _createClass(JhysChannel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.queryQztjAndYlhj(function (operable) {
                if (operable) {
                    _this2.loadInfo();
                    _this2.updateZzbdBlzt();
                }
            });
        }

        //迎新现场已办理时迎新网站自动办理


        //查询前置条件和依赖环节


        //读取学生的是否住宿信息


        // 转化base64


        // 点击文件链接或预览图标时的回调


        // 关闭图片弹窗


        // 提交


        //判断文件类型是否正常  name：文件名称  map：类型范围数组  true正常


        //重新加载菜单


        // 是否住宿回调

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var form = this.props.form;
            var getFieldDecorator = this.props.form.getFieldDecorator;
            var _state = this.state,
                previewImage = _state.previewImage,
                previewVisible = _state.previewVisible,
                jymFlag = _state.jymFlag,
                sqlyFlag = _state.sqlyFlag,
                sfzsValue = _state.sfzsValue,
                edit = _state.edit;
            // const props = {
            //     name: 'file',
            //     action: 'zuul/docrepo/upload',
            //     data: { uuid: createUuid(), type: '1' },

            var props = {
                name: 'file',
                action: 'anonymity/docrepo/upload',
                data: { uuid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHCore__["c" /* createUuid */])(), type: '1' },

                onRemove: function onRemove(file) {
                    _this3.setState(function (_ref2) {
                        var fileList = _ref2.fileList;

                        var index = fileList.indexOf(file);
                        var newFileList = fileList.slice();
                        newFileList.splice(index, 1);
                        _this3.props.form.setFieldsValue({ wssqfj: { fileList: newFileList } });
                        return {
                            fileList: newFileList
                        };
                    }, function () {
                        if (file.response && file.response.data && file.response.data.ssbh) {
                            _this3.remove(file.response.data.ssbh);
                        }
                    });
                },
                beforeUpload: function beforeUpload(file) {
                    if (!_this3.beforeUpload(file)) {
                        return false;
                    }
                    _this3.setState(function (_ref3) {
                        var fileList = _ref3.fileList;
                        return {
                            fileList: [].concat(_toConsumableArray(fileList), [file])
                        };
                    });
                    return true;
                },
                onChange: function onChange(file) {
                    _this3.handleChange(file);
                },
                onPreview: this.handlePreview,
                fileList: this.state.fileList
                /*  defaultFileList:[
                     {
                         uid: '1',
                         name: 'xxx.png',
                         status: 'done',
                         response: 'Server Error 500', // custom error message to show
                         url: 'http://www.baidu.com/xxx.png',
                       },
                 ] */
            };
            // console.log("---------prop------",props,this.state.fileList);
            var data = this.state.data;
            return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                'div',
                { style: { position: 'relative' } },
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_26__components__["a" /* Flex */],
                        { className: 'w1180 mt-20', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__pages_Assembly_siderMenu__["a" /* default */], {
                            ref: "siderMenu",
                            setMenuList: this.setMenuList,
                            title: '\u81EA\u52A9\u62A5\u5230',
                            mkbz: this.state.mkbz
                            /*     active={4}*/
                            , menuType: '\u81EA\u52A9\u62A5\u5230' }),
                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_26__components__["a" /* Flex */].Item,
                            { className: 'page_con_r ' },
                            __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__pages_Assembly_Breadcrumb__["a" /* default */], {
                                noLine: true,
                                list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                            }),
                            __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                'div',
                                { className: 'box' },
                                __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__pages_SelfHelp_common_hint__["a" /* default */], null),
                                edit ? __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_18_antd_lib_form___default.a,
                                    { onSubmit: this.handleSubmit },
                                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u4FE1\u606F', extra: false }),
                                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                        'div',
                                        { className: 'p-sw' },
                                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                            'div',
                                            { style: { display: 'none' } },
                                            __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_39__components_common_NHFormItem__["a" /* default */],
                                                { id: 'pkid', initialValue: data['PKID'] ? data['PKID'] : "", form: form },
                                                __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_antd_lib_input___default.a, null)
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                            'div',
                                            { style: { marginLeft: "30px" } },
                                            __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_39__components_common_NHFormItem__["a" /* default */],
                                                { id: 'sfzs', required: true, initialValue: data['SFZS'] ? data['SFZS'] : "", form: form, formItemLayout: { labelCol: { span: 4 }, wrapperCol: { span: 16 } }, label: '\u662F\u5426\u9009\u62E9\u4F4F\u5BBF' },
                                                __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default.a.Group,
                                                    { onChange: this.sfzsOnChange, value: sfzsValue, style: { display: "flex", margin: "10px" } },
                                                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default.a,
                                                        { value: '1' },
                                                        '\u662F'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default.a,
                                                        { value: '0' },
                                                        '\u5426'
                                                    )
                                                )
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,
                                            { type: 'primary', htmlType: 'submit', loading: this.state.saveloading },
                                            '\u4FDD\u5B58'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__pages_SelfHelp_applyDorm_view__["a" /* default */], { reloadMenu: this.reloadMenu, nextUrl: this.state.nextUrl, loadInfo: function loadInfo() {
                                        return _this3.loadInfo("edit");
                                    }, search: this.state.search, showPreview: this.showPreview, setJudge: this.setJudge, data: this.state.data, judgeImgList: this.state.judgeImgList })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a,
                        {
                            visible: previewVisible,
                            footer: null,
                            onCancel: this.handleCancel
                        },
                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('img', {
                            alt: 'example',
                            style: { width: '100%' },
                            src: previewImage
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_spin___default.a, { style: { position: 'absolute', top: '300px', left: '60%' }, spinning: this.state.loading }),
                    ' '
                ) : __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__pages_SelfHelp_common__["a" /* default */], { hjmc: "绿色通道申请", key: "GD032", mkbz: 'GD032', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return JhysChannel;
}(__WEBPACK_IMPORTED_MODULE_23_react___default.a.Component)) || _class);


/***/ }),

/***/ 1011:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return View; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }









var TextArea = __WEBPACK_IMPORTED_MODULE_14_antd_lib_input___default.a.TextArea;

var basicUrl = "/zzbd";

var shztList = {
    '-1': '审核不通过',
    '0': '未审核',
    '1': '审核通过',
    '2': '已办理',
    '9': '驳回'
};

var View = function (_React$Component) {
    _inherits(View, _React$Component);

    function View(props) {
        _classCallCheck(this, View);

        var _this = _possibleConstructorReturn(this, (View.__proto__ || __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default()(View)).call(this, props));

        _this.getDmkMc = function (dmbz) {
            var data = _this.props.data;

            var dkyhmc = _this.state.dkyhmc;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])(basicUrl + "/getDmkMc", "GET", _defineProperty({ dmbz: dmbz }, 'dmbz', dmbz)).then(function (res) {
                if (res) {
                    if (res.data) {
                        if (dmbz === "YXWZ_DKYH") {
                            res.data.map(function (initItem) {
                                if (initItem.DM === data.dkyh) {
                                    dkyhmc = initItem.MC;
                                }
                            });
                            _this.setState({ dkyhmc: dkyhmc });
                        }
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.edit = function () {

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["b" /* getLoginUser */])().userId;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])('api/zhxg-yxxt/yxwz/zzbd/xzsfzz/getXzsfzzByXsid', 'GET', { xsid: xsid }).then(function (resData) {
                if (resData && resData.data) {
                    if (resData.data.SHZT != '' && resData.data.SHZT != undefined) {
                        if (resData.data.SHZT !== '0' && resData.data.SHZT !== '9') {
                            __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.warning('该申请已经审核，不能修改');
                            return;
                        }
                        _this.props.loadInfo('edit');
                        _this.props.reloadMenu();
                    } else {
                        _this.props.loadInfo('edit');
                        _this.props.reloadMenu();
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.warning("修改异常");
                }
            });
        };

        _this.handlePreview = function (fjmc, fjid) {
            var isImage = true;
            if (!_this.props.setJudge(fjmc, _this.props.judgeImgList)) {
                isImage = false;
            }

            if (isImage) {
                _this.props.showPreview('anonymity/docrepo/download/file?attachmentId=' + fjid);
            } else {
                window.open('anonymity/docrepo/download/file?attachmentId=' + fjid);
            }
        };

        _this.state = {
            dkyhmc: '',
            nextUrl: _this.props.nextUrl,
            search: _this.props.search,
            jhrgx: []
        };
        return _this;
    }

    _createClass(View, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.getDmkMc("YXWZ_DKYH");
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])('/proData/selectDataList?&sign=DMK_XSXX_JTCYGX', 'GET').then(function (res) {
                if (res && res.data) {
                    var jtcyList = res.data;
                    console.log(jtcyList);
                    _this2.setState({ jhrgx: jtcyList });
                }
            });
        }

        //获取下拉列表value对应的名称


        // 点击文件链接或预览图标时的回调

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var data = this.props.data;
            var _state = this.state,
                dkyhmc = _state.dkyhmc,
                jhrgx = _state.jhrgx;

            var fjList = [];
            if (__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()(data) != "{}") {
                var fj = data['WSSQFJ'];
                console.log(fj);
                if (fj) {
                    fjList = JSON.parse(fj);
                }
            }
            console.log(fjList);
            return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u4FE1\u606F', extra: false }),
                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%' } },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u662F\u5426\u9009\u62E9\u4F4F\u5BBF\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['SFZS'] == '1' ? '是' : '否'
                                )
                            )
                        )
                    )
                ),
                data['SFZS'] === '0' ? null : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u5BA1\u6838', extra: false }),
                data['SFZS'] === '0' ? null : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u5BA1\u6838\u610F\u89C1\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['SHYJ']
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u5BA1\u6838\u72B6\u6001\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    'span',
                                    { style: { color: '#0066FF' } },
                                    data['SHZTMC']
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('br', null),
                    (data['SHZT'] == '0' || data['SHZT'] == undefined || data['SHZT'] == '') && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u63D0\u793A\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'red' } },
                                    data['SFZS'] == '0' ? "已提交走读申请，请等待审核!" : "请等待分配宿舍后再继续后续操作！"
                                )
                            )
                        )
                    )
                ),
                (data['SHZT'] == "0" || data['SHZT'] == "9" || data['SHZT'] == null) && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    'div',
                    { className: 'text-center mt-50' },
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                        { type: 'primary', onClick: function onClick() {
                                _this3.edit(data['SHZT']);
                            } },
                        '\u4FEE\u6539'
                    ),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                )
            );
        }
    }]);

    return View;
}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);



/***/ }),

/***/ 1012:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Buy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_number__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_map__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_stepper_primitive__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_stepper_primitive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_stepper_primitive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_index__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__index_css__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_SelfHelp_common_hint__ = __webpack_require__(35);
















var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }



















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_25_history_createHashHistory___default()();
var basicUrl = "/zzbd";
var commonUrl = '/zzbdCommon';

var Buy = function (_React$Component) {
    _inherits(Buy, _React$Component);

    function Buy(props) {
        _classCallCheck(this, Buy);

        var _this = _possibleConstructorReturn(this, (Buy.__proto__ || __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default()(Buy)).call(this, props));

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_29__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.getWPlist = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])(basicUrl + "/getWPList", "GET").then(function (res) {
                if (res) {
                    if (res.data) {
                        var initStuWpData = _this.state.initStuWpData;

                        var operationI = 0;
                        var basicdata = res.data.map(function (item) {
                            operationI = 0;
                            if (item.SFBXXG === '1') {
                                operationI = 1;
                            }

                            if (initStuWpData.length > 0) {
                                initStuWpData.map(function (initItem) {
                                    if (initItem.SHWPID === item.PKID) {
                                        operationI = initItem.GMSL;
                                    }
                                });
                            }
                            return {
                                key: item.PKID, name: item.WPMC, gk: item.WPGG,
                                zd: item.ZLYQ, dj: item.WPDJ, buy: item.SFBXXG,
                                zdgmsl: item.ZDGML, operation: operationI
                            };
                        });
                        _this.setInitNumMap(basicdata);
                        _this.setState({ data: basicdata });
                    }
                }
            });
        };

        _this.checkIsZzbdHjLinked = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this.getQueryString('pkid');

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])("/zzbdCommon/checkIsZzbdHjLinked", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res) {
                    if (res.data) {
                        _this.setState({
                            transform: !res.data
                        });
                    } else {
                        _this.setState({
                            transform: true
                        });
                    }
                } else {
                    _this.setState({
                        transform: true
                    });
                }
            });
        };

        _this.getWPDatalist = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId; //todo
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])(basicUrl + "/getShwpgmListById", "GET", { xsid: xsid }).then(function (res) {
                if (res) {
                    if (res.data) {
                        _this.setState({ initStuWpData: res.data });
                        if (_this.state.initStuWpData.length > 0) {
                            _this.setState({ transform: false });
                        }
                    }
                }
                _this.getWPlist(); //物品table列表数据
            });
        };

        _this.onChange = function (value, record) {
            // 限制数量 >= 0 
            if (value < 0) {
                value = 0;
            }
            var WPSLMap = _this.state.WPSLMap;

            if (value > record.zdgmsl) {
                __WEBPACK_IMPORTED_MODULE_23_antd_lib_index__["message"].warning(record.name + '已经到达最大购买数！');
                value = record.zdgmsl;
            }
            if (record.buy === '1' && value == 0) {
                value = 1;
            }
            if (value == 1) {
                record.operation = 1;
            }
            WPSLMap.set(record.key, value);

            record.operation = value;
            _this.changeMonMoneyAndNub();
            if (value == 0) {
                // this.setState({editFlag:true});
                WPSLMap.delete(record.key);
                record.editable = false;
                record.operation = 0;
            }
        };

        _this.onSave = function () {
            var _this$state = _this.state,
                WPSLMap = _this$state.WPSLMap,
                update = _this$state.update,
                transform = _this$state.transform;


            if (WPSLMap.size === 0) {
                __WEBPACK_IMPORTED_MODULE_23_antd_lib_index__["message"].error('你还没选择物品，请点击列表中的购买按钮！');
                return;
            } else {
                var sUrl = '/saveShwpgmData';
                var succeMsg = '信息保存成功！';
                var errMsg = '信息保存失败，请重试！';
                // if (update) {
                // sUrl = '/updateShwpgmData';          //2018/08/16需求变更

                // }
                if (!transform) {
                    sUrl = '/deleteShwpgmData';
                    succeMsg = '取消成功！';
                    errMsg = '取消失败，请重试！';
                    // 点击取消时把物品清零
                    WPSLMap.clear();
                }

                // //修改 可编辑状态，并可以update数据
                // if (!this.state.transform) {            //2018/08/16需求变更
                //     this.setState({update: true, transform: true});
                //     return
                // }
                var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId;
                var zzbdhjid = _this.getUrlParams("pkid");
                var params = { xsid: xsid, zzbdhjid: zzbdhjid, formData: WPSLMap };
                //请求保存或修改数据
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])(basicUrl + sUrl, 'POST', params).then(function (res) {
                    if (res) {
                        if (res.data == '1') {
                            __WEBPACK_IMPORTED_MODULE_23_antd_lib_index__["message"].success(succeMsg);
                            _this.setState({ transform: !transform });
                            _this.getWPDatalist();
                            _this.reloadMenu();
                        } else {
                            __WEBPACK_IMPORTED_MODULE_23_antd_lib_index__["message"].error(errMsg);
                        }
                    }
                });
            }
            _this.setState({ loading: true });
            setTimeout(function () {
                _this.setState({
                    loading: false
                });
            }, 1000);
        };

        _this.getUrlParams = function (param) {
            return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.onSelectChange = function (selectedRowKeys) {
            _this.setState({ selectedRowKeys: selectedRowKeys });
        };

        _this.getCheckboxProps = function (record) {
            return {
                disabled: record.key === 'last'
            };
        };

        _this.edit = function (key) {
            var newData = [].concat(_toConsumableArray(_this.state.data));
            var target = newData.filter(function (item) {
                return key === item.key;
            })[0];
            if (target) {
                target.editable = true;
                _this.setState({ data: newData });
            }
        };

        _this.save = function (key) {
            var newData = [].concat(_toConsumableArray(_this.state.data));
            var target = newData.filter(function (item) {
                return key === item.key;
            })[0];
            if (target) {
                delete target.editable;
                _this.setState({ data: newData });
                _this.cacheData = newData.map(function (item) {
                    return _extends({}, item);
                });
            }
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD002',
            hjmc: '',
            data: [],
            selectedRowKeys: [],
            loading: false,
            totalMoney: "", //购买总金额
            count: "", //总购买物件数
            ediFolag: true,
            selectedList: [],
            WPSLMap: new __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_map___default.a(), //物品数量map   key：物品pkid  value:物品数量
            WPDJMap: new __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_map___default.a(), //物品单价map   key: 物品pkid  value:物品单价
            transform: true,
            update: false,
            initStuWpData: [],
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            isHjLinked: false
        };
        return _this;
    }

    _createClass(Buy, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.checkIsZzbdHjLinked();
            this.getWPDatalist();
            this.queryQztjAndYlhj();
        }

        //查询前置条件和依赖环节


        //环节pkid

    }, {
        key: 'setInitNumMap',


        //初始开始算必须购买物品的总数和总价
        value: function setInitNumMap(m) {
            var _state = this.state,
                WPSLMap = _state.WPSLMap,
                WPDJMap = _state.WPDJMap,
                initStuWpData = _state.initStuWpData;

            m.map(function (item) {
                if (item.operation != '0') {
                    WPSLMap.set(item.key, item.operation);
                }
                WPDJMap.set(item.key, item.dj);
            });

            this.changeMonMoneyAndNub();
        }

        //初始获取table列表

        //检查该环节是否已经办理


        //学生个人table列表数据


        //数字框发生变化检测

    }, {
        key: 'changeMonMoneyAndNub',


        //更改总金额和数量
        value: function changeMonMoneyAndNub() {
            var _state2 = this.state,
                WPSLMap = _state2.WPSLMap,
                WPDJMap = _state2.WPDJMap;

            var totalMoneys = 0;
            var nums = 0;
            WPSLMap.forEach(function (itemValue, itemKey, map) {
                totalMoneys += WPDJMap.get(itemKey) * itemValue;
                nums += itemValue;
            });
            this.setState({
                totalMoney: totalMoneys,
                count: nums
            });
        }

        //保存


        //获取url中传递的参数


        // onSave = () => {
        //     this.setState({loading: true});
        //     setTimeout(() => {
        //         this.setState({
        //             selectedRowKeys: [],
        //             loading: false
        //         });
        //     }, 1000);
        // };


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state3 = this.state,
                loading = _state3.loading,
                selectedRowKeys = _state3.selectedRowKeys,
                data = _state3.data,
                selectedList = _state3.selectedList,
                WPSLMap = _state3.WPSLMap,
                WPDJMap = _state3.WPDJMap,
                count = _state3.count,
                totalMoney = _state3.totalMoney,
                ediFolag = _state3.ediFolag,
                transform = _state3.transform;

            var rowSelection = {
                selectedRowKeys: selectedRowKeys,
                onChange: this.onSelectChange,
                getCheckboxProps: this.getCheckboxProps
            };
            var hasSelected = selectedRowKeys.length > 0;
            var columns = [{
                title: '物品名称',
                dataIndex: 'name'
            }, {
                title: '产品规格',
                dataIndex: 'gk',
                render: function render(text, record) {
                    var obj = {
                        children: text,
                        props: {}
                    };
                    if (record.key === 'last') {
                        obj.props.colSpan = 5;
                    }
                    return obj;
                }
            }, {
                title: '产品质地',
                dataIndex: 'zd',
                render: function render(text, record) {
                    var obj = {
                        children: text,
                        props: {}
                    };
                    if (record.key === 'last') {
                        obj.props.colSpan = 0;
                    }
                    return obj;
                }
            }, {
                title: '单价（元）',
                dataIndex: 'dj',
                render: function render(text, record) {
                    if (record.key === 'last') {
                        return {
                            props: {
                                colSpan: 0
                            }
                        };
                    }
                    return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'span',
                        { className: 'text-primary' },
                        text
                    );
                }
            }, {
                title: '是否必须购买',
                dataIndex: 'buy',
                render: function render(text, record) {
                    if (record.key === 'last') {
                        return {
                            props: {
                                colSpan: 0
                            }
                        };
                    }
                    return text == '1' ? '是' : '否';
                    return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'span',
                        { className: 'text-primary' },
                        text
                    );

                    // return text == '1' ?
                    //    '是'
                    //     : '否';
                }
            }, {
                title: transform ? '操作' : '购买数量',
                dataIndex: 'operation',
                width: 120,
                render: function render(text, record) {
                    if (record.key === 'last') {
                        return {
                            props: {
                                colSpan: 0
                            }
                        };
                    }
                    var editable = record.editable,
                        buy = record.buy,
                        key = record.key,
                        dj = record.dj,
                        zdgmsl = record.zdgmsl,
                        operation = record.operation;

                    WPDJMap.set(key, dj);
                    /* if (buy === '1' || operation > 0) {
                        record.editable = true;
                    }
                    if (editable) {
                        return (
                            transform ?
                            <Stepper
                                min={buy}
                                max={zdgmsl}
                                render={({
                                             getFormProps,
                                             getInputProps,
                                             getIncrementProps,
                                             getDecrementProps
                                         }) => (
                                    <form {...getFormProps()}>
                                        <div styleName="btn_icon">
                                            <Icon
                                                {...getDecrementProps()}
                                                type="minus-circle-o"
                                                onClick={() => {
                                                    this.onChange(operation-1, record);
                                                }}
                                            />
                                        </div>
                                        <span>{operation}</span>
                                        <div styleName="btn_icon">
                                            <Icon
                                                {...getIncrementProps()}
                                                type="plus-circle"
                                                onClick={() => {
                                                    this.onChange(operation+1, record);
                                                }}
                                            />
                                        </div>
                                    </form>
                                )}
                            /> :  <InputNumber
                            defaultValue={operation}
                            disabled={!transform}
                        />
                        );
                    } */
                    /* return (
                        transform ?
                            <Button
                                type="primary"
                                onClick={() => {
                                    this.edit(record.key);
                                    this.onChange(1, record);
                                }}
                            >
                                数量:{record.buy}
                            </Button>
                             : <InputNumber
                                defaultValue={operation}
                                disabled={!transform}
                            />
                    ); */
                    return transform ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_stepper_primitive___default.a, {
                        min: buy,
                        max: zdgmsl,
                        render: function render(_ref) {
                            var getFormProps = _ref.getFormProps,
                                getInputProps = _ref.getInputProps,
                                getIncrementProps = _ref.getIncrementProps,
                                getDecrementProps = _ref.getDecrementProps;
                            return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'form',
                                getFormProps(),
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    'div',
                                    { className: 'app__css__app-pages-SelfHelp-buy-__index__btn_icon' },
                                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_icon___default.a, _extends({}, getDecrementProps(), {
                                        type: 'minus-circle-o',
                                        onClick: function onClick() {
                                            _this2.onChange(operation - 1, record);
                                        }
                                    }))
                                ),
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    'span',
                                    null,
                                    operation
                                ),
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    'div',
                                    { className: 'app__css__app-pages-SelfHelp-buy-__index__btn_icon' },
                                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_icon___default.a, _extends({}, getIncrementProps(), {
                                        type: 'plus-circle',
                                        onClick: function onClick() {
                                            _this2.onChange(operation + 1, record);
                                        }
                                    }))
                                )
                            );
                        }
                    }) : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_number___default.a, {
                        defaultValue: operation,
                        disabled: !transform
                    });
                }
            }];
            if (data[0]) {
                if (data[data.length - 1].key === 'last') {
                    // data.filter((i) => i !== data.length - 1)
                    data.splice(data.length - 1, 1);
                }
                data.push({
                    key: 'last',
                    name: '合计',
                    gk: __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'span',
                        null,
                        '\u5171 ',
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'span',
                            { className: 'text-red' },
                            count || 0
                        ),
                        ' \u4EF6\u5546\u54C1\uFF0C\u5171\u8BA1',
                        ' ',
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'span',
                            { className: 'text-primary' },
                            totalMoney || 0
                        ),
                        ' \u5143'
                    )
                });
            }

            return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                'div',
                { className: 'app__css__app-pages-SelfHelp-buy-__index__page_buy' },
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230',
                        mkbz: this.state.mkbz
                        /*       active={1}*/
                        , menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjmc, extra: false }),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'div',
                                { className: 'p-sw' },
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_table___default.a, {
                                    bordered: true,
                                    size: 'middle',
                                    pagination: false
                                    // rowSelection={rowSelection}
                                    , columns: columns,
                                    dataSource: data
                                }),
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    'div',
                                    { className: 'text-center mt-50' },
                                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default.a,
                                        {
                                            type: 'primary',
                                            onClick: this.onSave
                                            // disabled={!ediFolag}
                                            // disabled={!transform}
                                            , loading: loading
                                        },
                                        transform ? '保存' : '取消'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                )
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__common__["a" /* default */], { hjmc: "物品购买", key: "GD002", mkbz: 'GD002', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return Buy;
}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);



/***/ }),

/***/ 1013:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BuyFa; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_switch_style__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_switch__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input_number_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_number__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_map__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_stepper_primitive__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_stepper_primitive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_stepper_primitive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_index__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__index_css__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_common_hint__ = __webpack_require__(35);
















var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }


















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_24_history_createHashHistory___default()();
var basicUrl = "/zzbd";
var commonUrl = '/zzbdCommon';

var BuyFa = function (_React$Component) {
    _inherits(BuyFa, _React$Component);

    function BuyFa(props) {
        _classCallCheck(this, BuyFa);

        var _this = _possibleConstructorReturn(this, (BuyFa.__proto__ || __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default()(BuyFa)).call(this, props));

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.getWPlist = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])(basicUrl + "/getWPList", "GET").then(function (res) {
                if (res) {
                    if (res.data) {
                        var _this$state = _this.state,
                            initStuWpData = _this$state.initStuWpData,
                            tempData = _this$state.tempData;

                        var operationI = 0;
                        var basicdata = res.data.map(function (item, index) {
                            operationI = tempData.length > 0 ? tempData[index].operation : 0;

                            if (initStuWpData.length > 0) {
                                initStuWpData.map(function (initItem) {
                                    if (initItem.SHWPID === item.PKID) {
                                        operationI = initItem.GMSL;
                                    }
                                });
                            }
                            return {
                                key: item.PKID, name: item.WPMC, gk: item.WPGG,
                                zd: item.ZLYQ, dj: item.WPDJ, buy: item.SFBXXG,
                                zdgmsl: item.ZDGML, operation: operationI
                            };
                        });
                        _this.setInitNumMap(basicdata);
                        _this.setState({ data: basicdata });
                    }
                }
            });
        };

        _this.checkIsZzbdHjLinked = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this.getQueryString('pkid');

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])("/zzbdCommon/checkIsZzbdHjLinked", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res) {
                    if (res.data) {
                        _this.setState({
                            transform: !res.data
                        });
                    } else {
                        _this.setState({
                            transform: true
                        });
                    }
                } else {
                    _this.setState({
                        transform: true
                    });
                }
            });
        };

        _this.getWPDatalist = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])().userId; //todo
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])(basicUrl + "/getShwpgmListById", "GET", _defineProperty({ xsid: xsid }, 'xsid', xsid)).then(function (res) {
                if (res) {
                    if (res.data) {
                        _this.setState({ initStuWpData: res.data });
                        if (_this.state.initStuWpData.length > 0) {
                            _this.setState({ transform: false });
                        }
                    }
                }
                _this.getWPlist(); //物品table列表数据
            });
        };

        _this.onChange = function (value, record) {
            // 限制数量 >= 0 
            if (value < 0) {
                value = 0;
            }
            var WPSLMap = _this.state.WPSLMap;

            if (value > record.zdgmsl) {
                __WEBPACK_IMPORTED_MODULE_22_antd_lib_index__["message"].warning(record.name + '已经到达最大购买数！');
                value = record.zdgmsl;
            }
            if (record.buy === '1' && value == 0) {
                value = 1;
            }
            if (value == 1) {
                record.operation = 1;
            }
            WPSLMap.set(record.key, value);

            record.operation = value;
            _this.changeMonMoneyAndNub();
            if (value == 0) {
                // this.setState({editFlag:true});
                WPSLMap.delete(record.key);
                record.editable = false;
                record.operation = 0;
            }
        };

        _this.onSave = function () {
            var _this$state2 = _this.state,
                WPSLMap = _this$state2.WPSLMap,
                update = _this$state2.update,
                transform = _this$state2.transform,
                data = _this$state2.data,
                tempData = _this$state2.tempData;

            _this.setState({ tempData: data });

            var sUrl = '/saveShwpgmData';
            var succeMsg = '信息保存成功！';
            var errMsg = '信息保存失败，请重试！';

            if (!transform) {
                sUrl = '/deleteShwpgmData';
                succeMsg = '取消成功！';
                errMsg = '取消失败，请重试！';
                // 点击取消时把物品清零
                WPSLMap.clear();
            }

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])().userId;
            var zzbdhjid = _this.getUrlParams("pkid");
            var params = { xsid: xsid, zzbdhjid: zzbdhjid, formData: WPSLMap };
            //请求保存或修改数据
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])(basicUrl + sUrl, 'POST', params).then(function (res) {
                if (res) {
                    if (res.data == '1') {
                        __WEBPACK_IMPORTED_MODULE_22_antd_lib_index__["message"].success(succeMsg);
                        _this.setState({ transform: !transform });
                        _this.getWPDatalist();
                        _this.reloadMenu();
                    } else {
                        __WEBPACK_IMPORTED_MODULE_22_antd_lib_index__["message"].error(errMsg);
                    }
                }
            });

            _this.setState({ loading: true });
            setTimeout(function () {
                _this.setState({
                    loading: false,
                    tempData: data
                });
            }, 1000);
        };

        _this.getUrlParams = function (param) {
            return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.onSelectChange = function (selectedRowKeys) {
            _this.setState({ selectedRowKeys: selectedRowKeys });
        };

        _this.getCheckboxProps = function (record) {
            return {
                disabled: record.key === 'last'
            };
        };

        _this.edit = function (key) {
            var newData = [].concat(_toConsumableArray(_this.state.data));
            var target = newData.filter(function (item) {
                return key === item.key;
            })[0];
            if (target) {
                target.editable = true;
                _this.setState({ data: newData });
            }
        };

        _this.save = function (key) {
            var newData = [].concat(_toConsumableArray(_this.state.data));
            var target = newData.filter(function (item) {
                return key === item.key;
            })[0];
            if (target) {
                delete target.editable;
                _this.setState({ data: newData });
                _this.cacheData = newData.map(function (item) {
                    return _extends({}, item);
                });
            }
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.handleSwitchClick = function (value, record) {
            var amount = value ? 1 : 0;
            var _this$state3 = _this.state,
                data = _this$state3.data,
                WPSLMap = _this$state3.WPSLMap;

            var tempMap = WPSLMap;
            if (amount === 1) {
                tempMap.set(record.key, amount);
            } else {
                tempMap.delete(record.key);
            }
            var newData = data.map(function (item, index) {
                if (item.key === record.key) {
                    item.operation = amount;
                }
                return item;
            });
            _this.setState({
                data: newData,
                WPSLMap: tempMap
            });
            _this.changeMonMoneyAndNub();
        };

        _this.state = {
            mkbz: 'GD002_1',
            hjmc: '',
            data: [],
            selectedRowKeys: [],
            loading: false,
            totalMoney: "", //购买总金额
            count: "", //总购买物件数
            ediFolag: true,
            selectedList: [],
            WPSLMap: new __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_map___default.a(), //物品数量map   key：物品pkid  value:物品数量
            WPDJMap: new __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_map___default.a(), //物品单价map   key: 物品pkid  value:物品单价
            transform: true,
            update: false,
            initStuWpData: [],
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            isHjLinked: false,
            quantity: '', //物品数量
            tempData: [] //临时表数据
        };
        return _this;
    }

    _createClass(BuyFa, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.checkIsZzbdHjLinked();
            this.getWPDatalist();
            this.queryQztjAndYlhj();
        }

        //查询前置条件和依赖环节


        //环节pkid

    }, {
        key: 'setInitNumMap',


        //初始开始算必须购买物品的总数和总价
        value: function setInitNumMap(m) {
            var _state = this.state,
                WPSLMap = _state.WPSLMap,
                WPDJMap = _state.WPDJMap;

            m.map(function (item) {
                if (item.operation != '0') {
                    WPSLMap.set(item.key, item.operation);
                }
                WPDJMap.set(item.key, item.dj);
            });

            this.changeMonMoneyAndNub();
        }

        //初始获取table列表

        //检查该环节是否已经办理


        //学生个人table列表数据


        //数字框发生变化检测

    }, {
        key: 'changeMonMoneyAndNub',


        //更改总金额和数量
        value: function changeMonMoneyAndNub() {
            var _state2 = this.state,
                WPSLMap = _state2.WPSLMap,
                WPDJMap = _state2.WPDJMap;

            var totalMoneys = 0;
            var nums = 0;
            WPSLMap.forEach(function (itemValue, itemKey, map) {
                totalMoneys += WPDJMap.get(itemKey) * itemValue;
                nums += itemValue;
            });
            this.setState({
                totalMoney: totalMoneys,
                count: nums
            });
        }

        //保存


        //获取url中传递的参数


        //重新加载菜单


        //switch开关点击事件

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state3 = this.state,
                loading = _state3.loading,
                selectedRowKeys = _state3.selectedRowKeys,
                data = _state3.data,
                selectedList = _state3.selectedList,
                WPSLMap = _state3.WPSLMap,
                WPDJMap = _state3.WPDJMap,
                count = _state3.count,
                totalMoney = _state3.totalMoney,
                ediFolag = _state3.ediFolag,
                transform = _state3.transform;

            var rowSelection = {
                selectedRowKeys: selectedRowKeys,
                onChange: this.onSelectChange,
                getCheckboxProps: this.getCheckboxProps
            };
            var hasSelected = selectedRowKeys.length > 0;
            var columns = [{
                title: '物品名称',
                dataIndex: 'name'
            }, {
                title: '产品规格',
                dataIndex: 'gk',
                render: function render(text, record) {
                    var obj = {
                        children: text,
                        props: {}
                    };
                    if (record.key === 'last') {
                        obj.props.colSpan = 5;
                    }
                    return obj;
                }
            }, {
                title: '产品质地',
                dataIndex: 'zd',
                render: function render(text, record) {
                    var obj = {
                        children: text,
                        props: {}
                    };
                    if (record.key === 'last') {
                        obj.props.colSpan = 0;
                    }
                    return obj;
                }
            }, {
                title: '单价（元）',
                dataIndex: 'dj',
                render: function render(text, record) {
                    if (record.key === 'last') {
                        return {
                            props: {
                                colSpan: 0
                            }
                        };
                    }
                    return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'span',
                        { className: 'text-primary' },
                        text
                    );
                }
            }, {
                title: '购买数量',
                dataIndex: 'operation',
                width: 120,
                render: function render(text, record) {
                    if (record.key === 'last') {
                        return {
                            props: {
                                colSpan: 0
                            }
                        };
                    }
                    var editable = record.editable,
                        buy = record.buy,
                        key = record.key,
                        dj = record.dj,
                        zdgmsl = record.zdgmsl,
                        operation = record.operation;

                    WPDJMap.set(key, dj);
                    return transform ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_stepper_primitive___default.a, {
                        min: buy,
                        max: zdgmsl,
                        render: function render() {
                            return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'span',
                                null,
                                operation
                            );
                        }
                    }) : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_number___default.a, {
                        defaultValue: operation,
                        disabled: !transform
                    });
                }
            }, {
                title: '是否购买',
                dataIndex: 'isBuy',
                width: 120,
                render: function render(text, record) {
                    if (record.key === 'last') {
                        return {
                            props: {
                                colSpan: 0
                            }
                        };
                    }
                    var transform = _this2.state.transform;
                    var operation = record.operation;

                    var isChecked = operation === 1 ? true : false;
                    return transform ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_switch___default.a, { checkedChildren: '\u662F', unCheckedChildren: '\u5426',
                        checked: isChecked,
                        onClick: function onClick(operation) {
                            _this2.handleSwitchClick(operation, record);
                        }
                    }) : record.operation == 1 ? '已购买' : '未购买';
                }

            }];
            if (data[0]) {
                if (data[data.length - 1].key === 'last') {
                    data.splice(data.length - 1, 1);
                }
                data.push({
                    key: 'last',
                    name: '合计',
                    gk: __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'span',
                        null,
                        '\u5171 ',
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'span',
                            { className: 'text-red' },
                            count || 0
                        ),
                        ' \u4EF6\u5546\u54C1\uFF0C\u5171\u8BA1',
                        ' ',
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'span',
                            { className: 'text-primary' },
                            totalMoney || 0
                        ),
                        ' \u5143'
                    )
                });
            }
            return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                'div',
                { className: 'app__css__app-pages-SelfHelp-buyFa-__index__page_buy' },
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230',
                        mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjmc, extra: false }),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'div',
                                { className: 'p-sw' },
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_table___default.a, {
                                    bordered: true,
                                    size: 'middle',
                                    pagination: false,
                                    columns: columns,
                                    dataSource: data
                                }),
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    'div',
                                    { className: 'text-center mt-50' },
                                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default.a,
                                        {
                                            type: 'primary',
                                            onClick: this.onSave,
                                            loading: loading
                                        },
                                        transform ? '保存' : '取消'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                )
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__common__["a" /* default */], { hjmc: "物品购买（新）", key: "GD002_1", mkbz: 'GD002_1', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return BuyFa;
}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);



/***/ }),

/***/ 1014:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UpdateInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_radio_style__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_radio__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_common_NHModal__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__index_css__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_SelfHelp_common_hint__ = __webpack_require__(35);















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }


















if (false) {
  module.hot.accept("./index.css", function () {
    require("./index.css");
  });
}

var history = __WEBPACK_IMPORTED_MODULE_24_history_createHashHistory___default()();
var RadioGroup = __WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a.Group;

var UpdateInfo = function (_React$Component) {
  _inherits(UpdateInfo, _React$Component);

  function UpdateInfo(props) {
    _classCallCheck(this, UpdateInfo);

    var _this = _possibleConstructorReturn(this, (UpdateInfo.__proto__ || __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default()(UpdateInfo)).call(this, props));

    _this.getHint = function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])("api/zhxg-yxwz/whrj/lstdghlb/getLbNr", 'get').then(function (res) {
        if (res && res.data) {
          _this.setState({
            lbnrList: res.data.lbnrList,
            radioValue: res.data.radioValue
          });
        }
      });
    };

    _this.queryQztjAndYlhj = function (callback) {
      var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])().userId : '';
      if (!xsid) {
        _this.setState({
          nonOperationalData: { nologin: true },
          operable: false
        });
        return;
      }
      var zzbdhjid = _this.getUrlParams('pkid');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
        if (res && res.data) {
          var kfsj = res.data['kfsj'];
          var ylhj = res.data['ylhj'];
          var qzhj = res.data['qzhj'];
          _this.setState({ nonOperationalData: res.data });
          if (kfsj && kfsj['YXSJ'] != '1') {
            _this.setState({ operable: false });
          }

          if (ylhj && ylhj.length > 0) {
            _this.setState({ operable: false });
          }

          if (qzhj && qzhj.length > 0) {
            _this.setState({ operable: false });
          }

          if (callback) {
            callback(_this.state.operable);
          }
        }
      });
    };

    _this.getUrlParams = function (param) {
      return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
    };

    _this.setMenuList = function (menuList) {
      var nextCount = 0;
      var bz = _this.state.mkbz;
      menuList.map(function (elem, index) {
        if (elem.HJDM == bz) {
          var hjmc = elem.HJMC;
          _this.setState({ hjmc: hjmc });
          nextCount = index + 1;
          return;
        }
      });
      var menu = menuList[nextCount];
      if (menu) {
        var hjdm = menu.HJDM;
        if (hjdm.indexOf("GD") == 0) {
          var gdUrl = __WEBPACK_IMPORTED_MODULE_27__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
          _this.setState({
            nextUrl: gdUrl,
            search: "pkid=" + menu.PKID
          });
        } else if (hjdm.indexOf("ZDY") == 0) {
          var zdyUrl = "/customLink";
          _this.setState({
            nextUrl: zdyUrl,
            search: "pkid=" + menu.PKID + "&mkbz=" + hjdm + "&lx=" + menu.LX
          });
        }
      } else {
        _this.setState({
          nextUrl: "",
          search: ""
        });
      }
    };

    _this.onChange = function (e) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__components_common_NHModal__["b" /* NHConfirm */])({
        content: "确定？", type: "danger", onOk: function onOk() {
          _this.setState({
            uploading: true
          });
          var zzbdhjid = _this.getUrlParams('pkid');
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])("api/zhxg-yxwz/whrj/lstdghlb/updateGhlbmd", 'get', { 'lbid': e.target.value, 'zzbdhjid': zzbdhjid }).then(function (res) {
            if (res && res.data == 1) {
              __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.success("选择成功！");
              _this.setState({
                radioValue: e.target.value,
                uploading: false
              });
            } else {
              __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.error("确定后不能再更改");
              _this.setState({
                uploading: false
              });
            }
          });
        }
      });

      // this.setState({
      //   uploading: true
      // })
      // let zzbdhjid = this.getUrlParams('pkid');
      // NHFetch(`api/zhxg-yxwz/whrj/lstdghlb/updateGhlbmd`, 'get', {'lbid': e.target.value, 'zzbdhjid': zzbdhjid})
      // .then(res => {
      //     if (res && res.data == 1) {
      //       message.success("更换成功！");
      //       this.setState({
      //         radioValue: e.target.value,
      //         uploading: false
      //       })
      //     } else {
      //       message.error("领取后不能在更改");
      //       this.setState({
      //         uploading: false
      //       })
      //     }
      // });
    };

    _this.state = {
      mkbz: "GD005_11",
      hjmc: "",
      nextUrl: "", //左侧菜单加载完后传进来
      search: "",
      menuList: [],
      uploading: false,
      lbnrList: [],
      radioValue: '',
      operable: true //是否显示环节
    };
    return _this;
  }

  _createClass(UpdateInfo, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      this.queryQztjAndYlhj(function (operable) {
        if (operable) {
          _this2.getHint();
        }
      });
    }

    //查询前置条件和依赖环节


    //获取url中传递的参数

  }, {
    key: "render",
    value: function render() {

      return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
        "div",
        null,
        this.state.operable ? __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
          { className: "w1180 mt-20", align: "start" },
          __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_Assembly_siderMenu__["a" /* default */], {
            ref: "siderMenu",
            setMenuList: this.setMenuList,
            title: "\u81EA\u52A9\u62A5\u5230"
            /*   active={0}*/
            , mkbz: this.state.mkbz,
            menuType: "\u81EA\u52A9\u62A5\u5230",
            sfxs: "true"
          }),
          __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
            { className: "page_con_r" },
            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_Assembly_Breadcrumb__["a" /* default */], {
              noLine: true,
              list: [{ name: "首页", url: "/index" }, { name: "自助报到", url: "/register" }, { name: this.state.hjmc }]
            }),
            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin___default.a,
              { spinning: this.state.uploading },
              __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                "div",
                { className: "box" },
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__pages_SelfHelp_common_hint__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pages_Assembly_titleTop__["a" /* default */], {
                  className: "mt-20",
                  title: this.state.hjmc,
                  extra: false
                }),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                  "div",
                  { className: "tip" },
                  __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    RadioGroup,
                    { onChange: this.onChange, value: this.state.radioValue },
                    this.state.lbnrList.map(function (elem, index) {
                      return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                        { style: { marginTop: '20px' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                          {
                            key: index,
                            span: 4
                          },
                          __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a,
                            {
                              value: elem.pkid
                            },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                              "span",
                              null,
                              elem.lbmc + '：'
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                              "span",
                              null,
                              elem.lbnr
                            )
                          )
                        )
                      );
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                  "div",
                  { className: "p-sw text-center mt-30" },
                  __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__pages_SelfHelp_common_nextIndex__["a" /* default */], {
                    nextUrl: this.state.nextUrl,
                    search: this.state.search
                  })
                )
              )
            )
          )
        ) : __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__common__["a" /* default */], { hjmc: "报到情况填写", key: 'GD004', mkbz: "GD004", nonOperationalData: this.state.nonOperationalData })
      );
    }
  }]);

  return UpdateInfo;
}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);



/***/ }),

/***/ 1015:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dorm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert_style__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_radio_style__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_radio__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_checkbox_style__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_checkbox__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__selectBox__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__selectModal__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__index_css__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__utils_getSize__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_common_NHModal__ = __webpack_require__(106);
























var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }





















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_34_history_createHashHistory___default()();
var confirm = __WEBPACK_IMPORTED_MODULE_22_antd_lib_modal___default.a.confirm;
var CheckboxGroup = __WEBPACK_IMPORTED_MODULE_20_antd_lib_checkbox___default.a.Group;
var RadioGroup = __WEBPACK_IMPORTED_MODULE_18_antd_lib_radio___default.a.Group;
/**
 * @author weishihuai
 * @date 2018/7/6
 * @time 14:41
 * @Description: 迎新网站-自助报到-宿舍分配(成都职业技术学院)
 */

var Dorm = function (_React$Component) {
    _inherits(Dorm, _React$Component);

    function Dorm(props) {
        _classCallCheck(this, Dorm);

        var _this2 = _possibleConstructorReturn(this, (Dorm.__proto__ || __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_get_prototype_of___default()(Dorm)).call(this, props));

        _this2.updateZzbdBlzt = function () {
            var zzbdhjid = _this2.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/zzbd/updateZzbdBlzt', 'GET', { zzbdhjid: zzbdhjid, hjdm: 'GD006_3' }).then(function (res) {
                if (res.data) {
                    _this2.reloadMenu();
                }
            });
        };

        _this2.getQualifications = function (xsid) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])("/zzbdCommon/cdzyjsxy/getQualifications", 'GET', { xsid: xsid }).then(function (res) {
                if (res && res.data.flag === '1') {
                    _this2.setState({
                        flag: true
                    });
                } else {
                    _this2.setState({
                        flag: false
                    });
                }
            });
        };

        _this2.queryQztjAndYlhj = function (callback) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this2.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this2.getUrlParams('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this2.setState({ nonOperationalData: res.data });
                    if (kfsj && kfsj['YXSJ'] != '1') {
                        _this2.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this2.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this2.setState({ operable: false });
                    }

                    if (callback) {
                        callback(_this2.state.operable);
                    }
                }
            });
        };

        _this2.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this2.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this2.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_38__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this2.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this2.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this2.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this2.getUrlParams = function (param) {
            return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this2.getSfbzAndCwsInfo = function (xsid, xqid, xbm) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])("/gyxtUnauth/cwfp/getYxxcSfbzAndSslxInfo", 'GET', { xqid: xqid ? xqid : "", xsid: xsid, xbm: xbm }).then(function (res) {
                if (res) {
                    var data = res.data;
                    _this2.setState({
                        cwsList: data.cwsList,
                        sfbzList: data.sfbzList,
                        xqList: data.xqList
                    });

                    //如果学生无校区信息,默认加载第一个Tab校区的宿舍信息
                    if (!xqid) {
                        _this2.setState({
                            currentXqid: data.xqList[0].XQID
                        });
                        _this2.getFjxxList({
                            cws: "",
                            sfbz: "",
                            xsid: xsid,
                            xqid: data.xqList[0].XQID,
                            xbm: xbm
                        });
                    }
                }
            });
        };

        _this2.getFjxxList = function (param) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])("/gyxtUnauth/cwfp/getYxwzSsfpFjxxList", 'GET', param).then(function (res) {
                if (res) {
                    _this2.setState({
                        fjxxList: res.data
                    });
                }
            });
        };

        _this2.getXsssrzYwxxByXsid = function (xsid) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/getXsssrzYwxxByXsid', 'GET', {
                xsid: xsid
            }).then(function (res) {
                if (res && res.data) {
                    _this2.setState({
                        xsssruYwxx: res.data
                    });
                }
            });
        };

        _this2.confirmCwfpxx = function (xzId) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var _this2$state = _this2.state,
                loginUserInfo = _this2$state.loginUserInfo,
                flag = _this2$state.flag;

            var xqid = loginUserInfo.XQID,
                xbm = loginUserInfo.XBM;
            if (!xzId) {
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.warning("请先选择一个床位！");
                return;
            }
            if (!flag) {
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.warning("不满足条件，无法自动办理！");
                return;
            }

            //检查该床位是否被其他学生抢占(防并发的情况下同一个床位被其他人重复选择)
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/checkCwIsPermitSelect', 'GET', { cwid: xzId, xsid: xsid }).then(function (res) {
                if (res) {
                    if (res.data === 0) {
                        __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("抱歉，该床位已经被其他同学抢占，请选择其他床位！");
                        return;
                    } else {
                        //确认床位信息
                        _this2.cwfpSubmit(xsid, xzId, xqid, xbm);
                    }
                }
            });
        };

        _this2.cwfpSubmit = function (xsid, currentClickCwPkid, xqid, xbm) {
            var zzbdhjid = _this2.getUrlParams("pkid");
            var params = { xsid: xsid, cwid: currentClickCwPkid, zzbdhjid: zzbdhjid };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/checkCwIsAvailableSelected', 'GET', { cwid: currentClickCwPkid }).then(function (res) {
                if (res) {
                    if (res.data) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/yxwzConfirmCwxx', 'POST', params).then(function (res) {
                            if (res) {
                                if (res.data) {
                                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.success("分配成功！");
                                    _this2.reloadMenu();
                                    _this2.setState({
                                        currentClickCwPkid: ""
                                    });

                                    _this2.getFjxxList({
                                        cws: "",
                                        sfbz: "",
                                        xsid: xsid,
                                        xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                                        xbm: xbm
                                    });

                                    _this2.getXsssrzYwxxByXsid(xsid);

                                    _this2.checkZzbdisLinked();
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("分配失败，请稍后重试！");
                                }
                            }
                        });
                    } else {
                        __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("抱歉，该床位未到分配时间或已过床位分配时间期限，请选择其他床位! ");
                    }
                }
            });
        };

        _this2.showConfirm = function (value, id, cwh) {
            confirm({
                title: __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                    'span',
                    null,
                    '\u786E\u5B9A\u9009\u62E9',
                    value.name,
                    '\u623F\u95F4\u7684\u4E0B\u5217\u5E8A\u94FA\uFF1F'
                ),
                content: __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__selectModal__["a" /* default */], {
                    data: value,
                    id: id,
                    currentClickCwh: cwh,
                    onChange: function onChange(value) {
                        _this2.setState({
                            xzId: value.id,
                            currentClickCwPkid: value.id
                        });
                    }
                }),
                onOk: function onOk() {
                    var currentClickCwPkid = _this2.state.currentClickCwPkid;
                    //确定分配宿舍提交

                    _this2.confirmCwfpxx(currentClickCwPkid);
                },
                onCancel: function onCancel() {
                    _this2.setState({
                        currentClickCwPkid: ""
                    });
                }
            });
        };

        _this2.judeageCs = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/yxwzSyzxcs', 'GET', { xsid: xsid }).then(function (res) {

                if (res && res.data === -1) {
                    _this2.handleCancelListener();
                } else if (res && res.data === 0) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_40__components_common_NHModal__["b" /* NHConfirm */])("自选宿舍次数已用完，取消后不能再进行自选宿舍操作！确定取消？", function () {
                        _this2.handleCancelListener();
                    }, "warn");
                } else if (res && res.data !== -1 && res.data !== 0) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_40__components_common_NHModal__["b" /* NHConfirm */])("确定取消？取消后还剩" + res.data + "次可选", function () {
                        _this2.handleCancelListener();
                    }, "warn");
                }
            });
        };

        _this2.handleCancelListener = function () {
            _this2.setState({
                cancelLoading: true
            });
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xqid = loginUserInfo.XQID,
                xbm = loginUserInfo.XBM;

            var zzbdhjid = _this2.getUrlParams("pkid");
            var params = { xsid: xsid, zzbdhjid: zzbdhjid };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/cancelBlSsfp', 'POST', params).then(function (res) {
                if (res && res.data === 1) {
                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.success('取消办理成功！');
                    _this2.reloadMenu();
                    _this2.getFjxxList({
                        cws: "",
                        sfbz: "",
                        xsid: xsid,
                        xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                        xbm: xbm
                    });

                    _this2.checkZzbdisLinked();

                    _this2.setState({
                        xsssruYwxx: {},
                        cancelLoading: false
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error('取消办理失败，请稍后重试！');
                    _this2.setState({
                        cancelLoading: false
                    });
                }
            }).catch(function () {
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("取消办理失败，请稍后重试！");
                _this2.setState({
                    cancelLoading: false
                });
            });
        };

        _this2.handleAutoDistributeListener = function () {
            _this2.setState({
                autoBlLoading: true
            });
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var _this2$state2 = _this2.state,
                loginUserInfo = _this2$state2.loginUserInfo,
                flag = _this2$state2.flag;

            var xqid = loginUserInfo.XQID,
                xbm = loginUserInfo.XBM;
            var zzbdhjid = _this2.getUrlParams("pkid");

            if (!xsid) {
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.warning("自动办理失败,请稍后重试！");
                _this2.setState({
                    autoBlLoading: false
                });
                return;
            }
            if (!flag) {
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.warning("不满足条件，无法自动办理！");
                _this2.setState({
                    autoBlLoading: false
                });
                return;
            }

            var param = _this2.state.param;
            //自动分配宿舍

            var params = {
                cws: param.cws || "",
                sfbz: param.sfbz || "",
                xsid: xsid,
                xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                xbm: xbm,
                zzbdhjid: zzbdhjid
            };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])("/gyxtUnauth/cwfp/yxwzAutoDistributeSscwxx", 'POST', params).then(function (res) {
                if (res) {
                    if (res.data === 1) {
                        var text = "";
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/getXsssrzYwxxByXsid', 'GET', { xsid: xsid }).then(function (res) {
                            if (res && res.data) {
                                var data = res.data;
                                _this2.setState({
                                    xsssruYwxx: data
                                });
                                text = data.ldmc + "-" + data.fj + "-" + data.cwh + "号床位";
                                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.success("自动办理成功,分配宿舍为 " + text + "！");
                                _this2.reloadMenu();
                                _this2.getFjxxList({
                                    cws: "",
                                    sfbz: "",
                                    xsid: xsid,
                                    xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                                    xbm: xbm
                                });

                                _this2.getXsssrzYwxxByXsid(xsid);
                                _this2.checkZzbdisLinked();

                                _this2.setState({
                                    autoBlLoading: false
                                });
                            } else {
                                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("自动办理失败,请稍后重试！");
                                _this2.setState({
                                    autoBlLoading: false
                                });
                            }
                        });
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("自动办理失败,请稍后重试！");
                    _this2.setState({
                        autoBlLoading: false
                    });
                }
            }).catch(function () {
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("自动办理失败,请稍后重试！");
                _this2.setState({
                    autoBlLoading: false
                });
            });
        };

        _this2.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this2.checkZzbdisLinked = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this2.getUrlParams("pkid");
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])("/zzbdCommon/checkIsZzbdHjLinked", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                console.log("公寓", res.data);
                if (res) {
                    if (res.data) {
                        _this2.setState({
                            isHjLinked: res.data
                        });
                    } else {
                        _this2.setState({
                            isHjLinked: false
                        });
                    }
                } else {
                    _this2.setState({
                        isHjLinked: false
                    });
                }
            });
        };

        _this2.autoSelectCwListener = function (value) {
            _this2.setState({
                zdrzLoading: true
            });
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var _this2$state3 = _this2.state,
                loginUserInfo = _this2$state3.loginUserInfo,
                flag = _this2$state3.flag;

            var xqid = loginUserInfo.XQID,
                xbm = loginUserInfo.XBM;

            var yxwzCwxxTzVOs = value.yxwzCwxxTzVOs,
                name = value.name;

            var zzbdhjid = _this2.getUrlParams("pkid");
            var availableSelectArr = [],
                availSelectCwPkId = "",
                text = "";

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(yxwzCwxxTzVOs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    availableSelectArr.push(item.xz);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (availableSelectArr.indexOf("0") === -1) {
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.warning("抱歉，该房间已满员，请选择其他房间！");
                return;
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(yxwzCwxxTzVOs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _item = _step2.value;

                    //床位未被选择并且未过分配期限
                    if (_item.xz === '0' && !_item.expire) {
                        availSelectCwPkId = _item.id;
                        text = name + "-" + _item.cwh;
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            if (!flag) {
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.warning("不满足条件，无法自动办理！");
                _this2.setState({
                    zdrzLoading: false
                });
                return;
            }

            if (availSelectCwPkId) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/checkCwIsPermitSelect', 'GET', { cwid: availSelectCwPkId, xsid: xsid }).then(function (res) {
                    if (res) {
                        if (res.data === 0) {
                            __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("抱歉，该床位已经被其他同学抢占，请选择其他床位！");
                            _this2.setState({
                                zdrzLoading: false
                            });
                            return;
                        } else {
                            // 确认床位信息
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/yxwzConfirmCwxx', 'POST', {
                                xsid: xsid,
                                cwid: availSelectCwPkId,
                                zzbdhjid: zzbdhjid
                            }).then(function (res) {
                                if (res) {
                                    if (res.data) {
                                        __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.success("分配成功，分配宿舍为 " + text + ", 请尽快确认办理！");
                                        _this2.reloadMenu();
                                        _this2.getFjxxList({
                                            cws: "",
                                            sfbz: "",
                                            xsid: xsid,
                                            xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                                            xbm: xbm
                                        });

                                        _this2.getXsssrzYwxxByXsid(xsid);
                                        _this2.checkZzbdisLinked();

                                        _this2.setState({
                                            zdrzLoading: false
                                        });
                                    }
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("分配失败，请稍后重试！");
                                    _this2.setState({
                                        zdrzLoading: false
                                    });
                                }
                            });
                        }
                    }
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.warning("抱歉，未匹配到合适的床位信息,请选择其他床位！");
                _this2.setState({
                    zdrzLoading: false
                });
            }
        };

        _this2.onSfbzChangeListener = function (checkedValues) {
            var _this2$state4 = _this2.state,
                param = _this2$state4.param,
                currentXqid = _this2$state4.currentXqid,
                sfmy = _this2$state4.sfmy;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xbm = loginUserInfo.XBM;
            param.sfbz = checkedValues.length > 0 ? checkedValues.join(",") : "";
            param.xsid = xsid;
            param.xqid = currentXqid ? currentXqid : _this2.state.xqList[0].XQID;
            param.xbm = xbm;
            param.sfmy = sfmy;
            _this2.setState({
                sfbz: checkedValues.length > 0 ? checkedValues.join(",") : ""
            });
            _this2.getFjxxList(param);
        };

        _this2.onSfmyChangeListener = function (e) {
            var _this2$state5 = _this2.state,
                param = _this2$state5.param,
                currentXqid = _this2$state5.currentXqid,
                sfbz = _this2$state5.sfbz;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xbm = loginUserInfo.XBM;
            param.sfbz = sfbz;
            param.xsid = xsid;
            param.xqid = currentXqid ? currentXqid : _this2.state.xqList[0].XQID;
            param.xbm = xbm;
            param.sfmy = e.target.value;
            _this2.setState({
                sfmy: e.target.value
            });
            _this2.getFjxxList(param);
        };

        _this2.onCwsChange = function (checkedValues) {
            var _this2$state6 = _this2.state,
                param = _this2$state6.param,
                currentXqid = _this2$state6.currentXqid;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xbm = loginUserInfo.XBM;
            param.cws = checkedValues.length > 0 ? checkedValues.join(",") : "";
            param.xsid = xsid;
            param.xbm = xbm;
            param.xqid = currentXqid ? currentXqid : _this2.state.xqList[0].XQID;
            _this2.getFjxxList(param);
        };

        _this2.tabChangeListener = function (activeKey) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xbm = loginUserInfo.XBM;
            var _this2$state$param = _this2.state.param,
                cws = _this2$state$param.cws,
                sfbz = _this2$state$param.sfbz;


            _this2.setState({
                currentXqid: activeKey
            });

            //加载房间信息
            _this2.getFjxxList({
                cws: cws || "",
                sfbz: sfbz || "",
                xsid: xsid,
                xqid: activeKey,
                xbm: xbm
            });
        };

        _this2.reloadMenu = function () {
            _this2.refs.siderMenu.reloadMenuList();
        };

        _this2.state = {
            mkbz: 'GD006_3',
            hjmc: '',
            xzId: '',
            _xzId: '',
            cwsList: [], //床位数
            sfbzList: [], //收费标准
            xqList: [], //校区信息
            currentXqid: "", //当前校区ID
            fjxxList: [], //房间信息
            currentClickCwPkid: "", //当前床位信息ID
            xsssruYwxx: {}, //学生宿舍入住业务信息
            isHjLinked: false, //环节是否办理状态
            param: {}, //过滤条件
            scrollHeight: 200, //默认滚动高度
            loginUserInfo: {}, //当前登录学生信息
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            autoBlLoading: false, //自动办理按钮载入状态
            cancelLoading: false, //取消办理按钮载入状态
            zdrzLoading: false, //自动入住载入状态
            setRoom: [], //过滤房间信息
            sfbz: "", //收费标准选中值
            sfmy: "", //是否满员选中值
            flag: false //是否：1有缴费记录，2绿色通道；3购买床上用品 

        };
        return _this2;
    }

    _createClass(Dorm, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var that = this;
            this.setState({ scrollHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_getSize__["a" /* default */])().windowH - 206 });
            window.onresize = function () {
                that.setState({
                    scrollHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_getSize__["a" /* default */])().windowH - 206
                });
            };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            this.queryQztjAndYlhj(function (operable) {
                if (operable) {
                    var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
                    if (xsid) {
                        var _this = _this3;
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["d" /* getLoginUserInfo */])(xsid, function (data) {
                            _this.setState({
                                loginUserInfo: data
                            }, function () {
                                var loginUserInfo = _this.state.loginUserInfo;

                                var xqid = loginUserInfo.XQID,
                                    xbm = loginUserInfo.XBM;

                                if (xsid) {
                                    //办理状态根据 关联现场环节和是否反向关联修改 不根据现场状态
                                    //_this.updateZzbdBlzt();
                                    //判断是否缴费信息
                                    _this.getQualifications(xsid);
                                    //加载收费标准、床位数信息
                                    _this.getSfbzAndCwsInfo(xsid, xqid, xbm);
                                    _this.getXsssrzYwxxByXsid(xsid);
                                    //如果学生校区ID不为空,则只加载本校区宿舍信息
                                    if (xqid) {
                                        _this.setState({
                                            currentXqid: xqid
                                        });
                                        _this.getFjxxList({
                                            cws: "",
                                            sfbz: "",
                                            xsid: xsid,
                                            xqid: xqid,
                                            xbm: xbm
                                        });
                                    }
                                }
                                _this.checkZzbdisLinked();
                            });
                        });
                    }
                }
            });
        }

        //迎新现场已办理时迎新网站自动办理


        //查询前置条件和依赖环节


        //获取url中传递的参数


        //获取收费标准、床位信息等


        //获取宿舍房间信息


        // 过滤可以选择的房间信息
        // fitlerRoom = () => {
        //     let kyxzRoom = [];
        //     // console.log("获取房间信息-------",res.data);
        //     let fjxxList = this.state.fjxxList;
        //     fjxxList.map((item, index) => {
        //         if (item.yxNum < item.allNum) {
        //             // console.log("未住满的房间(个数判断)------",item);
        //             if (item.bedList && item.bedList.length > 0) {
        //                 item.yxwzCwxxTzVOs.map((item2, index2) => {
        //                     console.log("item2", item2);
        //                     if (item2.xz == '0') {
        //                         // console.log("可以选择的床位---------",item2,item);
        //                         kyxzRoom.push(item);
        //                     }
        //                 })
        //             }
        //         }
        //     })
        //     let setRoom = [];
        //     if (kyxzRoom.length > 0) {
        //         setRoom = Array.from(new Set(kyxzRoom));
        //         // setRoom = Array.from(setRoom);
        //     }
        //     console.log("过滤后的房间------", kyxzRoom, setRoom);
        //     this.setState({
        //         setRoom: setRoom
        //     })
        // }

        //查询学生宿舍入住信息


        //确认床位分配


        //床位分配提交


        //选择床位弹层


        //取消办理事件


        //自动办理事件

        //检查环节是否已办理


        //自动入住事件


        //收费标准onChange事件


        //是否满员onChange事件


        //宿舍类型onChange事件


        //tab切换事件


        //重新加载菜单

    }, {
        key: 'render',


        // handleNextRoom = (RoomList) => {
        //     const { fjxxList, setRoom } = this.state;
        //     console.log("当前宿舍信息-----------", RoomList, fjxxList, setRoom);
        //     let list = [];
        //     fjxxList.map((item, index) => {
        //         if (item.fjid == "cba18dd6-ac51-4119-b35e-1f2d9eb30bf7") {
        //             item.yxNum = '8';
        //         }
        //         list.push(item);
        //     })
        //     console.log("模拟修改-----------", list);
        //     this.setState({
        //         fjxxList: list
        //     }, () => {
        //         this.fitlerRoom();
        //     })
        // }

        value: function render() {
            var _this4 = this;

            var _state = this.state,
                xzId = _state.xzId,
                _xzId = _state._xzId,
                cwsList = _state.cwsList,
                xqList = _state.xqList,
                sfbzList = _state.sfbzList,
                fjxxList = _state.fjxxList,
                setRoom = _state.setRoom,
                xsssruYwxx = _state.xsssruYwxx,
                isHjLinked = _state.isHjLinked,
                scrollHeight = _state.scrollHeight,
                currentXqid = _state.currentXqid,
                autoBlLoading = _state.autoBlLoading,
                cancelLoading = _state.cancelLoading,
                zdrzLoading = _state.zdrzLoading;
            //学生已选宿舍信息

            var xqmc = xsssruYwxx.xqmc,
                ldmc = xsssruYwxx.ldmc,
                fj = xsssruYwxx.fj,
                cwh = xsssruYwxx.cwh;

            var yxssInfo = (xqmc || "") + "-" + (ldmc || "") + "-" + (fj || "") + "-" + (cwh || "") + "号床";
            var fsmyList = [{ "label": "未满", "value": "0" }, { "label": "满员", "value": "1" }];
            // let RoomList = []
            // if (setRoom.length > 1) {
            //     RoomList.push(setRoom[0]);
            // } else {
            //     RoomList = setRoom;
            // }
            return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230',
                        mkbz: this.state.mkbz
                        /*   active={5}*/
                        , menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */].Item,
                        { className: 'page_con_r ' },
                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_titleTop__["a" /* default */],
                                {
                                    className: 'mt-20',
                                    title: this.state.hjmc,
                                    extra: false
                                },
                                !isHjLinked ? __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_12_antd_lib_button___default.a,
                                    {
                                        className: 'ml-10',
                                        type: 'primary',
                                        ghost: true,
                                        loading: autoBlLoading,
                                        onClick: this.handleAutoDistributeListener
                                    },
                                    '\u81EA\u52A8\u529E\u7406'
                                ) : __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_12_antd_lib_button___default.a,
                                    {
                                        className: 'ml-10',
                                        type: 'danger',
                                        ghost: true,
                                        loading: cancelLoading,
                                        onClick: this.judeageCs
                                    },
                                    '\u53D6\u6D88\u529E\u7406'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                'div',
                                { className: 'p-sw' },
                                __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */],
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                        'span',
                                        null,
                                        '\u6536\u8D39\u6807\u51C6\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */].Item,
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                            CheckboxGroup,
                                            {
                                                style: { width: '100%' },
                                                onChange: this.onSfbzChangeListener
                                            },
                                            __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_row___default.a,
                                                null,
                                                sfbzList.map(function (elem, index) {
                                                    return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_10_antd_lib_col___default.a,
                                                        {
                                                            key: index,
                                                            span: 4
                                                        },
                                                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_20_antd_lib_checkbox___default.a,
                                                            {
                                                                value: elem.value
                                                            },
                                                            elem.label
                                                        )
                                                    );
                                                })
                                            )
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */],
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                        'span',
                                        null,
                                        '\u662F\u5426\u6EE1\u5458\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */].Item,
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                            RadioGroup,
                                            {
                                                style: { width: '100%' },
                                                onChange: this.onSfmyChangeListener,
                                                defaultValue: '0'
                                            },
                                            __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_row___default.a,
                                                null,
                                                fsmyList.map(function (elem, index) {
                                                    return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_10_antd_lib_col___default.a,
                                                        {
                                                            key: index,
                                                            span: 4
                                                        },
                                                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_18_antd_lib_radio___default.a,
                                                            {
                                                                value: elem.value
                                                            },
                                                            elem.label
                                                        )
                                                    );
                                                })
                                            )
                                        )
                                    )
                                ),
                                isHjLinked && __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert___default.a, { message: "当前选择宿舍为: " + yxssInfo, type: 'info', showIcon: true })
                                ),
                                __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin___default.a,
                                    { spinning: zdrzLoading },
                                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__tab_box' },
                                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__selectBox__["a" /* default */], {
                                            Data: fjxxList,
                                            xzId: _xzId,
                                            showConfirm: this.showConfirm,
                                            onChange: function onChange(value) {
                                                _this4.setState({
                                                    xzId: value.id,
                                                    currentClickCwPkid: value.id
                                                });
                                            },
                                            autoSelectCwListener: function autoSelectCwListener(value) {
                                                return _this4.autoSelectCwListener(value);
                                            },
                                            scrollHeight: scrollHeight,
                                            tabChangeListener: this.tabChangeListener,
                                            xqList: xqList,
                                            currentXqid: currentXqid
                                        })
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                'div',
                                { className: 'text-center mt-50' },
                                __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__common__["a" /* default */], { hjmc: "自选宿舍", key: 'GD006_3', mkbz: 'GD006_3', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return Dorm;
}(__WEBPACK_IMPORTED_MODULE_23_react___default.a.Component);



/***/ }),

/***/ 1016:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_popover_style__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_popover_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_popover_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_popover__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_tabs_style__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_plugin_react_css_modules_dist_browser_getClassName__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_plugin_react_css_modules_dist_browser_getClassName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_plugin_react_css_modules_dist_browser_getClassName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__index_css__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars__);











var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;


var _styleModuleImportMap = {
    './index.css': {
        'tab_box': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__tab_box',
        'tip': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__tip',
        'item': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__item',
        'item_con': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__item_con',
        'round': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__round',
        'select_box': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__select_box',
        'select_list': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__select_list',
        'select_item': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__select_item',
        'select_item_b': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__select_item_b',
        'select_item_y': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__select_item_y',
        'item_btn_box': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__item_btn_box',
        'item_btn': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__item_btn',
        'modal_box': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__modal_box',
        'modal_list': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__modal_list'
    }
};

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }










if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var TabPane = __WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default.a.TabPane;

/**
 * @author weishihuai
 * @date 2018/7/6
 * @time 14:42
 * @Description: 迎新网站-自助报到-宿舍分配-宿舍床位信息
 */
var SelectBox = (_temp = _class = function (_React$Component) {
    _inherits(SelectBox, _React$Component);

    function SelectBox(props) {
        _classCallCheck(this, SelectBox);

        var _this = _possibleConstructorReturn(this, (SelectBox.__proto__ || __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default()(SelectBox)).call(this, props));

        _this.getListItem = function () {
            var Data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var _this$props = _this.props,
                className = _this$props.className,
                showConfirm = _this$props.showConfirm,
                xzId = _this$props.xzId,
                onChange = _this$props.onChange,
                autoSelectCwListener = _this$props.autoSelectCwListener;

            return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_14__components__["a" /* Flex */],
                { align: 'top', wrap: 'wrap', className: 'mt-20' },
                Data.length > 0 ? Data.map(function (item, idx) {
                    var sscx = item.sscx != null && item.sscx.length > 0 ? item.sscx : '';
                    var fjxx = item.name + " " + sscx;
                    return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        'div',
                        { key: idx, className: 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__item' },
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__item_con' },
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__components__["a" /* Flex */],
                                { justify: 'between' },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'span',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('span', { className: 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__round' }),
                                    fjxx.length < 12 ? fjxx : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        { style: { cursor: "pointer" } },
                                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_popover___default.a,
                                            { content: fjxx, trigger: 'hover' },
                                            fjxx.substr(0, 10) + "..."
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'span',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        { className: 'text-blue' },
                                        item.yxNum
                                    ),
                                    '/',
                                    item.allNum
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__components__["a" /* Flex */],
                                {
                                    wrap: 'wrap',
                                    align: 'center',
                                    justify: 'center',
                                    className: 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__select_box'
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'div',
                                    { className: 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__select_list' },
                                    item.bedList[0] && item.bedList.map(function (el, index) {
                                        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                            'div',
                                            { key: index },
                                            el.map(function (cwxx, index) {
                                                return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div', {
                                                    key: index,

                                                    onClick: function onClick() {
                                                        if (cwxx.xz === "0") {
                                                            showConfirm(item, cwxx.id, cwxx.cwh);
                                                            onChange(cwxx);
                                                        } else {
                                                            __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.warning('抱歉，该床铺已选择！');
                                                        }
                                                    },
                                                    className: __WEBPACK_IMPORTED_MODULE_10_babel_plugin_react_css_modules_dist_browser_getClassName___default()(__WEBPACK_IMPORTED_MODULE_13_classnames___default()('select_item', {
                                                        select_item_b: cwxx.xz === '1',
                                                        select_item_y: xzId === cwxx.id && cwxx.xz === '0' || cwxx.currentXsSelected
                                                    }), _styleModuleImportMap)
                                                });
                                            })
                                        );
                                    })
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__item_btn_box' },
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'div',
                                {
                                    className: 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__item_btn',
                                    onClick: function onClick() {
                                        return autoSelectCwListener(item);
                                    }
                                },
                                '\u81EA\u52A8\u5165\u4F4F'
                            ),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'div',
                                {
                                    className: 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__item_btn',
                                    onClick: function onClick() {
                                        return showConfirm(item);
                                    }
                                },
                                '\u9009\u62E9\u5E8A\u4F4D'
                            )
                        )
                    );
                }) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        'span',
                        { style: { color: "#f00" } },
                        '\u6682\u65E0\u5339\u914D\u7684\u5BBF\u820D\u4FE1\u606F\uFF01'
                    )
                )
            );
        };

        return _this;
    }

    //床位信息


    _createClass(SelectBox, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                className = _props.className,
                Data = _props.Data,
                scrollHeight = _props.scrollHeight,
                tabChangeListener = _props.tabChangeListener,
                xqList = _props.xqList,
                currentXqid = _props.currentXqid;

            var activeKey = currentXqid || xqList[0] && xqList[0].XQID;

            return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default.a,
                { defaultActiveKey: '0', activeKey: activeKey, tabPosition: 'top',
                    onChange: function onChange(activeKey) {
                        return tabChangeListener(activeKey);
                    } },
                xqList.map(function (xq) {
                    return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        TabPane,
                        { tab: xq.XQMC, key: xq.XQID },
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_14__components__["a" /* Flex */],
                            { className: 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__tip', justify: 'center' },
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('img', {
                                src: __webpack_require__(281),
                                alt: ''
                            }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'span',
                                null,
                                '\u53EF\u9009\u62E9'
                            ),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('img', {
                                className: 'ml-10',
                                src: __webpack_require__(280),
                                alt: ''
                            }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'span',
                                null,
                                '\u4E0D\u53EF\u9009'
                            ),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('img', {
                                className: 'ml-10',
                                src: __webpack_require__(282),
                                alt: ''
                            }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'span',
                                null,
                                '\u5DF2\u9009\u62E9'
                            )
                        ),
                        Data.length > 16 ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars__["Scrollbars"],
                            { autoHide: true,
                                style: { width: '100%', height: scrollHeight } },
                            _this2.getListItem(Data)
                        ) : _this2.getListItem(Data)
                    );
                })
            );
        }
    }]);

    return SelectBox;
}(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component), _class.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,
    xzId: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.any,
    showConfirm: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
    autoSelectCwListener: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
    tabChangeListener: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func
}, _class.defaultProps = {
    xzId: '',
    showConfirm: Function.prototype,
    onChange: Function.prototype,
    autoSelectCwListener: Function.prototype,
    tabChangeListener: Function.prototype
}, _temp);


/***/ }),

/***/ 1017:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_plugin_react_css_modules_dist_browser_getClassName__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_plugin_react_css_modules_dist_browser_getClassName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_plugin_react_css_modules_dist_browser_getClassName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_css__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__index_css__);







var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;


var _styleModuleImportMap = {
    './index.css': {
        'tab_box': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__tab_box',
        'tip': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__tip',
        'item': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__item',
        'item_con': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__item_con',
        'round': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__round',
        'select_box': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__select_box',
        'select_list': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__select_list',
        'select_item': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__select_item',
        'select_item_b': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__select_item_b',
        'select_item_y': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__select_item_y',
        'item_btn_box': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__item_btn_box',
        'item_btn': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__item_btn',
        'modal_box': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__modal_box',
        'modal_list': 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__modal_list'
    }
};

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }









/**
 * @author weishihuai
 * @date 2018/7/6
 * @time 14:41
 * @Description: 迎新网站-自助报到-宿舍分配-选择床位弹层
 */

if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var SelectModal = (_temp = _class = function (_React$Component) {
    _inherits(SelectModal, _React$Component);

    function SelectModal(props) {
        _classCallCheck(this, SelectModal);

        var _this = _possibleConstructorReturn(this, (SelectModal.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(SelectModal)).call(this, props));

        var id = props.id;

        _this.state = {
            xzId: id,
            currentClickCwh: "" //当前床位号
        };
        return _this;
    }

    _createClass(SelectModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var currentClickCwh = this.props.currentClickCwh;

            this.setState({
                currentClickCwh: currentClickCwh
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                xzId = _state.xzId,
                currentClickCwh = _state.currentClickCwh;
            var _props = this.props,
                className = _props.className,
                data = _props.data,
                onChange = _props.onChange;


            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('text-center', className) },
                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                    'div',
                    { className: 'text-blue' },
                    currentClickCwh ? currentClickCwh > 9 ? currentClickCwh + "床" : "0" + currentClickCwh + "床" : "请选择床铺"
                ),
                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                    'div',
                    null,
                    data.ysje + "元/年"
                ),
                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10__components__["a" /* Flex */],
                    { wrap: 'wrap', align: 'center', justify: 'center' },
                    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                        'div',
                        { className: 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__modal_box' },
                        data.bedList[0] && data.bedList.map(function (el, i) {
                            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                                'div',
                                { key: i },
                                el.map(function (cwxx, index) {
                                    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                                        'div',
                                        {
                                            className: 'app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__modal_list',
                                            onClick: function onClick() {
                                                if (cwxx.xz === "0") {
                                                    _this2.setState({
                                                        xzId: cwxx.id,
                                                        currentClickCwh: cwxx.cwh
                                                    });
                                                    onChange(cwxx);
                                                } else {
                                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.warning('抱歉，该床铺已选择！');
                                                }
                                            },
                                            key: index
                                        },
                                        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
                                            className: __WEBPACK_IMPORTED_MODULE_6_babel_plugin_react_css_modules_dist_browser_getClassName___default()(__WEBPACK_IMPORTED_MODULE_9_classnames___default()('select_item', {
                                                select_item_b: cwxx.xz === '1',
                                                select_item_y: xzId === cwxx.id && cwxx.xz === '0' || cwxx.currentXsSelected
                                            }), _styleModuleImportMap)
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                                            'div',
                                            null,
                                            cwxx.cwh > 9 ? cwxx.cwh + "床" : "0" + cwxx.cwh + "床"
                                        )
                                    );
                                })
                            );
                        })
                    )
                )
            );
        }
    }]);

    return SelectModal;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _class.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
    currentClickCwh: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
}, _class.defaultProps = {
    id: '',
    onChange: Function.prototype,
    currentClickCwh: ""
}, _temp);


/***/ }),

/***/ 1018:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Channel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_spin_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_spin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_number_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input_number__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_json_stringify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_checkbox_style__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_checkbox__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_axios__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_SelfHelp_channel_view__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_SelfHelp_common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__ = __webpack_require__(43);































var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }












var Dragger = __WEBPACK_IMPORTED_MODULE_29_antd_lib_upload___default.a.Dragger;







var history = __WEBPACK_IMPORTED_MODULE_40_history_createHashHistory___default()();
var TextArea = __WEBPACK_IMPORTED_MODULE_27_antd_lib_input___default.a.TextArea;

var FormItem = __WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item;
var CheckboxGroup = __WEBPACK_IMPORTED_MODULE_23_antd_lib_checkbox___default.a.Group;
var formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 }
};

var Channel = (_dec = __WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(Channel, _React$Component);

    function Channel(props) {
        _classCallCheck(this, Channel);

        var _this = _possibleConstructorReturn(this, (Channel.__proto__ || __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_object_get_prototype_of___default()(Channel)).call(this, props));

        _this.updateZzbdBlzt = function () {
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__["a" /* default */])('/zzbd/updateZzbdBlzt', 'GET', { zzbdhjid: zzbdhjid, hjdm: 'GD005' }).then(function (res) {
                if (res.data) {
                    _this.reloadMenu();
                }
            });
        };

        _this.queryQztjAndYlhj = function (callback) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }if (callback) {
                        callback(_this.state.operable);
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_44__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.loadLstdBlyy = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__["a" /* default */])('/proData/selectDataList', 'get', 'sign=dmk_YXXT_LSTD_BLYY').then(function (res) {
                if (res) {
                    var col = [];
                    res.data.map(function (item) {
                        col.push(__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_20_antd_lib_col___default.a,
                            { span: 6 },
                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_23_antd_lib_checkbox___default.a,
                                { value: item.VALUE },
                                item.LABEL
                            )
                        ));
                    });
                    var html = __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_18_antd_lib_row___default.a,
                        null,
                        col
                    );
                    _this.setState({ checkGroup: html });
                }
            });
        };

        _this.loadLstdInfo = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__["a" /* default */])('/lstd/getLstdInfoByXsid', 'GET').then(function (resData) {
                if (resData && resData.data) {
                    _this.setState({ data: resData.data });
                    var fileList = [];
                    if (resData.data && resData.data['fj']) {
                        resData.data['fj'].map(function (elem, index) {
                            //格式化对于附件取值
                            var file = {
                                uid: elem.fjid,
                                name: elem.fjmc,
                                response: {
                                    data: {
                                        ssbh: elem.fjid,
                                        fjmc: elem.fjmc
                                    }
                                },
                                status: 'done'
                            };
                            fileList.push(file);
                        });
                    }
                    _this.setState({ fileList: fileList });
                    _this.props.form.setFieldsValue({ fj: { fileList: _this.state.fileList } });
                } else {
                    _this.setState({ data: {} });
                    _this.setState({ fileList: [] });
                    _this.props.form.resetFields();
                }
            });
        };

        _this.getBase64 = function (img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        };

        _this.handlePreview = function (file) {
            var isImage = /^image\/.*$/i.test(file.type);
            if (isImage) {
                if (file) {
                    _this.getBase64(file, function (imageUrl) {
                        _this.setState({
                            previewImage: imageUrl,
                            previewVisible: true
                        });
                    });
                } else {
                    _this.setState({
                        previewImage: file.url || file.thumbUrl,
                        previewVisible: true
                    });
                }
            } else if (file && file['response'] && file['response']['data']) {
                //其他情况
                var _isImage = true;
                var fjmc = file['response']['data']['fjmc'];
                var ssbh = file['response']['data']['ssbh'];
                if (!_this.setJudge(fjmc, _this.state.judgeImgList)) {
                    _isImage = false;
                }

                if (_isImage) {
                    _this.showPreview('anonymity/docrepo/download/file?attachmentId=' + ssbh);
                } else {
                    window.open('anonymity/docrepo/download/file?attachmentId=' + ssbh);
                }
            }
        };

        _this.showPreview = function (url) {
            _this.setState({
                previewImage: url,
                previewVisible: true
            });
        };

        _this.handleCancel = function () {
            return _this.setState({ previewVisible: false });
        };

        _this.handleSubmit = function (e) {
            _this.setState({ loading: true });
            e.preventDefault();
            var zzbdhjid = _this.getQueryString('pkid');
            _this.props.form.validateFieldsAndScroll(function (err, values) {
                if (err) {
                    _this.setState({ loading: false });
                    return false;
                }

                var fj = values['fj'];

                var isEmpty = false;
                if (fj) {
                    if (fj['fileList'] && fj['fileList'].length > 0) {
                        isEmpty = false;
                    } else {
                        isEmpty = true;
                    }
                } else {
                    isEmpty = true;
                }

                if (isEmpty) {
                    _this.props.form.setFields({
                        fj: {
                            value: undefined,
                            errors: [new Error('请上传材料证明')]
                        }
                    });
                    _this.setState({ loading: false });
                    return false;
                }

                var size = fj['fileList'].length;
                var file = fj['fileList'].filter(function (file) {
                    if (file.status === 'error') {
                        return false;
                    }
                    return true;
                });
                if (file.length != size) {
                    _this.props.form.setFields({
                        fj: {
                            value: fj,
                            errors: [new Error('材料上传出错，请重新上传.')]
                        }
                    });
                    _this.setState({ loading: false });
                    return false;
                }

                var fileList = fj['fileList'];
                var fjlist = [];
                for (var i = 0; i < fileList.length; i++) {
                    var fjid = fileList[i].response.data.ssbh;
                    var fjmc = fileList[i].name;
                    fjlist.push({
                        fjid: fjid,
                        fjmc: fjmc
                    });
                }

                var sqsmFlag = false;
                var msg = '';
                var blyy = values['blyy'];
                var sqsm = values['sqsm'];
                var dkyh = values['dkyh'];
                var hzjym = values['hzjym'];
                var dkhtbh = values['dkhtbh'];
                var pkid = values['pkid'];
                blyy.map(function (item) {
                    if (item == '99') {
                        if (typeof sqsm == "undefined" || sqsm.trim().length == 0) {
                            sqsmFlag = true;
                            msg = "其它原因，请填写申请理由";
                        }
                    }
                });

                // if(dkyh == '01'){
                //     if(typeof(hzjym) == "undefined" ||hzjym.trim().length!=6){
                //         sqsmFlag = true ;
                //         msg="国家开发银行贷款，请填写6位数回执校验码"
                //     }
                // }
                if ((typeof dkhtbh == "undefined" || dkhtbh == "") && (typeof hzjym == "undefined" || hzjym == "")) {
                    sqsmFlag = true;
                    msg = "请填写贷款合同编号或回执校验码";
                }
                if (typeof hzjym != "undefined" && hzjym != "" && hzjym.trim().length != 6) {
                    sqsmFlag = true;
                    msg = "请填写6位回执校验码";
                }
                if (sqsmFlag) {
                    __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.error(msg);
                    return;
                }

                var blje = values['blje'];
                var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])().userId;
                var params = {
                    fj: fjlist,
                    blyy: blyy,
                    blje: blje,
                    sqsm: sqsm,
                    hzjym: hzjym,
                    dkyh: dkyh,
                    xsid: xsid,
                    zzbdhjid: zzbdhjid,
                    pkid: pkid,
                    dkhtbh: dkhtbh
                };
                if (!pkid) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__["a" /* default */])('/lstd/insert', "POST", params).then(function (res) {
                        if (res) {
                            __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.success("绿色通道申请保存成功。");
                            _this.loadLstdInfo();
                            _this.reloadMenu();
                        }
                        _this.setState({ loading: false });
                    }).catch(function (res) {
                        _this.setState({ loading: false });
                        return res;
                    });
                } else {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__["a" /* default */])('/lstd/update', "POST", params).then(function (res) {
                        if (res && res.data && res.data > 0) {
                            __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.success("绿色通道申请保存成功。");
                            _this.loadLstdInfo();
                            _this.reloadMenu();
                        } else {
                            __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.warning("绿色通道申请保存失败，请重试。");
                        }
                        _this.setState({ loading: false });
                    }).catch(function (res) {
                        _this.setState({ loading: false });
                        return res;
                    });
                }
            });
        };

        _this.handleChange = function (_ref) {
            var fileList = _ref.fileList;

            var count = 0;
            fileList.map(function (elem) {
                if (elem && elem['status'] && elem['status'] === 'uploading') {
                    _this.setState({ uploading: true });
                    return;
                } else if (elem && elem['status']) {
                    count++;
                }
            });
            if (count > 0) {
                _this.setState({ uploading: false });
            }
        };

        _this.setJudge = function (name, map) {
            var flag = false;
            map.map(function (item) {
                if (name.indexOf(item) !== -1) {
                    flag = true;
                }
            });
            return flag;
        };

        _this.beforeUpload = function (file) {
            if (!(_this.setJudge(file.name, _this.state.judgeImgList) || _this.setJudge(file.name, _this.state.judgeFileList))) {
                __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.error('不能上传该格式文件');
                return false;
            } else {
                return true;
            }
        };

        _this.remove = function (ssbh) {
            var url = 'api/docrepo/attachment/sourceId/delete?souerceId=' + ssbh;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__["a" /* default */])(url, "POST").then(function (res) {
                if (res.data && res.data > 0) {
                    __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.success('已删除材料.');
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD005',
            hjmc: '',
            uploading: false,
            loading: false,
            previewVisible: false,
            fileList: [],
            checkGroup: [], //绿色通道办理原因
            data: {}, //绿色通道申请信息
            nextUrl: '',
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            sqlyFlag: false, //申请理由flag
            jymFlag: false, //6位数回执校验码flag
            judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'], //可以导入的图片格式
            judgeFileList: ['.pdf', '.PDF', '.doc', '.DOC', '.zip', '.ZIP', '.txt', '.TXT', '.xls', '.XLS', '.rar', '.RAR'] //可以导入的非图片格式
        };
        return _this;
    }

    _createClass(Channel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.queryQztjAndYlhj(function (operable) {
                if (operable) {
                    _this2.loadLstdInfo();
                    _this2.loadLstdBlyy();
                    _this2.updateZzbdBlzt();
                }
            });
        }

        //迎新现场已办理时迎新网站自动办理


        //查询前置条件和依赖环节


        //读取学生的绿色通道信息


        // 转化base64


        // 点击文件链接或预览图标时的回调


        // 关闭图片弹窗


        // 提交


        //判断文件类型是否正常  name：文件名称  map：类型范围数组  true正常


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var form = this.props.form;
            var getFieldDecorator = this.props.form.getFieldDecorator;
            var _state = this.state,
                previewImage = _state.previewImage,
                previewVisible = _state.previewVisible,
                jymFlag = _state.jymFlag,
                sqlyFlag = _state.sqlyFlag;

            var props = {
                name: 'file',
                action: 'anonymity/docrepo/upload',
                data: { uuid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["c" /* createUuid */])(), type: '1' },

                onRemove: function onRemove(file) {
                    _this3.setState(function (_ref2) {
                        var fileList = _ref2.fileList;

                        var index = fileList.indexOf(file);
                        var newFileList = fileList.slice();
                        newFileList.splice(index, 1);
                        _this3.props.form.setFieldsValue({ fj: { fileList: newFileList } });
                        return {
                            fileList: newFileList
                        };
                    }, function () {
                        if (file.response && file.response.data && file.response.data.ssbh) {
                            _this3.remove(file.response.data.ssbh);
                        }
                    });
                },
                beforeUpload: function beforeUpload(file) {
                    if (!_this3.beforeUpload(file)) {
                        return false;
                    }
                    _this3.setState(function (_ref3) {
                        var fileList = _ref3.fileList;
                        return {
                            fileList: [].concat(_toConsumableArray(fileList), [file])
                        };
                    });
                    return true;
                },
                onChange: function onChange(file) {
                    _this3.handleChange(file);
                },
                onPreview: this.handlePreview,
                fileList: this.state.fileList
            };

            var edit = false;
            var data = this.state.data;
            if (__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_json_stringify___default()(data) == "{}") {
                edit = true;
            } else if (data && data['shzt'] === '9') {
                edit = true;
            }
            return __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                'div',
                { style: { position: 'relative' } },
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_33__components__["a" /* Flex */],
                        { className: 'w1180 mt-20', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__pages_Assembly_siderMenu__["a" /* default */], {
                            ref: "siderMenu",
                            setMenuList: this.setMenuList,
                            title: '\u81EA\u52A9\u62A5\u5230',
                            mkbz: this.state.mkbz
                            /*     active={4}*/
                            , menuType: '\u81EA\u52A9\u62A5\u5230' }),
                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_33__components__["a" /* Flex */].Item,
                            { className: 'page_con_r ' },
                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__pages_Assembly_Breadcrumb__["a" /* default */], {
                                noLine: true,
                                list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                            }),
                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                'div',
                                { className: 'box' },
                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_45__pages_SelfHelp_common_hint__["a" /* default */], null),
                                edit ? __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a,
                                    { onSubmit: this.handleSubmit },
                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u4FE1\u606F', extra: false }),
                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                        'div',
                                        { className: 'p-sw' },
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                            'div',
                                            { style: { display: 'none' } },
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__["a" /* default */],
                                                { id: 'pkid', initialValue: data['pkid'], form: form },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_input___default.a, null)
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                            'div',
                                            { style: { marginLeft: "30px" } },
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__["a" /* default */],
                                                { id: 'blyy', required: true, initialValue: data['blyydm'], form: form, formItemLayout: { labelCol: { span: 4 }, wrapperCol: { span: 16 } }, label: '\u529E\u7406\u539F\u56E0' },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                    CheckboxGroup,
                                                    { style: { width: '100%' } },
                                                    this.state.checkGroup
                                                )
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item', style: { marginLeft: '7%' } },
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__["a" /* default */],
                                                { id: 'sqsm', initialValue: data['sqsm'], form: form, formItemLayout: formItemLayout, label: '\u7533\u8BF7\u7406\u7531' },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(TextArea, { maxLength: 50, placeholder: '\u8BF7\u586B\u5199\u7533\u8BF7\u7406\u7531' })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__["a" /* default */],
                                                { id: 'blje', required: true, initialValue: data['blje'], form: form, formItemLayout: formItemLayout, label: '\u8D37\u6B3E\u91D1\u989D' },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input_number___default.a, { style: { width: '100%' }, min: 0, max: 9999999, precision: '0', placeholder: '\u8BF7\u586B\u5199\u8D37\u6B3E\u91D1\u989D\uFF08\u5143\uFF09' })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__["a" /* default */],
                                                { id: 'dkyh', required: true, initialValue: data['dkyh'], form: form, formItemLayout: formItemLayout, label: '\u8D37\u6B3E\u94F6\u884C' },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__components_common_NHSelect__["a" /* default */], { sign: "dmk_yxwz_dkyh", onChange: function onChange(v) {} })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__["a" /* default */],
                                                { id: 'hzjym', initialValue: data['hzjym'], form: form, formItemLayout: formItemLayout, label: '\u56DE\u6267\u6821\u9A8C\u7801' },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_input___default.a, { maxLength: 6, placeholder: '6\u4F4D\u6570\u56DE\u6267\u6821\u9A8C\u7801' })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__["a" /* default */],
                                                { id: 'dkhtbh', initialValue: data['dkhtbh'], form: form, formItemLayout: formItemLayout, label: '\u8D37\u6B3E\u5408\u540C\u7F16\u53F7' },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_input___default.a, { placeholder: '\u8D37\u6B3E\u5408\u540C\u7F16\u53F7' })
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u6750\u6599', extra: false }),
                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                        'div',
                                        { className: 'p-sw' },
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item', style: { marginLeft: '7%' } },
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                FormItem,
                                                {
                                                    labelCol: { span: 8 },
                                                    wrapperCol: { span: 16 },
                                                    label: '\u4E0A\u4F20\u8D37\u6B3E\u53D7\u7406\u8BC1\u660E'
                                                },
                                                getFieldDecorator('fj', {
                                                    rules: [{
                                                        required: true,
                                                        message: '请上传材料证明'
                                                    }]
                                                })(__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                    Dragger,
                                                    props,
                                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                        'p',
                                                        { className: 'ant-upload-drag-icon' },
                                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, { type: 'inbox' })
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_spin___default.a, { spinning: this.state.uploading }),
                                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                        'p',
                                                        { className: 'ant-upload-text font-14' },
                                                        '\u70B9\u51FB\u6B64\u5904\u6216\u62D6\u62FD\u6587\u4EF6\u5230\u6B64'
                                                    )
                                                ))
                                            )
                                        )
                                    ),
                                    data['shzt'] === '9' ? __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                        'div',
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u5BA1\u6838', extra: false }),
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                            'div',
                                            { className: 'p-sw' },
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                'div',
                                                { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_18_antd_lib_row___default.a,
                                                    { gutter: 24 },
                                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_20_antd_lib_col___default.a,
                                                        { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                            'span',
                                                            {
                                                                style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                                            '\u5BA1\u6838\u610F\u89C1\xA0: '
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_20_antd_lib_col___default.a,
                                                        { span: 20 },
                                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                            'span',
                                                            null,
                                                            data['shyj']
                                                        )
                                                    )
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement('br', null),
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                'div',
                                                { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_18_antd_lib_row___default.a,
                                                    { gutter: 24 },
                                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_20_antd_lib_col___default.a,
                                                        { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                            'span',
                                                            {
                                                                style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                                            '\u5BA1\u6838\u72B6\u6001\xA0: '
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_20_antd_lib_col___default.a,
                                                        { span: 20 },
                                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                            'span',
                                                            { style: { color: '#0066FF' } },
                                                            '\u9A73\u56DE'
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    ) : "",
                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,
                                            { type: 'primary', htmlType: 'submit' },
                                            '\u4FDD\u5B58'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__pages_SelfHelp_channel_view__["a" /* default */], { reloadMenu: this.reloadMenu, nextUrl: this.state.nextUrl, loadLstdInfo: this.loadLstdInfo, search: this.state.search, showPreview: this.showPreview, setJudge: this.setJudge, data: this.state.data, judgeImgList: this.state.judgeImgList })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a,
                        {
                            visible: previewVisible,
                            footer: null,
                            onCancel: this.handleCancel
                        },
                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement('img', {
                            alt: 'example',
                            style: { width: '100%' },
                            src: previewImage
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_spin___default.a, { style: { position: 'absolute', top: '300px', left: '60%' }, spinning: this.state.loading }),
                    ' '
                ) : __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41__pages_SelfHelp_common__["a" /* default */], { hjmc: "绿色通道申请", key: "GD005", mkbz: 'GD005', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return Channel;
}(__WEBPACK_IMPORTED_MODULE_30_react___default.a.Component)) || _class);


/***/ }),

/***/ 1019:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return View; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }








var TextArea = __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a.TextArea;

var basicUrl = "/zzbd";

var shztList = {
    '-1': '审核不通过',
    '0': '未审核',
    '1': '审核通过',
    '2': '已办理',
    '9': '驳回'
};

var View = function (_React$Component) {
    _inherits(View, _React$Component);

    function View(props) {
        _classCallCheck(this, View);

        var _this = _possibleConstructorReturn(this, (View.__proto__ || __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default()(View)).call(this, props));

        _this.getDmkMc = function (dmbz) {
            var data = _this.props.data;

            var dkyhmc = _this.state.dkyhmc;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])(basicUrl + "/getDmkMc", "GET", _defineProperty({ dmbz: dmbz }, 'dmbz', dmbz)).then(function (res) {
                if (res) {
                    if (res.data) {
                        if (dmbz === "YXWZ_DKYH") {
                            res.data.map(function (initItem) {
                                if (initItem.DM === data.dkyh) {
                                    dkyhmc = initItem.MC;
                                }
                            });
                            _this.setState({ dkyhmc: dkyhmc });
                        }
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.cancel = function (lstdid, shzt) {

            if (shzt !== '0') {
                __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warning('该申请已经审核，不能取消');
                return;
            }

            var pkid = _this.getQueryString("pkid");

            var params = {
                zzbdhjid: pkid,
                pkid: lstdid
            };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])("/lstd/deleteByParams", "POST", params).then(function (res) {
                if (res && res.data && res.data > 0) {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.success("取消成功");
                    _this.props.loadLstdInfo();
                    _this.props.reloadMenu();
                } else {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warning("取消异常");
                }
            });
        };

        _this.handlePreview = function (fjmc, fjid) {
            var isImage = true;
            if (!_this.props.setJudge(fjmc, _this.props.judgeImgList)) {
                isImage = false;
            }

            if (isImage) {
                _this.props.showPreview('anonymity/docrepo/download/file?attachmentId=' + fjid);
            } else {
                window.open('anonymity/docrepo/download/file?attachmentId=' + fjid);
            }
        };

        _this.state = {
            dkyhmc: '',
            nextUrl: _this.props.nextUrl,
            search: _this.props.search
        };
        return _this;
    }

    _createClass(View, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.getDmkMc("YXWZ_DKYH");
        }

        //获取下拉列表value对应的名称


        // 点击文件链接或预览图标时的回调

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var data = this.props.data;
            var dkyhmc = this.state.dkyhmc;

            return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u4FE1\u606F', extra: false }),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '20px' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', marginTop: "3px", paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u529E\u7406\u539F\u56E0\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                data['blyy'].map(function (elem, index) {
                                    return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                        'span',
                                        { style: {
                                                borderColor: '#1890ff',
                                                borderRadius: '5px',
                                                padding: '2px 16px',
                                                border: '1px solid rgb(24, 144, 255)',
                                                marginRight: '15px',
                                                display: 'inline-block'
                                            } },
                                        elem
                                    );
                                })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u7533\u8BF7\u7406\u7531\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['sqsm']
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u8D37\u6B3E\u91D1\u989D\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['blje'],
                                    '\u5143'
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u8D37\u6B3E\u94F6\u884C\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    dkyhmc
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '6\u4F4D\u6570\u56DE\u6267\u6821\u9A8C\u7801\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['hzjym']
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u8D37\u6B3E\u5408\u540C\u7F16\u53F7\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['dkhtbh']
                                )
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u6750\u6599', extra: false }),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u6750\u6599\u8BC1\u660E\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                data['fj'].map(function (elem, index) {
                                    return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                        'div',
                                        { style: { marginBottom: '20px' } },
                                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                            'a',
                                            { onClick: function onClick() {
                                                    _this2.handlePreview(elem['fjmc'], elem['fjid']);
                                                } },
                                            elem['fjmc']
                                        )
                                    );
                                })
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u5BA1\u6838', extra: false }),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u5BA1\u6838\u610F\u89C1\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['shyj']
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u5BA1\u6838\u72B6\u6001\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    { style: { color: '#0066FF' } },
                                    shztList[data['shzt']]
                                )
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'text-center mt-50' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                        { type: 'primary', onClick: function onClick() {
                                _this2.cancel(data['pkid'], data['shzt']);
                            } },
                        '\u53D6\u6D88'
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                )
            );
        }
    }]);

    return View;
}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);



/***/ }),

/***/ 1020:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Channel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_spin_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_spin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_input_number_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_input_number__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_json_stringify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_checkbox_style__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_checkbox__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_axios__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_SelfHelp_channelCzxy_view__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_SelfHelp_common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__ = __webpack_require__(43);































var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }












var Dragger = __WEBPACK_IMPORTED_MODULE_29_antd_lib_upload___default.a.Dragger;







var history = __WEBPACK_IMPORTED_MODULE_40_history_createHashHistory___default()();
var TextArea = __WEBPACK_IMPORTED_MODULE_27_antd_lib_input___default.a.TextArea;

var FormItem = __WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item;
var CheckboxGroup = __WEBPACK_IMPORTED_MODULE_23_antd_lib_checkbox___default.a.Group;
var formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 }
};

var Channel = (_dec = __WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(Channel, _React$Component);

    function Channel(props) {
        _classCallCheck(this, Channel);

        var _this = _possibleConstructorReturn(this, (Channel.__proto__ || __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_object_get_prototype_of___default()(Channel)).call(this, props));

        _this.updateZzbdBlzt = function () {
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__["a" /* default */])('/zzbd/updateZzbdBlzt', 'GET', { zzbdhjid: zzbdhjid, hjdm: 'GD005' }).then(function (res) {
                if (res.data) {
                    _this.reloadMenu();
                }
            });
        };

        _this.queryQztjAndYlhj = function (callback) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }if (callback) {
                        callback(_this.state.operable);
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_44__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.getLstdYjjeData = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])().userId;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__["a" /* default */])('/openapi/jfxt/getTotalYjje', 'GET', { xsid: xsid }).then(function (res) {
                if (res && res.data) {
                    _this.setState({ yjje: res.data });
                } else {
                    _this.setState({ yjje: 0 });
                }
            });
        };

        _this.loadLstdInfo = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__["a" /* default */])('/lstd/getLstdInfoByXsid', 'GET').then(function (resData) {
                if (resData && resData.data) {
                    console.log(resData.data);
                    _this.setState({ data: resData.data });
                    var fileList = [];
                    if (resData.data && resData.data['fj']) {
                        resData.data['fj'].map(function (elem, index) {
                            //格式化对于附件取值
                            var file = {
                                uid: elem.fjid,
                                name: elem.fjmc,
                                response: {
                                    data: {
                                        ssbh: elem.fjid,
                                        fjmc: elem.fjmc
                                    }
                                },
                                status: 'done'
                            };
                            fileList.push(file);
                        });
                    }
                    _this.setState({ fileList: fileList });
                    _this.props.form.setFieldsValue({ fj: { fileList: _this.state.fileList } });
                } else {
                    _this.setState({ data: {} });
                    _this.setState({ fileList: [] });
                    _this.props.form.resetFields();
                }
            });
        };

        _this.getBase64 = function (img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        };

        _this.handlePreview = function (file) {
            var isImage = /^image\/.*$/i.test(file.type);
            if (isImage) {
                if (file) {
                    _this.getBase64(file, function (imageUrl) {
                        _this.setState({
                            previewImage: imageUrl,
                            previewVisible: true
                        });
                    });
                } else {
                    _this.setState({
                        previewImage: file.url || file.thumbUrl,
                        previewVisible: true
                    });
                }
            } else if (file && file['response'] && file['response']['data']) {
                //其他情况
                var _isImage = true;
                var fjmc = file['response']['data']['fjmc'];
                var ssbh = file['response']['data']['ssbh'];
                if (!_this.setJudge(fjmc, _this.state.judgeImgList)) {
                    _isImage = false;
                }

                if (_isImage) {
                    _this.showPreview('anonymity/docrepo/download/file?attachmentId=' + ssbh);
                } else {
                    window.open('anonymity/docrepo/download/file?attachmentId=' + ssbh);
                }
            }
        };

        _this.showPreview = function (url) {
            _this.setState({
                previewImage: url,
                previewVisible: true
            });
        };

        _this.handleCancel = function () {
            return _this.setState({ previewVisible: false });
        };

        _this.handleSubmit = function (e) {
            _this.setState({ loading: true });
            e.preventDefault();
            var zzbdhjid = _this.getQueryString('pkid');
            _this.props.form.validateFieldsAndScroll(function (err, values) {
                if (err) {
                    _this.setState({ loading: false });
                    return false;
                }
                console.log(values);
                var fj = values['fj'];
                var isEmpty = false;
                if (fj) {
                    if (fj['fileList'] && fj['fileList'].length > 0) {
                        isEmpty = false;
                    } else {
                        isEmpty = true;
                    }
                } else {
                    isEmpty = true;
                }

                if (isEmpty) {
                    _this.props.form.setFields({
                        fj: {
                            value: undefined,
                            errors: [new Error('请上传材料证明')]
                        }
                    });
                    _this.setState({ loading: false });
                    return false;
                }

                var size = fj['fileList'].length;
                var file = fj['fileList'].filter(function (file) {
                    if (file.status === 'error') {
                        return false;
                    }
                    return true;
                });
                if (file.length != size) {
                    _this.props.form.setFields({
                        fj: {
                            value: fj,
                            errors: [new Error('材料上传出错，请重新上传.')]
                        }
                    });
                    _this.setState({ loading: false });
                    return false;
                }

                var fileList = fj['fileList'];
                var fjlist = [];
                for (var i = 0; i < fileList.length; i++) {
                    var fjid = fileList[i].response.data.ssbh;
                    var fjmc = fileList[i].name;
                    fjlist.push({
                        fjid: fjid,
                        fjmc: fjmc
                    });
                }

                var sqsmFlag = false;
                var msg = '';
                var sqsm = values['sqsm'];
                var dkyh = values['dkyh'];
                var hzjym = values['hzjym'];
                var dkhtbh = values['dkhtbh'];
                var pkid = values['pkid'];

                // if(dkyh == '01'){
                //     if(typeof(hzjym) == "undefined" ||hzjym.trim().length!=6){
                //         sqsmFlag = true ;
                //         msg="国家开发银行贷款，请填写6位数回执校验码"
                //     }
                // }
                if ((typeof dkhtbh == "undefined" || dkhtbh == "") && (typeof hzjym == "undefined" || hzjym == "")) {
                    sqsmFlag = true;
                    msg = "请填写贷款合同编号或回执校验码";
                }
                if (typeof hzjym != "undefined" && hzjym != "" && hzjym.trim().length != 6) {
                    sqsmFlag = true;
                    msg = "请填写6位回执校验码";
                }
                if (sqsmFlag) {
                    __WEBPACK_IMPORTED_MODULE_20_antd_lib_message___default.a.error(msg);
                    return;
                }

                var blje = values['blje'];
                var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])().userId;
                var params = {
                    fj: fjlist,
                    blje: blje,
                    sqsm: sqsm,
                    hzjym: hzjym,
                    dkyh: dkyh,
                    xsid: xsid,
                    zzbdhjid: zzbdhjid,
                    pkid: pkid,
                    dkhtbh: dkhtbh,
                    blyy: [""]
                };

                if (!pkid) {
                    console.log(params);
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__["a" /* default */])('/lstd/insert', "POST", params).then(function (res) {
                        if (res) {
                            __WEBPACK_IMPORTED_MODULE_20_antd_lib_message___default.a.success("绿色通道申请保存成功。");
                            _this.loadLstdInfo();
                            _this.reloadMenu();
                        }
                        _this.setState({ loading: false });
                    }).catch(function (res) {
                        _this.setState({ loading: false });
                        return res;
                    });
                } else {
                    console.log(params);
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__["a" /* default */])('/lstd/update', "POST", params).then(function (res) {
                        if (res && res.data && res.data > 0) {
                            __WEBPACK_IMPORTED_MODULE_20_antd_lib_message___default.a.success("绿色通道申请保存成功2。");
                            _this.loadLstdInfo();
                            _this.reloadMenu();
                        } else {
                            __WEBPACK_IMPORTED_MODULE_20_antd_lib_message___default.a.warning("绿色通道申请保存失败，请重试。");
                        }
                        _this.setState({ loading: false });
                    }).catch(function (res) {
                        _this.setState({ loading: false });
                        return res;
                    });
                }
            });
        };

        _this.handleChange = function (_ref) {
            var fileList = _ref.fileList;

            var count = 0;
            fileList.map(function (elem) {
                if (elem && elem['status'] && elem['status'] === 'uploading') {
                    _this.setState({ uploading: true });
                    return;
                } else if (elem && elem['status']) {
                    count++;
                }
            });
            if (count > 0) {
                _this.setState({ uploading: false });
            }
        };

        _this.setJudge = function (name, map) {
            var flag = false;
            map.map(function (item) {
                if (name.indexOf(item) !== -1) {
                    flag = true;
                }
            });
            return flag;
        };

        _this.beforeUpload = function (file) {
            if (!(_this.setJudge(file.name, _this.state.judgeImgList) || _this.setJudge(file.name, _this.state.judgeFileList))) {
                __WEBPACK_IMPORTED_MODULE_20_antd_lib_message___default.a.error('不能上传该格式文件');
                return false;
            } else {
                return true;
            }
        };

        _this.remove = function (ssbh) {
            var url = 'api/docrepo/attachment/sourceId/delete?souerceId=' + ssbh;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__["a" /* default */])(url, "POST").then(function (res) {
                if (res.data && res.data > 0) {
                    __WEBPACK_IMPORTED_MODULE_20_antd_lib_message___default.a.success('已删除材料.');
                }
            });
        };

        _this.input_changeBlje = function (form) {
            //动态获取贷款金额的值 以及动态改变差额
            var blje = form.getFieldValue("blje");
            var yjje = _this.state.yjje;

            var ce = blje - yjje;
            if (ce > 0) {
                var str = "+" + ce;
                form.setFieldsValue({
                    ce: str
                });
            }
            if (ce < 0) {
                form.setFieldsValue({
                    ce: ce
                });
            }
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD005_6',
            hjmc: '',
            uploading: false,
            loading: false,
            previewVisible: false,
            fileList: [],
            checkGroup: [], //绿色通道办理原因
            data: {}, //绿色通道申请信息
            nextUrl: '',
            search: '',
            yjje: '',
            blje: '',
            ce: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            sqlyFlag: false, //申请理由flag
            jymFlag: false, //6位数回执校验码flag
            judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'], //可以导入的图片格式
            judgeFileList: ['.pdf', '.PDF', '.doc', '.DOC', '.zip', '.ZIP', '.txt', '.TXT', '.xls', '.XLS', '.rar', '.RAR'] //可以导入的非图片格式
        };
        return _this;
    }

    _createClass(Channel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.queryQztjAndYlhj(function (operable) {
                if (operable) {
                    _this2.loadLstdInfo();
                    _this2.updateZzbdBlzt();
                }
            });
            this.getLstdYjjeData();
        }

        //迎新现场已办理时迎新网站自动办理


        //查询前置条件和依赖环节


        /**
         * * 获取学生应缴费用信息
         * @memberof Lstd
         */


        //读取学生的绿色通道信息


        // 转化base64


        // 点击文件链接或预览图标时的回调


        // 关闭图片弹窗


        // 提交


        //判断文件类型是否正常  name：文件名称  map：类型范围数组  true正常


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var form = this.props.form;
            var getFieldDecorator = this.props.form.getFieldDecorator;
            var _state = this.state,
                previewImage = _state.previewImage,
                previewVisible = _state.previewVisible,
                jymFlag = _state.jymFlag,
                sqlyFlag = _state.sqlyFlag;

            var props = {
                name: 'file',
                action: 'anonymity/docrepo/upload',
                data: { uuid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["c" /* createUuid */])(), type: '1' },

                onRemove: function onRemove(file) {
                    _this3.setState(function (_ref2) {
                        var fileList = _ref2.fileList;

                        var index = fileList.indexOf(file);
                        var newFileList = fileList.slice();
                        newFileList.splice(index, 1);
                        _this3.props.form.setFieldsValue({ fj: { fileList: newFileList } });
                        return {
                            fileList: newFileList
                        };
                    }, function () {
                        if (file.response && file.response.data && file.response.data.ssbh) {
                            _this3.remove(file.response.data.ssbh);
                        }
                    });
                },
                beforeUpload: function beforeUpload(file) {
                    if (!_this3.beforeUpload(file)) {
                        return false;
                    }
                    _this3.setState(function (_ref3) {
                        var fileList = _ref3.fileList;
                        return {
                            fileList: [].concat(_toConsumableArray(fileList), [file])
                        };
                    });
                    return true;
                },
                onChange: function onChange(file) {
                    _this3.handleChange(file);
                },
                onPreview: this.handlePreview,
                fileList: this.state.fileList
            };

            var edit = false;
            var _state2 = this.state,
                data = _state2.data,
                yjje = _state2.yjje;

            if (__WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_json_stringify___default()(data) == "{}") {
                edit = true;
            } else if (data && data['shzt'] === '9') {
                edit = true;
            }

            return __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                'div',
                { style: { position: 'relative' } },
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_33__components__["a" /* Flex */],
                        { className: 'w1180 mt-20', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__pages_Assembly_siderMenu__["a" /* default */], {
                            ref: "siderMenu",
                            setMenuList: this.setMenuList,
                            title: '\u81EA\u52A9\u62A5\u5230',
                            mkbz: this.state.mkbz
                            /*     active={4}*/
                            , menuType: '\u81EA\u52A9\u62A5\u5230' }),
                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_33__components__["a" /* Flex */].Item,
                            { className: 'page_con_r ' },
                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__pages_Assembly_Breadcrumb__["a" /* default */], {
                                noLine: true,
                                list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                            }),
                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                'div',
                                { className: 'box' },
                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_45__pages_SelfHelp_common_hint__["a" /* default */], null),
                                edit ? __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a,
                                    { onSubmit: this.handleSubmit },
                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u4FE1\u606F', extra: false }),
                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                        'div',
                                        { className: 'p-sw' },
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                            'div',
                                            { style: { display: 'none' } },
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__["a" /* default */],
                                                { id: 'pkid', initialValue: data['pkid'], form: form },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_input___default.a, null)
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item', style: { marginLeft: '7%', whiteSpace: 'pre-wrap' } },
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__["a" /* default */],
                                                { id: 'sqsm', required: true, initialValue: data['sqsm'], form: form, formItemLayout: formItemLayout, label: '\u7533\u8BF7\u7406\u7531' },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(TextArea, { maxLength: 50, placeholder: '\u8BF7\u586B\u5199\u7533\u8BF7\u7406\u7531' })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__["a" /* default */],
                                                { id: 'yjje', form: form },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                    'span',
                                                    { style: { marginLeft: "44px",
                                                            fontSize: "13px",
                                                            color: "#262626" } },
                                                    '\u5E94\u7F34\u91D1\u989D\uFF1A',
                                                    yjje ? yjje : 0
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__["a" /* default */],
                                                { id: 'blje', required: true, initialValue: data['blje'], form: form, formItemLayout: formItemLayout, label: '\u8D37\u6B3E\u91D1\u989D' },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_input_number___default.a, { style: { width: '100%' }, min: 0, max: 9999999, precision: '0', placeholder: '\u8BF7\u586B\u5199\u8D37\u6B3E\u91D1\u989D\uFF08\u5143\uFF09', onBlur: function onBlur() {
                                                        return _this3.input_changeBlje(form);
                                                    } })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__["a" /* default */],
                                                { id: 'dkyh', required: true, initialValue: data['dkyh'], form: form, formItemLayout: formItemLayout, label: '\u8D37\u6B3E\u94F6\u884C' },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__components_common_NHSelect__["a" /* default */], { sign: "dmk_yxwz_dkyh", onChange: function onChange(v) {} })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__["a" /* default */],
                                                { id: 'ce', form: form, formItemLayout: formItemLayout },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                    'span',
                                                    { style: { marginLeft: "36px", fontSize: "13px", color: "#262626" } },
                                                    '\u8D37\u6B3E\u91D1\u989D\u4E0E\u5E94\u4EA4\u8D39\u7528\u5DEE\u989D\uFF1A',
                                                    form.getFieldValue("ce") ? form.getFieldValue("ce") : 0
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__["a" /* default */],
                                                { id: 'hzjym', initialValue: data['hzjym'], form: form, formItemLayout: formItemLayout, label: '\u56DE\u6267\u6821\u9A8C\u7801' },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_input___default.a, { maxLength: 6, placeholder: '6\u4F4D\u6570\u56DE\u6267\u6821\u9A8C\u7801' })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__["a" /* default */],
                                                { id: 'dkhtbh', initialValue: data['dkhtbh'], form: form, formItemLayout: formItemLayout, label: '\u8D37\u6B3E\u5408\u540C\u7F16\u53F7' },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_input___default.a, { placeholder: '\u8D37\u6B3E\u5408\u540C\u7F16\u53F7' })
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u6750\u6599', extra: false }),
                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                        'div',
                                        { className: 'p-sw' },
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item', style: { marginLeft: '7%' } },
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                FormItem,
                                                {
                                                    labelCol: { span: 8 },
                                                    wrapperCol: { span: 16 },
                                                    label: '\u4E0A\u4F20\u8D37\u6B3E\u53D7\u7406\u8BC1\u660E'
                                                },
                                                getFieldDecorator('fj', {
                                                    rules: [{
                                                        required: true,
                                                        message: '请上传材料证明'
                                                    }]
                                                })(__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                    Dragger,
                                                    props,
                                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                        'p',
                                                        { className: 'ant-upload-drag-icon' },
                                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a, { type: 'inbox' })
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_spin___default.a, { spinning: this.state.uploading }),
                                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                        'p',
                                                        { className: 'ant-upload-text font-14' },
                                                        '\u70B9\u51FB\u6B64\u5904\u6216\u62D6\u62FD\u6587\u4EF6\u5230\u6B64'
                                                    )
                                                ))
                                            )
                                        )
                                    ),
                                    data['shzt'] === '9' ? __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                        'div',
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u5BA1\u6838', extra: false }),
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                            'div',
                                            { className: 'p-sw' },
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                'div',
                                                { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,
                                                    { gutter: 24 },
                                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,
                                                        { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                            'span',
                                                            {
                                                                style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                                            '\u5BA1\u6838\u610F\u89C1\xA0: '
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,
                                                        { span: 20 },
                                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                            'span',
                                                            null,
                                                            data['shyj']
                                                        )
                                                    )
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement('br', null),
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                'div',
                                                { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_9_antd_lib_row___default.a,
                                                    { gutter: 24 },
                                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,
                                                        { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                            'span',
                                                            {
                                                                style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                                            '\u5BA1\u6838\u72B6\u6001\xA0: '
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_11_antd_lib_col___default.a,
                                                        { span: 20 },
                                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                            'span',
                                                            { style: { color: '#0066FF' } },
                                                            '\u9A73\u56DE'
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    ) : "",
                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,
                                            { type: 'primary', htmlType: 'submit' },
                                            '\u4FDD\u5B58'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__pages_SelfHelp_channelCzxy_view__["a" /* default */], { reloadMenu: this.reloadMenu, nextUrl: this.state.nextUrl, loadLstdInfo: this.loadLstdInfo, search: this.state.search, showPreview: this.showPreview, setJudge: this.setJudge, data: this.state.data, judgeImgList: this.state.judgeImgList })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a,
                        {
                            visible: previewVisible,
                            footer: null,
                            onCancel: this.handleCancel
                        },
                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement('img', {
                            alt: 'example',
                            style: { width: '100%' },
                            src: previewImage
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_spin___default.a, { style: { position: 'absolute', top: '300px', left: '60%' }, spinning: this.state.loading }),
                    ' '
                ) : __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41__pages_SelfHelp_common__["a" /* default */], { hjmc: "绿色通道申请", key: "GD005_6", mkbz: 'GD005_6', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return Channel;
}(__WEBPACK_IMPORTED_MODULE_30_react___default.a.Component)) || _class);


/***/ }),

/***/ 1021:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return View; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }








var TextArea = __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a.TextArea;

var basicUrl = "/zzbd";

var shztList = {
    '-1': '审核不通过',
    '0': '未审核',
    '1': '审核通过',
    '2': '已办理',
    '9': '驳回'
};

var View = function (_React$Component) {
    _inherits(View, _React$Component);

    function View(props) {
        _classCallCheck(this, View);

        var _this = _possibleConstructorReturn(this, (View.__proto__ || __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default()(View)).call(this, props));

        _this.getDmkMc = function (dmbz) {
            var data = _this.props.data;

            var dkyhmc = _this.state.dkyhmc;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])(basicUrl + "/getDmkMc", "GET", _defineProperty({ dmbz: dmbz }, 'dmbz', dmbz)).then(function (res) {
                if (res) {
                    if (res.data) {
                        if (dmbz === "YXWZ_DKYH") {
                            res.data.map(function (initItem) {
                                if (initItem.DM === data.dkyh) {
                                    dkyhmc = initItem.MC;
                                }
                            });
                            _this.setState({ dkyhmc: dkyhmc });
                        }
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.cancel = function (lstdid, shzt) {

            if (shzt !== '0') {
                __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warning('该申请已经审核，不能取消');
                return;
            }

            var pkid = _this.getQueryString("pkid");

            var params = {
                zzbdhjid: pkid,
                pkid: lstdid
            };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])("/lstd/deleteByParams", "POST", params).then(function (res) {
                if (res && res.data && res.data > 0) {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.success("取消成功");
                    _this.props.loadLstdInfo();
                    _this.props.reloadMenu();
                } else {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warning("取消异常");
                }
            });
        };

        _this.handlePreview = function (fjmc, fjid) {
            var isImage = true;
            if (!_this.props.setJudge(fjmc, _this.props.judgeImgList)) {
                isImage = false;
            }

            if (isImage) {
                _this.props.showPreview('anonymity/docrepo/download/file?attachmentId=' + fjid);
            } else {
                window.open('anonymity/docrepo/download/file?attachmentId=' + fjid);
            }
        };

        _this.state = {
            dkyhmc: '',
            nextUrl: _this.props.nextUrl,
            search: _this.props.search
        };
        return _this;
    }

    _createClass(View, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.getDmkMc("YXWZ_DKYH");
        }

        //获取下拉列表value对应的名称


        // 点击文件链接或预览图标时的回调

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var data = this.props.data;
            var dkyhmc = this.state.dkyhmc;

            return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u4FE1\u606F', extra: false }),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u7533\u8BF7\u7406\u7531\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['sqsm']
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u8D37\u6B3E\u91D1\u989D\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['blje'],
                                    '\u5143'
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u8D37\u6B3E\u94F6\u884C\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    dkyhmc
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '6\u4F4D\u6570\u56DE\u6267\u6821\u9A8C\u7801\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['hzjym']
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u8D37\u6B3E\u5408\u540C\u7F16\u53F7\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['dkhtbh']
                                )
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u6750\u6599', extra: false }),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u6750\u6599\u8BC1\u660E\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                data['fj'].map(function (elem, index) {
                                    return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                        'div',
                                        { style: { marginBottom: '20px' } },
                                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                            'a',
                                            { onClick: function onClick() {
                                                    _this2.handlePreview(elem['fjmc'], elem['fjid']);
                                                } },
                                            elem['fjmc']
                                        )
                                    );
                                })
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u5BA1\u6838', extra: false }),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u5BA1\u6838\u610F\u89C1\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['shyj']
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u5BA1\u6838\u72B6\u6001\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    { style: { color: '#0066FF' } },
                                    shztList[data['shzt']]
                                )
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'text-center mt-50' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                        { type: 'primary', onClick: function onClick() {
                                _this2.cancel(data['pkid'], data['shzt']);
                            } },
                        '\u53D6\u6D88'
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                )
            );
        }
    }]);

    return View;
}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);



/***/ }),

/***/ 1022:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Channel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_spin_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_spin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_date_picker_style__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input_number_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input_number__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_radio_style__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_radio__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_tooltip_style__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_tooltip__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_checkbox_style__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_checkbox__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_axios__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__pages_SelfHelp_channelFb_view__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__pages_SelfHelp_common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_common_NHFormItem__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_common_NHModal__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_moment__);




































var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }












var Dragger = __WEBPACK_IMPORTED_MODULE_34_antd_lib_upload___default.a.Dragger;









var history = __WEBPACK_IMPORTED_MODULE_45_history_createHashHistory___default()();
var TextArea = __WEBPACK_IMPORTED_MODULE_32_antd_lib_input___default.a.TextArea;

var FormItem = __WEBPACK_IMPORTED_MODULE_30_antd_lib_form___default.a.Item;
var CheckboxGroup = __WEBPACK_IMPORTED_MODULE_28_antd_lib_checkbox___default.a.Group;
var formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 }
};

var Channel = (_dec = __WEBPACK_IMPORTED_MODULE_30_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(Channel, _React$Component);

    function Channel(props) {
        _classCallCheck(this, Channel);

        var _this = _possibleConstructorReturn(this, (Channel.__proto__ || __WEBPACK_IMPORTED_MODULE_26_babel_runtime_core_js_object_get_prototype_of___default()(Channel)).call(this, props));

        _this.getHjsjCsbz = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_43__utils_NHFetch__["a" /* default */])('/zzbdCommon/getCssz', "GET", { csbz: 'YXXT_LSTD_HJJZRQ' }).then(function (res) {
                if (res) {
                    if (res.data && res.code === 200) {
                        _this.setState({ hjjzrqxz: res.data });
                    }
                }
            });
        };

        _this.getSfsqLstd = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_43__utils_NHFetch__["a" /* default */])('/proData/selectDataList', 'get', 'sign=dmk_YXXT_LSTD_BLZT').then(function (res) {
                if (res) {
                    if (res.data) {
                        _this.setState({
                            BlztList: res.data
                        });
                    }
                }
            });
        };

        _this.getMojorInfo = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_42__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_42__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_43__utils_NHFetch__["a" /* default */])("/zdybl/getXsxxAndLcidByXsid", 'GET', { xsid: xsid }).then(function (res) {
                if (res.code == "200") {
                    _this.setState({
                        XsxxlcidData: res.data
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.error("获取流程信息接口失败");
                }
            });
        };

        _this.loadLstddkfs = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_43__utils_NHFetch__["a" /* default */])('/proData/selectDataList', 'get', 'sign=dmk_YXXT_DKLX').then(function (res) {
                if (res && res.code == 200) {
                    var dkfsList = res.data;
                    _this.setState({
                        dkfsList: dkfsList
                    });
                }
            });
        };

        _this.updateZzbdBlzt = function () {
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_43__utils_NHFetch__["a" /* default */])('/zzbd/updateZzbdBlzt', 'GET', { zzbdhjid: zzbdhjid, hjdm: 'GD005_2' }).then(function (res) {
                if (res.data) {
                    _this.reloadMenu();
                }
            });
        };

        _this.queryQztjAndYlhj = function (callback) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_42__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_42__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_43__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }if (callback) {
                        callback(_this.state.operable);
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_49__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.loadLstdBlyy = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_43__utils_NHFetch__["a" /* default */])('/proData/selectDataList', 'get', 'sign=dmk_YXXT_LSTD_BLYY').then(function (res) {
                if (res) {
                    var col = [];
                    res.data.map(function (item) {
                        col.push(__WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_23_antd_lib_col___default.a,
                            { span: 6 },
                            __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_28_antd_lib_checkbox___default.a,
                                { value: item.VALUE },
                                item.LABEL
                            )
                        ));
                    });
                    var html = __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_21_antd_lib_row___default.a,
                        null,
                        col
                    );
                    _this.setState({ checkGroup: html });
                }
            });
        };

        _this.loadLstdHjsqdx = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_43__utils_NHFetch__["a" /* default */])('/proData/selectDataList', 'get', 'sign=dmk_YXXT_LSTD_HJSQDXLX').then(function (res) {
                if (res) {
                    var col = [];
                    res.data.map(function (item) {
                        if (item.VALUE == '7') {
                            col.push(__WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_23_antd_lib_col___default.a,
                                { span: 12 },
                                __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_19_antd_lib_tooltip___default.a,
                                    { placement: 'bottom', title: '\u4E3B\u8981\u5305\u62EC\u6276\u8D2B\u90E8\u95E8\u76D1\u6D4B\u7684\u8FB9\u7F18\u6237\uFF1B\u4EAB\u53D7\u56FD\u5BB6\u5B9A\u671F\u629A\u6064\u8865\u52A9\u7684\u4F18\u629A\u5BF9\u8C61\u5B50\u5973\uFF1B\u5BB6\u5EAD\u7ECF\u6D4E\u56F0\u96BE\u6B8B\u75BE\u4EBA\u5B50\u5973\uFF1B\u56E0\u5BB6\u5EAD\u906D\u53D7\u91CD\u5927\u81EA\u7136\u707E\u5BB3\uFF08\u75AB\u60C5\uFF09\u9020\u6210\u91CD\u5927\u635F\u5931\u7684\u56F0\u96BE\u5BB6\u5EAD\u5B50\u5973\uFF1B\u56E0\u5BB6\u5EAD\u6210\u5458\u906D\u53D7\u91CD\u5927\u75BE\u75C5\u6216\u610F\u5916\u4F24\u5BB3\u7684\u56F0\u96BE\u5BB6\u5EAD\u5B50\u5973\uFF1B\u56E0\u5BB6\u5EAD\u53D1\u751F\u91CD\u5927\u53D8\u6545\u7B49\u5F71\u54CD\u5176\u5B50\u5973\u5165\u5B66\u5C31\u8BFB\u7684\u56F0\u96BE\u5BB6\u5EAD\u5B50\u5973\uFF1B\u5176\u4ED6\u9700\u8981\u8D44\u52A9\u7684\u4F4E\u6536\u5165\u5BB6\u5EAD\u7ECF\u6D4E\u56F0\u96BE\u5B66\u751F\u3002' },
                                    __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_28_antd_lib_checkbox___default.a,
                                        { value: item.VALUE },
                                        item.LABEL
                                    )
                                )
                            ));
                        } else {
                            col.push(__WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_23_antd_lib_col___default.a,
                                { span: 12 },
                                __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_28_antd_lib_checkbox___default.a,
                                    { value: item.VALUE },
                                    item.LABEL
                                )
                            ));
                        }
                    });
                    var html = __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_21_antd_lib_row___default.a,
                        null,
                        col
                    );
                    _this.setState({ HjsqdxGroup: html });
                }
            });
        };

        _this.loadLstdInfo = function (flag) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_42__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_42__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_43__utils_NHFetch__["a" /* default */])('api/zhxg-yxxt/yxwz/zzbd/lstdFb/getLstdInfoByXsid', 'GET', { xsid: xsid }).then(function (resData) {
                if (resData && resData.data) {
                    if (flag == "edit") {
                        _this.setState({
                            edit: true
                        });
                    }
                    if (resData.data.sfbllstd == '0') {
                        _this.setState({
                            edit: false
                        });
                    }
                    var params = {
                        xsid: xsid,
                        hjdm: 'GD005_2'
                    };
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_43__utils_NHFetch__["a" /* default */])('/zzbdCommon/getBlztByHjdm', 'GET', params).then(function (res) {
                        if (res) {
                            if (res.data == '1') {
                                _this.setState({
                                    lstdblzt: true
                                });
                            } else {
                                _this.setState({
                                    lstdblzt: false
                                }, function () {
                                    var lstdblzt = _this.state.lstdblzt;

                                    if (!lstdblzt && resData.data.sfbllstd == '0') {
                                        _this.submitBtnClick();
                                    }
                                });
                            }
                        }
                    });
                    // this.setState({ data: resData.data });
                    _this.setState({
                        data: resData.data,
                        dkfsValue: resData.data.dklx,
                        sqValue: resData.data.sfbllstd
                    });
                    var fileList = [];
                    if (resData.data && resData.data['fjmap']) {
                        resData.data['fjmap'].map(function (elem, index) {
                            //格式化对于附件取值
                            var file = {
                                uid: elem.fjid,
                                name: elem.fjmc,
                                response: {
                                    data: {
                                        ssbh: elem.fjid,
                                        fjmc: elem.fjmc
                                    }
                                },
                                status: 'done'
                            };
                            fileList.push(file);
                        });
                    }
                    console.log(fileList);
                    _this.setState({ fileList: fileList });
                    _this.props.form.setFieldsValue({ fj: { fileList: _this.state.fileList } });
                } else {
                    _this.setState({ data: {}, edit: true });
                    _this.setState({ fileList: [] });
                    _this.props.form.resetFields();
                }
            });
        };

        _this.getBase64 = function (img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        };

        _this.handlePreview = function (file) {
            var isImage = /^image\/.*$/i.test(file.type);
            if (isImage) {
                if (file) {
                    _this.getBase64(file, function (imageUrl) {
                        _this.setState({
                            previewImage: imageUrl,
                            previewVisible: true
                        });
                    });
                } else {
                    _this.setState({
                        previewImage: file.url || file.thumbUrl,
                        previewVisible: true
                    });
                }
            } else if (file && file['response'] && file['response']['data']) {
                //其他情况
                var _isImage = true;
                var fjmc = file['response']['data']['fjmc'];
                var ssbh = file['response']['data']['ssbh'];
                if (!_this.setJudge(fjmc, _this.state.judgeImgList)) {
                    _isImage = false;
                }

                if (_isImage) {
                    _this.showPreview('anonymity/docrepo/download/file?attachmentId=' + ssbh);
                } else {
                    window.open('anonymity/docrepo/download/file?attachmentId=' + ssbh);
                }
            }
        };

        _this.showPreview = function (url) {
            _this.setState({
                previewImage: url,
                previewVisible: true
            });
        };

        _this.getLcidInfo = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_42__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_42__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_43__utils_NHFetch__["a" /* default */])("/zdybl/getXsxxAndLcidByXsid", 'GET', { xsid: xsid }).then(function (res) {
                if (res.code == "200") {
                    _this.setState({
                        lcidData: res.data
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.error("获取专业信息接口失败");
                }
            });
        };

        _this.hjblBtnClick = function () {
            var lcidData = _this.state.lcidData;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_42__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_42__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this.getQueryString('pkid');
            var formData = { xsid: xsid, yhid: xsid, zzbdhjid: zzbdhjid, lchjid: lcidData.LCID };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_43__utils_NHFetch__["a" /* default */])('/zdybl/saveCustomLinkData', "POST", formData).then(function (res) {
                if (res) {
                    if (res.data == '1') {
                        _this.setState({
                            isHjLinked: true
                        }, function () {
                            _this.reloadMenu();
                        });
                    } else {
                        _this.setState({
                            isHjLinked: false
                        });
                    }
                }
            });
        };

        _this.handleCancel = function () {
            return _this.setState({ previewVisible: false });
        };

        _this.getJfhjData = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_42__utils_NHCore__["b" /* getLoginUser */])().userId ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_42__utils_NHCore__["b" /* getLoginUser */])().userId : "";
            var param = {
                xsid: xsid,
                hjdm: 'GD008_1'
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_43__utils_NHFetch__["a" /* default */])('/zzbdCommon/getBlztByHjdm', 'GET', param).then(function (res) {
                if (res) {
                    if (res.data == '1') {
                        _this.setState({
                            jfhjzt: true
                        });
                    } else {
                        _this.setState({
                            jfhjzt: false
                        });
                    }
                }
            });
        };

        _this.handleSubmit = function (e) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_42__utils_NHCore__["b" /* getLoginUser */])().userId ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_42__utils_NHCore__["b" /* getLoginUser */])().userId : "";
            if (!xsid) {
                __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.error("登录已过期，请重新登录！");
                return;
            }
            if (_this.state.jfhjzt) {
                __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.error("缴费环节已办理，不可再申请绿色通道！");
                return;
            }
            var modalFlag = "";
            _this.setState({ loading: true, saveLoading: true });
            e.preventDefault();
            var zzbdhjid = _this.getQueryString('pkid');
            _this.props.form.validateFieldsAndScroll(function (err, values) {
                if (err) {
                    _this.setState({ loading: false, saveLoading: false });
                    return false;
                }

                /*  if(values['dklx'] == '6'){
                     NHConfirm("确定选择不贷款？保存后将不能取消！",() => {
                         console.log("11111");
                         modalFlag = true;
                        },"warn");
                 }
                 if(!modalFlag && values['dklx'] == '6'){
                     this.setState({loading:false});
                     return false;
                 } */
                var fjlist = [];
                if (values['sfbllstd'] == 1) {
                    var fj = values['fj'];
                    var lenList = [];
                    if (fj) {
                        if (fj['fileList'] && fj['fileList'].length > 0) {
                            fj['fileList'].map(function (item, index) {
                                if (index < 5) {
                                    lenList.push(item);
                                }
                            });
                        }
                    }
                    var isEmpty = false;
                    if (values['dklx'] == '5' || values['dklx'] == 'whrj_1' || values['dklx'] == 'whrj_4') {
                        fj['fileList'] = lenList;
                        console.log(values, lenList);
                        if (fj) {
                            if (fj['fileList'] && fj['fileList'].length > 0) {
                                isEmpty = false;
                            } else {
                                isEmpty = true;
                            }
                        } else {
                            isEmpty = true;
                        }
                        if (isEmpty) {
                            _this.props.form.setFields({
                                fj: {
                                    value: undefined,
                                    errors: [new Error('请上传材料证明')]
                                }
                            });
                            _this.setState({ loading: false, saveLoading: false });
                            return false;
                        }
                    }
                    if (fj != undefined) {
                        var size = fj['fileList'].length;
                        var file = fj['fileList'].filter(function (file) {
                            if (file.status === 'error') {
                                return false;
                            }
                            return true;
                        });

                        if (file.length != size) {
                            _this.props.form.setFields({
                                fj: {
                                    value: fj,
                                    errors: [new Error('材料上传出错，请重新上传.')]
                                }
                            });
                            _this.setState({ loading: false, saveLoading: false });
                            return false;
                        }

                        var fileList = fj['fileList'];

                        for (var i = 0; i < fileList.length; i++) {
                            var fjid = fileList[i].response.data.ssbh;
                            var fjmc = fileList[i].name;
                            fjlist.push({
                                fjid: fjid,
                                fjmc: fjmc
                            });
                        }
                    }
                }

                var sqsmFlag = false;
                var msg = '';
                var blyy = values['blyy'];
                var sqsm = values['sqsm'];
                var dkyh = values['dkyh'];
                var hzjym = values['hzjym'];
                var dkhtbh = values['dkhtbh'];
                var dklx = values['dklx'];
                var pkid = values['pkid'];
                var x_djlqzy = values['x_djlqzy'];
                var x_hjjzrq = _this.state.x_hjjzrq == "" || _this.state.x_hjjzrq == null ? values['x_hjjzrq'] : _this.state.x_hjjzrq;
                var sfbllstd = values['sfbllstd'];
                var x_hjsqdxlx = values['x_hjsqdxlx'];
                if (x_hjsqdxlx) {
                    x_hjsqdxlx = x_hjsqdxlx.toString();
                }
                if (sqsmFlag) {
                    __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.error(msg);
                    return;
                }
                var params = {};
                var blje = values['blje'];
                if (values['sfbllstd'] == 1) {
                    if (fjlist.length > 0) {
                        params = {
                            sfbllstd: sfbllstd,
                            fj: fjlist,
                            blje: blje,
                            blyy: blyy,
                            sqsm: sqsm,
                            hzjym: hzjym,
                            dkyh: dkyh,
                            xsid: xsid,
                            zzbdhjid: zzbdhjid,
                            pkid: pkid,
                            dkhtbh: dkhtbh,
                            dklx: dklx,
                            x_djlqzy: x_djlqzy

                        };
                    } else {
                        params = {
                            sfbllstd: sfbllstd,
                            blje: blje,
                            blyy: blyy,
                            sqsm: sqsm,
                            hzjym: hzjym,
                            dkyh: dkyh,
                            xsid: xsid,
                            zzbdhjid: zzbdhjid,
                            pkid: pkid,
                            dkhtbh: dkhtbh,
                            dklx: dklx,
                            x_djlqzy: x_djlqzy
                        };
                    }
                } else {
                    params = {
                        sfbllstd: sfbllstd,
                        xsid: xsid,
                        zzbdhjid: zzbdhjid,
                        pkid: pkid
                        // shzt:'1'
                    };
                }
                if (values['dklx'] == 'whrj_4') {
                    params['x_hjjzrq'] = x_hjjzrq;
                    params['x_hjsqdxlx'] = x_hjsqdxlx;
                }
                console.log("params", params);
                if (sfbllstd == '0') {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_52__components_common_NHModal__["b" /* NHConfirm */])("是否确定不申请绿色通道？保存后将不能取消！", function () {
                        if (!pkid) {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_43__utils_NHFetch__["a" /* default */])('api/zhxg-yxxt/yxwz/zzbd/lstdFb/insert', "POST", params).then(function (res) {
                                if (res) {
                                    __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.success("绿色通道申请保存成功。");
                                    _this.loadLstdInfo();
                                    _this.reloadMenu();
                                    if (sfbllstd == '0') {
                                        _this.submitBtnClick();
                                    }
                                }
                                _this.setState({ loading: false, edit: false, saveLoading: false });
                            }).catch(function (res) {
                                _this.setState({ loading: false, saveLoading: false });
                                return res;
                            });
                        } else {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_43__utils_NHFetch__["a" /* default */])('api/zhxg-yxxt/yxwz/zzbd/lstdFb/update', "POST", params).then(function (res) {
                                if (res && res.data && res.data > 0) {
                                    __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.success("绿色通道申请保存成功。");
                                    _this.loadLstdInfo();
                                    _this.reloadMenu();
                                    if (sfbllstd == '0') {
                                        _this.submitBtnClick();
                                    }
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.warning("绿色通道申请保存失败，请重试。");
                                }
                                _this.setState({ loading: false, edit: false, saveLoading: false });
                            }).catch(function (res) {
                                _this.setState({ loading: false, saveLoading: false });
                                return res;
                            });
                        }
                    }, "warn");
                } else {
                    if (!pkid) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_43__utils_NHFetch__["a" /* default */])('api/zhxg-yxxt/yxwz/zzbd/lstdFb/insert', "POST", params).then(function (res) {
                            if (res) {
                                __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.success("绿色通道申请保存成功。");
                                _this.loadLstdInfo();
                                _this.reloadMenu();
                                if (sfbllstd == '0') {
                                    _this.submitBtnClick();
                                }
                            }
                            _this.setState({ loading: false, edit: false, saveLoading: false });
                        }).catch(function (res) {
                            _this.setState({ loading: false, saveLoading: false });
                            return res;
                        });
                    } else {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_43__utils_NHFetch__["a" /* default */])('api/zhxg-yxxt/yxwz/zzbd/lstdFb/update', "POST", params).then(function (res) {
                            if (res && res.data && res.data > 0) {
                                __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.success("绿色通道申请保存成功。");
                                _this.loadLstdInfo();
                                _this.reloadMenu();
                                if (sfbllstd == '0') {
                                    _this.submitBtnClick();
                                }
                            } else {
                                __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.warning("绿色通道申请保存失败，请重试。");
                            }
                            _this.setState({ loading: false, edit: false, saveLoading: false });
                        }).catch(function (res) {
                            _this.setState({ loading: false, saveLoading: false });
                            return res;
                        });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.submitBtnClick = function () {
            var XsxxlcidData = _this.state.XsxxlcidData;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_42__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_42__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this.getQueryString('pkid');
            var formData = { xsid: xsid, yhid: xsid, zzbdhjid: zzbdhjid, lchjid: XsxxlcidData.LCID };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_43__utils_NHFetch__["a" /* default */])('/zdybl/saveCustomLinkData', "POST", formData).then(function (res) {
                if (res) {
                    if (res.data == '1') {
                        _this.reloadMenu();
                        __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.success('环节办理成功！');
                        var blztFlag = _this.state.blztFlag == '0' ? '1' : '0';
                        _this.setState({
                            blztFlag: blztFlag
                        });
                    } else {
                        __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.error('环节办理失败，请重试！');
                    }
                }
            });
        };

        _this.handleChange = function (_ref) {
            var fileList = _ref.fileList;

            var count = 0;
            fileList.map(function (elem) {
                if (elem && elem['status'] && elem['status'] === 'uploading') {
                    _this.setState({ uploading: true });
                    return;
                } else if (elem && elem['status']) {
                    count++;
                }
            });
            if (count > 0) {
                _this.setState({ uploading: false });
            }
        };

        _this.setJudge = function (name, map) {
            var flag = false;
            map.map(function (item) {
                if (name.indexOf(item) !== -1) {
                    flag = true;
                }
            });
            return flag;
        };

        _this.beforeUpload = function (file) {
            var fileList = _this.state.fileList;

            if (fileList.length >= 5) {
                __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.error('最多只能上传5个文件');
                console.log();
                return false;
            }
            if (!(_this.setJudge(file.name, _this.state.judgeImgList) || _this.setJudge(file.name, _this.state.judgeFileList))) {
                __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.error('不能上传该格式文件');
                return false;
            } else {
                return true;
            }
        };

        _this.remove = function (ssbh) {
            var url = 'api/docrepo/attachment/sourceId/delete?souerceId=' + ssbh;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_43__utils_NHFetch__["a" /* default */])(url, "POST").then(function (res) {
                if (res.data && res.data > 0) {
                    __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.success('已删除材料.');
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.dkfsOnChange = function (e) {
            _this.setState({
                dkfsValue: e.target.value
            });
        };

        _this.sfsqOnChange = function (e) {
            _this.setState({
                sqValue: e.target.value
            });
        };

        _this.timeData = function (moment, timeString) {
            _this.setState({
                x_hjjzrq: timeString
            });
        };

        _this.disabledStartDate = function (startValue) {
            var endValue = _this.state.hjjzrqxz;
            if (!startValue || !endValue) {
                return false;
            }
            return startValue.valueOf() > __WEBPACK_IMPORTED_MODULE_53_moment___default()(endValue, 'YYYY-MM-DD').add(1, 'd').valueOf();
        };

        _this.state = {
            mkbz: 'GD005_2',
            hjmc: '',
            uploading: false,
            loading: false,
            previewVisible: false,
            fileList: [],
            checkGroup: [], //绿色通道办理原因
            HjsqdxGroup: [], //缓交申请对象
            data: {}, //绿色通道申请信息
            nextUrl: '',
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            sqlyFlag: false, //申请理由flag
            jymFlag: false, //6位数回执校验码flag
            judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'], //可以导入的图片格式
            judgeFileList: ['.pdf', '.PDF', '.doc', '.DOC', '.zip', '.ZIP', '.txt', '.TXT', '.xls', '.XLS', '.rar', '.RAR'], //可以导入的非图片格式
            dkfsList: [],
            dkfsValue: "", //申请类型
            sqValue: "", //是否申请绿色通道
            lcidData: {},
            edit: false,
            x_hjjzrq: "",
            XsxxlcidData: [],
            jfhjzt: false, //缴费环节状态
            BlztList: [], //办理状态
            saveLoading: false
        };
        return _this;
    }

    _createClass(Channel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.getHjsjCsbz();
            this.getMojorInfo();
            this.loadLstdInfo();
            this.getJfhjData();
            this.queryQztjAndYlhj(function (operable) {
                if (operable) {
                    _this2.loadLstdBlyy();
                    _this2.loadLstdHjsqdx();
                    _this2.updateZzbdBlzt();
                }
            });
            this.getSfsqLstd();
            this.loadLstddkfs();
            this.getLcidInfo();
        }

        // 获取绿色通道是否办理选项


        // 获取lcid接口


        //迎新现场已办理时迎新网站自动办理


        //查询前置条件和依赖环节


        //读取学生的绿色通道信息


        // 转化base64


        // 点击文件链接或预览图标时的回调


        // 获取流程信息接口


        // 环节办理接口


        // 关闭图片弹窗


        // 获取缴费环节状态


        // 提交


        // 自动办理


        //判断文件类型是否正常  name：文件名称  map：类型范围数组  true正常


        //重新加载菜单


        // 回调


        //选择缓交截止日期回调

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var form = this.props.form;
            var getFieldDecorator = this.props.form.getFieldDecorator;
            var _state = this.state,
                previewImage = _state.previewImage,
                previewVisible = _state.previewVisible,
                jymFlag = _state.jymFlag,
                sqlyFlag = _state.sqlyFlag,
                dkfsList = _state.dkfsList,
                dkfsValue = _state.dkfsValue,
                edit = _state.edit,
                data = _state.data,
                sqValue = _state.sqValue,
                BlztList = _state.BlztList;

            var props = {
                name: 'file',
                action: 'zuul/docrepo/upload',
                maxCount: 5,
                data: { uuid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_42__utils_NHCore__["c" /* createUuid */])(), type: '1' },

                onRemove: function onRemove(file) {
                    _this3.setState(function (_ref2) {
                        var fileList = _ref2.fileList;

                        var index = fileList.indexOf(file);
                        var newFileList = fileList.slice();
                        newFileList.splice(index, 1);
                        _this3.props.form.setFieldsValue({ fj: { fileList: newFileList } });
                        return {
                            fileList: newFileList
                        };
                        console.log('fileList', fileList);
                    }, function () {
                        if (file.response && file.response.data && file.response.data.ssbh) {
                            _this3.remove(file.response.data.ssbh);
                        }
                    });
                },
                beforeUpload: function beforeUpload(file) {
                    if (!_this3.beforeUpload(file)) {
                        return false;
                    }
                    if (_this3.state.fileList.length < 5) {
                        _this3.setState(function (_ref3) {
                            var fileList = _ref3.fileList;
                            return {
                                fileList: [].concat(_toConsumableArray(fileList), [file])
                            };
                        });
                    }
                    return true;
                },
                onChange: function onChange(file) {
                    _this3.handleChange(file);
                },
                onPreview: this.handlePreview,
                fileList: this.state.fileList
            };

            return __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                'div',
                { style: { position: 'relative' } },
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_38__components__["a" /* Flex */],
                        { className: 'w1180 mt-20', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__pages_Assembly_siderMenu__["a" /* default */], {
                            ref: "siderMenu",
                            setMenuList: this.setMenuList,
                            title: '\u81EA\u52A9\u62A5\u5230',
                            mkbz: this.state.mkbz
                            /*     active={4}*/
                            , menuType: '\u81EA\u52A9\u62A5\u5230' }),
                        __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_38__components__["a" /* Flex */].Item,
                            { className: 'page_con_r ' },
                            __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__pages_Assembly_Breadcrumb__["a" /* default */], {
                                noLine: true,
                                list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                            }),
                            __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                'div',
                                { className: 'box' },
                                __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_50__pages_SelfHelp_common_hint__["a" /* default */], null),
                                edit ? __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_30_antd_lib_form___default.a,
                                    { onSubmit: this.handleSubmit },
                                    __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u4FE1\u606F', extra: false }),
                                    __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                        'div',
                                        { className: 'p-sw' },
                                        __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                            'div',
                                            { style: { display: 'none' } },
                                            __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_51__components_common_NHFormItem__["a" /* default */],
                                                { id: 'pkid', initialValue: data['pkid'], form: form },
                                                __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32_antd_lib_input___default.a, null)
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item', style: { marginLeft: '7%' } },
                                            __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_51__components_common_NHFormItem__["a" /* default */],
                                                { required: true, id: 'sfbllstd', initialValue: data['sfbllstd'], form: form, formItemLayout: formItemLayout, label: '\u7EFF\u8272\u901A\u9053\u7533\u8BF7' },
                                                __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_radio___default.a.Group,
                                                    { onChange: this.sfsqOnChange, value: this.state.sqValue, style: { display: "flex", margin: "10px" } },
                                                    BlztList && BlztList.map(function (item, index) {
                                                        return __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_17_antd_lib_radio___default.a,
                                                            { value: item.VALUE },
                                                            item.LABEL
                                                        );
                                                    })
                                                )
                                            )
                                        ),
                                        sqValue == '1' && __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item', style: { marginLeft: '7%' } },
                                            __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_51__components_common_NHFormItem__["a" /* default */],
                                                { required: true, id: 'dklx', initialValue: data['dklx'], form: form, formItemLayout: formItemLayout, label: '\u7533\u8BF7\u7C7B\u578B' },
                                                __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_radio___default.a.Group,
                                                    { onChange: this.dkfsOnChange, value: this.state.dkfsValue, style: { display: "flex", margin: "10px" } },
                                                    dkfsList.map(function (item, index) {
                                                        return __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_17_antd_lib_radio___default.a,
                                                            { value: item.VALUE },
                                                            item.LABEL
                                                        );
                                                    })
                                                )
                                            )
                                        ),
                                        sqValue == '1' && __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                            'div',
                                            { style: { marginLeft: "30px" } },
                                            dkfsValue == 'whrj_1' && __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_51__components_common_NHFormItem__["a" /* default */],
                                                { id: 'blyy', required: true, initialValue: data['blyydm'], form: form, formItemLayout: { labelCol: { span: 4 }, wrapperCol: { span: 16 } }, label: '\u529E\u7406\u539F\u56E0' },
                                                __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                    CheckboxGroup,
                                                    { style: { width: '100%' } },
                                                    this.state.checkGroup
                                                )
                                            )
                                        ),
                                        sqValue == '1' && __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                            'div',
                                            { style: { marginLeft: "30px" } },
                                            dkfsValue == 'whrj_4' && __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_51__components_common_NHFormItem__["a" /* default */],
                                                { id: 'x_hjsqdxlx', required: true, initialValue: data['x_hjsqdxlx'], form: form, formItemLayout: { labelCol: { span: 4 }, wrapperCol: { span: 16 } }, label: '\u7F13\u4EA4\u7533\u8BF7\u5BF9\u8C61' },
                                                __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                    CheckboxGroup,
                                                    { style: { width: '100%' } },
                                                    this.state.HjsqdxGroup
                                                )
                                            )
                                        ),
                                        sqValue == '1' && __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item', style: { marginLeft: '7%' } },
                                            (dkfsValue == '1' || dkfsValue == '4' || dkfsValue == 'whrj_1') && __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_51__components_common_NHFormItem__["a" /* default */],
                                                { id: 'sqsm', required: dkfsValue == '4' ? true : false, initialValue: data['sqsm'], form: form, formItemLayout: formItemLayout, label: '\u7533\u8BF7\u7406\u7531' },
                                                __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(TextArea, { maxLength: 50, placeholder: '\u8BF7\u586B\u5199\u7533\u8BF7\u7406\u7531' })
                                            ),
                                            (dkfsValue == '1' || dkfsValue == 'whrj_1') && __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_51__components_common_NHFormItem__["a" /* default */],
                                                { id: 'blje', required: true, initialValue: data['blje'], form: form, formItemLayout: formItemLayout, label: '\u8D37\u6B3E\u91D1\u989D' },
                                                __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input_number___default.a, { style: { width: '100%' }, min: 0, max: 9999999, precision: '0', placeholder: '\u8BF7\u586B\u5199\u91D1\u989D\uFF08\u5143\uFF09' })
                                            ),
                                            (dkfsValue == '4' || dkfsValue == 'whrj_4') && __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_51__components_common_NHFormItem__["a" /* default */],
                                                { id: 'blje', required: true, initialValue: data['blje'], form: form, formItemLayout: formItemLayout, label: '\u7F13\u4EA4\u91D1\u989D' },
                                                __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input_number___default.a, { style: { width: '100%' }, min: 0, max: 9999999, precision: '0', placeholder: '\u7F13\u4EA4\u91D1\u989D' })
                                            ),
                                            dkfsValue == '5' && __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_51__components_common_NHFormItem__["a" /* default */],
                                                { id: 'blje', required: true, initialValue: data['blje'], form: form, formItemLayout: formItemLayout, label: '\u51CF\u514D\u91D1\u989D' },
                                                __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input_number___default.a, { style: { width: '100%' }, min: 0, max: 9999999, precision: '0', placeholder: '\u51CF\u514D\u91D1\u989D' })
                                            ),
                                            dkfsValue == 'whrj_4' && __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_51__components_common_NHFormItem__["a" /* default */],
                                                { id: 'x_hjjzrq', required: true, form: form, formItemLayout: formItemLayout, label: '\u7F13\u4EA4\u622A\u6B62\u65E5\u671F',
                                                    initialValue: data.x_hjjzrq ? __WEBPACK_IMPORTED_MODULE_53_moment___default()(data.x_hjjzrq, 'YYYY/MM/DD') : null
                                                },
                                                __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker___default.a, { onChange: this.timeData, placeholder: "选择日期...", format: "YYYY-MM-DD", disabledDate: this.disabledStartDate })
                                            ),
                                            (dkfsValue == '1' || dkfsValue == 'whrj_1') && __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_51__components_common_NHFormItem__["a" /* default */],
                                                { id: 'dkyh', required: true, initialValue: data['dkyh'], form: form, formItemLayout: formItemLayout, label: '\u8D37\u6B3E\u94F6\u884C' },
                                                __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_47__components_common_NHSelect__["a" /* default */], { sign: "dmk_yxwz_dkyh", onChange: function onChange(v) {} })
                                            ),
                                            (dkfsValue == '1' || dkfsValue == 'whrj_1') && __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_51__components_common_NHFormItem__["a" /* default */],
                                                { required: true, id: 'hzjym', initialValue: data['hzjym'], form: form, formItemLayout: formItemLayout, label: '\u56DE\u6267\u6821\u9A8C\u7801' },
                                                __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32_antd_lib_input___default.a, { maxLength: 6, placeholder: '6\u4F4D\u6570\u56DE\u6267\u6821\u9A8C\u7801' })
                                            ),
                                            dkfsValue == '1' && __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_51__components_common_NHFormItem__["a" /* default */],
                                                { required: true, id: 'dkhtbh', initialValue: data['dkhtbh'], form: form, formItemLayout: formItemLayout, label: '\u8D37\u6B3E\u5408\u540C\u7F16\u53F7' },
                                                __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32_antd_lib_input___default.a, { placeholder: '\u8D37\u6B3E\u5408\u540C\u7F16\u53F7' })
                                            ),
                                            dkfsValue == '5' && __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_51__components_common_NHFormItem__["a" /* default */],
                                                { required: true, id: 'x_djlqzy', initialValue: data['x_djlqzy'], form: form, formItemLayout: formItemLayout, label: '\u767B\u8BB0\u5F55\u53D6\u4E13\u4E1A' },
                                                __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32_antd_lib_input___default.a, { placeholder: '\u767B\u8BB0\u5F55\u53D6\u4E13\u4E1A' })
                                            )
                                        )
                                    ),
                                    sqValue == '1' && dkfsValue != '' && dkfsValue != undefined && __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u6750\u6599', extra: false }),
                                    sqValue == '1' && dkfsValue != '' && dkfsValue != undefined && __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                        'div',
                                        { className: 'p-sw' },
                                        __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item', style: { marginLeft: '7%' } },
                                            __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                FormItem,
                                                {
                                                    labelCol: { span: 8 },
                                                    wrapperCol: { span: 16 },
                                                    label: '请上传材料证明'
                                                },
                                                getFieldDecorator('fj', {
                                                    rules: [{
                                                        required: dkfsValue == '5' || dkfsValue == 'whrj_1' || dkfsValue == 'whrj_4' ? true : false,
                                                        message: '请上传材料证明'
                                                    }]
                                                })(__WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                    Dragger,
                                                    props,
                                                    __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                        'p',
                                                        { className: 'ant-upload-drag-icon' },
                                                        __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, { type: 'inbox' })
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_spin___default.a, { spinning: this.state.uploading }),
                                                    __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                                        'p',
                                                        { className: 'ant-upload-text font-14' },
                                                        '\u70B9\u51FB\u6B64\u5904\u6216\u62D6\u62FD\u6587\u4EF6\u5230\u6B64'
                                                    )
                                                ))
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,
                                            { type: 'primary', htmlType: 'submit', loading: this.state.saveLoading },
                                            '\u4FDD\u5B58'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_44__pages_SelfHelp_channelFb_view__["a" /* default */], { reloadMenu: this.reloadMenu, nextUrl: this.state.nextUrl, loadLstdInfo: function loadLstdInfo() {
                                        return _this3.loadLstdInfo("edit");
                                    }, search: this.state.search, showPreview: this.showPreview, setJudge: this.setJudge, data: this.state.data, judgeImgList: this.state.judgeImgList, jfhjzt: this.state.jfhjzt, BlztList: BlztList })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a,
                        {
                            visible: previewVisible,
                            footer: null,
                            onCancel: this.handleCancel
                        },
                        __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement('img', {
                            alt: 'example',
                            style: { width: '100%' },
                            src: previewImage
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_spin___default.a, { style: { position: 'absolute', top: '300px', left: '60%' }, spinning: this.state.loading }),
                    ' '
                ) : __WEBPACK_IMPORTED_MODULE_35_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_46__pages_SelfHelp_common__["a" /* default */], { hjmc: "绿色通道申请", key: "GD005_2", mkbz: 'GD005_2', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return Channel;
}(__WEBPACK_IMPORTED_MODULE_35_react___default.a.Component)) || _class);


/***/ }),

/***/ 1023:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return View; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }









var TextArea = __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a.TextArea;

var basicUrl = "/zzbd";

var shztList = {
    '-1': '审核不通过',
    '0': '未审核',
    '1': '审核通过',
    '2': '已办理',
    '9': '驳回'
};

var View = function (_React$Component) {
    _inherits(View, _React$Component);

    function View(props) {
        _classCallCheck(this, View);

        var _this = _possibleConstructorReturn(this, (View.__proto__ || __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default()(View)).call(this, props));

        _this.loadLstdHjsqdx = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])('/proData/selectDataList', 'get', 'sign=dmk_YXXT_LSTD_HJSQDXLX').then(function (res) {
                if (res) {
                    if (res.data) {
                        _this.setState({
                            hjsqdxlx: res.data
                        });
                    }
                }
            });
        };

        _this.getDmkMc = function (dmbz) {
            var data = _this.props.data;

            var dkyhmc = _this.state.dkyhmc;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])(basicUrl + "/getDmkMc", "GET", { dmbz: dmbz }).then(function (res) {
                if (res) {
                    if (res.data) {
                        if (dmbz === "YXWZ_DKYH") {
                            /*    res.data.map(initItem => {
                                   if(initItem.DM === data.dkyh){
                                       dkyhmc=initItem.MC;
                                   }
                               });
                               this.setState({dkyhmc: dkyhmc}); */
                            _this.setState({
                                dkyhList: res.data
                            });
                        }
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.edit = function (lstdid, shzt) {
            if (_this.props.jfhjzt) {
                __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.error("缴费环节已办理，不可修改申请！");
                return;
            }
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])('api/zhxg-yxxt/yxwz/zzbd/lstdFb/getLstdInfoByXsid', 'GET', { xsid: xsid }).then(function (resData) {
                if (resData && resData.data) {
                    if (resData.data.shzt != '' && resData.data.shzt != undefined && resData.data.shzt == null) {
                        if (resData.data.shzt !== '0' && resData.data.shzt !== '9') {
                            __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warning('该申请已经审核，不能修改');
                            return;
                        }
                        _this.props.loadLstdInfo('edit');
                        _this.props.reloadMenu();
                    } else {
                        _this.props.loadLstdInfo('edit');
                        _this.props.reloadMenu();
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warning("修改异常");
                }
            });

            /* if(resData.data.SHZT !== '0' && resData.data.SHZT !== '-1'){
                message.warning('该申请已经审核，不能取消')
                return ;
            } */

            /*  let pkid = this.getQueryString("pkid");
              let params = {
                 zzbdhjid:pkid,
                 pkid:lstdid
             }
              NHFetch("/lstd/deleteByParams", "POST", params)
                 .then(res => {
                     if (res && res.data && res.data>0) {
                         message.success("取消成功");
                         this.props.loadLstdInfo();
                         this.props.reloadMenu();
                     }else{
                         message.warning("取消异常");
                     }
                 }); */
        };

        _this.handlePreview = function (fjmc, fjid) {
            var isImage = true;
            if (!_this.props.setJudge(fjmc, _this.props.judgeImgList)) {
                isImage = false;
            }

            if (isImage) {
                window.open('anonymity/docrepo/download/file?attachmentId=' + fjid);
                _this.props.showPreview('anonymity/docrepo/download/file?attachmentId=' + fjid);
            } else {
                window.open('anonymity/docrepo/download/file?attachmentId=' + fjid);
            }
        };

        _this.state = {
            dkyhmc: '',
            nextUrl: _this.props.nextUrl,
            search: _this.props.search,
            hjsqdxlx: [], //缓交申请对象
            dkyhList: [] //贷款银行
        };
        return _this;
    }

    _createClass(View, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.getDmkMc("YXWZ_DKYH");
            this.loadLstdHjsqdx();
        }

        //获取下拉列表value对应的名称


        // 点击文件链接或预览图标时的回调

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                data = _props.data,
                BlztList = _props.BlztList;
            var _state = this.state,
                hjsqdxlx = _state.hjsqdxlx,
                dkyhList = _state.dkyhList;

            var x_hjsqdxlx = [];
            if (data['x_hjsqdxlx']) {
                var x_hjsqdxlxdm = data['x_hjsqdxlx'].split(',');
                hjsqdxlx.map(function (item, index) {
                    x_hjsqdxlxdm.map(function (elem) {
                        if (item.VALUE == elem) {
                            x_hjsqdxlx.push(item.LABEL);
                        }
                    });
                });
            }
            var dkyhmc = '';
            if (data['dkyh']) {
                if (dkyhList) {
                    dkyhList.map(function (item, index) {
                        if (item.DM === data.dkyh) {
                            dkyhmc = item.MC;
                        }
                    });
                }
            }
            var lstdBlzt = "";
            if (data['sfbllstd']) {
                if (BlztList) {
                    BlztList.map(function (item, index) {
                        if (data['sfbllstd'] == item.VALUE) {
                            lstdBlzt = item.LABEL;
                        }
                    });
                }
            }
            return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u4FE1\u606F', extra: false }),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            _defineProperty({ gutter: 24, style: { margin: "10px 0px" } }, 'style', { margin: "10px 0px" }),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u7EFF\u8272\u901A\u9053\u7533\u8BF7\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    lstdBlzt
                                )
                            )
                        ),
                        data['sfbllstd'] == '1' && __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            _defineProperty({ gutter: 24, style: { margin: "10px 0px" } }, 'style', { margin: "10px 0px" }),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u7533\u8BF7\u7C7B\u578B\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['dklxmc'] ? data['dklxmc'] : ""
                                )
                            )
                        ),
                        data['sfbllstd'] == '1' && data['dklx'] != '5' && data['dklx'] != 'whrj_4' && __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24, style: { margin: "10px 0px" } },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u7533\u8BF7\u7406\u7531\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['sqsm'] ? data['sqsm'] : ""
                                )
                            )
                        ),
                        data['sfbllstd'] == '1' && data['dklx'] != '4' && data['dklx'] != '5' && data['dklx'] != 'whrj_4' && __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24, style: { margin: "10px 0px" } },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u8D37\u6B3E\u91D1\u989D\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['blje'] ? data['blje'] : "",
                                    '\u5143'
                                )
                            )
                        ),
                        data['sfbllstd'] == '1' && (data['dklx'] == 'whrj_4' || data['dklx'] == '4') && __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24, style: { margin: "10px 0px" } },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u7F13\u4EA4\u91D1\u989D\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['blje'] ? data['blje'] : "",
                                    '\u5143'
                                )
                            )
                        ),
                        data['sfbllstd'] == '1' && data['dklx'] == '5' && __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24, style: { margin: "10px 0px" } },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u51CF\u514D\u91D1\u989D\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['blje'] ? data['blje'] : "",
                                    '\u5143'
                                )
                            )
                        ),
                        data['sfbllstd'] == '1' && (data['dklx'] == '1' || data['dklx'] == 'whrj_1') && __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24, style: { margin: "10px 0px" } },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u8D37\u6B3E\u94F6\u884C\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    dkyhmc
                                )
                            )
                        ),
                        data['sfbllstd'] == '1' && (data['dklx'] == '1' || data['dklx'] == 'whrj_1') && __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24, style: { margin: "10px 0px" } },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '6\u4F4D\u6570\u56DE\u6267\u6821\u9A8C\u7801\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['hzjym'] ? data['hzjym'] : ""
                                )
                            )
                        ),
                        data['sfbllstd'] == '1' && data['dklx'] == '1' && __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24, style: { margin: "10px 0px" } },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u8D37\u6B3E\u5408\u540C\u7F16\u53F7\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['dkhtbh'] ? data['dkhtbh'] : ""
                                )
                            )
                        ),
                        data['sfbllstd'] == '1' && data['dklx'] == '5' && __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24, style: { margin: "10px 0px" } },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u767B\u8BB0\u5F55\u53D6\u4E13\u4E1A\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['x_djlqzy'] ? data['x_djlqzy'] : ""
                                )
                            )
                        ),
                        data['sfbllstd'] == '1' && data['dklx'] == 'whrj_4' && __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24, style: { margin: "10px 0px" } },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u7F13\u4EA4\u622A\u6B62\u65E5\u671F\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['x_hjjzrq'] ? data['x_hjjzrq'] : ""
                                )
                            )
                        )
                    )
                ),
                data['sfbllstd'] == '1' && data['dklx'] == 'whrj_4' && __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'form_item', style: { width: '100%', marginBottom: '20px' } },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                        { gutter: 24 },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                            { span: 4, style: { textAlign: 'right', marginTop: "3px", paddingRight: 0 } },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                'span',
                                {
                                    style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                '\u7F13\u4EA4\u7533\u8BF7\u5BF9\u8C61\xA0: '
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                            { span: 20 },
                            x_hjsqdxlx && x_hjsqdxlx.map(function (elem, index) {
                                return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    { style: {
                                            borderColor: '#1890ff',
                                            borderRadius: '5px',
                                            padding: '2px 16px',
                                            border: '1px solid rgb(24, 144, 255)',
                                            margin: '5px',
                                            display: 'inline-block'
                                        } },
                                    elem
                                );
                            })
                        )
                    )
                ),
                data['sfbllstd'] == '1' && data['dklx'] == 'whrj_1' && __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'form_item', style: { width: '100%', marginBottom: '20px' } },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                        { gutter: 24 },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                            { span: 4, style: { textAlign: 'right', marginTop: "3px", paddingRight: 0 } },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                'span',
                                {
                                    style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                '\u529E\u7406\u539F\u56E0\xA0: '
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                            { span: 20 },
                            data['blyy'].map(function (elem, index) {
                                return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    { style: {
                                            borderColor: '#1890ff',
                                            borderRadius: '5px',
                                            padding: '2px 16px',
                                            border: '1px solid rgb(24, 144, 255)',
                                            margin: '5px',
                                            display: 'inline-block'
                                        } },
                                    elem
                                );
                            })
                        )
                    )
                ),
                data['sfbllstd'] == '1' && __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u6750\u6599', extra: false }),
                data['sfbllstd'] == '1' && __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u6750\u6599\u8BC1\u660E\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                data['fjmap'] && data['fjmap'].map(function (elem, index) {
                                    return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                        'div',
                                        { style: { marginBottom: '20px' } },
                                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                            'a',
                                            { onClick: function onClick() {
                                                    _this2.handlePreview(elem['fjmc'], elem['fjid']);
                                                } },
                                            elem['fjmc']
                                        )
                                    );
                                })
                            )
                        )
                    )
                ),
                data['sfbllstd'] == '1' && __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u5BA1\u6838', extra: false }),
                data['sfbllstd'] == '1' && __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24, style: { margin: "10px 0px" } },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u5BA1\u6838\u610F\u89C1\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['shyj']
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24, style: { margin: "10px 0px" } },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u5BA1\u6838\u72B6\u6001\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    { style: { color: '#0066FF' } },
                                    shztList[data['shzt']]
                                )
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'text-center mt-50' },
                    data['sfbllstd'] == '1' && (data['shzt'] == null || data['shzt'] == "0" || data['shzt'] == "9") && __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                        { type: 'primary', onClick: function onClick() {
                                _this2.edit(data['pkid'], data['shzt']);
                            } },
                        '\u4FEE\u6539'
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                )
            );
        }
    }]);

    return View;
}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);



/***/ }),

/***/ 1024:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChannelTlxy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_spin_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_spin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_number_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input_number__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_json_stringify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_checkbox_style__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_checkbox__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_axios__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_SelfHelp_channelTlxy_view__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_SelfHelp_common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__ = __webpack_require__(43);































var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }












var Dragger = __WEBPACK_IMPORTED_MODULE_29_antd_lib_upload___default.a.Dragger;







var history = __WEBPACK_IMPORTED_MODULE_40_history_createHashHistory___default()();
var TextArea = __WEBPACK_IMPORTED_MODULE_27_antd_lib_input___default.a.TextArea;

var FormItem = __WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item;
var CheckboxGroup = __WEBPACK_IMPORTED_MODULE_23_antd_lib_checkbox___default.a.Group;
var formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 }
};

var ChannelTlxy = (_dec = __WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(ChannelTlxy, _React$Component);

    function ChannelTlxy(props) {
        _classCallCheck(this, ChannelTlxy);

        var _this = _possibleConstructorReturn(this, (ChannelTlxy.__proto__ || __WEBPACK_IMPORTED_MODULE_21_babel_runtime_core_js_object_get_prototype_of___default()(ChannelTlxy)).call(this, props));

        _this.updateZzbdBlzt = function () {
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__["a" /* default */])('/zzbd/updateZzbdBlzt', 'GET', { zzbdhjid: zzbdhjid, hjdm: 'GD005_5' }).then(function (res) {
                if (res.data) {
                    _this.reloadMenu();
                }
            });
        };

        _this.queryQztjAndYlhj = function (callback) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }if (callback) {
                        callback(_this.state.operable);
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_44__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.loadLstdBlyy = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__["a" /* default */])('/proData/selectDataList', 'get', 'sign=dmk_YXXT_LSTD_BLYY').then(function (res) {
                if (res) {
                    var col = [];
                    res.data.map(function (item) {
                        col.push(__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_20_antd_lib_col___default.a,
                            { span: 6 },
                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_23_antd_lib_checkbox___default.a,
                                { value: item.VALUE },
                                item.LABEL
                            )
                        ));
                    });
                    var html = __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_18_antd_lib_row___default.a,
                        null,
                        col
                    );
                    _this.setState({ checkGroup: html });
                }
            });
        };

        _this.loadLstdInfo = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__["a" /* default */])('/lstd/getLstdInfoByXsid', 'GET').then(function (resData) {
                if (resData && resData.data) {
                    _this.setState({ data: resData.data });
                    var fileList = [];
                    if (resData.data && resData.data['fj']) {
                        resData.data['fj'].map(function (elem, index) {
                            //格式化对于附件取值
                            var file = {
                                uid: elem.fjid,
                                name: elem.fjmc,
                                response: {
                                    data: {
                                        ssbh: elem.fjid,
                                        fjmc: elem.fjmc
                                    }
                                },
                                status: 'done'
                            };
                            fileList.push(file);
                        });
                    }
                    _this.setState({ fileList: fileList });
                    _this.props.form.setFieldsValue({ fj: { fileList: _this.state.fileList } });
                } else {
                    _this.setState({ data: {} });
                    _this.setState({ fileList: [] });
                    _this.props.form.resetFields();
                }
            });
        };

        _this.getBase64 = function (img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        };

        _this.handlePreview = function (file) {
            var isImage = /^image\/.*$/i.test(file.type);
            if (isImage) {
                if (file) {
                    _this.getBase64(file, function (imageUrl) {
                        _this.setState({
                            previewImage: imageUrl,
                            previewVisible: true
                        });
                    });
                } else {
                    _this.setState({
                        previewImage: file.url || file.thumbUrl,
                        previewVisible: true
                    });
                }
            } else if (file && file['response'] && file['response']['data']) {
                //其他情况
                var _isImage = true;
                var fjmc = file['response']['data']['fjmc'];
                var ssbh = file['response']['data']['ssbh'];
                if (!_this.setJudge(fjmc, _this.state.judgeImgList)) {
                    _isImage = false;
                }

                if (_isImage) {
                    _this.showPreview('anonymity/docrepo/download/file?attachmentId=' + ssbh);
                } else {
                    window.open('anonymity/docrepo/download/file?attachmentId=' + ssbh);
                }
            }
        };

        _this.showPreview = function (url) {
            _this.setState({
                previewImage: url,
                previewVisible: true
            });
        };

        _this.handleCancel = function () {
            return _this.setState({ previewVisible: false });
        };

        _this.handleSubmit = function (e) {
            _this.setState({ loading: true });
            e.preventDefault();
            var zzbdhjid = _this.getQueryString('pkid');
            _this.props.form.validateFieldsAndScroll(function (err, values) {
                if (err) {
                    _this.setState({ loading: false });
                    return false;
                }

                var fj = values['fj'];

                var isEmpty = false;
                if (fj) {
                    if (fj['fileList'] && fj['fileList'].length > 0) {
                        isEmpty = false;
                    } else {
                        isEmpty = true;
                    }
                } else {
                    isEmpty = true;
                }

                if (isEmpty) {
                    _this.props.form.setFields({
                        fj: {
                            value: undefined,
                            errors: [new Error('请上传材料证明')]
                        }
                    });
                    _this.setState({ loading: false });
                    return false;
                }

                var size = fj['fileList'].length;
                var file = fj['fileList'].filter(function (file) {
                    if (file.status === 'error') {
                        return false;
                    }
                    return true;
                });
                if (file.length != size) {
                    _this.props.form.setFields({
                        fj: {
                            value: fj,
                            errors: [new Error('材料上传出错，请重新上传.')]
                        }
                    });
                    _this.setState({ loading: false });
                    return false;
                }

                var fileList = fj['fileList'];
                var fjlist = [];
                for (var i = 0; i < fileList.length; i++) {
                    var fjid = fileList[i].response.data.ssbh;
                    var fjmc = fileList[i].name;
                    fjlist.push({
                        fjid: fjid,
                        fjmc: fjmc
                    });
                }

                var sqsmFlag = false;
                var msg = '';
                var blyy = values['blyy'];
                var sqsm = values['sqsm'];
                var dkyh = values['dkyh'];
                var hzjym = values['hzjym'];
                var dkhtbh = values['dkhtbh'];
                var pkid = values['pkid'];
                blyy.map(function (item) {
                    if (item == '99') {
                        if (typeof sqsm == "undefined" || sqsm.trim().length == 0) {
                            sqsmFlag = true;
                            msg = "其它原因，请填写申请理由";
                        }
                    }
                });

                // if(dkyh == '01'){
                //     if(typeof(hzjym) == "undefined" ||hzjym.trim().length!=6){
                //         sqsmFlag = true ;
                //         msg="国家开发银行贷款，请填写6位数回执校验码"
                //     }
                // }
                if ((typeof dkhtbh == "undefined" || dkhtbh == "") && (typeof hzjym == "undefined" || hzjym == "")) {
                    sqsmFlag = true;
                    msg = "请填写贷款合同编号或回执校验码";
                }
                if (typeof hzjym != "undefined" && hzjym != "" && hzjym.trim().length != 6) {
                    sqsmFlag = true;
                    msg = "请填写6位回执校验码";
                }
                if (sqsmFlag) {
                    __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.error(msg);
                    return;
                }

                var blje = values['blje'];
                var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])().userId;
                var params = {
                    fj: fjlist,
                    blyy: blyy,
                    blje: blje,
                    sqsm: sqsm,
                    hzjym: hzjym,
                    dkyh: dkyh,
                    xsid: xsid,
                    zzbdhjid: zzbdhjid,
                    pkid: pkid,
                    dkhtbh: dkhtbh
                };
                if (!pkid) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__["a" /* default */])('/lstd/insert', "POST", params).then(function (res) {
                        if (res) {
                            __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.success("绿色通道申请保存成功。");
                            _this.loadLstdInfo();
                            _this.reloadMenu();
                        }
                        _this.setState({ loading: false });
                    }).catch(function (res) {
                        _this.setState({ loading: false });
                        return res;
                    });
                } else {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__["a" /* default */])('/lstd/update', "POST", params).then(function (res) {
                        if (res && res.data && res.data > 0) {
                            __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.success("绿色通道申请保存成功。");
                            _this.loadLstdInfo();
                            _this.reloadMenu();
                        } else {
                            __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.warning("绿色通道申请保存失败，请重试。");
                        }
                        _this.setState({ loading: false });
                    }).catch(function (res) {
                        _this.setState({ loading: false });
                        return res;
                    });
                }
            });
        };

        _this.handleChange = function (_ref) {
            var fileList = _ref.fileList;

            var count = 0;
            fileList.map(function (elem) {
                if (elem && elem['status'] && elem['status'] === 'uploading') {
                    _this.setState({ uploading: true });
                    return;
                } else if (elem && elem['status']) {
                    count++;
                }
            });
            if (count > 0) {
                _this.setState({ uploading: false });
            }
        };

        _this.setJudge = function (name, map) {
            var flag = false;
            map.map(function (item) {
                if (name.indexOf(item) !== -1) {
                    flag = true;
                }
            });
            return flag;
        };

        _this.beforeUpload = function (file) {
            if (!(_this.setJudge(file.name, _this.state.judgeImgList) || _this.setJudge(file.name, _this.state.judgeFileList))) {
                __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.error('不能上传该格式文件');
                return false;
            } else {
                return true;
            }
        };

        _this.remove = function (ssbh) {
            var url = 'api/docrepo/attachment/sourceId/delete?souerceId=' + ssbh;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHFetch__["a" /* default */])(url, "POST").then(function (res) {
                if (res.data && res.data > 0) {
                    __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.success('已删除材料.');
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD005_5',
            hjmc: '',
            uploading: false,
            loading: false,
            previewVisible: false,
            fileList: [],
            checkGroup: [], //绿色通道办理原因
            data: {}, //绿色通道申请信息
            nextUrl: '',
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            sqlyFlag: false, //申请理由flag
            jymFlag: false, //6位数回执校验码flag
            judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'], //可以导入的图片格式
            judgeFileList: ['.pdf', '.PDF', '.doc', '.DOC', '.zip', '.ZIP', '.txt', '.TXT', '.xls', '.XLS', '.rar', '.RAR'] //可以导入的非图片格式
        };
        return _this;
    }

    _createClass(ChannelTlxy, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.queryQztjAndYlhj(function (operable) {
                if (operable) {
                    _this2.loadLstdInfo();
                    _this2.loadLstdBlyy();
                    _this2.updateZzbdBlzt();
                }
            });
        }

        //迎新现场已办理时迎新网站自动办理


        //查询前置条件和依赖环节


        //读取学生的绿色通道信息


        // 转化base64


        // 点击文件链接或预览图标时的回调


        // 关闭图片弹窗


        // 提交


        //判断文件类型是否正常  name：文件名称  map：类型范围数组  true正常


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var form = this.props.form;
            var getFieldDecorator = this.props.form.getFieldDecorator;
            var _state = this.state,
                previewImage = _state.previewImage,
                previewVisible = _state.previewVisible,
                jymFlag = _state.jymFlag,
                sqlyFlag = _state.sqlyFlag;

            var props = {
                name: 'file',
                action: 'anonymity/docrepo/upload',
                data: { uuid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["c" /* createUuid */])(), type: '1' },

                onRemove: function onRemove(file) {
                    _this3.setState(function (_ref2) {
                        var fileList = _ref2.fileList;

                        var index = fileList.indexOf(file);
                        var newFileList = fileList.slice();
                        newFileList.splice(index, 1);
                        _this3.props.form.setFieldsValue({ fj: { fileList: newFileList } });
                        return {
                            fileList: newFileList
                        };
                    }, function () {
                        if (file.response && file.response.data && file.response.data.ssbh) {
                            _this3.remove(file.response.data.ssbh);
                        }
                    });
                },
                beforeUpload: function beforeUpload(file) {
                    if (!_this3.beforeUpload(file)) {
                        return false;
                    }
                    _this3.setState(function (_ref3) {
                        var fileList = _ref3.fileList;
                        return {
                            fileList: [].concat(_toConsumableArray(fileList), [file])
                        };
                    });
                    return true;
                },
                onChange: function onChange(file) {
                    _this3.handleChange(file);
                },
                onPreview: this.handlePreview,
                fileList: this.state.fileList
            };

            var edit = false;
            var data = this.state.data;
            if (__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_json_stringify___default()(data) == "{}") {
                edit = true;
            } else if (data && data['shzt'] === '9') {
                edit = true;
            }
            return __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                'div',
                { style: { position: 'relative' } },
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_33__components__["a" /* Flex */],
                        { className: 'w1180 mt-20', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__pages_Assembly_siderMenu__["a" /* default */], {
                            ref: "siderMenu",
                            setMenuList: this.setMenuList,
                            title: '\u81EA\u52A9\u62A5\u5230',
                            mkbz: this.state.mkbz
                            /*     active={4}*/
                            , menuType: '\u81EA\u52A9\u62A5\u5230' }),
                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_33__components__["a" /* Flex */].Item,
                            { className: 'page_con_r ' },
                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__pages_Assembly_Breadcrumb__["a" /* default */], {
                                noLine: true,
                                list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                            }),
                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                'div',
                                { className: 'box' },
                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_45__pages_SelfHelp_common_hint__["a" /* default */], null),
                                edit ? __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a,
                                    { onSubmit: this.handleSubmit },
                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u4FE1\u606F', extra: false }),
                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                        'div',
                                        { className: 'p-sw' },
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                            'div',
                                            { style: { display: 'none' } },
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__["a" /* default */],
                                                { id: 'pkid', initialValue: data['pkid'], form: form },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_input___default.a, null)
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                            'div',
                                            { style: { marginLeft: "30px" } },
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__["a" /* default */],
                                                { id: 'blyy', required: true, initialValue: data['blyydm'], form: form, formItemLayout: { labelCol: { span: 4 }, wrapperCol: { span: 16 } }, label: '\u529E\u7406\u539F\u56E0' },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                    CheckboxGroup,
                                                    { style: { width: '100%' } },
                                                    this.state.checkGroup
                                                )
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item', style: { marginLeft: '7%' } },
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__["a" /* default */],
                                                { id: 'sqsm', initialValue: data['sqsm'], form: form, formItemLayout: formItemLayout, label: '\u7533\u8BF7\u7406\u7531' },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(TextArea, { maxLength: 50, placeholder: '\u8BF7\u586B\u5199\u7533\u8BF7\u7406\u7531' })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__["a" /* default */],
                                                { id: 'blje', required: true, initialValue: data['blje'], form: form, formItemLayout: formItemLayout, label: '\u8D37\u6B3E\u91D1\u989D' },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input_number___default.a, { style: { width: '100%' }, min: 0, max: 9999999, precision: '0', placeholder: '\u8BF7\u586B\u5199\u8D37\u6B3E\u91D1\u989D\uFF08\u5143\uFF09' })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__["a" /* default */],
                                                { id: 'dkyh', required: true, initialValue: data['dkyh'], form: form, formItemLayout: formItemLayout, label: '\u8D37\u6B3E\u94F6\u884C' },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__components_common_NHSelect__["a" /* default */], { sign: "dmk_yxwz_dkyh", onChange: function onChange(v) {} })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_46__components_common_NHFormItem__["a" /* default */],
                                                { id: 'hzjym', required: true, initialValue: data['hzjym'], form: form, formItemLayout: formItemLayout, label: '\u56DE\u6267\u6821\u9A8C\u7801' },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_input___default.a, { maxLength: 6, placeholder: '6\u4F4D\u6570\u56DE\u6267\u6821\u9A8C\u7801' })
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u6750\u6599', extra: false }),
                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                        'div',
                                        { className: 'p-sw' },
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item', style: { marginLeft: '7%' } },
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                FormItem,
                                                {
                                                    labelCol: { span: 8 },
                                                    wrapperCol: { span: 16 },
                                                    label: '\u4E0A\u4F20\u8D37\u6B3E\u53D7\u7406\u8BC1\u660E'
                                                },
                                                getFieldDecorator('fj', {
                                                    rules: [{
                                                        required: true,
                                                        message: '请上传材料证明'
                                                    }]
                                                })(__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                    Dragger,
                                                    props,
                                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                        'p',
                                                        { className: 'ant-upload-drag-icon' },
                                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, { type: 'inbox' })
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_spin___default.a, { spinning: this.state.uploading }),
                                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                        'p',
                                                        { className: 'ant-upload-text font-14' },
                                                        '\u70B9\u51FB\u6B64\u5904\u6216\u62D6\u62FD\u6587\u4EF6\u5230\u6B64'
                                                    )
                                                ))
                                            )
                                        )
                                    ),
                                    data['shzt'] === '9' ? __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                        'div',
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u5BA1\u6838', extra: false }),
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                            'div',
                                            { className: 'p-sw' },
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                'div',
                                                { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_18_antd_lib_row___default.a,
                                                    { gutter: 24 },
                                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_20_antd_lib_col___default.a,
                                                        { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                            'span',
                                                            {
                                                                style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                                            '\u5BA1\u6838\u610F\u89C1\xA0: '
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_20_antd_lib_col___default.a,
                                                        { span: 20 },
                                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                            'span',
                                                            null,
                                                            data['shyj']
                                                        )
                                                    )
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement('br', null),
                                            __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                'div',
                                                { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                                                __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_18_antd_lib_row___default.a,
                                                    { gutter: 24 },
                                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_20_antd_lib_col___default.a,
                                                        { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                            'span',
                                                            {
                                                                style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                                            '\u5BA1\u6838\u72B6\u6001\xA0: '
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_20_antd_lib_col___default.a,
                                                        { span: 20 },
                                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                                            'span',
                                                            { style: { color: '#0066FF' } },
                                                            '\u9A73\u56DE'
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    ) : "",
                                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,
                                            { type: 'primary', htmlType: 'submit' },
                                            '\u4FDD\u5B58'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__pages_SelfHelp_channelTlxy_view__["a" /* default */], { reloadMenu: this.reloadMenu, nextUrl: this.state.nextUrl, loadLstdInfo: this.loadLstdInfo, search: this.state.search, showPreview: this.showPreview, setJudge: this.setJudge, data: this.state.data, judgeImgList: this.state.judgeImgList })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a,
                        {
                            visible: previewVisible,
                            footer: null,
                            onCancel: this.handleCancel
                        },
                        __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement('img', {
                            alt: 'example',
                            style: { width: '100%' },
                            src: previewImage
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_spin___default.a, { style: { position: 'absolute', top: '300px', left: '60%' }, spinning: this.state.loading }),
                    ' '
                ) : __WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41__pages_SelfHelp_common__["a" /* default */], { hjmc: "绿色通道申请", key: "GD005_5", mkbz: 'GD005_5', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return ChannelTlxy;
}(__WEBPACK_IMPORTED_MODULE_30_react___default.a.Component)) || _class);


/***/ }),

/***/ 1025:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return View; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }








var TextArea = __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a.TextArea;

var basicUrl = "/zzbd";

var shztList = {
    '-1': '审核不通过',
    '0': '未审核',
    '1': '审核通过',
    '2': '已办理',
    '9': '驳回'
};

var View = function (_React$Component) {
    _inherits(View, _React$Component);

    function View(props) {
        _classCallCheck(this, View);

        var _this = _possibleConstructorReturn(this, (View.__proto__ || __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default()(View)).call(this, props));

        _this.getDmkMc = function (dmbz) {
            var data = _this.props.data;

            var dkyhmc = _this.state.dkyhmc;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])(basicUrl + "/getDmkMc", "GET", _defineProperty({ dmbz: dmbz }, 'dmbz', dmbz)).then(function (res) {
                if (res) {
                    if (res.data) {
                        if (dmbz === "YXWZ_DKYH") {
                            res.data.map(function (initItem) {
                                if (initItem.DM === data.dkyh) {
                                    dkyhmc = initItem.MC;
                                }
                            });
                            _this.setState({ dkyhmc: dkyhmc });
                        }
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.cancel = function (lstdid, shzt) {

            if (shzt !== '0') {
                __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warning('该申请已经审核，不能取消');
                return;
            }

            var pkid = _this.getQueryString("pkid");

            var params = {
                zzbdhjid: pkid,
                pkid: lstdid
            };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])("/lstd/deleteByParams", "POST", params).then(function (res) {
                if (res && res.data && res.data > 0) {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.success("取消成功");
                    _this.props.loadLstdInfo();
                    _this.props.reloadMenu();
                } else {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warning("取消异常");
                }
            });
        };

        _this.handlePreview = function (fjmc, fjid) {
            var isImage = true;
            if (!_this.props.setJudge(fjmc, _this.props.judgeImgList)) {
                isImage = false;
            }

            if (isImage) {
                _this.props.showPreview('anonymity/docrepo/download/file?attachmentId=' + fjid);
            } else {
                window.open('anonymity/docrepo/download/file?attachmentId=' + fjid);
            }
        };

        _this.state = {
            dkyhmc: '',
            nextUrl: _this.props.nextUrl,
            search: _this.props.search
        };
        return _this;
    }

    _createClass(View, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.getDmkMc("YXWZ_DKYH");
        }

        //获取下拉列表value对应的名称


        // 点击文件链接或预览图标时的回调

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var data = this.props.data;
            var dkyhmc = this.state.dkyhmc;

            return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u4FE1\u606F', extra: false }),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '20px' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', marginTop: "3px", paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u529E\u7406\u539F\u56E0\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                data['blyy'].map(function (elem, index) {
                                    return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                        'span',
                                        { style: {
                                                borderColor: '#1890ff',
                                                borderRadius: '5px',
                                                padding: '2px 16px',
                                                border: '1px solid rgb(24, 144, 255)',
                                                marginRight: '15px',
                                                display: 'inline-block'
                                            } },
                                        elem
                                    );
                                })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u7533\u8BF7\u7406\u7531\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['sqsm']
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u8D37\u6B3E\u91D1\u989D\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['blje'],
                                    '\u5143'
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u8D37\u6B3E\u94F6\u884C\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    dkyhmc
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '6\u4F4D\u6570\u56DE\u6267\u6821\u9A8C\u7801\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['hzjym']
                                )
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u6750\u6599', extra: false }),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u6750\u6599\u8BC1\u660E\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                data['fj'].map(function (elem, index) {
                                    return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                        'div',
                                        { style: { marginBottom: '20px' } },
                                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                            'a',
                                            { onClick: function onClick() {
                                                    _this2.handlePreview(elem['fjmc'], elem['fjid']);
                                                } },
                                            elem['fjmc']
                                        )
                                    );
                                })
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u5BA1\u6838', extra: false }),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u5BA1\u6838\u610F\u89C1\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['shyj']
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u5BA1\u6838\u72B6\u6001\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    { style: { color: '#0066FF' } },
                                    shztList[data['shzt']]
                                )
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'text-center mt-50' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                        { type: 'primary', onClick: function onClick() {
                                _this2.cancel(data['pkid'], data['shzt']);
                            } },
                        '\u53D6\u6D88'
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                )
            );
        }
    }]);

    return View;
}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);



/***/ }),

/***/ 1026:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SzjdChannel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_number__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_axios__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_SelfHelp_channelZtxy_view__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_SelfHelp_common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_common_NHFormItem__ = __webpack_require__(43);


















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }


















var history = __WEBPACK_IMPORTED_MODULE_27_history_createHashHistory___default()();
var TextArea = __WEBPACK_IMPORTED_MODULE_16_antd_lib_input___default.a.TextArea;

var formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 }
};

//请求默认路径
var pathUrl = "api/zhxg-yxxt";
var SzjdChannel = (_dec = __WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(SzjdChannel, _React$Component);

    function SzjdChannel(props) {
        _classCallCheck(this, SzjdChannel);

        var _this = _possibleConstructorReturn(this, (SzjdChannel.__proto__ || __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default()(SzjdChannel)).call(this, props));

        _this.queryQztjAndYlhj = function (callback) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }if (callback) {
                        callback(_this.state.operable);
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_30__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.loadLstdInfo = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHCore__["b" /* getLoginUser */])().userId;
            var params = {
                xsid: xsid
            };
            if (xsid) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHFetch__["a" /* default */])(pathUrl + '/ztxy/swbl/lstd/getLstdData', 'GET', params).then(function (resData) {
                    if (resData && resData.data) {
                        _this.setState({ data: resData.data });
                    } else {
                        _this.setState({ data: {} });
                        _this.props.form.resetFields();
                    }
                });
            }
        };

        _this.handleSubmit = function (e) {
            var xsids = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHCore__["b" /* getLoginUser */])().userId;
            _this.setState({ loading: true });
            e.preventDefault();
            var zzbdhjid = _this.getQueryString('pkid');
            _this.props.form.validateFieldsAndScroll(function (err, values) {
                if (err) {
                    _this.setState({ loading: false });
                    return false;
                }
                var sqsm = values['sqsm'];
                var pkid = values['pkid'];
                var hjje = values['hjje'];
                var xfhj = values['xfhj'];
                var zsfhj = values['zsfhj'];
                var hjqx = values['hjqx'];
                var params = {
                    hjje: hjje,
                    xfhj: xfhj,
                    zsfhj: zsfhj,
                    hjqx: hjqx,
                    sqsm: sqsm,
                    xsid: xsids,
                    zzbdhjid: zzbdhjid,
                    pkid: pkid
                };
                if (!pkid) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHFetch__["a" /* default */])(pathUrl + '/yxwz/zzbd/lstdfd/insert', "POST", params).then(function (res) {
                        if (res && res.code == 200) {
                            __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.success("绿色通道申请保存成功。");
                            _this.loadLstdInfo();
                            _this.reloadMenu();
                        }
                        _this.setState({ loading: false });
                    }).catch(function (res) {
                        _this.setState({ loading: false });
                        return res;
                    });
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD005_4',
            hjmc: '',
            loading: false,
            fileList: [],
            data: {}, //绿色通道申请信息
            nextUrl: '',
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            sqlyFlag: false //申请理由flag

        };
        return _this;
    }

    _createClass(SzjdChannel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.queryQztjAndYlhj(function (operable) {
                if (operable) {
                    _this2.loadLstdInfo();
                    // this.updateZzbdBlzt();
                }
            });
        }

        //迎新现场已办理时迎新网站自动办理
        // updateZzbdBlzt = () =>{
        //         let zzbdhjid = this.getQueryString('pkid');
        //         NHFetch('/zzbd/updateZzbdBlzt', 'GET',{zzbdhjid:zzbdhjid,hjdm:'GD005_4'}).then(res => {
        //             if(res.data){
        //                 this.reloadMenu();
        //             }
        //         })
        // }

        //查询前置条件和依赖环节


        //读取学生的绿色通道信息


        // 提交


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var form = this.props.form;

            var edit = false;
            var data = this.state.data;
            if (__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_json_stringify___default()(data) == "{}") {
                edit = true;
            }
            return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                'div',
                { style: { position: 'relative' } },
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_20__components__["a" /* Flex */],
                        { className: 'w1180 mt-20', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pages_Assembly_siderMenu__["a" /* default */], {
                            ref: "siderMenu",
                            setMenuList: this.setMenuList,
                            title: '\u81EA\u52A9\u62A5\u5230',
                            mkbz: this.state.mkbz
                            /*     active={4}*/
                            , menuType: '\u81EA\u52A9\u62A5\u5230' }),
                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_20__components__["a" /* Flex */].Item,
                            { className: 'page_con_r ' },
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__pages_Assembly_Breadcrumb__["a" /* default */], {
                                noLine: true,
                                list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                            }),
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                'div',
                                { className: 'box' },
                                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__pages_SelfHelp_common_hint__["a" /* default */], null),
                                edit ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a,
                                    { onSubmit: this.handleSubmit },
                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u4FE1\u606F', extra: false }),
                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                        'div',
                                        { className: 'p-sw' },
                                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { style: { display: 'none' } },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_32__components_common_NHFormItem__["a" /* default */],
                                                { id: 'pkid', initialValue: data['pkid'], form: form },
                                                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_input___default.a, null)
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item', style: { marginLeft: '7%', width: '80%' } },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_32__components_common_NHFormItem__["a" /* default */],
                                                { id: 'xfhj', required: true, initialValue: data['xfhj'], form: form, formItemLayout: formItemLayout, label: '\u7F13\u7F34\u5B66\u8D39' },
                                                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_number___default.a, { style: { width: '50%' }, min: 0, max: 9999999, precision: '0', placeholder: '\u8BF7\u586B\u5199\u7F13\u7F34\u5B66\u8D39\uFF08\u5143\uFF09' })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_32__components_common_NHFormItem__["a" /* default */],
                                                { id: 'zsfhj', required: true, initialValue: data['zsfhj'], form: form, formItemLayout: formItemLayout, label: '\u7F13\u7F34\u4F4F\u5BBF\u8D39' },
                                                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_number___default.a, { style: { width: '50%' }, min: 0, max: 9999999, precision: '0', placeholder: '\u8BF7\u586B\u5199\u7F13\u7F34\u4F4F\u5BBF\u8D39\uFF08\u5143\uFF09' })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_32__components_common_NHFormItem__["a" /* default */],
                                                { id: 'hjje', required: true, initialValue: data['hjje'], form: form, formItemLayout: formItemLayout, label: '\u7F13\u7F34\u603B\u91D1\u989D' },
                                                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_number___default.a, { style: { width: '50%' }, min: 0, max: 9999999, precision: '0', placeholder: '\u8BF7\u586B\u5199\u7F13\u7F34\u603B\u91D1\u989D\uFF08\u5143\uFF09' })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_32__components_common_NHFormItem__["a" /* default */],
                                                { id: 'hjqx', required: true, initialValue: data['hjqx'], form: form, formItemLayout: formItemLayout, label: '\u7F13\u7F34\u671F\u9650' },
                                                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_number___default.a, { style: { width: '50%' }, min: 0, max: 9999999, precision: '0', placeholder: '\u8BF7\u586B\u5199\u7F13\u7F34\u671F\u9650\uFF08\u6708\uFF09' })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_32__components_common_NHFormItem__["a" /* default */],
                                                { id: 'sqsm', initialValue: data['sqsm'], form: form, required: true, formItemLayout: formItemLayout, label: '\u5BB6\u5EAD\u7ECF\u6D4E\u56F0\u96BE\u4E3B\u8981\u60C5\u51B5\u8BF4\u660E' },
                                                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(TextArea, { style: { width: '50%' }, maxLength: 500, placeholder: '\u8BF7\u586B\u5199\u5BB6\u5EAD\u7ECF\u6D4E\u56F0\u96BE\u4E3B\u8981\u60C5\u51B5\u8BF4\u660E' })
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default.a,
                                            { type: 'primary', htmlType: 'submit', onClick: this.handleSubmit },
                                            '\u4FDD\u5B58'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__pages_SelfHelp_channelZtxy_view__["a" /* default */], { reloadMenu: this.reloadMenu, nextUrl: this.state.nextUrl, loadLstdInfo: this.loadLstdInfo, search: this.state.search, data: this.state.data })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_spin___default.a, { style: { position: 'absolute', top: '300px', left: '60%' }, spinning: this.state.loading }),
                    ' '
                ) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__pages_SelfHelp_common__["a" /* default */], { hjmc: "绿色通道(昭通学院)", key: "GD005_4", mkbz: 'GD005_4', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return SzjdChannel;
}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component)) || _class);


/***/ }),

/***/ 1027:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return View; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }








var TextArea = __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a.TextArea;
//请求默认路径

var pathUrl = "api/zhxg-yxxt";

var shztList = {
    '0': '未审核',
    '1': '审核通过',
    '2': '审核不通过',
    '3': '驳回'
};

var View = function (_React$Component) {
    _inherits(View, _React$Component);

    function View(props) {
        _classCallCheck(this, View);

        var _this = _possibleConstructorReturn(this, (View.__proto__ || __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default()(View)).call(this, props));

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.cancel = function (lstdid, shzt) {

            if (shzt == '1' || shzt == '2') {
                __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warning('该申请已经审核，不能取消');
                return;
            }

            var pkid = _this.getQueryString("pkid");

            var params = {
                zzbdhjid: pkid,
                pkid: lstdid,
                shzt: shzt
            };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])(pathUrl + "/yxwz/zzbd/lstdfd/deleteByParams", "POST", params).then(function (res) {
                if (res && res.data && res.data > 0) {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.success("取消成功");
                    _this.props.loadLstdInfo();
                    _this.props.reloadMenu();
                } else {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warning("取消异常");
                }
            });
        };

        _this.state = {
            nextUrl: _this.props.nextUrl,
            search: _this.props.search
        };
        return _this;
    }

    _createClass(View, [{
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var data = this.props.data;
            var _state = this.state,
                dkyhmc = _state.dkyhmc,
                dkfsValue = _state.dkfsValue;

            return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u4FE1\u606F', extra: false }),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u7F13\u7F34\u5B66\u8D39\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['xfhj'],
                                    '\u5143'
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u7F13\u7F34\u4F4F\u5BBF\u8D39\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['zsfhj'],
                                    '\u5143'
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u7F13\u7F34\u603B\u91D1\u989D\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['hjje'],
                                    '\u5143'
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u7F13\u7F34\u671F\u9650\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['hjqx'],
                                    '\u6708'
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u5BB6\u5EAD\u7ECF\u6D4E\u56F0\u96BE\u4E3B\u8981\u60C5\u51B5\u8BF4\u660E\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['sqsm']
                                )
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u5BA1\u6838', extra: false }),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u5BA1\u6838\u65F6\u95F4\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['shsj'] ? data['shsj'] : '未审核'
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u5BA1\u6838\u610F\u89C1\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['shyj'] ? data['shyj'] : '未审核'
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u5BA1\u6838\u72B6\u6001\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    { style: { color: '#0066FF' } },
                                    shztList[data['shzt']]
                                )
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'text-center mt-50' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                        { type: 'primary', onClick: function onClick() {
                                _this2.cancel(data['pkid'], data['shzt']);
                            } },
                        '\u53D6\u6D88'
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                )
            );
        }
    }]);

    return View;
}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);



/***/ }),

/***/ 1028:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dorm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_result_style__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_result_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_result_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_result__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_result___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_result__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_radio_style__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_radio__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_checkbox_style__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_checkbox__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__index_css__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_getSize__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_common_NHModal__ = __webpack_require__(106);



















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }








// import SelectBox from './selectBox';
// import SelectModal from './selectModal';











if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_28_history_createHashHistory___default()();
var confirm = __WEBPACK_IMPORTED_MODULE_17_antd_lib_modal___default.a.confirm;
var CheckboxGroup = __WEBPACK_IMPORTED_MODULE_15_antd_lib_checkbox___default.a.Group;
var RadioGroup = __WEBPACK_IMPORTED_MODULE_13_antd_lib_radio___default.a.Group;

/**
 * @author weishihuai
 * @date 2018/7/6
 * @time 14:41
 * @Description: 迎新网站-自助报到-宿舍分配
 */

var Dorm = function (_React$Component) {
    _inherits(Dorm, _React$Component);

    function Dorm(props) {
        _classCallCheck(this, Dorm);

        var _this2 = _possibleConstructorReturn(this, (Dorm.__proto__ || __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default()(Dorm)).call(this, props));

        _this2.getCssz = function () {
            var params = { csbz: "YXXT_SSXX_SFXSCWH" };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])('/zzbdCommon/getCssz', 'GET', params).then(function (res) {
                if (res && res.data) {
                    _this2.setState({
                        cwhFlag: res.data == 'true' ? true : false
                    });
                }
            });
        };

        _this2.getSsinfo = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (xsid) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])('/newStudent/queryStuInfo', 'GET', { 'xsid': xsid }).then(function (res) {
                    if (res && res.data) {
                        var stuInfo = res.data.stuInfo.userBaseInfo;
                        var stuXxcj = res.data.stuXxcj;
                        var stuSsxx = res.data.stuSsxx;
                        _this2.setState({
                            stuInfo: stuInfo,
                            stuXxcj: stuXxcj,
                            stuSsxx: stuSsxx
                        });
                    }
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.error("登录超时,请重新登录！");
            }
        };

        _this2.updateZzbdBlzt = function () {
            var zzbdhjid = _this2.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])('/zzbd/updateZzbdBlzt', 'GET', { zzbdhjid: zzbdhjid, hjdm: 'GD006_2' }).then(function (res) {
                if (res.data) {
                    _this2.reloadMenu();
                }
            });
        };

        _this2.queryQztjAndYlhj = function (callback) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this2.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this2.getUrlParams('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this2.setState({ nonOperationalData: res.data });
                    if (kfsj && kfsj['YXSJ'] != '1') {
                        _this2.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this2.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this2.setState({ operable: false });
                    }

                    if (callback) {
                        callback(_this2.state.operable);
                    }
                }
            });
        };

        _this2.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this2.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this2.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_32__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this2.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this2.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this2.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this2.getUrlParams = function (param) {
            return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this2.getFjxxList = function (param) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])("/gyxtUnauth/cwfp/getYxwzSsfpFjxxList", 'GET', param).then(function (res) {
                if (res) {
                    _this2.setState({
                        fjxxList: res.data
                    });
                }
            });
        };

        _this2.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this2.checkZzbdisLinked = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this2.getUrlParams("pkid");
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])("/zzbdCommon/checkIsZzbdHjLinked", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res) {
                    if (res.data) {
                        _this2.setState({
                            isHjLinked: res.data
                        });
                    } else {
                        _this2.setState({
                            isHjLinked: false
                        });
                    }
                } else {
                    _this2.setState({
                        isHjLinked: false
                    });
                }
            });
        };

        _this2.reloadMenu = function () {
            _this2.refs.siderMenu.reloadMenuList();
        };

        _this2.state = {
            mkbz: 'GD006_2',
            hjmc: '',
            xzId: '',
            _xzId: '',
            cwsList: [], //床位数
            sfbzList: [], //收费标准
            xqList: [], //校区信息
            currentXqid: "", //当前校区ID
            fjxxList: [], //房间信息
            currentClickCwPkid: "", //当前床位信息ID
            xsssruYwxx: {}, //学生宿舍入住业务信息
            isHjLinked: false, //环节是否办理状态
            param: {}, //过滤条件
            scrollHeight: 200, //默认滚动高度
            loginUserInfo: {}, //当前登录学生信息
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            autoBlLoading: false, //自动办理按钮载入状态
            cancelLoading: false, //取消办理按钮载入状态
            zdrzLoading: false, //自动入住载入状态
            setRoom: [], //过滤房间信息
            sfbz: "", //收费标准选中值
            stuInfo: {},
            stuXxcj: {},
            stuSsxx: {},
            cwhFlag: true
        };
        return _this2;
    }

    _createClass(Dorm, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var that = this;
            this.setState({ scrollHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_getSize__["a" /* default */])().windowH - 206 });
            window.onresize = function () {
                that.setState({
                    scrollHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_getSize__["a" /* default */])().windowH - 206
                });
            };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            this.getSsinfo();
            this.queryQztjAndYlhj(function (operable) {
                if (operable) {
                    var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__utils_NHCore__["b" /* getLoginUser */])().userId : '';
                    if (xsid) {
                        var _this = _this3;
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__utils_NHCore__["d" /* getLoginUserInfo */])(xsid, function (data) {
                            _this.setState({
                                loginUserInfo: data
                            }, function () {
                                var loginUserInfo = _this.state.loginUserInfo;

                                var xqid = loginUserInfo.XQID,
                                    xbm = loginUserInfo.XBM;

                                if (xsid) {
                                    //办理状态根据 关联现场环节和是否反向关联修改 不根据现场状态
                                    //_this.updateZzbdBlzt();
                                    //加载收费标准、床位数信息
                                    //如果学生校区ID不为空,则只加载本校区宿舍信息
                                    if (xqid) {
                                        _this.setState({
                                            currentXqid: xqid
                                        });
                                        _this.getFjxxList({
                                            cws: "",
                                            sfbz: "",
                                            xsid: xsid,
                                            xqid: xqid,
                                            xbm: xbm
                                        });
                                    }
                                }
                                _this.checkZzbdisLinked();
                            });
                        });
                    }
                }
            });
            this.getCssz();
        }

        //迎新现场已办理时迎新网站自动办理


        //查询前置条件和依赖环节


        //获取url中传递的参数


        //获取宿舍房间信息

        //检查环节是否已办理


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                stuInfo = _state.stuInfo,
                stuXxcj = _state.stuXxcj,
                stuSsxx = _state.stuSsxx,
                cwhFlag = _state.cwhFlag;

            return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_21__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230',
                        mkbz: this.state.mkbz
                        /*   active={5}*/
                        , menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_21__components__["a" /* Flex */].Item,
                        { className: 'page_con_r ' },
                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1037811784' + ' ' + 'box'
                            },
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__pages_Assembly_titleTop__["a" /* default */], {
                                className: 'mt-20',
                                title: this.state.hjmc,
                                extra: false
                            }),
                            stuSsxx ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                'div',
                                { style: { marginTop: "10px" }, className: 'jsx-1037811784'
                                },
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                        {
                                            style: { textAlign: "center", padding: "10px" },
                                            span: 8
                                        },
                                        '\u59D3\u540D\uFF1A',
                                        stuInfo ? stuInfo.XM : ""
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                        {
                                            style: { textAlign: "center", padding: "10px" },
                                            span: 8
                                        },
                                        '\u6821\u533A\u540D\u79F0\uFF1A',
                                        stuSsxx ? stuSsxx.xqmc : ""
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                        {
                                            style: { textAlign: "center", padding: "10px" },
                                            span: 8
                                        },
                                        '\u697C\u680B\uFF1A',
                                        stuSsxx ? stuSsxx.ldmc : ""
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                        {
                                            style: { textAlign: "center", padding: "10px" },
                                            span: 8
                                        },
                                        '\u697C\u5C42\uFF1A',
                                        stuSsxx ? stuSsxx.lcmc : ""
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                        {
                                            style: { textAlign: "center", padding: "10px" },
                                            span: 8
                                        },
                                        '\u623F\u95F4\u53F7\uFF1A',
                                        stuSsxx ? stuSsxx.fj : ""
                                    ),
                                    cwhFlag ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                        {
                                            style: { textAlign: "center", padding: "10px" },
                                            span: 8
                                        },
                                        '\u5E8A\u4F4D\u53F7\uFF1A',
                                        stuSsxx ? stuSsxx.cwh : ""
                                    ) : null
                                )
                            ) : __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1037811784'
                                },
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_result___default.a, {
                                    title: '\u6682\u65E0\u5BBF\u820D\u4FE1\u606F'
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1037811784' + ' ' + 'text-center mt-50'
                                },
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                            ),
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_styled_jsx_style___default.a, {
                                styleId: '1037811784',
                                css: ['.ant-result-title{font-size:20px!important;}']
                            })
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__common__["a" /* default */], { hjmc: "宿舍信息查看", key: 'GD006_2', mkbz: 'GD006_2', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return Dorm;
}(__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component);



/***/ }),

/***/ 1029:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChoosePhoneNum; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_tag_style__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_tag_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_tag_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_tag__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_radio_style__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_radio__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_select__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_common_NHModal__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_index__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__index_css__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_common_NHRadioGroup__ = __webpack_require__(537);
















var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }





















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_26_history_createHashHistory___default()();
var basicUrl = "/zzbd";
var commonUrl = '/zzbdCommon';
var FormItem = __WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item;
var Option = __WEBPACK_IMPORTED_MODULE_12_antd_lib_select___default.a.Option;
var formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 }
};

var ChoosePhoneNum = (_dec = __WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(ChoosePhoneNum, _React$Component);

    function ChoosePhoneNum(props) {
        _classCallCheck(this, ChoosePhoneNum);

        var _this = _possibleConstructorReturn(this, (ChoosePhoneNum.__proto__ || __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of___default()(ChoosePhoneNum)).call(this, props));

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] !== '1') {
                        _this.setState({ operable: false });
                    }
                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.checkIsZzbdHjLinked = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this.getQueryString('pkid');

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])("/zzbdCommon/checkIsZzbdHjLinked", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res) {
                    if (res.data) {
                        _this.setState({
                            editable: false
                        });
                    } else {
                        _this.setState({
                            editable: true
                        });
                    }
                } else {
                    _this.setState({
                        editable: true
                    });
                }
            });
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_30__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.getUrlParams = function (param) {
            return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.getSfglxyw = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/zzbdCommon/getCssz', 'GET', { csbz: 'YXXT_ZXSJH_SFXYGLXYW' }).then(function (res) {
                if (res && res.data) {
                    // 返回 "true", "false", null
                    _this.setState({ sfglxyw: res.data == 'true' });
                } else {
                    _this.setState({ sfglxyw: false });
                }
            });
        };

        _this.onChangeZx = function (value) {
            if (value === "1") {
                // 0否 1是
                _this.setState({
                    isChoosePhoneNum: true,
                    page: 1
                });
                _this.getPhoneNumList("0", 1, _this.state.pageSize);
                _this.props.form.setFieldsValue({ sjh: undefined, yys: undefined });
            } else {
                _this.setState({
                    isChoosePhoneNum: false,
                    page: 1
                });
            }
        };

        _this.onChangeYys = function (yys) {
            _this.setState({ page: 1, disablebtnClick: false });
            if (yys !== null || yys !== undefined || yys.trim().length > 0) {
                _this.getPhoneNumList(yys, 1, _this.state.pageSize); //改变了运营商需要从第一页开始
            }
            _this.props.form.setFieldsValue({ sjh: undefined }); //切换运营商后将之前选择的手机号选项清空
        };

        _this.onChangeNumList = function () {
            var page = _this.state.page;

            _this.setState({ loading: true });
            if (!_this.state.disabledTime == 0) {
                _this.count(); // 4s倒计时
            }
            var yys = _this.props.form.getFieldValue("yys");
            if (yys !== null || yys !== undefined || yys.trim().length > 0) {
                _this.getPhoneNumList(yys, page + 1, _this.state.pageSize); //改变了运营商需要从第一页开始
                _this.setState({
                    page: page + 1
                });
            }
            //this.getPhoneNumList(yys, page + 1, this.state.pageSize);
        };

        _this.backToFirstPage = function () {
            _this.setState({ page: 1, disablebtnClick: false });
            var yys = _this.props.form.getFieldValue("yys");
            _this.getPhoneNumList(yys, 1, _this.state.pageSize);
        };

        _this.getPhoneNumList = function (yys, page, pageSize) {
            var params = {
                yys: yys ? yys : "0",
                page: page,
                pageSize: pageSize
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])(basicUrl + "/getPhoneNumListByYys", "GET", params).then(function (res) {
                if (res) {
                    if (res.data) {
                        if (res.data.length !== _this.state.pageSize) {
                            _this.setState({
                                disablebtnClick: true // 最后一页了，[下一批]按钮不能再按了
                            });
                        }
                        var option = [];
                        option = res.data.map(function (option) {
                            return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_9_antd_lib_radio___default.a,
                                { key: option, value: option },
                                option
                            );
                        });
                        _this.setState({ phoneNumList: option });
                    }
                }
            });
        };

        _this.getPhoneNumById = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])(basicUrl + "/getPhoneNumById", "GET", { xsid: xsid }).then(function (res) {
                if (res) {
                    if (res.data) {
                        var data = res.data;
                        _this.setState({
                            yysmc: data.YYSMC,
                            sjh: data.SJH,
                            isChoosePhoneNum: data.SFZX == "1",
                            sfktxyw: data.SFKTXYW == "1",
                            editable: false
                        });
                    } else {
                        _this.setState({
                            editable: true
                        });
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_24_antd_lib_index__["message"].error('获取数据失败，请重试！');
                }
            });
        };

        _this.count = function () {
            var disabledTime = _this.state.disabledTime;

            var siv = setInterval(function () {
                _this.setState({ disabledTime: disabledTime-- }, function () {
                    if (disabledTime <= -1) {
                        clearInterval(siv); //倒计时setInterval函数会每秒执行一次函数，用clearInterval来停止执行
                        _this.setState({ loading: false, disabledTime: 3 });
                    }
                });
            }, 1000);
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.props.form.validateFieldsAndScroll(function (err, values) {
                if (err) {
                    return;
                }
                var str = _this.state.sfglxyw ? "您选择" + (_this.state.sfktxyw ? "" : "不") + "开通校园网，" : "您";
                var formData = {};
                if (_this.state.sfglxyw && !values['sfktxyw']) {
                    __WEBPACK_IMPORTED_MODULE_24_antd_lib_index__["message"].error("请选择是否开通校园网！");
                    return;
                }
                formData.sfktxyw = values['sfktxyw'] ? values['sfktxyw'] : "0";
                if (values['sfzx'] == '1') {
                    if (values['yys'] == null || typeof values['yys'] == "undefined" || values['yys'].trim().length === 0) {
                        __WEBPACK_IMPORTED_MODULE_24_antd_lib_index__["message"].error('请选择运营商！');
                        return;
                    }
                    if (values['sjh'] == null || typeof values['sjh'] == "undefined" || values['sjh'].trim().length === 0) {
                        __WEBPACK_IMPORTED_MODULE_24_antd_lib_index__["message"].error('请选择手机号码！');
                        return;
                    }
                    str = str + "选择的号码是：" + values['sjh'] + "（" + (values['yys'] == '0' ? "中国移动" : values['yys'] == '1' ? "中国联通" : "中国电信") + "），";
                    formData.sfzx = "1";
                    formData.yys = values['yys'];
                    formData.sjh = values['sjh'];
                } else {
                    formData.sfzx = "0";
                    formData.yys = "";
                    formData.sjh = "";
                    str = str + "确定不办理自选手机号吗，";
                }
                str = str + "提交后不能再进行操作！确定提交？";
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__components_common_NHModal__["b" /* NHConfirm */])(str, function () {
                    var _this$state = _this.state,
                        isChoosePhoneNum = _this$state.isChoosePhoneNum,
                        editable = _this$state.editable;

                    var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId;
                    var zzbdhjid = _this.getUrlParams("pkid");
                    var params = {
                        xsid: xsid,
                        zzbdhjid: zzbdhjid,
                        formData: formData
                    };
                    //请求提交保存
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])(basicUrl + "/savePhoneNumById", 'POST', params).then(function (res) {
                        if (res) {
                            if (res.data == '1') {
                                __WEBPACK_IMPORTED_MODULE_24_antd_lib_index__["message"].success("保存成功！");
                                if (editable) {
                                    _this.setState({ editable: false }); //一经提交则不可再修改
                                }
                                _this.getPhoneNumById();
                                _this.reloadMenu();
                            } else {
                                __WEBPACK_IMPORTED_MODULE_24_antd_lib_index__["message"].error("保存失败，请重试！");
                            }
                        }
                    });
                }, "warn");
            });
        };

        _this.state = {
            mkbz: 'GD027_1',
            hjmc: '',
            nextUrl: '', // 左侧菜单加载完后传进来
            search: '',
            operable: true, // 是否显示环节
            nonOperationalData: {}, // 不可操作的数据
            disabledTime: 3, // 4s内禁止再次点击下一批按钮
            disablebtnClick: false, // [下一批]按钮是否禁用
            loading: false,
            isChoosePhoneNum: false, // 是否自选手机号码
            phoneNumList: [], // 手机号码列表
            page: 1, // 默认展示第一页手机号码
            pageSize: 50, // 一页最多展示50个手机号码
            yysmc: '', // 已选的运营商名称
            sjh: '', // 已选的手机号码
            sfglxyw: false, // 是否关联校园网（默认不关联，益阳医专是true，根据系统管理的参数值进行切换）
            sfktxyw: false, // 是否开通校园网（当sfglxyw为true是才有用）
            editable: true // 是否可以自选编辑
        };
        return _this;
    }

    _createClass(ChoosePhoneNum, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.checkIsZzbdHjLinked();
            this.queryQztjAndYlhj();
            this.getPhoneNumById(); // 查询学生是否已经办理了，办理了就回填数据
            this.getSfglxyw(); // 查询是否关联校园网
        }

        // 查询前置条件和依赖环节


        // 环节pkid


        // 检查该环节是否已经办理


        // 设置左侧菜单


        // 获取url中传递的参数


        // 重新加载菜单


        // 获取参数设置：自选手机号码是否关联了校园网（关联则 增加是否开通校园网下拉框选项，不关联则没有该选项）


        // 是否自选手机号码


        // 改变运营商下拉框


        // 点击换一批手机号码


        // 手机号码列表回到第一页


        // 根据运营商获取手机号列表（默认为0中国移动）


        // 查询某学生自选的手机号码


        //倒计时4s


        // 提交保存

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props$form = this.props.form,
                getFieldDecorator = _props$form.getFieldDecorator,
                getFieldValue = _props$form.getFieldValue,
                setFieldsValue = _props$form.setFieldsValue;
            var _state = this.state,
                editable = _state.editable,
                isChoosePhoneNum = _state.isChoosePhoneNum,
                phoneNumList = _state.phoneNumList,
                sjh = _state.sjh,
                yysmc = _state.yysmc,
                disablebtnClick = _state.disablebtnClick,
                sfglxyw = _state.sfglxyw,
                sfktxyw = _state.sfktxyw;

            return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                'div',
                { className: 'app__css__app-pages-SelfHelp-choosePhoneNum-__index__page_buy' },
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230',
                        mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjmc, extra: false }),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a,
                                { onSubmit: this.handleSubmit },
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    'div',
                                    { className: 'p-sw' },
                                    sfglxyw ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */],
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: "是否开通校园网" }),
                                                getFieldDecorator('sfktxyw', {
                                                    initialValue: sfktxyw ? "1" : "0",
                                                    placeholder: '请选择',
                                                    rules: [{
                                                        required: true,
                                                        message: "请选择是否开通校园网"
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_12_antd_lib_select___default.a,
                                                    { placeholder: '\u8BF7\u9009\u62E9', onChange: function onChange(value) {
                                                            if (value === "1") {
                                                                // 0否 1是
                                                                _this2.setState({ sfktxyw: true });
                                                            } else {
                                                                _this2.setState({ sfktxyw: false });
                                                            }
                                                        } },
                                                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                        Option,
                                                        { value: '0' },
                                                        '\u5426'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                        Option,
                                                        { value: '1' },
                                                        '\u662F'
                                                    )
                                                ) : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    sfktxyw ? '是' : '否'
                                                ))
                                            )
                                        )
                                    ) : null,
                                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */],
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: "是否自选手机号" }),
                                                getFieldDecorator('sfzx', {
                                                    initialValue: isChoosePhoneNum ? "1" : "0",
                                                    placeholder: '请选择',
                                                    rules: [{
                                                        required: true,
                                                        message: "请选择是否自选手机号"
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_12_antd_lib_select___default.a,
                                                    { placeholder: '\u8BF7\u9009\u62E9', onChange: this.onChangeZx },
                                                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                        Option,
                                                        { value: '0' },
                                                        '\u5426'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                        Option,
                                                        { value: '1' },
                                                        '\u662F'
                                                    )
                                                ) : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    isChoosePhoneNum ? '是' : '否'
                                                ))
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */],
                                        null,
                                        isChoosePhoneNum && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, { label: '\u8FD0\u8425\u5546' }),
                                                getFieldDecorator('yys', {
                                                    placeholder: '请选择',
                                                    //initialValue: "0",
                                                    rules: [{ required: true, message: '请选择运营商' }]
                                                })(editable ?
                                                // <NHSelect sign={"zhxg_yxwz_txyys"} onChange={(v) => {
                                                //     this.onChangeYys(v);
                                                // }}/>
                                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__components_common_NHRadioGroup__["a" /* default */], { sign: "DMK_YXXT_TXYYS", onChange: function onChange(v) {
                                                        _this2.onChangeYys(v);
                                                    } }) : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    yysmc
                                                ))
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */],
                                        null,
                                        (isChoosePhoneNum && getFieldValue('yys') || isChoosePhoneNum && !editable) && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u624B\u673A\u53F7\u7801'
                                                }),
                                                getFieldDecorator('sjh', {
                                                    initialValue: sjh,
                                                    rules: [{ required: true, message: '请选择手机号码' }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_9_antd_lib_radio___default.a.Group,
                                                    null,
                                                    phoneNumList
                                                ) : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    sjh
                                                ))
                                            ),
                                            getFieldValue('yys') && editable ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                'div',
                                                { className: 'text-center mt-30' },
                                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,
                                                    { type: 'ghost', loading: this.state.loading,
                                                        onClick: this.onChangeNumList,
                                                        disabled: disablebtnClick },
                                                    this.state.loading ? this.state.disabledTime + '秒' : '下一批'
                                                ),
                                                disablebtnClick && this.state.page !== 1 ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,
                                                    { type: 'ghost', style: { marginLeft: "15px" },
                                                        onClick: this.backToFirstPage },
                                                    '\u56DE\u5230\u7B2C\u4E00\u9875'
                                                ) : undefined
                                            ) : undefined,
                                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                'div',
                                                { className: 'text-center mt-30' },
                                                editable ? getFieldValue('yys') == "0" ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_tag___default.a,
                                                    { color: 'cyan', style: { marginRight: "12px" } },
                                                    '\u4E2D\u56FD\u79FB\u52A8'
                                                ) : getFieldValue('yys') == "1" ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_tag___default.a,
                                                    { color: 'magenta',
                                                        style: { marginRight: "12px" } },
                                                    '\u4E2D\u56FD\u8054\u901A'
                                                ) : getFieldValue('yys') == "2" ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_tag___default.a,
                                                    { color: 'geekblue',
                                                        style: { marginRight: "12px" } },
                                                    '\u4E2D\u56FD\u7535\u4FE1'
                                                ) : undefined : undefined,
                                                editable ? getFieldValue('sjh') !== "" && getFieldValue('sjh') !== undefined ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_tag___default.a,
                                                    { color: 'purple',
                                                        style: { marginLeft: "5px" } },
                                                    getFieldValue('sjh')
                                                ) : undefined : undefined
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,
                                            { type: 'primary', htmlType: 'submit', disabled: !editable },
                                            '\u4FDD\u5B58'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                )
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__common__["a" /* default */], { hjmc: "自选手机号码", key: "GD027_1", mkbz: 'GD027_1',
                    nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return ChoosePhoneNum;
}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component)) || _class);


/***/ }),

/***/ 1030:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getQztjAndYlhjInfoByHjId */
/* unused harmony export getZzbdhjid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getQztjAndYlhjInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_globalUtil__ = __webpack_require__(225);






/**
 * @author qianzhiwei
 * @date 2020/09/27
 * @description 根据学生ID以及环节ID查询前置环节以及依赖环节信息
 * @param {学生id} xsid 
 * @param {自助报到环节id} hjid 
 * @param {回掉函数} callback 
 */
var getQztjAndYlhjInfoByHjId = function getQztjAndYlhjInfoByHjId(xsid, hjid, callback) {
  if (!xsid || !hjid) {
    return;
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: hjid }).then(function (response) {
    if (response) {
      if (callback) {
        callback(response.data);
      }
    }
  }).catch(function () {
    __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.error("服务器异常，请稍后重试！");
  });
};

/**
 * @author qianzhiwei
 * @date 2020/09/27
 * @description 获取环节ID
 */
var getZzbdhjid = function getZzbdhjid() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_globalUtil__["b" /* getQueryString */])('pkid');
};

var getQztjAndYlhjInfo = function getQztjAndYlhjInfo(xsid, callback) {
  var hjid = getZzbdhjid();
  getQztjAndYlhjInfoByHjId();
};

/***/ }),

/***/ 1031:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox_style__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio_style__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_radio__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker_style__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_date_picker__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_common_NHCascader__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__index_css__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_common_NHModal__ = __webpack_require__(106);





















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }













if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var uploadUrl = "api/zhxg-yxwz/newStudent/cacheStudentPhoto"; //上传logo路径 
var zpTip = "<p style=\"white-space: normal;text-align:center;color:#000;font-size:16px;\">—照片要求—</p><br/><p style=\"white-space: normal;\">1.本人清晰、免冠、正面彩色头像；要求面部五官无遮挡，人头部约占照片高度的三分之二；</p><br/><p style=\"white-space: normal;\">2.常戴眼镜的人员允许佩戴眼镜，要求不能为宽边框，拍照时注意镜片不要反光;</p><br/><p style=\"white-space: normal;\">3.照片背景颜色尽量单一，底色为白色、蓝色、红色均可；</p><br/><p style=\"white-space: normal;\">4.照片光线均匀，面部无明显逆光；</p><br/><p style=\"white-space: normal;\">5.照片文件大小要求：大于60KB，小于1MB;</p><br/><p style=\"white-space: normal;\">6.照片像素要求：宽高在200*200以上；</p><p><br/></p>";



function beforeUpload(file) {

    var isJPG = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJPG) {
        __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.error("You can only upload JPG file!");
    }
    var isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.error("Image must smaller than 2MB!");
    }
    return isJPG && isLt2M;
}

var JbxxInitForm = function (_React$Component) {
    _inherits(JbxxInitForm, _React$Component);

    function JbxxInitForm(props) {
        _classCallCheck(this, JbxxInitForm);

        var _this = _possibleConstructorReturn(this, (JbxxInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_get_prototype_of___default()(JbxxInitForm)).call(this, props));

        _this.getStudentPhotoBase64 = function (userId, callback) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/openapi/student/getStudentPhotoBase64', 'get', { xsid: userId, type: 10 }).then(function (res) {
                if (res && res.code == 200) {
                    callback(res.data);
                }
            });
        };

        _this.loadZzmm = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHFetch__["a" /* default */])('/proData/selectDataList', 'get', 'sign=dMK_XTGL_ZZMMM').then(function (res) {
                if (res && res.code == 200) {
                    var list = [];
                    var zzmmList = res.data;
                    zzmmList.map(function (item) {
                        list.push({ "value": item.VALUE, label: item.LABEL });
                    });
                    _this.setState({
                        zzmmList: list
                    });
                }
            });
        };

        _this.loadLxjt = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHFetch__["a" /* default */])('/proData/selectDataList', 'get', 'sign=dmk_YXWZ_LXJTGJ').then(function (res) {
                if (res && res.code == 200) {
                    var dxjtList = res.data;
                    _this.setState({
                        dxjtList: dxjtList
                    });
                }
            });
        };

        _this.getjbxxData = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHFetch__["a" /* default */])("/newStudent/getStudentInfo", 'get', { xsid: xsid }).then(function (res) {
                if (res && res.data) {
                    _this.setState({
                        basicData: res.data
                    });
                }
            });
        };

        _this.onSavejbxxFormData = function (cb) {
            _this.props.form.validateFields(function (error, values) {
                if (error) {
                    cb(false);
                    return;
                }
                _this.setState({
                    jbxx: false
                });
                cb(true);
                console.log("66666666666666", values.hkszd, "vvv", values.jgm, "22222222", values);
                var hkszdArray = values.hkszd;
                if (hkszdArray.length > 0) {
                    var num = hkszdArray.length;
                    values['hkszd'] = hkszdArray[num - 1];
                    console.log(values['hkszd']);
                }
                var jgArray = values.hkszd;
                if (_this.state.csny != "" && _this.state.csny && _this.state.csny != null) {
                    values['csrq'] = _this.state.csny;
                } else {
                    values['csrq'] = _this.props.jbxxFormData.csrq;
                }
                if (_this.state.jgDetail != "" && _this.state.jgDetail) {
                    values['jgDetail'] = _this.state.jgDetail;
                } else {
                    values['jgDetail'] = _this.props.jbxxFormData.jgDetail;
                }
                if (_this.state.hkszdDetail != "" && _this.state.hkszdDetail) {
                    values['hkszdDetail'] = _this.state.hkszdDetail;
                } else {
                    values['hkszdDetail'] = _this.props.jbxxFormData.hkszdDetail;
                }
                if (_this.state.zzmmMC != "" && _this.state.zzmmMC) {
                    values['zzmmmc'] = _this.state.zzmmMC;
                } else {
                    values['zzmmmc'] = _this.props.jbxxFormData.zzmmmc;
                }
                /*  if(this.state.dxrq && this.state.sj){
                     console.log(this.state.dxrq,this.state.sj);
                     values.dxsj = this.state.dxrq+this.state.sj;
                 }else{
                     values.dxsj = this.props.dxsj;
                 } */
                // values['hkszd'] = hkszdArray[hkszdArray.length-1]
                // value['jgm'] =  jgArray[jgArray.length-1];
                // values['jbxx_jgm']=values.jbxx_jgm[values.jbxx_jgm.length-1]
                var cacheFormData = _this.props.cacheFormData;

                cacheFormData('jbxx', values);
            });
        };

        _this.handleUploadChange = function (info) {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (info && info['file'] && info['file'].status === 'done') {
                var photoUUID = info['file'].response.data;
                if (photoUUID) {
                    var url = '/newStudent/saveStudentPhoto?xsid=' + userId + '&photoUUID=' + photoUUID + '&type=' + '10';
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHFetch__["a" /* default */])(url, 'POST').then(function (res) {
                        if (res && res.data) {
                            __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.success("上传成功!");
                        }
                    });
                }
            }
            _this.getBase64(info.file.originFileObj, function (imageUrl) {
                return _this.setState({ imageUrl: imageUrl });
            });
        };

        _this.onjgNHCascaderChange = function (value, selectedOptions, type) {
            var label = '';
            if (selectedOptions) {
                selectedOptions.forEach(function (i) {
                    label += i.label;
                });
            }
            _this.setState({
                jgDetail: label
            });
        };

        _this.onNHCascaderChange = function (value, selectedOptions, type) {
            var label = '';
            if (selectedOptions) {
                selectedOptions.forEach(function (i) {
                    label += i.label;
                });
            }
            _this.setState({ hkszdDetail: label });
        };

        _this.zzmmSelect = function (value) {
            var mc = "";
            console.log('radio checked', value);
            _this.state.zzmmList.map(function (item) {
                if (item.value == value) {
                    mc = item.label;
                }
            });
            _this.setState({
                zzmmValue: value,
                zzmmMC: mc
            }, function () {
                console.log("赋值zzmm", _this.state.zzmmMC);
            });
        };

        _this.sfqyOnChange = function (e) {
            console.log('radio checked', e.target.value);
            _this.setState({
                sfqyValue: e.target.value
            });
        };

        _this.timeData = function (moment, timeString) {
            console.log(moment, timeString);
            _this.setState({
                csny: timeString
            });
        };

        _this.dxfsOnChange = function (e) {
            console.log('radio checked', e.target.value);
            _this.setState({
                dxfsValue: e.target.value
            });
        };

        _this.dateData = function (moment, dateString) {
            console.log(moment, dateString);
            _this.setState({
                dxrq: dateString
            });
        };

        _this.dxtimeData = function (moment, timeString) {
            console.log(moment, timeString);
            _this.setState({
                sj: timeString
            });
        };

        _this.getZSInfo = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHFetch__["a" /* default */])('api/zhxg-yxxt/yxwz/getFbnrByFlbz', 'get', { flbz: "XY_ZS" }).then(function (res) {
                if (res && res.code == 200) {
                    console.log("res", res);
                    _this.setState({
                        xyContent: res.data
                    });
                }
            });
        };

        _this.sfzsOnChange = function (e) {
            console.log('radio checked', e.target.value);
            _this.setState({
                sfzsValue: e.target.value
            });
            if (e.target.value == '1') {
                _this.nhModal.show();
            } else {
                _this.setState({
                    ZSXYFlag: false
                });
            }
        };

        _this.onChangeCheck = function (e) {
            console.log('checked = ' + e.target.checked);
            if (e.target.checked) {
                _this.setState({
                    ZSXYFlag: true
                });
            } else {
                _this.setState({
                    ZSXYFlag: false
                });
            }
        };

        _this.handleCancel = function () {
            _this.setState({
                jbxx: true,
                sureButton: false
            });
        };

        _this.handleOk = function (stopLoading) {
            var cacheFormData = _this.props.cacheFormData;

            if (_this.state.ZSXYFlag) {
                _this.nhModal.close();
                _this.setState({
                    sureButton: true
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.warn("请勾选同意住宿协议，再确定");
            }
        };

        _this.zphandleOk = function () {
            _this.zpModal.close();
            // this.beforeUpload();
            _this.setState({
                modal: false
            }, function () {
                _this.handleUploadChange(_this.state.modalInfo);
            });
        };

        _this.openZPModal = function (info) {
            _this.zpModal.show();
            _this.setState({
                modalInfo: info
            });
        };

        _this.state = {
            basicData: [],
            jbxx: false,
            xsid: '',
            userInfoData: null,
            zzmmmList: [],
            mzmList: [],
            textData: '',
            jgmStr: '',
            jtStr: '',
            xsSsInfo: '',
            zzmmValue: 1, //政治面貌
            sfqyValue: -1, //是否迁移户口
            csny: "",
            dxjtList: [], //到校交通工具
            sfzsValue: "",
            dxfsValue: "", //到校方式
            xyContent: "", //协议内容
            values: {},
            sj: "",
            dxrq: "",
            sureButton: false,
            ZSXYFlag: false,
            zzmmList: [
                // {value:"01",label:"中国共产党党员"},
                // {value:"02",label:"中国共产党预备党员"},
                // {value:"03",label:"中国共产主义青年团团员"},
                // {value:"04",label:"中国国民党革命委员会会员"},
                // {value:"05",label:"中国民主同盟盟员"},
                // {value:"06",label:"中国民主建国会会员"},
                // {value:"07",label:"中国民主促进会会员"},
                // {value:"08",label:"中国农工民主党党员"},
                // {value:"09",label:"中国致公党党员"},
                // {value:"10",label:"九三学社社员"},
                // {value:"11",label:"台湾民主自治同盟盟员"},
                // {value:"12",label:"无党派民主人士"},
                // {value:"13",label:"群众"}
            ], //政治面貌
            hkszdDetail: "",
            jgmmc: "",
            zzmmMC: ""
        };
        return _this;
    }

    _createClass(JbxxInitForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                this.getStudentPhotoBase64(userId, function (data) {
                    if (!data) return;
                    _this2.setState({
                        xsid: userId,
                        imageUrl: 'data:image/jpeg;base64,' + data
                    });
                });
            }
            this.getjbxxData();
            this.loadLxjt();
            this.getZSInfo();
            this.loadZzmm();
        }

        // 获取学生头像


        // 政治面貌


        // 获取到校使用交通工具

    }, {
        key: 'getBase64',
        value: function getBase64(img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        }
        // 上传图片


        // 政治面貌回调


        // 是否迁移户口回调


        //   选择出生年月回调


        // 到校方式回调


        //   选择到校日期回调

        //   选择到校时间回调


        // 获取住宿协议


        // 是否住宿回调

        //   是否住宿弹窗的勾选事件


        // 取消按钮


        // 是否住宿弹窗确定按钮


        // modalSure=(info)=>{
        //     this.zpModal.show();
        // }

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                form = _props.form,
                jbxxFormData = _props.jbxxFormData,
                getChildComponent = _props.getChildComponent,
                userInfoData = _props.userInfoData,
                stuSsxx = _props.stuSsxx,
                editXszp = _props.editXszp,
                kzxxInitData = _props.kzxxInitData,
                SFBT = _props.SFBT,
                blztFlag = _props.blztFlag,
                dxxxFormData = _props.dxxxFormData;
            var _state = this.state,
                jbxx = _state.jbxx,
                imageUrl = _state.imageUrl,
                tempUrl = _state.tempUrl,
                xsid = _state.xsid,
                zzmmList = _state.zzmmList,
                basicData = _state.basicData,
                dxjtList = _state.dxjtList,
                sfzsValue = _state.sfzsValue,
                dxfsValue = _state.dxfsValue;

            var jtjddz = jbxxFormData ? jbxxFormData.jtjddz : '';
            var ssxx = '';
            var zdz = "";
            console.log("照片是否可以编辑-----", editXszp);
            console.log("kzxxInitData", kzxxInitData, jbxxFormData.xxcj_zdyhksfqy);
            if (jbxxFormData.xxcj_zdyhksfqy == undefined) {
                if (kzxxInitData) {
                    kzxxInitData.map(function (item) {
                        if (item.zdbz == "ZDYHKSFQY") {
                            zdz = item.zdz;
                            console.log(item.zdz);
                        }
                    });
                }
            } else {
                zdz = jbxxFormData.xxcj_zdyhksfqy;
            }

            // 到校时间
            var dx_sj = "";
            var dxrq = null;
            if (jbxxFormData && jbxxFormData.dxsj) {
                var dateStr = jbxxFormData.dxsj;
                /* let dxrq = dateStr.substring(0,10);
                let sj = dateStr.substring(11,18); */
                dxrq = dateStr.substring(0, 10);
                dx_sj = dateStr.substring(10);
                console.log(dateStr, dxrq, dx_sj);
            }
            // 是否住宿弹窗页脚
            var footer = [{ text: '确定', type: 'primary', onClick: this.handleOk }];

            if (stuSsxx && stuSsxx.xqmc && stuSsxx.ldmc && stuSsxx.fj && stuSsxx.cwh) {
                ssxx = stuSsxx.xqmc + stuSsxx.ldmc + ' - ' + stuSsxx.fj + ' - ' + stuSsxx.cwh;
            }
            console.log(jbxxFormData);
            return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a,
                { layout: 'inline' },
                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u57FA\u672C\u4FE1\u606F',
                    onEdit: function onEdit(type) {
                        _this3.setState({
                            jbxx: true,
                            sfqyValue: zdz,
                            dxfsValue: jbxxFormData ? jbxxFormData.jtgj : ""
                        });
                        getChildComponent(1, false);
                    },
                    onSave: function onSave(cb) {
                        _this3.onSavejbxxFormData(cb); //现在不需要单条保存数据
                        getChildComponent(1, true);
                    },
                    onClose: function onClose() {
                        _this3.setState({
                            jbxx: false
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_23__components__["a" /* Flex */],
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + '_bg app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_icon'
                        },
                        jbxx && editXszp === "true" ? __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16_antd_lib_upload___default.a,
                            {
                                name: 'photo',
                                accept: 'image/*',
                                showUploadList: false,
                                action: uploadUrl + "?xsid=" + xsid,
                                beforeUpload: this.beforeUpload,
                                onChange: this.openZPModal
                            },
                            imageUrl || userInfoData ? imageUrl ? __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('img', {
                                src: imageUrl,
                                alt: '',
                                className: 'jsx-1702183314' + ' ' + 'avatar'
                            }) : tempUrl : __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__upload-box'
                                },
                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__upload-title'
                                    },
                                    '\u4E0A\u4F20\u56FE\u7247'
                                )
                            )
                        ) : imageUrl ? __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('img', {
                            src: imageUrl,
                            alt: '',

                            style: { border: "1px solid #1890ff", padding: "5px" },
                            className: 'jsx-1702183314' + ' ' + 'avatar'
                        }) : tempUrl
                    ),
                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_23__components__["a" /* Flex */].Item,
                        { className: 'ml-20' },
                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u59D3\u540D\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                basicData ? basicData.XM : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u6027\u522B\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                basicData && basicData.XB ? basicData.XB === '男' ? __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('img', { src: __webpack_require__(141), alt: '', className: 'jsx-1702183314'
                                }) : basicData.XB === '女' ? __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('img', { src: __webpack_require__(142), alt: '', className: 'jsx-1702183314'
                                }) : __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('img', { src: __webpack_require__(143), alt: '', className: 'jsx-1702183314'
                                }) : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u6C11\u65CF\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                basicData ? basicData.MZ : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u5B66\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                basicData ? basicData.XH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u5B66\u9662\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                basicData ? basicData.BM : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u4E13\u4E1A\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                basicData ? basicData.ZY : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            jbxx ? __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_24__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'csrq',
                                    label: __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        '\u51FA\u751F\u5E74\u6708\uFF1A'
                                    ),
                                    colon: false,
                                    form: form,
                                    required: true
                                    // hasFeedback={true}

                                    , initialValue: jbxxFormData.csrq ? __WEBPACK_IMPORTED_MODULE_28_moment___default()(jbxxFormData.csrq, 'YYYY-MM-DD HH:mm') : null
                                },
                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_date_picker___default.a, { onChange: this.timeData, placeholder: "选择日期...", format: "YYYY-MM-DD" })
                            ) : __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314'
                                },
                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                        'span',
                                        { style: { color: 'red' }, className: 'jsx-1702183314'
                                        },
                                        '*'
                                    ),
                                    '\u51FA\u751F\u5E74\u6708\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                    'div',
                                    {
                                        style: { display: 'inline' },
                                        className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                    },
                                    jbxxFormData ? jbxxFormData.csrq : ''
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            jbxx ? __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_24__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'byxx',
                                    label: __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        '\u6BD5\u4E1A\u4E2D\u5B66\uFF1A'
                                    ),
                                    colon: false,
                                    form: form,
                                    required: true
                                    // hasFeedback={true} 
                                    // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}
                                    , initialValue: jbxxFormData ? jbxxFormData.byxx : ""
                                },
                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u6BD5\u4E1A\u4E2D\u5B66' })
                            ) : __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314'
                                },
                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                        'span',
                                        { style: { color: 'red' }, className: 'jsx-1702183314'
                                        },
                                        '*'
                                    ),
                                    '\u6BD5\u4E1A\u4E2D\u5B66\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                    'div',
                                    {
                                        style: { display: 'inline' },
                                        className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                    },
                                    jbxxFormData ? jbxxFormData.byxx : ''
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                            'div',
                            { style: { display: "flex" }, className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            jbxx ? __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_24__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'sg',
                                    label: __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        '\u8EAB\u9AD8\uFF1A'
                                    ),
                                    colon: false,
                                    form: form,
                                    required: true
                                    // hasFeedback={true} 
                                    // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}
                                    , initialValue: jbxxFormData ? jbxxFormData.sg : ""
                                },
                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u8EAB\u9AD8(cm)' })
                            ) : __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314'
                                },
                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                        'span',
                                        { style: { color: 'red' }, className: 'jsx-1702183314'
                                        },
                                        '*'
                                    ),
                                    '\u8EAB\u9AD8\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                    'div',
                                    {
                                        style: { display: 'inline' },
                                        className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                    },
                                    jbxxFormData ? jbxxFormData.sg : ''
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'span',
                                { style: { padding: "6px 0px", color: "#000" }, className: 'jsx-1702183314'
                                },
                                'cm'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            jbxx ? __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_24__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'xqah',
                                    label: __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        '\u5174\u8DA3\u7231\u597D\uFF1A'
                                    ),
                                    colon: false,
                                    form: form
                                    // required={true}
                                    // hasFeedback={true} 
                                    // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}
                                    , initialValue: jbxxFormData ? jbxxFormData.xqah : ""
                                },
                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u5174\u8DA3\u7231\u597D' })
                            ) : __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314'
                                },
                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    '\u5174\u8DA3\u7231\u597D\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                    'div',
                                    {
                                        style: { display: 'inline' },
                                        className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                    },
                                    jbxxFormData ? jbxxFormData.xqah : ''
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                                },
                                jbxx ? __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_24__components_common_NHFormItem_index__["a" /* default */],
                                    { id: 'hkszd',
                                        label: __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                            'span',
                                            {
                                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                            },
                                            '\u6237\u53E3\u6240\u5728\u5730\uFF1A'
                                        ),
                                        colon: false,
                                        form: form,
                                        required: true
                                        // hasFeedback={true} 
                                        // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}
                                        , initialValue: jbxxFormData ? jbxxFormData.hkszdArray : ""
                                    },
                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_common_NHCascader__["a" /* default */], { style: { width: 400 }, sign: "zhxg_ssq", onChange: function onChange(value, selectedOptions) {
                                            return _this3.onNHCascaderChange(value, selectedOptions, 'jt');
                                        } })
                                ) : __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 'jsx-1702183314'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                            'span',
                                            { style: { color: 'red' }, className: 'jsx-1702183314'
                                            },
                                            '*'
                                        ),
                                        '\u6237\u53E3\u6240\u5728\u5730\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                        'div',
                                        {
                                            style: { display: 'inline' },
                                            className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                        },
                                        jbxxFormData ? jbxxFormData.hkszdDetail : ''
                                    )
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                            },
                            jbxx ? __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_24__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'jgm',
                                    label: __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        '\u7C4D\u8D2F\uFF1A'
                                    ),
                                    colon: false,
                                    required: true,
                                    form: form,
                                    initialValue: jbxxFormData ? jbxxFormData.jgArray : []
                                },
                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_common_NHCascader__["a" /* default */], { style: { width: 400 }, sign: "zhxg_ssq", onChange: function onChange(value, selectedOptions) {
                                        return _this3.onjgNHCascaderChange(value, selectedOptions, 'jt');
                                    } })
                            ) : __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314'
                                },
                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                        'span',
                                        { style: { color: 'red' }, className: 'jsx-1702183314'
                                        },
                                        '*'
                                    ),
                                    '\u7C4D\u8D2F\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                    'div',
                                    {
                                        style: { display: 'inline' },
                                        className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                    },
                                    jbxxFormData ? jbxxFormData.jgDetail : ''
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                                },
                                jbxx ? __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_24__components_common_NHFormItem_index__["a" /* default */],
                                    { id: 'zzmmm',
                                        label: __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                            'span',
                                            {
                                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                            },
                                            '\u653F\u6CBB\u9762\u8C8C\uFF1A'
                                        ),
                                        colon: false,
                                        form: form,
                                        required: true
                                        // hasFeedback={true} 
                                        // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}
                                        , initialValue: jbxxFormData ? jbxxFormData.zzmmm : ""
                                    },
                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_10_antd_lib_select___default.a,
                                        { defaultValue: jbxxFormData ? jbxxFormData.zzmmm : '', style: { width: 220 }, onChange: this.zzmmSelect, value: this.state.zzmmValue, placeholder: '\u8BF7\u9009\u62E9...' },
                                        zzmmList.map(function (item, index) {
                                            return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                Option,
                                                { value: item.value },
                                                item.label
                                            );
                                        })
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 'jsx-1702183314'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                            'span',
                                            { style: { color: 'red' }, className: 'jsx-1702183314'
                                            },
                                            '*'
                                        ),
                                        '\u653F\u6CBB\u9762\u8C8C\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                        'div',
                                        {
                                            style: { display: 'inline' },
                                            className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                        },
                                        jbxxFormData ? jbxxFormData.zzmmmc : ''
                                    )
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                            'div',
                            { style: { padding: "0px" }, className: 'jsx-1702183314' + ' ' + 'p-swc'
                            },
                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'div',
                                { style: { width: '100%' }, className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                                },
                                jbxx ? __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                    'div',
                                    { style: { display: "flex" }, className: 'jsx-1702183314'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                        'div',
                                        { style: { padding: "10px", color: "#9A9A9A", fontSize: "12px" }, className: 'jsx-1702183314'
                                        },
                                        '\u5728\u6821\u671F\u95F4\u662F\u5426\u7533\u8BF7\u5165\u4F4F\u5B66\u751F\u5BBF\u820D\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_24__components_common_NHFormItem_index__["a" /* default */],
                                        { id: 'sfzs',
                                            label: '',
                                            colon: false,
                                            form: form,
                                            required: true
                                            // hasFeedback={true} 
                                            // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}
                                            , initialValue: jbxxFormData ? jbxxFormData.sfzs : ""
                                        },
                                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_radio___default.a.Group,
                                            { onChange: this.sfzsOnChange, value: sfzsValue, style: { display: "flex", margin: "10px" } },
                                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_radio___default.a,
                                                { value: '1' },
                                                '\u7533\u8BF7\u4F4F\u5BBF'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_radio___default.a,
                                                { value: '0' },
                                                '\u4E0D\u7533\u8BF7\u4F4F\u5BBF'
                                            )
                                        )
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 'jsx-1702183314'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                            'span',
                                            { style: { color: 'red' }, className: 'jsx-1702183314'
                                            },
                                            '*'
                                        ),
                                        '\u5728\u6821\u671F\u95F4\u662F\u5426\u7533\u8BF7\u5165\u4F4F\u5B66\u751F\u5BBF\u820D\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                        'div',
                                        {
                                            style: { display: 'inline' },
                                            className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                        },
                                        jbxxFormData ? jbxxFormData.sfzs == '1' ? "申请住宿" : jbxxFormData.sfzs == '0' ? "不申请住宿" : "" : ''
                                    )
                                )
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_30__components_common_NHModal__["a" /* default */],
                    {
                        ref: function ref(form) {
                            _this3.zpModal = form;
                        },
                        title: '\u7167\u7247\u89C4\u8303',
                        width: "40%"
                        // style={{width:"70%"}}
                        , onOk: this.zphandleOk
                        // footer={footer}
                        // onCancel={this.zphandleCancel}
                    },
                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('img', { src: __webpack_require__(815), style: { width: "50%", position: "relative", left: "25%" }, className: 'jsx-1702183314'
                    }),
                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: zpTip }, style: { textAlign: "center" }, className: 'jsx-1702183314'
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_30__components_common_NHModal__["a" /* default */],
                    {
                        ref: function ref(form) {
                            _this3.nhModal = form;
                        },
                        title: '\u4F4F\u5BBF\u534F\u8BAE',
                        width: "60%"
                        // style={{width:"70%"}}
                        , onOk: this.handleOk,
                        footer: footer,
                        onCancel: this.handleCancel
                    },
                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314'
                        },
                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.xyContent }, className: 'jsx-1702183314'
                        }),
                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox___default.a,
                            { onChange: this.onChangeCheck, checked: this.state.ZSXYFlag },
                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'span',
                                { style: { color: "red" }, className: 'jsx-1702183314'
                                },
                                '\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F\u8BE5\u534F\u8BAE\u3002'
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_styled_jsx_style___default.a, {
                    styleId: '1702183314',
                    css: ['.ant-col-md-7{width:100px;}']
                })
            );
        }
    }]);

    return JbxxInitForm;
}(__WEBPACK_IMPORTED_MODULE_21_react___default.a.Component);

var JbxxForm = __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a.create()(JbxxInitForm);

/* harmony default export */ __webpack_exports__["a"] = (JbxxForm);

/***/ }),

/***/ 1032:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__index_css__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__utils_RegExp__);



















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;

var JtcyInitForm = function (_React$Component) {
    _inherits(JtcyInitForm, _React$Component);

    function JtcyInitForm(props) {
        _classCallCheck(this, JtcyInitForm);

        var _this = _possibleConstructorReturn(this, (JtcyInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default()(JtcyInitForm)).call(this, props));

        _this.cacheJtcyData = function (cb) {
            _this.props.form.validateFields(function (err, values) {
                if (err) return cb(false);
                //判断数据是否全部填写
                var dataList = [];
                var errorPhone = "";
                var errorList = [];
                if (_this.state.jtcyData && _this.state.jtcyData.length > 0) {
                    for (var i = 0; i < _this.state.jtcyData.length; i++) {
                        var data = _this.state.jtcyData[i];
                        var pattern = /^1\d{10}$/;
                        if (data.lxfs) {
                            if (!pattern.test(data.lxfs)) {
                                if (errorList.length == 0) {
                                    errorPhone += data.lxfs;
                                } else {
                                    errorPhone += "," + data.lxfs;
                                }
                                errorList.push(data);
                            }
                        }
                        if (!data.gx && !data.xm && !data.gzxxdw && !data.lxfs && !data.operation) {} else {
                            dataList.push(data);
                        }
                    }
                }

                if (errorList && errorList.length > 0) {
                    __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default.a.error(errorPhone + '\u53F7\u7801\u586B\u5199\u9519\u8BEF');
                    return;
                }
                var _this$props = _this.props,
                    cacheFormData = _this$props.cacheFormData,
                    getChildComponent = _this$props.getChildComponent;

                getChildComponent(3, true);
                cacheFormData('jtcy', dataList, true);
                cb(true);
                _this.setState({
                    jtcy: false,
                    jtcyAdd: false
                });
            });
        };

        _this.onjtcyAdd = function () {
            var _this$state = _this.state,
                jtcyAdd = _this$state.jtcyAdd,
                jtcyData = _this$state.jtcyData;

            if (!jtcyData) {
                jtcyData = [];
            }

            if (jtcyAdd) {
                jtcyData.push({
                    key: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHCore__["c" /* createUuid */])(),
                    gx: '',
                    xm: '',
                    gzxxdw: '',
                    zzmmm: '',
                    lxfs: '',
                    operation: ''
                });
                _this.setState({
                    jtcyData: jtcyData
                });
            }
            _this.setState({
                jtcyAdd: true
            });
        };

        _this.onjtcySave = function () {
            var jtcyData = _this.state.jtcyData;

            jtcyData.push();
            _this.setState({
                jtcyData: jtcyData,
                jtcyAdd: false
            });
        };

        _this.onjtcyClose = function (index) {
            var jtcyData = _this.state.jtcyData;

            jtcyData.splice(index, 1);
            _this.setState({
                jtcyData: jtcyData,
                jtcyAdd: true
            });
        };

        _this.handleChange = function (value, index, key) {
            var jtcyData = _this.state.jtcyData;
            jtcyData[index][key] = value;
            _this.setState({ jtcyData: jtcyData });
        };

        _this.getzzmmmStr = function (value) {
            var temp = '';
            _this.state.zzmmmList.forEach(function (i) {
                if (i.value === value) {
                    temp = i.label;
                }
            });
            return temp;
        };

        _this.deepCopy = function (obj) {
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                return obj;
            }

            if (_this.isArrayFn(obj)) {
                var newobj = [];
                for (var i = 0; i < obj.length; i++) {
                    newobj.push(_this.deepCopy(obj[i]));
                }
                return newobj;
            } else {
                var _newobj = {};
                for (var attr in obj) {
                    _newobj[attr] = _this.deepCopy(obj[attr]);
                }
                return _newobj;
            }
        };

        _this.isArrayFn = function (value) {
            if (typeof Array.isArray === "function") {
                return Array.isArray(value);
            } else {
                return Object.prototype.toString.call(value) === "[object Array]";
            }
        };

        _this.state = {
            jtcy: false,
            jtcyAdd: false,
            jtcyData: [],
            zzmmmList: [],
            tempStr: '',
            jtcyList: [] //家庭成员数据加载
        };
        return _this;
    }

    _createClass(JtcyInitForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('/proData/selectDataList?&sign=DMK_XTGL_ZZMMM', 'GET').then(function (res) {
                if (res && res.data) {
                    var zzmmmList = [];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default()(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var obj = _step.value;

                            zzmmmList.push({ 'label': obj.LABEL, 'value': obj.VALUE });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this2.setState({ zzmmmList: zzmmmList });
                }
            });
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('/proData/selectDataList?&sign=DMK_XSXX_JTCYGX', 'GET').then(function (res) {
                if (res && res.data) {
                    var jtcyList = [];
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default()(res.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var obj = _step2.value;

                            jtcyList.push({ 'label': obj.LABEL, 'value': obj.VALUE });
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    _this2.setState({ jtcyList: jtcyList });
                }
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('jtcyInitData' in nextProps && nextProps.jtcyInitData) {
                if (nextProps.jtcyInitData instanceof Array) {
                    var temp = [].concat(_toConsumableArray(nextProps.jtcyInitData));
                    this.setState({ jtcyData: temp });
                }
            }
        }

        // 家庭成员 添加

        // 家庭成员 保存添加

        // 家庭成员 关闭添加

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _state = this.state,
                jtcy = _state.jtcy,
                jtcyData = _state.jtcyData,
                jtcyAdd = _state.jtcyAdd,
                jtcyList = _state.jtcyList;
            var _props = this.props,
                getChildComponent = _props.getChildComponent,
                form = _props.form;
            var getFieldDecorator = form.getFieldDecorator;

            var jtcyTransalate = {}; //家庭成员翻译
            for (var i = 0; i < jtcyList.length; i++) {
                jtcyTransalate[jtcyList[i].value] = jtcyList[i].label;
            }
            var jtcyColumns = [{
                title: '关系',
                key: 'gx',
                dataIndex: 'gx',
                render: function render(text, record, index) {
                    return jtcy ?

                    // <Input
                    //     value={text}
                    //     required={true}
                    //     onChange={(e) =>{this.handleChange(e.target.value,index,'gx')}}
                    //     style={{ width: 100 }}
                    //     placeholder="请填写关系"
                    // />
                    __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_common_NHSelect__["a" /* default */], { style: { width: 140 }, sign: 'DMK_XSXX_JTCYGX',
                        value: text,
                        onChange: function onChange(value) {
                            _this3.handleChange(value, index, 'gx');
                        }

                    })
                    // <NHFormItem id={'gx'} label={''} form={form} required={true}
                    //     pattern={{max:5, message: "关系长度不能超过5字符！"}}
                    //     initialValue={text}>
                    // <Input onChange={(e) =>{this.handleChange(e.target.value,index,'gx')}}
                    //        placeholder="请填写关系"/>
                    // </NHFormItem>
                    : jtcyTransalate[text];
                }
            }, {
                title: '姓名',
                dataIndex: 'xm',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'xm');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u59D3\u540D'
                    }) : text;
                }
            },
            // {
            //     title: '政治面貌',
            //     dataIndex: 'zzmmm',
            //     render: (text, record,index) => {
            //         //let tempStr = '';
            //         return(
            //             jtcy ?
            //             <NHSelect disabled = {jtcy ? false : true} style={{ width: 140 }} sign="DMK_XTGL_ZZMMM"
            //             value={text}
            //             onChange={(value) =>{this.handleChange(value,index,'zzmmm')}}

            //             />
            //             :
            //             (this.getzzmmmStr(text))
            //         );
            //     }
            // },
            {
                title: '工作单位及职务',
                dataIndex: 'gzxxdw',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'gzxxdw');
                        },
                        style: { width: 140 },
                        placeholder: '\u8BF7\u586B\u5199\u5355\u4F4D\u548C\u804C\u52A1'
                    }) : text;
                }
            }, {
                title: '联系电话',
                dataIndex: 'lxfs',
                render: function render(text, record, index) {
                    return jtcy ?
                    // <FormItem form={form} style={{ marginBottom: '0px' }}>
                    //     {getFieldDecorator('lxfs', {
                    //         rules: [
                    //             { required: true, message: '请填写电话' },
                    //             FormRules.MOBILE_PHONE_NUMBER
                    //         ],
                    //         initialValue: text
                    //     })(
                    __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        maxLength: 11,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'lxfs');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u7535\u8BDD'
                    })
                    /*   )}
                    </FormItem> */
                    : text;
                }
            },
            /*  {
                 title: 'QQ',
                 dataIndex: 'qq',
                 render: (text, record,index) => {
                     return jtcy ? (
                         <Input
                             value={text}
                             onChange={(e) =>{this.handleChange(e.target.value,index,'qq')}}
                             style={{ width: 100 }}
                             placeholder="请填QQ号"
                         />
                     ) : (
                         text
                     );
                 }
             }, */
            /* {
                title: '微信',
                dataIndex: 'wx',
                render: (text, record,index) => {
                    return jtcy ? (
                        <Input
                            value={text}
                            onChange={(e) =>{this.handleChange(e.target.value,index,'wx')}}
                            style={{ width: 100 }}
                            placeholder="请填微信号"
                        />
                    ) : (
                        text
                    );
                }
            }, */
            {
                title: '删除',
                dataIndex: 'operation',
                width: 80,
                render: function render(text, record, index) {
                    if (jtcy) {
                        return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                            'div',
                            { className: 'editable-row-operations' },
                            __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                                'a',
                                {
                                    href: 'javascript:;',
                                    onClick: function onClick() {
                                        return _this3.onjtcyClose(index);
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, {
                                    type: 'close',
                                    style: { color: 'red' }
                                })
                            )
                        );
                    }
                    return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                        'a',
                        { href: 'javascript:;', onClick: function onClick() {
                                return _this3.onjtcyClose();
                            } },
                        __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'delete', style: { color: 'red' } })
                    );
                }
            }];
            if (!jtcy) {
                jtcyColumns.pop();
            }
            return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u5BB6\u5EAD\u6210\u5458\u4FE1\u606F',
                    onEdit: function onEdit(type) {
                        _this3.setState({
                            jtcy: true,
                            jtcyAdd: true,
                            cacheData: _this3.deepCopy(_this3.state.jtcyData)
                        });
                        getChildComponent(3, false);
                    },
                    onSave: function onSave(cb) {
                        _this3.cacheJtcyData(cb);
                    },
                    onClose: function onClose() {
                        _this3.setState({
                            jtcy: false,
                            jtcyAdd: false,
                            jtcyData: _this3.deepCopy(_this3.state.cacheData)
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a,
                    null,
                    __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                        'div',
                        { className: 'p-sw' },
                        __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a, {
                            bordered: true,
                            size: 'middle',
                            pagination: false,
                            dataSource: jtcyData,
                            columns: jtcyColumns
                        }),
                        jtcyAdd && __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                            'div',
                            {
                                className: 'mt-10 app__css__app-pages-SelfHelp-commonInfo-__index__btn_add',

                                onClick: function onClick() {

                                    _this3.onjtcyAdd();
                                }
                            },
                            '\u6DFB\u52A0\u5BB6\u5EAD\u6210\u5458'
                        )
                    )
                )
            );
        }
    }]);

    return JtcyInitForm;
}(__WEBPACK_IMPORTED_MODULE_18_react___default.a.Component);

var JtcyForm = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create()(JtcyInitForm);
/* harmony default export */ __webpack_exports__["a"] = (JtcyForm);

/***/ }),

/***/ 1033:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_date_picker_style__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_date_picker__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__utils_RegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__index_css__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_common_NHFormItem_index__ = __webpack_require__(43);




















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }














if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_18_antd_lib_form___default.a.Item;
var RangePicker = __WEBPACK_IMPORTED_MODULE_16_antd_lib_date_picker___default.a.RangePicker;

var dateFormat = 'YYYY/MM/DD ';

var JyjlInitForm = function (_React$Component) {
    _inherits(JyjlInitForm, _React$Component);

    function JyjlInitForm(props) {
        _classCallCheck(this, JyjlInitForm);

        var _this = _possibleConstructorReturn(this, (JyjlInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default()(JyjlInitForm)).call(this, props));

        _this.cacheJyjlData = function (cb) {
            _this.props.form.validateFields(function (err, values) {
                if (err) return cb(false);
                //判断数据是否全部填写
                var dataList = [];
                var errorPhone = "";
                var errorList = [];
                if (_this.state.jyjlData && _this.state.jyjlData.length > 0) {
                    for (var i = 0; i < _this.state.jyjlData.length; i++) {
                        var data = _this.state.jyjlData[i];
                        var pattern = /^1\d{10}$/;
                        if (data.zmrlxfs) {
                            if (!pattern.test(data.zmrlxfs)) {
                                if (errorList.length == 0) {
                                    errorPhone += data.zmrlxfs;
                                } else {
                                    errorPhone += "," + data.zmrlxfs;
                                }
                                errorList.push(data);
                            }
                        }
                        if (!data.qsny && !data.xxjl && !data.zw && !data.zmr && !data.zmrlxfs && !data.operation) {} else {
                            dataList.push(data);
                        }
                    }
                }
                if (errorList && errorList.length > 0) {
                    __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error(errorPhone + '\u53F7\u7801\u586B\u5199\u9519\u8BEF');
                    return;
                }
                var _this$props = _this.props,
                    cacheFormData = _this$props.cacheFormData,
                    getChildComponent = _this$props.getChildComponent;

                getChildComponent(6, true);
                cacheFormData('jyjl', dataList, true);
                cb(true);
                _this.setState({
                    jyjl: false,
                    jyjlAdd: false

                });
            });
        };

        _this.validateFields = function (func) {
            var err = false;
            var formData = _this.state.jyjlData;
            func(err, formData);
        };

        _this.onjyjlAdd = function () {
            var _this$state = _this.state,
                jyjlAdd = _this$state.jyjlAdd,
                jyjlData = _this$state.jyjlData;

            if (!jyjlData) {
                jyjlData = [];
            }
            if (jyjlAdd) {
                jyjlData.push({
                    key: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["c" /* createUuid */])(),
                    qsny: '',
                    xxjl: '',
                    zw: '',
                    zmr: '',
                    zmrlxfs: '',
                    operation: ''
                });
                _this.setState({
                    jyjlData: jyjlData
                });
            }
            _this.setState({
                jyjlAdd: true
            });
        };

        _this.onjyjlSave = function () {
            var jyjlData = _this.state.jyjlData;

            jyjlData.push();
            _this.setState({
                jyjlData: jyjlData,
                jyjlAdd: false
            });
        };

        _this.onjyjlClose = function (index) {
            var jyjlData = _this.state.jyjlData;

            jyjlData.splice(index, 1);
            _this.setState({
                jyjlData: jyjlData,
                jyjlAdd: true
            });
        };

        _this.handleChange = function (value, index, key) {
            var jyjlData = _this.state.jyjlData;
            jyjlData[index][key] = value;
            _this.setState({ jyjlData: jyjlData });
        };

        _this.handleDateChange = function (value, index) {

            var jyjlData = _this.state.jyjlData;
            var kssj = value[0] ? __WEBPACK_IMPORTED_MODULE_22_moment___default()(value[0]).format(dateFormat) : undefined;
            var jssj = value[1] ? __WEBPACK_IMPORTED_MODULE_22_moment___default()(value[1]).format(dateFormat) : undefined;
            jyjlData[index]['kssj'] = kssj;
            jyjlData[index]['jssj'] = jssj;
            _this.setState({ jyjlData: jyjlData });
        };

        _this.deepCopy = function (obj) {
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                return obj;
            }

            if (_this.isArrayFn(obj)) {
                var newobj = [];
                for (var i = 0; i < obj.length; i++) {
                    newobj.push(_this.deepCopy(obj[i]));
                }
                return newobj;
            } else {
                var _newobj = {};
                for (var attr in obj) {
                    _newobj[attr] = _this.deepCopy(obj[attr]);
                }
                return _newobj;
            }
        };

        _this.isArrayFn = function (value) {
            if (typeof Array.isArray === "function") {
                return Array.isArray(value);
            } else {
                return Object.prototype.toString.call(value) === "[object Array]";
            }
        };

        _this.state = {
            jyjl: false,
            jyjlAdd: false,
            jyjlData: []
        };
        return _this;
    }

    _createClass(JyjlInitForm, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('jyjlInitData' in nextProps && nextProps.jyjlInitData) {
                if (nextProps.jyjlInitData instanceof Array) {
                    var temp = [].concat(_toConsumableArray(nextProps.jyjlInitData));
                    this.setState({ jyjlData: temp });
                }
            }
        }
    }, {
        key: 'disabledDate',
        value: function disabledDate(current) {
            // Can not select days after today and today
            return current && current > __WEBPACK_IMPORTED_MODULE_22_moment___default()().endOf('day');
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                getChildComponent = _props.getChildComponent,
                form = _props.form;
            var _state = this.state,
                jyjl = _state.jyjl,
                jyjlData = _state.jyjlData,
                jyjlAdd = _state.jyjlAdd;
            var getFieldDecorator = form.getFieldDecorator;

            var jyjlColumns = [{
                title: '起始年月',
                dataIndex: 'qsny',
                render: function render(text, record, index) {
                    var kssj = record.kssj;
                    var jssj = record.jssj;
                    return jyjl ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(RangePicker
                    // disabledDate={this.disabledDate}
                    , { value: kssj && jssj ? [__WEBPACK_IMPORTED_MODULE_22_moment___default()(kssj, dateFormat), __WEBPACK_IMPORTED_MODULE_22_moment___default()(jssj, dateFormat)] : undefined,
                        format: dateFormat,
                        onChange: function onChange(value) {
                            _this2.handleDateChange(value, index);
                        }
                    }) : (kssj ? kssj : '') + ' ~ ' + (jssj ? jssj : '');
                }
            }, {
                title: '在何地何学校',
                dataIndex: 'xxjl',
                render: function render(text, record, index) {
                    return jyjl ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this2.handleChange(e.target.value, index, 'xxjl');
                        },
                        style: { width: 140 },
                        placeholder: '\u8BF7\u586B\u5199\u5B66\u6821'
                    }) : text;
                }
            },
            // {
            //     title: '任何职',
            //     dataIndex: 'zw',
            //     render: (text, record,index) => {
            //         return jyjl ? (
            //             <Input     
            //                 value={text}
            //                 onChange={(e) =>{this.handleChange(e.target.value,index,'zw')}}         
            //                 style={{ width: 100 }}
            //                 placeholder="请填写职位"
            //             />
            //         ) : (
            //             text
            //         );
            //     }
            // },
            {
                title: '证明人',
                dataIndex: 'zmr',
                render: function render(text, record, index) {
                    return jyjl ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this2.handleChange(e.target.value, index, 'zmr');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u8BC1\u660E\u4EBA'
                    }) : text;
                }
            }, {
                title: '证明人联系电话',
                dataIndex: 'zmrlxfs',
                render: function render(text, record, index) {
                    return jyjl ?
                    // <FormItem form={form} style={{ marginBottom: '0px' }}>
                    //     {getFieldDecorator('zmrlxfs', {
                    //         rules: [
                    //             { required: true, message: '请填写电话' },
                    //             FormRules.MOBILE_PHONE_NUMBER
                    //         ],
                    //         initialValue: text
                    //     })(
                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        maxLength: 11,
                        onChange: function onChange(e) {
                            _this2.handleChange(e.target.value, index, 'zmrlxfs');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u7535\u8BDD'
                    })
                    /*    )}
                    </FormItem> */
                    : text;
                }
            }, {
                title: '删除',
                dataIndex: 'operation',
                width: 80,
                render: function render(text, record, index) {
                    if (jyjl) {
                        return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                            'div',
                            { className: 'editable-row-operations' },
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                'a',
                                {
                                    href: 'javascript:;',
                                    onClick: function onClick() {
                                        return _this2.onjyjlClose(index);
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, {
                                    type: 'close',
                                    style: { color: 'red' }
                                })
                            )
                        );
                    }
                    return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                        'a',
                        { href: '#' },
                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'delete', style: { color: 'red' } })
                    );
                }
            }];

            if (!jyjl) {
                jyjlColumns.pop();
            }
            return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u6559\u80B2\u7ECF\u5386\u4FE1\u606F',
                    onEdit: function onEdit(type) {
                        _this2.setState({
                            jyjl: true,
                            jyjlAdd: true,
                            cacheData: _this2.deepCopy(_this2.state.jyjlData)
                        });
                        getChildComponent(6, false);
                    },
                    onSave: function onSave(cb) {
                        _this2.cacheJyjlData(cb);
                    },
                    onClose: function onClose() {
                        _this2.setState({
                            jyjl: false,
                            jyjlAdd: false,
                            jyjlData: _this2.deepCopy(_this2.state.cacheData)
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a, {
                        bordered: true,
                        size: 'middle',
                        pagination: false,
                        dataSource: jyjlData,
                        columns: jyjlColumns
                    }),
                    jyjlAdd && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                        'div',
                        {
                            className: 'mt-10 app__css__app-pages-SelfHelp-commonInfo-__index__btn_add',

                            onClick: function onClick() {

                                _this2.onjyjlAdd();
                            }
                        },
                        '\u6DFB\u52A0\u6559\u80B2\u7ECF\u5386'
                    )
                )
            );
        }
    }]);

    return JyjlInitForm;
}(__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component);

var JyjlForm = __WEBPACK_IMPORTED_MODULE_18_antd_lib_form___default.a.create()(JyjlInitForm);
/* harmony default export */ __webpack_exports__["a"] = (JyjlForm);

/***/ }),

/***/ 1034:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_custom_scrollbars__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_custom_scrollbars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_common_NHFormItem_FormRules__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__index_css__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components__ = __webpack_require__(10);



















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _extends = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _styleModuleImportMap = {
    './index.css': {
        'progress': 'app__css__app-pages-SelfHelp-commonInfo-__index__progress',
        'jbxx_icon': 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_icon',
        'upload-box': 'app__css__app-pages-SelfHelp-commonInfo-__index__upload-box',
        'upload-title': 'app__css__app-pages-SelfHelp-commonInfo-__index__upload-title',
        'jbxx_item': 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item',
        'jbxx_item2': 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2',
        'item-label': 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label',
        'item-name': 'app__css__app-pages-SelfHelp-commonInfo-__index__item-name',
        'kzxx_list': 'app__css__app-pages-SelfHelp-commonInfo-__index__kzxx_list',
        'kzxx_item': 'app__css__app-pages-SelfHelp-commonInfo-__index__kzxx_item',
        'kzxx_label': 'app__css__app-pages-SelfHelp-commonInfo-__index__kzxx_label',
        'kzxx_name': 'app__css__app-pages-SelfHelp-commonInfo-__index__kzxx_name',
        'kzxx_item_textarea': 'app__css__app-pages-SelfHelp-commonInfo-__index__kzxx_item_textarea',
        'kzxx_name_textarea': 'app__css__app-pages-SelfHelp-commonInfo-__index__kzxx_name_textarea',
        'btn_add': 'app__css__app-pages-SelfHelp-commonInfo-__index__btn_add',
        'title_top': 'app__css__app-pages-SelfHelp-commonInfo-__index__title_top',
        'title_top_name': 'app__css__app-pages-SelfHelp-commonInfo-__index__title_top_name',
        'line': 'app__css__app-pages-SelfHelp-commonInfo-__index__line',
        'detail_adrress': 'app__css__app-pages-SelfHelp-commonInfo-__index__detail_adrress'
    }
};

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }


















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;
var basicUrl = "/zzbd";
var stuInfoUrl = "/xxcj/";

//日期格式化
var dateFormat = 'YYYY-MM-DD';

var KzxxFormComponent = function (_React$Component) {
    _inherits(KzxxFormComponent, _React$Component);

    function KzxxFormComponent(props) {
        _classCallCheck(this, KzxxFormComponent);

        var _this = _possibleConstructorReturn(this, (KzxxFormComponent.__proto__ || __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default()(KzxxFormComponent)).call(this, props));

        _this.onSaveKzxx = function (cb) {
            _this.props.form.validateFields(function (error, values) {
                if (error) {
                    return;
                }
                _this.setState({
                    formData: _extends({}, values),
                    kzxx: false
                });
                var _this$props = _this.props,
                    cacheFormData = _this$props.cacheFormData,
                    getChildComponent = _this$props.getChildComponent;

                getChildComponent(2, true);
                var xxcjData = {};
                __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys___default()(values).forEach(function (key) {
                    var keys = "xxcj_" + key;
                    if (values[key] != null && values[key] != undefined) {
                        xxcjData[keys] = values[key]; // 这里的name为目标属性名
                        if (values[key].constructor.name == 'Moment') {//处理Moment格式的数据  
                            //values[key] = moment(values[key]).format(dateFormat); 
                        } else if (values[key].constructor.name == 'Array') {
                            if (_typeof(values[key]) === 'object') {
                                var isFileUpload = false;
                                var array = [];
                                var _iteratorNormalCompletion = true;
                                var _didIteratorError = false;
                                var _iteratorError = undefined;

                                try {
                                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(values[key]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                        var item = _step.value;

                                        if (item.hasOwnProperty('uuid') && item['uuid']) {
                                            isFileUpload = true;
                                            array.push(item['uuid']);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return) {
                                            _iterator.return();
                                        }
                                    } finally {
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }

                                if (isFileUpload) {
                                    // values[key]= array.join(',');
                                    xxcjData[keys] = array.join(','); // 这里的name为目标属性名
                                } else {
                                    // values[key] =  values[key].join(',');
                                    xxcjData[keys] = values[key].join(','); // 这里的name为目标属性名
                                }
                            } else {
                                // values[key] =  values[key].join(',');
                                xxcjData[keys] = values[key].join(',');
                            }
                        }
                    } else {
                        // values[key]='';
                        xxcjData[keys] = '';
                    }
                });
                var postData = {
                    'xxcj': { 'xsid': _this.props.xsid, 'formData': _extends({}, xxcjData) },
                    'params': { 'zzbdhjid': _this.props.zzbdhjid, 'xsid': _this.props.xsid }
                };
                var flbs = "";
                // let xsxx = {'xxcj_zdyhksfqy':values.ZDYHKSFQY?"1":"0","xxcj_zdysyd":values.ZDYSYD,"xxcj_zdyhklx":values.ZDYHKLX};
                var xsxx = _extends({}, xxcjData);
                flbs = "kzxx";
                // xsxx['xm'] = '卡瓦';
                var xsInfo4YxwzVO = {
                    xsid: _this.props.xsid,
                    xsxx: xsxx,
                    flbs: flbs
                };
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])('/newStudent/saveOrUpdateXsInfo', 'POST', xsInfo4YxwzVO).then(function (res) {
                    if (res && res.code == 200) {
                        __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.success("保存成功");
                        cb(true);
                        // this.props.reloadMenu();
                        _this.props.getData4Yxwz();
                    } else {
                        __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error("保存失败");
                    }
                });
            });
        };

        _this.onChange = function (date, dateString) {}
        // console.log('date', date)
        // console.log('dateString', dateString)
        // if(date && dateString){
        //     //this.
        // }


        //获取下拉列表value对应的名称
        ;

        _this.getDmkMc = function (dmbz, zdbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])("/proData/selectDataList", "GET", { sign: dmbz }).then(function (res) {
                if (res) {
                    if (res.data) {
                        var dmkmcList = _this.state.dmkmcList;
                        dmkmcList[zdbz] = res.data;
                        _this.setState({
                            dmkmcList: dmkmcList
                        });
                    }
                }
            });
        };

        _this.getCascaderDmkMc = function (level, sign, cascaderValue, zdbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])("/proData/selectCascaderList", "GET", { level: level, sign: sign, cascaderValue: cascaderValue }).then(function (res) {
                if (res) {
                    if (res.data) {
                        var dmkmcList = _this.state.dmkmcList;
                        dmkmcList[level + zdbz] = res.data;
                        _this.setState({
                            dmkmcList: dmkmcList
                        });
                    }
                }
            });
        };

        _this.handlePreview = function (fjmc, fjid) {

            if (fjmc === "isImage") {
                _this.showPreview('anonymity/docrepo/download/file?attachmentId=' + fjid);
            } else {
                window.open('anonymity/docrepo/download/file?attachmentId=' + fjid);
            }
        };

        _this.showPreview = function (url) {
            _this.setState({
                previewImage: url,
                previewVisible: true
            });
        };

        _this.closeModal = function () {
            return _this.setState({ previewVisible: false });
        };

        _this.fileLists = function (fileLists) {
            {
                var items = [];

                var _loop = function _loop(key) {
                    var fileList = typeof fileLists[key] == 'string' ? fileLists[key].split(";") : fileLists[key];
                    items.push(__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                            'a',
                            { onClick: function onClick() {
                                    _this.handlePreview("file", fileList[0]);
                                } },
                            fileList[1]
                        )
                    ));
                };

                for (var key in fileLists) {
                    _loop(key);
                }
                return items;
            }
        };

        _this.imageLists = function (imageLists) {
            {
                var items = [];

                var _loop2 = function _loop2(key) {
                    var imageList = typeof imageLists[key] == 'string' ? imageLists[key].split(";") : imageLists[key];
                    items.push(__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        'span',
                        null,
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('img', { style: { height: "80px", width: "80px" }, src: "anonymity/docrepo/download/file?attachmentId=" + imageList,
                            onClick: function onClick() {
                                _this.handlePreview("isImage", imageList[0]);
                            } })
                    ));
                };

                for (var key in imageLists) {
                    _loop2(key);
                }
                return items;
            }
        };

        _this.state = {
            xsid: '',
            kzxx: false,
            scrollHeight: 0, //默认滚动高度
            initData: {}, //初始数据
            loading: false, //页面加载状态
            onSubmit: false, //保存按钮加载状态
            isShow: false,
            previewVisible: false,
            formData: '',
            dmkmcList: {},
            zdzmc: ''
        };
        return _this;
    }

    //控件回调

    //获取联级下拉列表value对应的名称

    // 点击文件链接或预览图标时的回调


    //打开图片弹窗

    // 关闭图片弹窗

    // 文件展示 

    //图片展示


    _createClass(KzxxFormComponent, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                form = _props.form,
                getChildComponent = _props.getChildComponent,
                initData = _props.initData;
            var _state = this.state,
                kzxx = _state.kzxx,
                formData = _state.formData,
                previewVisible = _state.previewVisible,
                previewImage = _state.previewImage;
            //提示信息

            var AlertParams = {
                message: '当前没有需要填写的信息',
                description: '',
                type: 'info'
                //信息采集字段分类
            };var infoItems = [];
            var reactid = 0;
            if (initData) {
                //表单信息、表单字段信息
                var _initData$zdglVOs = initData.zdglVOs,
                    zdglVOs = _initData$zdglVOs === undefined ? [] : _initData$zdglVOs;

                if (zdglVOs != null) {
                    if (zdglVOs.length > 0) {
                        var array = [];
                        //循环过滤出多行文本框的key，偶数在左，奇数在右，相应的同行的另一条文本也需要加宽
                        for (var key in zdglVOs) {
                            var kjcs = zdglVOs[key].kjcs;

                            var kjcsjson = JSON.parse(kjcs);
                            if (kjcsjson.type === "textarea" || kjcsjson.type === "oldupload" || kjcsjson.type === "upload") {
                                if (key % 2 === 0) {
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key));
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key) + 1);
                                } else {
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key));
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key) - 1);
                                }
                            }
                        }
                        //显示表单字段信息

                        var _loop3 = function _loop3(_key) {
                            //字段状态、是否必填、默认值、字段标识、字段名称、控件参数、字段值
                            var _zdglVOs$_key = zdglVOs[_key],
                                zdbz = _zdglVOs$_key.zdbz,
                                zdmc = _zdglVOs$_key.zdmc,
                                kjcs = _zdglVOs$_key.kjcs,
                                zdz = _zdglVOs$_key.zdz,
                                sfbt = _zdglVOs$_key.sfbt,
                                mrz = _zdglVOs$_key.mrz,
                                zdzt = _zdglVOs$_key.zdzt; //表单字段

                            var zdzmc = '';
                            var kjcsjson = JSON.parse(kjcs);
                            if (formData && formData[zdbz] != null) {
                                zdz = formData[zdbz];
                            }
                            if (kjcsjson.type === 'datepicker' || kjcsjson.type === 'datetimepicker' || kjcsjson.type === 'timepicker' || kjcsjson.type === 'monthpicker' || kjcsjson.type === 'rangepicker') {
                                //日期值展示阶段，从moment转为文字 
                                if (zdz) {
                                    zdzmc = __WEBPACK_IMPORTED_MODULE_27_moment___default()(zdz).format(kjcsjson.format);
                                }
                            } else if (kjcsjson.type === "select") {
                                if (kjcsjson.dataTag && !_this2.state.dmkmcList[zdbz]) {
                                    _this2.getDmkMc(kjcsjson.dataTag, zdbz);
                                }
                                var list = _this2.state.dmkmcList[zdbz];
                                list && list.map(function (item) {
                                    if (item.VALUE === zdz) {
                                        zdzmc = item.LABEL;
                                    }
                                });
                            } else if (kjcsjson.type === "multiselect") {
                                if (kjcsjson.dataTag && !_this2.state.dmkmcList[zdbz]) {
                                    _this2.getDmkMc(kjcsjson.dataTag, zdbz);
                                }
                                var _list = _this2.state.dmkmcList[zdbz];
                                if (zdz) {
                                    (function () {
                                        var multiselect = typeof zdz == 'string' ? zdz.split(",") : zdz;
                                        var multiselectList = [];

                                        var _loop4 = function _loop4(i) {
                                            _list && _list.map(function (item) {
                                                if (item.VALUE === multiselect[i]) {
                                                    multiselectList.push(item.LABEL);
                                                }
                                            });
                                        };

                                        for (var i in multiselect) {
                                            _loop4(i);
                                        }
                                        zdzmc = multiselectList.join(",");
                                    })();
                                }
                            } else if (kjcsjson.type === "nhcascader") {
                                if (zdz) {
                                    (function () {
                                        var nhcascaderList = typeof zdz == 'string' ? zdz.split(",") : zdz;
                                        var nhcascaderLists = [];

                                        var _loop5 = function _loop5(i) {
                                            var level = i;
                                            var c = i;
                                            var d = i;
                                            var a = ++level;
                                            var b = --d;
                                            if (kjcsjson.dataTag && !_this2.state.dmkmcList[a + zdbz]) {
                                                if (i == "0") {
                                                    _this2.getCascaderDmkMc(a, kjcsjson.dataTag, '', zdbz);
                                                } else {
                                                    _this2.getCascaderDmkMc(a, kjcsjson.dataTag, nhcascaderList[b], zdbz);
                                                }
                                            }
                                            var list = _this2.state.dmkmcList[level++ + zdbz];

                                            list && list.map(function (item) {
                                                if (item.value === nhcascaderList[c]) {
                                                    nhcascaderLists.push(item.label);
                                                }
                                            });
                                        };

                                        for (var i in nhcascaderList) {
                                            _loop5(i);
                                        }
                                        zdzmc = nhcascaderLists.join("/");
                                    })();
                                }
                            } else if (kjcsjson.type === "switch") {
                                zdzmc = zdz === "1" || zdz === true ? kjcsjson.checkedText : kjcsjson.uncheckedText;
                            } else if (kjcsjson.type === "radio") {
                                kjcsjson.options && kjcsjson.options.map(function (item, key) {
                                    if (item.value === zdz) {
                                        zdzmc = item.label;
                                    }
                                });
                            } else if (kjcsjson.fileType === "file" && zdz) {
                                var fileLists = typeof zdz == 'string' ? zdz.split(",") : zdz;
                                zdzmc = _this2.fileLists(fileLists);
                            } else if (kjcsjson.fileType === "image" && zdz) {
                                if ((typeof zdz === 'undefined' ? 'undefined' : _typeof(zdz)) === 'object') {
                                    var _array = [];
                                    var _iteratorNormalCompletion2 = true;
                                    var _didIteratorError2 = false;
                                    var _iteratorError2 = undefined;

                                    try {
                                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(zdz), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                            var item = _step2.value;

                                            if (item.hasOwnProperty('uuid') && item['uuid']) {
                                                _array.push(item['uuid']);
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError2 = true;
                                        _iteratorError2 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                                _iterator2.return();
                                            }
                                        } finally {
                                            if (_didIteratorError2) {
                                                throw _iteratorError2;
                                            }
                                        }
                                    }

                                    zdz = _array;
                                } else {
                                    zdz = zdz.split(",");
                                }
                                zdzmc = _this2.imageLists(zdz);
                            } else {
                                zdzmc = zdz;
                            }
                            var required = sfbt === '1' ? true : false;

                            var formItem = void 0;
                            var csz = formData ? formData[zdbz] : zdz;
                            if (required) {
                                formItem = kjcsjson.type === 'textarea' || kjcsjson.type === "oldupload" || kjcsjson.type === "upload" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { minHeight: "120px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item_textarea", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-commonInfo-__index__kzxx_label' },
                                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                            'span',
                                            { style: { color: 'red' } },
                                            '*'
                                        ),
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-commonInfo-__index__kzxx_name_textarea' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs }) : zdzmc
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { minHeight: "71px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-commonInfo-__index__kzxx_label' },
                                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                            'span',
                                            { style: { color: 'red' } },
                                            '*'
                                        ),
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-commonInfo-__index__kzxx_name' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs,
                                            onChange: _this2.onChange }) : zdzmc
                                    )
                                );
                            } else {
                                formItem = kjcsjson.type === 'textarea' || kjcsjson.type === "oldupload" || kjcsjson.type === "upload" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { minHeight: "120px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item_textarea", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-commonInfo-__index__kzxx_label' },
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-commonInfo-__index__kzxx_name_textarea' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs }) : zdzmc
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { minHeight: "71px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-commonInfo-__index__kzxx_label' },
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-commonInfo-__index__kzxx_name' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs,
                                            onChange: _this2.onChange }) : zdzmc
                                    )
                                );
                            }
                            infoItems.push(formItem);
                        };

                        for (var _key in zdglVOs) {
                            _loop3(_key);
                        }
                    } else {
                        //未找到表单配置的采集字段信息
                        AlertParams['message'] = '暂时没有需要填写的信息';
                        AlertParams['description'] = '当前未配置采集信息项';
                        AlertParams['type'] = 'warning';
                    }
                }
            }

            return __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                'div',
                {
                    className: 'jsx-2266704716'
                },
                infoItems.length > 0 && __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                    'div',
                    {
                        className: 'jsx-2266704716'
                    },
                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__pages_Assembly_titleTop__["a" /* default */], {
                        title: '\u6269\u5C55\u4FE1\u606F',
                        onEdit: function onEdit(type) {
                            _this2.setState({
                                kzxx: true
                            });
                            getChildComponent(2, false);
                        },
                        onSave: function onSave(cb) {
                            _this2.onSaveKzxx(cb);
                        },
                        onClose: function onClose() {
                            _this2.setState({
                                kzxx: false
                            });
                        }
                    }),
                    infoItems.length > 0 ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a,
                        null,
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-2266704716' + ' ' + 'p-sw'
                            },
                            __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-2266704716' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__kzxx_list'
                                },
                                infoItems
                            )
                        )
                    ) : __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default.a, _extends({ style: { marginTop: 20 }
                    }, AlertParams, {
                        showIcon: true
                    })),
                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a,
                        {
                            visible: previewVisible,
                            footer: null,
                            onCancel: this.closeModal
                        },
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('img', {
                            alt: 'example',
                            style: { width: '100%' },
                            src: previewImage,
                            className: 'jsx-2266704716'
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_styled_jsx_style___default.a, {
                    styleId: '2266704716',
                    css: ['.app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_item{height:100% !important;}', '.app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_label{background-color:#fff;}', '.app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_name{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;width:67%;}']
                })
            );
        }
    }]);

    return KzxxFormComponent;
}(__WEBPACK_IMPORTED_MODULE_20_react___default.a.Component);

var KzxxForm = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create()(KzxxFormComponent);
/* harmony default export */ __webpack_exports__["a"] = (KzxxForm);

/***/ }),

/***/ 1035:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__index_css__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__utils_RegExp__);



















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;

var ZyshgxInitForm = function (_React$Component) {
    _inherits(ZyshgxInitForm, _React$Component);

    function ZyshgxInitForm(props) {
        _classCallCheck(this, ZyshgxInitForm);

        var _this = _possibleConstructorReturn(this, (ZyshgxInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default()(ZyshgxInitForm)).call(this, props));

        _this.cacheZyshgxData = function (cb) {
            _this.props.form.validateFields(function (err, values) {
                if (err) return cb(false);
                //判断数据是否全部填写
                var dataList = [];
                var errorPhone = "";
                var errorList = [];
                if (_this.state.zyshgxData && _this.state.zyshgxData.length > 0) {
                    for (var i = 0; i < _this.state.zyshgxData.length; i++) {
                        var data = _this.state.zyshgxData[i];
                        var pattern = /^1\d{10}$/;
                        if (data.lxfs) {
                            if (!pattern.test(data.lxfs)) {
                                if (errorList.length == 0) {
                                    errorPhone += data.lxfs;
                                } else {
                                    errorPhone += "," + data.lxfs;
                                }
                                errorList.push(data);
                            }
                        }
                        if (!data.gx && !data.xm && !data.gzxxdw && !data.lxfs && !data.operation) {} else {
                            dataList.push(data);
                        }
                    }
                }

                if (errorList && errorList.length > 0) {
                    __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default.a.error(errorPhone + '\u53F7\u7801\u586B\u5199\u9519\u8BEF');
                    return;
                }
                var _this$props = _this.props,
                    cacheFormData = _this$props.cacheFormData,
                    getChildComponent = _this$props.getChildComponent;

                getChildComponent(7, true);
                cacheFormData('zyshgx', dataList, true);
                cb(true);
                _this.setState({
                    zyshgx: false,
                    zyshgxAdd: false
                });
            });
        };

        _this.onzyshgxAdd = function () {
            var _this$state = _this.state,
                zyshgxAdd = _this$state.zyshgxAdd,
                zyshgxData = _this$state.zyshgxData;

            if (!zyshgxData) {
                zyshgxData = [];
            }

            if (zyshgxAdd) {
                zyshgxData.push({
                    key: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHCore__["c" /* createUuid */])(),
                    gx: '',
                    xm: '',
                    gzxxdw: '',
                    zzmmm: '',
                    lxfs: '',
                    operation: ''
                });
                _this.setState({
                    zyshgxData: zyshgxData
                });
            }
            _this.setState({
                zyshgxAdd: true
            });
        };

        _this.onzyshgxSave = function () {
            var zyshgxData = _this.state.zyshgxData;

            zyshgxData.push();
            _this.setState({
                zyshgxData: zyshgxData,
                zyshgxAdd: false
            });
        };

        _this.onzyshgxClose = function (index) {
            var zyshgxData = _this.state.zyshgxData;

            zyshgxData.splice(index, 1);
            _this.setState({
                zyshgxData: zyshgxData,
                zyshgxAdd: true
            });
        };

        _this.handleChange = function (value, index, key) {
            var zyshgxData = _this.state.zyshgxData;
            zyshgxData[index][key] = value;
            _this.setState({ zyshgxData: zyshgxData });
        };

        _this.getzzmmmStr = function (value) {
            var temp = '';
            _this.state.zzmmmList.forEach(function (i) {
                if (i.value === value) {
                    temp = i.label;
                }
            });
            return temp;
        };

        _this.deepCopy = function (obj) {
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                return obj;
            }

            if (_this.isArrayFn(obj)) {
                var newobj = [];
                for (var i = 0; i < obj.length; i++) {
                    newobj.push(_this.deepCopy(obj[i]));
                }
                return newobj;
            } else {
                var _newobj = {};
                for (var attr in obj) {
                    _newobj[attr] = _this.deepCopy(obj[attr]);
                }
                return _newobj;
            }
        };

        _this.isArrayFn = function (value) {
            if (typeof Array.isArray === "function") {
                return Array.isArray(value);
            } else {
                return Object.prototype.toString.call(value) === "[object Array]";
            }
        };

        _this.state = {
            zyshgx: false,
            zyshgxAdd: false,
            zyshgxData: [],
            zzmmmList: [],
            tempStr: ''
        };
        return _this;
    }

    _createClass(ZyshgxInitForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('/proData/selectDataList?&sign=DMK_XTGL_ZZMMM', 'GET').then(function (res) {
                if (res && res.data) {
                    var zzmmmList = [];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default()(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var obj = _step.value;

                            zzmmmList.push({ 'label': obj.LABEL, 'value': obj.VALUE });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this2.setState({ zzmmmList: zzmmmList });
                }
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('zyshgxInitData' in nextProps && nextProps.zyshgxInitData) {
                if (nextProps.zyshgxInitData instanceof Array) {
                    var temp = [].concat(_toConsumableArray(nextProps.zyshgxInitData));
                    this.setState({ zyshgxData: temp });
                }
            }
        }

        // 家庭成员 添加

        // 家庭成员 保存添加

        // 家庭成员 关闭添加

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _state = this.state,
                zyshgx = _state.zyshgx,
                zyshgxData = _state.zyshgxData,
                zyshgxAdd = _state.zyshgxAdd;
            var _props = this.props,
                getChildComponent = _props.getChildComponent,
                form = _props.form;
            var getFieldDecorator = form.getFieldDecorator;

            var zyshgxColumns = [{
                title: '关系',
                key: 'gx',
                dataIndex: 'gx',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'gx');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u5173\u7CFB'
                    }) : text;
                }
            }, {
                title: '姓名',
                dataIndex: 'xm',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'xm');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u59D3\u540D'
                    }) : text;
                }
            }, {
                title: '工作单位及职务',
                dataIndex: 'gzxxdw',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'gzxxdw');
                        },
                        style: { width: 140 },
                        placeholder: '\u8BF7\u586B\u5199\u5355\u4F4D\u548C\u804C\u52A1'
                    }) : text;
                }
            }, {
                title: '联系电话',
                dataIndex: 'lxfs',
                render: function render(text, record, index) {
                    return zyshgx ?
                    // <FormItem form={form} style={{ marginBottom: '0px' }}>
                    //     {getFieldDecorator('lxfs', {
                    //         rules: [
                    //             { required: true, message: '请填写电话' },
                    //             FormRules.MOBILE_PHONE_NUMBER
                    //         ],
                    //         initialValue: text
                    //     })(
                    __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        maxLength: 11,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'lxfs');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u7535\u8BDD'
                    })
                    /*  )}
                    </FormItem> */
                    : text;
                }
            }, {
                title: 'QQ',
                dataIndex: 'qq',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'qq');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586BQQ\u53F7'
                    }) : text;
                }
            }, {
                title: '微信',
                dataIndex: 'wx',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'wx');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5FAE\u4FE1\u53F7'
                    }) : text;
                }
            }, {
                title: '删除',
                dataIndex: 'operation',
                width: 80,
                render: function render(text, record, index) {
                    if (zyshgx) {
                        return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                            'div',
                            { className: 'editable-row-operations' },
                            __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                                'a',
                                {
                                    href: 'javascript:;',
                                    onClick: function onClick() {
                                        return _this3.onzyshgxClose(index);
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, {
                                    type: 'close',
                                    style: { color: 'red' }
                                })
                            )
                        );
                    }
                    return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                        'a',
                        { href: 'javascript:;', onClick: function onClick() {
                                return _this3.onzyshgxClose();
                            } },
                        __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'delete', style: { color: 'red' } })
                    );
                }
            }];
            if (!zyshgx) {
                zyshgxColumns.pop();
            }
            return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u4E3B\u8981\u793E\u4F1A\u5173\u7CFB',
                    onEdit: function onEdit(type) {
                        _this3.setState({
                            zyshgx: true,
                            zyshgxAdd: true,
                            cacheData: _this3.deepCopy(_this3.state.zyshgxData)
                        });
                        getChildComponent(3, false);
                    },
                    onSave: function onSave(cb) {
                        _this3.cacheZyshgxData(cb);
                    },
                    onClose: function onClose() {
                        _this3.setState({
                            zyshgx: false,
                            zyshgxAdd: false,
                            zyshgxData: _this3.deepCopy(_this3.state.cacheData)
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a,
                    null,
                    __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                        'div',
                        { className: 'p-sw' },
                        __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a, {
                            bordered: true,
                            size: 'middle',
                            pagination: false,
                            dataSource: zyshgxData,
                            columns: zyshgxColumns
                        }),
                        zyshgxAdd && __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                            'div',
                            {
                                className: 'mt-10 app__css__app-pages-SelfHelp-commonInfo-__index__btn_add',

                                onClick: function onClick() {

                                    _this3.onzyshgxAdd();
                                }
                            },
                            '\u6DFB\u52A0\u4E3B\u8981\u793E\u4F1A\u5173\u7CFB'
                        )
                    )
                )
            );
        }
    }]);

    return ZyshgxInitForm;
}(__WEBPACK_IMPORTED_MODULE_18_react___default.a.Component);

var ZyshgxForm = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create()(ZyshgxInitForm);
/* harmony default export */ __webpack_exports__["a"] = (ZyshgxForm);

/***/ }),

/***/ 1036:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_common_NHCascader__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__utils_RegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__index_css__);













var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }












if (false) {
    module.hot.accept('../index.css', function () {
        require('../index.css');
    });
}

var uploadUrl = "api/zhxg-yxwz/newStudent/cacheStudentPhoto"; //上传logo路径


function beforeUpload(file) {

    var isJPG = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJPG) {
        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("You can only upload JPG file!");
    }
    var isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("Image must smaller than 2MB!");
    }
    return isJPG && isLt2M;
}

var JbxxInitForm = function (_React$Component) {
    _inherits(JbxxInitForm, _React$Component);

    function JbxxInitForm(props) {
        _classCallCheck(this, JbxxInitForm);

        var _this = _possibleConstructorReturn(this, (JbxxInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(JbxxInitForm)).call(this, props));

        _this.getStudentPhotoBase64 = function (userId, callback) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/openapi/student/getStudentPhotoBase64', 'get', { xsid: userId, type: 10 }).then(function (res) {
                if (res && res.code == 200) {
                    callback(res.data);
                }
            });
        };

        _this.onSavejbxxFormData = function (cb) {
            _this.props.form.validateFields(function (error, values) {
                if (error) {
                    cb(false);
                    return;
                }
                cb(true);
                var cacheFormData = _this.props.cacheFormData;

                if (_this.state.jtStr !== '') {
                    values.jtdzDetail = _this.state.jtStr;
                } else {
                    values.jtdzDetail = _this.props.jbxxFormData ? _this.props.jbxxFormData.jtdzDetail ? _this.props.jbxxFormData.jtdzDetail : "" : "";
                }

                cacheFormData('jbxx_ahgs', values);
                _this.setState({
                    jbxx: false
                });
            });
        };

        _this.handleUploadChange = function (info) {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (info && info['file'] && info['file'].status === 'done') {
                var photoUUID = info['file'].response.data;
                if (photoUUID) {
                    var url = '/newStudent/saveStudentPhoto?xsid=' + userId + '&photoUUID=' + photoUUID + '&type=' + '10';
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])(url, 'POST').then(function (res) {
                        if (res && res.data) {
                            __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.success("上传成功!");
                        }
                    });
                }
            }
            _this.getBase64(info.file.originFileObj, function (imageUrl) {
                return _this.setState({ imageUrl: imageUrl });
            });
        };

        _this.onNHCascaderChange = function (value, selectedOptions, type) {
            var label = '';
            if (selectedOptions) {
                selectedOptions.forEach(function (i) {
                    label += i.label;
                });
            }
            if (type == 'jg') {
                _this.setState({ jgmStr: label });
            } else {
                _this.setState({ jtStr: label });
            }
        };

        _this.state = {
            jbxx: false,
            xsid: '',
            zzmmmList: [],
            mzmList: [],
            textData: '',
            jgmStr: '',
            jtStr: '',
            xsSsInfo: ''
        };
        return _this;
    }

    _createClass(JbxxInitForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                if (userId) {
                    this.getStudentPhotoBase64(userId, function (data) {
                        if (!data) return;
                        _this2.setState({
                            xsid: userId,
                            imageUrl: 'data:image/jpeg;base64,' + data
                        });
                    });
                }
            }
        }

        // 获取学生头像

    }, {
        key: 'getBase64',
        value: function getBase64(img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        }
        // 上传图片

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                form = _props.form,
                jbxxFormData = _props.jbxxFormData,
                getChildComponent = _props.getChildComponent,
                stuSsxx = _props.stuSsxx,
                editXszp = _props.editXszp,
                userBaseInfo = _props.userBaseInfo;
            var _state = this.state,
                jbxx = _state.jbxx,
                imageUrl = _state.imageUrl,
                tempUrl = _state.tempUrl,
                xsid = _state.xsid;

            var jtjddz = jbxxFormData ? jbxxFormData.jtjddz : '';
            var jtdzDetail = jbxxFormData ? jbxxFormData.jtdzDetail : '';
            var ssxx = '';
            if (stuSsxx && stuSsxx.XQMC && stuSsxx.LDMC && stuSsxx.FJ && stuSsxx.CWH) {
                ssxx = stuSsxx.XQMC + stuSsxx.LDMC + ' - ' + stuSsxx.FJ + ' - ' + stuSsxx.CWH;
            }
            return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a,
                { layout: 'inline' },
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u57FA\u672C\u4FE1\u606F',
                    onEdit: function onEdit(type) {
                        _this3.setState({
                            jbxx: true
                        });
                        getChildComponent(1, false);
                    },
                    onSave: function onSave(cb) {
                        _this3.onSavejbxxFormData(cb);
                        getChildComponent(1, true);
                    },
                    onClose: function onClose() {
                        _this3.setState({
                            jbxx: false
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + '_bg app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_icon'
                        },
                        jbxx && editXszp === "true" ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default.a,
                            {
                                name: 'photo',
                                accept: 'image/*',
                                showUploadList: false,
                                action: uploadUrl + "?xsid=" + xsid,
                                beforeUpload: beforeUpload,
                                onChange: this.handleUploadChange
                            },
                            imageUrl || userBaseInfo ? imageUrl ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
                                src: imageUrl,
                                alt: '',
                                className: 'jsx-1702183314' + ' ' + 'avatar'
                            }) : tempUrl : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__upload-box'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__upload-title'
                                    },
                                    '\u4E0A\u4F20\u56FE\u7247'
                                )
                            )
                        ) : imageUrl ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
                            src: imageUrl,
                            alt: '',
                            className: 'jsx-1702183314' + ' ' + 'avatar'
                        }) : tempUrl
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */].Item,
                        { className: 'ml-20' },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u59D3\u540D\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userBaseInfo ? userBaseInfo.XM : '',
                                userBaseInfo && userBaseInfo.XB ? userBaseInfo.XB === '男' ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(141), alt: '', className: 'jsx-1702183314'
                                }) : userBaseInfo.XB === '女' ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(142), alt: '', className: 'jsx-1702183314'
                                }) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(143), alt: '', className: 'jsx-1702183314'
                                }) : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u5B66\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userBaseInfo ? userBaseInfo.XH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u8003\u751F\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userBaseInfo ? userBaseInfo.KSH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u8EAB\u4EFD\u8BC1\u4EF6\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userBaseInfo ? userBaseInfo.SFZJH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u51FA\u751F\u5E74\u6708\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userBaseInfo ? userBaseInfo.CSRQ : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u653F\u6CBB\u9762\u8C8C\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userBaseInfo ? userBaseInfo.ZZMM : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u6C11\u65CF\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userBaseInfo ? userBaseInfo.MZ : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u7C4D\u8D2F\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userBaseInfo ? userBaseInfo.JG : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u6BD5\u4E1A\u5B66\u6821\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userBaseInfo ? userBaseInfo.BYXX : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u9AD8\u8003\u5206\u6570\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.gkcj : ''
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    'div',
                    {
                        className: 'jsx-1702183314' + ' ' + 'p-swc'
                    },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            '\u5B66\u9662\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            userBaseInfo ? userBaseInfo.BMMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            '\u4E13\u4E1A\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            userBaseInfo ? userBaseInfo.ZYMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            '\u73ED\u7EA7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            userBaseInfo ? userBaseInfo.BJMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                        },
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                            { id: 'sjhm',
                                label: __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    '\u672C\u4EBA\u8054\u7CFB\u7535\u8BDD\uFF1A'
                                ),
                                colon: false,
                                form: form,
                                required: true
                                // hasFeedback={true} 
                                // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}
                                , pattern: __WEBPACK_IMPORTED_MODULE_20__utils_RegExp__["FormRules"].MOBILE_PHONE_NUMBER,
                                initialValue: jbxxFormData ? jbxxFormData.sjhm : ""
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u8054\u7CFB\u7535\u8BDD' })
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'red' }, className: 'jsx-1702183314'
                                    },
                                    '*'
                                ),
                                '\u672C\u4EBA\u8054\u7CFB\u7535\u8BDD\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.sjhm : ''
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            '\u5BBF\u820D\u4FE1\u606F\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            ssxx
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__detail_adrress'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            { style: { lineHeight: '32px' }, className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                { style: { color: 'red' }, className: 'jsx-1702183314'
                                },
                                '*'
                            ),
                            '\u8BE6\u7EC6\u5BB6\u5EAD\u4F4F\u5740\uFF1A'
                        ),
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                            null,
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'jtszdqArray',
                                    label: '',
                                    colon: false,
                                    required: true,
                                    form: form,
                                    initialValue: jbxxFormData ? jbxxFormData.jtszdqArray : []
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_common_NHCascader__["a" /* default */], { style: { width: 432.63 }, sign: "zhxg_ssq", onChange: function onChange(value, selectedOptions) {
                                        return _this3.onNHCascaderChange(value, selectedOptions, 'jt');
                                    }

                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'jtjddz',
                                    label: '',
                                    colon: false,
                                    required: true,
                                    form: form,
                                    pattern: { max: 100, message: "家庭住址长度不能超过100字符！" },
                                    initialValue: jbxxFormData ? jbxxFormData.jtjddz : '' },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 346.07 }, placeholder: '\u8BF7\u586B\u5199\u8BE6\u7EC6\u5BB6\u5EAD\u5730\u5740\uFF0C\u5982\uFF1Axx\u8857\u9053\u3001xx\u5C0F\u533A\u3001\u95E8\u724C\u53F7' })
                            )
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            jtdzDetail ? jtdzDetail : '',
                            jtjddz ? jtjddz : ''
                        )
                    ),
                    userBaseInfo ? userBaseInfo.FDY && userBaseInfo.FDY.length > 0 ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            '\u8F85\u5BFC\u5458\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            userBaseInfo.FDY.map(function (item, key) {
                                if (item) {
                                    var lxdh = item.LXDH ? "( " + item.LXDH + " )" : "";
                                    return item.XM + lxdh + " ";
                                } else {
                                    return "";
                                }
                            })
                        )
                    ) : null : null,
                    userBaseInfo ? userBaseInfo.BZR && userBaseInfo.BZR.length > 0 ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            '\u73ED\u4E3B\u4EFB\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            userBaseInfo.BZR.map(function (item, key) {
                                if (item) {
                                    var lxdh = item.LXDH ? "( " + item.LXDH + " )" : "";
                                    return item.XM + lxdh + " ";
                                } else {
                                    return "";
                                }
                            })
                        )
                    ) : null : null
                ),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_styled_jsx_style___default.a, {
                    styleId: '1702183314',
                    css: ['.ant-col-md-7{width:100px;}']
                })
            );
        }
    }]);

    return JbxxInitForm;
}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);

var JbxxForm = __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a.create()(JbxxInitForm);

/* harmony default export */ __webpack_exports__["a"] = (JbxxForm);

/***/ }),

/***/ 1037:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__utils_RegExp__);

















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }










if (false) {
    module.hot.accept('../index.css', function () {
        require('../index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item;

var JtcyInitForm = function (_React$Component) {
    _inherits(JtcyInitForm, _React$Component);

    function JtcyInitForm(props) {
        _classCallCheck(this, JtcyInitForm);

        var _this = _possibleConstructorReturn(this, (JtcyInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of___default()(JtcyInitForm)).call(this, props));

        _this.cacheJtcyData = function (cb) {
            _this.props.form.validateFields(function (err, values) {
                if (err) return cb(false);
                //判断数据是否全部填写
                var dataList = [];
                var errorPhone = "";
                var errorList = [];
                if (_this.state.jtcyData && _this.state.jtcyData.length > 0) {
                    for (var i = 0; i < _this.state.jtcyData.length; i++) {
                        var data = _this.state.jtcyData[i];
                        var pattern = /^1\d{10}$/;
                        if (data.lxfs) {
                            if (!pattern.test(data.lxfs)) {
                                if (errorList.length == 0) {
                                    errorPhone += data.lxfs;
                                } else {
                                    errorPhone += "," + data.lxfs;
                                }
                                errorList.push(data);
                            }
                        }
                        if (!data.gx && !data.xm && !data.gzxxdw && !data.lxfs && !data.operation && !data.sfzh) {} else {
                            dataList.push(data);
                        }
                    }
                }

                if (errorList && errorList.length > 0) {
                    message.error(errorPhone + '\u53F7\u7801\u586B\u5199\u9519\u8BEF');
                    return;
                }
                var _this$props = _this.props,
                    cacheFormData = _this$props.cacheFormData,
                    getChildComponent = _this$props.getChildComponent;

                getChildComponent(3, true);
                cacheFormData('jtcy', dataList, true);
                cb(true);
                _this.setState({
                    jtcy: false,
                    jtcyAdd: false
                });
            });
        };

        _this.onjtcyAdd = function () {
            var _this$state = _this.state,
                jtcyAdd = _this$state.jtcyAdd,
                jtcyData = _this$state.jtcyData;

            if (!jtcyData) {
                jtcyData = [];
            }

            if (jtcyAdd) {
                jtcyData.push({
                    key: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["c" /* createUuid */])(),
                    gx: '',
                    xm: '',
                    gzxxdw: '',
                    zzmmm: '',
                    lxfs: '',
                    sfzh: '',
                    operation: ''
                });
                _this.setState({
                    jtcyData: jtcyData
                });
            }
            _this.setState({
                jtcyAdd: true
            });
        };

        _this.onjtcySave = function () {
            var jtcyData = _this.state.jtcyData;

            jtcyData.push();
            _this.setState({
                jtcyData: jtcyData,
                jtcyAdd: false
            });
        };

        _this.onjtcyClose = function (index) {
            var jtcyData = _this.state.jtcyData;

            jtcyData.splice(index, 1);
            _this.setState({
                jtcyData: jtcyData,
                jtcyAdd: true
            });
        };

        _this.handleChange = function (value, index, key) {
            var jtcyData = _this.state.jtcyData;
            jtcyData[index][key] = value;
            _this.setState({ jtcyData: jtcyData });
        };

        _this.getzzmmmStr = function (value) {
            var temp = '';
            _this.state.zzmmmList.forEach(function (i) {
                if (i.value === value) {
                    temp = i.label;
                }
            });
            return temp;
        };

        _this.deepCopy = function (obj) {
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                return obj;
            }

            if (_this.isArrayFn(obj)) {
                var newobj = [];
                for (var i = 0; i < obj.length; i++) {
                    newobj.push(_this.deepCopy(obj[i]));
                }
                return newobj;
            } else {
                var _newobj = {};
                for (var attr in obj) {
                    _newobj[attr] = _this.deepCopy(obj[attr]);
                }
                return _newobj;
            }
        };

        _this.isArrayFn = function (value) {
            if (typeof Array.isArray === "function") {
                return Array.isArray(value);
            } else {
                return Object.prototype.toString.call(value) === "[object Array]";
            }
        };

        _this.state = {
            jtcy: false,
            jtcyAdd: false,
            jtcyData: [],
            zzmmmList: [],
            tempStr: '',
            jtcyList: [] //家庭成员数据加载
        };
        return _this;
    }

    _createClass(JtcyInitForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/proData/selectDataList?&sign=DMK_XTGL_ZZMMM', 'GET').then(function (res) {
                if (res && res.data) {
                    var zzmmmList = [];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default()(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var obj = _step.value;

                            zzmmmList.push({ 'label': obj.LABEL, 'value': obj.VALUE });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this2.setState({ zzmmmList: zzmmmList });
                }
            });
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/proData/selectDataList?&sign=DMK_XSXX_JTCYGX', 'GET').then(function (res) {
                if (res && res.data) {
                    var jtcyList = [];
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default()(res.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var obj = _step2.value;

                            jtcyList.push({ 'label': obj.LABEL, 'value': obj.VALUE });
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    _this2.setState({ jtcyList: jtcyList });
                }
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('jtcyInitData' in nextProps && nextProps.jtcyInitData) {
                if (nextProps.jtcyInitData instanceof Array) {
                    var temp = [].concat(_toConsumableArray(nextProps.jtcyInitData));
                    this.setState({ jtcyData: temp });
                }
            }
        }

        // 家庭成员 添加

        // 家庭成员 保存添加

        // 家庭成员 关闭添加

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _state = this.state,
                jtcy = _state.jtcy,
                jtcyData = _state.jtcyData,
                jtcyAdd = _state.jtcyAdd,
                jtcyList = _state.jtcyList;
            var _props = this.props,
                getChildComponent = _props.getChildComponent,
                form = _props.form;
            var getFieldDecorator = form.getFieldDecorator;

            var jtcyTransalate = {}; //家庭成员翻译
            for (var i = 0; i < jtcyList.length; i++) {
                jtcyTransalate[jtcyList[i].value] = jtcyList[i].label;
            }
            var jtcyColumns = [{
                title: '关系',
                key: 'gx',
                dataIndex: 'gx',
                render: function render(text, record, index) {
                    return jtcy ?

                    // <Input
                    //     value={text}
                    //     required={true}
                    //     onChange={(e) =>{this.handleChange(e.target.value,index,'gx')}}
                    //     style={{ width: 100 }}
                    //     placeholder="请填写关系"
                    // />
                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_common_NHSelect__["a" /* default */], { style: { width: 140 }, sign: 'DMK_XSXX_JTCYGX',
                        value: text,
                        onChange: function onChange(value) {
                            _this3.handleChange(value, index, 'gx');
                        }

                    })
                    // <NHFormItem id={'gx'} label={''} form={form} required={true}
                    //     pattern={{max:5, message: "关系长度不能超过5字符！"}}
                    //     initialValue={text}>
                    // <Input onChange={(e) =>{this.handleChange(e.target.value,index,'gx')}}
                    //        placeholder="请填写关系"/>
                    // </NHFormItem>
                    : jtcyTransalate[text];
                }
            }, {
                title: '姓名',
                dataIndex: 'xm',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'xm');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u59D3\u540D'
                    }) : text;
                }
            },
            // {
            //     title: '政治面貌',
            //     dataIndex: 'zzmmm',
            //     render: (text, record,index) => {
            //         //let tempStr = '';
            //         return(
            //             jtcy ?
            //             <NHSelect disabled = {jtcy ? false : true} style={{ width: 140 }} sign="DMK_XTGL_ZZMMM"
            //             value={text}
            //             onChange={(value) =>{this.handleChange(value,index,'zzmmm')}}

            //             />
            //             :
            //             (this.getzzmmmStr(text))
            //         );
            //     }
            // },
            {
                title: '工作单位及职务',
                dataIndex: 'gzxxdw',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'gzxxdw');
                        },
                        style: { width: 140 },
                        placeholder: '\u8BF7\u586B\u5199\u5355\u4F4D\u548C\u804C\u52A1'
                    }) : text;
                }
            }, {
                title: '联系电话',
                dataIndex: 'lxfs',
                render: function render(text, record, index) {
                    return jtcy ?
                    // <FormItem form={form} style={{ marginBottom: '0px' }}>
                    //     {getFieldDecorator('lxfs', {
                    //         rules: [
                    //             { required: true, message: '请填写电话' },
                    //             FormRules.MOBILE_PHONE_NUMBER
                    //         ],
                    //         initialValue: text
                    //     })(
                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        maxLength: 11,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'lxfs');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u7535\u8BDD'
                    })
                    //     )}
                    // </FormItem>
                    : text;
                }
            }, {
                title: 'QQ',
                dataIndex: 'qq',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'qq');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586BQQ\u53F7'
                    }) : text;
                }
            }, {
                title: '微信',
                dataIndex: 'wx',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'wx');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5FAE\u4FE1\u53F7'
                    }) : text;
                }
            }, {
                title: '身份证号',
                dataIndex: 'sfzh',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'sfzh');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u8EAB\u4EFD\u8BC1\u53F7'
                    }) : text;
                }
            }, {
                title: '删除',
                dataIndex: 'operation',
                width: 80,
                render: function render(text, record, index) {
                    if (jtcy) {
                        return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                            'div',
                            { className: 'editable-row-operations' },
                            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                'a',
                                {
                                    href: 'javascript:;',
                                    onClick: function onClick() {
                                        return _this3.onjtcyClose(index);
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, {
                                    type: 'close',
                                    style: { color: 'red' }
                                })
                            )
                        );
                    }
                    return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                        'a',
                        { href: 'javascript:;', onClick: function onClick() {
                                return _this3.onjtcyClose();
                            } },
                        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'delete', style: { color: 'red' } })
                    );
                }
            }];
            if (!jtcy) {
                jtcyColumns.pop();
            }
            return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u5BB6\u5EAD\u6210\u5458\u4FE1\u606F',
                    onEdit: function onEdit(type) {
                        _this3.setState({
                            jtcy: true,
                            jtcyAdd: true,
                            cacheData: _this3.deepCopy(_this3.state.jtcyData)
                        });
                        getChildComponent(3, false);
                    },
                    onSave: function onSave(cb) {
                        _this3.cacheJtcyData(cb);
                    },
                    onClose: function onClose() {
                        _this3.setState({
                            jtcy: false,
                            jtcyAdd: false,
                            jtcyData: _this3.deepCopy(_this3.state.cacheData)
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a,
                    null,
                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                        'div',
                        { className: 'p-sw' },
                        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a, {
                            bordered: true,
                            size: 'middle',
                            pagination: false,
                            dataSource: jtcyData,
                            columns: jtcyColumns
                        }),
                        jtcyAdd && __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                            'div',
                            {
                                className: 'mt-10 app__css__app-pages-SelfHelp-commonInfo-__index__btn_add',

                                onClick: function onClick() {

                                    _this3.onjtcyAdd();
                                }
                            },
                            '\u6DFB\u52A0\u5BB6\u5EAD\u6210\u5458'
                        )
                    )
                )
            );
        }
    }]);

    return JtcyInitForm;
}(__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);

var JtcyForm = __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.create()(JtcyInitForm);
/* harmony default export */ __webpack_exports__["a"] = (JtcyForm);

/***/ }),

/***/ 1038:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox_style__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio_style__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_radio__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_number__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_time_picker_style__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_time_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_time_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_time_picker__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_time_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_time_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker_style__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_date_picker__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_common_NHCascader__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_common_NHModal__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__index_css__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_moment__);



















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }













if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var uploadUrl = "api/zhxg-yxwz/newStudent/cacheStudentPhoto"; //上传logo路径 


function beforeUpload(file) {

    var isJPG = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJPG) {
        __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("You can only upload JPG file!");
    }
    var isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("Image must smaller than 2MB!");
    }
    return isJPG && isLt2M;
}

var JbxxInitForm = function (_React$Component) {
    _inherits(JbxxInitForm, _React$Component);

    function JbxxInitForm(props) {
        _classCallCheck(this, JbxxInitForm);

        var _this = _possibleConstructorReturn(this, (JbxxInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default()(JbxxInitForm)).call(this, props));

        _this.loadLxjt = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHFetch__["a" /* default */])('/proData/selectDataList', 'get', 'sign=dmk_YXWZ_LXJTGJ').then(function (res) {
                if (res && res.code == 200) {
                    var dxjtList = res.data;
                    _this.setState({
                        dxjtList: dxjtList
                    });
                }
            });
        };

        _this.onSavedxxxFormData = function (cb) {
            _this.props.form.validateFields(function (error, values) {
                if (error) {
                    cb(false);
                    return;
                }
                cb(true);
                var cacheFormData = _this.props.cacheFormData;

                console.log(_this.state.dxrq + _this.state.sj);
                if (_this.state.dxrq && _this.state.sj) {
                    values.dxsj = _this.state.dxrq + _this.state.sj;
                } else {
                    values.dxsj = _this.props.dxsj;
                } /* 
                  if(values.sfzs == 1){
                         if(this.state.ZSXYFlag && this.state.sureButton){                        
                             cacheFormData('dxxx', values);
                             this.setState({
                                 jbxx: false
                             });
                         }
                     }else if(values.sfzs == 0){ */
                cacheFormData('dxxx', values);
                _this.setState({
                    jbxx: false
                });
                // }   
            });
        };

        _this.handleCancel = function () {
            _this.setState({
                jbxx: true,
                sureButton: fasle
            });
        };

        _this.handleOk = function (stopLoading) {
            var cacheFormData = _this.props.cacheFormData;

            if (_this.state.ZSXYFlag) {
                _this.nhModal.close();
                _this.setState({
                    sureButton: true
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.warn("请勾选同意住宿协议，在确定");
            }
        };

        _this.handleUploadChange = function (info) {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (info && info['file'] && info['file'].status === 'done') {
                var photoUUID = info['file'].response.data;
                if (photoUUID) {
                    var url = '/newStudent/saveStudentPhoto?xsid=' + userId + '&photoUUID=' + photoUUID + '&type=' + '10';
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHFetch__["a" /* default */])(url, 'POST').then(function (res) {
                        if (res && res.data) {
                            __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.success("上传成功!");
                        }
                    });
                }
            }
            _this.getBase64(info.file.originFileObj, function (imageUrl) {
                return _this.setState({ imageUrl: imageUrl });
            });
        };

        _this.onNHCascaderChange = function (value, selectedOptions, type) {
            var label = '';
            if (selectedOptions) {
                selectedOptions.forEach(function (i) {
                    label += i.label;
                });
            }
            if (type == 'jg') {
                _this.setState({ jgmStr: label });
            } else {
                _this.setState({ jtStr: label });
            }
        };

        _this.dxfsOnChange = function (e) {
            console.log('radio checked', e.target.value);
            _this.setState({
                dxfsValue: e.target.value
            });
        };

        _this.dateData = function (moment, dateString) {
            console.log(moment, dateString);
            _this.setState({
                dxrq: dateString
            });
        };

        _this.timeData = function (moment, timeString) {
            console.log(moment, timeString);
            _this.setState({
                sj: timeString
            });
        };

        _this.getZSInfo = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHFetch__["a" /* default */])('api/zhxg-yxxt/yxwz/getFbnrByFlbz', 'get', { flbz: "XY_ZS" }).then(function (res) {
                if (res && res.code == 200) {
                    console.log("res", res);
                    _this.setState({
                        xyContent: res.data
                    });
                }
            });
        };

        _this.sfzsOnChange = function (e) {
            console.log('radio checked', e.target.value);
            _this.setState({
                sfzsValue: e.target.value
            });
            if (e.target.value == '1') {
                _this.nhModal.show();
            } else {
                _this.setState({
                    ZSXYFlag: false
                });
            }
        };

        _this.onChangeCheck = function (e) {
            console.log('checked = ' + e.target.checked);
            if (e.target.checked) {
                _this.setState({
                    ZSXYFlag: true
                });
            } else {
                _this.setState({
                    ZSXYFlag: false
                });
            }
        };

        _this.state = {
            jbxx: false,
            xsid: '',
            userInfoData: null,
            zzmmmList: [],
            mzmList: [],
            textData: '',
            jgmStr: '',
            jtStr: '',
            xsSsInfo: '',
            dxfsValue: "", //是否迁移户口
            sj: "",
            dxrq: "",
            dxjtList: [], //到校交通工具
            sfzsValue: "",
            xyContent: "", //协议内容
            values: {},
            sureButton: false,
            ZSXYFlag: false
        };
        return _this;
    }

    _createClass(JbxxInitForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                this.setState({
                    xsid: userId
                });
            }
            this.loadLxjt();
            this.getZSInfo();
        }

        // 获取到校使用交通工具

    }, {
        key: 'getBase64',
        value: function getBase64(img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        }
        // 上传图片


        // 是否迁移户口回调


        //   选择到校日期回调

        //   选择到校时间回调


        // 获取住宿协议


        // 回调

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                form = _props.form,
                dxxxFormData = _props.dxxxFormData,
                getChildComponent = _props.getChildComponent,
                userInfoData = _props.userInfoData,
                stuSsxx = _props.stuSsxx,
                editXszp = _props.editXszp,
                SFBT = _props.SFBT,
                blztFlag = _props.blztFlag;
            var _state = this.state,
                jbxx = _state.jbxx,
                xsid = _state.xsid,
                zzmmList = _state.zzmmList,
                dxjtList = _state.dxjtList,
                sfzsValue = _state.sfzsValue,
                dxfsValue = _state.dxfsValue;
            /* const jtjddz = dxxxFormData ? dxxxFormData.jtjddz : '';
            const dxxxFormData = dxxxFormData ? dxxxFormData.dxxxFormData : ''; */

            var dx_sj = "";
            var dxrq = null;
            if (dxxxFormData && dxxxFormData.dxsj) {
                var dateStr = dxxxFormData.dxsj;
                /* let dxrq = dateStr.substring(0,10);
                let sj = dateStr.substring(11,18); */
                dxrq = dateStr.substring(0, 10);
                dx_sj = dateStr.substring(10);
                console.log(dateStr, dxrq, dx_sj);
            }
            var ssxx = '';
            if (stuSsxx && stuSsxx.xqmc && stuSsxx.ldmc && stuSsxx.fj && stuSsxx.cwh) {
                ssxx = stuSsxx.xqmc + stuSsxx.ldmc + ' - ' + stuSsxx.fj + ' - ' + stuSsxx.cwh;
            }
            var footer = [{ text: '同意', type: 'primary', onClick: this.handleOk }];

            return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a,
                { layout: 'inline' },
                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u5230\u6821\u4FE1\u606F',
                    onEdit: function onEdit(type) {
                        _this2.setState({
                            jbxx: true,
                            dxfsValue: dxxxFormData.jtgj
                        });
                        getChildComponent(4, false);
                    },
                    onSave: function onSave(cb) {
                        _this2.onSavedxxxFormData(cb);
                        getChildComponent(4, true);
                    },
                    onClose: function onClose() {
                        _this2.setState({
                            jbxx: false
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_21__components__["a" /* Flex */],
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_21__components__["a" /* Flex */].Item,
                        { className: 'ml-20' },
                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            jbxx ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_22__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'dxrq',
                                    label: __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        '\u5230\u6821\u65E5\u671F\uFF1A'
                                    ),
                                    colon: false,
                                    form: form,
                                    required: true
                                    // hasFeedback={true} moment(dxrq,"YYYY-MM-DD")
                                    , initialValue: dxxxFormData ? dxrq != null ? __WEBPACK_IMPORTED_MODULE_28_moment___default()(dxrq, "YYYY-MM-DD") : null : null
                                },
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_date_picker___default.a, { onChange: this.dateData, placeholder: "选择日期...", format: "YYYY-MM-DD" })
                            ) : __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314'
                                },
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                        'span',
                                        { style: { color: 'red' }, className: 'jsx-1702183314'
                                        },
                                        '*'
                                    ),
                                    '\u5230\u6821\u65E5\u671F\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                    'div',
                                    {
                                        style: { display: 'inline' },
                                        className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                    },
                                    dxrq ? dxrq : ''
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            jbxx ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_22__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'sj',
                                    label: __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        '\u5230\u6821\u65F6\u95F4\uFF1A'
                                    ),
                                    colon: false,
                                    form: form,
                                    required: true
                                    // hasFeedback={true} 
                                    , initialValue: dxxxFormData ? dxxxFormData.dxsj != null ? __WEBPACK_IMPORTED_MODULE_28_moment___default()(dxxxFormData.dxsj, "HH:mm:ss") : "" : ""
                                },
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_time_picker___default.a, { onChange: this.timeData, placeholder: "请选择..." })
                            ) : __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314'
                                },
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                        'span',
                                        { style: { color: 'red' }, className: 'jsx-1702183314'
                                        },
                                        '*'
                                    ),
                                    '\u5230\u6821\u65F6\u95F4\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                    'div',
                                    {
                                        style: { display: 'inline' },
                                        className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                    },
                                    dx_sj ? dx_sj : ''
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            jbxx ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_22__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'ptrs',
                                    label: __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        '\u5230\u6821\u968F\u884C\u4EBA\u6570\uFF1A'
                                    ),
                                    colon: false,
                                    form: form,
                                    required: true
                                    // hasFeedback={true} 
                                    // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}InputNumber
                                    , initialValue: dxxxFormData ? dxxxFormData.ptrs : ""
                                },
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_number___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u968F\u884C\u4EBA\u6570' })
                            ) : __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314'
                                },
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                        'span',
                                        { style: { color: 'red' }, className: 'jsx-1702183314'
                                        },
                                        '*'
                                    ),
                                    '\u5230\u6821\u968F\u884C\u4EBA\u6570\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                    'div',
                                    {
                                        style: { display: 'inline' },
                                        className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                    },
                                    dxxxFormData ? dxxxFormData.ptrs : ''
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            jbxx ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314'
                                },
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_22__components_common_NHFormItem_index__["a" /* default */],
                                    { id: 'sfzs',
                                        label: __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                            'span',
                                            {
                                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                            },
                                            '\u662F\u5426\u4F4F\u5BBF\uFF1A'
                                        ),
                                        colon: false,
                                        form: form,
                                        required: true
                                        // hasFeedback={true} 
                                        // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}
                                        , initialValue: dxxxFormData ? dxxxFormData.sfzs : ""
                                    },
                                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_radio___default.a.Group,
                                        { onChange: this.sfzsOnChange, value: sfzsValue, style: { display: "flex", margin: "10px" } },
                                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_radio___default.a,
                                            { value: '1' },
                                            '\u7533\u8BF7\u4F4F\u5BBF'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_radio___default.a,
                                            { value: '0' },
                                            '\u4E0D\u7533\u8BF7\u4F4F\u5BBF'
                                        )
                                    )
                                )
                            ) : __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314'
                                },
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                        'span',
                                        { style: { color: 'red' }, className: 'jsx-1702183314'
                                        },
                                        '*'
                                    ),
                                    '\u662F\u5426\u4F4F\u5BBF\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                    'div',
                                    {
                                        style: { display: 'inline' },
                                        className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                    },
                                    dxxxFormData ? dxxxFormData.sfzs == '1' ? "申请住宿" : dxxxFormData.sfzs == '0' ? "不申请住宿" : "" : ''
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'p-swc'
                            },
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                                },
                                jbxx ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 'jsx-1702183314'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_22__components_common_NHFormItem_index__["a" /* default */],
                                        { id: 'jtgj',
                                            label: __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                                'span',
                                                {
                                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                                },
                                                '\u5230\u6821\u65B9\u5F0F\uFF1A'
                                            ),
                                            colon: false,
                                            form: form,
                                            required: true,
                                            initialValue: dxxxFormData ? dxxxFormData.jtgj : ""
                                        },
                                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                            'div',
                                            {
                                                className: 'jsx-1702183314'
                                            },
                                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_radio___default.a.Group,
                                                { onChange: this.dxfsOnChange, value: dxfsValue, style: { display: "flex", margin: "10px" } },
                                                dxjtList.map(function (item, index) {
                                                    return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_radio___default.a,
                                                        { value: item.VALUE },
                                                        item.LABEL
                                                    );
                                                })
                                            )
                                        )
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 'jsx-1702183314'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                            'span',
                                            { style: { color: 'red' }, className: 'jsx-1702183314'
                                            },
                                            '*'
                                        ),
                                        '\u5230\u6821\u65B9\u5F0F\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                        'div',
                                        {
                                            style: { display: 'inline' },
                                            className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                        },
                                        dxxxFormData ? dxxxFormData.jtgjmc : ''
                                    )
                                )
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_26__components_common_NHModal__["a" /* default */],
                    {
                        ref: function ref(form) {
                            _this2.nhModal = form;
                        },
                        title: '\u4F4F\u5BBF\u534F\u8BAE',
                        width: "60%"
                        // style={{width:"70%"}}
                        , onOk: this.handleOk,
                        footer: footer,
                        onCancel: this.handleCancel
                    },
                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314'
                        },
                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.xyContent }, className: 'jsx-1702183314'
                        }),
                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_checkbox___default.a,
                            { onChange: this.onChangeCheck, checked: this.state.ZSXYFlag },
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                'span',
                                { style: { color: "red" }, className: 'jsx-1702183314'
                                },
                                '\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F\u8BE5\u534F\u8BAE\u3002'
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_styled_jsx_style___default.a, {
                    styleId: '1702183314',
                    css: ['.ant-col-md-7{width:100px;}']
                })
            );
        }
    }]);

    return JbxxInitForm;
}(__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component);

var JbxxForm = __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a.create()(JbxxInitForm);

/* unused harmony default export */ var _unused_webpack_default_export = (JbxxForm);

/***/ }),

/***/ 1039:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_date_picker_style__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_json_stringify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__utils_RegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__index_css__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__NHImage_index__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_handlebars_runtime__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_handlebars_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_handlebars_runtime__);






















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }











// import NHImage from '@components/common/NHImage/index'



if (false) {
    module.hot.accept('../index.css', function () {
        require('../index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_20_antd_lib_form___default.a.Item;
// const { RangePicker } = DatePicker;
var dateFormat = 'YYYY-MM-DD ';

var HjqkInitForm = function (_React$Component) {
    _inherits(HjqkInitForm, _React$Component);

    function HjqkInitForm(props) {
        _classCallCheck(this, HjqkInitForm);

        var _this = _possibleConstructorReturn(this, (HjqkInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_prototype_of___default()(HjqkInitForm)).call(this, props));

        _this.cacheHjqkData = function (cb) {
            _this.props.form.validateFields(function (err, values) {
                if (err) return cb(false);
                //判断数据是否全部填写
                var dataList = [];
                var errorPhone = "";
                var errorList = [];
                var xxcjData = {};
                if (_this.state.hjqkData && _this.state.hjqkData.length > 0) {
                    for (var i = 0; i < _this.state.hjqkData.length; i++) {
                        var data = _this.state.hjqkData[i];
                        if (!data.hjmc && !data.hjsj && !data.fjid && !data.operation) {} else {
                            dataList.push(data);
                        }
                    }
                }

                var _this$props = _this.props,
                    cacheFormData = _this$props.cacheFormData,
                    getChildComponent = _this$props.getChildComponent;

                getChildComponent(8, true);
                cacheFormData('hjqk', dataList, true);
                cb(true);
                _this.setState({
                    hjqk: false,
                    hjqkAdd: false,
                    hjqkData: dataList
                });
            });
        };

        _this.onhjqkAdd = function () {
            var _this$state = _this.state,
                hjqkAdd = _this$state.hjqkAdd,
                hjqkData = _this$state.hjqkData;

            if (!hjqkData) {
                hjqkData = [];
            }
            if (hjqkAdd) {
                hjqkData.push({
                    pkid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["c" /* createUuid */])(),
                    hjmc: '',
                    hjsj: '',
                    fjid: '',
                    operation: ''
                });
                _this.setState({
                    hjqkData: hjqkData
                });
            }
            _this.setState({
                hjqkAdd: true
            });
        };

        _this.onhjqkSave = function () {
            var hjqkData = _this.state.hjqkData;

            hjqkData.push();
            _this.setState({
                hjqkData: hjqkData,
                hjqkAdd: false
            });
        };

        _this.onhjqkClose = function (index) {
            var hjqkData = _this.state.hjqkData;

            hjqkData.splice(index, 1);
            _this.setState({
                hjqkData: hjqkData,
                hjqkAdd: true,
                cacheData: _this.deepCopy(hjqkData)
            });
        };

        _this.handleChange = function (value, index, key) {
            var hjqkData = _this.state.hjqkData;
            hjqkData[index][key] = value;
            _this.setState({ hjqkData: hjqkData });
        };

        _this.handleDateChange = function (value, index) {

            var hjqkData = _this.state.hjqkData;
            var hjsj = value ? __WEBPACK_IMPORTED_MODULE_24_moment___default()(value).format(dateFormat) : undefined;
            hjqkData[index]['hjsj'] = hjsj;
            _this.setState({ hjqkData: hjqkData });
        };

        _this.handleFjidChange = function (value, index) {
            var hjqkData = _this.state.hjqkData;
            if (value.constructor.name == 'Array') {
                if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
                    var isFileUpload = false;
                    var array = [];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_get_iterator___default()(value), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var item = _step.value;

                            if (item.hasOwnProperty('uuid') && item['uuid']) {
                                isFileUpload = true;
                                array.push(item['uuid']);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    if (isFileUpload) {
                        hjqkData[index]['fjid'] = array.join(',');
                        _this.setState({ hjqkData: hjqkData });
                    }
                }
            }
        };

        _this.handleFjidRemove = function (value, index) {
            var hjqkData = _this.state.hjqkData;
            var fjData = hjqkData[index]['fjid'];
            var hjqkArr = fjData.split(',');
            for (var i = 0; i < hjqkArr.length; i++) {
                if (hjqkArr[i] == value) {
                    hjqkArr.splice(i, 1);
                }
            }
            hjqkData[index]['fjid'] = hjqkArr.join(',');
            _this.setState({ hjqkData: hjqkData });
        };

        _this.deepCopy = function (obj) {
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                return obj;
            }

            if (_this.isArrayFn(obj)) {
                var newobj = [];
                for (var i = 0; i < obj.length; i++) {
                    newobj.push(_this.deepCopy(obj[i]));
                }
                return newobj;
            } else {
                var _newobj = {};
                for (var attr in obj) {
                    _newobj[attr] = _this.deepCopy(obj[attr]);
                }
                return _newobj;
            }
        };

        _this.isArrayFn = function (value) {
            if (typeof Array.isArray === "function") {
                return Array.isArray(value);
            } else {
                return Object.prototype.toString.call(value) === "[object Array]";
            }
        };

        _this.getImage = function (fjdata) {
            if (fjdata != null && fjdata != '' && __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_json_stringify___default()(fjdata) !== '{}') {
                if ((typeof fjdata === 'undefined' ? 'undefined' : _typeof(fjdata)) === 'object') {
                    var array = [];
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_get_iterator___default()(fjdata), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var item = _step2.value;

                            if (item.hasOwnProperty('uuid') && item['uuid']) {
                                array.push(item['uuid']);
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    fjdata = array;
                } else {
                    fjdata = fjdata.split(",");
                }
                var imageList = _this.imageLists(fjdata);
                return imageList;
            }
        };

        _this.imageLists = function (imageLists) {
            {
                var items = [];

                var _loop = function _loop(key) {
                    var imageList = typeof imageLists[key] == 'string' ? imageLists[key].split(";") : imageLists[key];
                    items.push(__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                        'span',
                        null,
                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('img', { style: { height: "40px", width: "40px", marginRight: "3px" }, src: "anonymity/docrepo/download/file?attachmentId=" + imageList,
                            onClick: function onClick() {
                                _this.handlePreview("isImage", imageList[0]);
                            } })
                    ));
                };

                for (var key in imageLists) {
                    _loop(key);
                }
                return items;
            }
        };

        _this.handlePreview = function (fjmc, fjid) {
            if (fjmc === "isImage") {
                _this.showPreview('anonymity/docrepo/download/file?attachmentId=' + fjid);
            } else {
                window.open('anonymity/docrepo/download/file?attachmentId=' + fjid);
            }
        };

        _this.showPreview = function (url) {
            _this.setState({
                previewImage: url,
                previewVisible: true
            });
        };

        _this.closeModal = function () {
            return _this.setState({ previewVisible: false });
        };

        _this.state = {
            hjqk: false,
            hjqkAdd: false,
            hjqkData: [],
            previewVisible: false
        };
        return _this;
    }

    _createClass(HjqkInitForm, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('hjqkInitData' in nextProps && nextProps.hjqkInitData) {
                if (nextProps.hjqkInitData instanceof Array) {
                    var temp = [].concat(_toConsumableArray(nextProps.hjqkInitData));
                    this.setState({ hjqkData: temp });
                }
            }
        }
    }, {
        key: 'disabledDate',
        value: function disabledDate(current) {
            // Can not select days after today and today
            return current && current > __WEBPACK_IMPORTED_MODULE_24_moment___default()().endOf('day');
        }

        //图片展示


        // 点击文件链接或预览图标时的回调


        //打开图片弹窗

        // 关闭图片弹窗

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                getChildComponent = _props.getChildComponent,
                form = _props.form;
            var _state = this.state,
                hjqk = _state.hjqk,
                hjqkData = _state.hjqkData,
                hjqkAdd = _state.hjqkAdd,
                previewImage = _state.previewImage,
                previewVisible = _state.previewVisible;


            var hjqkColumns = [{
                title: '获奖名称',
                dataIndex: 'hjmc',
                width: '300px',
                render: function render(text, record, index) {
                    return hjqk ? __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this2.handleChange(e.target.value, index, 'hjmc');
                        },
                        style: { width: 140 },
                        placeholder: '\u8BF7\u586B\u5199\u83B7\u5956\u540D\u79F0'
                    }) : text;
                }
            }, {
                title: '获奖时间',
                dataIndex: 'hjsj',
                width: '200px',
                render: function render(text, record, index) {
                    var hjsj = record.hjsj;
                    return hjqk ? __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker___default.a, {
                        value: hjsj ? __WEBPACK_IMPORTED_MODULE_24_moment___default()(hjsj, dateFormat) : undefined,
                        format: dateFormat,
                        onChange: function onChange(value) {
                            _this2.handleDateChange(value, index);
                        }
                    }) : hjsj ? hjsj : '';
                }
            }, {
                title: '附件',
                dataIndex: 'fjid',
                // width: '500px',
                render: function render(text, record, index) {
                    return hjqk ? __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__NHImage_index__["a" /* default */], { numberOfSize: '10', saveType: 'file', disabled: hjqk ? false : true,
                        numberOfLimit: '5',
                        imageList: record.fjid ? record.fjid.split(",") : [],
                        previewImageVisible: 'true',
                        onChange: function onChange(value) {
                            _this2.handleFjidChange(value, index);
                        },
                        onRemove: function onRemove(value) {
                            _this2.handleFjidRemove(value, index);
                        }
                    }) : _this2.getImage(record.fjid ? record.fjid : '');
                }
            }, {
                title: '删除',
                dataIndex: 'operation',
                width: 80,
                render: function render(text, record, index) {
                    if (hjqk) {
                        return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                            'div',
                            { className: 'editable-row-operations' },
                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'a',
                                {
                                    href: 'javascript:;',
                                    onClick: function onClick() {
                                        return _this2.onhjqkClose(index);
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, {
                                    type: 'close',
                                    style: { color: 'red' }
                                })
                            )
                        );
                    }
                    return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                        'a',
                        { href: '#' },
                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, { type: 'delete', style: { color: 'red' } })
                    );
                }
            }];

            if (!hjqk) {
                hjqkColumns.pop();
            }

            return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u83B7\u5956\u60C5\u51B5',
                    onEdit: function onEdit(type) {
                        _this2.setState({
                            hjqk: true,
                            hjqkAdd: true,
                            cacheData: _this2.deepCopy(_this2.state.hjqkData)
                        });
                        getChildComponent(8, false);
                    },
                    onSave: function onSave(cb) {
                        _this2.cacheHjqkData(cb);
                    },
                    onClose: function onClose() {
                        _this2.setState({
                            hjqk: false,
                            hjqkAdd: false,
                            hjqkData: _this2.deepCopy(_this2.state.cacheData)
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_table___default.a, {
                        bordered: true,
                        size: 'middle',
                        pagination: false,
                        dataSource: hjqkData,
                        columns: hjqkColumns
                    }),
                    hjqkAdd && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                        'div',
                        {
                            className: 'mt-10 app__css__app-pages-SelfHelp-commonInfo-__index__btn_add',

                            onClick: function onClick() {

                                _this2.onhjqkAdd();
                            }
                        },
                        '\u6DFB\u52A0\u83B7\u5956\u60C5\u51B5'
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a,
                    {
                        visible: previewVisible,
                        footer: null,
                        onCancel: this.closeModal
                    },
                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement('img', {
                        alt: 'example',
                        style: { width: '100%' },
                        src: previewImage
                    })
                )
            );
        }
    }]);

    return HjqkInitForm;
}(__WEBPACK_IMPORTED_MODULE_21_react___default.a.Component);

var HjqkForm = __WEBPACK_IMPORTED_MODULE_20_antd_lib_form___default.a.create()(HjqkInitForm);
/* harmony default export */ __webpack_exports__["a"] = (HjqkForm);

/***/ }),

/***/ 1040:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_json_stringify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_common_NHPicturesWall_NHPicturesWall_css__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_common_NHPicturesWall_NHPicturesWall_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_common_NHPicturesWall_NHPicturesWall_css__);
















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }







if (false) {
    module.hot.accept('../../../../../components/common/NHPicturesWall/NHPicturesWall.css', function () {
        require('../../../../../components/common/NHPicturesWall/NHPicturesWall.css');
    });
}

var fileDocDownloadPath = 'anonymity/docrepo/download/file?attachmentId=';
var redisDownloadPath = window.baseUrl + '/proData/downloadRedisCacheImage?uuid=';

/**
 * @author weishihuai
 * @date 2018/9/12
 * @time 9:52
 * @Description: 图片墙上传组件
 *
 *   图片墙使用说明：
 *   onRemove: this.onImageRemove.bind(this), 非必须, 图片删除之后回传删除图片给父组件的方法
 *   onChange: this.onChange.bind(this), 非必须, 值改变时执行的方法
 *   numberOfLimit: 2, 必须, 图片墙允许上传的图片张数，超过numberOfLimit上传按钮自动隐藏
 *   numberOfSize: 5,  必须, 图片墙允许上传图片大小的最大值，超过numberOfSize的话直接不上传
 *   saveType: 'file', 必须, 图片墙图片保存的格式，默认为‘file’保存在文档库，‘redis’为缓存在redis,‘base64’保存在内存中，如果需要永久保存文件，建议保存在文档库
 *   cacheTime: 30,  非必须, Redis缓存时长，单位：分钟  超过30分钟redis会删除缓存的图片信息
 *   imageList: ['0264a687-baa4-490f-92f5-e988dcd8d976','0264a687-baa4-490f-92f5-e988dcd8d976'] 非必须, 如果是编辑模式下，需要回显已经保存的图片信息，注意一下需要构造如下类型数据才能显示出来：
 */
var NHPicturesWall = (_temp = _class = function (_React$Component) {
    _inherits(NHPicturesWall, _React$Component);

    function NHPicturesWall(props) {
        _classCallCheck(this, NHPicturesWall);

        var _this = _possibleConstructorReturn(this, (NHPicturesWall.__proto__ || __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default()(NHPicturesWall)).call(this, props));

        _this.isnull = function (value) {
            if (__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_json_stringify___default()(value) === '[]' || value === null || typeof value === "undefined" || typeof value === 'string' && value.trim() === '') {
                return true;
            } else {
                return false;
            }
        };

        _this.handlePreview = function (file) {
            _this.setState({
                previewImageUrl: file.url || file.thumbUrl,
                previewImageName: file.name,
                previewImageVisible: true
            });
        };

        _this.handlePreviewCancel = function () {
            _this.setState({
                previewImageVisible: false
            });
        };

        _this.handleChange = function (e) {
            var saveType = _this.props.saveType || 'file';
            var fileList = e.fileList;
            var fileStatus = e.file.status;
            if (fileStatus === 'uploading') {//上传中
            } else if (fileStatus === 'done') {
                //上传成功
                var response = e.file.response;
                if (!response) {
                    __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error("抱歉，文件由于未知原因上传失败!");
                    return;
                }
                var responseMeta = response.meta;
                if (saveType === 'file') {
                    //上传到文档库
                    //上传成功(success为true并且响应码为200)
                    if (responseMeta && responseMeta.success && responseMeta.statusCode === 200) {
                        fileList = fileList.map(function (file) {
                            if (file.uid === e.file.uid) {
                                file.uuid = response.data.ssbh;
                                //file.uuid = response.data.bh;
                            }
                            return file;
                        });

                        _this.getUploadedImage(fileList, 'file');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error("抱歉，文件由于未知原因上传失败!");
                        //过滤上传失败的图片
                        fileList = _this.filterUploadFailFile(e.fileList, e.file);
                    }
                } else if (saveType === 'redis') {
                    //缓存Redis
                    //缓存成功(响应码为200)
                    if (response.code === 200) {
                        fileList = fileList.map(function (file) {
                            if (file.uid === e.file.uid) {
                                file.uuid = response.data;
                            }
                            return file;
                        });
                        _this.getUploadedImage(fileList, 'redis');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error("抱歉，文件由于未知原因上传失败!");
                        //过滤上传失败的图片
                        fileList = _this.filterUploadFailFile(e.fileList, e.file);
                    }
                } else if (saveType === 'base64') {
                    //用于保存数据库
                    _this.getImageBase64(e.file.originFileObj, function (imageUrl) {
                        //上传成功
                        if (response.code === 200) {
                            fileList = fileList.map(function (file) {
                                if (file.uid === e.file.uid) {
                                    file.uuid = imageUrl;
                                    file.base64Url = imageUrl;
                                } else {
                                    file.base64Url = file.thumbUrl || file.url;
                                }
                                return file;
                            });
                            _this.getUploadedImage(fileList, 'base64');
                        } else {
                            __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error("抱歉，文件由于未知原因上传失败!");
                            //过滤上传失败的图片
                            fileList = _this.filterUploadFailFile(e.fileList, e.file);
                        }
                    });
                }
            } else if (fileStatus === 'error') {
                //上传出错
                __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error("抱歉，文件由于未知原因上传失败!");
                //过滤上传失败的图片
                fileList = _this.filterUploadFailFile(e.fileList, e.file);
            }
            if (fileStatus) {
                var uploadFlag = fileStatus === 'uploading';
                _this.setState({
                    uploadFlag: uploadFlag,
                    uploadedImageList: fileList
                });
            }
        };

        _this.getImageBase64 = function (img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        };

        _this.filterUploadFailFile = function (list, failUploadedFile) {
            return list.filter(function (file) {
                return file.uid !== failUploadedFile.uid;
            });
        };

        _this.getUploadedImage = function (fileList, saveType) {
            if (saveType === 'base64') {
                var uploadedImageList = [];
                fileList.map(function (file) {
                    var obj = {
                        uuid: file.uuid,
                        base64Url: file.base64Url
                    };
                    uploadedImageList.push(obj);
                });

                //父组件回调方法，在父组件可以拿到已经上传成功的图片信息
                if (_this.props.onChange && typeof _this.props.onChange === "function") {
                    _this.props.onChange(uploadedImageList);
                }
            } else {
                var _uploadedImageList = [];
                fileList.map(function (file) {
                    var obj = {
                        uuid: file.uuid
                    };
                    _uploadedImageList.push(obj);
                });

                //父组件回调方法，在父组件可以拿到已经上传成功的图片信息
                if (_this.props.onChange && typeof _this.props.onChange === "function") {
                    _this.props.onChange(_uploadedImageList);
                }
            }
        };

        _this.handelBeforeUpload = function (file) {
            var fileType = file.type;
            var fileName = file.name;
            //判断是否支持该文件格式
            var isInvalidFileType = !fileType || fileType.length < 1;
            if (isInvalidFileType) {
                __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error('抱歉，不支持上传该格式的文件！');
                return !isInvalidFileType;
            }

            var availFileSuffix = ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.gif', '.GIF'];
            var fileSuffixName = fileName.substring(file.name.lastIndexOf('.'));
            var isAvailableSuffix = availFileSuffix.includes(fileSuffixName);
            if (!isAvailableSuffix) {
                var msg = '抱歉，只支持上传【' + availFileSuffix.join(' || ') + '】格式的文件！';
                __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error(msg);
                return isAvailableSuffix;
            }

            //限制上传文件大小(默认上传大小限制2MB)
            var availSize = _this.props.numberOfSize || 2;
            var fileSize = file.size / 1024 / 1024;
            var isOverSize = fileSize > availSize;

            if (isOverSize) {
                var _msg = '抱歉，上传文件大小最大不能超过' + availSize + 'M！';
                __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error(_msg);
                return !isOverSize;
            }
            return true;
        };

        _this.handleRemove = function (file) {
            var uploadedImageList = _this.state.uploadedImageList;
            for (var index = 0, len = uploadedImageList.length; index < len; index++) {
                if (uploadedImageList[index].uid === file.uid) {
                    uploadedImageList.splice(index, 1);
                    break;
                }
            }
            _this.setState({
                uploadedImageList: uploadedImageList
            });

            //组装数据返回给父组件，包含文档库的uuid以及文件名称
            var imageList = [];
            uploadedImageList.length > 0 && uploadedImageList.map(function (file) {
                var obj = { uuid: file.uuid };
                imageList.push(obj);
            });

            if (_this.props.onChange && typeof _this.props.onChange === 'function') {
                _this.props.onChange(imageList);
            }

            //如果有需要对删除的图片做删除文档库等操作，回传给父组件进行处理
            if (_this.props.onRemove && typeof _this.props.onRemove === 'function') {
                _this.props.onRemove(file.uuid);
            }
        };

        _this.state = {
            uploadedImageList: [], //已上传图片
            previewImageVisible: false, //是否预览图片标识
            previewImageUrl: '', //预览图片的URL
            previewImageName: '' //预览图片的名称
        };
        return _this;
    }

    //设置props默认值


    _createClass(NHPicturesWall, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('imageList' in nextProps) {
                var imageList = this.isnull(nextProps.imageList);
                var thisImageList = this.isnull(this.props.imageList);
                var uploadFlag = this.state.uploadFlag;

                if (imageList && !thisImageList) {
                    this.setState({ uploadedImageList: [] });
                } else if (!uploadFlag && !imageList && __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_json_stringify___default()(nextProps.imageList) !== __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_json_stringify___default()(this.props.imageList)) {
                    var saveType = nextProps.saveType || 'file';
                    var uploadedImageList = [];
                    nextProps.imageList.map(function (uuid) {
                        uploadedImageList.push({
                            uuid: uuid,
                            uid: uuid,
                            url: saveType === 'file' ? fileDocDownloadPath + uuid : redisDownloadPath + uuid
                        });
                    });
                    this.setState({
                        uploadedImageList: uploadedImageList
                    });

                    var _imageList = [];
                    uploadedImageList.map(function (file) {
                        var obj = { uuid: file.uuid };
                        _imageList.push(obj);
                    });
                }
            }
        }
    }, {
        key: 'componentWillMount',


        //组件render之前组装已经上传成功的图片信息uploadedImageList,主要用于回显图片
        value: function componentWillMount() {
            var saveType = this.props.saveType || 'file';
            if (this.props.imageList != undefined) {
                if (saveType === 'base64') {
                    if (this.props.imageList.length > 0) {
                        var uploadedImageList = [];
                        this.props.imageList.map(function (base64Code) {
                            uploadedImageList.push({
                                uuid: base64Code,
                                uid: base64Code,
                                url: base64Code
                            });
                        });
                        this.setState({
                            uploadedImageList: uploadedImageList
                        });

                        var imageList = [];
                        uploadedImageList.map(function (file) {
                            var obj = {
                                uuid: file.uuid,
                                base64Url: file.url
                            };
                            imageList.push(obj);
                        });

                        if (this.props.onChange && typeof this.props.onChange === "function") {
                            this.props.onChange(imageList);
                        }
                    }
                } else {
                    if (this.props.imageList.length > 0) {
                        var _uploadedImageList2 = [];
                        this.props.imageList.map(function (uuid) {
                            if ((typeof uuid === 'undefined' ? 'undefined' : _typeof(uuid)) === 'object') {
                                uuid = uuid['uuid'];
                            }
                            _uploadedImageList2.push({
                                uuid: uuid,
                                uid: uuid,
                                url: saveType === 'file' ? fileDocDownloadPath + uuid : redisDownloadPath + uuid
                            });
                        });
                        this.setState({
                            uploadedImageList: _uploadedImageList2
                        });

                        var _imageList2 = [];
                        _uploadedImageList2.map(function (file) {
                            var obj = { uuid: file.uuid };
                            _imageList2.push(obj);
                        });

                        if (this.props.onChange && typeof this.props.onChange === "function") {
                            this.props.onChange(_imageList2);
                        }
                    }
                }
            }
        }

        //图片预览事件


        //取消图片预览事件


        //文件上传改变事件


        //获取图片Base64


        //过滤上传失败的图片


        //获取上传成功的图片


        //上传文件之前的钩子，参数为准备上传的文件，若返回 false 则停止上传
        //一般在beforeUpload方法内限制文件上传的格式以及大小


        //删除图片事件

    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                previewImageVisible = _state.previewImageVisible,
                previewImageUrl = _state.previewImageUrl,
                uploadedImageList = _state.uploadedImageList,
                previewImageName = _state.previewImageName;

            var numberOfLimit = this.props.numberOfLimit || 1; //默认最多上传一张图片
            var saveType = this.props.saveType || 'file'; //默认上传到文档库
            var redisCacheTime = this.props.cacheTime || 30; //Redis默认保存时长，单位：分钟

            var uploadButton = __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon___default.a, { type: 'plus' }),
                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    'div',
                    { className: 'xgui-picturewall-ant-upload-text' },
                    'Upload'
                )
            );

            //根据saveType构造上传的url
            var action = saveType === 'file' ? 'anonymity/docrepo/upload' : saveType === 'redis' ? window.baseUrl + '/proData/uploadRedis' : this.props.base64UploadUrl;
            //请求发送的数据
            var requestData = saveType === 'file' ? {
                uuid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHCore__["c" /* createUuid */])(),
                type: '1'
            } : saveType === 'redis' ? {
                'redisData': redisCacheTime
            } : {};

            var params = {
                name: 'file',
                action: action, //图片上传路径
                accept: 'image/*', //接受上传的文件类型,指定为image/**的话，弹出选择文件窗口的时候只会显示图片类型文件，过滤掉.txt、.xsl等非图片文件
                listType: 'picture-card', //图片墙样式
                multiple: false, //是否允许多选
                fileList: uploadedImageList, //已上传的图片
                data: requestData, //上传所需参数
                onRemove: this.handleRemove, //删除执行的方法
                beforeUpload: this.handelBeforeUpload, //图片上传前执行的方法
                onPreview: this.handlePreview, //预览图片执行的方法
                onChange: this.handleChange //值改变执行的方法
            };

            return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                'div',
                { className: 'clearfix' },
                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default.a,
                    params,
                    uploadedImageList.length >= numberOfLimit ? null : uploadButton
                ),
                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal___default.a,
                    { visible: previewImageVisible, footer: null, onCancel: this.handlePreviewCancel },
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('img', { alt: previewImageName, style: { width: '100%' }, src: previewImageUrl })
                )
            );
        }
    }]);

    return NHPicturesWall;
}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component), _class.defaultProps = {
    saveType: 'file', //保存的类型，默认为file文档库，可选的值: 'file'(上传文档库)、'base64'(保存数据库)、'redis'(缓存redis)
    imageList: [], //设置默认上传的图片 格式:imageList: [{ uid: '对应文档库uuid', name: '图片名称',status: 'done', url: '图片url'}]
    cacheTime: 30, //设置Redis缓存的时间，单位：分钟 表示Redis超过30分钟会删除缓存的信息
    numberOfLimit: 1, //最多允许上传多少张图片 默认为1张
    numberOfSize: 2, //默认上传大小限制2MB
    disabled: false, //是否禁用
    onRemove: function onRemove() {//删除成功回调
    },
    onChange: function onChange() {}, //值改变时的回调
    base64UploadUrl: '' //base64上传图片路径
}, _temp);

//属性检查

NHPicturesWall.PropTypes = {
    saveType: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.string, //保存的类型
    imageList: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.array, //初始化图片信息
    cacheTime: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.number, //Redis缓存时间
    numberOfLimit: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.number, //允许上传的图片张数
    numberOfSize: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.number, //允许上传的图片大小
    disabled: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.bool, //是否禁用
    base64UploadUrl: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.string, //base64图片上传路径
    onRemove: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.func, //删除成功回调
    onChange: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.func //值改变回调
};

/* harmony default export */ __webpack_exports__["a"] = (NHPicturesWall);

/***/ }),

/***/ 1041:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_common_NHCascader__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__utils_RegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__index_css__);













var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }












if (false) {
    module.hot.accept('../index.css', function () {
        require('../index.css');
    });
}

var uploadUrl = "api/zhxg-yxwz/newStudent/cacheStudentPhoto"; //上传logo路径


function beforeUpload(file) {

    var isJPG = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJPG) {
        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("You can only upload JPG file!");
    }
    var isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("Image must smaller than 2MB!");
    }
    return isJPG && isLt2M;
}

var JbxxInitForm = function (_React$Component) {
    _inherits(JbxxInitForm, _React$Component);

    function JbxxInitForm(props) {
        _classCallCheck(this, JbxxInitForm);

        var _this = _possibleConstructorReturn(this, (JbxxInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(JbxxInitForm)).call(this, props));

        _this.getStudentPhotoBase64 = function (userId, callback) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/openapi/student/getStudentPhotoBase64', 'get', { xsid: userId, type: 10 }).then(function (res) {
                if (res && res.code == 200) {
                    callback(res.data);
                }
            });
        };

        _this.onSavejbxxFormData = function (cb) {
            _this.props.form.validateFields(function (error, values) {
                if (error) {
                    cb(false);
                    return;
                }
                cb(true);
                var cacheFormData = _this.props.cacheFormData;

                if (_this.state.jtdzDetail !== '') {
                    values['jtdzDetail'] = _this.state.jtdzDetail;
                } else {
                    values['jtdzDetail'] = _this.props.jbxxFormData ? _this.props.jbxxFormData.jtdzDetail ? _this.props.jbxxFormData.jtdzDetail : "" : "";
                }
                var jtszdqArray = values.jtszdqArray;
                if (jtszdqArray.length > 0) {
                    var num = jtszdqArray.length;
                    values['jtszdq'] = jtszdqArray[num - 1];
                }

                cacheFormData('jbxx_hnyz', values);
                _this.setState({
                    jbxx: false
                });
            });
        };

        _this.handleUploadChange = function (info) {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (info && info['file'] && info['file'].status === 'done') {
                var photoUUID = info['file'].response.data;
                if (photoUUID) {
                    var url = '/newStudent/saveStudentPhoto?xsid=' + userId + '&photoUUID=' + photoUUID + '&type=' + '10';
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])(url, 'POST').then(function (res) {
                        if (res && res.data) {
                            __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.success("上传成功!");
                        }
                    });
                }
            }
            _this.getBase64(info.file.originFileObj, function (imageUrl) {
                return _this.setState({ imageUrl: imageUrl });
            });
        };

        _this.onNHCascaderChange = function (value, selectedOptions, type) {
            var label = '';
            if (selectedOptions) {
                selectedOptions.forEach(function (i) {
                    label += i.label;
                });
            }
            if (type == 'jg') {
                _this.setState({ jgmStr: label });
            } else {
                _this.setState({ jtStr: label });
            }
        };

        _this.state = {
            jbxx: false,
            xsid: '',
            userInfoData: {},
            zzmmmList: [],
            mzmList: [],
            textData: '',
            jgmStr: '',
            jtStr: '',
            xsSsInfo: ''
        };
        return _this;
    }

    _createClass(JbxxInitForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                this.getStudentPhotoBase64(userId, function (data) {
                    if (!data) return;
                    _this2.setState({
                        xsid: userId,
                        imageUrl: 'data:image/jpeg;base64,' + data
                    });
                });
            }
        }

        // 获取学生头像

    }, {
        key: 'getBase64',
        value: function getBase64(img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        }
        // 上传图片

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                form = _props.form,
                jbxxFormData = _props.jbxxFormData,
                getChildComponent = _props.getChildComponent,
                stuSsxx = _props.stuSsxx,
                editXszp = _props.editXszp,
                userInfoData = _props.userInfoData;
            var _state = this.state,
                jbxx = _state.jbxx,
                imageUrl = _state.imageUrl,
                tempUrl = _state.tempUrl,
                xsid = _state.xsid;

            var jtjddz = jbxxFormData ? jbxxFormData.jtjddz : '';
            var jtdzDetail = jbxxFormData ? jbxxFormData.jtdzDetail : '';
            var ssxx = '';
            if (stuSsxx && stuSsxx.XQMC && stuSsxx.LDMC && stuSsxx.FJ && stuSsxx.CWH) {
                ssxx = stuSsxx.XQMC + stuSsxx.LDMC + ' - ' + stuSsxx.FJ + ' - ' + stuSsxx.CWH;
            }

            return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a,
                { layout: 'inline' },
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u57FA\u672C\u4FE1\u606F',
                    onEdit: function onEdit(type) {
                        _this3.setState({
                            jbxx: true
                        });
                        getChildComponent(1, false);
                    },
                    onSave: function onSave(cb) {
                        _this3.onSavejbxxFormData(cb);
                        getChildComponent(1, true);
                    },
                    onClose: function onClose() {
                        _this3.setState({
                            jbxx: false
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + '_bg app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_icon'
                        },
                        jbxx && editXszp === "true" ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default.a,
                            {
                                name: 'photo',
                                accept: 'image/*',
                                showUploadList: false,
                                action: uploadUrl + "?xsid=" + xsid,
                                beforeUpload: beforeUpload,
                                onChange: this.handleUploadChange
                            },
                            imageUrl || userInfoData ? imageUrl ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
                                src: imageUrl,
                                alt: '',
                                className: 'jsx-1702183314' + ' ' + 'avatar'
                            }) : tempUrl : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__upload-box'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__upload-title'
                                    },
                                    '\u4E0A\u4F20\u56FE\u7247'
                                )
                            )
                        ) : imageUrl ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
                            src: imageUrl,
                            alt: '',
                            className: 'jsx-1702183314' + ' ' + 'avatar'
                        }) : tempUrl
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */].Item,
                        { className: 'ml-20' },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u59D3\u540D\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.XM : '',
                                userInfoData && userInfoData.XB ? userInfoData.XB === '男' ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(141), alt: '', className: 'jsx-1702183314'
                                }) : userInfoData.XB === '女' ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(142), alt: '', className: 'jsx-1702183314'
                                }) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(143), alt: '', className: 'jsx-1702183314'
                                }) : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u5B66\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.XH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u8003\u751F\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.KSH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u8EAB\u4EFD\u8BC1\u4EF6\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.SFZJH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u51FA\u751F\u5E74\u6708\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.CSRQ : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u653F\u6CBB\u9762\u8C8C\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.ZZMM : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u6C11\u65CF\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.MZ : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u7C4D\u8D2F\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.JG : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u6BD5\u4E1A\u5B66\u6821\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.BYXX : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u9AD8\u8003\u5206\u6570\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.gkcj : ''
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    'div',
                    {
                        className: 'jsx-1702183314' + ' ' + 'p-swc'
                    },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            '\u5B66\u9662\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            userInfoData ? userInfoData.BMMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            '\u4E13\u4E1A\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            userInfoData ? userInfoData.ZYMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            '\u73ED\u7EA7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            userInfoData ? userInfoData.BJMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                        },
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                            { id: 'sjhm',
                                label: __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    '\u672C\u4EBA\u8054\u7CFB\u7535\u8BDD\uFF1A'
                                ),
                                colon: false,
                                form: form,
                                required: true
                                // hasFeedback={true} 
                                // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}
                                , pattern: __WEBPACK_IMPORTED_MODULE_20__utils_RegExp__["FormRules"].MOBILE_PHONE_NUMBER,
                                initialValue: jbxxFormData ? jbxxFormData.sjhm : ""
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u8054\u7CFB\u7535\u8BDD' })
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'red' }, className: 'jsx-1702183314'
                                    },
                                    '*'
                                ),
                                '\u672C\u4EBA\u8054\u7CFB\u7535\u8BDD\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.sjhm : ''
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            '\u5BBF\u820D\u4FE1\u606F\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            ssxx
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            '\u73ED\u7EA7QQ\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            jbxxFormData.bjqq ? jbxxFormData.bjqq : '暂无'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__detail_adrress'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            { style: { lineHeight: '32px' }, className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                { style: { color: 'red' }, className: 'jsx-1702183314'
                                },
                                '*'
                            ),
                            '\u8BE6\u7EC6\u5BB6\u5EAD\u4F4F\u5740\uFF1A'
                        ),
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                            null,
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'jtszdqArray',
                                    label: '',
                                    colon: false,
                                    required: true,
                                    form: form,
                                    initialValue: jbxxFormData ? jbxxFormData.jtszdqArray : []
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_common_NHCascader__["a" /* default */], { style: { width: 432.63 }, sign: "zhxg_ssq", onChange: function onChange(value, selectedOptions) {
                                        return _this3.onNHCascaderChange(value, selectedOptions, 'jt');
                                    }

                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'jtjddz',
                                    label: '',
                                    colon: false,
                                    required: true,
                                    form: form,
                                    pattern: { max: 100, message: "家庭住址长度不能超过100字符！" },
                                    initialValue: jbxxFormData ? jbxxFormData.jtjddz : '' },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 346.07 }, placeholder: '\u8BF7\u586B\u5199\u8BE6\u7EC6\u5BB6\u5EAD\u5730\u5740\uFF0C\u5982\uFF1Axx\u8857\u9053\u3001xx\u5C0F\u533A\u3001\u95E8\u724C\u53F7' })
                            )
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            jtdzDetail ? jtdzDetail : '',
                            jtjddz ? jtjddz : ''
                        )
                    ),
                    userInfoData ? userInfoData.FDY && userInfoData.FDY.length > 0 ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            '\u8F85\u5BFC\u5458\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            userInfoData.FDY.map(function (item, key) {
                                if (item) {
                                    var lxdh = item.LXDH ? "( " + item.LXDH + " )" : "";
                                    return item.XM + lxdh + " ";
                                } else {
                                    return "";
                                }
                            })
                        )
                    ) : null : null,
                    userInfoData ? userInfoData.BZR && userInfoData.BZR.length > 0 ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            '\u73ED\u4E3B\u4EFB\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            userInfoData.BZR.map(function (item, key) {
                                if (item) {
                                    var lxdh = item.LXDH ? "( " + item.LXDH + " )" : "";
                                    return item.XM + lxdh + " ";
                                } else {
                                    return "";
                                }
                            })
                        )
                    ) : null : null
                ),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_styled_jsx_style___default.a, {
                    styleId: '1702183314',
                    css: ['.ant-col-md-7{width:100px;}']
                })
            );
        }
    }]);

    return JbxxInitForm;
}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);

var JbxxForm = __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a.create()(JbxxInitForm);

/* harmony default export */ __webpack_exports__["a"] = (JbxxForm);

/***/ }),

/***/ 1042:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UpdateInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_select__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker_style__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_date_picker__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__index_css__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__JbxxForm__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__JtcyForm__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__dxxxForm__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__lxfsForm__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__KzxxForm__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__zyzxxForm__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__sjz_JbxxForm__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ahgs_JtcyForm__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ahgs_JbxxForm__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__JyjlForm__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ZyshgxForm__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__whgc_JbxxForm__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__hnyz_JbxxForm__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__gxxxzyjsxy_HjqkForm__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__pages_SelfHelp_common_hint__ = __webpack_require__(35);
















var _extends = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }











 //基本信息
 //家庭成员
 //到校信息
 //联系方式
 //扩展信息
 //志愿者信息
 //基本信息（石家庄）
 //家庭成员信息（安徽工商）
 //基本信息（安徽工商）
 //教育经历(安徽工商)
 //主要社会关系
 //基本信息（武汉工程）
 //基本信息(湖南幼专)
 //获奖情况(广西信息职业)






if (false) {
  module.hot.accept("./index.css", function () {
    require("./index.css");
  });
}

var history = __WEBPACK_IMPORTED_MODULE_38_history_createHashHistory___default()();
var RangePicker = __WEBPACK_IMPORTED_MODULE_14_antd_lib_date_picker___default.a.RangePicker;

var Option = __WEBPACK_IMPORTED_MODULE_12_antd_lib_select___default.a.Option;
var stuInfoUrl = "/xxcj/";

var UpdateInfo = function (_React$Component) {
  _inherits(UpdateInfo, _React$Component);

  function UpdateInfo(props) {
    _classCallCheck(this, UpdateInfo);

    var _this = _possibleConstructorReturn(this, (UpdateInfo.__proto__ || __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of___default()(UpdateInfo)).call(this, props));

    _this.queryQztjAndYlhj = function () {
      var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])().userId : "";
      if (!xsid) {
        _this.setState({
          nonOperationalData: { nologin: true },
          operable: false
        });
        return;
      }
      var zzbdhjid = _this.getQueryString("pkid");
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", "GET", {
        xsid: xsid,
        zzbdhjid: zzbdhjid
      }).then(function (res) {
        if (res && res.data) {
          var kfsj = res.data["kfsj"];
          var ylhj = res.data["ylhj"];
          var qzhj = res.data["qzhj"];
          _this.setState({
            nonOperationalData: res.data,
            zzbdhjid: zzbdhjid
          });
          if (kfsj["YXSJ"] != "1") {
            _this.setState({ operable: false });
          }

          if (ylhj && ylhj.length > 0) {
            _this.setState({ operable: false });
          }

          if (qzhj && qzhj.length > 0) {
            _this.setState({ operable: false });
          }
        }
        var sideMenu = _this.refs.siderMenu.state.menuList;
        console.log(sideMenu);
        var blztFlag = "0";
        sideMenu.map(function (item) {
          if (item.HJDM == "GD001_3") {
            blztFlag = item.BLZT;
          }
        });
        _this.setState({
          blztFlag: blztFlag
        });
      });
    };

    _this.getQueryString = function (name) {
      return decodeURIComponent((new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(location.href) || [, ""])[1].replace(/\+/g, "%20")) || null;
    };

    _this.setMenuList = function (menuList) {
      var nextCount = 0;
      var bz = _this.state.mkbz;
      menuList.map(function (elem, index) {
        if (elem.HJDM == bz) {
          var hjmc = elem.HJMC;
          _this.setState({ hjmc: hjmc });
          nextCount = index + 1;
          return;
        }
      });
      var menu = menuList[nextCount];
      if (menu) {
        var hjdm = menu.HJDM;
        if (hjdm.indexOf("GD") == 0) {
          var gdUrl = __WEBPACK_IMPORTED_MODULE_41__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
          _this.setState({
            nextUrl: gdUrl,
            search: "pkid=" + menu.PKID
          });
        } else if (hjdm.indexOf("ZDY") == 0) {
          var zdyUrl = "/customLink";
          _this.setState({
            nextUrl: zdyUrl,
            search: "pkid=" + menu.PKID + "&mkbz=" + hjdm + "&lx=" + menu.LX
          });
        }
      } else {
        _this.setState({
          nextUrl: "",
          search: ""
        });
      }
    };

    _this.getChildComponent = function (flag, mode) {
      // console.log("getChildComponent返回数据",flag,mode,this.state.dxxxInitData);
      switch (flag) {
        case 1:
          _this.setState({ jbxxFlag: mode });
          break;
        case 2:
          _this.setState({ lxfsFlag: mode });
          break;
        case 3:
          _this.setState({ jtcyFlag: mode });
          break;
        case 4:
          _this.setState({ dxxxFlag: mode });
          break;
        case 5:
          _this.setState({ zyzxxFlag: mode });
        case 6:
          _this.setState({ jyjlFlag: mode });
        case 7:
          _this.setState({ zyshgxFlag: mode });
        case 8:
          _this.setState({ hjqkFlag: mode });
        default:
          break;
      }
    };

    _this.cacheFormData = function (type, values, isAdd) {
      if (type.indexOf("jbxx") != -1) {
        var jbxx_CSRQ = values.jbxx_CSRQ,
            rxxx_byxx = values.rxxx_byxx,
            xxcj_ZDYHKSFQY = values.xxcj_ZDYHKSFQY,
            jbxx_zzmmm = values.jbxx_zzmmm,
            jbxx_hkszd = values.jbxx_hkszd,
            jbxx_jgm = values.jbxx_jgm;
        // if (jbxx_CSRQ !== null && rxxx_byxx !== null && jbxx_jgm.length > 0 && xxcj_ZDYHKSFQY !== null && jbxx_zzmmm !== null&&jbxx_hkszd!=null) {

        _this.setState({
          jbxxInitData: _extends({}, values),
          isEditJbxx: true
        }, function () {
          _this.insertData4Yxwz(type);
        });
        /* } else {
                  message.error("存在必填信息未填写，请填写后再保存！")
              } */
      }
      if (type == "jtcy" && isAdd) {
        if (values !== null && values.length > 0) {
          _this.setState({
            jtcyInitData: values,
            isEditJtcy: true
          }, function () {
            _this.insertData4Yxwz(type);
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error("存在必填信息未填写，请填写后再保存！");
        }
      }
      if (type == "dxxx") {
        // console.log("缓存个人信息数据-------",values,type,isAdd);
        var ptrs = values.ptrs,
            jtgj = values.jtgj,
            zsqk_sfzs = values.zsqk_sfzs,
            dxsj = values.dxsj;
        // if (jtgj!== null && zsqk_sfzs !== null  && ptrs !== null && dxsj!== null) {

        _this.setState({
          dxxxInitData: _extends({}, values),
          isEditdxxx: true
        }, function () {
          _this.insertData4Yxwz(type);
        });
        // } else {
        //     message.error("存在必填信息未填写，请填写后再保存！")
        // }
      }
      if (type == "lxxx") {
        // const {jjlxr_gxdm,jjlxr_jjlxr,jjlxr_lxrdh ,lxxx_dzyx, lxxx_qq, lxxx_sjhm,lxxx_wx,jtdzDetail,jtxx_jtjddz,jtjddz} = values;
        // if (jjlxr_gxdm !== null  && jjlxr_jjlxr !== null && jjlxr_lxrdh !== null&&lxxx_dzyx!=null&& lxxx_qq !== null && lxxx_sjhm !== null&&lxxx_wx!=null&&jtdzDetail!=null) {
        //     console.log("缓存个人信息数据-------",values,type,isAdd);
        _this.setState({
          lxxxInitData: _extends({}, values),
          isEditlxxx: true
        }, function () {
          _this.insertData4Yxwz(type);
        });
        // } else {
        //     message.error("存在必填信息未填写，请填写后再保存！")
        // }
      }
      if (type == "jyjl") {
        _this.setState({
          jyjlInitData: values,
          isEditJyjl: true
        }, function () {
          _this.insertData4Yxwz(type);
        });
      }
      if (type == "zyshgx") {
        _this.setState({
          zyshgxInitData: values,
          isEditZyshgx: true
        }, function () {
          _this.insertData4Yxwz(type);
        });
      }
      if (type == "hjqk" && isAdd) {
        _this.setState({
          hjqkInitData: values,
          isEditHjqk: true
        }, function () {
          _this.insertData4Yxwz(type);
        });
      }
    };

    _this.getData4Yxwz = function () {
      var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
      if (userId) {
        _this.setState({ xsid: userId });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])("/newStudent/queryXsInfo", "GET", { xsid: userId }).then(function (res) {
          if (res && res.data) {
            console.log(res.data);
            var stuInfo = res.data.stuInfo;
            var stuXxcj = res.data.stuXxcj;
            var stuSsxx = res.data.stuSsxx;
            var editXszp = res.data.editXszp;
            _this.setState({
              userBaseInfo: stuInfo.userBaseInfo,
              jbxxInitData: stuInfo.xsJbxx4YxwzVO,
              lxxxInitData: stuInfo.xsJbxx4YxwzVO,
              dxxxInitData: stuInfo.xsJbxx4YxwzVO,
              jtcyInitData: stuInfo.jtcyVo,
              zyshgxInitData: stuInfo.zyshgxVO,
              jyjlInitData: stuInfo.jyjlVO,
              hjqkInitData: stuInfo.hjqkVO,
              kzxxInitData: _extends({}, stuXxcj),
              stuSsxx: stuSsxx,
              editXszp: editXszp
            });
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error("登录超时,请重新登录！");
      }
    };

    _this.insertData4Yxwz = function (type) {
      var _this$state = _this.state,
          jbxxInitData = _this$state.jbxxInitData,
          jtcyInitData = _this$state.jtcyInitData,
          lxxxInitData = _this$state.lxxxInitData,
          dxxxInitData = _this$state.dxxxInitData,
          zyshgxInitData = _this$state.zyshgxInitData,
          jyjlInitData = _this$state.jyjlInitData,
          xsid = _this$state.xsid,
          zzbdhjid = _this$state.zzbdhjid,
          hjqkInitData = _this$state.hjqkInitData;

      var flbs = "";
      var xsxx = {};
      var jtcyVo = [];
      var zyshgxVO = [];
      var jyjlVO = [];
      var hjqkVO = [];
      var xsInfo4YxwzVO = {};
      console.log(type);
      if (type == "jbxx") {
        xsInfo4YxwzVO = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()(xsxx, jbxxInitData);
        flbs = "jbxx";
      } else if (type == "jbxx_sjz") {
        xsInfo4YxwzVO = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()(xsxx, jbxxInitData);
        flbs = "jbxx_sjz";
      } else if (type == "jbxx_whgc") {
        xsInfo4YxwzVO = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()(xsxx, jbxxInitData);
        flbs = "jbxx_whgc";
      } else if (type == "jbxx_ahgs") {
        xsInfo4YxwzVO = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()(xsxx, jbxxInitData);
        flbs = "jbxx_ahgs";
      } else if (type == "jbxx_hnyz") {
        xsInfo4YxwzVO = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()(xsxx, jbxxInitData);
        flbs = "jbxx_hnyz";
      } else if (type == "jtcy") {
        jtcyVo = jtcyInitData;
        flbs = "jtxx";
      } else if (type == "jtxx_ahgs") {
        jtcyVo = jtcyInitData;
        flbs = "jtxx_ahgs";
      } else if (type == "jyjl") {
        jyjlVO = jyjlInitData;
        flbs = "jyjl";
      } else if (type == "zyshgx") {
        zyshgxVO = zyshgxInitData;
        flbs = "zyshgx";
      } else if (type == "lxxx") {
        xsInfo4YxwzVO = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()(xsxx, lxxxInitData);
        flbs = "lxxx";
      } else if (type == "dxxx") {
        xsInfo4YxwzVO = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()(xsxx, dxxxInitData);
        flbs = "dxxx";
      } else if (type == "hjqk") {
        hjqkVO = hjqkInitData;
        flbs = "hjqk";
      }
      xsInfo4YxwzVO = {
        xsid: xsid,
        xsxx: xsxx,
        flbs: flbs
      };
      // 增加判断社会关系，家庭成员，教育经历编辑其中一个时，另外两个不要传空
      if (type.indexOf("jyjl") !== -1) {
        xsInfo4YxwzVO["jyjlVO"] = jyjlVO;
      } else if (type.indexOf("jtcy") !== -1) {
        xsInfo4YxwzVO["jtcyVo"] = jtcyVo;
      } else if (type.indexOf("zyshgx") !== -1) {
        xsInfo4YxwzVO["zyshgxVO"] = zyshgxVO;
      } else if (type.indexOf("hjqk") !== -1) {
        xsInfo4YxwzVO["hjqkVO"] = hjqkVO;
      }
      console.log(xsInfo4YxwzVO);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])("/newStudent/saveOrUpdateXsInfo", "POST", xsInfo4YxwzVO).then(function (res) {
        if (res && res.code == 200) {
          console.log(res);
          __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.success("保存成功");
          _this.getData4Yxwz();
        } else {
          __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error("保存失败");
        }
      });
    };

    _this.getPersonConfig = function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])("api/zhxg-yxxt/yxwz/getXxcjFl", "get").then(function (res) {
        if (res && res.code == 200) {
          console.log("res", res);
          _this.setState({
            Typeconfig: res.data
          });
        }
      });
    };

    _this.reloadMenu = function () {
      _this.refs.siderMenu.reloadMenuList();
    };

    _this.handelData = function () {
      _this.setState({
        uploading: true
      });
      var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
      var hjblFlag = true;
      /* if(this.state.blztFlag=="1"){
              hjblFlag = true
          } */
      var params = {
        xsid: xsid,
        hjblFlag: hjblFlag,
        zzbdhjid: _this.state.zzbdhjid
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])("/zzbd/stuInfoSubmit", "post", params).then(function (res) {
        if (res && res.code == 200) {
          if (res.data != null && res.data.code == "1") {
            _this.refs.siderMenu.reloadMenuList();
            __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.success("提交成功");
            _this.setState({
              bkbjFlage: true,
              hjblFlag: true,
              uploading: false
            });
            _this.queryQztjAndYlhj();
          } else if (res.data != null && res.data.code == "0") {
            __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error(res.data.msg);
            _this.setState({
              uploading: false
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error("个人信息环节提交失败");
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error("个人信息环节提交失败");
        }
      });
    };

    _this.state = {
      mkbz: "GD001_3",
      hjmc: "",
      jbxxFormData: {},
      formInitData: {},
      jbxxInitData: {},
      lxxxInitData: {},
      dxxxInitData: {},
      jtcyInitData: [],
      zyshgxInitData: [],
      jyjlInitData: [],
      kzxxInitData: {},
      userBaseInfo: {},
      stuSsxx: {},
      hjqkInitData: {},
      xsid: "",
      jbxxFlag: true,
      lxfsFlag: true,
      dxxxFlag: true,
      jtcyFlag: true,
      jyjlFlag: true,
      zyshgxFlag: true,
      nextUrl: "", //左侧菜单加载完后传进来
      search: "",
      operable: true, //是否显示环节
      nonOperationalData: {}, //不可操作的数据
      isEditJbxx: false,
      isEditJtcy: false,
      isEditZyshgx: false,
      isEditJyjl: false,
      isEditHjqk: false,
      menuList: [],
      zzbdhjid: "",
      Typeconfig: [], //分类采集数据
      bkbjFlage: false,
      blztFlag: "0", //环节办理状态
      uploading: false
    };
    return _this;
  }

  _createClass(UpdateInfo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getPersonConfig();
      this.queryQztjAndYlhj();
      //this.getYlhjData();
      this.getData4Yxwz();
    }

    //查询前置条件和依赖环节


    //缓存编写的信息，缓存完之后提交


    //获取个人信息初始数据


    // 单个保存个人信息数据


    // 获取个人信息采集分类配置


    //重新加载菜单


    //提交

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          xsid = _state.xsid,
          jtcyInitData = _state.jtcyInitData,
          zyshgxInitData = _state.zyshgxInitData,
          Typeconfig = _state.Typeconfig,
          bkbjFlage = _state.bkbjFlage,
          blztFlag = _state.blztFlag,
          hjqkInitData = _state.hjqkInitData;

      return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
        "div",
        null,
        this.state.operable ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */],
          { className: "w1180 mt-20", align: "start" },
          __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_Assembly_siderMenu__["a" /* default */], {
            ref: "siderMenu",
            setMenuList: this.setMenuList,
            title: "\u81EA\u52A9\u62A5\u5230"
            /*   active={0}*/
            , mkbz: this.state.mkbz,
            menuType: "\u81EA\u52A9\u62A5\u5230"
          }),
          __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */].Item,
            { className: "page_con_r" },
            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_Assembly_Breadcrumb__["a" /* default */], {
              noLine: true,
              list: [{ name: "首页", url: "/index" }, { name: "自助报到", url: "/register" }, { name: this.state.hjmc }]
            }),
            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin___default.a,
              { spinning: this.state.uploading },
              __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                "div",
                { className: "box" },
                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__pages_SelfHelp_common_hint__["a" /* default */], null),
                Typeconfig.map(function (item) {
                  if (item.FLBS == "jbxx" && item.SFXS == "1") {
                    return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__JbxxForm__["a" /* default */], {
                      ref: "refJbxxForm",
                      jbxxFormData: _this2.state.jbxxInitData,
                      getChildComponent: _this2.getChildComponent,
                      cacheFormData: _this2.cacheFormData,
                      userInfoData: _this2.state.userBaseInfo,
                      stuSsxx: _this2.state.stuSsxx,
                      editXszp: _this2.state.editXszp,
                      kzxxInitData: _this2.state.kzxxInitData.zdglVOs,
                      SFBT: item.SFBT,
                      blztFlag: _this2.state.blztFlag
                    });
                  }
                  if (item.FLBS == "jbxx_ahgs" && item.SFXS == "1") {
                    //安徽工商个人基本信息
                    return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__ahgs_JbxxForm__["a" /* default */], {
                      ref: "refJbxxForm_ahgs",
                      jbxxFormData: _this2.state.jbxxInitData,
                      getChildComponent: _this2.getChildComponent,
                      cacheFormData: _this2.cacheFormData,
                      userBaseInfo: _this2.state.userBaseInfo,
                      stuSsxx: _this2.state.stuSsxx,
                      editXszp: _this2.state.editXszp,
                      SFBT: item.SFBT,
                      blztFlag: _this2.state.blztFlag
                    });
                  }
                  if (item.FLBS == "jbxx_hnyz" && item.SFXS == "1") {
                    return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__hnyz_JbxxForm__["a" /* default */], {
                      ref: "refJbxxForm_hnyz",
                      jbxxFormData: _this2.state.jbxxInitData,
                      getChildComponent: _this2.getChildComponent,
                      cacheFormData: _this2.cacheFormData,
                      userInfoData: _this2.state.userBaseInfo,
                      stuSsxx: _this2.state.stuSsxx,
                      editXszp: _this2.state.editXszp,
                      SFBT: item.SFBT,
                      blztFlag: _this2.state.blztFlag
                    });
                  }
                  if (item.FLBS == "lxxx" && item.SFXS == "1") {
                    return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__lxfsForm__["a" /* default */], {
                      ref: "refJbxxForm",
                      lxxxFormData: _this2.state.lxxxInitData,
                      getChildComponent: _this2.getChildComponent,
                      cacheFormData: _this2.cacheFormData,
                      userInfoData: _this2.state.userBaseInfo,
                      stuSsxx: _this2.state.stuSsxx,
                      editXszp: _this2.state.editXszp,
                      SFBT: item.SFBT,
                      blztFlag: _this2.state.blztFlag
                    });
                  }
                  if (item.FLBS == "jbxx_sjz" && item.SFXS == "1") {
                    return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__sjz_JbxxForm__["a" /* default */], {
                      ref: "refJbxxForm",
                      jbxxFormData: _this2.state.jbxxInitData,
                      getChildComponent: _this2.getChildComponent,
                      cacheFormData: _this2.cacheFormData,
                      userInfoData: _this2.state.userBaseInfo,
                      stuSsxx: _this2.state.stuSsxx,
                      editXszp: _this2.state.editXszp,
                      kzxxInitData: _this2.state.kzxxInitData.zdglVOs,
                      SFBT: item.SFBT,
                      blztFlag: _this2.state.blztFlag
                    });
                  }
                  if (item.FLBS == "jbxx_whgc" && item.SFXS == "1") {
                    return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__whgc_JbxxForm__["a" /* default */], {
                      ref: "refJbxxForm",
                      jbxxFormData: _this2.state.jbxxInitData,
                      getChildComponent: _this2.getChildComponent,
                      cacheFormData: _this2.cacheFormData,
                      userInfoData: _this2.state.userBaseInfo,
                      stuSsxx: _this2.state.stuSsxx,
                      editXszp: _this2.state.editXszp,
                      SFBT: item.SFBT,
                      blztFlag: _this2.state.blztFlag
                    });
                  }
                  if (item.FLBS == "jtxx" && item.SFXS == "1") {
                    return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__JtcyForm__["a" /* default */], {
                      ref: "refJtcyForm",
                      jtcyInitData: jtcyInitData,
                      getChildComponent: _this2.getChildComponent,
                      cacheFormData: _this2.cacheFormData,
                      SFBT: item.SFBT,
                      blztFlag: _this2.state.blztFlag
                    });
                  }

                  if (item.FLBS == "jtxx_ahgs" && item.SFXS == "1") {
                    return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__ahgs_JtcyForm__["a" /* default */], {
                      ref: "refJtcyForm_ahgs",
                      jtcyInitData: jtcyInitData,
                      getChildComponent: _this2.getChildComponent,
                      cacheFormData: _this2.cacheFormData,
                      SFBT: item.SFBT,
                      blztFlag: _this2.state.blztFlag
                    });
                  }

                  if (item.FLBS == "jyjl" && item.SFXS == "1") {
                    return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__JyjlForm__["a" /* default */], {
                      ref: "refJyjlForm_ahgs",
                      jyjlInitData: _this2.state.jyjlInitData,
                      getChildComponent: _this2.getChildComponent,
                      cacheFormData: _this2.cacheFormData,
                      SFBT: item.SFBT,
                      blztFlag: _this2.state.blztFlag
                    });
                  }

                  if (item.FLBS == "zyshgx" && item.SFXS == "1") {
                    return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__ZyshgxForm__["a" /* default */], {
                      ref: "refZyshgxForm_ahgs",
                      zyshgxInitData: _this2.state.zyshgxInitData,
                      getChildComponent: _this2.getChildComponent,
                      cacheFormData: _this2.cacheFormData,
                      SFBT: item.SFBT,
                      blztFlag: _this2.state.blztFlag
                    });
                  }

                  if (item.FLBS == "zyzxx" && item.SFXS == "1") {
                    return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__zyzxxForm__["a" /* default */], {
                      ref: "refZyzxxForm",
                      getChildComponent: _this2.getChildComponent
                    });
                  }
                  if (item.FLBS == "hjqk" && item.SFXS == "1") {
                    return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__gxxxzyjsxy_HjqkForm__["a" /* default */], {
                      ref: "refHjqkForm",
                      getChildComponent: _this2.getChildComponent,
                      hjqkInitData: hjqkInitData,
                      cacheFormData: _this2.cacheFormData,
                      SFBT: item.SFBT,
                      blztFlag: _this2.state.blztFlag
                    });
                  }
                  if (item.FLBS == "kzxx" && item.SFXS == "1") {
                    return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__KzxxForm__["a" /* default */], {
                      ref: "refKzxxForm",
                      getChildComponent: _this2.getChildComponent,
                      reloadMenu: _this2.reloadMenu,
                      xsid: _this2.state.xsid,
                      zzbdhjid: _this2.state.zzbdhjid,
                      initData: _this2.state.kzxxInitData,
                      getData4Yxwz: _this2.getData4Yxwz
                    });
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                  "div",
                  { className: "p-sw text-center mt-30" },
                  this.state.blztFlag == "0" && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default.a,
                    { type: "primary", onClick: this.handelData },
                    "\u63D0\u4EA4"
                  ),
                  this.state.blztFlag == "1" && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default.a,
                    null,
                    "\u5DF2\u63D0\u4EA4"
                  ),
                  __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__pages_SelfHelp_common_nextIndex__["a" /* default */], {
                    nextUrl: this.state.nextUrl,
                    search: this.state.search
                  }),
                  this.state.blztFlag == "1" && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    "div",
                    { style: { color: "red", margin: "10px" } },
                    "\u63D0\u793A\uFF1A\u8BE5\u73AF\u8282\u5DF2\u63D0\u4EA4\u5B8C\u6210"
                  )
                )
              )
            )
          )
        ) : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__common__["a" /* default */], {
          hjmc: "个人信息填写",
          key: "GD001_3",
          mkbz: "GD001_3",
          nonOperationalData: this.state.nonOperationalData
        })
      );
    }
  }]);

  return UpdateInfo;
}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);



/***/ }),

/***/ 1043:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio_style__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_NHCascader__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__utils_RegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__index_css__);











var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }














if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var JbxxInitForm = function (_React$Component) {
    _inherits(JbxxInitForm, _React$Component);

    function JbxxInitForm(props) {
        _classCallCheck(this, JbxxInitForm);

        var _this = _possibleConstructorReturn(this, (JbxxInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(JbxxInitForm)).call(this, props));

        _this.getgxData = function () {
            var params = {
                sign: "dmk_XSXX_JJLXR_GX"
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/proData/selectDataList', 'GET', params).then(function (res) {
                if (res && res.code == 200) {
                    _this.setState({
                        jjlxrData: res.data
                    });
                } else {
                    message.error("获取紧急联系人数据失败!");
                }
            });
        };

        _this.onSavelxxxFormData = function (cb) {
            _this.props.form.validateFields(function (error, values) {
                if (error) {
                    cb(false);
                    return;
                }
                cb(true);
                var jtszdq = values.jtszdq;
                if (jtszdq.length > 0) {
                    var num = jtszdq.length;
                    values['jtszdq'] = jtszdq[num - 1];
                }
                var cacheFormData = _this.props.cacheFormData;

                if (_this.state.jtStr !== '') {
                    values.jtdzDetail = _this.state.jtStr;
                } else {
                    values.jtdzDetail = _this.props.lxxxFormData ? _this.props.lxxxFormData.jtdzDetail ? _this.props.lxxxFormData.jtdzDetail : "" : "";
                }
                if (values['gxdm'] != '08') {
                    values['gxmc'] = null;
                }
                values['gx'] = _this.state.jjlxrmc;
                console.log(values);
                cacheFormData('lxxx', values);
                _this.setState({
                    jbxx: false
                });
            });
        };

        _this.handleUploadChange = function (info) {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (info && info['file'] && info['file'].status === 'done') {
                var photoUUID = info['file'].response.data;
                if (photoUUID) {
                    var url = '/newStudent/saveStudentPhoto?xsid=' + userId + '&photoUUID=' + photoUUID + '&type=' + '10';
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])(url, 'POST').then(function (res) {
                        if (res && res.data) {
                            message.success("上传成功!");
                        }
                    });
                }
            }
            _this.getBase64(info.file.originFileObj, function (imageUrl) {
                return _this.setState({ imageUrl: imageUrl });
            });
        };

        _this.onNHCascaderChange = function (value, selectedOptions, type) {
            var label = '';
            if (selectedOptions) {
                selectedOptions.forEach(function (i) {
                    label += i.label;
                });
            }
            if (type == 'jg') {
                _this.setState({ jgmStr: label });
            } else {
                _this.setState({ jtStr: label });
            }
        };

        _this.jjlxrgxOnChange = function (e) {
            var jjlxrmc = "";
            console.log('radio checked', e.target.value);
            _this.state.jjlxrData.map(function (item) {
                if (e.target.value == item.VALUE) {
                    jjlxrmc = item.LABEL;
                }
            });
            _this.setState({
                jjlxsValue: e.target.value,
                jjlxrmc: jjlxrmc
            });
        };

        _this.state = {
            jbxx: false,
            xsid: '',
            userInfoData: null,
            zzmmmList: [],
            mzmList: [],
            textData: '',
            jgmStr: '',
            jtStr: '',
            xsSsInfo: '',
            zzmmValue: 1, //政治面貌
            sfqyValue: 1, //是否迁移户口
            jjlxrData: [], //紧急联系人数据
            jjlxsValue: "",
            jjlxrmc: ""
        };
        return _this;
    }

    _createClass(JbxxInitForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                this.setState({
                    xsid: userId
                });
            }
            this.getgxData();
        }

        // 获取关系数据

    }, {
        key: 'getBase64',
        value: function getBase64(img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        }
        // 上传图片


        // 是否迁移户口回调

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                form = _props.form,
                lxxxFormData = _props.lxxxFormData,
                getChildComponent = _props.getChildComponent,
                stuSsxx = _props.stuSsxx;
            var _state = this.state,
                jbxx = _state.jbxx,
                jjlxrData = _state.jjlxrData;

            var jtjddz = lxxxFormData ? lxxxFormData.jtjddz : '';
            var jtdzDetail = lxxxFormData ? lxxxFormData.jtdzDetail : '';
            var ssxx = '';
            if (stuSsxx && stuSsxx.xqmc && stuSsxx.ldmc && stuSsxx.fj && stuSsxx.cwh) {
                ssxx = stuSsxx.xqmc + stuSsxx.ldmc + ' - ' + stuSsxx.fj + ' - ' + stuSsxx.cwh;
            }
            return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a,
                { layout: 'inline' },
                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u8054\u7CFB\u65B9\u5F0F',
                    onEdit: function onEdit(type) {
                        _this2.setState({
                            jbxx: true,
                            jjlxsValue: lxxxFormData.gx
                        });
                        getChildComponent(2, false);
                    },
                    onSave: function onSave(cb) {
                        _this2.onSavelxxxFormData(cb);
                        getChildComponent(2, true);
                    },
                    onClose: function onClose() {
                        _this2.setState({
                            jbxx: false
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_13__components__["a" /* Flex */],
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13__components__["a" /* Flex */].Item,
                        { className: 'ml-20' },
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            jbxx ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'sjhm',
                                    label: __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        '\u624B\u673A\u53F7\uFF1A'
                                    ),
                                    colon: false,
                                    form: form,
                                    required: true
                                    // hasFeedback={true} 
                                    // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/, message: "请输入正确的手机号码或电话号码" }}
                                    , pattern: __WEBPACK_IMPORTED_MODULE_18__utils_RegExp__["FormRules"].MOBILE_PHONE_NUMBER,
                                    initialValue: lxxxFormData ? lxxxFormData.sjhm : ""
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u624B\u673A\u53F7' })
                            ) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-595067151'
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        { style: { color: 'red' }, className: 'jsx-595067151'
                                        },
                                        '*'
                                    ),
                                    '\u624B\u673A\u53F7\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'div',
                                    {
                                        style: { display: 'inline' },
                                        className: 'jsx-595067151' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                    },
                                    lxxxFormData ? lxxxFormData.sjhm : ''
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            jbxx ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'dzyx',
                                    label: __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        '\u7535\u5B50\u90AE\u7BB1\uFF1A'
                                    ),
                                    colon: false,
                                    form: form,
                                    required: true
                                    // hasFeedback={true} 
                                    // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}
                                    , initialValue: lxxxFormData ? lxxxFormData.dzyx : ""
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u7535\u5B50\u90AE\u7BB1' })
                            ) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-595067151'
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        { style: { color: 'red' }, className: 'jsx-595067151'
                                        },
                                        '*'
                                    ),
                                    '\u7535\u5B50\u90AE\u7BB1\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'div',
                                    {
                                        style: { display: 'inline' },
                                        className: 'jsx-595067151' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                    },
                                    lxxxFormData ? lxxxFormData.dzyx : ''
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            jbxx ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'qq',
                                    label: __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        'QQ\u53F7\uFF1A'
                                    ),
                                    colon: false,
                                    form: form,
                                    required: true
                                    // hasFeedback={true} 
                                    // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}
                                    , initialValue: lxxxFormData ? lxxxFormData.qq : ""
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199QQ\u53F7' })
                            ) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-595067151'
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        { style: { color: 'red' }, className: 'jsx-595067151'
                                        },
                                        '*'
                                    ),
                                    'QQ\u53F7\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'div',
                                    {
                                        style: { display: 'inline' },
                                        className: 'jsx-595067151' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                    },
                                    lxxxFormData ? lxxxFormData.qq : ''
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            jbxx ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'wx',
                                    label: __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        '\u5FAE\u4FE1\u53F7\uFF1A'
                                    ),
                                    colon: false,
                                    form: form,
                                    required: true
                                    // hasFeedback={true} 
                                    // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}
                                    , initialValue: lxxxFormData ? lxxxFormData.wx : ""
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u5FAE\u4FE1\u53F7' })
                            ) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-595067151'
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        { style: { color: 'red' }, className: 'jsx-595067151'
                                        },
                                        '*'
                                    ),
                                    '\u5FAE\u4FE1\u53F7\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'div',
                                    {
                                        style: { display: 'inline' },
                                        className: 'jsx-595067151' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                    },
                                    lxxxFormData ? lxxxFormData.wx : ''
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            jbxx ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'jjlxr',
                                    label: __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        '\u7D27\u6025\u8054\u7CFB\u4EBA\uFF1A'
                                    ),
                                    colon: false,
                                    form: form,
                                    required: true
                                    // hasFeedback={true} 
                                    // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}
                                    , initialValue: lxxxFormData ? lxxxFormData.jjlxr : ""
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u7D27\u6025\u8054\u7CFB\u4EBA' })
                            ) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-595067151'
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        { style: { color: 'red' }, className: 'jsx-595067151'
                                        },
                                        '*'
                                    ),
                                    '\u7D27\u6025\u8054\u7CFB\u4EBA\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'div',
                                    {
                                        style: { display: 'inline' },
                                        className: 'jsx-595067151' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                    },
                                    lxxxFormData ? lxxxFormData.jjlxr : ''
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            jbxx ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'lxrdh',
                                    label: __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        '\u7D27\u6025\u8054\u7CFB\u4EBA\u7535\u8BDD\uFF1A'
                                    ),
                                    colon: false,
                                    form: form,
                                    required: true
                                    // hasFeedback={true} 
                                    // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/, message: "请输入正确的手机号码或电话号码" }}
                                    , pattern: __WEBPACK_IMPORTED_MODULE_18__utils_RegExp__["FormRules"].MOBILE_PHONE_NUMBER,
                                    initialValue: lxxxFormData ? lxxxFormData.lxrdh : ""
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input___default.a, { style: { width: 150 }, placeholder: '\u8BF7\u586B\u5199\u7D27\u6025\u8054\u7CFB\u4EBA\u7535\u8BDD' })
                            ) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-595067151'
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        { style: { color: 'red' }, className: 'jsx-595067151'
                                        },
                                        '*'
                                    ),
                                    '\u7D27\u6025\u8054\u7CFB\u4EBA\u7535\u8BDD\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'div',
                                    {
                                        style: { display: 'inline' },
                                        className: 'jsx-595067151' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                    },
                                    lxxxFormData ? lxxxFormData.lxrdh : ''
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                            },
                            jbxx ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-595067151'
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_14__components_common_NHFormItem_index__["a" /* default */],
                                    { id: 'gxdm',
                                        label: __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                            'span',
                                            {
                                                className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                            },
                                            '\u4E0E\u7D27\u6025\u8054\u7CFB\u4EBA\u5173\u7CFB\uFF1A'
                                        ),
                                        colon: false,
                                        form: form,
                                        required: true
                                        // hasFeedback={true} 
                                        // pattern={FormRules.MOBILE_PHONE_NUMBER}
                                        , initialValue: lxxxFormData ? lxxxFormData.gx : ""
                                    },
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio___default.a.Group,
                                        { onChange: this.jjlxrgxOnChange, style: { display: "flex", margin: "10px" } },
                                        jjlxrData && jjlxrData.map(function (item, index) {
                                            return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio___default.a,
                                                { value: item.VALUE },
                                                item.LABEL
                                            );
                                        })
                                    )
                                )
                            ) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-595067151'
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        { style: { color: 'red' }, className: 'jsx-595067151'
                                        },
                                        '*'
                                    ),
                                    '\u4E0E\u7D27\u6025\u8054\u7CFB\u4EBA\u5173\u7CFB\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'div',
                                    {
                                        style: { display: 'inline' },
                                        className: 'jsx-595067151' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                    },
                                    lxxxFormData ? lxxxFormData.gxmc_dmk : ''
                                )
                            )
                        ),
                        this.state.jjlxsValue == "08" && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-595067151'
                            },
                            jbxx ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'gxmc',
                                    label: __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        '\u5176\u4ED6\u5173\u7CFB\uFF1A'
                                    ),
                                    colon: false,
                                    form: form,
                                    required: true
                                    // hasFeedback={true} 
                                    // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}
                                    , initialValue: lxxxFormData ? lxxxFormData.gxmc : ""
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input___default.a, { style: { width: 180 }, placeholder: '\u8BF7\u586B\u5199\u5176\u4ED6\u7D27\u6025\u8054\u7CFB\u4EBA' })
                            ) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-595067151'
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        { style: { color: 'red' }, className: 'jsx-595067151'
                                        },
                                        '*'
                                    ),
                                    '\u5176\u4ED6\u5173\u7CFB\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'div',
                                    {
                                        style: { display: 'inline' },
                                        className: 'jsx-595067151' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                    },
                                    lxxxFormData ? lxxxFormData.gxmc : ''
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__detail_adrress'
                            },
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'span',
                                { style: { lineHeight: '32px' }, className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'red' }, className: 'jsx-595067151'
                                    },
                                    '*'
                                ),
                                '\u73B0\u8BE6\u7EC6\u5C45\u4F4F\u4F4F\u5740\uFF1A'
                            ),
                            jbxx ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_13__components__["a" /* Flex */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_14__components_common_NHFormItem_index__["a" /* default */],
                                    { id: 'jtszdq',
                                        label: '',
                                        colon: false,
                                        required: true,
                                        form: form,
                                        initialValue: lxxxFormData ? lxxxFormData.jtszdqArray : []
                                    },
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_common_NHCascader__["a" /* default */], { style: { width: 432.63 }, sign: "zhxg_ssq", onChange: function onChange(value, selectedOptions) {
                                            return _this2.onNHCascaderChange(value, selectedOptions, 'jt');
                                        }

                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_14__components_common_NHFormItem_index__["a" /* default */],
                                    { id: 'jtjddz',
                                        label: '',
                                        colon: false,
                                        required: true,
                                        form: form,
                                        pattern: { max: 100, message: "家庭住址长度不能超过100字符！" },
                                        initialValue: lxxxFormData ? lxxxFormData.jtjddz : '' },
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input___default.a, { style: { width: 346.07 }, placeholder: '\u8BF7\u586B\u5199\u8BE6\u7EC6\u5BB6\u5EAD\u5730\u5740\uFF0C\u5982\uFF1Axx\u8857\u9053\u3001xx\u5C0F\u533A\u3001\u95E8\u724C\u53F7' })
                                )
                            ) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-595067151' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                jtdzDetail ? jtdzDetail : '',
                                jtjddz ? jtjddz : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            jbxx ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'yzbm',
                                    label: __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        '\u90AE\u653F\u7F16\u7801\uFF1A'
                                    ),
                                    colon: false,
                                    form: form,
                                    required: true
                                    // hasFeedback={true} 
                                    // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}
                                    , initialValue: lxxxFormData ? lxxxFormData.yzbm : ""
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input___default.a, { style: { width: 150 }, placeholder: '\u8BF7\u586B\u5199\u90AE\u653F\u7F16\u7801' })
                            ) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-595067151'
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-595067151' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        { style: { color: 'red' }, className: 'jsx-595067151'
                                        },
                                        '*'
                                    ),
                                    '\u90AE\u653F\u7F16\u7801\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'div',
                                    {
                                        style: { display: 'inline' },
                                        className: 'jsx-595067151' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                    },
                                    lxxxFormData ? lxxxFormData.yzbm : ''
                                )
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_styled_jsx_style___default.a, {
                    styleId: '595067151',
                    css: ['.ant-col-md-7{width:110px;}']
                })
            );
        }
    }]);

    return JbxxInitForm;
}(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);

var JbxxForm = __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a.create()(JbxxInitForm);
/* harmony default export */ __webpack_exports__["a"] = (JbxxForm);

/***/ }),

/***/ 1044:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_common_NHCascader__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__index_css__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_common_NHModal__ = __webpack_require__(106);













var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }












if (false) {
    module.hot.accept('../index.css', function () {
        require('../index.css');
    });
}

var uploadUrl = "api/zhxg-yxwz/newStudent/cacheStudentPhoto"; //上传logo路径 
var zpTip = "<p style=\"white-space: normal;text-align:center;color:#000;font-size:16px;\">—照片要求—</p><br/><p style=\"white-space: normal;\">1.本人清晰、免冠、正面彩色头像；要求面部五官无遮挡，人头部约占照片高度的三分之二；</p><br/><p style=\"white-space: normal;\">2.常戴眼镜的人员允许佩戴眼镜，要求不能为宽边框，拍照时注意镜片不要反光;</p><br/><p style=\"white-space: normal;\">3.照片背景颜色尽量单一，底色为白色、蓝色、红色均可；</p><br/><p style=\"white-space: normal;\">4.照片光线均匀，面部无明显逆光；</p><br/><p style=\"white-space: normal;\">5.照片文件大小要求：大于60KB，小于1MB;</p><br/><p style=\"white-space: normal;\">6.照片像素要求：宽高在200*200以上；</p><p><br/></p>";



function beforeUpload(file) {
    var isJPG = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJPG) {
        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("You can only upload JPG file!");
    }
    var isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("Image must smaller than 2MB!");
    }
    return isJPG && isLt2M;
}

var JbxxInitForm = function (_React$Component) {
    _inherits(JbxxInitForm, _React$Component);

    function JbxxInitForm(props) {
        _classCallCheck(this, JbxxInitForm);

        var _this = _possibleConstructorReturn(this, (JbxxInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(JbxxInitForm)).call(this, props));

        _this.getStudentPhotoBase64 = function (userId, callback) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/openapi/student/getStudentPhotoBase64', 'get', { xsid: userId, type: 10 }).then(function (res) {
                if (res && res.code == 200) {
                    callback(res.data);
                }
            });
        };

        _this.loadZzmm = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])('/proData/selectDataList', 'get', 'sign=dMK_XTGL_ZZMMM').then(function (res) {
                if (res && res.code == 200) {
                    var list = [];
                    var zzmmList = res.data;
                    zzmmList.map(function (item) {
                        list.push({ "value": item.VALUE, label: item.LABEL });
                    });
                    _this.setState({
                        zzmmList: list
                    });
                }
            });
        };

        _this.loadMz = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])('/proData/selectDataList', 'get', 'sign=DMK_XTGL_MZM').then(function (res) {
                if (res && res.code == 200) {
                    var list = [];
                    var mzList = res.data;
                    mzList.map(function (item) {
                        list.push({ "value": item.VALUE, label: item.LABEL });
                    });
                    _this.setState({
                        mzList: list
                    });
                }
            });
        };

        _this.onSavejbxxFormData = function (cb) {
            _this.props.form.validateFields(function (error, values) {
                if (error) {
                    cb(false);
                    return;
                }
                _this.setState({
                    jbxx: false
                });
                cb(true);
                console.log("66666666666666", values.hkszd, "vvv", values.jgm, "22222222", values);
                var hkszdArray = values.hkszd;
                if (hkszdArray.length > 0) {
                    var num = hkszdArray.length;
                    values['hkszd'] = hkszdArray[num - 1];
                    console.log(values['hkszd']);
                }
                var jgArray = values.hkszd;
                if (_this.state.jgDetail != "" && _this.state.jgDetail) {
                    values['jgDetail'] = _this.state.jgDetail;
                } else {
                    values['jgDetail'] = _this.props.jbxxFormData.jgDetail;
                }
                if (_this.state.hkszdDetail != "" && _this.state.hkszdDetail) {
                    values['hkszdDetail'] = _this.state.hkszdDetail;
                } else {
                    values['hkszdDetail'] = _this.props.jbxxFormData.hkszdDetail;
                }
                if (_this.state.zzmmMC != "" && _this.state.zzmmMC) {
                    values['zzmmmc'] = _this.state.zzmmMC;
                } else {
                    values['zzmmmc'] = _this.props.jbxxFormData.zzmmmc;
                }
                if (_this.state.mzMc != "" && _this.state.mzMc) {
                    values['mzMc'] = _this.state.mzMc;
                } else {
                    values['mzMc'] = _this.props.jbxxFormData.mzMc;
                }
                var cacheFormData = _this.props.cacheFormData;

                cacheFormData('jbxx_sjz', values);
            });
        };

        _this.handleUploadChange = function (info) {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (info && info['file'] && info['file'].status === 'done') {
                var photoUUID = info['file'].response.data;
                if (photoUUID) {
                    var url = '/newStudent/saveStudentPhoto?xsid=' + userId + '&photoUUID=' + photoUUID + '&type=' + '10';
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])(url, 'POST').then(function (res) {
                        if (res && res.data) {
                            __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.success("上传成功!");
                        }
                    });
                }
            }
            _this.getBase64(info.file.originFileObj, function (imageUrl) {
                return _this.setState({ imageUrl: imageUrl });
            });
        };

        _this.onjgNHCascaderChange = function (value, selectedOptions, type) {
            var label = '';
            if (selectedOptions) {
                selectedOptions.forEach(function (i) {
                    label += i.label;
                });
            }
            _this.setState({
                jgDetail: label
            });
        };

        _this.onNHCascaderChange = function (value, selectedOptions, type) {
            var label = '';
            if (selectedOptions) {
                selectedOptions.forEach(function (i) {
                    label += i.label;
                });
            }
            _this.setState({ hkszdDetail: label });
        };

        _this.zzmmSelect = function (value) {
            var mc = "";
            console.log('radio checked', value);
            _this.state.zzmmList.map(function (item) {
                if (item.value == value) {
                    mc = item.label;
                }
            });
            _this.setState({
                zzmmValue: value,
                zzmmMC: mc
            }, function () {
                console.log("赋值zzmm", _this.state.zzmmMC);
            });
        };

        _this.mzSelect = function (value) {
            var mc = "";
            console.log('radio checked', value);
            _this.state.mzList.map(function (item) {
                if (item.value == value) {
                    mc = item.label;
                }
            });
            _this.setState({
                mzValue: value,
                mzMc: mc
            }, function () {
                console.log("赋值mz", _this.state.mzMc);
            });
        };

        _this.sfqyOnChange = function (e) {
            console.log('radio checked', e.target.value);
            _this.setState({
                sfqyValue: e.target.value
            });
        };

        _this.handleCancel = function () {
            _this.setState({
                jbxx: true,
                sureButton: fasle
            });
        };

        _this.zphandleOk = function () {
            _this.zpModal.close();
            // this.beforeUpload();
            _this.setState({
                modal: false
            }, function () {
                _this.handleUploadChange(_this.state.modalInfo);
            });
        };

        _this.openZPModal = function (info) {
            _this.zpModal.show();
            _this.setState({
                modalInfo: info
            });
        };

        _this.state = {
            userInfoData: {},
            jbxx: false,
            xsid: '',
            zzmmmList: [],
            mzmList: [],
            textData: '',
            jgmStr: '',
            jtStr: '',
            xsSsInfo: '',
            zzmmValue: 1, //政治面貌
            sfqyValue: -1, //是否迁移户口
            xyContent: "", //协议内容
            values: {},
            sj: "",
            sureButton: false,
            ZSXYFlag: false,
            zzmmList: [
                /* {value:"01",label:"中国共产党党员"},
                {value:"02",label:"中国共产党预备党员"},
                {value:"03",label:"中国共产主义青年团团员"},
                {value:"04",label:"中国国民党革命委员会会员"},
                {value:"05",label:"中国民主同盟盟员"},
                {value:"06",label:"中国民主建国会会员"},
                {value:"07",label:"中国民主促进会会员"},
                {value:"08",label:"中国农工民主党党员"},
                {value:"09",label:"中国致公党党员"},
                {value:"10",label:"九三学社社员"},
                {value:"11",label:"台湾民主自治同盟盟员"},
                {value:"12",label:"无党派民主人士"},
                {value:"13",label:"群众"} */
            ], //政治面貌
            hkszdDetail: "",
            jgmmc: "",
            zzmmMC: "",
            mzList: [],
            mzMc: ""
        };
        return _this;
    }

    _createClass(JbxxInitForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                this.getStudentPhotoBase64(userId, function (data) {
                    if (!data) return;
                    _this2.setState({
                        xsid: userId,
                        imageUrl: 'data:image/jpeg;base64,' + data
                    });
                });
            }
            this.loadZzmm();
            this.loadMz();
        }

        // 获取学生头像


        // 政治面貌


        // 民族

    }, {
        key: 'getBase64',
        value: function getBase64(img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        }

        // 上传图片


        // 政治面貌回调


        // 民族回调


        // 是否迁移户口回调


        // 取消按钮


        // modalSure=(info)=>{
        //     this.zpModal.show();
        // }

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                form = _props.form,
                jbxxFormData = _props.jbxxFormData,
                getChildComponent = _props.getChildComponent,
                userInfoData = _props.userInfoData,
                stuSsxx = _props.stuSsxx,
                editXszp = _props.editXszp,
                kzxxInitData = _props.kzxxInitData,
                SFBT = _props.SFBT,
                blztFlag = _props.blztFlag,
                dxxxFormData = _props.dxxxFormData;
            var _state = this.state,
                jbxx = _state.jbxx,
                imageUrl = _state.imageUrl,
                tempUrl = _state.tempUrl,
                xsid = _state.xsid,
                zzmmList = _state.zzmmList,
                mzList = _state.mzList;

            var jtjddz = jbxxFormData ? jbxxFormData.jtjddz : '';
            var ssxx = '';
            var zdz = "";
            console.log("照片是否可以编辑-----", editXszp);
            if (jbxxFormData.xxcj_zdyhksfqy == undefined) {
                if (kzxxInitData) {
                    kzxxInitData.map(function (item) {
                        if (item.zdbz == "ZDYHKSFQY") {
                            zdz = item.zdz;
                            console.log(item.zdz);
                        }
                    });
                }
            } else {
                zdz = jbxxFormData.xxcj_zdyhksfqy;
            }

            if (stuSsxx && stuSsxx.xqmc && stuSsxx.ldmc && stuSsxx.fj && stuSsxx.cwh) {
                ssxx = stuSsxx.xqmc + stuSsxx.ldmc + ' - ' + stuSsxx.fj + ' - ' + stuSsxx.cwh;
            }
            console.log(jbxxFormData);
            return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a,
                { layout: 'inline' },
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u57FA\u672C\u4FE1\u606F',
                    onEdit: function onEdit(type) {
                        _this3.setState({
                            jbxx: true,
                            sfqyValue: zdz
                        });
                        getChildComponent(1, false);
                    },
                    onSave: function onSave(cb) {
                        _this3.onSavejbxxFormData(cb); //现在不需要单条保存数据
                        getChildComponent(1, true);
                    },
                    onClose: function onClose() {
                        _this3.setState({
                            jbxx: false
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + '_bg app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_icon'
                        },
                        jbxx && editXszp === "true" ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default.a,
                            {
                                name: 'photo',
                                accept: 'image/*',
                                showUploadList: false,
                                action: uploadUrl + "?xsid=" + xsid,
                                beforeUpload: this.beforeUpload,
                                onChange: this.openZPModal
                            },
                            imageUrl || userInfoData ? imageUrl ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
                                src: imageUrl,
                                alt: '',

                                style: { border: "1px solid #1890ff", padding: "5px" },
                                className: 'jsx-1702183314' + ' ' + 'avatar'
                            }) : tempUrl : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__upload-box'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__upload-title'
                                    },
                                    '\u4E0A\u4F20\u56FE\u7247'
                                )
                            )
                        ) : imageUrl ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
                            src: imageUrl,
                            alt: '',
                            className: 'jsx-1702183314' + ' ' + 'avatar'
                        }) : tempUrl
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */].Item,
                        { className: 'ml-20' },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u59D3\u540D\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.XM : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u6027\u522B\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userInfoData && userInfoData.XB ? userInfoData.XB === '男' ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(141), alt: '', className: 'jsx-1702183314'
                                }) : userInfoData.XB === '女' ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(142), alt: '', className: 'jsx-1702183314'
                                }) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(143), alt: '', className: 'jsx-1702183314'
                                }) : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                                },
                                jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                                    { id: 'mzm',
                                        label: __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                            'span',
                                            {
                                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                            },
                                            '\u6C11\u65CF\uFF1A'
                                        ),
                                        colon: false,
                                        form: form,
                                        required: true
                                        // hasFeedback={true} 
                                        , initialValue: userInfoData ? userInfoData.MZM : ""
                                    },
                                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_select___default.a,
                                        { defaultValue: userInfoData ? userInfoData.MZM : '', style: { width: 220 }, onChange: this.mzSelect, value: this.state.mzValue, placeholder: '\u8BF7\u9009\u62E9...' },
                                        mzList.map(function (item, index) {
                                            return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                                Option,
                                                { value: item.value },
                                                item.label
                                            );
                                        })
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 'jsx-1702183314'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                            'span',
                                            { style: { color: 'red' }, className: 'jsx-1702183314'
                                            },
                                            '*'
                                        ),
                                        '\u6C11\u65CF\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                        'div',
                                        {
                                            style: { display: 'inline' },
                                            className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                        },
                                        userInfoData ? this.state.mzMc ? this.state.mzMc : userInfoData.MZ : ''
                                    )
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u5B66\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.XH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u5B66\u9662\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.BMMC : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u4E13\u4E1A\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.ZYMC : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                                },
                                jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                                    { id: 'hkszd',
                                        label: __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                            'span',
                                            {
                                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                            },
                                            '\u6237\u53E3\u6240\u5728\u5730\uFF1A'
                                        ),
                                        colon: false,
                                        form: form,
                                        required: true
                                        // hasFeedback={true} 
                                        // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}
                                        , initialValue: jbxxFormData ? jbxxFormData.hkszdArray : ""
                                    },
                                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_common_NHCascader__["a" /* default */], { style: { width: 400 }, sign: "zhxg_ssq", onChange: function onChange(value, selectedOptions) {
                                            return _this3.onNHCascaderChange(value, selectedOptions, 'jt');
                                        } })
                                ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 'jsx-1702183314'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                            'span',
                                            { style: { color: 'red' }, className: 'jsx-1702183314'
                                            },
                                            '*'
                                        ),
                                        '\u6237\u53E3\u6240\u5728\u5730\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                        'div',
                                        {
                                            style: { display: 'inline' },
                                            className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                        },
                                        jbxxFormData ? jbxxFormData.hkszdDetail : ''
                                    )
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                            },
                            jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'jgm',
                                    label: __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        '\u7C4D\u8D2F\uFF1A'
                                    ),
                                    colon: false,
                                    required: true,
                                    form: form,
                                    initialValue: jbxxFormData ? jbxxFormData.jgArray : []
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_common_NHCascader__["a" /* default */], { style: { width: 400 }, sign: "zhxg_ssq", onChange: function onChange(value, selectedOptions) {
                                        return _this3.onjgNHCascaderChange(value, selectedOptions, 'jt');
                                    } })
                            ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                        'span',
                                        { style: { color: 'red' }, className: 'jsx-1702183314'
                                        },
                                        '*'
                                    ),
                                    '\u7C4D\u8D2F\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'div',
                                    {
                                        style: { display: 'inline' },
                                        className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                    },
                                    jbxxFormData ? jbxxFormData.jgDetail : ''
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                                },
                                jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                                    { id: 'zzmmm',
                                        label: __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                            'span',
                                            {
                                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                            },
                                            '\u653F\u6CBB\u9762\u8C8C\uFF1A'
                                        ),
                                        colon: false,
                                        form: form,
                                        required: true
                                        // hasFeedback={true} 
                                        // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}
                                        , initialValue: jbxxFormData ? jbxxFormData.zzmmm : ""
                                    },
                                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_select___default.a,
                                        { defaultValue: jbxxFormData ? jbxxFormData.zzmmm : '', style: { width: 220 }, onChange: this.zzmmSelect, value: this.state.zzmmValue, placeholder: '\u8BF7\u9009\u62E9...' },
                                        zzmmList.map(function (item, index) {
                                            return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                                Option,
                                                { value: item.value },
                                                item.label
                                            );
                                        })
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 'jsx-1702183314'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                        'span',
                                        {
                                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                        },
                                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                            'span',
                                            { style: { color: 'red' }, className: 'jsx-1702183314'
                                            },
                                            '*'
                                        ),
                                        '\u653F\u6CBB\u9762\u8C8C\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                        'div',
                                        {
                                            style: { display: 'inline' },
                                            className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                        },
                                        jbxxFormData ? jbxxFormData.zzmmmc : ''
                                    )
                                )
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_21__components_common_NHModal__["a" /* default */],
                    {
                        ref: function ref(form) {
                            _this3.zpModal = form;
                        },
                        title: '\u7167\u7247\u89C4\u8303',
                        width: "40%"
                        // style={{width:"70%"}}
                        , onOk: this.zphandleOk
                        // footer={footer}
                        // onCancel={this.zphandleCancel}
                    },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(815), style: { width: "50%", position: "relative", left: "25%" }, className: 'jsx-1702183314'
                    }),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: zpTip }, style: { textAlign: "center" }, className: 'jsx-1702183314'
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_styled_jsx_style___default.a, {
                    styleId: '1702183314',
                    css: ['.ant-col-md-7{width:100px;}']
                })
            );
        }
    }]);

    return JbxxInitForm;
}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);

var JbxxForm = __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a.create()(JbxxInitForm);

/* harmony default export */ __webpack_exports__["a"] = (JbxxForm);

/***/ }),

/***/ 1045:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_common_NHCascader__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__utils_RegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_common_NHRadioGroup__ = __webpack_require__(537);













var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }













if (false) {
    module.hot.accept('../index.css', function () {
        require('../index.css');
    });
}

var uploadUrl = "api/zhxg-yxwz/newStudent/cacheStudentPhoto"; //上传logo路径 


function beforeUpload(file) {

    var isJPG = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJPG) {
        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("You can only upload JPG file!");
    }
    var isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("Image must smaller than 2MB!");
    }
    return isJPG && isLt2M;
}

var JbxxInitForm = function (_React$Component) {
    _inherits(JbxxInitForm, _React$Component);

    function JbxxInitForm(props) {
        _classCallCheck(this, JbxxInitForm);

        var _this = _possibleConstructorReturn(this, (JbxxInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(JbxxInitForm)).call(this, props));

        _this.getStudentPhotoBase64 = function (userId, callback) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/openapi/student/getStudentPhotoBase64', 'get', { xsid: userId, type: 10 }).then(function (res) {
                if (res && res.code == 200) {
                    callback(res.data);
                }
            });
        };

        _this.getShowCwhCssz = function () {
            var params = { csbz: "YXXT_SSXX_SFXSCWH" };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])('/zzbdCommon/getCssz', 'GET', params).then(function (res) {
                if (res && res.data) {
                    _this.setState({
                        cwhFlag: res.data == 'true' ? true : false
                    });
                }
            });
        };

        _this.onSavejbxxFormData = function (cb) {
            _this.props.form.validateFields(function (error, values) {
                if (error) {
                    cb(false);
                    return;
                }
                cb(true);
                var cacheFormData = _this.props.cacheFormData;

                if (_this.state.jtdzDetail !== '') {
                    values['jtdzDetail'] = _this.state.jtdzDetail;
                } else {
                    values['jtdzDetail'] = _this.props.jbxxFormData ? _this.props.jbxxFormData.jtdzDetail ? _this.props.jbxxFormData.jtdzDetail : "" : "";
                }
                var jtszdqArray = values.jtszdqArray;
                if (jtszdqArray.length > 0) {
                    var num = jtszdqArray.length;
                    values['jtszdq'] = jtszdqArray[num - 1];
                }
                cacheFormData('jbxx_whgc', values);
                _this.setState({
                    jbxx: false
                });
            });
        };

        _this.handleUploadChange = function (info) {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (info && info['file'] && info['file'].status === 'done') {
                var photoUUID = info['file'].response.data;
                if (photoUUID) {
                    var url = '/newStudent/saveStudentPhoto?xsid=' + userId + '&photoUUID=' + photoUUID + '&type=' + '10';
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])(url, 'POST').then(function (res) {
                        if (res && res.data) {
                            __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.success("上传成功!");
                        }
                    });
                }
            }
            _this.getBase64(info.file.originFileObj, function (imageUrl) {
                return _this.setState({ imageUrl: imageUrl });
            });
        };

        _this.onNHCascaderChange = function (value, selectedOptions, type) {
            var label = '';
            if (selectedOptions) {
                selectedOptions.forEach(function (i) {
                    label += i.label;
                });
            }
            if (type == 'jg') {
                _this.setState({ jgmStr: label });
            } else {
                _this.setState({ jtStr: label });
            }
        };

        _this.onChangeSftqblyhk = function (value) {
            _this.setState({ sftqblyhk: value });
            _this.props.form.setFieldsValue({ sjh: undefined });
        };

        _this.state = {
            jbxx: false,
            xsid: '',
            userInfoData: {},
            zzmmmList: [],
            mzmList: [],
            textData: '',
            jgmStr: '',
            jtStr: '',
            xsSsInfo: '',
            cwhFlag: true,
            sftqblyhk: undefined
        };
        return _this;
    }

    _createClass(JbxxInitForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                this.getStudentPhotoBase64(userId, function (data) {
                    if (!data) return;
                    _this2.setState({
                        xsid: userId,
                        imageUrl: 'data:image/jpeg;base64,' + data
                    });
                });
            }
            this.getShowCwhCssz();
        }

        // 获取学生头像

    }, {
        key: 'getBase64',
        value: function getBase64(img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        }
        // 上传图片

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                form = _props.form,
                jbxxFormData = _props.jbxxFormData,
                getChildComponent = _props.getChildComponent,
                stuSsxx = _props.stuSsxx,
                editXszp = _props.editXszp,
                userInfoData = _props.userInfoData;
            var _state = this.state,
                jbxx = _state.jbxx,
                imageUrl = _state.imageUrl,
                tempUrl = _state.tempUrl,
                xsid = _state.xsid,
                cwhFlag = _state.cwhFlag,
                sftqblyhk = _state.sftqblyhk;

            var jtjddz = jbxxFormData ? jbxxFormData.jtjddz : '';
            var jtdzDetail = jbxxFormData ? jbxxFormData.jtdzDetail : '';
            var ssxx = '';
            if (stuSsxx && stuSsxx.XQMC && stuSsxx.LDMC && stuSsxx.FJ) {
                ssxx = stuSsxx.XQMC + stuSsxx.LDMC + ' - ' + stuSsxx.FJ;
                if (stuSsxx.CWH && cwhFlag) {
                    ssxx = ssxx + ' - ' + stuSsxx.CWH + '号床位';
                }
            }

            return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a,
                { layout: 'inline' },
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u57FA\u672C\u4FE1\u606F',
                    onEdit: function onEdit(type) {
                        _this3.setState({
                            jbxx: true
                        });
                        getChildComponent(1, false);
                    },
                    onSave: function onSave(cb) {
                        _this3.onSavejbxxFormData(cb);
                        getChildComponent(1, true);
                    },
                    onClose: function onClose() {
                        _this3.setState({
                            jbxx: false
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + '_bg app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_icon'
                        },
                        jbxx && editXszp === "true" ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default.a,
                            {
                                name: 'photo',
                                accept: 'image/*',
                                showUploadList: false,
                                action: uploadUrl + "?xsid=" + xsid,
                                beforeUpload: beforeUpload,
                                onChange: this.handleUploadChange
                            },
                            imageUrl || userInfoData ? imageUrl ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
                                src: imageUrl,
                                alt: '',
                                className: 'jsx-1702183314' + ' ' + 'avatar'
                            }) : tempUrl : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__upload-box'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__upload-title'
                                    },
                                    '\u4E0A\u4F20\u56FE\u7247'
                                )
                            )
                        ) : imageUrl ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
                            src: imageUrl,
                            alt: '',
                            className: 'jsx-1702183314' + ' ' + 'avatar'
                        }) : tempUrl
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */].Item,
                        { className: 'ml-20' },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u59D3\u540D\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.XM : '',
                                userInfoData && userInfoData.XB ? userInfoData.XB === '男' ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(141), alt: '', className: 'jsx-1702183314'
                                }) : userInfoData.XB === '女' ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(142), alt: '', className: 'jsx-1702183314'
                                }) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(143), alt: '', className: 'jsx-1702183314'
                                }) : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u5B66\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.XH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u8003\u751F\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.KSH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u8EAB\u4EFD\u8BC1\u4EF6\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.SFZJH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u51FA\u751F\u5E74\u6708\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.CSRQ : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u653F\u6CBB\u9762\u8C8C\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.ZZMM : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u6C11\u65CF\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.MZ : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u7C4D\u8D2F\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.JG : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u6BD5\u4E1A\u5B66\u6821\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.byxx : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                '\u9AD8\u8003\u5206\u6570\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.gkcj : ''
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    'div',
                    {
                        className: 'jsx-1702183314' + ' ' + 'p-swc'
                    },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            '\u5B66\u9662\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            userInfoData ? userInfoData.BMMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            '\u4E13\u4E1A\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            userInfoData ? userInfoData.ZYMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            '\u73ED\u7EA7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            userInfoData ? userInfoData.BJMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                        },
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                            { id: 'sjhm',
                                label: __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    '\u672C\u4EBA\u8054\u7CFB\u7535\u8BDD\uFF1A'
                                ),
                                colon: false,
                                form: form,
                                required: true
                                // hasFeedback={true} 
                                // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}
                                , pattern: __WEBPACK_IMPORTED_MODULE_20__utils_RegExp__["FormRules"].MOBILE_PHONE_NUMBER,
                                initialValue: jbxxFormData ? jbxxFormData.sjhm : ""
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u8054\u7CFB\u7535\u8BDD' })
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'red' }, className: 'jsx-1702183314'
                                    },
                                    '*'
                                ),
                                '\u672C\u4EBA\u8054\u7CFB\u7535\u8BDD\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.sjhm : ''
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            '\u5BBF\u820D\u4FE1\u606F\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            ssxx
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            '\u4E13\u4E1AQQ\u7FA4\u53F7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            jbxxFormData.zyqq ? jbxxFormData.zyqq : '暂无'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__detail_adrress'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            { style: { lineHeight: '32px' }, className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                { style: { color: 'red' }, className: 'jsx-1702183314'
                                },
                                '*'
                            ),
                            '\u8BE6\u7EC6\u5BB6\u5EAD\u4F4F\u5740\uFF1A'
                        ),
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                            null,
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'jtszdqArray',
                                    label: '',
                                    colon: false,
                                    required: true,
                                    form: form,
                                    initialValue: jbxxFormData ? jbxxFormData.jtszdqArray : []
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_common_NHCascader__["a" /* default */], { style: { width: 432.63 }, sign: "zhxg_ssq", onChange: function onChange(value, selectedOptions) {
                                        return _this3.onNHCascaderChange(value, selectedOptions, 'jt');
                                    }

                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'jtjddz',
                                    label: '',
                                    colon: false,
                                    required: true,
                                    form: form,
                                    pattern: { max: 100, message: "家庭住址长度不能超过100字符！" },
                                    initialValue: jbxxFormData ? jbxxFormData.jtjddz : '' },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 346.07 }, placeholder: '\u8BF7\u586B\u5199\u8BE6\u7EC6\u5BB6\u5EAD\u5730\u5740\uFF0C\u5982\uFF1Axx\u8857\u9053\u3001xx\u5C0F\u533A\u3001\u95E8\u724C\u53F7' })
                            )
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            jtdzDetail ? jtdzDetail : '',
                            jtjddz ? jtjddz : ''
                        )
                    ),
                    userInfoData ? userInfoData.FDY && userInfoData.FDY.length > 0 ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            '\u8F85\u5BFC\u5458\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            userInfoData.FDY.map(function (item, key) {
                                if (item) {
                                    var lxdh = item.LXDH ? "( " + item.LXDH + " )" : "";
                                    return item.XM + lxdh + " ";
                                } else {
                                    return "";
                                }
                            })
                        )
                    ) : null : null,
                    userInfoData ? userInfoData.BZR && userInfoData.BZR.length > 0 ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                            },
                            '\u73ED\u4E3B\u4EFB\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                            },
                            userInfoData.BZR.map(function (item, key) {
                                if (item) {
                                    var lxdh = item.LXDH ? "( " + item.LXDH + " )" : "";
                                    return item.XM + lxdh + " ";
                                } else {
                                    return "";
                                }
                            })
                        )
                    ) : null : null,
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item'
                        },
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                            { id: 'lxrdh',
                                label: __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    '\u7D27\u6025\u8054\u7CFB\u4EBA\u7535\u8BDD\uFF1A'
                                ),
                                colon: false,
                                form: form,
                                required: true
                                // hasFeedback={true} 
                                // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}
                                , pattern: __WEBPACK_IMPORTED_MODULE_20__utils_RegExp__["FormRules"].MOBILE_PHONE_NUMBER,
                                initialValue: jbxxFormData ? jbxxFormData.lxrdh : ""
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 150 }, placeholder: '\u8BF7\u586B\u5199\u7D27\u6025\u8054\u7CFB\u4EBA\u7535\u8BDD' })
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'red' }, className: 'jsx-1702183314'
                                    },
                                    '*'
                                ),
                                '\u7D27\u6025\u8054\u7CFB\u4EBA\u7535\u8BDD\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.lxrdh : ''
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2'
                        },
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                            { id: 'gddh',
                                label: __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    '\u5EA7\u673A\uFF1A'
                                ),
                                colon: false,
                                form: form,
                                required: false
                                // hasFeedback={true} 
                                , pattern: { pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/, message: "请输入正确的座机号码" },
                                initialValue: jbxxFormData ? jbxxFormData.gddh : ""
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u5EA7\u673A\u53F7\u7801' })
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'red' }, className: 'jsx-1702183314'
                                    },
                                    '*'
                                ),
                                '\u5EA7\u673A\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.gddh : ''
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314'
                        },
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                            { id: 'sftqblyhk',
                                formItemLayout: { labelCol: { span: 16 }, wrapperCol: { span: 8 } },
                                label: __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    '\u662F\u5426\u5DF2\u63D0\u524D\u529E\u7406\u672C\u4EBA\u6237\u540D\u7684\u4E2D\u56FD\u94F6\u884C\u50A8\u84C4\u5361\uFF1A'
                                ),
                                colon: false,
                                form: form,
                                required: true,
                                initialValue: jbxxFormData ? jbxxFormData.sftqblyhk : ""
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_common_NHRadioGroup__["a" /* default */], { sign: "DMK_XTGL_SFM", onChange: function onChange(v) {
                                    _this3.onChangeSftqblyhk(v);
                                } })
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'red' }, className: 'jsx-1702183314'
                                    },
                                    '*'
                                ),
                                '\u662F\u5426\u5DF2\u63D0\u524D\u529E\u7406\u672C\u4EBA\u6237\u540D\u7684\u4E2D\u56FD\u94F6\u884C\u50A8\u84C4\u5361\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.sftqblyhk === '1' ? '是' : '否' : ''
                            )
                        )
                    ),
                    (sftqblyhk ? sftqblyhk : jbxxFormData ? jbxxFormData.sftqblyhk : '') === '1' && __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314'
                        },
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                            { id: 'zgyhkh',
                                label: __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                    },
                                    '\u4E2D\u56FD\u94F6\u884C\u5361\u53F7\uFF1A'
                                ),
                                colon: false,
                                form: form,
                                required: true
                                // hasFeedback={true} 
                                , pattern: { pattern: /^(62166[1-9]|62178[5-8]|621798|62590[6-9]|625910|456351|62\d{4})\d{10,13}$/, message: "请输入正确的中国银行卡号" },
                                initialValue: jbxxFormData ? jbxxFormData.zgyhkh : ""
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 240 }, placeholder: '\u8BF7\u586B\u5199\u4E2D\u56FD\u94F6\u884C\u5361\u53F7' })
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-commonInfo-__index__item-label'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'red' }, className: 'jsx-1702183314'
                                    },
                                    '*'
                                ),
                                '\u4E2D\u56FD\u94F6\u884C\u5361\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-commonInfo-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.zgyhkh : ''
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_styled_jsx_style___default.a, {
                    styleId: '1702183314',
                    css: ['.ant-col-md-7{width:100px;}']
                })
            );
        }
    }]);

    return JbxxInitForm;
}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);

var JbxxForm = __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a.create()(JbxxInitForm);

/* harmony default export */ __webpack_exports__["a"] = (JbxxForm);

/***/ }),

/***/ 1046:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ZyzxxInitForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_NHCascader__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_NHModal__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__index_css__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__index_css__);









var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }














if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var ZyzxxInitForm = function (_React$Component) {
    _inherits(ZyzxxInitForm, _React$Component);

    function ZyzxxInitForm(props) {
        _classCallCheck(this, ZyzxxInitForm);

        var _this = _possibleConstructorReturn(this, (ZyzxxInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default()(ZyzxxInitForm)).call(this, props));

        _this.loadZyzxx = function (userId) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_NHFetch__["a" /* default */])('api/zhxg-yxxt/yxwz/' + userId + '/getZyzInfoByXsid', 'get').then(function (res) {
                if (res && res.code == 200) {
                    var zyzData = res.data;
                    _this.setState({
                        zyzData: zyzData
                    });
                }
            });
        };

        _this.state = {
            xsid: '',
            textData: '',
            zyzData: ''
        };
        return _this;
    }

    _createClass(ZyzxxInitForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            this.loadZyzxx(userId);
        }

        // 获取志愿者信息

    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                form = _props.form,
                getChildComponent = _props.getChildComponent;
            var zyzData = this.state.zyzData;


            var zyzxxColumns = [{
                title: '姓名',
                key: 'xm',
                dataIndex: 'XM',
                render: function render(text, record, index) {
                    return text;
                }
            }, {
                title: '性别',
                dataIndex: 'XB',
                render: function render(text, record, index) {
                    return text;
                }
            }, {
                title: '联系电话',
                dataIndex: 'LXDH',
                render: function render(text, record, index) {
                    return text;
                }
            }, {
                title: '微信号',
                dataIndex: 'WX',
                render: function render(text, record, index) {
                    return text;
                }
            }];

            return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u5FD7\u613F\u8005\u4FE1\u606F',
                    extra: false
                }),
                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a,
                    null,
                    __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                        'div',
                        { className: 'p-sw' },
                        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table___default.a, {
                            bordered: true,
                            size: 'middle',
                            pagination: false,
                            dataSource: zyzData,
                            columns: zyzxxColumns
                        })
                    )
                )
            );
        }
    }]);

    return ZyzxxInitForm;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);



/***/ }),

/***/ 1047:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_card_style__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_card__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_keys__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_common_NHInputPicker_render__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_globalUtil__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__index_css__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__index_css__);




















var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }











if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_18_antd_lib_form___default.a.Item;

var Common = function (_React$Component) {
    _inherits(Common, _React$Component);

    function Common() {
        _classCallCheck(this, Common);

        var _this = _possibleConstructorReturn(this, (Common.__proto__ || __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_get_prototype_of___default()(Common)).call(this));

        _this.handleSubmit = function () {
            _this.setState({
                loading: true
            });
            var zzbdhjid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_globalUtil__["a" /* getHashParam */])('pkid');
            var pkid = _this.state.hjblztData.pkid;

            var form = _this.props.form;
            //校验
            form.validateFields(function (err, formData) {

                if (err) {
                    return;
                }

                //处理保存到数据库中的数据 
                __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_keys___default()(formData).forEach(function (key) {
                    if (formData[key] != null && formData[key] != undefined) {
                        if (formData[key].constructor.name == 'Array') {
                            if (_typeof(formData[key]) === 'object') {
                                var isFileUpload = false;
                                var array = [];
                                var _iteratorNormalCompletion = true;
                                var _didIteratorError = false;
                                var _iteratorError = undefined;

                                try {
                                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_get_iterator___default()(formData[key]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                        var item = _step.value;

                                        if (item.hasOwnProperty('uuid') && item['uuid']) {
                                            isFileUpload = true;
                                            array.push(item['uuid']);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return) {
                                            _iterator.return();
                                        }
                                    } finally {
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }

                                if (isFileUpload) {
                                    formData[key] = array.join(',');
                                } else {
                                    formData[key] = formData[key].join(',');
                                }
                            } else {
                                formData[key] = formData[key].join(',');
                            }
                        }
                    } else {
                        formData[key] = '';
                    }
                });

                var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHCore__["b" /* getLoginUser */])().userId : '';
                if (!userId) {
                    __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error("登录已过期，请重新登录！");
                    return;
                }
                var params = { xsid: userId, lchjid: pkid, formData: formData, yhid: userId, zzbdhjid: zzbdhjid };

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/zdybl/saveCustomLinkData', 'POST', params).then(function (res) {
                    if (res) {
                        if (res.data == '1') {
                            _this.setState({
                                loading: false
                            });
                            __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.success('环节办理成功！');
                            //办理完成回调
                            var onFinish = _this.props.onFinish;
                            if (onFinish) {
                                onFinish();
                            }
                        } else {
                            _this.setState({
                                loading: false
                            });
                            __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error('环节办理失败，请重试！');
                        }
                    }
                });
            });
        };

        _this.handleCancel = function () {
            var pkid = _this.state.hjblztData.pkid;

            var zzbdhjid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_globalUtil__["a" /* getHashParam */])('pkid');
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var params = { xsid: xsid, lchjid: pkid, zzbdhjid: zzbdhjid };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/zdybl/cancelCustomLinkData', 'POST', params).then(function (res) {
                if (res) {
                    if (res.data == '1') {
                        __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.success('环节办理取消成功！');
                        //取消办理完成回调
                        var onFinish = _this.props.onFinish;
                        if (onFinish) {
                            onFinish();
                        }
                    } else {
                        __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error('环节办理取消失败，请重试！');
                    }
                }
            });
        };

        _this.handleLast = function () {
            var onLast = _this.props.onLast;
            if (onLast) {
                onLast();
            }
        };

        _this.handleNext = function () {
            var onNext = _this.props.onNext;
            if (onNext) {
                onNext();
            }
        };

        _this.getDmkMc = function (dmbz, zdbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])("/proData/selectDataList", "GET", { sign: dmbz }).then(function (res) {
                if (res) {
                    if (res.data) {
                        var dmkmcList = _this.state.dmkmcList;
                        dmkmcList[zdbz] = res.data;
                        _this.setState({
                            dmkmcList: dmkmcList
                        });
                    }
                }
            });
        };

        _this.getCascaderDmkMc = function (level, sign, cascaderValue, zdbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])("/proData/selectCascaderList", "GET", { level: level, sign: sign, cascaderValue: cascaderValue }).then(function (res) {
                if (res) {
                    if (res.data) {
                        var dmkmcList = _this.state.dmkmcList;
                        dmkmcList[level + zdbz] = res.data;
                        _this.setState({
                            dmkmcList: dmkmcList
                        });
                    }
                }
            });
        };

        _this.handlePreview = function (fjmc, fjid) {
            if (fjmc === "isImage") {
                _this.showPreview('anonymity/docrepo/download/file?attachmentId=' + fjid);
            } else {
                window.open('anonymity/docrepo/download/file?attachmentId=' + fjid);
            }
        };

        _this.showPreview = function (url) {
            _this.setState({
                previewImage: url,
                previewVisible: true
            });
        };

        _this.closeModal = function () {
            return _this.setState({ previewVisible: false });
        };

        _this.fileLists = function (fileLists) {
            {
                var items = [];

                var _loop = function _loop(key) {
                    var fileList = fileLists[key].split(";");
                    items.push(__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                            'a',
                            { onClick: function onClick() {
                                    _this.handlePreview("file", fileList[0]);
                                } },
                            fileList[1],
                            ' '
                        )
                    ));
                };

                for (var key in fileLists) {
                    _loop(key);
                }
                return items;
            }
        };

        _this.imageLists = function (imageLists) {
            {
                var items = [];

                var _loop2 = function _loop2(key) {
                    var imageList = imageLists[key].split(";");
                    items.push(__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('img', { style: { height: "86px", width: "86px" }, src: "anonymity/docrepo/download/file?attachmentId=" + imageList,
                            onClick: function onClick() {
                                _this.handlePreview("isImage", imageList[0]);
                            } })
                    ));
                };

                for (var key in imageLists) {
                    _loop2(key);
                }
                return items;
            }
        };

        _this.state = {
            hjblztData: {}, //环节办理状态信息
            hjywxData: [], //环节业务项信息
            editable: true, //是否可编辑
            previewVisible: false,
            dmkmcList: {},
            loading: false
        };
        return _this;
    }

    _createClass(Common, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('hjblztData' in nextProps) {
                var hjblztData = nextProps.hjblztData;
                if (hjblztData) {
                    var editable = hjblztData.blzt == '1' ? false : true;
                    this.setState({ hjblztData: hjblztData, editable: editable });
                } else {
                    this.setState({ hjblztData: hjblztData, editable: true });
                }
            }
        }

        //确认办理


        //取消办理


        //上一步


        //下一步

        //获取下拉列表value对应的名称


        //获取联级下拉列表value对应的名称


        // 点击文件链接或预览图标时的回调


        //打开图片弹窗

        // 关闭图片弹窗

        // 文件展示

        //图片展示

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                form = _props.form,
                hjywxData = _props.hjywxData,
                hjblztData = _props.hjblztData,
                hasLast = _props.hasLast,
                hasNext = _props.hasNext;
            var _state = this.state,
                editable = _state.editable,
                previewVisible = _state.previewVisible,
                previewImage = _state.previewImage;


            var formItems = [];
            var formItemLayout = {//表单项布局
                /*    labelCol: {
                       xs: { span: 24 },
                       sm: { span: 12 },
                       md: { span: 10 },
                       lg: { span: 4 },
                   },
                   wrapperCol: {
                       xs: { span: 24 },
                       sm: { span: 12 },
                       md: { span: 10 },
                       lg: { span: 8 },
                   } */
            };

            if (hjywxData && hjywxData.length > 0) {
                var _loop3 = function _loop3(key) {
                    var hjywx = hjywxData[key];
                    var kjcsjson = JSON.parse(hjywx.kjcs);
                    var ywxz = hjywx.ywxz;
                    var zdbz = hjywx.zdbz;
                    var formItem = "";
                    if (editable) {
                        formItem = __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-customLink-__index__kzxx_item_textarea' },
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-customLink-__index__kzxx_label' },
                                hjywx.sfbt === '1' ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'red' } },
                                    '*'
                                ) : __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('span', null),
                                hjywx.zdmc,
                                '\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-customLink-__index__kzxx_name_textarea' },
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_common_NHInputPicker_render__["a" /* default */], { id: hjywx.pkid,
                                    label: '',
                                    defaultValue: hjywx.mrz,
                                    value: kjcsjson.validationValueType === 'array' ? ywxz && typeof ywxz == 'string' ? ywxz.split(",") : ywxz ? ywxz : [] : ywxz,
                                    required: hjywx.sfbt === '1' ? true : false,
                                    form: form,
                                    feature: hjywx.kjcs,
                                    formItemLayout: formItemLayout })
                            )
                        );
                    } else {
                        if (kjcsjson.type === 'datepicker' || kjcsjson.type === 'datetimepicker' || kjcsjson.type === 'timepicker' || kjcsjson.type === 'monthpicker' || kjcsjson.type === 'rangepicker') {
                            //日期值展示阶段，从moment转为文字 

                            if (ywxz) {
                                ywxz = __WEBPACK_IMPORTED_MODULE_23_moment___default()(ywxz).format(kjcsjson.format);
                            }
                        } else if (kjcsjson.type === "select") {
                            if (kjcsjson.dataTag && !_this2.state.dmkmcList[zdbz]) {
                                _this2.getDmkMc(kjcsjson.dataTag, zdbz);
                            }
                            var list = _this2.state.dmkmcList[zdbz];
                            list && list.map(function (item) {
                                if (item.VALUE === ywxz) {
                                    ywxz = item.LABEL;
                                }
                            });
                        } else if (kjcsjson.type === "multiselect") {
                            if (kjcsjson.dataTag && !_this2.state.dmkmcList[zdbz]) {
                                _this2.getDmkMc(kjcsjson.dataTag, zdbz);
                            }
                            var _list = _this2.state.dmkmcList[zdbz];
                            if (ywxz) {
                                (function () {
                                    var multiselect = typeof ywxz == 'string' ? ywxz.split(",") : ywxz;
                                    var multiselectList = [];

                                    var _loop4 = function _loop4(i) {
                                        _list && _list.map(function (item) {
                                            if (item.VALUE === multiselect[i]) {
                                                multiselectList.push(item.LABEL);
                                            }
                                        });
                                    };

                                    for (var i in multiselect) {
                                        _loop4(i);
                                    }
                                    ywxz = multiselectList.join(",");
                                })();
                            }
                        } else if (kjcsjson.type === "nhcascader" && ywxz) {
                            (function () {
                                var nhcascaderList = typeof ywxz == 'string' ? ywxz.split(",") : ywxz;
                                var nhcascaderLists = [];

                                var _loop5 = function _loop5(i) {
                                    var level = i;
                                    var c = i;
                                    var d = i;
                                    var a = ++level;
                                    var b = --d;
                                    if (kjcsjson.dataTag && !_this2.state.dmkmcList[a + zdbz]) {
                                        if (i == "0") {
                                            _this2.getCascaderDmkMc(a, kjcsjson.dataTag, '', zdbz);
                                        } else {
                                            _this2.getCascaderDmkMc(a, kjcsjson.dataTag, nhcascaderList[b], zdbz);
                                        }
                                    }
                                    var list = _this2.state.dmkmcList[level++ + zdbz];

                                    list && list.map(function (item) {
                                        if (item.value === nhcascaderList[c]) {
                                            nhcascaderLists.push(item.label);
                                        }
                                    });
                                };

                                for (var i in nhcascaderList) {
                                    _loop5(i);
                                }
                                ywxz = nhcascaderLists.join("/");
                            })();
                        } else if (kjcsjson.type === "switch" && ywxz) {
                            ywxz = ywxz === "true" ? kjcsjson.checkedText : kjcsjson.uncheckedText;
                        } else if (kjcsjson.type === "radio" && ywxz) {
                            kjcsjson.options && kjcsjson.options.map(function (item, keys) {
                                if (item.value === ywxz) {
                                    ywxz = item.label;
                                }
                            });
                        } else if (kjcsjson.fileType === "file" && ywxz) {

                            var fileLists = typeof ywxz == 'string' ? ywxz.split(",") : ywxz;
                            ywxz = _this2.fileLists(fileLists);
                        } else if (kjcsjson.fileType === "image" && ywxz) {
                            var imageLists = typeof ywxz == 'string' ? ywxz.split(",") : ywxz;
                            if ((typeof ywxz === 'undefined' ? 'undefined' : _typeof(ywxz)) === 'object') {
                                var array = [];
                                var _iteratorNormalCompletion2 = true;
                                var _didIteratorError2 = false;
                                var _iteratorError2 = undefined;

                                try {
                                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_get_iterator___default()(ywxz), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                        var item = _step2.value;

                                        if (item.hasOwnProperty('uuid') && item['uuid']) {
                                            array.push(item['uuid']);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                            _iterator2.return();
                                        }
                                    } finally {
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }

                                imageLists = array;
                            }
                            ywxz = _this2.imageLists(imageLists);
                        }
                        formItem = __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                            FormItem,
                            _extends({}, formItemLayout, { label: hjywx.zdmc }),
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                'span',
                                null,
                                ywxz
                            )
                        );
                    }
                    formItems.push(formItem);
                };

                for (var key in hjywxData) {
                    _loop3(key);
                }
            } else {
                var _formItem = __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                    'span',
                    null,
                    '\u6682\u65E0\u9700\u8981\u586B\u5199\u7684\u4E1A\u52A1\u9879\u4FE1\u606F'
                );
                formItems.push(_formItem);
            }
            return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_11_antd_lib_card___default.a,
                    { type: 'inner', title: hjblztData && hjblztData.hjmc ? hjblztData.hjmc + '\u4E1A\u52A1\u4FE1\u606F' : '业务信息' },
                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_18_antd_lib_form___default.a,
                        null,
                        formItems
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_9_antd_lib_modal___default.a,
                    {
                        visible: previewVisible,
                        footer: null,
                        onCancel: this.closeModal
                    },
                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('img', {
                        alt: 'example',
                        style: { width: '100%' },
                        src: previewImage
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                    'div',
                    { style: { position: 'relative', textAlign: 'center' } },
                    editable ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,
                        { type: 'primary', style: { position: 'absolute', top: '74px', left: '308px' },
                            onClick: this.handleSubmit, loading: this.state.loading },
                        '\u786E\u8BA4\u529E\u7406'
                    ) : __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,
                        { type: 'primary', style: { position: 'absolute', top: '74px', left: '308px' },
                            onClick: this.handleCancel },
                        '\u53D6\u6D88\u529E\u7406'
                    )
                )
            );
        }
    }]);

    return Common;
}(__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component);

var common = __WEBPACK_IMPORTED_MODULE_18_antd_lib_form___default.a.create()(Common);

Common.propTypes = {
    xsData: __WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.object, //学生信息
    hjblztData: __WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.object, //环节办理状态数据
    hjywxData: __WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.array //环节业务项数据
};
/* harmony default export */ __webpack_exports__["a"] = (common);

/***/ }),

/***/ 1048:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card_style__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_card__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_json_stringify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_select__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_date_picker_style__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_date_picker__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__index_css__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__common__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_SelfHelp_common_hint__ = __webpack_require__(35);




















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }


















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_29_history_createHashHistory___default()();
var RangePicker = __WEBPACK_IMPORTED_MODULE_18_antd_lib_date_picker___default.a.RangePicker;

var Option = __WEBPACK_IMPORTED_MODULE_16_antd_lib_select___default.a.Option;

var CustomLink = function (_React$Component) {
    _inherits(CustomLink, _React$Component);

    function CustomLink(props) {
        _classCallCheck(this, CustomLink);

        var _this = _possibleConstructorReturn(this, (CustomLink.__proto__ || __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default()(CustomLink)).call(this, props));

        _this.getStudentPhotoBase64 = function (userId, callback) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/openapi/student/getStudentPhotoBase64', 'get', { xsid: userId, type: 10 }).then(function (res) {
                if (res && res.code == 200) {
                    callback(res.data);
                }
            });
        };

        _this.getSsxxDisplay = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHFetch__["a" /* default */])('/zzbdCommon/getCssz', 'GET', { csbz: 'YXWZ_ZZBD_GRXXYY_SFZSZSXX' }).then(function (res) {
                if (res) {
                    if (res.code == 200) {
                        _this.setState({
                            ssxxDisplay: res.data == "false" ? false : true
                        });
                    } else {
                        __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error("获取是否展示宿舍信息信息参数失败！");
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error("获取是否展示宿舍信息信息参数失败！");
                }
            });
        };

        _this.reload = function () {
            var mkbz = _this.getQueryString('mkbz');
            if (_this.state.mkbz != mkbz) {
                _this.setState({
                    mkbz: mkbz
                }, function () {
                    var hjid = _this.getQueryString('pkid');
                    var lchjid = _this.state.xsData['LCID'];
                    var xsid = _this.state.xsid;
                    _this.getHjblxx(hjid, lchjid, xsid);
                    _this.queryQztjAndYlhj();
                    _this.setNext(_this.state.menuList);
                    _this.getSsxxDisplay();
                });
            }
        };

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });

                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    } else if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    } else if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    } else {
                        _this.setState({ operable: true });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            _this.setState({ menuList: menuList });
            _this.setNext(menuList);
        };

        _this.setNext = function (menuList) {
            if (!menuList || menuList.length == 0) {
                return;
            }
            var nextCount = 0;
            var bz = _this.getQueryString("mkbz");
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_32__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = '/customLink';
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.getHjInfo = function () {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHFetch__["a" /* default */])('/zdybl/getXsxxAndLcidByXsid', 'GET', { xsid: userId }).then(function (res) {
                if (res) {
                    var data = res.data;
                    if (data) {
                        _this.setState({ xsData: data }, function () {
                            _this.getGyxx();
                        });
                    } else {
                        _this.setState({ xsData: {} });
                    }
                }
            });
        };

        _this.getHjData = function (mkbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHFetch__["a" /* default */])('/zzbd/getHjData', 'GET', { hjdm: mkbz }).then(function (res) {
                if (res) {
                    var data = res.data;
                    if (data) {
                        _this.setState({ hjData: data });
                    } else {
                        _this.setState({ hjData: {} });
                    }
                }
            });
        };

        _this.getGyxx = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/getXsssrzYwxxByXsid', 'GET').then(function (res) {
                if (res) {
                    var data = res.data;
                    if (data) {
                        var xqmc = data['xqmc'];
                        var ldmc = data['ldmc'];
                        var fj = data['fj'];
                        /* let ysje = data['ysje'];*/
                        var cwh = data['cwh'];
                        var ssxx = '';
                        if (xqmc) {
                            ssxx = xqmc + "-";
                        }
                        if (ldmc) {
                            ssxx += ldmc + "-";
                        }
                        if (fj) {
                            ssxx += fj + "-";
                        }
                        if (cwh) {
                            ssxx += cwh + "号床";
                        }

                        var xsData = _this.state.xsData;
                        xsData['SSXX'] = ssxx;
                        _this.setState({ xsData: xsData });
                    }
                }
            });
        };

        _this.getHjblxx = function (hjid, lchjid, xsid) {
            var hjblxxFilter = {};
            hjblxxFilter.xsid = xsid;
            hjblxxFilter.hjid = hjid;
            hjblxxFilter.lchjid = lchjid;
            _this.getHjblztData(hjblxxFilter);
            _this.getHjywxData(hjblxxFilter);
        };

        _this.getHjblztData = function (params) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHFetch__["a" /* default */])('/zdybl/getZzbdHjblztByFilter', 'GET', params).then(function (res) {
                if (res) {
                    var data = res.data;
                    if (data) {
                        _this.setState({ hjblztData: data });
                    } else {
                        _this.setState({ hjblztData: {} });
                    }
                }
            });
        };

        _this.getHjywxData = function (params) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHFetch__["a" /* default */])('/zdybl/getHjywxByFilter', 'GET', params).then(function (res) {
                if (res) {
                    var data = res.data;
                    if (data) {
                        _this.setState({ hjywxData: data });
                    } else {
                        _this.setState({ hjywxData: [] });
                    }
                }
            });
        };

        _this.finish = function () {
            var hjid = _this.getQueryString('pkid');
            var lchjid = _this.state.xsData['LCID'];
            var xsid = _this.state.xsid;
            _this.reloadMenu();
            _this.getHjblxx(hjid, lchjid, xsid);
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.getBlzt = function () {
            var xsid = _this.state.xsid;
            var zzbdhjid = _this.getQueryString('pkid');
            var params = {
                'zzbdhjid': zzbdhjid,
                'xsid': xsid
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHFetch__["a" /* default */])('/zzbdCommon/getBlzt', 'GET', params).then(function (res) {
                if (res) {
                    //let blzt = res.data.blzt;
                    if (res.data && res.data.blzt && res.data.blzt == '1') {
                        history.push({
                            pathname: _this.state.nextUrl,
                            search: _this.state.search
                        });
                    } else {
                        __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.warning("请先确认知悉，再点下一步");
                    }
                }
            });
        };

        _this.updateStatus = function () {
            var zzbdhjid = _this.getQueryString('pkid');
            var xsid = _this.state.xsid;
            var postData = {
                'zzbdhjid': zzbdhjid,
                'xsid': xsid
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHFetch__["a" /* default */])('/zzbdCommon/commonSaveLinkTransactionStatus', 'POST', postData).then(function (res) {
                if (res) {
                    __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.success("已确认办理");
                    _this.reloadMenu();
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            xsid: '', //学生id
            xsData: {}, //学生信息
            hjywxData: [], //环节业务项
            hjblztData: {}, //环节办理状态
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            mkbz: '',
            hjData: {},
            menuList: [],
            ssxxDisplay: false //宿舍信息是否显示(true显示，false不显示)
        };
        return _this;
    }

    _createClass(CustomLink, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var mkbz = this.getQueryString('mkbz');
            var lx = this.getQueryString('lx');
            this.setState({
                mkbz: mkbz,
                xsid: userId,
                lx: lx
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.getSsxxDisplay();
            var lx = this.state.lx;
            var mkbz = this.getQueryString('mkbz');
            this.queryQztjAndYlhj();
            if (lx && lx == 0) {
                this.getHjData(mkbz);
            } else {
                this.getHjInfo();
            }

            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                this.getStudentPhotoBase64(userId, function (data) {
                    if (!data) return;
                    _this2.setState({
                        xsid: userId,
                        imageUrl: 'data:image/jpeg;base64,' + data
                    });
                });
            }
        }

        // 获取学生头像

    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            var _this3 = this;

            var mkbz = this.getQueryString('mkbz');
            var lx = this.getQueryString('lx');
            if (lx && lx == 0) {
                //自定义环节，没关联环节
                if (this.state.mkbz != mkbz) {
                    this.setState({
                        mkbz: mkbz,
                        lx: lx
                    }, function () {
                        _this3.setNext(_this3.state.menuList);
                        _this3.getHjData(mkbz);
                        _this3.queryQztjAndYlhj();
                    });
                }
            } else {
                if (__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_json_stringify___default()(this.state.xsData) == '{}' && __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_json_stringify___default()(nextState.xsData) != '{}') {
                    var hjid = this.getQueryString('pkid');
                    var lchjid = nextState.xsData['LCID'];
                    var xsid = this.state.xsid;
                    this.getHjblxx(hjid, lchjid, xsid);
                }
                if (this.state.mkbz != mkbz) {
                    this.setState({
                        mkbz: mkbz,
                        lx: lx
                    }, function () {
                        _this3.setNext(_this3.state.menuList);
                        var hjid = _this3.getQueryString('pkid');
                        var lchjid = nextState.xsData['LCID'];
                        var xsid = _this3.state.xsid;
                        _this3.getHjblxx(hjid, lchjid, xsid);
                        _this3.queryQztjAndYlhj();
                    });
                }
            }
            return true;
        }

        //获取是否展示宿舍信息参数设置


        //查询前置条件和依赖环节


        //获取环节办理信息


        //获取环节办理状态信息


        //获取环节业务项信息


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var xsData = this.state.xsData;
            var hjywxData = this.state.hjywxData;
            var hjblztData = this.state.hjblztData;
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            this.reload();
            var _state = this.state,
                ssxxDisplay = _state.ssxxDisplay,
                imageUrl = _state.imageUrl;

            return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_21__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        title: '\u81EA\u52A9\u62A5\u5230',
                        setMenuList: this.setMenuList,
                        menuType: '\u81EA\u52A9\u62A5\u5230',
                        mkbz: this.state.mkbz,
                        lx: this.state.lx
                    }),
                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_21__components__["a" /* Flex */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjData['HJMC'] }]
                        }),
                        this.state.lx && this.state.lx == 0 ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjData['HJMC'], extra: false }),
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-customLink-__index__ueditor' },
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.hjData['PCBLTS'] } })
                            ),
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                'div',
                                { className: 'text-center mt-50' },
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default.a,
                                    {
                                        onClick: function onClick() {
                                            return _this4.updateStatus();
                                        },
                                        type: 'primary',
                                        htmlType: 'submit'
                                    },
                                    '\u786E\u8BA4\u77E5\u6089'
                                ),
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                            )
                        ) : __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__pages_Assembly_titleTop__["a" /* default */], { title: '\u4E2A\u4EBA\u4FE1\u606F', extra: false }),
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_4_antd_lib_card___default.a,
                                { style: { paddingLeft: 0 }, bordered: false },
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                        { xl: 4, lg: 6, md: 12, sm: 24, xs: 24, style: { lineHeight: '22px', paddingBottom: '12px' } },
                                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('img', {
                                            src: imageUrl,
                                            onError: function onError(e) {
                                                e.target.src = __webpack_require__(2190);
                                            },
                                            style: { width: 125, height: 150 } })
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                        { xl: 7, lg: 9, md: 12, sm: 24, xs: 24, style: { lineHeight: '22px', paddingBottom: '12px' } },
                                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                            'div',
                                            { style: { lineHeight: '22px', paddingBottom: '12px' } },
                                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                                'span',
                                                null,
                                                '\u59D3 \u540D\uFF1A'
                                            ),
                                            xsData.XM
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                            'div',
                                            { style: { lineHeight: '22px', paddingBottom: '12px' } },
                                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                                'span',
                                                null,
                                                '\u6027 \u522B\uFF1A'
                                            ),
                                            xsData.XB
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                            'div',
                                            { style: { lineHeight: '22px', paddingBottom: '12px' } },
                                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                                'span',
                                                null,
                                                '\u6C11 \u65CF\uFF1A'
                                            ),
                                            xsData.MZ
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                            'div',
                                            { style: { lineHeight: '22px', paddingBottom: '12px' } },
                                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                                'span',
                                                null,
                                                '\u5B66 \u9662\uFF1A'
                                            ),
                                            xsData.BMMC
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                            'div',
                                            { style: { lineHeight: '22px', paddingBottom: '12px' } },
                                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                                'span',
                                                null,
                                                '\u73ED \u7EA7\uFF1A'
                                            ),
                                            xsData.BJMC
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                        { xl: 7, lg: 9, md: 12, sm: 24, xs: 24, style: { lineHeight: '22px', paddingBottom: '12px' } },
                                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                            'div',
                                            { style: { lineHeight: '22px', paddingBottom: '12px' } },
                                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                                'span',
                                                null,
                                                '\u8EAB\u4EFD\u8BC1\u53F7\uFF1A'
                                            ),
                                            xsData.SFZJH
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                            'div',
                                            { style: { lineHeight: '22px', paddingBottom: '12px' } },
                                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                                'span',
                                                null,
                                                '\u51FA\u751F\u65E5\u671F\uFF1A'
                                            ),
                                            xsData.CSRQ
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                            'div',
                                            { style: { lineHeight: '22px', paddingBottom: '12px' } },
                                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                                'span',
                                                null,
                                                '\u5B66\u751F\u7C7B\u578B\uFF1A'
                                            ),
                                            xsData.XSLB
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                            'div',
                                            { style: { lineHeight: '22px', paddingBottom: '12px' } },
                                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                                'span',
                                                null,
                                                '\u4E13\u4E1A\uFF1A'
                                            ),
                                            xsData.ZYMC
                                        ),
                                        ssxxDisplay && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                            'div',
                                            { style: { lineHeight: '22px', paddingBottom: '12px' } },
                                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                                'span',
                                                null,
                                                '\u5BBF\u820D\u4FE1\u606F\uFF1A'
                                            ),
                                            xsData.SSXX
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                        { xl: 6, lg: 12, md: 12, sm: 24, xs: 24, style: { lineHeight: '22px', paddingBottom: '12px' } },
                                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                            'div',
                                            { style: { lineHeight: '22px', paddingBottom: '12px' } },
                                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                                'span',
                                                null,
                                                '\u751F\u6E90\u5730\uFF1A'
                                            ),
                                            xsData.SYD
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                            'div',
                                            { style: { lineHeight: '22px', paddingBottom: '12px' } },
                                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                                'span',
                                                null,
                                                '\u8054\u7CFB\u7535\u8BDD\uFF1A'
                                            ),
                                            xsData.SJHM
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__common__["a" /* default */], { key: "1", studentData: xsData, onFinish: this.finish,
                                    hjblztData: hjblztData, hjywxData: hjywxData })
                            ),
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                'div',
                                { className: 'p-sw text-center mt-30' },
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__common__["a" /* default */], { hjmc: this.state.hjData['HJMC'], key: 'mkbz', mkbz: this.state.mkbz, nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return CustomLink;
}(__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component);



/***/ }),

/***/ 1049:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dorm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert_style__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_radio_style__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_radio__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_checkbox_style__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_checkbox__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__selectBox__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__selectModal__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__index_css__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__utils_getSize__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_common_NHModal__ = __webpack_require__(106);
























var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }





















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_34_history_createHashHistory___default()();
var confirm = __WEBPACK_IMPORTED_MODULE_22_antd_lib_modal___default.a.confirm;
var CheckboxGroup = __WEBPACK_IMPORTED_MODULE_20_antd_lib_checkbox___default.a.Group;
var RadioGroup = __WEBPACK_IMPORTED_MODULE_18_antd_lib_radio___default.a.Group;

/**
 * @author weishihuai
 * @date 2018/7/6
 * @time 14:41
 * @Description: 迎新网站-自助报到-宿舍分配
 */

var Dorm = function (_React$Component) {
    _inherits(Dorm, _React$Component);

    function Dorm(props) {
        _classCallCheck(this, Dorm);

        var _this2 = _possibleConstructorReturn(this, (Dorm.__proto__ || __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_get_prototype_of___default()(Dorm)).call(this, props));

        _this2.updateZzbdBlzt = function () {
            var zzbdhjid = _this2.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/zzbd/updateZzbdBlzt', 'GET', { zzbdhjid: zzbdhjid, hjdm: 'GD006' }).then(function (res) {
                if (res.data) {
                    _this2.reloadMenu();
                }
            });
        };

        _this2.queryQztjAndYlhj = function (callback) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this2.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this2.getUrlParams('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this2.setState({ nonOperationalData: res.data });
                    if (kfsj && kfsj['YXSJ'] != '1') {
                        _this2.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this2.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this2.setState({ operable: false });
                    }

                    if (callback) {
                        callback(_this2.state.operable);
                    }
                }
            });
        };

        _this2.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this2.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this2.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_38__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this2.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this2.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this2.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this2.getUrlParams = function (param) {
            return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this2.getSfbzAndCwsInfo = function (xsid, xqid, xbm) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])("/gyxtUnauth/cwfp/getYxxcSfbzAndSslxInfo", 'GET', { xqid: xqid ? xqid : "", xsid: xsid, xbm: xbm }).then(function (res) {
                if (res) {
                    var data = res.data;
                    _this2.setState({
                        cwsList: data.cwsList,
                        sfbzList: data.sfbzList,
                        xqList: data.xqList
                    });

                    //如果学生无校区信息,默认加载第一个Tab校区的宿舍信息
                    if (!xqid) {
                        _this2.setState({
                            currentXqid: data.xqList[0].XQID
                        });
                        _this2.getFjxxList({
                            cws: "",
                            sfbz: "",
                            xsid: xsid,
                            xqid: data.xqList[0].XQID,
                            xbm: xbm
                        });
                    }
                }
            });
        };

        _this2.getFjxxList = function (param) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])("/gyxtUnauth/cwfp/getYxwzSsfpFjxxList", 'GET', param).then(function (res) {
                if (res) {
                    _this2.setState({
                        fjxxList: res.data
                    });
                }
            });
        };

        _this2.getXsssrzYwxxByXsid = function (xsid) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/getXsssrzYwxxByXsid', 'GET', {
                xsid: xsid
            }).then(function (res) {
                if (res && res.data) {
                    _this2.setState({
                        xsssruYwxx: res.data
                    });
                }
            });
        };

        _this2.confirmCwfpxx = function (xzId) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xqid = loginUserInfo.XQID,
                xbm = loginUserInfo.XBM;

            if (!xzId) {
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.warning("请先选择一个床位！");
                return;
            }

            //检查该床位是否被其他学生抢占(防并发的情况下同一个床位被其他人重复选择)
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/checkCwIsPermitSelect', 'GET', { cwid: xzId, xsid: xsid }).then(function (res) {
                if (res) {
                    if (res.data === 0) {
                        __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("抱歉，该床位已经被其他同学抢占，请选择其他床位！");
                        return;
                    } else {
                        //确认床位信息
                        _this2.cwfpSubmit(xsid, xzId, xqid, xbm);
                    }
                }
            });
        };

        _this2.cwfpSubmit = function (xsid, currentClickCwPkid, xqid, xbm) {
            var zzbdhjid = _this2.getUrlParams("pkid");
            var params = { xsid: xsid, cwid: currentClickCwPkid, zzbdhjid: zzbdhjid };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/checkCwIsAvailableSelected', 'GET', { cwid: currentClickCwPkid }).then(function (res) {
                if (res) {
                    if (res.data) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/yxwzConfirmCwxx', 'POST', params).then(function (res) {
                            if (res) {
                                if (res.data) {
                                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.success("分配成功！");
                                    _this2.reloadMenu();
                                    _this2.setState({
                                        currentClickCwPkid: ""
                                    });

                                    _this2.getFjxxList({
                                        cws: "",
                                        sfbz: "",
                                        xsid: xsid,
                                        xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                                        xbm: xbm
                                    });

                                    _this2.getXsssrzYwxxByXsid(xsid);

                                    _this2.checkZzbdisLinked();
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("分配失败，请稍后重试！");
                                }
                            }
                        });
                    } else {
                        __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("抱歉，该床位未到分配时间或已过床位分配时间期限，请选择其他床位! ");
                    }
                }
            });
        };

        _this2.showConfirm = function (value, id, cwh) {
            confirm({
                title: __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                    'span',
                    null,
                    '\u786E\u5B9A\u9009\u62E9',
                    value.name,
                    '\u623F\u95F4\u7684\u4E0B\u5217\u5E8A\u94FA\uFF1F'
                ),
                content: __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__selectModal__["a" /* default */], {
                    data: value,
                    id: id,
                    currentClickCwh: cwh,
                    onChange: function onChange(value) {
                        _this2.setState({
                            xzId: value.id,
                            currentClickCwPkid: value.id
                        });
                    }
                }),
                onOk: function onOk() {
                    var currentClickCwPkid = _this2.state.currentClickCwPkid;
                    //确定分配宿舍提交

                    _this2.confirmCwfpxx(currentClickCwPkid);
                },
                onCancel: function onCancel() {
                    _this2.setState({
                        currentClickCwPkid: ""
                    });
                }
            });
        };

        _this2.judeageCs = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/yxwzSyzxcs', 'GET', { xsid: xsid }).then(function (res) {

                if (res && res.data === -1) {
                    _this2.handleCancelListener();
                } else if (res && res.data === 0) {
                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("自选宿舍次数已用完，不可再取消办理");
                    /* NHConfirm("自选宿舍次数已用完，取消后不能再进行自选宿舍操作！确定取消？",() => {
                    this.handleCancelListener();
                    },"warn"); */
                } else if (res && res.data !== -1 && res.data !== 0) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_40__components_common_NHModal__["b" /* NHConfirm */])("确定取消？取消后还剩" + res.data + "次可选", function () {
                        _this2.handleCancelListener();
                    }, "warn");
                }
            });
        };

        _this2.handleCancelListener = function () {
            _this2.setState({
                cancelLoading: true
            });
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xqid = loginUserInfo.XQID,
                xbm = loginUserInfo.XBM;

            var zzbdhjid = _this2.getUrlParams("pkid");
            var params = { xsid: xsid, zzbdhjid: zzbdhjid };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/cancelBlSsfp', 'POST', params).then(function (res) {
                if (res && res.data === 1) {
                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.success('取消办理成功！');
                    _this2.reloadMenu();
                    _this2.getFjxxList({
                        cws: "",
                        sfbz: "",
                        xsid: xsid,
                        xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                        xbm: xbm
                    });

                    _this2.checkZzbdisLinked();

                    _this2.setState({
                        xsssruYwxx: {},
                        cancelLoading: false
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error('取消办理失败，请稍后重试！');
                    _this2.setState({
                        cancelLoading: false
                    });
                }
            }).catch(function () {
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("取消办理失败，请稍后重试！");
                _this2.setState({
                    cancelLoading: false
                });
            });
        };

        _this2.handleAutoDistributeListener = function () {
            _this2.setState({
                autoBlLoading: true
            });
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xqid = loginUserInfo.XQID,
                xbm = loginUserInfo.XBM;
            var zzbdhjid = _this2.getUrlParams("pkid");

            if (!xsid) {
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.warning("自动办理失败,请稍后重试！");
                return;
            }

            var param = _this2.state.param;
            //自动分配宿舍

            var params = {
                cws: param.cws || "",
                sfbz: param.sfbz || "",
                xsid: xsid,
                xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                xbm: xbm,
                zzbdhjid: zzbdhjid
            };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])("/gyxtUnauth/cwfp/yxwzAutoDistributeSscwxx", 'POST', params).then(function (res) {
                if (res) {
                    if (res.data === 1) {
                        var text = "";
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/getXsssrzYwxxByXsid', 'GET', { xsid: xsid }).then(function (res) {
                            if (res && res.data) {
                                var data = res.data;
                                _this2.setState({
                                    xsssruYwxx: data
                                });
                                text = data.ldmc + "-" + data.fj + "-" + data.cwh + "号床位";
                                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.success("自动办理成功,分配宿舍为 " + text + "！");
                                _this2.reloadMenu();
                                _this2.getFjxxList({
                                    cws: "",
                                    sfbz: "",
                                    xsid: xsid,
                                    xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                                    xbm: xbm
                                });

                                _this2.getXsssrzYwxxByXsid(xsid);
                                _this2.checkZzbdisLinked();

                                _this2.setState({
                                    autoBlLoading: false
                                });
                            } else {
                                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("自动办理失败,请稍后重试！");
                                _this2.setState({
                                    autoBlLoading: false
                                });
                            }
                        });
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("自动办理失败,请稍后重试！");
                    _this2.setState({
                        autoBlLoading: false
                    });
                }
            }).catch(function () {
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("自动办理失败,请稍后重试！");
                _this2.setState({
                    autoBlLoading: false
                });
            });
        };

        _this2.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this2.checkZzbdisLinked = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this2.getUrlParams("pkid");
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])("/zzbdCommon/checkIsZzbdHjLinked", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                console.log("公寓", res.data);
                if (res) {
                    if (res.data) {
                        _this2.setState({
                            isHjLinked: res.data
                        });
                    } else {
                        _this2.setState({
                            isHjLinked: false
                        });
                    }
                } else {
                    _this2.setState({
                        isHjLinked: false
                    });
                }
            });
        };

        _this2.autoSelectCwListener = function (value) {
            _this2.setState({
                zdrzLoading: true
            });
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xqid = loginUserInfo.XQID,
                xbm = loginUserInfo.XBM;

            var yxwzCwxxTzVOs = value.yxwzCwxxTzVOs,
                name = value.name;

            var zzbdhjid = _this2.getUrlParams("pkid");
            var availableSelectArr = [],
                availSelectCwPkId = "",
                text = "";

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(yxwzCwxxTzVOs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    availableSelectArr.push(item.xz);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (availableSelectArr.indexOf("0") === -1) {
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.warning("抱歉，该房间已满员，请选择其他房间！");
                return;
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(yxwzCwxxTzVOs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _item = _step2.value;

                    //床位未被选择并且未过分配期限
                    if (_item.xz === '0' && !_item.expire) {
                        availSelectCwPkId = _item.id;
                        text = name + "-" + _item.cwh;
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            if (availSelectCwPkId) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/checkCwIsPermitSelect', 'GET', { cwid: availSelectCwPkId, xsid: xsid }).then(function (res) {
                    if (res) {
                        if (res.data === 0) {
                            __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("抱歉，该床位已经被其他同学抢占，请选择其他床位！");
                            _this2.setState({
                                zdrzLoading: false
                            });
                            return;
                        } else {
                            // 确认床位信息
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/yxwzConfirmCwxx', 'POST', {
                                xsid: xsid,
                                cwid: availSelectCwPkId,
                                zzbdhjid: zzbdhjid
                            }).then(function (res) {
                                if (res) {
                                    if (res.data) {
                                        __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.success("分配成功，分配宿舍为 " + text + ", 请尽快确认办理！");
                                        _this2.reloadMenu();
                                        _this2.getFjxxList({
                                            cws: "",
                                            sfbz: "",
                                            xsid: xsid,
                                            xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                                            xbm: xbm
                                        });

                                        _this2.getXsssrzYwxxByXsid(xsid);
                                        _this2.checkZzbdisLinked();

                                        _this2.setState({
                                            zdrzLoading: false
                                        });
                                    }
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("分配失败，请稍后重试！");
                                    _this2.setState({
                                        zdrzLoading: false
                                    });
                                }
                            });
                        }
                    }
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.warning("抱歉，未匹配到合适的床位信息,请选择其他床位！");
                _this2.setState({
                    zdrzLoading: false
                });
            }
        };

        _this2.onSfbzChangeListener = function (checkedValues) {
            var _this2$state = _this2.state,
                param = _this2$state.param,
                currentXqid = _this2$state.currentXqid,
                sfmy = _this2$state.sfmy;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xbm = loginUserInfo.XBM;
            param.sfbz = checkedValues.length > 0 ? checkedValues.join(",") : "";
            param.xsid = xsid;
            param.xqid = currentXqid ? currentXqid : _this2.state.xqList[0].XQID;
            param.xbm = xbm;
            param.sfmy = sfmy;
            _this2.setState({
                sfbz: checkedValues.length > 0 ? checkedValues.join(",") : ""
            });
            _this2.getFjxxList(param);
        };

        _this2.onSfmyChangeListener = function (e) {
            var _this2$state2 = _this2.state,
                param = _this2$state2.param,
                currentXqid = _this2$state2.currentXqid,
                sfbz = _this2$state2.sfbz;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xbm = loginUserInfo.XBM;
            param.sfbz = sfbz;
            param.xsid = xsid;
            param.xqid = currentXqid ? currentXqid : _this2.state.xqList[0].XQID;
            param.xbm = xbm;
            param.sfmy = e.target.value;
            _this2.setState({
                sfmy: e.target.value
            });
            _this2.getFjxxList(param);
        };

        _this2.onCwsChange = function (checkedValues) {
            var _this2$state3 = _this2.state,
                param = _this2$state3.param,
                currentXqid = _this2$state3.currentXqid;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xbm = loginUserInfo.XBM;
            param.cws = checkedValues.length > 0 ? checkedValues.join(",") : "";
            param.xsid = xsid;
            param.xbm = xbm;
            param.xqid = currentXqid ? currentXqid : _this2.state.xqList[0].XQID;
            _this2.getFjxxList(param);
        };

        _this2.tabChangeListener = function (activeKey) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xbm = loginUserInfo.XBM;
            var _this2$state$param = _this2.state.param,
                cws = _this2$state$param.cws,
                sfbz = _this2$state$param.sfbz;


            _this2.setState({
                currentXqid: activeKey
            });

            //加载房间信息
            _this2.getFjxxList({
                cws: cws || "",
                sfbz: sfbz || "",
                xsid: xsid,
                xqid: activeKey,
                xbm: xbm
            });
        };

        _this2.reloadMenu = function () {
            _this2.refs.siderMenu.reloadMenuList();
        };

        _this2.state = {
            mkbz: 'GD006',
            hjmc: '',
            xzId: '',
            _xzId: '',
            cwsList: [], //床位数
            sfbzList: [], //收费标准
            xqList: [], //校区信息
            currentXqid: "", //当前校区ID
            fjxxList: [], //房间信息
            currentClickCwPkid: "", //当前床位信息ID
            xsssruYwxx: {}, //学生宿舍入住业务信息
            isHjLinked: false, //环节是否办理状态
            param: {}, //过滤条件
            scrollHeight: 200, //默认滚动高度
            loginUserInfo: {}, //当前登录学生信息
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            autoBlLoading: false, //自动办理按钮载入状态
            cancelLoading: false, //取消办理按钮载入状态
            zdrzLoading: false, //自动入住载入状态
            sfbz: "", //收费标准选中值
            sfmy: "" //是否满员选中值
        };
        return _this2;
    }

    _createClass(Dorm, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var that = this;
            this.setState({ scrollHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_getSize__["a" /* default */])().windowH - 206 });
            window.onresize = function () {
                that.setState({
                    scrollHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_getSize__["a" /* default */])().windowH - 206
                });
            };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/newStudent/' + xsid + '/getYxwzUserInfoByXsid', 'GET').then(function (res) {
                if (res && res.data) {
                    _this3.queryQztjAndYlhj(function (operable) {
                        if (operable) {
                            // let xsid = getLoginUser() ? getLoginUser().userId : '';
                            if (xsid) {
                                var _this = _this3;
                                // getLoginUserInfo(xsid, data => {
                                _this.setState({
                                    // loginUserInfo: data
                                    loginUserInfo: res.data
                                }, function () {
                                    var loginUserInfo = _this.state.loginUserInfo;

                                    var xqid = loginUserInfo.XQID,
                                        xbm = loginUserInfo.XBM;

                                    if (xsid) {
                                        //办理状态根据 关联现场环节和是否反向关联修改 不根据现场状态
                                        //_this.updateZzbdBlzt();
                                        //加载收费标准、床位数信息
                                        _this.getSfbzAndCwsInfo(xsid, xqid, xbm);
                                        _this.getXsssrzYwxxByXsid(xsid);
                                        //如果学生校区ID不为空,则只加载本校区宿舍信息
                                        if (xqid) {
                                            _this.setState({
                                                currentXqid: xqid
                                            });
                                            _this.getFjxxList({
                                                cws: "",
                                                sfbz: "",
                                                xsid: xsid,
                                                xqid: xqid,
                                                xbm: xbm
                                            });
                                        }
                                    }
                                    _this.checkZzbdisLinked();
                                });
                                // });
                            }
                        }
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("抱歉，未能查询到相关学生信息，请稍后重试！");
                }
            });
        }

        //迎新现场已办理时迎新网站自动办理


        //查询前置条件和依赖环节


        //获取url中传递的参数


        //获取收费标准、床位信息等


        //获取宿舍房间信息


        // 过滤可以选择的房间信息
        /* fitlerRoom = () =>{
            let kyxzRoom= [];
                        // console.log("获取房间信息-------",res.data);
                        let fjxxList = this.state.fjxxList;
                        fjxxList.map((item,index)=>{
                            if(item.yxNum < item.allNum){
                                // console.log("未住满的房间(个数判断)------",item);
                                if(item.bedList && item.bedList.length > 0){
                                    item.yxwzCwxxTzVOs.map((item2,index2)=>{
                                        console.log("item2",item2);
                                        if(item2.xz == '0'){
                                            // console.log("可以选择的床位---------",item2,item);
                                                kyxzRoom.push(item);
                                        }
                                    })
                                }
                            }
                        })
                        let setRoom = [];
                        if(kyxzRoom.length > 0){
                            setRoom = Array.from(new Set(kyxzRoom));
                            // setRoom = Array.from(setRoom);
                        }
                        console.log("过滤后的房间------",kyxzRoom,setRoom);
                        this.setState({
                            setRoom:setRoom
                        })
        } */

        //查询学生宿舍入住信息


        //确认床位分配


        //床位分配提交


        //选择床位弹层


        //取消办理事件


        //自动办理事件

        //检查环节是否已办理


        //自动入住事件


        //收费标准onChange事件


        //是否满员onChange事件


        //宿舍类型onChange事件


        //tab切换事件


        //重新加载菜单

    }, {
        key: 'render',


        /*  handleNextRoom = (RoomList) =>{
             const {fjxxList,setRoom} = this.state;
             console.log("当前宿舍信息-----------",RoomList,fjxxList,setRoom);
             let list = [];
             fjxxList.map((item,index)=>{
                 if(item.fjid == "cba18dd6-ac51-4119-b35e-1f2d9eb30bf7"){
                     item. yxNum = '8';
                 }
                 list.push(item);
             })
             console.log("模拟修改-----------",list);
             this.setState({
                 fjxxList:list
             },()=>{
                 this.fitlerRoom();
             })
         } */

        value: function render() {
            var _this4 = this;

            var _state = this.state,
                xzId = _state.xzId,
                _xzId = _state._xzId,
                cwsList = _state.cwsList,
                xqList = _state.xqList,
                sfbzList = _state.sfbzList,
                fjxxList = _state.fjxxList,
                xsssruYwxx = _state.xsssruYwxx,
                isHjLinked = _state.isHjLinked,
                scrollHeight = _state.scrollHeight,
                currentXqid = _state.currentXqid,
                autoBlLoading = _state.autoBlLoading,
                cancelLoading = _state.cancelLoading,
                zdrzLoading = _state.zdrzLoading;
            //学生已选宿舍信息

            var xqmc = xsssruYwxx.xqmc,
                ldmc = xsssruYwxx.ldmc,
                fj = xsssruYwxx.fj,
                cwh = xsssruYwxx.cwh;

            var yxssInfo = (xqmc || "") + "-" + (ldmc || "") + "-" + (fj || "") + "-" + (cwh || "") + "号床";
            var fsmyList = [{ "label": "未满", "value": "0" }, { "label": "满员", "value": "1" }];
            /* let RoomList = []
            if(setRoom.length > 1){
                RoomList.push(setRoom[0]);
            }else{
                RoomList = setRoom;
            } */
            return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230',
                        mkbz: this.state.mkbz
                        /*   active={5}*/
                        , menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */].Item,
                        { className: 'page_con_r ' },
                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_titleTop__["a" /* default */],
                                {
                                    className: 'mt-20',
                                    title: this.state.hjmc,
                                    extra: false
                                },
                                !isHjLinked ? __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_12_antd_lib_button___default.a,
                                    {
                                        className: 'ml-10',
                                        type: 'primary',
                                        ghost: true,
                                        loading: autoBlLoading,
                                        onClick: this.handleAutoDistributeListener
                                    },
                                    '\u81EA\u52A8\u529E\u7406'
                                ) : __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_12_antd_lib_button___default.a,
                                    {
                                        className: 'ml-10',
                                        type: 'danger',
                                        ghost: true,
                                        loading: cancelLoading,
                                        onClick: this.judeageCs
                                    },
                                    '\u53D6\u6D88\u529E\u7406'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                'div',
                                { className: 'p-sw' },
                                __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */],
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                        'span',
                                        null,
                                        '\u6536\u8D39\u6807\u51C6\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */].Item,
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                            CheckboxGroup,
                                            {
                                                style: { width: '100%' },
                                                onChange: this.onSfbzChangeListener
                                            },
                                            __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_row___default.a,
                                                null,
                                                sfbzList.map(function (elem, index) {
                                                    return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_10_antd_lib_col___default.a,
                                                        {
                                                            key: index,
                                                            span: 4
                                                        },
                                                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_20_antd_lib_checkbox___default.a,
                                                            {
                                                                value: elem.value
                                                            },
                                                            elem.label
                                                        )
                                                    );
                                                })
                                            )
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */],
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                        'span',
                                        null,
                                        '\u662F\u5426\u6EE1\u5458\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */].Item,
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                            RadioGroup,
                                            {
                                                style: { width: '100%' },
                                                onChange: this.onSfmyChangeListener,
                                                defaultValue: '0'
                                            },
                                            __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_row___default.a,
                                                null,
                                                fsmyList.map(function (elem, index) {
                                                    return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_10_antd_lib_col___default.a,
                                                        {
                                                            key: index,
                                                            span: 4
                                                        },
                                                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_18_antd_lib_radio___default.a,
                                                            {
                                                                value: elem.value
                                                            },
                                                            elem.label
                                                        )
                                                    );
                                                })
                                            )
                                        )
                                    )
                                ),
                                isHjLinked && __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert___default.a, { message: "当前选择宿舍为: " + yxssInfo, type: 'info', showIcon: true })
                                ),
                                __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin___default.a,
                                    { spinning: zdrzLoading },
                                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-dorm-__index__tab_box' },
                                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__selectBox__["a" /* default */], {
                                            Data: fjxxList,
                                            xzId: _xzId,
                                            showConfirm: this.showConfirm,
                                            onChange: function onChange(value) {
                                                _this4.setState({
                                                    xzId: value.id,
                                                    currentClickCwPkid: value.id
                                                });
                                            },
                                            autoSelectCwListener: function autoSelectCwListener(value) {
                                                return _this4.autoSelectCwListener(value);
                                            },
                                            scrollHeight: scrollHeight,
                                            tabChangeListener: this.tabChangeListener,
                                            xqList: xqList,
                                            currentXqid: currentXqid
                                        })
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                'div',
                                { className: 'text-center mt-50' },
                                __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__common__["a" /* default */], { hjmc: "自选宿舍", key: 'GD006', mkbz: 'GD006', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return Dorm;
}(__WEBPACK_IMPORTED_MODULE_23_react___default.a.Component);



/***/ }),

/***/ 1050:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_popover_style__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_popover_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_popover_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_popover__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_tabs_style__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_plugin_react_css_modules_dist_browser_getClassName__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_plugin_react_css_modules_dist_browser_getClassName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_plugin_react_css_modules_dist_browser_getClassName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__index_css__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars__);











var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;


var _styleModuleImportMap = {
    './index.css': {
        'tab_box': 'app__css__app-pages-SelfHelp-dorm-__index__tab_box',
        'tip': 'app__css__app-pages-SelfHelp-dorm-__index__tip',
        'item': 'app__css__app-pages-SelfHelp-dorm-__index__item',
        'item_con': 'app__css__app-pages-SelfHelp-dorm-__index__item_con',
        'round': 'app__css__app-pages-SelfHelp-dorm-__index__round',
        'select_box': 'app__css__app-pages-SelfHelp-dorm-__index__select_box',
        'select_list': 'app__css__app-pages-SelfHelp-dorm-__index__select_list',
        'select_item': 'app__css__app-pages-SelfHelp-dorm-__index__select_item',
        'select_item_b': 'app__css__app-pages-SelfHelp-dorm-__index__select_item_b',
        'select_item_y': 'app__css__app-pages-SelfHelp-dorm-__index__select_item_y',
        'item_btn_box': 'app__css__app-pages-SelfHelp-dorm-__index__item_btn_box',
        'item_btn': 'app__css__app-pages-SelfHelp-dorm-__index__item_btn',
        'modal_box': 'app__css__app-pages-SelfHelp-dorm-__index__modal_box',
        'modal_list': 'app__css__app-pages-SelfHelp-dorm-__index__modal_list'
    }
};

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }










if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var TabPane = __WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default.a.TabPane;

/**
 * @author weishihuai
 * @date 2018/7/6
 * @time 14:42
 * @Description: 迎新网站-自助报到-宿舍分配-宿舍床位信息
 */
var SelectBox = (_temp = _class = function (_React$Component) {
    _inherits(SelectBox, _React$Component);

    function SelectBox(props) {
        _classCallCheck(this, SelectBox);

        var _this = _possibleConstructorReturn(this, (SelectBox.__proto__ || __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default()(SelectBox)).call(this, props));

        _this.getListItem = function () {
            var Data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var _this$props = _this.props,
                className = _this$props.className,
                showConfirm = _this$props.showConfirm,
                xzId = _this$props.xzId,
                onChange = _this$props.onChange,
                autoSelectCwListener = _this$props.autoSelectCwListener;

            return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_14__components__["a" /* Flex */],
                { align: 'top', wrap: 'wrap', className: 'mt-20' },
                Data.length > 0 ? Data.map(function (item, idx) {
                    var sscx = item.sscx != null && item.sscx.length > 0 ? item.sscx : '';
                    var fjxx = item.name + " " + sscx;
                    return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        'div',
                        { key: idx, className: 'app__css__app-pages-SelfHelp-dorm-__index__item' },
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-dorm-__index__item_con' },
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__components__["a" /* Flex */],
                                { justify: 'between' },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'span',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('span', { className: 'app__css__app-pages-SelfHelp-dorm-__index__round' }),
                                    fjxx.length < 12 ? fjxx : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        { style: { cursor: "pointer" } },
                                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_popover___default.a,
                                            { content: fjxx, trigger: 'hover' },
                                            fjxx.substr(0, 10) + "..."
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'span',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        { className: 'text-blue' },
                                        item.yxNum
                                    ),
                                    '/',
                                    item.allNum
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__components__["a" /* Flex */],
                                {
                                    wrap: 'wrap',
                                    align: 'center',
                                    justify: 'center',
                                    className: 'app__css__app-pages-SelfHelp-dorm-__index__select_box'
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'div',
                                    { className: 'app__css__app-pages-SelfHelp-dorm-__index__select_list' },
                                    item.bedList[0] && item.bedList.map(function (el, index) {
                                        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                            'div',
                                            { key: index },
                                            el.map(function (cwxx, index) {
                                                return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div', {
                                                    key: index,

                                                    onClick: function onClick() {
                                                        if (cwxx.xz === "0") {
                                                            showConfirm(item, cwxx.id, cwxx.cwh);
                                                            onChange(cwxx);
                                                        } else {
                                                            __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.warning('抱歉，该床铺已选择！');
                                                        }
                                                    },
                                                    className: __WEBPACK_IMPORTED_MODULE_10_babel_plugin_react_css_modules_dist_browser_getClassName___default()(__WEBPACK_IMPORTED_MODULE_13_classnames___default()('select_item', {
                                                        select_item_b: cwxx.xz === '1',
                                                        select_item_y: xzId === cwxx.id && cwxx.xz === '0' || cwxx.currentXsSelected
                                                    }), _styleModuleImportMap)
                                                });
                                            })
                                        );
                                    })
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-dorm-__index__item_btn_box' },
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'div',
                                {
                                    className: 'app__css__app-pages-SelfHelp-dorm-__index__item_btn',
                                    onClick: function onClick() {
                                        return autoSelectCwListener(item);
                                    }
                                },
                                '\u81EA\u52A8\u5165\u4F4F'
                            ),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'div',
                                {
                                    className: 'app__css__app-pages-SelfHelp-dorm-__index__item_btn',
                                    onClick: function onClick() {
                                        return showConfirm(item);
                                    }
                                },
                                '\u9009\u62E9\u5E8A\u4F4D'
                            )
                        )
                    );
                }) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        'span',
                        { style: { color: "#f00" } },
                        '\u6682\u65E0\u5339\u914D\u7684\u5BBF\u820D\u4FE1\u606F\uFF01'
                    )
                )
            );
        };

        return _this;
    }

    //床位信息


    _createClass(SelectBox, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                className = _props.className,
                Data = _props.Data,
                scrollHeight = _props.scrollHeight,
                tabChangeListener = _props.tabChangeListener,
                xqList = _props.xqList,
                currentXqid = _props.currentXqid;

            var activeKey = currentXqid || xqList[0] && xqList[0].XQID;

            return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default.a,
                { defaultActiveKey: '0', activeKey: activeKey, tabPosition: 'top',
                    onChange: function onChange(activeKey) {
                        return tabChangeListener(activeKey);
                    } },
                xqList.map(function (xq) {
                    return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        TabPane,
                        { tab: xq.XQMC, key: xq.XQID },
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_14__components__["a" /* Flex */],
                            { className: 'app__css__app-pages-SelfHelp-dorm-__index__tip', justify: 'center' },
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('img', {
                                src: __webpack_require__(281),
                                alt: ''
                            }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'span',
                                null,
                                '\u53EF\u9009\u62E9'
                            ),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('img', {
                                className: 'ml-10',
                                src: __webpack_require__(280),
                                alt: ''
                            }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'span',
                                null,
                                '\u4E0D\u53EF\u9009'
                            ),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('img', {
                                className: 'ml-10',
                                src: __webpack_require__(282),
                                alt: ''
                            }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'span',
                                null,
                                '\u5DF2\u9009\u62E9'
                            )
                        ),
                        Data.length > 16 ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars__["Scrollbars"],
                            { autoHide: true,
                                style: { width: '100%', height: scrollHeight } },
                            _this2.getListItem(Data)
                        ) : _this2.getListItem(Data)
                    );
                })
            );
        }
    }]);

    return SelectBox;
}(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component), _class.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,
    xzId: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.any,
    showConfirm: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
    autoSelectCwListener: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
    tabChangeListener: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func
}, _class.defaultProps = {
    xzId: '',
    showConfirm: Function.prototype,
    onChange: Function.prototype,
    autoSelectCwListener: Function.prototype,
    tabChangeListener: Function.prototype
}, _temp);


/***/ }),

/***/ 1051:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_plugin_react_css_modules_dist_browser_getClassName__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_plugin_react_css_modules_dist_browser_getClassName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_plugin_react_css_modules_dist_browser_getClassName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_css__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__index_css__);







var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;


var _styleModuleImportMap = {
    './index.css': {
        'tab_box': 'app__css__app-pages-SelfHelp-dorm-__index__tab_box',
        'tip': 'app__css__app-pages-SelfHelp-dorm-__index__tip',
        'item': 'app__css__app-pages-SelfHelp-dorm-__index__item',
        'item_con': 'app__css__app-pages-SelfHelp-dorm-__index__item_con',
        'round': 'app__css__app-pages-SelfHelp-dorm-__index__round',
        'select_box': 'app__css__app-pages-SelfHelp-dorm-__index__select_box',
        'select_list': 'app__css__app-pages-SelfHelp-dorm-__index__select_list',
        'select_item': 'app__css__app-pages-SelfHelp-dorm-__index__select_item',
        'select_item_b': 'app__css__app-pages-SelfHelp-dorm-__index__select_item_b',
        'select_item_y': 'app__css__app-pages-SelfHelp-dorm-__index__select_item_y',
        'item_btn_box': 'app__css__app-pages-SelfHelp-dorm-__index__item_btn_box',
        'item_btn': 'app__css__app-pages-SelfHelp-dorm-__index__item_btn',
        'modal_box': 'app__css__app-pages-SelfHelp-dorm-__index__modal_box',
        'modal_list': 'app__css__app-pages-SelfHelp-dorm-__index__modal_list'
    }
};

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }









/**
 * @author weishihuai
 * @date 2018/7/6
 * @time 14:41
 * @Description: 迎新网站-自助报到-宿舍分配-选择床位弹层
 */

if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var SelectModal = (_temp = _class = function (_React$Component) {
    _inherits(SelectModal, _React$Component);

    function SelectModal(props) {
        _classCallCheck(this, SelectModal);

        var _this = _possibleConstructorReturn(this, (SelectModal.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(SelectModal)).call(this, props));

        var id = props.id;

        _this.state = {
            xzId: id,
            currentClickCwh: "" //当前床位号
        };
        return _this;
    }

    _createClass(SelectModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var currentClickCwh = this.props.currentClickCwh;

            this.setState({
                currentClickCwh: currentClickCwh
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                xzId = _state.xzId,
                currentClickCwh = _state.currentClickCwh;
            var _props = this.props,
                className = _props.className,
                data = _props.data,
                onChange = _props.onChange;


            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('text-center', className) },
                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                    'div',
                    { className: 'text-blue' },
                    currentClickCwh ? currentClickCwh > 9 ? currentClickCwh + "床" : "0" + currentClickCwh + "床" : "请选择床铺"
                ),
                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                    'div',
                    null,
                    data.ysje + "元/年"
                ),
                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10__components__["a" /* Flex */],
                    { wrap: 'wrap', align: 'center', justify: 'center' },
                    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                        'div',
                        { className: 'app__css__app-pages-SelfHelp-dorm-__index__modal_box' },
                        data.bedList[0] && data.bedList.map(function (el, i) {
                            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                                'div',
                                { key: i },
                                el.map(function (cwxx, index) {
                                    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                                        'div',
                                        {
                                            className: 'app__css__app-pages-SelfHelp-dorm-__index__modal_list',
                                            onClick: function onClick() {
                                                if (cwxx.xz === "0") {
                                                    _this2.setState({
                                                        xzId: cwxx.id,
                                                        currentClickCwh: cwxx.cwh
                                                    });
                                                    onChange(cwxx);
                                                } else {
                                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.warning('抱歉，该床铺已选择！');
                                                }
                                            },
                                            key: index
                                        },
                                        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
                                            className: __WEBPACK_IMPORTED_MODULE_6_babel_plugin_react_css_modules_dist_browser_getClassName___default()(__WEBPACK_IMPORTED_MODULE_9_classnames___default()('select_item', {
                                                select_item_b: cwxx.xz === '1',
                                                select_item_y: xzId === cwxx.id && cwxx.xz === '0' || cwxx.currentXsSelected
                                            }), _styleModuleImportMap)
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                                            'div',
                                            null,
                                            cwxx.cwh > 9 ? cwxx.cwh + "床" : "0" + cwxx.cwh + "床"
                                        )
                                    );
                                })
                            );
                        })
                    )
                )
            );
        }
    }]);

    return SelectModal;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _class.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
    currentClickCwh: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
}, _class.defaultProps = {
    id: '',
    onChange: Function.prototype,
    currentClickCwh: ""
}, _temp);


/***/ }),

/***/ 1052:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return education; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_history_createHashHistory__);









var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }
















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_20_history_createHashHistory___default()();

var education = function (_React$Component) {
    _inherits(education, _React$Component);

    function education(props) {
        _classCallCheck(this, education);

        var _this = _possibleConstructorReturn(this, (education.__proto__ || __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default()(education)).call(this, props));

        _this.startStudy = function () {
            // let uid = '201901000872'
            var pkid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHCore__["b" /* getLoginUser */])().userId;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])("/zzbd/startStudy", 'GET', { pkid: pkid }).then(function (res) {
                if (res && res.data == "-1") {
                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_message___default.a.info("请先完善入学教育配置相关信息！");
                } else if (res && res.data) {
                    window.open(res.data);
                }
            });
        };

        _this.nextStudy = function () {
            // let uid = '201901000872'
            var pkid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHCore__["b" /* getLoginUser */])().userId;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])("/zzbd/getCoursePerformance", 'GET', { pkid: pkid }).then(function (res) {
                if (res && res.data) {
                    var jgfsx = 0;
                    var score = 0;
                    jgfsx = res.data.jgfsx;
                    score = res.data.score;
                    if (score < jgfsx) {
                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_message___default.a.info("请先完成入学教育考试再进行下一环节操作！");
                        //重新加载菜单
                        _this.refs.siderMenu.reloadMenuList();
                    } else {
                        //选择已办理
                        _this.insertHjblzt();
                    }
                    _this.setState({
                        jgfsx: jgfsx,
                        score: score
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_message___default.a.info("请先完善入学教育配置相关信息！");
                }
            });
        };

        _this.insertHjblzt = function () {
            var zzbdhjid = _this.getUrlParams("pkid");
            var pkid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHCore__["b" /* getLoginUser */])().userId;
            // const uid = '201901000872'
            var params = { pkid: pkid, zzbdhjid: zzbdhjid };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])("/zzbd/getLinkHandling", 'POST', params).then(function (res) {
                if (res && res.data) {
                    _this.refs.siderMenu.reloadMenuList();
                    _this.next();
                }
            });
        };

        _this.next = function () {
            var nextUrl = _this.state.nextUrl;
            var search = _this.state.search;
            history.push({
                pathname: nextUrl,
                search: search
            });
        };

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.getUrlParams = function (param) {
            return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_10__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.state = {
            mkbz: 'GD021',
            hjmc: '',
            operable: true, //是否显示环节
            nextUrl: '', //左侧菜单加载完后传进来
            jgfsx: 0, //及格分数线
            score: 0 //个人分数
        };
        return _this;
    }

    _createClass(education, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.queryQztjAndYlhj();
        }

        //查询前置条件和依赖环节


        //环节pkid


        //获取url中传递的参数

    }, {
        key: 'render',
        value: function render() {

            return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                'div',
                { className: 'app__css__app-pages-SelfHelp-education-__index__page_buy' },
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_12__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230',
                        mkbz: this.state.mkbz
                        /*       active={1}*/
                        , menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_12__components__["a" /* Flex */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjmc, extra: false }),
                            __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                'div',
                                { className: 'p-sw' },
                                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                                    { type: 'ghost', style: { marginLeft: 30, marginTop: 30 }, onClick: this.startStudy },
                                    '\u5F00\u59CB\u5B66\u4E60'
                                ),
                                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                                    { type: 'ghost', style: { marginLeft: 30, marginTop: 30 }, onClick: this.nextStudy },
                                    '\u4E0B\u4E00\u73AF\u8282'
                                )
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__common__["a" /* default */], { hjmc: "入学教育", key: "GD021", mkbz: 'GD021', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return education;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);



/***/ }),

/***/ 1053:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dormitory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_css__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);













var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var confirm = __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.confirm;

var dormitory = function (_React$Component) {
    _inherits(dormitory, _React$Component);

    function dormitory(props) {
        _classCallCheck(this, dormitory);

        var _this = _possibleConstructorReturn(this, (dormitory.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(dormitory)).call(this, props));

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getUserCjById = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this.getUrlParams("pkid");
            var taskcsbz = "YXXT_RXJYKS_TASKID";
            var jgfcsbz = "YXXT_RXJYKS_JGF";
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/questionnaire/getUserCjById', 'GET', {
                zzbdhjid: zzbdhjid,
                taskcsbz: taskcsbz,
                jgfcsbz: jgfcsbz,
                xsid: xsid
            }).then(function (res) {
                if (res && res.data) {
                    _this.setState({
                        xsssruYwxx: res.data
                    });
                    _this.refs.siderMenu.reloadMenuList();
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.getUrlParams = function (param) {
            return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_16__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.getJgfsx = function () {
            var params = { csbz: "YXXT_RXJYKS_JGF" };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/zzbdCommon/getCssz', 'GET', params).then(function (res) {
                if (res && res.data) {
                    _this.setState({
                        jgfsx: res.data
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error('未获取及格分数线，请联系管理员！');
                }
            });
        };

        _this.startStudy = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var taskcsbz = "YXXT_RXJYKS_TASKID";
            var ksrkcsbz = "YXXT_KSRK_HBDX";
            var params = { ksrkcsbz: ksrkcsbz, taskcsbz: taskcsbz, xsid: xsid };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/questionnaire/getKsrk', 'GET', params).then(function (res) {
                if (res && res.data) {
                    if (res.data != "-1") {
                        window.open(res.data);
                        var getUserCjById = _this.getUserCjById;

                        confirm({
                            title: '是否完成问卷调查?',
                            okText: '已完成',
                            okType: 'success',
                            cancelText: '未完成',
                            onOk: function onOk() {
                                getUserCjById(true);
                            },
                            onCancel: function onCancel() {
                                getUserCjById(true);
                            }
                        });
                    } else {
                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error('你没有参与问卷调查资格，请联系管理员！');
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error('未获取问卷调查入口，请联系管理员！');
                }
            });
        };

        _this.state = {
            mkbz: 'GD023',
            hjmc: '',
            operable: true, //是否显示环节
            isAllPay: true,
            xsssruYwxx: [],
            jgfsx: ''
        };
        return _this;
    }

    _createClass(dormitory, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            this.getUserCjById();
            this.getJgfsx();
            this.queryQztjAndYlhj();
        }

        //查询前置条件和依赖环节


        //查询学生入学教育考试成绩

        //环节pkid


        //获取url中传递的参数

    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                xsssruYwxx = _state.xsssruYwxx,
                jgfsx = _state.jgfsx;


            var columns = [{
                title: '问卷调查填写时间',
                dataIndex: 'START_TIME'
            }, {
                title: '问卷调查成绩',
                dataIndex: 'RESULT_SCORE'
            }];

            return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                'div',
                { className: 'app__css__app-pages-SelfHelp-examination-__index__page_buy' },
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230',
                        mkbz: this.state.mkbz
                        /*       active={1}*/
                        , menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_SelfHelp_common_hint__["a" /* default */], null),
                            this.state.jgfsx ? this.state.jgfsx == 0 ? __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjmc, extra: false }) : __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjmc + ' \uFF08\u53CA\u683C\u5206\u6570\uFF1A ' + this.state.jgfsx + ' \u5206\u53CA\u4EE5\u4E0A\uFF09', extra: false }) : __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjmc + ' \uFF08\u672A\u8BBE\u7F6E\u53CA\u683C\u6807\u51C6\uFF09', extra: false }),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                'div',
                                { className: 'p-sw' },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table___default.a, {
                                    bordered: true,
                                    size: 'middle',
                                    pagination: false,
                                    columns: columns,
                                    dataSource: xsssruYwxx
                                }),
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'div',
                                    { className: 'text-center mt-50' },
                                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                                        { onClick: this.startStudy,
                                            type: 'primary',
                                            className: "ml-20",
                                            htmlType: 'submit' },
                                        '\u95EE\u5377\u8C03\u67E5\u5165\u53E3'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, before: this.checkNext,
                                        search: this.state.search })
                                )
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__common__["a" /* default */], { hjmc: "问卷调查", key: "GD023", mkbz: 'GD023', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return dormitory;
}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);



/***/ }),

/***/ 1054:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_common_NHCascader__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__utils_RegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__index_css__);













var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }












if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var uploadUrl = "api/zhxg-yxwz/newStudent/cacheStudentPhoto"; //上传logo路径 


// 上传之前调用
function beforeUpload(file) {

    var isJPG = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJPG) {
        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error('You can only upload JPG/PNG file!');
    }
    var isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("Image must smaller than 2MB!");
    }
    return isJPG && isLt2M;
}

var JbxxInitForm = function (_React$Component) {
    _inherits(JbxxInitForm, _React$Component);

    function JbxxInitForm(props) {
        _classCallCheck(this, JbxxInitForm);

        var _this = _possibleConstructorReturn(this, (JbxxInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(JbxxInitForm)).call(this, props));

        _this.getStudentPhotoBase64 = function (userId, callback) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/openapi/student/getStudentPhotoBase64', 'get', { xsid: userId, type: 10 }).then(function (res) {
                if (res && res.code == 200) {
                    callback(res.data);
                }
            });
        };

        _this.onSavejbxxFormData = function (cb) {
            _this.props.form.validateFields(function (error, values) {
                if (error) {
                    cb(false);
                    return;
                }
                cb(true);
                var cacheFormData = _this.props.cacheFormData;

                if (_this.state.jtStr !== '') {
                    values.jtdzDetail = _this.state.jtStr;
                } else {
                    values.jtdzDetail = _this.props.jbxxFormData ? _this.props.jbxxFormData.jtdzDetail ? _this.props.jbxxFormData.jtdzDetail : "" : "";
                }
                cacheFormData('jbxx', values);
                _this.setState({
                    jbxx: false
                });
            });
        };

        _this.handleUploadChange = function (info) {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (info && info['file'] && info['file'].status === 'done') {
                var photoUUID = info['file'].response.data;
                if (photoUUID) {
                    var url = '/newStudent/saveStudentPhoto?xsid=' + userId + '&photoUUID=' + photoUUID + '&type=' + '10';
                    console.log('测试:', url);
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])(url, 'POST').then(function (res) {
                        if (res && res.data) {
                            console.log('头像上传成功响应:', res);
                            __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.success("上传成功!");
                        }
                    });
                }
            }
            _this.getBase64(info.file.originFileObj, function (imageUrl) {
                return _this.setState({ imageUrl: imageUrl });
            });
        };

        _this.onNHCascaderChange = function (value, selectedOptions, type) {
            var label = '';
            if (selectedOptions) {
                selectedOptions.forEach(function (i) {
                    label += i.label;
                });
            }
            if (type == 'jg') {
                _this.setState({ jgmStr: label });
            } else {
                _this.setState({ jtStr: label });
            }
        };

        _this.state = {
            jbxx: false,
            xsid: '',
            userInfoData: null,
            zzmmmList: [],
            mzmList: [],
            textData: '',
            jgmStr: '',
            jtStr: '',
            xsSsInfo: ''
        };
        return _this;
    }

    _createClass(JbxxInitForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                this.getStudentPhotoBase64(userId, function (data) {
                    if (!data) return;
                    _this2.setState({
                        xsid: userId,
                        imageUrl: 'data:image/jpeg;base64,' + data
                    });
                });
            }
        }

        // 获取学生头像


        // 保存信息

    }, {
        key: 'getBase64',

        // 获取bs64图片
        value: function getBase64(img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        }
        // 上传图片

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                form = _props.form,
                jbxxFormData = _props.jbxxFormData,
                getChildComponent = _props.getChildComponent,
                userInfoData = _props.userInfoData,
                stuSsxx = _props.stuSsxx,
                editXszp = _props.editXszp;
            var _state = this.state,
                jbxx = _state.jbxx,
                imageUrl = _state.imageUrl,
                tempUrl = _state.tempUrl,
                xsid = _state.xsid;

            var jtjddz = jbxxFormData ? jbxxFormData.jtjddz : '';
            var jtdzDetail = jbxxFormData ? jbxxFormData.jtdzDetail : '';
            var ssxx = '';
            if (stuSsxx && stuSsxx.xqmc && stuSsxx.ldmc && stuSsxx.fj && stuSsxx.cwh) {
                ssxx = stuSsxx.xqmc + stuSsxx.ldmc + ' - ' + stuSsxx.fj + ' - ' + stuSsxx.cwh;
            }
            return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a,
                { layout: 'inline' },
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u57FA\u672C\u4FE1\u606F'
                    // 点击编辑
                    , onEdit: function onEdit(_) {
                        _this3.setState({
                            jbxx: true
                        });
                        getChildComponent(1, false);
                    }
                    // 点击保存
                    , onSave: function onSave(cb) {
                        _this3.onSavejbxxFormData(cb);
                        getChildComponent(1, true);
                    }
                    // 点击取消
                    , onClose: function onClose(_) {
                        _this3.setState({
                            jbxx: false
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + '_bg app__css__app-pages-SelfHelp-info-__index__jbxx_icon'
                        },
                        jbxx && editXszp === "true" ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default.a,
                            {
                                name: 'photo',
                                accept: 'image/*',
                                showUploadList: false,
                                className: 'avatar-uploader',
                                action: uploadUrl + "?xsid=" + xsid,
                                beforeUpload: beforeUpload,
                                onChange: this.handleUploadChange
                            },
                            imageUrl || userInfoData ? imageUrl ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
                                src: imageUrl,
                                alt: '',
                                className: 'jsx-1702183314' + ' ' + 'avatar'
                            }) : tempUrl : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__upload-box'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__upload-title'
                                    },
                                    '\u4E0A\u4F20\u56FE\u7247'
                                )
                            )
                        ) : imageUrl ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
                            src: imageUrl,
                            alt: '',
                            className: 'jsx-1702183314' + ' ' + 'avatar'
                        }) : tempUrl
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */].Item,
                        { className: 'ml-20' },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__item-label'
                                },
                                '\u59D3\u540D\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-info-__index__item-name'
                                },
                                userInfoData ? userInfoData.XM : '',
                                userInfoData && userInfoData.XB ? userInfoData.XB === '男' ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(141), alt: '', className: 'jsx-1702183314'
                                }) : userInfoData.XB === '女' ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(142), alt: '', className: 'jsx-1702183314'
                                }) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(143), alt: '', className: 'jsx-1702183314'
                                }) : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__item-label'
                                },
                                '\u5B66\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-info-__index__item-name'
                                },
                                userInfoData ? userInfoData.XH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__item-label'
                                },
                                '\u8003\u751F\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-info-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.ksh : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__item-label'
                                },
                                '\u8EAB\u4EFD\u8BC1\u4EF6\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-info-__index__item-name'
                                },
                                userInfoData ? userInfoData.SFZJH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__item-label'
                                },
                                '\u51FA\u751F\u5E74\u6708\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-info-__index__item-name'
                                },
                                userInfoData ? userInfoData.CSRQ : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__item-label'
                                },
                                '\u653F\u6CBB\u9762\u8C8C\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-info-__index__item-name'
                                },
                                userInfoData ? userInfoData.ZZMM : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__item-label'
                                },
                                '\u6C11\u65CF\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-info-__index__item-name'
                                },
                                userInfoData ? userInfoData.MZ : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__item-label'
                                },
                                '\u7C4D\u8D2F\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-info-__index__item-name'
                                },
                                userInfoData ? userInfoData.JG : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__item-label'
                                },
                                '\u6BD5\u4E1A\u5B66\u6821\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-info-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.byzx : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__item-label'
                                },
                                '\u9AD8\u8003\u5206\u6570\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-info-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.gkcj : ''
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    'div',
                    {
                        className: 'jsx-1702183314' + ' ' + 'p-swc'
                    },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__item-label'
                            },
                            '\u5B66\u9662\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-info-__index__item-name'
                            },
                            userInfoData ? userInfoData.BMMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__item-label'
                            },
                            '\u4E13\u4E1A\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-info-__index__item-name'
                            },
                            userInfoData ? userInfoData.ZYMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__item-label'
                            },
                            '\u73ED\u7EA7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-info-__index__item-name'
                            },
                            userInfoData ? userInfoData.BJMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__jbxx_item2'
                        },
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                            { id: 'sjhm',
                                label: __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__item-label'
                                    },
                                    '\u672C\u4EBA\u8054\u7CFB\u7535\u8BDD\uFF1A'
                                ),
                                colon: false,
                                form: form,
                                required: true
                                // hasFeedback={true} 
                                // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/, message: "请输入正确的手机号码或电话号码" }}
                                , pattern: __WEBPACK_IMPORTED_MODULE_20__utils_RegExp__["FormRules"].MOBILE_PHONE_NUMBER,
                                initialValue: jbxxFormData ? jbxxFormData.sjhm : ""
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u8054\u7CFB\u7535\u8BDD' })
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__item-label'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'red' }, className: 'jsx-1702183314'
                                    },
                                    '*'
                                ),
                                '\u672C\u4EBA\u8054\u7CFB\u7535\u8BDD\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-info-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.sjhm : ''
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__item-label'
                            },
                            '\u5BBF\u820D\u4FE1\u606F\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-info-__index__item-name'
                            },
                            ssxx
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__detail_adrress'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            { style: { lineHeight: '32px' }, className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__item-label'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                { style: { color: 'red' }, className: 'jsx-1702183314'
                                },
                                '*'
                            ),
                            '\u8BE6\u7EC6\u5BB6\u5EAD\u4F4F\u5740\uFF1A'
                        ),
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                            null,
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'jtszdqArray',
                                    label: '',
                                    colon: false,
                                    required: true,
                                    form: form,
                                    initialValue: jbxxFormData ? jbxxFormData.jtszdqArray : []
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_common_NHCascader__["a" /* default */], { style: { width: 432.63 }, sign: "zhxg_ssq", onChange: function onChange(value, selectedOptions) {
                                        return _this3.onNHCascaderChange(value, selectedOptions, 'jt');
                                    }

                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'jtjddz',
                                    label: '',
                                    colon: false,
                                    required: true,
                                    form: form,
                                    pattern: { max: 100, message: "家庭住址长度不能超过100字符！" },
                                    initialValue: jbxxFormData ? jbxxFormData.jtjddz : '' },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 346.07 }, placeholder: '\u8BF7\u586B\u5199\u8BE6\u7EC6\u5BB6\u5EAD\u5730\u5740\uFF0C\u5982\uFF1Axx\u8857\u9053\u3001xx\u5C0F\u533A\u3001\u95E8\u724C\u53F7' })
                            )
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-info-__index__item-name'
                            },
                            jtdzDetail ? jtdzDetail : '',
                            jtjddz ? jtjddz : ''
                        )
                    ),
                    userInfoData ? userInfoData.FDY && userInfoData.FDY.length > 0 ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__item-label'
                            },
                            '\u8F85\u5BFC\u5458\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-info-__index__item-name'
                            },
                            userInfoData.FDY.map(function (item, key) {
                                if (item) {
                                    var lxdh = item.LXDH ? "( " + item.LXDH + " )" : "";
                                    return item.XM + lxdh + " ";
                                } else {
                                    return "";
                                }
                            })
                        )
                    ) : null : null,
                    userInfoData ? userInfoData.BZR && userInfoData.BZR.length > 0 ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-info-__index__item-label'
                            },
                            '\u73ED\u4E3B\u4EFB\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-info-__index__item-name'
                            },
                            userInfoData.BZR.map(function (item, key) {
                                if (item) {
                                    var lxdh = item.LXDH ? "( " + item.LXDH + " )" : "";
                                    return item.XM + lxdh + " ";
                                } else {
                                    return "";
                                }
                            })
                        )
                    ) : null : null
                ),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_styled_jsx_style___default.a, {
                    styleId: '1702183314',
                    css: ['.ant-col-md-7{width:100px;}']
                })
            );
        }
    }]);

    return JbxxInitForm;
}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);

var JbxxForm = __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a.create()(JbxxInitForm);

/* harmony default export */ __webpack_exports__["a"] = (JbxxForm);

/***/ }),

/***/ 1055:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Info; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_css__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__JbxxForm__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_SelfHelp_common_hint__ = __webpack_require__(35);








var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var Info = function (_React$Component) {
    _inherits(Info, _React$Component);

    function Info(props) {
        _classCallCheck(this, Info);

        var _this = _possibleConstructorReturn(this, (Info.__proto__ || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default()(Info)).call(this, props));

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({
                        nonOperationalData: res.data,
                        zzbdhjid: zzbdhjid
                    });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_17__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.getChildComponent = function (flag, mode) {
            switch (flag) {
                case 1:
                    _this.setState({ jbxxFlag: mode });
                    break;
                default:
                    break;
            }
        };

        _this.cacheFormData = function (type, values, isAdd) {
            if (type == 'jbxx') {
                // console.log('保存:', values)
                var sjhm = values.sjhm,
                    jtszdqArray = values.jtszdqArray,
                    jtjddz = values.jtjddz;

                if (sjhm !== null && jtszdqArray !== null && jtszdqArray.length > 0 && jtjddz !== null) {
                    _this.setState({
                        jbxxInitData: _extends({}, values),
                        isEditJbxx: true
                    }, function () {
                        _this.insertData4Yxwz();
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("存在必填信息未填写，请填写后再保存！");
                }
            }
        };

        _this.getData4Yxwz = function () {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            console.log('userId:', userId);
            if (userId) {
                _this.setState({ xsid: userId });
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_NHFetch__["a" /* default */])('/newStudent/queryStuInfo', 'GET', { 'xsid': userId }).then(function (res) {
                    // console.log('获取信息:', res)
                    if (res && res.data) {
                        var stuInfo = res.data.stuInfo;
                        // let stuXxcj = res.data.stuXxcj;
                        var stuSsxx = res.data.stuSsxx;
                        var editXszp = res.data.editXszp;

                        _this.setState({
                            userBaseInfo: stuInfo.userBaseInfo,
                            jbxxInitData: stuInfo.xsJbxx4YxwzVO,
                            // kzxxInitData: { ...stuXxcj },
                            stuSsxx: stuSsxx,
                            editXszp: editXszp
                        });
                    }
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("登录超时,请重新登录！");
            }
        };

        _this.insertData4Yxwz = function () {
            var postFormData = {};
            // console.log('state:', this.state)
            var _this$state = _this.state,
                jbxxInitData = _this$state.jbxxInitData,
                xsid = _this$state.xsid,
                zzbdhjid = _this$state.zzbdhjid;

            postFormData['xsid'] = xsid;
            postFormData['xsJbxx4YxwzVO'] = jbxxInitData;

            var postData = {
                'xsInfo4YxwzVO': postFormData,
                'params': { 'zzbdhjid': zzbdhjid, 'xsid': xsid }
            };

            //必填一
            var _postData$xsInfo4Yxwz = postData.xsInfo4YxwzVO.xsJbxx4YxwzVO,
                sjhm = _postData$xsInfo4Yxwz.sjhm,
                jtszdqArray = _postData$xsInfo4Yxwz.jtszdqArray,
                jtjddz = _postData$xsInfo4Yxwz.jtjddz;

            var jbxxFlag = false;
            if (sjhm !== null && jtszdqArray !== null && jtszdqArray.length > 0 && jtjddz !== null) {
                jbxxFlag = true;
            }
            var hjblFlag = false;
            if (jbxxFlag) hjblFlag = true;
            postData.params.hjblFlag = hjblFlag;
            // console.log('更新参数:', postData)
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_NHFetch__["a" /* default */])('/simpleStudentMng/updateStuInfo', 'POST', postData).then(function (res) {
                if (res && res.code == 200) {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.success("保存成功");
                    _this.reloadMenu();
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("保存失败");
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD001_1',
            hjmc: '',
            jbxxFormData: {},
            jbxxInitData: {},
            kzxxInitData: {},
            userBaseInfo: {},
            stuSsxx: {},
            xsid: '',
            jbxxFlag: true,
            kzxxFlag: true,
            jtcyFlag: true,
            zyshgxFlag: true,
            jyjlFlag: true,
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            isEditJbxx: false,
            isEditJtcy: false,
            isEditZyshgx: false,
            isEditJyjl: false,
            menuList: [],
            zzbdhjid: ''
        };
        return _this;
    }

    _createClass(Info, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.queryQztjAndYlhj();
            this.getData4Yxwz();
        }
        //查询前置条件和依赖环节

        // 获取地址参数

        // 左侧导航菜单

        // 获取子组件


        //缓存编写的信息，缓存完之后提交

        // 获取基本信息

        // 插入数据


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230',
                        mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_8__components__["a" /* Flex */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__JbxxForm__["a" /* default */], { ref: 'refJbxxForm', jbxxFormData: this.state.jbxxInitData,
                                getChildComponent: this.getChildComponent,
                                cacheFormData: this.cacheFormData,
                                userInfoData: this.state.userBaseInfo,
                                stuSsxx: this.state.stuSsxx,
                                editXszp: this.state.editXszp
                            }),
                            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                                'div',
                                { className: 'p-sw text-center mt-30' },
                                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__common__["a" /* default */], { hjmc: "个人信息填写", key: 'GD001_1', mkbz: 'GD001_1', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return Info;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);



/***/ }),

/***/ 1056:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_common_NHCascader__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__utils_RegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__index_css__);













var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }












if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var uploadUrl = "api/zhxg-yxwz/newStudent/cacheStudentPhoto"; //上传logo路径


function beforeUpload(file) {

    var isJPG = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJPG) {
        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("You can only upload JPG file!");
    }
    var isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("Image must smaller than 2MB!");
    }
    return isJPG && isLt2M;
}

var JbxxInitForm = function (_React$Component) {
    _inherits(JbxxInitForm, _React$Component);

    function JbxxInitForm(props) {
        _classCallCheck(this, JbxxInitForm);

        var _this = _possibleConstructorReturn(this, (JbxxInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(JbxxInitForm)).call(this, props));

        _this.getStudentPhotoBase64 = function (userId, callback) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/openapi/student/getStudentPhotoBase64', 'get', { xsid: userId, type: 10 }).then(function (res) {
                if (res && res.code == 200) {
                    callback(res.data);
                }
            });
        };

        _this.onSavejbxxFormData = function (cb) {
            _this.props.form.validateFields(function (error, values) {
                if (error) {
                    cb(false);
                    return;
                }
                cb(true);
                var cacheFormData = _this.props.cacheFormData;

                if (_this.state.jtStr !== '') {
                    values.jtdzDetail = _this.state.jtStr;
                } else {
                    values.jtdzDetail = _this.props.jbxxFormData ? _this.props.jbxxFormData.jtdzDetail ? _this.props.jbxxFormData.jtdzDetail : "" : "";
                }
                cacheFormData('jbxx', values);
                _this.setState({
                    jbxx: false
                });
            });
        };

        _this.handleUploadChange = function (info) {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (info && info['file'] && info['file'].status === 'done') {
                var photoUUID = info['file'].response.data;
                if (photoUUID) {
                    var url = '/newStudent/saveStudentPhoto?xsid=' + userId + '&photoUUID=' + photoUUID + '&type=' + '10';
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])(url, 'POST').then(function (res) {
                        if (res && res.data) {
                            __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.success("上传成功!");
                        }
                    });
                }
            }
            _this.getBase64(info.file.originFileObj, function (imageUrl) {
                return _this.setState({ imageUrl: imageUrl });
            });
        };

        _this.onNHCascaderChange = function (value, selectedOptions, type) {
            var label = '';
            if (selectedOptions) {
                selectedOptions.forEach(function (i) {
                    label += i.label;
                });
            }
            if (type == 'jg') {
                _this.setState({ jgmStr: label });
            } else {
                _this.setState({ jtStr: label });
            }
        };

        _this.state = {
            jbxx: false,
            xsid: '',
            userInfoData: null,
            zzmmmList: [],
            mzmList: [],
            textData: '',
            jgmStr: '',
            jtStr: '',
            xsSsInfo: ''
        };
        return _this;
    }

    _createClass(JbxxInitForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                this.getStudentPhotoBase64(userId, function (data) {
                    if (!data) return;
                    _this2.setState({
                        xsid: userId,
                        imageUrl: 'data:image/jpeg;base64,' + data
                    });
                });
            }
        }

        // 获取学生头像

    }, {
        key: 'getBase64',
        value: function getBase64(img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        }
        // 上传图片

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                form = _props.form,
                jbxxFormData = _props.jbxxFormData,
                getChildComponent = _props.getChildComponent,
                userInfoData = _props.userInfoData,
                stuSsxx = _props.stuSsxx,
                editXszp = _props.editXszp;
            var _state = this.state,
                jbxx = _state.jbxx,
                imageUrl = _state.imageUrl,
                tempUrl = _state.tempUrl,
                xsid = _state.xsid;

            var jtjddz = jbxxFormData ? jbxxFormData.jtjddz : '';
            var jtdzDetail = jbxxFormData ? jbxxFormData.jtdzDetail : '';
            var ssxx = '';
            if (stuSsxx && stuSsxx.xqmc && stuSsxx.ldmc && stuSsxx.fj && stuSsxx.cwh) {
                ssxx = stuSsxx.xqmc + stuSsxx.ldmc + ' - ' + stuSsxx.fj + ' - ' + stuSsxx.cwh;
            }
            return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a,
                { layout: 'inline' },
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u57FA\u672C\u4FE1\u606F',
                    onEdit: function onEdit(type) {
                        _this3.setState({
                            jbxx: true
                        });
                        getChildComponent(1, false);
                    },
                    onSave: function onSave(cb) {
                        _this3.onSavejbxxFormData(cb);
                        getChildComponent(1, true);
                    },
                    onClose: function onClose() {
                        _this3.setState({
                            jbxx: false
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + '_bg app__css__app-pages-SelfHelp-infoGdnhgs-__index__jbxx_icon'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            { style: { width: '100%', position: 'absolute', color: 'red', fontSize: '20px', textAlign: 'center', top: '50%', transform: 'translate(0,-50%)' }, className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                { style: { marginBottom: '30px' }, className: 'jsx-1702183314'
                                },
                                '\u70B9\u51FB\u6B64\u5904'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314'
                                },
                                '\u6DFB\u52A0\u8FD1\u7167'
                            )
                        ),
                        jbxx && editXszp === "true" ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default.a,
                            {
                                name: 'photo',
                                accept: 'image/*',
                                showUploadList: false,
                                action: uploadUrl + "?xsid=" + xsid,
                                beforeUpload: beforeUpload,
                                onChange: this.handleUploadChange
                            },
                            imageUrl || userInfoData ? imageUrl ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
                                src: imageUrl,
                                alt: '',
                                className: 'jsx-1702183314' + ' ' + 'avatar'
                            }) : tempUrl : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__upload-box'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__upload-title'
                                    },
                                    '\u4E0A\u4F20\u56FE\u7247'
                                )
                            )
                        ) : imageUrl ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
                            src: imageUrl,
                            alt: '',
                            className: 'jsx-1702183314' + ' ' + 'avatar'
                        }) : tempUrl
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */].Item,
                        { className: 'ml-20' },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-label'
                                },
                                '\u59D3\u540D\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-name'
                                },
                                userInfoData ? userInfoData.XM : '',
                                userInfoData && userInfoData.XB ? userInfoData.XB === '男' ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(141), alt: '', className: 'jsx-1702183314'
                                }) : userInfoData.XB === '女' ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(142), alt: '', className: 'jsx-1702183314'
                                }) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(143), alt: '', className: 'jsx-1702183314'
                                }) : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-label'
                                },
                                '\u5B66\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-name'
                                },
                                userInfoData ? userInfoData.XH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-label'
                                },
                                '\u8003\u751F\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.ksh : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-label'
                                },
                                '\u8EAB\u4EFD\u8BC1\u4EF6\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-name'
                                },
                                userInfoData ? userInfoData.SFZJH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-label'
                                },
                                '\u51FA\u751F\u5E74\u6708\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-name'
                                },
                                userInfoData ? userInfoData.CSRQ : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-label'
                                },
                                '\u653F\u6CBB\u9762\u8C8C\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-name'
                                },
                                userInfoData ? userInfoData.ZZMM : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-label'
                                },
                                '\u6C11\u65CF\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-name'
                                },
                                userInfoData ? userInfoData.MZ : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-label'
                                },
                                '\u7C4D\u8D2F\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-name'
                                },
                                userInfoData ? userInfoData.JG : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-label'
                                },
                                '\u6BD5\u4E1A\u5B66\u6821\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.byzx : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-label'
                                },
                                '\u9AD8\u8003\u5206\u6570\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.gkcj : ''
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    'div',
                    {
                        className: 'jsx-1702183314' + ' ' + 'p-swc'
                    },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-label'
                            },
                            '\u5B66\u9662\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-name'
                            },
                            userInfoData ? userInfoData.BMMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-label'
                            },
                            '\u4E13\u4E1A\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-name'
                            },
                            userInfoData ? userInfoData.ZYMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-label'
                            },
                            '\u73ED\u7EA7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-name'
                            },
                            userInfoData ? userInfoData.BJMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__jbxx_item2'
                        },
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                            { id: 'sjhm',
                                label: __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-label'
                                    },
                                    '\u672C\u4EBA\u8054\u7CFB\u7535\u8BDD\uFF1A'
                                ),
                                colon: false,
                                form: form,
                                required: true
                                // hasFeedback={true} 
                                // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}
                                , pattern: __WEBPACK_IMPORTED_MODULE_20__utils_RegExp__["FormRules"].MOBILE_PHONE_NUMBER,
                                initialValue: jbxxFormData ? jbxxFormData.sjhm : ""
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u8054\u7CFB\u7535\u8BDD' })
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-label'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'red' }, className: 'jsx-1702183314'
                                    },
                                    '*'
                                ),
                                '\u672C\u4EBA\u8054\u7CFB\u7535\u8BDD\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.sjhm : ''
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-label'
                            },
                            '\u5BBF\u820D\u4FE1\u606F\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-name'
                            },
                            ssxx
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__detail_adrress'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            { style: { lineHeight: '32px' }, className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-label'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                { style: { color: 'red' }, className: 'jsx-1702183314'
                                },
                                '*'
                            ),
                            '\u8BE6\u7EC6\u5BB6\u5EAD\u4F4F\u5740\uFF1A'
                        ),
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                            null,
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'jtszdqArray',
                                    label: '',
                                    colon: false,
                                    required: true,
                                    form: form,
                                    initialValue: jbxxFormData ? jbxxFormData.jtszdqArray : []
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_common_NHCascader__["a" /* default */], { style: { width: 432.63 }, sign: "zhxg_ssq", onChange: function onChange(value, selectedOptions) {
                                        return _this3.onNHCascaderChange(value, selectedOptions, 'jt');
                                    }

                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'jtjddz',
                                    label: '',
                                    colon: false,
                                    required: true,
                                    form: form,
                                    pattern: { max: 100, message: "家庭住址长度不能超过100字符！" },
                                    initialValue: jbxxFormData ? jbxxFormData.jtjddz : '' },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 346.07 }, placeholder: '\u8BF7\u586B\u5199\u8BE6\u7EC6\u5BB6\u5EAD\u5730\u5740\uFF0C\u5982\uFF1Axx\u8857\u9053\u3001xx\u5C0F\u533A\u3001\u95E8\u724C\u53F7' })
                            )
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-name'
                            },
                            jtdzDetail ? jtdzDetail : '',
                            jtjddz ? jtjddz : ''
                        )
                    ),
                    userInfoData ? userInfoData.FDY && userInfoData.FDY.length > 0 ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-label'
                            },
                            '\u8F85\u5BFC\u5458\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-name'
                            },
                            userInfoData.FDY.map(function (item, key) {
                                if (item) {
                                    var lxdh = item.LXDH ? "( " + item.LXDH + " )" : "";
                                    return item.XM + lxdh + " ";
                                } else {
                                    return "";
                                }
                            })
                        )
                    ) : null : null,
                    userInfoData ? userInfoData.BZR && userInfoData.BZR.length > 0 ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-label'
                            },
                            '\u73ED\u4E3B\u4EFB\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-name'
                            },
                            userInfoData.BZR.map(function (item, key) {
                                if (item) {
                                    var lxdh = item.LXDH ? "( " + item.LXDH + " )" : "";
                                    return item.XM + lxdh + " ";
                                } else {
                                    return "";
                                }
                            })
                        )
                    ) : null : null
                ),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_styled_jsx_style___default.a, {
                    styleId: '1702183314',
                    css: ['.ant-col-md-7{width:100px;}']
                })
            );
        }
    }]);

    return JbxxInitForm;
}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);

var JbxxForm = __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a.create()(JbxxInitForm);

/* harmony default export */ __webpack_exports__["a"] = (JbxxForm);

/***/ }),

/***/ 1057:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__index_css__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__utils_RegExp__);

















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default()(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item;

var JtcyInitForm = function (_React$Component) {
    _inherits(JtcyInitForm, _React$Component);

    function JtcyInitForm(props) {
        _classCallCheck(this, JtcyInitForm);

        var _this = _possibleConstructorReturn(this, (JtcyInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of___default()(JtcyInitForm)).call(this, props));

        _this.cacheJtcyData = function (cb) {
            _this.props.form.validateFields(function (err, values) {
                if (err) return cb(false);
                //判断数据是否全部填写
                var dataList = [];
                if (_this.state.jtcyData && _this.state.jtcyData.length > 0) {
                    for (var i = 0; i < _this.state.jtcyData.length; i++) {
                        var data = _this.state.jtcyData[i];
                        if (!data.gx && !data.xm && !data.gzxxdw && !data.lxfs && !data.operation) {} else {
                            dataList.push(data);
                        }
                    }
                }

                var _this$props = _this.props,
                    cacheFormData = _this$props.cacheFormData,
                    getChildComponent = _this$props.getChildComponent;

                getChildComponent(3, true);
                cacheFormData('jtcy', dataList, true);
                cb(true);
                _this.setState({
                    jtcy: false,
                    jtcyAdd: false
                });
            });
        };

        _this.onjtcyAdd = function () {
            var _this$state = _this.state,
                jtcyAdd = _this$state.jtcyAdd,
                jtcyData = _this$state.jtcyData;

            if (!jtcyData) {
                jtcyData = [];
            }

            if (jtcyAdd) {
                jtcyData.push({
                    key: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["c" /* createUuid */])(),
                    gx: '',
                    xm: '',
                    gzxxdw: '',
                    zzmmm: '',
                    lxfs: '',
                    operation: ''
                });
                _this.setState({
                    jtcyData: jtcyData
                });
            }
            _this.setState({
                jtcyAdd: true
            });
        };

        _this.onjtcySave = function () {
            var jtcyData = _this.state.jtcyData;

            jtcyData.push();
            _this.setState({
                jtcyData: jtcyData,
                jtcyAdd: false
            });
        };

        _this.onjtcyClose = function (index) {
            var jtcyData = _this.state.jtcyData;

            jtcyData.splice(index, 1);
            _this.setState({
                jtcyData: jtcyData,
                jtcyAdd: true
            });
        };

        _this.handleChange = function (value, index, key) {
            var jtcyData = _this.state.jtcyData;
            jtcyData[index][key] = value;
            _this.setState({ jtcyData: jtcyData });
        };

        _this.getzzmmmStr = function (value) {
            var temp = '';
            _this.state.zzmmmList.forEach(function (i) {
                if (i.value === value) {
                    temp = i.label;
                }
            });
            return temp;
        };

        _this.deepCopy = function (obj) {
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                return obj;
            }

            if (_this.isArrayFn(obj)) {
                var newobj = [];
                for (var i = 0; i < obj.length; i++) {
                    newobj.push(_this.deepCopy(obj[i]));
                }
                return newobj;
            } else {
                var _newobj = {};
                for (var attr in obj) {
                    _newobj[attr] = _this.deepCopy(obj[attr]);
                }
                return _newobj;
            }
        };

        _this.isArrayFn = function (value) {
            if (typeof Array.isArray === "function") {
                return Array.isArray(value);
            } else {
                return Object.prototype.toString.call(value) === "[object Array]";
            }
        };

        _this.state = _defineProperty({
            jtcy: false,
            jtcyAdd: false,
            jtcyData: [],
            zzmmmList: [],
            jtcyList: [],
            tempStr: ''
        }, 'jtcyList', []);
        return _this;
    }

    _createClass(JtcyInitForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])('/proData/selectDataList?&sign=DMK_XSXX_JTCYGX', 'GET').then(function (res) {
                if (res && res.data) {
                    var jtcyList = [];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default()(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var obj = _step.value;

                            jtcyList.push({ 'label': obj.LABEL, 'value': obj.VALUE });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this2.setState({ jtcyList: jtcyList });
                }
            });

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])('/proData/selectDataList?&sign=DMK_XTGL_ZZMMM', 'GET').then(function (res) {
                if (res && res.data) {
                    var zzmmmList = [];
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default()(res.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var obj = _step2.value;

                            zzmmmList.push({ 'label': obj.LABEL, 'value': obj.VALUE });
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    _this2.setState({ zzmmmList: zzmmmList });
                }
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('jtcyInitData' in nextProps && nextProps.jtcyInitData) {
                if (nextProps.jtcyInitData instanceof Array) {
                    var temp = [].concat(_toConsumableArray(nextProps.jtcyInitData));
                    this.setState({ jtcyData: temp });
                }
            }
        }

        // 家庭成员 添加

        // 家庭成员 保存添加

        // 家庭成员 关闭添加

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _state = this.state,
                jtcy = _state.jtcy,
                jtcyData = _state.jtcyData,
                jtcyAdd = _state.jtcyAdd,
                jtcyList = _state.jtcyList;
            var _props = this.props,
                getChildComponent = _props.getChildComponent,
                form = _props.form;
            var getFieldDecorator = form.getFieldDecorator;

            var jtcyTransalate = {}; //家庭成员翻译
            for (var i = 0; i < jtcyList.length; i++) {
                jtcyTransalate[jtcyList[i].value] = jtcyList[i].label;
            }
            var jtcyColumns = [{
                title: '关系',
                key: 'gx',
                dataIndex: 'gx',
                render: function render(text, record, index) {
                    return jtcy ?

                    // <Input
                    //     value={text}
                    //     required={true}
                    //     onChange={(e) =>{this.handleChange(e.target.value,index,'gx')}}
                    //     style={{ width: 100 }}
                    //     placeholder="请填写关系"
                    // />
                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_common_NHSelect__["a" /* default */], { style: { width: 140 }, sign: 'DMK_XSXX_JTCYGX',
                        value: text,
                        onChange: function onChange(value) {
                            _this3.handleChange(value, index, 'gx');
                        }

                    })
                    // <NHFormItem id={'gx'} label={''} form={form} required={true}
                    //     pattern={{max:5, message: "关系长度不能超过5字符！"}}
                    //     initialValue={text}>
                    // <Input onChange={(e) =>{this.handleChange(e.target.value,index,'gx')}}
                    //        placeholder="请填写关系"/>
                    // </NHFormItem>
                    : jtcyTransalate[text];
                }
            }, {
                title: '姓名',
                dataIndex: 'xm',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'xm');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u59D3\u540D'
                    }) : text;
                }
            },
            // {
            //     title: '政治面貌',
            //     dataIndex: 'zzmmm',
            //     render: (text, record,index) => {
            //         //let tempStr = '';
            //         return(
            //             jtcy ?
            //             <NHSelect disabled = {jtcy ? false : true} style={{ width: 140 }} sign="DMK_XTGL_ZZMMM"
            //             value={text}
            //             onChange={(value) =>{this.handleChange(value,index,'zzmmm')}}

            //             />
            //             :
            //             (this.getzzmmmStr(text))
            //         );
            //     }
            // },
            {
                title: '工作单位',
                dataIndex: 'gzxxdw',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'gzxxdw');
                        },
                        style: { width: 140 },
                        placeholder: '\u8BF7\u586B\u5199\u5355\u4F4D\u548C\u804C\u52A1'
                    }) : text;
                }
            }, {
                title: '联系手机',
                dataIndex: 'lxfs',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                        FormItem,
                        { form: form, style: { marginBottom: '0px' } },
                        getFieldDecorator('lxfs', {
                            rules: [{ required: true, message: '请填写电话' }, __WEBPACK_IMPORTED_MODULE_27__utils_RegExp__["FormRules"].MOBILE_PHONE_NUMBER],
                            initialValue: text
                        })(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                            value: text,
                            onChange: function onChange(e) {
                                _this3.handleChange(e.target.value, index, 'lxfs');
                            },
                            style: { width: 100 },
                            placeholder: '\u8BF7\u586B\u5199\u7535\u8BDD'
                        }))
                    ) : text;
                }
            },
            // {
            //     title: 'QQ',
            //     dataIndex: 'qq',
            //     render: (text, record,index) => {
            //         return jtcy ? (
            //             <Input
            //                 value={text}
            //                 onChange={(e) =>{this.handleChange(e.target.value,index,'qq')}}
            //                 style={{ width: 100 }}
            //                 placeholder="请填QQ号"
            //             />
            //         ) : (
            //             text
            //         );
            //     }
            // },
            // {
            //     title: '微信',
            //     dataIndex: 'wx',
            //     render: (text, record,index) => {
            //         return jtcy ? (
            //             <Input
            //                 value={text}
            //                 onChange={(e) =>{this.handleChange(e.target.value,index,'wx')}}
            //                 style={{ width: 100 }}
            //                 placeholder="请填微信号"
            //             />
            //         ) : (
            //             text
            //         );
            //     }
            // },
            {
                title: '删除',
                dataIndex: 'operation',
                width: 80,
                render: function render(text, record, index) {
                    if (jtcy) {
                        return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                            'div',
                            { className: 'editable-row-operations' },
                            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                'a',
                                {
                                    href: 'javascript:;',
                                    onClick: function onClick() {
                                        return _this3.onjtcyClose(index);
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, {
                                    type: 'close',
                                    style: { color: 'red' }
                                })
                            )
                        );
                    }
                    return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                        'a',
                        { href: 'javascript:;', onClick: function onClick() {
                                return _this3.onjtcyClose();
                            } },
                        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'delete', style: { color: 'red' } })
                    );
                }
            }];
            if (!jtcy) {
                jtcyColumns.pop();
            }
            return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u5BB6\u5EAD\u6210\u5458\u4FE1\u606F',
                    onEdit: function onEdit(type) {
                        _this3.setState({
                            jtcy: true,
                            jtcyAdd: true,
                            cacheData: _this3.deepCopy(_this3.state.jtcyData)
                        });
                        getChildComponent(3, false);
                    },
                    onSave: function onSave(cb) {
                        _this3.cacheJtcyData(cb);
                    },
                    onClose: function onClose() {
                        _this3.setState({
                            jtcy: false,
                            jtcyAdd: false,
                            jtcyData: _this3.deepCopy(_this3.state.cacheData)
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a,
                    null,
                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                        'div',
                        { className: 'p-sw' },
                        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a, {
                            bordered: true,
                            size: 'middle',
                            pagination: false,
                            dataSource: jtcyData,
                            columns: jtcyColumns
                        }),
                        jtcyAdd && __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                            'div',
                            {
                                className: 'mt-10 app__css__app-pages-SelfHelp-infoGdnhgs-__index__btn_add',

                                onClick: function onClick() {

                                    _this3.onjtcyAdd();
                                }
                            },
                            '\u6DFB\u52A0\u5BB6\u5EAD\u6210\u5458'
                        )
                    )
                )
            );
        }
    }]);

    return JtcyInitForm;
}(__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);

var JtcyForm = __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.create()(JtcyInitForm);
/* harmony default export */ __webpack_exports__["a"] = (JtcyForm);

/***/ }),

/***/ 1058:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JyjlForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker_style__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_date_picker__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__index_css__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_common_NHFormItem_index__ = __webpack_require__(43);
















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }













if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var RangePicker = __WEBPACK_IMPORTED_MODULE_14_antd_lib_date_picker___default.a.RangePicker;

var dateFormat = 'YYYY/MM/DD ';

var JyjlForm = function (_React$Component) {
    _inherits(JyjlForm, _React$Component);

    function JyjlForm(props) {
        _classCallCheck(this, JyjlForm);

        var _this = _possibleConstructorReturn(this, (JyjlForm.__proto__ || __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default()(JyjlForm)).call(this, props));

        _this.cacheJyjlData = function (cb) {
            //判断数据是否全部填写
            var dataList = [];
            if (_this.state.jyjlData && _this.state.jyjlData.length > 0) {
                for (var i = 0; i < _this.state.jyjlData.length; i++) {
                    var data = _this.state.jyjlData[i];
                    if (!data.qsny && !data.xxjl && !data.zw && !data.zmr && !data.zmrlxfs && !data.operation) {} else {
                        dataList.push(data);
                    }
                }
            }
            var _this$props = _this.props,
                cacheFormData = _this$props.cacheFormData,
                getChildComponent = _this$props.getChildComponent;

            getChildComponent(4, true);
            cacheFormData('jyjl', dataList, true);
            cb(true);
        };

        _this.validateFields = function (func) {
            var err = false;
            var formData = _this.state.jyjlData;
            func(err, formData);
        };

        _this.onjyjlAdd = function () {
            var _this$state = _this.state,
                jyjlAdd = _this$state.jyjlAdd,
                jyjlData = _this$state.jyjlData;

            if (!jyjlData) {
                jyjlData = [];
            }
            if (jyjlAdd) {
                jyjlData.push({
                    key: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["c" /* createUuid */])(),
                    qsny: '',
                    xxjl: '',
                    zw: '',
                    zmr: '',
                    zmrlxfs: '',
                    operation: ''
                });
                _this.setState({
                    jyjlData: jyjlData
                });
            }
            _this.setState({
                jyjlAdd: true
            });
        };

        _this.onjyjlSave = function () {
            var jyjlData = _this.state.jyjlData;

            jyjlData.push();
            _this.setState({
                jyjlData: jyjlData,
                jyjlAdd: false
            });
        };

        _this.onjyjlClose = function (index) {
            var jyjlData = _this.state.jyjlData;

            jyjlData.splice(index, 1);
            _this.setState({
                jyjlData: jyjlData,
                jyjlAdd: true
            });
        };

        _this.handleChange = function (value, index, key) {
            var jyjlData = _this.state.jyjlData;
            jyjlData[index][key] = value;
            _this.setState({ jyjlData: jyjlData });
        };

        _this.handleDateChange = function (value, index) {

            var jyjlData = _this.state.jyjlData;
            var kssj = value[0] ? __WEBPACK_IMPORTED_MODULE_18_moment___default()(value[0]).format(dateFormat) : undefined;
            var jssj = value[1] ? __WEBPACK_IMPORTED_MODULE_18_moment___default()(value[1]).format(dateFormat) : undefined;
            jyjlData[index]['kssj'] = kssj;
            jyjlData[index]['jssj'] = jssj;
            _this.setState({ jyjlData: jyjlData });
        };

        _this.deepCopy = function (obj) {
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                return obj;
            }

            if (_this.isArrayFn(obj)) {
                var newobj = [];
                for (var i = 0; i < obj.length; i++) {
                    newobj.push(_this.deepCopy(obj[i]));
                }
                return newobj;
            } else {
                var _newobj = {};
                for (var attr in obj) {
                    _newobj[attr] = _this.deepCopy(obj[attr]);
                }
                return _newobj;
            }
        };

        _this.isArrayFn = function (value) {
            if (typeof Array.isArray === "function") {
                return Array.isArray(value);
            } else {
                return Object.prototype.toString.call(value) === "[object Array]";
            }
        };

        _this.state = {
            jyjl: false,
            jyjlAdd: false,
            jyjlData: []
        };
        return _this;
    }

    _createClass(JyjlForm, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('jyjlInitData' in nextProps && nextProps.jyjlInitData) {
                if (nextProps.jyjlInitData instanceof Array) {
                    var temp = [].concat(_toConsumableArray(nextProps.jyjlInitData));
                    this.setState({ jyjlData: temp });
                }
            }
        }
    }, {
        key: 'disabledDate',
        value: function disabledDate(current) {
            // Can not select days after today and today
            return current && current > __WEBPACK_IMPORTED_MODULE_18_moment___default()().endOf('day');
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                initJtcyData = _props.initJtcyData,
                getChildComponent = _props.getChildComponent;
            var _state = this.state,
                jyjl = _state.jyjl,
                jyjlData = _state.jyjlData,
                jyjlAdd = _state.jyjlAdd;

            var jyjlColumns = [{
                title: '起始年月',
                dataIndex: 'qsny',
                render: function render(text, record, index) {
                    var kssj = record.kssj;
                    var jssj = record.jssj;
                    return jyjl ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(RangePicker
                    // disabledDate={this.disabledDate}
                    , { value: kssj && jssj ? [__WEBPACK_IMPORTED_MODULE_18_moment___default()(kssj, dateFormat), __WEBPACK_IMPORTED_MODULE_18_moment___default()(jssj, dateFormat)] : undefined,
                        format: dateFormat,
                        onChange: function onChange(value) {
                            _this2.handleDateChange(value, index);
                        }
                    }) : (kssj ? kssj : '') + ' ~ ' + (jssj ? jssj : '');
                }
            }, {
                title: '在何地何学校',
                dataIndex: 'xxjl',
                render: function render(text, record, index) {
                    return jyjl ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this2.handleChange(e.target.value, index, 'xxjl');
                        },
                        style: { width: 140 },
                        placeholder: '\u8BF7\u586B\u5199\u5B66\u6821'
                    }) : text;
                }
            },
            // {
            //     title: '任何职',
            //     dataIndex: 'zw',
            //     render: (text, record,index) => {
            //         return jyjl ? (
            //             <Input     
            //                 value={text}
            //                 onChange={(e) =>{this.handleChange(e.target.value,index,'zw')}}         
            //                 style={{ width: 100 }}
            //                 placeholder="请填写职位"
            //             />
            //         ) : (
            //             text
            //         );
            //     }
            // },
            // {
            //     title: '证明人',
            //     dataIndex: 'zmr',
            //     render: (text, record,index) => {
            //         return jyjl ? (
            //             <Input     
            //                 value={text}
            //                 onChange={(e) =>{this.handleChange(e.target.value,index,'zmr')}}         
            //                 style={{ width: 100 }}
            //                 placeholder="请填写证明人"
            //             />
            //         ) : (
            //             text
            //         );
            //     }
            // }, 
            // {
            //     title: '证明人联系电话',
            //     dataIndex: 'zmrlxfs',
            //     render: (text, record,index) => {
            //         return jyjl ? (
            //             <Input     
            //                 value={text}
            //                 onChange={(e) =>{this.handleChange(e.target.value,index,'zmrlxfs')}}         
            //                 style={{ width: 100 }}
            //                 placeholder="请填写电话"
            //             />
            //         ) : (
            //             text
            //         );
            //     }
            // },                
            {
                title: '删除',
                dataIndex: 'operation',
                width: 80,
                render: function render(text, record, index) {
                    if (jyjl) {
                        return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            { className: 'editable-row-operations' },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'a',
                                {
                                    href: 'javascript:;',
                                    onClick: function onClick() {
                                        return _this2.onjyjlClose(index);
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, {
                                    type: 'close',
                                    style: { color: 'red' }
                                })
                            )
                        );
                    }
                    return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'a',
                        { href: '#' },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'delete', style: { color: 'red' } })
                    );
                }
            }];

            if (!jyjl) {
                jyjlColumns.pop();
            }
            return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u6559\u80B2\u7ECF\u5386\u4FE1\u606F',
                    onEdit: function onEdit(type) {
                        _this2.setState({
                            jyjl: true,
                            jyjlAdd: true,
                            cacheData: _this2.deepCopy(_this2.state.jyjlData)
                        });
                        getChildComponent(4, false);
                    },
                    onSave: function onSave(cb) {
                        _this2.cacheJyjlData(cb);
                        _this2.setState({
                            jyjl: false,
                            jyjlAdd: false

                        });
                    },
                    onClose: function onClose() {
                        _this2.setState({
                            jyjl: false,
                            jyjlAdd: false,
                            jyjlData: _this2.deepCopy(_this2.state.cacheData)
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a, {
                        bordered: true,
                        size: 'middle',
                        pagination: false,
                        dataSource: jyjlData,
                        columns: jyjlColumns
                    }),
                    jyjlAdd && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'div',
                        {
                            className: 'mt-10 app__css__app-pages-SelfHelp-infoGdnhgs-__index__btn_add',

                            onClick: function onClick() {

                                _this2.onjyjlAdd();
                            }
                        },
                        '\u6DFB\u52A0\u6559\u80B2\u7ECF\u5386'
                    )
                )
            );
        }
    }]);

    return JyjlForm;
}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);



/***/ }),

/***/ 1059:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_custom_scrollbars__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_custom_scrollbars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_common_NHFormItem_FormRules__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__index_css__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components__ = __webpack_require__(10);



















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _extends = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _styleModuleImportMap = {
    './index.css': {
        'progress': 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__progress',
        'jbxx_icon': 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__jbxx_icon',
        'upload-box': 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__upload-box',
        'upload-title': 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__upload-title',
        'jbxx_item': 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__jbxx_item',
        'jbxx_item2': 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__jbxx_item2',
        'item-label': 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-label',
        'item-name': 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-name',
        'kzxx_list': 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__kzxx_list',
        'kzxx_item': 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__kzxx_item',
        'kzxx_label': 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__kzxx_label',
        'kzxx_name': 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__kzxx_name',
        'kzxx_item_textarea': 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__kzxx_item_textarea',
        'kzxx_name_textarea': 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__kzxx_name_textarea',
        'btn_add': 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__btn_add',
        'title_top': 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__title_top',
        'title_top_name': 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__title_top_name',
        'line': 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__line',
        'detail_adrress': 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__detail_adrress'
    }
};

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }


















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;
var basicUrl = "/zzbd";
var stuInfoUrl = "/xxcj/";

//日期格式化
var dateFormat = 'YYYY-MM-DD';

var KzxxFormComponent = function (_React$Component) {
    _inherits(KzxxFormComponent, _React$Component);

    function KzxxFormComponent(props) {
        _classCallCheck(this, KzxxFormComponent);

        var _this = _possibleConstructorReturn(this, (KzxxFormComponent.__proto__ || __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default()(KzxxFormComponent)).call(this, props));

        _this.onSaveKzxx = function (cb) {
            _this.props.form.validateFields(function (error, values) {
                if (error) {
                    return;
                }
                _this.setState({
                    formData: _extends({}, values),
                    kzxx: false
                });
                var _this$props = _this.props,
                    cacheFormData = _this$props.cacheFormData,
                    getChildComponent = _this$props.getChildComponent;

                getChildComponent(2, true);
                __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys___default()(values).forEach(function (key) {
                    if (values[key] != null && values[key] != undefined) {
                        if (values[key].constructor.name == 'Moment') {//处理Moment格式的数据  
                            //values[key] = moment(values[key]).format(dateFormat); 
                        } else if (values[key].constructor.name == 'Array') {
                            if (_typeof(values[key]) === 'object') {
                                var isFileUpload = false;
                                var array = [];
                                var _iteratorNormalCompletion = true;
                                var _didIteratorError = false;
                                var _iteratorError = undefined;

                                try {
                                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(values[key]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                        var item = _step.value;

                                        if (item.hasOwnProperty('uuid') && item['uuid']) {
                                            isFileUpload = true;
                                            array.push(item['uuid']);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return) {
                                            _iterator.return();
                                        }
                                    } finally {
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }

                                if (isFileUpload) {
                                    values[key] = array.join(',');
                                } else {
                                    values[key] = values[key].join(',');
                                }
                            } else {
                                values[key] = values[key].join(',');
                            }
                        }
                    } else {
                        values[key] = '';
                    }
                });

                var postData = {
                    'xxcj': { 'xsid': _this.props.xsid, 'formData': _extends({}, values) },
                    'params': { 'zzbdhjid': _this.props.zzbdhjid, 'xsid': _this.props.xsid }
                };

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])('/newStudent/updateStuInfo', 'POST', postData).then(function (res) {
                    if (res && res.code == 200) {
                        __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.success("保存成功");
                        cb(true);
                        _this.props.reloadMenu();
                    } else {
                        __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error("保存失败");
                    }
                });
            });
        };

        _this.onChange = function (date, dateString) {}
        // console.log('date', date)
        // console.log('dateString', dateString)
        // if(date && dateString){
        //     //this.
        // }


        //获取下拉列表value对应的名称
        ;

        _this.getDmkMc = function (dmbz, zdbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])("/proData/selectDataList", "GET", { sign: dmbz }).then(function (res) {
                if (res) {
                    if (res.data) {
                        var dmkmcList = _this.state.dmkmcList;
                        dmkmcList[zdbz] = res.data;
                        _this.setState({
                            dmkmcList: dmkmcList
                        });
                    }
                }
            });
        };

        _this.getCascaderDmkMc = function (level, sign, cascaderValue, zdbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])("/proData/selectCascaderList", "GET", { level: level, sign: sign, cascaderValue: cascaderValue }).then(function (res) {
                if (res) {
                    if (res.data) {
                        var dmkmcList = _this.state.dmkmcList;
                        dmkmcList[level + zdbz] = res.data;
                        _this.setState({
                            dmkmcList: dmkmcList
                        });
                    }
                }
            });
        };

        _this.handlePreview = function (fjmc, fjid) {

            if (fjmc === "isImage") {
                _this.showPreview('anonymity/docrepo/download/file?attachmentId=' + fjid);
            } else {
                window.open('anonymity/docrepo/download/file?attachmentId=' + fjid);
            }
        };

        _this.showPreview = function (url) {
            _this.setState({
                previewImage: url,
                previewVisible: true
            });
        };

        _this.closeModal = function () {
            return _this.setState({ previewVisible: false });
        };

        _this.fileLists = function (fileLists) {
            {
                var items = [];

                var _loop = function _loop(key) {
                    var fileList = typeof fileLists[key] == 'string' ? fileLists[key].split(";") : fileLists[key];
                    items.push(__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                            'a',
                            { onClick: function onClick() {
                                    _this.handlePreview("file", fileList[0]);
                                } },
                            fileList[1]
                        )
                    ));
                };

                for (var key in fileLists) {
                    _loop(key);
                }
                return items;
            }
        };

        _this.imageLists = function (imageLists) {
            {
                var items = [];

                var _loop2 = function _loop2(key) {
                    var imageList = typeof imageLists[key] == 'string' ? imageLists[key].split(";") : imageLists[key];
                    items.push(__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        'span',
                        null,
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('img', { style: { height: "80px", width: "80px" }, src: "anonymity/docrepo/download/file?attachmentId=" + imageList,
                            onClick: function onClick() {
                                _this.handlePreview("isImage", imageList[0]);
                            } })
                    ));
                };

                for (var key in imageLists) {
                    _loop2(key);
                }
                return items;
            }
        };

        _this.state = {
            xsid: '',
            kzxx: false,
            scrollHeight: 0, //默认滚动高度
            initData: {}, //初始数据
            loading: false, //页面加载状态
            onSubmit: false, //保存按钮加载状态
            isShow: false,
            previewVisible: false,
            formData: '',
            dmkmcList: {},
            zdzmc: ''
        };
        return _this;
    }

    //控件回调

    //获取联级下拉列表value对应的名称

    // 点击文件链接或预览图标时的回调


    //打开图片弹窗

    // 关闭图片弹窗

    // 文件展示 

    //图片展示


    _createClass(KzxxFormComponent, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                form = _props.form,
                getChildComponent = _props.getChildComponent,
                initData = _props.initData;
            var _state = this.state,
                kzxx = _state.kzxx,
                formData = _state.formData,
                previewVisible = _state.previewVisible,
                previewImage = _state.previewImage;
            //提示信息

            var AlertParams = {
                message: '当前没有需要填写的信息',
                description: '',
                type: 'info'
                //信息采集字段分类
            };var infoItems = [];
            var reactid = 0;
            if (initData) {
                //表单信息、表单字段信息
                var _initData$zdglVOs = initData.zdglVOs,
                    zdglVOs = _initData$zdglVOs === undefined ? [] : _initData$zdglVOs;

                if (zdglVOs != null) {
                    if (zdglVOs.length > 0) {
                        var array = [];
                        //循环过滤出多行文本框的key，偶数在左，奇数在右，相应的同行的另一条文本也需要加宽
                        for (var key in zdglVOs) {
                            var kjcs = zdglVOs[key].kjcs;

                            var kjcsjson = JSON.parse(kjcs);
                            if (kjcsjson.type === "textarea" || kjcsjson.type === "oldupload" || kjcsjson.type === "upload") {
                                if (key % 2 === 0) {
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key));
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key) + 1);
                                } else {
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key));
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key) - 1);
                                }
                            }
                        }
                        //显示表单字段信息

                        var _loop3 = function _loop3(_key) {
                            //字段状态、是否必填、默认值、字段标识、字段名称、控件参数、字段值
                            var _zdglVOs$_key = zdglVOs[_key],
                                zdbz = _zdglVOs$_key.zdbz,
                                zdmc = _zdglVOs$_key.zdmc,
                                kjcs = _zdglVOs$_key.kjcs,
                                zdz = _zdglVOs$_key.zdz,
                                sfbt = _zdglVOs$_key.sfbt,
                                mrz = _zdglVOs$_key.mrz,
                                zdzt = _zdglVOs$_key.zdzt; //表单字段

                            var zdzmc = '';
                            var kjcsjson = JSON.parse(kjcs);
                            if (formData && formData[zdbz] != null) {
                                zdz = formData[zdbz];
                            }
                            if (kjcsjson.type === 'datepicker' || kjcsjson.type === 'datetimepicker' || kjcsjson.type === 'timepicker' || kjcsjson.type === 'monthpicker' || kjcsjson.type === 'rangepicker') {
                                //日期值展示阶段，从moment转为文字 
                                if (zdz) {
                                    zdzmc = __WEBPACK_IMPORTED_MODULE_27_moment___default()(zdz).format(kjcsjson.format);
                                }
                            } else if (kjcsjson.type === "select") {
                                if (kjcsjson.dataTag && !_this2.state.dmkmcList[zdbz]) {
                                    _this2.getDmkMc(kjcsjson.dataTag, zdbz);
                                }
                                var list = _this2.state.dmkmcList[zdbz];
                                list && list.map(function (item) {
                                    if (item.VALUE === zdz) {
                                        zdzmc = item.LABEL;
                                    }
                                });
                            } else if (kjcsjson.type === "multiselect") {
                                if (kjcsjson.dataTag && !_this2.state.dmkmcList[zdbz]) {
                                    _this2.getDmkMc(kjcsjson.dataTag, zdbz);
                                }
                                var _list = _this2.state.dmkmcList[zdbz];
                                if (zdz) {
                                    (function () {
                                        var multiselect = typeof zdz == 'string' ? zdz.split(",") : zdz;
                                        var multiselectList = [];

                                        var _loop4 = function _loop4(i) {
                                            _list && _list.map(function (item) {
                                                if (item.VALUE === multiselect[i]) {
                                                    multiselectList.push(item.LABEL);
                                                }
                                            });
                                        };

                                        for (var i in multiselect) {
                                            _loop4(i);
                                        }
                                        zdzmc = multiselectList.join(",");
                                    })();
                                }
                            } else if (kjcsjson.type === "nhcascader") {
                                if (zdz) {
                                    (function () {
                                        var nhcascaderList = typeof zdz == 'string' ? zdz.split(",") : zdz;
                                        var nhcascaderLists = [];

                                        var _loop5 = function _loop5(i) {
                                            var level = i;
                                            var c = i;
                                            var d = i;
                                            var a = ++level;
                                            var b = --d;
                                            if (kjcsjson.dataTag && !_this2.state.dmkmcList[a + zdbz]) {
                                                if (i == "0") {
                                                    _this2.getCascaderDmkMc(a, kjcsjson.dataTag, '', zdbz);
                                                } else {
                                                    _this2.getCascaderDmkMc(a, kjcsjson.dataTag, nhcascaderList[b], zdbz);
                                                }
                                            }
                                            var list = _this2.state.dmkmcList[level++ + zdbz];

                                            list && list.map(function (item) {
                                                if (item.value === nhcascaderList[c]) {
                                                    nhcascaderLists.push(item.label);
                                                }
                                            });
                                        };

                                        for (var i in nhcascaderList) {
                                            _loop5(i);
                                        }
                                        zdzmc = nhcascaderLists.join("/");
                                    })();
                                }
                            } else if (kjcsjson.type === "switch") {
                                zdzmc = zdz === "1" || zdz === true ? kjcsjson.checkedText : kjcsjson.uncheckedText;
                            } else if (kjcsjson.type === "radio") {
                                kjcsjson.options && kjcsjson.options.map(function (item, key) {
                                    if (item.value === zdz) {
                                        zdzmc = item.label;
                                    }
                                });
                            } else if (kjcsjson.fileType === "file" && zdz) {
                                var fileLists = typeof zdz == 'string' ? zdz.split(",") : zdz;
                                zdzmc = _this2.fileLists(fileLists);
                            } else if (kjcsjson.fileType === "image" && zdz) {
                                if ((typeof zdz === 'undefined' ? 'undefined' : _typeof(zdz)) === 'object') {
                                    var _array = [];
                                    var _iteratorNormalCompletion2 = true;
                                    var _didIteratorError2 = false;
                                    var _iteratorError2 = undefined;

                                    try {
                                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(zdz), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                            var item = _step2.value;

                                            if (item.hasOwnProperty('uuid') && item['uuid']) {
                                                _array.push(item['uuid']);
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError2 = true;
                                        _iteratorError2 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                                _iterator2.return();
                                            }
                                        } finally {
                                            if (_didIteratorError2) {
                                                throw _iteratorError2;
                                            }
                                        }
                                    }

                                    zdz = _array;
                                } else {
                                    zdz = zdz.split(",");
                                }
                                zdzmc = _this2.imageLists(zdz);
                            } else {
                                zdzmc = zdz;
                            }
                            var required = sfbt === '1' ? true : false;

                            var formItem = void 0;
                            var csz = formData ? formData[zdbz] : zdz;
                            if (required) {
                                formItem = kjcsjson.type === 'textarea' || kjcsjson.type === "oldupload" || kjcsjson.type === "upload" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { height: "120px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item_textarea", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__kzxx_label' },
                                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                            'span',
                                            { style: { color: 'red' } },
                                            '*'
                                        ),
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__kzxx_name_textarea' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs }) : zdzmc
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { height: "71px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__kzxx_label' },
                                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                            'span',
                                            { style: { color: 'red' } },
                                            '*'
                                        ),
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__kzxx_name' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs,
                                            onChange: _this2.onChange }) : zdzmc
                                    )
                                );
                            } else {
                                formItem = kjcsjson.type === 'textarea' || kjcsjson.type === "oldupload" || kjcsjson.type === "upload" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { height: "120px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item_textarea", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__kzxx_label' },
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__kzxx_name_textarea' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs }) : zdzmc
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { height: "71px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__kzxx_label' },
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__kzxx_name' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs,
                                            onChange: _this2.onChange }) : zdzmc
                                    )
                                );
                            }
                            infoItems.push(formItem);
                        };

                        for (var _key in zdglVOs) {
                            _loop3(_key);
                        }
                    } else {
                        //未找到表单配置的采集字段信息
                        AlertParams['message'] = '暂时没有需要填写的信息';
                        AlertParams['description'] = '当前未配置采集信息项';
                        AlertParams['type'] = 'warning';
                    }
                }
            }

            return __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                'div',
                {
                    className: 'jsx-2266704716'
                },
                infoItems.length > 0 && __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                    'div',
                    {
                        className: 'jsx-2266704716'
                    },
                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__pages_Assembly_titleTop__["a" /* default */], {
                        title: '\u6269\u5C55\u4FE1\u606F',
                        onEdit: function onEdit(type) {
                            _this2.setState({
                                kzxx: true
                            });
                            getChildComponent(2, false);
                        },
                        onSave: function onSave(cb) {
                            _this2.onSaveKzxx(cb);
                        },
                        onClose: function onClose() {
                            _this2.setState({
                                kzxx: false
                            });
                        }
                    }),
                    infoItems.length > 0 ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a,
                        null,
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-2266704716' + ' ' + 'p-sw'
                            },
                            __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-2266704716' + ' ' + 'app__css__app-pages-SelfHelp-infoGdnhgs-__index__kzxx_list'
                                },
                                infoItems
                            )
                        )
                    ) : __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default.a, _extends({ style: { marginTop: 20 }
                    }, AlertParams, {
                        showIcon: true
                    })),
                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a,
                        {
                            visible: previewVisible,
                            footer: null,
                            onCancel: this.closeModal
                        },
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('img', {
                            alt: 'example',
                            style: { width: '100%' },
                            src: previewImage,
                            className: 'jsx-2266704716'
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_styled_jsx_style___default.a, {
                    styleId: '2266704716',
                    css: ['.app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_item{height:100% !important;}', '.app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_label{background-color:#fff;}', '.app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_name{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;width:67%;}']
                })
            );
        }
    }]);

    return KzxxFormComponent;
}(__WEBPACK_IMPORTED_MODULE_20_react___default.a.Component);

var KzxxForm = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create()(KzxxFormComponent);
/* harmony default export */ __webpack_exports__["a"] = (KzxxForm);

/***/ }),

/***/ 106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NHModal */
/* harmony export (immutable) */ __webpack_exports__["b"] = NHConfirm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_custom_scrollbars__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_custom_scrollbars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_css__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__index_css__);










var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }







//Modal的最大宽度、高度为屏幕宽度、高度的2/3

if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var maxWidth = window.screen.width * 2 / 3;
var maxHeight = window.screen.height * 2 / 3;

//确认对话框
var confirm = __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal___default.a.confirm;

/**
 * Ant Design Modal 模态对话框二次封装
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-01-23 14:37:19
 * Version: 1.0
 * Modify log:
 * 2018-05-25：
 *  1、解决控制台警告问题；
 *  2、对话框居中；
 *  3、点击保存按钮后，保存按钮默认变成loading状态，
 *     可在onOk回调方法中调用回调函数stopLoading来终止按钮的loading状态；
 * 2018-06-04:
 *  1、“保存”按钮更改为“确认”
 */
var NHModal = function (_React$Component) {
    _inherits(NHModal, _React$Component);

    function NHModal(props) {
        _classCallCheck(this, NHModal);

        var _this = _possibleConstructorReturn(this, (NHModal.__proto__ || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default()(NHModal)).call(this, props));

        _this.show = function () {
            _this.setState({ visible: true });
        };

        _this.close = function () {
            _this.setState({ visible: false, confirmLoading: false });
        };

        _this.stopLoading = function () {
            _this.setState({ confirmLoading: false });
        };

        _this.handleOk = function () {
            _this.setState({ confirmLoading: true });
            _this.props.onOk(_this.stopLoading);
        };

        _this.handleCancel = function () {
            _this.close();
            _this.props.onCancel();
        };

        _this.state = {
            visible: false, //默认不可见
            confirmLoading: false //确定按钮 loading
        };
        return _this;
    }

    //显示


    //关闭


    //隐藏加载动画


    //确认


    //取消


    _createClass(NHModal, [{
        key: 'render',
        value: function render() {
            var _state = this.state,
                visible = _state.visible,
                confirmLoading = _state.confirmLoading;
            var _props = this.props,
                title = _props.title,
                style = _props.style,
                bodyStyle = _props.bodyStyle,
                maxSize = _props.maxSize,
                destroyOnClose = _props.destroyOnClose,
                footer = _props.footer,
                afterClose = _props.afterClose;

            var width = this.props.width;

            if (maxSize) {
                width = maxWidth;
            } else if (width > maxWidth) {
                width = maxWidth;
            }

            //如果未定义页脚按钮，则使用默认按钮
            if (footer === undefined && visible) {
                return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                    'div',
                    {
                        className: 'jsx-498553737'
                    },
                    __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal___default.a,
                        {
                            title: title,
                            style: style,
                            bodyStyle: bodyStyle,
                            visible: visible,
                            width: width,
                            okText: '\u786E\u5B9A',
                            onOk: this.handleOk,
                            cancelText: '\u8FD4\u56DE',
                            onCancel: this.handleCancel,
                            wrapClassName: 'vertical-center-modal',
                            confirmLoading: confirmLoading,
                            maskClosable: false,
                            destroyOnClose: destroyOnClose,
                            afterClose: afterClose
                        },
                        __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                            'div',
                            { style: { maxHeight: maxHeight }, className: 'jsx-498553737'
                            },
                            __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_11_react_custom_scrollbars__["Scrollbars"],
                                { autoHide: true, autoHeight: true, autoHeightMax: maxHeight, style: { width: '100%' } },
                                this.props.children
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_styled_jsx_style___default.a, {
                        styleId: '498553737',
                        css: ['.vertical-center-modal{text-align:center;white-space:nowrap;}', '.vertical-center-modal:before{content:\'\';display:inline-block;height:100%;vertical-align:middle;width:0;}', '.vertical-center-modal .ant-modal{display:inline-block;vertical-align:middle;top:0;text-align:left;}']
                    })
                );
            } else if (visible) {
                //如果footer为null，则不显示页脚按钮
                var buttons = [];
                if (footer != null && footer.length > 0) {
                    var buttonKey = 0;
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(footer), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var buttonParam = _step.value;

                            //text：按钮描述，type：按钮类型，icon：按钮图标，loading：加载状态，onClick：按钮点击事件
                            var _buttonParam$text = buttonParam.text,
                                text = _buttonParam$text === undefined ? "" : _buttonParam$text,
                                _buttonParam$type = buttonParam.type,
                                type = _buttonParam$type === undefined ? "primary" : _buttonParam$type,
                                _buttonParam$icon = buttonParam.icon,
                                icon = _buttonParam$icon === undefined ? "" : _buttonParam$icon,
                                _buttonParam$loading = buttonParam.loading,
                                loading = _buttonParam$loading === undefined ? false : _buttonParam$loading,
                                _buttonParam$onClick = buttonParam.onClick,
                                onClick = _buttonParam$onClick === undefined ? function () {} : _buttonParam$onClick;

                            var customButton = __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                                { key: buttonKey, type: type, icon: icon, loading: loading, onClick: onClick },
                                text
                            );
                            buttons.push(customButton);
                            buttonKey++;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else {
                    buttons = null;
                }

                return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                    'div',
                    {
                        className: 'jsx-498553737'
                    },
                    __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_modal___default.a,
                        {
                            title: title,
                            style: style,
                            bodyStyle: bodyStyle,
                            visible: visible,
                            width: width,
                            footer: buttons,
                            onCancel: this.handleCancel,
                            wrapClassName: 'vertical-center-modal',
                            confirmLoading: confirmLoading,
                            maskClosable: false,
                            destroyOnClose: destroyOnClose,
                            afterClose: afterClose
                        },
                        __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                            'div',
                            { style: { maxHeight: maxHeight }, className: 'jsx-498553737'
                            },
                            __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_11_react_custom_scrollbars__["Scrollbars"],
                                { autoHide: true, autoHeight: true, autoHeightMax: maxHeight, style: { width: '100%' } },
                                this.props.children
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_styled_jsx_style___default.a, {
                        styleId: '498553737',
                        css: ['.vertical-center-modal{text-align:center;white-space:nowrap;}', '.vertical-center-modal:before{content:\'\';display:inline-block;height:100%;vertical-align:middle;width:0;}', '.vertical-center-modal .ant-modal{display:inline-block;vertical-align:middle;top:0;text-align:left;}']
                    })
                );
            } else {
                return null;
            }
        }
    }]);

    return NHModal;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);

/**
 *  NHModal默认属性
 */
NHModal.defaultProps = {
    title: "标题",
    width: 520, //默认最小宽度
    maxSize: false, //是否最大化窗口
    destroyOnClose: true, //关闭时销毁 Modal 里的子元素
    onOk: function onOk() {},
    onCancel: function onCancel() {},
    afterClose: function afterClose() {}

    /**
     *  NHModal属性检查
     */
};NHModal.propTypes = {
    title: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string, //对话框标题
    style: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.object, //对话框样式
    bodyStyle: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.object, //Modal body 样式
    width: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number, //宽度
    maxSize: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool, //最大化窗口
    footer: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.object), //按钮组
    destroyOnClose: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool, //关闭时销毁对话框内子元素
    onOk: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func, //保存事件回调方法
    onCancel: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func, //返回事件回调方法
    afterClose: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func //Modal 完全关闭后的回调


    //确认对话框
};function NHConfirm(pContent, pOnOk, pType, pOnCancel) {
    if (typeof pContent == 'string') {
        var content = pContent ? pContent : '请填写内容描述';
        var type = pType ? pType : 'normal';
        var _onOk = pOnOk ? pOnOk : function () {};
        var _onCancel = pOnCancel ? pOnCancel : function () {};
    } else {
        var params = pContent;
        var content = params.content ? params.content : '请填写内容描述';
        var type = params.type ? params.type : 'normal';
        var _onOk = params.onOk ? params.onOk : function () {};
        var _onCancel = params.onCancel ? params.onCancel : function () {};
    }

    var title = '提示';
    var okType = 'primary'; //默认确认按钮类型
    var iconType = 'question-circle'; //问号

    if (type == 'warn') {
        //警告类型操作提示

        okType = 'danger';
        iconType = 'info-circle';
    } else if (type == 'danger') {
        //危险类型操作提示

        okType = 'danger';
        iconType = 'exclamation-circle';
    }

    confirm({
        title: title,
        content: content,
        okText: '确定',
        cancelText: '取消',
        okType: okType,
        iconType: iconType,
        onOk: function onOk() {
            _onOk();
        },
        onCancel: function onCancel() {
            _onCancel();
        }
    });
}

/* harmony default export */ __webpack_exports__["a"] = (NHModal);

/***/ }),

/***/ 1060:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__utils_RegExp__);















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item;

var ZyshgxInitForm = function (_React$Component) {
    _inherits(ZyshgxInitForm, _React$Component);

    function ZyshgxInitForm(props) {
        _classCallCheck(this, ZyshgxInitForm);

        var _this = _possibleConstructorReturn(this, (ZyshgxInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default()(ZyshgxInitForm)).call(this, props));

        _this.cacheZyshgxData = function (cb) {
            _this.props.form.validateFields(function (err, values) {
                if (err) return cb(false);
                //判断数据是否全部填写
                var dataList = [];
                if (_this.state.zyshgxData && _this.state.zyshgxData.length > 0) {
                    for (var i = 0; i < _this.state.zyshgxData.length; i++) {
                        var data = _this.state.zyshgxData[i];
                        if (!data.gx && !data.xm && !data.gzxxdw && !data.lxfs && !data.operation) {} else {
                            dataList.push(data);
                        }
                    }
                }

                var _this$props = _this.props,
                    cacheFormData = _this$props.cacheFormData,
                    getChildComponent = _this$props.getChildComponent;

                getChildComponent(3, true);
                cacheFormData('zyshgx', dataList, true);
                cb(true);
                _this.setState({
                    zyshgx: false,
                    zyshgxAdd: false
                });
            });
        };

        _this.onzyshgxAdd = function () {
            var _this$state = _this.state,
                zyshgxAdd = _this$state.zyshgxAdd,
                zyshgxData = _this$state.zyshgxData;

            if (!zyshgxData) {
                zyshgxData = [];
            }

            if (zyshgxAdd) {
                zyshgxData.push({
                    key: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["c" /* createUuid */])(),
                    gx: '',
                    xm: '',
                    gzxxdw: '',
                    zzmmm: '',
                    lxfs: '',
                    operation: ''
                });
                _this.setState({
                    zyshgxData: zyshgxData
                });
            }
            _this.setState({
                zyshgxAdd: true
            });
        };

        _this.onzyshgxSave = function () {
            var zyshgxData = _this.state.zyshgxData;

            zyshgxData.push();
            _this.setState({
                zyshgxData: zyshgxData,
                zyshgxAdd: false
            });
        };

        _this.onzyshgxClose = function (index) {
            var zyshgxData = _this.state.zyshgxData;

            zyshgxData.splice(index, 1);
            _this.setState({
                zyshgxData: zyshgxData,
                zyshgxAdd: true
            });
        };

        _this.handleChange = function (value, index, key) {
            var zyshgxData = _this.state.zyshgxData;
            zyshgxData[index][key] = value;
            _this.setState({ zyshgxData: zyshgxData });
        };

        _this.getzzmmmStr = function (value) {
            var temp = '';
            _this.state.zzmmmList.forEach(function (i) {
                if (i.value === value) {
                    temp = i.label;
                }
            });
            return temp;
        };

        _this.deepCopy = function (obj) {
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                return obj;
            }

            if (_this.isArrayFn(obj)) {
                var newobj = [];
                for (var i = 0; i < obj.length; i++) {
                    newobj.push(_this.deepCopy(obj[i]));
                }
                return newobj;
            } else {
                var _newobj = {};
                for (var attr in obj) {
                    _newobj[attr] = _this.deepCopy(obj[attr]);
                }
                return _newobj;
            }
        };

        _this.isArrayFn = function (value) {
            if (typeof Array.isArray === "function") {
                return Array.isArray(value);
            } else {
                return Object.prototype.toString.call(value) === "[object Array]";
            }
        };

        _this.state = {
            zyshgx: false,
            zyshgxAdd: false,
            zyshgxData: [],
            zzmmmList: [],
            tempStr: ''
        };
        return _this;
    }

    _createClass(ZyshgxInitForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])('/proData/selectDataList?&sign=DMK_XTGL_ZZMMM', 'GET').then(function (res) {
                if (res && res.data) {
                    var zzmmmList = [];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_get_iterator___default()(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var obj = _step.value;

                            zzmmmList.push({ 'label': obj.LABEL, 'value': obj.VALUE });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this2.setState({ zzmmmList: zzmmmList });
                }
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('zyshgxInitData' in nextProps && nextProps.zyshgxInitData) {
                if (nextProps.zyshgxInitData instanceof Array) {
                    var temp = [].concat(_toConsumableArray(nextProps.zyshgxInitData));
                    this.setState({ zyshgxData: temp });
                }
            }
        }

        // 家庭成员 添加

        // 家庭成员 保存添加

        // 家庭成员 关闭添加

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _state = this.state,
                zyshgx = _state.zyshgx,
                zyshgxData = _state.zyshgxData,
                zyshgxAdd = _state.zyshgxAdd,
                zyshgxList = _state.zyshgxList;
            var _props = this.props,
                getChildComponent = _props.getChildComponent,
                form = _props.form;
            var zzmmmList = this.state.zzmmmList;
            var getFieldDecorator = form.getFieldDecorator;

            var zyshgxColumns = [{
                title: '关系',
                key: 'gx',
                dataIndex: 'gx',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'gx');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u5173\u7CFB'
                    }) : text;
                }
            }, {
                title: '姓名',
                dataIndex: 'xm',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'xm');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u59D3\u540D'
                    }) : text;
                }
            }, {
                title: '工作单位及职务',
                dataIndex: 'gzxxdw',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'gzxxdw');
                        },
                        style: { width: 140 },
                        placeholder: '\u8BF7\u586B\u5199\u5355\u4F4D\u548C\u804C\u52A1'
                    }) : text;
                }
            }, {
                title: '联系电话',
                dataIndex: 'lxfs',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        FormItem,
                        { form: form, style: { marginBottom: '0px' } },
                        getFieldDecorator('lxfs', {
                            rules: [{ required: true, message: '请填写电话' }, __WEBPACK_IMPORTED_MODULE_25__utils_RegExp__["FormRules"].MOBILE_PHONE_NUMBER],
                            initialValue: text
                        })(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a, {
                            value: text,
                            onChange: function onChange(e) {
                                _this3.handleChange(e.target.value, index, 'lxfs');
                            },
                            style: { width: 100 },
                            placeholder: '\u8BF7\u586B\u5199\u7535\u8BDD'
                        }))
                    ) : text;
                }
            }, {
                title: 'QQ',
                dataIndex: 'qq',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'qq');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586BQQ\u53F7'
                    }) : text;
                }
            }, {
                title: '微信',
                dataIndex: 'wx',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'wx');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5FAE\u4FE1\u53F7'
                    }) : text;
                }
            }, {
                title: '删除',
                dataIndex: 'operation',
                width: 80,
                render: function render(text, record, index) {
                    if (zyshgx) {
                        return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            { className: 'editable-row-operations' },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                'a',
                                {
                                    href: 'javascript:;',
                                    onClick: function onClick() {
                                        return _this3.onzyshgxClose(index);
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default.a, {
                                    type: 'close',
                                    style: { color: 'red' }
                                })
                            )
                        );
                    }
                    return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'a',
                        { href: 'javascript:;', onClick: function onClick() {
                                return _this3.onzyshgxClose();
                            } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default.a, { type: 'delete', style: { color: 'red' } })
                    );
                }
            }];
            if (!zyshgx) {
                zyshgxColumns.pop();
            }
            return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('div', null);
        }
    }]);

    return ZyshgxInitForm;
}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);

var ZyshgxForm = __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.create()(ZyshgxInitForm);
/* harmony default export */ __webpack_exports__["a"] = (ZyshgxForm);

/***/ }),

/***/ 1061:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoGdnhgs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker_style__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_date_picker__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__JbxxForm__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__JtcyForm__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ZyshgxForm__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__JyjlForm__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__KzxxForm__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_common_hint__ = __webpack_require__(35);












var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }






















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_25_history_createHashHistory___default()();
var RangePicker = __WEBPACK_IMPORTED_MODULE_10_antd_lib_date_picker___default.a.RangePicker;

var Option = __WEBPACK_IMPORTED_MODULE_8_antd_lib_select___default.a.Option;
var stuInfoUrl = "/xxcj/";

var InfoGdnhgs = function (_React$Component) {
    _inherits(InfoGdnhgs, _React$Component);

    function InfoGdnhgs(props) {
        _classCallCheck(this, InfoGdnhgs);

        var _this = _possibleConstructorReturn(this, (InfoGdnhgs.__proto__ || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default()(InfoGdnhgs)).call(this, props));

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({
                        nonOperationalData: res.data,
                        zzbdhjid: zzbdhjid
                    });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.getChildComponent = function (flag, mode) {
            switch (flag) {
                case 1:
                    _this.setState({ jbxxFlag: mode });
                    break;
                case 2:
                    _this.setState({ kzxxFlag: mode });
                    break;
                case 3:
                    _this.setState({ jtcyFlag: mode });
                    break;
                case 4:
                    _this.setState({ zyshgxFlag: mode });
                    break;
                case 5:
                    _this.setState({ jyjlFlag: mode });
                    break;
                default:
                    break;
            }
        };

        _this.cacheFormData = function (type, values, isAdd) {
            //const{jbxxInitData} = this.state;
            if (type == 'jbxx') {
                var sjhm = values.sjhm,
                    jtszdqArray = values.jtszdqArray,
                    jtjddz = values.jtjddz;

                if (sjhm !== null && jtszdqArray !== null && jtszdqArray.length > 0 && jtjddz !== null) {
                    _this.setState({
                        jbxxInitData: _extends({}, values),
                        isEditJbxx: true
                    }, function () {
                        _this.insertData4Yxwz();
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("存在必填信息未填写，请填写后再保存！");
                }
            }
            if (type == 'jtcy' && isAdd) {
                var zyshgxInitData = _this.state.zyshgxInitData;

                if (zyshgxInitData !== null && zyshgxInitData.length > 0) {
                    _this.setState({
                        jtcyInitData: values,
                        isEditJtcy: true
                    }, function () {
                        _this.insertData4Yxwz();
                    });
                } else if (values !== null && values.length > 0) {
                    _this.setState({
                        jtcyInitData: values,
                        isEditJtcy: true
                    }, function () {
                        _this.insertData4Yxwz();
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("家庭成员信息和主要社会关系至少要填一项！");
                }
            }
            if (type == 'zyshgx' && isAdd) {
                var jtcyInitData = _this.state.jtcyInitData;

                if (jtcyInitData !== null && jtcyInitData.length > 0) {
                    _this.setState({
                        zyshgxInitData: values,
                        isEditZyshgx: true
                    }, function () {
                        _this.insertData4Yxwz();
                    });
                } else if (values !== null && values.length > 0) {
                    _this.setState({
                        zyshgxInitData: values,
                        isEditZyshgx: true
                    }, function () {
                        _this.insertData4Yxwz();
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("家庭成员信息和主要社会关系至少要填一项！");
                }
            }
            if (type == 'jyjl') {
                if (values !== null && values.length > 0) {
                    _this.setState({
                        jyjlInitData: values,
                        isEditJyjl: true
                    }, function () {
                        _this.insertData4Yxwz();
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("教育经历信息不能为空！");
                }
            }
        };

        _this.getData4Yxwz = function () {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                _this.setState({ xsid: userId });
                // NHFetch('/newStudent/queryStuInfo', 'GET', { 'xsid': userId })
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/newStudent/queryXsInfo', 'GET', { 'xsid': userId }) // 不跨服务调用
                .then(function (res) {
                    if (res && res.data) {
                        var stuInfo = res.data.stuInfo;
                        var stuXxcj = res.data.stuXxcj;
                        var stuSsxx = res.data.stuSsxx;
                        var editXszp = res.data.editXszp;

                        _this.setState({
                            userBaseInfo: stuInfo.userBaseInfo,
                            jbxxInitData: stuInfo.xsJbxx4YxwzVO,
                            jtcyInitData: stuInfo.jtcyVo,
                            zyshgxInitData: stuInfo.zyshgxVO,
                            jyjlInitData: stuInfo.jyjlVO,
                            kzxxInitData: _extends({}, stuXxcj),
                            stuSsxx: stuSsxx,
                            editXszp: editXszp
                        });
                    }
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("登录超时,请重新登录！");
            }
        };

        _this.insertData4Yxwz = function () {
            var postFormData = {};
            var _this$state = _this.state,
                jbxxInitData = _this$state.jbxxInitData,
                jtcyInitData = _this$state.jtcyInitData,
                zyshgxInitData = _this$state.zyshgxInitData,
                jyjlInitData = _this$state.jyjlInitData,
                xsid = _this$state.xsid,
                zzbdhjid = _this$state.zzbdhjid;

            postFormData['xsid'] = xsid;
            postFormData['xsJbxx4YxwzVO'] = jbxxInitData;
            postFormData['jtcyVO'] = jtcyInitData;
            postFormData['zyshgxVO'] = zyshgxInitData;
            postFormData['jyjlVO'] = jyjlInitData;

            var postData = {
                'xsInfo4YxwzVO': postFormData,
                'params': { 'zzbdhjid': zzbdhjid, 'xsid': xsid }
            };

            //必填一
            var _postData$xsInfo4Yxwz = postData.xsInfo4YxwzVO.xsJbxx4YxwzVO,
                sjhm = _postData$xsInfo4Yxwz.sjhm,
                jtszdqArray = _postData$xsInfo4Yxwz.jtszdqArray,
                jtjddz = _postData$xsInfo4Yxwz.jtjddz;

            var jbxxFlag = false;
            if (sjhm !== null && jtszdqArray !== null && jtszdqArray.length > 0 && jtjddz !== null) {
                jbxxFlag = true;
            }
            //必填项二：两个填一个
            var _postData$xsInfo4Yxwz2 = postData.xsInfo4YxwzVO,
                jtcyVO = _postData$xsInfo4Yxwz2.jtcyVO,
                zyshgxVO = _postData$xsInfo4Yxwz2.zyshgxVO,
                jyjlVO = _postData$xsInfo4Yxwz2.jyjlVO;

            var jtxxFlag = false;
            if (jtcyVO !== null && jtcyVO.length > 0 || zyshgxVO !== null && zyshgxVO.length > 0) {
                jtxxFlag = true;
            }
            //必填三
            var jyxxFlag = false;
            if (jyjlVO !== null && jyjlVO.length > 0) {
                jyxxFlag = true;
            }
            var hjblFlag = false;
            if (jbxxFlag && jtxxFlag && jyxxFlag) {
                hjblFlag = true;
            }
            postData.params.hjblFlag = hjblFlag;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/newStudent/updateStuInfo', 'POST', postData).then(function (res) {
                if (res && res.code == 200) {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.success("保存成功");
                    _this.reloadMenu();
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("保存失败");
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD001_5',
            hjmc: '',
            jbxxFormData: {},
            formInitData: {},
            jbxxInitData: {},
            jtcyInitData: [],
            zyshgxInitData: [],
            jyjlInitData: [],
            kzxxInitData: {},
            userBaseInfo: {},
            stuSsxx: {},
            xsid: '',
            jbxxFlag: true,
            kzxxFlag: true,
            jtcyFlag: true,
            zyshgxFlag: true,
            jyjlFlag: true,
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            isEditJbxx: false,
            isEditJtcy: false,
            isEditZyshgx: false,
            isEditJyjl: false,
            menuList: [],
            zzbdhjid: ''
        };
        return _this;
    }

    _createClass(InfoGdnhgs, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.queryQztjAndYlhj();
            //this.getYlhjData();
            this.getData4Yxwz();
        }

        //查询前置条件和依赖环节


        //缓存编写的信息，缓存完之后提交


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                xsid = _state.xsid,
                jtcyInitData = _state.jtcyInitData,
                zyshgxInitData = _state.zyshgxInitData;


            return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_13__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230'
                        /*   active={0}*/
                        , mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13__components__["a" /* Flex */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__JbxxForm__["a" /* default */], { ref: 'refJbxxForm', jbxxFormData: this.state.jbxxInitData,
                                getChildComponent: this.getChildComponent,
                                cacheFormData: this.cacheFormData,
                                userInfoData: this.state.userBaseInfo,
                                stuSsxx: this.state.stuSsxx,
                                editXszp: this.state.editXszp
                            }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__KzxxForm__["a" /* default */], { ref: 'refKzxxForm', getChildComponent: this.getChildComponent,
                                reloadMenu: this.reloadMenu,
                                xsid: this.state.xsid,
                                zzbdhjid: this.state.zzbdhjid,
                                initData: this.state.kzxxInitData
                            }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__JtcyForm__["a" /* default */], { ref: 'refJtcyForm', jtcyInitData: this.state.jtcyInitData,
                                getChildComponent: this.getChildComponent,
                                cacheFormData: this.cacheFormData }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__ZyshgxForm__["a" /* default */], { ref: 'refZyshgxForm', zyshgxInitData: this.state.zyshgxInitData,
                                getChildComponent: this.getChildComponent,
                                cacheFormData: this.cacheFormData }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__JyjlForm__["a" /* default */], { ref: 'refJyjlForm', jyjlInitData: this.state.jyjlInitData,
                                getChildComponent: this.getChildComponent,
                                cacheFormData: this.cacheFormData }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'div',
                                { className: 'p-sw text-center mt-30' },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__common__["a" /* default */], { hjmc: "个人信息填写", key: 'GD001_5', mkbz: 'GD001_5', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return InfoGdnhgs;
}(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);



/***/ }),

/***/ 1062:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_common_NHCascader__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__utils_RegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_common_NHSelect__ = __webpack_require__(71);













var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }












if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var uploadUrl = "api/zhxg-yxwz/newStudent/cacheStudentPhoto"; //上传logo路径 



function beforeUpload(file) {

    var isJPG = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJPG) {
        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("You can only upload JPG file!");
    }
    var isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("Image must smaller than 2MB!");
    }
    return isJPG && isLt2M;
}

var JbxxInitForm = function (_React$Component) {
    _inherits(JbxxInitForm, _React$Component);

    function JbxxInitForm(props) {
        _classCallCheck(this, JbxxInitForm);

        var _this = _possibleConstructorReturn(this, (JbxxInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(JbxxInitForm)).call(this, props));

        _this.getStudentPhotoBase64 = function (userId, callback) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/openapi/student/getStudentPhotoBase64', 'get', { xsid: userId, type: 10 }).then(function (res) {
                if (res && res.code == 200) {
                    callback(res.data);
                }
            });
        };

        _this.onSavejbxxFormData = function (cb) {
            _this.props.form.validateFields(function (error, values) {
                if (error) {
                    cb(false);
                    return;
                }
                cb(true);
                var cacheFormData = _this.props.cacheFormData;

                if (_this.state.jtStr !== '') {
                    values.jtdzDetail = _this.state.jtStr;
                } else {
                    values.jtdzDetail = _this.props.jbxxFormData ? _this.props.jbxxFormData.jtdzDetail ? _this.props.jbxxFormData.jtdzDetail : "" : "";
                }
                if (_this.state.hczmc !== '') {
                    values.hczmc = _this.state.hczmc;
                } else {
                    values.hczmc = _this.props.jbxxFormData ? _this.props.jbxxFormData.hczmc ? _this.props.jbxxFormData.hczmc : "" : "";
                }
                cacheFormData('jbxx', values);
                _this.setState({
                    jbxx: false
                });
            });
        };

        _this.handleUploadChange = function (info) {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (info && info['file'] && info['file'].status === 'done') {
                var photoUUID = info['file'].response.data;
                if (photoUUID) {
                    var url = '/newStudent/saveStudentPhoto?xsid=' + userId + '&photoUUID=' + photoUUID + '&type=' + '10';
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])(url, 'POST').then(function (res) {
                        if (res && res.data) {
                            __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.success("上传成功!");
                        }
                    });
                }
            }
            _this.getBase64(info.file.originFileObj, function (imageUrl) {
                return _this.setState({ imageUrl: imageUrl });
            });
        };

        _this.onNHCascaderChange = function (value, selectedOptions, type) {
            var label = '';
            if (selectedOptions) {
                selectedOptions.forEach(function (i) {
                    label += i.label;
                });
            }
            if (type == 'jg') {
                _this.setState({ jgmStr: label });
            } else if (type == 'jt') {
                _this.setState({ jtStr: label });
            } else {

                _this.setState({ jtszdzmStr: label });
            }
        };

        _this.selectHczmc = function (value, option) {
            _this.setState({ hczmc: option });
        };

        _this.state = {
            jbxx: false,
            xsid: '',
            userInfoData: null,
            zzmmmList: [],
            mzmList: [],
            textData: '',
            jgmStr: '',
            jtStr: '',
            hczmc: '',
            // jtszdzmStr:'',
            xsSsInfo: ''
        };
        return _this;
    }

    _createClass(JbxxInitForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                this.getStudentPhotoBase64(userId, function (data) {
                    if (!data) return;
                    _this2.setState({
                        xsid: userId,
                        imageUrl: 'data:image/jpeg;base64,' + data
                    });
                });
            }
        }

        // 获取学生头像

    }, {
        key: 'getBase64',
        value: function getBase64(img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        }
        // 上传图片

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                form = _props.form,
                jbxxFormData = _props.jbxxFormData,
                getChildComponent = _props.getChildComponent,
                userInfoData = _props.userInfoData,
                stuSsxx = _props.stuSsxx,
                editXszp = _props.editXszp;
            var _state = this.state,
                jbxx = _state.jbxx,
                imageUrl = _state.imageUrl,
                tempUrl = _state.tempUrl,
                xsid = _state.xsid;

            var jtjddz = jbxxFormData ? jbxxFormData.jtjddz : '';
            var jtdzDetail = jbxxFormData ? jbxxFormData.jtdzDetail : '';
            var hczmc = jbxxFormData ? jbxxFormData.hczmc : '';
            var ssxx = '';
            if (stuSsxx && stuSsxx.xqmc && stuSsxx.ldmc && stuSsxx.fj && stuSsxx.cwh) {
                ssxx = stuSsxx.xqmc + stuSsxx.ldmc + ' - ' + stuSsxx.fj + ' - ' + stuSsxx.cwh;
            }
            return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a,
                { layout: 'inline' },
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u57FA\u672C\u4FE1\u606F',
                    onEdit: function onEdit(type) {
                        _this3.setState({
                            jbxx: true
                        });
                        getChildComponent(1, false);
                    },
                    onSave: function onSave(cb) {
                        _this3.onSavejbxxFormData(cb);
                        getChildComponent(1, true);
                    },
                    onClose: function onClose() {
                        _this3.setState({
                            jbxx: false
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + '_bg app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_icon'
                        },
                        jbxx && editXszp === "true" ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default.a,
                            {
                                name: 'photo',
                                accept: 'image/*',
                                showUploadList: false,
                                action: uploadUrl + "?xsid=" + xsid,
                                beforeUpload: beforeUpload,
                                onChange: this.handleUploadChange
                            },
                            imageUrl || userInfoData ? imageUrl ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
                                src: imageUrl,
                                alt: '',
                                className: 'jsx-1702183314' + ' ' + 'avatar'
                            }) : tempUrl : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__upload-box'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__upload-title'
                                    },
                                    '\u4E0A\u4F20\u56FE\u7247'
                                )
                            )
                        ) : imageUrl ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
                            src: imageUrl,
                            alt: '',
                            className: 'jsx-1702183314' + ' ' + 'avatar'
                        }) : tempUrl
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */].Item,
                        { className: 'ml-20' },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                                },
                                '\u59D3\u540D\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoHncs-__index__item-name'
                                },
                                userInfoData ? userInfoData.XM : '',
                                userInfoData && userInfoData.XB ? userInfoData.XB === '男' ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(141), alt: '', className: 'jsx-1702183314'
                                }) : userInfoData.XB === '女' ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(142), alt: '', className: 'jsx-1702183314'
                                }) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(143), alt: '', className: 'jsx-1702183314'
                                }) : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                                },
                                '\u5B66\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoHncs-__index__item-name'
                                },
                                userInfoData ? userInfoData.XH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                                },
                                '\u8003\u751F\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoHncs-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.ksh : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                                },
                                '\u8EAB\u4EFD\u8BC1\u4EF6\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoHncs-__index__item-name'
                                },
                                userInfoData ? userInfoData.SFZJH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                                },
                                '\u51FA\u751F\u5E74\u6708\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoHncs-__index__item-name'
                                },
                                userInfoData ? userInfoData.CSRQ : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                                },
                                '\u653F\u6CBB\u9762\u8C8C\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoHncs-__index__item-name'
                                },
                                userInfoData ? userInfoData.ZZMM : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                                },
                                '\u6C11\u65CF\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoHncs-__index__item-name'
                                },
                                userInfoData ? userInfoData.MZ : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                                },
                                '\u7C4D\u8D2F\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoHncs-__index__item-name'
                                },
                                userInfoData ? userInfoData.JG : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                                },
                                '\u6BD5\u4E1A\u5B66\u6821\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoHncs-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.byzx : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                                },
                                '\u9AD8\u8003\u5206\u6570\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoHncs-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.gkcj : ''
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    'div',
                    {
                        className: 'jsx-1702183314' + ' ' + 'p-swc'
                    },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                            },
                            '\u5B66\u9662\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoHncs-__index__item-name'
                            },
                            userInfoData ? userInfoData.BMMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                            },
                            '\u4E13\u4E1A\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoHncs-__index__item-name'
                            },
                            userInfoData ? userInfoData.ZYMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                            },
                            '\u73ED\u7EA7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoHncs-__index__item-name'
                            },
                            userInfoData ? userInfoData.BJMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item2'
                        },
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                            { id: 'sjhm',
                                label: __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                                    },
                                    '\u672C\u4EBA\u8054\u7CFB\u7535\u8BDD\uFF1A'
                                ),
                                colon: false,
                                form: form,
                                required: true
                                // hasFeedback={true} 
                                // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}
                                , pattern: __WEBPACK_IMPORTED_MODULE_20__utils_RegExp__["FormRules"].MOBILE_PHONE_NUMBER,
                                initialValue: jbxxFormData ? jbxxFormData.sjhm : ""
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u8054\u7CFB\u7535\u8BDD' })
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'red' }, className: 'jsx-1702183314'
                                    },
                                    '*'
                                ),
                                '\u672C\u4EBA\u8054\u7CFB\u7535\u8BDD\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoHncs-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.sjhm : ''
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item2'
                        },
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                            { id: 'x_hczm',
                                label: __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                                    },
                                    '\u5BB6\u5EAD\u6240\u5728\u5730\u7AD9\u540D'
                                ),
                                colon: false,
                                form: form,
                                required: true,
                                initialValue: jbxxFormData ? jbxxFormData.x_hczm : ''
                                // hasFeedback={true}
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_common_NHSelect__["a" /* default */], { style: { width: 140 }, sign: "zhxg_yxwz_xsxx_qghcz_select", placeholder: "请选择...", onSelect: this.selectHczmc })
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'red' }, className: 'jsx-1702183314'
                                    },
                                    '*'
                                ),
                                '\u5BB6\u5EAD\u6240\u5728\u5730\u7AD9\u540D\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoHncs-__index__item-name'
                                },
                                hczmc ? hczmc : ''
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                            },
                            '\u5BBF\u820D\u4FE1\u606F\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoHncs-__index__item-name'
                            },
                            ssxx
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item2'
                        },
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                            { id: 'yzbm',
                                label: __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                                    },
                                    '\u90AE\u653F\u7F16\u7801\uFF1A'
                                ),
                                colon: false,
                                form: form,
                                required: true,
                                initialValue: jbxxFormData ? jbxxFormData.yzbm : ""
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u90AE\u653F\u7F16\u7801' })
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'red' }, className: 'jsx-1702183314'
                                    },
                                    '*'
                                ),
                                '\u90AE\u653F\u7F16\u7801\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoHncs-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.yzbm : ''
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item3'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            { style: { lineHeight: '32px' }, className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                { style: { color: 'red' }, className: 'jsx-1702183314'
                                },
                                '*'
                            ),
                            '\u8BE6\u7EC6\u5BB6\u5EAD\u4F4F\u5740\uFF1A'
                        ),
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                            null,
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'jtszdqArray',
                                    label: '',
                                    colon: false,
                                    required: true,
                                    form: form,
                                    initialValue: jbxxFormData ? jbxxFormData.jtszdqArray : []
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_common_NHCascader__["a" /* default */], { style: { width: 432.63 }, sign: "zhxg_ssq", onChange: function onChange(value, selectedOptions) {
                                        return _this3.onNHCascaderChange(value, selectedOptions, 'jt');
                                    }

                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'jtjddz',
                                    label: '',
                                    colon: false,
                                    required: true,
                                    form: form,
                                    pattern: { max: 100, message: "家庭住址长度不能超过100字符！" },
                                    initialValue: jbxxFormData ? jbxxFormData.jtjddz : '' },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 346.07 }, placeholder: '\u8BF7\u586B\u5199\u8BE6\u7EC6\u5BB6\u5EAD\u5730\u5740\uFF0C\u5982\uFF1Axx\u8857\u9053\u3001xx\u5C0F\u533A\u3001\u95E8\u724C\u53F7' })
                            )
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoHncs-__index__item-name'
                            },
                            jtdzDetail ? jtdzDetail : '',
                            jtjddz ? jtjddz : ''
                        )
                    ),
                    userInfoData ? userInfoData.FDY && userInfoData.FDY.length > 0 ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                            },
                            '\u8F85\u5BFC\u5458\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoHncs-__index__item-name'
                            },
                            userInfoData.FDY.map(function (item, key) {
                                if (item) {
                                    var lxdh = item.LXDH ? "( " + item.LXDH + " )" : "";
                                    return item.XM + lxdh + " ";
                                } else {
                                    return "";
                                }
                            })
                        )
                    ) : null : null,
                    userInfoData ? userInfoData.BZR && userInfoData.BZR.length > 0 ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label'
                            },
                            '\u73ED\u4E3B\u4EFB\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-infoHncs-__index__item-name'
                            },
                            userInfoData.BZR.map(function (item, key) {
                                if (item) {
                                    var lxdh = item.LXDH ? "( " + item.LXDH + " )" : "";
                                    return item.XM + lxdh + " ";
                                } else {
                                    return "";
                                }
                            })
                        )
                    ) : null : null
                ),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_styled_jsx_style___default.a, {
                    styleId: '1702183314',
                    css: ['.ant-col-md-7{width:100px;}']
                })
            );
        }
    }]);

    return JbxxInitForm;
}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);

var JbxxForm = __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a.create()(JbxxInitForm);

/* harmony default export */ __webpack_exports__["a"] = (JbxxForm);

/***/ }),

/***/ 1063:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__utils_RegExp__);



















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }










if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;

var JtcyForm = function (_React$Component) {
    _inherits(JtcyForm, _React$Component);

    function JtcyForm(props) {
        _classCallCheck(this, JtcyForm);

        var _this = _possibleConstructorReturn(this, (JtcyForm.__proto__ || __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default()(JtcyForm)).call(this, props));

        _this.cacheJtcyData = function (cb) {
            _this.props.form.validateFields(function (err, values) {
                if (err) {
                    __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default.a.info('请检查家庭成员是否正确填写');
                    cb(false);
                    return;
                }
                // 判断数据是否全部填写
                var errorPhone = "";
                var errorList = [];
                var dataList = [];
                if (_this.state.jtcyData && _this.state.jtcyData.length > 0) {
                    for (var i = 0; i < _this.state.jtcyData.length; i++) {
                        var data = _this.state.jtcyData[i];
                        var pattern = /^1\d{10}$/;
                        if (data.lxfs) {
                            if (!pattern.test(data.lxfs)) {
                                if (errorList.length == 0) {
                                    errorPhone += data.lxfs;
                                } else {
                                    errorPhone += "," + data.lxfs;
                                }
                                errorList.push(data);
                            }
                        }
                        if (!data.gx && !data.xm && !data.gzxxdw && !data.lxfs && !data.operation) {} else {
                            dataList.push(data);
                        }
                    }
                }
                if (errorList && errorList.length > 0) {
                    __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default.a.error(errorPhone + '\u53F7\u7801\u586B\u5199\u9519\u8BEF');
                    return;
                }
                _this.setState({
                    jtcy: false,
                    jtcyAdd: false
                });

                var _this$props = _this.props,
                    cacheFormData = _this$props.cacheFormData,
                    getChildComponent = _this$props.getChildComponent;

                getChildComponent(3, true);
                cacheFormData('jtcy', dataList, true);
                cb(true);
            });
        };

        _this.onjtcyAdd = function () {
            var _this$state = _this.state,
                jtcyAdd = _this$state.jtcyAdd,
                jtcyData = _this$state.jtcyData;

            if (!jtcyData) {
                jtcyData = [];
            }
            if (jtcyAdd) {
                jtcyData.push({
                    key: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["c" /* createUuid */])(),
                    gx: '',
                    xm: '',
                    gzxxdw: '',
                    zzmmm: '',
                    lxfs: '',
                    operation: ''
                });

                _this.setState({
                    jtcyData: jtcyData
                });
            }
            _this.setState({
                jtcyAdd: true
            });
        };

        _this.onjtcySave = function () {
            var jtcyData = _this.state.jtcyData;

            jtcyData.push();
            _this.setState({
                jtcyData: jtcyData,
                jtcyAdd: false
            });
        };

        _this.onjtcyClose = function (index) {
            var jtcyData = _this.state.jtcyData;

            jtcyData.splice(index, 1);
            _this.setState({
                jtcyData: jtcyData,
                jtcyAdd: true
            });
        };

        _this.handleChange = function (value, index, key) {
            var jtcyData = _this.state.jtcyData;
            jtcyData[index][key] = value;
            _this.setState({ jtcyData: jtcyData });
        };

        _this.validateCustom = function () {
            var _this$state2 = _this.state,
                jtcy = _this$state2.jtcy,
                formInitData = _this$state2.formInitData;

            if (jtcy) {
                // 若是编辑模式 使用表单验证
                _this.props.form.validateFields(function (err, values) {
                    if (err) {
                        return false;
                    }
                    return true;
                });
            } else {
                return true;
            }
        };

        _this.validateFields = function (func) {
            var err = false;
            var formData = _this.state.data;
            func(err, formData);
        };

        _this.deepCopy = function (obj) {
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                return obj;
            }

            if (_this.isArrayFn(obj)) {
                var newobj = [];
                for (var i = 0; i < obj.length; i++) {
                    newobj.push(_this.deepCopy(obj[i]));
                }
                return newobj;
            } else {
                var _newobj = {};
                for (var attr in obj) {
                    _newobj[attr] = _this.deepCopy(obj[attr]);
                }
                return _newobj;
            }
        };

        _this.isArrayFn = function (value) {
            if (typeof Array.isArray === "function") {
                return Array.isArray(value);
            } else {
                return Object.prototype.toString.call(value) === "[object Array]";
            }
        };

        _this.state = {
            jtcy: false,
            jtcyAdd: false,
            jtcyData: [],
            zzmmmList: [],
            tempStr: '',
            jtcyList: [] //家庭成员数据加载
        };
        return _this;
    }

    _createClass(JtcyForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])('/proData/selectDataList?&sign=DMK_XSXX_JTCYGX', 'GET').then(function (res) {
                if (res && res.data) {
                    var jtcyList = [];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default()(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var obj = _step.value;

                            jtcyList.push({ 'label': obj.LABEL, 'value': obj.VALUE });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this2.setState({ jtcyList: jtcyList });
                }
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('jtcyInitData' in nextProps && nextProps.jtcyInitData) {
                if (nextProps.jtcyInitData instanceof Array) {
                    var temp = [].concat(_toConsumableArray(nextProps.jtcyInitData));
                    this.setState({ jtcyData: temp });
                }
            }
        }

        // 家庭成员 添加

        // 家庭成员 保存添加

        // 家庭成员 关闭添加


        /** 验证必填项 */

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _state = this.state,
                jtcy = _state.jtcy,
                jtcyAdd = _state.jtcyAdd,
                jtcyData = _state.jtcyData,
                jtcyList = _state.jtcyList;
            var getChildComponent = this.props.getChildComponent;
            var getFieldDecorator = this.props.form.getFieldDecorator;

            var formStyle = {
                margin: 0
            };
            var jtcyTransalate = {}; //家庭成员翻译
            for (var i = 0; i < jtcyList.length; i++) {
                jtcyTransalate[jtcyList[i].value] = jtcyList[i].label;
            }
            var jtcyColumns = [{
                title: '关系',
                key: 'gx',
                dataIndex: 'gx',
                render: function render(text, record, index) {
                    return jtcy ?

                    // <Input
                    //     value={text}
                    //     required={true}
                    //     onChange={(e) =>{this.handleChange(e.target.value,index,'gx')}}
                    //     style={{ width: 100 }}
                    //     placeholder="请填写关系"
                    // />
                    __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_common_NHSelect__["a" /* default */], { style: { width: 140 }, sign: 'DMK_XSXX_JTCYGX',
                        value: text,
                        onChange: function onChange(value) {
                            _this3.handleChange(value, index, 'gx');
                        }

                    })
                    // <NHFormItem id={'gx'} label={''} form={form} required={true}
                    //     pattern={{max:5, message: "关系长度不能超过5字符！"}}
                    //     initialValue={text}>
                    // <Input onChange={(e) =>{this.handleChange(e.target.value,index,'gx')}}
                    //        placeholder="请填写关系"/>
                    // </NHFormItem>
                    : jtcyTransalate[text];
                }
            }, {
                title: '姓名',
                dataIndex: 'xm',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'xm');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u59D3\u540D'
                    }) : text;
                }
            },
            // {
            //     title: '政治面貌',
            //     dataIndex: 'zzmmm',
            //     render: (text, record,index) => {
            //         //let tempStr = '';
            //         return(
            //             jtcy ?
            //             <NHSelect disabled = {jtcy ? false : true} style={{ width: 140 }} sign="DMK_XTGL_ZZMMM"
            //             value={text}
            //             onChange={(value) =>{this.handleChange(value,index,'zzmmm')}}

            //             />
            //             :
            //             (this.getzzmmmStr(text))
            //         );
            //     }
            // },
            {
                title: '工作单位及职务',
                dataIndex: 'gzxxdw',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'gzxxdw');
                        },
                        style: { width: 140 },
                        placeholder: '\u8BF7\u586B\u5199\u5355\u4F4D\u548C\u804C\u52A1'
                    }) : text;
                }
            },
            // {
            //     title: '联系电话',
            //     dataIndex: 'lxfs',
            //     render: (text, record,index) => {
            //         return jtcy ? (
            //             <Input
            //                 value={text}
            //                 onChange={(e) =>{this.handleChange(e.target.value,index,'lxfs')}}
            //                 style={{ width: 100 }}
            //                 placeholder="请填写电话"
            //                 onBlur={(e) =>{this.inputOnBlur(e.target.value)}}
            //             />
            //         ) : (
            //             text
            //         );
            //     }
            // },
            {
                title: '联系电话',
                dataIndex: 'lxfs',
                render: function render(text, record, index) {
                    return jtcy ?
                    /* <Form.Item style={formStyle}>
                        {getFieldDecorator(`list.${index}.lxfs`, {
                            initialValue: text,
                            rules: [
                                { required: true, message: '请输入联系电话' },
                                FormRules.MOBILE_PHONE_NUMBER
                            ]
                        })( */
                    __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        maxLength: 11,
                        placeholder: '\u8BF7\u586B\u5199\u7535\u8BDD',
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'lxfs');
                        }
                    })
                    /*    )}
                    </Form.Item> */

                    : text;
                }
            }, {
                title: 'QQ',
                dataIndex: 'qq',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'qq');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586BQQ\u53F7'
                    }) : text;
                }
            }, {
                title: '微信',
                dataIndex: 'wx',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'wx');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5FAE\u4FE1\u53F7'
                    }) : text;
                }
            }, {
                title: '删除',
                dataIndex: 'operation',
                width: 80,
                render: function render(text, record, index) {
                    if (jtcy) {
                        return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                            'div',
                            { className: 'editable-row-operations' },
                            __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                                'a',
                                {
                                    href: 'javascript:;',
                                    onClick: function onClick() {
                                        return _this3.onjtcyClose(index);
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, {
                                    type: 'close',
                                    style: { color: 'red' }
                                })
                            )
                        );
                    }
                    return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                        'a',
                        { href: 'javascript:;', onClick: function onClick() {
                                return _this3.onjtcyClose();
                            } },
                        __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'delete', style: { color: 'red' } })
                    );
                }
            }];
            if (!jtcy) {
                jtcyColumns.pop();
            }
            return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u5BB6\u5EAD\u6210\u5458\u4FE1\u606F',
                    onEdit: function onEdit(type) {
                        _this3.setState({
                            jtcy: true,
                            jtcyAdd: true,
                            cacheData: _this3.deepCopy(_this3.state.jtcyData)
                        });
                        getChildComponent(3, false);
                    },
                    onSave: function onSave(cb) {
                        _this3.cacheJtcyData(cb);
                    },
                    onClose: function onClose() {
                        _this3.setState({
                            jtcy: false,
                            jtcyAdd: false,
                            jtcyData: _this3.deepCopy(_this3.state.cacheData)
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a,
                    null,
                    __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                        'div',
                        { className: 'p-sw' },
                        __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a, {
                            bordered: true,
                            size: 'middle',
                            pagination: false,
                            dataSource: jtcyData,
                            columns: jtcyColumns
                        }),
                        jtcyAdd && __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                            'div',
                            {
                                className: 'mt-10 app__css__app-pages-SelfHelp-infoHncs-__index__btn_add',

                                onClick: function onClick() {

                                    _this3.onjtcyAdd();
                                }
                            },
                            '\u6DFB\u52A0\u5BB6\u5EAD\u6210\u5458'
                        )
                    )
                )
            );
        }
    }]);

    return JtcyForm;
}(__WEBPACK_IMPORTED_MODULE_18_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create()(JtcyForm));

/***/ }),

/***/ 1064:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_date_picker_style__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_date_picker__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__utils_RegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__index_css__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_common_NHFormItem_index__ = __webpack_require__(43);




















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }














if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var RangePicker = __WEBPACK_IMPORTED_MODULE_18_antd_lib_date_picker___default.a.RangePicker;

var dateFormat = 'YYYY/MM/DD ';

var JyjlForm = function (_React$Component) {
    _inherits(JyjlForm, _React$Component);

    function JyjlForm(props) {
        _classCallCheck(this, JyjlForm);

        var _this = _possibleConstructorReturn(this, (JyjlForm.__proto__ || __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_get_prototype_of___default()(JyjlForm)).call(this, props));

        _this.cacheJyjlData = function (cb) {
            _this.props.form.validateFields(function (err, values) {
                if (err) {
                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.info('请检查教育经历是否正确填写');
                    cb(false);
                    return;
                }
                //判断数据是否全部填写
                var errorPhone = "";
                var errorList = [];
                var dataList = [];
                if (_this.state.jyjlData && _this.state.jyjlData.length > 0) {
                    for (var i = 0; i < _this.state.jyjlData.length; i++) {
                        var data = _this.state.jyjlData[i];
                        var pattern = /^1\d{10}$/;
                        if (data.zmrlxfs) {
                            if (!pattern.test(data.zmrlxfs)) {
                                if (errorList.length == 0) {
                                    errorPhone += data.zmrlxfs;
                                } else {
                                    errorPhone += "," + data.zmrlxfs;
                                }
                                errorList.push(data);
                            }
                        }
                        if (!data.qsny && !data.xxjl && !data.zw && !data.zmr && !data.zmrlxfs && !data.operation) {} else {
                            dataList.push(data);
                        }
                    }
                }
                if (errorList && errorList.length > 0) {
                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error(errorPhone + '\u53F7\u7801\u586B\u5199\u9519\u8BEF');
                    return;
                }
                _this.setState({
                    jyjl: false,
                    jyjlAdd: false
                });
                var _this$props = _this.props,
                    cacheFormData = _this$props.cacheFormData,
                    getChildComponent = _this$props.getChildComponent;

                getChildComponent(4, true);
                cacheFormData('jyjl', dataList, true);
                cb(true);
            });
        };

        _this.validateFields = function (func) {
            var err = false;
            var formData = _this.state.jyjlData;
            func(err, formData);
        };

        _this.onjyjlAdd = function () {
            var _this$state = _this.state,
                jyjlAdd = _this$state.jyjlAdd,
                jyjlData = _this$state.jyjlData;

            if (!jyjlData) {
                jyjlData = [];
            }
            if (jyjlAdd) {
                jyjlData.push({
                    key: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["c" /* createUuid */])(),
                    qsny: '',
                    xxjl: '',
                    zw: '',
                    zmr: '',
                    zmrlxfs: '',
                    operation: ''
                });
                _this.setState({
                    jyjlData: jyjlData
                });
            }
            _this.setState({
                jyjlAdd: true
            });
        };

        _this.onjyjlSave = function () {
            var jyjlData = _this.state.jyjlData;

            jyjlData.push();
            _this.setState({
                jyjlData: jyjlData,
                jyjlAdd: false
            });
        };

        _this.onjyjlClose = function (index) {
            var jyjlData = _this.state.jyjlData;

            jyjlData.splice(index, 1);
            _this.setState({
                jyjlData: jyjlData,
                jyjlAdd: true
            });
        };

        _this.handleChange = function (value, index, key) {
            var jyjlData = _this.state.jyjlData;
            jyjlData[index][key] = value;
            _this.setState({ jyjlData: jyjlData });
        };

        _this.handleDateChange = function (value, index) {

            var jyjlData = _this.state.jyjlData;
            var kssj = value[0] ? __WEBPACK_IMPORTED_MODULE_22_moment___default()(value[0]).format(dateFormat) : undefined;
            var jssj = value[1] ? __WEBPACK_IMPORTED_MODULE_22_moment___default()(value[1]).format(dateFormat) : undefined;
            jyjlData[index]['kssj'] = kssj;
            jyjlData[index]['jssj'] = jssj;
            _this.setState({ jyjlData: jyjlData });
        };

        _this.deepCopy = function (obj) {
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                return obj;
            }

            if (_this.isArrayFn(obj)) {
                var newobj = [];
                for (var i = 0; i < obj.length; i++) {
                    newobj.push(_this.deepCopy(obj[i]));
                }
                return newobj;
            } else {
                var _newobj = {};
                for (var attr in obj) {
                    _newobj[attr] = _this.deepCopy(obj[attr]);
                }
                return _newobj;
            }
        };

        _this.isArrayFn = function (value) {
            if (typeof Array.isArray === "function") {
                return Array.isArray(value);
            } else {
                return Object.prototype.toString.call(value) === "[object Array]";
            }
        };

        _this.validateCustom = function () {
            var _this$state2 = _this.state,
                jtcy = _this$state2.jtcy,
                formInitData = _this$state2.formInitData;

            if (jtcy) {
                // 若是编辑模式 使用表单验证
                _this.props.form.validateFields(function (err, values) {
                    if (err) {
                        return false;
                    }
                    return true;
                });
            } else {
                return true;
            }
        };

        _this.validateFields = function (func) {
            var err = false;
            var formData = _this.state.data;
            func(err, formData);
        };

        _this.state = {
            jyjl: false,
            jyjlAdd: false,
            jyjlData: []
        };
        return _this;
    }

    _createClass(JyjlForm, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('jyjlInitData' in nextProps && nextProps.jyjlInitData) {
                if (nextProps.jyjlInitData instanceof Array) {
                    var temp = [].concat(_toConsumableArray(nextProps.jyjlInitData));
                    this.setState({ jyjlData: temp });
                }
            }
        }
    }, {
        key: 'disabledDate',
        value: function disabledDate(current) {
            // Can not select days after today and today
            return current && current > __WEBPACK_IMPORTED_MODULE_22_moment___default()().endOf('day');
        }

        /** 验证必填项 */

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                initJtcyData = _props.initJtcyData,
                getChildComponent = _props.getChildComponent;
            var _state = this.state,
                jyjl = _state.jyjl,
                jyjlData = _state.jyjlData,
                jyjlAdd = _state.jyjlAdd;

            var formStyle = {
                margin: 0
            };
            var getFieldDecorator = this.props.form.getFieldDecorator;

            var jyjlColumns = [{
                title: '起始年月',
                dataIndex: 'qsny',
                render: function render(text, record, index) {
                    var kssj = record.kssj;
                    var jssj = record.jssj;
                    return jyjl ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(RangePicker
                    // disabledDate={this.disabledDate}
                    , { value: kssj && jssj ? [__WEBPACK_IMPORTED_MODULE_22_moment___default()(kssj, dateFormat), __WEBPACK_IMPORTED_MODULE_22_moment___default()(jssj, dateFormat)] : undefined,
                        format: dateFormat,
                        onChange: function onChange(value) {
                            _this2.handleDateChange(value, index);
                        }
                    }) : (kssj ? kssj : '') + ' ~ ' + (jssj ? jssj : '');
                }
            }, {
                title: '在何地何学校',
                dataIndex: 'xxjl',
                render: function render(text, record, index) {
                    return jyjl ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this2.handleChange(e.target.value, index, 'xxjl');
                        },
                        style: { width: 140 },
                        placeholder: '\u8BF7\u586B\u5199\u5B66\u6821'
                    }) : text;
                }
            },
            // {
            //     title: '任何职',
            //     dataIndex: 'zw',
            //     render: (text, record,index) => {
            //         return jyjl ? (
            //             <Input     
            //                 value={text}
            //                 onChange={(e) =>{this.handleChange(e.target.value,index,'zw')}}         
            //                 style={{ width: 100 }}
            //                 placeholder="请填写职位"
            //             />
            //         ) : (
            //             text
            //         );
            //     }
            // },
            {
                title: '证明人',
                dataIndex: 'zmr',
                render: function render(text, record, index) {
                    return jyjl ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this2.handleChange(e.target.value, index, 'zmr');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u8BC1\u660E\u4EBA'
                    }) : text;
                }
            },
            // {
            //     title: '证明人联系电话',
            //     dataIndex: 'zmrlxfs',
            //     render: (text, record,index) => {
            //         return jyjl ? (
            //             <Input     
            //                 value={text}
            //                 onChange={(e) =>{this.handleChange(e.target.value,index,'zmrlxfs')}}         
            //                 style={{ width: 100 }}
            //                 placeholder="请填写电话"
            //             />
            //         ) : (
            //             text
            //         );
            //     }
            // }, 
            {
                title: '证明人联系电话',
                dataIndex: 'zmrlxfs',
                render: function render(text, record, index) {
                    return jyjl ?
                    // <Form.Item style={formStyle}>
                    //     {getFieldDecorator(`list.${index}.zmrlxfs`, {
                    //         initialValue: text,
                    //         rules: [
                    //             { required: true, message: '请输入联系电话' },
                    //             FormRules.MOBILE_PHONE_NUMBER
                    //         ]
                    //     })(
                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, {
                        value: text,
                        maxLength: 11,
                        placeholder: '\u8BF7\u586B\u5199\u7535\u8BDD',
                        onChange: function onChange(e) {
                            _this2.handleChange(e.target.value, index, 'zmrlxfs');
                        }
                    })
                    /*     )}
                    </Form.Item> */

                    : text;
                }
            }, {
                title: '删除',
                dataIndex: 'operation',
                width: 80,
                render: function render(text, record, index) {
                    if (jyjl) {
                        return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                            'div',
                            { className: 'editable-row-operations' },
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                'a',
                                {
                                    href: 'javascript:;',
                                    onClick: function onClick() {
                                        return _this2.onjyjlClose(index);
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, {
                                    type: 'close',
                                    style: { color: 'red' }
                                })
                            )
                        );
                    }
                    return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                        'a',
                        { href: '#' },
                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, { type: 'delete', style: { color: 'red' } })
                    );
                }
            }];

            if (!jyjl) {
                jyjlColumns.pop();
            }
            return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u6559\u80B2\u7ECF\u5386\u4FE1\u606F',
                    onEdit: function onEdit(type) {
                        _this2.setState({
                            jyjl: true,
                            jyjlAdd: true,
                            cacheData: _this2.deepCopy(_this2.state.jyjlData)
                        });
                        getChildComponent(4, false);
                    },
                    onSave: function onSave(cb) {
                        _this2.cacheJyjlData(cb);
                    },
                    onClose: function onClose() {
                        _this2.setState({
                            jyjl: false,
                            jyjlAdd: false,
                            jyjlData: _this2.deepCopy(_this2.state.cacheData)
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_table___default.a, {
                        bordered: true,
                        size: 'middle',
                        pagination: false,
                        dataSource: jyjlData,
                        columns: jyjlColumns
                    }),
                    jyjlAdd && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                        'div',
                        {
                            className: 'mt-10 app__css__app-pages-SelfHelp-infoHncs-__index__btn_add',

                            onClick: function onClick() {

                                _this2.onjyjlAdd();
                            }
                        },
                        '\u6DFB\u52A0\u6559\u80B2\u7ECF\u5386'
                    )
                )
            );
        }
    }]);

    return JyjlForm;
}(__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(JyjlForm));

/***/ }),

/***/ 1065:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_custom_scrollbars__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_custom_scrollbars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_common_NHFormItem_FormRules__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__index_css__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components__ = __webpack_require__(10);



















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _extends = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _styleModuleImportMap = {
    './index.css': {
        'progress': 'app__css__app-pages-SelfHelp-infoHncs-__index__progress',
        'jbxx_icon': 'app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_icon',
        'upload-box': 'app__css__app-pages-SelfHelp-infoHncs-__index__upload-box',
        'upload-title': 'app__css__app-pages-SelfHelp-infoHncs-__index__upload-title',
        'jbxx_item': 'app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item',
        'jbxx_item2': 'app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item2',
        'jbxx_item3': 'app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item3',
        'item-label': 'app__css__app-pages-SelfHelp-infoHncs-__index__item-label',
        'item-name': 'app__css__app-pages-SelfHelp-infoHncs-__index__item-name',
        'kzxx_list': 'app__css__app-pages-SelfHelp-infoHncs-__index__kzxx_list',
        'kzxx_item': 'app__css__app-pages-SelfHelp-infoHncs-__index__kzxx_item',
        'kzxx_label': 'app__css__app-pages-SelfHelp-infoHncs-__index__kzxx_label',
        'kzxx_name': 'app__css__app-pages-SelfHelp-infoHncs-__index__kzxx_name',
        'kzxx_item_textarea': 'app__css__app-pages-SelfHelp-infoHncs-__index__kzxx_item_textarea',
        'kzxx_name_textarea': 'app__css__app-pages-SelfHelp-infoHncs-__index__kzxx_name_textarea',
        'btn_add': 'app__css__app-pages-SelfHelp-infoHncs-__index__btn_add',
        'title_top': 'app__css__app-pages-SelfHelp-infoHncs-__index__title_top',
        'title_top_name': 'app__css__app-pages-SelfHelp-infoHncs-__index__title_top_name',
        'line': 'app__css__app-pages-SelfHelp-infoHncs-__index__line',
        'detail_adrress': 'app__css__app-pages-SelfHelp-infoHncs-__index__detail_adrress'
    }
};

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }


















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;
var basicUrl = "/zzbd";
var stuInfoUrl = "/xxcj/";

//日期格式化
var dateFormat = 'YYYY-MM-DD';

var KzxxFormComponent = function (_React$Component) {
    _inherits(KzxxFormComponent, _React$Component);

    function KzxxFormComponent(props) {
        _classCallCheck(this, KzxxFormComponent);

        var _this = _possibleConstructorReturn(this, (KzxxFormComponent.__proto__ || __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default()(KzxxFormComponent)).call(this, props));

        _this.onSaveKzxx = function (cb) {
            _this.props.form.validateFields(function (error, values) {
                if (error) {
                    return;
                }
                _this.setState({
                    formData: _extends({}, values),
                    kzxx: false
                });
                var _this$props = _this.props,
                    cacheFormData = _this$props.cacheFormData,
                    getChildComponent = _this$props.getChildComponent;

                getChildComponent(2, true);
                __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys___default()(values).forEach(function (key) {
                    if (values[key] != null && values[key] != undefined) {
                        if (values[key].constructor.name == 'Moment') {//处理Moment格式的数据  
                            //values[key] = moment(values[key]).format(dateFormat); 
                        } else if (values[key].constructor.name == 'Array') {
                            if (_typeof(values[key]) === 'object') {
                                var isFileUpload = false;
                                var array = [];
                                var _iteratorNormalCompletion = true;
                                var _didIteratorError = false;
                                var _iteratorError = undefined;

                                try {
                                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(values[key]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                        var item = _step.value;

                                        if (item.hasOwnProperty('uuid') && item['uuid']) {
                                            isFileUpload = true;
                                            array.push(item['uuid']);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return) {
                                            _iterator.return();
                                        }
                                    } finally {
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }

                                if (isFileUpload) {
                                    values[key] = array.join(',');
                                } else {
                                    values[key] = values[key].join(',');
                                }
                            } else {
                                values[key] = values[key].join(',');
                            }
                        }
                    } else {
                        values[key] = '';
                    }
                });

                var postData = {
                    'xxcj': { 'xsid': _this.props.xsid, 'formData': _extends({}, values) },
                    'params': { 'zzbdhjid': _this.props.zzbdhjid, 'xsid': _this.props.xsid }
                };

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])('/newStudent/updateStuInfo', 'POST', postData).then(function (res) {
                    if (res && res.code == 200) {
                        __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.success("保存成功");
                        cb(true);
                        _this.props.reloadMenu();
                    } else {
                        __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error("保存失败");
                    }
                });
            });
        };

        _this.onChange = function (date, dateString) {}
        // console.log('date', date)
        // console.log('dateString', dateString)
        // if(date && dateString){
        //     //this.
        // }


        //获取下拉列表value对应的名称
        ;

        _this.getDmkMc = function (dmbz, zdbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])("/proData/selectDataList", "GET", { sign: dmbz }).then(function (res) {
                if (res) {
                    if (res.data) {
                        var dmkmcList = _this.state.dmkmcList;
                        dmkmcList[zdbz] = res.data;
                        _this.setState({
                            dmkmcList: dmkmcList
                        });
                    }
                }
            });
        };

        _this.getCascaderDmkMc = function (level, sign, cascaderValue, zdbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])("/proData/selectCascaderList", "GET", { level: level, sign: sign, cascaderValue: cascaderValue }).then(function (res) {
                if (res) {
                    if (res.data) {
                        var dmkmcList = _this.state.dmkmcList;
                        dmkmcList[level + zdbz] = res.data;
                        _this.setState({
                            dmkmcList: dmkmcList
                        });
                    }
                }
            });
        };

        _this.handlePreview = function (fjmc, fjid) {

            if (fjmc === "isImage") {
                _this.showPreview('anonymity/docrepo/download/file?attachmentId=' + fjid);
            } else {
                window.open('anonymity/docrepo/download/file?attachmentId=' + fjid);
            }
        };

        _this.showPreview = function (url) {
            _this.setState({
                previewImage: url,
                previewVisible: true
            });
        };

        _this.closeModal = function () {
            return _this.setState({ previewVisible: false });
        };

        _this.fileLists = function (fileLists) {
            {
                var items = [];

                var _loop = function _loop(key) {
                    var fileList = typeof fileLists[key] == 'string' ? fileLists[key].split(";") : fileLists[key];
                    items.push(__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                            'a',
                            { onClick: function onClick() {
                                    _this.handlePreview("file", fileList[0]);
                                } },
                            fileList[1]
                        )
                    ));
                };

                for (var key in fileLists) {
                    _loop(key);
                }
                return items;
            }
        };

        _this.imageLists = function (imageLists) {
            {
                var items = [];

                var _loop2 = function _loop2(key) {
                    var imageList = typeof imageLists[key] == 'string' ? imageLists[key].split(";") : imageLists[key];
                    items.push(__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        'span',
                        null,
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('img', { style: { height: "80px", width: "80px" }, src: "anonymity/docrepo/download/file?attachmentId=" + imageList,
                            onClick: function onClick() {
                                _this.handlePreview("isImage", imageList[0]);
                            } })
                    ));
                };

                for (var key in imageLists) {
                    _loop2(key);
                }
                return items;
            }
        };

        _this.state = {
            xsid: '',
            kzxx: false,
            scrollHeight: 0, //默认滚动高度
            initData: {}, //初始数据
            loading: false, //页面加载状态
            onSubmit: false, //保存按钮加载状态
            isShow: false,
            previewVisible: false,
            formData: '',
            dmkmcList: {},
            zdzmc: ''
        };
        return _this;
    }

    //控件回调

    //获取联级下拉列表value对应的名称

    // 点击文件链接或预览图标时的回调


    //打开图片弹窗

    // 关闭图片弹窗

    // 文件展示 

    //图片展示


    _createClass(KzxxFormComponent, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                form = _props.form,
                getChildComponent = _props.getChildComponent,
                initData = _props.initData;
            var _state = this.state,
                kzxx = _state.kzxx,
                formData = _state.formData,
                previewVisible = _state.previewVisible,
                previewImage = _state.previewImage;
            //提示信息

            var AlertParams = {
                message: '当前没有需要填写的信息',
                description: '',
                type: 'info'
                //信息采集字段分类
            };var infoItems = [];
            var reactid = 0;
            if (initData) {
                //表单信息、表单字段信息
                var _initData$zdglVOs = initData.zdglVOs,
                    zdglVOs = _initData$zdglVOs === undefined ? [] : _initData$zdglVOs;

                if (zdglVOs != null) {
                    if (zdglVOs.length > 0) {
                        var array = [];
                        //循环过滤出多行文本框的key，偶数在左，奇数在右，相应的同行的另一条文本也需要加宽
                        for (var key in zdglVOs) {
                            var kjcs = zdglVOs[key].kjcs;

                            var kjcsjson = JSON.parse(kjcs);
                            if (kjcsjson.type === "textarea" || kjcsjson.type === "oldupload" || kjcsjson.type === "upload") {
                                if (key % 2 === 0) {
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key));
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key) + 1);
                                } else {
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key));
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key) - 1);
                                }
                            }
                        }
                        //显示表单字段信息

                        var _loop3 = function _loop3(_key) {
                            //字段状态、是否必填、默认值、字段标识、字段名称、控件参数、字段值
                            var _zdglVOs$_key = zdglVOs[_key],
                                zdbz = _zdglVOs$_key.zdbz,
                                zdmc = _zdglVOs$_key.zdmc,
                                kjcs = _zdglVOs$_key.kjcs,
                                zdz = _zdglVOs$_key.zdz,
                                sfbt = _zdglVOs$_key.sfbt,
                                mrz = _zdglVOs$_key.mrz,
                                zdzt = _zdglVOs$_key.zdzt; //表单字段

                            var zdzmc = '';
                            var kjcsjson = JSON.parse(kjcs);
                            if (formData && formData[zdbz] != null) {
                                zdz = formData[zdbz];
                            }
                            if (kjcsjson.type === 'datepicker' || kjcsjson.type === 'datetimepicker' || kjcsjson.type === 'timepicker' || kjcsjson.type === 'monthpicker' || kjcsjson.type === 'rangepicker') {
                                //日期值展示阶段，从moment转为文字 
                                if (zdz) {
                                    zdzmc = __WEBPACK_IMPORTED_MODULE_27_moment___default()(zdz).format(kjcsjson.format);
                                }
                            } else if (kjcsjson.type === "select") {
                                if (kjcsjson.dataTag && !_this2.state.dmkmcList[zdbz]) {
                                    _this2.getDmkMc(kjcsjson.dataTag, zdbz);
                                }
                                var list = _this2.state.dmkmcList[zdbz];
                                list && list.map(function (item) {
                                    if (item.VALUE === zdz) {
                                        zdzmc = item.LABEL;
                                    }
                                });
                            } else if (kjcsjson.type === "multiselect") {
                                if (kjcsjson.dataTag && !_this2.state.dmkmcList[zdbz]) {
                                    _this2.getDmkMc(kjcsjson.dataTag, zdbz);
                                }
                                var _list = _this2.state.dmkmcList[zdbz];
                                if (zdz) {
                                    (function () {
                                        var multiselect = typeof zdz == 'string' ? zdz.split(",") : zdz;
                                        var multiselectList = [];

                                        var _loop4 = function _loop4(i) {
                                            _list && _list.map(function (item) {
                                                if (item.VALUE === multiselect[i]) {
                                                    multiselectList.push(item.LABEL);
                                                }
                                            });
                                        };

                                        for (var i in multiselect) {
                                            _loop4(i);
                                        }
                                        zdzmc = multiselectList.join(",");
                                    })();
                                }
                            } else if (kjcsjson.type === "nhcascader") {
                                if (zdz) {
                                    (function () {
                                        var nhcascaderList = typeof zdz == 'string' ? zdz.split(",") : zdz;
                                        var nhcascaderLists = [];

                                        var _loop5 = function _loop5(i) {
                                            var level = i;
                                            var c = i;
                                            var d = i;
                                            var a = ++level;
                                            var b = --d;
                                            if (kjcsjson.dataTag && !_this2.state.dmkmcList[a + zdbz]) {
                                                if (i == "0") {
                                                    _this2.getCascaderDmkMc(a, kjcsjson.dataTag, '', zdbz);
                                                } else {
                                                    _this2.getCascaderDmkMc(a, kjcsjson.dataTag, nhcascaderList[b], zdbz);
                                                }
                                            }
                                            var list = _this2.state.dmkmcList[level++ + zdbz];

                                            list && list.map(function (item) {
                                                if (item.value === nhcascaderList[c]) {
                                                    nhcascaderLists.push(item.label);
                                                }
                                            });
                                        };

                                        for (var i in nhcascaderList) {
                                            _loop5(i);
                                        }
                                        zdzmc = nhcascaderLists.join("/");
                                    })();
                                }
                            } else if (kjcsjson.type === "switch") {
                                zdzmc = zdz === "1" || zdz === true ? kjcsjson.checkedText : kjcsjson.uncheckedText;
                            } else if (kjcsjson.type === "radio") {
                                kjcsjson.options && kjcsjson.options.map(function (item, key) {
                                    if (item.value === zdz) {
                                        zdzmc = item.label;
                                    }
                                });
                            } else if (kjcsjson.fileType === "file" && zdz) {
                                var fileLists = typeof zdz == 'string' ? zdz.split(",") : zdz;
                                zdzmc = _this2.fileLists(fileLists);
                            } else if (kjcsjson.fileType === "image" && zdz) {
                                if ((typeof zdz === 'undefined' ? 'undefined' : _typeof(zdz)) === 'object') {
                                    var _array = [];
                                    var _iteratorNormalCompletion2 = true;
                                    var _didIteratorError2 = false;
                                    var _iteratorError2 = undefined;

                                    try {
                                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(zdz), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                            var item = _step2.value;

                                            if (item.hasOwnProperty('uuid') && item['uuid']) {
                                                _array.push(item['uuid']);
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError2 = true;
                                        _iteratorError2 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                                _iterator2.return();
                                            }
                                        } finally {
                                            if (_didIteratorError2) {
                                                throw _iteratorError2;
                                            }
                                        }
                                    }

                                    zdz = _array;
                                } else {
                                    zdz = zdz.split(",");
                                }
                                zdzmc = _this2.imageLists(zdz);
                            } else {
                                zdzmc = zdz;
                            }
                            var required = sfbt === '1' ? true : false;

                            var formItem = void 0;
                            var csz = formData ? formData[zdbz] : zdz;
                            if (required) {
                                formItem = kjcsjson.type === 'textarea' || kjcsjson.type === "oldupload" || kjcsjson.type === "upload" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { height: "120px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item_textarea", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-infoHncs-__index__kzxx_label' },
                                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                            'span',
                                            { style: { color: 'red' } },
                                            '*'
                                        ),
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-infoHncs-__index__kzxx_name_textarea' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs }) : zdzmc
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { height: "71px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-infoHncs-__index__kzxx_label' },
                                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                            'span',
                                            { style: { color: 'red' } },
                                            '*'
                                        ),
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-infoHncs-__index__kzxx_name' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs,
                                            onChange: _this2.onChange }) : zdzmc
                                    )
                                );
                            } else {
                                formItem = kjcsjson.type === 'textarea' || kjcsjson.type === "oldupload" || kjcsjson.type === "upload" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { height: "120px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item_textarea", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-infoHncs-__index__kzxx_label' },
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-infoHncs-__index__kzxx_name_textarea' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs }) : zdzmc
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { height: "71px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-infoHncs-__index__kzxx_label' },
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-infoHncs-__index__kzxx_name' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs,
                                            onChange: _this2.onChange }) : zdzmc
                                    )
                                );
                            }
                            infoItems.push(formItem);
                        };

                        for (var _key in zdglVOs) {
                            _loop3(_key);
                        }
                    } else {
                        //未找到表单配置的采集字段信息
                        AlertParams['message'] = '暂时没有需要填写的信息';
                        AlertParams['description'] = '当前未配置采集信息项';
                        AlertParams['type'] = 'warning';
                    }
                }
            }

            return __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                'div',
                {
                    className: 'jsx-2266704716'
                },
                infoItems.length > 0 && __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                    'div',
                    {
                        className: 'jsx-2266704716'
                    },
                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__pages_Assembly_titleTop__["a" /* default */], {
                        title: '\u6269\u5C55\u4FE1\u606F',
                        onEdit: function onEdit(type) {
                            _this2.setState({
                                kzxx: true
                            });
                            getChildComponent(2, false);
                        },
                        onSave: function onSave(cb) {
                            _this2.onSaveKzxx(cb);
                        },
                        onClose: function onClose() {
                            _this2.setState({
                                kzxx: false
                            });
                        }
                    }),
                    infoItems.length > 0 ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a,
                        null,
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-2266704716' + ' ' + 'p-sw'
                            },
                            __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-2266704716' + ' ' + 'app__css__app-pages-SelfHelp-infoHncs-__index__kzxx_list'
                                },
                                infoItems
                            )
                        )
                    ) : __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default.a, _extends({ style: { marginTop: 20 }
                    }, AlertParams, {
                        showIcon: true
                    })),
                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a,
                        {
                            visible: previewVisible,
                            footer: null,
                            onCancel: this.closeModal
                        },
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('img', {
                            alt: 'example',
                            style: { width: '100%' },
                            src: previewImage,
                            className: 'jsx-2266704716'
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_styled_jsx_style___default.a, {
                    styleId: '2266704716',
                    css: ['.app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_item{height:100% !important;}', '.app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_label{background-color:#fff;}', '.app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_name{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;width:67%;}']
                })
            );
        }
    }]);

    return KzxxFormComponent;
}(__WEBPACK_IMPORTED_MODULE_20_react___default.a.Component);

var KzxxForm = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create()(KzxxFormComponent);
/* harmony default export */ __webpack_exports__["a"] = (KzxxForm);

/***/ }),

/***/ 1066:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__index_css__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__utils_RegExp__);



















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;

var ZyshgxForm = function (_React$Component) {
    _inherits(ZyshgxForm, _React$Component);

    function ZyshgxForm(props) {
        _classCallCheck(this, ZyshgxForm);

        var _this = _possibleConstructorReturn(this, (ZyshgxForm.__proto__ || __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default()(ZyshgxForm)).call(this, props));

        _this.cacheZyshgxData = function (cb) {
            _this.props.form.validateFields(function (err, values) {
                if (err) {
                    __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default.a.info('请检查主要社会关系是否正确填写');
                    cb(false);
                    return;
                }
                //判断数据是否全部填写
                var errorPhone = "";
                var errorList = [];
                var dataList = [];
                if (_this.state.zyshgxData && _this.state.zyshgxData.length > 0) {
                    for (var i = 0; i < _this.state.zyshgxData.length; i++) {
                        var data = _this.state.zyshgxData[i];
                        var pattern = /^1\d{10}$/;
                        if (data.lxfs) {
                            if (!pattern.test(data.lxfs)) {
                                if (errorList.length == 0) {
                                    errorPhone += data.lxfs;
                                } else {
                                    errorPhone += "," + data.lxfs;
                                }
                                errorList.push(data);
                            }
                        }
                        if (!data.gx && !data.xm && !data.gzxxdw && !data.lxfs && !data.operation) {} else {
                            dataList.push(data);
                        }
                    }
                }
                if (errorList && errorList.length > 0) {
                    __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default.a.error(errorPhone + '\u53F7\u7801\u586B\u5199\u9519\u8BEF');
                    return;
                }
                _this.setState({
                    zyshgx: false,
                    zyshgxAdd: false
                });
                var _this$props = _this.props,
                    cacheFormData = _this$props.cacheFormData,
                    getChildComponent = _this$props.getChildComponent;

                getChildComponent(3, true);
                cacheFormData('zyshgx', dataList, true);
                cb(true);
            });
        };

        _this.onzyshgxAdd = function () {
            var _this$state = _this.state,
                zyshgxAdd = _this$state.zyshgxAdd,
                zyshgxData = _this$state.zyshgxData;

            if (!zyshgxData) {
                zyshgxData = [];
            }

            if (zyshgxAdd) {
                zyshgxData.push({
                    key: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHCore__["c" /* createUuid */])(),
                    gx: '',
                    xm: '',
                    gzxxdw: '',
                    zzmmm: '',
                    lxfs: '',
                    operation: ''
                });
                _this.setState({
                    zyshgxData: zyshgxData
                });
            }
            _this.setState({
                zyshgxAdd: true
            });
        };

        _this.onzyshgxSave = function () {
            var zyshgxData = _this.state.zyshgxData;

            zyshgxData.push();
            _this.setState({
                zyshgxData: zyshgxData,
                zyshgxAdd: false
            });
        };

        _this.onzyshgxClose = function (index) {
            var zyshgxData = _this.state.zyshgxData;

            zyshgxData.splice(index, 1);
            _this.setState({
                zyshgxData: zyshgxData,
                zyshgxAdd: true
            });
        };

        _this.handleChange = function (value, index, key) {
            var zyshgxData = _this.state.zyshgxData;
            zyshgxData[index][key] = value;
            _this.setState({ zyshgxData: zyshgxData });
        };

        _this.getzzmmmStr = function (value) {
            var temp = '';
            _this.state.zzmmmList.forEach(function (i) {
                if (i.value === value) {
                    temp = i.label;
                }
            });
            return temp;
        };

        _this.deepCopy = function (obj) {
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                return obj;
            }

            if (_this.isArrayFn(obj)) {
                var newobj = [];
                for (var i = 0; i < obj.length; i++) {
                    newobj.push(_this.deepCopy(obj[i]));
                }
                return newobj;
            } else {
                var _newobj = {};
                for (var attr in obj) {
                    _newobj[attr] = _this.deepCopy(obj[attr]);
                }
                return _newobj;
            }
        };

        _this.isArrayFn = function (value) {
            if (typeof Array.isArray === "function") {
                return Array.isArray(value);
            } else {
                return Object.prototype.toString.call(value) === "[object Array]";
            }
        };

        _this.validateCustom = function () {
            var _this$state2 = _this.state,
                jtcy = _this$state2.jtcy,
                formInitData = _this$state2.formInitData;

            if (jtcy) {
                // 若是编辑模式 使用表单验证
                _this.props.form.validateFields(function (err, values) {
                    if (err) {
                        return false;
                    }
                    return true;
                });
            } else {
                return true;
            }
        };

        _this.validateFields = function (func) {
            var err = false;
            var formData = _this.state.data;
            func(err, formData);
        };

        _this.state = {
            zyshgx: false,
            zyshgxAdd: false,
            zyshgxData: [],
            zzmmmList: [],
            tempStr: ''
        };
        return _this;
    }

    _createClass(ZyshgxForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('/proData/selectDataList?&sign=DMK_XTGL_ZZMMM', 'GET').then(function (res) {
                if (res && res.data) {
                    var zzmmmList = [];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default()(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var obj = _step.value;

                            zzmmmList.push({ 'label': obj.LABEL, 'value': obj.VALUE });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this2.setState({ zzmmmList: zzmmmList });
                }
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('zyshgxInitData' in nextProps && nextProps.zyshgxInitData) {
                if (nextProps.zyshgxInitData instanceof Array) {
                    var temp = [].concat(_toConsumableArray(nextProps.zyshgxInitData));
                    this.setState({ zyshgxData: temp });
                }
            }
        }

        // 家庭成员 添加

        // 家庭成员 保存添加

        // 家庭成员 关闭添加


        /** 验证必填项 */

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _state = this.state,
                zyshgx = _state.zyshgx,
                zyshgxData = _state.zyshgxData,
                zyshgxAdd = _state.zyshgxAdd,
                zyshgxList = _state.zyshgxList;
            var getChildComponent = this.props.getChildComponent;
            var zzmmmList = this.state.zzmmmList;

            var formStyle = {
                margin: 0
            };
            var getFieldDecorator = this.props.form.getFieldDecorator;

            var zyshgxColumns = [{
                title: '关系',
                key: 'gx',
                dataIndex: 'gx',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'gx');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u5173\u7CFB'
                    }) : text;
                }
            }, {
                title: '姓名',
                dataIndex: 'xm',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'xm');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u59D3\u540D'
                    }) : text;
                }
            }, {
                title: '工作单位及职务',
                dataIndex: 'gzxxdw',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'gzxxdw');
                        },
                        style: { width: 140 },
                        placeholder: '\u8BF7\u586B\u5199\u5355\u4F4D\u548C\u804C\u52A1'
                    }) : text;
                }
            },
            // {
            //     title: '联系电话',
            //     dataIndex: 'lxfs',
            //     render: (text, record,index) => {
            //         return zyshgx ? (
            //             <Input
            //                 value={text}
            //                 onChange={(e) =>{this.handleChange(e.target.value,index,'lxfs')}}
            //                 style={{ width: 100 }}
            //                 placeholder="请填写电话"
            //             />
            //         ) : (
            //             text
            //         );
            //     }
            // },
            {
                title: '联系电话',
                dataIndex: 'lxfs',
                render: function render(text, record, index) {
                    return zyshgx ?
                    /* <Form.Item style={formStyle}>
                        {getFieldDecorator(index, {
                            initialValue: text,
                            rules: [
                                { required: true, message: '请输入联系电话' },
                                FormRules.MOBILE_PHONE_NUMBER
                            ]
                        })( */
                    __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        maxLength: 11,
                        placeholder: '\u8BF7\u586B\u5199\u7535\u8BDD',
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'lxfs');
                        }
                    })
                    /*    )}
                    </Form.Item> */

                    : text;
                }
            }, {
                title: 'QQ',
                dataIndex: 'qq',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'qq');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586BQQ\u53F7'
                    }) : text;
                }
            }, {
                title: '微信',
                dataIndex: 'wx',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'wx');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5FAE\u4FE1\u53F7'
                    }) : text;
                }
            }, {
                title: '删除',
                dataIndex: 'operation',
                width: 80,
                render: function render(text, record, index) {
                    if (zyshgx) {
                        return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                            'div',
                            { className: 'editable-row-operations' },
                            __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                                'a',
                                {
                                    href: 'javascript:;',
                                    onClick: function onClick() {
                                        return _this3.onzyshgxClose(index);
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, {
                                    type: 'close',
                                    style: { color: 'red' }
                                })
                            )
                        );
                    }
                    return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                        'a',
                        { href: 'javascript:;', onClick: function onClick() {
                                return _this3.onzyshgxClose();
                            } },
                        __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'delete', style: { color: 'red' } })
                    );
                }
            }];
            if (!zyshgx) {
                zyshgxColumns.pop();
            }
            return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u4E3B\u8981\u793E\u4F1A\u5173\u7CFB',
                    onEdit: function onEdit(type) {
                        _this3.setState({
                            zyshgx: true,
                            zyshgxAdd: true,
                            cacheData: _this3.deepCopy(_this3.state.zyshgxData)
                        });
                        getChildComponent(3, false);
                    },
                    onSave: function onSave(cb) {
                        _this3.cacheZyshgxData(cb);
                    },
                    onClose: function onClose() {
                        _this3.setState({
                            zyshgx: false,
                            zyshgxAdd: false,
                            zyshgxData: _this3.deepCopy(_this3.state.cacheData)
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a,
                    null,
                    __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                        'div',
                        { className: 'p-sw' },
                        __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a, {
                            bordered: true,
                            size: 'middle',
                            pagination: false,
                            dataSource: zyshgxData,
                            columns: zyshgxColumns
                        }),
                        zyshgxAdd && __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                            'div',
                            {
                                className: 'mt-10 app__css__app-pages-SelfHelp-infoHncs-__index__btn_add',

                                onClick: function onClick() {

                                    _this3.onzyshgxAdd();
                                }
                            },
                            '\u6DFB\u52A0\u4E3B\u8981\u793E\u4F1A\u5173\u7CFB'
                        )
                    )
                )
            );
        }
    }]);

    return ZyshgxForm;
}(__WEBPACK_IMPORTED_MODULE_18_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create()(ZyshgxForm));

/***/ }),

/***/ 1067:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return infoHncs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker_style__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_date_picker__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__JbxxForm__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__JtcyForm__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ZyshgxForm__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__JyjlForm__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__KzxxForm__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_common_hint__ = __webpack_require__(35);












var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }






















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_25_history_createHashHistory___default()();
var RangePicker = __WEBPACK_IMPORTED_MODULE_10_antd_lib_date_picker___default.a.RangePicker;

var Option = __WEBPACK_IMPORTED_MODULE_8_antd_lib_select___default.a.Option;
var stuInfoUrl = "/xxcj/";

var infoHncs = function (_React$Component) {
    _inherits(infoHncs, _React$Component);

    function infoHncs(props) {
        _classCallCheck(this, infoHncs);

        var _this = _possibleConstructorReturn(this, (infoHncs.__proto__ || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default()(infoHncs)).call(this, props));

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({
                        nonOperationalData: res.data,
                        zzbdhjid: zzbdhjid
                    });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.getChildComponent = function (flag, mode) {
            switch (flag) {
                case 1:
                    _this.setState({ jbxxFlag: mode });
                    break;
                case 2:
                    _this.setState({ kzxxFlag: mode });
                    break;
                case 3:
                    _this.setState({ jtcyFlag: mode });
                    break;
                case 4:
                    _this.setState({ zyshgxFlag: mode });
                    break;
                case 5:
                    _this.setState({ jyjlFlag: mode });
                    break;
                default:
                    break;
            }
        };

        _this.cacheFormData = function (type, values, isAdd) {
            //const{jbxxInitData} = this.state;
            if (type == 'jbxx') {
                var sjhm = values.sjhm,
                    jtszdqArray = values.jtszdqArray,
                    jtjddz = values.jtjddz;

                if (sjhm !== null && jtszdqArray !== null && jtszdqArray.length > 0 && jtjddz !== null) {
                    _this.setState({
                        jbxxInitData: _extends({}, values),
                        isEditJbxx: true
                    }, function () {
                        _this.insertData4Yxwz();
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("存在必填信息未填写，请填写后再保存！");
                }
            }
            if (type == 'jtcy' && isAdd) {
                if (values !== null && values.length > 0) {
                    _this.setState({
                        jtcyInitData: values,
                        isEditJtcy: true
                    }, function () {
                        _this.insertData4Yxwz();
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("家庭成员信息不能为空！");
                }
            }
            if (type == 'zyshgx' && isAdd) {
                _this.setState({
                    zyshgxInitData: values,
                    isEditZyshgx: true
                }, function () {
                    _this.insertData4Yxwz();
                });
            }
            if (type == 'jyjl') {
                if (values !== null && values.length > 0) {
                    _this.setState({
                        jyjlInitData: values,
                        isEditJyjl: true
                    }, function () {
                        _this.insertData4Yxwz();
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("教育经历信息不能为空！");
                }
            }
        };

        _this.getData4Yxwz = function () {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                _this.setState({ xsid: userId });
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/newStudent/queryStuInfo', 'GET', { 'xsid': userId }).then(function (res) {
                    if (res && res.data) {
                        var stuInfo = res.data.stuInfo;
                        var stuXxcj = res.data.stuXxcj;
                        var stuSsxx = res.data.stuSsxx;
                        var editXszp = res.data.editXszp;

                        _this.setState({
                            userBaseInfo: stuInfo.userBaseInfo,
                            jbxxInitData: stuInfo.xsJbxx4YxwzVO,
                            jtcyInitData: stuInfo.jtcyVO,
                            zyshgxInitData: stuInfo.zyshgxVO,
                            jyjlInitData: stuInfo.jyjlVO,
                            kzxxInitData: _extends({}, stuXxcj),
                            stuSsxx: stuSsxx,
                            editXszp: editXszp
                        });
                    }
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("登录超时,请重新登录！");
            }
        };

        _this.insertData4Yxwz = function () {
            var postFormData = {};
            var _this$state = _this.state,
                jbxxInitData = _this$state.jbxxInitData,
                jtcyInitData = _this$state.jtcyInitData,
                zyshgxInitData = _this$state.zyshgxInitData,
                jyjlInitData = _this$state.jyjlInitData,
                xsid = _this$state.xsid,
                zzbdhjid = _this$state.zzbdhjid;

            postFormData['xsid'] = xsid;
            postFormData['xsJbxx4YxwzVO'] = jbxxInitData;
            postFormData['jtcyVO'] = jtcyInitData;
            postFormData['zyshgxVO'] = zyshgxInitData;
            postFormData['jyjlVO'] = jyjlInitData;

            var postData = {
                'xsInfo4YxwzVO': postFormData,
                'params': { 'zzbdhjid': zzbdhjid, 'xsid': xsid }
            };

            //必填一
            var _postData$xsInfo4Yxwz = postData.xsInfo4YxwzVO.xsJbxx4YxwzVO,
                sjhm = _postData$xsInfo4Yxwz.sjhm,
                jtszdqArray = _postData$xsInfo4Yxwz.jtszdqArray,
                jtjddz = _postData$xsInfo4Yxwz.jtjddz;

            var jbxxFlag = false;
            if (sjhm !== null && jtszdqArray !== null && jtszdqArray.length > 0 && jtjddz !== null) {
                jbxxFlag = true;
            }
            //必填项二：两个填一个
            var _postData$xsInfo4Yxwz2 = postData.xsInfo4YxwzVO,
                jtcyVO = _postData$xsInfo4Yxwz2.jtcyVO,
                zyshgxVO = _postData$xsInfo4Yxwz2.zyshgxVO,
                jyjlVO = _postData$xsInfo4Yxwz2.jyjlVO;

            var jtxxFlag = false;
            if (jtcyVO !== null && jtcyVO.length > 0 || zyshgxVO !== null && zyshgxVO.length > 0) {
                jtxxFlag = true;
            }
            //必填三
            var jyxxFlag = false;
            if (jyjlVO !== null && jyjlVO.length > 0) {
                jyxxFlag = true;
            }
            var hjblFlag = false;
            if (jbxxFlag && jtxxFlag && jyxxFlag) {
                hjblFlag = true;
            }
            postData.params.hjblFlag = hjblFlag;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/newStudent/updateStuInfo', 'POST', postData).then(function (res) {
                if (res && res.code == 200) {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.success("保存成功");
                    _this.reloadMenu();
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("保存失败");
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD001_6',
            hjmc: '',
            jbxxFormData: {},
            formInitData: {},
            jbxxInitData: {},
            jtcyInitData: [],
            zyshgxInitData: [],
            jyjlInitData: [],
            kzxxInitData: {},
            userBaseInfo: {},
            stuSsxx: {},
            xsid: '',
            jbxxFlag: true,
            kzxxFlag: true,
            jtcyFlag: true,
            zyshgxFlag: true,
            jyjlFlag: true,
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            isEditJbxx: false,
            isEditJtcy: false,
            isEditZyshgx: false,
            isEditJyjl: false,
            menuList: [],
            zzbdhjid: ''
        };
        return _this;
    }

    _createClass(infoHncs, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.queryQztjAndYlhj();
            //this.getYlhjData();
            this.getData4Yxwz();
        }

        //查询前置条件和依赖环节


        //缓存编写的信息，缓存完之后提交


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                xsid = _state.xsid,
                jtcyInitData = _state.jtcyInitData,
                zyshgxInitData = _state.zyshgxInitData;


            return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_13__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230'
                        /*   active={0}*/
                        , mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13__components__["a" /* Flex */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__JbxxForm__["a" /* default */], { ref: 'refJbxxForm', jbxxFormData: this.state.jbxxInitData,
                                getChildComponent: this.getChildComponent,
                                cacheFormData: this.cacheFormData,
                                userInfoData: this.state.userBaseInfo,
                                stuSsxx: this.state.stuSsxx,
                                editXszp: this.state.editXszp
                            }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__KzxxForm__["a" /* default */], { ref: 'refKzxxForm', getChildComponent: this.getChildComponent,
                                reloadMenu: this.reloadMenu,
                                xsid: this.state.xsid,
                                zzbdhjid: this.state.zzbdhjid,
                                initData: this.state.kzxxInitData
                            }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__JtcyForm__["a" /* default */], { ref: 'refJtcyForm', jtcyInitData: this.state.jtcyInitData,
                                getChildComponent: this.getChildComponent,
                                cacheFormData: this.cacheFormData }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__ZyshgxForm__["a" /* default */], { ref: 'refZyshgxForm', zyshgxInitData: this.state.zyshgxInitData,
                                getChildComponent: this.getChildComponent,
                                cacheFormData: this.cacheFormData }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__JyjlForm__["a" /* default */], { ref: 'refJyjlForm', jyjlInitData: this.state.jyjlInitData,
                                getChildComponent: this.getChildComponent,
                                cacheFormData: this.cacheFormData }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'div',
                                { className: 'p-sw text-center mt-30' },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__common__["a" /* default */], { hjmc: "个人信息填写", key: 'GD001_6', mkbz: 'GD001_6', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return infoHncs;
}(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);



/***/ }),

/***/ 1068:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MajorForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__index_css__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_common_NHMultiSelect__ = __webpack_require__(249);















var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }









if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item;
var TextArea = __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a.TextArea;

var formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 }
};
var MajorForm = (_dec = __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(MajorForm, _React$Component);

    function MajorForm(props) {
        _classCallCheck(this, MajorForm);

        var _this = _possibleConstructorReturn(this, (MajorForm.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(MajorForm)).call(this, props));

        _this.getXsxx = function () {
            var xsid = _this.props.xsid;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/zytz/getXsxx', 'GET', { xsid: xsid }).then(function (resData) {
                if (resData && resData.data) {
                    _this.setState({ xsxxData: resData.data });
                }
            });
        };

        _this.getXyxxData = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/zytz/getSelectOptionDataByFilter', 'GET', { tag: 'xy' }).then(function (res) {
                if (res) {
                    _this.setState({ xyxxData: res.data ? res.data : [] });
                }
            });
        };

        _this.handleXyxxChange = function (value) {
            var _this$props$form = _this.props.form,
                getFieldValue = _this$props$form.getFieldValue,
                setFieldsValue = _this$props$form.setFieldsValue;

            if (value && value.length > 0) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/zytz/getSelectOptionDataByFilter', 'GET', { tag: 'zy', filter: value.toString() }).then(function (res) {
                    if (res) {
                        if (res.data) {
                            var newData = res.data.map(function (item) {
                                return item.VALUE;
                            });
                            newData = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set___default.a(newData);
                            setFieldsValue({ zyids: [] });
                            _this.handleZyxxChange(newData);
                        }
                        _this.setState({ zyxxData: res.data ? res.data : [] });
                    }
                });
            } else {
                setFieldsValue({ zyids: [], bjids: [] });
                _this.setState({ zyxxData: [], bjxxData: [] });
            }
        };

        _this.handleZyxxChange = function (value) {
            var _this$props$form2 = _this.props.form,
                getFieldValue = _this$props$form2.getFieldValue,
                setFieldsValue = _this$props$form2.setFieldsValue;

            if (value && value.length > 0) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/zytz/getSelectOptionDataByFilter', 'GET', { tag: 'bj', filter: value.toString() }).then(function (res) {
                    if (res) {
                        if (res.data) {
                            setFieldsValue({ bjids: [] });
                        }
                        _this.setState({ bjxxData: res.data ? res.data : [] });
                    }
                });
            } else {
                setFieldsValue({ bjids: [] });
                _this.setState({ bjxxData: [] });
            }
        };

        _this.loadZyData = function (bmid, zyid, bjid) {
            var setFieldsValue = _this.props.form.setFieldsValue;

            if (bmid) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/zytz/getSelectOptionDataByFilter', 'GET', { tag: 'zy', filter: bmid.toString() }).then(function (res) {
                    if (res) {
                        if (res.data) {
                            var newData = res.data.map(function (item) {
                                return item.VALUE;
                            });
                            newData = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set___default.a(newData);
                            if (newData.has(zyid)) {
                                setFieldsValue({ zyids: zyid });
                                _this.loadBjData(zyid, bjid);
                            }
                        }
                        _this.setState({ zyxxData: res.data ? res.data : [] });
                    }
                });
            }
        };

        _this.loadBjData = function (zyid, bjid) {
            var setFieldsValue = _this.props.form.setFieldsValue;

            if (zyid) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/zytz/getSelectOptionDataByFilter', 'GET', { tag: 'bj', filter: zyid.toString() }).then(function (res) {
                    if (res) {
                        if (res.data) {
                            var newData = res.data.map(function (item) {
                                return item.VALUE;
                            });
                            newData = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set___default.a(newData);
                            if (newData.has(bjid)) {
                                setFieldsValue({ bjids: bjid });
                            }
                        }
                        _this.setState({ bjxxData: res.data ? res.data : [] });
                    }
                });
            }
        };

        _this.state = {
            xsxxData: {}, //学生信息,
            xyxxData: [], //学院下拉数据
            zyxxData: [], //专业下拉数据
            bjxxData: [] //班级下拉数据
        };
        return _this;
    }

    _createClass(MajorForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var _props$form = this.props.form,
                getFieldValue = _props$form.getFieldValue,
                setFieldsValue = _props$form.setFieldsValue,
                resetFields = _props$form.resetFields;
            var zytzPkid = this.props.zytzPkid;

            if (zytzPkid) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/zytz/getZytzInfo', 'GET', { pkid: zytzPkid }).then(function (resData) {
                    if (resData && resData.data) {
                        var data = resData.data;
                        var bmid = data['tzhyxid'];
                        var zyid = data['tzhzyid'];
                        var bjid = data['tzhbjid'];
                        var ly = data['sqly'];
                        setFieldsValue({
                            bmids: bmid,
                            ly: ly
                        });
                        _this2.loadZyData(bmid, zyid, bjid);
                    }
                });
            }

            this.getXsxx();
            this.getXyxxData();
        }

        //加载学院数据


        //部门信息选择回调


        //专业信息选择回调

    }, {
        key: 'render',
        value: function render() {
            var getFieldDecorator = this.props.form.getFieldDecorator;
            var _state = this.state,
                xsxxData = _state.xsxxData,
                xyxxData = _state.xyxxData,
                zyxxData = _state.zyxxData,
                bjxxData = _state.bjxxData;

            return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                { align: 'start' },
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'app__css__app-pages-SelfHelp-major-__index__modal_l' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                        { align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-major-__index__modal_l_label' },
                            '\u8003\u751F\u53F7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['KSH'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                        { className: 'mt-10', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-major-__index__modal_l_label' },
                            '\u6027\u522B\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['XB'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                        { className: 'mt-10', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-major-__index__modal_l_label' },
                            '\u5F55\u53D6\u53F7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['LQH'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                        { className: 'mt-10', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-major-__index__modal_l_label' },
                            '\u59D3\u540D\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['XM'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                        { className: 'mt-10', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-major-__index__modal_l_label' },
                            '\u8EAB\u4EFD\u8BC1\u53F7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['SFZJH'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                        { className: 'mt-10', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-major-__index__modal_l_label' },
                            '\u5B66\u53F7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['XH'] : ''
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                    { className: 'app__css__app-pages-SelfHelp-major-__index__modal_r' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,
                        null,
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,
                            { className: 'app__css__app-pages-SelfHelp-major-__index__text-label', span: 6 },
                            '\u5B66\u9662\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,
                            { className: 'app__css__app-pages-SelfHelp-major-__index__text-name', span: 18 },
                            xsxxData ? xsxxData['BMMC'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,
                        { className: 'mt-10' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,
                            { className: 'app__css__app-pages-SelfHelp-major-__index__text-label', span: 6 },
                            '\u4E13\u4E1A\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,
                            { className: 'app__css__app-pages-SelfHelp-major-__index__text-name', span: 18 },
                            xsxxData ? xsxxData['ZYMC'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,
                        { className: 'mt-10' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,
                            { className: 'app__css__app-pages-SelfHelp-major-__index__text-label', span: 6 },
                            '\u73ED\u7EA7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,
                            { className: 'app__css__app-pages-SelfHelp-major-__index__text-name', span: 18 },
                            xsxxData ? xsxxData['BJMC'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                        { className: 'app__css__app-pages-SelfHelp-major-__index__line' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item, { className: 'app__css__app-pages-SelfHelp-major-__index__line_l' }),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-major-__index__line_con' },
                            '\u7533\u8BF7\u4E13\u4E1A\u8C03\u6574'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item, { className: 'app__css__app-pages-SelfHelp-major-__index__line_r' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a,
                        null,
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            FormItem,
                            { style: { display: 'none' } },
                            getFieldDecorator('pkid', {
                                initialValue: this.props.zytzPkid
                            })(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, null))
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            FormItem,
                            _extends({}, formItemLayout, { label: '\u5B66\u9662' }),
                            getFieldDecorator('bmids', {
                                rules: [{
                                    required: true,
                                    message: '请选择学院'
                                }]
                            })(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_common_NHMultiSelect__["a" /* default */], { mode: 'default', dataSource: xyxxData, onChange: this.handleXyxxChange }))
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            FormItem,
                            _extends({}, formItemLayout, { label: '\u4E13\u4E1A' }),
                            getFieldDecorator('zyids', {
                                rules: [{
                                    required: true,
                                    message: '请选择专业'
                                }]
                            })(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_common_NHMultiSelect__["a" /* default */], { mode: 'default', dataSource: zyxxData, onChange: this.handleZyxxChange }))
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            FormItem,
                            _extends({}, formItemLayout, { label: '\u73ED\u7EA7' }),
                            getFieldDecorator('bjids')(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_common_NHMultiSelect__["a" /* default */], { mode: 'default', dataSource: bjxxData }))
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            FormItem,
                            _extends({}, formItemLayout, { label: '\u7533\u8BF7\u7406\u7531' }),
                            getFieldDecorator('ly')(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(TextArea, {
                                autosize: {
                                    minRows: 4,
                                    maxRows: 4
                                }
                            }))
                        )
                    )
                )
            );
        }
    }]);

    return MajorForm;
}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component)) || _class);


/***/ }),

/***/ 1069:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Major; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_collapse_style__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_collapse_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_collapse_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_collapse__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_axios__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__index_css__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__form__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_SelfHelp_common_hint__ = __webpack_require__(35);























var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }












if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_29_history_createHashHistory___default()();
//确认对话框
var confirm = __WEBPACK_IMPORTED_MODULE_21_antd_lib_modal___default.a.confirm;
var Panel = __WEBPACK_IMPORTED_MODULE_19_antd_lib_collapse___default.a.Panel;
var FormItem = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;
var Option = __WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a.Option;
var TextArea = __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a.TextArea;










var Major = (_dec = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(Major, _React$Component);

    function Major(props) {
        _classCallCheck(this, Major);

        var _this = _possibleConstructorReturn(this, (Major.__proto__ || __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default()(Major)).call(this, props));

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_36__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.zytzList = function () {
            var params = {
                xsid: _this.state.xsid
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/zytz/getZytzList', "GET", params).then(function (res) {
                if (res && res.data) {
                    _this.setState({ data: res.data });
                }
            });
        };

        _this.deleteTip = function (pkid) {
            confirm({
                title: '提示',
                content: '是否确定删除该条申请数据',
                okText: '确定',
                cancelText: '取消',
                okType: 'danger',
                iconType: 'info-circle',
                onOk: function onOk() {
                    _this.delete(pkid);
                },
                onCancel: function onCancel() {}
            });
        };

        _this.delete = function (pkid) {
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/zytz/deleteById', "POST", { pkid: pkid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data == 1) {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.success('删除成功.');
                    _this.reloadMenu();
                    _this.setState({ visible: false });
                    _this.zytzList(); //重新加载
                } else {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn('删除异常');
                }
                _this.zytzList(); //重新查询
            }).catch(function (err) {
                __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn('删除异常');
            });
        };

        _this.showModal = function () {
            var zytzPkid = _this.state.zytzPkid;
            if (zytzPkid) {
                _this.setState({
                    visible: true
                });
            } else {
                var xsid = _this.state.xsid;
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/zytz/getZytzCountByZt', "GET", { xsid: xsid }).then(function (res) {
                    if (res && res.data > 0) {
                        __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn("已存在专业调整申请状态未完成，待完成后再申请.");
                    } else {
                        _this.setState({
                            visible: true
                        });
                    }
                });
            }
        };

        _this.handleCancel = function () {
            _this.setState({
                visible: false
            });
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.setState({
                confirmLoading: true
            });
            var zzbdhjid = _this.getQueryString('pkid');
            _this.form.validateFields(function (err, values) {
                if (err) {
                    _this.setState({
                        confirmLoading: false
                    });
                    return false;
                }

                var bmid = values['bmids'];
                var zyid = values['zyids'];
                var pkid = values['pkid'];
                var bjid = '';
                if (values['bjids'] && values['bjids'].length > 0) {
                    bjid = values['bjids'];
                }

                var sqly = values['ly'];

                var params = {
                    zzbdhjid: zzbdhjid,
                    zytzDTO: {

                        tzhyxid: bmid,
                        tzhzyid: zyid,
                        tzhbjid: bjid,
                        sqly: sqly,
                        pkid: pkid
                    }
                };
                if (pkid) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/zytz/update', "POST", params).then(function (res) {
                        if (res && res.data && res.data == 1) {
                            __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.success("修改成功！");
                            _this.reloadMenu();
                            _this.setState({ visible: false });
                            _this.zytzList(); //重新加载
                        } else {
                            __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn("修改异常！");
                            _this.setState({ confirmLoading: false });
                        }
                        _this.setState({ confirmLoading: false });
                    }).catch(function (res) {
                        _this.setState({ confirmLoading: false });
                        __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn("修改异常！");
                        return res;
                    });
                } else {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/zytz/insert', "POST", params).then(function (res) {
                        if (res && res.data && res.data == 1) {
                            __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.success("保存成功！");
                            _this.reloadMenu();
                            _this.setState({ visible: false });
                            _this.zytzList(); //重新加载
                        } else {
                            __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn("保存异常！");
                            _this.setState({ confirmLoading: false });
                        }
                        _this.setState({ confirmLoading: false });
                    }).catch(function (res) {
                        _this.setState({ confirmLoading: false });
                        __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn("保存异常！");
                        return res;
                    });
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD007',
            hjmc: '',
            data: [],
            visible: false,
            confirmLoading: false,
            xsid: '',
            zytzPkid: '',
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {} //不可操作的数据
        };
        return _this;
    }

    _createClass(Major, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHCore__["b" /* getLoginUser */])().userId;
            this.setState({ xsid: xsid });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.queryQztjAndYlhj();
            this.zytzList();
        }

        //查询前置条件和依赖环节


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                visible = _state.visible,
                confirmLoading = _state.confirmLoading;

            return __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */],
                        { className: 'w1180 mt-20', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__pages_Assembly_siderMenu__["a" /* default */], {
                            ref: "siderMenu",
                            title: '\u81EA\u52A9\u62A5\u5230',
                            setMenuList: this.setMenuList
                            /*      active={6}*/
                            , mkbz: this.state.mkbz,
                            menuType: '\u81EA\u52A9\u62A5\u5230' }),
                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */].Item,
                            { className: 'page_con_r ' },
                            __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__pages_Assembly_Breadcrumb__["a" /* default */], {
                                noLine: true,
                                list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                            }),
                            __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                'div',
                                { className: 'box' },
                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__pages_SelfHelp_common_hint__["a" /* default */], null),
                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__pages_Assembly_titleTop__["a" /* default */], {
                                    className: 'mt-20',
                                    title: this.state.hjmc,
                                    extra: false,
                                    apply: true,
                                    onApplyClick: function onApplyClick() {
                                        _this2.setState({ zytzPkid: '' }, function () {
                                            _this2.showModal();
                                        });
                                    }
                                }),
                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                    'div',
                                    { className: 'p-sw' },
                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_19_antd_lib_collapse___default.a,
                                        { accordion: true, defaultActiveKey: ['0'] },
                                        this.state.data.map(function (elem, index) {
                                            // let tzqxx = elem.TZQYXMC + " - " + elem.TZQZYMC + " - " + elem.TZQBJMC;
                                            var tzqxx = void 0;
                                            if (elem.TZQBJMC != undefined) {
                                                tzqxx = elem.TZQYXMC + " - " + elem.TZQZYMC + " - " + elem.TZQBJMC;
                                            } else {
                                                tzqxx = elem.TZQYXMC + " - " + elem.TZQZYMC;
                                            }
                                            var tzhxx = '' + elem.TZHYXMC + (elem.TZHZYMC ? ' - ' + elem.TZHZYMC : '') + (elem.TZHBJMC ? ' - ' + elem.TZHBJMC : '');
                                            return __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                Panel,
                                                {
                                                    header: __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */],
                                                        null,
                                                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */].Item,
                                                            null,
                                                            '\u7533\u8BF7\u4EBA\uFF1A',
                                                            __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                                'span',
                                                                { className: 'text-blue' },
                                                                elem['XM']
                                                            )
                                                        ),
                                                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */].Item,
                                                            null,
                                                            '\u6027\u522B\uFF1A',
                                                            elem['XB']
                                                        ),
                                                        elem['ZT'] == '0' ? __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */].Item,
                                                            { className: 'text-right' },
                                                            __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon___default.a, {
                                                                style: {
                                                                    color: '#0273fd'
                                                                },
                                                                type: 'edit',
                                                                onClick: function onClick(e) {
                                                                    e.stopPropagation();
                                                                    _this2.setState({ zytzPkid: elem['PKID'] }, function () {
                                                                        _this2.showModal();
                                                                    });
                                                                }
                                                            }),
                                                            __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon___default.a, {
                                                                className: 'ml-10 mr-10',
                                                                type: 'delete',
                                                                onClick: function onClick(e) {
                                                                    e.stopPropagation();
                                                                    _this2.deleteTip(elem['PKID']);
                                                                }
                                                            })
                                                        ) : __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */].Item, { className: 'text-right' })
                                                    ),
                                                    key: index
                                                },
                                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_row___default.a,
                                                    null,
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                                        {
                                                            className: 'app__css__app-pages-SelfHelp-major-__index__coll_label',
                                                            span: 4
                                                        },
                                                        '\u8C03\u6574\u524D\uFF1A'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                                        { span: 20 },
                                                        tzqxx
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_row___default.a,
                                                    { className: 'mt-10' },
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                                        {
                                                            className: 'app__css__app-pages-SelfHelp-major-__index__coll_label',
                                                            span: 4
                                                        },
                                                        '\u8C03\u6574\u540E\uFF1A'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                                        { span: 20 },
                                                        tzhxx
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_row___default.a,
                                                    { className: 'mt-10' },
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                                        {
                                                            className: 'app__css__app-pages-SelfHelp-major-__index__coll_label',
                                                            span: 4
                                                        },
                                                        '\u8C03\u6574\u7406\u7531\uFF1A'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                                        { span: 20 },
                                                        elem['SQLY']
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */],
                                                    {
                                                        justify: 'between',
                                                        className: 'app__css__app-pages-SelfHelp-major-__index__coll_b'
                                                    },
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        'div',
                                                        null,
                                                        '\u7533\u8BF7\u72B6\u6001\uFF1A',
                                                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                            'span',
                                                            { className: 'text-primary' },
                                                            elem['SHZT']
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        'div',
                                                        null,
                                                        '\u7533\u8BF7\u65F6\u95F4\uFF1A',
                                                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                            'span',
                                                            { className: 'text-sub' },
                                                            elem['SQSJ']
                                                        )
                                                    )
                                                )
                                            );
                                        })
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                    'div',
                                    { className: 'text-center mt-50' },
                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_21_antd_lib_modal___default.a,
                        {
                            className: 'modal_body_0',
                            title: '\u4E13\u4E1A\u8C03\u6574\u7F16\u8F91',
                            width: 820,
                            visible: visible,
                            onOk: this.handleSubmit,
                            confirmLoading: confirmLoading,
                            onCancel: this.handleCancel
                        },
                        visible && __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__form__["a" /* default */], { xsid: this.state.xsid, zytzPkid: this.state.zytzPkid, ref: function ref(form) {
                                _this2.form = form;
                            }, xsxxData: this.state.xsxxData })
                    )
                ) : __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__common__["a" /* default */], { hjmc: "专业调整", key: 'GD007', mkbz: 'GD007', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return Major;
}(__WEBPACK_IMPORTED_MODULE_22_react___default.a.Component)) || _class);


/***/ }),

/***/ 1070:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MajorForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__index_css__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_common_NHMultiSelect__ = __webpack_require__(249);















var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }









if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item;
var TextArea = __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a.TextArea;

var formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 }
};
var MajorForm = (_dec = __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(MajorForm, _React$Component);

    function MajorForm(props) {
        _classCallCheck(this, MajorForm);

        var _this = _possibleConstructorReturn(this, (MajorForm.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(MajorForm)).call(this, props));

        _this.getXsxx = function () {
            var xsid = _this.props.xsid;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/zytz/getXsxx', 'GET', { xsid: xsid }).then(function (resData) {
                if (resData && resData.data) {
                    _this.setState({ xsxxData: resData.data });
                }
            });
        };

        _this.getXyxxData = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/zytz/getSelectOptionDataByFilter', 'GET', { tag: 'xy' }).then(function (res) {
                if (res) {
                    _this.setState({ xyxxData: res.data ? res.data : [] });
                }
            });
        };

        _this.handleXyxxChange = function (value) {
            var _this$props$form = _this.props.form,
                getFieldValue = _this$props$form.getFieldValue,
                setFieldsValue = _this$props$form.setFieldsValue;

            if (value && value.length > 0) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/zytz/getSelectOptionDataByFilter', 'GET', { tag: 'zy', filter: value.toString() }).then(function (res) {
                    if (res) {
                        if (res.data) {
                            var newData = res.data.map(function (item) {
                                return item.VALUE;
                            });
                            newData = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set___default.a(newData);
                            setFieldsValue({ zyids: [] });
                            _this.handleZyxxChange(newData);
                        }
                        _this.setState({ zyxxData: res.data ? res.data : [] });
                    }
                });
            } else {
                setFieldsValue({ zyids: [], bjids: [] });
                _this.setState({ zyxxData: [], bjxxData: [] });
            }
        };

        _this.handleZyxxChange = function (value) {
            var _this$props$form2 = _this.props.form,
                getFieldValue = _this$props$form2.getFieldValue,
                setFieldsValue = _this$props$form2.setFieldsValue;

            if (value && value.length > 0) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/zytz/getSelectOptionDataByFilter', 'GET', { tag: 'bj', filter: value.toString() }).then(function (res) {
                    if (res) {
                        if (res.data) {
                            setFieldsValue({ bjids: [] });
                        }
                        _this.setState({ bjxxData: res.data ? res.data : [] });
                    }
                });
            } else {
                setFieldsValue({ bjids: [] });
                _this.setState({ bjxxData: [] });
            }
        };

        _this.loadZyData = function (bmid, zyid, bjid) {
            var setFieldsValue = _this.props.form.setFieldsValue;

            if (bmid) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/zytz/getSelectOptionDataByFilter', 'GET', { tag: 'zy', filter: bmid.toString() }).then(function (res) {
                    if (res) {
                        if (res.data) {
                            var newData = res.data.map(function (item) {
                                return item.VALUE;
                            });
                            newData = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set___default.a(newData);
                            if (newData.has(zyid)) {
                                setFieldsValue({ zyids: zyid });
                                _this.loadBjData(zyid, bjid);
                            }
                        }
                        _this.setState({ zyxxData: res.data ? res.data : [] });
                    }
                });
            }
        };

        _this.loadBjData = function (zyid, bjid) {
            var setFieldsValue = _this.props.form.setFieldsValue;

            if (zyid) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/zytz/getSelectOptionDataByFilter', 'GET', { tag: 'bj', filter: zyid.toString() }).then(function (res) {
                    if (res) {
                        if (res.data) {
                            var newData = res.data.map(function (item) {
                                return item.VALUE;
                            });
                            newData = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set___default.a(newData);
                            if (newData.has(bjid)) {
                                setFieldsValue({ bjids: bjid });
                            }
                        }
                        _this.setState({ bjxxData: res.data ? res.data : [] });
                    }
                });
            }
        };

        _this.state = {
            xsxxData: {}, //学生信息,
            xyxxData: [], //学院下拉数据
            zyxxData: [], //专业下拉数据
            bjxxData: [] //班级下拉数据
        };
        return _this;
    }

    _createClass(MajorForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var _props$form = this.props.form,
                getFieldValue = _props$form.getFieldValue,
                setFieldsValue = _props$form.setFieldsValue,
                resetFields = _props$form.resetFields;
            var zytzPkid = this.props.zytzPkid;

            if (zytzPkid) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/zytz/getZytzInfo', 'GET', { pkid: zytzPkid }).then(function (resData) {
                    if (resData && resData.data) {
                        var data = resData.data;
                        var bmid = data['tzhyxid'];
                        var zyid = data['tzhzyid'];
                        var bjid = data['tzhbjid'];
                        var ly = data['sqly'];
                        setFieldsValue({
                            bmids: bmid,
                            ly: ly
                        });
                        _this2.loadZyData(bmid, zyid, bjid);
                    }
                });
            }

            this.getXsxx();
            this.getXyxxData();
        }

        //加载学院数据


        //部门信息选择回调


        //专业信息选择回调

    }, {
        key: 'render',
        value: function render() {
            var getFieldDecorator = this.props.form.getFieldDecorator;
            var _state = this.state,
                xsxxData = _state.xsxxData,
                xyxxData = _state.xyxxData,
                zyxxData = _state.zyxxData,
                bjxxData = _state.bjxxData;

            return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                { align: 'start' },
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'app__css__app-pages-SelfHelp-majorFa-__index__modal_l' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                        { align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-majorFa-__index__modal_l_label' },
                            '\u8003\u751F\u53F7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['KSH'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                        { className: 'mt-10', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-majorFa-__index__modal_l_label' },
                            '\u6027\u522B\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['XB'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                        { className: 'mt-10', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-majorFa-__index__modal_l_label' },
                            '\u5F55\u53D6\u53F7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['LQH'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                        { className: 'mt-10', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-majorFa-__index__modal_l_label' },
                            '\u59D3\u540D\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['XM'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                        { className: 'mt-10', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-majorFa-__index__modal_l_label' },
                            '\u8EAB\u4EFD\u8BC1\u53F7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['SFZJH'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                        { className: 'mt-10', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-majorFa-__index__modal_l_label' },
                            '\u5B66\u53F7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['XH'] : ''
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                    { className: 'app__css__app-pages-SelfHelp-majorFa-__index__modal_r' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,
                        null,
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,
                            { className: 'app__css__app-pages-SelfHelp-majorFa-__index__text-label', span: 6 },
                            '\u5B66\u9662\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,
                            { className: 'app__css__app-pages-SelfHelp-majorFa-__index__text-name', span: 18 },
                            xsxxData ? xsxxData['BMMC'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,
                        { className: 'mt-10' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,
                            { className: 'app__css__app-pages-SelfHelp-majorFa-__index__text-label', span: 6 },
                            '\u4E13\u4E1A\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,
                            { className: 'app__css__app-pages-SelfHelp-majorFa-__index__text-name', span: 18 },
                            xsxxData ? xsxxData['ZYMC'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,
                        { className: 'mt-10' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,
                            { className: 'app__css__app-pages-SelfHelp-majorFa-__index__text-label', span: 6 },
                            '\u73ED\u7EA7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,
                            { className: 'app__css__app-pages-SelfHelp-majorFa-__index__text-name', span: 18 },
                            xsxxData ? xsxxData['BJMC'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                        { className: 'app__css__app-pages-SelfHelp-majorFa-__index__line' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item, { className: 'app__css__app-pages-SelfHelp-majorFa-__index__line_l' }),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-majorFa-__index__line_con' },
                            '\u7533\u8BF7\u4E13\u4E1A\u8C03\u6574'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item, { className: 'app__css__app-pages-SelfHelp-majorFa-__index__line_r' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a,
                        null,
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            FormItem,
                            { style: { display: 'none' } },
                            getFieldDecorator('pkid', {
                                initialValue: this.props.zytzPkid
                            })(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, null))
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            FormItem,
                            _extends({}, formItemLayout, { label: '\u5B66\u9662' }),
                            getFieldDecorator('bmids', {
                                rules: [{
                                    required: true,
                                    message: '请选择学院'
                                }]
                            })(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_common_NHMultiSelect__["a" /* default */], { mode: 'default', dataSource: xyxxData, onChange: this.handleXyxxChange }))
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            FormItem,
                            _extends({}, formItemLayout, { label: '\u4E13\u4E1A' }),
                            getFieldDecorator('zyids', {
                                rules: [{
                                    required: true,
                                    message: '请选择专业'
                                }]
                            })(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_common_NHMultiSelect__["a" /* default */], { mode: 'default', dataSource: zyxxData, onChange: this.handleZyxxChange }))
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            FormItem,
                            _extends({}, formItemLayout, { label: '\u73ED\u7EA7' }),
                            getFieldDecorator('bjids')(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_common_NHMultiSelect__["a" /* default */], { mode: 'default', dataSource: bjxxData }))
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            FormItem,
                            _extends({}, formItemLayout, { label: '\u7533\u8BF7\u7406\u7531' }),
                            getFieldDecorator('ly')(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(TextArea, {
                                autosize: {
                                    minRows: 4,
                                    maxRows: 4
                                }
                            }))
                        )
                    )
                )
            );
        }
    }]);

    return MajorForm;
}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component)) || _class);


/***/ }),

/***/ 1071:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Major; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_collapse_style__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_collapse_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_collapse_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_collapse__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_axios__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__index_css__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__form__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_SelfHelp_common_hint__ = __webpack_require__(35);























var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }












if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_29_history_createHashHistory___default()();
//确认对话框
var confirm = __WEBPACK_IMPORTED_MODULE_21_antd_lib_modal___default.a.confirm;
var Panel = __WEBPACK_IMPORTED_MODULE_19_antd_lib_collapse___default.a.Panel;
var FormItem = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;
var Option = __WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a.Option;
var TextArea = __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a.TextArea;










var Major = (_dec = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(Major, _React$Component);

    function Major(props) {
        _classCallCheck(this, Major);

        var _this = _possibleConstructorReturn(this, (Major.__proto__ || __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default()(Major)).call(this, props));

        _this.getMojorInfo = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])("/zdybl/getXsxxAndLcidByXsid", 'GET', { xsid: xsid }).then(function (res) {
                if (res.code == "200") {
                    _this.setState({
                        XsxxMojorData: res.data
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.error("获取专业信息接口失败");
                }
            });
        };

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
                var sideMenu = _this.refs.siderMenu.state.menuList;
                var blztFlag = "0";
                sideMenu.map(function (item) {
                    if (item.HJDM == "GD007_1") {
                        blztFlag = item.BLZT;
                    }
                });
                _this.setState({
                    blztFlag: blztFlag
                });
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_36__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.zytzList = function () {
            var params = {
                xsid: _this.state.xsid
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/zytz/getZytzList', "GET", params).then(function (res) {
                if (res && res.data) {
                    _this.setState({ data: res.data });
                }
            });
        };

        _this.deleteTip = function (pkid) {
            confirm({
                title: '提示',
                content: '是否确定删除该条申请数据',
                okText: '确定',
                cancelText: '取消',
                okType: 'danger',
                iconType: 'info-circle',
                onOk: function onOk() {
                    _this.delete(pkid);
                },
                onCancel: function onCancel() {}
            });
        };

        _this.delete = function (pkid) {
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/zytz/deleteById', "POST", { pkid: pkid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data == 1) {
                    var blztFlag = _this.state.blztFlag == '0' ? '1' : '0';
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.success('删除成功.');
                    _this.reloadMenu();
                    _this.setState({ visible: false, blztFlag: blztFlag });
                    _this.zytzList(); //重新加载
                } else {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn('删除异常');
                }
                _this.zytzList(); //重新查询
            }).catch(function (err) {
                __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn('删除异常');
            });
        };

        _this.ifApply = function (pkid, yhbh) {
            confirm({
                title: '提示',
                content: '是否确认放弃该专业调整申请，放弃后将不能再重新发起！ ',
                okText: '确定',
                cancelText: '取消',
                okType: 'danger',
                iconType: 'info-circle',
                onOk: function onOk() {
                    _this.handelApply(pkid, yhbh);
                },
                onCancel: function onCancel() {}
            });
        };

        _this.handelApply = function (pkid, yhbh) {
            var data = {
                pkid: pkid,
                shzt: '4',
                yhbh: yhbh
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('api/zhxg-yxxt/yxwz/zzbd/zytzfa/shzytz', 'POST', data).then(function (res) {
                if (res) {
                    if (res.data == 1) {
                        __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.success('放弃申请成功');
                        _this.zytzList();
                        _this.submitBtnClick();
                    } else {
                        __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.error("放弃申请失败");
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.error("放弃申请失败");
                }
            });
        };

        _this.showModal = function () {
            var zytzPkid = _this.state.zytzPkid;
            if (zytzPkid) {
                _this.setState({
                    visible: true
                });
            } else {
                var xsid = _this.state.xsid;
                var uid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHCore__["b" /* getLoginUser */])().userId : '';
                if (!uid) {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.error("登录已过期，请重新登录！");
                    return;
                }
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/zytz/getZytzCountByZt', "GET", { xsid: xsid }).then(function (res) {
                    if (res && res.data > 0) {
                        __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn("已存在专业调整申请，不可再申请 !");
                    } else {
                        _this.setState({
                            visible: true
                        });
                    }
                });
            }
        };

        _this.handleCancel = function () {
            _this.setState({
                visible: false
            });
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.setState({
                confirmLoading: true
            });
            var zzbdhjid = _this.getQueryString('pkid');
            _this.form.validateFields(function (err, values) {
                if (err) {
                    _this.setState({
                        confirmLoading: false
                    });
                    return false;
                }

                var bmid = values['bmids'];
                var zyid = values['zyids'];
                var pkid = values['pkid'];
                var bjid = '';
                if (values['bjids'] && values['bjids'].length > 0) {
                    bjid = values['bjids'];
                }

                var sqly = values['ly'];

                var params = {
                    zzbdhjid: zzbdhjid,
                    zytzDTO: {

                        tzhyxid: bmid,
                        tzhzyid: zyid,
                        tzhbjid: bjid,
                        sqly: sqly,
                        pkid: pkid
                    }
                };
                var blztFlag = _this.state.blztFlag == '0' ? '1' : '0';
                if (pkid) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/zytz/update', "POST", params).then(function (res) {
                        if (res && res.data && res.data == 1) {
                            __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.success("修改成功！");
                            _this.reloadMenu();
                            _this.setState({ visible: false, blztFlag: blztFlag });
                            _this.zytzList(); //重新加载
                        } else {
                            __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn("修改异常！");
                            _this.setState({ confirmLoading: false });
                        }
                        _this.setState({ confirmLoading: false });
                    }).catch(function (res) {
                        _this.setState({ confirmLoading: false });
                        __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn("修改异常！");
                        return res;
                    });
                } else {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/zytz/insert', "POST", params).then(function (res) {
                        if (res && res.data && res.data == 1) {
                            __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.success("保存成功！");
                            _this.reloadMenu();
                            _this.setState({ visible: false, blztFlag: blztFlag });
                            _this.zytzList(); //重新加载
                        } else {
                            __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn("保存异常！");
                            _this.setState({ confirmLoading: false });
                        }
                        _this.setState({ confirmLoading: false });
                    }).catch(function (res) {
                        _this.setState({ confirmLoading: false });
                        __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn("保存异常！");
                        return res;
                    });
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.submitBtnClick = function () {
            var XsxxMojorData = _this.state.XsxxMojorData;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this.getQueryString('pkid');
            var formData = { xsid: xsid, yhid: xsid, zzbdhjid: zzbdhjid, lchjid: XsxxMojorData.LCID };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/zdybl/saveCustomLinkData', "POST", formData).then(function (res) {
                if (res) {
                    if (res.data == '1') {
                        _this.reloadMenu();
                        __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.success('环节办理成功！');
                        var blztFlag = _this.state.blztFlag == '0' ? '1' : '0';
                        _this.setState({
                            blztFlag: blztFlag
                        });
                    } else {
                        __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.error('环节办理失败，请重试！');
                    }
                }
            });
        };

        _this.cancleBtnClick = function () {
            var XsxxMojorData = _this.state.XsxxMojorData;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this.getQueryString('pkid');
            var formData = { xsid: xsid, lchjid: XsxxMojorData.LCID, zzbdhjid: zzbdhjid };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/zdybl/cancelCustomLinkData', 'POST', formData).then(function (res) {
                if (res) {
                    if (res.data == '1') {
                        __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.success('环节办理取消成功！');
                        //取消办理完成回调
                        _this.reloadMenu();
                        var blztFlag = _this.state.blztFlag == '0' ? '1' : '0';
                        _this.setState({
                            blztFlag: blztFlag
                        });
                    } else {
                        __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.error('环节办理取消失败，请重试！');
                    }
                }
            });
        };

        _this.state = {
            mkbz: 'GD007_1',
            hjmc: '',
            data: [],
            visible: false,
            confirmLoading: false,
            xsid: '',
            zytzPkid: '',
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            XsxxMojorData: {}, //获取专业信息接口
            hjblztData: {}, //环节办理状态信息
            blztFlag: "0", //办理状态
            delloading: false,
            ifapplyloading: false,
            applyloading: false,
            editloading: false
        };
        return _this;
    }

    _createClass(Major, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHCore__["b" /* getLoginUser */])().userId;
            this.setState({ xsid: xsid });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.queryQztjAndYlhj();
            this.zytzList();
            this.getMojorInfo();
        }

        // 获取专业信息接口


        //查询前置条件和依赖环节


        //是否放弃申请


        //放弃申请--确定


        //重新加载菜单


        // 确认办理


        // 取消办理

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                visible = _state.visible,
                confirmLoading = _state.confirmLoading,
                XsxxMojorData = _state.XsxxMojorData,
                blztFlag = _state.blztFlag;

            return __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */],
                        { className: 'w1180 mt-20', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__pages_Assembly_siderMenu__["a" /* default */], {
                            ref: "siderMenu",
                            title: '\u81EA\u52A9\u62A5\u5230',
                            setMenuList: this.setMenuList
                            /*      active={6}*/
                            , mkbz: this.state.mkbz,
                            menuType: '\u81EA\u52A9\u62A5\u5230' }),
                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */].Item,
                            { className: 'page_con_r ' },
                            __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__pages_Assembly_Breadcrumb__["a" /* default */], {
                                noLine: true,
                                list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                            }),
                            __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                'div',
                                { className: 'box' },
                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__pages_SelfHelp_common_hint__["a" /* default */], null),
                                this.state.data.length == 0 && blztFlag == "0" ? __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__pages_Assembly_titleTop__["a" /* default */], {
                                    className: 'mt-20',
                                    title: this.state.hjmc,
                                    extra: false,
                                    apply: true,
                                    onApplyClick: function onApplyClick() {
                                        _this2.setState({ zytzPkid: '' }, function () {
                                            _this2.showModal();
                                        });
                                    }
                                }) : __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__pages_Assembly_titleTop__["a" /* default */], {
                                    className: 'mt-20',
                                    title: this.state.hjmc,
                                    extra: false
                                }),
                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                    'div',
                                    { className: 'p-sw', style: { border: "1px solid #d9d9d9", margin: 20 } },
                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                            {
                                                className: 'app__css__app-pages-SelfHelp-majorFa-__index__col',
                                                span: 8
                                            },
                                            '\u59D3\u540D\uFF1A',
                                            XsxxMojorData ? XsxxMojorData.XM : ""
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                            {
                                                className: 'app__css__app-pages-SelfHelp-majorFa-__index__col',
                                                span: 8
                                            },
                                            '\u6027\u522B\uFF1A',
                                            XsxxMojorData ? XsxxMojorData.XB : ""
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                            {
                                                className: 'app__css__app-pages-SelfHelp-majorFa-__index__col',
                                                span: 8
                                            },
                                            '\u5B66\u53F7\uFF1A',
                                            XsxxMojorData ? XsxxMojorData.XH : ""
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                            {
                                                className: 'app__css__app-pages-SelfHelp-majorFa-__index__col',
                                                span: 8
                                            },
                                            '\u5B66\u9662\uFF1A',
                                            XsxxMojorData ? XsxxMojorData.BMMC : ""
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                            {
                                                className: 'app__css__app-pages-SelfHelp-majorFa-__index__col',
                                                span: 8
                                            },
                                            '\u4E13\u4E1A\uFF1A',
                                            XsxxMojorData ? XsxxMojorData.ZYMC : ""
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                            {
                                                className: 'app__css__app-pages-SelfHelp-majorFa-__index__col',
                                                span: 8
                                            },
                                            '\u73ED\u7EA7\uFF1A',
                                            XsxxMojorData ? XsxxMojorData.BJMC : ""
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                    'div',
                                    { className: 'p-sw' },
                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_19_antd_lib_collapse___default.a,
                                        { accordion: true, defaultActiveKey: ['0'] },
                                        this.state.data.map(function (elem, index) {
                                            // let tzqxx = elem.TZQYXMC + " - " + elem.TZQZYMC + " - " + elem.TZQBJMC;
                                            var tzqxx = void 0;
                                            if (elem.TZQBJMC != undefined) {
                                                tzqxx = elem.TZQYXMC + " - " + elem.TZQZYMC + " - " + elem.TZQBJMC;
                                            } else {
                                                tzqxx = elem.TZQYXMC + " - " + elem.TZQZYMC;
                                            }
                                            var tzhxx = '' + elem.TZHYXMC + (elem.TZHZYMC ? ' - ' + elem.TZHZYMC : '') + (elem.TZHBJMC ? ' - ' + elem.TZHBJMC : '');
                                            return __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                Panel,
                                                {
                                                    header: __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */],
                                                        null,
                                                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */].Item,
                                                            null,
                                                            '\u7533\u8BF7\u4EBA\uFF1A',
                                                            __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                                'span',
                                                                { className: 'text-blue' },
                                                                elem['XM']
                                                            )
                                                        ),
                                                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */].Item,
                                                            null,
                                                            '\u6027\u522B\uFF1A',
                                                            elem['XB']
                                                        ),
                                                        elem['ZT'] == '0' || elem['ZT'] == '3' ? __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */].Item,
                                                            { className: 'text-right' },
                                                            elem['ZT'] == '3' ? __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                                __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                                                                { type: 'primary', ghost: true, shape: 'circle', style: { height: "26px", borderRadius: "13px", padding: "0 15px", marginRight: "10px" },
                                                                    onClick: function onClick(e) {
                                                                        e.stopPropagation();
                                                                        _this2.ifApply(elem['PKID'], elem['SHYHID']);
                                                                    }
                                                                },
                                                                '\u653E\u5F03\u7533\u8BF7'
                                                            ) : null,
                                                            __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                                __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                                                                { type: 'primary', shape: 'circle', ghost: true, style: { height: "26px", borderRadius: "13px", padding: "0 15px", marginRight: "10px" },
                                                                    onClick: function onClick(e) {
                                                                        e.stopPropagation();
                                                                        _this2.setState({ zytzPkid: elem['PKID'] }, function () {
                                                                            _this2.showModal();
                                                                        });
                                                                    }
                                                                },
                                                                '\u4FEE\u6539'
                                                            ),
                                                            elem['ZT'] == '0' ? __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                                __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                                                                { shape: 'circle', style: { height: "26px", borderRadius: "13px", padding: "0 15px" },
                                                                    onClick: function onClick(e) {
                                                                        e.stopPropagation();
                                                                        _this2.deleteTip(elem['PKID']);
                                                                    }
                                                                },
                                                                '\u5220\u9664'
                                                            ) : null
                                                        ) : __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */].Item, { className: 'text-right' })
                                                    ),
                                                    key: index
                                                },
                                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                                                    null,
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                                        {
                                                            className: 'app__css__app-pages-SelfHelp-majorFa-__index__coll_label',
                                                            span: 4
                                                        },
                                                        '\u8C03\u6574\u524D\uFF1A'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                                        { span: 20 },
                                                        tzqxx
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                                                    { className: 'mt-10' },
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                                        {
                                                            className: 'app__css__app-pages-SelfHelp-majorFa-__index__coll_label',
                                                            span: 4
                                                        },
                                                        '\u8C03\u6574\u540E\uFF1A'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                                        { span: 20 },
                                                        tzhxx
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                                                    { className: 'mt-10' },
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                                        {
                                                            className: 'app__css__app-pages-SelfHelp-majorFa-__index__coll_label',
                                                            span: 4
                                                        },
                                                        '\u8C03\u6574\u7406\u7531\uFF1A'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                                        { span: 20 },
                                                        elem['SQLY']
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */],
                                                    {
                                                        justify: 'between',
                                                        className: 'app__css__app-pages-SelfHelp-majorFa-__index__coll_b'
                                                    },
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        'div',
                                                        null,
                                                        '\u7533\u8BF7\u72B6\u6001\uFF1A',
                                                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                            'span',
                                                            { className: 'text-primary' },
                                                            elem['SHZT']
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        'div',
                                                        null,
                                                        '\u7533\u8BF7\u65F6\u95F4\uFF1A',
                                                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                            'span',
                                                            { className: 'text-sub' },
                                                            elem['SQSJ']
                                                        )
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                    'div',
                                                    null,
                                                    '\u5BA1\u6838\u610F\u89C1\uFF1A',
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        'span',
                                                        { className: 'text-primary', style: { marginTop: 10 } },
                                                        elem['HTYJ']
                                                    )
                                                )
                                            );
                                        })
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                    'div',
                                    { className: 'text-center mt-50' },
                                    this.state.data.length == 0 && blztFlag == "0" && __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                                        { type: 'primary', onClick: function onClick() {
                                                return _this2.submitBtnClick();
                                            } },
                                        '\u786E\u8BA4\u65E0\u8BEF'
                                    )
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_21_antd_lib_modal___default.a,
                        {
                            className: 'modal_body_0',
                            title: '\u4E13\u4E1A\u8C03\u6574\u7F16\u8F91',
                            width: 820,
                            visible: visible,
                            onOk: this.handleSubmit,
                            confirmLoading: confirmLoading,
                            onCancel: this.handleCancel
                        },
                        visible && __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__form__["a" /* default */], { xsid: this.state.xsid, zytzPkid: this.state.zytzPkid, ref: function ref(form) {
                                _this2.form = form;
                            }, xsxxData: this.state.xsxxData })
                    )
                ) : __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__common__["a" /* default */], { hjmc: "专业调整", key: 'GD007_1', mkbz: 'GD007_1', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return Major;
}(__WEBPACK_IMPORTED_MODULE_22_react___default.a.Component)) || _class);


/***/ }),

/***/ 1072:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MajorForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_empty_style__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_empty_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_empty_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_empty__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_common_NHSelect__ = __webpack_require__(71);
















var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }









if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item;
var TextArea = __WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default.a.TextArea;

var formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 }
};
var MajorForm = (_dec = __WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(MajorForm, _React$Component);

    function MajorForm(props) {
        _classCallCheck(this, MajorForm);

        var _this = _possibleConstructorReturn(this, (MajorForm.__proto__ || __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of___default()(MajorForm)).call(this, props));

        _this.getXsxx = function () {
            var xsid = _this.props.xsid;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])('/zytz/getXsxx', 'GET', { xsid: xsid }).then(function (resData) {
                if (resData && resData.data) {
                    _this.setState({ xsxxData: _extends({}, _this.state.xsxxData, resData.data) });
                }
            });
        };

        _this.handleZyxxChange = function (value) {
            var _this$props$form = _this.props.form,
                getFieldValue = _this$props$form.getFieldValue,
                setFieldsValue = _this$props$form.setFieldsValue;
            var zyxxData = _this.state.zyxxData;

            var bmids = zyxxData.filter(function (item) {
                return item.value === value;
            }).map(function (item) {
                return item.BMID;
            });
            if (bmids && bmids.length > 0) {
                setFieldsValue({ bmids: bmids[0] });
            } else {
                setFieldsValue({ bmids: [] });
            }
        };

        _this.loadZyData = function () {
            var xsid = _this.props.xsid;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])('api/zhxg-yxxt/yxwz/zzbd/zytzfb/AdjustableMajorInfo/get', 'GET', { xsid: xsid }).then(function (res) {
                if (res && res.data) {
                    _this.setState({
                        zyxxData: res.data
                    });
                }
            });
        };

        _this.state = {
            xsxxData: {}, //学生信息,
            xyxxData: [], //学院下拉数据
            zyxxData: [], //专业下拉数据
            bjxxData: [] //班级下拉数据
        };
        return _this;
    }

    _createClass(MajorForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.getXsxx();
            this.loadZyData();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if ('zytzPkid' in nextProps && nextProps.zytzPkid !== this.props.zytzPkid) {
                var _props$form = this.props.form,
                    getFieldValue = _props$form.getFieldValue,
                    setFieldsValue = _props$form.setFieldsValue,
                    resetFields = _props$form.resetFields;
                var zytzPkid = nextProps.zytzPkid;

                if (zytzPkid) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])('/zytz/getZytzInfo', 'GET', { pkid: zytzPkid }).then(function (resData) {
                        if (resData && resData.data) {
                            var data = resData.data;
                            var bmid = data['tzhyxid'];
                            var zyid = data['tzhzyid'];
                            var ly = data['sqly'];
                            _this2.setState({ shyj: resData.data.shzt === '3' ? resData.data.shyj : null });
                            setFieldsValue({
                                bmids: bmid,
                                zyids: zyid,
                                ly: ly
                            });
                        }
                    });
                }
            }
        }

        //专业信息选择回调

    }, {
        key: 'render',
        value: function render() {
            var getFieldDecorator = this.props.form.getFieldDecorator;
            var _state = this.state,
                xsxxData = _state.xsxxData,
                zyxxData = _state.zyxxData,
                shyj = _state.shyj;

            return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */],
                { align: 'start' },
                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    'div',
                    { className: 'app__css__app-pages-SelfHelp-majorFb-__index__modal_l' },
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */],
                        { align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-majorFb-__index__modal_l_label' },
                            '\u8003\u751F\u53F7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['KSH'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */],
                        { className: 'mt-10', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-majorFb-__index__modal_l_label' },
                            '\u6027\u522B\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['XB'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */],
                        { className: 'mt-10', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-majorFb-__index__modal_l_label' },
                            '\u5F55\u53D6\u53F7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['LQH'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */],
                        { className: 'mt-10', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-majorFb-__index__modal_l_label' },
                            '\u59D3\u540D\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['XM'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */],
                        { className: 'mt-10', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-majorFb-__index__modal_l_label' },
                            '\u8EAB\u4EFD\u8BC1\u53F7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['SFZJH'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */],
                        { className: 'mt-10', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-majorFb-__index__modal_l_label' },
                            '\u5B66\u53F7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['XH'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */],
                        { className: 'mt-10', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-majorFb-__index__modal_l_label' },
                            '\u7B2C\u4E00\u5FD7\u613F\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */].Item,
                            null,
                            this.props.xsxxData ? this.props.xsxxData['dyzymc'] : ''
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */].Item,
                    { className: 'app__css__app-pages-SelfHelp-majorFb-__index__modal_r' },
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,
                        null,
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,
                            { className: 'app__css__app-pages-SelfHelp-majorFb-__index__text-label', span: 6 },
                            '\u5B66\u9662\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,
                            { className: 'app__css__app-pages-SelfHelp-majorFb-__index__text-name', span: 18 },
                            xsxxData ? xsxxData['BMMC'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,
                        { className: 'mt-10' },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,
                            { className: 'app__css__app-pages-SelfHelp-majorFb-__index__text-label', span: 6 },
                            '\u4E13\u4E1A\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,
                            { className: 'app__css__app-pages-SelfHelp-majorFb-__index__text-name', span: 18 },
                            xsxxData ? xsxxData['ZYMC'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */],
                        { className: 'app__css__app-pages-SelfHelp-majorFb-__index__line' },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */].Item, { className: 'app__css__app-pages-SelfHelp-majorFb-__index__line_l' }),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-majorFb-__index__line_con' },
                            '\u7533\u8BF7\u4E13\u4E1A\u8C03\u6574'
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */].Item, { className: 'app__css__app-pages-SelfHelp-majorFb-__index__line_r' })
                    ),
                    this.props.visible ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a,
                        null,
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            FormItem,
                            { style: { display: 'none' } },
                            getFieldDecorator('pkid', {
                                initialValue: this.props.zytzPkid
                            })(__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default.a, null))
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            { style: { display: 'none' } },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                FormItem,
                                _extends({}, formItemLayout, { label: '\u5B66\u9662' }),
                                getFieldDecorator('bmids', {
                                    rules: [{
                                        required: true,
                                        message: '请选择学院'
                                    }]
                                })(__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default.a, null))
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            FormItem,
                            _extends({}, formItemLayout, { label: '\u4E13\u4E1A' }),
                            getFieldDecorator('zyids', {
                                rules: [{
                                    required: true,
                                    message: '请选择专业'
                                }]
                            })(__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_common_NHSelect__["a" /* default */], { mode: 'default', dataSource: zyxxData, onSelect: this.handleZyxxChange }))
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            FormItem,
                            _extends({}, formItemLayout, { label: '\u7533\u8BF7\u7406\u7531' }),
                            getFieldDecorator('ly')(__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(TextArea, {
                                autosize: {
                                    minRows: 4,
                                    maxRows: 4
                                }
                            }))
                        ),
                        shyj && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            FormItem,
                            _extends({}, formItemLayout, { label: '\u56DE\u9000\u610F\u89C1' }),
                            shyj
                        )
                    ) : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_empty___default.a, { description: '\u60A8\u65E0\u6CD5\u8FDB\u884C\u8C03\u6574\u4E13\u4E1A\uFF01' })
                )
            );
        }
    }]);

    return MajorForm;
}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component)) || _class);


/***/ }),

/***/ 1073:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Major; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_collapse_style__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_collapse_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_collapse_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_collapse__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__index_css__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__form__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_SelfHelp_common_hint__ = __webpack_require__(35);






















var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }








//确认对话框

if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var confirm = __WEBPACK_IMPORTED_MODULE_20_antd_lib_modal___default.a.confirm;
var Panel = __WEBPACK_IMPORTED_MODULE_18_antd_lib_collapse___default.a.Panel;









var Major = (_dec = __WEBPACK_IMPORTED_MODULE_16_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(Major, _React$Component);

    function Major(props) {
        _classCallCheck(this, Major);

        var _this = _possibleConstructorReturn(this, (Major.__proto__ || __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default()(Major)).call(this, props));

        _this.getXszyxx = function () {
            var xsid = _this.state.xsid;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('api/zhxg-yxxt/yxwz/zzbd/zytzfb/majorInfo/get', 'GET', { xsid: xsid }).then(function (resData) {
                if (resData && resData.data) {
                    _this.setState({
                        xsxxData: _extends({}, _this.state.xsxxData, resData.data),
                        formVisible: resData.data.dyzyid !== resData.data.lqzyid && resData.data.limit
                    });
                }
            });
        };

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_32__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.zytzList = function () {
            var params = {
                xsid: _this.state.xsid
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('api/zhxg-yxxt/yxwz/zzbd/zytzfb/queryMajorApplyInfo', "GET", params).then(function (res) {
                // debugger
                if (res && res.data) {
                    var zytzPkid = res.data.find(function (item) {
                        return item.ZT === '3';
                    }) ? res.data.find(function (item) {
                        return item.ZT === '3';
                    }).PKID : '';
                    _this.setState({
                        data: res.data.filter(function (item) {
                            return item.ZT !== "3";
                        }),
                        zytzPkid: zytzPkid
                    });
                    if (res.data.length === 0 || res.data.findIndex(function (item) {
                        return item.ZT === '3';
                    }) !== -1) {
                        _this.setState({ visible: true });
                    } else {
                        _this.setState({ visible: false });
                    }
                }
            });
        };

        _this.deleteTip = function (pkid) {
            confirm({
                title: '提示',
                content: '是否确定删除该条申请数据',
                okText: '确定',
                cancelText: '取消',
                okType: 'danger',
                iconType: 'info-circle',
                onOk: function onOk() {
                    _this.delete(pkid);
                },
                onCancel: function onCancel() {}
            });
        };

        _this.delete = function (pkid) {
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('/zytz/deleteById', "POST", { pkid: pkid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data == 1) {
                    __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.success('删除成功.');
                    _this.reloadMenu();
                    _this.setState({ visible: true, formVisible: true });
                    _this.zytzList(); //重新加载
                } else {
                    __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.warn('删除异常');
                }
                _this.zytzList(); //重新查询
            }).catch(function (err) {
                __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.warn('删除异常');
            });
        };

        _this.showModal = function () {
            var zytzPkid = _this.state.zytzPkid;
            if (zytzPkid) {
                _this.setState({
                    visible: true
                });
            } else {
                var xsid = _this.state.xsid;
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('/zytz/getZytzCountByZt', "GET", { xsid: xsid }).then(function (res) {
                    if (res && res.data > 0) {
                        __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.warn("已存在专业调整申请状态未完成，待完成后再申请.");
                    } else {
                        _this.setState({
                            visible: true
                        });
                    }
                });
            }
        };

        _this.query = function () {};

        _this.handleCancel = function () {
            _this.setState({
                visible: false
            });
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.setState({
                confirmLoading: true
            });
            var zzbdhjid = _this.getQueryString('pkid');
            _this.form.validateFields(function (err, values) {
                if (err) {
                    _this.setState({
                        confirmLoading: false
                    });
                    return false;
                }

                var bmid = values['bmids'];
                var zyid = values['zyids'];
                var pkid = values['pkid'];
                var bjid = '';
                if (values['bjids'] && values['bjids'].length > 0) {
                    bjid = values['bjids'];
                }

                var sqly = values['ly'];

                var params = {
                    zzbdhjid: zzbdhjid,
                    zytzDTO: {

                        tzhyxid: bmid,
                        tzhzyid: zyid,
                        tzhbjid: bjid,
                        sqly: sqly,
                        pkid: pkid
                    }
                };
                if (pkid) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('/zytz/update', "POST", params).then(function (res) {
                        if (res && res.data && res.data == 1) {
                            __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.success("修改成功！");
                            _this.reloadMenu();
                            _this.setState({ visible: false });
                            _this.zytzList(); //重新加载
                        } else {
                            __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.warn("修改异常！");
                            _this.setState({ confirmLoading: false });
                        }
                        _this.setState({ confirmLoading: false });
                    }).catch(function (res) {
                        _this.setState({ confirmLoading: false });
                        __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.warn("修改异常！");
                        return res;
                    });
                } else {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('/zytz/insert', "POST", params).then(function (res) {
                        if (res && res.data && res.data == 1) {
                            __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.success("保存成功！");
                            _this.reloadMenu();
                            _this.setState({ visible: false });
                            _this.zytzList(); //重新加载
                        } else {
                            __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.warn("保存异常！");
                            _this.setState({ confirmLoading: false });
                        }
                        _this.setState({ confirmLoading: false });
                    }).catch(function (res) {
                        _this.setState({ confirmLoading: false });
                        __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.warn("保存异常！");
                        return res;
                    });
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD007_2',
            hjmc: '',
            data: [],
            visible: true,
            formVisible: false,
            confirmLoading: false,
            xsid: '',
            zytzPkid: '',
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {} //不可操作的数据
        };
        return _this;
    }

    _createClass(Major, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHCore__["b" /* getLoginUser */])().userId;
            this.setState({ xsid: xsid });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.queryQztjAndYlhj();
            this.zytzList();
            this.getXszyxx();
        }

        //查询前置条件和依赖环节


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                visible = _state.visible,
                formVisible = _state.formVisible;

            return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_22__components__["a" /* Flex */],
                        { className: 'w1180 mt-20', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__pages_Assembly_siderMenu__["a" /* default */], {
                            ref: "siderMenu",
                            title: '\u81EA\u52A9\u62A5\u5230',
                            setMenuList: this.setMenuList
                            /*      active={6}*/
                            , mkbz: this.state.mkbz,
                            menuType: '\u81EA\u52A9\u62A5\u5230' }),
                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_22__components__["a" /* Flex */].Item,
                            { className: 'page_con_r ' },
                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__pages_Assembly_Breadcrumb__["a" /* default */], {
                                noLine: true,
                                list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                            }),
                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                'div',
                                { className: 'box' },
                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__pages_SelfHelp_common_hint__["a" /* default */], null),
                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__pages_Assembly_titleTop__["a" /* default */], {
                                    title: this.state.hjmc,
                                    extra: false
                                }),
                                visible && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__form__["a" /* default */], { xsid: this.state.xsid, zytzPkid: this.state.zytzPkid, ref: function ref(form) {
                                        _this2.form = form;
                                    }, xsxxData: this.state.xsxxData, visible: this.state.formVisible }),
                                this.state.data.length > 0 && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                    'div',
                                    { className: 'p-sw' },
                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_18_antd_lib_collapse___default.a,
                                        { accordion: true, defaultActiveKey: ['0'] },
                                        this.state.data.map(function (elem, index) {
                                            // let tzqxx = elem.TZQYXMC + " - " + elem.TZQZYMC + " - " + elem.TZQBJMC;
                                            var tzqxx = void 0;
                                            if (elem.TZQBJMC != undefined) {
                                                tzqxx = elem.TZQYXMC + " - " + elem.TZQZYMC + " - " + elem.TZQBJMC;
                                            } else {
                                                tzqxx = elem.TZQYXMC + " - " + elem.TZQZYMC;
                                            }
                                            var tzhxx = '' + elem.TZHYXMC + (elem.TZHZYMC ? ' - ' + elem.TZHZYMC : '') + (elem.TZHBJMC ? ' - ' + elem.TZHBJMC : '');
                                            return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                Panel,
                                                {
                                                    header: __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_22__components__["a" /* Flex */],
                                                        null,
                                                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_22__components__["a" /* Flex */].Item,
                                                            null,
                                                            '\u7533\u8BF7\u4EBA\uFF1A',
                                                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                                'span',
                                                                { className: 'text-blue' },
                                                                elem['XM']
                                                            )
                                                        ),
                                                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_22__components__["a" /* Flex */].Item,
                                                            null,
                                                            '\u6027\u522B\uFF1A',
                                                            elem['XB']
                                                        ),
                                                        elem['ZT'] == '0' ? __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_22__components__["a" /* Flex */].Item,
                                                            { className: 'text-right' },
                                                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, {
                                                                style: {
                                                                    color: '#0273fd'
                                                                },
                                                                type: 'edit',
                                                                onClick: function onClick(e) {
                                                                    e.stopPropagation();
                                                                    _this2.setState({ zytzPkid: elem['PKID'] }, function () {
                                                                        _this2.showModal();
                                                                    });
                                                                }
                                                            }),
                                                            __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, {
                                                                className: 'ml-10 mr-10',
                                                                type: 'delete',
                                                                onClick: function onClick(e) {
                                                                    e.stopPropagation();
                                                                    _this2.deleteTip(elem['PKID']);
                                                                }
                                                            })
                                                        ) : __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components__["a" /* Flex */].Item, { className: 'text-right' })
                                                    ),
                                                    key: index
                                                },
                                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,
                                                    null,
                                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,
                                                        {
                                                            className: 'app__css__app-pages-SelfHelp-majorFb-__index__coll_label',
                                                            span: 4
                                                        },
                                                        '\u8C03\u6574\u524D\uFF1A'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,
                                                        { span: 20 },
                                                        tzqxx
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,
                                                    { className: 'mt-10' },
                                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,
                                                        {
                                                            className: 'app__css__app-pages-SelfHelp-majorFb-__index__coll_label',
                                                            span: 4
                                                        },
                                                        '\u8C03\u6574\u540E\uFF1A'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,
                                                        { span: 20 },
                                                        tzhxx
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_7_antd_lib_row___default.a,
                                                    { className: 'mt-10' },
                                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,
                                                        {
                                                            className: 'app__css__app-pages-SelfHelp-majorFb-__index__coll_label',
                                                            span: 4
                                                        },
                                                        '\u8C03\u6574\u7406\u7531\uFF1A'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_9_antd_lib_col___default.a,
                                                        { span: 20 },
                                                        elem['SQLY']
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_22__components__["a" /* Flex */],
                                                    {
                                                        justify: 'between',
                                                        className: 'app__css__app-pages-SelfHelp-majorFb-__index__coll_b'
                                                    },
                                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                        'div',
                                                        null,
                                                        '\u7533\u8BF7\u72B6\u6001\uFF1A',
                                                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                            'span',
                                                            { className: 'text-primary' },
                                                            elem['SHZT']
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                        'div',
                                                        null,
                                                        '\u7533\u8BF7\u65F6\u95F4\uFF1A',
                                                        __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                                            'span',
                                                            { className: 'text-sub' },
                                                            elem['SQSJ']
                                                        )
                                                    )
                                                )
                                            );
                                        })
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                    'div',
                                    { className: 'text-center mt-50' },
                                    visible && formVisible && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,
                                        { type: 'primary', htmlType: 'submit', onClick: this.handleSubmit },
                                        '\u4FDD\u5B58'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                )
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__common__["a" /* default */], { hjmc: "专业调整", key: 'GD007_2', mkbz: 'GD007_2', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return Major;
}(__WEBPACK_IMPORTED_MODULE_21_react___default.a.Component)) || _class);


/***/ }),

/***/ 1074:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MajorForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__index_css__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_common_NHMultiSelect__ = __webpack_require__(249);















var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }









if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item;
var TextArea = __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a.TextArea;

var formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 }
};
var MajorForm = (_dec = __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(MajorForm, _React$Component);

    function MajorForm(props) {
        _classCallCheck(this, MajorForm);

        var _this = _possibleConstructorReturn(this, (MajorForm.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(MajorForm)).call(this, props));

        _this.getXsxx = function () {
            var xsid = _this.props.xsid;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/zytz/getXsxx', 'GET', { xsid: xsid }).then(function (resData) {
                if (resData && resData.data) {
                    _this.setState({ xsxxData: resData.data });
                }
            });
        };

        _this.getXyxxData = function () {
            var xsid = _this.props.xsid;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/zytz/get/options/by/params', 'GET', { xsid: xsid, tag: 'xy' }).then(function (res) {
                if (res) {
                    _this.setState({ xyxxData: res.data ? res.data : [] });
                }
            });
        };

        _this.handleXyxxChange = function (value) {
            var xsid = _this.props.xsid;
            var _this$props$form = _this.props.form,
                getFieldValue = _this$props$form.getFieldValue,
                setFieldsValue = _this$props$form.setFieldsValue;

            if (value && value.length > 0) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/zytz/get/options/by/params', 'GET', { xsid: xsid, tag: 'zy', filter: value.toString() }).then(function (res) {
                    if (res) {
                        if (res.data) {
                            var newData = res.data.map(function (item) {
                                return item.VALUE;
                            });
                            newData = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set___default.a(newData);
                            setFieldsValue({ zyids: [] });
                        }
                        _this.setState({ zyxxData: res.data ? res.data : [] });
                    }
                });
            } else {
                setFieldsValue({ zyids: [] });
                _this.setState({ zyxxData: [] });
            }
        };

        _this.loadZyData = function (bmid, zyid) {
            var xsid = _this.props.xsid;
            var setFieldsValue = _this.props.form.setFieldsValue;

            if (bmid) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/zytz/get/options/by/params', 'GET', { xsid: xsid, tag: 'zy', filter: bmid.toString() }).then(function (res) {
                    if (res) {
                        if (res.data) {
                            var newData = res.data.map(function (item) {
                                return item.VALUE;
                            });
                            newData = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set___default.a(newData);
                            if (newData.has(zyid)) {
                                setFieldsValue({ zyids: zyid });
                            }
                        }
                        _this.setState({ zyxxData: res.data ? res.data : [] });
                    }
                });
            }
        };

        _this.state = {
            xsxxData: {}, //学生信息,
            xyxxData: [], //学院下拉数据
            zyxxData: [] //专业下拉数据
        };
        return _this;
    }

    _createClass(MajorForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var _props$form = this.props.form,
                getFieldValue = _props$form.getFieldValue,
                setFieldsValue = _props$form.setFieldsValue,
                resetFields = _props$form.resetFields;
            var zytzPkid = this.props.zytzPkid;

            if (zytzPkid) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/zytz/getZytzInfo', 'GET', { pkid: zytzPkid }).then(function (resData) {
                    if (resData && resData.data) {
                        var data = resData.data;
                        var bmid = data['tzhyxid'];
                        var zyid = data['tzhzyid'];
                        var ly = data['sqly'];
                        setFieldsValue({
                            bmids: bmid,
                            ly: ly
                        });
                        _this2.loadZyData(bmid, zyid);
                    }
                });
            }

            this.getXsxx();
            this.getXyxxData();
        }

        //加载学院数据


        //部门信息选择回调

    }, {
        key: 'render',
        value: function render() {
            var getFieldDecorator = this.props.form.getFieldDecorator;
            var _state = this.state,
                xsxxData = _state.xsxxData,
                xyxxData = _state.xyxxData,
                zyxxData = _state.zyxxData,
                bjxxData = _state.bjxxData;

            return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                { align: 'start' },
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'app__css__app-pages-SelfHelp-majorFc-__index__modal_l' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                        { align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-majorFc-__index__modal_l_label' },
                            '\u8003\u751F\u53F7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['KSH'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                        { className: 'mt-10', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-majorFc-__index__modal_l_label' },
                            '\u6027\u522B\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['XB'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                        { className: 'mt-10', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-majorFc-__index__modal_l_label' },
                            '\u5F55\u53D6\u53F7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['LQH'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                        { className: 'mt-10', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-majorFc-__index__modal_l_label' },
                            '\u59D3\u540D\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['XM'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                        { className: 'mt-10', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-majorFc-__index__modal_l_label' },
                            '\u8EAB\u4EFD\u8BC1\u53F7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['SFZJH'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                        { className: 'mt-10', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-majorFc-__index__modal_l_label' },
                            '\u5B66\u53F7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                            null,
                            xsxxData ? xsxxData['XH'] : ''
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                    { className: 'app__css__app-pages-SelfHelp-majorFc-__index__modal_r' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,
                        null,
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,
                            { className: 'app__css__app-pages-SelfHelp-majorFc-__index__text-label', span: 6 },
                            '\u5B66\u9662\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,
                            { className: 'app__css__app-pages-SelfHelp-majorFc-__index__text-name', span: 18 },
                            xsxxData ? xsxxData['BMMC'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,
                        { className: 'mt-10' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,
                            { className: 'app__css__app-pages-SelfHelp-majorFc-__index__text-label', span: 6 },
                            '\u4E13\u4E1A\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,
                            { className: 'app__css__app-pages-SelfHelp-majorFc-__index__text-name', span: 18 },
                            xsxxData ? xsxxData['ZYMC'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,
                        { className: 'mt-10' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,
                            { className: 'app__css__app-pages-SelfHelp-majorFc-__index__text-label', span: 6 },
                            '\u73ED\u7EA7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_col___default.a,
                            { className: 'app__css__app-pages-SelfHelp-majorFc-__index__text-name', span: 18 },
                            xsxxData ? xsxxData['BJMC'] : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                        { className: 'app__css__app-pages-SelfHelp-majorFc-__index__line' },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item, { className: 'app__css__app-pages-SelfHelp-majorFc-__index__line_l' }),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-majorFc-__index__line_con' },
                            '\u7533\u8BF7\u4E13\u4E1A\u8C03\u6574'
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item, { className: 'app__css__app-pages-SelfHelp-majorFc-__index__line_r' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a,
                        null,
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            FormItem,
                            { style: { display: 'none' } },
                            getFieldDecorator('pkid', {
                                initialValue: this.props.zytzPkid
                            })(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, null))
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            FormItem,
                            _extends({}, formItemLayout, { label: '\u5B66\u9662' }),
                            getFieldDecorator('bmids', {
                                rules: [{
                                    required: true,
                                    message: '请选择学院'
                                }]
                            })(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_common_NHMultiSelect__["a" /* default */], { mode: 'default', dataSource: xyxxData, onChange: this.handleXyxxChange }))
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            FormItem,
                            _extends({}, formItemLayout, { label: '\u4E13\u4E1A' }),
                            getFieldDecorator('zyids', {
                                rules: [{
                                    required: true,
                                    message: '请选择专业'
                                }]
                            })(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_common_NHMultiSelect__["a" /* default */], { mode: 'default', dataSource: zyxxData }))
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_antd_lib_row___default.a,
                            { hidden: true },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                FormItem,
                                _extends({}, formItemLayout, { label: '\u73ED\u7EA7' }),
                                getFieldDecorator('bjids')(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_common_NHMultiSelect__["a" /* default */], { mode: 'default', dataSource: [] }))
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            FormItem,
                            _extends({}, formItemLayout, { label: '\u7533\u8BF7\u7406\u7531' }),
                            getFieldDecorator('ly')(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(TextArea, {
                                autosize: {
                                    minRows: 4,
                                    maxRows: 4
                                }
                            }))
                        )
                    )
                )
            );
        }
    }]);

    return MajorForm;
}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component)) || _class);


/***/ }),

/***/ 1075:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MajorFc; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_collapse_style__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_collapse_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_collapse_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_collapse__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_axios__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__index_css__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__form__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_SelfHelp_common_hint__ = __webpack_require__(35);























var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }












if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_29_history_createHashHistory___default()();
//确认对话框
var confirm = __WEBPACK_IMPORTED_MODULE_21_antd_lib_modal___default.a.confirm;
var Panel = __WEBPACK_IMPORTED_MODULE_19_antd_lib_collapse___default.a.Panel;
var FormItem = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;
var Option = __WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a.Option;
var TextArea = __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a.TextArea;










var MajorFc = (_dec = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(MajorFc, _React$Component);

    function MajorFc(props) {
        _classCallCheck(this, MajorFc);

        var _this = _possibleConstructorReturn(this, (MajorFc.__proto__ || __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default()(MajorFc)).call(this, props));

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_36__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.zytzList = function () {
            var params = {
                xsid: _this.state.xsid
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/zytz/getZytzList', "GET", params).then(function (res) {
                if (res && res.data) {
                    _this.setState({ data: res.data });
                }
            });
        };

        _this.checkRestrictions = function () {
            var params = {
                xsid: _this.state.xsid
                // 申请限制条件，可申请时默认返回false，不能申请时返回true，则表示不能进行申请
            };__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/zytz/check/apply/condition', "GET", params).then(function (res) {
                if (res && res.data) {
                    _this.setState({
                        restrictionMessage: res.data,
                        restrictionFlag: false
                    });
                }
            });
        };

        _this.deleteTip = function (pkid) {
            confirm({
                title: '提示',
                content: '是否确定删除该条申请数据',
                okText: '确定',
                cancelText: '取消',
                okType: 'danger',
                iconType: 'info-circle',
                onOk: function onOk() {
                    _this.delete(pkid);
                },
                onCancel: function onCancel() {}
            });
        };

        _this.delete = function (pkid) {
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/zytz/deleteById', "POST", { pkid: pkid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data == 1) {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.success('删除成功.');
                    _this.reloadMenu();
                    _this.setState({ visible: false });
                    _this.zytzList(); //重新加载
                } else {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn('删除异常');
                }
                _this.zytzList(); //重新查询
            }).catch(function (err) {
                __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn('删除异常');
            });
        };

        _this.showModal = function () {
            var zytzPkid = _this.state.zytzPkid;
            var data = _this.state.data;
            if (zytzPkid) {
                _this.setState({
                    visible: true
                });
            } else {
                var xsid = _this.state.xsid;
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/zytz/select/apply/status', "GET", { xsid: xsid }).then(function (res) {
                    if (res && res.data !== null) {
                        // 审核状态，0待审核，1审核通过，-1审核不通过，2现场办理，3回退（驳回），4放弃申请
                        ['1'].includes(res.data) && __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn('您已申请过专业调整，申请通过后不可以再进行申请！');
                        ['-1'].includes(res.data) && __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn('您已申请过专业调整，申请不通过后不可以再进行申请！');
                        ['0', '2', '4'].includes(res.data) && __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn("已存在专业调整申请状态未完成，待完成后再申请！");
                        if (['3'].includes(res.data) && data && data.length > 0) {
                            var pkid = data[0].PKID;
                            __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn("您最新申请的专业调整已驳回，可进行修改后再申请！");
                            _this.setState({
                                zytzPkid: pkid,
                                visible: true
                            });
                        }
                    } else {
                        _this.setState({
                            visible: true
                        });
                    }
                });
            }
        };

        _this.handleCancel = function () {
            _this.setState({
                visible: false
            });
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.setState({
                confirmLoading: true
            });
            var zzbdhjid = _this.getQueryString('pkid');
            _this.form.validateFields(function (err, values) {
                if (err) {
                    _this.setState({
                        confirmLoading: false
                    });
                    return false;
                }

                var bmid = values['bmids'];
                var zyid = values['zyids'];
                var pkid = values['pkid'];
                var bjid = '';
                if (values['bjids'] && values['bjids'].length > 0) {
                    bjid = values['bjids'];
                }

                var sqly = values['ly'];

                var params = {
                    zzbdhjid: zzbdhjid,
                    zytzDTO: {

                        tzhyxid: bmid,
                        tzhzyid: zyid,
                        tzhbjid: bjid,
                        sqly: sqly,
                        pkid: pkid
                    }
                };
                if (pkid) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/zytz/update', "POST", params).then(function (res) {
                        if (res && res.data && res.data == 1) {
                            __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.success("修改成功！");
                            _this.reloadMenu();
                            _this.setState({ visible: false });
                            _this.zytzList(); //重新加载
                        } else {
                            __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn("修改异常！");
                            _this.setState({ confirmLoading: false });
                        }
                        _this.setState({ confirmLoading: false });
                    }).catch(function (res) {
                        _this.setState({ confirmLoading: false });
                        __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn("修改异常！");
                        return res;
                    });
                } else {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_NHFetch__["a" /* default */])('/zytz/insert', "POST", params).then(function (res) {
                        if (res && res.data && res.data == 1) {
                            __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.success("保存成功！");
                            _this.reloadMenu();
                            _this.setState({ visible: false });
                            _this.zytzList(); //重新加载
                        } else {
                            __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn("保存异常！");
                            _this.setState({ confirmLoading: false });
                        }
                        _this.setState({ confirmLoading: false });
                    }).catch(function (res) {
                        _this.setState({ confirmLoading: false });
                        __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warn("保存异常！");
                        return res;
                    });
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD007_3',
            hjmc: '',
            data: [],
            visible: false,
            confirmLoading: false,
            xsid: '',
            zytzPkid: '',
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据

            restrictionMessage: {},
            restrictionFlag: true
        };
        return _this;
    }

    _createClass(MajorFc, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHCore__["b" /* getLoginUser */])().userId;
            this.setState({ xsid: xsid });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            // 校验专业调整申请限制条件
            this.checkRestrictions();
            this.queryQztjAndYlhj();
            this.zytzList();
        }

        //查询前置条件和依赖环节


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                visible = _state.visible,
                confirmLoading = _state.confirmLoading,
                mkbz = _state.mkbz,
                restrictionFlag = _state.restrictionFlag,
                restrictionMessage = _state.restrictionMessage;

            return __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                'div',
                null,
                restrictionFlag ? this.state.operable ? __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */],
                        { className: 'w1180 mt-20', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__pages_Assembly_siderMenu__["a" /* default */], {
                            ref: "siderMenu",
                            title: '\u81EA\u52A9\u62A5\u5230',
                            setMenuList: this.setMenuList
                            /*      active={6}*/
                            , mkbz: this.state.mkbz,
                            menuType: '\u81EA\u52A9\u62A5\u5230' }),
                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */].Item,
                            { className: 'page_con_r ' },
                            __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__pages_Assembly_Breadcrumb__["a" /* default */], {
                                noLine: true,
                                list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                            }),
                            __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                'div',
                                { className: 'box' },
                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__pages_SelfHelp_common_hint__["a" /* default */], null),
                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__pages_Assembly_titleTop__["a" /* default */], {
                                    className: 'mt-20',
                                    title: this.state.hjmc,
                                    extra: false,
                                    apply: true,
                                    onApplyClick: function onApplyClick() {
                                        _this2.setState({ zytzPkid: '' }, function () {
                                            _this2.showModal();
                                        });
                                    }
                                }),
                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                    'div',
                                    { className: 'p-sw' },
                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_19_antd_lib_collapse___default.a,
                                        { accordion: true, defaultActiveKey: ['0'] },
                                        this.state.data.map(function (elem, index) {
                                            // let tzqxx = elem.TZQYXMC + " - " + elem.TZQZYMC + " - " + elem.TZQBJMC;
                                            var tzqxx = void 0;
                                            if (elem.TZQBJMC != undefined) {
                                                tzqxx = elem.TZQYXMC + " - " + elem.TZQZYMC + " - " + elem.TZQBJMC;
                                            } else {
                                                tzqxx = elem.TZQYXMC + " - " + elem.TZQZYMC;
                                            }
                                            var tzhxx = '' + elem.TZHYXMC + (elem.TZHZYMC ? ' - ' + elem.TZHZYMC : '') + (elem.TZHBJMC ? ' - ' + elem.TZHBJMC : '');
                                            return __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                Panel,
                                                {
                                                    header: __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */],
                                                        null,
                                                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */].Item,
                                                            null,
                                                            '\u7533\u8BF7\u4EBA\uFF1A',
                                                            __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                                'span',
                                                                { className: 'text-blue' },
                                                                elem['XM']
                                                            )
                                                        ),
                                                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */].Item,
                                                            null,
                                                            '\u6027\u522B\uFF1A',
                                                            elem['XB']
                                                        ),
                                                        elem['ZT'] == '0' ? __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */].Item,
                                                            { className: 'text-right' },
                                                            __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon___default.a, {
                                                                style: {
                                                                    color: '#0273fd'
                                                                },
                                                                type: 'edit',
                                                                onClick: function onClick(e) {
                                                                    e.stopPropagation();
                                                                    _this2.setState({ zytzPkid: elem['PKID'] }, function () {
                                                                        _this2.showModal();
                                                                    });
                                                                }
                                                            })
                                                        ) : __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */].Item, { className: 'text-right' })
                                                    ),
                                                    key: index
                                                },
                                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_row___default.a,
                                                    null,
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                                        {
                                                            className: 'app__css__app-pages-SelfHelp-majorFc-__index__coll_label',
                                                            span: 4
                                                        },
                                                        '\u8C03\u6574\u524D\uFF1A'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                                        { span: 20 },
                                                        tzqxx
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_row___default.a,
                                                    { className: 'mt-10' },
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                                        {
                                                            className: 'app__css__app-pages-SelfHelp-majorFc-__index__coll_label',
                                                            span: 4
                                                        },
                                                        '\u8C03\u6574\u540E\uFF1A'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                                        { span: 20 },
                                                        tzhxx
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_row___default.a,
                                                    { className: 'mt-10' },
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                                        {
                                                            className: 'app__css__app-pages-SelfHelp-majorFc-__index__coll_label',
                                                            span: 4
                                                        },
                                                        '\u8C03\u6574\u7406\u7531\uFF1A'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                                        { span: 20 },
                                                        elem['SQLY']
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_25__components__["a" /* Flex */],
                                                    {
                                                        justify: 'between',
                                                        className: 'app__css__app-pages-SelfHelp-majorFc-__index__coll_b'
                                                    },
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        'div',
                                                        null,
                                                        '\u7533\u8BF7\u72B6\u6001\uFF1A',
                                                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                            'span',
                                                            { className: 'text-primary' },
                                                            elem['SHZT'] === '回退' ? '已驳回' : elem['SHZT']
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                        'div',
                                                        null,
                                                        '\u7533\u8BF7\u65F6\u95F4\uFF1A',
                                                        __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                                            'span',
                                                            { className: 'text-sub' },
                                                            elem['SQSJ']
                                                        )
                                                    )
                                                )
                                            );
                                        })
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                                    'div',
                                    { className: 'text-center mt-50' },
                                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_21_antd_lib_modal___default.a,
                        {
                            className: 'modal_body_0',
                            title: '\u4E13\u4E1A\u8C03\u6574\u7F16\u8F91',
                            width: 820,
                            visible: visible,
                            onOk: this.handleSubmit,
                            confirmLoading: confirmLoading,
                            onCancel: this.handleCancel
                        },
                        visible && __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__form__["a" /* default */], { xsid: this.state.xsid, zytzPkid: this.state.zytzPkid, ref: function ref(form) {
                                _this2.form = form;
                            }, xsxxData: this.state.xsxxData })
                    )
                ) : __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__common__["a" /* default */], { hjmc: "专业调整", key: mkbz, mkbz: mkbz, nonOperationalData: this.state.nonOperationalData }) : __WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__common__["a" /* default */], { hjmc: "专业调整", key: mkbz, mkbz: mkbz, nonOperationalData: restrictionMessage })
            );
        }
    }]);

    return MajorFc;
}(__WEBPACK_IMPORTED_MODULE_22_react___default.a.Component)) || _class);


/***/ }),

/***/ 1076:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return antiepidemic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_SelfHelp_common_hint__ = __webpack_require__(35);












var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }
















var history = __WEBPACK_IMPORTED_MODULE_20_history_createHashHistory___default()();

var basicUrl = "api/zhxg-yxxt/yxwz";
var FormItem = __WEBPACK_IMPORTED_MODULE_10_antd_lib_form___default.a.Item;

var formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 }
};

var antiepidemic = (_dec = __WEBPACK_IMPORTED_MODULE_10_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(antiepidemic, _React$Component);

    function antiepidemic(props) {
        _classCallCheck(this, antiepidemic);

        var _this = _possibleConstructorReturn(this, (antiepidemic.__proto__ || __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_prototype_of___default()(antiepidemic)).call(this, props));

        _this.checkIsZzbdHjLinked = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this.getQueryString('pkid');

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHFetch__["a" /* default */])("/zzbdCommon/checkIsZzbdHjLinked", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.code === 200) {
                    if (res.data) {
                        _this.setState({
                            editable: false
                        });
                    } else {
                        //查询第三方财务信息，判断医疗保险环节是否已经缴费
                        _this.synchronousMedicalInsuranceInfo(xsid);
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default.a.error("查询环节办理状态失败，请稍后再试");
                }
            });
        };

        _this.synchronousMedicalInsuranceInfo = function (stuId) {
            var linkCode = _this.state.mkbz;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHFetch__["a" /* default */])('/medicalInsurance/synchronousMedicalInsuranceInfo', 'GET', { stuId: stuId, linkCode: linkCode }).then(function (res) {
                if (res && res.code === 200) {
                    if (res.data === 1) {
                        _this.commonSaveLinkTransactionStatus();
                    } else {
                        _this.setState({ editable: true });
                    }
                } else {
                    _this.setState({ editable: false });
                    __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default.a.error("同步医疗保险环节信息接口异常，请联系管理员处理！");
                }
            });
        };

        _this.queryInitData = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHFetch__["a" /* default */])('/medicalInsurance/queryInitData', 'GET', { xsid: xsid }).then(function (res) {
                if (res && res.code === 200) {
                    if (res.data) {
                        _this.setState({
                            initData: res.data
                        });
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default.a.error("查询初始化数据失败，请稍后再试");
                }
            });
        };

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_22__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.handleSubmit = function (e) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var mkbz = _this.state.mkbz;

            e.preventDefault();
            _this.props.form.validateFieldsAndScroll(function (err, values) {
                if (err) {
                    return;
                }
                values.xsid = xsid;
                values.hjdm = mkbz;
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHFetch__["a" /* default */])('/medicalInsurance/saveMedicalInsuranceInfo', 'POST', values).then(function (res) {
                    if (res && res.code === 200) {
                        if (res.data === 1) {
                            _this.commonSaveLinkTransactionStatus();
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default.a.success("保存成功");
                        } else {
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default.a.error("保存失败，请联系管理员");
                        }
                    } else {
                        __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default.a.error("网络异常，请稍后再试");
                    }
                });
            });
        };

        _this.commonSaveLinkTransactionStatus = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : "";
            var zzbdhjid = _this.getQueryString("pkid");
            var params = { xsid: xsid, zzbdhjid: zzbdhjid };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHFetch__["a" /* default */])("/zzbdCommon/commonSaveLinkTransactionStatus", "POST", params).then(function (res) {
                if (res) {
                    if (res.data === 1) {
                        _this.setState({ editable: false });
                        _this.reloadMenu();
                        _this.queryInitData();
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default.a.error("办理环节失败，请稍后重试！");
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD024_1',
            hjmc: '',
            editable: false,
            update: false,
            initData: {
                sfjnylbx: ''
            },
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            isHide: true
        };
        return _this;
    }

    //渲染前获取信息


    _createClass(antiepidemic, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.checkIsZzbdHjLinked();
            this.queryQztjAndYlhj();
            this.queryInitData();
        }

        //检查该环节是否已经办理


        //查询初始化数据


        //查询前置条件和依赖环节


        //自动办理环节


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var getFieldDecorator = this.props.form.getFieldDecorator;
            var _state = this.state,
                editable = _state.editable,
                initData = _state.initData;

            return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_12__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230'
                        /* active={3}*/
                        , mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_12__components__["a" /* Flex */].Item,
                        { className: 'page_con_r ' },
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjmc, extra: false }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_10_antd_lib_form___default.a,
                                { onSubmit: this.handleSubmit },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'div',
                                    { className: 'p-sw' },
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_12__components__["a" /* Flex */],
                                        { align: 'start', wrap: 'wrap' },
                                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u662F\u5426\u7F34\u7EB3\u533B\u7597\u4FDD\u9669',
                                                    labelAlign: 'left'
                                                }),
                                                getFieldDecorator('sfjnylbx', {
                                                    initialValue: initData.sfjnylbx ? initData.sfjnylbx : '',
                                                    rules: [{
                                                        required: true,
                                                        message: '请选择...'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_common_NHSelect__["a" /* default */], { dataSource: [{ value: '1', label: '是' }, { value: '0', label: '否' }] }) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initData.sfjnylbx === '1' ? '是' : '否'
                                                ))
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        editable ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,
                                            { type: 'primary', htmlType: 'submit' },
                                            '\u4FDD\u5B58'
                                        ) : '',
                                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                )
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__common__["a" /* default */], { hjmc: "是否缴纳医疗保险", key: 'GD024_1', mkbz: 'GD024_1', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return antiepidemic;
}(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component)) || _class);


/***/ }),

/***/ 1077:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dorm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_result_style__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_result_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_result_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_result__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_result___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_result__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_checkbox_style__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_checkbox__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_getSize__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_common_NHModal__ = __webpack_require__(106);

















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }








// import SelectBox from './selectBox';
// import SelectModal from './selectModal';










var history = __WEBPACK_IMPORTED_MODULE_25_history_createHashHistory___default()();
var confirm = __WEBPACK_IMPORTED_MODULE_15_antd_lib_modal___default.a.confirm;
var CheckboxGroup = __WEBPACK_IMPORTED_MODULE_13_antd_lib_checkbox___default.a.Group;
var RadioGroup = __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default.a.Group;

/**
 * @author weishihuai
 * @date 2018/7/6
 * @time 14:41
 * @Description: 迎新网站-自助报到-宿舍分配
 */

var Dorm = function (_React$Component) {
    _inherits(Dorm, _React$Component);

    function Dorm(props) {
        _classCallCheck(this, Dorm);

        var _this2 = _possibleConstructorReturn(this, (Dorm.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(Dorm)).call(this, props));

        _this2.getMojorInfo = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])("/zdybl/getXsxxAndLcidByXsid", 'GET', { xsid: xsid }).then(function (res) {
                if (res.code == "200") {
                    _this2.setState({
                        XsxxData: res.data
                    }, function () {
                        _this2.checkZzbdisLinked();
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error("获取专业信息接口失败");
                }
            });
        };

        _this2.updateZzbdBlzt = function () {
            var zzbdhjid = _this2.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])('/zzbd/updateZzbdBlzt', 'GET', { zzbdhjid: zzbdhjid, hjdm: 'GD031' }).then(function (res) {
                if (res.data) {
                    _this2.reloadMenu();
                }
            });
        };

        _this2.queryQztjAndYlhj = function (callback) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this2.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this2.getUrlParams('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this2.setState({ nonOperationalData: res.data });
                    if (kfsj && kfsj['YXSJ'] != '1') {
                        _this2.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this2.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this2.setState({ operable: false });
                    }

                    if (callback) {
                        callback(_this2.state.operable);
                    }
                }
            });
        };

        _this2.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this2.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this2.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_29__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this2.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this2.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this2.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this2.getUrlParams = function (param) {
            return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this2.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this2.checkZzbdisLinked = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this2.getUrlParams("pkid");
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])("/zzbdCommon/checkIsZzbdHjLinked", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res) {
                    if (res.data) {
                        _this2.setState({
                            isHjLinked: res.data
                        });
                    } else {
                        _this2.getStatusData();
                        /* this.setState({
                            isHjLinked: false
                        }) */
                    }
                } else {
                    _this2.setState({
                        isHjLinked: false
                    });
                }
            });
        };

        _this2.getStatusData = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])("api/zhxg-yxxt/yxwz/zzbd/xljkztpc/getXljkztpcJgByXsid", 'GET', { xsid: xsid }).then(function (res) {
                if (res) {
                    if (res.data) {
                        console.log("666666666666666666616----", res.data);
                        if (res.data.data) {
                            console.log("666666666666666662666----", res.data.data);
                            // if(res.data.data.normal){
                            // console.log("666666666666636666666----",res.data.data);
                            _this2.hjblBtnClick();
                            // }else{
                            // this.setState({
                            // isHjLinked: false
                            // })
                            // }
                        } else {
                            _this2.setState({
                                isHjLinked: false
                            });
                        }
                    } else {
                        _this2.setState({
                            isHjLinked: false
                        });
                    }
                } else {
                    _this2.setState({
                        isHjLinked: false
                    });
                }
            });
        };

        _this2.hjblBtnClick = function () {
            var XsxxData = _this2.state.XsxxData;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this2.getQueryString('pkid');
            var formData = { xsid: xsid, yhid: xsid, zzbdhjid: zzbdhjid, lchjid: XsxxData.LCID };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])('/zdybl/saveCustomLinkData', "POST", formData).then(function (res) {
                if (res) {
                    if (res.data == '1') {
                        _this2.setState({
                            isHjLinked: true
                        }, function () {
                            _this2.reloadMenu();
                        });
                    } else {
                        _this2.setState({
                            isHjLinked: false
                        });
                    }
                }
            });
        };

        _this2.reloadMenu = function () {
            _this2.refs.siderMenu.reloadMenuList();
        };

        _this2.handleBtnClick = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])("api/zhxg-yxxt/yxwz/zzbd/xljkztpc/getSsoParamByXsid", 'GET', { xsid: xsid }).then(function (res) {
                if (res) {
                    console.log("办理跳转-------", res);
                    var newwin = void 0;
                    if (res.data) {
                        if (res.data.dddlUrl) {
                            newwin = window.open(res.data.dddlUrl);
                        }
                    } else {
                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error("心理健康咨询办理失败！");
                    }
                }
            });
        };

        _this2.state = {
            mkbz: 'GD031',
            hjmc: '',
            xzId: '',
            _xzId: '',
            cwsList: [], //床位数
            sfbzList: [], //收费标准
            xqList: [], //校区信息
            currentXqid: "", //当前校区ID
            fjxxList: [], //房间信息
            currentClickCwPkid: "", //当前床位信息ID
            xsssruYwxx: {}, //学生宿舍入住业务信息
            isHjLinked: false, //环节是否办理状态
            param: {}, //过滤条件
            scrollHeight: 200, //默认滚动高度
            loginUserInfo: {}, //当前登录学生信息
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            autoBlLoading: false, //自动办理按钮载入状态
            cancelLoading: false, //取消办理按钮载入状态
            zdrzLoading: false, //自动入住载入状态
            setRoom: [], //过滤房间信息
            sfbz: "", //收费标准选中值
            XsxxData: {}
        };
        return _this2;
    }

    _createClass(Dorm, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var that = this;
            this.setState({ scrollHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_getSize__["a" /* default */])().windowH - 206 });
            window.onresize = function () {
                that.setState({
                    scrollHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_getSize__["a" /* default */])().windowH - 206
                });
            };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            this.queryQztjAndYlhj(function (operable) {
                if (operable) {
                    var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId : '';
                    if (xsid) {
                        var _this = _this3;
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["d" /* getLoginUserInfo */])(xsid, function (data) {
                            _this.setState({
                                loginUserInfo: data
                            }, function () {
                                var loginUserInfo = _this.state.loginUserInfo;

                                var xqid = loginUserInfo.XQID,
                                    xbm = loginUserInfo.XBM;

                                if (xsid) {
                                    //办理状态根据 关联现场环节和是否反向关联修改 不根据现场状态
                                    //_this.updateZzbdBlzt();
                                    //加载收费标准、床位数信息
                                    //如果学生校区ID不为空,则只加载本校区宿舍信息
                                    if (xqid) {
                                        _this.setState({
                                            currentXqid: xqid
                                        });
                                    }
                                }
                            });
                        });
                    }
                }
            });
            this.getMojorInfo();
        }

        // 获取流程信息接口


        //迎新现场已办理时迎新网站自动办理


        //查询前置条件和依赖环节


        //获取url中传递的参数

        //检查环节是否已办理


        //判断心理状态的接口


        // 环节办理接口


        //重新加载菜单


        // 心里健康外部接口

    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var isHjLinked = this.state.isHjLinked;

            return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_19__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230',
                        mkbz: this.state.mkbz
                        /*   active={5}*/
                        , menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_19__components__["a" /* Flex */].Item,
                        { className: 'page_con_r ' },
                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1037811784' + ' ' + 'box'
                            },
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__pages_Assembly_titleTop__["a" /* default */], {
                                className: 'mt-20',
                                title: this.state.hjmc,
                                extra: false
                            }),
                            isHjLinked && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                'div',
                                { style: { margin: "15px" }, className: 'jsx-1037811784'
                                },
                                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_result___default.a, {
                                    status: 'success',
                                    title: '\u5DF2\u5B8C\u6210\u5FC3\u7406\u5065\u5EB7\u72B6\u6001\u666E\u67E5\u586B\u5199'
                                })
                            ),
                            !isHjLinked && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                'div',
                                { style: { margin: "15px" }, className: 'jsx-1037811784'
                                },
                                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_result___default.a, {
                                    title: '\u672A\u5B8C\u6210\u5FC3\u7406\u5065\u5EB7\u72B6\u6001\u666E\u67E5\u586B\u5199\uFF0C\u8BF7\u70B9\u51FB\u529E\u7406\u6309\u94AE\u8FDB\u884C\u586B\u5199'
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1037811784' + ' ' + 'text-center mt-50'
                                },
                                !isHjLinked && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                                    { type: 'primary', onClick: function onClick() {
                                            _this4.handleBtnClick();
                                        } },
                                    '\u529E\u7406'
                                ),
                                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_styled_jsx_style___default.a, {
                            styleId: '1037811784',
                            css: ['.ant-result-title{font-size:20px!important;}']
                        })
                    )
                ) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__common__["a" /* default */], { hjmc: "心理健康普查", key: 'GD031', mkbz: 'GD031', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return Dorm;
}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);



/***/ }),

/***/ 1078:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__utils_RegExp__);













var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }










if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var uploadUrl = "api/zhxg-yxwz/newStudent/cacheStudentPhoto"; //上传logo路径


// 上传之前调用
function beforeUpload(file) {
    var isJPG = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJPG) {
        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error('You can only upload JPG/PNG file!');
    }
    var sizeMin = 1024 * 60; //限制文件最小值（60k）
    var sizeMax = 1024 * 1024 * 1; //限制文件最大值(1M)
    var isSize = file.size > sizeMin && file.size < sizeMax;
    if (!isSize) {
        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("文件不能小于60k或者大于1M!");
    }
    return isJPG && isSize;
}

var JbxxInitForm = function (_React$Component) {
    _inherits(JbxxInitForm, _React$Component);

    function JbxxInitForm(props) {
        _classCallCheck(this, JbxxInitForm);

        var _this = _possibleConstructorReturn(this, (JbxxInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(JbxxInitForm)).call(this, props));

        _this.getStudentPhotoBase64 = function (userId, callback) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/openapi/student/getStudentPhotoBase64', 'get', { xsid: userId, type: 10 }).then(function (res) {
                if (res && res.code == 200) {
                    callback(res.data);
                }
            });
        };

        _this.onSavejbxxFormData = function (cb) {
            _this.props.form.validateFields(function (error, values) {
                if (error) {
                    cb(false);
                    return;
                }
                cb(true);
                var cacheFormData = _this.props.cacheFormData;

                if (_this.state.jtStr !== '') {
                    values.jtdzDetail = _this.state.jtStr;
                } else {
                    values.jtdzDetail = _this.props.jbxxFormData ? _this.props.jbxxFormData.jtdzDetail ? _this.props.jbxxFormData.jtdzDetail : "" : "";
                }
                cacheFormData('jbxx', values);
                _this.setState({
                    jbxx: false
                });
            });
        };

        _this.handleUploadChange = function (info) {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (info && info['file'] && info['file'].status === 'done') {
                var photoUUID = info['file'].response.data;
                if (photoUUID) {
                    var url = '/newStudent/saveStudentPhoto?xsid=' + userId + '&photoUUID=' + photoUUID + '&type=' + '10';
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])(url, 'POST').then(function (res) {
                        if (res && res.data) {
                            console.log('头像上传成功响应:', res);
                            __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.success("上传成功!");
                        }
                    });
                }
            }
            _this.getBase64(info.file.originFileObj, function (imageUrl) {
                return _this.setState({ imageUrl: imageUrl });
            });
        };

        _this.onNHCascaderChange = function (value, selectedOptions, type) {
            var label = '';
            if (selectedOptions) {
                selectedOptions.forEach(function (i) {
                    label += i.label;
                });
            }
            if (type == 'jg') {
                _this.setState({ jgmStr: label });
            } else {
                _this.setState({ jtStr: label });
            }
        };

        _this.state = {
            jbxx: false,
            xsid: '',
            userInfoData: null,
            zzmmmList: [],
            mzmList: [],
            textData: '',
            jgmStr: '',
            jtStr: '',
            xsSsInfo: ''
        };
        return _this;
    }

    _createClass(JbxxInitForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                this.getStudentPhotoBase64(userId, function (data) {
                    if (!data) return;
                    _this2.setState({
                        xsid: userId,
                        imageUrl: 'data:image/jpeg;base64,' + data
                    });
                });
            }
        }

        // 获取学生头像


        // 保存信息

    }, {
        key: 'getBase64',

        // 获取bs64图片
        value: function getBase64(file, callback) {
            if (!file) return;
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(file);
        }
        // 上传图片

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                form = _props.form,
                jbxxFormData = _props.jbxxFormData,
                getChildComponent = _props.getChildComponent,
                userInfoData = _props.userInfoData,
                stuSsxx = _props.stuSsxx,
                editXszp = _props.editXszp,
                studentOtherInfo = _props.studentOtherInfo;
            var _state = this.state,
                jbxx = _state.jbxx,
                imageUrl = _state.imageUrl,
                tempUrl = _state.tempUrl,
                xsid = _state.xsid;

            var jtjddz = jbxxFormData ? jbxxFormData.jtjddz : '';
            var jtdzDetail = jbxxFormData ? jbxxFormData.jtdzDetail : '';
            var jjlxr = jbxxFormData ? jbxxFormData.jjlxr : '';
            var jjlxdh = jbxxFormData ? jbxxFormData.jjlxdh : '';

            var ssxx = '';
            if (stuSsxx && stuSsxx.xqmc && stuSsxx.ldmc && stuSsxx.fj && stuSsxx.cwh) {
                ssxx = stuSsxx.xqmc + stuSsxx.ldmc + ' - ' + stuSsxx.fj + ' - ' + stuSsxx.cwh;
            }
            return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a,
                { layout: 'inline' },
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u57FA\u672C\u4FE1\u606F'
                    // 点击编辑
                    , onEdit: function onEdit(_) {
                        _this3.setState({
                            jbxx: true
                        });
                        getChildComponent(1, false);
                    }
                    // 点击保存
                    , onSave: function onSave(cb) {
                        _this3.onSavejbxxFormData(cb);
                        getChildComponent(1, true);
                    }
                    // 点击取消
                    , onClose: function onClose(_) {
                        _this3.setState({
                            jbxx: false
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + '_bg app__css__app-pages-SelfHelp-newInfo-__index__jbxx_icon'
                        },
                        jbxx && editXszp === "true" ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default.a,
                            {
                                name: 'photo',
                                accept: 'image/*',
                                showUploadList: false,
                                className: 'avatar-uploader',
                                action: uploadUrl + "?xsid=" + xsid,
                                beforeUpload: beforeUpload,
                                onChange: this.handleUploadChange
                            },
                            imageUrl || userInfoData ? imageUrl ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
                                src: imageUrl,
                                alt: '',
                                className: 'jsx-1702183314' + ' ' + 'avatar'
                            }) : tempUrl : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__upload-box'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__upload-title'
                                    },
                                    '\u4E0A\u4F20\u56FE\u7247'
                                )
                            )
                        ) : imageUrl ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
                            src: imageUrl,
                            alt: '',
                            className: 'jsx-1702183314' + ' ' + 'avatar'
                        }) : tempUrl
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */].Item,
                        { className: 'ml-20' },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                                },
                                '\u59D3\u540D\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-newInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.XM : '',
                                userInfoData && userInfoData.XB ? userInfoData.XB === '男' ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(141), alt: '', className: 'jsx-1702183314'
                                }) : userInfoData.XB === '女' ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(142), alt: '', className: 'jsx-1702183314'
                                }) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(143), alt: '', className: 'jsx-1702183314'
                                }) : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                                },
                                '\u5B66\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-newInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.XH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                                },
                                '\u8003\u751F\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-newInfo-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.ksh : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                                },
                                '\u8EAB\u4EFD\u8BC1\u4EF6\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-newInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.SFZJH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                                },
                                '\u51FA\u751F\u5E74\u6708\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-newInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.CSRQ : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                                },
                                '\u653F\u6CBB\u9762\u8C8C\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-newInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.ZZMM : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                                },
                                '\u6C11\u65CF\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-newInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.MZ : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                                },
                                '\u7C4D\u8D2F\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-newInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.JG : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                                },
                                '\u6BD5\u4E1A\u5B66\u6821\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-newInfo-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.byzx : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                                },
                                '\u9AD8\u8003\u5206\u6570\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-newInfo-__index__item-name'
                                },
                                studentOtherInfo ? studentOtherInfo.GKCJ : ''
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    'div',
                    {
                        className: 'jsx-1702183314' + ' ' + 'p-swc'
                    },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                            },
                            '\u5B66\u9662\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-newInfo-__index__item-name'
                            },
                            userInfoData ? userInfoData.BMMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                            },
                            '\u4E13\u4E1A\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-newInfo-__index__item-name'
                            },
                            userInfoData ? userInfoData.ZYMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                            },
                            '\u73ED\u7EA7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-newInfo-__index__item-name'
                            },
                            userInfoData ? userInfoData.BJMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                            },
                            '\u5B66\u9662\u4EE3\u7801\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-newInfo-__index__item-name'
                            },
                            studentOtherInfo ? studentOtherInfo.BMDM : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                            },
                            '\u4E13\u4E1A\u4EE3\u7801\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-newInfo-__index__item-name'
                            },
                            studentOtherInfo ? studentOtherInfo.ZYDM : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                            },
                            '\u73ED\u7EA7\u4EE3\u7801\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-newInfo-__index__item-name'
                            },
                            studentOtherInfo ? studentOtherInfo.BJDM : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                            },
                            '\u5B66\u751F\u7C7B\u522B\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-newInfo-__index__item-name'
                            },
                            studentOtherInfo ? studentOtherInfo.XSLB : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                            },
                            '\u5BBF\u820D\u4FE1\u606F\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-newInfo-__index__item-name'
                            },
                            ssxx
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item2'
                        },
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                            { id: 'sjhm',
                                label: __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                                    },
                                    '\u672C\u4EBA\u8054\u7CFB\u7535\u8BDD\uFF1A'
                                ),
                                colon: false,
                                form: form,
                                required: true
                                // hasFeedback={true} 
                                // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/, message: "请输入正确的手机号码或电话号码" }}
                                , pattern: __WEBPACK_IMPORTED_MODULE_20__utils_RegExp__["FormRules"].MOBILE_PHONE_NUMBER,
                                initialValue: jbxxFormData ? jbxxFormData.sjhm : ""
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u8054\u7CFB\u7535\u8BDD' })
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'red' }, className: 'jsx-1702183314'
                                    },
                                    '*'
                                ),
                                '\u672C\u4EBA\u8054\u7CFB\u7535\u8BDD\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-newInfo-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.sjhm : ''
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item2'
                        },
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                            { id: 'jjlxr',
                                label: __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                                    },
                                    '\u7D27\u6025\u8054\u7CFB\u4EBA\uFF1A'
                                ),
                                colon: false,
                                form: form,
                                required: true
                                // hasFeedback={true}
                                , initialValue: jjlxr ? jjlxr : studentOtherInfo.JJLXR
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u7D27\u6025\u8054\u7CFB\u4EBA' })
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'red' }, className: 'jsx-1702183314'
                                    },
                                    '*'
                                ),
                                '\u7D27\u6025\u8054\u7CFB\u4EBA\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-newInfo-__index__item-name'
                                },
                                jjlxr ? jjlxr : studentOtherInfo.JJLXR
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item2'
                        },
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                            { id: 'jjlxdh',
                                label: __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                                    },
                                    '\u7D27\u6025\u8054\u7CFB\u7535\u8BDD\uFF1A'
                                ),
                                colon: false,
                                form: form,
                                required: true
                                // hasFeedback={true}
                                // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/, message: "请输入正确的手机号码或电话号码" }}
                                , pattern: __WEBPACK_IMPORTED_MODULE_20__utils_RegExp__["FormRules"].MOBILE_PHONE_NUMBER,
                                initialValue: jjlxdh ? jjlxdh : studentOtherInfo.JJLXDH
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u7D27\u6025\u8054\u7CFB\u7535\u8BDD' })
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'red' }, className: 'jsx-1702183314'
                                    },
                                    '*'
                                ),
                                '\u7D27\u6025\u8054\u7CFB\u7535\u8BDD\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-newInfo-__index__item-name'
                                },
                                jjlxdh ? jjlxdh : studentOtherInfo.JJLXDH
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__detail_adrress'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            { style: { lineHeight: '32px' }, className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-newInfo-__index__item-label'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                { style: { color: 'red' }, className: 'jsx-1702183314'
                                },
                                '*'
                            ),
                            '\u751F\u6E90\u5730\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-newInfo-__index__item-name'
                            },
                            jtdzDetail ? jtdzDetail : '',
                            jtjddz ? jtjddz : ''
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_styled_jsx_style___default.a, {
                    styleId: '1702183314',
                    css: ['.ant-col-md-7{width:100px;}']
                })
            );
        }
    }]);

    return JbxxInitForm;
}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);

var JbxxForm = __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a.create()(JbxxInitForm);

/* harmony default export */ __webpack_exports__["a"] = (JbxxForm);

/***/ }),

/***/ 1079:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_css__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__JbxxForm__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_SelfHelp_common_hint__ = __webpack_require__(35);








var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var NewInfo = function (_React$Component) {
    _inherits(NewInfo, _React$Component);

    function NewInfo(props) {
        _classCallCheck(this, NewInfo);

        var _this = _possibleConstructorReturn(this, (NewInfo.__proto__ || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default()(NewInfo)).call(this, props));

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({
                        nonOperationalData: res.data,
                        zzbdhjid: zzbdhjid
                    });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_17__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.getChildComponent = function (flag, mode) {
            switch (flag) {
                case 1:
                    _this.setState({ jbxxFlag: mode });
                    break;
                default:
                    break;
            }
        };

        _this.cacheFormData = function (type, values, isAdd) {
            if (type == 'jbxx') {
                // console.log('保存:', values)
                var sjhm = values.sjhm,
                    jjlxr = values.jjlxr,
                    jjlxdh = values.jjlxdh;

                if (sjhm !== null && jjlxr != null && jjlxdh != null) {
                    _this.setState({
                        jbxxInitData: _extends({}, values),
                        isEditJbxx: true
                    }, function () {
                        _this.insertData4Yxwz();
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("存在必填信息未填写，请填写后再保存！");
                }
            }
        };

        _this.getData4Yxwz = function () {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            // console.log('userId:', userId)
            if (userId) {
                _this.setState({ xsid: userId });
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_NHFetch__["a" /* default */])('/latestStudent/queryStuInfo', 'GET', { 'xsid': userId }).then(function (res) {
                    // console.log('获取信息:', res)
                    if (res && res.data) {
                        var stuInfo = res.data.stuInfo;
                        // let stuXxcj = res.data.stuXxcj;
                        var stuSsxx = res.data.stuSsxx;
                        var editXszp = res.data.editXszp;
                        var studentOtherInfo = res.data.studentOtherInfo;

                        _this.setState({
                            userBaseInfo: stuInfo.userBaseInfo,
                            jbxxInitData: stuInfo.xsJbxx4YxwzVO,
                            // kzxxInitData: { ...stuXxcj },
                            stuSsxx: stuSsxx,
                            editXszp: editXszp,
                            studentOtherInfo: studentOtherInfo
                        });
                    }
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("登录超时,请重新登录！");
            }
        };

        _this.insertData4Yxwz = function () {
            var postFormData = {};
            // console.log('state:', this.state)
            var _this$state = _this.state,
                jbxxInitData = _this$state.jbxxInitData,
                xsid = _this$state.xsid,
                zzbdhjid = _this$state.zzbdhjid;

            postFormData['xsid'] = xsid;
            postFormData['zzbdhjid'] = zzbdhjid;
            postFormData['xsJbxx4YxwzVO'] = jbxxInitData;

            var postData = {
                'xsInfo4YxwzVO': postFormData,
                'params': { 'zzbdhjid': zzbdhjid, 'xsid': xsid }
            };

            //必填一
            var _postData$xsInfo4Yxwz = postData.xsInfo4YxwzVO.xsJbxx4YxwzVO,
                sjhm = _postData$xsInfo4Yxwz.sjhm,
                jjlxr = _postData$xsInfo4Yxwz.jjlxr,
                jjlxdh = _postData$xsInfo4Yxwz.jjlxdh;

            var jbxxFlag = false;
            if (sjhm !== null && jjlxr != null && jjlxdh != null) {
                jbxxFlag = true;
            }
            var hjblFlag = false;
            if (jbxxFlag) hjblFlag = true;
            postData.params.hjblFlag = hjblFlag;

            console.log('更新参数:', postData);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_NHFetch__["a" /* default */])('/latestStudent/updateStuLxxxInfo', 'POST', postData).then(function (res) {
                if (res && res.code == 200) {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.success("保存成功");
                    _this.reloadMenu();
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("保存失败");
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD001_4',
            hjmc: '',
            jbxxFormData: {},
            jbxxInitData: {},
            kzxxInitData: {},
            userBaseInfo: {},
            studentOtherInfo: {},
            stuSsxx: {},
            xsid: '',
            jbxxFlag: true,
            kzxxFlag: true,
            jtcyFlag: true,
            zyshgxFlag: true,
            jyjlFlag: true,
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            isEditJbxx: false,
            isEditJtcy: false,
            isEditZyshgx: false,
            isEditJyjl: false,
            menuList: [],
            zzbdhjid: '',
            lxxxRedis: {},
            blztFlag: '0'
        };
        return _this;
    }

    _createClass(NewInfo, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.queryQztjAndYlhj();
            this.getData4Yxwz();
        }

        //查询前置条件和依赖环节

        // 获取地址参数

        // 左侧导航菜单

        // 获取子组件


        //缓存编写的信息，缓存完之后提交

        // 获取基本信息

        // 插入数据


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230',
                        mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_8__components__["a" /* Flex */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__JbxxForm__["a" /* default */], { ref: 'refJbxxForm', jbxxFormData: this.state.jbxxInitData,
                                getChildComponent: this.getChildComponent,
                                cacheFormData: this.cacheFormData,
                                userInfoData: this.state.userBaseInfo,
                                stuSsxx: this.state.stuSsxx,
                                editXszp: this.state.editXszp,
                                studentOtherInfo: this.state.studentOtherInfo

                            }),
                            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                                'div',
                                { className: 'p-sw text-center mt-30' },
                                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__common__["a" /* default */], { hjmc: "个人信息填写", key: 'GD001_4', mkbz: 'GD001_4', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return NewInfo;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);



/***/ }),

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_cascader_style__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_cascader_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_cascader_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_cascader__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_cascader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_cascader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);








var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }






var pathUrl = "/proData/selectCascaderList";

/**
 * 级联选择框
 * 1、符合自定义表单组件规范，结合FormItem使用时不会出现警告信息
 * 2、使用sign属性时，后台对应sign标识的sql查询数据语句列必须以value、label作为别名
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-04-02 14:44:22
 * Version: 1.0
 * Modify log:
 */
var NHCascader = (_temp = _class = function (_React$Component) {
    _inherits(NHCascader, _React$Component);

    function NHCascader(props) {
        _classCallCheck(this, NHCascader);

        var _this = _possibleConstructorReturn(this, (NHCascader.__proto__ || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default()(NHCascader)).call(this, props));

        _initialiseProps.call(_this);

        var value = _this.props.value || [];
        _this.state = {
            options: [],
            value: value
        };
        return _this;
    }

    //初始加载第一级级联下拉数据


    _createClass(NHCascader, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var level = 1;
            var cascaderValue = '';
            this.getInitData(level, cascaderValue);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {

            // Should be a controlled component.
            if ('value' in nextProps) {
                var value = nextProps.value;
                this.setState({ value: value });
            }
        }

        //获取初始化数据


        //当选择父项时，动态加载子项数据


        //从后台查询级联下拉数据


        //级联选择框值变化时回调


        //提供onChange回调方法给Form表单，表明这是一个自定义表单受控组件

    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                options = _state.options,
                value = _state.value;
            var _props = this.props,
                style = _props.style,
                placeholder = _props.placeholder,
                disabled = _props.disabled,
                defaultValue = _props.defaultValue,
                changeOnSelect = _props.changeOnSelect,
                onChange = _props.onChange;


            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_cascader___default.a, {
                options: options,
                loadData: this.loadData,
                onChange: this.handleCascaderChange,
                changeOnSelect: changeOnSelect,
                style: style,
                placeholder: placeholder,
                value: value,
                disabled: disabled,
                notFoundContent: '无数据'
            });
        }
    }]);

    return NHCascader;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.getInitData = function (level, cascaderValue, parentOption) {
        var sign = _this2.props.sign;


        var params = { level: level, sign: sign, cascaderValue: cascaderValue };

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])(pathUrl, 'GET', params).then(function (res) {
            if (res) {
                var data = res.data;
                if (data) {
                    if (parentOption) {
                        parentOption.loading = false;
                        parentOption.children = data;
                        _this2.setState({
                            options: [].concat(_toConsumableArray(_this2.state.options))
                        });
                    } else {
                        _this2.setState({
                            options: data
                        });
                    }

                    //获取初始值，判断是否需要加载下一级级联数据
                    var initValue = _this2.props.value;
                    if (initValue && initValue.length > 0) {
                        var targetOption = data.filter(function (item) {
                            return item.value == initValue[level - 1];
                        })[0];
                        if (targetOption) {
                            targetOption.loading = true;
                            if (level < initValue.length) {
                                _this2.getInitData(level + 1, initValue[level - 1], targetOption);
                            }
                        }
                    }
                } else {
                    _this2.setState({ options: [] });
                }
            }
        });
    };

    this.loadData = function (selectedOptions) {
        var targetOption = selectedOptions[selectedOptions.length - 1];
        targetOption.loading = true;
        var level = targetOption.currLevel + 1;
        var cascaderValue = targetOption.value;
        _this2.getCascaderData(level, cascaderValue, targetOption);
    };

    this.getCascaderData = function (level, cascaderValue, targetOption) {
        var sign = _this2.props.sign;


        var params = { level: level, sign: sign, cascaderValue: cascaderValue };

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])(pathUrl, 'GET', params).then(function (res) {
            if (res) {
                if (res.data) {
                    if (targetOption) {
                        targetOption.loading = false;
                        if (res.data.length == 1) {
                            if (res.data[0].value == null) {
                                targetOption.children = undefined;
                            } else {
                                targetOption.children = res.data;
                            }
                        } else {
                            targetOption.children = res.data;
                        }

                        _this2.setState({
                            options: [].concat(_toConsumableArray(_this2.state.options))
                        });
                    } else {
                        _this2.setState({
                            options: [].concat(_toConsumableArray(res.data))
                        });
                    }
                } else {
                    _this2.setState({ options: [] });
                }
            }
        });
    };

    this.handleCascaderChange = function (value, selectedOptions) {

        if (!('value' in _this2.props)) {
            _this2.setState({
                value: value
            });
        }

        _this2.triggerChange(value, selectedOptions);
    };

    this.triggerChange = function (changedValue, selectedOptions) {
        // Should provide an event to pass value to Form.
        var onChange = _this2.props.onChange;
        if (onChange) {
            onChange(changedValue, selectedOptions);
        }
    };
}, _temp);

//默认属性值

NHCascader.defaultProps = {
    sign: '', //数据源标识
    placeholder: '请选择...', //输入框占位文本
    disabled: false, //是否禁用
    changeOnSelect: true //当此项为 true 时，点选每级菜单选项值都会发生变化


    //属性检查
};NHCascader.propTypes = {
    sign: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired, //数据源标识
    style: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object, //样式
    placeholder: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, //输入框占位文本
    disabled: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool, //是否禁用
    defaultValue: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any, //默认选中项
    value: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any, //初始值
    changeOnSelect: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool, //当此项为 true 时，点选每级菜单选项值都会发生变化
    onChange: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func //选择完成后的回调
};

/* harmony default export */ __webpack_exports__["a"] = (NHCascader);

/***/ }),

/***/ 1080:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NonTaxPayIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_SelfHelp_common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pay__ = __webpack_require__(1081);













var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }















var NonTaxPayIndex = function (_React$Component) {
    _inherits(NonTaxPayIndex, _React$Component);

    function NonTaxPayIndex(props) {
        _classCallCheck(this, NonTaxPayIndex);

        var _this = _possibleConstructorReturn(this, (NonTaxPayIndex.__proto__ || __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default()(NonTaxPayIndex)).call(this, props));

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.queryQztjAndYlhj = function (callback) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    } else if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    } else if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    } else {
                        _this.loadFeeDetailList();
                    }if (callback) {
                        callback(_this.state.operable);
                    }
                }
            });
        };

        _this.handleCancel = function (e) {
            _this.setState({
                visible: false
            }, function () {
                _this.loadFeeDetailList();
            });
        };

        _this.loadFeeDetailList = function () {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_NHCore__["b" /* getLoginUser */])().userId) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_NHFetch__["a" /* default */])('/jfxt/getFeeDetailList', 'GET').then(function (res) {
                    if (res && res.code === 200) {
                        _this.setState({
                            feeDetailList: res.data
                        });
                    }
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.error("获取不到登录人信息");
            }
        };

        _this.loadMerchantInfo = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_NHFetch__["a" /* default */])('/jfxt/getJfcsInfo', 'GET').then(function (res) {
                if (res && res.data) {
                    _this.setState({
                        merchantInfo: res.data
                    });
                }
            });
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_17__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.handlePaySubmit = function (recode) {
            var JFBH = recode.JFBH,
                SFXMMC = recode.SFXMMC,
                QFJE = recode.QFJE;

            _this.setState({
                visible: true,
                params: {
                    jfbh: JFBH,
                    xmmc: SFXMMC,
                    qfje: QFJE
                }
            }, function () {
                _this.saveOrderInfo();
            });
        };

        _this.saveOrderInfo = function () {
            var jfbh = _this.state.params.jfbh;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_NHFetch__["a" /* default */])('/jfxt/saveOrderInfo', 'GET', { jfbh: jfbh }).then(function (res) {
                if (res && res.code === 200) {
                    if (res.data === 1) {
                        return null;
                    } else {
                        __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.error("新增订单失败，请稍后再试！");
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.error("新增订单失败，请稍后再试！");
                }
            });
        };

        _this.handleShowPaper = function (recode) {
            var JFBH = recode.JFBH,
                QFJE = recode.QFJE;
            var merchantInfo = _this.state.merchantInfo;

            if (QFJE > 0) {
                __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.error("该项目费用未缴完，无法查看缴费票据！");
            } else {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_NHFetch__["a" /* default */])('/jfxt/getBillAddress', 'GET', { jfbh: JFBH }).then(function (res) {
                    if (res && res.data) {
                        var billInfo = res.data;
                        if (billInfo.success) {
                            window.open('' + billInfo.publicUrl + billInfo.path, "_blank");
                        } else {
                            __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.error("获取票据失败，请稍后再试！");
                        }
                    } else {
                        __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.error("系统异常，请稍后再试！");
                    }
                });
            }
        };

        _this.state = {
            mkbz: 'GD0081',
            hjmc: '',
            feeDetailList: [], //缴费项目明细list
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            merchantInfo: {}, //收费商户信息
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            visible: false,
            params: {
                jfbh: '', //缴费编号（即通知书编号）
                xmmc: '', //项目名称
                qfje: 0 //欠费金额
            }
        };
        return _this;
    }

    _createClass(NonTaxPayIndex, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.queryQztjAndYlhj(function (operable) {
                if (operable) {
                    //办理状态根据 关联现场环节和是否反向关联修改 不根据现场状态
                    // this.updateZzbdBlzt();
                }
            });
            this.loadMerchantInfo();
        }

        //查询前置条件和依赖环节

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                feeDetailList = _state.feeDetailList,
                merchantInfo = _state.merchantInfo,
                params = _state.params;

            var columns = [{
                title: '序号',
                dataIndex: 'ROW_ID'
            }, {
                title: '收费项目',
                dataIndex: 'SFXMMC'
            }, {
                title: '应缴金额（元）',
                dataIndex: 'YSJE'
            }, {
                title: '实收金额（元）',
                dataIndex: 'SSJE',
                render: function render(text, record) {
                    return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                        'span',
                        { className: 'text-primary' },
                        text
                    );
                }
            }, {
                title: '欠费金额（元）',
                dataIndex: 'QFJE',
                render: function render(text, record) {
                    if (text > 0) {
                        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            'span',
                            { className: 'text-info-red' },
                            text
                        );
                    } else {
                        return text;
                    }
                }
            }, {
                title: '操作',
                key: 'operation',
                render: function render(text, record) {
                    return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_button___default.a,
                            { style: { background: 'rgb(1, 176, 241)', color: 'white' }, onClick: function onClick() {
                                    return _this2.handlePaySubmit(record);
                                } },
                            '\u5728\u7EBF\u7F34\u8D39'
                        ),
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_button___default.a,
                            { style: { marginLeft: '10px', background: record.QFJE > 0 ? '#7a7a90' : 'rgb(1, 176, 241)', color: 'white' }, onClick: function onClick() {
                                    return _this2.handleShowPaper(record);
                                } },
                            '\u67E5\u770B\u7968\u636E'
                        )
                    );
                }
            }];

            return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                'div',
                { className: 'page_pay' },
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_19__components_index__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230'
                        /*active={7}*/
                        , mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_19__components_index__["a" /* Flex */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjmc, extra: false }),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                'div',
                                { className: 'p-sw mt-20' },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table___default.a, {
                                    bordered: true,
                                    size: 'middle',
                                    pagination: false,
                                    columns: columns,
                                    dataSource: feeDetailList
                                }),
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'div',
                                    { className: 'text-center mt-50' },
                                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                )
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__pages_SelfHelp_common__["a" /* default */], { hjmc: "网上缴费（非税平台）", key: 'GD0081', mkbz: 'GD0081', nonOperationalData: this.state.nonOperationalData }),
                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal___default.a,
                    {
                        title: params.xmmc + "支付界面",
                        visible: this.state.visible,
                        onCancel: this.handleCancel,
                        footer: [__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_button___default.a,
                            { key: 'back', onClick: this.handleCancel },
                            '\u5173\u95ED'
                        )]
                    },
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__pay__["a" /* default */], { merchantInfo: merchantInfo, params: params })
                )
            );
        }
    }]);

    return NonTaxPayIndex;
}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);



/***/ }),

/***/ 1081:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PayModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_result_style__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_result_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_result_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_result__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_result___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_result__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_NHFetch__ = __webpack_require__(7);









var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }





var PayModal = function (_React$Component) {
    _inherits(PayModal, _React$Component);

    function PayModal(props) {
        _classCallCheck(this, PayModal);

        var _this = _possibleConstructorReturn(this, (PayModal.__proto__ || __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default()(PayModal)).call(this, props));

        _this.QRCodeImg = function () {
            var merchantInfo = _this.props.merchantInfo;
            var _this$props$params = _this.props.params,
                jfbh = _this$props$params.jfbh,
                xmmc = _this$props$params.xmmc;

            var acceptAgencyCode = merchantInfo.acceptAgencyCode;
            var url = merchantInfo.url;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_NHFetch__["a" /* default */])('/jfxt/getDeimensionlCode?jfbh=' + jfbh, 'GET').then(function (res) {
                if (res && res.data) {
                    _this.setState({
                        code: res.data
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_message___default.a.error("获取缴费二维码失败");
                }
            });
        };

        _this.refreshPayInfo = function () {
            var jfbh = _this.props.params.jfbh;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_NHFetch__["a" /* default */])('/openapi/turnBack/refreshPayInfo', 'GET', { jfbh: jfbh }).then(function (res) {
                if (res && res.data) {} else {
                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_message___default.a.error("刷新失败，请稍后再试");
                }
            });
        };

        _this.state = {
            code: ''
        };
        return _this;
    }

    _createClass(PayModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.QRCodeImg();
        }
    }, {
        key: 'render',
        value: function render() {
            var qfje = this.props.params.qfje;
            var code = this.state.code;
            var xmmc = this.props.params.xmmc;

            return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                'div',
                { style: { display: 'flex', justifyContent: 'center' }, className: 'jsx-3868271548'
                },
                qfje > 0 ? __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                    'div',
                    {
                        className: 'jsx-3868271548' + ' ' + 'result-example'
                    },
                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_result___default.a, {
                        icon: __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('img', { src: code, style: { fill: '#1F90E6' }, className: 'jsx-3868271548' + ' ' + 'spe'
                        }),
                        title: xmmc
                        // extra={<Button type="primary" onClick={this.refreshPayInfo}>刷新</Button>}
                    })
                ) : __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                    'div',
                    {
                        className: 'jsx-3868271548' + ' ' + 'result-example'
                    },
                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_result___default.a, {
                        status: 'success',
                        title: '\u5DF2\u652F\u4ED8',
                        subTitle: '\u8BE5\u9879\u76EE\u5DF2\u7ECF\u7F34\u8D39\u5B8C\u6210'
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_styled_jsx_style___default.a, {
                    styleId: '3868271548',
                    css: ['.result-example .spe{width:140px;height:140px;}', '.am-result .am-result-pic{width:120px;height:120px;}']
                })
            );
        }
    }]);

    return PayModal;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);



/***/ }),

/***/ 1082:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dorm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_empty_style__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_empty_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_empty_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_empty__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_spin_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_spin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert_style__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_radio_style__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_radio__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_checkbox_style__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_checkbox__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__selectBox__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__selectModal__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__index_css__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__utils_getSize__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_common_NHModal__ = __webpack_require__(106);


























var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }





















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_36_history_createHashHistory___default()();
var confirm = __WEBPACK_IMPORTED_MODULE_24_antd_lib_modal___default.a.confirm;
var CheckboxGroup = __WEBPACK_IMPORTED_MODULE_22_antd_lib_checkbox___default.a.Group;
var RadioGroup = __WEBPACK_IMPORTED_MODULE_20_antd_lib_radio___default.a.Group;

/**
 * @author weishihuai
 * @date 2018/7/6
 * @time 14:41
 * @Description: 迎新网站-自助报到-宿舍分配
 */

var Dorm = function (_React$Component) {
    _inherits(Dorm, _React$Component);

    function Dorm(props) {
        _classCallCheck(this, Dorm);

        var _this2 = _possibleConstructorReturn(this, (Dorm.__proto__ || __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_object_get_prototype_of___default()(Dorm)).call(this, props));

        _this2.getJfxxByXsid = function (xsid) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHFetch__["a" /* default */])('/nxyszyxy/chooseDormitory/getJfxxByXsid', 'GET', { xsid: xsid }).then(function (res) {
                if (res && res.data) {
                    _this2.setState({
                        jfState: res.data
                    });
                }
            });
        };

        _this2.updateZzbdBlzt = function () {
            var zzbdhjid = _this2.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHFetch__["a" /* default */])('/zzbd/updateZzbdBlzt', 'GET', { zzbdhjid: zzbdhjid, hjdm: 'GD006_6' }).then(function (res) {
                if (res.data) {
                    _this2.reloadMenu();
                }
            });
        };

        _this2.queryQztjAndYlhj = function (callback) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this2.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this2.getUrlParams('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this2.setState({ nonOperationalData: res.data });
                    if (kfsj && kfsj['YXSJ'] != '1') {
                        _this2.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this2.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this2.setState({ operable: false });
                    }

                    if (callback) {
                        callback(_this2.state.operable);
                    }
                }
            });
        };

        _this2.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this2.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this2.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_40__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this2.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this2.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this2.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this2.getUrlParams = function (param) {
            return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this2.getSfbzAndCwsInfo = function (xsid, xqid, xbm) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHFetch__["a" /* default */])("/gyxtUnauth/cwfp/getYxxcSfbzAndSslxInfo", 'GET', { xqid: xqid ? xqid : "", xsid: xsid, xbm: xbm }).then(function (res) {
                if (res) {
                    var data = res.data;
                    _this2.setState({
                        cwsList: data.cwsList,
                        sfbzList: data.sfbzList,
                        xqList: data.xqList
                    });

                    //如果学生无校区信息,默认加载第一个Tab校区的宿舍信息
                    if (!xqid) {
                        _this2.setState({
                            currentXqid: data.xqList[0].XQID
                        });
                        _this2.getFjxxList({
                            cws: "",
                            sfbz: "",
                            xsid: xsid,
                            xqid: data.xqList[0].XQID,
                            xbm: xbm
                        });
                    }
                }
            });
        };

        _this2.getFjxxList = function (param) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHFetch__["a" /* default */])("/gyxtUnauth/cwfp/getYxwzSsfpFjxxList", 'GET', param).then(function (res) {
                if (res) {
                    _this2.setState({
                        fjxxList: res.data
                    });
                }
            });
        };

        _this2.getXsssrzYwxxByXsid = function (xsid) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/getXsssrzYwxxByXsid', 'GET', {
                xsid: xsid
            }).then(function (res) {
                if (res && res.data) {
                    _this2.setState({
                        xsssruYwxx: res.data
                    });
                }
            });
        };

        _this2.confirmCwfpxx = function (xzId) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xqid = loginUserInfo.XQID,
                xbm = loginUserInfo.XBM;

            if (!xzId) {
                __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.warning("请先选择一个床位！");
                return;
            }

            //检查该床位是否被其他学生抢占(防并发的情况下同一个床位被其他人重复选择)
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/checkCwIsPermitSelect', 'GET', { cwid: xzId, xsid: xsid }).then(function (res) {
                if (res) {
                    if (res.data === 0) {
                        __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("抱歉，该床位已经被其他同学抢占，请选择其他床位！");
                        return;
                    } else {
                        //确认床位信息
                        _this2.cwfpSubmit(xsid, xzId, xqid, xbm);
                    }
                }
            });
        };

        _this2.cwfpSubmit = function (xsid, currentClickCwPkid, xqid, xbm) {
            var zzbdhjid = _this2.getUrlParams("pkid");
            var params = { xsid: xsid, cwid: currentClickCwPkid, zzbdhjid: zzbdhjid };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/checkCwIsAvailableSelected', 'GET', { cwid: currentClickCwPkid }).then(function (res) {
                if (res) {
                    if (res.data) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/yxwzConfirmCwxx', 'POST', params).then(function (res) {
                            if (res) {
                                if (res.data) {
                                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.success("分配成功！");
                                    _this2.reloadMenu();
                                    _this2.setState({
                                        currentClickCwPkid: ""
                                    });

                                    _this2.getFjxxList({
                                        cws: "",
                                        sfbz: "",
                                        xsid: xsid,
                                        xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                                        xbm: xbm
                                    });

                                    _this2.getXsssrzYwxxByXsid(xsid);

                                    _this2.checkZzbdisLinked();
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("分配失败，请稍后重试！");
                                }
                            }
                        });
                    } else {
                        __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("抱歉，该床位未到分配时间或已过床位分配时间期限，请选择其他床位! ");
                    }
                }
            });
        };

        _this2.showConfirm = function (value, id, cwh) {
            confirm({
                title: __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                    'span',
                    null,
                    '\u786E\u5B9A\u9009\u62E9',
                    value.name,
                    '\u623F\u95F4\u7684\u4E0B\u5217\u5E8A\u94FA\uFF1F'
                ),
                content: __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__selectModal__["a" /* default */], {
                    data: value,
                    id: id,
                    currentClickCwh: cwh,
                    onChange: function onChange(value) {
                        _this2.setState({
                            xzId: value.id,
                            currentClickCwPkid: value.id
                        });
                    }
                }),
                onOk: function onOk() {
                    var currentClickCwPkid = _this2.state.currentClickCwPkid;
                    //确定分配宿舍提交

                    _this2.confirmCwfpxx(currentClickCwPkid);
                },
                onCancel: function onCancel() {
                    _this2.setState({
                        currentClickCwPkid: ""
                    });
                }
            });
        };

        _this2.judeageCs = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/yxwzSyzxcs', 'GET', { xsid: xsid }).then(function (res) {

                if (res && res.data === -1) {
                    _this2.handleCancelListener();
                } else if (res && res.data === 0) {
                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("自选宿舍次数已用完，不可再取消办理");
                    /* NHConfirm("自选宿舍次数已用完，取消后不能再进行自选宿舍操作！确定取消？",() => {
                    this.handleCancelListener();
                    },"warn"); */
                } else if (res && res.data !== -1 && res.data !== 0) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_42__components_common_NHModal__["b" /* NHConfirm */])("确定取消？取消后还剩" + res.data + "次可选", function () {
                        _this2.handleCancelListener();
                    }, "warn");
                }
            });
        };

        _this2.handleCancelListener = function () {
            _this2.setState({
                cancelLoading: true
            });
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xqid = loginUserInfo.XQID,
                xbm = loginUserInfo.XBM;

            var zzbdhjid = _this2.getUrlParams("pkid");
            var params = { xsid: xsid, zzbdhjid: zzbdhjid };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/cancelBlSsfp', 'POST', params).then(function (res) {
                if (res && res.data === 1) {
                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.success('取消办理成功！');
                    _this2.reloadMenu();
                    _this2.getFjxxList({
                        cws: "",
                        sfbz: "",
                        xsid: xsid,
                        xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                        xbm: xbm
                    });

                    _this2.checkZzbdisLinked();

                    _this2.setState({
                        xsssruYwxx: {},
                        cancelLoading: false
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error('取消办理失败，请稍后重试！');
                    _this2.setState({
                        cancelLoading: false
                    });
                }
            }).catch(function () {
                __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("取消办理失败，请稍后重试！");
                _this2.setState({
                    cancelLoading: false
                });
            });
        };

        _this2.handleAutoDistributeListener = function () {
            _this2.setState({
                autoBlLoading: true
            });
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xqid = loginUserInfo.XQID,
                xbm = loginUserInfo.XBM;
            var zzbdhjid = _this2.getUrlParams("pkid");

            if (!xsid) {
                __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.warning("自动办理失败,请稍后重试！");
                return;
            }

            var param = _this2.state.param;
            //自动分配宿舍

            var params = {
                cws: param.cws || "",
                sfbz: param.sfbz || "",
                xsid: xsid,
                xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                xbm: xbm,
                zzbdhjid: zzbdhjid
            };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHFetch__["a" /* default */])("/gyxtUnauth/cwfp/yxwzAutoDistributeSscwxx", 'POST', params).then(function (res) {
                if (res) {
                    if (res.data === 1) {
                        var text = "";
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/getXsssrzYwxxByXsid', 'GET', { xsid: xsid }).then(function (res) {
                            if (res && res.data) {
                                var data = res.data;
                                _this2.setState({
                                    xsssruYwxx: data
                                });
                                text = data.ldmc + "-" + data.fj + "-" + data.cwh + "号床位";
                                __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.success("自动办理成功,分配宿舍为 " + text + "！");
                                _this2.reloadMenu();
                                _this2.getFjxxList({
                                    cws: "",
                                    sfbz: "",
                                    xsid: xsid,
                                    xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                                    xbm: xbm
                                });

                                _this2.getXsssrzYwxxByXsid(xsid);
                                _this2.checkZzbdisLinked();

                                _this2.setState({
                                    autoBlLoading: false
                                });
                            } else {
                                __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("自动办理失败,请稍后重试！");
                                _this2.setState({
                                    autoBlLoading: false
                                });
                            }
                        });
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("自动办理失败,请稍后重试！");
                    _this2.setState({
                        autoBlLoading: false
                    });
                }
            }).catch(function () {
                __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("自动办理失败,请稍后重试！");
                _this2.setState({
                    autoBlLoading: false
                });
            });
        };

        _this2.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this2.checkZzbdisLinked = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this2.getUrlParams("pkid");
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHFetch__["a" /* default */])("/zzbdCommon/checkIsZzbdHjLinked", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                console.log("公寓", res.data);
                if (res) {
                    if (res.data) {
                        _this2.setState({
                            isHjLinked: res.data
                        });
                    } else {
                        _this2.setState({
                            isHjLinked: false
                        });
                    }
                } else {
                    _this2.setState({
                        isHjLinked: false
                    });
                }
            });
        };

        _this2.autoSelectCwListener = function (value) {
            _this2.setState({
                zdrzLoading: true
            });
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xqid = loginUserInfo.XQID,
                xbm = loginUserInfo.XBM;

            var yxwzCwxxTzVOs = value.yxwzCwxxTzVOs,
                name = value.name;

            var zzbdhjid = _this2.getUrlParams("pkid");
            var availableSelectArr = [],
                availSelectCwPkId = "",
                text = "";

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_get_iterator___default()(yxwzCwxxTzVOs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    availableSelectArr.push(item.xz);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (availableSelectArr.indexOf("0") === -1) {
                __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.warning("抱歉，该房间已满员，请选择其他房间！");
                return;
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_get_iterator___default()(yxwzCwxxTzVOs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _item = _step2.value;

                    //床位未被选择并且未过分配期限
                    if (_item.xz === '0' && !_item.expire) {
                        availSelectCwPkId = _item.id;
                        text = name + "-" + _item.cwh;
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            if (availSelectCwPkId) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/checkCwIsPermitSelect', 'GET', { cwid: availSelectCwPkId, xsid: xsid }).then(function (res) {
                    if (res) {
                        if (res.data === 0) {
                            __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("抱歉，该床位已经被其他同学抢占，请选择其他床位！");
                            _this2.setState({
                                zdrzLoading: false
                            });
                            return;
                        } else {
                            // 确认床位信息
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/yxwzConfirmCwxx', 'POST', {
                                xsid: xsid,
                                cwid: availSelectCwPkId,
                                zzbdhjid: zzbdhjid
                            }).then(function (res) {
                                if (res) {
                                    if (res.data) {
                                        __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.success("分配成功，分配宿舍为 " + text + ", 请尽快确认办理！");
                                        _this2.reloadMenu();
                                        _this2.getFjxxList({
                                            cws: "",
                                            sfbz: "",
                                            xsid: xsid,
                                            xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                                            xbm: xbm
                                        });

                                        _this2.getXsssrzYwxxByXsid(xsid);
                                        _this2.checkZzbdisLinked();

                                        _this2.setState({
                                            zdrzLoading: false
                                        });
                                    }
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("分配失败，请稍后重试！");
                                    _this2.setState({
                                        zdrzLoading: false
                                    });
                                }
                            });
                        }
                    }
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.warning("抱歉，未匹配到合适的床位信息,请选择其他床位！");
                _this2.setState({
                    zdrzLoading: false
                });
            }
        };

        _this2.onSfbzChangeListener = function (checkedValues) {
            var _this2$state = _this2.state,
                param = _this2$state.param,
                currentXqid = _this2$state.currentXqid,
                sfmy = _this2$state.sfmy;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xbm = loginUserInfo.XBM;
            param.sfbz = checkedValues.length > 0 ? checkedValues.join(",") : "";
            param.xsid = xsid;
            param.xqid = currentXqid ? currentXqid : _this2.state.xqList[0].XQID;
            param.xbm = xbm;
            param.sfmy = sfmy;
            _this2.setState({
                sfbz: checkedValues.length > 0 ? checkedValues.join(",") : ""
            });
            _this2.getFjxxList(param);
        };

        _this2.onSfmyChangeListener = function (e) {
            var _this2$state2 = _this2.state,
                param = _this2$state2.param,
                currentXqid = _this2$state2.currentXqid,
                sfbz = _this2$state2.sfbz;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xbm = loginUserInfo.XBM;
            param.sfbz = sfbz;
            param.xsid = xsid;
            param.xqid = currentXqid ? currentXqid : _this2.state.xqList[0].XQID;
            param.xbm = xbm;
            param.sfmy = e.target.value;
            _this2.setState({
                sfmy: e.target.value
            });
            _this2.getFjxxList(param);
        };

        _this2.onCwsChange = function (checkedValues) {
            var _this2$state3 = _this2.state,
                param = _this2$state3.param,
                currentXqid = _this2$state3.currentXqid;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xbm = loginUserInfo.XBM;
            param.cws = checkedValues.length > 0 ? checkedValues.join(",") : "";
            param.xsid = xsid;
            param.xbm = xbm;
            param.xqid = currentXqid ? currentXqid : _this2.state.xqList[0].XQID;
            _this2.getFjxxList(param);
        };

        _this2.tabChangeListener = function (activeKey) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xbm = loginUserInfo.XBM;
            var _this2$state$param = _this2.state.param,
                cws = _this2$state$param.cws,
                sfbz = _this2$state$param.sfbz;


            _this2.setState({
                currentXqid: activeKey
            });

            //加载房间信息
            _this2.getFjxxList({
                cws: cws || "",
                sfbz: sfbz || "",
                xsid: xsid,
                xqid: activeKey,
                xbm: xbm
            });
        };

        _this2.reloadMenu = function () {
            _this2.refs.siderMenu.reloadMenuList();
        };

        _this2.state = {
            mkbz: 'GD006_6',
            hjmc: '',
            xzId: '',
            _xzId: '',
            cwsList: [], //床位数
            sfbzList: [], //收费标准
            xqList: [], //校区信息
            currentXqid: "", //当前校区ID
            fjxxList: [], //房间信息
            currentClickCwPkid: "", //当前床位信息ID
            xsssruYwxx: {}, //学生宿舍入住业务信息
            isHjLinked: false, //环节是否办理状态
            param: {}, //过滤条件
            scrollHeight: 200, //默认滚动高度
            loginUserInfo: {}, //当前登录学生信息
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            autoBlLoading: false, //自动办理按钮载入状态
            cancelLoading: false, //取消办理按钮载入状态
            zdrzLoading: false, //自动入住载入状态
            sfbz: "", //收费标准选中值
            sfmy: "", //是否满员选中值

            jfState: false //缴费状态
        };
        return _this2;
    }

    _createClass(Dorm, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var that = this;
            this.setState({ scrollHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_getSize__["a" /* default */])().windowH - 206 });
            window.onresize = function () {
                that.setState({
                    scrollHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_getSize__["a" /* default */])().windowH - 206
                });
            };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            this.queryQztjAndYlhj(function (operable) {
                if (operable) {
                    var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["b" /* getLoginUser */])().userId : '';
                    if (xsid) {
                        var _this = _this3;
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_NHCore__["d" /* getLoginUserInfo */])(xsid, function (data) {
                            _this.setState({
                                loginUserInfo: data
                            }, function () {
                                var loginUserInfo = _this.state.loginUserInfo;

                                var xqid = loginUserInfo.XQID,
                                    xbm = loginUserInfo.XBM;

                                if (xsid) {
                                    //办理状态根据 关联现场环节和是否反向关联修改 不根据现场状态
                                    //_this.updateZzbdBlzt();
                                    //加载收费标准、床位数信息
                                    _this.getSfbzAndCwsInfo(xsid, xqid, xbm);
                                    _this.getXsssrzYwxxByXsid(xsid);
                                    //如果学生校区ID不为空,则只加载本校区宿舍信息
                                    if (xqid) {
                                        _this.setState({
                                            currentXqid: xqid
                                        });
                                        _this.getFjxxList({
                                            cws: "",
                                            sfbz: "",
                                            xsid: xsid,
                                            xqid: xqid,
                                            xbm: xbm
                                        });
                                    }
                                    _this.getJfxxByXsid(xsid);
                                }
                                _this.checkZzbdisLinked();
                            });
                        });
                    }
                }
            });
        }

        //迎新现场已办理时迎新网站自动办理


        //查询前置条件和依赖环节


        //获取url中传递的参数


        //获取收费标准、床位信息等


        //获取宿舍房间信息


        // 过滤可以选择的房间信息
        /* fitlerRoom = () =>{
            let kyxzRoom= [];
                        // console.log("获取房间信息-------",res.data);
                        let fjxxList = this.state.fjxxList;
                        fjxxList.map((item,index)=>{
                            if(item.yxNum < item.allNum){
                                // console.log("未住满的房间(个数判断)------",item);
                                if(item.bedList && item.bedList.length > 0){
                                    item.yxwzCwxxTzVOs.map((item2,index2)=>{
                                        console.log("item2",item2);
                                        if(item2.xz == '0'){
                                            // console.log("可以选择的床位---------",item2,item);
                                                kyxzRoom.push(item);
                                        }
                                    })
                                }
                            }
                        })
                        let setRoom = [];
                        if(kyxzRoom.length > 0){
                            setRoom = Array.from(new Set(kyxzRoom));
                            // setRoom = Array.from(setRoom);
                        }
                        console.log("过滤后的房间------",kyxzRoom,setRoom);
                        this.setState({
                            setRoom:setRoom
                        })
        } */

        //查询学生宿舍入住信息


        //确认床位分配


        //床位分配提交


        //选择床位弹层


        //取消办理事件


        //自动办理事件

        //检查环节是否已办理


        //自动入住事件


        //收费标准onChange事件


        //是否满员onChange事件


        //宿舍类型onChange事件


        //tab切换事件


        //重新加载菜单

    }, {
        key: 'render',


        /*  handleNextRoom = (RoomList) =>{
             const {fjxxList,setRoom} = this.state;
             console.log("当前宿舍信息-----------",RoomList,fjxxList,setRoom);
             let list = [];
             fjxxList.map((item,index)=>{
                 if(item.fjid == "cba18dd6-ac51-4119-b35e-1f2d9eb30bf7"){
                     item. yxNum = '8';
                 }
                 list.push(item);
             })
             console.log("模拟修改-----------",list);
             this.setState({
                 fjxxList:list
             },()=>{
                 this.fitlerRoom();
             })
         } */

        value: function render() {
            var _this4 = this;

            var _state = this.state,
                xzId = _state.xzId,
                _xzId = _state._xzId,
                cwsList = _state.cwsList,
                xqList = _state.xqList,
                sfbzList = _state.sfbzList,
                fjxxList = _state.fjxxList,
                xsssruYwxx = _state.xsssruYwxx,
                isHjLinked = _state.isHjLinked,
                scrollHeight = _state.scrollHeight,
                currentXqid = _state.currentXqid,
                autoBlLoading = _state.autoBlLoading,
                cancelLoading = _state.cancelLoading,
                zdrzLoading = _state.zdrzLoading,
                jfState = _state.jfState;
            //学生已选宿舍信息

            var xqmc = xsssruYwxx.xqmc,
                ldmc = xsssruYwxx.ldmc,
                fj = xsssruYwxx.fj,
                cwh = xsssruYwxx.cwh;

            var yxssInfo = (xqmc || "") + "-" + (ldmc || "") + "-" + (fj || "") + "-" + (cwh || "") + "号床";
            var fsmyList = [{ "label": "未满", "value": "0" }, { "label": "满员", "value": "1" }];
            /* let RoomList = []
            if(setRoom.length > 1){
                RoomList.push(setRoom[0]);
            }else{
                RoomList = setRoom;
            } */
            return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_27__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230',
                        mkbz: this.state.mkbz
                        /*   active={5}*/
                        , menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_27__components__["a" /* Flex */].Item,
                        { className: 'page_con_r ' },
                        __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_30__pages_Assembly_titleTop__["a" /* default */],
                                {
                                    className: 'mt-20',
                                    title: this.state.hjmc,
                                    extra: false
                                },
                                jfState ? !isHjLinked ? __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_14_antd_lib_button___default.a,
                                    {
                                        className: 'ml-10',
                                        type: 'primary',
                                        ghost: true,
                                        loading: autoBlLoading,
                                        onClick: this.handleAutoDistributeListener
                                    },
                                    '\u81EA\u52A8\u529E\u7406'
                                ) : __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_14_antd_lib_button___default.a,
                                    {
                                        className: 'ml-10',
                                        type: 'danger',
                                        ghost: true,
                                        loading: cancelLoading,
                                        onClick: this.judeageCs
                                    },
                                    '\u53D6\u6D88\u529E\u7406'
                                ) : null
                            ),
                            jfState ? __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                'div',
                                { className: 'p-sw' },
                                __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_27__components__["a" /* Flex */],
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                        'span',
                                        null,
                                        '\u6536\u8D39\u6807\u51C6\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_27__components__["a" /* Flex */].Item,
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                            CheckboxGroup,
                                            {
                                                style: { width: '100%' },
                                                onChange: this.onSfbzChangeListener
                                            },
                                            __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_10_antd_lib_row___default.a,
                                                null,
                                                sfbzList.map(function (elem, index) {
                                                    return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_12_antd_lib_col___default.a,
                                                        {
                                                            key: index,
                                                            span: 4
                                                        },
                                                        __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_22_antd_lib_checkbox___default.a,
                                                            {
                                                                value: elem.value
                                                            },
                                                            elem.label
                                                        )
                                                    );
                                                })
                                            )
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_27__components__["a" /* Flex */],
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                        'span',
                                        null,
                                        '\u662F\u5426\u6EE1\u5458\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_27__components__["a" /* Flex */].Item,
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                            RadioGroup,
                                            {
                                                style: { width: '100%' },
                                                onChange: this.onSfmyChangeListener,
                                                defaultValue: '0'
                                            },
                                            __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_10_antd_lib_row___default.a,
                                                null,
                                                fsmyList.map(function (elem, index) {
                                                    return __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_12_antd_lib_col___default.a,
                                                        {
                                                            key: index,
                                                            span: 4
                                                        },
                                                        __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_20_antd_lib_radio___default.a,
                                                            {
                                                                value: elem.value
                                                            },
                                                            elem.label
                                                        )
                                                    );
                                                })
                                            )
                                        )
                                    )
                                ),
                                isHjLinked && __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_alert___default.a, { message: "当前选择宿舍为: " + yxssInfo, type: 'info', showIcon: true })
                                ),
                                __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_spin___default.a,
                                    { spinning: zdrzLoading },
                                    __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__tab_box' },
                                        __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__selectBox__["a" /* default */], {
                                            Data: fjxxList,
                                            xzId: _xzId,
                                            showConfirm: this.showConfirm,
                                            onChange: function onChange(value) {
                                                _this4.setState({
                                                    xzId: value.id,
                                                    currentClickCwPkid: value.id
                                                });
                                            },
                                            autoSelectCwListener: function autoSelectCwListener(value) {
                                                return _this4.autoSelectCwListener(value);
                                            },
                                            scrollHeight: scrollHeight,
                                            tabChangeListener: this.tabChangeListener,
                                            xqList: xqList,
                                            currentXqid: currentXqid
                                        })
                                    )
                                )
                            ) : __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_empty___default.a, { description: __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                    'span',
                                    { style: { "color": "black" } },
                                    '\u8BF7\u5148\u8FDB\u884C\u7F34\u8D39\u73AF\u8282\uFF01'
                                ) }),
                            __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(
                                'div',
                                { className: 'text-center mt-50' },
                                __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_25_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__common__["a" /* default */], { hjmc: "自选宿舍", key: 'GD006', mkbz: 'GD006_6', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return Dorm;
}(__WEBPACK_IMPORTED_MODULE_25_react___default.a.Component);



/***/ }),

/***/ 1083:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_popover_style__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_popover_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_popover_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_popover__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_tabs_style__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_plugin_react_css_modules_dist_browser_getClassName__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_plugin_react_css_modules_dist_browser_getClassName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_plugin_react_css_modules_dist_browser_getClassName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__index_css__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars__);











var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;


var _styleModuleImportMap = {
    './index.css': {
        'tab_box': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__tab_box',
        'tip': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__tip',
        'item': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__item',
        'item_con': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__item_con',
        'round': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__round',
        'select_box': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__select_box',
        'select_list': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__select_list',
        'select_item': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__select_item',
        'select_item_b': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__select_item_b',
        'select_item_y': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__select_item_y',
        'item_btn_box': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__item_btn_box',
        'item_btn': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__item_btn',
        'modal_box': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__modal_box',
        'modal_list': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__modal_list'
    }
};

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }










if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var TabPane = __WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default.a.TabPane;

/**
 * @author weishihuai
 * @date 2018/7/6
 * @time 14:42
 * @Description: 迎新网站-自助报到-宿舍分配-宿舍床位信息
 */
var SelectBox = (_temp = _class = function (_React$Component) {
    _inherits(SelectBox, _React$Component);

    function SelectBox(props) {
        _classCallCheck(this, SelectBox);

        var _this = _possibleConstructorReturn(this, (SelectBox.__proto__ || __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default()(SelectBox)).call(this, props));

        _this.getListItem = function () {
            var Data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var _this$props = _this.props,
                className = _this$props.className,
                showConfirm = _this$props.showConfirm,
                xzId = _this$props.xzId,
                onChange = _this$props.onChange,
                autoSelectCwListener = _this$props.autoSelectCwListener;

            return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_14__components__["a" /* Flex */],
                { align: 'top', wrap: 'wrap', className: 'mt-20' },
                Data.length > 0 ? Data.map(function (item, idx) {
                    var sscx = item.sscx != null && item.sscx.length > 0 ? item.sscx : '';
                    var fjxx = item.name + " " + sscx;
                    return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        'div',
                        { key: idx, className: 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__item' },
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__item_con' },
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__components__["a" /* Flex */],
                                { justify: 'between' },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'span',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('span', { className: 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__round' }),
                                    fjxx.length < 12 ? fjxx : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        { style: { cursor: "pointer" } },
                                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_popover___default.a,
                                            { content: fjxx, trigger: 'hover' },
                                            fjxx.substr(0, 10) + "..."
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'span',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        { className: 'text-blue' },
                                        item.yxNum
                                    ),
                                    '/',
                                    item.allNum
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__components__["a" /* Flex */],
                                {
                                    wrap: 'wrap',
                                    align: 'center',
                                    justify: 'center',
                                    className: 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__select_box'
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'div',
                                    { className: 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__select_list' },
                                    item.bedList[0] && item.bedList.map(function (el, index) {
                                        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                            'div',
                                            { key: index },
                                            el.map(function (cwxx, index) {
                                                return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div', {
                                                    key: index,

                                                    onClick: function onClick() {
                                                        if (cwxx.xz === "0") {
                                                            showConfirm(item, cwxx.id, cwxx.cwh);
                                                            onChange(cwxx);
                                                        } else {
                                                            __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.warning('抱歉，该床铺已选择！');
                                                        }
                                                    },
                                                    className: __WEBPACK_IMPORTED_MODULE_10_babel_plugin_react_css_modules_dist_browser_getClassName___default()(__WEBPACK_IMPORTED_MODULE_13_classnames___default()('select_item', {
                                                        select_item_b: cwxx.xz === '1',
                                                        select_item_y: xzId === cwxx.id && cwxx.xz === '0' || cwxx.currentXsSelected
                                                    }), _styleModuleImportMap)
                                                });
                                            })
                                        );
                                    })
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__item_btn_box' },
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'div',
                                {
                                    className: 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__item_btn',
                                    onClick: function onClick() {
                                        return autoSelectCwListener(item);
                                    }
                                },
                                '\u81EA\u52A8\u5165\u4F4F'
                            ),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'div',
                                {
                                    className: 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__item_btn',
                                    onClick: function onClick() {
                                        return showConfirm(item);
                                    }
                                },
                                '\u9009\u62E9\u5E8A\u4F4D'
                            )
                        )
                    );
                }) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        'span',
                        { style: { color: "#f00" } },
                        '\u6682\u65E0\u5339\u914D\u7684\u5BBF\u820D\u4FE1\u606F\uFF01'
                    )
                )
            );
        };

        return _this;
    }

    //床位信息


    _createClass(SelectBox, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                className = _props.className,
                Data = _props.Data,
                scrollHeight = _props.scrollHeight,
                tabChangeListener = _props.tabChangeListener,
                xqList = _props.xqList,
                currentXqid = _props.currentXqid;

            var activeKey = currentXqid || xqList[0] && xqList[0].XQID;

            return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default.a,
                { defaultActiveKey: '0', activeKey: activeKey, tabPosition: 'top',
                    onChange: function onChange(activeKey) {
                        return tabChangeListener(activeKey);
                    } },
                xqList.map(function (xq) {
                    return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        TabPane,
                        { tab: xq.XQMC, key: xq.XQID },
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_14__components__["a" /* Flex */],
                            { className: 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__tip', justify: 'center' },
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('img', {
                                src: __webpack_require__(281),
                                alt: ''
                            }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'span',
                                null,
                                '\u53EF\u9009\u62E9'
                            ),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('img', {
                                className: 'ml-10',
                                src: __webpack_require__(280),
                                alt: ''
                            }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'span',
                                null,
                                '\u4E0D\u53EF\u9009'
                            ),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('img', {
                                className: 'ml-10',
                                src: __webpack_require__(282),
                                alt: ''
                            }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'span',
                                null,
                                '\u5DF2\u9009\u62E9'
                            )
                        ),
                        Data.length > 16 ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars__["Scrollbars"],
                            { autoHide: true,
                                style: { width: '100%', height: scrollHeight } },
                            _this2.getListItem(Data)
                        ) : _this2.getListItem(Data)
                    );
                })
            );
        }
    }]);

    return SelectBox;
}(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component), _class.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,
    xzId: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.any,
    showConfirm: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
    autoSelectCwListener: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
    tabChangeListener: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func
}, _class.defaultProps = {
    xzId: '',
    showConfirm: Function.prototype,
    onChange: Function.prototype,
    autoSelectCwListener: Function.prototype,
    tabChangeListener: Function.prototype
}, _temp);


/***/ }),

/***/ 1084:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_plugin_react_css_modules_dist_browser_getClassName__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_plugin_react_css_modules_dist_browser_getClassName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_plugin_react_css_modules_dist_browser_getClassName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_css__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__index_css__);







var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;


var _styleModuleImportMap = {
    './index.css': {
        'tab_box': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__tab_box',
        'tip': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__tip',
        'item': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__item',
        'item_con': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__item_con',
        'round': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__round',
        'select_box': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__select_box',
        'select_list': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__select_list',
        'select_item': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__select_item',
        'select_item_b': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__select_item_b',
        'select_item_y': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__select_item_y',
        'item_btn_box': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__item_btn_box',
        'item_btn': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__item_btn',
        'modal_box': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__modal_box',
        'modal_list': 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__modal_list'
    }
};

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }









/**
 * @author weishihuai
 * @date 2018/7/6
 * @time 14:41
 * @Description: 迎新网站-自助报到-宿舍分配-选择床位弹层
 */

if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var SelectModal = (_temp = _class = function (_React$Component) {
    _inherits(SelectModal, _React$Component);

    function SelectModal(props) {
        _classCallCheck(this, SelectModal);

        var _this = _possibleConstructorReturn(this, (SelectModal.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(SelectModal)).call(this, props));

        var id = props.id;

        _this.state = {
            xzId: id,
            currentClickCwh: "" //当前床位号
        };
        return _this;
    }

    _createClass(SelectModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var currentClickCwh = this.props.currentClickCwh;

            this.setState({
                currentClickCwh: currentClickCwh
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                xzId = _state.xzId,
                currentClickCwh = _state.currentClickCwh;
            var _props = this.props,
                className = _props.className,
                data = _props.data,
                onChange = _props.onChange;


            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('text-center', className) },
                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                    'div',
                    { className: 'text-blue' },
                    currentClickCwh ? currentClickCwh > 9 ? currentClickCwh + "床" : "0" + currentClickCwh + "床" : "请选择床铺"
                ),
                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                    'div',
                    null,
                    data.ysje + "元/年"
                ),
                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10__components__["a" /* Flex */],
                    { wrap: 'wrap', align: 'center', justify: 'center' },
                    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                        'div',
                        { className: 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__modal_box' },
                        data.bedList[0] && data.bedList.map(function (el, i) {
                            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                                'div',
                                { key: i },
                                el.map(function (cwxx, index) {
                                    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                                        'div',
                                        {
                                            className: 'app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__modal_list',
                                            onClick: function onClick() {
                                                if (cwxx.xz === "0") {
                                                    _this2.setState({
                                                        xzId: cwxx.id,
                                                        currentClickCwh: cwxx.cwh
                                                    });
                                                    onChange(cwxx);
                                                } else {
                                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.warning('抱歉，该床铺已选择！');
                                                }
                                            },
                                            key: index
                                        },
                                        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
                                            className: __WEBPACK_IMPORTED_MODULE_6_babel_plugin_react_css_modules_dist_browser_getClassName___default()(__WEBPACK_IMPORTED_MODULE_9_classnames___default()('select_item', {
                                                select_item_b: cwxx.xz === '1',
                                                select_item_y: xzId === cwxx.id && cwxx.xz === '0' || cwxx.currentXsSelected
                                            }), _styleModuleImportMap)
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                                            'div',
                                            null,
                                            cwxx.cwh > 9 ? cwxx.cwh + "床" : "0" + cwxx.cwh + "床"
                                        )
                                    );
                                })
                            );
                        })
                    )
                )
            );
        }
    }]);

    return SelectModal;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _class.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
    currentClickCwh: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
}, _class.defaultProps = {
    id: '',
    onChange: Function.prototype,
    currentClickCwh: ""
}, _temp);


/***/ }),

/***/ 1085:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio_style__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_common_NHCascader__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__index_css__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__utils_RegExp__);















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }











if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var uploadUrl = "api/zhxg-yxwz/newStudent/cacheStudentPhoto"; //上传logo路径



function beforeUpload(file) {

    var isJPG = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJPG) {
        __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error("You can only upload JPG file!");
    }
    var isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error("Image must smaller than 2MB!");
    }
    return isJPG && isLt2M;
}

var JbxxInitForm = function (_React$Component) {
    _inherits(JbxxInitForm, _React$Component);

    function JbxxInitForm(props) {
        _classCallCheck(this, JbxxInitForm);

        var _this = _possibleConstructorReturn(this, (JbxxInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default()(JbxxInitForm)).call(this, props));

        _this.getStudentPhotoBase64 = function (userId, callback) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/openapi/student/getStudentPhotoBase64', 'get', { xsid: userId, type: 10 }).then(function (res) {
                if (res && res.code == 200) {
                    callback(res.data);
                }
            });
        };

        _this.onSavejbxxFormData = function (cb) {
            _this.props.form.validateFields(function (error, values) {
                if (error) {
                    cb(false);
                    return;
                }
                cb(true);
                var cacheFormData = _this.props.cacheFormData;

                if (_this.state.jtStr !== '') {
                    values.jtdzDetail = _this.state.jtStr;
                } else {
                    values.jtdzDetail = _this.props.jbxxFormData ? _this.props.jbxxFormData.jtdzDetail ? _this.props.jbxxFormData.jtdzDetail : "" : "";
                }
                cacheFormData('jbxx', values);
                _this.setState({
                    jbxx: false
                });
            });
        };

        _this.handleUploadChange = function (info) {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (info && info['file'] && info['file'].status === 'done') {
                var photoUUID = info['file'].response.data;
                if (photoUUID) {
                    var url = '/newStudent/saveStudentPhoto?xsid=' + userId + '&photoUUID=' + photoUUID + '&type=' + '10';
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])(url, 'POST').then(function (res) {
                        if (res && res.data) {
                            __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.success("上传成功!");
                        }
                    });
                }
            }
            _this.getBase64(info.file.originFileObj, function (imageUrl) {
                return _this.setState({ imageUrl: imageUrl });
            });
        };

        _this.onNHCascaderChange = function (value, selectedOptions, type) {
            var label = '';
            if (selectedOptions) {
                selectedOptions.forEach(function (i) {
                    label += i.label;
                });
            }
            if (type == 'jg') {
                _this.setState({ jgmStr: label });
            } else {
                _this.setState({ jtStr: label });
            }
        };

        _this.state = {
            jbxx: false,
            xsid: '',
            userInfoData: null,
            zzmmmList: [],
            mzmList: [],
            textData: '',
            jgmStr: '',
            jtStr: '',
            xsSsInfo: ''
        };
        return _this;
    }

    _createClass(JbxxInitForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                this.getStudentPhotoBase64(userId, function (data) {
                    if (!data) return;
                    _this2.setState({
                        xsid: userId,
                        imageUrl: 'data:image/jpeg;base64,' + data
                    });
                });
            }
        }

        // 获取学生头像

    }, {
        key: 'getBase64',
        value: function getBase64(img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        }
        // 上传图片

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                form = _props.form,
                jbxxFormData = _props.jbxxFormData,
                getChildComponent = _props.getChildComponent,
                userInfoData = _props.userInfoData,
                stuSsxx = _props.stuSsxx,
                editXszp = _props.editXszp;
            var _state = this.state,
                jbxx = _state.jbxx,
                imageUrl = _state.imageUrl,
                tempUrl = _state.tempUrl,
                xsid = _state.xsid;

            var jtjddz = jbxxFormData ? jbxxFormData.jtjddz : '';
            var jtdzDetail = jbxxFormData ? jbxxFormData.jtdzDetail : '';
            var ssxx = '';
            if (stuSsxx && stuSsxx.xqmc && stuSsxx.ldmc && stuSsxx.fj && stuSsxx.cwh) {
                ssxx = stuSsxx.xqmc + stuSsxx.ldmc + ' - ' + stuSsxx.fj + ' - ' + stuSsxx.cwh;
            }
            return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a,
                { layout: 'inline' },
                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u57FA\u672C\u4FE1\u606F',
                    onEdit: function onEdit(type) {
                        _this3.setState({
                            jbxx: true
                        });
                        getChildComponent(1, false);
                    },
                    onSave: function onSave(cb) {
                        _this3.onSavejbxxFormData(cb);
                        getChildComponent(1, true);
                    },
                    onClose: function onClose() {
                        _this3.setState({
                            jbxx: false
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */],
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + '_bg app__css__app-pages-SelfHelp-pInfo-__index__jbxx_icon'
                        },
                        jbxx && editXszp === "true" ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_10_antd_lib_upload___default.a,
                            {
                                name: 'photo',
                                accept: 'image/*',
                                showUploadList: false,
                                action: uploadUrl + "?xsid=" + xsid,
                                beforeUpload: beforeUpload,
                                onChange: this.handleUploadChange
                            },
                            imageUrl || userInfoData ? imageUrl ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('img', {
                                src: imageUrl,
                                alt: '',
                                className: 'jsx-1702183314' + ' ' + 'avatar'
                            }) : tempUrl : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__upload-box'
                                },
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__upload-title'
                                    },
                                    '\u4E0A\u4F20\u56FE\u7247'
                                )
                            )
                        ) : imageUrl ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('img', {
                            src: imageUrl,
                            alt: '',
                            className: 'jsx-1702183314' + ' ' + 'avatar'
                        }) : tempUrl
                    ),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */].Item,
                        { className: 'ml-20' },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                                },
                                '\u59D3\u540D\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-pInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.XM : '',
                                userInfoData && userInfoData.XB ? userInfoData.XB === '男' ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('img', { src: __webpack_require__(141), alt: '', className: 'jsx-1702183314'
                                }) : userInfoData.XB === '女' ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('img', { src: __webpack_require__(142), alt: '', className: 'jsx-1702183314'
                                }) : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('img', { src: __webpack_require__(143), alt: '', className: 'jsx-1702183314'
                                }) : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                                },
                                '\u5B66\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-pInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.XH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                                },
                                '\u8003\u751F\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-pInfo-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.ksh : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                                },
                                '\u8EAB\u4EFD\u8BC1\u4EF6\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-pInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.SFZJH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                                },
                                '\u51FA\u751F\u5E74\u6708\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-pInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.CSRQ : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                                },
                                '\u653F\u6CBB\u9762\u8C8C\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-pInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.ZZMM : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                                },
                                '\u6C11\u65CF\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-pInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.MZ : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                                },
                                '\u7C4D\u8D2F\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-pInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.JG : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            { style: { display: 'none' }, className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                                },
                                '\u6BD5\u4E1A\u5B66\u6821\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-pInfo-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.byzx : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                                },
                                '\u9AD8\u8003\u5206\u6570\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-pInfo-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.gkcj : ''
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    'div',
                    {
                        className: 'jsx-1702183314' + ' ' + 'p-swc'
                    },
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                            },
                            '\u5B66\u9662\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-pInfo-__index__item-name'
                            },
                            userInfoData ? userInfoData.BMMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                            },
                            '\u4E13\u4E1A\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-pInfo-__index__item-name'
                            },
                            userInfoData ? userInfoData.ZYMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                            },
                            '\u73ED\u7EA7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-pInfo-__index__item-name'
                            },
                            userInfoData ? userInfoData.BJMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item2'
                        },
                        jbxx ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_18__components_common_NHFormItem_index__["a" /* default */],
                            { id: 'sjhm',
                                label: __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                                    },
                                    '\u672C\u4EBA\u8054\u7CFB\u7535\u8BDD\uFF1A'
                                ),
                                colon: false,
                                form: form,
                                required: true
                                // hasFeedback={true} 
                                // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/, message: "请输入正确的手机号码或电话号码" }}
                                , pattern: __WEBPACK_IMPORTED_MODULE_23__utils_RegExp__["FormRules"].MOBILE_PHONE_NUMBER,
                                initialValue: jbxxFormData ? jbxxFormData.sjhm : ""
                            },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u8054\u7CFB\u7535\u8BDD' })
                        ) : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                                },
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'red' }, className: 'jsx-1702183314'
                                    },
                                    '*'
                                ),
                                '\u672C\u4EBA\u8054\u7CFB\u7535\u8BDD\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-pInfo-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.sjhm : ''
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                            },
                            '\u5BBF\u820D\u4FE1\u606F\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-pInfo-__index__item-name'
                            },
                            ssxx
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                            },
                            '\u66FE\u7528\u540D\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-pInfo-__index__item-name'
                            },
                            jbxx ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_18__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'cym',
                                    label: '',
                                    colon: false,
                                    form: form,
                                    initialValue: jbxxFormData ? jbxxFormData.cym : ""
                                },
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u66FE\u7528\u540D' })
                            ) : jbxxFormData ? jbxxFormData.cym : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                            },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'span',
                                { style: { color: 'red' }, className: 'jsx-1702183314'
                                },
                                '*'
                            ),
                            '\u6BD5\u4E1A\u5B66\u6821\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-pInfo-__index__item-name'
                            },
                            '  ',
                            jbxx ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_18__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'byxx',
                                    label: '',
                                    colon: false,
                                    form: form,
                                    required: true,
                                    initialValue: jbxxFormData ? jbxxFormData.byxx : ""
                                },
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u6BD5\u4E1A\u5B66\u6821' })
                            ) : jbxxFormData ? jbxxFormData.byxx : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                            },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'span',
                                { style: { color: 'red' }, className: 'jsx-1702183314'
                                },
                                '*'
                            ),
                            '\u662F\u5426\u5E94\u5C4A\u6BD5\u4E1A\u751F\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-pInfo-__index__item-name'
                            },
                            ' ',
                            jbxx ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_18__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'bylx',
                                    label: '',
                                    colon: false,
                                    form: form,
                                    required: true,
                                    initialValue: jbxxFormData ? jbxxFormData.bylx : ""
                                },
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio___default.a.Group,
                                    { style: { display: "flex", margin: "10px" } },
                                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio___default.a,
                                        { value: '01' },
                                        '\u5E94\u5C4A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio___default.a,
                                        { value: '02' },
                                        '\u5F80\u5C4A'
                                    )
                                )
                            ) : jbxxFormData ? jbxxFormData.bylx == '01' ? '应届' : '往届' : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                            },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'span',
                                { style: { color: 'red' }, className: 'jsx-1702183314'
                                },
                                '*'
                            ),
                            '\u662F\u5426\u5E38\u4F4F\u6237\u53E3\u5728\u519C\u6751\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-pInfo-__index__item-name'
                            },
                            jbxx ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_18__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'sfczhkznc',
                                    label: '',
                                    colon: false,
                                    form: form,
                                    required: true,
                                    initialValue: jbxxFormData ? jbxxFormData.sfczhkznc : ""
                                },
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio___default.a.Group,
                                    { style: { display: "flex", margin: "10px" } },
                                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio___default.a,
                                        { value: '是' },
                                        '\u662F'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio___default.a,
                                        { value: '否' },
                                        '\u5426'
                                    )
                                )
                            ) : jbxxFormData ? jbxxFormData.sfczhkznc == '是' ? '是' : '否' : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__detail_adrress'
                        },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'span',
                            { style: { lineHeight: '32px' }, className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                            },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'span',
                                { style: { color: 'red' }, className: 'jsx-1702183314'
                                },
                                '*'
                            ),
                            '\u8BE6\u7EC6\u5BB6\u5EAD\u4F4F\u5740\uFF1A'
                        ),
                        jbxx ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */],
                            null,
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_18__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'jtszdqArray',
                                    label: '',
                                    colon: false,
                                    required: true,
                                    form: form,
                                    initialValue: jbxxFormData ? jbxxFormData.jtszdqArray : []
                                },
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_common_NHCascader__["a" /* default */], { style: { width: 432.63 }, sign: "zhxg_ssq", onChange: function onChange(value, selectedOptions) {
                                        return _this3.onNHCascaderChange(value, selectedOptions, 'jt');
                                    }

                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_18__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'jtjddz',
                                    label: '',
                                    colon: false,
                                    required: true,
                                    form: form,
                                    pattern: { max: 100, message: "家庭住址长度不能超过100字符！" },
                                    initialValue: jbxxFormData ? jbxxFormData.jtjddz : '' },
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input___default.a, { style: { width: 346.07 }, placeholder: '\u5730\u5740\u9700\u586B\u5199\u5230\u5C0F\u533A/\u6751' })
                            )
                        ) : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-pInfo-__index__item-name'
                            },
                            jtdzDetail ? jtdzDetail : '',
                            jtjddz ? jtjddz : ''
                        )
                    ),
                    userInfoData ? userInfoData.FDY && userInfoData.FDY.length > 0 ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314'
                        },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                            },
                            '\u8F85\u5BFC\u5458\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-pInfo-__index__item-name'
                            },
                            userInfoData.FDY.map(function (item, key) {
                                if (item) {
                                    var lxdh = item.LXDH ? "( " + item.LXDH + " )" : "";
                                    return item.XM + lxdh + " ";
                                } else {
                                    return "";
                                }
                            })
                        )
                    ) : null : null,
                    userInfoData ? userInfoData.BZR && userInfoData.BZR.length > 0 ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314'
                        },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__item-label'
                            },
                            '\u73ED\u4E3B\u4EFB\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-pInfo-__index__item-name'
                            },
                            userInfoData.BZR.map(function (item, key) {
                                if (item) {
                                    var lxdh = item.LXDH ? "( " + item.LXDH + " )" : "";
                                    return item.XM + lxdh + " ";
                                } else {
                                    return "";
                                }
                            })
                        )
                    ) : null : null
                ),
                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_styled_jsx_style___default.a, {
                    styleId: '1702183314',
                    css: ['.ant-col-md-7{width:100px;}']
                })
            );
        }
    }]);

    return JbxxInitForm;
}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);

var JbxxForm = __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a.create()(JbxxInitForm);

/* harmony default export */ __webpack_exports__["a"] = (JbxxForm);

/***/ }),

/***/ 1086:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__index_css__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__ = __webpack_require__(7);

















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }














if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item;

var JtcyForm = function (_React$Component) {
    _inherits(JtcyForm, _React$Component);

    function JtcyForm(props) {
        _classCallCheck(this, JtcyForm);

        var _this = _possibleConstructorReturn(this, (JtcyForm.__proto__ || __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of___default()(JtcyForm)).call(this, props));

        _this.cacheJtcyData = function (cb) {
            _this.props.form.validateFields(function (err, values) {
                if (err) return cb(false);
                //判断数据是否全部填写
                var dataList = [];
                if (_this.state.jtcyData && _this.state.jtcyData.length > 0) {
                    for (var i = 0; i < _this.state.jtcyData.length; i++) {
                        var data = _this.state.jtcyData[i];
                        if (!data.gx && !data.xm && !data.gzxxdw && !data.lxfs && !data.operation) {} else {
                            dataList.push(data);
                        }
                    }
                }

                var _this$props = _this.props,
                    cacheFormData = _this$props.cacheFormData,
                    getChildComponent = _this$props.getChildComponent;

                getChildComponent(3, true);
                cacheFormData('jtcy', dataList, true);
                cb(true);
                _this.setState({
                    jtcy: false,
                    jtcyAdd: false
                });
            });
        };

        _this.onjtcyAdd = function () {
            var _this$state = _this.state,
                jtcyAdd = _this$state.jtcyAdd,
                jtcyData = _this$state.jtcyData;

            if (!jtcyData) {
                jtcyData = [];
            }

            if (jtcyAdd) {
                jtcyData.push({
                    key: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["c" /* createUuid */])(),
                    gx: '',
                    xm: '',
                    gzxxdw: '',
                    zzmmm: '',
                    lxfs: '',
                    operation: ''
                });
                _this.setState({
                    jtcyData: jtcyData
                });
            }
            _this.setState({
                jtcyAdd: true
            });
        };

        _this.onjtcySave = function () {
            var jtcyData = _this.state.jtcyData;

            jtcyData.push();
            _this.setState({
                jtcyData: jtcyData,
                jtcyAdd: false
            });
        };

        _this.onjtcyClose = function (index) {
            var jtcyData = _this.state.jtcyData;

            jtcyData.splice(index, 1);
            _this.setState({
                jtcyData: jtcyData,
                jtcyAdd: true
            });
        };

        _this.handleChange = function (value, index, key) {
            var jtcyData = _this.state.jtcyData;
            jtcyData[index][key] = value;
            _this.setState({ jtcyData: jtcyData });
        };

        _this.getzzmmmStr = function (value) {
            var temp = '';
            _this.state.zzmmmList.forEach(function (i) {
                if (i.value === value) {
                    temp = i.label;
                }
            });
            return temp;
        };

        _this.deepCopy = function (obj) {
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                return obj;
            }

            if (_this.isArrayFn(obj)) {
                var newobj = [];
                for (var i = 0; i < obj.length; i++) {
                    newobj.push(_this.deepCopy(obj[i]));
                }
                return newobj;
            } else {
                var _newobj = {};
                for (var attr in obj) {
                    _newobj[attr] = _this.deepCopy(obj[attr]);
                }
                return _newobj;
            }
        };

        _this.isArrayFn = function (value) {
            if (typeof Array.isArray === "function") {
                return Array.isArray(value);
            } else {
                return Object.prototype.toString.call(value) === "[object Array]";
            }
        };

        _this.state = {
            jtcy: false,
            jtcyAdd: false,
            jtcyData: [],
            zzmmmList: [],
            tempStr: '',
            jtcyList: [] //家庭成员数据加载
        };
        return _this;
    }

    _createClass(JtcyForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])('/proData/selectDataList?&sign=DMK_XTGL_ZZMMM', 'GET').then(function (res) {
                if (res && res.data) {
                    var zzmmmList = [];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default()(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var obj = _step.value;

                            zzmmmList.push({ 'label': obj.LABEL, 'value': obj.VALUE });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this2.setState({ zzmmmList: zzmmmList });
                }
            });
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])('/proData/selectDataList?&sign=DMK_XSXX_JTCYGX', 'GET').then(function (res) {
                if (res && res.data) {
                    var jtcyList = [];
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default()(res.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var obj = _step2.value;

                            jtcyList.push({ 'label': obj.LABEL, 'value': obj.VALUE });
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    _this2.setState({ jtcyList: jtcyList });
                }
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('jtcyInitData' in nextProps && nextProps.jtcyInitData) {
                if (nextProps.jtcyInitData instanceof Array) {
                    var temp = [].concat(_toConsumableArray(nextProps.jtcyInitData));
                    this.setState({ jtcyData: temp });
                }
            }
        }

        // 家庭成员 添加

        // 家庭成员 保存添加

        // 家庭成员 关闭添加

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _state = this.state,
                jtcy = _state.jtcy,
                jtcyData = _state.jtcyData,
                jtcyAdd = _state.jtcyAdd,
                jtcyList = _state.jtcyList;
            var _props = this.props,
                getChildComponent = _props.getChildComponent,
                form = _props.form;
            var zzmmmList = this.state.zzmmmList;
            var getFieldDecorator = form.getFieldDecorator;

            var jtcyTransalate = {}; //家庭成员翻译
            for (var i = 0; i < jtcyList.length; i++) {
                jtcyTransalate[jtcyList[i].value] = jtcyList[i].label;
            }
            var jtcyColumns = [{
                title: '关系',
                key: 'gx',
                dataIndex: 'gx',
                render: function render(text, record, index) {
                    return jtcy ?

                    // <Input
                    //     value={text}
                    //     required={true}
                    //     onChange={(e) =>{this.handleChange(e.target.value,index,'gx')}}
                    //     style={{ width: 100 }}
                    //     placeholder="请填写关系"
                    // />
                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_common_NHSelect__["a" /* default */], { style: { width: 140 }, sign: 'DMK_XSXX_JTCYGX',
                        value: text,
                        onChange: function onChange(value) {
                            _this3.handleChange(value, index, 'gx');
                        }

                    })
                    // <NHFormItem id={'gx'} label={''} form={form} required={true}
                    //     pattern={{max:5, message: "关系长度不能超过5字符！"}}
                    //     initialValue={text}>
                    // <Input onChange={(e) =>{this.handleChange(e.target.value,index,'gx')}}
                    //        placeholder="请填写关系"/>
                    // </NHFormItem>
                    : jtcyTransalate[text];
                }
            }, {
                title: '姓名',
                dataIndex: 'xm',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'xm');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u59D3\u540D'
                    }) : text;
                }
            },
            // {
            //     title: '政治面貌',
            //     dataIndex: 'zzmmm',
            //     render: (text, record,index) => {
            //         //let tempStr = '';
            //         return(
            //             jtcy ?
            //             <NHSelect disabled = {jtcy ? false : true} style={{ width: 140 }} sign="DMK_XTGL_ZZMMM"
            //             value={text}
            //             onChange={(value) =>{this.handleChange(value,index,'zzmmm')}}

            //             />
            //             :
            //             (this.getzzmmmStr(text))
            //         );
            //     }
            // },
            {
                title: '工作单位及职务',
                dataIndex: 'gzxxdw',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'gzxxdw');
                        },
                        style: { width: 140 },
                        placeholder: '\u8BF7\u586B\u5199\u5355\u4F4D\u548C\u804C\u52A1'
                    }) : text;
                }
            }, {
                title: '联系电话',
                dataIndex: 'lxfs',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                        FormItem,
                        { form: form, style: { marginBottom: '0px' } },
                        getFieldDecorator('lxfs', {
                            rules: [{ required: true, message: '请填写电话' }, FormRules.MOBILE_PHONE_NUMBER],
                            initialValue: text
                        })(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                            value: text,
                            onChange: function onChange(e) {
                                _this3.handleChange(e.target.value, index, 'lxfs');
                            },
                            style: { width: 100 },
                            placeholder: '\u8BF7\u586B\u5199\u7535\u8BDD'
                        }))
                    ) : text;
                }
            }, {
                title: 'QQ',
                dataIndex: 'qq',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'qq');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586BQQ\u53F7'
                    }) : text;
                }
            }, {
                title: '微信',
                dataIndex: 'wx',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'wx');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5FAE\u4FE1\u53F7'
                    }) : text;
                }
            }, {
                title: '删除',
                dataIndex: 'operation',
                width: 80,
                render: function render(text, record, index) {
                    if (jtcy) {
                        return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                            'div',
                            { className: 'editable-row-operations' },
                            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                'a',
                                {
                                    href: 'javascript:;',
                                    onClick: function onClick() {
                                        return _this3.onjtcyClose(index);
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, {
                                    type: 'close',
                                    style: { color: 'red' }
                                })
                            )
                        );
                    }
                    return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                        'a',
                        { href: 'javascript:;', onClick: function onClick() {
                                return _this3.onjtcyClose();
                            } },
                        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'delete', style: { color: 'red' } })
                    );
                }
            }];
            if (!jtcy) {
                jtcyColumns.pop();
            }
            return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u5BB6\u5EAD\u6210\u5458\u4FE1\u606F',
                    onEdit: function onEdit(type) {
                        _this3.setState({
                            jtcy: true,
                            jtcyAdd: true,
                            cacheData: _this3.deepCopy(_this3.state.jtcyData)
                        });
                        getChildComponent(3, false);
                    },
                    onSave: function onSave(cb) {
                        _this3.cacheJtcyData(cb);
                    },
                    onClose: function onClose() {
                        _this3.setState({
                            jtcy: false,
                            jtcyAdd: false,
                            jtcyData: _this3.deepCopy(_this3.state.cacheData)
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a,
                    null,
                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                        'div',
                        { className: 'p-sw' },
                        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a, {
                            bordered: true,
                            size: 'middle',
                            pagination: false,
                            dataSource: jtcyData,
                            columns: jtcyColumns
                        }),
                        jtcyAdd && __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                            'div',
                            {
                                className: 'mt-10 app__css__app-pages-SelfHelp-pInfo-__index__btn_add',

                                onClick: function onClick() {

                                    _this3.onjtcyAdd();
                                }
                            },
                            '\u6DFB\u52A0\u5BB6\u5EAD\u6210\u5458'
                        )
                    )
                )
            );
        }
    }]);

    return JtcyForm;
}(__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.create()(JtcyForm));

/***/ }),

/***/ 1087:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_date_picker_style__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_date_picker__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__index_css__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__utils_RegExp__);


















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }














if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var RangePicker = __WEBPACK_IMPORTED_MODULE_16_antd_lib_date_picker___default.a.RangePicker;

var dateFormat = 'YYYY/MM/DD ';

var JyjlForm = function (_React$Component) {
    _inherits(JyjlForm, _React$Component);

    function JyjlForm(props) {
        _classCallCheck(this, JyjlForm);

        var _this = _possibleConstructorReturn(this, (JyjlForm.__proto__ || __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default()(JyjlForm)).call(this, props));

        _this.cacheJyjlData = function (cb) {
            _this.props.form.validateFields(function (err, values) {
                if (err) return cb(false);
                //判断数据是否全部填写
                var dataList = [];
                if (_this.state.jyjlData && _this.state.jyjlData.length > 0) {
                    for (var i = 0; i < _this.state.jyjlData.length; i++) {
                        var data = _this.state.jyjlData[i];
                        if (!data.qsny && !data.xxjl && !data.zw && !data.zmr && !data.zmrlxfs && !data.operation) {} else {
                            dataList.push(data);
                        }
                    }
                }
                var _this$props = _this.props,
                    cacheFormData = _this$props.cacheFormData,
                    getChildComponent = _this$props.getChildComponent;

                getChildComponent(4, true);
                cacheFormData('jyjl', dataList, true);
                cb(true);
                _this.setState({
                    jyjl: false,
                    jyjlAdd: false

                });
            });
        };

        _this.validateFields = function (func) {
            var err = false;
            var formData = _this.state.jyjlData;
            func(err, formData);
        };

        _this.onjyjlAdd = function () {
            var _this$state = _this.state,
                jyjlAdd = _this$state.jyjlAdd,
                jyjlData = _this$state.jyjlData;

            if (!jyjlData) {
                jyjlData = [];
            }
            if (jyjlAdd) {
                jyjlData.push({
                    key: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHCore__["c" /* createUuid */])(),
                    qsny: '',
                    xxjl: '',
                    zw: '',
                    zmr: '',
                    zmrlxfs: '',
                    operation: ''
                });
                _this.setState({
                    jyjlData: jyjlData
                });
            }
            _this.setState({
                jyjlAdd: true
            });
        };

        _this.onjyjlSave = function () {
            var jyjlData = _this.state.jyjlData;

            jyjlData.push();
            _this.setState({
                jyjlData: jyjlData,
                jyjlAdd: false
            });
        };

        _this.onjyjlClose = function (index) {
            var jyjlData = _this.state.jyjlData;

            jyjlData.splice(index, 1);
            _this.setState({
                jyjlData: jyjlData,
                jyjlAdd: true
            });
        };

        _this.handleChange = function (value, index, key) {
            var jyjlData = _this.state.jyjlData;
            jyjlData[index][key] = value;
            _this.setState({ jyjlData: jyjlData });
        };

        _this.handleDateChange = function (value, index) {

            var jyjlData = _this.state.jyjlData;
            var kssj = value[0] ? __WEBPACK_IMPORTED_MODULE_20_moment___default()(value[0]).format(dateFormat) : undefined;
            var jssj = value[1] ? __WEBPACK_IMPORTED_MODULE_20_moment___default()(value[1]).format(dateFormat) : undefined;
            jyjlData[index]['kssj'] = kssj;
            jyjlData[index]['jssj'] = jssj;
            _this.setState({ jyjlData: jyjlData });
        };

        _this.deepCopy = function (obj) {
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                return obj;
            }

            if (_this.isArrayFn(obj)) {
                var newobj = [];
                for (var i = 0; i < obj.length; i++) {
                    newobj.push(_this.deepCopy(obj[i]));
                }
                return newobj;
            } else {
                var _newobj = {};
                for (var attr in obj) {
                    _newobj[attr] = _this.deepCopy(obj[attr]);
                }
                return _newobj;
            }
        };

        _this.isArrayFn = function (value) {
            if (typeof Array.isArray === "function") {
                return Array.isArray(value);
            } else {
                return Object.prototype.toString.call(value) === "[object Array]";
            }
        };

        _this.state = {
            jyjl: false,
            jyjlAdd: false,
            jyjlData: []
        };
        return _this;
    }

    _createClass(JyjlForm, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('jyjlInitData' in nextProps && nextProps.jyjlInitData) {
                if (nextProps.jyjlInitData instanceof Array) {
                    var temp = [].concat(_toConsumableArray(nextProps.jyjlInitData));
                    this.setState({ jyjlData: temp });
                }
            }
        }
    }, {
        key: 'disabledDate',
        value: function disabledDate(current) {
            // Can not select days after today and today
            return current && current > __WEBPACK_IMPORTED_MODULE_20_moment___default()().endOf('day');
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                initJtcyData = _props.initJtcyData,
                getChildComponent = _props.getChildComponent;
            var _state = this.state,
                jyjl = _state.jyjl,
                jyjlData = _state.jyjlData,
                jyjlAdd = _state.jyjlAdd;
            var getFieldDecorator = this.props.form.getFieldDecorator;

            var jyjlColumns = [{
                title: '起始年月',
                dataIndex: 'qsny',
                render: function render(text, record, index) {
                    var kssj = record.kssj;
                    var jssj = record.jssj;
                    return jyjl ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(RangePicker
                    // disabledDate={this.disabledDate}
                    , { value: kssj && jssj ? [__WEBPACK_IMPORTED_MODULE_20_moment___default()(kssj, dateFormat), __WEBPACK_IMPORTED_MODULE_20_moment___default()(jssj, dateFormat)] : undefined,
                        format: dateFormat,
                        onChange: function onChange(value) {
                            _this2.handleDateChange(value, index);
                        }
                    }) : (kssj ? kssj : '') + ' ~ ' + (jssj ? jssj : '');
                }
            }, {
                title: '在何地何学校',
                dataIndex: 'xxjl',
                render: function render(text, record, index) {
                    return jyjl ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this2.handleChange(e.target.value, index, 'xxjl');
                        },
                        style: { width: 140 },
                        placeholder: '\u8BF7\u586B\u5199\u5B66\u6821'
                    }) : text;
                }
            },
            // {
            //     title: '任何职',
            //     dataIndex: 'zw',
            //     render: (text, record,index) => {
            //         return jyjl ? (
            //             <Input     
            //                 value={text}
            //                 onChange={(e) =>{this.handleChange(e.target.value,index,'zw')}}         
            //                 style={{ width: 100 }}
            //                 placeholder="请填写职位"
            //             />
            //         ) : (
            //             text
            //         );
            //     }
            // },
            {
                title: '证明人',
                dataIndex: 'zmr',
                render: function render(text, record, index) {
                    return jyjl ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this2.handleChange(e.target.value, index, 'zmr');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u8BC1\u660E\u4EBA'
                    }) : text;
                }
            }, {
                title: '证明人联系电话',
                dataIndex: 'zmrlxfs',
                render: function render(text, record, index) {
                    return jyjl ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        FormItem,
                        { style: { marginBottom: '0px' } },
                        getFieldDecorator('zmrlxfs', {
                            rules: [{ required: true, message: '请填写电话' }, __WEBPACK_IMPORTED_MODULE_27__utils_RegExp__["FormRules"].MOBILE_PHONE_NUMBER],
                            initialValue: text
                        })(__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a, {
                            value: text,
                            onChange: function onChange(e) {
                                _this2.handleChange(e.target.value, index, 'zmrlxfs');
                            },
                            style: { width: 100 },
                            placeholder: '\u8BF7\u586B\u5199\u7535\u8BDD'
                        }))
                    ) : text;
                }
            }, {
                title: '删除',
                dataIndex: 'operation',
                width: 80,
                render: function render(text, record, index) {
                    if (jyjl) {
                        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                            'div',
                            { className: 'editable-row-operations' },
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                'a',
                                {
                                    href: 'javascript:;',
                                    onClick: function onClick() {
                                        return _this2.onjyjlClose(index);
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, {
                                    type: 'close',
                                    style: { color: 'red' }
                                })
                            )
                        );
                    }
                    return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        'a',
                        { href: '#' },
                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon___default.a, { type: 'delete', style: { color: 'red' } })
                    );
                }
            }];

            if (!jyjl) {
                jyjlColumns.pop();
            }
            return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u6559\u80B2\u7ECF\u5386\u4FE1\u606F',
                    onEdit: function onEdit(type) {
                        _this2.setState({
                            jyjl: true,
                            jyjlAdd: true,
                            cacheData: _this2.deepCopy(_this2.state.jyjlData)
                        });
                        getChildComponent(4, false);
                    },
                    onSave: function onSave(cb) {
                        _this2.cacheJyjlData(cb);
                    },
                    onClose: function onClose() {
                        _this2.setState({
                            jyjl: false,
                            jyjlAdd: false,
                            jyjlData: _this2.deepCopy(_this2.state.cacheData)
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_table___default.a, {
                        bordered: true,
                        size: 'middle',
                        pagination: false,
                        dataSource: jyjlData,
                        columns: jyjlColumns
                    }),
                    jyjlAdd && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        'div',
                        {
                            className: 'mt-10 app__css__app-pages-SelfHelp-pInfo-__index__btn_add',

                            onClick: function onClick() {

                                _this2.onjyjlAdd();
                            }
                        },
                        '\u6DFB\u52A0\u6559\u80B2\u7ECF\u5386'
                    )
                )
            );
        }
    }]);

    return JyjlForm;
}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.create()(JyjlForm));

/***/ }),

/***/ 1088:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_custom_scrollbars__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_custom_scrollbars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_common_NHFormItem_FormRules__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__index_css__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components__ = __webpack_require__(10);



















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _extends = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _styleModuleImportMap = {
    './index.css': {
        'progress': 'app__css__app-pages-SelfHelp-pInfo-__index__progress',
        'jbxx_icon': 'app__css__app-pages-SelfHelp-pInfo-__index__jbxx_icon',
        'upload-box': 'app__css__app-pages-SelfHelp-pInfo-__index__upload-box',
        'upload-title': 'app__css__app-pages-SelfHelp-pInfo-__index__upload-title',
        'jbxx_item': 'app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item',
        'jbxx_item2': 'app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item2',
        'item-label': 'app__css__app-pages-SelfHelp-pInfo-__index__item-label',
        'item-name': 'app__css__app-pages-SelfHelp-pInfo-__index__item-name',
        'kzxx_list': 'app__css__app-pages-SelfHelp-pInfo-__index__kzxx_list',
        'kzxx_item': 'app__css__app-pages-SelfHelp-pInfo-__index__kzxx_item',
        'kzxx_label': 'app__css__app-pages-SelfHelp-pInfo-__index__kzxx_label',
        'kzxx_name': 'app__css__app-pages-SelfHelp-pInfo-__index__kzxx_name',
        'kzxx_item_textarea': 'app__css__app-pages-SelfHelp-pInfo-__index__kzxx_item_textarea',
        'kzxx_name_textarea': 'app__css__app-pages-SelfHelp-pInfo-__index__kzxx_name_textarea',
        'btn_add': 'app__css__app-pages-SelfHelp-pInfo-__index__btn_add',
        'title_top': 'app__css__app-pages-SelfHelp-pInfo-__index__title_top',
        'title_top_name': 'app__css__app-pages-SelfHelp-pInfo-__index__title_top_name',
        'line': 'app__css__app-pages-SelfHelp-pInfo-__index__line',
        'detail_adrress': 'app__css__app-pages-SelfHelp-pInfo-__index__detail_adrress'
    }
};

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }


















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;
var basicUrl = "/zzbd";
var stuInfoUrl = "/xxcj/";

//日期格式化
var dateFormat = 'YYYY-MM-DD';

var KzxxFormComponent = function (_React$Component) {
    _inherits(KzxxFormComponent, _React$Component);

    function KzxxFormComponent(props) {
        _classCallCheck(this, KzxxFormComponent);

        var _this = _possibleConstructorReturn(this, (KzxxFormComponent.__proto__ || __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default()(KzxxFormComponent)).call(this, props));

        _this.onSaveKzxx = function (cb) {
            _this.props.form.validateFields(function (error, values) {
                if (error) {
                    return;
                }
                _this.setState({
                    formData: _extends({}, values),
                    kzxx: false
                });
                var _this$props = _this.props,
                    cacheFormData = _this$props.cacheFormData,
                    getChildComponent = _this$props.getChildComponent;

                getChildComponent(2, true);
                __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys___default()(values).forEach(function (key) {
                    if (values[key] != null && values[key] != undefined) {
                        if (values[key].constructor.name == 'Moment') {//处理Moment格式的数据  
                            //values[key] = moment(values[key]).format(dateFormat); 
                        } else if (values[key].constructor.name == 'Array') {
                            if (_typeof(values[key]) === 'object') {
                                var isFileUpload = false;
                                var array = [];
                                var _iteratorNormalCompletion = true;
                                var _didIteratorError = false;
                                var _iteratorError = undefined;

                                try {
                                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(values[key]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                        var item = _step.value;

                                        if (item.hasOwnProperty('uuid') && item['uuid']) {
                                            isFileUpload = true;
                                            array.push(item['uuid']);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return) {
                                            _iterator.return();
                                        }
                                    } finally {
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }

                                if (isFileUpload) {
                                    values[key] = array.join(',');
                                } else {
                                    values[key] = values[key].join(',');
                                }
                            } else {
                                values[key] = values[key].join(',');
                            }
                        }
                    } else {
                        values[key] = '';
                    }
                });

                var postData = {
                    'xxcj': { 'xsid': _this.props.xsid, 'formData': _extends({}, values) },
                    'params': { 'zzbdhjid': _this.props.zzbdhjid, 'xsid': _this.props.xsid }
                };

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])('/newStudent/updateStuInfo', 'POST', postData).then(function (res) {
                    if (res && res.code == 200) {
                        __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.success("保存成功");
                        cb(true);
                        _this.props.reloadMenu();
                    } else {
                        __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error("保存失败");
                    }
                });
            });
        };

        _this.onChange = function (date, dateString) {}
        // console.log('date', date)
        // console.log('dateString', dateString)
        // if(date && dateString){
        //     //this.
        // }


        //获取下拉列表value对应的名称
        ;

        _this.getDmkMc = function (dmbz, zdbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])("/proData/selectDataList", "GET", { sign: dmbz }).then(function (res) {
                if (res) {
                    if (res.data) {
                        var dmkmcList = _this.state.dmkmcList;
                        dmkmcList[zdbz] = res.data;
                        _this.setState({
                            dmkmcList: dmkmcList
                        });
                    }
                }
            });
        };

        _this.getCascaderDmkMc = function (level, sign, cascaderValue, zdbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])("/proData/selectCascaderList", "GET", { level: level, sign: sign, cascaderValue: cascaderValue }).then(function (res) {
                if (res) {
                    if (res.data) {
                        var dmkmcList = _this.state.dmkmcList;
                        dmkmcList[level + zdbz] = res.data;
                        _this.setState({
                            dmkmcList: dmkmcList
                        });
                    }
                }
            });
        };

        _this.handlePreview = function (fjmc, fjid) {

            if (fjmc === "isImage") {
                _this.showPreview('anonymity/docrepo/download/file?attachmentId=' + fjid);
            } else {
                window.open('anonymity/docrepo/download/file?attachmentId=' + fjid);
            }
        };

        _this.showPreview = function (url) {
            _this.setState({
                previewImage: url,
                previewVisible: true
            });
        };

        _this.closeModal = function () {
            return _this.setState({ previewVisible: false });
        };

        _this.fileLists = function (fileLists) {
            {
                var items = [];

                var _loop = function _loop(key) {
                    var fileList = typeof fileLists[key] == 'string' ? fileLists[key].split(";") : fileLists[key];
                    items.push(__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                            'a',
                            { onClick: function onClick() {
                                    _this.handlePreview("file", fileList[0]);
                                } },
                            fileList[1]
                        )
                    ));
                };

                for (var key in fileLists) {
                    _loop(key);
                }
                return items;
            }
        };

        _this.imageLists = function (imageLists) {
            {
                var items = [];

                var _loop2 = function _loop2(key) {
                    var imageList = typeof imageLists[key] == 'string' ? imageLists[key].split(";") : imageLists[key];
                    items.push(__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        'span',
                        null,
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('img', { style: { height: "80px", width: "80px" }, src: "anonymity/docrepo/download/file?attachmentId=" + imageList,
                            onClick: function onClick() {
                                _this.handlePreview("isImage", imageList[0]);
                            } })
                    ));
                };

                for (var key in imageLists) {
                    _loop2(key);
                }
                return items;
            }
        };

        _this.state = {
            xsid: '',
            kzxx: false,
            scrollHeight: 0, //默认滚动高度
            initData: {}, //初始数据
            loading: false, //页面加载状态
            onSubmit: false, //保存按钮加载状态
            isShow: false,
            previewVisible: false,
            formData: '',
            dmkmcList: {},
            zdzmc: ''
        };
        return _this;
    }

    //控件回调

    //获取联级下拉列表value对应的名称

    // 点击文件链接或预览图标时的回调


    //打开图片弹窗

    // 关闭图片弹窗

    // 文件展示 

    //图片展示


    _createClass(KzxxFormComponent, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                form = _props.form,
                getChildComponent = _props.getChildComponent,
                initData = _props.initData;
            var _state = this.state,
                kzxx = _state.kzxx,
                formData = _state.formData,
                previewVisible = _state.previewVisible,
                previewImage = _state.previewImage;
            //提示信息

            var AlertParams = {
                message: '当前没有需要填写的信息',
                description: '',
                type: 'info'
                //信息采集字段分类
            };var infoItems = [];
            var reactid = 0;
            if (initData) {
                //表单信息、表单字段信息
                var _initData$zdglVOs = initData.zdglVOs,
                    zdglVOs = _initData$zdglVOs === undefined ? [] : _initData$zdglVOs;

                if (zdglVOs != null) {
                    if (zdglVOs.length > 0) {
                        var array = [];
                        //循环过滤出多行文本框的key，偶数在左，奇数在右，相应的同行的另一条文本也需要加宽
                        for (var key in zdglVOs) {
                            var kjcs = zdglVOs[key].kjcs;

                            var kjcsjson = JSON.parse(kjcs);
                            if (kjcsjson.type === "textarea" || kjcsjson.type === "oldupload" || kjcsjson.type === "upload") {
                                if (key % 2 === 0) {
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key));
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key) + 1);
                                } else {
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key));
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key) - 1);
                                }
                            }
                        }
                        //显示表单字段信息

                        var _loop3 = function _loop3(_key) {
                            //字段状态、是否必填、默认值、字段标识、字段名称、控件参数、字段值
                            var _zdglVOs$_key = zdglVOs[_key],
                                zdbz = _zdglVOs$_key.zdbz,
                                zdmc = _zdglVOs$_key.zdmc,
                                kjcs = _zdglVOs$_key.kjcs,
                                zdz = _zdglVOs$_key.zdz,
                                sfbt = _zdglVOs$_key.sfbt,
                                mrz = _zdglVOs$_key.mrz,
                                zdzt = _zdglVOs$_key.zdzt; //表单字段

                            var zdzmc = '';
                            var kjcsjson = JSON.parse(kjcs);
                            if (formData && formData[zdbz] != null) {
                                zdz = formData[zdbz];
                            }
                            if (kjcsjson.type === 'datepicker' || kjcsjson.type === 'datetimepicker' || kjcsjson.type === 'timepicker' || kjcsjson.type === 'monthpicker' || kjcsjson.type === 'rangepicker') {
                                //日期值展示阶段，从moment转为文字 
                                if (zdz) {
                                    zdzmc = __WEBPACK_IMPORTED_MODULE_27_moment___default()(zdz).format(kjcsjson.format);
                                }
                            } else if (kjcsjson.type === "select") {
                                if (kjcsjson.dataTag && !_this2.state.dmkmcList[zdbz]) {
                                    _this2.getDmkMc(kjcsjson.dataTag, zdbz);
                                }
                                var list = _this2.state.dmkmcList[zdbz];
                                list && list.map(function (item) {
                                    if (item.VALUE === zdz) {
                                        zdzmc = item.LABEL;
                                    }
                                });
                            } else if (kjcsjson.type === "multiselect") {
                                if (kjcsjson.dataTag && !_this2.state.dmkmcList[zdbz]) {
                                    _this2.getDmkMc(kjcsjson.dataTag, zdbz);
                                }
                                var _list = _this2.state.dmkmcList[zdbz];
                                if (zdz) {
                                    (function () {
                                        var multiselect = typeof zdz == 'string' ? zdz.split(",") : zdz;
                                        var multiselectList = [];

                                        var _loop4 = function _loop4(i) {
                                            _list && _list.map(function (item) {
                                                if (item.VALUE === multiselect[i]) {
                                                    multiselectList.push(item.LABEL);
                                                }
                                            });
                                        };

                                        for (var i in multiselect) {
                                            _loop4(i);
                                        }
                                        zdzmc = multiselectList.join(",");
                                    })();
                                }
                            } else if (kjcsjson.type === "nhcascader") {
                                if (zdz) {
                                    (function () {
                                        var nhcascaderList = typeof zdz == 'string' ? zdz.split(",") : zdz;
                                        var nhcascaderLists = [];

                                        var _loop5 = function _loop5(i) {
                                            var level = i;
                                            var c = i;
                                            var d = i;
                                            var a = ++level;
                                            var b = --d;
                                            if (kjcsjson.dataTag && !_this2.state.dmkmcList[a + zdbz]) {
                                                if (i == "0") {
                                                    _this2.getCascaderDmkMc(a, kjcsjson.dataTag, '', zdbz);
                                                } else {
                                                    _this2.getCascaderDmkMc(a, kjcsjson.dataTag, nhcascaderList[b], zdbz);
                                                }
                                            }
                                            var list = _this2.state.dmkmcList[level++ + zdbz];

                                            list && list.map(function (item) {
                                                if (item.value === nhcascaderList[c]) {
                                                    nhcascaderLists.push(item.label);
                                                }
                                            });
                                        };

                                        for (var i in nhcascaderList) {
                                            _loop5(i);
                                        }
                                        zdzmc = nhcascaderLists.join("/");
                                    })();
                                }
                            } else if (kjcsjson.type === "switch") {
                                zdzmc = zdz === "1" || zdz === true ? kjcsjson.checkedText : kjcsjson.uncheckedText;
                            } else if (kjcsjson.type === "radio") {
                                kjcsjson.options && kjcsjson.options.map(function (item, key) {
                                    if (item.value === zdz) {
                                        zdzmc = item.label;
                                    }
                                });
                            } else if (kjcsjson.fileType === "file" && zdz) {
                                var fileLists = typeof zdz == 'string' ? zdz.split(",") : zdz;
                                zdzmc = _this2.fileLists(fileLists);
                            } else if (kjcsjson.fileType === "image" && zdz) {
                                if ((typeof zdz === 'undefined' ? 'undefined' : _typeof(zdz)) === 'object') {
                                    var _array = [];
                                    var _iteratorNormalCompletion2 = true;
                                    var _didIteratorError2 = false;
                                    var _iteratorError2 = undefined;

                                    try {
                                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(zdz), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                            var item = _step2.value;

                                            if (item.hasOwnProperty('uuid') && item['uuid']) {
                                                _array.push(item['uuid']);
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError2 = true;
                                        _iteratorError2 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                                _iterator2.return();
                                            }
                                        } finally {
                                            if (_didIteratorError2) {
                                                throw _iteratorError2;
                                            }
                                        }
                                    }

                                    zdz = _array;
                                } else {
                                    zdz = zdz.split(",");
                                }
                                zdzmc = _this2.imageLists(zdz);
                            } else {
                                zdzmc = zdz;
                            }
                            var required = sfbt === '1' ? true : false;

                            var formItem = void 0;
                            var csz = formData ? formData[zdbz] : zdz;
                            if (required) {
                                formItem = kjcsjson.type === 'textarea' || kjcsjson.type === "oldupload" || kjcsjson.type === "upload" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { height: "120px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item_textarea", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-pInfo-__index__kzxx_label' },
                                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                            'span',
                                            { style: { color: 'red' } },
                                            '*'
                                        ),
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-pInfo-__index__kzxx_name_textarea' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs }) : zdzmc
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { height: "71px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-pInfo-__index__kzxx_label' },
                                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                            'span',
                                            { style: { color: 'red' } },
                                            '*'
                                        ),
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-pInfo-__index__kzxx_name' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs,
                                            onChange: _this2.onChange }) : zdzmc
                                    )
                                );
                            } else {
                                formItem = kjcsjson.type === 'textarea' || kjcsjson.type === "oldupload" || kjcsjson.type === "upload" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { height: "120px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item_textarea", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-pInfo-__index__kzxx_label' },
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-pInfo-__index__kzxx_name_textarea' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs }) : zdzmc
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { height: "71px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-pInfo-__index__kzxx_label' },
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-pInfo-__index__kzxx_name' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs,
                                            onChange: _this2.onChange }) : zdzmc
                                    )
                                );
                            }
                            infoItems.push(formItem);
                        };

                        for (var _key in zdglVOs) {
                            _loop3(_key);
                        }
                    } else {
                        //未找到表单配置的采集字段信息
                        AlertParams['message'] = '暂时没有需要填写的信息';
                        AlertParams['description'] = '当前未配置采集信息项';
                        AlertParams['type'] = 'warning';
                    }
                }
            }

            return __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                'div',
                {
                    className: 'jsx-2266704716'
                },
                infoItems.length > 0 && __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                    'div',
                    {
                        className: 'jsx-2266704716'
                    },
                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__pages_Assembly_titleTop__["a" /* default */], {
                        title: '\u6269\u5C55\u4FE1\u606F',
                        onEdit: function onEdit(type) {
                            _this2.setState({
                                kzxx: true
                            });
                            getChildComponent(2, false);
                        },
                        onSave: function onSave(cb) {
                            _this2.onSaveKzxx(cb);
                        },
                        onClose: function onClose() {
                            _this2.setState({
                                kzxx: false
                            });
                        }
                    }),
                    infoItems.length > 0 ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a,
                        null,
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-2266704716' + ' ' + 'p-sw'
                            },
                            __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-2266704716' + ' ' + 'app__css__app-pages-SelfHelp-pInfo-__index__kzxx_list'
                                },
                                infoItems
                            )
                        )
                    ) : __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default.a, _extends({ style: { marginTop: 20 }
                    }, AlertParams, {
                        showIcon: true
                    })),
                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a,
                        {
                            visible: previewVisible,
                            footer: null,
                            onCancel: this.closeModal
                        },
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('img', {
                            alt: 'example',
                            style: { width: '100%' },
                            src: previewImage,
                            className: 'jsx-2266704716'
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_styled_jsx_style___default.a, {
                    styleId: '2266704716',
                    css: ['.app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_item{height:100% !important;}', '.app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_label{background-color:#fff;}', '.app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_name{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;width:67%;}']
                })
            );
        }
    }]);

    return KzxxFormComponent;
}(__WEBPACK_IMPORTED_MODULE_20_react___default.a.Component);

var KzxxForm = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create()(KzxxFormComponent);
/* harmony default export */ __webpack_exports__["a"] = (KzxxForm);

/***/ }),

/***/ 1089:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_css__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__JbxxForm__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__JtcyForm__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__JyjlForm__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__KzxxForm__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_SelfHelp_common_hint__ = __webpack_require__(35);








var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }


















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var PInfo = function (_React$Component) {
    _inherits(PInfo, _React$Component);

    function PInfo(props) {
        _classCallCheck(this, PInfo);

        var _this = _possibleConstructorReturn(this, (PInfo.__proto__ || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default()(PInfo)).call(this, props));

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({
                        nonOperationalData: res.data,
                        zzbdhjid: zzbdhjid
                    });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.getChildComponent = function (flag, mode) {
            switch (flag) {
                case 1:
                    _this.setState({ jbxxFlag: mode });
                    break;
                case 2:
                    _this.setState({ kzxxFlag: mode });
                    break;
                case 3:
                    _this.setState({ jtcyFlag: mode });
                    break;
                case 5:
                    _this.setState({ jyjlFlag: mode });
                    break;
                default:
                    break;
            }
        };

        _this.cacheFormData = function (type, values, isAdd) {
            //const{jbxxInitData} = this.state;
            if (type == 'jbxx') {
                var sjhm = values.sjhm,
                    jtszdqArray = values.jtszdqArray,
                    jtjddz = values.jtjddz;

                if (sjhm !== null && jtszdqArray !== null && jtszdqArray.length > 0 && jtjddz !== null) {
                    _this.setState({
                        jbxxInitData: _extends({}, values),
                        isEditJbxx: true
                    }, function () {
                        _this.insertData4Yxwz();
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("存在必填信息未填写，请填写后再保存！");
                }
            }
            if (type == 'jtcy' && isAdd) {
                if (values !== null && values.length > 0) {
                    _this.setState({
                        jtcyInitData: values,
                        isEditJtcy: true
                    }, function () {
                        _this.insertData4Yxwz();
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("家庭成员信息不能为空！");
                }
            }
            if (type == 'jyjl') {
                if (values !== null && values.length > 0) {
                    _this.setState({
                        jyjlInitData: values,
                        isEditJyjl: true
                    }, function () {
                        _this.insertData4Yxwz();
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("教育经历信息不能为空！");
                }
            }
        };

        _this.getData4Yxwz = function () {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                _this.setState({ xsid: userId });
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_NHFetch__["a" /* default */])('/newStudent/queryStuInfo', 'GET', { 'xsid': userId }).then(function (res) {
                    if (res && res.data) {
                        var stuInfo = res.data.stuInfo;
                        var stuXxcj = res.data.stuXxcj;
                        var stuSsxx = res.data.stuSsxx;
                        var editXszp = res.data.editXszp;

                        _this.setState({
                            userBaseInfo: stuInfo.userBaseInfo,
                            jbxxInitData: stuInfo.xsJbxx4YxwzVO,
                            jtcyInitData: stuInfo.jtcyVO,
                            jyjlInitData: stuInfo.jyjlVO,
                            kzxxInitData: _extends({}, stuXxcj),
                            stuSsxx: stuSsxx,
                            editXszp: editXszp
                        });
                    }
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("登录超时,请重新登录！");
            }
        };

        _this.insertData4Yxwz = function () {
            var postFormData = {};
            var _this$state = _this.state,
                jbxxInitData = _this$state.jbxxInitData,
                jtcyInitData = _this$state.jtcyInitData,
                jyjlInitData = _this$state.jyjlInitData,
                xsid = _this$state.xsid,
                zzbdhjid = _this$state.zzbdhjid;

            postFormData['xsid'] = xsid;
            postFormData['xsJbxx4YxwzVO'] = jbxxInitData;
            postFormData['jtcyVO'] = jtcyInitData;
            postFormData['jyjlVO'] = jyjlInitData;

            var postData = {
                'xsInfo4YxwzVO': postFormData,
                'params': { 'zzbdhjid': zzbdhjid, 'xsid': xsid }
            };

            //必填一
            var _postData$xsInfo4Yxwz = postData.xsInfo4YxwzVO.xsJbxx4YxwzVO,
                sjhm = _postData$xsInfo4Yxwz.sjhm,
                jtszdqArray = _postData$xsInfo4Yxwz.jtszdqArray,
                jtjddz = _postData$xsInfo4Yxwz.jtjddz;

            var jbxxFlag = false;
            if (sjhm !== null && jtszdqArray !== null && jtszdqArray.length > 0 && jtjddz !== null) {
                jbxxFlag = true;
            }
            //必填项二：两个填一个
            var _postData$xsInfo4Yxwz2 = postData.xsInfo4YxwzVO,
                jtcyVO = _postData$xsInfo4Yxwz2.jtcyVO,
                jyjlVO = _postData$xsInfo4Yxwz2.jyjlVO;

            var jtxxFlag = false;
            if (jtcyVO !== null && jtcyVO.length > 0) {
                jtxxFlag = true;
            }
            //必填三
            var jyxxFlag = false;
            if (jyjlVO !== null && jyjlVO.length > 0) {
                jyxxFlag = true;
            }
            var hjblFlag = false;
            if (jbxxFlag && jtxxFlag && jyxxFlag) {
                hjblFlag = true;
            }
            postData.params.hjblFlag = hjblFlag;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_NHFetch__["a" /* default */])('/newStudent/updateStuInfo', 'POST', postData).then(function (res) {
                if (res && res.code == 200) {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.success("保存成功");
                    _this.reloadMenu();
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("保存失败");
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD001_2',
            hjmc: '',
            jbxxFormData: {},
            formInitData: {},
            jbxxInitData: {},
            jtcyInitData: [],
            jyjlInitData: [],
            kzxxInitData: {},
            userBaseInfo: {},
            stuSsxx: {},
            xsid: '',
            jbxxFlag: true,
            kzxxFlag: true,
            jtcyFlag: true,
            jyjlFlag: true,
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            isEditJbxx: false,
            isEditJtcy: false,
            isEditZyshgx: false,
            isEditJyjl: false,
            menuList: [],
            zzbdhjid: ''
        };
        return _this;
    }

    _createClass(PInfo, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.queryQztjAndYlhj();
            //this.getYlhjData();
            this.getData4Yxwz();
        }

        //查询前置条件和依赖环节


        //缓存编写的信息，缓存完之后提交


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230'
                        /*   active={0}*/
                        , mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_8__components__["a" /* Flex */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__JbxxForm__["a" /* default */], { ref: 'refJbxxForm', jbxxFormData: this.state.jbxxInitData,
                                getChildComponent: this.getChildComponent,
                                cacheFormData: this.cacheFormData,
                                userInfoData: this.state.userBaseInfo,
                                stuSsxx: this.state.stuSsxx,
                                editXszp: this.state.editXszp
                            }),
                            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__KzxxForm__["a" /* default */], { ref: 'refKzxxForm', getChildComponent: this.getChildComponent,
                                reloadMenu: this.reloadMenu,
                                xsid: this.state.xsid,
                                zzbdhjid: this.state.zzbdhjid,
                                initData: this.state.kzxxInitData
                            }),
                            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__JtcyForm__["a" /* default */], { ref: 'refJtcyForm', jtcyInitData: this.state.jtcyInitData,
                                getChildComponent: this.getChildComponent,
                                cacheFormData: this.cacheFormData }),
                            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__JyjlForm__["a" /* default */], { ref: 'refJyjlForm', jyjlInitData: this.state.jyjlInitData,
                                getChildComponent: this.getChildComponent,
                                cacheFormData: this.cacheFormData }),
                            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                                'div',
                                { className: 'p-sw text-center mt-30' },
                                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__common__["a" /* default */], { hjmc: "个人信息填写", key: 'GD001_2', mkbz: 'GD001_2', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return PInfo;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);



/***/ }),

/***/ 1090:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Pay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__index_css__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__order_js__ = __webpack_require__(1091);











var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }


















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_20_history_createHashHistory___default()();

var Pay = function (_React$Component) {
    _inherits(Pay, _React$Component);

    function Pay(props) {
        _classCallCheck(this, Pay);

        var _this = _possibleConstructorReturn(this, (Pay.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(Pay)).call(this, props));

        _this.syncJfxx = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (xsid) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])('/openapi/xtgl/queryDqxx', 'GET').then(function (res) {
                    if (res && res.code === 200) {
                        //如果是项目地，则需要先进行同步缴费信息
                        _this.syncStuChargeInfo(res.data.xxdm, xsid);
                    }
                });
            }
        };

        _this.syncStuChargeInfo = function (xxdm, xsid) {
            switch (xxdm) {
                // 长沙电力职业技术学院
                case '13938':
                    {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])('/openapi/jfxt/syncChargeInfoFromBankOfChangsha', 'GET', { xsid: xsid }).then(function (res) {
                            if (res && res.code == 200) {
                                var _res$data = res.data,
                                    status = _res$data.status,
                                    msg = _res$data.msg;

                                if (status != '00' && status != '02') {
                                    Toast.fail(msg);
                                }
                            }
                        });
                        break;
                    }
                default:
                    {
                        break;
                    }
            }
        };

        _this.updateZzbdBlzt = function () {
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])('/zzbd/updateZzbdBlzt', 'GET', { zzbdhjid: zzbdhjid, hjdm: 'GD008' }).then(function (res) {
                if (res.data) {
                    _this.reloadMenu();
                }
            });
        };

        _this.getSfxxList = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])('/jfxtUnauth/yxwzjfxx/getJfxxList', 'GET') //所有的收费数据
            .then(function (resData) {
                if (resData && resData.data) {
                    _this.setState({ data: resData.data }, function () {
                        var list = _this.state.data.filter(function (item) {
                            return item.QFJE > 0 ? true : false;
                        });
                        if (resData.data.length === 0) {
                            _this.setState({
                                flage: false
                            });
                        } else {
                            if (list.length <= 0) {
                                _this.setState({ flage: false });
                                // this.handleConfirmSubmit();//进入这里说明没有欠费信息，所以直接保存环节数据
                            }
                        }
                    });
                }
            });
        };

        _this.showModal = function () {
            // this.loadZxjfInfo();
            _this.setState({
                visible: true
            });
        };

        _this.handleOk = function (e) {
            _this.setState({
                visible: false
            }, function () {
                _this.getSfxxList();
            });
        };

        _this.handleCancel = function (e) {
            _this.setState({
                visible: false
            }, function () {
                _this.getSfxxList();
            });
        };

        _this.loadZxjfInfo = function () {
            var mkbz = _this.state.mkbz;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])('/jfxtUnauth/yxwzjfxx/getCurrDdxx', 'GET', { hjdm: mkbz }).then(function (res) {
                if (res && res.data) {
                    _this.setState({
                        zxjfInfo: res.data
                    });
                }
            });
        };

        _this.queryQztjAndYlhj = function (callback) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    } else if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    } else if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    } else {
                        _this.getSfxxList();
                    }if (callback) {
                        callback(_this.state.operable);
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_22__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.onSave = function () {
            _this.setState({ loading: true });
            setTimeout(function () {
                _this.setState({
                    loading: false
                });
            }, 1000);
        };

        _this.checkIsZzbdHjLinked = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this.getQueryString('pkid');

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])("/zzbdCommon/checkIsZzbdHjLinked", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res) {
                    if (res.data) {
                        _this.setState({
                            isHjLinked: res.data
                        });
                    } else {
                        _this.setState({
                            isHjLinked: false
                        });
                    }
                } else {
                    _this.setState({
                        isHjLinked: false
                    });
                }
            });
        };

        _this.handleConfirmSubmit = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var hjdm = 'GD008';
            var params = { xsid: xsid, hjdm: hjdm };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])('/zzbd/commonSaveLinkTransactionStatusByXsidAndHjdm', 'POST', params).then(function (res) {
                _this.checkIsZzbdHjLinked();
                if (res) {
                    if (res.data === 1) {
                        _this.reloadMenu();
                    }
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD008',
            hjmc: '',
            data: [],
            loading: false,
            pageData: { //分页设置的是三个参数
                total: 0,
                pageSize: 10, //当前页默认多少条数据
                page: 1
            },
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            isHjLinked: false, //环节是否办理标志
            zxjfInfo: {}, //在线缴费相关信息
            hjje: 0, //缓交金额
            jfxxHz: {}, //缴费信息汇总
            visible: false,
            flage: true //是否存在需要缴费的项目
        };
        return _this;
    }

    _createClass(Pay, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.syncJfxx();
            this.queryQztjAndYlhj(function (operable) {
                if (operable) {
                    //办理状态根据 关联现场环节和是否反向关联修改 不根据现场状态
                    // this.updateZzbdBlzt();
                }
            });
            this.handleConfirmSubmit();
            this.loadZxjfInfo();
            // this.checkIsZzbdHjLinked();
            //this.getSfxxList();//列表显示
        }

        /**
         * 同步第三方平台学生缴费信息
         */


        //迎新现场已办理时迎新网站自动办理

        //获取在线缴费相关信息


        //查询前置条件和依赖环节


        //检查该环节是否已经办理


        //自动办理缴费环节，后台代码有逻辑判断（只有满足办理条件的才会自动办理）


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                loading = _state.loading,
                data = _state.data,
                isHjLinked = _state.isHjLinked,
                zxjfInfo = _state.zxjfInfo;

            var columns = [{
                title: '序号',
                dataIndex: 'XH'
            }, {
                title: '收费项目',
                dataIndex: 'SFXMMC'
            }, {
                title: '应收金额（元）',
                dataIndex: 'YSJE'
            }, {
                title: '实收金额（元）',
                dataIndex: 'SSJE',
                render: function render(text, record) {
                    return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                        'span',
                        { className: 'text-primary' },
                        text
                    );
                }
            }, {
                title: '欠费金额（元）',
                dataIndex: 'QFJE',
                render: function render(text, record) {
                    if (text > 0) {
                        return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                            'span',
                            { className: 'text-info-red' },
                            text
                        );
                    } else {
                        return text;
                    }
                }
            }];

            return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                'div',
                { className: 'app__css__app-pages-SelfHelp-pay-__index__page_pay' },
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_12__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230'
                        /*active={7}*/
                        , mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_12__components__["a" /* Flex */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjmc, extra: false }),
                            __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                                'div',
                                { className: 'p-sw mt-20' },
                                __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_table___default.a, {
                                    bordered: true,
                                    size: 'middle',
                                    pagination: false,
                                    columns: columns,
                                    dataSource: data
                                }),
                                __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                                    'div',
                                    { className: 'text-center mt-50' },
                                    __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        this.state.flage == true && zxjfInfo.ZFD != '0' ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default.a,
                                            { onClick: function onClick() {
                                                    return _this2.showModal();
                                                },
                                                type: 'primary',
                                                htmlType: 'submit' },
                                            '\u7F51\u4E0A\u652F\u4ED8'
                                        ) : null,
                                        __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                )
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__common__["a" /* default */], { hjmc: "网上缴费", key: 'GD008', mkbz: 'GD008', nonOperationalData: this.state.nonOperationalData }),
                __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal___default.a,
                    {
                        title: '\u652F\u4ED8\u8BE6\u60C5\u4FE1\u606F',
                        visible: this.state.visible,
                        onOk: this.handleOk,
                        onCancel: this.handleCancel },
                    __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__order_js__["a" /* default */], { zxjfInfo: zxjfInfo, ddh: zxjfInfo.DDH, sfxmInfo: data })
                )
            );
        }
    }]);

    return Pay;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);



/***/ }),

/***/ 1091:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Order; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_list_style__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_list__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__paydisc_index_js__ = __webpack_require__(544);















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }







var Item = __WEBPACK_IMPORTED_MODULE_13_antd_lib_list___default.a.Item;
var Brief = Item.Brief;
var confirm = __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.confirm;

var Order = function (_React$Component) {
  _inherits(Order, _React$Component);

  function Order(props) {
    _classCallCheck(this, Order);

    var _this = _possibleConstructorReturn(this, (Order.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(Order)).call(this, props));

    _this.getTotalNumber = function () {
      var list = _this.props.sfxmInfo;
      var yjje = 0.0; //应缴金额
      var ysje = 0.0; //已收金额
      var sjje = _this.state.jfje; //实缴金额
      var hjje = _this.props.hjje ? _this.props.hjje : 0.0;
      list.map(function (item) {
        yjje += item.YSJE;
        ysje += item.SSJE;
        // sjje+=item.JE;
        //  hjje+=(item.QFJE-item.JE);//缓交金额，还需要加上这次学生修改的没交的金额
        return item;
      });
      return {
        yjje: yjje,
        ysje: ysje,
        sjje: sjje - hjje,
        hjje: hjje
      };
    };

    _this.getDdxx = function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_NHFetch__["a" /* default */])("/openapi/jfxt/addOrder", "POST", {}).then(function (res) {
        if (res) {
          var msg = res.data;
          _this.setState({
            ddxx: msg
          }, function () {
            _this.toPayView();
          });
        }
      });
    };

    _this.addOrder = function () {
      //1、获取支付项目
      var list = _this.props.sfxmInfo.filter(function (item) {
        return item.QFJE > 0 ? true : false;
      });
      if (list.length <= 0) {
        __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error("支付项目为空，不能执行支付操作");
        return;
      }
      var jfxm = [];
      //je(交易金额),ysje(应缴金额),ssje(已缴金额)
      list.map(function (item) {
        jfxm.push({
          sfxmid: item.SFXMID,
          sfxmdm: item.SFXMDM,
          sfxmmc: item.SFXMMC,
          je: item.YSJE,
          ysje: item.YSJE,
          ssje: item.SSJE
        });
        return item;
      });
      var map = _this.getTotalNumber();

      //2、生成订单
      var params = {
        jfxm: jfxm,
        sfxyjldd: _this.props.zxjfInfo.SFXYJLDD,
        jyje: map.sjje,
        yjje: map.yjje,
        ysje: map.ysje,
        hjje: map.hjje
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_NHFetch__["a" /* default */])("/openapi/jfxt/addOrder", "POST", params).then(function (res) {
        if (res) {
          var msg = res.data;
          _this.setState({
            ddxx: msg
          });
          if (msg.code === "1") {
            //返回信息时正常的，此时跳转到支付界面
            _this.toPayView();
          } else {
            //返回信息有误
            __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error(msg.message);
          }
        }
      });
    };

    _this.getQueryString = function (name) {
      return decodeURIComponent((new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(location.href) || [, ""])[1].replace(/\+/g, "%20")) || null;
    };

    _this.getJfje = function () {
      var list = _this.props.sfxmInfo.filter(function (item) {
        return item.QFJE > 0 ? true : false;
      });
      var jfje = 0.0; // 缴费金额
      list.map(function (item) {
        jfje += item.QFJE;
      });
      jfje = Math.round(jfje * Math.pow(10, 2)) / Math.pow(10, 2);
      _this.setState({
        jfje: jfje
      });
    };

    _this.handleBackFunc = function () {
      if (_this.props.backFunc) {
        _this.props.backFunc();
      }
    };

    _this.handleSubmit = function () {
      //如果有提示信息，则需要先显示提示信息
      var $this = _this;
      if (_this.props.zxjfInfo.ZFTS) {
        confirm({
          title: "提示",
          content: _this.props.zxjfInfo.ZFTS,
          onOk: function onOk() {
            $this.toRedirertPayView();
          },
          onCancel: function onCancel() {}
        });
      } else {
        _this.toRedirertPayView();
      }
    };

    _this.toRedirertPayView = function () {
      //不存在正在进行的订单的时候就要先添加一个订单
      if (_this.props.ddh === null) {
        _this.addOrder();
      } else {
        //此时说明存在正在进行的订单，就把订单的信息查询出来
        _this.getDdxx();
      }
    };

    _this.toPayView = function () {
      var msg = _this.state.ddxx;
      var type = _this.props.zxjfInfo.DJFSID;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__paydisc_index_js__["a" /* handle */])(type, msg.ddh, msg.csxx, msg.xsxx, msg.jfxm, msg.jyje, msg.yjje, msg.ysje, msg.hjje);
    };

    _this.handleSyncBtn = function () {
      var msg = _this.state.ddxx;
      var type = _this.props.zxjfInfo.DJFSID;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__paydisc_index_js__["b" /* syscBtnFunc */])(type, msg.ddh);
    };

    _this.state = {
      ddxx: {}, //订单信息
      jfje: 0, //本次缴费总金额
      list: []
    };
    return _this;
  }

  _createClass(Order, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      //进来后先计算缴费金额
      this.getJfje();
    }
    //获取订单信息

    //添加一个订单


    //计算要缴费的金额


    //点击支付按钮触发的事件


    //进行支付跳转前的判断

    //跳转到支付界面


    //绑定同步按钮

  }, {
    key: "render",
    value: function render() {
      var ddxx = this.state.ddxx;
      var zxjfInfo = this.props.zxjfInfo;
      var list = this.props.sfxmInfo.filter(function (item) {
        return item.QFJE > 0 ? true : false;
      });
      var columns = [{
        title: "收费项目",
        dataIndex: "SFXMMC"
      }, {
        title: "应付金额（元）",
        dataIndex: "QFJE"
      }];
      return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
        "div",
        null,
        this.state.jfje != 0 ? __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
          "p",
          null,
          __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
            "span",
            { style: { fontSize: "15px", fontWeight: "bold" } },
            "\u4EA4\u6613\u91D1\u989D:",
            this.state.jfje,
            "\u5143"
          )
        ) : null,
        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table___default.a, {
          bordered: true,
          size: "middle",
          pagination: false,
          columns: columns,
          dataSource: list
        }),
        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
          "p",
          { style: { color: "red" } },
          "\u7279\u522B\u8BF4\u660E\uFF1A\u4E3A\u4E86\u89E3\u51B3\u94F6\u884C\u5361\u4EA4\u6613\u9650\u989D\u7B49\u539F\u56E0\uFF0C\u7F51\u4E0A\u7F34\u8D39\u652F\u6301\u591A\u6B21\u7F34\u8D39\uFF1B\u8BF7\u52FF\u6076\u610F\u591A\u6B21\u5C0F\u989D\u7F34\u8D39\uFF08\u59820.1\u5143\uFF09\uFF0C\u4EE5\u514D\u4F60\u7684\u94F6\u884C\u5361\u68C0\u6D4B\u6709\u98CE\u9669\u88AB\u7981\u6B62\u4EA4\u6613"
        ),
        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
          {
            style: {
              float: "left",
              backgroundColor: "rgb(1, 176, 241)",
              color: "#fff"
            },
            onClick: this.handleSubmit
          },
          "\u8FDB\u5165\u652F\u4ED8\u754C\u9762"
        )
      );
    }
  }]);

  return Order;
}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);



/***/ }),

/***/ 1092:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handle; });
/* unused harmony export syscBtnFunc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_NHVirtualForm_js__ = __webpack_require__(114);






var md5 = __webpack_require__(119);

/**
 * 网上支付办理接口
 * 请自行在此处判断需要的参数是否符合要求，例如判断身份证件号是否为空，Toast.hide()，可以使用改方法关闭准备跳转支付界面提示
 *
 * @param {*} csxx 配置参数信息，包含：pczflj(PC端支付路径),ydzflj(移动端支付路径)，zfts(支付提示),所有的自定义配置的参数信息
 * @param {*} xsxx 学生信息，包含：XSID(学生ID),XH(学号),XM(姓名),XBM(性别码),SFZJH(身份证件号),RXNF(入学年份),CSRQ(出生日期)
 */
var handle = function handle(csxx, xsxx) {

    var xh = xsxx.XH; //学号
    var url = csxx.pcUrl; //单点登录连接地址

    if (!url) {
        __WEBPACK_IMPORTED_MODULE_2_antd_lib_message___default.a.info("单点登录连接地址不能为空，请联系管理员！");
        return;
    }

    //虚拟表单提交
    var map = {
        cid: xsxx.XSID,
        user_name: xsxx.XM,
        school_code: csxx.schoolCode,
        account_type: 'STUNO',
        account_no: xsxx.KSH,
        app_code: csxx.appCode,
        back_url: csxx.turnBackUrl,
        mark: window.location.href
    };
    var signature = md5(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(map) + csxx.appKey + csxx.signKey);
    var params = {
        json: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(map),
        appkey: csxx.appKey,
        signature: signature
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_NHVirtualForm_js__["a" /* NHVirtualForm */])(url + '/wac/e/apiForKk/wac/skipToPC', "_blank", params);
};

/**
 * 点击同步按钮触发时的操作
 * @param {*} ddh 订单号
 */
var syscBtnFunc = function syscBtnFunc(ddh) {};

//获取当前日志，格式yyyyMMdd
function getNowFormatDate() {
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var hours = date.getHours(); //获取系统时，
    var minutes = date.getMinutes(); //分
    var seconds = date.getSeconds(); //秒
    var strDate = date.getDate();

    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
    }
    if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
    }
    if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
    }
    var currentdate = year + month + strDate + hours + minutes + seconds;;
    return currentdate;
}

/***/ }),

/***/ 1093:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handle; });
/* unused harmony export syscBtnFunc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_NHVirtualForm_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_NHFetch__ = __webpack_require__(7);




var md5 = __webpack_require__(119);

/**
 * 网上支付办理接口
 * 请自行在此处判断需要的参数是否符合要求，例如判断身份证件号是否为空，Toast.hide()，可以使用改方法关闭准备跳转支付界面提示
 *
 * @param {*} ddh 订单号
 * @param {*} csxx 配置参数信息，包含：pczflj(PC端支付路径),ydzflj(移动端支付路径)，zfts(支付提示),所有的自定义配置的参数信息
 * @param {*} xsxx 学生信息，包含：XSID(学生ID),XH(学号),XM(姓名),XBM(性别码),SFZJH(身份证件号),RXNF(入学年份),CSRQ(出生日期)
 * @param {*} jfxm 缴费信息，LIst<Map<String,Object>>对象,包含：sfxmid(收费项目ID),sfxmdm(收费项目代码),sfxmmc(收费项目名称)，je(金额)
 * @param {*} jyje 交易金额
 * @param {*} yjje 应缴金额
 * @param {*} ysje 已缴金额
 * @param {*} hjje 缓缴金额
 */
var handle = function handle(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje) {
  var params = csxx;
  params.orderId = ddh;
  params.jfje = jyje;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_NHFetch__["a" /* default */])('/openapi/jfxt/getjsyhUrl', 'POST', params).then(function (res) {
    if (res) {
      var msg = res.data;
      window.open(msg);
    }
  });
};

/**
 * 点击同步按钮触发时的操作
 * @param {*} ddh 订单号
 */
var syscBtnFunc = function syscBtnFunc(ddh) {};

/***/ }),

/***/ 1094:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handle; });
/* unused harmony export syscBtnFunc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_NHVirtualForm_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_NHFetch__ = __webpack_require__(7);




var md5 = __webpack_require__(119);

/**
 * 网上支付办理接口
 * 请自行在此处判断需要的参数是否符合要求，例如判断身份证件号是否为空，Toast.hide()，可以使用改方法关闭准备跳转支付界面提示
 *
 * @param {*} ddh 订单号
 * @param {*} csxx 配置参数信息，包含：pczflj(PC端支付路径),ydzflj(移动端支付路径)，zfts(支付提示),所有的自定义配置的参数信息
 * @param {*} xsxx 学生信息，包含：XSID(学生ID),XH(学号),XM(姓名),XBM(性别码),SFZJH(身份证件号),RXNF(入学年份),CSRQ(出生日期)
 * @param {*} jfxm 缴费信息，LIst<Map<String,Object>>对象,包含：sfxmid(收费项目ID),sfxmdm(收费项目代码),sfxmmc(收费项目名称)，je(金额)
 * @param {*} jyje 交易金额
 * @param {*} yjje 应缴金额
 * @param {*} ysje 已缴金额
 * @param {*} hjje 缓缴金额
 */
var handle = function handle(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje) {
  var idcode = xsxx.SFZJH; //身份证号 
  var name = xsxx.XM; //姓名 
  var urlencode = __webpack_require__(490);
  var urlUserName = urlencode(name); //姓名
  var url = csxx.pczflj; //单点登录连接地址
  var year = csxx.year;
  // let url="http://wx.weiweixiao.net/index.php/Wap/ModZhjf/bind?mod_id=45&id=UoorE17g6hGAAAAWPwAVGQ&token=DHruLzx76BGAAAAWPwAVGQ&auto_login=1";//单点登录连接地址
  var purl = url + "?name=" + urlUserName + "&idcode=" + idcode + "&sfqjbm=" + year;
  window.open('' + purl);
};

/**
 * 点击同步按钮触发时的操作
 * @param {*} ddh 订单号
 */
var syscBtnFunc = function syscBtnFunc(ddh) {};

/***/ }),

/***/ 1095:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return syscBtnFunc; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_NHVirtualForm_js__ = __webpack_require__(114);





var md5 = __webpack_require__(119);

/**
 * 网上支付办理接口
 * 请自行在此处判断需要的参数是否符合要求，例如判断身份证件号是否为空，Toast.hide()，可以使用改方法关闭准备跳转支付界面提示
 *
 * @param {*} ddh 订单号
 * @param {*} csxx 配置参数信息，包含：pczflj(PC端支付路径),ydzflj(移动端支付路径)，zfts(支付提示),所有的自定义配置的参数信息
 * @param {*} xsxx 学生信息，包含：XSID(学生ID),XH(学号),XM(姓名),XBM(性别码),SFZJH(身份证件号),RXNF(入学年份),CSRQ(出生日期)
 * @param {*} jfxm 缴费信息，LIst<Map<String,Object>>对象,包含：sfxmid(收费项目ID),sfxmdm(收费项目代码),sfxmmc(收费项目名称)，je(金额)
 * @param {*} jyje 交易金额
 * @param {*} yjje 应缴金额
 * @param {*} ysje 已缴金额
 * @param {*} hjje 缓缴金额
 */
var handle = function handle(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje) {
  var url = csxx.ydzflj; //跳转URL
  var sfzjh = xsxx.SFZJH; //身份证件号
  var partnerid = csxx.partnerid; //合作者ID
  var sign = csxx.sign; //签名
  var projectid = csxx.projectid; //缴费项目ID
  var istimelimit = csxx.istimelimit; //是否限时用户登陆缴费平台时间
  var timelimit = csxx.timelimit; //缴费平台限制时间
  var ydurl = csxx.ydurl; //移动端限时结束返回地址
  var errormsg = csxx.errormsg; //页面提示信息
  var ydreturnurl = csxx.ydreturnurl; //移动端缴费成功页面
  if (!url) {

    __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.warning("支付路径不能为空，请联系管理员！");
    return;
  }
  if (!sfzjh) {

    __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.warning("身份证件号不能为空，请联系管理员！");
    return;
  }
  if (!partnerid || !sign) {
    __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.warning("参数不能为空，请联系管理员！");
    return;
  }
  sign = md5(sfzjh + getNowFormatDate() + sign);
  //虚拟表单提交
  var map = {
    idserial: sfzjh,
    partnerid: partnerid,
    sign: sign,
    projectid: projectid,
    istimelimit: istimelimit,
    timelimit: timelimit,
    url: ydurl,
    errormsg: errormsg,
    returnurl: ydreturnurl
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_NHVirtualForm_js__["a" /* NHVirtualForm */])(url, "_self", map);
};

/**
 * 点击同步按钮触发时的操作
 * @param {*} ddh 订单号
 */
var syscBtnFunc = function syscBtnFunc(ddh) {};

//获取当前日志，格式yyyyMMdd
function getNowFormatDate() {
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var hours = date.getHours(); //获取系统时，
  var minutes = date.getMinutes(); //分
  var seconds = date.getSeconds(); //秒
  var strDate = date.getDate();

  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  if (hours >= 0 && hours <= 9) {
    hours = "0" + hours;
  }
  if (minutes >= 0 && minutes <= 9) {
    minutes = "0" + minutes;
  }
  if (seconds >= 0 && seconds <= 9) {
    seconds = "0" + seconds;
  }
  var currentdate = year + month + strDate;
  return currentdate;
}

/***/ }),

/***/ 1096:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_NHVirtualForm_js__ = __webpack_require__(114);





var md5 = __webpack_require__(119);

/**
 * 网上支付办理接口
 * 请自行在此处判断需要的参数是否符合要求，例如判断身份证件号是否为空，Toast.hide()，可以使用改方法关闭准备跳转支付界面提示
 *
 * @param {*} csxx 配置参数信息，包含：pczflj(PC端支付路径),ydzflj(移动端支付路径)，zfts(支付提示),所有的自定义配置的参数信息
 * @param {*} xsxx 学生信息，包含：XSID(学生ID),XH(学号),XM(姓名),XBM(性别码),SFZJH(身份证件号),RXNF(入学年份),CSRQ(出生日期)
 */
var handle = function handle(csxx, xsxx) {

  var dsfzh = xsxx.DSFZH; //请求第三方接口账户
  var key = csxx.key; //签名
  var tm = getNowFormatDate();
  var url = csxx.dddlljdz; //单点登录连接地址

  if (!url) {
    __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.info("支付路径不能为空，请联系管理员！");
    return;
  }
  if (!dsfzh) {
    __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.info("学号或考生号不能为空，请联系管理员！");
    return;
  }
  if (!key) {
    __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.info("参数不能为空，请联系管理员！");
    return;
  }
  console.log(dsfzh + tm + key);
  var sign = md5(dsfzh + tm + key);

  //虚拟表单提交
  var map = {

    xh: dsfzh,
    tm: tm,
    sign: sign
  };
  console.log(map);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_NHVirtualForm_js__["a" /* NHVirtualForm */])(url, "_blank", map);
};

//获取当前日志，格式yyyyMMdd
function getNowFormatDate() {
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var hours = date.getHours(); //获取系统时，
  var minutes = date.getMinutes(); //分
  var seconds = date.getSeconds(); //秒
  var strDate = date.getDate();

  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  if (hours >= 0 && hours <= 9) {
    hours = "0" + hours;
  }
  if (minutes >= 0 && minutes <= 9) {
    minutes = "0" + minutes;
  }
  if (seconds >= 0 && seconds <= 9) {
    seconds = "0" + seconds;
  }
  var currentdate = year + month + strDate + hours + minutes + seconds;;
  return currentdate;
}

/***/ }),

/***/ 1097:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handle; });
/* unused harmony export syscBtnFunc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_NHVirtualForm_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_NHFetch__ = __webpack_require__(7);




var md5 = __webpack_require__(119);

/**
 * 网上支付办理接口
 * 请自行在此处判断需要的参数是否符合要求，例如判断身份证件号是否为空，Toast.hide()，可以使用改方法关闭准备跳转支付界面提示
 *
 * @param {*} ddh 订单号
 * @param {*} csxx 配置参数信息，包含：pczflj(PC端支付路径),ydzflj(移动端支付路径)，zfts(支付提示),所有的自定义配置的参数信息
 * @param {*} xsxx 学生信息，包含：XSID(学生ID),XH(学号),XM(姓名),XBM(性别码),SFZJH(身份证件号),RXNF(入学年份),CSRQ(出生日期)
 * @param {*} jfxm 缴费信息，LIst<Map<String,Object>>对象,包含：sfxmid(收费项目ID),sfxmdm(收费项目代码),sfxmmc(收费项目名称)，je(金额)
 * @param {*} jyje 交易金额
 * @param {*} yjje 应缴金额
 * @param {*} ysje 已缴金额
 * @param {*} hjje 缓缴金额
 */
var handle = function handle(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje) {
  var userNo = xsxx.XH; //学号
  // let userNo="20020343";//学号
  var userName = xsxx.XM; //姓名
  // let userName="李星";//姓名
  var urlencode = __webpack_require__(490);
  var urlUserName = urlencode(userName); //姓名
  var url = csxx.pczflj; //单点登录连接地址
  // let url="http://wx.weiweixiao.net/index.php/Wap/ModZhjf/bind?mod_id=45&id=UoorE17g6hGAAAAWPwAVGQ&token=DHruLzx76BGAAAAWPwAVGQ&auto_login=1";//单点登录连接地址
  var purl = url + "&user_no=" + userNo + "&user_name=" + urlUserName;
  window.open('' + purl);
};

/**
 * 点击同步按钮触发时的操作
 * @param {*} ddh 订单号
 */
var syscBtnFunc = function syscBtnFunc(ddh) {};

/***/ }),

/***/ 1098:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handle; });
/* unused harmony export syscBtnFunc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_NHVirtualForm_js__ = __webpack_require__(114);





var md5 = __webpack_require__(119);

/**
 * 网上支付办理接口
 * 请自行在此处判断需要的参数是否符合要求，例如判断身份证件号是否为空，Toast.hide()，可以使用改方法关闭准备跳转支付界面提示
 *
 * @param {*} csxx 配置参数信息，包含：pczflj(PC端支付路径),ydzflj(移动端支付路径)，zfts(支付提示),所有的自定义配置的参数信息
 * @param {*} xsxx 学生信息，包含：XSID(学生ID),XH(学号),XM(姓名),XBM(性别码),SFZJH(身份证件号),RXNF(入学年份),CSRQ(出生日期)
 */
var handle = function handle(csxx, xsxx) {

    var xh = xsxx.XH; //学号
    var url = csxx.pcUrl; //单点登录连接地址
    // url = "http://www.baidu.com";
    if (!url) {
        __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.info("单点登录连接地址不能为空，请联系管理员！");
        return;
    }

    window.open(url);
};

/**
 * 点击同步按钮触发时的操作
 * @param {*} ddh 订单号
 */
var syscBtnFunc = function syscBtnFunc(ddh) {};

//获取当前日志，格式yyyyMMdd
function getNowFormatDate() {
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var hours = date.getHours(); //获取系统时，
    var minutes = date.getMinutes(); //分
    var seconds = date.getSeconds(); //秒
    var strDate = date.getDate();

    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
    }
    if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
    }
    if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
    }
    var currentdate = year + month + strDate + hours + minutes + seconds;;
    return currentdate;
}

/***/ }),

/***/ 1099:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handle; });
/* unused harmony export syscBtnFunc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_NHVirtualForm_js__ = __webpack_require__(114);





var md5 = __webpack_require__(119);

/**
 * 网上支付办理接口
 * 请自行在此处判断需要的参数是否符合要求，例如判断身份证件号是否为空，Toast.hide()，可以使用改方法关闭准备跳转支付界面提示
 *
 * @param {*} ddh 订单号
 * @param {*} csxx 配置参数信息，包含：pczflj(PC端支付路径),ydzflj(移动端支付路径)，zfts(支付提示),所有的自定义配置的参数信息
 * @param {*} xsxx 学生信息，包含：XSID(学生ID),XH(学号),XM(姓名),XBM(性别码),SFZJH(身份证件号),RXNF(入学年份),CSRQ(出生日期)
 * @param {*} jfxm 缴费信息，LIst<Map<String,Object>>对象,包含：sfxmid(收费项目ID),sfxmdm(收费项目代码),sfxmmc(收费项目名称)，je(金额)
 * @param {*} jyje 交易金额
 * @param {*} yjje 应缴金额
 * @param {*} ysje 已缴金额
 * @param {*} hjje 缓缴金额
 */
var handle = function handle(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje) {

  var xh = xsxx.XH; //学号

  var key = csxx.key; //签名
  var tm = getNowFormatDate();
  var url = csxx.dddlljdz; //单点登录连接地址

  if (!url) {
    __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.info("支付路径不能为空，请联系管理员！");
    return;
  }
  if (!xh) {
    __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.info("学号不能为空，请联系管理员！");
    return;
  }
  if (!key) {
    __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.info("参数不能为空，请联系管理员！");
    return;
  }
  var sign = md5(xh + tm + key);
  //let sign=md5(xh+getNowFormatDate()+key);

  //虚拟表单提交
  var map = {

    xh: xh,
    tm: tm,
    sign: sign
  };

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_NHVirtualForm_js__["a" /* NHVirtualForm */])(url, "_blank", map);
};

/**
 * 点击同步按钮触发时的操作
 * @param {*} ddh 订单号
 */
var syscBtnFunc = function syscBtnFunc(ddh) {};

//获取当前日志，格式yyyyMMdd
function getNowFormatDate() {
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var hours = date.getHours(); //获取系统时，
  var minutes = date.getMinutes(); //分
  var seconds = date.getSeconds(); //秒
  var strDate = date.getDate();

  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  if (hours >= 0 && hours <= 9) {
    hours = "0" + hours;
  }
  if (minutes >= 0 && minutes <= 9) {
    minutes = "0" + minutes;
  }
  if (seconds >= 0 && seconds <= 9) {
    seconds = "0" + seconds;
  }
  var currentdate = year + month + strDate + hours + minutes + seconds;;
  return currentdate;
}

/***/ }),

/***/ 1100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handle; });
/* unused harmony export syscBtnFunc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_NHVirtualForm_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_NHFetch__ = __webpack_require__(7);




var md5 = __webpack_require__(119);

/**
 * 网上支付办理接口
 * 请自行在此处判断需要的参数是否符合要求，例如判断身份证件号是否为空，Toast.hide()，可以使用改方法关闭准备跳转支付界面提示
 *
 * @param {*} ddh 订单号
 * @param {*} csxx 配置参数信息，包含：pczflj(PC端支付路径),ydzflj(移动端支付路径)，zfts(支付提示),所有的自定义配置的参数信息
 * @param {*} xsxx 学生信息，包含：XSID(学生ID),XH(学号),XM(姓名),XBM(性别码),SFZJH(身份证件号),RXNF(入学年份),CSRQ(出生日期)
 * @param {*} jfxm 缴费信息，LIst<Map<String,Object>>对象,包含：sfxmid(收费项目ID),sfxmdm(收费项目代码),sfxmmc(收费项目名称)，je(金额)
 * @param {*} jyje 交易金额
 * @param {*} yjje 应缴金额
 * @param {*} ysje 已缴金额
 * @param {*} hjje 缓缴金额
 */
var handle = function handle(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje) {
  var url = csxx.axfpayurl;
  var key = csxx.securetkey;
  var json = '{"custno":"' + xsxx.SFZJH + '"}';
  var signature = md5(json + key);
  // window.open(`${url}?json={"custno":"13800138000"}&signature=${signature}`);
  window.open(url + '?json=' + json + '&signature=' + signature);
};

/**
 * 点击同步按钮触发时的操作
 * @param {*} ddh 订单号
 */
var syscBtnFunc = function syscBtnFunc(ddh) {};

/***/ }),

/***/ 1101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handle; });
/* unused harmony export syscBtnFunc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_NHFetch__ = __webpack_require__(7);





/**
 * 网上支付办理接口
 * 请自行在此处判断需要的参数是否符合要求，例如判断身份证件号是否为空，Toast.hide()，可以使用改方法关闭准备跳转支付界面提示
 *
 * @param {*} ddh 订单号
 * @param {*} csxx 配置参数信息，包含：pczflj(PC端支付路径),ydzflj(移动端支付路径)，zfts(支付提示),所有的自定义配置的参数信息
 * @param {*} xsxx 学生信息，包含：XSID(学生ID),XH(学号),XM(姓名),XBM(性别码),SFZJH(身份证件号),RXNF(入学年份),CSRQ(出生日期)
 */
var handle = function handle(ddh, csxx, xsxx) {
  console.info(csxx);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_NHFetch__["a" /* default */])('/cxsfChatPay/queryToken', 'GET', { hjdm: 'GD008_1' }).then(function (res) {
    if (res && res.data) {
      var data = res.data;
      var purl = csxx.ydzflj + "?head=" + encodeURI(data.headStr) + "&data=" + encodeURI(data.dataStr) + "&sign=" + encodeURI(data.signStr);
      window.location.href = purl;
    } else {
      __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.error("获取登录地址失败，请联系管理员！");
    }
  });
};

/**
 * 点击同步按钮触发时的操作
 * @param {*} ddh 订单号
 */
var syscBtnFunc = function syscBtnFunc(ddh) {};

/***/ }),

/***/ 1102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handle; });
/* unused harmony export syscBtnFunc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_NHVirtualForm_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_NHFetch__ = __webpack_require__(7);




var md5 = __webpack_require__(119);

/**
 * 网上支付办理接口
 * 请自行在此处判断需要的参数是否符合要求，例如判断身份证件号是否为空，Toast.hide()，可以使用改方法关闭准备跳转支付界面提示
 *
 * @param {*} ddh 订单号
 * @param {*} csxx 配置参数信息，包含：pczflj(PC端支付路径),ydzflj(移动端支付路径)，zfts(支付提示),所有的自定义配置的参数信息
 * @param {*} xsxx 学生信息，包含：XSID(学生ID),XH(学号),XM(姓名),XBM(性别码),SFZJH(身份证件号),RXNF(入学年份),CSRQ(出生日期)
 * @param {*} jfxm 缴费信息，LIst<Map<String,Object>>对象,包含：sfxmid(收费项目ID),sfxmdm(收费项目代码),sfxmmc(收费项目名称)，je(金额)
 * @param {*} jyje 交易金额
 * @param {*} yjje 应缴金额
 * @param {*} ysje 已缴金额
 * @param {*} hjje 缓缴金额
 */
var handle = function handle(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje) {
  console.info(csxx);
  var pcurl = csxx.pcurl;
  window.open('' + pcurl);
};

/**
 * 点击同步按钮触发时的操作
 * @param {*} ddh 订单号
 */
var syscBtnFunc = function syscBtnFunc(ddh) {};

/***/ }),

/***/ 1103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handle; });
/* unused harmony export syscBtnFunc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_NHVirtualForm_js__ = __webpack_require__(114);



var md5 = __webpack_require__(119);

/**
 * 网上支付办理接口
 * 请自行在此处判断需要的参数是否符合要求，例如判断身份证件号是否为空，Toast.hide()，可以使用改方法关闭准备跳转支付界面提示
 *
 * @param {*} ddh 订单号
 * @param {*} csxx 配置参数信息，包含：pczflj(PC端支付路径),ydzflj(移动端支付路径)，zfts(支付提示),所有的自定义配置的参数信息
 * @param {*} xsxx 学生信息，包含：XSID(学生ID),XH(学号),XM(姓名),XBM(性别码),SFZJH(身份证件号),RXNF(入学年份),CSRQ(出生日期)
 * @param {*} jfxm 缴费信息，LIst<Map<String,Object>>对象,包含：sfxmid(收费项目ID),sfxmdm(收费项目代码),sfxmmc(收费项目名称)，je(金额)
 * @param {*} jyje 交易金额
 * @param {*} yjje 应缴金额
 * @param {*} ysje 已缴金额
 * @param {*} hjje 缓缴金额
 */
var handle = function handle(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje) {

  var xh = xsxx.XH; //学号

  var key = csxx.key; //签名
  var tm = getNowFormatDate();
  var url = csxx.dddlljdz; //单点登录连接地址

  if (!url) {
    Toast.hide();
    Toast.info("支付路径不能为空，请联系管理员！");
    return;
  }
  if (!xh) {
    Toast.hide();
    Toast.info("学号不能为空，请联系管理员！");
    return;
  }
  if (!key) {
    Toast.hide();
    Toast.info("参数不能为空，请联系管理员！");
    return;
  }
  var sign = md5(xh + getNowFormatDate() + key);
  //虚拟表单提交
  var map = {

    xh: xh,
    tm: tm,
    sign: sign
  };

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_NHVirtualForm_js__["a" /* NHVirtualForm */])(url, "_blank", map);
};

/**
 * 点击同步按钮触发时的操作
 * @param {*} ddh 订单号
 */
var syscBtnFunc = function syscBtnFunc(ddh) {};

//获取当前日志，格式yyyyMMdd
function getNowFormatDate() {
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var hours = date.getHours(); //获取系统时，
  var minutes = date.getMinutes(); //分
  var seconds = date.getSeconds(); //秒
  var strDate = date.getDate();

  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  if (hours >= 0 && hours <= 9) {
    hours = "0" + hours;
  }
  if (minutes >= 0 && minutes <= 9) {
    minutes = "0" + minutes;
  }
  if (seconds >= 0 && seconds <= 9) {
    seconds = "0" + seconds;
  }
  var currentdate = year + month + strDate + hours + minutes + seconds;;
  return currentdate;
}

/***/ }),

/***/ 1104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Pay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__index_css__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__qrCode__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pay_paydisc_index__ = __webpack_require__(544);














var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }



















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_23_history_createHashHistory___default()();

var Pay = function (_React$Component) {
    _inherits(Pay, _React$Component);

    function Pay(props) {
        _classCallCheck(this, Pay);

        var _this = _possibleConstructorReturn(this, (Pay.__proto__ || __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default()(Pay)).call(this, props));

        _this.queryStudentInfo = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (xsid) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/jfxt/queryStudentInfo', 'GET').then(function (res) {
                    if (res && res.data) {
                        _this.setState({
                            xsxxData: res.data
                        });
                    } else {
                        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("获取学生信息失败");
                    }
                });
            }
        };

        _this.queryPayPlan = function () {
            var mkbz = _this.state.mkbz;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/jfxt/queryPayPlan', 'GET', { hjdm: mkbz }).then(function (res) {
                if (res && res.data) {
                    _this.setState({
                        jffaData: res.data['jffaVO'],
                        jccsData: res.data['jfdjJccsVO']
                    }, function () {
                        _this.queryQztjAndYlhj(function (operable) {
                            if (operable) {}
                        });
                        _this.queryPayParams();
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("该环节未设置缴费方案");
                }
            });
        };

        _this.queryQztjAndYlhj = function (callback) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    } else if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    } else if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    } else {
                        _this.checkDataSource();
                    }if (callback) {
                        callback(_this.state.operable);
                    }
                }
            });
        };

        _this.checkDataSource = function () {
            var jfqkly = _this.state.jccsData.jfqkly;

            if (jfqkly == '0') {
                //0:中间库，1：第三方接口
                _this.queryPayListByDataBase();
            } else if (jfqkly == '1') {
                _this.queryPayInfoList();
            }
        };

        _this.queryPayListByDataBase = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/jfxt/queryPayListByDataBase', 'GET') //所有的收费数据
            .then(function (resData) {
                if (resData && resData.data) {
                    // 获取缴费数据，根据已有的规则判断是否符合自动办理
                    // 财务欠费公式：(应收billAmount - 减免derateAmount - 实收（累计）payedAmount + 退款（累计）refundAmount) > 0；
                    // 业务欠费公式：(应收billAmount - 减免derateAmount - 实收（累计）payedAmount - 缓交postponeAmount + 退款（累计）refundAmount) > 0。
                    // 学生每一项缴费项目，只要是达到财务欠费结果或者业务欠费结果=0，就说明学生没有欠费，自动办理缴费环节
                    var jfxxList = resData.data;
                    if (jfxxList.length > 0) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/openapi/yxxt/getBlztByXsid', 'GET').then(function (resData) {
                            if (resData && resData.data) {
                                if (resData.data.BLZT == '1') {
                                    _this.checkIsZzbdHjLinked();
                                }
                            }
                        });
                    }
                    _this.setState({ data: resData.data }, function () {
                        var list = _this.state.data.filter(function (item) {
                            return item.qfje > 0 ? true : false;
                        });
                        if (resData.data.length === 0) {
                            _this.setState({
                                flage: false
                            });
                        } else {
                            if (list.length <= 0) {
                                _this.setState({ flage: false });
                            }
                        }
                    });
                }
            });
        };

        _this.queryPayInfoList = function () {
            var mkbz = _this.state.mkbz;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/jfxt/queryPayInfoList', 'GET', { hjdm: mkbz }).then(function (res) {
                if (res && res.data['sfxxList']) {
                    if (res.data['sfbl']) {
                        _this.checkIsZzbdHjLinked();
                    }
                    _this.setState({ data: res.data['sfxxList'] }, function () {
                        var list = _this.state.data.filter(function (item) {
                            return item.qfje > 0 ? true : false;
                        });
                        if (res.data['sfxxList'].length === 0) {
                            _this.setState({
                                flage: false
                            });
                        } else {
                            if (list.length <= 0) {
                                _this.setState({ flage: false });
                            }
                        }
                    });
                } else {
                    _this.setState({ flage: false });
                    __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.info("查询不到学生的缴费信息，请联系管理员处理");
                }
            });
        };

        _this.checkIsZzbdHjLinked = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this.getQueryString('pkid');

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])("/zzbdCommon/checkIsZzbdHjLinked", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.code === 200) {
                    if (!res.data) {
                        _this.commonSaveLinkTransactionStatus();
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("查询环节办理状态失败，请稍后再试");
                }
            });
        };

        _this.commonSaveLinkTransactionStatus = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])().userId : "";
            var zzbdhjid = _this.getQueryString("pkid");
            var params = { xsid: xsid, zzbdhjid: zzbdhjid };
            // this.toPayView();
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])("/zzbdCommon/commonSaveLinkTransactionStatus", "POST", params).then(function (res) {
                if (res) {
                    if (res.data === 1) {
                        _this.reloadMenu();
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("自动办理缴费环节失败，请稍后重试！");
                }
            });
        };

        _this.showModal = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/jfxt/clearRedisData', 'GET').then(function (res) {
                if (res && res.code == 200) {
                    _this.setState({
                        visible: true
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("清除缓存失败");
                }
            });
        };

        _this.queryPayParams = function () {
            var djfsid = _this.state.jffaData.djfsid;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/jfxt/queryPayParams', 'GET', { djfsid: djfsid }).then(function (res) {
                if (res && res.data) {
                    _this.setState({
                        djcsData: res.data
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("获取缴费对接参数失败");
                }
            });
        };

        _this.onHandleCancel = function () {
            _this.setState({
                visible: false
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_25__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.onSave = function () {
            _this.setState({ loading: true });
            setTimeout(function () {
                _this.setState({
                    loading: false
                });
            }, 1000);
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.toPayView = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/jfxt/clearRedisData', 'GET').then(function (res) {
                if (res && res.code == 200) {
                    var _this$state = _this.state,
                        djcsData = _this$state.djcsData,
                        xsxxData = _this$state.xsxxData,
                        jccsData = _this$state.jccsData;
                    var djfsid = _this.state.jffaData.djfsid;

                    var csxx = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()(jccsData, djcsData);
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__pay_paydisc_index__["a" /* handle */])(djfsid, "", csxx, xsxxData, "", "", "", "", "");
                } else {
                    __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("清除缓存失败");
                }
            });
        };

        _this.toShowModal = function () {
            var _this$state2 = _this.state,
                jccsData = _this$state2.jccsData,
                djcsData = _this$state2.djcsData;

            switch (jccsData.zffs) {
                case '1':
                    return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__qrCode__["a" /* default */], { jccsData: jccsData });
                    break;
                case '2':
                    return null;
                    break;
                default:
                    return null;
                    break;
            }
        };

        _this.state = {
            mkbz: 'GD008_1',
            hjmc: '',
            data: [],
            loading: false,
            pageData: { //分页设置的是三个参数
                total: 0,
                pageSize: 10, //当前页默认多少条数据
                page: 1
            },
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            hjje: 0, //缓交金额
            jfxxHz: {}, //缴费信息汇总
            visible: false,
            flage: true, //是否存在需要缴费的项目
            jffaData: {}, //缴费方案信息
            jccsData: {}, //基础参数信息
            djcsData: {}, //缴费对接参数信息
            xsxxData: {} //学生信息
        };
        return _this;
    }

    _createClass(Pay, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.queryStudentInfo();
            this.queryPayPlan();
        }

        //查询学生信息


        //根据环节代码获取对应的缴费方案数据


        //查询前置条件和依赖环节


        //校验数据来源


        //中间库


        //第三方接口


        //检查该环节是否已经办理


        //自动办理缴费环节


        //查询缴费对接参数


        //重新加载菜单


        //跳转到收费平台


        //根据缴费方案加载对应的二维码页面

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                data = _state.data,
                jccsData = _state.jccsData;

            var columns = [{
                title: '序号',
                dataIndex: 'XH',
                render: function render(text, record, index) {
                    return index + 1;
                }
            }, {
                title: '收费项目',
                dataIndex: 'sfxmmc'
            }, {
                title: '应收金额（元）',
                dataIndex: 'ysje'
            }, {
                title: '实收金额（元）',
                dataIndex: 'ssje',
                render: function render(text, record) {
                    return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'span',
                        { className: 'text-primary' },
                        text
                    );
                }
            }, {
                title: '减免金额（元）',
                dataIndex: 'jmje',
                render: function render(text, record) {
                    return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'span',
                        { className: 'text-primary' },
                        text
                    );
                }
            }, {
                title: '缓交金额（元）',
                dataIndex: 'hjje',
                render: function render(text, record) {
                    return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'span',
                        { className: 'text-primary' },
                        text
                    );
                }
            }, {
                title: '欠费金额（元）',
                dataIndex: 'qfje',
                render: function render(text, record) {
                    if (text > 0) {
                        return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            { className: 'text-info-red' },
                            text
                        );
                    } else {
                        return text;
                    }
                }
            }];

            return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                'div',
                { className: 'app__css__app-pages-SelfHelp-payFxxy-__index__page_pay' },
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230'
                        /*active={7}*/
                        , mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjmc, extra: false }),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                { className: 'p-sw mt-20' },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_table___default.a, {
                                    bordered: true,
                                    size: 'middle',
                                    pagination: false,
                                    columns: columns,
                                    dataSource: data
                                }),
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'div',
                                    { className: 'text-center mt-50' },
                                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        this.state.flage == true && jccsData.zfd != '0' ? jccsData.zffs == '0' ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default.a,
                                            { onClick: function onClick() {
                                                    return _this2.toPayView();
                                                }, type: 'primary', htmlType: 'submit' },
                                            '\u7F51\u4E0A\u652F\u4ED8'
                                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default.a,
                                            { onClick: function onClick() {
                                                    return _this2.showModal();
                                                }, type: 'primary', htmlType: 'submit' },
                                            '\u6253\u5F00\u7F34\u8D39\u4E8C\u7EF4\u7801'
                                        ) : null,
                                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                )
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__common__["a" /* default */], { hjmc: "网上缴费", key: 'GD008_1', mkbz: 'GD008_1', nonOperationalData: this.state.nonOperationalData }),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal___default.a,
                    {
                        title: '\u4E8C\u7EF4\u7801\u4FE1\u606F',
                        visible: this.state.visible,
                        onCancel: this.onHandleCancel,
                        footer: [__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default.a,
                            { onClick: this.onHandleCancel },
                            '\u5173\u95ED'
                        )] },
                    this.toShowModal()
                )
            );
        }
    }]);

    return Pay;
}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);



/***/ }),

/***/ 1105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QrCodeIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_result_style__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_result_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_result_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_result__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_result___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_result__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__ = __webpack_require__(7);







var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }





var QrCodeIndex = function (_React$Component) {
    _inherits(QrCodeIndex, _React$Component);

    function QrCodeIndex(props) {
        _classCallCheck(this, QrCodeIndex);

        var _this = _possibleConstructorReturn(this, (QrCodeIndex.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(QrCodeIndex)).call(this, props));

        _this.getDetailed = function () {
            var jccsData = _this.props.jccsData;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])('front/zhxg-unauth/dynamic/' + jccsData.qrcode + '/getDetailed', 'GET').then(function (res) {
                if (res && res.data) {
                    _this.setState({
                        qrcode: res.data[0].uuid
                    });
                } else {
                    message.error("获取二维码失败");
                }
            });
        };

        _this.state = {
            qrcode: ''
        };
        return _this;
    }

    _createClass(QrCodeIndex, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.getDetailed();
        }
    }, {
        key: 'render',
        value: function render() {
            var qrcode = this.state.qrcode;

            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                'div',
                { style: { display: 'flex', justifyContent: 'center' }, className: 'jsx-3739943726'
                },
                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                    'div',
                    {
                        className: 'jsx-3739943726' + ' ' + 'result-example'
                    },
                    qrcode ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_result___default.a, {
                        icon: __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('img', { src: "/anonymity/docrepo/download/file?attachmentId=" + qrcode, style: { fill: '#1F90E6' }, className: 'jsx-3739943726' + ' ' + 'spe'
                        }),
                        title: "请扫描二维码，登录收费系统进行缴费"
                    }) : null
                ),
                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_styled_jsx_style___default.a, {
                    styleId: '3739943726',
                    css: ['.result-example .spe{width:160px;height:160px;}', '.am-result .am-result-pic{width:160px;height:160px;}']
                })
            );
        }
    }]);

    return QrCodeIndex;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);



/***/ }),

/***/ 1106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Report; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_date_picker_style__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_index__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_SelfHelp_common_hint__ = __webpack_require__(35);


















var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }














// import 'moment/src/locale/zh-cn';





var history = __WEBPACK_IMPORTED_MODULE_29_history_createHashHistory___default()();
var format = 'HH:mm';

var basicUrl = "/zzbd";
var commonUrl = '/zzbdCommon';

var FormItem = __WEBPACK_IMPORTED_MODULE_16_antd_lib_form___default.a.Item;
var Option = __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default.a.Option;

var formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 }
};

var Report = (_dec = __WEBPACK_IMPORTED_MODULE_16_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(Report, _React$Component);

    function Report(props) {
        _classCallCheck(this, Report);

        var _this = _possibleConstructorReturn(this, (Report.__proto__ || __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default()(Report)).call(this, props));

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getLxjtgjmc = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])('/zzbdCommon/getCssz', "GET", { csbz: 'YXXT_ZZBD_BDQK_ZDBC_LXJTGJ' }).then(function (res) {
                if (res) {
                    if (res && res.code === 200) {
                        _this.setState({ lxjtgjbc: res.data });
                    }
                }
            });
        };

        _this.getLxrqmc = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])('/zzbdCommon/getCssz', "GET", { csbz: 'YXXT_ZZBD_BDQK_ZDBC_LXRQ' }).then(function (res) {
                if (res) {
                    if (res && res.code === 200) {
                        _this.setState({ lxrqbc: res.data });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_31__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.props.form.validateFieldsAndScroll(function (err, values) {
                if (err) {
                    return;
                }
                if (values['sfasbd'] == '0') {
                    if (values['basbdyy'] == null || typeof values['basbdyy'] == "undefined" || values['basbdyy'].trim().length === 0) {
                        __WEBPACK_IMPORTED_MODULE_24_antd_lib_index__["message"].error('不按时到达请填写原因。');
                        return;
                    }
                }

                var sUrl = '/saveBdqkData';
                if (_this.state.update) {
                    sUrl = '/updateBdqkData';
                }
                //修改 可编辑状态，并可以update数据
                if (!_this.state.editable) {
                    _this.setState({ update: true, editable: true });
                    return;
                }
                var dxsj = values.dxsj;

                var dxsjVal = __WEBPACK_IMPORTED_MODULE_25_moment___default()(dxsj).format("YYYY-MM-DD HH:mm");
                values.dxsj = dxsjVal;
                var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId;
                var zzbdhjid = _this.getUrlParams("pkid");
                var params = { xsid: xsid, zzbdhjid: zzbdhjid, formData: values };

                //请求保存或修改数据
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])(basicUrl + sUrl, 'POST', params).then(function (res) {
                    if (res) {
                        if (res.data == '1') {
                            __WEBPACK_IMPORTED_MODULE_24_antd_lib_index__["message"].success('信息保存成功！');
                            _this.reloadMenu();
                            _this.getQkpo();
                        } else {
                            __WEBPACK_IMPORTED_MODULE_24_antd_lib_index__["message"].error('信息保存失败，请重试！');
                        }
                    }
                });
            });
        };

        _this.getUrlParams = function (param) {
            return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.getDmkMc = function (dmbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])(basicUrl + "/getDmkMc", "GET", { dmbz: dmbz }).then(function (res) {
                if (res) {
                    if (res.data) {
                        if (dmbz === "YXWZ_LXJTGJ") {
                            _this.setState({ lxjtgjmcList: res.data });
                        }
                    }
                }
            });
        };

        _this.getDdz = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])(basicUrl + "/getDdz", "GET").then(function (res) {
                if (res) {
                    if (res.data) {
                        _this.setState({ ddz: res.data });
                    }
                }
            });
        };

        _this.DdzSeleOption = function (value) {

            var dqddz = '';
            var coptions = '';
            if (_this.state.ddz.length > 0) {
                coptions = _this.state.ddz.map(function (item, key) {
                    if (value === item.ZTLX) {
                        dqddz = item.ZTMC;
                        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                            Option,
                            { key: item.ZTMC },
                            item.ZTMC
                        );
                    } else {
                        return null;
                    }
                });
            }
            _this.props.form.setFieldsValue({ ddz: dqddz });
            _this.setState({ options: coptions, dqddz: dqddz });
        };

        _this.onChange = function (value) {
            _this.DdzSeleOption(value);
        };

        _this.onSfasbdChange = function (value) {
            _this.setState({
                isHide: value != '1',
                isShow: true
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.numberChange = function (value) {
            if (value > 10 || value < 0) {
                __WEBPACK_IMPORTED_MODULE_24_antd_lib_index__["message"].warning('陪同人数请填写0-10之内的整数！');
            }
        };

        _this.disabledStartDate = function (startValue) {
            return startValue && startValue < __WEBPACK_IMPORTED_MODULE_25_moment___default()().subtract(1, "days");
        };

        _this.state = {
            mkbz: 'GD004',
            hjmc: '',
            editable: true,
            update: false,
            initPOvalue: {
                nd: '',
                xsid: '',
                sfasbd: '',
                basbdyy: '',
                jtgj: '',
                ddz: '',
                dxsj: '',
                bc: '',
                ptrs: 0
            },
            value: null,
            lxjtgjmcList: {},
            lxjtgjmc: '',
            ddz: {},
            options: [],
            dqddz: '',
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            isHide: true,
            lxjtgjbc: '来校交通工具',
            lxrqbc: '来校日期',
            isShow: false //来校日期是否显示
        };
        return _this;
    }

    _createClass(Report, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getDmkMc("YXWZ_LXJTGJ");
        }

        //渲染前获取信息

    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.queryQztjAndYlhj();
            this.getLxjtgjmc();
            this.getLxrqmc();
            this.getDdz();
            this.getQkpo();
        }

        //查询前置条件和依赖环节

    }, {
        key: 'getQkpo',
        value: function getQkpo() {
            var _this2 = this;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId;
            var lxjtgjmc = '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])(basicUrl + "/getQkpoByXsidAndNd", "GET", { xsid: xsid }).then(function (res) {
                if (res) {
                    if (res.data) {
                        lxjtgjmc = res.data.jtgjmc;
                        _this2.setState({ initPOvalue: res.data, editable: false, lxjtgjmc: lxjtgjmc });
                        var dqddz = _this2.state.initPOvalue.ddz;
                        _this2.onChange(_this2.state.initPOvalue.jtgj);
                        _this2.setState({
                            dqddz: dqddz,
                            isHide: res.data.sfasbd != 1
                        });
                    }
                }
            });
        }

        //获取url中传递的参数


        //获取下拉列表value对应的名称

        //获取到达站下拉列表的名称


        //到达站级联


        //下拉框发生变化检测


        //动态显示报到情况填写


        //重新加载菜单


        //陪同人数不符合时提示


        //disabledStartDate设置到校日期的时间选择器的可选日期区域

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var getFieldDecorator = this.props.form.getFieldDecorator;
            var _state = this.state,
                editable = _state.editable,
                initPOvalue = _state.initPOvalue,
                lxjtgjmc = _state.lxjtgjmc,
                options = _state.options,
                dqddz = _state.dqddz,
                isHide = _state.isHide,
                lxjtgjbc = _state.lxjtgjbc,
                lxrqbc = _state.lxrqbc,
                isShow = _state.isShow;

            return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_19__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230'
                        /* active={3}*/
                        , mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_19__components__["a" /* Flex */].Item,
                        { className: 'page_con_r ' },
                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjmc, extra: false }),
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_16_antd_lib_form___default.a,
                                { onSubmit: this.handleSubmit },
                                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                    'div',
                                    { className: 'p-sw' },
                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_19__components__["a" /* Flex */],
                                        { align: 'start', wrap: 'wrap' },
                                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u662F\u5426\u6309\u65F6\u62A5\u5230'
                                                }),
                                                getFieldDecorator('sfasbd', {
                                                    initialValue: initPOvalue.sfasbd, placeholder: '请选择',
                                                    rules: [{
                                                        required: true,
                                                        message: '请选择是否按时报到'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default.a,
                                                    { placeholder: '\u8BF7\u9009\u62E9', onChange: this.onSfasbdChange },
                                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                        Option,
                                                        { value: '1' },
                                                        '\u662F'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                        Option,
                                                        { value: '0' },
                                                        '\u5426'
                                                    )
                                                ) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.sfasbd == 1 ? '是' : '否'
                                                ))
                                            )
                                        ),
                                        isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u4E0D\u6309\u65F6\u62A5\u5230\u539F\u56E0'
                                                }),
                                                getFieldDecorator('basbdyy', { initialValue: initPOvalue.basbdyy,
                                                    rules: [{
                                                        required: true,
                                                        message: '请填写原因'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, { placeholder: '\u8BF7\u586B\u5199\u539F\u56E0' }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.basbdyy
                                                ))
                                            )
                                        ),
                                        !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: lxjtgjbc
                                                }),
                                                getFieldDecorator('jtgj', {
                                                    initialValue: initPOvalue.jtgj,
                                                    rules: [{
                                                        required: true,
                                                        message: '请选择交通工具'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_common_NHSelect__["a" /* default */], { sign: "zhxg_yxwz_lxjtgj", onChange: function onChange(v) {
                                                        _this3.onChange(v);
                                                    } }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    lxjtgjmc
                                                ))
                                            )
                                        ),
                                        !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u5230\u8FBE\u7AD9'
                                                }),
                                                getFieldDecorator('ddz', {
                                                    initialValue: dqddz,
                                                    rules: [{
                                                        message: '请选择到达站'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default.a,
                                                    null,
                                                    options
                                                ) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    dqddz
                                                ))
                                            )
                                        ),
                                        (isShow || initPOvalue.sfasbd == '0' || initPOvalue.sfasbd == '1') && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: isHide ? '预计来校日期' : lxrqbc
                                                }),
                                                getFieldDecorator('dxsj', {
                                                    initialValue: initPOvalue.dxsj == '' ? null : __WEBPACK_IMPORTED_MODULE_25_moment___default()(initPOvalue.dxsj, 'YYYY-MM-DD HH:mm'),
                                                    rules: [{
                                                        required: !isHide,
                                                        message: '请选择日期'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker___default.a, {
                                                    style: { 'width': '100%' },
                                                    showTime: true,
                                                    format: 'YYYY-MM-DD HH:mm',
                                                    disabledDate: this.disabledStartDate
                                                    // defaultValue={initPOvalue.dxsj==''?null:moment(initPOvalue.dxsj, 'YYYY-MM-DD HH:mm')} //如果时间发生错误，请删除此句defaultValue

                                                }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.dxsj
                                                ))
                                            )
                                        ),
                                        !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u73ED\u6B21'
                                                }),
                                                getFieldDecorator('bc', { initialValue: initPOvalue.bc })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, null) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.bc
                                                ))
                                            )
                                        ),
                                        !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u966A\u540C\u4EBA\u6570'
                                                }),
                                                getFieldDecorator('ptrs', { initialValue: initPOvalue.ptrs })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number___default.a, {
                                                    precision: 0,
                                                    min: 0,
                                                    max: 10,
                                                    onChange: this.numberChange
                                                }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.ptrs
                                                )),
                                                '\xA0\xA0',
                                                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    '  (\u4EBA) '
                                                )
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,
                                            {
                                                type: 'primary',
                                                htmlType: 'submit'
                                            },
                                            editable ? '保存' : '修改'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                )
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__common__["a" /* default */], { hjmc: "报到情况填写", key: 'GD004', mkbz: 'GD004', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return Report;
}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component)) || _class);


/***/ }),

/***/ 1107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Report; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_date_picker_style__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_index__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_SelfHelp_common_hint__ = __webpack_require__(35);


















var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _defineProperty(obj, key, value) { if (key in obj) { __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }














// import 'moment/src/locale/zh-cn';




var history = __WEBPACK_IMPORTED_MODULE_29_history_createHashHistory___default()();
var format = 'HH:mm';

var basicUrl = '/zzbd';
var commonUrl = '/zzbdCommon';

var FormItem = __WEBPACK_IMPORTED_MODULE_16_antd_lib_form___default.a.Item;
var Option = __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default.a.Option;

var formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 }
};

var Report = (_dec = __WEBPACK_IMPORTED_MODULE_16_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
  _inherits(Report, _React$Component);

  function Report(props) {
    _classCallCheck(this, Report);

    var _this = _possibleConstructorReturn(this, (Report.__proto__ || __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default()(Report)).call(this, props));

    _this.queryQztjAndYlhj = function () {
      var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId : '';
      if (!xsid) {
        _this.setState({
          nonOperationalData: { nologin: true },
          operable: false
        });
        return;
      }
      var zzbdhjid = _this.getQueryString('pkid');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])('/zzbd/queryQztjAndYlhj', 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
        if (res && res.data) {
          var kfsj = res.data['kfsj'];
          var ylhj = res.data['ylhj'];
          var qzhj = res.data['qzhj'];
          _this.setState({ nonOperationalData: res.data });
          if (kfsj['YXSJ'] != '1') {
            _this.setState({ operable: false });
          }

          if (ylhj && ylhj.length > 0) {
            _this.setState({ operable: false });
          }

          if (qzhj && qzhj.length > 0) {
            _this.setState({ operable: false });
          }
        }
      });
    };

    _this.getQueryString = function (name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
    };

    _this.setMenuList = function (menuList) {
      var nextCount = 0;
      var bz = _this.state.mkbz;
      menuList.map(function (elem, index) {
        if (elem.HJDM == bz) {
          var hjmc = elem.HJMC;
          _this.setState({ hjmc: hjmc });
          nextCount = index + 1;
          return;
        }
      });
      var menu = menuList[nextCount];
      if (menu) {
        var hjdm = menu.HJDM;
        if (hjdm.indexOf('GD') == 0) {
          var gdUrl = __WEBPACK_IMPORTED_MODULE_31__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
          _this.setState({
            nextUrl: gdUrl,
            search: 'pkid=' + menu.PKID
          });
        } else if (hjdm.indexOf('ZDY') == 0) {
          var zdyUrl = '/customLink';
          _this.setState({
            nextUrl: zdyUrl,
            search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
          });
        }
      } else {
        _this.setState({
          nextUrl: '',
          search: ''
        });
      }
    };

    _this.handleSubmit = function (e) {
      e.preventDefault();
      _this.props.form.validateFieldsAndScroll(function (err, values) {
        if (err) {
          return;
        }
        var xgymjzqk = values.xgymjzqk;
        var jzqkList = _this.state.jzqkList;
        for (var i = 0; i < jzqkList.length; i++) {
          if (xgymjzqk == jzqkList[i].MC) {
            values.xgymjzqk = jzqkList[i].DM;
          }
        }
        var wbdyy = values.wbdyy;
        var wbdyyList = _this.state.wbdyyList;
        for (var _i = 0; _i < wbdyyList.length; _i++) {
          if (wbdyy == wbdyyList[_i].MC) {
            values.wbdyy = wbdyyList[_i].DM;
          }
        }

        var sUrl = '/saveBdqkData';
        if (_this.state.update) {
          sUrl = '/updateBdqkData';
        }
        //修改 可编辑状态，并可以update数据
        if (!_this.state.editable) {
          _this.setState({ update: true, editable: true });
          return;
        }
        var dxsj = values.dxsj;

        var dxsjVal = __WEBPACK_IMPORTED_MODULE_25_moment___default()(dxsj).format('YYYY-MM-DD HH:mm');
        values.dxsj = dxsjVal;
        var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId;
        var zzbdhjid = _this.getUrlParams('pkid');
        var params = { xsid: xsid, zzbdhjid: zzbdhjid, formData: values };

        console.log(params);
        // 请求保存或修改数据
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])(basicUrl + sUrl, 'POST', params).then(function (res) {
          if (res) {
            if (res.data == '1') {
              __WEBPACK_IMPORTED_MODULE_24_antd_lib_index__["message"].success('信息保存成功！');
              _this.reloadMenu();
              _this.getQkpo();
            } else {
              __WEBPACK_IMPORTED_MODULE_24_antd_lib_index__["message"].error('信息保存失败，请重试！');
            }
          }
        });
      });
    };

    _this.getUrlParams = function (param) {
      return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
    };

    _this.getDmkMc = function (dmbz) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])(basicUrl + '/getDmkMc', 'GET', _defineProperty({ dmbz: dmbz }, 'dmbz', dmbz)).then(function (res) {
        if (res) {
          if (res.data) {
            if (dmbz === 'YXWZ_LXJTGJ') {
              _this.setState({ lxjtgjmcList: res.data });
            }
            if (dmbz === 'YXXT_BDQK_WBDYY') {
              _this.setState({ wbdyyList: res.data });
            }
            if (dmbz === 'YXXT_BDQK_XGYMJZQK') {
              _this.setState({ jzqkList: res.data });
            }
          }
        }
      });
    };

    _this.getDdz = function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])(basicUrl + '/getDdz', 'GET').then(function (res) {
        if (res) {
          if (res.data) {
            _this.setState({ ddz: res.data });
          }
        }
      });
    };

    _this.DdzSeleOption = function (value) {
      var dqddz = '';
      var coptions = '';
      if (_this.state.ddz.length > 0) {
        coptions = _this.state.ddz.map(function (item, key) {
          if (value === item.ZTLX) {
            dqddz = item.ZTMC;
            return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
              Option,
              { key: item.ZTMC },
              item.ZTMC
            );
          } else {
            return null;
          }
        });
      }
      _this.props.form.setFieldsValue({ ddz: dqddz });
      _this.setState({ options: coptions, dqddz: dqddz });
    };

    _this.onChange = function (value) {
      _this.DdzSeleOption(value);
    };

    _this.showDetail = function (value) {
      if (value === 'ycbd') {
        _this.setState({
          isHideDetail: true
        });
      } else {
        _this.setState({
          isHideDetail: false
        });
      }
    };

    _this.onSfasbdChange = function (value) {
      _this.setState({
        isHide: value == '1' ? false : true,
        isHideDetail: value == '1' ? false : true
      });
    };

    _this.showReason = function (v) {
      if (v == 0) {
        _this.setState({
          isHideReason: true
        });
      } else {
        _this.setState({ isHideReason: false });
      }
    };

    _this.reloadMenu = function () {
      _this.refs.siderMenu.reloadMenuList();
    };

    _this.numberChange = function (value) {
      if (value > 10 || value < 0) {
        __WEBPACK_IMPORTED_MODULE_24_antd_lib_index__["message"].warning('陪同人数请填写0-10之内的整数！');
      }
    };

    _this.disabledStartDate = function (startValue) {
      return startValue && startValue < __WEBPACK_IMPORTED_MODULE_25_moment___default()().subtract(1, 'days');
    };

    _this.state = {
      mkbz: 'GD004_3',
      hjmc: '',
      editable: true,
      update: false,
      initPOvalue: {
        nd: '',
        xsid: '',
        sfasbd: '',
        basbdyy: '',
        jtgj: '',
        ddz: '',
        dxsj: '',
        bc: '',
        ptrs: 0
      },
      value: null,
      lxjtgjmcList: {},
      lxjtgjmc: '',
      ddz: {},
      options: [],
      dqddz: '',
      nextUrl: '', //左侧菜单加载完后传进来
      search: '',
      operable: true, //是否显示环节
      nonOperationalData: {}, //不可操作的数据
      isHide: true,
      isHideDetail: false,
      wbdyy: '', //未报到原因
      wbdyyList: {},
      jzqkList: {},
      isHideReason: false
    };
    return _this;
  }

  _createClass(Report, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.getDmkMc('YXWZ_LXJTGJ');
      this.getDmkMc('YXXT_BDQK_XGYMJZQK');
      this.getDmkMc('YXXT_BDQK_WBDYY');
    }
    //渲染前获取信息

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.queryQztjAndYlhj();
      this.getDdz();
      this.getQkpo();
    }

    //查询前置条件和依赖环节

  }, {
    key: 'getQkpo',
    value: function getQkpo() {
      var _this2 = this;

      var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId;
      var lxjtgjmc = '';
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])(basicUrl + '/getQkpoByXsidAndNd', 'GET', _defineProperty({ xsid: xsid }, 'xsid', xsid)).then(function (res) {
        if (res) {
          if (res.data) {
            console.log(res.data);
            lxjtgjmc = res.data.jtgjmc;
            _this2.setState({ initPOvalue: res.data, editable: false, lxjtgjmc: lxjtgjmc });
            var dqddz = _this2.state.initPOvalue.ddz;
            _this2.onChange(_this2.state.initPOvalue.jtgj);
            _this2.setState({ dqddz: dqddz, isHide: res.data.sfasbd == 1 ? false : true, isHideReason: res.data.sffhrxbdtj == 1 ? false : true });
            if (res.data.sfasbd == 0 && '延迟报到' == res.data.wbdyy) {
              _this2.showDetail('ycbd');
            }
          }
        }
      });
    }

    //获取url中传递的参数


    //获取下拉列表value对应的名称

    //获取到达站下拉列表的名称


    //到达站级联


    //下拉框发生变化检测


    //动态显示报到情况填写


    //重新加载菜单


    //陪同人数不符合时提示


    //disabledStartDate设置到校日期的时间选择器的可选日期区域

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var getFieldDecorator = this.props.form.getFieldDecorator;
      var _state = this.state,
          editable = _state.editable,
          initPOvalue = _state.initPOvalue,
          lxjtgjmc = _state.lxjtgjmc,
          options = _state.options,
          dqddz = _state.dqddz,
          isHide = _state.isHide,
          isHideDetail = _state.isHideDetail,
          wbdyyList = _state.wbdyyList,
          jzqkList = _state.jzqkList,
          isHideReason = _state.isHideReason;

      var wbdyy = '';
      var jzqk = '';
      for (var i = 0; i < wbdyyList.length; i++) {
        if (wbdyyList[i].DM == initPOvalue.wbdyy) {
          wbdyy = wbdyyList[i].MC;
        }
      }
      for (var _i2 = 0; _i2 < jzqkList.length; _i2++) {
        if (jzqkList[_i2].DM == initPOvalue.xgymjzqk) {
          jzqk = jzqkList[_i2].MC;
        }
      }

      return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
        'div',
        null,
        this.state.operable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_19__components__["a" /* Flex */],
          { className: 'w1180 mt-20', align: 'start' },
          __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pages_Assembly_siderMenu__["a" /* default */], {
            ref: 'siderMenu',
            setMenuList: this.setMenuList,
            title: '\u81EA\u52A9\u62A5\u5230'
            /* active={3}*/
            , mkbz: this.state.mkbz,
            menuType: '\u81EA\u52A9\u62A5\u5230'
          }),
          __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_19__components__["a" /* Flex */].Item,
            { className: 'page_con_r ' },
            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pages_Assembly_Breadcrumb__["a" /* default */], { noLine: true, list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }] }),
            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
              'div',
              { className: 'box' },
              __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__pages_SelfHelp_common_hint__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjmc, extra: false }),
              __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16_antd_lib_form___default.a,
                { onSubmit: this.handleSubmit },
                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                  'div',
                  { className: 'p-sw' },
                  __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_19__components__["a" /* Flex */],
                    { align: 'start', wrap: 'wrap' },
                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                      'div',
                      { style: { display: 'inline-block', verticalAlign: 'top', width: '40%' } },
                      __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        FormItem,
                        _extends({}, formItemLayout, { label: '\u662F\u5426\u6309\u65F6\u62A5\u5230' }),
                        getFieldDecorator('sfasbd', {
                          initialValue: initPOvalue.sfasbd,
                          placeholder: '请选择',
                          rules: [{
                            required: true,
                            message: '请选择是否按时报到'
                          }]
                        })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default.a,
                          { placeholder: '\u8BF7\u9009\u62E9', onChange: this.onSfasbdChange },
                          __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                            Option,
                            { value: '1' },
                            '\u662F'
                          ),
                          __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                            Option,
                            { value: '0' },
                            '\u5426'
                          )
                        ) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                          'span',
                          null,
                          initPOvalue.sfasbd == 1 ? '是' : '否'
                        ))
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                      'div',
                      { style: { display: 'inline-block', verticalAlign: 'top', width: '60%' } },
                      __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        FormItem,
                        _extends({}, formItemLayout, { label: '\u662F\u5426\u7B26\u5408\u5165\u5B66\u62A5\u5230\u6761\u4EF6' }),
                        getFieldDecorator('sffhrxbdtj', {
                          initialValue: initPOvalue.sffhrxbdtj,
                          placeholder: '请选择',
                          rules: [{
                            required: true,
                            message: '请选择是否'
                          }]
                        })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default.a,
                          { placeholder: '\u8BF7\u9009\u62E9', onChange: function onChange(v) {
                              return _this3.showReason(v);
                            } },
                          __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                            Option,
                            { value: '1' },
                            '\u662F'
                          ),
                          __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                            Option,
                            { value: '0' },
                            '\u5426'
                          )
                        ) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                          'span',
                          null,
                          initPOvalue.sffhrxbdtj == 1 ? '是' : '否'
                        ))
                      )
                    ),
                    isHideReason && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                      'div',
                      { className: 'form_item' },
                      __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        FormItem,
                        _extends({}, formItemLayout, { label: '\u4E0D\u7B26\u5408\u5165\u5B66\u62A5\u5230\u539F\u56E0' }),
                        getFieldDecorator('bfhrxbdyy', { initialValue: initPOvalue.bfhrxbdyy })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, { placeholder: '\u8BF7\u586B\u5199\u539F\u56E0' }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                          'span',
                          null,
                          initPOvalue.bfhrxbdyy
                        ))
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                      'div',
                      { className: 'form_item' },
                      __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        FormItem,
                        _extends({}, formItemLayout, { label: '\u662F\u5426\u63A5\u79CD\u65B0\u51A0\u75AB\u82D7' }),
                        getFieldDecorator('xgymjzqk', {
                          initialValue: jzqk,
                          placeholder: '请选择',
                          rules: [{
                            required: true,
                            message: '请选择是否接种新冠疫苗'
                          }]
                        })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_common_NHSelect__["a" /* default */], { sign: 'DMK_YXXT_BDQK_XGYMJZQK' }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                          'span',
                          null,
                          jzqk
                        ))
                      )
                    ),
                    isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                      'div',
                      { className: 'form_item' },
                      __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        FormItem,
                        _extends({}, formItemLayout, { label: '\u672A\u62A5\u5230\u539F\u56E0' }),
                        getFieldDecorator('wbdyy', { initialValue: wbdyy })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_common_NHSelect__["a" /* default */], { sign: 'DMK_YXXT_BDQK_WBDYY', onChange: function onChange(v) {
                            return _this3.showDetail(v);
                          } }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                          'span',
                          null,
                          wbdyy
                        ))
                      )
                    ),
                    isHideDetail && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                      'div',
                      { className: 'form_item' },
                      __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        FormItem,
                        _extends({}, formItemLayout, { label: '\u4E0D\u6309\u65F6\u62A5\u5230\u539F\u56E0' }),
                        getFieldDecorator('basbdyy', { initialValue: initPOvalue.basbdyy })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, { placeholder: '\u8BF7\u586B\u5199\u539F\u56E0' }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                          'span',
                          null,
                          initPOvalue.basbdyy
                        ))
                      )
                    ),
                    isHideDetail && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                      'div',
                      { className: 'form_item' },
                      __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        FormItem,
                        _extends({}, formItemLayout, { label: '\u5EF6\u8FDF\u65F6\u95F4(\u5929)' }),
                        getFieldDecorator('ycsj', { initialValue: initPOvalue.ycsj })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, { placeholder: '\u8BF7\u586B\u5199\u5EF6\u8FDF\u5929\u6570' }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                          'span',
                          null,
                          initPOvalue.ycsj
                        ))
                      )
                    ),
                    isHideDetail && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                      'div',
                      { className: 'form_item' },
                      __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        FormItem,
                        _extends({}, formItemLayout, { label: '\u662F\u5426\u7B26\u5408\u8BF7\u5047\u624B\u7EED' }),
                        getFieldDecorator('sffhqjsx', { initialValue: initPOvalue.sffhqjsx })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default.a,
                          { placeholder: '\u8BF7\u9009\u62E9' },
                          __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                            Option,
                            { value: '1' },
                            '\u662F'
                          ),
                          __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                            Option,
                            { value: '0' },
                            '\u5426'
                          )
                        ) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                          'span',
                          null,
                          initPOvalue.sffhqjsx == 1 ? '是' : '否'
                        ))
                      )
                    ),
                    !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                      'div',
                      { className: 'form_item' },
                      __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        FormItem,
                        _extends({}, formItemLayout, { label: '\u6765\u6821\u4EA4\u901A\u5DE5\u5177' }),
                        getFieldDecorator('jtgj', {
                          initialValue: initPOvalue.jtgj,
                          rules: [{
                            required: true,
                            message: '请选择来校交通工具'
                          }]
                        })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_common_NHSelect__["a" /* default */], {
                          sign: 'zhxg_yxwz_lxjtgj',
                          onChange: function onChange(v) {
                            _this3.onChange(v);
                          }
                        }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                          'span',
                          null,
                          lxjtgjmc
                        ))
                      )
                    ),
                    !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                      'div',
                      { className: 'form_item' },
                      __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        FormItem,
                        _extends({}, formItemLayout, { label: '\u5230\u8FBE\u7AD9' }),
                        getFieldDecorator('ddz', {
                          initialValue: dqddz,
                          rules: [{
                            message: '请选择到达站'
                          }]
                        })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default.a,
                          null,
                          options
                        ) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                          'span',
                          null,
                          dqddz
                        ))
                      )
                    ),
                    !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                      'div',
                      { className: 'form_item' },
                      __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        FormItem,
                        _extends({}, formItemLayout, { label: '\u5230\u6821\u65E5\u671F' }),
                        getFieldDecorator('dxsj', {
                          initialValue: initPOvalue.dxsj == '' ? null : __WEBPACK_IMPORTED_MODULE_25_moment___default()(initPOvalue.dxsj, 'YYYY-MM-DD HH:mm'),
                          rules: [{
                            // required: true,
                            required: editable,
                            message: '请选择到校日期'
                          }]
                        })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker___default.a, {
                          style: { width: '100%' },
                          showTime: true,
                          format: 'YYYY-MM-DD HH:mm',
                          disabledDate: this.disabledStartDate
                          // defaultValue={initPOvalue.dxsj==''?null:moment(initPOvalue.dxsj, 'YYYY-MM-DD HH:mm')} //如果时间发生错误，请删除此句defaultValue
                        }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                          'span',
                          null,
                          initPOvalue.dxsj
                        ))
                      )
                    ),
                    !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                      'div',
                      { className: 'form_item' },
                      __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        FormItem,
                        _extends({}, formItemLayout, { label: '\u73ED\u6B21' }),
                        getFieldDecorator('bc', { initialValue: initPOvalue.bc })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, null) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                          'span',
                          null,
                          initPOvalue.bc
                        ))
                      )
                    ),
                    !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                      'div',
                      { className: 'form_item' },
                      __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        FormItem,
                        _extends({}, formItemLayout, { label: '\u966A\u540C\u4EBA\u6570' }),
                        getFieldDecorator('ptrs', { initialValue: initPOvalue.ptrs })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number___default.a, { precision: 0, min: 0, max: 10, onChange: this.numberChange }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                          'span',
                          null,
                          initPOvalue.ptrs
                        )),
                        '\xA0\xA0',
                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                          'span',
                          null,
                          ' (\u4EBA) '
                        )
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                    'div',
                    { className: 'text-center mt-50' },
                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,
                      { type: 'primary', htmlType: 'submit' },
                      editable ? '保存' : '修改'
                    ),
                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                  )
                )
              )
            )
          )
        ) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__common__["a" /* default */], { hjmc: '报到情况填写', key: 'GD004_3', mkbz: 'GD004_3', nonOperationalData: this.state.nonOperationalData })
      );
    }
  }]);

  return Report;
}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component)) || _class);


/***/ }),

/***/ 1108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reportGdnhgs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_date_picker_style__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_index__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_common_NHCascader__ = __webpack_require__(108);


















var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }













// import 'moment/src/locale/zh-cn';






var history = __WEBPACK_IMPORTED_MODULE_28_history_createHashHistory___default()();
var format = 'HH:mm';

var basicUrl = "/zzbd";
var commonUrl = '/zzbdCommon';

var FormItem = __WEBPACK_IMPORTED_MODULE_16_antd_lib_form___default.a.Item;
var Option = __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default.a.Option;

var formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 }
};

var reportGdnhgs = (_dec = __WEBPACK_IMPORTED_MODULE_16_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(reportGdnhgs, _React$Component);

    function reportGdnhgs(props) {
        _classCallCheck(this, reportGdnhgs);

        var _this = _possibleConstructorReturn(this, (reportGdnhgs.__proto__ || __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default()(reportGdnhgs)).call(this, props));

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] !== '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM === bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') === 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_30__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') === 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.props.form.validateFieldsAndScroll(function (err, values) {
                if (err) {
                    return;
                }
                console.log(values);
                if (values['sfasbd'] === '0') {
                    if (values['basbdyy'] == null || typeof values['basbdyy'] == "undefined" || values['basbdyy'].trim().length === 0) {
                        __WEBPACK_IMPORTED_MODULE_23_antd_lib_index__["message"].error('不按时到达请填写原因。');
                        return;
                    }
                } else {
                    if (values['cfd'] === []) {
                        __WEBPACK_IMPORTED_MODULE_23_antd_lib_index__["message"].error('请选择出发地区！');
                        return;
                    }
                    var cfd = values.cfd,
                        dxsj = values.dxsj;

                    values.cfd = cfd.pop();
                    values.dxsj = __WEBPACK_IMPORTED_MODULE_24_moment___default()(dxsj).format("YYYY-MM-DD HH:mm");
                }
                var sUrl = '/saveBdqkData';
                if (_this.state.update) {
                    sUrl = '/updateBdqkData';
                }
                //修改 可编辑状态，并可以update数据
                if (!_this.state.editable) {
                    _this.setState({ update: true, editable: true });
                    return;
                }
                var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId;
                var zzbdhjid = _this.getUrlParams("pkid");
                var params = { xsid: xsid, zzbdhjid: zzbdhjid, formData: values };

                //请求保存或修改数据
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])(basicUrl + sUrl, 'POST', params).then(function (res) {
                    if (res) {
                        if (res.data === 1) {
                            __WEBPACK_IMPORTED_MODULE_23_antd_lib_index__["message"].success('信息保存成功！');
                            _this.reloadMenu();
                            _this.getQkpo();
                        } else {
                            __WEBPACK_IMPORTED_MODULE_23_antd_lib_index__["message"].error('信息保存失败，请重试！');
                        }
                    }
                });
            });
        };

        _this.getUrlParams = function (param) {
            return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.getDmkMc = function (dmbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])(basicUrl + "/getDmkMc", "GET", { dmbz: dmbz }).then(function (res) {
                if (res) {
                    if (res.data) {
                        if (dmbz === "YXWZ_LXJTGJ") {
                            _this.setState({ lxjtgjmcList: res.data });
                        }
                    }
                }
            });
        };

        _this.getDdz = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])(basicUrl + "/getDdz", "GET").then(function (res) {
                if (res) {
                    if (res.data) {
                        _this.setState({ ddz: res.data });
                    }
                }
            });
        };

        _this.getSSqmc = function (cfd) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])(basicUrl + "/getCfdmcBySsqm?ssqm=" + cfd, "GET").then(function (res) {
                if (res) {
                    if (res.data) {
                        _this.setState({ cfdmc: res.data });
                    }
                }
            });
        };

        _this.DdzSeleOption = function (value) {
            var dqddz = '';
            var coptions = '';
            if (_this.state.ddz.length > 0) {
                coptions = _this.state.ddz.map(function (item, key) {
                    if (value === item.ZTLX) {
                        dqddz = item.ZTMC;
                        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                            Option,
                            { key: item.ZTMC },
                            item.ZTMC
                        );
                    } else {
                        return null;
                    }
                });
            }
            _this.props.form.setFieldsValue({ ddz: dqddz });
            _this.setState({ options: coptions, dqddz: dqddz });
        };

        _this.onNHCascaderChange = function (value, selectedOptions) {
            var label = '';
            if (selectedOptions) {
                selectedOptions.forEach(function (i) {
                    label += i.label;
                });
            }
            _this.setState({ cfdStr: label });
        };

        _this.onChange = function (value) {
            _this.DdzSeleOption(value);
        };

        _this.onSfasbdChange = function (value) {
            _this.setState({ isHide: value !== '1' });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.numberChange = function (value) {
            if (value > 10 || value < 0) {
                __WEBPACK_IMPORTED_MODULE_23_antd_lib_index__["message"].warning('陪同人数请填写0-10之内的整数！');
            }
        };

        _this.disabledStartDate = function (startValue) {
            return startValue && startValue < __WEBPACK_IMPORTED_MODULE_24_moment___default()().subtract(1, "days");
        };

        _this.state = {
            mkbz: 'GD004_1',
            hjmc: '',
            editable: true,
            update: false,
            initPOvalue: {
                nd: '',
                xsid: '',
                sfasbd: '',
                basbdyy: '',
                jtgj: '',
                ddz: '',
                dxsj: '',
                bc: '',
                cfd: '',
                ptrs: 0
            },
            value: null,
            lxjtgjmcList: {},
            lxjtgjmc: '',
            ddz: {},
            cfdStr: '', //根据级联选择拼接的出发地省市区名称
            cfdmc: '', //根据initPOvalue.cfd省市区代码获取的省市区名称
            options: [],
            dqddz: '',
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            isHide: true
        };
        return _this;
    }

    _createClass(reportGdnhgs, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getDmkMc("YXWZ_LXJTGJ");
        }

        //渲染前获取信息

    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.queryQztjAndYlhj();
            this.getDdz();
            this.getQkpo();
        }

        //查询前置条件和依赖环节

    }, {
        key: 'getQkpo',
        value: function getQkpo() {
            var _this2 = this;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId;
            var lxjtgjmc = '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])(basicUrl + "/getQkpoByXsidAndNd", "GET", { xsid: xsid }).then(function (res) {
                if (res) {
                    if (res.data) {
                        lxjtgjmc = res.data.jtgjmc;
                        _this2.setState({ initPOvalue: res.data, editable: false, lxjtgjmc: lxjtgjmc });
                        var dqddz = _this2.state.initPOvalue.ddz;
                        _this2.onChange(_this2.state.initPOvalue.jtgj);
                        _this2.setState({
                            dqddz: dqddz,
                            isHide: res.data.sfasbd != 1
                        });
                        var cfd = res.data.cfd;
                        if (cfd !== null && cfd !== '') {
                            _this2.getSSqmc(cfd);
                        }
                    }
                }
            });
        }

        //获取url中传递的参数


        //获取下拉列表value对应的名称


        //获取到达站下拉列表的名称


        //获取出发地名称


        //到达站级联


        // 出发地省市区级联变化


        //下拉框发生变化检测


        //动态显示报到情况填写


        //重新加载菜单


        //陪同人数不符合时提示


        //disabledStartDate设置到校日期的时间选择器的可选日期区域

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var getFieldDecorator = this.props.form.getFieldDecorator;
            var _state = this.state,
                editable = _state.editable,
                initPOvalue = _state.initPOvalue,
                isHide = _state.isHide,
                lxjtgjmc = _state.lxjtgjmc,
                options = _state.options,
                dqddz = _state.dqddz,
                cfdStr = _state.cfdStr,
                cfdmc = _state.cfdmc;


            var cfdList = [];
            if (typeof initPOvalue.cfd == 'string') {
                // for (let i = 0; i < initPOvalue.cfd.length / 2; i++) {
                //     cfdList[i] = initPOvalue.cfd.substring(0, (i + 1) * 2);
                // }
                cfdList[0] = initPOvalue.cfd.substring(0, 2);
                cfdList[1] = initPOvalue.cfd.substring(0, 4);
                cfdList[2] = initPOvalue.cfd.substring(0, 6);
            }
            return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_18__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230'
                        /* active={3}*/
                        , mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_18__components__["a" /* Flex */].Item,
                        { className: 'page_con_r ' },
                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjmc, extra: false }),
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_16_antd_lib_form___default.a,
                                { onSubmit: this.handleSubmit },
                                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                    'div',
                                    { className: 'p-sw' },
                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_18__components__["a" /* Flex */],
                                        { align: 'start', wrap: 'wrap' },
                                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u662F\u5426\u62A5\u5230'
                                                }),
                                                getFieldDecorator('sfasbd', {
                                                    initialValue: initPOvalue.sfasbd, placeholder: '请选择',
                                                    rules: [{
                                                        required: true,
                                                        message: '请选择是否报到'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default.a,
                                                    { placeholder: '\u8BF7\u9009\u62E9', onChange: this.onSfasbdChange },
                                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                        Option,
                                                        { value: '1' },
                                                        '\u662F'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                        Option,
                                                        { value: '0' },
                                                        '\u5426'
                                                    )
                                                ) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.sfasbd === '1' ? '是' : '否'
                                                ))
                                            )
                                        ),
                                        isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u4E0D\u62A5\u5230\u539F\u56E0'
                                                }),
                                                getFieldDecorator('basbdyy', { initialValue: initPOvalue.basbdyy })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, { placeholder: '\u8BF7\u586B\u5199\u539F\u56E0' }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.basbdyy
                                                ))
                                            )
                                        ),
                                        !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u6765\u6821\u4EA4\u901A\u5DE5\u5177'
                                                }),
                                                getFieldDecorator('jtgj', {
                                                    initialValue: initPOvalue.jtgj,
                                                    rules: [{
                                                        required: true,
                                                        message: '请选择来校交通工具'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_common_NHSelect__["a" /* default */], { sign: "zhxg_yxwz_lxjtgj", onChange: function onChange(v) {
                                                        _this3.onChange(v);
                                                    } }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    lxjtgjmc
                                                ))
                                            )
                                        ),
                                        !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u5230\u8FBE\u7AD9'
                                                }),
                                                getFieldDecorator('ddz', {
                                                    initialValue: dqddz,
                                                    rules: [{
                                                        message: '请选择到达站'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default.a,
                                                    null,
                                                    options
                                                ) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    dqddz
                                                ))
                                            )
                                        ),
                                        !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u5230\u6821\u65E5\u671F'
                                                }),
                                                getFieldDecorator('dxsj', {
                                                    initialValue: initPOvalue.dxsj == '' || initPOvalue.dxsj == null ? null : __WEBPACK_IMPORTED_MODULE_24_moment___default()(initPOvalue.dxsj, 'YYYY-MM-DD HH:mm'),
                                                    rules: [{
                                                        required: editable,
                                                        message: '请选择到校日期'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker___default.a, {
                                                    style: { 'width': '100%' },
                                                    showTime: true,
                                                    format: 'YYYY-MM-DD HH:mm',
                                                    disabledDate: this.disabledStartDate
                                                    // defaultValue={initPOvalue.dxsj==''?null:moment(initPOvalue.dxsj, 'YYYY-MM-DD HH:mm')} //如果时间发生错误，请删除此句defaultValue

                                                }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.dxsj
                                                ))
                                            )
                                        ),
                                        !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u73ED\u6B21'
                                                }),
                                                getFieldDecorator('bc', { initialValue: initPOvalue.bc })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                                                    placeholder: '\u81EA\u9A7E\u8F66\u4E0D\u9700\u586B\u5199'
                                                }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.bc
                                                ))
                                            )
                                        ),
                                        !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u966A\u540C\u4EBA\u6570'
                                                }),
                                                getFieldDecorator('ptrs', { initialValue: initPOvalue.ptrs })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number___default.a, {
                                                    precision: 0,
                                                    min: 0,
                                                    max: 10,
                                                    onChange: this.numberChange
                                                }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.ptrs
                                                )),
                                                '\xA0\xA0',
                                                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    '  (\u4EBA) '
                                                )
                                            )
                                        ),
                                        !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, { label: '\u51FA\u53D1\u5730\u533A' }),
                                                getFieldDecorator('cfd', {
                                                    initialValue: cfdList,
                                                    rules: [{
                                                        required: true,
                                                        message: '请选择出发地区'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__components_common_NHCascader__["a" /* default */], { style: { width: 340 }, sign: "zhxg_ssq",
                                                    onChange: function onChange(value, selectedOptions) {
                                                        return _this3.onNHCascaderChange(value, selectedOptions);
                                                    }
                                                }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    cfdStr !== '' ? cfdStr : cfdmc,
                                                    ' '
                                                ))
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,
                                            {
                                                type: 'primary',
                                                htmlType: 'submit'
                                            },
                                            editable ? '保存' : '修改'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                )
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__common__["a" /* default */], { hjmc: "报到情况填写", key: 'GD004', mkbz: 'GD004',
                    nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return reportGdnhgs;
}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component)) || _class);


/***/ }),

/***/ 1109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReportHncs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_date_picker_style__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_index__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_SelfHelp_common_hint__ = __webpack_require__(35);


















var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _defineProperty(obj, key, value) { if (key in obj) { __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }














// import 'moment/src/locale/zh-cn';




var history = __WEBPACK_IMPORTED_MODULE_29_history_createHashHistory___default()();
var format = 'HH:mm';

var basicUrl = "/zzbd";
var commonUrl = '/zzbdCommon';

var FormItem = __WEBPACK_IMPORTED_MODULE_16_antd_lib_form___default.a.Item;
var Option = __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default.a.Option;

var formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 }
};

var ReportHncs = (_dec = __WEBPACK_IMPORTED_MODULE_16_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(ReportHncs, _React$Component);

    function ReportHncs(props) {
        _classCallCheck(this, ReportHncs);

        var _this = _possibleConstructorReturn(this, (ReportHncs.__proto__ || __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default()(ReportHncs)).call(this, props));

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_31__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.props.form.validateFieldsAndScroll(function (err, values) {
                if (err) {
                    return;
                }
                if (values['sfasbd'] == '0') {
                    if (values['basbdyy'] == null || typeof values['basbdyy'] == "undefined" || values['basbdyy'].trim().length == 0) {
                        __WEBPACK_IMPORTED_MODULE_24_antd_lib_index__["message"].error('不按时到达请填写原因。');
                        return;
                    }
                }

                var sUrl = '/saveBdqkData';
                if (_this.state.update) {
                    sUrl = '/updateBdqkData';
                }
                //修改 可编辑状态，并可以update数据
                if (!_this.state.editable) {
                    _this.setState({ update: true, editable: true });
                    return;
                }
                var dxsj = values.dxsj;

                var dxsjVal = __WEBPACK_IMPORTED_MODULE_25_moment___default()(dxsj).format("YYYY-MM-DD HH:mm");
                values.dxsj = dxsjVal;
                var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId;
                var zzbdhjid = _this.getUrlParams("pkid");
                var params = { xsid: xsid, zzbdhjid: zzbdhjid, formData: values };

                //请求保存或修改数据
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])(basicUrl + sUrl, 'POST', params).then(function (res) {
                    if (res) {
                        if (res.data == '1') {
                            __WEBPACK_IMPORTED_MODULE_24_antd_lib_index__["message"].success('信息保存成功！');
                            _this.reloadMenu();
                            _this.getQkpo();
                        } else {
                            __WEBPACK_IMPORTED_MODULE_24_antd_lib_index__["message"].error('信息保存失败，请重试！');
                        }
                    }
                });
            });
        };

        _this.getUrlParams = function (param) {
            return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.getDmkMc = function (dmbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])(basicUrl + "/getDmkMc", "GET", _defineProperty({ dmbz: dmbz }, 'dmbz', dmbz)).then(function (res) {
                if (res) {
                    if (res.data) {
                        if (dmbz === "YXWZ_LXJTGJ") {
                            _this.setState({ lxjtgjmcList: res.data });
                        }
                    }
                }
            });
        };

        _this.getDdz = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])(basicUrl + "/getDdz", "GET").then(function (res) {
                if (res) {
                    if (res.data) {
                        _this.setState({ ddz: res.data });
                    }
                }
            });
        };

        _this.DdzSeleOption = function (value) {

            var dqddz = '';
            var coptions = '';
            if (_this.state.ddz.length > 0) {
                coptions = _this.state.ddz.map(function (item, key) {
                    if (value === item.ZTLX) {
                        dqddz = item.ZTMC;
                        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                            Option,
                            { key: item.ZTMC },
                            item.ZTMC
                        );
                    } else {
                        return null;
                    }
                });
            }
            _this.props.form.setFieldsValue({ ddz: dqddz });
            _this.setState({ options: coptions, dqddz: dqddz });
        };

        _this.onChange = function (value) {
            if (value === '02') {
                _this.setState({
                    bcFlag: true
                });
            } else {
                _this.setState({
                    bcFlag: false
                });
            }
            _this.DdzSeleOption(value);
        };

        _this.onSfasbdChange = function (value) {
            _this.setState({ isHide: value == '1' ? false : true });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.numberChange = function (value) {
            if (value > 10 || value < 0) {
                __WEBPACK_IMPORTED_MODULE_24_antd_lib_index__["message"].warning('陪同人数请填写0-10之内的整数！');
            }
        };

        _this.disabledStartDate = function (startValue) {
            return startValue && startValue < __WEBPACK_IMPORTED_MODULE_25_moment___default()().subtract(1, "days");
        };

        _this.state = {
            mkbz: 'GD004_2',
            hjmc: '',
            editable: true,
            update: false,
            initPOvalue: {
                nd: '',
                xsid: '',
                sfasbd: '',
                basbdyy: '',
                jtgj: '',
                ddz: '',
                dxsj: '',
                bc: '',
                ptrs: 0
            },
            value: null,
            lxjtgjmcList: {},
            lxjtgjmc: '',
            ddz: {},
            options: [],
            dqddz: '',
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            isHide: true,
            bcFlag: false
        };
        return _this;
    }

    _createClass(ReportHncs, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getDmkMc("YXWZ_LXJTGJ");
        }
        //渲染前获取信息

    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.queryQztjAndYlhj();
            this.getDdz();
            this.getQkpo();
        }

        //查询前置条件和依赖环节

    }, {
        key: 'getQkpo',
        value: function getQkpo() {
            var _this2 = this;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId;
            var lxjtgjmc = '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])(basicUrl + "/getQkpoByXsidAndNd", "GET", _defineProperty({ xsid: xsid }, 'xsid', xsid)).then(function (res) {
                if (res) {
                    if (res.data) {
                        lxjtgjmc = res.data.jtgjmc;
                        _this2.setState({ initPOvalue: res.data, editable: false, lxjtgjmc: lxjtgjmc });
                        var dqddz = _this2.state.initPOvalue.ddz;
                        _this2.onChange(_this2.state.initPOvalue.jtgj);
                        _this2.setState({ dqddz: dqddz,
                            isHide: res.data.sfasbd == 1 ? false : true
                        });
                    }
                }
            });
        }

        //获取url中传递的参数


        //获取下拉列表value对应的名称

        //获取到达站下拉列表的名称


        //到达站级联


        //下拉框发生变化检测


        //动态显示报到情况填写


        //重新加载菜单


        //陪同人数不符合时提示


        //disabledStartDate设置到校日期的时间选择器的可选日期区域

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var getFieldDecorator = this.props.form.getFieldDecorator;
            var _state = this.state,
                editable = _state.editable,
                initPOvalue = _state.initPOvalue,
                lxjtgjmc = _state.lxjtgjmc,
                options = _state.options,
                dqddz = _state.dqddz,
                isHide = _state.isHide,
                bcFlag = _state.bcFlag;

            return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_19__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230'
                        /* active={3}*/
                        , mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_19__components__["a" /* Flex */].Item,
                        { className: 'page_con_r ' },
                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjmc, extra: false }),
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_16_antd_lib_form___default.a,
                                { onSubmit: this.handleSubmit },
                                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                    'div',
                                    { className: 'p-sw' },
                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_19__components__["a" /* Flex */],
                                        { align: 'start', wrap: 'wrap' },
                                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u662F\u5426\u6309\u65F6\u62A5\u5230'
                                                }),
                                                getFieldDecorator('sfasbd', { initialValue: initPOvalue.sfasbd, placeholder: '请选择',
                                                    rules: [{
                                                        required: true,
                                                        message: '请选择是否按时报到'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default.a,
                                                    { placeholder: '\u8BF7\u9009\u62E9', onChange: this.onSfasbdChange },
                                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                        Option,
                                                        { value: '1' },
                                                        '\u662F'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                        Option,
                                                        { value: '0' },
                                                        '\u5426'
                                                    )
                                                ) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.sfasbd == 1 ? '是' : '否'
                                                ))
                                            )
                                        ),
                                        isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u4E0D\u6309\u65F6\u62A5\u5230\u539F\u56E0'
                                                }),
                                                getFieldDecorator('basbdyy', { initialValue: initPOvalue.basbdyy })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, { placeholder: '\u8BF7\u586B\u5199\u539F\u56E0' }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.basbdyy
                                                ))
                                            )
                                        ),
                                        !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u6765\u6821\u4EA4\u901A\u5DE5\u5177'
                                                }),
                                                getFieldDecorator('jtgj', { initialValue: initPOvalue.jtgj,
                                                    rules: [{
                                                        required: true,
                                                        message: '请选择来校交通工具'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_common_NHSelect__["a" /* default */], { sign: "zhxg_yxwz_lxjtgj", onChange: function onChange(v) {
                                                        _this3.onChange(v);
                                                    } }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    lxjtgjmc
                                                ))
                                            )
                                        ),
                                        !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u5230\u8FBE\u7AD9'
                                                }),
                                                getFieldDecorator('ddz', { initialValue: dqddz,
                                                    rules: [{
                                                        message: '请选择到达站'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default.a,
                                                    null,
                                                    options
                                                ) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    dqddz
                                                ))
                                            )
                                        ),
                                        !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u5230\u6821\u65E5\u671F'
                                                }),
                                                getFieldDecorator('dxsj', { initialValue: initPOvalue.dxsj == '' ? null : __WEBPACK_IMPORTED_MODULE_25_moment___default()(initPOvalue.dxsj, 'YYYY-MM-DD HH:mm'),
                                                    rules: [{
                                                        // required: true,
                                                        required: editable,
                                                        message: '请选择到校日期'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker___default.a, {
                                                    style: { 'width': '100%' },
                                                    showTime: true,
                                                    format: 'YYYY-MM-DD HH:mm',
                                                    disabledDate: this.disabledStartDate
                                                    // defaultValue={initPOvalue.dxsj==''?null:moment(initPOvalue.dxsj, 'YYYY-MM-DD HH:mm')} //如果时间发生错误，请删除此句defaultValue

                                                }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.dxsj
                                                ))
                                            )
                                        ),
                                        !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u73ED\u6B21'
                                                }),
                                                getFieldDecorator('bc', { initialValue: initPOvalue.bc,
                                                    rules: [{
                                                        required: bcFlag
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, null) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.bc
                                                ))
                                            )
                                        ),
                                        !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u966A\u540C\u4EBA\u6570'
                                                }),
                                                getFieldDecorator('ptrs', { initialValue: initPOvalue.ptrs })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number___default.a, {
                                                    precision: 0,
                                                    min: 0,
                                                    max: 10,
                                                    onChange: this.numberChange
                                                }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.ptrs
                                                )),
                                                '\xA0\xA0',
                                                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    '  (\u4EBA) '
                                                )
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,
                                            {
                                                type: 'primary',
                                                htmlType: 'submit'
                                            },
                                            editable ? '保存' : '修改'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                )
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__common__["a" /* default */], { hjmc: "报到情况填写", key: 'GD004_2', mkbz: 'GD004_2', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return ReportHncs;
}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component)) || _class);


/***/ }),

/***/ 1110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Reportwhrj; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_date_picker_style__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_index__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_SelfHelp_common_hint__ = __webpack_require__(35);


















var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _defineProperty(obj, key, value) { if (key in obj) { __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }













// import 'moment/src/locale/zh-cn';




var history = __WEBPACK_IMPORTED_MODULE_28_history_createHashHistory___default()();
var format = 'HH:mm';

var basicUrl = "/zzbd";
var commonUrl = '/zzbdCommon';

var FormItem = __WEBPACK_IMPORTED_MODULE_16_antd_lib_form___default.a.Item;
var Option = __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default.a.Option;

var formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 }
};

var Reportwhrj = (_dec = __WEBPACK_IMPORTED_MODULE_16_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(Reportwhrj, _React$Component);

    function Reportwhrj(props) {
        _classCallCheck(this, Reportwhrj);

        var _this = _possibleConstructorReturn(this, (Reportwhrj.__proto__ || __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default()(Reportwhrj)).call(this, props));

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_30__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.props.form.validateFieldsAndScroll(function (err, values) {
                if (err) {
                    return;
                }
                if (values['sfasbd'] == '0') {
                    if (values['basbdyy'] == null || typeof values['basbdyy'] == "undefined" || values['basbdyy'].trim().length == 0) {
                        __WEBPACK_IMPORTED_MODULE_23_antd_lib_index__["message"].error('不按时到达请填写原因。');
                        return;
                    }
                }

                var sUrl = '/saveBdqkData';
                if (_this.state.update) {
                    sUrl = '/updateBdqkData';
                }
                //修改 可编辑状态，并可以update数据
                if (!_this.state.editable) {
                    _this.setState({ update: true, editable: true });
                    return;
                }
                var dxsj = values.dxsj;

                var dxsjVal = __WEBPACK_IMPORTED_MODULE_24_moment___default()(dxsj).format("YYYY-MM-DD HH:mm");
                values.dxsj = dxsjVal;
                var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId;
                var zzbdhjid = _this.getUrlParams("pkid");
                var params = { xsid: xsid, zzbdhjid: zzbdhjid, formData: values };

                //请求保存或修改数据
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])(basicUrl + sUrl, 'POST', params).then(function (res) {
                    if (res) {
                        if (res.data == '1') {
                            __WEBPACK_IMPORTED_MODULE_23_antd_lib_index__["message"].success('信息保存成功！');
                            _this.reloadMenu();
                            _this.getQkpo();
                        } else {
                            __WEBPACK_IMPORTED_MODULE_23_antd_lib_index__["message"].error('信息保存失败，请重试！');
                        }
                    }
                });
            });
        };

        _this.getUrlParams = function (param) {
            return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.getDmkMc = function (dmbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])(basicUrl + "/getDmkMc", "GET", _defineProperty({ dmbz: dmbz }, 'dmbz', dmbz)).then(function (res) {
                if (res) {
                    if (res.data) {
                        if (dmbz === "YXWZ_LXJTGJ") {
                            _this.setState({ lxjtgjmcList: res.data });
                        }
                    }
                }
            });
        };

        _this.getDdz = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])(basicUrl + "/getDdz", "GET").then(function (res) {
                if (res) {
                    if (res.data) {
                        _this.setState({ ddz: res.data });
                    }
                }
            });
        };

        _this.DdzSeleOption = function (value) {

            var dqddz = '';
            var coptions = '';
            if (_this.state.ddz.length > 0) {
                coptions = _this.state.ddz.map(function (item, key) {
                    if (value === item.ZTLX) {
                        dqddz = item.ZTMC;
                        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                            Option,
                            { key: item.ZTMC },
                            item.ZTMC
                        );
                    } else {
                        return null;
                    }
                });
            }
            _this.props.form.setFieldsValue({ ddz: dqddz });
            _this.setState({ options: coptions, dqddz: dqddz });
        };

        _this.onChange = function (value) {
            _this.DdzSeleOption(value);
        };

        _this.onSfasbdChange = function (value) {
            _this.setState({ isHide: value == '1' ? false : true });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.numberChange = function (value) {
            if (value > 10 || value < 0) {
                __WEBPACK_IMPORTED_MODULE_23_antd_lib_index__["message"].warning('陪同人数请填写0-10之内的整数！');
            }
        };

        _this.disabledStartDate = function (startValue) {
            return startValue && startValue < __WEBPACK_IMPORTED_MODULE_24_moment___default()().subtract(1, "days");
        };

        _this.state = {
            mkbz: 'GD004_4',
            hjmc: '',
            editable: true,
            update: false,
            initPOvalue: {
                nd: '',
                xsid: '',
                sfasbd: '',
                basbdyy: '',
                jtgj: '',
                ddz: '',
                dxsj: '',
                bc: '',
                ptrs: 0
            },
            value: null,
            lxjtgjmcList: {},
            lxjtgjmc: '',
            ddz: {},
            options: [],
            dqddz: '',
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            isHide: true
        };
        return _this;
    }

    _createClass(Reportwhrj, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getDmkMc("YXWZ_LXJTGJ");
        }
        //渲染前获取信息

    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.queryQztjAndYlhj();
            this.getDdz();
            this.getQkpo();
        }

        //查询前置条件和依赖环节

    }, {
        key: 'getQkpo',
        value: function getQkpo() {
            var _this2 = this;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId;
            var lxjtgjmc = '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])(basicUrl + "/getQkpoByXsidAndNd", "GET", _defineProperty({ xsid: xsid }, 'xsid', xsid)).then(function (res) {
                if (res) {
                    if (res.data) {
                        lxjtgjmc = res.data.jtgjmc;
                        _this2.setState({ initPOvalue: res.data, editable: false, lxjtgjmc: lxjtgjmc });
                        var dqddz = _this2.state.initPOvalue.ddz;
                        _this2.onChange(_this2.state.initPOvalue.jtgj);
                        _this2.setState({ dqddz: dqddz,
                            isHide: res.data.sfasbd == 1 ? false : true
                        });
                    }
                }
            });
        }

        //获取url中传递的参数


        //获取下拉列表value对应的名称

        //获取到达站下拉列表的名称


        //到达站级联


        //下拉框发生变化检测


        //动态显示报到情况填写


        //重新加载菜单


        //陪同人数不符合时提示


        //disabledStartDate设置到校日期的时间选择器的可选日期区域

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var getFieldDecorator = this.props.form.getFieldDecorator;
            var _state = this.state,
                editable = _state.editable,
                initPOvalue = _state.initPOvalue,
                lxjtgjmc = _state.lxjtgjmc,
                options = _state.options,
                dqddz = _state.dqddz,
                isHide = _state.isHide;

            return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_18__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230'
                        /* active={3}*/
                        , mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_18__components__["a" /* Flex */].Item,
                        { className: 'page_con_r ' },
                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjmc, extra: false }),
                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_16_antd_lib_form___default.a,
                                { onSubmit: this.handleSubmit },
                                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                    'div',
                                    { className: 'p-sw' },
                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_18__components__["a" /* Flex */],
                                        { align: 'start', wrap: 'wrap' },
                                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u662F\u5426\u6309\u65F6\u62A5\u5230'
                                                }),
                                                getFieldDecorator('sfasbd', { initialValue: initPOvalue.sfasbd, placeholder: '请选择',
                                                    rules: [{
                                                        required: true,
                                                        message: '请选择是否按时报到'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default.a,
                                                    { placeholder: '\u8BF7\u9009\u62E9', onChange: this.onSfasbdChange },
                                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                        Option,
                                                        { value: '1' },
                                                        '\u662F'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                        Option,
                                                        { value: '0' },
                                                        '\u5426'
                                                    )
                                                ) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.sfasbd == 1 ? '是' : '否'
                                                ))
                                            )
                                        ),
                                        isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u4E0D\u6309\u65F6\u62A5\u5230\u539F\u56E0'
                                                }),
                                                getFieldDecorator('basbdyy', { initialValue: initPOvalue.basbdyy })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, { placeholder: '\u8BF7\u586B\u5199\u539F\u56E0' }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.basbdyy
                                                ))
                                            )
                                        ),
                                        !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u6765\u6C49\u4EA4\u901A\u5DE5\u5177'
                                                }),
                                                getFieldDecorator('jtgj', { initialValue: initPOvalue.jtgj,
                                                    rules: [{
                                                        required: true,
                                                        message: '请选择来汉交通工具'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_common_NHSelect__["a" /* default */], { sign: "zhxg_yxwz_lxjtgj", onChange: function onChange(v) {
                                                        _this3.onChange(v);
                                                    } }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    lxjtgjmc
                                                ))
                                            )
                                        ),
                                        !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u5230\u8FBE\u7AD9'
                                                }),
                                                getFieldDecorator('ddz', { initialValue: dqddz,
                                                    rules: [{
                                                        message: '请选择到达站'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default.a,
                                                    null,
                                                    options
                                                ) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    dqddz
                                                ))
                                            )
                                        ),
                                        !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u5230\u6C49\u65E5\u671F'
                                                }),
                                                getFieldDecorator('dxsj', { initialValue: initPOvalue.dxsj == '' ? null : __WEBPACK_IMPORTED_MODULE_24_moment___default()(initPOvalue.dxsj, 'YYYY-MM-DD HH:mm'),
                                                    rules: [{
                                                        // required: true,
                                                        required: editable,
                                                        message: '请选择到汉日期'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker___default.a, {
                                                    style: { 'width': '100%' },
                                                    showTime: true,
                                                    format: 'YYYY-MM-DD HH:mm',
                                                    disabledDate: this.disabledStartDate
                                                    // defaultValue={initPOvalue.dxsj==''?null:moment(initPOvalue.dxsj, 'YYYY-MM-DD HH:mm')} //如果时间发生错误，请删除此句defaultValue

                                                }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.dxsj
                                                ))
                                            )
                                        ),
                                        !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u73ED\u6B21'
                                                }),
                                                getFieldDecorator('bc', { initialValue: initPOvalue.bc })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, null) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.bc
                                                ))
                                            )
                                        ),
                                        !isHide && __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u966A\u540C\u4EBA\u6570'
                                                }),
                                                getFieldDecorator('ptrs', { initialValue: initPOvalue.ptrs })(editable ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number___default.a, {
                                                    precision: 0,
                                                    min: 0,
                                                    max: 10,
                                                    onChange: this.numberChange
                                                }) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.ptrs
                                                )),
                                                '\xA0\xA0',
                                                __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    '  (\u4EBA) '
                                                )
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,
                                            {
                                                type: 'primary',
                                                htmlType: 'submit'
                                            },
                                            editable ? '保存' : '修改'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                )
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__common__["a" /* default */], { hjmc: "来汉信息登记", key: 'GD004_4', mkbz: 'GD004_4', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return Reportwhrj;
}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component)) || _class);


/***/ }),

/***/ 1111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Route; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Flex__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_css__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__index_css__);





var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }




if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_5_history_createHashHistory___default()();

/*页面*/






var Route = function (_React$Component) {
    _inherits(Route, _React$Component);

    function Route(props) {
        _classCallCheck(this, Route);

        var _this = _possibleConstructorReturn(this, (Route.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Route)).call(this, props));

        _this.loadMenuList = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_NHFetch__["a" /* default */])('/zzbd/getZzbdInfoList', 'GET').then(function (resData) {
                if (resData && resData.data) {
                    _this.toLink(resData.data);
                }
            });
        };

        _this.getBddCssz = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_NHFetch__["a" /* default */])('/zzbdCommon/getCssz', 'GET', { csbz: 'YXXT_BDD_SCHOOL' }).then(function (res) {
                if (res) {
                    if (res.data) {
                        console.log('res.data', res.data);
                        _this.setState({ bddSchool: res.data });
                    } else {
                        _this.setState({ bddSchool: 'lydx' });
                    }
                } else {
                    _this.setState({ bddSchool: 'lydx' });
                }
            });
        };

        _this.toLink = function (menuList) {
            if (menuList && menuList.length > 0) {
                var menu = menuList[0];
                var hjdm = menu.HJDM;
                var pkid = menu.PKID;
                var lx = menu.LX;
                var bddSchool = _this.state.bddSchool;

                if (hjdm.indexOf('GD') == 0) {
                    var hashUrl = hjdm === 'GD009' ? '/' + bddSchool + 'Index' : __WEBPACK_IMPORTED_MODULE_8__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    history.push({
                        pathname: hashUrl,
                        search: 'pkid=' + pkid
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var _hashUrl = '/customLink';
                    history.push({
                        pathname: _hashUrl,
                        search: 'pkid=' + pkid + '&mkbz=' + hjdm + '&lx=' + lx
                    });
                }
            }
        };

        _this.state = {};
        return _this;
    }

    _createClass(Route, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.loadMenuList();
            this.getBddCssz();
        }

        //获取报到单学校模板参数设置

    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                { className: 'app__css__app-pages-SelfHelp-route-__index__page_pay' },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10__components_Flex__["a" /* default */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__pages_Assembly_siderMenu__["a" /* default */], {
                        title: '\u81EA\u52A9\u62A5\u5230',
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10__components_Flex__["a" /* default */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }]
                        })
                    )
                )
            );
        }
    }]);

    return Route;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);



/***/ }),

/***/ 1112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dorm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert_style__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_set__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_checkbox_style__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_checkbox__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__selectBox__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__selectModal__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__index_css__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_getSize__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_common_NHModal__ = __webpack_require__(106);




















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }





















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_30_history_createHashHistory___default()();
var confirm = __WEBPACK_IMPORTED_MODULE_18_antd_lib_modal___default.a.confirm;
var CheckboxGroup = __WEBPACK_IMPORTED_MODULE_16_antd_lib_checkbox___default.a.Group;

var Dorm = function (_React$Component) {
    _inherits(Dorm, _React$Component);

    function Dorm(props) {
        _classCallCheck(this, Dorm);

        var _this2 = _possibleConstructorReturn(this, (Dorm.__proto__ || __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default()(Dorm)).call(this, props));

        _this2.updateZzbdBlzt = function () {
            var zzbdhjid = _this2.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('/zzbd/updateZzbdBlzt', 'GET', { zzbdhjid: zzbdhjid, hjdm: 'GD006_1' }).then(function (res) {
                if (res.data) {
                    _this2.reloadMenu();
                }
            });
        };

        _this2.queryQztjAndYlhj = function (callback) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this2.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this2.getUrlParams('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this2.setState({ nonOperationalData: res.data });
                    if (kfsj && kfsj['YXSJ'] != '1') {
                        _this2.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this2.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this2.setState({ operable: false });
                    }

                    if (callback) {
                        callback(_this2.state.operable);
                    }
                }
            });
        };

        _this2.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this2.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this2.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_34__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this2.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this2.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this2.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this2.getUrlParams = function (param) {
            return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this2.getSfbzAndCwsInfo = function (xsid, xqid, xbm) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])("/gyxtUnauth/cwfp/getYxxcSfbzAndSslxInfo", 'GET', { xqid: xqid ? xqid : "", xsid: xsid, xbm: xbm }).then(function (res) {
                if (res) {
                    var data = res.data;
                    _this2.setState({
                        cwsList: data.cwsList,
                        sfbzList: data.sfbzList,
                        xqList: data.xqList
                    });

                    //如果学生无校区信息,默认加载第一个Tab校区的宿舍信息
                    if (!xqid) {
                        _this2.setState({
                            currentXqid: data.xqList[0].XQID
                        });
                        _this2.getFjxxList({
                            cws: "",
                            sfbz: "",
                            xsid: xsid,
                            xqid: data.xqList[0].XQID,
                            xbm: xbm
                        });
                    }
                }
            });
        };

        _this2.getFjxxList = function (param) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])("/gyxtUnauth/cwfp/getYxwzSsfpFjxxList", 'GET', param).then(function (res) {
                if (res) {
                    _this2.setState({
                        fjxxList: res.data
                    }, function () {
                        _this2.fitlerRoom();
                    });
                }
            });
        };

        _this2.fitlerRoom = function () {
            var kyxzRoom = [];
            // console.log("获取房间信息-------",res.data);
            var fjxxList = _this2.state.fjxxList;
            fjxxList.map(function (item, index) {
                if (item.yxNum < item.allNum) {
                    // console.log("未住满的房间(个数判断)------",item);
                    if (item.bedList && item.bedList.length > 0) {
                        item.yxwzCwxxTzVOs.map(function (item2, index2) {
                            if (item2.xz == '0') {
                                // console.log("可以选择的床位---------",item2,item);
                                kyxzRoom.push(item);
                            }
                        });
                    }
                }
            });
            var setRoom = [];
            if (kyxzRoom.length > 0) {
                //去重
                setRoom = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_set___default.a(kyxzRoom));
                // setRoom = Array.from(setRoom);
            }
            console.log("过滤后的房间------", kyxzRoom, setRoom);
            _this2.setState({
                setRoom: setRoom
            });
        };

        _this2.getXsssrzYwxxByXsid = function (xsid) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/getXsssrzYwxxByXsid', 'GET', {
                xsid: xsid
            }).then(function (res) {
                if (res && res.data) {
                    _this2.setState({
                        xsssruYwxx: res.data
                    });
                }
            });
        };

        _this2.confirmCwfpxx = function (xzId) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xqid = loginUserInfo.XQID,
                xbm = loginUserInfo.XBM;

            if (!xzId) {
                __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.warning("请先选择一个床位！");
                return;
            }

            //检查该床位是否被其他学生抢占(防并发的情况下同一个床位被其他人重复选择)
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/checkCwIsPermitSelect', 'GET', { cwid: xzId, xsid: xsid }).then(function (res) {
                if (res) {
                    if (res.data === 0) {
                        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("抱歉，该床位已经被其他同学抢占，请选择其他床位！");
                        return;
                    } else {
                        //确认床位信息
                        _this2.cwfpSubmit(xsid, xzId, xqid, xbm);
                    }
                }
            });
        };

        _this2.cwfpSubmit = function (xsid, currentClickCwPkid, xqid, xbm) {
            var zzbdhjid = _this2.getUrlParams("pkid");
            var params = { xsid: xsid, cwid: currentClickCwPkid, zzbdhjid: zzbdhjid };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/checkCwIsAvailableSelected', 'GET', { cwid: currentClickCwPkid }).then(function (res) {
                if (res) {
                    if (res.data) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/yxwzConfirmCwxx', 'POST', params).then(function (res) {
                            if (res) {
                                if (res.data) {
                                    __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.success("分配成功！");
                                    _this2.reloadMenu();
                                    _this2.setState({
                                        currentClickCwPkid: ""
                                    });

                                    _this2.getFjxxList({
                                        cws: "",
                                        sfbz: "",
                                        xsid: xsid,
                                        xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                                        xbm: xbm
                                    });

                                    _this2.getXsssrzYwxxByXsid(xsid);

                                    _this2.checkZzbdisLinked();
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("分配失败，请稍后重试！");
                                }
                            }
                        });
                    } else {
                        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("抱歉，该床位未到分配时间或已过床位分配时间期限，请选择其他床位! ");
                    }
                }
            });
        };

        _this2.showConfirm = function (value, id, cwh) {
            confirm({
                title: __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                    'span',
                    null,
                    '\u786E\u5B9A\u9009\u62E9',
                    value.name,
                    '\u623F\u95F4\u7684\u4E0B\u5217\u5E8A\u94FA\uFF1F'
                ),
                content: __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__selectModal__["a" /* default */], {
                    data: value,
                    id: id,
                    currentClickCwh: cwh,
                    onChange: function onChange(value) {
                        _this2.setState({
                            xzId: value.id,
                            currentClickCwPkid: value.id
                        });
                    }
                }),
                onOk: function onOk() {
                    var currentClickCwPkid = _this2.state.currentClickCwPkid;
                    //确定分配宿舍提交

                    _this2.confirmCwfpxx(currentClickCwPkid);
                },
                onCancel: function onCancel() {
                    _this2.setState({
                        currentClickCwPkid: ""
                    });
                }
            });
        };

        _this2.judeageCs = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/yxwzSyzxcs', 'GET', { xsid: xsid }).then(function (res) {

                if (res && res.data === -1) {
                    _this2.handleCancelListener();
                } else if (res && res.data === 0) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_36__components_common_NHModal__["b" /* NHConfirm */])("自选宿舍次数已用完，取消后不能再进行自选宿舍操作！确定取消？", function () {
                        _this2.handleCancelListener();
                    }, "warn");
                } else if (res && res.data !== -1 && res.data !== 0) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_36__components_common_NHModal__["b" /* NHConfirm */])("确定取消？取消后还剩" + res.data + "次可选", function () {
                        _this2.handleCancelListener();
                    }, "warn");
                }
            });
        };

        _this2.handleCancelListener = function () {
            _this2.setState({
                cancelLoading: true
            });
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xqid = loginUserInfo.XQID,
                xbm = loginUserInfo.XBM;

            var zzbdhjid = _this2.getUrlParams("pkid");
            var params = { xsid: xsid, zzbdhjid: zzbdhjid };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/cancelBlSsfp', 'POST', params).then(function (res) {
                if (res && res.data === 1) {
                    __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.success('取消办理成功！');
                    _this2.reloadMenu();
                    _this2.getFjxxList({
                        cws: "",
                        sfbz: "",
                        xsid: xsid,
                        xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                        xbm: xbm
                    });

                    _this2.checkZzbdisLinked();

                    _this2.setState({
                        xsssruYwxx: {},
                        cancelLoading: false
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error('取消办理失败，请稍后重试！');
                    _this2.setState({
                        cancelLoading: false
                    });
                }
            }).catch(function () {
                __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("取消办理失败，请稍后重试！");
                _this2.setState({
                    cancelLoading: false
                });
            });
        };

        _this2.handleAutoDistributeListener = function () {
            _this2.setState({
                autoBlLoading: true
            });
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xqid = loginUserInfo.XQID,
                xbm = loginUserInfo.XBM;
            var zzbdhjid = _this2.getUrlParams("pkid");

            if (!xsid) {
                __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.warning("自动办理失败,请稍后重试！");
                return;
            }

            var param = _this2.state.param;
            //自动分配宿舍

            var params = {
                cws: param.cws || "",
                sfbz: param.sfbz || "",
                xsid: xsid,
                xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                xbm: xbm,
                zzbdhjid: zzbdhjid
            };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])("/gyxtUnauth/cwfp/yxwzAutoDistributeSscwxx", 'POST', params).then(function (res) {
                if (res) {
                    if (res.data === 1) {
                        var text = "";
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/getXsssrzYwxxByXsid', 'GET', { xsid: xsid }).then(function (res) {
                            if (res && res.data) {
                                var data = res.data;
                                _this2.setState({
                                    xsssruYwxx: data
                                });
                                text = data.ldmc + "-" + data.fj + "-" + data.cwh + "号床位";
                                __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.success("自动办理成功,分配宿舍为 " + text + "！");
                                _this2.reloadMenu();
                                _this2.getFjxxList({
                                    cws: "",
                                    sfbz: "",
                                    xsid: xsid,
                                    xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                                    xbm: xbm
                                });

                                _this2.getXsssrzYwxxByXsid(xsid);
                                _this2.checkZzbdisLinked();

                                _this2.setState({
                                    autoBlLoading: false
                                });
                            } else {
                                __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("自动办理失败,请稍后重试！");
                                _this2.setState({
                                    autoBlLoading: false
                                });
                            }
                        });
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("自动办理失败,请稍后重试！");
                    _this2.setState({
                        autoBlLoading: false
                    });
                }
            }).catch(function () {
                __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("自动办理失败,请稍后重试！");
                _this2.setState({
                    autoBlLoading: false
                });
            });
        };

        _this2.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this2.checkZzbdisLinked = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this2.getUrlParams("pkid");
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])("/zzbdCommon/checkIsZzbdHjLinked", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                console.log("公寓", res.data);
                if (res) {
                    if (res.data) {
                        _this2.setState({
                            isHjLinked: res.data
                        });
                    } else {
                        _this2.setState({
                            isHjLinked: false
                        });
                    }
                } else {
                    _this2.setState({
                        isHjLinked: false
                    });
                }
            });
        };

        _this2.autoSelectCwListener = function (value) {
            _this2.setState({
                zdrzLoading: true
            });
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xqid = loginUserInfo.XQID,
                xbm = loginUserInfo.XBM;

            var yxwzCwxxTzVOs = value.yxwzCwxxTzVOs,
                name = value.name;

            var zzbdhjid = _this2.getUrlParams("pkid");
            var availableSelectArr = [],
                availSelectCwPkId = "",
                text = "";

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator___default()(yxwzCwxxTzVOs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    availableSelectArr.push(item.xz);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (availableSelectArr.indexOf("0") === -1) {
                __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.warning("抱歉，该房间已满员，请选择其他房间！");
                return;
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator___default()(yxwzCwxxTzVOs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _item = _step2.value;

                    //床位未被选择并且未过分配期限
                    if (_item.xz === '0' && !_item.expire) {
                        availSelectCwPkId = _item.id;
                        text = name + "-" + _item.cwh;
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            if (availSelectCwPkId) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/checkCwIsPermitSelect', 'GET', { cwid: availSelectCwPkId, xsid: xsid }).then(function (res) {
                    if (res) {
                        if (res.data === 0) {
                            __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("抱歉，该床位已经被其他同学抢占，请选择其他床位！");
                            _this2.setState({
                                zdrzLoading: false
                            });
                            return;
                        } else {
                            // 确认床位信息
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/yxwzConfirmCwxx', 'POST', {
                                xsid: xsid,
                                cwid: availSelectCwPkId,
                                zzbdhjid: zzbdhjid
                            }).then(function (res) {
                                if (res) {
                                    if (res.data) {
                                        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.success("分配成功，分配宿舍为 " + text + ", 请尽快确认办理！");
                                        _this2.reloadMenu();
                                        _this2.getFjxxList({
                                            cws: "",
                                            sfbz: "",
                                            xsid: xsid,
                                            xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                                            xbm: xbm
                                        });

                                        _this2.getXsssrzYwxxByXsid(xsid);
                                        _this2.checkZzbdisLinked();

                                        _this2.setState({
                                            zdrzLoading: false
                                        });
                                    }
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("分配失败，请稍后重试！");
                                    _this2.setState({
                                        zdrzLoading: false
                                    });
                                }
                            });
                        }
                    }
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.warning("抱歉，未匹配到合适的床位信息,请选择其他床位！");
                _this2.setState({
                    zdrzLoading: false
                });
            }
        };

        _this2.onSfbzChangeListener = function (checkedValues) {
            var _this2$state = _this2.state,
                param = _this2$state.param,
                currentXqid = _this2$state.currentXqid;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xbm = loginUserInfo.XBM;
            param.sfbz = checkedValues.length > 0 ? checkedValues.join(",") : "";
            param.xsid = xsid;
            param.xqid = currentXqid ? currentXqid : _this2.state.xqList[0].XQID;
            param.xbm = xbm;
            _this2.getFjxxList(param);
        };

        _this2.onCwsChange = function (checkedValues) {
            var _this2$state2 = _this2.state,
                param = _this2$state2.param,
                currentXqid = _this2$state2.currentXqid;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xbm = loginUserInfo.XBM;
            param.cws = checkedValues.length > 0 ? checkedValues.join(",") : "";
            param.xsid = xsid;
            param.xbm = xbm;
            param.xqid = currentXqid ? currentXqid : _this2.state.xqList[0].XQID;
            _this2.getFjxxList(param);
        };

        _this2.tabChangeListener = function (activeKey) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xbm = loginUserInfo.XBM;
            var _this2$state$param = _this2.state.param,
                cws = _this2$state$param.cws,
                sfbz = _this2$state$param.sfbz;


            _this2.setState({
                currentXqid: activeKey
            });

            //加载房间信息
            _this2.getFjxxList({
                cws: cws || "",
                sfbz: sfbz || "",
                xsid: xsid,
                xqid: activeKey,
                xbm: xbm
            });
        };

        _this2.reloadMenu = function () {
            _this2.refs.siderMenu.reloadMenuList();
        };

        _this2.handleNextRoom = function (RoomList) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var _this2$state3 = _this2.state,
                fjxxList = _this2$state3.fjxxList,
                setRoom = _this2$state3.setRoom;

            var fjid = RoomList[0].fjid;
            var list = [];
            console.log("当前宿舍信息-----------", RoomList, fjxxList, setRoom, fjid);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('api/zhxg-yxxt/yxwz/zzbd/zxss/checkFullByRoomId', 'GET', { roomId: fjid, xsid: xsid }).then(function (res) {
                if (res) {
                    if (res.code == "200") {
                        if (res != null) {
                            if (!res.data) {
                                var _fjid = RoomList[0].fjid;
                                fjxxList.map(function (item, index) {
                                    if (item.fjid == _fjid) {
                                        item.yxNum = item.allNum;
                                    }
                                    list.push(item);
                                });
                                console.log("模拟修改-----------", list);
                                _this2.setState({
                                    fjxxList: list
                                }, function () {
                                    _this2.fitlerRoom();
                                });
                            } else {
                                __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("当前宿舍未选满,不可选择下一个宿舍!");
                            }
                        }
                    } else {
                        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("获取宿舍信息失败！");
                    }
                }
            });
        };

        _this2.state = {
            mkbz: 'GD006_1',
            hjmc: '',
            xzId: '',
            _xzId: '',
            cwsList: [], //床位数
            sfbzList: [], //收费标准
            xqList: [], //校区信息
            currentXqid: "", //当前校区ID
            fjxxList: [], //房间信息
            currentClickCwPkid: "", //当前床位信息ID
            xsssruYwxx: {}, //学生宿舍入住业务信息
            isHjLinked: false, //环节是否办理状态
            param: {}, //过滤条件
            scrollHeight: 200, //默认滚动高度
            loginUserInfo: {}, //当前登录学生信息
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            autoBlLoading: false, //自动办理按钮载入状态
            cancelLoading: false, //取消办理按钮载入状态
            zdrzLoading: false, //自动入住载入状态
            setRoom: [] //过滤房间信息
        };
        return _this2;
    }

    _createClass(Dorm, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var that = this;
            this.setState({ scrollHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__utils_getSize__["a" /* default */])().windowH - 206 });
            window.onresize = function () {
                that.setState({
                    scrollHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__utils_getSize__["a" /* default */])().windowH - 206
                });
            };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            this.queryQztjAndYlhj(function (operable) {
                if (operable) {
                    var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["b" /* getLoginUser */])().userId : '';
                    if (xsid) {
                        var _this = _this3;
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_NHCore__["d" /* getLoginUserInfo */])(xsid, function (data) {
                            _this.setState({
                                loginUserInfo: data
                            }, function () {
                                var loginUserInfo = _this.state.loginUserInfo;

                                var xqid = loginUserInfo.XQID,
                                    xbm = loginUserInfo.XBM;

                                if (xsid) {
                                    //办理状态根据 关联现场环节和是否反向关联修改 不根据现场状态
                                    //_this.updateZzbdBlzt();
                                    //加载收费标准、床位数信息
                                    _this.getSfbzAndCwsInfo(xsid, xqid, xbm);
                                    _this.getXsssrzYwxxByXsid(xsid);
                                    //如果学生校区ID不为空,则只加载本校区宿舍信息
                                    if (xqid) {
                                        _this.setState({
                                            currentXqid: xqid
                                        });
                                        _this.getFjxxList({
                                            cws: "",
                                            sfbz: "",
                                            xsid: xsid,
                                            xqid: xqid,
                                            xbm: xbm
                                        });
                                    }
                                }
                                _this.checkZzbdisLinked();
                            });
                        });
                    }
                }
            });
        }

        //迎新现场已办理时迎新网站自动办理


        //查询前置条件和依赖环节


        //获取url中传递的参数


        //获取收费标准、床位信息等


        //获取宿舍房间信息


        // 过滤可以选择的房间信息


        //查询学生宿舍入住信息


        //确认床位分配


        //床位分配提交


        //选择床位弹层


        //取消办理事件


        //自动办理事件

        //检查环节是否已办理


        //自动入住事件


        //收费标准onChange事件


        //宿舍类型onChange事件


        //tab切换事件


        //重新加载菜单


        // 选择下一个宿舍（当前宿舍选择完后才可以选择）

    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _state = this.state,
                xzId = _state.xzId,
                _xzId = _state._xzId,
                cwsList = _state.cwsList,
                xqList = _state.xqList,
                sfbzList = _state.sfbzList,
                fjxxList = _state.fjxxList,
                setRoom = _state.setRoom,
                xsssruYwxx = _state.xsssruYwxx,
                isHjLinked = _state.isHjLinked,
                scrollHeight = _state.scrollHeight,
                currentXqid = _state.currentXqid,
                autoBlLoading = _state.autoBlLoading,
                cancelLoading = _state.cancelLoading,
                zdrzLoading = _state.zdrzLoading;
            //学生已选宿舍信息

            var xqmc = xsssruYwxx.xqmc,
                ldmc = xsssruYwxx.ldmc,
                fj = xsssruYwxx.fj,
                cwh = xsssruYwxx.cwh;

            var yxssInfo = (xqmc || "") + "-" + (ldmc || "") + "-" + (fj || "") + "-" + (cwh || "") + "号床";
            // 只拿一个宿舍，但该宿舍选完后才显示下一个宿舍（每次显示一个宿舍）
            var RoomList = [];
            if (setRoom.length > 1) {
                RoomList.push(setRoom[0]);
            } else {
                RoomList = setRoom;
            }

            return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_21__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230',
                        mkbz: this.state.mkbz
                        /*   active={5}*/
                        , menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_21__components__["a" /* Flex */].Item,
                        { className: 'page_con_r ' },
                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_24__pages_Assembly_titleTop__["a" /* default */],
                                {
                                    className: 'mt-20',
                                    title: this.state.hjmc,
                                    extra: false
                                },
                                !isHjLinked && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_8_antd_lib_button___default.a,
                                    {
                                        className: 'ml-10',
                                        type: 'primary',
                                        ghost: true,
                                        loading: autoBlLoading,
                                        onClick: this.handleAutoDistributeListener
                                    },
                                    '\u81EA\u52A8\u529E\u7406'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                'div',
                                { className: 'p-sw' },
                                isHjLinked && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert___default.a, { message: "当前选择宿舍为: " + yxssInfo, type: 'info', showIcon: true })
                                ),
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin___default.a,
                                    { spinning: zdrzLoading },
                                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__tab_box' },
                                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__selectBox__["a" /* default */], {
                                            Data: RoomList,
                                            xzId: _xzId,
                                            showConfirm: this.showConfirm,
                                            onChange: function onChange(value) {
                                                _this4.setState({
                                                    xzId: value.id,
                                                    currentClickCwPkid: value.id
                                                });
                                            },
                                            autoSelectCwListener: function autoSelectCwListener(value) {
                                                return _this4.autoSelectCwListener(value);
                                            },
                                            scrollHeight: scrollHeight,
                                            tabChangeListener: this.tabChangeListener,
                                            xqList: xqList,
                                            currentXqid: currentXqid
                                        })
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                'div',
                                { className: 'text-center mt-50' },
                                setRoom.length > 1 && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_8_antd_lib_button___default.a,
                                    { type: 'primary', onClick: function onClick() {
                                            return _this4.handleNextRoom(RoomList);
                                        } },
                                    '\u4E0B\u4E00\u4E2A\u5BBF\u820D'
                                ),
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__common__["a" /* default */], { hjmc: "自选宿舍", key: 'GD006_1', mkbz: 'GD006_1', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return Dorm;
}(__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component);



/***/ }),

/***/ 1113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_popover_style__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_popover_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_popover_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_popover__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_tabs_style__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_plugin_react_css_modules_dist_browser_getClassName__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_plugin_react_css_modules_dist_browser_getClassName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_plugin_react_css_modules_dist_browser_getClassName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__index_css__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars__);











var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;


var _styleModuleImportMap = {
    './index.css': {
        'tab_box': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__tab_box',
        'tip': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__tip',
        'item': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__item',
        'item_con': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__item_con',
        'round': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__round',
        'select_box': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__select_box',
        'select_list': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__select_list',
        'select_item': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__select_item',
        'select_item_b': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__select_item_b',
        'select_item_y': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__select_item_y',
        'item_btn_box': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__item_btn_box',
        'item_btn': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__item_btn',
        'modal_box': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__modal_box',
        'modal_list': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__modal_list',
        'dorPic': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__dorPic'
    }
};

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }










if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var TabPane = __WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default.a.TabPane;

/**
 * @author weishihuai
 * @date 2018/7/6
 * @time 14:42
 * @Description: 迎新网站-自助报到-宿舍分配-宿舍床位信息
 */
var SelectBox = (_temp = _class = function (_React$Component) {
    _inherits(SelectBox, _React$Component);

    function SelectBox(props) {
        _classCallCheck(this, SelectBox);

        var _this = _possibleConstructorReturn(this, (SelectBox.__proto__ || __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default()(SelectBox)).call(this, props));

        _this.getListItem = function () {
            var Data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var _this$props = _this.props,
                className = _this$props.className,
                showConfirm = _this$props.showConfirm,
                xzId = _this$props.xzId,
                onChange = _this$props.onChange,
                autoSelectCwListener = _this$props.autoSelectCwListener;

            return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_14__components__["a" /* Flex */],
                { align: 'top', wrap: 'wrap', className: 'mt-20' },
                Data.length > 0 ? Data.map(function (item, idx) {
                    var sscx = item.sscx != null && item.sscx.length > 0 ? item.sscx : '';
                    var fjxx = item.name + " " + sscx;
                    return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        'div',
                        { key: idx, className: 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__item' },
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__item_con' },
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__components__["a" /* Flex */],
                                { justify: 'between' },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'span',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('span', { className: 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__round' }),
                                    fjxx.length < 12 ? fjxx : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        { style: { cursor: "pointer" } },
                                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_popover___default.a,
                                            { content: fjxx, trigger: 'hover' },
                                            fjxx.substr(0, 10) + "..."
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'span',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                        'span',
                                        { className: 'text-blue' },
                                        item.yxNum
                                    ),
                                    '/',
                                    item.allNum
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__components__["a" /* Flex */],
                                {
                                    wrap: 'wrap',
                                    align: 'center',
                                    justify: 'center',
                                    className: 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__select_box'
                                },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                    'div',
                                    { className: 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__select_list' },
                                    item.bedList[0] && item.bedList.map(function (el, index) {
                                        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                            'div',
                                            { key: index },
                                            el.map(function (cwxx, index) {
                                                return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div', {
                                                    key: index,

                                                    onClick: function onClick() {
                                                        if (cwxx.xz === "0") {
                                                            showConfirm(item, cwxx.id, cwxx.cwh);
                                                            onChange(cwxx);
                                                        } else {
                                                            __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.warning('抱歉，该床铺已选择！');
                                                        }
                                                    },
                                                    className: __WEBPACK_IMPORTED_MODULE_10_babel_plugin_react_css_modules_dist_browser_getClassName___default()(__WEBPACK_IMPORTED_MODULE_13_classnames___default()('select_item', {
                                                        select_item_b: cwxx.xz === '1',
                                                        select_item_y: xzId === cwxx.id && cwxx.xz === '0' || cwxx.currentXsSelected
                                                    }), _styleModuleImportMap)
                                                });
                                            })
                                        );
                                    })
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__item_btn_box' },
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'div',
                                {
                                    className: 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__item_btn',
                                    onClick: function onClick() {
                                        return autoSelectCwListener(item);
                                    }
                                },
                                '\u81EA\u52A8\u5165\u4F4F'
                            ),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'div',
                                {
                                    className: 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__item_btn',
                                    onClick: function onClick() {
                                        return showConfirm(item);
                                    }
                                },
                                '\u9009\u62E9\u5E8A\u4F4D'
                            )
                        )
                    );
                }) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        'span',
                        { style: { color: "#f00" } },
                        '\u6682\u65E0\u5339\u914D\u7684\u5BBF\u820D\u4FE1\u606F\uFF01'
                    )
                )
            );
        };

        return _this;
    }

    //床位信息


    _createClass(SelectBox, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                className = _props.className,
                Data = _props.Data,
                scrollHeight = _props.scrollHeight,
                tabChangeListener = _props.tabChangeListener,
                xqList = _props.xqList,
                currentXqid = _props.currentXqid;

            var activeKey = currentXqid || xqList[0] && xqList[0].XQID;

            return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default.a,
                { defaultActiveKey: '0', activeKey: activeKey, tabPosition: 'top',
                    onChange: function onChange(activeKey) {
                        return tabChangeListener(activeKey);
                    } },
                xqList.map(function (xq) {
                    return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        TabPane,
                        { tab: xq.XQMC, key: xq.XQID },
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_14__components__["a" /* Flex */],
                            { className: 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__tip', justify: 'center' },
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('img', {
                                src: __webpack_require__(281),
                                alt: ''
                            }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'span',
                                null,
                                '\u53EF\u9009\u62E9'
                            ),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('img', {
                                className: 'ml-10',
                                src: __webpack_require__(280),
                                alt: ''
                            }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'span',
                                null,
                                '\u4E0D\u53EF\u9009'
                            ),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('img', {
                                className: 'ml-10',
                                src: __webpack_require__(282),
                                alt: ''
                            }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'span',
                                null,
                                '\u5DF2\u9009\u62E9'
                            )
                        ),
                        Data.length > 16 ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars__["Scrollbars"],
                            { autoHide: true,
                                style: { width: '100%', height: scrollHeight } },
                            _this2.getListItem(Data)
                        ) : _this2.getListItem(Data)
                    );
                })
            );
        }
    }]);

    return SelectBox;
}(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component), _class.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,
    xzId: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.any,
    showConfirm: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
    autoSelectCwListener: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
    tabChangeListener: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func
}, _class.defaultProps = {
    xzId: '',
    showConfirm: Function.prototype,
    onChange: Function.prototype,
    autoSelectCwListener: Function.prototype,
    tabChangeListener: Function.prototype
}, _temp);


/***/ }),

/***/ 1114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_plugin_react_css_modules_dist_browser_getClassName__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_plugin_react_css_modules_dist_browser_getClassName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_plugin_react_css_modules_dist_browser_getClassName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_css__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__index_css__);







var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;



var _styleModuleImportMap = {
    './index.css': {
        'tab_box': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__tab_box',
        'tip': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__tip',
        'item': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__item',
        'item_con': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__item_con',
        'round': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__round',
        'select_box': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__select_box',
        'select_list': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__select_list',
        'select_item': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__select_item',
        'select_item_b': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__select_item_b',
        'select_item_y': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__select_item_y',
        'item_btn_box': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__item_btn_box',
        'item_btn': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__item_btn',
        'modal_box': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__modal_box',
        'modal_list': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__modal_list',
        'dorPic': 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__dorPic'
    }
};

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }









/**
 * @author weishihuai
 * @date 2018/7/6
 * @time 14:41
 * @Description: 迎新网站-自助报到-宿舍分配-选择床位弹层
 */

if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var SelectModal = (_temp = _class = function (_React$Component) {
    _inherits(SelectModal, _React$Component);

    function SelectModal(props) {
        _classCallCheck(this, SelectModal);

        var _this = _possibleConstructorReturn(this, (SelectModal.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(SelectModal)).call(this, props));

        _this.getPicByCws = function (cws) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHFetch__["a" /* default */])('api/zhxg-yxxt/yxwz/zzbd/zxss/getPicByFjlx', 'GET', { lxbz: "cws", lxz: cws }).then(function (res) {
                if (res && res.data) {
                    _this.setState({
                        picList: res.data,
                        picData: "data:image/png;base64," + res.data
                    }, function () {
                        // this.setState({
                        //     picUrl : <img src={this.state.picData} alt="" className="avatar" />
                        // })
                    });
                }
            });
        };

        var id = props.id;

        _this.state = {
            xzId: id,
            currentClickCwh: "" //当前床位号
        };
        return _this;
    }

    _createClass(SelectModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                currentClickCwh = _props.currentClickCwh,
                data = _props.data;

            var cws = data.allNum;
            this.setState({
                currentClickCwh: currentClickCwh
            });
            this.getPicByCws(cws);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                xzId = _state.xzId,
                currentClickCwh = _state.currentClickCwh,
                picUrl = _state.picUrl,
                picList = _state.picList;
            var _props2 = this.props,
                className = _props2.className,
                data = _props2.data,
                onChange = _props2.onChange;


            return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()('text-center', className) },
                picList ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                    'div',
                    { style: { 'white-space': 'nowrap' }, className: 'jsx-2741941163'
                    },
                    __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_styled_jsx_style___default.a, {
                        styleId: '2741941163',
                        css: ['.ant-modal-content{width:740px;}']
                    }),
                    this.state.picList.map(function (el, i) {
                        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('img', { src: "data:image/png;base64," + el, alt: '', style: { width: 250, height: 250, margin: 1 }, className: 'jsx-2741941163' + ' ' + 'avatar'
                        });
                    })
                ) : null,
                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                    'div',
                    { className: 'text-blue' },
                    currentClickCwh ? currentClickCwh > 9 ? currentClickCwh + "床" : "0" + currentClickCwh + "床" : "请选择床铺"
                ),
                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_11__components__["a" /* Flex */],
                    { wrap: 'wrap', align: 'center', justify: 'center' },
                    __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                        'div',
                        { className: 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__modal_box' },
                        data.bedList[0] && data.bedList.map(function (el, i) {
                            return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                'div',
                                { key: i },
                                el.map(function (cwxx, index) {
                                    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                        'div',
                                        {
                                            className: 'app__css__app-pages-SelfHelp-scjtChooseDor-__index__modal_list',
                                            onClick: function onClick() {
                                                if (cwxx.xz === "0") {
                                                    _this2.setState({
                                                        xzId: cwxx.id,
                                                        currentClickCwh: cwxx.cwh
                                                    });
                                                    onChange(cwxx);
                                                } else {
                                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.warning('抱歉，该床铺已选择！');
                                                }
                                            },
                                            key: index
                                        },
                                        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', {
                                            className: __WEBPACK_IMPORTED_MODULE_7_babel_plugin_react_css_modules_dist_browser_getClassName___default()(__WEBPACK_IMPORTED_MODULE_10_classnames___default()('select_item', {
                                                select_item_b: cwxx.xz === '1',
                                                select_item_y: xzId === cwxx.id && cwxx.xz === '0' || cwxx.currentXsSelected
                                            }), _styleModuleImportMap)
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                            'div',
                                            null,
                                            cwxx.cwh > 9 ? cwxx.cwh + "床" : "0" + cwxx.cwh + "床"
                                        )
                                    );
                                })
                            );
                        })
                    )
                )
            );
        }
    }]);

    return SelectModal;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component), _class.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
    id: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any,
    currentClickCwh: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
    onChange: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
}, _class.defaultProps = {
    id: '',
    onChange: Function.prototype,
    currentClickCwh: ""
}, _temp);


/***/ }),

/***/ 1115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Size; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_index__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_SelfHelp_common_hint__ = __webpack_require__(35);














var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }

















var history = __WEBPACK_IMPORTED_MODULE_22_history_createHashHistory___default()();
var FormItem = __WEBPACK_IMPORTED_MODULE_12_antd_lib_form___default.a.Item;
var Option = __WEBPACK_IMPORTED_MODULE_10_antd_lib_select___default.a.Option;
var basicUrl = "/zzbd";
var commonUrl = '/zzbdCommon';

var formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 }
};

var Size = (_dec = __WEBPACK_IMPORTED_MODULE_12_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(Size, _React$Component);

    function Size(props) {
        _classCallCheck(this, Size);

        var _this = _possibleConstructorReturn(this, (Size.__proto__ || __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_prototype_of___default()(Size)).call(this, props));

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_26__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.getDmkMc = function (dmbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])(basicUrl + "/getDmkMc", "GET", { dmbz: dmbz }).then(function (res) {
                if (res) {
                    if (res.data) {
                        if (dmbz === "YXWZ_JXXM") {
                            _this.setState({ cmmc: res.data });
                        } else if (dmbz === "YXWZ_FZCM") {
                            _this.setState({ fzmc: res.data });
                        }
                    }
                }
            });
        };

        _this.getMrxm = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])(basicUrl + "/getMrxm", "GET").then(function (res) {
                if (res) {
                    if (res.data == null) {
                        return;
                    } else {
                        _this.setState({
                            mrxm: res.data
                        });
                    }
                }
            });
        };

        _this.handleSubmit = function (e) {

            e.preventDefault();
            _this.props.form.validateFieldsAndScroll(function (err, values) {
                if (err) {
                    return;
                }

                var sUrl = '/saveJxfzData';
                if (_this.state.update) {
                    sUrl = '/updateJxfzData';
                }
                //修改 可编辑状态，并可以update数据
                if (!_this.state.editable) {
                    _this.setState({ update: true, editable: true });
                    return;
                }
                var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHCore__["b" /* getLoginUser */])().userId;
                var zzbdhjid = _this.getUrlParams("pkid");
                var params = { xsid: xsid, zzbdhjid: zzbdhjid, formData: values };
                //请求保存或修改数据
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])(basicUrl + sUrl, 'POST', params).then(function (res) {
                    if (res) {
                        if (res.data == '1') {
                            __WEBPACK_IMPORTED_MODULE_19_antd_lib_index__["message"].success('信息保存成功！');
                            _this.reloadMenu();
                            _this.getFzpo();
                        } else {
                            __WEBPACK_IMPORTED_MODULE_19_antd_lib_index__["message"].error('信息保存失败，请重试！');
                        }
                    }
                });
            });
        };

        _this.getUrlParams = function (param) {
            return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD003',
            hjmc: '',
            data: [{
                key: '1',
                size: 'XS',
                man: '160 / 80A',
                woman: '150 / 78A'
            }, {
                key: '2',
                size: 'S',
                man: '165 / 80A',
                woman: '155 / 82A'
            }, {
                key: '3',
                size: 'M',
                man: '170 / 84A',
                woman: '160 / 86A'
            }, {
                key: '4',
                size: 'L',
                man: '175 / 88A',
                woman: '165 / 90A'
            }, {
                key: '5',
                size: 'XL',
                man: '180 / 92A',
                woman: '170 / 94A'
            }, {
                key: '6',
                size: 'XXL',
                man: '185 / 96A',
                woman: '172 / 98A'
            }, {
                key: '7',
                size: 'XXXL',
                man: '190 / 100A',
                woman: '175 / 102A'
            }],
            editable: true,
            update: false,
            initPOvalue: {
                nd: '',
                xsid: '',
                fzcm: '',
                xm: '',
                sg: '',
                tz: '',
                bz: ''
            },
            cmmc: {},
            fzmc: {},
            xmmc: '',
            fzcmmc: '',
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            mrxm: ''
        };
        return _this;
    }

    //渲染前获取信息


    _createClass(Size, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.queryQztjAndYlhj();
            this.getFzpo();
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getDmkMc("YXWZ_JXXM");
            this.getDmkMc("YXWZ_FZCM");
            this.getMrxm();
        }

        //查询前置条件和依赖环节

    }, {
        key: 'getFzpo',
        value: function getFzpo() {
            var _this2 = this;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHCore__["b" /* getLoginUser */])().userId; //todo
            var xmmc = '';
            var fzcmmc = '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])(basicUrl + "/getFzpoByXsidAndNd", "GET", { xsid: xsid }).then(function (res) {
                if (res) {
                    if (res.data) {

                        _this2.setState({ initPOvalue: res.data, editable: false });

                        _this2.state.cmmc.map(function (initItem) {
                            if (initItem.DM === res.data.xm) {
                                xmmc = initItem.MC;
                            }
                        });
                        _this2.state.fzmc.map(function (initItem) {
                            if (initItem.DM === res.data.fzcm) {
                                fzcmmc = initItem.MC;
                            }
                        });
                        _this2.setState({ xmmc: xmmc, fzcmmc: fzcmmc });
                    }
                }
            });
        }

        //获取下拉列表value对应的名称


        //加载默认鞋码


        //保存和修改


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var getFieldDecorator = this.props.form.getFieldDecorator;
            var _state = this.state,
                data = _state.data,
                editable = _state.editable,
                initPOvalue = _state.initPOvalue,
                xmmc = _state.xmmc,
                fzcmmc = _state.fzcmmc,
                mrxm = _state.mrxm;

            var columns = [{
                title: '尺码',
                dataIndex: 'size',
                key: 'size',
                render: function render(text) {
                    return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'span',
                        { className: 'text-bold' },
                        text
                    );
                }
            }, {
                title: '身高/胸围',
                children: [{
                    title: '男款',
                    dataIndex: 'man',
                    key: 'man',
                    render: function render(text) {
                        return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            { className: 'text-blue' },
                            text
                        );
                    }
                }, {
                    title: '女款',
                    dataIndex: 'woman',
                    key: 'woman',
                    render: function render(text) {
                        return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            { className: 'text-info-red' },
                            text
                        );
                    }
                }]
            }];

            return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230'
                        /*  active={2}*/
                        , mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjmc, extra: false }),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_12_antd_lib_form___default.a,
                                { onSubmit: this.handleSubmit },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'div',
                                    { className: 'p-sw' },
                                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                                        { align: 'start', wrap: 'wrap' },
                                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u8EAB\u9AD8'
                                                }),
                                                getFieldDecorator('sg', {
                                                    initialValue: initPOvalue.sg,
                                                    rules: [{
                                                        required: true,
                                                        message: '请填写身高'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number___default.a, { placeholder: '\u8BF7\u586B\u5199\u8EAB\u9AD8',
                                                    min: 0,
                                                    max: 300,
                                                    disabled: !editable }) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.sg,
                                                    ' '
                                                )),
                                                '\xA0\xA0',
                                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    '  CM '
                                                )
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u4F53\u91CD'
                                                }),
                                                getFieldDecorator('tz', {
                                                    initialValue: initPOvalue.tz,
                                                    rules: [{
                                                        required: true,
                                                        message: '请填写体重'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input_number___default.a, { placeholder: '\u8BF7\u586B\u5199\u4F53\u91CD',
                                                    min: 0,
                                                    max: 500, disabled: !editable }) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.tz
                                                )),
                                                '\xA0\xA0',
                                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    '  KG '
                                                )
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u978B\u7801'
                                                }),
                                                getFieldDecorator('xm', {
                                                    initialValue: initPOvalue.xm ? initPOvalue.xm : mrxm ? mrxm : '',
                                                    rules: [{
                                                        required: true,
                                                        message: '请选择鞋码'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_common_NHSelect__["a" /* default */], { sign: "dmk_yxwz_jxxm" }) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    xmmc
                                                ))
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__pages_SelfHelp_common_hint__["a" /* default */], null),
                                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,
                                            {
                                                type: 'primary',
                                                htmlType: 'submit'
                                            },
                                            editable ? '保存' : '修改'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                )
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__common__["a" /* default */], { hjmc: "军训服装尺码", key: 'GD003', mkbz: 'GD003', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return Size;
}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component)) || _class);


/***/ }),

/***/ 1116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SszyChannel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_spin_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_spin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input_number_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input_number__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_json_stringify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_checkbox_style__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_checkbox__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_axios__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_SelfHelp_sszychannel_view__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__pages_SelfHelp_common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_common_NHFormItem__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_common_NHModal__ = __webpack_require__(106);
































var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }












var Dragger = __WEBPACK_IMPORTED_MODULE_30_antd_lib_upload___default.a.Dragger;








var history = __WEBPACK_IMPORTED_MODULE_41_history_createHashHistory___default()();
var TextArea = __WEBPACK_IMPORTED_MODULE_28_antd_lib_input___default.a.TextArea;

var FormItem = __WEBPACK_IMPORTED_MODULE_26_antd_lib_form___default.a.Item;
var CheckboxGroup = __WEBPACK_IMPORTED_MODULE_24_antd_lib_checkbox___default.a.Group;
var formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 }
};

var SszyChannel = (_dec = __WEBPACK_IMPORTED_MODULE_26_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(SszyChannel, _React$Component);

    function SszyChannel(props) {
        _classCallCheck(this, SszyChannel);

        var _this = _possibleConstructorReturn(this, (SszyChannel.__proto__ || __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_object_get_prototype_of___default()(SszyChannel)).call(this, props));

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_39__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_45__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.loadLstdBlyy = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_39__utils_NHFetch__["a" /* default */])('/proData/selectDataList', 'get', 'sign=dmk_YXXT_LSTD_BLYY').then(function (res) {
                if (res) {
                    var col = [];
                    res.data.map(function (item) {
                        col.push(__WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_21_antd_lib_col___default.a,
                            { span: 6 },
                            __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_24_antd_lib_checkbox___default.a,
                                { value: item.VALUE },
                                item.LABEL
                            )
                        ));
                    });
                    var html = __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_19_antd_lib_row___default.a,
                        null,
                        col
                    );
                    _this.setState({ checkGroup: html });
                }
            });
        };

        _this.loadLstdInfo = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_39__utils_NHFetch__["a" /* default */])('/lstd/getLstdInfoByXsid', 'GET').then(function (resData) {
                if (resData && resData.data) {
                    _this.setState({ data: resData.data });
                    var fileList = [];
                    if (resData.data && resData.data['fj']) {
                        resData.data['fj'].map(function (elem, index) {
                            //格式化对于附件取值
                            var file = {
                                uid: elem.fjid,
                                name: elem.fjmc,
                                response: {
                                    data: {
                                        ssbh: elem.fjid,
                                        fjmc: elem.fjmc
                                    }
                                },
                                status: 'done'
                            };
                            fileList.push(file);
                        });
                    }
                    _this.setState({ fileList: fileList });
                    _this.props.form.setFieldsValue({ fj: { fileList: _this.state.fileList } });
                } else {
                    _this.setState({ data: {} });
                    _this.setState({ fileList: [] });
                    _this.props.form.resetFields();
                }
            });
        };

        _this.getBase64 = function (img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        };

        _this.handlePreview = function (file) {
            var isImage = /^image\/.*$/i.test(file.type);
            if (isImage) {
                if (file) {
                    _this.getBase64(file, function (imageUrl) {
                        _this.setState({
                            previewImage: imageUrl,
                            previewVisible: true
                        });
                    });
                } else {
                    _this.setState({
                        previewImage: file.url || file.thumbUrl,
                        previewVisible: true
                    });
                }
            } else if (file && file['response'] && file['response']['data']) {
                //其他情况
                var _isImage = true;
                var fjmc = file['response']['data']['fjmc'];
                var ssbh = file['response']['data']['ssbh'];
                if (!_this.setJudge(fjmc, _this.state.judgeImgList)) {
                    _isImage = false;
                }

                if (_isImage) {
                    _this.showPreview('anonymity/docrepo/download/file?attachmentId=' + ssbh);
                } else {
                    window.open('anonymity/docrepo/download/file?attachmentId=' + ssbh);
                }
            }
        };

        _this.showPreview = function (url) {
            _this.setState({
                previewImage: url,
                previewVisible: true
            });
        };

        _this.handleCancel = function () {
            return _this.setState({ previewVisible: false });
        };

        _this.handleSubmit = function (e) {

            _this.setState({ loading: true });
            e.preventDefault();
            var zzbdhjid = _this.getQueryString('pkid');
            _this.props.form.validateFieldsAndScroll(function (err, values) {
                if (err) {
                    _this.setState({ loading: false });
                    return false;
                }
                var fj = values['fj'];

                var isEmpty = false;
                if (fj) {
                    if (fj['fileList'] && fj['fileList'].length > 0) {
                        isEmpty = false;
                    } else {
                        isEmpty = true;
                    }
                } else {
                    isEmpty = true;
                }

                if (isEmpty) {
                    _this.props.form.setFields({
                        fj: {
                            value: undefined
                            // errors:[new Error('请上传材料证明')],
                        }
                    });
                    _this.setState({ loading: false });
                    // return false;
                }
                var size = null;
                var file = null;
                var fileList = null;
                var fjlist = [];

                if (fj) {
                    size = fj['fileList'].length;
                    file = fj['fileList'].filter(function (file) {
                        if (file.status === 'error') {
                            return false;
                        }
                        return true;
                    });
                    if (file.length != size) {
                        _this.props.form.setFields({
                            fj: {
                                value: fj,
                                errors: [new Error('材料上传出错，请重新上传.')]
                            }
                        });
                        _this.setState({ loading: false });
                        return false;
                    }
                    fileList = fj['fileList'];
                    for (var i = 0; i < fileList.length; i++) {
                        var fjid = fileList[i].response.data.ssbh;
                        var fjmc = fileList[i].name;
                        fjlist.push({
                            fjid: fjid,
                            fjmc: fjmc
                        });
                    }
                }

                var sqsmFlag = false;
                var msg = '';
                var blyy = values['blyy'];
                var sqsm = values['sqsm'];
                var dkyh = values['dkyh'];
                var hzjym = values['hzjym'];
                var pkid = values['pkid'];
                blyy.map(function (item) {
                    if (item == '99') {
                        if (typeof sqsm == "undefined" || sqsm.trim().length == 0) {
                            sqsmFlag = true;
                            msg = "其它原因，请填写申请理由";
                        }
                    }
                });

                if (dkyh == '01') {
                    if (typeof hzjym == "undefined" || hzjym.trim().length != 6) {
                        sqsmFlag = true;
                        msg = "国家开发银行贷款，请填写6位数回执校验码";
                    }
                }
                if (sqsmFlag) {
                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error(msg);
                    return;
                }

                var blje = values['blje'];
                var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHCore__["b" /* getLoginUser */])().userId;
                var params = {
                    fj: fjlist,
                    blyy: blyy,
                    blje: blje,
                    sqsm: sqsm,
                    hzjym: hzjym,
                    dkyh: dkyh,
                    xsid: xsid,
                    zzbdhjid: zzbdhjid,
                    pkid: pkid
                };
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_48__components_common_NHModal__["b" /* NHConfirm */])("绿色通道办理之后无法取消办理,请确认是否办理！", function () {
                    if (!pkid) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_39__utils_NHFetch__["a" /* default */])('/lstd/insertofsszy', "POST", params).then(function (res) {
                            if (res) {
                                if (res.data === -1) {
                                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("学费标准未下发，暂时无法办理绿色通道！");
                                } else if (res.data == null) {
                                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("缴费系统接口调用失败！请重试！");
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.success("绿色通道申请保存成功。");
                                }
                                _this.loadLstdInfo();
                                _this.reloadMenu();
                            }
                            _this.setState({ loading: false });
                        }).catch(function (res) {
                            _this.setState({ loading: false });
                            return res;
                        });
                    } else {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_39__utils_NHFetch__["a" /* default */])('/lstd/updateofsszy', "POST", params).then(function (res) {
                            if (res) {
                                if (res.data === -1) {
                                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("学费标准未确认，暂时无法办理绿色通道！");
                                } else if (res.data == null) {
                                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("缴费系统接口调用失败！请重试！");
                                } else if (res.data && res.data > 0) {
                                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.success("绿色通道申请保存成功。");
                                }
                                _this.loadLstdInfo();
                                _this.reloadMenu();
                            } else {
                                __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.warning("绿色通道申请保存失败，请重试。");
                            }
                            _this.setState({ loading: false });
                        }).catch(function (res) {
                            _this.setState({ loading: false });
                            return res;
                        });
                    }
                }, "warn");
            });
        };

        _this.handleChange = function (_ref) {
            var fileList = _ref.fileList;

            var count = 0;
            fileList.map(function (elem) {
                if (elem && elem['status'] && elem['status'] === 'uploading') {
                    _this.setState({ uploading: true });
                    return;
                } else if (elem && elem['status']) {
                    count++;
                }
            });
            if (count > 0) {
                _this.setState({ uploading: false });
            }
        };

        _this.setJudge = function (name, map) {
            var flag = false;
            map.map(function (item) {
                if (name.indexOf(item) !== -1) {
                    flag = true;
                }
            });
            return flag;
        };

        _this.beforeUpload = function (file) {
            if (!(_this.setJudge(file.name, _this.state.judgeImgList) || _this.setJudge(file.name, _this.state.judgeFileList))) {
                __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error('不能上传该格式文件');
                return false;
            } else {
                return true;
            }
        };

        _this.remove = function (ssbh) {
            var url = 'api/docrepo/attachment/sourceId/delete?souerceId=' + ssbh;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_39__utils_NHFetch__["a" /* default */])(url, "POST").then(function (res) {
                if (res.data && res.data > 0) {
                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.success('已删除材料.');
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD010',
            hjmc: '',
            uploading: false,
            loading: false,
            previewVisible: false,
            fileList: [],
            checkGroup: [], //绿色通道办理原因
            data: {}, //绿色通道申请信息
            nextUrl: '',
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            sqlyFlag: false, //申请理由flag
            jymFlag: false, //6位数回执校验码flag
            judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'], //可以导入的图片格式
            judgeFileList: ['.pdf', '.PDF', '.doc', '.DOC', '.zip', '.ZIP', '.txt', '.TXT', '.xls', '.XLS', '.rar', '.RAR'] //可以导入的非图片格式
        };
        return _this;
    }

    _createClass(SszyChannel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.queryQztjAndYlhj();
            this.loadLstdInfo();
            this.loadLstdBlyy();
        }

        //查询前置条件和依赖环节


        //读取学生的绿色通道信息


        // 转化base64


        // 点击文件链接或预览图标时的回调


        // 关闭图片弹窗


        // 提交


        //判断文件类型是否正常  name：文件名称  map：类型范围数组  true正常


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var form = this.props.form;
            var getFieldDecorator = this.props.form.getFieldDecorator;
            var _state = this.state,
                previewImage = _state.previewImage,
                previewVisible = _state.previewVisible,
                jymFlag = _state.jymFlag,
                sqlyFlag = _state.sqlyFlag;

            var props = {
                name: 'file',
                action: 'anonymity/docrepo/upload',
                data: { uuid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__utils_NHCore__["c" /* createUuid */])(), type: '1' },

                onRemove: function onRemove(file) {
                    _this2.setState(function (_ref2) {
                        var fileList = _ref2.fileList;

                        var index = fileList.indexOf(file);
                        var newFileList = fileList.slice();
                        newFileList.splice(index, 1);
                        _this2.props.form.setFieldsValue({ fj: { fileList: newFileList } });
                        return {
                            fileList: newFileList
                        };
                    }, function () {
                        if (file.response && file.response.data && file.response.data.ssbh) {
                            _this2.remove(file.response.data.ssbh);
                        }
                    });
                },
                beforeUpload: function beforeUpload(file) {
                    if (!_this2.beforeUpload(file)) {
                        return false;
                    }
                    _this2.setState(function (_ref3) {
                        var fileList = _ref3.fileList;
                        return {
                            fileList: [].concat(_toConsumableArray(fileList), [file])
                        };
                    });
                    return true;
                },
                onChange: function onChange(file) {
                    _this2.handleChange(file);
                },
                onPreview: this.handlePreview,
                fileList: this.state.fileList
            };

            var edit = false;
            var data = this.state.data;
            if (__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_json_stringify___default()(data) == "{}") {
                edit = true;
            } else if (data && data['shzt'] === '9') {
                edit = true;
            }
            return __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                'div',
                { style: { position: 'relative' } },
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_34__components__["a" /* Flex */],
                        { className: 'w1180 mt-20', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__pages_Assembly_siderMenu__["a" /* default */], {
                            ref: "siderMenu",
                            setMenuList: this.setMenuList,
                            title: '\u81EA\u52A9\u62A5\u5230',
                            mkbz: this.state.mkbz
                            /*     active={4}*/
                            , menuType: '\u81EA\u52A9\u62A5\u5230' }),
                        __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_34__components__["a" /* Flex */].Item,
                            { className: 'page_con_r ' },
                            __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__pages_Assembly_Breadcrumb__["a" /* default */], {
                                noLine: true,
                                list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                            }),
                            __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                                'div',
                                { className: 'box' },
                                __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_46__pages_SelfHelp_common_hint__["a" /* default */], null),
                                edit ? __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_26_antd_lib_form___default.a,
                                    { onSubmit: this.handleSubmit },
                                    __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u4FE1\u606F', extra: false }),
                                    __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                                        'div',
                                        { className: 'p-sw' },
                                        __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                                            'div',
                                            { style: { display: 'none' } },
                                            __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_47__components_common_NHFormItem__["a" /* default */],
                                                { id: 'pkid', initialValue: data['pkid'], form: form },
                                                __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_input___default.a, null)
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                                            'div',
                                            { style: { marginLeft: "30px" } },
                                            __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_47__components_common_NHFormItem__["a" /* default */],
                                                { id: 'blyy', initialValue: data['blyydm'], form: form, formItemLayout: { labelCol: { span: 4 }, wrapperCol: { span: 16 } }, label: '\u529E\u7406\u539F\u56E0' },
                                                __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                                                    CheckboxGroup,
                                                    { style: { width: '100%' } },
                                                    this.state.checkGroup
                                                )
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item', style: { marginLeft: '7%' } },
                                            __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_47__components_common_NHFormItem__["a" /* default */],
                                                { id: 'sqsm', initialValue: data['sqsm'], form: form, formItemLayout: formItemLayout, label: '\u7533\u8BF7\u7406\u7531' },
                                                __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(TextArea, { maxLength: 50, placeholder: '\u8BF7\u586B\u5199\u7533\u8BF7\u7406\u7531' })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_47__components_common_NHFormItem__["a" /* default */],
                                                { id: 'blje', initialValue: data['blje'], form: form, formItemLayout: formItemLayout, label: '\u8D37\u6B3E\u91D1\u989D' },
                                                __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_input_number___default.a, { style: { width: '100%' }, min: 0, max: 99999999, precision: '0', placeholder: '\u8BF7\u586B\u5199\u8D37\u6B3E\u91D1\u989D\uFF08\u5143\uFF09' })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_47__components_common_NHFormItem__["a" /* default */],
                                                { id: 'dkyh', initialValue: data['dkyh'], form: form, formItemLayout: formItemLayout, label: '\u8D37\u6B3E\u94F6\u884C' },
                                                __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__components_common_NHSelect__["a" /* default */], { sign: "dmk_yxwz_dkyh", onChange: function onChange(v) {} })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_47__components_common_NHFormItem__["a" /* default */],
                                                { id: 'hzjym', initialValue: data['hzjym'], form: form, formItemLayout: formItemLayout, label: '\u56DE\u6267\u6821\u9A8C\u7801' },
                                                __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_input___default.a, { maxLength: 6, placeholder: '6\u4F4D\u6570\u56DE\u6267\u6821\u9A8C\u7801' })
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u6750\u6599', extra: false }),
                                    __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                                        'div',
                                        { className: 'p-sw' },
                                        __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item', style: { marginLeft: '7%' } },
                                            __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u6750\u6599\u8BC1\u660E'
                                                }),
                                                getFieldDecorator('fj', {
                                                    rules: [{
                                                        required: false,
                                                        message: '请上传材料证明'
                                                    }]
                                                })(__WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                                                    Dragger,
                                                    props,
                                                    __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                                                        'p',
                                                        { className: 'ant-upload-drag-icon' },
                                                        __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_icon___default.a, { type: 'inbox' })
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_spin___default.a, { spinning: this.state.uploading }),
                                                    __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                                                        'p',
                                                        { className: 'ant-upload-text font-14' },
                                                        '\u70B9\u51FB\u6B64\u5904\u6216\u62D6\u62FD\u6587\u4EF6\u5230\u6B64'
                                                    )
                                                ))
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_button___default.a,
                                            { type: 'primary', htmlType: 'submit' },
                                            '\u4FDD\u5B58'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_44__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__pages_SelfHelp_sszychannel_view__["a" /* default */], { reloadMenu: this.reloadMenu, nextUrl: this.state.nextUrl, loadLstdInfo: this.loadLstdInfo, search: this.state.search, showPreview: this.showPreview, setJudge: this.setJudge, data: this.state.data, judgeImgList: this.state.judgeImgList })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal___default.a,
                        {
                            visible: previewVisible,
                            footer: null,
                            onCancel: this.handleCancel
                        },
                        __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement('img', {
                            alt: 'example',
                            style: { width: '100%' },
                            src: previewImage
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_spin___default.a, { style: { position: 'absolute', top: '300px', left: '60%' }, spinning: this.state.loading }),
                    ' '
                ) : __WEBPACK_IMPORTED_MODULE_31_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__pages_SelfHelp_common__["a" /* default */], { hjmc: "绿色通道申请", key: "GD010", mkbz: 'GD010', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return SszyChannel;
}(__WEBPACK_IMPORTED_MODULE_31_react___default.a.Component)) || _class);


/***/ }),

/***/ 1117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return View; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);













var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }








var TextArea = __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a.TextArea;

var basicUrl = "/zzbd";

var shztList = {
    '-1': '审核不通过',
    '0': '未审核',
    '1': '审核通过',
    '2': '已办理',
    '9': '驳回'
};

var View = function (_React$Component) {
    _inherits(View, _React$Component);

    function View(props) {
        _classCallCheck(this, View);

        var _this = _possibleConstructorReturn(this, (View.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(View)).call(this, props));

        _this.getDmkMc = function (dmbz) {
            var data = _this.props.data;

            var dkyhmc = _this.state.dkyhmc;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHFetch__["a" /* default */])(basicUrl + "/getDmkMc", "GET", _defineProperty({ dmbz: dmbz }, 'dmbz', dmbz)).then(function (res) {
                if (res) {
                    if (res.data) {
                        if (dmbz === "YXWZ_DKYH") {
                            res.data.map(function (initItem) {
                                if (initItem.DM === data.dkyh) {
                                    dkyhmc = initItem.MC;
                                }
                            });
                            _this.setState({ dkyhmc: dkyhmc });
                        }
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.cancel = function (lstdid, shzt) {

            if (shzt !== '0') {
                __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.warning('该申请已经审核，不能取消');
                return;
            }

            var pkid = _this.getQueryString("pkid");

            var params = {
                zzbdhjid: pkid,
                pkid: lstdid
            };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHFetch__["a" /* default */])("/lstd/deleteByParamsofsszy", "POST", params).then(function (res) {
                if (res && res.data) {
                    __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.success("取消成功");
                    _this.props.loadLstdInfo();
                    _this.props.reloadMenu();
                } else {
                    __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.warning("取消异常");
                }
            });
        };

        _this.handlePreview = function (fjmc, fjid) {
            var isImage = true;
            if (!_this.props.setJudge(fjmc, _this.props.judgeImgList)) {
                isImage = false;
            }

            if (isImage) {
                _this.props.showPreview('anonymity/docrepo/download/file?attachmentId=' + fjid);
            } else {
                window.open('anonymity/docrepo/download/file?attachmentId=' + fjid);
            }
        };

        _this.state = {
            dkyhmc: '',
            nextUrl: _this.props.nextUrl,
            search: _this.props.search
        };
        return _this;
    }

    _createClass(View, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.getDmkMc("YXWZ_DKYH");
        }

        //获取下拉列表value对应的名称


        // 点击文件链接或预览图标时的回调

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var data = this.props.data;
            var dkyhmc = this.state.dkyhmc;

            return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u4FE1\u606F', extra: false }),
                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '20px' } },
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', marginTop: "3px", paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u529E\u7406\u539F\u56E0\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                { span: 20 },
                                data['blyy'].map(function (elem, index) {
                                    return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                        'span',
                                        { style: {
                                                borderColor: '#1890ff',
                                                borderRadius: '5px',
                                                padding: '2px 16px',
                                                border: '1px solid rgb(24, 144, 255)',
                                                marginRight: '15px',
                                                display: 'inline-block'
                                            } },
                                        elem
                                    );
                                })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%' } },
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u7533\u8BF7\u7406\u7531\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['sqsm']
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u8D37\u6B3E\u91D1\u989D\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['blje'] ? data['blje'] : '0',
                                    '\u5143'
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u8D37\u6B3E\u94F6\u884C\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'span',
                                    null,
                                    dkyhmc
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '6\u4F4D\u6570\u56DE\u6267\u6821\u9A8C\u7801\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['hzjym']
                                )
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u6750\u6599', extra: false }),
                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%' } },
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u6750\u6599\u8BC1\u660E\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                { span: 20 },
                                data['fj'].map(function (elem, index) {
                                    return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                        'div',
                                        { style: { marginBottom: '20px' } },
                                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                            'a',
                                            { onClick: function onClick() {
                                                    _this2.handlePreview(elem['fjmc'], elem['fjid']);
                                                } },
                                            elem['fjmc']
                                        )
                                    );
                                })
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u5BA1\u6838', extra: false }),
                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u5BA1\u6838\u610F\u89C1\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['shyj']
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u5BA1\u6838\u72B6\u6001\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'span',
                                    { style: { color: '#0066FF' } },
                                    shztList[data['shzt']]
                                )
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                    'div',
                    { className: 'text-center mt-50' },
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                )
            );
        }
    }]);

    return View;
}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);



/***/ }),

/***/ 1118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SszyDorm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert_style__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_checkbox_style__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_checkbox__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__selectBox__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__selectModal__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__index_css__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_getSize__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_common_NHModal__ = __webpack_require__(106);
















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }





















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_26_history_createHashHistory___default()();
var confirm = __WEBPACK_IMPORTED_MODULE_14_antd_lib_modal___default.a.confirm;
var CheckboxGroup = __WEBPACK_IMPORTED_MODULE_12_antd_lib_checkbox___default.a.Group;

/**
 * @author weishihuai
 * @date 2018/7/6
 * @time 14:41
 * @Description: 迎新网站-自助报到-宿舍分配
 */

var SszyDorm = function (_React$Component) {
    _inherits(SszyDorm, _React$Component);

    function SszyDorm(props) {
        _classCallCheck(this, SszyDorm);

        var _this2 = _possibleConstructorReturn(this, (SszyDorm.__proto__ || __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of___default()(SszyDorm)).call(this, props));

        _this2.queryQztjAndYlhj = function (callback) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this2.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this2.getUrlParams('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this2.setState({ nonOperationalData: res.data });
                    if (kfsj && kfsj['YXSJ'] != '1') {
                        _this2.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this2.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this2.setState({ operable: false });
                    }

                    if (callback) {
                        callback(_this2.state.operable);
                    }
                }
            });
        };

        _this2.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this2.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this2.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_30__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this2.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this2.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this2.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this2.getUrlParams = function (param) {
            return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this2.getSfbzAndCwsInfo = function (xsid, xqid, xbm) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])("/gyxtUnauth/cwfp/getSfbzAndSslxInfo", 'GET', { xqid: xqid ? xqid : "" }).then(function (res) {
                if (res) {
                    var data = res.data;
                    _this2.setState({
                        cwsList: data.cwsList,
                        sfbzList: data.sfbzList,
                        xqList: data.xqList
                    });

                    //如果学生无校区信息,默认加载第一个Tab校区的宿舍信息
                    if (!xqid) {
                        _this2.setState({
                            currentXqid: data.xqList[0].XQID
                        });
                        _this2.getFjxxList({
                            cws: "",
                            sfbz: "",
                            xsid: xsid,
                            xqid: data.xqList[0].XQID,
                            xbm: xbm
                        });
                    }
                }
            });
        };

        _this2.getSszySfbzAndCwsInfo = function (xsid, xqid, xbm) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])("/gyxtUnauth/cwfp/getSszySfbzAndSslxInfo", 'GET', { xqid: xqid ? xqid : "" }).then(function (res) {
                if (res) {
                    var data = res.data;
                    _this2.setState({
                        cwsList: data.cwsList,
                        sfbzList: data.sfbzList,
                        xqList: data.xqList
                    });

                    //如果学生无校区信息,默认加载第一个Tab校区的宿舍信息
                    if (!xqid) {
                        _this2.setState({
                            currentXqid: data.xqList[0].XQID
                        });
                        _this2.getFjxxList({
                            cws: "",
                            sfbz: "",
                            xsid: xsid,
                            xqid: data.xqList[0].XQID,
                            xbm: xbm
                        });
                    }
                }
            });
        };

        _this2.getSszyFjxxList = function (param) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])("/gyxtUnauth/cwfp/getSszyYxwzSsfpFjxxList", 'GET', param).then(function (res) {
                if (res) {
                    _this2.setState({
                        fjxxList: res.data
                    });
                }
            });
        };

        _this2.getFjxxList = function (param) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])("/gyxtUnauth/cwfp/getYxwzSsfpFjxxList", 'GET', param).then(function (res) {
                if (res) {
                    _this2.setState({
                        fjxxList: res.data
                    });
                }
            });
        };

        _this2.getXsssrzYwxxByXsid = function (xsid) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/getXsssrzYwxxByXsid', 'GET', { xsid: xsid }).then(function (res) {
                if (res && res.data) {
                    _this2.setState({
                        xsssruYwxx: res.data
                    });
                }
            });
        };

        _this2.confirmCwfpxx = function (xzId) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xqid = loginUserInfo.XQID,
                xbm = loginUserInfo.XBM;

            if (!xzId) {
                __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.warning("请先选择一个床位！");
                return;
            }

            //检查该床位是否被其他学生抢占(防并发的情况下同一个床位被其他人重复选择)
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/checkCwIsPermitSelect', 'GET', { cwid: xzId, xsid: xsid }).then(function (res) {
                if (res) {
                    if (res.data === 0) {
                        __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error("抱歉，该床位已经被其他同学抢占，请选择其他床位！");
                        return;
                    } else {
                        //确认床位信息
                        _this2.cwfpSubmit(xsid, xzId, xqid, xbm);
                    }
                }
            });
        };

        _this2.cwfpSubmit = function (xsid, currentClickCwPkid, xqid, xbm) {
            var zzbdhjid = _this2.getUrlParams("pkid");
            var params = { xsid: xsid, cwid: currentClickCwPkid, zzbdhjid: zzbdhjid };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/checkCwIsAvailableSelected', 'GET', { cwid: currentClickCwPkid }).then(function (res) {
                if (res) {
                    if (res.data) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/sszyyxwzConfirmCwxx', 'POST', params).then(function (res) {
                            if (res) {
                                if (res.data) {
                                    __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.success("分配成功！");
                                    _this2.reloadMenu();
                                    _this2.setState({
                                        currentClickCwPkid: ""
                                    });

                                    _this2.getFjxxList({
                                        cws: "",
                                        sfbz: "",
                                        xsid: xsid,
                                        xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                                        xbm: xbm
                                    });

                                    _this2.getXsssrzYwxxByXsid(xsid);

                                    _this2.checkZzbdisLinked();
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error("分配失败，请稍后重试！");
                                }
                            }
                        });
                    } else {
                        __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error("抱歉，该床位未到分配时间或已过床位分配时间期限，请选择其他床位! ");
                    }
                }
            });
        };

        _this2.showConfirm = function (value, id, cwh) {
            confirm({
                title: __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    'span',
                    null,
                    '\u786E\u5B9A\u9009\u62E9',
                    value.name,
                    '\u623F\u95F4\u7684\u4E0B\u5217\u5E8A\u94FA\uFF1F'
                ),
                content: __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__selectModal__["a" /* default */], {
                    data: value,
                    id: id,
                    currentClickCwh: cwh,
                    onChange: function onChange(value) {
                        _this2.setState({
                            xzId: value.id,
                            currentClickCwPkid: value.id
                        });
                    }
                }),
                onOk: function onOk() {
                    var currentClickCwPkid = _this2.state.currentClickCwPkid;
                    //确定分配宿舍提交

                    _this2.confirmCwfpxx(currentClickCwPkid);
                },
                onCancel: function onCancel() {
                    _this2.setState({
                        currentClickCwPkid: ""
                    });
                }
            });
        };

        _this2.judeageCs = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var sfxmdm = "GD_002";
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])("/zzbdCommon/sszy/getLstdSq/" + xsid + "/" + sfxmdm, "get").then(function (res) {

                if (res && res.data === 1) {
                    //不欠费 已交清  不能取消办理
                    __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error("宿舍费已交,不能取消办理");
                } else if (res && res.data === 0) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/yxwzSyzxcs', 'GET', { xsid: xsid }).then(function (res1) {
                        if (res1 && res1.data <= 0) {
                            //this.handleCancelListener();
                            __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error("您已没有可选机会,不能取消办理");
                        } else if (res1 && res1.data > 0) {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__components_common_NHModal__["b" /* NHConfirm */])("确定取消？取消后还剩" + res1.data + "次可选", function () {
                                _this2.handleCancelListener();
                            }, "warn");
                        }
                    });
                }
            });
        };

        _this2.checkIsPay = function (cb) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var sfxmdm = "GD_002";
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])('/openapi/jfxt/checkIsPay', 'get', { sfxmdm: sfxmdm }).then(function (res) {
                if (res) {
                    if (!res.data) {
                        if (cb) {
                            cb();
                        }
                    } else {
                        __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error("学生已经缴费，不能办理！");
                    }
                }
            });
        };

        _this2.handleCancelListener = function () {
            _this2.setState({
                cancelLoading: true
            });
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xqid = loginUserInfo.XQID,
                xbm = loginUserInfo.XBM;

            var zzbdhjid = _this2.getUrlParams("pkid");
            var params = { xsid: xsid, zzbdhjid: zzbdhjid };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/sszycancelBlSsfp', 'POST', params).then(function (res) {
                if (res && res.data === 1) {
                    __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.success('取消办理成功！');
                    _this2.reloadMenu();
                    _this2.getFjxxList({
                        cws: "",
                        sfbz: "",
                        xsid: xsid,
                        xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                        xbm: xbm
                    });

                    _this2.checkZzbdisLinked();

                    _this2.setState({
                        xsssruYwxx: {},
                        cancelLoading: false
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error('取消办理失败，请稍后重试！');
                    _this2.setState({
                        cancelLoading: false
                    });
                }
            }).catch(function () {
                __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error("取消办理失败，请稍后重试！");
                _this2.setState({
                    cancelLoading: false
                });
            });
        };

        _this2.handleSszyAutoDistributeListener = function () {
            _this2.checkIsPay(function () {
                _this2.setState({
                    autoBlLoading: true
                });
                var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId : '';
                var loginUserInfo = _this2.state.loginUserInfo;

                var xqid = loginUserInfo.XQID,
                    xbm = loginUserInfo.XBM;
                var zzbdhjid = _this2.getUrlParams("pkid");

                if (!xsid) {
                    __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.warning("自动办理失败,请稍后重试！");
                    return;
                }

                var param = _this2.state.param;
                //自动分配宿舍

                var params = {
                    cws: param.cws || "",
                    sfbz: param.sfbz || "",
                    xsid: xsid,
                    xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                    xbm: xbm,
                    zzbdhjid: zzbdhjid
                };
                var str = "";
                if (_this2.state.sfhj) {
                    str = "SszyyxwzAutoDistributeSscwxx";
                } else {
                    str = "SszyZzyxwzAutoDistributeSscwxx";
                }

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])("/gyxtUnauth/cwfp/" + str, 'POST', params).then(function (res) {
                    if (res) {
                        if (res.data === 1) {
                            var text = "";
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/getXsssrzYwxxByXsid', 'GET', { xsid: xsid }).then(function (res) {
                                if (res && res.data) {
                                    var data = res.data;
                                    _this2.setState({
                                        xsssruYwxx: data
                                    });
                                    text = data.ldmc; //+ "-" + data.fj + "-" + data.cwh + "号床位";
                                    __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.success("自动办理成功,分配宿舍: " + text + "！");
                                    _this2.reloadMenu();
                                    _this2.getFjxxList({
                                        cws: "",
                                        sfbz: "",
                                        xsid: xsid,
                                        xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                                        xbm: xbm
                                    });

                                    _this2.getXsssrzYwxxByXsid(xsid);

                                    _this2.checkZzbdisLinked();

                                    _this2.setState({
                                        autoBlLoading: false
                                    });
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error("自动办理失败,请稍后重试！");
                                    _this2.setState({
                                        autoBlLoading: false
                                    });
                                }
                            });
                        }
                    } else {
                        __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error("自动办理失败,请稍后重试！");
                        _this2.setState({
                            autoBlLoading: false
                        });
                    }
                }).catch(function () {
                    __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error("自动办理失败,请稍后重试！");
                    _this2.setState({
                        autoBlLoading: false
                    });
                });
            });
        };

        _this2.checkZzbdisLinked = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this2.getUrlParams("pkid");

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])("/zzbdCommon/checkIsZzbdHjLinked", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res) {
                    if (res.data) {
                        _this2.setState({
                            isHjLinked: res.data
                        });
                    } else {
                        _this2.setState({
                            isHjLinked: false
                        });
                    }
                } else {
                    _this2.setState({
                        isHjLinked: false
                    });
                }
            });
        };

        _this2.autoSelectCwListener = function (value) {
            _this2.setState({
                zdrzLoading: true
            });
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xqid = loginUserInfo.XQID,
                xbm = loginUserInfo.XBM;

            var yxwzCwxxTzVOs = value.yxwzCwxxTzVOs,
                name = value.name;

            var zzbdhjid = _this2.getUrlParams("pkid");
            var availableSelectArr = [],
                availSelectCwPkId = "",
                text = "";

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(yxwzCwxxTzVOs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    availableSelectArr.push(item.xz);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (availableSelectArr.indexOf("0") === -1) {
                __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.warning("抱歉，该房间已满员，请选择其他房间！");
                return;
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(yxwzCwxxTzVOs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _item = _step2.value;

                    //床位未被选择并且未过分配期限
                    if (_item.xz === '0' && !_item.expire) {
                        availSelectCwPkId = _item.id;
                        text = name + "-" + _item.cwh;
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            if (availSelectCwPkId) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/checkCwIsPermitSelect', 'GET', { cwid: availSelectCwPkId, xsid: xsid }).then(function (res) {
                    if (res) {
                        if (res.data === 0) {
                            __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error("抱歉，该床位已经被其他同学抢占，请选择其他床位！");
                            _this2.setState({
                                zdrzLoading: false
                            });
                            return;
                        } else {
                            // 确认床位信息
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])('/gyxtUnauth/cwfp/sszyyxwzConfirmCwxx', 'POST', {
                                xsid: xsid,
                                cwid: availSelectCwPkId,
                                zzbdhjid: zzbdhjid
                            }).then(function (res) {
                                if (res) {
                                    if (res.data) {
                                        __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.success("分配成功，分配宿舍为 " + text + ", 请尽快确认办理！");
                                        _this2.reloadMenu();
                                        _this2.getFjxxList({
                                            cws: "",
                                            sfbz: "",
                                            xsid: xsid,
                                            xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                                            xbm: xbm
                                        });

                                        _this2.getXsssrzYwxxByXsid(xsid);
                                        _this2.checkZzbdisLinked();

                                        _this2.setState({
                                            zdrzLoading: false
                                        });
                                    }
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error("分配失败，请稍后重试！");
                                    _this2.setState({
                                        zdrzLoading: false
                                    });
                                }
                            });
                        }
                    }
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.warning("抱歉，未匹配到合适的床位信息,请选择其他床位！");
                _this2.setState({
                    zdrzLoading: false
                });
            }
        };

        _this2.onSfbzChangeListener = function (checkedValues) {
            // const {param, currentXqid} = this.state;
            // let xsid = getLoginUser() ? getLoginUser().userId : '';
            // const {loginUserInfo} = this.state;
            // const xbm = loginUserInfo.XBM;
            // param.sfbz = checkedValues.length > 0 ? checkedValues.join(",") : "";
            // param.xsid = xsid;
            // param.xqid = currentXqid ? currentXqid : this.state.xqList[0].XQID;
            // param.xbm = xbm;
            // this.getFjxxList(param);
        };

        _this2.onCwsChange = function (checkedValues) {
            // const {param, currentXqid} = this.state;
            // let xsid = getLoginUser() ? getLoginUser().userId : '';
            // const {loginUserInfo} = this.state;
            // const xbm = loginUserInfo.XBM;
            // param.cws = checkedValues.length > 0 ? checkedValues.join(",") : "";
            // param.xsid = xsid;
            // param.xbm = xbm;
            // param.xqid = currentXqid ? currentXqid : this.state.xqList[0].XQID;
            // this.getFjxxList(param);
        };

        _this2.tabChangeListener = function (activeKey) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xbm = loginUserInfo.XBM;
            var _this2$state$param = _this2.state.param,
                cws = _this2$state$param.cws,
                sfbz = _this2$state$param.sfbz;


            _this2.setState({
                currentXqid: activeKey
            });

            //加载房间信息
            _this2.getFjxxList({
                cws: cws || "",
                sfbz: sfbz || "",
                xsid: xsid,
                xqid: activeKey,
                xbm: xbm
            });
        };

        _this2.reloadMenu = function () {
            _this2.refs.siderMenu.reloadMenuList();
        };

        _this2.state = {
            mkbz: 'GD012',
            hjmc: '',
            xzId: '',
            _xzId: '',
            cwsList: [], //床位数
            sfbzList: [], //收费标准
            xqList: [], //校区信息
            currentXqid: "", //当前校区ID
            fjxxList: [], //房间信息
            currentClickCwPkid: "", //当前床位信息ID
            xsssruYwxx: {}, //学生宿舍入住业务信息
            isHjLinked: false, //环节是否办理状态
            param: {}, //过滤条件
            scrollHeight: 200, //默认滚动高度
            loginUserInfo: {}, //当前登录学生信息
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            autoBlLoading: false, //自动办理按钮载入状态
            cancelLoading: false, //取消办理按钮载入状态
            zdrzLoading: false, //自动入住载入状态
            sfhj: false //是否缓交
        };
        return _this2;
    }

    _createClass(SszyDorm, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var that = this;
            this.setState({ scrollHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_getSize__["a" /* default */])().windowH - 206 });
            window.onresize = function () {
                that.setState({
                    scrollHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_getSize__["a" /* default */])().windowH - 206
                });
            };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            this.queryQztjAndYlhj(function (operable) {
                if (operable) {
                    var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["b" /* getLoginUser */])().userId : '';
                    if (xsid) {
                        var _this = _this3;
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__utils_NHCore__["d" /* getLoginUserInfo */])(xsid, function (data) {
                            _this.setState({
                                loginUserInfo: data
                            }, function () {
                                var loginUserInfo = _this.state.loginUserInfo;

                                var xqid = loginUserInfo.XQID,
                                    xbm = loginUserInfo.XBM;
                                var sfxmdm = 'GD_001';
                                if (xsid) {
                                    //判读是否已申请绿色通道sszy/getLstdSq/{xsid}
                                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__["a" /* default */])("/zzbdCommon/sszy/getLstdSq/" + xsid + "/" + sfxmdm, "get").then(function (res) {
                                        if (res && res.data === 0) {
                                            //没有申请缓交
                                            //加载收费标准、床位数信息
                                            _this.getSfbzAndCwsInfo(xsid, xqid, xbm);
                                            _this.getXsssrzYwxxByXsid(xsid);

                                            //如果学生校区ID不为空,则只加载本校区宿舍信息
                                            if (xqid) {
                                                _this.setState({
                                                    currentXqid: xqid
                                                });
                                                _this.getFjxxList({
                                                    cws: "",
                                                    sfbz: "",
                                                    xsid: xsid,
                                                    xqid: xqid,
                                                    xbm: xbm
                                                });
                                            }
                                        } else if (res && res.data === 1) {
                                            //申请了缓交
                                            _this.getSszySfbzAndCwsInfo(xsid, xqid, xbm);
                                            _this.getXsssrzYwxxByXsid(xsid);
                                            //如果学生校区ID不为空,则只加载本校区宿舍信息
                                            //表明是否申请缓交
                                            _this.setState({
                                                sfhj: true
                                            });
                                            if (xqid) {
                                                _this.setState({
                                                    currentXqid: xqid
                                                });
                                                _this.getSszyFjxxList({
                                                    cws: "",
                                                    sfbz: "",
                                                    xsid: xsid,
                                                    xqid: xqid,
                                                    xbm: xbm
                                                });
                                            }
                                        }
                                    });
                                }
                                _this.checkZzbdisLinked();
                            });
                        });
                    }
                }
            });
        }

        //查询前置条件和依赖环节


        //获取url中传递的参数


        //获取收费标准、床位信息等

        // 松山职业-- 获取收费标准、床位信息等


        //松山职业----获取宿舍房间信息

        //获取宿舍房间信息


        //查询学生宿舍入住信息


        //确认床位分配


        //床位分配提交


        //选择床位弹层


        //检查是否缴费了


        //取消办理事件


        //自动办理事件--松山职业


        //检查环节是否已办理


        //自动入住事件


        //收费标准onChange事件


        //宿舍类型onChange事件


        //tab切换事件


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                xzId = _state.xzId,
                _xzId = _state._xzId,
                cwsList = _state.cwsList,
                xqList = _state.xqList,
                sfbzList = _state.sfbzList,
                fjxxList = _state.fjxxList,
                xsssruYwxx = _state.xsssruYwxx,
                isHjLinked = _state.isHjLinked,
                scrollHeight = _state.scrollHeight,
                currentXqid = _state.currentXqid,
                autoBlLoading = _state.autoBlLoading,
                cancelLoading = _state.cancelLoading,
                zdrzLoading = _state.zdrzLoading;
            //学生已选宿舍信息

            var xqmc = xsssruYwxx.xqmc,
                ldmc = xsssruYwxx.ldmc,
                fj = xsssruYwxx.fj,
                cwh = xsssruYwxx.cwh,
                ysje = xsssruYwxx.ysje;
            //用于让勾选框选中

            var chooseSfbzArr = sfbzList.map(function (v) {
                return v.value;
            });
            var chooseCwsArr = cwsList.map(function (v) {
                return v.value;
            });

            var yxssInfo = (xqmc || "") + "-" + (ldmc || ""); //+ "-" + (fj || "") + "-" + (cwh || "") + "号床";
            return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230',
                        mkbz: this.state.mkbz
                        /*   active={5}*/
                        , menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */].Item,
                        { className: 'page_con_r ' },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_titleTop__["a" /* default */],
                                {
                                    className: 'mt-20',
                                    title: this.state.hjmc,
                                    extra: false
                                },
                                !isHjLinked ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default.a,
                                    {
                                        className: 'ml-10',
                                        type: 'primary',
                                        ghost: true,
                                        loading: autoBlLoading,
                                        onClick: this.handleSszyAutoDistributeListener
                                    },
                                    '\u81EA\u52A8\u529E\u7406'
                                ) : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default.a,
                                    {
                                        className: 'ml-10',
                                        type: 'danger',
                                        ghost: true,
                                        loading: cancelLoading,
                                        onClick: this.judeageCs
                                    },
                                    '\u53D6\u6D88\u529E\u7406'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'div',
                                { className: 'p-sw' },
                                isHjLinked && __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_alert___default.a, { message: "当前选择宿舍为: " + yxssInfo, type: 'info', showIcon: true })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                'div',
                                { className: 'text-center mt-50' },
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__common__["a" /* default */], { hjmc: "自选宿舍", key: 'GD012', mkbz: 'GD012', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return SszyDorm;
}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);



/***/ }),

/***/ 1119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_tabs_style__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_plugin_react_css_modules_dist_browser_getClassName__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_plugin_react_css_modules_dist_browser_getClassName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_plugin_react_css_modules_dist_browser_getClassName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_css__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_custom_scrollbars__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_custom_scrollbars__);









var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;


var _styleModuleImportMap = {
    './index.css': {
        'tab_box': 'app__css__app-pages-SelfHelp-sszydorm-__index__tab_box',
        'tip': 'app__css__app-pages-SelfHelp-sszydorm-__index__tip',
        'item': 'app__css__app-pages-SelfHelp-sszydorm-__index__item',
        'item_con': 'app__css__app-pages-SelfHelp-sszydorm-__index__item_con',
        'round': 'app__css__app-pages-SelfHelp-sszydorm-__index__round',
        'select_box': 'app__css__app-pages-SelfHelp-sszydorm-__index__select_box',
        'select_list': 'app__css__app-pages-SelfHelp-sszydorm-__index__select_list',
        'select_item': 'app__css__app-pages-SelfHelp-sszydorm-__index__select_item',
        'select_item_b': 'app__css__app-pages-SelfHelp-sszydorm-__index__select_item_b',
        'select_item_y': 'app__css__app-pages-SelfHelp-sszydorm-__index__select_item_y',
        'item_btn_box': 'app__css__app-pages-SelfHelp-sszydorm-__index__item_btn_box',
        'item_btn': 'app__css__app-pages-SelfHelp-sszydorm-__index__item_btn',
        'modal_box': 'app__css__app-pages-SelfHelp-sszydorm-__index__modal_box',
        'modal_list': 'app__css__app-pages-SelfHelp-sszydorm-__index__modal_list'
    }
};

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }










if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var TabPane = __WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs___default.a.TabPane;

/**
 * @author weishihuai
 * @date 2018/7/6
 * @time 14:42
 * @Description: 迎新网站-自助报到-宿舍分配-宿舍床位信息
 */
var SelectBox = (_temp = _class = function (_React$Component) {
    _inherits(SelectBox, _React$Component);

    function SelectBox(props) {
        _classCallCheck(this, SelectBox);

        var _this = _possibleConstructorReturn(this, (SelectBox.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(SelectBox)).call(this, props));

        _this.getListItem = function () {
            var Data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var _this$props = _this.props,
                className = _this$props.className,
                showConfirm = _this$props.showConfirm,
                xzId = _this$props.xzId,
                onChange = _this$props.onChange,
                autoSelectCwListener = _this$props.autoSelectCwListener;

            return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_12__components__["a" /* Flex */],
                { align: 'top', wrap: 'wrap', className: 'mt-20' },
                Data.length > 0 ? Data.map(function (item, idx) {
                    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                        'div',
                        { key: idx, className: 'app__css__app-pages-SelfHelp-sszydorm-__index__item' },
                        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-sszydorm-__index__item_con' },
                            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_12__components__["a" /* Flex */],
                                { justify: 'between' },
                                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                    'span',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('span', { className: 'app__css__app-pages-SelfHelp-sszydorm-__index__round' }),
                                    item.name
                                ),
                                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                    'span',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                        'span',
                                        { className: 'text-blue' },
                                        item.yxNum
                                    ),
                                    '/',
                                    item.allNum
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_12__components__["a" /* Flex */],
                                {
                                    wrap: 'wrap',
                                    align: 'center',
                                    justify: 'center',
                                    className: 'app__css__app-pages-SelfHelp-sszydorm-__index__select_box'
                                },
                                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                    'div',
                                    { className: 'app__css__app-pages-SelfHelp-sszydorm-__index__select_list' },
                                    item.bedList[0] && item.bedList.map(function (el, index) {
                                        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                            'div',
                                            { key: index },
                                            el.map(function (cwxx, index) {
                                                return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', {
                                                    key: index,

                                                    onClick: function onClick() {
                                                        if (cwxx.xz === "0") {
                                                            showConfirm(item, cwxx.id, cwxx.cwh);
                                                            onChange(cwxx);
                                                        } else {
                                                            __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.warning('抱歉，该床铺已选择！');
                                                        }
                                                    },
                                                    className: __WEBPACK_IMPORTED_MODULE_8_babel_plugin_react_css_modules_dist_browser_getClassName___default()(__WEBPACK_IMPORTED_MODULE_11_classnames___default()('select_item', {
                                                        select_item_b: cwxx.xz === '1',
                                                        select_item_y: xzId === cwxx.id && cwxx.xz === '0' || cwxx.currentXsSelected
                                                    }), _styleModuleImportMap)
                                                });
                                            })
                                        );
                                    })
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-sszydorm-__index__item_btn_box' },
                            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                'div',
                                {
                                    className: 'app__css__app-pages-SelfHelp-sszydorm-__index__item_btn',
                                    onClick: function onClick() {
                                        return autoSelectCwListener(item);
                                    }
                                },
                                '\u81EA\u52A8\u5165\u4F4F'
                            ),
                            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                'div',
                                {
                                    className: 'app__css__app-pages-SelfHelp-sszydorm-__index__item_btn',
                                    onClick: function onClick() {
                                        return showConfirm(item);
                                    }
                                },
                                '\u9009\u62E9\u5E8A\u4F4D'
                            )
                        )
                    );
                }) : __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                        'span',
                        { style: { color: "#f00" } },
                        '\u6682\u65E0\u5339\u914D\u7684\u5BBF\u820D\u4FE1\u606F\uFF01'
                    )
                )
            );
        };

        return _this;
    }

    //床位信息


    _createClass(SelectBox, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                className = _props.className,
                Data = _props.Data,
                scrollHeight = _props.scrollHeight,
                tabChangeListener = _props.tabChangeListener,
                xqList = _props.xqList,
                currentXqid = _props.currentXqid;

            var activeKey = currentXqid || xqList[0] && xqList[0].XQID;

            return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs___default.a,
                { defaultActiveKey: '0', activeKey: activeKey, tabPosition: 'top',
                    onChange: function onChange(activeKey) {
                        return tabChangeListener(activeKey);
                    } },
                xqList.map(function (xq) {
                    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                        TabPane,
                        { tab: xq.XQMC, key: xq.XQID },
                        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_12__components__["a" /* Flex */],
                            { className: 'app__css__app-pages-SelfHelp-sszydorm-__index__tip', justify: 'center' },
                            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('img', {
                                src: __webpack_require__(281),
                                alt: ''
                            }),
                            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                'span',
                                null,
                                '\u53EF\u9009\u62E9'
                            ),
                            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('img', {
                                className: 'ml-10',
                                src: __webpack_require__(280),
                                alt: ''
                            }),
                            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                'span',
                                null,
                                '\u4E0D\u53EF\u9009'
                            ),
                            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('img', {
                                className: 'ml-10',
                                src: __webpack_require__(282),
                                alt: ''
                            }),
                            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                'span',
                                null,
                                '\u5DF2\u9009\u62E9'
                            )
                        ),
                        Data.length > 16 ? __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_14_react_custom_scrollbars__["Scrollbars"],
                            { autoHide: true,
                                style: { width: '100%', height: scrollHeight } },
                            _this2.getListItem(Data)
                        ) : _this2.getListItem(Data)
                    );
                })
            );
        }
    }]);

    return SelectBox;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component), _class.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string,
    xzId: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.any,
    showConfirm: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
    autoSelectCwListener: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
    tabChangeListener: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func
}, _class.defaultProps = {
    xzId: '',
    showConfirm: Function.prototype,
    onChange: Function.prototype,
    autoSelectCwListener: Function.prototype,
    tabChangeListener: Function.prototype
}, _temp);


/***/ }),

/***/ 1120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_plugin_react_css_modules_dist_browser_getClassName__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_plugin_react_css_modules_dist_browser_getClassName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_plugin_react_css_modules_dist_browser_getClassName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_css__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__index_css__);







var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;


var _styleModuleImportMap = {
    './index.css': {
        'tab_box': 'app__css__app-pages-SelfHelp-sszydorm-__index__tab_box',
        'tip': 'app__css__app-pages-SelfHelp-sszydorm-__index__tip',
        'item': 'app__css__app-pages-SelfHelp-sszydorm-__index__item',
        'item_con': 'app__css__app-pages-SelfHelp-sszydorm-__index__item_con',
        'round': 'app__css__app-pages-SelfHelp-sszydorm-__index__round',
        'select_box': 'app__css__app-pages-SelfHelp-sszydorm-__index__select_box',
        'select_list': 'app__css__app-pages-SelfHelp-sszydorm-__index__select_list',
        'select_item': 'app__css__app-pages-SelfHelp-sszydorm-__index__select_item',
        'select_item_b': 'app__css__app-pages-SelfHelp-sszydorm-__index__select_item_b',
        'select_item_y': 'app__css__app-pages-SelfHelp-sszydorm-__index__select_item_y',
        'item_btn_box': 'app__css__app-pages-SelfHelp-sszydorm-__index__item_btn_box',
        'item_btn': 'app__css__app-pages-SelfHelp-sszydorm-__index__item_btn',
        'modal_box': 'app__css__app-pages-SelfHelp-sszydorm-__index__modal_box',
        'modal_list': 'app__css__app-pages-SelfHelp-sszydorm-__index__modal_list'
    }
};

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }









/**
 * @author weishihuai
 * @date 2018/7/6
 * @time 14:41
 * @Description: 迎新网站-自助报到-宿舍分配-选择床位弹层
 */

if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var SelectModal = (_temp = _class = function (_React$Component) {
    _inherits(SelectModal, _React$Component);

    function SelectModal(props) {
        _classCallCheck(this, SelectModal);

        var _this = _possibleConstructorReturn(this, (SelectModal.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(SelectModal)).call(this, props));

        var id = props.id;

        _this.state = {
            xzId: id,
            currentClickCwh: "" //当前床位号
        };
        return _this;
    }

    _createClass(SelectModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var currentClickCwh = this.props.currentClickCwh;

            this.setState({
                currentClickCwh: currentClickCwh
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                xzId = _state.xzId,
                currentClickCwh = _state.currentClickCwh;
            var _props = this.props,
                className = _props.className,
                data = _props.data,
                onChange = _props.onChange;


            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('text-center', className) },
                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                    'div',
                    { className: 'text-blue' },
                    currentClickCwh ? currentClickCwh > 9 ? currentClickCwh + "床" : "0" + currentClickCwh + "床" : "请选择床铺"
                ),
                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                    'div',
                    null,
                    data.ysje + "元/年"
                ),
                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10__components__["a" /* Flex */],
                    { wrap: 'wrap', align: 'center', justify: 'center' },
                    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                        'div',
                        { className: 'app__css__app-pages-SelfHelp-sszydorm-__index__modal_box' },
                        data.bedList[0] && data.bedList.map(function (el, i) {
                            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                                'div',
                                { key: i },
                                el.map(function (cwxx, index) {
                                    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                                        'div',
                                        {
                                            className: 'app__css__app-pages-SelfHelp-sszydorm-__index__modal_list',
                                            onClick: function onClick() {
                                                if (cwxx.xz === "0") {
                                                    _this2.setState({
                                                        xzId: cwxx.id,
                                                        currentClickCwh: cwxx.cwh
                                                    });
                                                    onChange(cwxx);
                                                } else {
                                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.warning('抱歉，该床铺已选择！');
                                                }
                                            },
                                            key: index
                                        },
                                        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
                                            className: __WEBPACK_IMPORTED_MODULE_6_babel_plugin_react_css_modules_dist_browser_getClassName___default()(__WEBPACK_IMPORTED_MODULE_9_classnames___default()('select_item', {
                                                select_item_b: cwxx.xz === '1',
                                                select_item_y: xzId === cwxx.id && cwxx.xz === '0' || cwxx.currentXsSelected
                                            }), _styleModuleImportMap)
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                                            'div',
                                            null,
                                            cwxx.cwh > 9 ? cwxx.cwh + "床" : "0" + cwxx.cwh + "床"
                                        )
                                    );
                                })
                            );
                        })
                    )
                )
            );
        }
    }]);

    return SelectModal;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _class.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
    currentClickCwh: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
}, _class.defaultProps = {
    id: '',
    onChange: Function.prototype,
    currentClickCwh: ""
}, _temp);


/***/ }),

/***/ 1121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SszyssfPay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__order_js__ = __webpack_require__(1122);













var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }


















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_22_history_createHashHistory___default()();

var SszyssfPay = function (_React$Component) {
    _inherits(SszyssfPay, _React$Component);

    function SszyssfPay(props) {
        _classCallCheck(this, SszyssfPay);

        var _this = _possibleConstructorReturn(this, (SszyssfPay.__proto__ || __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default()(SszyssfPay)).call(this, props));

        _this.getSfxxList = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])('/jfxtUnauth/yxwzjfxx/getJfxxList', 'GET').then(function (resData) {
                if (resData && resData.data) {
                    var data = resData.data.filter(function (item) {
                        return item.SFXMDM == 'GD_002';
                    }); //只显示宿舍费用
                    data.map(function (v, i) {
                        v.XH = i + 1;
                    });
                    _this.setState({ data: data }, function () {
                        if (data.length === 0) {
                            //收费（学费）数据未导进去,不能自动办理环节，网上支付按钮也要屏蔽掉
                            _this.setState({
                                flage: false
                            });
                        } else {
                            var list = _this.state.data.filter(function (item) {
                                return item.QFJE > 0 ? true : false;
                            });
                            if (list.length <= 0) {
                                _this.setState({ flage: false });
                                _this.handleConfirmSubmit(); //进入这里说明没有欠费信息，所以直接保存环节数据
                            }
                        }
                    });
                }
            });
        };

        _this.showModal = function () {
            _this.loadZxjfInfo();
            _this.setState({
                visible: true
            });
        };

        _this.handleOk = function (e) {

            _this.setState({
                visible: false
            }, function () {
                _this.getSfxxList();
            });
        };

        _this.handleCancel = function (e) {

            _this.setState({
                visible: false
            }, function () {
                _this.getSfxxList();
            });
        };

        _this.loadZxjfInfo = function () {

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])('/jfxtUnauth/yxwzjfxx/getCurrDdxx', 'GET').then(function (res) {
                if (res && res.data) {
                    _this.setState({
                        zxjfInfo: res.data
                    });
                }
            });
        };

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    } else if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    } else if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    } else {
                        _this.getSfxxList();
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_24__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.onSave = function () {
            _this.setState({ loading: true });
            setTimeout(function () {
                _this.setState({
                    loading: false
                });
            }, 1000);
        };

        _this.checkIsZzbdHjLinked = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this.getQueryString('pkid');

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])("/zzbdCommon/checkIsZzbdHjLinked", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res) {
                    if (res.data) {
                        _this.setState({
                            isHjLinked: res.data
                        });
                    } else {
                        _this.setState({
                            isHjLinked: false
                        });
                    }
                } else {
                    _this.setState({
                        isHjLinked: false
                    });
                }
            });
        };

        _this.handleConfirmSubmit = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this.getQueryString('pkid');
            var params = { xsid: xsid, zzbdhjid: zzbdhjid };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])('/zzbdCommon/commonSaveLinkTransactionStatus', 'POST', params).then(function (res) {
                if (res) {
                    if (res.data === 1) {
                        _this.checkIsZzbdHjLinked();
                        _this.reloadMenu();
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.error('确认失败，请稍后重试！');
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD013',
            hjmc: '',
            data: [],
            loading: false,
            pageData: { //分页设置的是三个参数
                total: 0,
                pageSize: 10, //当前页默认多少条数据
                page: 1
            },
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            isHjLinked: false, //环节是否办理标志
            zxjfInfo: {}, //在线缴费相关信息
            hjje: 0, //缓交金额
            jfxxHz: {}, //缴费信息汇总
            visible: false,
            flage: true //是否存在需要缴费的项目
        };
        return _this;
    }

    _createClass(SszyssfPay, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.checkIsZzbdHjLinked();
            this.queryQztjAndYlhj();
            //this.getSfxxList();//列表显示
        }
        //获取在线缴费相关信息


        //查询前置条件和依赖环节


        //检查该环节是否已经办理


        //确认知悉


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                loading = _state.loading,
                data = _state.data,
                isHjLinked = _state.isHjLinked,
                zxjfInfo = _state.zxjfInfo;

            var columns = [{
                title: '序号',
                dataIndex: 'XH'
            }, {
                title: '收费项目',
                dataIndex: 'SFXMMC'
            }, {
                title: '应收金额（元）',
                dataIndex: 'YSJE'
            }, {
                title: '实收金额（元）',
                dataIndex: 'SSJE',
                render: function render(text, record) {
                    return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                        'span',
                        { className: 'text-primary' },
                        text
                    );
                }
            }, {
                title: '缓交金额（元）',
                dataIndex: 'JMJE',
                render: function render(text, record) {
                    return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                        'span',
                        { className: 'text-primary' },
                        text
                    );
                }
            }, {
                title: '欠费金额（元）',
                dataIndex: 'QFJE',
                render: function render(text, record) {
                    if (text > 0) {
                        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            'span',
                            { className: 'text-info-red' },
                            text
                        );
                    } else {
                        return text;
                    }
                }
            }];

            return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                'div',
                { className: 'app__css__app-pages-SelfHelp-sszyssfpay-__index__page_pay' },
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_14__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230'
                        /*active={7}*/
                        , mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_14__components__["a" /* Flex */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjmc, extra: false }),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                'div',
                                { className: 'p-sw mt-20' },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_table___default.a, {
                                    bordered: true,
                                    size: 'middle',
                                    pagination: false,
                                    columns: columns,
                                    dataSource: data
                                }),
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'div',
                                    { className: 'text-center mt-50' },
                                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        this.state.flage == true ? __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default.a,
                                            { onClick: function onClick() {
                                                    return _this2.showModal();
                                                },
                                                type: 'primary',
                                                htmlType: 'submit' },
                                            '\u7F51\u4E0A\u652F\u4ED8'
                                        ) : null,
                                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                )
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__common__["a" /* default */], { hjmc: "网上缴费", key: 'GD013', mkbz: 'GD013', nonOperationalData: this.state.nonOperationalData }),
                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal___default.a,
                    {
                        title: '\u652F\u4ED8\u8BE6\u60C5\u4FE1\u606F',
                        visible: this.state.visible,
                        onOk: this.handleOk,
                        onCancel: this.handleCancel,
                        footer: [__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default.a,
                            { key: 'submit', type: 'primary', onClick: this.handleOk },
                            '\u5173\u95ED'
                        )] },
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__order_js__["a" /* default */], { zxjfInfo: zxjfInfo, ddh: zxjfInfo.DDH, sfxmInfo: data })
                )
            );
        }
    }]);

    return SszyssfPay;
}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);



/***/ }),

/***/ 1122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Order; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_list_style__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_list__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__paydisc_index_js__ = __webpack_require__(1124);















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }







var Item = __WEBPACK_IMPORTED_MODULE_13_antd_lib_list___default.a.Item;
var Brief = Item.Brief;
var confirm = __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.confirm;

var Order = function (_React$Component) {
  _inherits(Order, _React$Component);

  function Order(props) {
    _classCallCheck(this, Order);

    var _this = _possibleConstructorReturn(this, (Order.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(Order)).call(this, props));

    _this.getTotalNumber = function () {
      //let list = this.props.sfxmInfo;
      var list = _this.props.sfxmInfo.filter(function (item) {
        return item.QFJE > 0 ? true : false;
      });
      var yjje = 0.0; //应缴金额
      var ysje = 0.0; //已收金额
      var sjje = _this.state.jfje; //实缴金额
      var hjje = _this.props.hjje ? _this.props.hjje : 0.0;
      list.map(function (item) {
        yjje += item.YSJE;
        ysje += item.SSJE;
        // sjje+=item.JE;
        //  hjje+=(item.QFJE-item.JE);//缓交金额，还需要加上这次学生修改的没交的金额
        return item;
      });
      return {
        yjje: yjje,
        ysje: ysje,
        sjje: sjje - hjje,
        hjje: hjje
      };
    };

    _this.getDdxx = function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_NHFetch__["a" /* default */])("/openapi/jfxt/sszy/addOrder", "POST", {}).then(function (res) {
        if (res) {
          var msg = res.data;
          _this.setState({
            ddxx: msg
          }, function () {
            if (msg.code === "1") {
              //返回信息时正常的，此时跳转到支付界面
              //this.handleConfirmSubmit();
              _this.toPayView();
            } else if (msg.code === "-1") {
              __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error("调用建行查询方法失败，请重新请求");
            } else if (msg.code === "2") {
              __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.info("已支付成功，无需重复支付");
            } else {
              //返回信息有误
              __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error(msg.message);
            }
            //this.toPayView();
          });
        }
      });
    };

    _this.addOrder = function () {
      //1、获取支付项目
      var list = _this.props.sfxmInfo.filter(function (item) {
        return item.QFJE > 0 ? true : false;
      });
      if (list.length <= 0) {
        __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error("支付项目为空，不能执行支付操作");
        return;
      }
      var jfxm = [];
      //je(交易金额),ysje(应缴金额),ssje(已缴金额)
      list.map(function (item) {
        jfxm.push({
          sfxmid: item.SFXMID,
          sfxmdm: item.SFXMDM,
          sfxmmc: item.SFXMMC,
          je: item.YSJE,
          ysje: item.YSJE,
          ssje: item.SSJE
        });
        return item;
      });
      var map = _this.getTotalNumber();

      //2、生成订单
      var params = {
        jfxm: jfxm,
        sfxyjldd: _this.props.zxjfInfo.SFXYJLDD,
        jyje: map.sjje,
        yjje: map.yjje,
        ysje: map.ysje,
        hjje: map.hjje
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_NHFetch__["a" /* default */])("/openapi/jfxt/sszy/addOrder", "POST", params).then(function (res) {
        if (res) {
          var msg = res.data;
          _this.setState({
            ddxx: msg
          });
          if (msg.code === "1") {
            //返回信息时正常的，此时跳转到支付界面
            //this.handleConfirmSubmit();
            _this.toPayView();
          } else if (msg.code === "-1") {
            __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error("调用建行查询方法失败，请重新请求");
          } else if (msg.code === "2") {
            __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.info("已支付成功，无需重复支付");
          } else {
            //返回信息有误
            __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error(msg.message);
          }
        }
      });
    };

    _this.getQueryString = function (name) {
      return decodeURIComponent((new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(location.href) || [, ""])[1].replace(/\+/g, "%20")) || null;
    };

    _this.handleConfirmSubmit = function () {
      var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHCore__["b" /* getLoginUser */])().userId : "";
      var zzbdhjid = _this.getQueryString("pkid");
      var params = { xsid: xsid, zzbdhjid: zzbdhjid };
      // this.toPayView();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_NHFetch__["a" /* default */])("/zzbdCommon/commonSaveLinkTransactionStatus", "POST", params).then(function (res) {
        if (res) {
          if (res.data === 1) {
            _this.toPayView();
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error("确认失败，请稍后重试！");
        }
      });
    };

    _this.getJfje = function () {
      var list = _this.props.sfxmInfo.filter(function (item) {
        return item.QFJE > 0 ? true : false;
      });
      var jfje = 0.0; // 缴费金额
      list.map(function (item) {
        jfje += item.QFJE;
      });
      jfje = Math.round(jfje * Math.pow(10, 2)) / Math.pow(10, 2);
      _this.setState({
        jfje: jfje
      });
    };

    _this.handleBackFunc = function () {
      if (_this.props.backFunc) {
        _this.props.backFunc();
      }
    };

    _this.handleSubmit = function () {
      //如果有提示信息，则需要先显示提示信息
      var $this = _this;
      if (_this.props.zxjfInfo.ZFTS) {
        confirm({
          title: "提示",
          content: _this.props.zxjfInfo.ZFTS,
          onOk: function onOk() {
            $this.setState({
              noallowpay: true
            }, function () {
              $this.toRedirertPayView();
            });
          },
          onCancel: function onCancel() {}
        });
      } else {
        _this.setState({
          noallowpay: true
        }, function () {
          _this.toRedirertPayView();
        });
      }
    };

    _this.toRedirertPayView = function () {
      //不存在正在进行的订单的时候就要先添加一个订单
      // if (this.props.ddh === null) {
      //   this.addOrder();
      // } else {
      //   //此时说明存在正在进行的订单，就把订单的信息查询出来
      //   this.getDdxx();

      // }
      //都改成调addOrder()方法，原因是，虽然数据库有处于交易中的数据但是这条数据可能是交易失败了建行没回写，这边需要作废原来的并且重新生成订单
      //重新生成订单的话需要有参数传入到后台的方法里边去，而页面方法getDdxx()方法没有传参，所以都换成addOrder()
      _this.addOrder();
    };

    _this.toPayView = function () {
      var msg = _this.state.ddxx;
      var type = _this.props.zxjfInfo.DJFSID;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__paydisc_index_js__["a" /* handle */])(type, msg.ddh, msg.csxx, msg.xsxx, msg.jfxm, msg.jyje, msg.yjje, msg.ysje, msg.hjje);
    };

    _this.handleSyncBtn = function () {
      var msg = _this.state.ddxx;
      var type = _this.props.zxjfInfo.DJFSID;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__paydisc_index_js__["b" /* syscBtnFunc */])(type, msg.ddh);
    };

    _this.state = {
      ddxx: {}, //订单信息
      jfje: 0, //本次缴费总金额
      list: [],
      noallowpay: false //支付按钮禁用
    };
    return _this;
  }

  _createClass(Order, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      //进来后先计算缴费金额
      this.getJfje();
    }
    //获取订单信息

    //添加一个订单

    //确认知悉


    //计算要缴费的金额


    //点击支付按钮触发的事件


    //进行支付跳转前的判断

    //跳转到支付界面


    //绑定同步按钮

  }, {
    key: "render",
    value: function render() {
      var noallowpay = this.state.noallowpay;
      var ddxx = this.state.ddxx;
      var zxjfInfo = this.props.zxjfInfo;
      var list = this.props.sfxmInfo.filter(function (item) {
        return item.QFJE > 0 ? true : false;
      });
      var columns = [{
        title: "收费项目",
        dataIndex: "SFXMMC"
      }, {
        title: "支付金额（元）",
        dataIndex: "QFJE"
      }];
      return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
        "div",
        null,
        this.state.jfje != 0 ? __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
          "p",
          null,
          __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
            "span",
            { style: { fontSize: "15px", fontWeight: "bold" } },
            "\u4EA4\u6613\u91D1\u989D:",
            this.state.jfje,
            "\u5143"
          )
        ) : null,
        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table___default.a, {
          bordered: true,
          size: "middle",
          pagination: false,
          columns: columns,
          dataSource: list
        }),
        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
          "p",
          { style: { color: "red" } },
          "\u7279\u522B\u8BF4\u660E\uFF1A\u4E3A\u4E86\u89E3\u51B3\u94F6\u884C\u5361\u4EA4\u6613\u9650\u989D\u7B49\u539F\u56E0\uFF0C\u7F51\u4E0A\u7F34\u8D39\u652F\u6301\u591A\u6B21\u7F34\u8D39\uFF1B\u8BF7\u52FF\u6076\u610F\u591A\u6B21\u5C0F\u989D\u7F34\u8D39\uFF08\u59820.1\u5143\uFF09\uFF0C\u4EE5\u514D\u4F60\u7684\u94F6\u884C\u5361\u68C0\u6D4B\u6709\u98CE\u9669\u88AB\u7981\u6B62\u4EA4\u6613"
        ),
        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
          {
            style: {
              float: "left",
              backgroundColor: "rgb(1, 176, 241)",
              color: "#fff"
            },
            onClick: this.handleSubmit,
            disabled: noallowpay
          },
          "\u8FDB\u5165\u652F\u4ED8\u754C\u9762"
        )
      );
    }
  }]);

  return Order;
}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);



/***/ }),

/***/ 1123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handle; });
/* unused harmony export syscBtnFunc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_NHVirtualForm_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_NHFetch__ = __webpack_require__(7);




var md5 = __webpack_require__(119);

/**
 * 网上支付办理接口
 * 请自行在此处判断需要的参数是否符合要求，例如判断身份证件号是否为空，Toast.hide()，可以使用改方法关闭准备跳转支付界面提示
 *
 * @param {*} ddh 订单号
 * @param {*} csxx 配置参数信息，包含：pczflj(PC端支付路径),ydzflj(移动端支付路径)，zfts(支付提示),所有的自定义配置的参数信息
 * @param {*} xsxx 学生信息，包含：XSID(学生ID),XH(学号),XM(姓名),XBM(性别码),SFZJH(身份证件号),RXNF(入学年份),CSRQ(出生日期)
 * @param {*} jfxm 缴费信息，LIst<Map<String,Object>>对象,包含：sfxmid(收费项目ID),sfxmdm(收费项目代码),sfxmmc(收费项目名称)，je(金额)
 * @param {*} jyje 交易金额
 * @param {*} yjje 应缴金额
 * @param {*} ysje 已缴金额
 * @param {*} hjje 缓缴金额
 */
var handle = function handle(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje) {
  var params = csxx;
  params.orderId = ddh;
  params.jfje = jyje;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_NHFetch__["a" /* default */])('/openapi/jfxt/getjsyhUrl', 'POST', params).then(function (res) {
    if (res) {
      var msg = res.data;
      window.open(msg);
    }
  });
};

/**
 * 点击同步按钮触发时的操作
 * @param {*} ddh 订单号
 */
var syscBtnFunc = function syscBtnFunc(ddh) {};

/***/ }),

/***/ 1124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return syscBtnFunc; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nxmzzyjsxy_js__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gdsxzyjsxy_js__ = __webpack_require__(1123);



/**
 * 网上支付办理接口
 * @param {*} ddh 订单号
 * @param {*} csxx 配置参数信息，包含：pczflj(PC端支付路径),ydzflj(移动端支付路径)，zfts(支付提示),所有的自定义配置的参数信息
 * @param {*} xsxx 学生信息，包含：XSID(学生ID),XH(学号),XM(姓名),XBM(性别码),SFZJH(身份证件号),RXNF(入学年份),CSRQ(出生日期)
 * @param {*} jfxm 缴费信息，LIst<Map<String,Object>>对象,包含：sfxmid(收费项目ID),sfxmdm(收费项目代码),sfxmmc(收费项目名称)，je(金额)
 * @param {*} jyje 交易金额
 * @param {*} yjje 应缴金额
 * @param {*} ysje 已缴金额
 * @param {*} hjje 缓缴金额
 */
var handle = function handle(type, ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje) {
  if (type === 'nxmzzyjsxy') {
    //宁夏民族职业技术学院
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__nxmzzyjsxy_js__["a" /* handle */])(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje);
  } else if (type === 'gdsxzyjsxy') {
    //广东松山技术学院
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__gdsxzyjsxy_js__["a" /* handle */])(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje);
  }
};

/**
 * 点击同步按钮触发时的操作
 * @param {*} ddh 订单号
 */
var syscBtnFunc = function syscBtnFunc(type, ddh) {
  if (type === 'nxmzzyjsxy') {
    //宁夏民族职业技术学院
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__nxmzzyjsxy_js__["b" /* syscBtnFunc */])(ddh);
  }
};

/***/ }),

/***/ 1125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return syscBtnFunc; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_NHVirtualForm_js__ = __webpack_require__(114);





var md5 = __webpack_require__(119);

/**
 * 网上支付办理接口
 * 请自行在此处判断需要的参数是否符合要求，例如判断身份证件号是否为空，Toast.hide()，可以使用改方法关闭准备跳转支付界面提示
 *
 * @param {*} ddh 订单号
 * @param {*} csxx 配置参数信息，包含：pczflj(PC端支付路径),ydzflj(移动端支付路径)，zfts(支付提示),所有的自定义配置的参数信息
 * @param {*} xsxx 学生信息，包含：XSID(学生ID),XH(学号),XM(姓名),XBM(性别码),SFZJH(身份证件号),RXNF(入学年份),CSRQ(出生日期)
 * @param {*} jfxm 缴费信息，LIst<Map<String,Object>>对象,包含：sfxmid(收费项目ID),sfxmdm(收费项目代码),sfxmmc(收费项目名称)，je(金额)
 * @param {*} jyje 交易金额
 * @param {*} yjje 应缴金额
 * @param {*} ysje 已缴金额
 * @param {*} hjje 缓缴金额
 */
var handle = function handle(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje) {
  var url = csxx.ydzflj; //跳转URL
  var sfzjh = xsxx.SFZJH; //身份证件号
  var partnerid = csxx.partnerid; //合作者ID
  var sign = csxx.sign; //签名
  var projectid = csxx.projectid; //缴费项目ID
  var istimelimit = csxx.istimelimit; //是否限时用户登陆缴费平台时间
  var timelimit = csxx.timelimit; //缴费平台限制时间
  var ydurl = csxx.ydurl; //移动端限时结束返回地址
  var errormsg = csxx.errormsg; //页面提示信息
  var ydreturnurl = csxx.ydreturnurl; //移动端缴费成功页面
  if (!url) {

    __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.warning("支付路径不能为空，请联系管理员！");
    return;
  }
  if (!sfzjh) {

    __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.warning("身份证件号不能为空，请联系管理员！");
    return;
  }
  if (!partnerid || !sign) {
    __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.warning("参数不能为空，请联系管理员！");
    return;
  }
  sign = md5(sfzjh + getNowFormatDate() + sign);
  //虚拟表单提交
  var map = {
    idserial: sfzjh,
    partnerid: partnerid,
    sign: sign,
    projectid: projectid,
    istimelimit: istimelimit,
    timelimit: timelimit,
    url: ydurl,
    errormsg: errormsg,
    returnurl: ydreturnurl
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_NHVirtualForm_js__["a" /* NHVirtualForm */])(url, "_self", map);
};

/**
 * 点击同步按钮触发时的操作
 * @param {*} ddh 订单号
 */
var syscBtnFunc = function syscBtnFunc(ddh) {};

//获取当前日志，格式yyyyMMdd
function getNowFormatDate() {
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var hours = date.getHours(); //获取系统时，
  var minutes = date.getMinutes(); //分
  var seconds = date.getSeconds(); //秒
  var strDate = date.getDate();

  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  if (hours >= 0 && hours <= 9) {
    hours = "0" + hours;
  }
  if (minutes >= 0 && minutes <= 9) {
    minutes = "0" + minutes;
  }
  if (seconds >= 0 && seconds <= 9) {
    seconds = "0" + seconds;
  }
  var currentdate = year + month + strDate;
  return currentdate;
}

/***/ }),

/***/ 1126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SszyxfPay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__order_js__ = __webpack_require__(1127);













var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }


















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_22_history_createHashHistory___default()();

var SszyxfPay = function (_React$Component) {
    _inherits(SszyxfPay, _React$Component);

    function SszyxfPay(props) {
        _classCallCheck(this, SszyxfPay);

        var _this = _possibleConstructorReturn(this, (SszyxfPay.__proto__ || __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default()(SszyxfPay)).call(this, props));

        _this.getSfxxList = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])('/jfxtUnauth/yxwzjfxx/getJfxxList', 'GET').then(function (resData) {
                if (resData && resData.data) {
                    var data = resData.data.filter(function (item) {
                        return item.SFXMDM == 'GD_001' || item.SFXMDM == 'GD_003';
                    }); //只显示学费和教材费的
                    data.map(function (v, i) {
                        v.XH = i + 1;
                    });
                    _this.setState({ data: data }, function () {
                        if (data.length === 0) {
                            //收费（学费和教材费）数据未导进去,不能自动办理环节，网上支付按钮也要屏蔽掉
                            _this.setState({
                                flage: false
                            });
                        } else {
                            var list = _this.state.data.filter(function (item) {
                                return item.QFJE > 0 ? true : false;
                            });
                            if (list.length <= 0) {
                                _this.setState({ flage: false });
                                _this.handleConfirmSubmit(); //进入这里说明没有欠费信息，所以直接保存环节数据
                            }
                        }
                    });
                }
            });
        };

        _this.showModal = function () {
            _this.loadZxjfInfo();
            _this.setState({
                visible: true
            });
        };

        _this.handleOk = function (e) {

            _this.setState({
                visible: false
            }, function () {
                _this.getSfxxList();
            });
        };

        _this.handleCancel = function (e) {
            _this.setState({
                visible: false
            }, function () {
                _this.getSfxxList();
            });
        };

        _this.loadZxjfInfo = function () {

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])('/jfxtUnauth/yxwzjfxx/getCurrDdxx', 'GET').then(function (res) {
                if (res && res.data) {
                    _this.setState({
                        zxjfInfo: res.data
                    });
                }
            });
        };

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    } else if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    } else if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    } else {
                        _this.getSfxxList();
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_24__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.onSave = function () {
            _this.setState({ loading: true });
            setTimeout(function () {
                _this.setState({
                    loading: false
                });
            }, 1000);
        };

        _this.checkIsZzbdHjLinked = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this.getQueryString('pkid');

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])("/zzbdCommon/checkIsZzbdHjLinked", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res) {
                    if (res.data) {
                        _this.setState({
                            isHjLinked: res.data
                        });
                    } else {
                        _this.setState({
                            isHjLinked: false
                        });
                    }
                } else {
                    _this.setState({
                        isHjLinked: false
                    });
                }
            });
        };

        _this.handleConfirmSubmit = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this.getQueryString('pkid');
            var params = { xsid: xsid, zzbdhjid: zzbdhjid };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])('/zzbdCommon/commonSaveLinkTransactionStatus', 'POST', params).then(function (res) {
                if (res) {
                    if (res.data === 1) {
                        _this.checkIsZzbdHjLinked();
                        _this.reloadMenu();
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.error('确认失败，请稍后重试！');
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD011',
            hjmc: '',
            data: [],
            loading: false,
            pageData: { //分页设置的是三个参数
                total: 0,
                pageSize: 10, //当前页默认多少条数据
                page: 1
            },
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            isHjLinked: false, //环节是否办理标志
            zxjfInfo: {}, //在线缴费相关信息
            hjje: 0, //缓交金额
            jfxxHz: {}, //缴费信息汇总
            visible: false,
            flage: true //是否存在需要缴费的项目
        };
        return _this;
    }

    _createClass(SszyxfPay, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.checkIsZzbdHjLinked();
            this.queryQztjAndYlhj();
            //this.getSfxxList();//列表显示
        }
        //获取在线缴费相关信息


        //查询前置条件和依赖环节


        //检查该环节是否已经办理


        //确认知悉


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                loading = _state.loading,
                data = _state.data,
                isHjLinked = _state.isHjLinked,
                zxjfInfo = _state.zxjfInfo;

            var columns = [{
                title: '序号',
                dataIndex: 'XH'
            }, {
                title: '收费项目',
                dataIndex: 'SFXMMC'
            }, {
                title: '应收金额（元）',
                dataIndex: 'YSJE'
            }, {
                title: '实收金额（元）',
                dataIndex: 'SSJE',
                render: function render(text, record) {
                    return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                        'span',
                        { className: 'text-primary' },
                        text
                    );
                }
            }, {
                title: '缓交金额（元）',
                dataIndex: 'JMJE',
                render: function render(text, record) {
                    return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                        'span',
                        { className: 'text-primary' },
                        text
                    );
                }
            }, {
                title: '欠费金额（元）',
                dataIndex: 'QFJE',
                render: function render(text, record) {
                    if (text > 0) {
                        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            'span',
                            { className: 'text-info-red' },
                            text
                        );
                    } else {
                        return text;
                    }
                }
            }];

            return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                'div',
                { className: 'app__css__app-pages-SelfHelp-sszyxfpay-__index__page_pay' },
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_14__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230'
                        /*active={7}*/
                        , mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_14__components__["a" /* Flex */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjmc, extra: false }),
                            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                'div',
                                { className: 'p-sw mt-20' },
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_table___default.a, {
                                    bordered: true,
                                    size: 'middle',
                                    pagination: false,
                                    columns: columns,
                                    dataSource: data
                                }),
                                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                    'div',
                                    { className: 'text-center mt-50' },
                                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        this.state.flage == true ? __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default.a,
                                            { onClick: function onClick() {
                                                    return _this2.showModal();
                                                },
                                                type: 'primary',
                                                htmlType: 'submit' },
                                            '\u7F51\u4E0A\u652F\u4ED8'
                                        ) : null,
                                        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                )
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__common__["a" /* default */], { hjmc: "网上缴费", key: 'GD011', mkbz: 'GD011', nonOperationalData: this.state.nonOperationalData }),
                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal___default.a,
                    {
                        title: '\u652F\u4ED8\u8BE6\u60C5\u4FE1\u606F',
                        visible: this.state.visible,
                        onOk: this.handleOk,
                        onCancel: this.handleCancel,
                        footer: [__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default.a,
                            { key: 'submit', type: 'primary', onClick: this.handleOk },
                            '\u5173\u95ED'
                        )] },
                    __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__order_js__["a" /* default */], { zxjfInfo: zxjfInfo, ddh: zxjfInfo.DDH, sfxmInfo: data })
                )
            );
        }
    }]);

    return SszyxfPay;
}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);



/***/ }),

/***/ 1127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Order; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_list_style__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_list__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__paydisc_index_js__ = __webpack_require__(1129);















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }







var Item = __WEBPACK_IMPORTED_MODULE_13_antd_lib_list___default.a.Item;
var Brief = Item.Brief;
var confirm = __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.confirm;

var Order = function (_React$Component) {
  _inherits(Order, _React$Component);

  function Order(props) {
    _classCallCheck(this, Order);

    var _this = _possibleConstructorReturn(this, (Order.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(Order)).call(this, props));

    _this.getTotalNumber = function () {
      //let list = this.props.sfxmInfo;
      var list = _this.props.sfxmInfo.filter(function (item) {
        return item.QFJE > 0 ? true : false;
      });
      var yjje = 0.0; //应缴金额
      var ysje = 0.0; //已收金额
      var sjje = _this.state.jfje; //实缴金额
      var hjje = _this.props.hjje ? _this.props.hjje : 0.0;
      list.map(function (item) {
        yjje += item.YSJE;
        ysje += item.SSJE;
        // sjje+=item.JE;
        //  hjje+=(item.QFJE-item.JE);//缓交金额，还需要加上这次学生修改的没交的金额
        return item;
      });
      return {
        yjje: yjje,
        ysje: ysje,
        sjje: sjje - hjje,
        hjje: hjje
      };
    };

    _this.getDdxx = function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_NHFetch__["a" /* default */])("/openapi/jfxt/sszy/addOrder", "POST", {}).then(function (res) {
        if (res) {
          var msg = res.data;
          _this.setState({
            ddxx: msg
          }, function () {
            if (msg.code === "1") {
              //返回信息时正常的，此时跳转到支付界面
              //this.handleConfirmSubmit();
              _this.toPayView();
            } else if (msg.code === "-1") {
              __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error("调用建行查询方法失败，请重新请求");
            } else if (msg.code === "2") {
              __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.info("已支付成功，无需重复支付");
            } else {
              //返回信息有误
              __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error(msg.message);
            }
            //this.toPayView();
          });
        }
      });
    };

    _this.addOrder = function () {
      //1、获取支付项目
      var list = _this.props.sfxmInfo.filter(function (item) {
        return item.QFJE > 0 ? true : false;
      });
      if (list.length <= 0) {
        __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error("支付项目为空，不能执行支付操作");
        return;
      }
      var jfxm = [];
      //je(交易金额),ysje(应缴金额),ssje(已缴金额)
      list.map(function (item) {
        jfxm.push({
          sfxmid: item.SFXMID,
          sfxmdm: item.SFXMDM,
          sfxmmc: item.SFXMMC,
          je: item.YSJE,
          ysje: item.YSJE,
          ssje: item.SSJE
        });
        return item;
      });
      var map = _this.getTotalNumber();

      //2、生成订单
      var params = {
        jfxm: jfxm,
        sfxyjldd: _this.props.zxjfInfo.SFXYJLDD,
        jyje: map.sjje, //缴费金额
        yjje: map.yjje, //收总额
        ysje: map.ysje, //已收总额
        hjje: map.hjje //缓交
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_NHFetch__["a" /* default */])("/openapi/jfxt/sszy/addOrder", "POST", params).then(function (res) {
        if (res) {
          var msg = res.data;
          _this.setState({
            ddxx: msg
          });
          if (msg.code === "1") {
            //返回信息时正常的，此时跳转到支付界面
            //this.handleConfirmSubmit();
            _this.toPayView();
          } else if (msg.code === "-1") {
            __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error("调用建行查询方法失败，请重新请求");
          } else if (msg.code === "2") {
            __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.info("已支付成功，无需重复支付");
          } else {
            //返回信息有误
            __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error(msg.message);
          }
        }
      });
    };

    _this.getQueryString = function (name) {
      return decodeURIComponent((new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(location.href) || [, ""])[1].replace(/\+/g, "%20")) || null;
    };

    _this.handleConfirmSubmit = function () {
      var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHCore__["b" /* getLoginUser */])().userId : "";
      var zzbdhjid = _this.getQueryString("pkid");
      var params = { xsid: xsid, zzbdhjid: zzbdhjid };
      //this.toPayView();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_NHFetch__["a" /* default */])("/zzbdCommon/commonSaveLinkTransactionStatus", "POST", params).then(function (res) {
        if (res) {
          if (res.data === 1) {
            _this.toPayView();
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error("确认失败，请稍后重试！");
        }
      });
    };

    _this.getJfje = function () {
      var list = _this.props.sfxmInfo.filter(function (item) {
        return item.QFJE > 0 ? true : false;
      });
      var jfje = 0.0; // 缴费金额
      list.map(function (item) {
        jfje += item.QFJE;
      });
      jfje = Math.round(jfje * Math.pow(10, 2)) / Math.pow(10, 2);
      _this.setState({
        jfje: jfje
      });
    };

    _this.handleBackFunc = function () {
      if (_this.props.backFunc) {
        _this.props.backFunc();
      }
    };

    _this.handleSubmit = function () {
      //如果有提示信息，则需要先显示提示信息
      var $this = _this;
      if (_this.props.zxjfInfo.ZFTS) {
        confirm({
          title: "提示",
          content: _this.props.zxjfInfo.ZFTS,
          onOk: function onOk() {
            $this.setState({
              noallowpay: true
            }, function () {
              $this.toRedirertPayView();
            });
          },
          onCancel: function onCancel() {}
        });
      } else {
        _this.setState({
          noallowpay: true
        }, function () {
          _this.toRedirertPayView();
        });
      }
    };

    _this.toRedirertPayView = function () {
      //不存在正在进行的订单的时候就要先添加一个订单
      // if (this.props.ddh === null) {
      //   this.addOrder();
      // } else {
      //   //此时说明存在正在进行的订单，就把订单的信息查询出来
      //   this.getDdxx();

      // }
      //都改成调addOrder()方法，原因是，虽然数据库有处于交易中的数据但是这条数据可能是交易失败了建行没回写，这边需要作废原来的并且重新生成订单
      //重新生成订单的话需要有参数传入到后台的方法里边去，而页面方法getDdxx()方法没有传参，所以都换成addOrder()
      _this.addOrder();
    };

    _this.toPayView = function () {
      var msg = _this.state.ddxx;
      var type = _this.props.zxjfInfo.DJFSID;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__paydisc_index_js__["a" /* handle */])(type, msg.ddh, msg.csxx, msg.xsxx, msg.jfxm, msg.jyje, msg.yjje, msg.ysje, msg.hjje);
    };

    _this.handleSyncBtn = function () {
      var msg = _this.state.ddxx;
      var type = _this.props.zxjfInfo.DJFSID;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__paydisc_index_js__["b" /* syscBtnFunc */])(type, msg.ddh);
    };

    _this.state = {
      ddxx: {}, //订单信息
      jfje: 0, //本次缴费总金额
      list: [],
      noallowpay: false //支付按钮禁用
    };
    return _this;
  }

  _createClass(Order, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      //进来后先计算缴费金额
      this.getJfje();
    }
    //获取订单信息

    //添加一个订单

    //确认知悉


    //计算要缴费的金额


    //点击支付按钮触发的事件


    //进行支付跳转前的判断

    //跳转到支付界面


    //绑定同步按钮

  }, {
    key: "render",
    value: function render() {
      var noallowpay = this.state.noallowpay;
      var ddxx = this.state.ddxx;
      var zxjfInfo = this.props.zxjfInfo;
      var list = this.props.sfxmInfo.filter(function (item) {
        return item.QFJE > 0 ? true : false;
      });
      var columns = [{
        title: "收费项目",
        dataIndex: "SFXMMC"
      }, {
        title: "支付金额（元）",
        dataIndex: "QFJE"
      }];
      return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
        "div",
        null,
        this.state.jfje != 0 ? __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
          "p",
          null,
          __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
            "span",
            { style: { fontSize: "15px", fontWeight: "bold" } },
            "\u4EA4\u6613\u91D1\u989D:",
            this.state.jfje,
            "\u5143"
          )
        ) : null,
        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table___default.a, {
          bordered: true,
          size: "middle",
          pagination: false,
          columns: columns,
          dataSource: list
        }),
        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
          "p",
          { style: { color: "red" } },
          "\u7279\u522B\u8BF4\u660E\uFF1A\u4E3A\u4E86\u89E3\u51B3\u94F6\u884C\u5361\u4EA4\u6613\u9650\u989D\u7B49\u539F\u56E0\uFF0C\u7F51\u4E0A\u7F34\u8D39\u652F\u6301\u591A\u6B21\u7F34\u8D39\uFF1B\u8BF7\u52FF\u6076\u610F\u591A\u6B21\u5C0F\u989D\u7F34\u8D39\uFF08\u59820.1\u5143\uFF09\uFF0C\u4EE5\u514D\u4F60\u7684\u94F6\u884C\u5361\u68C0\u6D4B\u6709\u98CE\u9669\u88AB\u7981\u6B62\u4EA4\u6613"
        ),
        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
          {
            style: {
              float: "left",
              backgroundColor: "rgb(1, 176, 241)",
              color: "#fff"
            },
            onClick: this.handleSubmit,
            disabled: noallowpay
          },
          "\u8FDB\u5165\u652F\u4ED8\u754C\u9762"
        )
      );
    }
  }]);

  return Order;
}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);



/***/ }),

/***/ 1128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handle; });
/* unused harmony export syscBtnFunc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_NHVirtualForm_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_NHFetch__ = __webpack_require__(7);




var md5 = __webpack_require__(119);

/**
 * 网上支付办理接口
 * 请自行在此处判断需要的参数是否符合要求，例如判断身份证件号是否为空，Toast.hide()，可以使用改方法关闭准备跳转支付界面提示
 *
 * @param {*} ddh 订单号
 * @param {*} csxx 配置参数信息，包含：pczflj(PC端支付路径),ydzflj(移动端支付路径)，zfts(支付提示),所有的自定义配置的参数信息
 * @param {*} xsxx 学生信息，包含：XSID(学生ID),XH(学号),XM(姓名),XBM(性别码),SFZJH(身份证件号),RXNF(入学年份),CSRQ(出生日期)
 * @param {*} jfxm 缴费信息，LIst<Map<String,Object>>对象,包含：sfxmid(收费项目ID),sfxmdm(收费项目代码),sfxmmc(收费项目名称)，je(金额)
 * @param {*} jyje 交易金额
 * @param {*} yjje 应缴金额
 * @param {*} ysje 已缴金额
 * @param {*} hjje 缓缴金额
 */
var handle = function handle(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje) {
  var params = csxx;
  params.orderId = ddh;
  params.jfje = jyje;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_NHFetch__["a" /* default */])('/openapi/jfxt/getjsyhUrl', 'POST', params).then(function (res) {
    if (res) {
      var msg = res.data;
      window.open(msg);
    }
  });
};

/**
 * 点击同步按钮触发时的操作
 * @param {*} ddh 订单号
 */
var syscBtnFunc = function syscBtnFunc(ddh) {};

/***/ }),

/***/ 1129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return syscBtnFunc; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nxmzzyjsxy_js__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gdsxzyjsxy_js__ = __webpack_require__(1128);



/**
 * 网上支付办理接口
 * @param {*} ddh 订单号
 * @param {*} csxx 配置参数信息，包含：pczflj(PC端支付路径),ydzflj(移动端支付路径)，zfts(支付提示),所有的自定义配置的参数信息
 * @param {*} xsxx 学生信息，包含：XSID(学生ID),XH(学号),XM(姓名),XBM(性别码),SFZJH(身份证件号),RXNF(入学年份),CSRQ(出生日期)
 * @param {*} jfxm 缴费信息，LIst<Map<String,Object>>对象,包含：sfxmid(收费项目ID),sfxmdm(收费项目代码),sfxmmc(收费项目名称)，je(金额)
 * @param {*} jyje 交易金额
 * @param {*} yjje 应缴金额
 * @param {*} ysje 已缴金额
 * @param {*} hjje 缓缴金额
 */
var handle = function handle(type, ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje) {
  if (type === 'nxmzzyjsxy') {
    //宁夏民族职业技术学院
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__nxmzzyjsxy_js__["a" /* handle */])(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje);
  } else if (type === 'gdsxzyjsxy') {
    //广东松山技术学院
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__gdsxzyjsxy_js__["a" /* handle */])(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje);
  }
};

/**
 * 点击同步按钮触发时的操作
 * @param {*} ddh 订单号
 */
var syscBtnFunc = function syscBtnFunc(type, ddh) {
  if (type === 'nxmzzyjsxy') {
    //宁夏民族职业技术学院
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__nxmzzyjsxy_js__["b" /* syscBtnFunc */])(ddh);
  }
};

/***/ }),

/***/ 1130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return syscBtnFunc; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_NHVirtualForm_js__ = __webpack_require__(114);





var md5 = __webpack_require__(119);

/**
 * 网上支付办理接口
 * 请自行在此处判断需要的参数是否符合要求，例如判断身份证件号是否为空，Toast.hide()，可以使用改方法关闭准备跳转支付界面提示
 *
 * @param {*} ddh 订单号
 * @param {*} csxx 配置参数信息，包含：pczflj(PC端支付路径),ydzflj(移动端支付路径)，zfts(支付提示),所有的自定义配置的参数信息
 * @param {*} xsxx 学生信息，包含：XSID(学生ID),XH(学号),XM(姓名),XBM(性别码),SFZJH(身份证件号),RXNF(入学年份),CSRQ(出生日期)
 * @param {*} jfxm 缴费信息，LIst<Map<String,Object>>对象,包含：sfxmid(收费项目ID),sfxmdm(收费项目代码),sfxmmc(收费项目名称)，je(金额)
 * @param {*} jyje 交易金额
 * @param {*} yjje 应缴金额
 * @param {*} ysje 已缴金额
 * @param {*} hjje 缓缴金额
 */
var handle = function handle(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje) {
  var url = csxx.ydzflj; //跳转URL
  var sfzjh = xsxx.SFZJH; //身份证件号
  var partnerid = csxx.partnerid; //合作者ID
  var sign = csxx.sign; //签名
  var projectid = csxx.projectid; //缴费项目ID
  var istimelimit = csxx.istimelimit; //是否限时用户登陆缴费平台时间
  var timelimit = csxx.timelimit; //缴费平台限制时间
  var ydurl = csxx.ydurl; //移动端限时结束返回地址
  var errormsg = csxx.errormsg; //页面提示信息
  var ydreturnurl = csxx.ydreturnurl; //移动端缴费成功页面
  if (!url) {

    __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.warning("支付路径不能为空，请联系管理员！");
    return;
  }
  if (!sfzjh) {

    __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.warning("身份证件号不能为空，请联系管理员！");
    return;
  }
  if (!partnerid || !sign) {
    __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.warning("参数不能为空，请联系管理员！");
    return;
  }
  sign = md5(sfzjh + getNowFormatDate() + sign);
  //虚拟表单提交
  var map = {
    idserial: sfzjh,
    partnerid: partnerid,
    sign: sign,
    projectid: projectid,
    istimelimit: istimelimit,
    timelimit: timelimit,
    url: ydurl,
    errormsg: errormsg,
    returnurl: ydreturnurl
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_NHVirtualForm_js__["a" /* NHVirtualForm */])(url, "_self", map);
};

/**
 * 点击同步按钮触发时的操作
 * @param {*} ddh 订单号
 */
var syscBtnFunc = function syscBtnFunc(ddh) {};

//获取当前日志，格式yyyyMMdd
function getNowFormatDate() {
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var hours = date.getHours(); //获取系统时，
  var minutes = date.getMinutes(); //分
  var seconds = date.getSeconds(); //秒
  var strDate = date.getDate();

  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  if (hours >= 0 && hours <= 9) {
    hours = "0" + hours;
  }
  if (minutes >= 0 && minutes <= 9) {
    minutes = "0" + minutes;
  }
  if (seconds >= 0 && seconds <= 9) {
    seconds = "0" + seconds;
  }
  var currentdate = year + month + strDate;
  return currentdate;
}

/***/ }),

/***/ 1131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SzjdChannel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_spin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_number_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_checkbox_style__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_checkbox__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_axios__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_SelfHelp_szjdChannel_view__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_SelfHelp_common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_common_NHFormItem__ = __webpack_require__(43);





























var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }












var Dragger = __WEBPACK_IMPORTED_MODULE_27_antd_lib_upload___default.a.Dragger;







var history = __WEBPACK_IMPORTED_MODULE_38_history_createHashHistory___default()();
var TextArea = __WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a.TextArea;

var FormItem = __WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.Item;
var CheckboxGroup = __WEBPACK_IMPORTED_MODULE_21_antd_lib_checkbox___default.a.Group;
var formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 }
};

var xsids = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
var SzjdChannel = (_dec = __WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(SzjdChannel, _React$Component);

    function SzjdChannel(props) {
        _classCallCheck(this, SzjdChannel);

        var _this = _possibleConstructorReturn(this, (SzjdChannel.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(SzjdChannel)).call(this, props));

        _this.updateZzbdBlzt = function () {
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_36__utils_NHFetch__["a" /* default */])('/zzbd/updateZzbdBlzt', 'GET', { zzbdhjid: zzbdhjid, hjdm: 'GD005_1' }).then(function (res) {
                if (res.data) {
                    _this.reloadMenu();
                }
            });
        };

        _this.queryQztjAndYlhj = function (callback) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_36__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }if (callback) {
                        callback(_this.state.operable);
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_42__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.loadLstddkfs = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_36__utils_NHFetch__["a" /* default */])('/proData/selectDataList', 'get', 'sign=dmk_YXXT_DKLX').then(function (res) {
                if (res && res.code == 200) {
                    var dkfsList = res.data;
                    _this.setState({
                        dkfsList: dkfsList
                    });
                }
            });
        };

        _this.loadLstdBlyy = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_36__utils_NHFetch__["a" /* default */])('/proData/selectDataList', 'get', 'sign=dmk_YXXT_LSTD_BLYY').then(function (res) {
                if (res) {
                    var col = [];
                    res.data.map(function (item) {
                        col.push(__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_18_antd_lib_col___default.a,
                            { span: 6 },
                            __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_21_antd_lib_checkbox___default.a,
                                { value: item.VALUE },
                                item.LABEL
                            )
                        ));
                    });
                    var html = __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16_antd_lib_row___default.a,
                        null,
                        col
                    );
                    _this.setState({ checkGroup: html });
                }
            });
        };

        _this.loadLstdInfo = function () {
            _this.setState({
                dkfsValue: ""
            });
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_36__utils_NHFetch__["a" /* default */])('/xmd/szkj/lstd/getLstdInfoByXsid', 'GET').then(function (resData) {
                if (resData && resData.data) {
                    _this.setState({ data: resData.data });
                    var fileList = [];
                    if (resData.data && resData.data['fj']) {
                        resData.data['fj'].map(function (elem, index) {
                            //格式化对于附件取值
                            var file = {
                                uid: elem.fjid,
                                name: elem.fjmc,
                                response: {
                                    data: {
                                        ssbh: elem.fjid,
                                        fjmc: elem.fjmc
                                    }
                                },
                                status: 'done'
                            };
                            fileList.push(file);
                        });
                    }
                    _this.setState({ fileList: fileList });
                    _this.props.form.setFieldsValue({ fj: { fileList: _this.state.fileList } });
                } else {
                    _this.setState({ data: {} });
                    _this.setState({ fileList: [] });
                    _this.props.form.resetFields();
                }
            });
        };

        _this.getBase64 = function (img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        };

        _this.handlePreview = function (file) {
            var isImage = /^image\/.*$/i.test(file.type);
            if (isImage) {
                if (file) {
                    _this.getBase64(file, function (imageUrl) {
                        _this.setState({
                            previewImage: imageUrl,
                            previewVisible: true
                        });
                    });
                } else {
                    _this.setState({
                        previewImage: file.url || file.thumbUrl,
                        previewVisible: true
                    });
                }
            } else if (file && file['response'] && file['response']['data']) {
                //其他情况
                var _isImage = true;
                var fjmc = file['response']['data']['fjmc'];
                var ssbh = file['response']['data']['ssbh'];
                if (!_this.setJudge(fjmc, _this.state.judgeImgList)) {
                    _isImage = false;
                }

                if (_isImage) {
                    _this.showPreview('anonymity/docrepo/download/file?attachmentId=' + ssbh);
                } else {
                    window.open('anonymity/docrepo/download/file?attachmentId=' + ssbh);
                }
            }
        };

        _this.showPreview = function (url) {
            _this.setState({
                previewImage: url,
                previewVisible: true
            });
        };

        _this.handleCancel = function () {
            return _this.setState({ previewVisible: false });
        };

        _this.handleSubmit = function (e) {
            var xsids = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId;
            console.log(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["b" /* getLoginUser */])().userId);
            _this.setState({ loading: true });
            e.preventDefault();
            var zzbdhjid = _this.getQueryString('pkid');
            _this.props.form.validateFieldsAndScroll(function (err, values) {
                if (err) {
                    _this.setState({ loading: false });
                    return false;
                }
                var hzjym = values['hzjym'];
                if (hzjym != undefined && hzjym.trim().length != 6) {
                    _this.setState({ loading: false });
                    __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default.a.warning("请填写6位回执校验码");
                    return;
                }

                var blyy = values['blyy'];
                var sqsm = values['sqsm'];
                var pkid = values['pkid'];
                var msg = "";
                /* blyy.map( item =>{
                    if(item == '99'){
                        if(typeof(sqsm) == "undefined" || sqsm.trim().length == 0){
                            sqsmFlag = true ;
                            msg="其它原因，请填写申请理由"
                        }
                    }
                })
                console.log(sqsmFlag);
                if(sqsmFlag){
                    this.setState({loading:false});
                    message.warning("其它原因，请填写申请理由");
                    return ;
                } */
                var dkyh = values['dkyh'];
                var blje = values['blje'];
                var params = {
                    blyy: blyy,
                    blje: blje,
                    hzjym: hzjym,
                    dkyh: dkyh,
                    sqsm: sqsm,
                    dklx: _this.state.dkfsValue,
                    xsid: xsids,
                    zzbdhjid: zzbdhjid,
                    pkid: pkid,
                    dkfsValue: ""
                };
                if (!pkid) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_36__utils_NHFetch__["a" /* default */])('/xmd/szkj/lstd/insert', "POST", params).then(function (res) {
                        if (res && res.code == 200) {
                            __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default.a.success("绿色通道申请保存成功。");
                            _this.loadLstdInfo();
                            _this.reloadMenu();
                        }
                        _this.setState({ loading: false });
                    }).catch(function (res) {
                        _this.setState({ loading: false });
                        return res;
                    });
                } else {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_36__utils_NHFetch__["a" /* default */])('/xmd/szkj/lstd/update', "POST", params).then(function (res) {
                        if (res && res.data && res.data > 0) {
                            __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default.a.success("绿色通道申请保存成功。");
                            _this.loadLstdInfo();
                            _this.reloadMenu();
                        } else {
                            __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default.a.warning("绿色通道申请保存失败，请重试。");
                        }
                        _this.setState({ loading: false });
                    }).catch(function (res) {
                        _this.setState({ loading: false });
                        return res;
                    });
                }
            });
        };

        _this.handleChange = function (_ref) {
            var fileList = _ref.fileList;

            var count = 0;
            fileList.map(function (elem) {
                if (elem && elem['status'] && elem['status'] === 'uploading') {
                    _this.setState({ uploading: true });
                    return;
                } else if (elem && elem['status']) {
                    count++;
                }
            });
            if (count > 0) {
                _this.setState({ uploading: false });
            }
        };

        _this.setJudge = function (name, map) {
            var flag = false;
            map.map(function (item) {
                if (name.indexOf(item) !== -1) {
                    flag = true;
                }
            });
            return flag;
        };

        _this.beforeUpload = function (file) {
            if (!(_this.setJudge(file.name, _this.state.judgeImgList) || _this.setJudge(file.name, _this.state.judgeFileList))) {
                __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default.a.error('不能上传该格式文件');
                return false;
            } else {
                return true;
            }
        };

        _this.remove = function (ssbh) {
            var url = 'api/docrepo/attachment/sourceId/delete?souerceId=' + ssbh;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_36__utils_NHFetch__["a" /* default */])(url, "POST").then(function (res) {
                if (res.data && res.data > 0) {
                    __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default.a.success('已删除材料.');
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.dkfsOnChange = function (e) {
            console.log('radio checked', e.target.value);
            _this.setState({
                dkfsValue: e.target.value
            });
        };

        _this.state = {
            mkbz: 'GD005_1',
            hjmc: '',
            uploading: false,
            loading: false,
            previewVisible: false,
            fileList: [],
            checkGroup: [], //绿色通道办理原因
            data: {}, //绿色通道申请信息
            nextUrl: '',
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            sqlyFlag: false, //申请理由flag
            jymFlag: false, //6位数回执校验码flag
            judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'], //可以导入的图片格式
            judgeFileList: ['.pdf', '.PDF', '.doc', '.DOC', '.zip', '.ZIP', '.txt', '.TXT', '.xls', '.XLS', '.rar', '.RAR'], //可以导入的非图片格式
            dkfsValue: "",
            dkfsList: []
        };
        return _this;
    }

    _createClass(SzjdChannel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.queryQztjAndYlhj(function (operable) {
                if (operable) {
                    _this2.loadLstdInfo();
                    _this2.loadLstdBlyy();
                    _this2.loadLstddkfs();
                    _this2.updateZzbdBlzt();
                }
            });
        }

        //迎新现场已办理时迎新网站自动办理


        //查询前置条件和依赖环节


        //读取学生的绿色通道信息


        // 转化base64


        // 点击文件链接或预览图标时的回调


        // 关闭图片弹窗


        // 提交


        //判断文件类型是否正常  name：文件名称  map：类型范围数组  true正常


        //重新加载菜单


        // 回调

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var form = this.props.form;
            var getFieldDecorator = this.props.form.getFieldDecorator;
            var _state = this.state,
                previewImage = _state.previewImage,
                previewVisible = _state.previewVisible,
                jymFlag = _state.jymFlag,
                sqlyFlag = _state.sqlyFlag,
                dkfsList = _state.dkfsList,
                dkfsValue = _state.dkfsValue;

            console.log("dkfsValue", dkfsValue);
            var props = {
                name: 'file',
                action: 'anonymity/docrepo/upload',
                data: { uuid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_NHCore__["c" /* createUuid */])(), type: '1' },

                onRemove: function onRemove(file) {
                    _this3.setState(function (_ref2) {
                        var fileList = _ref2.fileList;

                        var index = fileList.indexOf(file);
                        var newFileList = fileList.slice();
                        newFileList.splice(index, 1);
                        _this3.props.form.setFieldsValue({ fj: { fileList: newFileList } });
                        return {
                            fileList: newFileList
                        };
                    }, function () {
                        if (file.response && file.response.data && file.response.data.ssbh) {
                            _this3.remove(file.response.data.ssbh);
                        }
                    });
                },
                beforeUpload: function beforeUpload(file) {
                    if (!_this3.beforeUpload(file)) {
                        return false;
                    }
                    _this3.setState(function (_ref3) {
                        var fileList = _ref3.fileList;
                        return {
                            fileList: [].concat(_toConsumableArray(fileList), [file])
                        };
                    });
                    return true;
                },
                onChange: function onChange(file) {
                    _this3.handleChange(file);
                },
                onPreview: this.handlePreview,
                fileList: this.state.fileList
            };

            var edit = false;
            var data = this.state.data;
            if (__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(data) == "{}") {
                edit = true;
            } else if (data && data['shzt'] === '9') {
                edit = true;
            }
            return __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                'div',
                { style: { position: 'relative' } },
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_31__components__["a" /* Flex */],
                        { className: 'w1180 mt-20', align: 'start' },
                        __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__pages_Assembly_siderMenu__["a" /* default */], {
                            ref: "siderMenu",
                            setMenuList: this.setMenuList,
                            title: '\u81EA\u52A9\u62A5\u5230',
                            mkbz: this.state.mkbz
                            /*     active={4}*/
                            , menuType: '\u81EA\u52A9\u62A5\u5230' }),
                        __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_31__components__["a" /* Flex */].Item,
                            { className: 'page_con_r ' },
                            __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__pages_Assembly_Breadcrumb__["a" /* default */], {
                                noLine: true,
                                list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                            }),
                            __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                                'div',
                                { className: 'box' },
                                __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__pages_SelfHelp_common_hint__["a" /* default */], null),
                                edit ? __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_23_antd_lib_form___default.a,
                                    { onSubmit: this.handleSubmit },
                                    __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u4FE1\u606F', extra: false }),
                                    __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                                        'div',
                                        { className: 'p-sw' },
                                        __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                                            'div',
                                            { style: { display: 'none' } },
                                            __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_44__components_common_NHFormItem__["a" /* default */],
                                                { id: 'pkid', initialValue: data['pkid'], form: form },
                                                __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a, null)
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                                            'div',
                                            { style: { marginLeft: "30px" } },
                                            __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_44__components_common_NHFormItem__["a" /* default */],
                                                { id: 'blyy', required: true, initialValue: data['blyydm'], form: form, formItemLayout: { labelCol: { span: 4 }, wrapperCol: { span: 16 } }, label: '\u529E\u7406\u539F\u56E0' },
                                                __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                                                    CheckboxGroup,
                                                    { style: { width: '100%' } },
                                                    this.state.checkGroup
                                                )
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item', style: { marginLeft: '7%' } },
                                            __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_44__components_common_NHFormItem__["a" /* default */],
                                                { required: true, id: 'dkfs', initialValue: data['dkfs'], form: form, formItemLayout: formItemLayout, label: '\u8D37\u6B3E\u65B9\u5F0F' },
                                                __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default.a.Group,
                                                    { onChange: this.dkfsOnChange, value: this.state.dkfsValue, style: { display: "flex", margin: "10px" } },
                                                    dkfsList.map(function (item, index) {
                                                        return __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default.a,
                                                            { value: item.VALUE },
                                                            item.LABEL
                                                        );
                                                    })
                                                )
                                            ),
                                            dkfsValue == '1' && __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_44__components_common_NHFormItem__["a" /* default */],
                                                { id: 'blje', required: true, initialValue: data['blje'], form: form, formItemLayout: formItemLayout, label: '\u8D37\u6B3E\u91D1\u989D' },
                                                __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number___default.a, { style: { width: '100%' }, min: 0, max: 9999999, precision: '0', placeholder: '\u8BF7\u586B\u5199\u8D37\u6B3E\u91D1\u989D\uFF08\u5143\uFF09' })
                                            ),
                                            dkfsValue == '1' && __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_44__components_common_NHFormItem__["a" /* default */],
                                                { id: 'dkyh', required: true, initialValue: data['dkyh'], form: form, formItemLayout: formItemLayout, label: '\u8D37\u6B3E\u94F6\u884C' },
                                                __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__components_common_NHSelect__["a" /* default */], { sign: "dmk_yxwz_dkyh", onChange: function onChange(v) {} })
                                            ),
                                            dkfsValue == '1' && __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_44__components_common_NHFormItem__["a" /* default */],
                                                { id: 'hzjym', required: true, initialValue: data['hzjym'], form: form, formItemLayout: formItemLayout, label: '\u56DE\u6267\u6821\u9A8C\u7801' },
                                                __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a, { maxLength: 6, placeholder: '6\u4F4D\u6570\u56DE\u6267\u6821\u9A8C\u7801' })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_44__components_common_NHFormItem__["a" /* default */],
                                                { id: 'sqsm', initialValue: data['sqsm'], form: form, required: true, formItemLayout: formItemLayout, label: '\u7533\u8BF7\u7406\u7531' },
                                                __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(TextArea, { maxLength: 50, placeholder: '\u8BF7\u586B\u5199\u7533\u8BF7\u7406\u7531' })
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,
                                            { type: 'primary', htmlType: 'submit', onClick: this.handleSubmit },
                                            '\u4FDD\u5B58'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__pages_SelfHelp_szjdChannel_view__["a" /* default */], { reloadMenu: this.reloadMenu, nextUrl: this.state.nextUrl, loadLstdInfo: this.loadLstdInfo, search: this.state.search, showPreview: this.showPreview, setJudge: this.setJudge, data: this.state.data, judgeImgList: this.state.judgeImgList })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_spin___default.a, { style: { position: 'absolute', top: '300px', left: '60%' }, spinning: this.state.loading }),
                    ' '
                ) : __WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__pages_SelfHelp_common__["a" /* default */], { hjmc: "绿色通道（深圳技大", key: "GD005_1", mkbz: 'GD005_1', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return SzjdChannel;
}(__WEBPACK_IMPORTED_MODULE_28_react___default.a.Component)) || _class);


/***/ }),

/***/ 1132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return View; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }








var TextArea = __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a.TextArea;

var basicUrl = "/zzbd";

var shztList = {
    '-1': '审核不通过',
    '0': '未审核',
    '1': '审核通过',
    '2': '已办理',
    '9': '驳回'
};

var View = function (_React$Component) {
    _inherits(View, _React$Component);

    function View(props) {
        _classCallCheck(this, View);

        var _this = _possibleConstructorReturn(this, (View.__proto__ || __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default()(View)).call(this, props));

        _this.getDmkMc = function (dmbz) {
            var data = _this.props.data;

            var dkyhmc = _this.state.dkyhmc;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])(basicUrl + "/getDmkMc", "GET", _defineProperty({ dmbz: dmbz }, 'dmbz', dmbz)).then(function (res) {
                if (res) {
                    if (res.data) {
                        if (dmbz === "YXWZ_DKYH") {
                            res.data.map(function (initItem) {
                                if (initItem.DM === data.dkyh) {
                                    dkyhmc = initItem.MC;
                                }
                            });
                            _this.setState({ dkyhmc: dkyhmc });
                        }
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.cancel = function (lstdid, shzt) {

            if (shzt !== '0') {
                __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warning('该申请已经审核，不能取消');
                return;
            }

            var pkid = _this.getQueryString("pkid");

            var params = {
                zzbdhjid: pkid,
                pkid: lstdid
            };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])("/lstd/deleteByParams", "POST", params).then(function (res) {
                if (res && res.data && res.data > 0) {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.success("取消成功");
                    _this.props.loadLstdInfo();
                    _this.props.reloadMenu();
                } else {
                    __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warning("取消异常");
                }
            });
        };

        _this.handlePreview = function (fjmc, fjid) {
            var isImage = true;
            if (!_this.props.setJudge(fjmc, _this.props.judgeImgList)) {
                isImage = false;
            }

            if (isImage) {
                _this.props.showPreview('anonymity/docrepo/download/file?attachmentId=' + fjid);
            } else {
                window.open('anonymity/docrepo/download/file?attachmentId=' + fjid);
            }
        };

        _this.loadLstddkfs = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHFetch__["a" /* default */])('/proData/selectDataList', 'get', 'sign=dmk_YXXT_DKLX').then(function (res) {
                if (res && res.code == 200) {
                    var dkfsList = res.data;
                    dkfsList.map(function (item, index) {
                        if (item.VALUE == _this.props.data['dklx']) {
                            var dkfsValue = item.LABEL;
                            _this.setState({
                                dkfsValue: dkfsValue
                            });
                        }
                    });
                }
            });
        };

        _this.state = {
            dkyhmc: '',
            nextUrl: _this.props.nextUrl,
            search: _this.props.search,
            dkfsValue: ""
        };
        return _this;
    }

    _createClass(View, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.getDmkMc("YXWZ_DKYH");
            this.loadLstddkfs();
        }

        //获取下拉列表value对应的名称


        // 点击文件链接或预览图标时的回调

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var data = this.props.data;
            var _state = this.state,
                dkyhmc = _state.dkyhmc,
                dkfsValue = _state.dkfsValue;

            return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u4FE1\u606F', extra: false }),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '20px' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', marginTop: "3px", paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u529E\u7406\u539F\u56E0\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                data['blyy'].map(function (elem, index) {
                                    return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                        'span',
                                        { style: {
                                                borderColor: '#1890ff',
                                                borderRadius: '5px',
                                                padding: '2px 16px',
                                                border: '1px solid rgb(24, 144, 255)',
                                                marginRight: '15px',
                                                display: 'inline-block'
                                            } },
                                        elem
                                    );
                                })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u7533\u8BF7\u7406\u7531\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['sqsm']
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u8D37\u6B3E\u65B9\u5F0F\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    dkfsValue
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                        dkfsValue == "生源地贷款" && __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u8D37\u6B3E\u91D1\u989D\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['blje'],
                                    '\u5143'
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                        dkfsValue == "生源地贷款" && __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u8D37\u6B3E\u94F6\u884C\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    dkyhmc
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                        dkfsValue == "生源地贷款" && __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '6\u4F4D\u6570\u56DE\u6267\u6821\u9A8C\u7801\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['hzjym']
                                )
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__["a" /* default */], { title: '\u7533\u8BF7\u5BA1\u6838', extra: false }),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u5BA1\u6838\u610F\u89C1\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    null,
                                    data['shyj']
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        { className: 'form_item', style: { width: '100%', marginBottom: '24px' } },
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_row___default.a,
                            { gutter: 24 },
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 4, style: { textAlign: 'right', paddingRight: 0 } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    {
                                        style: { color: 'rgba(0, 0, 0, 0.85)' } },
                                    '\u5BA1\u6838\u72B6\u6001\xA0: '
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_col___default.a,
                                { span: 20 },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                    'span',
                                    { style: { color: '#0066FF' } },
                                    shztList[data['shzt']]
                                )
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'text-center mt-50' },
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                        { type: 'primary', onClick: function onClick() {
                                _this2.cancel(data['pkid'], data['shzt']);
                            } },
                        '\u53D6\u6D88'
                    ),
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                )
            );
        }
    }]);

    return View;
}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);



/***/ }),

/***/ 1133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_common_NHCascader__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__utils_RegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__index_css__);













var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }













if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var uploadUrl = "api/zhxg-yxwz/newStudent/cacheStudentPhoto"; //上传logo路径


function beforeUpload(file) {

    var isJPG = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJPG) {
        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("You can only upload JPG file!");
    }
    var isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("Image must smaller than 2MB!");
    }
    return isJPG && isLt2M;
}

var JbxxInitForm = function (_React$Component) {
    _inherits(JbxxInitForm, _React$Component);

    function JbxxInitForm(props) {
        _classCallCheck(this, JbxxInitForm);

        var _this = _possibleConstructorReturn(this, (JbxxInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(JbxxInitForm)).call(this, props));

        _this.getStudentPhotoBase64 = function (userId, callback) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/openapi/student/getStudentPhotoBase64', 'get', { xsid: userId, type: 10 }).then(function (res) {
                if (res && res.code == 200) {
                    callback(res.data);
                }
            });
        };

        _this.onSavejbxxFormData = function (cb) {
            _this.props.form.validateFields(function (error, values) {
                if (error) {
                    cb(false);
                    return;
                }
                cb(true);
                var cacheFormData = _this.props.cacheFormData;

                if (_this.state.jtStr !== '') {
                    values.jtdzDetail = _this.state.jtStr;
                } else {
                    values.jtdzDetail = _this.props.jbxxFormData ? _this.props.jbxxFormData.jtdzDetail ? _this.props.jbxxFormData.jtdzDetail : "" : "";
                }
                cacheFormData('jbxx', values);
                _this.setState({
                    jbxx: false
                });
            });
        };

        _this.handleUploadChange = function (info) {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (info && info['file'] && info['file'].status === 'done') {
                var photoUUID = info['file'].response.data;
                if (photoUUID) {
                    var url = '/newStudent/saveStudentPhoto?xsid=' + userId + '&photoUUID=' + photoUUID + '&type=' + '10';
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_NHFetch__["a" /* default */])(url, 'POST').then(function (res) {
                        if (res && res.data) {
                            __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.success("上传成功!");
                        }
                    });
                }
            }
            _this.getBase64(info.file.originFileObj, function (imageUrl) {
                return _this.setState({ imageUrl: imageUrl });
            });
        };

        _this.onNHCascaderChange = function (value, selectedOptions, type) {
            var label = '';
            if (selectedOptions) {
                selectedOptions.forEach(function (i) {
                    label += i.label;
                });
            }
            if (type == 'jg') {
                _this.setState({ jgmStr: label });
            } else {
                _this.setState({ jtStr: label });
            }
        };

        _this.state = {
            jbxx: false,
            xsid: '',
            userInfoData: null,
            zzmmmList: [],
            mzmList: [],
            textData: '',
            jgmStr: '',
            jtStr: '',
            xsSsInfo: ''
        };
        return _this;
    }

    _createClass(JbxxInitForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                this.getStudentPhotoBase64(userId, function (data) {
                    if (!data) return;
                    _this2.setState({
                        xsid: userId,
                        imageUrl: 'data:image/jpeg;base64,' + data
                    });
                });
            }
        }

        // 获取学生头像

    }, {
        key: 'getBase64',
        value: function getBase64(img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        }
        // 上传图片

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                form = _props.form,
                jbxxFormData = _props.jbxxFormData,
                getChildComponent = _props.getChildComponent,
                userInfoData = _props.userInfoData,
                stuSsxx = _props.stuSsxx,
                editXszp = _props.editXszp;
            var _state = this.state,
                jbxx = _state.jbxx,
                imageUrl = _state.imageUrl,
                tempUrl = _state.tempUrl,
                xsid = _state.xsid;

            var jtjddz = jbxxFormData ? jbxxFormData.jtjddz : '';
            var jtdzDetail = jbxxFormData ? jbxxFormData.jtdzDetail : '';
            var ssxx = '';
            if (stuSsxx && stuSsxx.xqmc && stuSsxx.ldmc && stuSsxx.fj && stuSsxx.cwh) {
                ssxx = stuSsxx.xqmc + stuSsxx.ldmc + ' - ' + stuSsxx.fj + ' - ' + stuSsxx.cwh;
            }
            return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a,
                { layout: 'inline' },
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u57FA\u672C\u4FE1\u606F',
                    onEdit: function onEdit(type) {
                        _this3.setState({
                            jbxx: true
                        });
                        getChildComponent(1, false);
                    },
                    onSave: function onSave(cb) {
                        _this3.onSavejbxxFormData(cb);
                        getChildComponent(1, true);
                    },
                    onClose: function onClose() {
                        _this3.setState({
                            jbxx: false
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + '_bg app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_icon'
                        },
                        jbxx && editXszp === "true" ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default.a,
                            {
                                name: 'photo',
                                accept: 'image/*',
                                showUploadList: false,
                                action: uploadUrl + "?xsid=" + xsid,
                                beforeUpload: beforeUpload,
                                onChange: this.handleUploadChange
                            },
                            imageUrl || userInfoData ? imageUrl ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
                                src: imageUrl,
                                alt: '',
                                className: 'jsx-1702183314' + ' ' + 'avatar'
                            }) : tempUrl : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__upload-box'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__upload-title'
                                    },
                                    '\u4E0A\u4F20\u56FE\u7247'
                                )
                            )
                        ) : imageUrl ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
                            src: imageUrl,
                            alt: '',
                            className: 'jsx-1702183314' + ' ' + 'avatar'
                        }) : tempUrl
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */].Item,
                        { className: 'ml-20' },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__item-label'
                                },
                                '\u59D3\u540D\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.XM : '',
                                userInfoData && userInfoData.XB ? userInfoData.XB === '男' ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(141), alt: '', className: 'jsx-1702183314'
                                }) : userInfoData.XB === '女' ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(142), alt: '', className: 'jsx-1702183314'
                                }) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(143), alt: '', className: 'jsx-1702183314'
                                }) : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__item-label'
                                },
                                '\u5B66\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.XH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__item-label'
                                },
                                '\u8003\u751F\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfo-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.ksh : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__item-label'
                                },
                                '\u8EAB\u4EFD\u8BC1\u4EF6\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.SFZJH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__item-label'
                                },
                                '\u51FA\u751F\u5E74\u6708\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.CSRQ : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__item-label'
                                },
                                '\u653F\u6CBB\u9762\u8C8C\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.ZZMM : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__item-label'
                                },
                                '\u6C11\u65CF\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.MZ : ''
                            )
                        ),
                        userInfoData.JG ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__item-label'
                                },
                                '\u7C4D\u8D2F\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfo-__index__item-name'
                                },
                                userInfoData ? userInfoData.JG : ''
                            )
                        ) : '',
                        jbxxFormData.byzx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__item-label'
                                },
                                '\u6BD5\u4E1A\u5B66\u6821\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfo-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.byzx : ''
                            )
                        ) : '',
                        jbxxFormData.gkcj ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__item-label'
                                },
                                '\u9AD8\u8003\u5206\u6570\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfo-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.gkcj : ''
                            )
                        ) : ''
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    'div',
                    {
                        className: 'jsx-1702183314' + ' ' + 'p-swc'
                    },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__item-label'
                            },
                            '\u5B66\u9662\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfo-__index__item-name'
                            },
                            userInfoData ? userInfoData.BMMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__item-label'
                            },
                            '\u4E13\u4E1A\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfo-__index__item-name'
                            },
                            userInfoData ? userInfoData.ZYMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__item-label'
                            },
                            '\u73ED\u7EA7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfo-__index__item-name'
                            },
                            userInfoData ? userInfoData.BJMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_item2'
                        },
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                            { id: 'sjhm',
                                label: __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__item-label'
                                    },
                                    '\u672C\u4EBA\u8054\u7CFB\u7535\u8BDD\uFF1A'
                                ),
                                colon: false,
                                form: form,
                                required: true
                                // hasFeedback={true} 
                                // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/,  message: "请输入正确的手机号码或电话号码"}}
                                , pattern: __WEBPACK_IMPORTED_MODULE_20__utils_RegExp__["FormRules"].MOBILE_PHONE_NUMBER,
                                initialValue: jbxxFormData ? jbxxFormData.sjhm : ""
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u8054\u7CFB\u7535\u8BDD' })
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__item-label'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'red' }, className: 'jsx-1702183314'
                                    },
                                    '*'
                                ),
                                '\u672C\u4EBA\u8054\u7CFB\u7535\u8BDD\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfo-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.sjhm : ''
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__item-label'
                            },
                            '\u5BBF\u820D\u4FE1\u606F\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfo-__index__item-name'
                            },
                            ssxx
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__detail_adrress'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            { style: { lineHeight: '32px' }, className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__item-label'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                { style: { color: 'red' }, className: 'jsx-1702183314'
                                },
                                '*'
                            ),
                            '\u8BE6\u7EC6\u5BB6\u5EAD\u4F4F\u5740\uFF1A'
                        ),
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                            null,
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'jtszdqArray',
                                    label: '',
                                    colon: false,
                                    required: true,
                                    form: form,
                                    initialValue: jbxxFormData ? jbxxFormData.jtszdqArray : []
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_common_NHCascader__["a" /* default */], { style: { width: 432.63 }, sign: "zhxg_ssq", onChange: function onChange(value, selectedOptions) {
                                        return _this3.onNHCascaderChange(value, selectedOptions, 'jt');
                                    }

                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem_index__["a" /* default */],
                                { id: 'jtjddz',
                                    label: '',
                                    colon: false,
                                    required: true,
                                    form: form,
                                    pattern: { max: 100, message: "家庭住址长度不能超过100字符！" },
                                    initialValue: jbxxFormData ? jbxxFormData.jtjddz : '' },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 346.07 }, placeholder: '\u8BF7\u586B\u5199\u8BE6\u7EC6\u5BB6\u5EAD\u5730\u5740\uFF0C\u5982\uFF1Axx\u8857\u9053\u3001xx\u5C0F\u533A\u3001\u95E8\u724C\u53F7' })
                            )
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfo-__index__item-name'
                            },
                            jtdzDetail ? jtdzDetail : '',
                            jtjddz ? jtjddz : ''
                        )
                    ),
                    userInfoData ? userInfoData.FDY && userInfoData.FDY.length > 0 ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__item-label'
                            },
                            '\u8F85\u5BFC\u5458\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfo-__index__item-name'
                            },
                            userInfoData.FDY.map(function (item, key) {
                                if (item) {
                                    var lxdh = item.LXDH ? "( " + item.LXDH + " )" : "";
                                    return item.XM + lxdh + " ";
                                } else {
                                    return "";
                                }
                            })
                        )
                    ) : null : null,
                    userInfoData ? userInfoData.BZR && userInfoData.BZR.length > 0 ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__item-label'
                            },
                            '\u73ED\u4E3B\u4EFB\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfo-__index__item-name'
                            },
                            userInfoData.BZR.map(function (item, key) {
                                if (item) {
                                    var lxdh = item.LXDH ? "( " + item.LXDH + " )" : "";
                                    return item.XM + lxdh + " ";
                                } else {
                                    return "";
                                }
                            })
                        )
                    ) : null : null
                ),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_styled_jsx_style___default.a, {
                    styleId: '1702183314',
                    css: ['.ant-col-md-7{width:100px;}']
                })
            );
        }
    }]);

    return JbxxInitForm;
}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);

var JbxxForm = __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a.create()(JbxxInitForm);

/* harmony default export */ __webpack_exports__["a"] = (JbxxForm);

/***/ }),

/***/ 1134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__utils_RegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_deepCopy__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_deepCopy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__utils_deepCopy__);

















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }











if (false) {
  module.hot.accept('./index.css', function () {
    require('./index.css');
  });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item;

var JtcyInitForm = function (_React$Component) {
  _inherits(JtcyInitForm, _React$Component);

  function JtcyInitForm(props) {
    _classCallCheck(this, JtcyInitForm);

    var _this = _possibleConstructorReturn(this, (JtcyInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of___default()(JtcyInitForm)).call(this, props));

    _this.cacheJtcyData = function (cb) {
      _this.props.form.validateFields(function (err, values) {
        var _this$state = _this.state,
            jtcyData = _this$state.jtcyData,
            errorFiled = _this$state.errorFiled;

        if (err || errorFiled) return cb(false);
        var dataList = jtcyData ? jtcyData : [];
        var _this$props = _this.props,
            cacheFormData = _this$props.cacheFormData,
            getChildComponent = _this$props.getChildComponent;

        getChildComponent(3, true);
        cacheFormData('jtcy', dataList, true);
        cb(true);
        _this.setState({
          jtcy: false,
          jtcyAdd: false
        });
      });
    };

    _this.onjtcyAdd = function () {
      var _this$state2 = _this.state,
          jtcyAdd = _this$state2.jtcyAdd,
          jtcyData = _this$state2.jtcyData;

      if (!jtcyData) {
        jtcyData = [];
      }
      if (!jtcyAdd) return __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error('操作逻辑异常!');
      jtcyData.push({
        key: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["c" /* createUuid */])(),
        gx: '',
        xm: '',
        gzxxdw: '',
        zzmmm: '',
        lxfs: '',
        operation: '',
        errorFiled: false
      });
      _this.setState({ jtcyData: jtcyData });
    };

    _this.onjtcyClose = function (index) {
      var jtcyData = _this.state.jtcyData;

      jtcyData.splice(index, 1);
      _this.setState({
        jtcyData: jtcyData,
        jtcyAdd: true
      });
    };

    _this.handleChange = function (value, index, key) {
      var errorFiled = key === 'lxfs' && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_RegExp__["regPhone"])(value);
      var jtcyData = _this.state.jtcyData;
      jtcyData[index][key] = value;
      jtcyData[index]['errorFiled'] = errorFiled;
      _this.setState({ jtcyData: jtcyData, errorFiled: errorFiled });
    };

    _this.getzzmmmStr = function (value) {
      var temp = '';
      _this.state.zzmmmList.forEach(function (i) {
        if (i.value === value) {
          temp = i.label;
        }
      });
      return temp;
    };

    _this.state = {
      jtcy: false,
      jtcyAdd: false,
      jtcyData: [],
      zzmmmList: [],
      tempStr: '',
      jtcyList: [], //家庭成员数据加载
      errorFiled: false
    };
    return _this;
  }

  _createClass(JtcyInitForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/proData/selectDataList?&sign=DMK_XTGL_ZZMMM', 'GET').then(function (res) {
        if (res && res.data) {
          var zzmmmList = [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_get_iterator___default()(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var obj = _step.value;

              zzmmmList.push({ label: obj.LABEL, value: obj.VALUE });
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this2.setState({ zzmmmList: zzmmmList });
        }
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/proData/selectDataList?&sign=DMK_XSXX_JTCYGX', 'GET').then(function (res) {
        if (res && res.data) {
          var jtcyList = [];
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_get_iterator___default()(res.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var obj = _step2.value;

              jtcyList.push({ label: obj.LABEL, value: obj.VALUE });
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          _this2.setState({ jtcyList: jtcyList });
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ('jtcyInitData' in nextProps && nextProps.jtcyInitData) {
        if (nextProps.jtcyInitData instanceof Array) {
          var temp = [].concat(_toConsumableArray(nextProps.jtcyInitData));
          this.setState({ jtcyData: temp });
        }
      }
    }

    // 家庭成员 添加

    // 家庭成员 关闭添加

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          jtcy = _state.jtcy,
          jtcyData = _state.jtcyData,
          jtcyAdd = _state.jtcyAdd,
          jtcyList = _state.jtcyList;
      var _props = this.props,
          getChildComponent = _props.getChildComponent,
          form = _props.form;

      var jtcyTransalate = {}; //家庭成员翻译
      for (var i = 0; i < jtcyList.length; i++) {
        jtcyTransalate[jtcyList[i].value] = jtcyList[i].label;
      }
      var jtcyColumns = [{
        title: '关系',
        key: 'gx',
        dataIndex: 'gx',
        render: function render(text, record, index) {
          return jtcy ?
          // <Input
          //     value={text}
          //     required={true}
          //     onChange={(e) =>{this.handleChange(e.target.value,index,'gx')}}
          //     style={{ width: 100 }}
          //     placeholder="请填写关系"
          // />
          __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_common_NHSelect__["a" /* default */], {
            style: { width: 100 },
            sign: 'DMK_XSXX_JTCYGX',
            value: text,
            onChange: function onChange(value) {
              _this3.handleChange(value, index, 'gx');
            }
          }) :
          // <NHFormItem id={'gx'} label={''} form={form} required={true}
          //     pattern={{max:5, message: "关系长度不能超过5字符！"}}
          //     initialValue={text}>
          // <Input onChange={(e) =>{this.handleChange(e.target.value,index,'gx')}}
          //        placeholder="请填写关系"/>
          // </NHFormItem>
          jtcyTransalate[text];
        }
      }, {
        title: '姓名',
        dataIndex: 'xm',
        render: function render(text, record, index) {
          console.log('测试:', text);
          return jtcy ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a, {
            value: text,
            onChange: function onChange(e) {
              _this3.handleChange(e.target.value, index, 'xm');
            },
            style: { width: 100 },
            placeholder: '\u8BF7\u586B\u5199\u59D3\u540D'
          }) : text;
        }
      },
      // {
      //     title: '政治面貌',
      //     dataIndex: 'zzmmm',
      //     render: (text, record,index) => {
      //         //let tempStr = '';
      //         return(
      //             jtcy ?
      //             <NHSelect disabled = {jtcy ? false : true} style={{ width: 140 }} sign="DMK_XTGL_ZZMMM"
      //             value={text}
      //             onChange={(value) =>{this.handleChange(value,index,'zzmmm')}}

      //             />
      //             :
      //             (this.getzzmmmStr(text))
      //         );
      //     }
      // },
      {
        title: '工作单位及职务',
        dataIndex: 'gzxxdw',
        render: function render(text, record, index) {
          return jtcy ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a, {
            value: text,
            onChange: function onChange(e) {
              _this3.handleChange(e.target.value, index, 'gzxxdw');
            },
            style: { width: 140 },
            placeholder: '\u8BF7\u586B\u5199\u5355\u4F4D\u548C\u804C\u52A1'
          }) : text;
        }
      }, {
        title: '联系电话',
        dataIndex: 'lxfs',
        render: function render(text, record, index) {
          return jtcy ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
            FormItem,
            { form: form, style: { marginBottom: '0px', width: '140px' } },
            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a, {
              value: text,
              maxLength: 11,
              onChange: function onChange(e) {
                _this3.handleChange(e.target.value, index, 'lxfs');
              },
              style: { width: 110 },
              placeholder: '\u8BF7\u586B\u5199\u7535\u8BDD'
            }),
            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
              'div',
              { style: { display: record.errorFiled ? 'block' : 'none', color: '#ff4d4f' } },
              text ? __WEBPACK_IMPORTED_MODULE_22__utils_RegExp__["FormRules"].MOBILE_PHONE_NUMBER.message : '请填写电话'
            )
          ) : text;
        }
      }, {
        title: 'QQ',
        dataIndex: 'qq',
        render: function render(text, record, index) {
          return jtcy ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a, {
            value: text,
            onChange: function onChange(e) {
              _this3.handleChange(e.target.value, index, 'qq');
            },
            style: { width: 100 },
            placeholder: '\u8BF7\u586BQQ\u53F7'
          }) : text;
        }
      }, {
        title: '微信',
        dataIndex: 'wx',
        render: function render(text, record, index) {
          return jtcy ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a, {
            value: text,
            onChange: function onChange(e) {
              _this3.handleChange(e.target.value, index, 'wx');
            },
            style: { width: 100 },
            placeholder: '\u8BF7\u586B\u5FAE\u4FE1\u53F7'
          }) : text;
        }
      }, {
        title: '删除',
        dataIndex: 'operation',
        width: 80,
        render: function render(text, record, index) {
          if (jtcy) {
            return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
              'div',
              { className: 'editable-row-operations' },
              __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                'a',
                { href: 'javascript:;', onClick: function onClick() {
                    return _this3.onjtcyClose(index);
                  } },
                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default.a, { type: 'close', style: { color: 'red' } })
              )
            );
          }
          return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
            'a',
            { href: 'javascript:;', onClick: function onClick() {
                return _this3.onjtcyClose();
              } },
            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon___default.a, { type: 'delete', style: { color: 'red' } })
          );
        }
      }];
      if (!jtcy) {
        jtcyColumns.pop();
      }
      return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_Assembly_titleTop__["a" /* default */], {
          title: '\u5BB6\u5EAD\u6210\u5458\u4FE1\u606F',
          onEdit: function onEdit(type) {
            _this3.setState({
              jtcy: true,
              jtcyAdd: true,
              cacheData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_deepCopy__["deepCopy"])(_this3.state.jtcyData)
            });
            getChildComponent(3, false);
          },
          onSave: function onSave(cb) {
            _this3.cacheJtcyData(cb);
          },
          onClose: function onClose() {
            _this3.setState({
              errorFiled: false,
              jtcy: false,
              jtcyAdd: false,
              jtcyData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_deepCopy__["deepCopy"])(_this3.state.cacheData)
            });
          }
        }),
        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a,
          null,
          __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
            'div',
            { className: 'p-sw' },
            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_table___default.a, { bordered: true, size: 'middle', pagination: false, dataSource: this.state.jtcyData, columns: jtcyColumns }),
            jtcyAdd && __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
              'div',
              {
                className: 'mt-10 app__css__app-pages-SelfHelp-updateInfo-__index__btn_add',

                onClick: function onClick() {
                  _this3.onjtcyAdd();
                }
              },
              '\u6DFB\u52A0\u5BB6\u5EAD\u6210\u5458'
            )
          )
        )
      );
    }
  }]);

  return JtcyInitForm;
}(__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);

var JtcyForm = __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.create()(JtcyInitForm);
/* harmony default export */ __webpack_exports__["a"] = (JtcyForm);

/***/ }),

/***/ 1135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_date_picker_style__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_date_picker__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__utils_RegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__index_css__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__index_css__);




















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }









if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_18_antd_lib_form___default.a.Item;
var RangePicker = __WEBPACK_IMPORTED_MODULE_16_antd_lib_date_picker___default.a.RangePicker;

var dateFormat = 'YYYY/MM/DD ';

var JyjlInitForm = function (_React$Component) {
    _inherits(JyjlInitForm, _React$Component);

    function JyjlInitForm(props) {
        _classCallCheck(this, JyjlInitForm);

        var _this = _possibleConstructorReturn(this, (JyjlInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default()(JyjlInitForm)).call(this, props));

        _this.cacheJyjlData = function (cb) {
            _this.props.form.validateFields(function (err, values) {
                if (err) return cb(false);
                //判断数据是否全部填写
                var dataList = [];
                var errorPhone = "";
                var errorList = [];
                if (_this.state.jyjlData && _this.state.jyjlData.length > 0) {
                    for (var i = 0; i < _this.state.jyjlData.length; i++) {
                        var data = _this.state.jyjlData[i];
                        var pattern = /^1\d{10}$/;
                        if (data.zmrlxfs) {
                            if (!pattern.test(data.zmrlxfs)) {
                                if (errorList.length == 0) {
                                    errorPhone += data.zmrlxfs;
                                } else {
                                    errorPhone += "," + data.zmrlxfs;
                                }
                                errorList.push(data);
                            }
                        }
                        if (!data.qsny && !data.xxjl && !data.zw && !data.zmr && !data.zmrlxfs && !data.operation) {} else {
                            dataList.push(data);
                        }
                    }
                }
                if (errorList && errorList.length > 0) {
                    __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error(errorPhone + '\u53F7\u7801\u586B\u5199\u9519\u8BEF');
                    return;
                }
                var _this$props = _this.props,
                    cacheFormData = _this$props.cacheFormData,
                    getChildComponent = _this$props.getChildComponent;

                getChildComponent(4, true);
                cacheFormData('jyjl', dataList, true);
                cb(true);
                _this.setState({
                    jyjl: false,
                    jyjlAdd: false
                });
            });
        };

        _this.validateFields = function (func) {
            var err = false;
            var formData = _this.state.jyjlData;
            func(err, formData);
        };

        _this.onjyjlAdd = function () {
            var _this$state = _this.state,
                jyjlAdd = _this$state.jyjlAdd,
                jyjlData = _this$state.jyjlData;

            if (!jyjlData) {
                jyjlData = [];
            }
            if (jyjlAdd) {
                jyjlData.push({
                    key: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["c" /* createUuid */])(),
                    qsny: '',
                    xxjl: '',
                    zw: '',
                    zmr: '',
                    zmrlxfs: '',
                    operation: ''
                });
                _this.setState({
                    jyjlData: jyjlData
                });
            }
            _this.setState({
                jyjlAdd: true
            });
        };

        _this.onjyjlSave = function () {
            var jyjlData = _this.state.jyjlData;

            jyjlData.push();
            _this.setState({
                jyjlData: jyjlData,
                jyjlAdd: false
            });
        };

        _this.onjyjlClose = function (index) {
            var jyjlData = _this.state.jyjlData;

            jyjlData.splice(index, 1);
            _this.setState({
                jyjlData: jyjlData,
                jyjlAdd: true
            });
        };

        _this.handleChange = function (value, index, key) {
            var jyjlData = _this.state.jyjlData;
            jyjlData[index][key] = value;
            _this.setState({ jyjlData: jyjlData });
        };

        _this.handleDateChange = function (value, index) {

            var jyjlData = _this.state.jyjlData;
            var kssj = value[0] ? __WEBPACK_IMPORTED_MODULE_20_moment___default()(value[0]).format(dateFormat) : undefined;
            var jssj = value[1] ? __WEBPACK_IMPORTED_MODULE_20_moment___default()(value[1]).format(dateFormat) : undefined;
            jyjlData[index]['kssj'] = kssj;
            jyjlData[index]['jssj'] = jssj;
            _this.setState({ jyjlData: jyjlData });
        };

        _this.deepCopy = function (obj) {
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                return obj;
            }

            if (_this.isArrayFn(obj)) {
                var newobj = [];
                for (var i = 0; i < obj.length; i++) {
                    newobj.push(_this.deepCopy(obj[i]));
                }
                return newobj;
            } else {
                var _newobj = {};
                for (var attr in obj) {
                    _newobj[attr] = _this.deepCopy(obj[attr]);
                }
                return _newobj;
            }
        };

        _this.isArrayFn = function (value) {
            if (typeof Array.isArray === "function") {
                return Array.isArray(value);
            } else {
                return Object.prototype.toString.call(value) === "[object Array]";
            }
        };

        _this.state = {
            jyjl: false,
            jyjlAdd: false,
            jyjlData: []
        };
        return _this;
    }

    _createClass(JyjlInitForm, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('jyjlInitData' in nextProps && nextProps.jyjlInitData) {
                if (nextProps.jyjlInitData instanceof Array) {
                    var temp = [].concat(_toConsumableArray(nextProps.jyjlInitData));
                    this.setState({ jyjlData: temp });
                }
            }
        }
    }, {
        key: 'disabledDate',
        value: function disabledDate(current) {
            // Can not select days after today and today
            return current && current > __WEBPACK_IMPORTED_MODULE_20_moment___default()().endOf('day');
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                getChildComponent = _props.getChildComponent,
                form = _props.form;
            var _state = this.state,
                jyjl = _state.jyjl,
                jyjlData = _state.jyjlData,
                jyjlAdd = _state.jyjlAdd;
            var getFieldDecorator = form.getFieldDecorator;

            var jyjlColumns = [{
                title: '起止年月',
                dataIndex: 'qsny',
                render: function render(text, record, index) {
                    var kssj = record.kssj;
                    var jssj = record.jssj;
                    return jyjl ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(RangePicker
                    // disabledDate={this.disabledDate}
                    , { value: kssj && jssj ? [__WEBPACK_IMPORTED_MODULE_20_moment___default()(kssj, dateFormat), __WEBPACK_IMPORTED_MODULE_20_moment___default()(jssj, dateFormat)] : undefined,
                        format: dateFormat,
                        onChange: function onChange(value) {
                            _this2.handleDateChange(value, index);
                        }
                    }) : (kssj ? kssj : '') + ' ~ ' + (jssj ? jssj : '');
                }
            }, {
                title: '在何地何学校',
                dataIndex: 'xxjl',
                render: function render(text, record, index) {
                    return jyjl ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this2.handleChange(e.target.value, index, 'xxjl');
                        },
                        style: { width: 140 },
                        placeholder: '\u8BF7\u586B\u5199\u5B66\u6821'
                    }) : text;
                }
            },
            // {
            //     title: '任何职',
            //     dataIndex: 'zw',
            //     render: (text, record,index) => {
            //         return jyjl ? (
            //             <Input     
            //                 value={text}
            //                 onChange={(e) =>{this.handleChange(e.target.value,index,'zw')}}         
            //                 style={{ width: 100 }}
            //                 placeholder="请填写职位"
            //             />
            //         ) : (
            //             text
            //         );
            //     }
            // },
            {
                title: '证明人',
                dataIndex: 'zmr',
                render: function render(text, record, index) {
                    return jyjl ? __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this2.handleChange(e.target.value, index, 'zmr');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u8BC1\u660E\u4EBA'
                    }) : text;
                }
            }, {
                title: '证明人联系电话',
                dataIndex: 'zmrlxfs',
                render: function render(text, record, index) {
                    return jyjl ?
                    // <FormItem form={form} style={{ marginBottom: '0px' }}>
                    //     {getFieldDecorator('zmrlxfs', {
                    //         rules: [
                    //             { required: true, message: '请填写电话' },
                    //             FormRules.MOBILE_PHONE_NUMBER
                    //         ],
                    //         initialValue: text
                    //     })(
                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        maxLength: 11,
                        onChange: function onChange(e) {
                            _this2.handleChange(e.target.value, index, 'zmrlxfs');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u7535\u8BDD'
                    })
                    /*   )}
                    </FormItem> */

                    : text;
                }
            }, {
                title: '删除',
                dataIndex: 'operation',
                width: 80,
                render: function render(text, record, index) {
                    if (jyjl) {
                        return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                            'div',
                            { className: 'editable-row-operations' },
                            __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                                'a',
                                {
                                    href: 'javascript:;',
                                    onClick: function onClick() {
                                        return _this2.onjyjlClose(index);
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, {
                                    type: 'close',
                                    style: { color: 'red' }
                                })
                            )
                        );
                    }
                    return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                        'a',
                        { href: '#' },
                        __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'delete', style: { color: 'red' } })
                    );
                }
            }];

            if (!jyjl) {
                jyjlColumns.pop();
            }
            return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u6559\u80B2\u7ECF\u5386\u4FE1\u606F',
                    onEdit: function onEdit(type) {
                        _this2.setState({
                            jyjl: true,
                            jyjlAdd: true,
                            cacheData: _this2.deepCopy(_this2.state.jyjlData)
                        });
                        getChildComponent(4, false);
                    },
                    onSave: function onSave(cb) {
                        _this2.cacheJyjlData(cb);
                    },
                    onClose: function onClose() {
                        _this2.setState({
                            jyjl: false,
                            jyjlAdd: false,
                            jyjlData: _this2.deepCopy(_this2.state.cacheData)
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a, {
                        bordered: true,
                        size: 'middle',
                        pagination: false,
                        dataSource: jyjlData,
                        columns: jyjlColumns
                    }),
                    jyjlAdd && __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
                        'div',
                        {
                            className: 'mt-10 app__css__app-pages-SelfHelp-updateInfo-__index__btn_add',

                            onClick: function onClick() {

                                _this2.onjyjlAdd();
                            }
                        },
                        '\u6DFB\u52A0\u6559\u80B2\u7ECF\u5386'
                    )
                )
            );
        }
    }]);

    return JyjlInitForm;
}(__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component);

var JyjlForm = __WEBPACK_IMPORTED_MODULE_18_antd_lib_form___default.a.create()(JyjlInitForm);
/* harmony default export */ __webpack_exports__["a"] = (JyjlForm);

/***/ }),

/***/ 1136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_custom_scrollbars__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_custom_scrollbars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_common_NHFormItem_FormRules__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__index_css__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components__ = __webpack_require__(10);



















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _extends = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _styleModuleImportMap = {
    './index.css': {
        'progress': 'app__css__app-pages-SelfHelp-updateInfo-__index__progress',
        'jbxx_icon': 'app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_icon',
        'upload-box': 'app__css__app-pages-SelfHelp-updateInfo-__index__upload-box',
        'upload-title': 'app__css__app-pages-SelfHelp-updateInfo-__index__upload-title',
        'jbxx_item': 'app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_item',
        'jbxx_item2': 'app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_item2',
        'item-label': 'app__css__app-pages-SelfHelp-updateInfo-__index__item-label',
        'item-name': 'app__css__app-pages-SelfHelp-updateInfo-__index__item-name',
        'kzxx_list': 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_list',
        'kzxx_item': 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_item',
        'kzxx_label': 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_label',
        'kzxx_name': 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_name',
        'kzxx_item_textarea': 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_item_textarea',
        'kzxx_name_textarea': 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_name_textarea',
        'btn_add': 'app__css__app-pages-SelfHelp-updateInfo-__index__btn_add',
        'title_top': 'app__css__app-pages-SelfHelp-updateInfo-__index__title_top',
        'title_top_name': 'app__css__app-pages-SelfHelp-updateInfo-__index__title_top_name',
        'line': 'app__css__app-pages-SelfHelp-updateInfo-__index__line',
        'detail_adrress': 'app__css__app-pages-SelfHelp-updateInfo-__index__detail_adrress'
    }
};

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }


















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;
var basicUrl = "/zzbd";
var stuInfoUrl = "/xxcj/";

//日期格式化
var dateFormat = 'YYYY-MM-DD';

var KzxxFormComponent = function (_React$Component) {
    _inherits(KzxxFormComponent, _React$Component);

    function KzxxFormComponent(props) {
        _classCallCheck(this, KzxxFormComponent);

        var _this = _possibleConstructorReturn(this, (KzxxFormComponent.__proto__ || __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default()(KzxxFormComponent)).call(this, props));

        _this.onSaveKzxx = function (cb) {
            _this.props.form.validateFields(function (error, values) {
                if (error) {
                    return;
                }
                _this.setState({
                    formData: _extends({}, values),
                    kzxx: false
                });
                var _this$props = _this.props,
                    cacheFormData = _this$props.cacheFormData,
                    getChildComponent = _this$props.getChildComponent;

                getChildComponent(2, true);
                __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys___default()(values).forEach(function (key) {
                    if (values[key] != null && values[key] != undefined) {
                        if (values[key].constructor.name == 'Moment') {//处理Moment格式的数据  
                            //values[key] = moment(values[key]).format(dateFormat); 
                        } else if (values[key].constructor.name == 'Array') {
                            if (_typeof(values[key]) === 'object') {
                                var isFileUpload = false;
                                var array = [];
                                var _iteratorNormalCompletion = true;
                                var _didIteratorError = false;
                                var _iteratorError = undefined;

                                try {
                                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(values[key]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                        var item = _step.value;

                                        if (item.hasOwnProperty('uuid') && item['uuid']) {
                                            isFileUpload = true;
                                            array.push(item['uuid']);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return) {
                                            _iterator.return();
                                        }
                                    } finally {
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }

                                if (isFileUpload) {
                                    values[key] = array.join(',');
                                } else {
                                    values[key] = values[key].join(',');
                                }
                            } else {
                                values[key] = values[key].join(',');
                            }
                        }
                    } else {
                        values[key] = '';
                    }
                });

                var postData = {
                    'xxcj': { 'xsid': _this.props.xsid, 'formData': _extends({}, values) },
                    'params': { 'zzbdhjid': _this.props.zzbdhjid, 'xsid': _this.props.xsid }
                };

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])('/newStudent/updateStuInfo', 'POST', postData).then(function (res) {
                    if (res && res.code == 200) {
                        __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.success("保存成功");
                        cb(true);
                        _this.props.reloadMenu();
                    } else {
                        __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error("保存失败");
                    }
                });
            });
        };

        _this.onChange = function (date, dateString) {}
        // console.log('date', date)
        // console.log('dateString', dateString)
        // if(date && dateString){
        //     //this.
        // }


        //获取下拉列表value对应的名称
        ;

        _this.getDmkMc = function (dmbz, zdbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])("/proData/selectDataList", "GET", { sign: dmbz }).then(function (res) {
                if (res) {
                    if (res.data) {
                        var dmkmcList = _this.state.dmkmcList;
                        dmkmcList[zdbz] = res.data;
                        _this.setState({
                            dmkmcList: dmkmcList
                        });
                    }
                }
            });
        };

        _this.getCascaderDmkMc = function (level, sign, cascaderValue, zdbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])("/proData/selectCascaderList", "GET", { level: level, sign: sign, cascaderValue: cascaderValue }).then(function (res) {
                if (res) {
                    if (res.data) {
                        var dmkmcList = _this.state.dmkmcList;
                        dmkmcList[level + zdbz] = res.data;
                        _this.setState({
                            dmkmcList: dmkmcList
                        });
                    }
                }
            });
        };

        _this.handlePreview = function (fjmc, fjid) {

            if (fjmc === "isImage") {
                _this.showPreview('anonymity/docrepo/download/file?attachmentId=' + fjid);
            } else {
                window.open('anonymity/docrepo/download/file?attachmentId=' + fjid);
            }
        };

        _this.showPreview = function (url) {
            _this.setState({
                previewImage: url,
                previewVisible: true
            });
        };

        _this.closeModal = function () {
            return _this.setState({ previewVisible: false });
        };

        _this.fileLists = function (fileLists) {
            {
                var items = [];

                var _loop = function _loop(key) {
                    var fileList = typeof fileLists[key] == 'string' ? fileLists[key].split(";") : fileLists[key];
                    items.push(__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                            'a',
                            { onClick: function onClick() {
                                    _this.handlePreview("file", fileList[0]);
                                } },
                            fileList[1]
                        )
                    ));
                };

                for (var key in fileLists) {
                    _loop(key);
                }
                return items;
            }
        };

        _this.imageLists = function (imageLists) {
            {
                var items = [];

                var _loop2 = function _loop2(key) {
                    var imageList = typeof imageLists[key] == 'string' ? imageLists[key].split(";") : imageLists[key];
                    items.push(__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        'span',
                        null,
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('img', { style: { height: "80px", width: "80px" }, src: "anonymity/docrepo/download/file?attachmentId=" + imageList,
                            onClick: function onClick() {
                                _this.handlePreview("isImage", imageList[0]);
                            } })
                    ));
                };

                for (var key in imageLists) {
                    _loop2(key);
                }
                return items;
            }
        };

        _this.state = {
            xsid: '',
            kzxx: false,
            scrollHeight: 0, //默认滚动高度
            initData: {}, //初始数据
            loading: false, //页面加载状态
            onSubmit: false, //保存按钮加载状态
            isShow: false,
            previewVisible: false,
            formData: '',
            dmkmcList: {},
            zdzmc: ''
        };
        return _this;
    }

    //控件回调

    //获取联级下拉列表value对应的名称

    // 点击文件链接或预览图标时的回调


    //打开图片弹窗

    // 关闭图片弹窗

    // 文件展示 

    //图片展示


    _createClass(KzxxFormComponent, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                form = _props.form,
                getChildComponent = _props.getChildComponent,
                initData = _props.initData;
            var _state = this.state,
                kzxx = _state.kzxx,
                formData = _state.formData,
                previewVisible = _state.previewVisible,
                previewImage = _state.previewImage;
            //提示信息

            var AlertParams = {
                message: '当前没有需要填写的信息',
                description: '',
                type: 'info'
                //信息采集字段分类
            };var infoItems = [];
            var reactid = 0;
            if (initData) {
                //表单信息、表单字段信息
                var _initData$zdglVOs = initData.zdglVOs,
                    zdglVOs = _initData$zdglVOs === undefined ? [] : _initData$zdglVOs;

                if (zdglVOs != null) {
                    if (zdglVOs.length > 0) {
                        var array = [];
                        //循环过滤出多行文本框的key，偶数在左，奇数在右，相应的同行的另一条文本也需要加宽
                        for (var key in zdglVOs) {
                            var kjcs = zdglVOs[key].kjcs;

                            var kjcsjson = JSON.parse(kjcs);
                            if (kjcsjson.type === "textarea" || kjcsjson.type === "oldupload" || kjcsjson.type === "upload") {
                                if (key % 2 === 0) {
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key));
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key) + 1);
                                } else {
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key));
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key) - 1);
                                }
                            }
                        }
                        //显示表单字段信息

                        var _loop3 = function _loop3(_key) {
                            //字段状态、是否必填、默认值、字段标识、字段名称、控件参数、字段值
                            var _zdglVOs$_key = zdglVOs[_key],
                                zdbz = _zdglVOs$_key.zdbz,
                                zdmc = _zdglVOs$_key.zdmc,
                                kjcs = _zdglVOs$_key.kjcs,
                                zdz = _zdglVOs$_key.zdz,
                                sfbt = _zdglVOs$_key.sfbt,
                                mrz = _zdglVOs$_key.mrz,
                                zdzt = _zdglVOs$_key.zdzt; //表单字段

                            var zdzmc = '';
                            var kjcsjson = JSON.parse(kjcs);
                            if (formData && formData[zdbz] != null) {
                                zdz = formData[zdbz];
                            }
                            if (kjcsjson.type === 'datepicker' || kjcsjson.type === 'datetimepicker' || kjcsjson.type === 'timepicker' || kjcsjson.type === 'monthpicker' || kjcsjson.type === 'rangepicker') {
                                //日期值展示阶段，从moment转为文字 
                                if (zdz) {
                                    zdzmc = __WEBPACK_IMPORTED_MODULE_27_moment___default()(zdz).format(kjcsjson.format);
                                }
                            } else if (kjcsjson.type === "select") {
                                if (kjcsjson.dataTag && !_this2.state.dmkmcList[zdbz]) {
                                    _this2.getDmkMc(kjcsjson.dataTag, zdbz);
                                }
                                var list = _this2.state.dmkmcList[zdbz];
                                list && list.map(function (item) {
                                    if (item.VALUE === zdz) {
                                        zdzmc = item.LABEL;
                                    }
                                });
                            } else if (kjcsjson.type === "multiselect") {
                                if (kjcsjson.dataTag && !_this2.state.dmkmcList[zdbz]) {
                                    _this2.getDmkMc(kjcsjson.dataTag, zdbz);
                                }
                                var _list = _this2.state.dmkmcList[zdbz];
                                if (zdz) {
                                    (function () {
                                        var multiselect = typeof zdz == 'string' ? zdz.split(",") : zdz;
                                        var multiselectList = [];

                                        var _loop4 = function _loop4(i) {
                                            _list && _list.map(function (item) {
                                                if (item.VALUE === multiselect[i]) {
                                                    multiselectList.push(item.LABEL);
                                                }
                                            });
                                        };

                                        for (var i in multiselect) {
                                            _loop4(i);
                                        }
                                        zdzmc = multiselectList.join(",");
                                    })();
                                }
                            } else if (kjcsjson.type === "nhcascader") {
                                if (zdz) {
                                    (function () {
                                        var nhcascaderList = typeof zdz == 'string' ? zdz.split(",") : zdz;
                                        var nhcascaderLists = [];

                                        var _loop5 = function _loop5(i) {
                                            var level = i;
                                            var c = i;
                                            var d = i;
                                            var a = ++level;
                                            var b = --d;
                                            if (kjcsjson.dataTag && !_this2.state.dmkmcList[a + zdbz]) {
                                                if (i == "0") {
                                                    _this2.getCascaderDmkMc(a, kjcsjson.dataTag, '', zdbz);
                                                } else {
                                                    _this2.getCascaderDmkMc(a, kjcsjson.dataTag, nhcascaderList[b], zdbz);
                                                }
                                            }
                                            var list = _this2.state.dmkmcList[level++ + zdbz];

                                            list && list.map(function (item) {
                                                if (item.value === nhcascaderList[c]) {
                                                    nhcascaderLists.push(item.label);
                                                }
                                            });
                                        };

                                        for (var i in nhcascaderList) {
                                            _loop5(i);
                                        }
                                        zdzmc = nhcascaderLists.join("/");
                                    })();
                                }
                            } else if (kjcsjson.type === "switch") {
                                zdzmc = zdz === "1" || zdz === true ? kjcsjson.checkedText : kjcsjson.uncheckedText;
                            } else if (kjcsjson.type === "radio") {
                                kjcsjson.options && kjcsjson.options.map(function (item, key) {
                                    if (item.value === zdz) {
                                        zdzmc = item.label;
                                    }
                                });
                            } else if (kjcsjson.fileType === "file" && zdz) {
                                var fileLists = typeof zdz == 'string' ? zdz.split(",") : zdz;
                                zdzmc = _this2.fileLists(fileLists);
                            } else if (kjcsjson.fileType === "image" && zdz) {
                                if ((typeof zdz === 'undefined' ? 'undefined' : _typeof(zdz)) === 'object') {
                                    var _array = [];
                                    var _iteratorNormalCompletion2 = true;
                                    var _didIteratorError2 = false;
                                    var _iteratorError2 = undefined;

                                    try {
                                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(zdz), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                            var item = _step2.value;

                                            if (item.hasOwnProperty('uuid') && item['uuid']) {
                                                _array.push(item['uuid']);
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError2 = true;
                                        _iteratorError2 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                                _iterator2.return();
                                            }
                                        } finally {
                                            if (_didIteratorError2) {
                                                throw _iteratorError2;
                                            }
                                        }
                                    }

                                    zdz = _array;
                                } else {
                                    zdz = zdz.split(",");
                                }
                                zdzmc = _this2.imageLists(zdz);
                            } else {
                                zdzmc = zdz;
                            }
                            var required = sfbt === '1' ? true : false;

                            var formItem = void 0;
                            var csz = formData ? formData[zdbz] : zdz;
                            if (required) {
                                formItem = kjcsjson.type === 'textarea' || kjcsjson.type === "oldupload" || kjcsjson.type === "upload" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { minHeight: "120px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item_textarea", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_label' },
                                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                            'span',
                                            { style: { color: 'red' } },
                                            '*'
                                        ),
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_name_textarea' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs }) : zdzmc
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { minHeight: "71px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_label' },
                                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                            'span',
                                            { style: { color: 'red' } },
                                            '*'
                                        ),
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_name' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs,
                                            onChange: _this2.onChange }) : zdzmc
                                    )
                                );
                            } else {
                                formItem = kjcsjson.type === 'textarea' || kjcsjson.type === "oldupload" || kjcsjson.type === "upload" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { minHeight: "120px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item_textarea", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_label' },
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_name_textarea' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs }) : zdzmc
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { minHeight: "71px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_label' },
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_name' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs,
                                            onChange: _this2.onChange }) : zdzmc
                                    )
                                );
                            }
                            infoItems.push(formItem);
                        };

                        for (var _key in zdglVOs) {
                            _loop3(_key);
                        }
                    } else {
                        //未找到表单配置的采集字段信息
                        AlertParams['message'] = '暂时没有需要填写的信息';
                        AlertParams['description'] = '当前未配置采集信息项';
                        AlertParams['type'] = 'warning';
                    }
                }
            }

            return __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                'div',
                {
                    className: 'jsx-2266704716'
                },
                infoItems.length > 0 && __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                    'div',
                    {
                        className: 'jsx-2266704716'
                    },
                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__pages_Assembly_titleTop__["a" /* default */], {
                        title: '\u6269\u5C55\u4FE1\u606F',
                        onEdit: function onEdit(type) {
                            _this2.setState({
                                kzxx: true
                            });
                            getChildComponent(2, false);
                        },
                        onSave: function onSave(cb) {
                            _this2.onSaveKzxx(cb);
                        },
                        onClose: function onClose() {
                            _this2.setState({
                                kzxx: false
                            });
                        }
                    }),
                    infoItems.length > 0 ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a,
                        null,
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-2266704716' + ' ' + 'p-sw'
                            },
                            __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-2266704716' + ' ' + 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_list'
                                },
                                infoItems
                            )
                        )
                    ) : __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default.a, _extends({ style: { marginTop: 20 }
                    }, AlertParams, {
                        showIcon: true
                    })),
                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a,
                        {
                            visible: previewVisible,
                            footer: null,
                            onCancel: this.closeModal
                        },
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('img', {
                            alt: 'example',
                            style: { width: '100%' },
                            src: previewImage,
                            className: 'jsx-2266704716'
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_styled_jsx_style___default.a, {
                    styleId: '2266704716',
                    css: ['.app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_item{height:100% !important;}', '.app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_label{background-color:#fff;}', '.app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_name{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;width:67%;}']
                })
            );
        }
    }]);

    return KzxxFormComponent;
}(__WEBPACK_IMPORTED_MODULE_20_react___default.a.Component);

var KzxxForm = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create()(KzxxFormComponent);
/* harmony default export */ __webpack_exports__["a"] = (KzxxForm);

/***/ }),

/***/ 1137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__utils_RegExp__);



















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }









if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;

var ZyshgxInitForm = function (_React$Component) {
    _inherits(ZyshgxInitForm, _React$Component);

    function ZyshgxInitForm(props) {
        _classCallCheck(this, ZyshgxInitForm);

        var _this = _possibleConstructorReturn(this, (ZyshgxInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default()(ZyshgxInitForm)).call(this, props));

        _this.cacheZyshgxData = function (cb) {
            _this.props.form.validateFields(function (err, values) {
                if (err) return cb(false);
                //判断数据是否全部填写
                var dataList = [];
                var errorPhone = "";
                var errorList = [];
                if (_this.state.zyshgxData && _this.state.zyshgxData.length > 0) {
                    for (var i = 0; i < _this.state.zyshgxData.length; i++) {
                        var data = _this.state.zyshgxData[i];
                        var pattern = /^1\d{10}$/;
                        if (data.lxfs) {
                            if (!pattern.test(data.lxfs)) {
                                if (errorList.length == 0) {
                                    errorPhone += data.lxfs;
                                } else {
                                    errorPhone += "," + data.lxfs;
                                }
                                errorList.push(data);
                            }
                        }
                        if (!data.gx && !data.xm && !data.gzxxdw && !data.lxfs && !data.operation) {} else {
                            dataList.push(data);
                        }
                    }
                }
                if (errorList && errorList.length > 0) {
                    __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default.a.error(errorPhone + '\u53F7\u7801\u586B\u5199\u9519\u8BEF');
                    return;
                }
                var _this$props = _this.props,
                    cacheFormData = _this$props.cacheFormData,
                    getChildComponent = _this$props.getChildComponent;

                getChildComponent(3, true);
                cacheFormData('zyshgx', dataList, true);
                cb(true);
                _this.setState({
                    zyshgx: false,
                    zyshgxAdd: false
                });
            });
        };

        _this.onzyshgxAdd = function () {
            var _this$state = _this.state,
                zyshgxAdd = _this$state.zyshgxAdd,
                zyshgxData = _this$state.zyshgxData;

            if (!zyshgxData) {
                zyshgxData = [];
            }

            if (zyshgxAdd) {
                zyshgxData.push({
                    key: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["c" /* createUuid */])(),
                    gx: '',
                    xm: '',
                    gzxxdw: '',
                    zzmmm: '',
                    lxfs: '',
                    operation: ''
                });
                _this.setState({
                    zyshgxData: zyshgxData
                });
            }
            _this.setState({
                zyshgxAdd: true
            });
        };

        _this.onzyshgxSave = function () {
            var zyshgxData = _this.state.zyshgxData;

            zyshgxData.push();
            _this.setState({
                zyshgxData: zyshgxData,
                zyshgxAdd: false
            });
        };

        _this.onzyshgxClose = function (index) {
            var zyshgxData = _this.state.zyshgxData;

            zyshgxData.splice(index, 1);
            _this.setState({
                zyshgxData: zyshgxData,
                zyshgxAdd: true
            });
        };

        _this.handleChange = function (value, index, key) {
            var zyshgxData = _this.state.zyshgxData;
            zyshgxData[index][key] = value;
            _this.setState({ zyshgxData: zyshgxData });
        };

        _this.getzzmmmStr = function (value) {
            var temp = '';
            _this.state.zzmmmList.forEach(function (i) {
                if (i.value === value) {
                    temp = i.label;
                }
            });
            return temp;
        };

        _this.deepCopy = function (obj) {
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                return obj;
            }

            if (_this.isArrayFn(obj)) {
                var newobj = [];
                for (var i = 0; i < obj.length; i++) {
                    newobj.push(_this.deepCopy(obj[i]));
                }
                return newobj;
            } else {
                var _newobj = {};
                for (var attr in obj) {
                    _newobj[attr] = _this.deepCopy(obj[attr]);
                }
                return _newobj;
            }
        };

        _this.isArrayFn = function (value) {
            if (typeof Array.isArray === "function") {
                return Array.isArray(value);
            } else {
                return Object.prototype.toString.call(value) === "[object Array]";
            }
        };

        _this.state = {
            zyshgx: false,
            zyshgxAdd: false,
            zyshgxData: [],
            zzmmmList: [],
            tempStr: ''
        };
        return _this;
    }

    _createClass(ZyshgxInitForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])('/proData/selectDataList?&sign=DMK_XTGL_ZZMMM', 'GET').then(function (res) {
                if (res && res.data) {
                    var zzmmmList = [];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default()(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var obj = _step.value;

                            zzmmmList.push({ 'label': obj.LABEL, 'value': obj.VALUE });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this2.setState({ zzmmmList: zzmmmList });
                }
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('zyshgxInitData' in nextProps && nextProps.zyshgxInitData) {
                if (nextProps.zyshgxInitData instanceof Array) {
                    var temp = [].concat(_toConsumableArray(nextProps.zyshgxInitData));
                    this.setState({ zyshgxData: temp });
                }
            }
        }

        // 家庭成员 添加

        // 家庭成员 保存添加

        // 家庭成员 关闭添加

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _state = this.state,
                zyshgx = _state.zyshgx,
                zyshgxData = _state.zyshgxData,
                zyshgxAdd = _state.zyshgxAdd;
            var _props = this.props,
                getChildComponent = _props.getChildComponent,
                form = _props.form;
            var getFieldDecorator = form.getFieldDecorator;

            var zyshgxColumns = [{
                title: '关系',
                key: 'gx',
                dataIndex: 'gx',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'gx');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u5173\u7CFB'
                    }) : text;
                }
            }, {
                title: '姓名',
                dataIndex: 'xm',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'xm');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u59D3\u540D'
                    }) : text;
                }
            }, {
                title: '工作单位及职务',
                dataIndex: 'gzxxdw',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'gzxxdw');
                        },
                        style: { width: 140 },
                        placeholder: '\u8BF7\u586B\u5199\u5355\u4F4D\u548C\u804C\u52A1'
                    }) : text;
                }
            }, {
                title: '联系电话',
                dataIndex: 'lxfs',
                render: function render(text, record, index) {
                    return zyshgx ?
                    // <FormItem form={form} style={{ marginBottom: '0px' }}>
                    //     {getFieldDecorator('lxfs', {
                    //         rules: [
                    //             { required: true, message: '请填写电话' },
                    //             FormRules.MOBILE_PHONE_NUMBER
                    //         ],
                    //         initialValue: text
                    //     })(
                    __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        maxLength: 11,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'lxfs');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u7535\u8BDD'
                    })
                    /* )}
                    </FormItem> */

                    : text;
                }
            }, {
                title: 'QQ',
                dataIndex: 'qq',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'qq');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586BQQ\u53F7'
                    }) : text;
                }
            }, {
                title: '微信',
                dataIndex: 'wx',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'wx');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5FAE\u4FE1\u53F7'
                    }) : text;
                }
            }, {
                title: '删除',
                dataIndex: 'operation',
                width: 80,
                render: function render(text, record, index) {
                    if (zyshgx) {
                        return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                            'div',
                            { className: 'editable-row-operations' },
                            __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                                'a',
                                {
                                    href: 'javascript:;',
                                    onClick: function onClick() {
                                        return _this3.onzyshgxClose(index);
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, {
                                    type: 'close',
                                    style: { color: 'red' }
                                })
                            )
                        );
                    }
                    return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                        'a',
                        { href: 'javascript:;', onClick: function onClick() {
                                return _this3.onzyshgxClose();
                            } },
                        __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'delete', style: { color: 'red' } })
                    );
                }
            }];
            if (!zyshgx) {
                zyshgxColumns.pop();
            }
            return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u4E3B\u8981\u793E\u4F1A\u5173\u7CFB',
                    onEdit: function onEdit(type) {
                        _this3.setState({
                            zyshgx: true,
                            zyshgxAdd: true,
                            cacheData: _this3.deepCopy(_this3.state.zyshgxData)
                        });
                        getChildComponent(3, false);
                    },
                    onSave: function onSave(cb) {
                        _this3.cacheZyshgxData(cb);
                    },
                    onClose: function onClose() {
                        _this3.setState({
                            zyshgx: false,
                            zyshgxAdd: false,
                            zyshgxData: _this3.deepCopy(_this3.state.cacheData)
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a,
                    null,
                    __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                        'div',
                        { className: 'p-sw' },
                        __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a, {
                            bordered: true,
                            size: 'middle',
                            pagination: false,
                            dataSource: zyshgxData,
                            columns: zyshgxColumns
                        }),
                        zyshgxAdd && __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                            'div',
                            {
                                className: 'mt-10 app__css__app-pages-SelfHelp-updateInfo-__index__btn_add',

                                onClick: function onClick() {

                                    _this3.onzyshgxAdd();
                                }
                            },
                            '\u6DFB\u52A0\u4E3B\u8981\u793E\u4F1A\u5173\u7CFB'
                        )
                    )
                )
            );
        }
    }]);

    return ZyshgxInitForm;
}(__WEBPACK_IMPORTED_MODULE_18_react___default.a.Component);

var ZyshgxForm = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create()(ZyshgxInitForm);
/* harmony default export */ __webpack_exports__["a"] = (ZyshgxForm);

/***/ }),

/***/ 1138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UpdateInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker_style__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_date_picker__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__JbxxForm__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__JtcyForm__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ZyshgxForm__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__JyjlForm__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__KzxxForm__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_common_hint__ = __webpack_require__(35);












var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }






















if (false) {
  module.hot.accept('./index.css', function () {
    require('./index.css');
  });
}

var history = __WEBPACK_IMPORTED_MODULE_25_history_createHashHistory___default()();
var RangePicker = __WEBPACK_IMPORTED_MODULE_10_antd_lib_date_picker___default.a.RangePicker;

var Option = __WEBPACK_IMPORTED_MODULE_8_antd_lib_select___default.a.Option;
var stuInfoUrl = '/xxcj/';

var UpdateInfo = function (_React$Component) {
  _inherits(UpdateInfo, _React$Component);

  function UpdateInfo(props) {
    _classCallCheck(this, UpdateInfo);

    var _this = _possibleConstructorReturn(this, (UpdateInfo.__proto__ || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default()(UpdateInfo)).call(this, props));

    _this.queryQztjAndYlhj = function () {
      var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : '';
      if (!xsid) {
        _this.setState({
          nonOperationalData: { nologin: true },
          operable: false
        });
        return;
      }
      var zzbdhjid = _this.getQueryString('pkid');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/zzbd/queryQztjAndYlhj', 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
        if (res && res.data) {
          var kfsj = res.data['kfsj'];
          var ylhj = res.data['ylhj'];
          var qzhj = res.data['qzhj'];
          _this.setState({
            nonOperationalData: res.data,
            zzbdhjid: zzbdhjid
          });
          if (kfsj['YXSJ'] != '1') {
            _this.setState({ operable: false });
          }

          if (ylhj && ylhj.length > 0) {
            _this.setState({ operable: false });
          }

          if (qzhj && qzhj.length > 0) {
            _this.setState({ operable: false });
          }
        }
      });
    };

    _this.getQueryString = function (name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
    };

    _this.setMenuList = function (menuList) {
      var nextCount = 0;
      var bz = _this.state.mkbz;
      menuList.map(function (elem, index) {
        if (elem.HJDM == bz) {
          var hjmc = elem.HJMC;
          _this.setState({ hjmc: hjmc });
          nextCount = index + 1;
          return;
        }
      });
      var menu = menuList[nextCount];
      if (menu) {
        var hjdm = menu.HJDM;
        if (hjdm.indexOf('GD') == 0) {
          var gdUrl = __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
          _this.setState({
            nextUrl: gdUrl,
            search: 'pkid=' + menu.PKID
          });
        } else if (hjdm.indexOf('ZDY') == 0) {
          var zdyUrl = '/customLink';
          _this.setState({
            nextUrl: zdyUrl,
            search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
          });
        }
      } else {
        _this.setState({
          nextUrl: '',
          search: ''
        });
      }
    };

    _this.getChildComponent = function (flag, mode) {
      switch (flag) {
        case 1:
          _this.setState({ jbxxFlag: mode });
          break;
        case 2:
          _this.setState({ kzxxFlag: mode });
          break;
        case 3:
          _this.setState({ jtcyFlag: mode });
          break;
        case 4:
          _this.setState({ zyshgxFlag: mode });
          break;
        case 5:
          _this.setState({ jyjlFlag: mode });
          break;
        default:
          break;
      }
    };

    _this.cacheFormData = function (type, values, isAdd) {
      //const{jbxxInitData} = this.state;
      if (type == 'jbxx') {
        var sjhm = values.sjhm,
            jtszdqArray = values.jtszdqArray,
            jtjddz = values.jtjddz;

        if (sjhm !== null && jtszdqArray !== null && jtszdqArray.length > 0 && jtjddz !== null) {
          _this.setState({
            jbxxInitData: _extends({}, values),
            isEditJbxx: true
          }, function () {
            _this.insertData4Yxwz();
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error('存在必填信息未填写，请填写后再保存！');
        }
      }
      if (type == 'jtcy' && isAdd) {
        var zyshgxInitData = _this.state.zyshgxInitData;

        if (zyshgxInitData !== null && zyshgxInitData.length > 0) {
          _this.setState({
            jtcyInitData: values,
            isEditJtcy: true
          }, function () {
            _this.insertData4Yxwz();
          });
        } else if (values !== null && values.length > 0) {
          _this.setState({
            jtcyInitData: values,
            isEditJtcy: true
          }, function () {
            _this.insertData4Yxwz();
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error('家庭成员信息和主要社会关系至少要填一项！');
        }
      }
      if (type == 'zyshgx' && isAdd) {
        var jtcyInitData = _this.state.jtcyInitData;

        if (jtcyInitData !== null && jtcyInitData.length > 0) {
          _this.setState({
            zyshgxInitData: values,
            isEditZyshgx: true
          }, function () {
            _this.insertData4Yxwz();
          });
        } else if (values !== null && values.length > 0) {
          _this.setState({
            zyshgxInitData: values,
            isEditZyshgx: true
          }, function () {
            _this.insertData4Yxwz();
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error('家庭成员信息和主要社会关系至少要填一项！');
        }
      }
      if (type == 'jyjl') {
        if (values !== null && values.length > 0) {
          _this.setState({
            jyjlInitData: values,
            isEditJyjl: true
          }, function () {
            _this.insertData4Yxwz();
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error('教育经历信息不能为空！');
        }
      }
    };

    _this.getData4Yxwz = function () {
      var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
      if (userId) {
        _this.setState({ xsid: userId });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/newStudent/queryStuInfo', 'GET', { xsid: userId }).then(function (res) {
          if (res && res.data) {
            var stuInfo = res.data.stuInfo;
            var stuXxcj = res.data.stuXxcj;
            var stuSsxx = res.data.stuSsxx;
            var editXszp = res.data.editXszp;

            _this.setState({
              userBaseInfo: stuInfo.userBaseInfo,
              jbxxInitData: stuInfo.xsJbxx4YxwzVO,
              jtcyInitData: stuInfo.jtcyVO ? stuInfo.jtcyVO.filter(function (item) {
                return item !== null;
              }) : stuInfo.jtcyVO,
              zyshgxInitData: stuInfo.zyshgxVO,
              jyjlInitData: stuInfo.jyjlVO,
              kzxxInitData: _extends({}, stuXxcj),
              stuSsxx: stuSsxx,
              editXszp: editXszp
            });
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error('登录超时,请重新登录！');
      }
    };

    _this.insertData4Yxwz = function () {
      var postFormData = {};
      var _this$state = _this.state,
          jbxxInitData = _this$state.jbxxInitData,
          jtcyInitData = _this$state.jtcyInitData,
          zyshgxInitData = _this$state.zyshgxInitData,
          jyjlInitData = _this$state.jyjlInitData,
          xsid = _this$state.xsid,
          zzbdhjid = _this$state.zzbdhjid;

      postFormData['xsid'] = xsid;
      postFormData['xsJbxx4YxwzVO'] = jbxxInitData;
      postFormData['jtcyVO'] = jtcyInitData;
      postFormData['zyshgxVO'] = zyshgxInitData;
      postFormData['jyjlVO'] = jyjlInitData;

      var postData = {
        xsInfo4YxwzVO: postFormData,
        params: { zzbdhjid: zzbdhjid, xsid: xsid }

        //必填一
      };var _postData$xsInfo4Yxwz = postData.xsInfo4YxwzVO.xsJbxx4YxwzVO,
          sjhm = _postData$xsInfo4Yxwz.sjhm,
          jtszdqArray = _postData$xsInfo4Yxwz.jtszdqArray,
          jtjddz = _postData$xsInfo4Yxwz.jtjddz;

      var jbxxFlag = false;
      if (sjhm !== null && jtszdqArray !== null && jtszdqArray.length > 0 && jtjddz !== null) {
        jbxxFlag = true;
      }
      //必填项二：两个填一个
      var _postData$xsInfo4Yxwz2 = postData.xsInfo4YxwzVO,
          jtcyVO = _postData$xsInfo4Yxwz2.jtcyVO,
          zyshgxVO = _postData$xsInfo4Yxwz2.zyshgxVO,
          jyjlVO = _postData$xsInfo4Yxwz2.jyjlVO;

      var jtxxFlag = false;
      if (jtcyVO !== null && jtcyVO.length > 0 || zyshgxVO !== null && zyshgxVO.length > 0) {
        var zum = 0;
        console.log('222', jtcyVO);
        //   jtcyVO.forEach((item,i)=>{
        if (jtcyVO !== null) {
          for (var i = 0; i < jtcyVO.length; i++) {
            if (jtcyVO[i].xm != '' && jtcyVO[i].gx != '') {
              zum++;
            }
          }
          //   })
          console.log('99', zum);
          if (zum == jtcyVO.length) {
            jtxxFlag = true;
          } else {
            __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error('家庭成员关系不能为空，请完善好家庭成员关系');
          }
        }
        if (zyshgxVO !== null) {
          var sum = 0;
          for (var j = 0; j < zyshgxVO.length; j++) {
            if (zyshgxVO[j].xm != '' && zyshgxVO[j].gx != '') {
              sum++;
            }
          }
          if (sum == zyshgxVO.length) {
            jtxxFlag = true;
          } else {
            __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error('请完善好主要社会关系');
          }
        }
      }
      //必填三
      var jyxxFlag = false;
      if (jyjlVO !== null && jyjlVO.length > 0) {
        jyxxFlag = true;
      }
      var hjblFlag = false;
      if (jbxxFlag || jtxxFlag || jyxxFlag) {
        hjblFlag = true;
      }
      postData.params.hjblFlag = hjblFlag;
      console.log('243278', hjblFlag);
      if (hjblFlag == true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/newStudent/updateStuInfo', 'POST', postData).then(function (res) {
          if (res && res.code == 200) {
            __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.success('保存成功');
            _this.reloadMenu();
          } else {
            __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error('保存失败');
          }
        });
      }
    };

    _this.reloadMenu = function () {
      _this.refs.siderMenu.reloadMenuList();
    };

    _this.state = {
      mkbz: 'GD001',
      hjmc: '',
      jbxxFormData: {},
      formInitData: {},
      jbxxInitData: {},
      jtcyInitData: [],
      zyshgxInitData: [],
      jyjlInitData: [],
      kzxxInitData: {},
      userBaseInfo: {},
      stuSsxx: {},
      xsid: '',
      jbxxFlag: true,
      kzxxFlag: true,
      jtcyFlag: true,
      zyshgxFlag: true,
      jyjlFlag: true,
      nextUrl: '', //左侧菜单加载完后传进来
      search: '',
      operable: true, //是否显示环节
      nonOperationalData: {}, //不可操作的数据
      isEditJbxx: false,
      isEditJtcy: false,
      isEditZyshgx: false,
      isEditJyjl: false,
      menuList: [],
      zzbdhjid: ''
    };
    return _this;
  }

  _createClass(UpdateInfo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.queryQztjAndYlhj();
      //this.getYlhjData();
      this.getData4Yxwz();
    }

    //查询前置条件和依赖环节


    //缓存编写的信息，缓存完之后提交


    //重新加载菜单

  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          xsid = _state.xsid,
          jtcyInitData = _state.jtcyInitData,
          zyshgxInitData = _state.zyshgxInitData;


      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
        'div',
        null,
        this.state.operable ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__components__["a" /* Flex */],
          { className: 'w1180 mt-20', align: 'start' },
          __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_Assembly_siderMenu__["a" /* default */], {
            ref: 'siderMenu',
            setMenuList: this.setMenuList,
            title: '\u81EA\u52A9\u62A5\u5230'
            /*   active={0}*/
            , mkbz: this.state.mkbz,
            menuType: '\u81EA\u52A9\u62A5\u5230'
          }),
          __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13__components__["a" /* Flex */].Item,
            { className: 'page_con_r' },
            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__pages_Assembly_Breadcrumb__["a" /* default */], { noLine: true, list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }] }),
            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
              'div',
              { className: 'box' },
              __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_common_hint__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__JbxxForm__["a" /* default */], {
                ref: 'refJbxxForm',
                jbxxFormData: this.state.jbxxInitData,
                getChildComponent: this.getChildComponent,
                cacheFormData: this.cacheFormData,
                userInfoData: this.state.userBaseInfo,
                stuSsxx: this.state.stuSsxx,
                editXszp: this.state.editXszp
              }),
              __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__KzxxForm__["a" /* default */], {
                ref: 'refKzxxForm',
                getChildComponent: this.getChildComponent,
                reloadMenu: this.reloadMenu,
                xsid: this.state.xsid,
                zzbdhjid: this.state.zzbdhjid,
                initData: this.state.kzxxInitData
              }),
              __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__JtcyForm__["a" /* default */], { ref: 'refJtcyForm', jtcyInitData: this.state.jtcyInitData, getChildComponent: this.getChildComponent, cacheFormData: this.cacheFormData }),
              __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__ZyshgxForm__["a" /* default */], { ref: 'refZyshgxForm', zyshgxInitData: this.state.zyshgxInitData, getChildComponent: this.getChildComponent, cacheFormData: this.cacheFormData }),
              __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__JyjlForm__["a" /* default */], { ref: 'refJyjlForm', jyjlInitData: this.state.jyjlInitData, getChildComponent: this.getChildComponent, cacheFormData: this.cacheFormData }),
              __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                'div',
                { className: 'p-sw text-center mt-30' },
                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
              )
            )
          )
        ) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__common__["a" /* default */], { hjmc: '个人信息填写', key: 'GD001', mkbz: 'GD001', nonOperationalData: this.state.nonOperationalData })
      );
    }
  }]);

  return UpdateInfo;
}(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);



/***/ }),

/***/ 1139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_common_NHCascader__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__utils_RegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_moment__);













var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }













if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var uploadUrl = "api/zhxg-yxwz/newStudent/cacheStudentPhoto"; //上传logo路径


function beforeUpload(file) {

    var isJPG = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJPG) {
        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("You can only upload JPG file!");
    }
    var isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("Image must smaller than 2MB!");
    }
    return isJPG && isLt2M;
}

var JbxxInitForm = function (_React$Component) {
    _inherits(JbxxInitForm, _React$Component);

    function JbxxInitForm(props) {
        _classCallCheck(this, JbxxInitForm);

        var _this = _possibleConstructorReturn(this, (JbxxInitForm.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(JbxxInitForm)).call(this, props));

        _this.getStudentPhotoBase64 = function (userId, callback) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/openapi/student/getStudentPhotoBase64', 'get', { xsid: userId, type: 10 }).then(function (res) {
                if (res && res.code == 200) {
                    callback(res.data);
                }
            });
        };

        _this.onSavejbxxFormData = function (cb) {
            _this.props.form.validateFields(function (error, values) {
                if (error) {
                    cb(false);
                    return;
                }
                cb(true);
                var cacheFormData = _this.props.cacheFormData;

                if (_this.state.jtStr !== '') {
                    values.jtdzDetail = _this.state.jtStr;
                } else {
                    values.jtdzDetail = _this.props.jbxxFormData ? _this.props.jbxxFormData.jtdzDetail ? _this.props.jbxxFormData.jtdzDetail : "" : "";
                }
                cacheFormData('jbxx', values);
                _this.setState({
                    jbxx: false
                });
            });
        };

        _this.handleUploadChange = function (info) {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (info && info['file'] && info['file'].status === 'done') {
                var photoUUID = info['file'].response.data;
                if (photoUUID) {
                    var url = '/newStudent/saveStudentPhoto?xsid=' + userId + '&photoUUID=' + photoUUID + '&type=' + '10';
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])(url, 'POST').then(function (res) {
                        if (res && res.data) {
                            __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.success("上传成功!");
                        }
                    });
                }
            }
            _this.getBase64(info.file.originFileObj, function (imageUrl) {
                return _this.setState({ imageUrl: imageUrl });
            });
        };

        _this.onNHCascaderChange = function (value, selectedOptions, type) {
            var label = '';
            if (selectedOptions) {
                selectedOptions.forEach(function (i) {
                    label += i.label;
                });
            }
            if (type == 'jg') {
                _this.setState({ jgmStr: label });
            } else {
                _this.setState({ jtStr: label });
            }
        };

        _this.state = {
            jbxx: false,
            xsid: '',
            userInfoData: null,
            zzmmmList: [],
            mzmList: [],
            textData: '',
            jgmStr: '',
            jtStr: '',
            xsSsInfo: ''
        };
        return _this;
    }

    _createClass(JbxxInitForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                this.getStudentPhotoBase64(userId, function (data) {
                    if (!data) return;
                    _this2.setState({
                        xsid: userId,
                        imageUrl: 'data:image/jpeg;base64,' + data
                    });
                });
            }
        }

        // 获取学生头像

    }, {
        key: 'getBase64',
        value: function getBase64(img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        }
        // 上传图片

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                form = _props.form,
                jbxxFormData = _props.jbxxFormData,
                getChildComponent = _props.getChildComponent,
                userInfoData = _props.userInfoData,
                stuSsxx = _props.stuSsxx,
                editXszp = _props.editXszp;
            var _state = this.state,
                jbxx = _state.jbxx,
                imageUrl = _state.imageUrl,
                tempUrl = _state.tempUrl,
                xsid = _state.xsid;

            var jtjddz = jbxxFormData ? jbxxFormData.jtjddz : '';
            var jtdzDetail = jbxxFormData ? jbxxFormData.jtdzDetail : '';
            var ssxx = '';
            if (stuSsxx && stuSsxx.xqmc && stuSsxx.ldmc && stuSsxx.fj && stuSsxx.cwh) {
                ssxx = stuSsxx.xqmc + stuSsxx.ldmc + ' - ' + stuSsxx.fj + ' - ' + stuSsxx.cwh;
            }
            return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a,
                { layout: 'inline' },
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u57FA\u672C\u4FE1\u606F'
                    // extra={false}
                    , onEdit: function onEdit(type) {
                        _this3.setState({
                            jbxx: true
                        });
                        getChildComponent(1, false);
                    },
                    onSave: function onSave(cb) {
                        _this3.onSavejbxxFormData(cb);
                        getChildComponent(1, true);
                    },
                    onClose: function onClose() {
                        _this3.setState({
                            jbxx: false
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + '_bg app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_icon'
                        },
                        jbxx && editXszp === "true" ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default.a,
                            {
                                name: 'photo',
                                accept: 'image/*',
                                showUploadList: false,
                                action: uploadUrl + "?xsid=" + xsid,
                                beforeUpload: beforeUpload,
                                onChange: this.handleUploadChange
                            },
                            imageUrl || userInfoData ? imageUrl ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
                                src: imageUrl,
                                alt: '',
                                className: 'jsx-1702183314' + ' ' + 'avatar'
                            }) : tempUrl : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__upload-box'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__upload-title'
                                    },
                                    '\u4E0A\u4F20\u56FE\u7247'
                                )
                            )
                        ) : imageUrl ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
                            src: imageUrl,
                            alt: '',
                            className: 'jsx-1702183314' + ' ' + 'avatar'
                        }) : tempUrl
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */].Item,
                        { className: 'ml-20' },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label'
                                },
                                '\u59D3\u540D\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfoFg-__index__item-name'
                                },
                                userInfoData ? userInfoData.XM : '',
                                userInfoData && userInfoData.XB ? userInfoData.XB === '男' ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(141), alt: '', className: 'jsx-1702183314'
                                }) : userInfoData.XB === '女' ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(142), alt: '', className: 'jsx-1702183314'
                                }) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(143), alt: '', className: 'jsx-1702183314'
                                }) : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label'
                                },
                                '\u5B66\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfoFg-__index__item-name'
                                },
                                userInfoData ? userInfoData.XH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label'
                                },
                                '\u8003\u751F\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfoFg-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.ksh : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label'
                                },
                                '\u8EAB\u4EFD\u8BC1\u4EF6\u53F7\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfoFg-__index__item-name'
                                },
                                userInfoData ? userInfoData.SFZJH : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label'
                                },
                                '\u653F\u6CBB\u9762\u8C8C\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfoFg-__index__item-name'
                                },
                                userInfoData ? userInfoData.ZZMM : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label'
                                },
                                '\u6C11\u65CF\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfoFg-__index__item-name'
                                },
                                userInfoData ? userInfoData.MZ : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label'
                                },
                                '\u6587\u5316\u5206\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfoFg-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.xWhf : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label'
                                },
                                '\u4E13\u4E1A\u5206\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfoFg-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.xZyf : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label'
                                },
                                '\u6BD5\u4E1A\u5B66\u6821\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfoFg-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.byzx : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label'
                                },
                                '\u6BD5\u4E1A\u5E74\u5EA6\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfoFg-__index__item-name'
                                },
                                jbxxFormData && jbxxFormData.bysj != null ? __WEBPACK_IMPORTED_MODULE_22_moment___default()(jbxxFormData.bysj).format('YYYY') : ''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_item'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label'
                                },
                                '\u5B66\u4E60\u5C42\u6B21\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfoFg-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.xXxcc : ''
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    'div',
                    {
                        className: 'jsx-1702183314' + ' ' + 'p-swc'
                    },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label'
                            },
                            '\u5B66\u9662\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfoFg-__index__item-name'
                            },
                            userInfoData ? userInfoData.BMMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label'
                            },
                            '\u5C31\u8BFB\u4E13\u4E1A\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfoFg-__index__item-name'
                            },
                            userInfoData ? userInfoData.ZYMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label'
                            },
                            '\u5F55\u53D6\u4E13\u4E1A\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfoFg-__index__item-name'
                            },
                            jbxxFormData ? jbxxFormData.xLqzy : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label'
                            },
                            '\u73ED\u7EA7\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfoFg-__index__item-name'
                            },
                            userInfoData ? userInfoData.BJMC : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__detail_adrress'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            { style: { lineHeight: '32px' }, className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label'
                            },
                            '\u5174\u8DA3\u7231\u597D\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfoFg-__index__item-name'
                            },
                            jbxxFormData ? jbxxFormData.xqah : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__detail_adrress'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            { style: { lineHeight: '32px' }, className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                { style: { color: 'red' }, className: 'jsx-1702183314'
                                },
                                '*'
                            ),
                            '\u8BE6\u7EC6\u5BB6\u5EAD\u4F4F\u5740\uFF1A'
                        ),
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                            null,
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem__["a" /* default */],
                                { id: 'jtszdqArray',
                                    label: '',
                                    colon: false,
                                    required: true,
                                    form: form,
                                    initialValue: jbxxFormData ? jbxxFormData.jtszdqArray : []
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_common_NHCascader__["a" /* default */], { style: { width: 432.63 }, sign: "zhxg_ssq", onChange: function onChange(value, selectedOptions) {
                                        return _this3.onNHCascaderChange(value, selectedOptions, 'jt');
                                    }

                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem__["a" /* default */],
                                { id: 'jtjddz',
                                    label: '',
                                    colon: false,
                                    required: true,
                                    form: form,
                                    pattern: { max: 100, message: "家庭住址长度不能超过100字符！" },
                                    initialValue: jbxxFormData ? jbxxFormData.jtjddz : '' },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 346.07 }, placeholder: '\u5730\u5740\u9700\u586B\u5199\u5230\u5C0F\u533A/\u6751' })
                            )
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfoFg-__index__item-name'
                            },
                            jtdzDetail ? jtdzDetail : '',
                            jtjddz ? jtjddz : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_item2'
                        },
                        jbxx ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_16__components_common_NHFormItem__["a" /* default */],
                            { id: 'jtdh',
                                label: __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    {
                                        className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label'
                                    },
                                    '\u5BB6\u5EAD\u7535\u8BDD\uFF1A'
                                ),
                                colon: false,
                                form: form,
                                required: true
                                // hasFeedback={true} 
                                // pattern={{ pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/, message: "请输入正确的手机号码或电话号码" }}
                                , pattern: __WEBPACK_IMPORTED_MODULE_19__utils_RegExp__["FormRules"].MOBILE_PHONE_NUMBER,
                                initialValue: jbxxFormData ? jbxxFormData.jtdh : ""
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input___default.a, { style: { width: 140 }, placeholder: '\u8BF7\u586B\u5199\u8054\u7CFB\u7535\u8BDD' })
                        ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-1702183314'
                            },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'span',
                                {
                                    className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label'
                                },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'red' }, className: 'jsx-1702183314'
                                    },
                                    '*'
                                ),
                                '\u5BB6\u5EAD\u7535\u8BDD\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                {
                                    style: { display: 'inline' },
                                    className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfoFg-__index__item-name'
                                },
                                jbxxFormData ? jbxxFormData.jtdh : ''
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label'
                            },
                            '\u5BB6\u957F\u624B\u673A\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfoFg-__index__item-name'
                            },
                            jbxxFormData ? jbxxFormData.xJzsj : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'div',
                        {
                            className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_item2'
                        },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            {
                                className: 'jsx-1702183314' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label'
                            },
                            '\u90AE\u653F\u7F16\u7801\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            {
                                style: { display: 'inline' },
                                className: 'jsx-1702183314' + ' ' + 't-clamp-1 app__css__app-pages-SelfHelp-updateInfoFg-__index__item-name'
                            },
                            jbxxFormData ? jbxxFormData.yzbm : ''
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_styled_jsx_style___default.a, {
                    styleId: '1702183314',
                    css: ['.ant-col-md-7{width:100px;}']
                })
            );
        }
    }]);

    return JbxxInitForm;
}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);

var JbxxForm = __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a.create()(JbxxInitForm);

/* harmony default export */ __webpack_exports__["a"] = (JbxxForm);

/***/ }),

/***/ 114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NHVirtualForm; });


/**
 * 虚拟表单提交
 * @param {*} url 请求路径
 * @param {*} target 请求方式，_blank:打开新页面，_self:打开本业
 * @param {*} map 请求参数
 */
var NHVirtualForm = function NHVirtualForm(url, target, map) {
  var tempForm = document.createElement("form");
  tempForm.method = "post";
  tempForm.action = url;
  document.body.appendChild(tempForm);
  //为模拟表单添加提交事件
  if (document.all) {
    //ie浏览器
    tempForm.fireEvent("onsubmit");
  } else {
    var evt = document.createEvent('HTMLEvents');
    evt.initEvent('onsubmit', true, true);
    tempForm.dispatchEvent(evt);
  }
  //添加参数
  if (map !== undefined && map !== '') {
    for (var key in map) {
      var hideInput = document.createElement("input");
      hideInput.type = "hidden";
      hideInput.name = key;
      hideInput.value = map[key];
      tempForm.appendChild(hideInput);
    }
  }
  //执行虚拟提交操作
  tempForm.target = target ? target : "_blank";
  tempForm.submit();
  document.body.removeChild(tempForm); //清除
};

/***/ }),

/***/ 1140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__index_css__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_common_NHFormItem__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__utils_RegExp__);



















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;

var JtcyForm = function (_React$Component) {
    _inherits(JtcyForm, _React$Component);

    function JtcyForm(props) {
        _classCallCheck(this, JtcyForm);

        var _this = _possibleConstructorReturn(this, (JtcyForm.__proto__ || __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default()(JtcyForm)).call(this, props));

        _this.cacheJtcyData = function (cb) {
            _this.props.form.validateFields(function (err, values) {
                if (err) return cb(false);
                //判断数据是否全部填写
                var errorPhone = "";
                var errorList = [];
                var dataList = [];
                if (_this.state.jtcyData && _this.state.jtcyData.length > 0) {
                    for (var i = 0; i < _this.state.jtcyData.length; i++) {
                        var data = _this.state.jtcyData[i];
                        var pattern = /^1\d{10}$/;
                        if (data.lxfs) {
                            if (!pattern.test(data.lxfs)) {
                                if (errorList.length == 0) {
                                    errorPhone += data.lxfs;
                                } else {
                                    errorPhone += "," + data.lxfs;
                                }
                                errorList.push(data);
                            }
                        }
                        if (!data.gx && !data.xm && !data.gzxxdw && !data.lxfs && !data.operation) {} else {
                            dataList.push(data);
                        }
                    }
                }
                if (errorList && errorList.length > 0) {
                    __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default.a.error(errorPhone + '\u53F7\u7801\u586B\u5199\u9519\u8BEF');
                    return;
                }
                var _this$props = _this.props,
                    cacheFormData = _this$props.cacheFormData,
                    getChildComponent = _this$props.getChildComponent;

                getChildComponent(3, true);
                cacheFormData('jtcy', dataList, true);
                cb(true);
                _this.setState({
                    jtcy: false,
                    jtcyAdd: false
                });
            });
        };

        _this.onjtcyAdd = function () {
            var _this$state = _this.state,
                jtcyAdd = _this$state.jtcyAdd,
                jtcyData = _this$state.jtcyData;

            if (!jtcyData) {
                jtcyData = [];
            }

            if (jtcyAdd) {
                jtcyData.push({
                    key: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHCore__["c" /* createUuid */])(),
                    gx: '',
                    xm: '',
                    gzxxdw: '',
                    zzmmm: '',
                    lxfs: '',
                    operation: ''
                });
                _this.setState({
                    jtcyData: jtcyData
                });
            }
            _this.setState({
                jtcyAdd: true
            });
        };

        _this.onjtcySave = function () {
            var jtcyData = _this.state.jtcyData;

            jtcyData.push();
            _this.setState({
                jtcyData: jtcyData,
                jtcyAdd: false
            });
        };

        _this.onjtcyClose = function (index) {
            var jtcyData = _this.state.jtcyData;

            jtcyData.splice(index, 1);
            _this.setState({
                jtcyData: jtcyData,
                jtcyAdd: true
            });
        };

        _this.handleChange = function (value, index, key) {
            var jtcyData = _this.state.jtcyData;
            jtcyData[index][key] = value;
            _this.setState({ jtcyData: jtcyData });
        };

        _this.getzzmmmStr = function (value) {
            var temp = '';
            _this.state.zzmmmList.forEach(function (i) {
                if (i.value === value) {
                    temp = i.label;
                }
            });
            return temp;
        };

        _this.deepCopy = function (obj) {
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                return obj;
            }

            if (_this.isArrayFn(obj)) {
                var newobj = [];
                for (var i = 0; i < obj.length; i++) {
                    newobj.push(_this.deepCopy(obj[i]));
                }
                return newobj;
            } else {
                var _newobj = {};
                for (var attr in obj) {
                    _newobj[attr] = _this.deepCopy(obj[attr]);
                }
                return _newobj;
            }
        };

        _this.isArrayFn = function (value) {
            if (typeof Array.isArray === "function") {
                return Array.isArray(value);
            } else {
                return Object.prototype.toString.call(value) === "[object Array]";
            }
        };

        _this.state = {
            jtcy: false,
            jtcyAdd: false,
            jtcyData: [],
            zzmmmList: [],
            tempStr: '',
            jtcyList: [] //家庭成员数据加载
        };
        return _this;
    }

    _createClass(JtcyForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('/proData/selectDataList?&sign=DMK_XTGL_ZZMMM', 'GET').then(function (res) {
                if (res && res.data) {
                    var zzmmmList = [];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default()(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var obj = _step.value;

                            zzmmmList.push({ 'label': obj.LABEL, 'value': obj.VALUE });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this2.setState({ zzmmmList: zzmmmList });
                }
            });
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('/proData/selectDataList?&sign=DMK_XSXX_JTCYGX', 'GET').then(function (res) {
                if (res && res.data) {
                    var jtcyList = [];
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default()(res.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var obj = _step2.value;

                            jtcyList.push({ 'label': obj.LABEL, 'value': obj.VALUE });
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    _this2.setState({ jtcyList: jtcyList });
                }
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('jtcyInitData' in nextProps && nextProps.jtcyInitData) {
                if (nextProps.jtcyInitData instanceof Array) {
                    var temp = [].concat(_toConsumableArray(nextProps.jtcyInitData));
                    this.setState({ jtcyData: temp });
                }
            }
        }

        // 家庭成员 添加

        // 家庭成员 保存添加

        // 家庭成员 关闭添加

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _state = this.state,
                jtcy = _state.jtcy,
                jtcyData = _state.jtcyData,
                jtcyAdd = _state.jtcyAdd,
                jtcyList = _state.jtcyList;
            var getChildComponent = this.props.getChildComponent;
            var zzmmmList = this.state.zzmmmList;
            var getFieldDecorator = this.props.form.getFieldDecorator;

            var jtcyTransalate = {}; //家庭成员翻译
            for (var i = 0; i < jtcyList.length; i++) {
                jtcyTransalate[jtcyList[i].value] = jtcyList[i].label;
            }
            var jtcyColumns = [{
                title: '关系',
                key: 'gx',
                dataIndex: 'gx',
                render: function render(text, record, index) {
                    return jtcy ?

                    // <Input
                    //     value={text}
                    //     required={true}
                    //     onChange={(e) =>{this.handleChange(e.target.value,index,'gx')}}
                    //     style={{ width: 100 }}
                    //     placeholder="请填写关系"
                    // />
                    __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_common_NHSelect__["a" /* default */], { style: { width: 140 }, sign: 'DMK_XSXX_JTCYGX',
                        value: text,
                        onChange: function onChange(value) {
                            _this3.handleChange(value, index, 'gx');
                        }

                    })
                    // <NHFormItem id={'gx'} label={''} form={form} required={true}
                    //     pattern={{max:5, message: "关系长度不能超过5字符！"}}
                    //     initialValue={text}>
                    // <Input onChange={(e) =>{this.handleChange(e.target.value,index,'gx')}}
                    //        placeholder="请填写关系"/>
                    // </NHFormItem>
                    : jtcyTransalate[text];
                }
            }, {
                title: '姓名',
                dataIndex: 'xm',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'xm');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u59D3\u540D'
                    }) : text;
                }
            },
            // {
            //     title: '政治面貌',
            //     dataIndex: 'zzmmm',
            //     render: (text, record,index) => {
            //         //let tempStr = '';
            //         return(
            //             jtcy ?
            //             <NHSelect disabled = {jtcy ? false : true} style={{ width: 140 }} sign="DMK_XTGL_ZZMMM"
            //             value={text}
            //             onChange={(value) =>{this.handleChange(value,index,'zzmmm')}}

            //             />
            //             :
            //             (this.getzzmmmStr(text))
            //         );
            //     }
            // },
            {
                title: '工作单位及职务',
                dataIndex: 'gzxxdw',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'gzxxdw');
                        },
                        style: { width: 140 },
                        placeholder: '\u8BF7\u586B\u5199\u5355\u4F4D\u548C\u804C\u52A1'
                    }) : text;
                }
            }, {
                title: '联系电话',
                dataIndex: 'lxfs',
                render: function render(text, record, index) {
                    return jtcy ?
                    // <FormItem style={{ marginBottom: '0px' }}>
                    //     {getFieldDecorator('lxfs', {
                    //         rules: [
                    //             { required: true, message: '请填写电话' },
                    //             FormRules.MOBILE_PHONE_NUMBER
                    //         ],
                    //         initialValue: text
                    //     })(
                    __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        maxLength: 11,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'lxfs');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u7535\u8BDD'
                    })
                    /*     )}
                    </FormItem> */
                    : text;
                }
            }, {
                title: 'QQ',
                dataIndex: 'qq',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'qq');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586BQQ\u53F7'
                    }) : text;
                }
            }, {
                title: '微信',
                dataIndex: 'wx',
                render: function render(text, record, index) {
                    return jtcy ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'wx');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5FAE\u4FE1\u53F7'
                    }) : text;
                }
            }, {
                title: '删除',
                dataIndex: 'operation',
                width: 80,
                render: function render(text, record, index) {
                    if (jtcy) {
                        return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                            'div',
                            { className: 'editable-row-operations' },
                            __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                                'a',
                                {
                                    href: 'javascript:;',
                                    onClick: function onClick() {
                                        return _this3.onjtcyClose(index);
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, {
                                    type: 'close',
                                    style: { color: 'red' }
                                })
                            )
                        );
                    }
                    return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                        'a',
                        { href: 'javascript:;', onClick: function onClick() {
                                return _this3.onjtcyClose();
                            } },
                        __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'delete', style: { color: 'red' } })
                    );
                }
            }];
            if (!jtcy) {
                jtcyColumns.pop();
            }
            return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u5BB6\u5EAD\u6210\u5458\u4FE1\u606F',
                    onEdit: function onEdit(type) {
                        _this3.setState({
                            jtcy: true,
                            jtcyAdd: true,
                            cacheData: _this3.deepCopy(_this3.state.jtcyData)
                        });
                        getChildComponent(3, false);
                    },
                    onSave: function onSave(cb) {
                        _this3.cacheJtcyData(cb);
                    },
                    onClose: function onClose() {
                        _this3.setState({
                            jtcy: false,
                            jtcyAdd: false,
                            jtcyData: _this3.deepCopy(_this3.state.cacheData)
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a,
                    null,
                    __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                        'div',
                        { className: 'p-sw' },
                        __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a, {
                            bordered: true,
                            size: 'middle',
                            pagination: false,
                            dataSource: jtcyData,
                            columns: jtcyColumns
                        }),
                        jtcyAdd && __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                            'div',
                            {
                                className: 'mt-10 app__css__app-pages-SelfHelp-updateInfoFg-__index__btn_add',

                                onClick: function onClick() {

                                    _this3.onjtcyAdd();
                                }
                            },
                            '\u6DFB\u52A0\u5BB6\u5EAD\u6210\u5458'
                        )
                    )
                )
            );
        }
    }]);

    return JtcyForm;
}(__WEBPACK_IMPORTED_MODULE_18_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create()(JtcyForm));

/***/ }),

/***/ 1141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JyjlForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_date_picker_style__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_date_picker__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_common_NHFormItem__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_NHFetch__ = __webpack_require__(7);














var _typeof = typeof __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }














if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var RangePicker = __WEBPACK_IMPORTED_MODULE_12_antd_lib_date_picker___default.a.RangePicker;


var dateFormat = 'YYYY/MM/DD ';

var JyjlForm = function (_React$Component) {
    _inherits(JyjlForm, _React$Component);

    function JyjlForm(props) {
        _classCallCheck(this, JyjlForm);

        var _this = _possibleConstructorReturn(this, (JyjlForm.__proto__ || __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of___default()(JyjlForm)).call(this, props));

        _this.cacheJyjlData = function (cb) {
            //判断数据是否全部填写
            var dataList = [];
            if (_this.state.jyjlData && _this.state.jyjlData.length > 0) {
                for (var i = 0; i < _this.state.jyjlData.length; i++) {
                    var data = _this.state.jyjlData[i];
                    if (!data.qsny && !data.xxjl && !data.zw && !data.zmr && !data.zmrlxfs && !data.operation) {} else {
                        dataList.push(data);
                    }
                }
            }
            var _this$props = _this.props,
                cacheFormData = _this$props.cacheFormData,
                getChildComponent = _this$props.getChildComponent;

            getChildComponent(4, true);
            cacheFormData('jyjl', dataList, true);
            cb(true);
        };

        _this.validateFields = function (func) {
            var err = false;
            var formData = _this.state.jyjlData;
            func(err, formData);
        };

        _this.onjyjlAdd = function () {
            var _this$state = _this.state,
                jyjlAdd = _this$state.jyjlAdd,
                jyjlData = _this$state.jyjlData;

            if (!jyjlData) {
                jyjlData = [];
            }
            if (jyjlAdd) {
                jyjlData.push({
                    key: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHCore__["c" /* createUuid */])(),
                    qsny: '',
                    xxjl: '',
                    zw: '',
                    zmr: '',
                    zmrlxfs: '',
                    operation: ''
                });
                _this.setState({
                    jyjlData: jyjlData
                });
            }
            _this.setState({
                jyjlAdd: true
            });
        };

        _this.onjyjlSave = function () {
            var jyjlData = _this.state.jyjlData;

            jyjlData.push();
            _this.setState({
                jyjlData: jyjlData,
                jyjlAdd: false
            });
        };

        _this.onjyjlClose = function (index) {
            var jyjlData = _this.state.jyjlData;

            jyjlData.splice(index, 1);
            _this.setState({
                jyjlData: jyjlData,
                jyjlAdd: true
            });
        };

        _this.handleChange = function (value, index, key) {
            var jyjlData = _this.state.jyjlData;
            jyjlData[index][key] = value;
            _this.setState({ jyjlData: jyjlData });
        };

        _this.handleDateChange = function (value, index) {

            var jyjlData = _this.state.jyjlData;
            var kssj = value[0] ? __WEBPACK_IMPORTED_MODULE_16_moment___default()(value[0]).format(dateFormat) : undefined;
            var jssj = value[1] ? __WEBPACK_IMPORTED_MODULE_16_moment___default()(value[1]).format(dateFormat) : undefined;
            jyjlData[index]['kssj'] = kssj;
            jyjlData[index]['jssj'] = jssj;
            _this.setState({ jyjlData: jyjlData });
        };

        _this.deepCopy = function (obj) {
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                return obj;
            }

            if (_this.isArrayFn(obj)) {
                var newobj = [];
                for (var i = 0; i < obj.length; i++) {
                    newobj.push(_this.deepCopy(obj[i]));
                }
                return newobj;
            } else {
                var _newobj = {};
                for (var attr in obj) {
                    _newobj[attr] = _this.deepCopy(obj[attr]);
                }
                return _newobj;
            }
        };

        _this.isArrayFn = function (value) {
            if (typeof Array.isArray === "function") {
                return Array.isArray(value);
            } else {
                return Object.prototype.toString.call(value) === "[object Array]";
            }
        };

        _this.state = {
            jyjl: false,
            jyjlAdd: false,
            jyjlData: [{ xl: "小学" }, { xl: "初中" }, { xl: "高中或中职" }]
        };
        return _this;
    }

    _createClass(JyjlForm, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('jyjlInitData' in nextProps && nextProps.jyjlInitData) {
                if (nextProps.jyjlInitData instanceof Array) {
                    var temp = [].concat(_toConsumableArray(nextProps.jyjlInitData));
                    if (temp.length > 0) {
                        this.setState({ jyjlData: temp });
                    }
                }
            }
        }
    }, {
        key: 'disabledDate',
        value: function disabledDate(current) {
            // Can not select days after today and today
            return current && current > __WEBPACK_IMPORTED_MODULE_16_moment___default()().endOf('day');
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                initJtcyData = _props.initJtcyData,
                getChildComponent = _props.getChildComponent;
            var _state = this.state,
                jyjl = _state.jyjl,
                jyjlData = _state.jyjlData,
                jyjlAdd = _state.jyjlAdd;

            var jyjlColumns = [{
                title: '学历',
                dataIndex: 'xl',
                render: function render(text, record, index) {
                    return text;
                }
            }, {
                title: '起始年月',
                dataIndex: 'qsny',
                render: function render(text, record, index) {
                    var kssj = record.kssj;
                    var jssj = record.jssj;
                    return jyjl ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(RangePicker
                    // disabledDate={this.disabledDate}
                    , { value: kssj && jssj ? [__WEBPACK_IMPORTED_MODULE_16_moment___default()(kssj, dateFormat), __WEBPACK_IMPORTED_MODULE_16_moment___default()(jssj, dateFormat)] : undefined,
                        format: dateFormat,
                        onChange: function onChange(value) {
                            _this2.handleDateChange(value, index);
                        }
                    }) : (kssj ? kssj : '') + ' ~ ' + (jssj ? jssj : '');
                }
            }, {
                title: '何地何学校就读',
                dataIndex: 'xxjl',
                render: function render(text, record, index) {
                    return jyjl ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this2.handleChange(e.target.value, index, 'xxjl');
                        },
                        style: { width: 140 },
                        placeholder: '\u8BF7\u586B\u5199\u5B66\u6821'
                    }) : text;
                }
            }];

            return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u6559\u80B2\u7ECF\u5386\u4FE1\u606F',
                    onEdit: function onEdit(type) {
                        _this2.setState({
                            jyjl: true,
                            jyjlAdd: true,
                            cacheData: _this2.deepCopy(_this2.state.jyjlData)
                        });
                        getChildComponent(4, false);
                    },
                    onSave: function onSave(cb) {
                        _this2.cacheJyjlData(cb);
                        _this2.setState({
                            jyjl: false,
                            jyjlAdd: false

                        });
                    },
                    onClose: function onClose() {
                        _this2.setState({
                            jyjl: false,
                            jyjlAdd: false,
                            jyjlData: _this2.deepCopy(_this2.state.cacheData)
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    'div',
                    { className: 'p-sw' },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a, {
                        bordered: true,
                        size: 'middle',
                        pagination: false,
                        dataSource: jyjlData,
                        columns: jyjlColumns
                    })
                )
            );
        }
    }]);

    return JyjlForm;
}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);



/***/ }),

/***/ 1142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_custom_scrollbars__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_custom_scrollbars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_common_NHFormItem_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_common_NHFormItem_FormRules__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__index_css__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components__ = __webpack_require__(10);



















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _extends = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _styleModuleImportMap = {
    './index.css': {
        'progress': 'app__css__app-pages-SelfHelp-updateInfoFg-__index__progress',
        'jbxx_icon': 'app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_icon',
        'upload-box': 'app__css__app-pages-SelfHelp-updateInfoFg-__index__upload-box',
        'upload-title': 'app__css__app-pages-SelfHelp-updateInfoFg-__index__upload-title',
        'jbxx_item': 'app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_item',
        'jbxx_item2': 'app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_item2',
        'item-label': 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label',
        'item-name': 'app__css__app-pages-SelfHelp-updateInfoFg-__index__item-name',
        'kzxx_list': 'app__css__app-pages-SelfHelp-updateInfoFg-__index__kzxx_list',
        'kzxx_item': 'app__css__app-pages-SelfHelp-updateInfoFg-__index__kzxx_item',
        'kzxx_label': 'app__css__app-pages-SelfHelp-updateInfoFg-__index__kzxx_label',
        'kzxx_name': 'app__css__app-pages-SelfHelp-updateInfoFg-__index__kzxx_name',
        'kzxx_item_textarea': 'app__css__app-pages-SelfHelp-updateInfoFg-__index__kzxx_item_textarea',
        'kzxx_name_textarea': 'app__css__app-pages-SelfHelp-updateInfoFg-__index__kzxx_name_textarea',
        'btn_add': 'app__css__app-pages-SelfHelp-updateInfoFg-__index__btn_add',
        'title_top': 'app__css__app-pages-SelfHelp-updateInfoFg-__index__title_top',
        'title_top_name': 'app__css__app-pages-SelfHelp-updateInfoFg-__index__title_top_name',
        'line': 'app__css__app-pages-SelfHelp-updateInfoFg-__index__line',
        'detail_adrress': 'app__css__app-pages-SelfHelp-updateInfoFg-__index__detail_adrress'
    }
};

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }


















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;
var basicUrl = "/zzbd";
var stuInfoUrl = "/xxcj/";

//日期格式化
var dateFormat = 'YYYY-MM-DD';

var KzxxFormComponent = function (_React$Component) {
    _inherits(KzxxFormComponent, _React$Component);

    function KzxxFormComponent(props) {
        _classCallCheck(this, KzxxFormComponent);

        var _this = _possibleConstructorReturn(this, (KzxxFormComponent.__proto__ || __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default()(KzxxFormComponent)).call(this, props));

        _this.onSaveKzxx = function (cb) {
            _this.props.form.validateFields(function (error, values) {
                if (error) {
                    return;
                }
                _this.setState({
                    formData: _extends({}, values),
                    kzxx: false
                });
                var _this$props = _this.props,
                    cacheFormData = _this$props.cacheFormData,
                    getChildComponent = _this$props.getChildComponent;

                getChildComponent(2, true);
                __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_keys___default()(values).forEach(function (key) {
                    if (values[key] != null && values[key] != undefined) {
                        if (values[key].constructor.name == 'Moment') {//处理Moment格式的数据  
                            //values[key] = moment(values[key]).format(dateFormat); 
                        } else if (values[key].constructor.name == 'Array') {
                            if (_typeof(values[key]) === 'object') {
                                var isFileUpload = false;
                                var array = [];
                                var _iteratorNormalCompletion = true;
                                var _didIteratorError = false;
                                var _iteratorError = undefined;

                                try {
                                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(values[key]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                        var item = _step.value;

                                        if (item.hasOwnProperty('uuid') && item['uuid']) {
                                            isFileUpload = true;
                                            array.push(item['uuid']);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return) {
                                            _iterator.return();
                                        }
                                    } finally {
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }

                                if (isFileUpload) {
                                    values[key] = array.join(',');
                                } else {
                                    values[key] = values[key].join(',');
                                }
                            } else {
                                values[key] = values[key].join(',');
                            }
                        }
                    } else {
                        values[key] = '';
                    }
                });

                var postData = {
                    'xxcj': { 'xsid': _this.props.xsid, 'formData': _extends({}, values) }
                };
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])('/newStudent/updateStuInfo', 'POST', postData).then(function (res) {
                    if (res && res.code == 200) {
                        __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.success("保存成功");
                        cb(true);
                        _this.props.reloadMenu();
                    } else {
                        __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error("保存失败");
                    }
                });
            });
        };

        _this.onChange = function (date, dateString) {}
        // console.log('date', date)
        // console.log('dateString', dateString)
        // if(date && dateString){
        //     //this.
        // }


        //获取下拉列表value对应的名称
        ;

        _this.getDmkMc = function (dmbz, zdbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])("/proData/selectDataList", "GET", { sign: dmbz }).then(function (res) {
                if (res) {
                    if (res.data) {
                        var dmkmcList = _this.state.dmkmcList;
                        dmkmcList[zdbz] = res.data;
                        _this.setState({
                            dmkmcList: dmkmcList
                        });
                    }
                }
            });
        };

        _this.getCascaderDmkMc = function (level, sign, cascaderValue, zdbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHFetch__["a" /* default */])("/proData/selectCascaderList", "GET", { level: level, sign: sign, cascaderValue: cascaderValue }).then(function (res) {
                if (res) {
                    if (res.data) {
                        var dmkmcList = _this.state.dmkmcList;
                        dmkmcList[level + zdbz] = res.data;
                        _this.setState({
                            dmkmcList: dmkmcList
                        });
                    }
                }
            });
        };

        _this.handlePreview = function (fjmc, fjid) {

            if (fjmc === "isImage") {
                _this.showPreview('anonymity/docrepo/download/file?attachmentId=' + fjid);
            } else {
                window.open('anonymity/docrepo/download/file?attachmentId=' + fjid);
            }
        };

        _this.showPreview = function (url) {
            _this.setState({
                previewImage: url,
                previewVisible: true
            });
        };

        _this.closeModal = function () {
            return _this.setState({ previewVisible: false });
        };

        _this.fileLists = function (fileLists) {
            {
                var items = [];

                var _loop = function _loop(key) {
                    var fileList = typeof fileLists[key] == 'string' ? fileLists[key].split(";") : fileLists[key];
                    items.push(__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                            'a',
                            { onClick: function onClick() {
                                    _this.handlePreview("file", fileList[0]);
                                } },
                            fileList[1]
                        )
                    ));
                };

                for (var key in fileLists) {
                    _loop(key);
                }
                return items;
            }
        };

        _this.imageLists = function (imageLists) {
            {
                var items = [];

                var _loop2 = function _loop2(key) {
                    var imageList = typeof imageLists[key] == 'string' ? imageLists[key].split(";") : imageLists[key];
                    items.push(__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        'span',
                        null,
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('img', { style: { height: "80px", width: "80px" }, src: "anonymity/docrepo/download/file?attachmentId=" + imageList,
                            onClick: function onClick() {
                                _this.handlePreview("isImage", imageList[0]);
                            } })
                    ));
                };

                for (var key in imageLists) {
                    _loop2(key);
                }
                return items;
            }
        };

        _this.state = {
            xsid: '',
            kzxx: false,
            scrollHeight: 0, //默认滚动高度
            initData: {}, //初始数据
            loading: false, //页面加载状态
            onSubmit: false, //保存按钮加载状态
            isShow: false,
            previewVisible: false,
            formData: '',
            dmkmcList: {},
            zdzmc: ''
        };
        return _this;
    }

    //控件回调

    //获取联级下拉列表value对应的名称

    // 点击文件链接或预览图标时的回调


    //打开图片弹窗

    // 关闭图片弹窗

    // 文件展示 

    //图片展示


    _createClass(KzxxFormComponent, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                form = _props.form,
                getChildComponent = _props.getChildComponent,
                initData = _props.initData;
            var _state = this.state,
                kzxx = _state.kzxx,
                formData = _state.formData,
                previewVisible = _state.previewVisible,
                previewImage = _state.previewImage;
            //提示信息

            var AlertParams = {
                message: '当前没有需要填写的信息',
                description: '',
                type: 'info'
                //信息采集字段分类
            };var infoItems = [];
            var reactid = 0;
            if (initData) {
                //表单信息、表单字段信息
                var _initData$zdglVOs = initData.zdglVOs,
                    zdglVOs = _initData$zdglVOs === undefined ? [] : _initData$zdglVOs;

                if (zdglVOs != null) {
                    if (zdglVOs.length > 0) {
                        var array = [];
                        //循环过滤出多行文本框的key，偶数在左，奇数在右，相应的同行的另一条文本也需要加宽
                        for (var key in zdglVOs) {
                            var kjcs = zdglVOs[key].kjcs;

                            var kjcsjson = JSON.parse(kjcs);
                            if (kjcsjson.type === "textarea" || kjcsjson.type === "oldupload" || kjcsjson.type === "upload") {
                                if (key % 2 === 0) {
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key));
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key) + 1);
                                } else {
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key));
                                    array.push(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(key) - 1);
                                }
                            }
                        }
                        //显示表单字段信息

                        var _loop3 = function _loop3(_key) {
                            //字段状态、是否必填、默认值、字段标识、字段名称、控件参数、字段值
                            var _zdglVOs$_key = zdglVOs[_key],
                                zdbz = _zdglVOs$_key.zdbz,
                                zdmc = _zdglVOs$_key.zdmc,
                                kjcs = _zdglVOs$_key.kjcs,
                                zdz = _zdglVOs$_key.zdz,
                                sfbt = _zdglVOs$_key.sfbt,
                                mrz = _zdglVOs$_key.mrz,
                                zdzt = _zdglVOs$_key.zdzt; //表单字段

                            var zdzmc = '';
                            var kjcsjson = JSON.parse(kjcs);
                            if (formData && formData[zdbz] != null) {
                                zdz = formData[zdbz];
                            }
                            if (kjcsjson.type === 'datepicker' || kjcsjson.type === 'datetimepicker' || kjcsjson.type === 'timepicker' || kjcsjson.type === 'monthpicker' || kjcsjson.type === 'rangepicker') {
                                //日期值展示阶段，从moment转为文字 
                                if (zdz) {
                                    zdzmc = __WEBPACK_IMPORTED_MODULE_27_moment___default()(zdz).format(kjcsjson.format);
                                }
                            } else if (kjcsjson.type === "select") {
                                if (kjcsjson.dataTag && !_this2.state.dmkmcList[zdbz]) {
                                    _this2.getDmkMc(kjcsjson.dataTag, zdbz);
                                }
                                var list = _this2.state.dmkmcList[zdbz];
                                list && list.map(function (item) {
                                    if (item.VALUE === zdz) {
                                        zdzmc = item.LABEL;
                                    }
                                });
                            } else if (kjcsjson.type === "multiselect") {
                                if (kjcsjson.dataTag && !_this2.state.dmkmcList[zdbz]) {
                                    _this2.getDmkMc(kjcsjson.dataTag, zdbz);
                                }
                                var _list = _this2.state.dmkmcList[zdbz];
                                if (zdz) {
                                    (function () {
                                        var multiselect = typeof zdz == 'string' ? zdz.split(",") : zdz;
                                        var multiselectList = [];

                                        var _loop4 = function _loop4(i) {
                                            _list && _list.map(function (item) {
                                                if (item.VALUE === multiselect[i]) {
                                                    multiselectList.push(item.LABEL);
                                                }
                                            });
                                        };

                                        for (var i in multiselect) {
                                            _loop4(i);
                                        }
                                        zdzmc = multiselectList.join(",");
                                    })();
                                }
                            } else if (kjcsjson.type === "nhcascader") {
                                if (zdz) {
                                    (function () {
                                        var nhcascaderList = typeof zdz == 'string' ? zdz.split(",") : zdz;
                                        var nhcascaderLists = [];

                                        var _loop5 = function _loop5(i) {
                                            var level = i;
                                            var c = i;
                                            var d = i;
                                            var a = ++level;
                                            var b = --d;
                                            if (kjcsjson.dataTag && !_this2.state.dmkmcList[a + zdbz]) {
                                                if (i == "0") {
                                                    _this2.getCascaderDmkMc(a, kjcsjson.dataTag, '', zdbz);
                                                } else {
                                                    _this2.getCascaderDmkMc(a, kjcsjson.dataTag, nhcascaderList[b], zdbz);
                                                }
                                            }
                                            var list = _this2.state.dmkmcList[level++ + zdbz];

                                            list && list.map(function (item) {
                                                if (item.value === nhcascaderList[c]) {
                                                    nhcascaderLists.push(item.label);
                                                }
                                            });
                                        };

                                        for (var i in nhcascaderList) {
                                            _loop5(i);
                                        }
                                        zdzmc = nhcascaderLists.join("/");
                                    })();
                                }
                            } else if (kjcsjson.type === "switch") {
                                zdzmc = zdz === "1" || zdz === true ? kjcsjson.checkedText : kjcsjson.uncheckedText;
                            } else if (kjcsjson.type === "radio") {
                                kjcsjson.options && kjcsjson.options.map(function (item, key) {
                                    if (item.value === zdz) {
                                        zdzmc = item.label;
                                    }
                                });
                            } else if (kjcsjson.fileType === "file" && zdz) {
                                var fileLists = typeof zdz == 'string' ? zdz.split(",") : zdz;
                                zdzmc = _this2.fileLists(fileLists);
                            } else if (kjcsjson.fileType === "image" && zdz) {
                                if ((typeof zdz === 'undefined' ? 'undefined' : _typeof(zdz)) === 'object') {
                                    var _array = [];
                                    var _iteratorNormalCompletion2 = true;
                                    var _didIteratorError2 = false;
                                    var _iteratorError2 = undefined;

                                    try {
                                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(zdz), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                            var item = _step2.value;

                                            if (item.hasOwnProperty('uuid') && item['uuid']) {
                                                _array.push(item['uuid']);
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError2 = true;
                                        _iteratorError2 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                                _iterator2.return();
                                            }
                                        } finally {
                                            if (_didIteratorError2) {
                                                throw _iteratorError2;
                                            }
                                        }
                                    }

                                    zdz = _array;
                                } else {
                                    zdz = zdz.split(",");
                                }
                                zdzmc = _this2.imageLists(zdz);
                            } else {
                                zdzmc = zdz;
                            }
                            var required = sfbt === '1' ? true : false;

                            var formItem = void 0;
                            var csz = formData ? formData[zdbz] : zdz;
                            if (required) {
                                formItem = kjcsjson.type === 'textarea' || kjcsjson.type === "oldupload" || kjcsjson.type === "upload" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { height: "120px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item_textarea", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-updateInfoFg-__index__kzxx_label' },
                                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                            'span',
                                            { style: { color: 'red' } },
                                            '*'
                                        ),
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-updateInfoFg-__index__kzxx_name_textarea' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs }) : zdzmc
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { height: "71px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-updateInfoFg-__index__kzxx_label' },
                                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                            'span',
                                            { style: { color: 'red' } },
                                            '*'
                                        ),
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-updateInfoFg-__index__kzxx_name' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs,
                                            onChange: _this2.onChange }) : zdzmc
                                    )
                                );
                            } else {
                                formItem = kjcsjson.type === 'textarea' || kjcsjson.type === "oldupload" || kjcsjson.type === "upload" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { height: "120px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item_textarea", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-updateInfoFg-__index__kzxx_label' },
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-updateInfoFg-__index__kzxx_name_textarea' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs }) : zdzmc
                                    )
                                ) : __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                    'div',
                                    { key: 'div' + reactid++,
                                        style: zdzt === "3" ? { display: "none" } : kzxx && array.indexOf(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_parse_int___default()(_key)) !== -1 ? { height: "71px" } : {},
                                        className: __WEBPACK_IMPORTED_MODULE_19_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item", _styleModuleImportMap)
                                    },
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-updateInfoFg-__index__kzxx_label' },
                                        zdmc,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-updateInfoFg-__index__kzxx_name' },
                                        kzxx && zdzt === "1" ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_NHInputPicker_render__["a" /* default */], { key: _key, id: zdbz, label: '', defaultValue: mrz,
                                            value: kjcsjson.validationValueType === 'array' ? csz && typeof csz == 'string' ? csz.split(",") : csz ? csz : [] : csz,
                                            required: required,
                                            disabled: kzxx ? false : true,
                                            form: form, formLayout: 'vertical', feature: kjcs,
                                            onChange: _this2.onChange }) : zdzmc
                                    )
                                );
                            }
                            infoItems.push(formItem);
                        };

                        for (var _key in zdglVOs) {
                            _loop3(_key);
                        }
                    } else {
                        //未找到表单配置的采集字段信息
                        AlertParams['message'] = '暂时没有需要填写的信息';
                        AlertParams['description'] = '当前未配置采集信息项';
                        AlertParams['type'] = 'warning';
                    }
                }
            }

            return __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                'div',
                {
                    className: 'jsx-2266704716'
                },
                infoItems.length > 0 && __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                    'div',
                    {
                        className: 'jsx-2266704716'
                    },
                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__pages_Assembly_titleTop__["a" /* default */], {
                        title: '\u6269\u5C55\u4FE1\u606F',
                        onEdit: function onEdit(type) {
                            _this2.setState({
                                kzxx: true
                            });
                            getChildComponent(2, false);
                        },
                        onSave: function onSave(cb) {
                            _this2.onSaveKzxx(cb);
                        },
                        onClose: function onClose() {
                            _this2.setState({
                                kzxx: false
                            });
                        }
                    }),
                    infoItems.length > 0 ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a,
                        null,
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                            'div',
                            {
                                className: 'jsx-2266704716' + ' ' + 'p-sw'
                            },
                            __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                                'div',
                                {
                                    className: 'jsx-2266704716' + ' ' + 'app__css__app-pages-SelfHelp-updateInfoFg-__index__kzxx_list'
                                },
                                infoItems
                            )
                        )
                    ) : __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default.a, _extends({ style: { marginTop: 20 }
                    }, AlertParams, {
                        showIcon: true
                    })),
                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a,
                        {
                            visible: previewVisible,
                            footer: null,
                            onCancel: this.closeModal
                        },
                        __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('img', {
                            alt: 'example',
                            style: { width: '100%' },
                            src: previewImage,
                            className: 'jsx-2266704716'
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_styled_jsx_style___default.a, {
                    styleId: '2266704716',
                    css: ['.app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_item{height:100% !important;}', '.app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_label{background-color:#fff;}', '.app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_name{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;width:67%;}']
                })
            );
        }
    }]);

    return KzxxFormComponent;
}(__WEBPACK_IMPORTED_MODULE_20_react___default.a.Component);

var KzxxForm = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create()(KzxxFormComponent);
/* harmony default export */ __webpack_exports__["a"] = (KzxxForm);

/***/ }),

/***/ 1143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__index_css__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_common_NHFormItem__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_RegExp__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_RegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__utils_RegExp__);



















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var FormItem = __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;

var ZyshgxForm = function (_React$Component) {
    _inherits(ZyshgxForm, _React$Component);

    function ZyshgxForm(props) {
        _classCallCheck(this, ZyshgxForm);

        var _this = _possibleConstructorReturn(this, (ZyshgxForm.__proto__ || __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_get_prototype_of___default()(ZyshgxForm)).call(this, props));

        _this.cacheZyshgxData = function (cb) {
            _this.props.form.validateFields(function (err, values) {
                if (err) return cb(false);
                //判断数据是否全部填写
                var dataList = [];
                var errorPhone = "";
                var errorList = [];
                if (_this.state.zyshgxData && _this.state.zyshgxData.length > 0) {
                    for (var i = 0; i < _this.state.zyshgxData.length; i++) {
                        var data = _this.state.zyshgxData[i];
                        var pattern = /^1\d{10}$/;
                        if (data.lxfs) {
                            if (!pattern.test(data.lxfs)) {
                                if (errorList.length == 0) {
                                    errorPhone += data.lxfs;
                                } else {
                                    errorPhone += "," + data.lxfs;
                                }
                                errorList.push(data);
                            }
                        }
                        if (!data.gx && !data.xm && !data.gzxxdw && !data.lxfs && !data.operation) {} else {
                            dataList.push(data);
                        }
                    }
                }
                if (errorList && errorList.length > 0) {
                    __WEBPACK_IMPORTED_MODULE_14_antd_lib_message___default.a.error(errorPhone + '\u53F7\u7801\u586B\u5199\u9519\u8BEF');
                    return;
                }
                var _this$props = _this.props,
                    cacheFormData = _this$props.cacheFormData,
                    getChildComponent = _this$props.getChildComponent;

                getChildComponent(3, true);
                cacheFormData('zyshgx', dataList, true);
                cb(true);
                _this.setState({
                    zyshgx: false,
                    zyshgxAdd: false
                });
            });
        };

        _this.onzyshgxAdd = function () {
            var _this$state = _this.state,
                zyshgxAdd = _this$state.zyshgxAdd,
                zyshgxData = _this$state.zyshgxData;

            if (!zyshgxData) {
                zyshgxData = [];
            }

            if (zyshgxAdd) {
                zyshgxData.push({
                    key: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_NHCore__["c" /* createUuid */])(),
                    gx: '',
                    xm: '',
                    gzxxdw: '',
                    zzmmm: '',
                    lxfs: '',
                    operation: ''
                });
                _this.setState({
                    zyshgxData: zyshgxData
                });
            }
            _this.setState({
                zyshgxAdd: true
            });
        };

        _this.onzyshgxSave = function () {
            var zyshgxData = _this.state.zyshgxData;

            zyshgxData.push();
            _this.setState({
                zyshgxData: zyshgxData,
                zyshgxAdd: false
            });
        };

        _this.onzyshgxClose = function (index) {
            var zyshgxData = _this.state.zyshgxData;

            zyshgxData.splice(index, 1);
            _this.setState({
                zyshgxData: zyshgxData,
                zyshgxAdd: true
            });
        };

        _this.handleChange = function (value, index, key) {
            var zyshgxData = _this.state.zyshgxData;
            zyshgxData[index][key] = value;
            _this.setState({ zyshgxData: zyshgxData });
        };

        _this.getzzmmmStr = function (value) {
            var temp = '';
            _this.state.zzmmmList.forEach(function (i) {
                if (i.value === value) {
                    temp = i.label;
                }
            });
            return temp;
        };

        _this.deepCopy = function (obj) {
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                return obj;
            }

            if (_this.isArrayFn(obj)) {
                var newobj = [];
                for (var i = 0; i < obj.length; i++) {
                    newobj.push(_this.deepCopy(obj[i]));
                }
                return newobj;
            } else {
                var _newobj = {};
                for (var attr in obj) {
                    _newobj[attr] = _this.deepCopy(obj[attr]);
                }
                return _newobj;
            }
        };

        _this.isArrayFn = function (value) {
            if (typeof Array.isArray === "function") {
                return Array.isArray(value);
            } else {
                return Object.prototype.toString.call(value) === "[object Array]";
            }
        };

        _this.state = {
            zyshgx: false,
            zyshgxAdd: false,
            zyshgxData: [],
            zzmmmList: [],
            tempStr: ''
        };
        return _this;
    }

    _createClass(ZyshgxForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__utils_NHFetch__["a" /* default */])('/proData/selectDataList?&sign=DMK_XTGL_ZZMMM', 'GET').then(function (res) {
                if (res && res.data) {
                    var zzmmmList = [];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default()(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var obj = _step.value;

                            zzmmmList.push({ 'label': obj.LABEL, 'value': obj.VALUE });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this2.setState({ zzmmmList: zzmmmList });
                }
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('zyshgxInitData' in nextProps && nextProps.zyshgxInitData) {
                if (nextProps.zyshgxInitData instanceof Array) {
                    var temp = [].concat(_toConsumableArray(nextProps.zyshgxInitData));
                    this.setState({ zyshgxData: temp });
                }
            }
        }

        // 家庭成员 添加

        // 家庭成员 保存添加

        // 家庭成员 关闭添加

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _state = this.state,
                zyshgx = _state.zyshgx,
                zyshgxData = _state.zyshgxData,
                zyshgxAdd = _state.zyshgxAdd,
                zyshgxList = _state.zyshgxList;
            var getChildComponent = this.props.getChildComponent;
            var zzmmmList = this.state.zzmmmList;
            var getFieldDecorator = this.props.form.getFieldDecorator;

            var zyshgxColumns = [{
                title: '关系',
                key: 'gx',
                dataIndex: 'gx',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'gx');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u5173\u7CFB'
                    }) : text;
                }
            }, {
                title: '姓名',
                dataIndex: 'xm',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'xm');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u59D3\u540D'
                    }) : text;
                }
            }, {
                title: '工作单位及职务',
                dataIndex: 'gzxxdw',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'gzxxdw');
                        },
                        style: { width: 140 },
                        placeholder: '\u8BF7\u586B\u5199\u5355\u4F4D\u548C\u804C\u52A1'
                    }) : text;
                }
            }, {
                title: '联系电话',
                dataIndex: 'lxfs',
                render: function render(text, record, index) {
                    return zyshgx ?
                    /* <FormItem style={{ marginBottom: '0px' }}>
                        {getFieldDecorator('lxfs', {
                            rules: [
                                { required: true, message: '请填写电话' },
                                FormRules.MOBILE_PHONE_NUMBER
                            ],
                            initialValue: text
                        })( */
                    __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        maxLength: 11,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'lxfs');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5199\u7535\u8BDD'
                    })
                    /*  )}
                    </FormItem> */

                    : text;
                }
            }, {
                title: 'QQ',
                dataIndex: 'qq',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'qq');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586BQQ\u53F7'
                    }) : text;
                }
            }, {
                title: '微信',
                dataIndex: 'wx',
                render: function render(text, record, index) {
                    return zyshgx ? __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a, {
                        value: text,
                        onChange: function onChange(e) {
                            _this3.handleChange(e.target.value, index, 'wx');
                        },
                        style: { width: 100 },
                        placeholder: '\u8BF7\u586B\u5FAE\u4FE1\u53F7'
                    }) : text;
                }
            }, {
                title: '删除',
                dataIndex: 'operation',
                width: 80,
                render: function render(text, record, index) {
                    if (zyshgx) {
                        return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                            'div',
                            { className: 'editable-row-operations' },
                            __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                                'a',
                                {
                                    href: 'javascript:;',
                                    onClick: function onClick() {
                                        return _this3.onzyshgxClose(index);
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, {
                                    type: 'close',
                                    style: { color: 'red' }
                                })
                            )
                        );
                    }
                    return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                        'a',
                        { href: 'javascript:;', onClick: function onClick() {
                                return _this3.onzyshgxClose();
                            } },
                        __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'delete', style: { color: 'red' } })
                    );
                }
            }];
            if (!zyshgx) {
                zyshgxColumns.pop();
            }
            return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__pages_Assembly_titleTop__["a" /* default */], {
                    title: '\u4E3B\u8981\u793E\u4F1A\u5173\u7CFB',
                    onEdit: function onEdit(type) {
                        _this3.setState({
                            zyshgx: true,
                            zyshgxAdd: true,
                            cacheData: _this3.deepCopy(_this3.state.zyshgxData)
                        });
                        getChildComponent(3, false);
                    },
                    onSave: function onSave(cb) {
                        _this3.cacheZyshgxData(cb);
                    },
                    onClose: function onClose() {
                        _this3.setState({
                            zyshgx: false,
                            zyshgxAdd: false,
                            zyshgxData: _this3.deepCopy(_this3.state.cacheData)
                        });
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a,
                    null,
                    __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                        'div',
                        { className: 'p-sw' },
                        __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a, {
                            bordered: true,
                            size: 'middle',
                            pagination: false,
                            dataSource: zyshgxData,
                            columns: zyshgxColumns
                        }),
                        zyshgxAdd && __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
                            'div',
                            {
                                className: 'mt-10 app__css__app-pages-SelfHelp-updateInfoFg-__index__btn_add',

                                onClick: function onClick() {

                                    _this3.onzyshgxAdd();
                                }
                            },
                            '\u6DFB\u52A0\u4E3B\u8981\u793E\u4F1A\u5173\u7CFB'
                        )
                    )
                )
            );
        }
    }]);

    return ZyshgxForm;
}(__WEBPACK_IMPORTED_MODULE_18_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.create()(ZyshgxForm));

/***/ }),

/***/ 1144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UpdateInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker_style__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_date_picker__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__JbxxForm__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__JtcyForm__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ZyshgxForm__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__JyjlForm__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__KzxxForm__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_common_hint__ = __webpack_require__(35);












var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }






















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_25_history_createHashHistory___default()();
var RangePicker = __WEBPACK_IMPORTED_MODULE_10_antd_lib_date_picker___default.a.RangePicker;

var Option = __WEBPACK_IMPORTED_MODULE_8_antd_lib_select___default.a.Option;
var stuInfoUrl = "/xxcj/";

var UpdateInfo = function (_React$Component) {
    _inherits(UpdateInfo, _React$Component);

    function UpdateInfo(props) {
        _classCallCheck(this, UpdateInfo);

        var _this = _possibleConstructorReturn(this, (UpdateInfo.__proto__ || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default()(UpdateInfo)).call(this, props));

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({
                        nonOperationalData: res.data,
                        zzbdhjid: zzbdhjid
                    });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.getChildComponent = function (flag, mode) {
            switch (flag) {
                case 1:
                    _this.setState({ jbxxFlag: mode });
                    break;
                case 2:
                    _this.setState({ kzxxFlag: mode });
                    break;
                case 3:
                    _this.setState({ jtcyFlag: mode });
                    break;
                case 4:
                    _this.setState({ zyshgxFlag: mode });
                    break;
                case 5:
                    _this.setState({ jyjlFlag: mode });
                    break;
                default:
                    break;
            }
        };

        _this.cacheFormData = function (type, values, isAdd) {
            //const{jbxxInitData} = this.state;
            if (type == 'jbxx') {
                var sjhm = values.sjhm,
                    jtszdqArray = values.jtszdqArray,
                    jtjddz = values.jtjddz;

                if (sjhm !== null && jtszdqArray !== null && jtszdqArray.length > 0 && jtjddz !== null) {
                    _this.setState({
                        jbxxInitData: _extends({}, values),
                        isEditJbxx: true
                    }, function () {
                        _this.insertData4Yxwz();
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("存在必填信息未填写，请填写后再保存！");
                }
            }
            if (type == 'jtcy' && isAdd) {
                var zyshgxInitData = _this.state.zyshgxInitData;

                if (zyshgxInitData !== null && zyshgxInitData.length > 0) {
                    _this.setState({
                        jtcyInitData: values,
                        isEditJtcy: true
                    }, function () {
                        _this.insertData4Yxwz();
                    });
                } else if (values !== null && values.length > 0) {
                    _this.setState({
                        jtcyInitData: values,
                        isEditJtcy: true
                    }, function () {
                        _this.insertData4Yxwz();
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("家庭成员信息和主要社会关系至少要填一项！");
                }
            }
            if (type == 'zyshgx' && isAdd) {
                var jtcyInitData = _this.state.jtcyInitData;

                if (jtcyInitData !== null && jtcyInitData.length > 0) {
                    _this.setState({
                        zyshgxInitData: values,
                        isEditZyshgx: true
                    }, function () {
                        _this.insertData4Yxwz();
                    });
                } else if (values !== null && values.length > 0) {

                    _this.setState({
                        zyshgxInitData: values,
                        isEditZyshgx: true
                    }, function () {
                        _this.insertData4Yxwz();
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("家庭成员信息和主要社会关系至少要填一项！");
                }
            }
            if (type == 'jyjl') {
                var state = false;
                if (values !== null && values.length >= 3) {
                    state = true;
                    values.map(function (item, index) {
                        if (item.jssj == "" || item.jssj == null || item.kssj == "" || item.kssj == null || item.xxjl == "" || item.xxjl == null) {
                            state = false;
                        }
                    });
                    if (state) {
                        _this.setState({
                            jyjlInitData: values,
                            isEditJyjl: true
                        }, function () {
                            _this.insertData4Yxwz();
                        });
                    } else {
                        __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("请填写完信息后保存！");
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("请填写完信息后保存！");
                }
            }
        };

        _this.getData4Yxwz = function () {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                _this.setState({ xsid: userId });
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/newStudent/queryStuInfo', 'GET', { 'xsid': userId }).then(function (res) {
                    if (res && res.data) {
                        var stuInfo = res.data.stuInfo;
                        var stuXxcj = res.data.stuXxcj;
                        var stuSsxx = res.data.stuSsxx;
                        var editXszp = res.data.editXszp;

                        _this.setState({
                            userBaseInfo: stuInfo.userBaseInfo,
                            jbxxInitData: stuInfo.xsJbxx4YxwzVO,
                            jtcyInitData: stuInfo.jtcyVO,
                            zyshgxInitData: stuInfo.zyshgxVO,
                            jyjlInitData: stuInfo.jyjlVO,
                            kzxxInitData: _extends({}, stuXxcj),
                            stuSsxx: stuSsxx,
                            editXszp: editXszp
                        });
                    }
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("登录超时,请重新登录！");
            }
        };

        _this.insertData4Yxwz = function () {
            var postFormData = {};
            var _this$state = _this.state,
                jbxxInitData = _this$state.jbxxInitData,
                jtcyInitData = _this$state.jtcyInitData,
                zyshgxInitData = _this$state.zyshgxInitData,
                jyjlInitData = _this$state.jyjlInitData,
                xsid = _this$state.xsid,
                zzbdhjid = _this$state.zzbdhjid;

            postFormData['xsid'] = xsid;
            postFormData['xsJbxx4YxwzVO'] = jbxxInitData;
            postFormData['jtcyVO'] = jtcyInitData;
            postFormData['zyshgxVO'] = zyshgxInitData;
            postFormData['jyjlVO'] = jyjlInitData;

            var postData = {
                'xsInfo4YxwzVO': postFormData,
                'params': { 'zzbdhjid': zzbdhjid, 'xsid': xsid }
            };

            //必填一
            var _postData$xsInfo4Yxwz = postData.xsInfo4YxwzVO.xsJbxx4YxwzVO,
                sjhm = _postData$xsInfo4Yxwz.sjhm,
                jtszdqArray = _postData$xsInfo4Yxwz.jtszdqArray,
                jtjddz = _postData$xsInfo4Yxwz.jtjddz;

            var jbxxFlag = false;
            if (sjhm !== null && jtszdqArray !== null && jtszdqArray.length > 0 && jtjddz !== null) {
                jbxxFlag = true;
            }
            //必填项二：两个填一个
            var _postData$xsInfo4Yxwz2 = postData.xsInfo4YxwzVO,
                jtcyVO = _postData$xsInfo4Yxwz2.jtcyVO,
                zyshgxVO = _postData$xsInfo4Yxwz2.zyshgxVO,
                jyjlVO = _postData$xsInfo4Yxwz2.jyjlVO;

            var jtxxFlag = false;
            if (jtcyVO !== null && jtcyVO.length > 0 || zyshgxVO !== null && zyshgxVO.length > 0) {
                jtxxFlag = true;
            }
            //必填三
            var jyxxFlag = false;
            if (jyjlVO !== null && jyjlVO.length >= 3) {
                jyxxFlag = true;
                jyjlVO.map(function (item, index) {
                    if (item.jssj == "" || item.jssj == null || item.kssj == "" || item.kssj == null || item.xxjl == "" || item.xxjl == null) {
                        jyxxFlag = false;
                    }
                });
            }

            var hjblFlag = false;
            if (jtxxFlag && jyxxFlag) {
                hjblFlag = true;
            }
            postData.params.hjblFlag = hjblFlag;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])('/newStudent/updateStuInfo', 'POST', postData).then(function (res) {
                if (res && res.code == 200) {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.success("保存成功");
                    _this.reloadMenu();
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error("保存失败");
                }
            });
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD001_7',
            hjmc: '',
            jbxxFormData: {},
            formInitData: {},
            jbxxInitData: {},
            jtcyInitData: [],
            zyshgxInitData: [],
            jyjlInitData: [],
            kzxxInitData: {},
            userBaseInfo: {},
            stuSsxx: {},
            xsid: '',
            jbxxFlag: true,
            kzxxFlag: true,
            jtcyFlag: true,
            zyshgxFlag: true,
            jyjlFlag: true,
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            isEditJbxx: false,
            isEditJtcy: false,
            isEditZyshgx: false,
            isEditJyjl: false,
            menuList: [],
            zzbdhjid: ''
        };
        return _this;
    }

    _createClass(UpdateInfo, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.queryQztjAndYlhj();
            //this.getYlhjData();
            this.getData4Yxwz();
        }

        //查询前置条件和依赖环节


        //缓存编写的信息，缓存完之后提交


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                xsid = _state.xsid,
                jtcyInitData = _state.jtcyInitData,
                zyshgxInitData = _state.zyshgxInitData;


            return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_13__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230'
                        /*   active={0}*/
                        , mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13__components__["a" /* Flex */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__JbxxForm__["a" /* default */], { ref: 'refJbxxForm', jbxxFormData: this.state.jbxxInitData,
                                getChildComponent: this.getChildComponent,
                                cacheFormData: this.cacheFormData,
                                userInfoData: this.state.userBaseInfo,
                                stuSsxx: this.state.stuSsxx,
                                editXszp: this.state.editXszp
                            }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__JtcyForm__["a" /* default */], { ref: 'refJtcyForm', jtcyInitData: this.state.jtcyInitData,
                                getChildComponent: this.getChildComponent,
                                cacheFormData: this.cacheFormData }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__ZyshgxForm__["a" /* default */], { ref: 'refZyshgxForm', zyshgxInitData: this.state.zyshgxInitData,
                                getChildComponent: this.getChildComponent,
                                cacheFormData: this.cacheFormData }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__JyjlForm__["a" /* default */], { ref: 'refJyjlForm', jyjlInitData: this.state.jyjlInitData,
                                getChildComponent: this.getChildComponent,
                                cacheFormData: this.cacheFormData }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__KzxxForm__["a" /* default */], { ref: 'refKzxxForm', getChildComponent: this.getChildComponent,
                                reloadMenu: this.reloadMenu,
                                xsid: this.state.xsid,
                                zzbdhjid: this.state.zzbdhjid,
                                initData: this.state.kzxxInitData
                            }),
                            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                                'div',
                                { className: 'p-sw text-center mt-30' },
                                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__common__["a" /* default */], { hjmc: "个人信息填写", key: 'GD001_7', mkbz: 'GD001_7', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return UpdateInfo;
}(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);



/***/ }),

/***/ 1145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dorm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_checkbox_style__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_checkbox__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_getSize__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_common_NHModal__ = __webpack_require__(106);

















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }








// import SelectBox from './selectBox';
// import SelectModal from './selectModal';










var history = __WEBPACK_IMPORTED_MODULE_24_history_createHashHistory___default()();
var confirm = __WEBPACK_IMPORTED_MODULE_15_antd_lib_modal___default.a.confirm;
var CheckboxGroup = __WEBPACK_IMPORTED_MODULE_13_antd_lib_checkbox___default.a.Group;
var RadioGroup = __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio___default.a.Group;

/**
 * @author weishihuai
 * @date 2018/7/6
 * @time 14:41
 * @Description: 迎新网站-自助报到-宿舍分配
 */

var Dorm = function (_React$Component) {
    _inherits(Dorm, _React$Component);

    function Dorm(props) {
        _classCallCheck(this, Dorm);

        var _this2 = _possibleConstructorReturn(this, (Dorm.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(Dorm)).call(this, props));

        _this2.getLcIdInfo = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])("/zdybl/getXsxxAndLcidByXsid", 'GET', { xsid: xsid }).then(function (res) {
                if (res.code == "200") {
                    console.log("获取专业信息接口----------", res.data);
                    _this2.setState({
                        LcidData: res.data
                    });
                } else {
                    Toast.error("获取专业信息接口失败");
                }
            });
        };

        _this2.getStudentID = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (xsid) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])('/newStudent/getXslbmByXsid', 'GET', { 'xsid': xsid }).then(function (res) {
                    if (res) {
                        console.log("查看学号信息", res);
                        if (res.data) {
                            _this2.setState({
                                stuInfo: res.data
                            }, function () {
                                var formData = {
                                    'xsid': xsid
                                };
                                if (res.data.XH == undefined || res.data.XH == null || res.data.XH == '') {
                                    _this2.NewStudentId(formData);
                                } else {
                                    _this2.setState({
                                        xh: res.data.XH
                                    });
                                }
                            });
                        } else {
                            __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error("获取学生信息失败！");
                        }
                    }
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error("检测不到学生信息，请重新登录!");
            }
        };

        _this2.NewStudentId = function (formData) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])('api/zhxg-yxxt/yxwz/zzbd/ckxh/createXhByXsid', 'POST', formData).then(function (res1) {
                if (res1) {
                    console.log(res1);
                    if (res1.data == 1) {
                        _this2.getStudentID();
                        _this2.submitBtnClick();
                    } else {
                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_message___default.a.error("生成学号失败！");
                    }
                }
            });
        };

        _this2.submitBtnClick = function () {
            var LcidData = _this2.state.LcidData;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this2.getQueryString('pkid');
            var formData = { xsid: xsid, yhid: xsid, zzbdhjid: zzbdhjid, lchjid: LcidData.LCID };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])('/zdybl/saveCustomLinkData', "POST", formData).then(function (res) {
                if (res) {
                    if (res.data == '1') {
                        console.log('环节办理成功！');
                        //办理完成回调
                    } else {
                        console.log('环节办理失败，请重试！');
                    }
                }
            });
        };

        _this2.queryQztjAndYlhj = function (callback) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this2.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this2.getUrlParams('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this2.setState({ nonOperationalData: res.data });
                    if (kfsj && kfsj['YXSJ'] != '1') {
                        _this2.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this2.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this2.setState({ operable: false });
                    }

                    if (callback) {
                        callback(_this2.state.operable);
                    }
                    _this2.setState({
                        isShow: !(kfsj && kfsj['YXSJ'] !== '1' || ylhj && ylhj.length > 0 || qzhj && qzhj.length > 0)
                    }, function () {
                        var isShow = _this2.state.isShow;

                        if (isShow) {
                            _this2.getStudentID();
                        }
                    });
                }
            });
        };

        _this2.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this2.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this2.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this2.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this2.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this2.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this2.getUrlParams = function (param) {
            return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this2.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this2.checkZzbdisLinked = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this2.getUrlParams("pkid");
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])("/zzbdCommon/checkIsZzbdHjLinked", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res) {
                    if (res.data) {
                        _this2.setState({
                            isHjLinked: res.data
                        });
                    } else {
                        _this2.setState({
                            isHjLinked: false
                        });
                    }
                } else {
                    _this2.setState({
                        isHjLinked: false
                    });
                }
            });
        };

        _this2.reloadMenu = function () {
            _this2.refs.siderMenu.reloadMenuList();
        };

        _this2.state = {
            mkbz: 'GD033',
            hjmc: '',
            xzId: '',
            _xzId: '',
            cwsList: [], //床位数
            sfbzList: [], //收费标准
            xqList: [], //校区信息
            currentXqid: "", //当前校区ID
            fjxxList: [], //房间信息
            currentClickCwPkid: "", //当前床位信息ID
            xsssruYwxx: {}, //学生宿舍入住业务信息
            isHjLinked: false, //环节是否办理状态
            param: {}, //过滤条件
            scrollHeight: 200, //默认滚动高度
            loginUserInfo: {}, //当前登录学生信息
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            autoBlLoading: false, //自动办理按钮载入状态
            cancelLoading: false, //取消办理按钮载入状态
            zdrzLoading: false, //自动入住载入状态
            setRoom: [], //过滤房间信息
            sfbz: "", //收费标准选中值
            stuInfo: {},
            stuXxcj: {},
            stuSsxx: {},
            xh: "", //学号
            LcidData: {} //lchjid
        };
        return _this2;
    }

    _createClass(Dorm, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var that = this;
            this.setState({ scrollHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_getSize__["a" /* default */])().windowH - 206 });
            window.onresize = function () {
                that.setState({
                    scrollHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_getSize__["a" /* default */])().windowH - 206
                });
            };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            this.getLcIdInfo();
            this.queryQztjAndYlhj(function (operable) {
                if (operable) {
                    var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["b" /* getLoginUser */])().userId : '';
                    if (xsid) {
                        var _this = _this3;
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_NHCore__["d" /* getLoginUserInfo */])(xsid, function (data) {
                            _this.setState({
                                loginUserInfo: data
                            }, function () {
                                var loginUserInfo = _this.state.loginUserInfo;

                                var xqid = loginUserInfo.XQID,
                                    xbm = loginUserInfo.XBM;
                            });
                        });
                    }
                }
            });
        }

        //获取该学生有没有学号


        // 生成学号


        // 确认办理


        //查询前置条件和依赖环节


        //获取url中传递的参数

        //检查环节是否已办理


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                stuInfo = _state.stuInfo,
                stuXxcj = _state.stuXxcj,
                stuSsxx = _state.stuSsxx,
                xh = _state.xh;

            return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_18__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230',
                        mkbz: this.state.mkbz
                        /*   active={5}*/
                        , menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_18__components__["a" /* Flex */].Item,
                        { className: 'page_con_r ' },
                        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pages_Assembly_titleTop__["a" /* default */], {
                                className: 'mt-20',
                                title: this.state.hjmc,
                                extra: false
                            }),
                            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                'div',
                                { style: { marginTop: "10px" } },
                                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_row___default.a,
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                        {
                                            style: { textAlign: "center", padding: "10px" },
                                            span: 8
                                        },
                                        '\u59D3\u540D\uFF1A',
                                        stuInfo ? stuInfo.XM : ""
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_antd_lib_col___default.a,
                                        {
                                            style: { textAlign: "center", padding: "10px" },
                                            span: 8
                                        },
                                        '\u5B66\u53F7\uFF1A',
                                        xh ? xh : ""
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                'div',
                                { className: 'text-center mt-50' },
                                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__common__["a" /* default */], { hjmc: "查看学号", key: 'GD033', mkbz: 'GD033', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return Dorm;
}(__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);



/***/ }),

/***/ 1146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dorm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert_style__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_radio_style__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_radio__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_checkbox_style__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_checkbox__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__selectBox__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__index_css__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__utils_getSize__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_common_NHModal__ = __webpack_require__(106);
























var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }



















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_32_history_createHashHistory___default()();
var confirm = __WEBPACK_IMPORTED_MODULE_22_antd_lib_modal___default.a.confirm;
var CheckboxGroup = __WEBPACK_IMPORTED_MODULE_20_antd_lib_checkbox___default.a.Group;
var RadioGroup = __WEBPACK_IMPORTED_MODULE_18_antd_lib_radio___default.a.Group;

/**
 * @author weishihuai
 * @date 2018/7/6
 * @time 14:41
 * @Description: 迎新网站-自助报到-宿舍分配(武汉软件)
 */

var Dorm = function (_React$Component) {
    _inherits(Dorm, _React$Component);

    function Dorm(props) {
        _classCallCheck(this, Dorm);

        var _this2 = _possibleConstructorReturn(this, (Dorm.__proto__ || __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_get_prototype_of___default()(Dorm)).call(this, props));

        _this2.getCwhFlag = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHFetch__["a" /* default */])('/zzbdCommon/getCssz', "GET", { csbz: 'YXXT_SSXX_SFXSCWH' }).then(function (res) {
                if (res) {
                    if (res && res.code === 200) {
                        if (res.data === 'false') {
                            _this2.setState({ cwhFlag: false });
                        }
                    }
                }
            });
        };

        _this2.getPayFlag = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var hjdm = 'GD008_1';
            var params = {
                xsid: xsid,
                hjdm: hjdm
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHFetch__["a" /* default */])('/zzbdCommon/getBlztByHjdm', "GET", params).then(function (res) {
                if (res) {
                    if (res && res.code === 200) {
                        if (res.data === '1') {
                            _this2.setState({ payFlag: true });
                        } else {
                            _this2.setState({ payFlag: false });
                        }
                    }
                }
            });
        };

        _this2.getMoneyPushFlag = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHFetch__["a" /* default */])('/zzbdCommon/getCssz', "GET", { csbz: 'YXXT_SSFP_SFTSZCWXT' }).then(function (res) {
                if (res) {
                    if (res && res.code === 200) {
                        if (res.data === 'true') {
                            _this2.setState({ moneyPushFlag: 'true' });
                        } else {
                            _this2.setState({ moneyPushFlag: 'false' });
                        }
                    }
                }
            });
        };

        _this2.updateZzbdBlzt = function () {
            var zzbdhjid = _this2.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHFetch__["a" /* default */])('/zzbd/updateZzbdBlzt', 'GET', { zzbdhjid: zzbdhjid, hjdm: 'GD006_4' }).then(function (res) {
                if (res.data) {
                    _this2.reloadMenu();
                }
            });
        };

        _this2.queryQztjAndYlhj = function (callback) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this2.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this2.getUrlParams('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this2.setState({ nonOperationalData: res.data });
                    if (kfsj && kfsj['YXSJ'] != '1') {
                        _this2.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this2.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this2.setState({ operable: false });
                    }

                    if (callback) {
                        callback(_this2.state.operable);
                    }
                }
            });
        };

        _this2.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this2.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this2.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_36__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this2.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this2.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this2.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this2.getUrlParams = function (param) {
            return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this2.getSfbzAndCwsInfo = function (xsid, xqid, xbm) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHFetch__["a" /* default */])("/whrj/gyxtUnauth/cwfp/getYxxcSfbzAndSslxInfo", 'GET', { xqid: xqid ? xqid : "", xsid: xsid, xbm: xbm }).then(function (res) {
                if (res) {
                    var data = res.data;
                    _this2.setState({
                        cwsList: data.cwsList,
                        sfbzList: data.sfbzList,
                        xqList: data.xqList
                    });

                    //如果学生无校区信息,默认加载第一个Tab校区的宿舍信息
                    if (!xqid) {
                        _this2.setState({
                            currentXqid: data.xqList[0].XQID
                        });
                        _this2.getFjxxList({
                            cws: "",
                            sfbz: "",
                            xsid: xsid,
                            xqid: data.xqList[0].XQID,
                            xbm: xbm
                        });
                    }
                }
            });
        };

        _this2.getFjxxList = function (param) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHFetch__["a" /* default */])("/whrj/gyxtUnauth/cwfp/getYxwzSsfpFjxxList", 'GET', param).then(function (res) {
                if (res) {
                    _this2.setState({
                        fjxxList: res.data
                    });
                }
            });
        };

        _this2.getXsssrzYwxxByXsid = function (xsid) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHFetch__["a" /* default */])('/whrj/gyxtUnauth/cwfp/getXsssrzYwxxByXsid', 'GET', {
                xsid: xsid
            }).then(function (res) {
                if (res && res.data) {
                    _this2.setState({
                        xsssruYwxx: res.data
                    });
                }
            });
        };

        _this2.judeageCs = function () {
            var payFlag = _this2.state.payFlag;

            if (payFlag) {
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("已完成缴费环节，不可取消");
                return;
            }
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHFetch__["a" /* default */])('/whrj/gyxtUnauth/cwfp/getSyzxcs', 'POST', { xsid: xsid }).then(function (res) {
                if (res && res.data === -1) {
                    _this2.handleCancelListener();
                } else if (res && res.data === 0) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__components_common_NHModal__["b" /* NHConfirm */])("自选宿舍次数已用完，取消后不能再进行自选宿舍操作！确定取消？", function () {
                        _this2.handleCancelListener();
                    }, "warn");
                } else if (res && res.data !== -1 && res.data !== 0) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__components_common_NHModal__["b" /* NHConfirm */])("确定取消？取消后还剩" + res.data + "次可选", function () {
                        _this2.handleCancelListener();
                    }, "warn");
                }
            });
        };

        _this2.handleCancelListener = function () {
            _this2.setState({
                cancelLoading: true
            });
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var _this2$state = _this2.state,
                loginUserInfo = _this2$state.loginUserInfo,
                moneyPushFlag = _this2$state.moneyPushFlag;

            var xqid = loginUserInfo.XQID,
                xbm = loginUserInfo.XBM;

            var zzbdhjid = _this2.getUrlParams("pkid");
            var params = { xsid: xsid, zzbdhjid: zzbdhjid, moneyPushFlag: moneyPushFlag };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHFetch__["a" /* default */])('/whrj/gyxtUnauth/cwfp/cancelBlSsfp', 'POST', params).then(function (res) {
                if (res && res.data === 1) {
                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.success('取消办理成功！');
                    _this2.reloadMenu();
                    _this2.getFjxxList({
                        cws: "",
                        sfbz: "",
                        xsid: xsid,
                        xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                        xbm: xbm
                    });

                    _this2.checkZzbdisLinked();

                    _this2.setState({
                        xsssruYwxx: {},
                        cancelLoading: false
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error('取消办理失败，请稍后重试！');
                    _this2.setState({
                        cancelLoading: false
                    });
                }
            }).catch(function () {
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("取消办理失败，请稍后重试！");
                _this2.setState({
                    cancelLoading: false
                });
            });
        };

        _this2.handleAutoDistributeListener = function () {
            _this2.setState({
                autoBlLoading: true
            });
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var _this2$state2 = _this2.state,
                loginUserInfo = _this2$state2.loginUserInfo,
                cwhFlag = _this2$state2.cwhFlag,
                moneyPushFlag = _this2$state2.moneyPushFlag;

            var xqid = loginUserInfo.XQID,
                xbm = loginUserInfo.XBM;
            var zzbdhjid = _this2.getUrlParams("pkid");

            if (!xsid) {
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.warning("自动办理失败,请稍后重试！");
                _this2.setState({
                    autoBlLoading: false
                });
                return;
            }

            var param = _this2.state.param;
            //自动分配宿舍

            var params = {
                cws: param.cws || "",
                sfbz: param.sfbz || "",
                xsid: xsid,
                xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                xbm: xbm,
                zzbdhjid: zzbdhjid,
                moneyPushFlag: moneyPushFlag
            };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHFetch__["a" /* default */])("/whrj/gyxtUnauth/cwfp/yxwzAutoDistributeSscwxx", 'POST', params).then(function (res) {
                if (res) {
                    if (res.data === 1) {
                        var text = "";
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHFetch__["a" /* default */])('/whrj/gyxtUnauth/cwfp/getXsssrzYwxxByXsid', 'GET', { xsid: xsid }).then(function (res) {
                            if (res && res.data) {
                                var data = res.data;
                                _this2.setState({
                                    xsssruYwxx: data
                                });
                                if (cwhFlag) {
                                    text = data.ldmc + "-" + data.fj + "-" + data.cwh + "号床位";
                                } else {
                                    text = data.ldmc + "-" + data.fj;
                                }
                                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.success("自动办理成功,分配宿舍为 " + text + "！");
                                _this2.reloadMenu();
                                _this2.getFjxxList({
                                    cws: "",
                                    sfbz: "",
                                    xsid: xsid,
                                    xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                                    xbm: xbm
                                });
                                _this2.getXsssrzYwxxByXsid(xsid);
                                _this2.checkZzbdisLinked();
                                _this2.setState({
                                    autoBlLoading: false
                                });
                            } else {
                                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("自动办理失败,请稍后重试！");
                                _this2.setState({
                                    autoBlLoading: false
                                });
                            }
                        });
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("自动办理失败,请稍后重试！");
                    _this2.setState({
                        autoBlLoading: false
                    });
                }
            }).catch(function () {
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("自动办理失败,请稍后重试！");
                _this2.setState({
                    autoBlLoading: false
                });
            });
        };

        _this2.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this2.checkZzbdisLinked = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this2.getUrlParams("pkid");
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHFetch__["a" /* default */])("/zzbdCommon/checkIsZzbdHjLinked", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                console.log("公寓", res.data);
                if (res) {
                    if (res.data) {
                        _this2.setState({
                            isHjLinked: res.data
                        });
                    } else {
                        _this2.setState({
                            isHjLinked: false
                        });
                    }
                } else {
                    _this2.setState({
                        isHjLinked: false
                    });
                }
            });
        };

        _this2.autoSelectCwListener = function (value) {
            _this2.setState({
                zdrzLoading: true
            });
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var _this2$state3 = _this2.state,
                loginUserInfo = _this2$state3.loginUserInfo,
                cwhFlag = _this2$state3.cwhFlag,
                moneyPushFlag = _this2$state3.moneyPushFlag;

            var xqid = loginUserInfo.XQID,
                xbm = loginUserInfo.XBM;

            var yxwzCwxxTzVOs = value.yxwzCwxxTzVOs,
                name = value.name;

            var zzbdhjid = _this2.getUrlParams("pkid");
            var availableSelectArr = [],
                availSelectCwPkId = "",
                text = "";

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(yxwzCwxxTzVOs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    availableSelectArr.push(item.xz);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (availableSelectArr.indexOf("0") === -1) {
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.warning("抱歉，该房间已满员，请选择其他房间！");
                _this2.setState({
                    zdrzLoading: false
                });
                return;
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(yxwzCwxxTzVOs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _item = _step2.value;

                    //床位未被选择并且未过分配期限
                    if (_item.xz === '0' && !_item.expire) {
                        availSelectCwPkId = _item.id;
                        if (cwhFlag) {
                            text = name + "-" + _item.cwh;
                        } else {
                            text = name;
                        }
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            if (availSelectCwPkId) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHFetch__["a" /* default */])('/whrj/gyxtUnauth/cwfp/checkCwIsPermitSelect', 'GET', { cwid: availSelectCwPkId, xsid: xsid }).then(function (res) {
                    if (res) {
                        if (res.data === 0) {
                            __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("抱歉，该床位已经被其他同学抢占，请选择其他床位！");
                            _this2.setState({
                                zdrzLoading: false
                            });
                            return;
                        } else {
                            // 确认床位信息
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_NHFetch__["a" /* default */])('/whrj/gyxtUnauth/cwfp/yxwzConfirmCwxx', 'POST', {
                                xsid: xsid,
                                cwid: availSelectCwPkId,
                                zzbdhjid: zzbdhjid,
                                moneyPushFlag: moneyPushFlag
                            }).then(function (res) {
                                if (res) {
                                    if (res.data) {
                                        __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.success("分配成功，分配宿舍为 " + text + ", 请尽快确认办理！");
                                        _this2.reloadMenu();
                                        _this2.getFjxxList({
                                            cws: "",
                                            sfbz: "",
                                            xsid: xsid,
                                            xqid: xqid ? xqid : _this2.state.currentXqid ? _this2.state.currentXqid : _this2.state.xqList[0].XQID,
                                            xbm: xbm
                                        });

                                        _this2.getXsssrzYwxxByXsid(xsid);
                                        _this2.checkZzbdisLinked();

                                        _this2.setState({
                                            zdrzLoading: false
                                        });
                                    }
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error("分配失败，请稍后重试！");
                                    _this2.setState({
                                        zdrzLoading: false
                                    });
                                }
                            });
                        }
                    }
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.warning("抱歉，未匹配到合适的床位信息,请选择其他床位！");
                _this2.setState({
                    zdrzLoading: false
                });
            }
        };

        _this2.onSfbzChangeListener = function (checkedValues) {
            var _this2$state4 = _this2.state,
                param = _this2$state4.param,
                currentXqid = _this2$state4.currentXqid,
                sfmy = _this2$state4.sfmy;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xbm = loginUserInfo.XBM;
            param.sfbz = checkedValues.length > 0 ? checkedValues.join(",") : "";
            param.xsid = xsid;
            param.xqid = currentXqid ? currentXqid : _this2.state.xqList[0].XQID;
            param.xbm = xbm;
            param.sfmy = sfmy;
            _this2.setState({
                sfbz: checkedValues.length > 0 ? checkedValues.join(",") : ""
            });
            _this2.getFjxxList(param);
        };

        _this2.tabChangeListener = function (activeKey) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var loginUserInfo = _this2.state.loginUserInfo;

            var xbm = loginUserInfo.XBM;
            var _this2$state$param = _this2.state.param,
                cws = _this2$state$param.cws,
                sfbz = _this2$state$param.sfbz;


            _this2.setState({
                currentXqid: activeKey
            });

            //加载房间信息
            _this2.getFjxxList({
                cws: cws || "",
                sfbz: sfbz || "",
                xsid: xsid,
                xqid: activeKey,
                xbm: xbm
            });
        };

        _this2.reloadMenu = function () {
            _this2.refs.siderMenu.reloadMenuList();
        };

        _this2.state = {
            mkbz: 'GD006_4',
            hjmc: '',
            xzId: '',
            _xzId: '',
            cwsList: [], //床位数
            sfbzList: [], //收费标准
            xqList: [], //校区信息
            currentXqid: "", //当前校区ID
            fjxxList: [], //房间信息
            currentClickCwPkid: "", //当前床位信息ID
            xsssruYwxx: {}, //学生宿舍入住业务信息
            isHjLinked: false, //环节是否办理状态
            param: {}, //过滤条件
            scrollHeight: 200, //默认滚动高度
            loginUserInfo: {}, //当前登录学生信息
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            autoBlLoading: false, //自动办理按钮载入状态
            cancelLoading: false, //取消办理按钮载入状态
            zdrzLoading: false, //自动入住载入状态
            sfbz: "", //收费标准选中值
            sfmy: "", //是否满员选中值
            cwhFlag: true, //是否显示床位号
            payFlag: false, //是否办理缴费环节
            moneyPushFlag: 'false' //是否推送到财务系统
        };
        return _this2;
    }

    _createClass(Dorm, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var that = this;
            this.setState({ scrollHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_getSize__["a" /* default */])().windowH - 206 });
            window.onresize = function () {
                that.setState({
                    scrollHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__utils_getSize__["a" /* default */])().windowH - 206
                });
            };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            this.queryQztjAndYlhj(function (operable) {
                if (operable) {
                    var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_NHCore__["b" /* getLoginUser */])().userId : '';
                    if (xsid) {
                        var _this = _this3;
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_NHCore__["d" /* getLoginUserInfo */])(xsid, function (data) {
                            _this.setState({
                                loginUserInfo: data
                            }, function () {
                                var loginUserInfo = _this.state.loginUserInfo;

                                var xqid = loginUserInfo.XQID,
                                    xbm = loginUserInfo.XBM;

                                if (xsid) {
                                    //办理状态根据 关联现场环节和是否反向关联修改 不根据现场状态
                                    //_this.updateZzbdBlzt();
                                    //加载收费标准、床位数信息
                                    _this.getSfbzAndCwsInfo(xsid, xqid, xbm);
                                    _this.getXsssrzYwxxByXsid(xsid);
                                    //如果学生校区ID不为空,则只加载本校区宿舍信息
                                    if (xqid) {
                                        _this.setState({
                                            currentXqid: xqid
                                        });
                                        _this.getFjxxList({
                                            cws: "",
                                            sfbz: "",
                                            xsid: xsid,
                                            xqid: xqid,
                                            xbm: xbm
                                        });
                                    }
                                }
                                _this.checkZzbdisLinked();
                            });
                        });
                    }
                }
            });
            this.getCwhFlag();
            this.getPayFlag();
            this.getMoneyPushFlag();
        }

        //迎新现场已办理时迎新网站自动办理


        //查询前置条件和依赖环节


        //获取url中传递的参数


        //获取收费标准、床位信息等


        //获取宿舍房间信息


        // 过滤可以选择的房间信息
        /* fitlerRoom = () =>{
            let kyxzRoom= [];
                        // console.log("获取房间信息-------",res.data);
                        let fjxxList = this.state.fjxxList;
                        fjxxList.map((item,index)=>{
                            if(item.yxNum < item.allNum){
                                // console.log("未住满的房间(个数判断)------",item);
                                if(item.bedList && item.bedList.length > 0){
                                    item.yxwzCwxxTzVOs.map((item2,index2)=>{
                                        console.log("item2",item2);
                                        if(item2.xz == '0'){
                                            // console.log("可以选择的床位---------",item2,item);
                                                kyxzRoom.push(item);
                                        }
                                    })
                                }
                            }
                        })
                        let setRoom = [];
                        if(kyxzRoom.length > 0){
                            setRoom = Array.from(new Set(kyxzRoom));
                            // setRoom = Array.from(setRoom);
                        }
                        console.log("过滤后的房间------",kyxzRoom,setRoom);
                        this.setState({
                            setRoom:setRoom
                        })
        } */

        //查询学生宿舍入住信息


        //确认床位分配
        // confirmCwfpxx = (xzId) => {
        //     let xsid = getLoginUser() ? getLoginUser().userId : '';
        //     const {loginUserInfo} = this.state;
        //     const xqid = loginUserInfo.XQID, xbm = loginUserInfo.XBM;

        //     if (!xzId) {
        //         message.warning("请先选择一个床位！");
        //         return;
        //     }

        //     //检查该床位是否被其他学生抢占(防并发的情况下同一个床位被其他人重复选择)
        //     NHFetch('/gyxtUnauth/cwfp/checkCwIsPermitSelect', 'GET', {cwid: xzId, xsid: xsid})
        //         .then(res => {
        //             if (res) {
        //                 if (res.data === 0) {
        //                     message.error("抱歉，该床位已经被其他同学抢占，请选择其他床位！");
        //                     return;
        //                 } else {
        //                     //确认床位信息
        //                     this.cwfpSubmit(xsid, xzId, xqid, xbm);
        //                 }
        //             }
        //         });
        // };

        //床位分配提交
        // cwfpSubmit = (xsid, currentClickCwPkid, xqid, xbm) => {
        //     let zzbdhjid = this.getUrlParams("pkid");
        //     let params = {xsid: xsid, cwid: currentClickCwPkid, zzbdhjid: zzbdhjid};

        //     NHFetch('/gyxtUnauth/cwfp/checkCwIsAvailableSelected', 'GET', {cwid: currentClickCwPkid})
        //         .then(res => {
        //             if (res) {
        //                 if (res.data) {
        //                     NHFetch('/gyxtUnauth/cwfp/yxwzConfirmCwxx', 'POST', params)
        //                         .then(res => {
        //                             if (res) {
        //                                 if (res.data) {
        //                                     message.success("分配成功！");
        //                                     this.reloadMenu();
        //                                     this.setState({
        //                                         currentClickCwPkid: ""
        //                                     });

        //                                     this.getFjxxList({
        //                                         cws: "",
        //                                         sfbz: "",
        //                                         xsid: xsid,
        //                                         xqid: xqid ? xqid : this.state.currentXqid ? this.state.currentXqid : this.state.xqList[0].XQID,
        //                                         xbm: xbm
        //                                     });

        //                                     this.getXsssrzYwxxByXsid(xsid);

        //                                     this.checkZzbdisLinked();
        //                                 } else {
        //                                     message.error("分配失败，请稍后重试！");
        //                                 }
        //                             }
        //                         })
        //                 } else {
        //                     message.error("抱歉，该床位未到分配时间或已过床位分配时间期限，请选择其他床位! ");
        //                 }
        //             }
        //         });
        // };

        //选择床位弹层
        // showConfirm = (value, id, cwh) => {
        //     confirm({
        //         title: <span>确定选择{value.name}房间的下列床铺？</span>,
        //         content: (
        //             <SelectModal
        //                 data={value}
        //                 id={id}
        //                 currentClickCwh={cwh}
        //                 onChange={value => {
        //                     this.setState({
        //                         xzId: value.id,
        //                         currentClickCwPkid: value.id
        //                     });
        //                 }}
        //             />
        //         ),
        //         onOk: () => {
        //             const {currentClickCwPkid} = this.state;
        //             //确定分配宿舍提交
        //             this.confirmCwfpxx(currentClickCwPkid);
        //         },
        //         onCancel: () => {
        //             this.setState({
        //                 currentClickCwPkid: ""
        //             });
        //         }
        //     });
        // };

        //取消办理事件


        //自动办理事件

        //检查环节是否已办理


        //自动入住事件


        //收费标准onChange事件


        //是否满员onChange事件
        // onSfmyChangeListener = (e) => {
        //     const { param, currentXqid, sfbz } = this.state;
        //     let xsid = getLoginUser() ? getLoginUser().userId : '';
        //     const { loginUserInfo } = this.state;
        //     const xbm = loginUserInfo.XBM;
        //     param.sfbz = sfbz;
        //     param.xsid = xsid;
        //     param.xqid = currentXqid ? currentXqid : this.state.xqList[0].XQID;
        //     param.xbm = xbm;
        //     param.sfmy = e.target.value;
        //     this.setState({
        //         sfmy: e.target.value
        //     });
        //     this.getFjxxList(param);
        // };

        //宿舍类型onChange事件
        // onCwsChange = (checkedValues) => {
        //     const { param, currentXqid } = this.state;
        //     let xsid = getLoginUser() ? getLoginUser().userId : '';
        //     const { loginUserInfo } = this.state;
        //     const xbm = loginUserInfo.XBM;
        //     param.cws = checkedValues.length > 0 ? checkedValues.join(",") : "";
        //     param.xsid = xsid;
        //     param.xbm = xbm;
        //     param.xqid = currentXqid ? currentXqid : this.state.xqList[0].XQID;
        //     this.getFjxxList(param);
        // };

        //tab切换事件


        //重新加载菜单

    }, {
        key: 'render',


        /*  handleNextRoom = (RoomList) =>{
             const {fjxxList,setRoom} = this.state;
             console.log("当前宿舍信息-----------",RoomList,fjxxList,setRoom);
             let list = [];
             fjxxList.map((item,index)=>{
                 if(item.fjid == "cba18dd6-ac51-4119-b35e-1f2d9eb30bf7"){
                     item. yxNum = '8';
                 }
                 list.push(item);
             })
             console.log("模拟修改-----------",list);
             this.setState({
                 fjxxList:list
             },()=>{
                 this.fitlerRoom();
             })
         } */

        value: function render() {
            var _this4 = this;

            var _state = this.state,
                xzId = _state.xzId,
                _xzId = _state._xzId,
                cwsList = _state.cwsList,
                xqList = _state.xqList,
                sfbzList = _state.sfbzList,
                fjxxList = _state.fjxxList,
                xsssruYwxx = _state.xsssruYwxx,
                isHjLinked = _state.isHjLinked,
                scrollHeight = _state.scrollHeight,
                currentXqid = _state.currentXqid,
                autoBlLoading = _state.autoBlLoading,
                cancelLoading = _state.cancelLoading,
                zdrzLoading = _state.zdrzLoading,
                cwhFlag = _state.cwhFlag;
            //学生已选宿舍信息

            var xqmc = xsssruYwxx.xqmc,
                ldmc = xsssruYwxx.ldmc,
                fj = xsssruYwxx.fj,
                cwh = xsssruYwxx.cwh;

            var yxssInfo = '';
            if (cwhFlag) {
                yxssInfo = (xqmc || "") + "-" + (ldmc || "") + "-" + (fj || "") + "-" + (cwh || "") + "号床";
            } else {
                yxssInfo = (xqmc || "") + "-" + (ldmc || "") + "-" + (fj || "");
            }
            //let yxssInfo = (xqmc || "") + "-" + (ldmc || "") + "-" + (fj || "") + "-" + (cwh || "") + "号床";
            // let fsmyList = [{ "label": "未满", "value": "0" }, { "label": "满员", "value": "1" }];
            /* let RoomList = []
            if(setRoom.length > 1){
                RoomList.push(setRoom[0]);
            }else{
                RoomList = setRoom;
            } */
            return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_24__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230',
                        mkbz: this.state.mkbz
                        /*   active={5}*/
                        , menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_24__components__["a" /* Flex */].Item,
                        { className: 'page_con_r ' },
                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_27__pages_Assembly_titleTop__["a" /* default */],
                                {
                                    className: 'mt-20',
                                    title: this.state.hjmc,
                                    extra: false
                                },
                                !isHjLinked ? __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_12_antd_lib_button___default.a,
                                    {
                                        className: 'ml-10',
                                        type: 'primary',
                                        ghost: true,
                                        loading: autoBlLoading,
                                        onClick: this.handleAutoDistributeListener
                                    },
                                    '\u81EA\u52A8\u529E\u7406'
                                ) : __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_12_antd_lib_button___default.a,
                                    {
                                        className: 'ml-10',
                                        type: 'danger',
                                        ghost: true,
                                        loading: cancelLoading,
                                        onClick: this.judeageCs
                                    },
                                    '\u53D6\u6D88\u529E\u7406'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                'div',
                                { className: 'p-sw' },
                                __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_24__components__["a" /* Flex */],
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                        'span',
                                        null,
                                        '\u6536\u8D39\u6807\u51C6\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_24__components__["a" /* Flex */].Item,
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                            CheckboxGroup,
                                            {
                                                style: { width: '100%' },
                                                onChange: this.onSfbzChangeListener
                                            },
                                            __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_8_antd_lib_row___default.a,
                                                null,
                                                sfbzList.map(function (elem, index) {
                                                    return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_10_antd_lib_col___default.a,
                                                        {
                                                            key: index,
                                                            span: 4
                                                        },
                                                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_20_antd_lib_checkbox___default.a,
                                                            {
                                                                value: elem.value
                                                            },
                                                            elem.label
                                                        )
                                                    );
                                                })
                                            )
                                        )
                                    )
                                ),
                                isHjLinked ? __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert___default.a, { message: "当前选择宿舍为: " + yxssInfo, type: 'info', showIcon: true })
                                ) : __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin___default.a,
                                    { spinning: zdrzLoading },
                                    __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-whrjChooseDor-__index__tab_box' },
                                        __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__selectBox__["a" /* default */], {
                                            Data: fjxxList,
                                            xzId: _xzId
                                            // showConfirm={this.showConfirm}
                                            // onChange={value => {
                                            //     this.setState({
                                            //         xzId: value.id,
                                            //         currentClickCwPkid: value.id
                                            //     });
                                            // }}
                                            , autoSelectCwListener: function autoSelectCwListener(value) {
                                                return _this4.autoSelectCwListener(value);
                                            },
                                            scrollHeight: scrollHeight,
                                            tabChangeListener: this.tabChangeListener,
                                            xqList: xqList,
                                            currentXqid: currentXqid
                                        })
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
                                'div',
                                { className: 'text-center mt-50' },
                                __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__common__["a" /* default */], { hjmc: "自选宿舍", key: 'GD006_4', mkbz: 'GD006_4', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return Dorm;
}(__WEBPACK_IMPORTED_MODULE_23_react___default.a.Component);



/***/ }),

/***/ 1147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_popover_style__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_popover_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_popover_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_popover__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_tabs_style__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_css__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_custom_scrollbars__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_custom_scrollbars__);









var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }










if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var TabPane = __WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs___default.a.TabPane;

/**
 * @author weishihuai
 * @date 2018/7/6
 * @time 14:42
 * @Description: 迎新网站-自助报到-宿舍分配-宿舍床位信息
 */
var SelectBox = (_temp = _class = function (_React$Component) {
    _inherits(SelectBox, _React$Component);

    function SelectBox(props) {
        _classCallCheck(this, SelectBox);

        var _this = _possibleConstructorReturn(this, (SelectBox.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(SelectBox)).call(this, props));

        _this.getListItem = function () {
            var Data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var _this$props = _this.props,
                className = _this$props.className,
                showConfirm = _this$props.showConfirm,
                xzId = _this$props.xzId,
                onChange = _this$props.onChange,
                autoSelectCwListener = _this$props.autoSelectCwListener;

            return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11__components__["a" /* Flex */],
                { align: 'top', wrap: 'wrap', className: 'mt-20' },
                Data.length > 0 ? Data.map(function (item, idx) {
                    var sscx = item.sscx != null && item.sscx.length > 0 ? item.sscx : '';
                    var fjxx = item.name + " " + sscx;
                    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                        'div',
                        { key: idx, className: 'app__css__app-pages-SelfHelp-whrjChooseDor-__index__item' },
                        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-whrjChooseDor-__index__item_con' },
                            __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_11__components__["a" /* Flex */],
                                { justify: 'between' },
                                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                    'span',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { className: 'app__css__app-pages-SelfHelp-whrjChooseDor-__index__round' }),
                                    fjxx.length < 12 ? fjxx : __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                        'span',
                                        { style: { cursor: "pointer" } },
                                        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_4_antd_lib_popover___default.a,
                                            { content: fjxx, trigger: 'hover' },
                                            fjxx.substr(0, 10) + "..."
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                    'span',
                                    null,
                                    item.allNum ? item.allNum : '0',
                                    '\u4EBA\u95F4'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_11__components__["a" /* Flex */],
                                { style: { marginTop: "15px" } },
                                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                    'span',
                                    null,
                                    '\u5F00\u653E\u5E8A\u4F4D\u6570\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                    'span',
                                    null,
                                    item.openNum ? item.openNum : '0'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_11__components__["a" /* Flex */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                    'span',
                                    null,
                                    '\u5269\u4F59\u53EF\u9009\u5E8A\u4F4D\u6570\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                    'span',
                                    null,
                                    item.checkNum ? item.checkNum : '0'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components__["a" /* Flex */], {
                                wrap: 'wrap',
                                align: 'center',
                                justify: 'center',
                                className: 'app__css__app-pages-SelfHelp-whrjChooseDor-__index__select_box'
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-whrjChooseDor-__index__item_btn_box' },
                            __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                'div',
                                {
                                    className: 'app__css__app-pages-SelfHelp-whrjChooseDor-__index__item_btn',
                                    onClick: function onClick() {
                                        return autoSelectCwListener(item);
                                    }
                                },
                                '\u81EA\u52A8\u5165\u4F4F'
                            )
                        )
                    );
                }) : __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                        'span',
                        { style: { color: "#f00" } },
                        '\u6682\u65E0\u5339\u914D\u7684\u5BBF\u820D\u4FE1\u606F\uFF01'
                    )
                )
            );
        };

        return _this;
    }

    //床位信息


    _createClass(SelectBox, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                className = _props.className,
                Data = _props.Data,
                scrollHeight = _props.scrollHeight,
                tabChangeListener = _props.tabChangeListener,
                xqList = _props.xqList,
                currentXqid = _props.currentXqid;

            var activeKey = currentXqid || xqList[0] && xqList[0].XQID;

            return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs___default.a,
                { defaultActiveKey: '0', activeKey: activeKey, tabPosition: 'top',
                    onChange: function onChange(activeKey) {
                        return tabChangeListener(activeKey);
                    } },
                xqList.map(function (xq) {
                    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                        TabPane,
                        { tab: xq.XQMC, key: xq.XQID },
                        Data.length > 16 ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_13_react_custom_scrollbars__["Scrollbars"],
                            { autoHide: true,
                                style: { width: '100%', height: scrollHeight } },
                            _this2.getListItem(Data)
                        ) : _this2.getListItem(Data)
                    );
                })
            );
        }
    }]);

    return SelectBox;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component), _class.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
    xzId: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any,
    showConfirm: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    autoSelectCwListener: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    tabChangeListener: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
}, _class.defaultProps = {
    xzId: '',
    showConfirm: Function.prototype,
    onChange: Function.prototype,
    autoSelectCwListener: Function.prototype,
    tabChangeListener: Function.prototype
}, _temp);


/***/ }),

/***/ 1148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WeChatPay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pay_index_css__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pay_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__pay_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__qrCode__ = __webpack_require__(1149);














var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }


















if (false) {
    module.hot.accept('../pay/index.css', function () {
        require('../pay/index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_23_history_createHashHistory___default()();

var WeChatPay = function (_React$Component) {
    _inherits(WeChatPay, _React$Component);

    function WeChatPay(props) {
        _classCallCheck(this, WeChatPay);

        var _this = _possibleConstructorReturn(this, (WeChatPay.__proto__ || __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default()(WeChatPay)).call(this, props));

        _this.queryToken = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/wxChatPay/queryToken', 'GET').then(function (res) {
                if (res && res.code === 200) {
                    _this.setState({
                        token: res.data
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("获取令牌失败，请稍后再试");
                }
            });
        };

        _this.checkIsZzbdHjLinked = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var zzbdhjid = _this.getQueryString('pkid');

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])("/zzbdCommon/checkIsZzbdHjLinked", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.code == 200) {
                    if (!res.data) {
                        _this.queryOrderInfo();
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("检查环节办理接口调用失败，请稍后再试");
                }
            });
        };

        _this.queryOrderInfo = function () {
            var mkbz = _this.state.mkbz;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/wxChatPay/queryOrderInfo', 'GET', { hjdm: mkbz }).then(function (res) {
                if (res && res.code == 200) {
                    if (res.data == 1) {
                        _this.reloadMenu();
                        _this.getSfxxList();
                    }
                }
            });
        };

        _this.getSfxxList = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/jfxtUnauth/yxwzjfxx/getJfxxList', 'GET') //所有的收费数据
            .then(function (resData) {
                if (resData && resData.data) {
                    _this.setState({ data: resData.data }, function () {
                        var list = _this.state.data.filter(function (item) {
                            return item.QFJE > 0 ? true : false;
                        });
                        if (resData.data.length === 0) {
                            _this.setState({
                                flage: false
                            });
                        } else {
                            if (list.length <= 0) {
                                _this.setState({ flage: false });
                            }
                        }
                    });
                }
            });
        };

        _this.closeWxPayOrder = function () {
            var mkbz = _this.state.mkbz;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/wxChatPay/closeWxPayOrder', 'GET', { hjdm: mkbz }).then(function (res) {
                if (res && res.code === 200) {
                    if (res.data === 1) {
                        _this.createWxPayOrder();
                    } else {
                        __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("微信订单关闭失败，请稍后再试");
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("微信订单关闭失败，请稍后再试");
                }
            });
        };

        _this.createWxPayOrder = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var _this$state = _this.state,
                data = _this$state.data,
                selectData = _this$state.selectData,
                token = _this$state.token;

            var jfje = 0.0; // 缴费金额
            var list = selectData.length > 0 ? selectData : data.filter(function (item) {
                return item.QFJE > 0 ? true : false;
            });
            list.map(function (item) {
                jfje += item.QFJE;
            });
            jfje = Math.round(jfje * Math.pow(10, 2)) / Math.pow(10, 2);
            //需要支付的收费项目订单信息
            var params = {};
            params['xsid'] = xsid;
            params['paymentAmount'] = jfje;
            var sfxmList = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator___default()(list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    var sfxmObj = {};
                    sfxmObj['sfxmid'] = item.SFXMID;
                    sfxmObj['qfje'] = item.QFJE;
                    sfxmList.push(sfxmObj);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            params['sfxmList'] = sfxmList;
            params['token'] = token;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/wxChatPay/addOrderInfo', 'POST', params).then(function (res) {
                if (res && res.code === 200) {
                    if (res.data == 1) {
                        //微信支付Native下单
                        _this.toNativeOrder();
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("创建业务订单操作失败，请稍后再试");
                }
            });
        };

        _this.toNativeOrder = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var mkbz = _this.state.mkbz;

            var params = {
                xsid: xsid,
                hjdm: mkbz
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/wxChatPay/toNativeOrder', 'POST', params).then(function (res) {
                if (res && res.code === 200) {
                    if (res.data) {
                        _this.setState({
                            qrcode: res.data,
                            visible: true
                        });
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error("创建微信订单操作失败，请稍后再试");
                }
            });
        };

        _this.loadZxjfInfo = function () {
            var mkbz = _this.state.mkbz;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])('/jfxtUnauth/yxwzjfxx/getCurrDdxx', 'GET', { hjdm: mkbz }).then(function (res) {
                if (res && res.data) {
                    _this.setState({
                        zxjfInfo: res.data
                    });
                }
            });
        };

        _this.queryQztjAndYlhj = function (callback) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    } else if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    } else if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    } else {
                        _this.getSfxxList();
                    }if (callback) {
                        callback(_this.state.operable);
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_25__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.onSave = function () {
            _this.setState({ loading: true });
            setTimeout(function () {
                _this.setState({
                    loading: false
                });
            }, 1000);
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.onRowSelect = function (selectedRowKeys, selectedRows) {
            _this.setState({
                selectData: selectedRows.filter(function (item) {
                    return item.QFJE > 0 ? true : false;
                })
            });
        };

        _this.showModal = function () {
            _this.closeWxPayOrder();
        };

        _this.handleCancel = function (e) {
            _this.setState({
                visible: false
            }, function () {
                _this.getSfxxList();
                _this.reloadMenu();
                _this.queryToken();
            });
        };

        _this.state = {
            mkbz: 'GD008_3',
            hjmc: '',
            data: [],
            loading: false,
            pageData: { //分页设置的是三个参数
                total: 0,
                pageSize: 10, //当前页默认多少条数据
                page: 1
            },
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            zxjfInfo: {}, //在线缴费相关信息
            hjje: 0, //缓交金额
            jfxxHz: {}, //缴费信息汇总
            visible: false,
            flage: true, //是否存在需要缴费的项目
            selectData: [], //选择的缴费项目
            token: '', //防重令牌
            qrcode: '' //缴费二维码
        };
        return _this;
    }

    _createClass(WeChatPay, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.checkIsZzbdHjLinked();
            this.loadZxjfInfo();
            this.queryToken();
            this.queryQztjAndYlhj(function (operable) {
                if (operable) {}
            });
        }

        //获取防重令牌


        //检查该环节是否已经办理


        //同步学生缴费情况信息


        //获取缴费信息


        //关闭微信支付订单


        //添加订单到业务系统


        //Native下单


        //获取在线缴费相关信息


        //查询前置条件和依赖环节


        //重新加载菜单


        //获取选择的项目


        //网上支付点击事件


        //model关闭事件

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                loading = _state.loading,
                data = _state.data,
                zxjfInfo = _state.zxjfInfo,
                selectData = _state.selectData,
                token = _state.token,
                qrcode = _state.qrcode;

            var columns = [{
                title: '序号',
                dataIndex: 'XH'
            }, {
                title: '收费项目',
                dataIndex: 'SFXMMC'
            }, {
                title: '应收金额（元）',
                dataIndex: 'YSJE'
            }, {
                title: '实收金额（元）',
                dataIndex: 'SSJE',
                render: function render(text, record) {
                    return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        'span',
                        { className: 'text-primary' },
                        text
                    );
                }
            }, {
                title: '欠费金额（元）',
                dataIndex: 'QFJE',
                render: function render(text, record) {
                    if (text > 0) {
                        return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'span',
                            { className: 'text-info-red' },
                            text
                        );
                    } else {
                        return text;
                    }
                }
            }];

            return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                'div',
                { className: 'app__css__app-pages-SelfHelp-pay-__index__page_pay' },
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230'
                        /*active={7}*/
                        , mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_15__components__["a" /* Flex */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjmc, extra: false }),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                { className: 'p-sw mt-20' },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_table___default.a, {
                                    bordered: true,
                                    size: 'middle',
                                    rowKey: function rowKey(record) {
                                        return record.SFXMID;
                                    },
                                    rowSelection: {
                                        onChange: function onChange(selectedRowKeys, selectedRows) {
                                            return _this2.onRowSelect(selectedRowKeys, selectedRows);
                                        }
                                    },
                                    pagination: false,
                                    columns: columns,
                                    dataSource: data
                                }),
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'div',
                                    { className: 'text-center mt-50' },
                                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        this.state.flage == true && zxjfInfo.ZFD != '0' ? __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default.a,
                                            { onClick: function onClick() {
                                                    return _this2.showModal();
                                                },
                                                type: 'primary',
                                                htmlType: 'submit' },
                                            '\u7F51\u4E0A\u652F\u4ED8'
                                        ) : null,
                                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                )
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__common__["a" /* default */], { hjmc: "网上缴费", key: 'GD008', mkbz: 'GD008', nonOperationalData: this.state.nonOperationalData }),
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal___default.a,
                    {
                        title: '\u4E8C\u7EF4\u7801\u4FE1\u606F',
                        visible: this.state.visible,
                        onCancel: this.handleCancel,
                        footer: [__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default.a,
                            { onClick: this.handleCancel },
                            '\u5173\u95ED'
                        )] },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__qrCode__["a" /* default */], { qrcode: qrcode })
                )
            );
        }
    }]);

    return WeChatPay;
}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);



/***/ }),

/***/ 1149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QrCodeIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_jsx_style__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_jsx_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_styled_jsx_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qrcode_react__ = __webpack_require__(1881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qrcode_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_qrcode_react__);





var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }





var QrCodeIndex = function (_React$Component) {
    _inherits(QrCodeIndex, _React$Component);

    function QrCodeIndex(props) {
        _classCallCheck(this, QrCodeIndex);

        var _this = _possibleConstructorReturn(this, (QrCodeIndex.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(QrCodeIndex)).call(this, props));

        _this.state = {};
        return _this;
    }

    _createClass(QrCodeIndex, [{
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'render',
        value: function render() {
            var qrcode = this.props.qrcode;

            console.log(qrcode);
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'div',
                { style: { display: 'flex', justifyContent: 'center' }, className: 'jsx-270676329'
                },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    'div',
                    {
                        className: 'jsx-270676329' + ' ' + 'result-example'
                    },
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_qrcode_react___default.a, { className: 'spe', value: qrcode, renderAs: 'canvas',
                        style: {
                            height: '160px',
                            width: '160px',
                            padding: '1.0rem'
                        }
                    }),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                        'p',
                        { style: { fontSize: '18px' }, className: 'jsx-270676329'
                        },
                        '\u8BF7\u4F7F\u7528\u5FAE\u4FE1\u626B\u7801\u7F34\u8D39'
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_styled_jsx_style___default.a, {
                    styleId: '270676329',
                    css: ['.result-example .spe{width:160px;height:160px;}', '.am-result .am-result-pic{width:160px;height:160px;}']
                })
            );
        }
    }]);

    return QrCodeIndex;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);



/***/ }),

/***/ 1150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SchoolUniform; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_number_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_select__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_index__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_common_NHSelect__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_common_hint__ = __webpack_require__(35);
















var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _defineProperty(obj, key, value) { if (key in obj) { __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }

















var history = __WEBPACK_IMPORTED_MODULE_24_history_createHashHistory___default()();
var FormItem = __WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item;
var Option = __WEBPACK_IMPORTED_MODULE_12_antd_lib_select___default.a.Option;
var basicUrl = "/zzbd";
var commonUrl = '/zzbdCommon';

var formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 }
};

var SchoolUniform = (_dec = __WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.create(), _dec(_class = function (_React$Component) {
    _inherits(SchoolUniform, _React$Component);

    function SchoolUniform(props) {
        _classCallCheck(this, SchoolUniform);

        var _this = _possibleConstructorReturn(this, (SchoolUniform.__proto__ || __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of___default()(SchoolUniform)).call(this, props));

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_28__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.getDmkMc = function (dmbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])(basicUrl + "/getDmkMc", "GET", _defineProperty({ dmbz: dmbz }, 'dmbz', dmbz)).then(function (res) {
                if (res) {
                    if (res.data) {
                        if (dmbz === "YXWZ_JXXM") {
                            _this.setState({ cmmc: res.data });
                        } else if (dmbz === "YXWZ_FZCM") {
                            _this.setState({ fzmc: res.data });
                        }
                    }
                }
            });
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.props.form.validateFieldsAndScroll(function (err, values) {
                if (err) {
                    return;
                }

                var sUrl = '/saveXffzData';
                if (_this.state.update) {
                    sUrl = '/updatexffzData';
                }
                //修改 可编辑状态，并可以update数据
                if (!_this.state.editable) {
                    _this.setState({ update: true, editable: true });
                    return;
                }
                var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId;
                var zzbdhjid = _this.getUrlParams("pkid");
                var params = { xsid: xsid, zzbdhjid: zzbdhjid, formData: values };
                //请求保存或修改数据
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])(basicUrl + sUrl, 'POST', params).then(function (res) {
                    if (res) {
                        if (res.data == '1') {
                            __WEBPACK_IMPORTED_MODULE_21_antd_lib_index__["message"].success('信息保存成功！');
                            _this.reloadMenu();
                            _this.getFzpo();
                        } else {
                            __WEBPACK_IMPORTED_MODULE_21_antd_lib_index__["message"].error('信息保存失败，请重试！');
                        }
                    }
                });
            });
        };

        _this.getUrlParams = function (param) {
            return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD014',
            hjmc: '',
            data: [{
                key: '1',
                size: 'XS',
                man: '160 / 80A',
                woman: '150 / 78A'
            }, {
                key: '2',
                size: 'S',
                man: '165 / 80A',
                woman: '155 / 82A'
            }, {
                key: '3',
                size: 'M',
                man: '170 / 84A',
                woman: '160 / 86A'
            }, {
                key: '4',
                size: 'L',
                man: '175 / 88A',
                woman: '165 / 90A'
            }, {
                key: '5',
                size: 'XL',
                man: '180 / 92A',
                woman: '170 / 94A'
            }, {
                key: '6',
                size: 'XXL',
                man: '185 / 96A',
                woman: '172 / 98A'
            }, {
                key: '7',
                size: 'XXXL',
                man: '190 / 100A',
                woman: '175 / 102A'
            }],
            editable: true,
            update: false,
            initPOvalue: {
                nd: '',
                xsid: '',
                fzcm: '',
                xm: '',
                sg: '',
                tz: '',
                bz: ''
            },
            cmmc: {},
            fzmc: {},
            xmmc: '',
            fzcmmc: '',
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {} //不可操作的数据
        };
        return _this;
    }

    //渲染前获取信息


    _createClass(SchoolUniform, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.queryQztjAndYlhj();
            this.getFzpo();
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getDmkMc("YXWZ_JXXM");
            this.getDmkMc("YXWZ_FZCM");
        }

        //查询前置条件和依赖环节

    }, {
        key: 'getFzpo',
        value: function getFzpo() {
            var _this2 = this;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__utils_NHCore__["b" /* getLoginUser */])().userId; //todo
            var xmmc = '';
            var fzcmmc = '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])(basicUrl + "/getXfFzpoByXsidAndNd", "GET", _defineProperty({ xsid: xsid }, 'xsid', xsid)).then(function (res) {
                if (res) {
                    if (res.data) {

                        _this2.setState({ initPOvalue: res.data, editable: false });

                        _this2.state.cmmc.map(function (initItem) {
                            if (initItem.DM === res.data.xm) {
                                xmmc = initItem.MC;
                            }
                        });
                        _this2.state.fzmc.map(function (initItem) {
                            if (initItem.DM === res.data.fzcm) {
                                fzcmmc = initItem.MC;
                            }
                        });
                        _this2.setState({ xmmc: xmmc, fzcmmc: fzcmmc });
                    }
                }
            });
        }

        //获取下拉列表value对应的名称


        //保存和修改


        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var getFieldDecorator = this.props.form.getFieldDecorator;
            var _state = this.state,
                data = _state.data,
                editable = _state.editable,
                initPOvalue = _state.initPOvalue,
                xmmc = _state.xmmc,
                fzcmmc = _state.fzcmmc;

            var columns = [{
                title: '尺码',
                dataIndex: 'size',
                key: 'size',
                render: function render(text) {
                    return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        'span',
                        { className: 'text-bold' },
                        text
                    );
                }
            }, {
                title: '身高/胸围',
                children: [{
                    title: '男款',
                    dataIndex: 'man',
                    key: 'man',
                    render: function render(text) {
                        return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'span',
                            { className: 'text-blue' },
                            text
                        );
                    }
                }, {
                    title: '女款',
                    dataIndex: 'woman',
                    key: 'woman',
                    render: function render(text) {
                        return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'span',
                            { className: 'text-info-red' },
                            text
                        );
                    }
                }]
            }];

            return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230'
                        /*  active={2}*/
                        , mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pages_Assembly_titleTop__["a" /* default */], { title: this.state.hjmc, extra: false }),
                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a,
                                { onSubmit: this.handleSubmit },
                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                    'div',
                                    { className: 'p-sw' },
                                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_17__components__["a" /* Flex */],
                                        { align: 'start', wrap: 'wrap' },
                                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u8EAB\u9AD8'
                                                }),
                                                getFieldDecorator('sg', { initialValue: initPOvalue.sg })(editable ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number___default.a, { placeholder: '\u8BF7\u586B\u5199\u8EAB\u9AD8',
                                                    min: 0,
                                                    max: 300,
                                                    disabled: !editable }) : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.sg,
                                                    ' '
                                                )),
                                                '\xA0\xA0',
                                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    '  CM '
                                                )
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u4F53\u91CD'
                                                }),
                                                getFieldDecorator('tz', { initialValue: initPOvalue.tz })(editable ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input_number___default.a, { placeholder: '\u8BF7\u586B\u5199\u4F53\u91CD',
                                                    min: 0,
                                                    max: 500, disabled: !editable }) : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.tz
                                                )),
                                                '\xA0\xA0',
                                                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    '  KG '
                                                )
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u670D\u88C5\u5C3A\u7801'
                                                }),
                                                getFieldDecorator('fzcm', {
                                                    initialValue: initPOvalue.fzcm,
                                                    rules: [{
                                                        required: true,
                                                        message: '请选择服装尺码'
                                                    }]
                                                })(editable ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_common_NHSelect__["a" /* default */], { sign: "dmk_yxwz_fzcm" }) : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    ' ',
                                                    fzcmmc,
                                                    ' '
                                                ))
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                            'div',
                                            { className: 'form_item' },
                                            __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                FormItem,
                                                _extends({}, formItemLayout, {
                                                    label: '\u5907\u6CE8'
                                                }),
                                                getFieldDecorator('bz', { initialValue: initPOvalue.bz })(editable ? __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { placeholder: '\u8BF7\u586B\u5199\u5907\u6CE8', disabled: !editable }) : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                                    'span',
                                                    null,
                                                    initPOvalue.bz
                                                ))
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_common_hint__["a" /* default */], null),
                                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                        'div',
                                        { className: 'text-center mt-50' },
                                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,
                                            {
                                                type: 'primary',
                                                htmlType: 'submit'
                                            },
                                            editable ? '保存' : '修改'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                                    )
                                )
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__common__["a" /* default */], { hjmc: "校服服装尺码", key: 'GD014', mkbz: 'GD014', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return SchoolUniform;
}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component)) || _class);


/***/ }),

/***/ 1151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DormInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_NHCore__ = __webpack_require__(8);







var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }









//请求默认路径

if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var pathUrl = "api/zhxg-yxxt";

var DormInfo = function (_React$Component) {
    _inherits(DormInfo, _React$Component);

    function DormInfo(props) {
        _classCallCheck(this, DormInfo);

        var _this = _possibleConstructorReturn(this, (DormInfo.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(DormInfo)).call(this, props));

        _this.getDormInfo = function (xsid) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_NHFetch__["a" /* default */])(pathUrl + '/yxwz/gdlm/qssy/getDormInfoByXsid', 'GET', { xsid: xsid }).then(function (res) {
                if (res && res.data) {
                    _this.setState({
                        roommateInfoList: res.data
                    });
                }
            });
        };

        _this.state = {
            roommateInfoList: []
            // flmid:'',//父栏目id
        };
        return _this;
    }

    _createClass(DormInfo, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (xsid) {
                this.getDormInfo(xsid);
            }
        }

        //加载室友信息

    }, {
        key: 'render',
        value: function render() {
            var roommateInfoList = this.state.roommateInfoList;
            var columns = [
            //   render: text => <a>{text}</a>,
            { title: '姓名', dataIndex: 'XM', key: 'XM' }, { title: '性别', dataIndex: 'XB', key: 'XB' }, { title: '院系', dataIndex: 'BMMC', key: 'BMMC' }, { title: '专业', dataIndex: 'ZYMC', key: 'ZYMC' }, { title: '班级', dataIndex: 'BJMC', key: 'BJMC' }, { title: '省市', dataIndex: 'JG', key: 'JG' }];
            //     const roommateInfoList = [
            //       {
            //           key: 1,
            //           XM: '张伟',
            //           XB:'男',
            //           BMMC:'信科院',
            //           ZYMC:'通信工程',
            //           BJMC:'110',
            //           JG:'广东省广州市'
            //         },
            // ];

            return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */].Item,
                        { className: 'app__css__app-pages-dormInfo-__index__con_r' },
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__pages_Assembly_Breadcrumb__["a" /* default */], {
                            list: [{ name: '首页', url: '/index' }, { name: '同寝信息', url: '/dormInfo' }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_table___default.a, { columns: columns, dataSource: roommateInfoList, pagination: false })
                    )
                )
            );
        }
    }]);

    return DormInfo;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);



/***/ }),

/***/ 1152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IndexRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_index__ = __webpack_require__(548);






var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }




var history = __WEBPACK_IMPORTED_MODULE_7_history_createHashHistory___default()();

/*页面*/


var IndexRoute = function (_React$Component) {
    _inherits(IndexRoute, _React$Component);

    function IndexRoute(props) {
        _classCallCheck(this, IndexRoute);

        var _this = _possibleConstructorReturn(this, (IndexRoute.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(IndexRoute)).call(this, props));

        _this.loadMrlm = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])("/dhlm/getDhlmMrlm", "GET").then(function (resData) {
                if (resData && resData.data) {
                    var dhlm = resData.data || [];
                    _this.setState({ dhlm: dhlm });
                    // 若存在默认栏目 就跳转到对应的默认栏目界面  --在迎新管理-服务管理-导航管理-默认栏目
                    var mrlm = dhlm.filter(function (item) {
                        return item.mrlm === '1';
                    });
                    if (mrlm.length > 0 && mrlm[0].MKBZ !== 'index') {
                        history.push({
                            pathname: mrlm[0].MKBZ
                        });
                    }
                }
            });
        };

        _this.state = {
            dhlm: {},
            nextUrl: 'index'
        };
        return _this;
    }

    _createClass(IndexRoute, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.loadMrlm();
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            var dhlm = nextState.dhlm;
            if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.state.dhlm) == '{}' && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(nextState.dhlm) != '{}') {
                var lmlx = dhlm['lmlx'];
                var flbz = dhlm['flbz'];
                var mkbz = dhlm['mkbz'];
                var flmid = dhlm['flmid'];
                var lmlj = dhlm['lmlj'];
                var pkid = dhlm['pkid'];
                if (lmlx == 3) {
                    history.push({
                        pathname: mkbz
                    });
                } else if (lmlx == 1) {
                    history.push({
                        pathname: 'notice',
                        search: 'flbz=' + flbz
                    });
                } else if (lmlx == 2) {
                    if (flmid == -1) {} else {
                        history.push({
                            pathname: 'link',
                            search: 'pkid=' + pkid
                        });
                    }
                    window.open(lmlj);
                }
            }
            return true;
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__pages_index__["a" /* default */], null);
        }
    }]);

    return IndexRoute;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);



/***/ }),

/***/ 1153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_carousel_style__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_carousel_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_carousel_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_carousel__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_history_createHashHistory__);









var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }








if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var hashHistory = __WEBPACK_IMPORTED_MODULE_12_history_createHashHistory___default()();

var Link = function (_React$Component) {
    _inherits(Link, _React$Component);

    function Link(props) {
        _classCallCheck(this, Link);

        var _this = _possibleConstructorReturn(this, (Link.__proto__ || __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default()(Link)).call(this, props));

        _this.getSyljList = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/sylj/getSyljList', 'GET').then(function (resData) {
                if (resData && resData.data) {
                    var size = 4;
                    var sylj = _this.sliceArr(resData.data, size);
                    _this.setState({ sylj: sylj });
                }
            });
        };

        _this.handleChange = function (url, ljlx, flbz) {
            if (ljlx == '1') {
                hashHistory.push({
                    pathname: '/notice',
                    search: 'flbz=' + flbz
                });
            } else {
                window.open(url);
            }
        };

        _this.sliceArr = function (array, size) {
            var result = [];
            for (var x = 0; x < Math.ceil(array.length / size); x++) {
                var start = x * size;
                var end = start + size;
                var arr = array.slice(start, end);
                var fill = 0;
                if ((fill = size - arr.length) > 0) {
                    for (var i = 0; i < fill; i++) {
                        arr.push({});
                    }
                }
                result.push(arr);
            }
            return result;
        };

        _this.state = {
            sylj: [] //首页链接
        };
        return _this;
    }

    _createClass(Link, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getSyljList();
        }

        //快速导航链接跳转

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _boxTop = this.props._boxTop;

            var settings = {
                dots: true,
                infinite: true,
                speed: 10000,
                slidesToShow: 1,
                slidesToScroll: 1
            };
            return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                'div',
                { className: 'app__css__app-pages-index-__index__cjyy' },
                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(_boxTop, {
                    img: __webpack_require__(2168),
                    title: '\u9996\u9875\u94FE\u63A5',
                    sub: 'Home page link'
                }),
                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_carousel___default.a,
                    _extends({}, settings, { autoplay: true }),
                    this.state.sylj.map(function (elem, index) {
                        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                            'div',
                            { key: index },
                            __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_11__components__["a" /* Flex */],
                                { className: 'app__css__app-pages-index-__index__ksdh_con' },
                                elem.map(function (e, i) {
                                    var img = e['LJTP'];
                                    var url = e['LJDZ'];
                                    var ljlx = e['LJLX'];
                                    var flbz = e['FLBZ'];
                                    var ljmc = e['LJMC'];
                                    var isEmpty = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(e) == "{}";
                                    return isEmpty ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components__["a" /* Flex */].Item, { key: index + i }) : __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_11__components__["a" /* Flex */].Item,
                                        { key: index + i, className: 'app__css__app-pages-index-__index__ksdh_item' },
                                        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('img', {
                                            src: img ? __webpack_require__(819)("./" + img) : '',
                                            alt: '',
                                            style: { display: 'inline-block' },
                                            onClick: function onClick() {
                                                _this2.handleChange(url, ljlx, flbz);
                                            }
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                            'p',
                                            {
                                                onClick: function onClick() {
                                                    _this2.handleChange(url, ljlx, flbz);
                                                }
                                            },
                                            ljmc
                                        )
                                    );
                                })
                            )
                        );
                    })
                )
            );
        }
    }]);

    return Link;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);



/***/ }),

/***/ 1154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_string_trim__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_string_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_string_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_login_js__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_common_NHSelect_index__ = __webpack_require__(71);















var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }






var FormItem = __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.Item;

var URL_PREFIX = ''; //统一前缀    
var reqGetCaptcha = URL_PREFIX + 'captchaServlet?v='; //验证码下载路径  

var LoginForm = function (_React$Component) {
    _inherits(LoginForm, _React$Component);

    function LoginForm(props) {
        _classCallCheck(this, LoginForm);

        var _this = _possibleConstructorReturn(this, (LoginForm.__proto__ || __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default()(LoginForm)).call(this, props));

        _this.getLoginTip = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/yxwz/login/getLoginTip', 'GET').then(function (resData) {
                if (resData && resData.data) {
                    _this.setState({ mmts: resData.data });
                }
            });
        };

        _this.getDefaultAccountType = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/yxwz/login/getDefaultAccountType', 'GET').then(function (resData) {
                if (resData && resData.data) {
                    _this.setState({ mrzhlx: resData.data });
                }
            });
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.props.form.validateFields(function (err, values) {
                if (err) {
                    return;
                }
                if (values.typeNum && values.username && values.password) {
                    values.vaildationService = 'ly-zhxg-yxwz-svc';
                    var params = values;
                    params.username = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_string_trim___default()(params.username);
                    params.password = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_string_trim___default()(params.password);
                    //验证码开启
                    if (_this.state.captchaVisible) {
                        params = _extends({}, params, {
                            captcha: values.captcha,
                            systemId: 'ly-zhxg'
                        });
                    }
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__actions_login_js__["b" /* userLogin */])(params, function () {
                        _this.getSetting();
                    });
                }
            });
        };

        _this.state = {
            mmts: '', //密码提示
            mrzhlx: '', //默认帐号类型
            validateUrl: '',
            captchaVisible: false //验证码是否可见
        };
        return _this;
    }

    _createClass(LoginForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.getLoginTip();
            this.getDefaultAccountType();
            this.getSetting(); //获取配置，是否开启验证码
        }

        /**
         * * 获取迎新默认帐号类型
         * @memberof LoginForm
         */

    }, {
        key: 'getSetting',

        //获取配置，是否开启验证码
        value: function getSetting() {
            var _this2 = this;

            fetch(URL_PREFIX + 'ng/captcha/status', {
                method: "GET",
                credentials: "include",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "X-Requested-With": "XMLHttpRequest",
                    "appId": "ly-zhxg"
                }
            }).then(function (response) {
                return response.json();
            }).then(function (res) {
                if (res.meta && res.meta.statusCode === 200) {
                    _this2.setState({
                        captchaVisible: res.data
                    }, function () {
                        if (res.data) {
                            _this2.changeCaptcha();
                        }
                    });
                } else {
                    _this2.setState({
                        captchaVisible: false
                    });
                }
                return res;
            }).catch(function (error) {
                // 网络请求失败返回执行该回调函数，得到错误信息
                Modal.error({ title: '错误提示', content: '网络请求异常,请联系管理员' });
                return error;
            });
        }
    }, {
        key: 'changeCaptcha',
        value: function changeCaptcha() {
            this.setState({
                validateUrl: reqGetCaptcha + new Date().getMilliseconds()
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var getFieldDecorator = this.props.form.getFieldDecorator;
            var mrzhlx = this.state.mrzhlx;

            return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a,
                { onSubmit: this.handleSubmit, className: 'login-form' },
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    'div',
                    { className: 'text-sub font-12 justify' },
                    this.state.mmts
                ),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    FormItem,
                    null,
                    getFieldDecorator('typeNum', {
                        rules: [{
                            required: true
                        }],
                        initialValue: mrzhlx
                    })(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_common_NHSelect_index__["a" /* default */], { sign: 'dmk_yxxt_zhlx', style: { width: '100%' } }))
                ),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    FormItem,
                    null,
                    getFieldDecorator('username', {
                        rules: [{
                            required: true
                        }]
                    })(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, {
                        style: { width: '100%' },
                        prefix: __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, {
                            type: 'user',
                            style: { color: '#a5c7d7', fontSize: 18 }
                        }),
                        placeholder: '\u8BF7\u8F93\u5165\u8D26\u53F7'
                    }))
                ),
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    FormItem,
                    null,
                    getFieldDecorator('password', {
                        rules: [{
                            required: true
                        }]
                    })(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, {
                        style: { width: '100%' },
                        prefix: __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, {
                            type: 'lock',
                            style: { color: '#a5c7d7', fontSize: 18 }
                        }),
                        type: 'password',
                        placeholder: '\u8BF7\u8F93\u5165\u5BC6\u7801'
                    }))
                ),
                this.state.captchaVisible ? __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    FormItem,
                    null,
                    getFieldDecorator('captcha', {
                        rules: [{ required: true, message: '请输入验证码！' }]
                    })(__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { size: 'large', type: 'text', placeholder: '\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801', style: { width: '58%', float: 'left' } }),
                        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                                'span',
                                { onClick: function onClick() {
                                        return _this3.changeCaptcha();
                                    } },
                                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('img', { src: this.state.validateUrl })
                            )
                        )
                    ))
                ) : null,
                __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                    FormItem,
                    null,
                    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,
                        {
                            type: 'primary',
                            htmlType: 'submit',
                            style: { width: '100%' }
                        },
                        '\u767B\u5F55'
                    )
                )
            );
        }
    }]);

    return LoginForm;
}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_13_antd_lib_form___default.a.create()(LoginForm));

/***/ }),

/***/ 1155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_string_trim__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_string_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_string_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_css__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_request__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions_login_js__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_common_NHModal__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__updatePasswordForm__ = __webpack_require__(1160);












var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }












if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var baseUrl = 'api/zhxg-yxwz/';

var LoginStuInfoForm = function (_Component) {
    _inherits(LoginStuInfoForm, _Component);

    function LoginStuInfoForm(props) {
        var _this2 = this;

        _classCallCheck(this, LoginStuInfoForm);

        var _this = _possibleConstructorReturn(this, (LoginStuInfoForm.__proto__ || __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_prototype_of___default()(LoginStuInfoForm)).call(this, props));

        _this.getStudentPhotoBase64 = function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.mark(function _callee(userId, callback) {
                var res;
                return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_request__["a" /* query */])('api/zhxg-yxwz/openapi/student/getStudentPhotoBase64', { xsid: userId, type: 10 });

                            case 2:
                                res = _context.sent;

                                if (!(!res || res.code != 200)) {
                                    _context.next = 5;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 5:
                                callback(res.data);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x, _x2) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.getStudentInfo = function (xsid) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_NHFetch__["a" /* default */])('/newStudent/getStudentInfo', 'GET', { xsid: xsid }).then(function (resData) {
                if (resData && resData.data) {
                    _this.setState({
                        studentInfo: resData.data
                        //imgSrc:baseUrl +'newStudent/getImgByParam?pkid='+xsid,

                    });
                }
            });
        };

        _this.handleLogout = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__actions_login_js__["c" /* userLogout */])();
        };

        _this.handleUpdatePassword = function () {
            _this.nhModal.show();
        };

        _this.handleModalOk = function () {
            _this.updatePasswordForm.validateFields(function (err, formData) {
                if (err) {
                    _this.nhModal.stopLoading();
                    return;
                }
                var oldPassWord = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_string_trim___default()(formData['oldPassWord']);
                var newPassWord = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_string_trim___default()(formData['newPassWord']);
                var verifyPassWord = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_string_trim___default()(formData['verifyPassWord']);
                var i = 0;
                if (!oldPassWord) {
                    i++;
                    _this.setFields('oldPassWord', '', '密码不能为空');
                }
                if (!newPassWord) {
                    i++;
                    _this.setFields('newPassWord', '', '新密码不能为空');
                }
                if (!verifyPassWord) {
                    i++;
                    _this.setFields('verifyPassWord', '', '确认密码不能为空');
                }

                if (i > 0) {
                    return;
                }

                if (newPassWord !== verifyPassWord) {
                    _this.setFields('verifyPassWord', verifyPassWord, '新密码与确认密码不一致，请检查输入');
                    return;
                }
                var params = {
                    oldPassWord: oldPassWord,
                    newPassWord: newPassWord
                };
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_NHFetch__["a" /* default */])('/newStudent/updatePassword', 'POST', params).then(function (resData) {
                    if (resData && resData.data) {
                        var data = resData.data;
                        if (data > 0) {
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default.a.success('密码修改成功');
                            _this.nhModal.close();
                        } else if (data == -2) {
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default.a.warning('密码为空');
                        } else if (data == -3) {
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default.a.warning('旧密码验证不通过，密码错误');
                            _this.updatePasswordForm.setFields({
                                oldPassWord: {
                                    value: oldPassWord,
                                    errors: [new Error('旧密码验证不通过，密码错误。')]
                                }
                            });
                        } else {
                            __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default.a.warning('密码修改失败');
                        }
                    } else {
                        __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default.a.warning('密码修改失败');
                    }
                    _this.nhModal.stopLoading();
                }).catch(function (res) {
                    __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default.a.error('密码修改异常');
                    _this.nhModal.stopLoading();
                    return res;
                });
            });
        };

        _this.setFields = function (name, value, message) {
            var obj = {};
            obj[name] = {
                value: value,
                errors: [new Error(message)]
            };
            _this.updatePasswordForm.setFields(obj);
            _this.nhModal.stopLoading();
        };

        _this.state = {
            studentInfo: {}, //学生信息
            imgSrc: '' //学生图片
        };
        return _this;
    }

    _createClass(LoginStuInfoForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_NHCore__["b" /* getLoginUser */])().userId;
            this.getStudentInfo(xsid);
            this.getStudentPhotoBase64(xsid, function (data) {
                if (!data) return;
                _this3.setState({
                    imageUrl: 'data:image/jpeg;base64,' + data
                });
            });
        }
        // 获取学生头像

    }, {
        key: 'handleImageErrored',
        value: function handleImageErrored() {
            this.setState({
                imgSrc: __webpack_require__(489)
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            var _state = this.state,
                studentInfo = _state.studentInfo,
                imageUrl = _state.imageUrl;

            var showImg = false;
            if (studentInfo) {
                showImg = true;
            }
            return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                'div',
                { className: 'app__css__app-pages-index-__index__grxx_con' },
                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                    'div',
                    { className: '_bg app__css__app-pages-index-__index__grxx_con_l' },
                    showImg && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('img', {
                        style: {
                            width: '100%',
                            height: '100%'
                        },
                        src: imageUrl ? imageUrl : '',
                        onError: this.handleImageErrored.bind(this)
                    }),
                    !showImg && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('img', {
                        style: {
                            width: '100%',
                            height: '100%'
                        },
                        src: __webpack_require__(489),
                        alt: ''
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                    'div',
                    { className: 'app__css__app-pages-index-__index__grxx_con_r' },
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        'div',
                        { className: 'app__css__app-pages-index-__index__grxx_con_item' },
                        '\u59D3\u540D\uFF1A',
                        studentInfo['XM']
                    ),
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        'div',
                        { className: 'app__css__app-pages-index-__index__grxx_con_item' },
                        '\u6027\u522B\uFF1A',
                        studentInfo['XB']
                    ),
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        'div',
                        { className: 'app__css__app-pages-index-__index__grxx_con_item' },
                        '\u6C11\u65CF\uFF1A',
                        studentInfo['MZ']
                    ),
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        'div',
                        { className: 'app__css__app-pages-index-__index__grxx_con_item' },
                        '\u4E13\u4E1A\uFF1A',
                        studentInfo['ZY']
                    ),
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        'div',
                        { className: 'app__css__app-pages-index-__index__grxx_con_item' },
                        '\u5B66\u9662\uFF1A',
                        studentInfo['BM']
                    ),
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,
                        { type: 'primary', style: { marginTop: '4px' }, onClick: this.handleLogout },
                        '\u9000\u51FA\u767B\u5F55'
                    ),
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,
                        { type: 'primary', style: { marginTop: '4px', marginLeft: '10px' }, onClick: this.handleUpdatePassword },
                        '\u4FEE\u6539\u5BC6\u7801'
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17__components_common_NHModal__["a" /* default */],
                    {
                        ref: function ref(modal) {
                            return _this4.nhModal = modal;
                        }, title: '密码修改', onOk: this.handleModalOk
                    },
                    __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__updatePasswordForm__["a" /* default */], { ref: function ref(modal) {
                            return _this4.updatePasswordForm = modal;
                        } })
                )
            );
        }
    }]);

    return LoginStuInfoForm;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (LoginStuInfoForm);

/***/ }),

/***/ 1156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Navigation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_css__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_history_createHashHistory__);








var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }







if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var hashHistory = __WEBPACK_IMPORTED_MODULE_10_history_createHashHistory___default()();

var Navigation = function (_React$Component) {
    _inherits(Navigation, _React$Component);

    function Navigation(props) {
        _classCallCheck(this, Navigation);

        var _this = _possibleConstructorReturn(this, (Navigation.__proto__ || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default()(Navigation)).call(this, props));

        _this.handleChange = function (url, ljlx, flbz) {
            if (ljlx == '1') {
                hashHistory.push({
                    pathname: '/notice',
                    search: 'flbz=' + flbz
                });
            } else {
                window.open(url);
            }
        };

        _this.getLjlx = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/proData/selectDataList', 'GET', {
                sign: 'DMK_YXXT_LJLX'
            }).then(function (resData) {
                if (resData && resData.data) {
                    _this.setState({
                        ljlxData: resData.data
                    }, function () {
                        _this.getKsdh();
                    });
                }
            });
        };

        _this.getKsdh = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/proData/selectDataList', 'GET', {
                sign: 'zhxg_yxwz_ksdh'
            }).then(function (resData) {
                if (resData && resData.data) {
                    (function () {
                        var ksdh = _this.state.ksdh;
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            var _loop = function _loop() {
                                var _ref = _step.value;
                                var LJLX = _ref.LJLX,
                                    LABEL = _ref.LABEL,
                                    VALUE = _ref.VALUE;

                                _this.state.ljlxData.map(function (item, index) {
                                    if (index < 4) {
                                        if (LJLX == item.VALUE) {
                                            ksdh[item.VALUE] = ksdh[item.VALUE] ? ksdh[item.VALUE] : [];
                                            ksdh[item.VALUE].push(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                                                Option,
                                                { key: VALUE, value: VALUE },
                                                LABEL
                                            ));
                                        }
                                    }
                                });
                            };

                            for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(resData.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                _loop();
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        _this.setState({ ksdh: ksdh });
                    })();
                }
            });
        };

        _this.handleChange = function (url, ljlx, flbz) {
            if (ljlx == '1') {
                hashHistory.push({
                    pathname: '/notice',
                    search: 'flbz=' + flbz
                });
            } else {
                window.open(url);
            }
        };

        _this.state = {
            ksdh: {
                //快速导航
            }
        };
        return _this;
    }
    //快速导航链接跳转


    _createClass(Navigation, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getLjlx();
        }

        //快速导航链接跳转

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _boxTop = this.props._boxTop;
            var ljlxData = this.state.ljlxData;

            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                'div',
                { className: 'app__css__app-pages-index-__index__ksdh' },
                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(_boxTop, {
                    img: __webpack_require__(2189),
                    title: '\u5FEB\u901F\u5BFC\u822A',
                    sub: 'Rapid Navigation'
                }),
                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                    'div',
                    { className: 'app__css__app-pages-index-__index__ksdh_con' },
                    ljlxData ? ljlxData.map(function (item, index) {
                        if (index < 4) {
                            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_4_antd_lib_select___default.a,
                                {
                                    showSearch: true,
                                    className: 'app__css__app-pages-index-__index__ksdh_select',
                                    placeholder: '----------' + item.LABEL + '----------',
                                    optionFilterProp: 'children',
                                    onChange: _this2.handleChange,
                                    value: []
                                },
                                _this2.state.ksdh[item.VALUE]
                            );
                        }
                    }) : null
                )
            );
        }
    }]);

    return Navigation;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);



/***/ }),

/***/ 1157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Notice; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_history_createHashHistory__);





var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }







if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var hashHistory = __WEBPACK_IMPORTED_MODULE_8_history_createHashHistory___default()();

var Notice = function (_React$Component) {
    _inherits(Notice, _React$Component);

    function Notice(props) {
        _classCallCheck(this, Notice);

        var _this = _possibleConstructorReturn(this, (Notice.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Notice)).call(this, props));

        _this.click = function (pkid) {
            hashHistory.push({
                pathname: '/notice/detail',
                search: 'pkid=' + pkid
            });
        };

        _this.getXxfbnrList = function () {
            var param = { flbz: _this.state.xxfbfl };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_NHFetch__["a" /* default */])("api/zhxg-yxwz/xxfb/getXxfbnrList", "GET", param).then(function (resData) {
                if (resData && resData.data) {
                    var list = resData.data;
                    var xxfb = _this.state.xxfb;
                    for (var i = 0; i < list.length; i++) {
                        var obj = {};
                        obj.title = list[i]['TZBT'];
                        obj.time = list[i]['FBSJ'];
                        obj.pkid = list[i]['PKID'];
                        xxfb.push(obj);
                    }
                    _this.setState({ xxfb: xxfb });
                }
            });
        };

        _this.state = {
            xxfbfl: '', //信息发布分类
            xxfb: [] //信息发布
        };
        return _this;
    }

    _createClass(Notice, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getXxfbnrList();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _boxTop = this.props._boxTop;

            var settings = {
                dots: true,
                infinite: true,
                speed: 10000,
                slidesToShow: 1,
                slidesToScroll: 1
            };
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                { className: 'app__css__app-pages-index-__index__tzgg' },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(_boxTop, {
                    img: __webpack_require__(2186),
                    title: '\u901A\u77E5\u516C\u544A',
                    sub: 'Notice',
                    extra: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        'a',
                        { className: 'text-desc', onClick: function onClick() {
                                hashHistory.push({
                                    pathname: '/notice',
                                    search: 'flbz=' + _this2.state.xxfbfl
                                });
                            } },
                        'more>>'
                    )
                }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    'div',
                    { className: 'app__css__app-pages-index-__index__tzgg_list' },
                    this.state.xxfb.map(function (elem, index) {
                        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */],
                            {
                                key: index,
                                className: 'app__css__app-pages-index-__index__tzgg_item',
                                justify: 'between',
                                onClick: function onClick() {
                                    _this2.click(elem.pkid);
                                }
                            },
                            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */].Item,
                                null,
                                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */],
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */],
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                                            'span',
                                            { className: 'app__css__app-pages-index-__index__tzgg_item_icon' },
                                            '>'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                                            'span',
                                            { className: 't-clamp-1' },
                                            elem.title
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */].Item, { className: 'app__css__app-pages-index-__index__tzgg_line' })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                                'div',
                                { className: 'ml-10' },
                                elem.time
                            )
                        );
                    })
                )
            );
        }
    }]);

    return Notice;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);



/***/ }),

/***/ 1158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Phone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_NHFetch__ = __webpack_require__(7);





var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }





if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var Phone = function (_React$Component) {
    _inherits(Phone, _React$Component);

    function Phone(props) {
        _classCallCheck(this, Phone);

        var _this = _possibleConstructorReturn(this, (Phone.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Phone)).call(this, props));

        _this.getLxfs = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/lxfs/getLxfsList', 'GET').then(function (resData) {
                if (resData && resData.data) {
                    var lxfs = _this.state.lxfs;
                    for (var i = 0; i < resData.data.length; i++) {
                        var data = resData.data;
                        lxfs.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                            'div',
                            { key: i },
                            data[i]['LXFSMC'],
                            '\uFF1A',
                            data[i]['LXFSHM']
                        ));
                    }
                    _this.setState({ lxfs: lxfs });
                }
            });
        };

        _this.state = {
            lxfs: [] //联系方式
        };
        return _this;
    }

    _createClass(Phone, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getLxfs();
        }
    }, {
        key: 'render',
        value: function render() {
            var _boxTop = this.props._boxTop;

            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                { className: 'app__css__app-pages-index-__index__lxdh' },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(_boxTop, {
                    img: __webpack_require__(2169),
                    title: '\u8054\u7CFB\u7535\u8BDD',
                    sub: 'Contact Number'
                }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    'div',
                    { className: 'app__css__app-pages-index-__index__lxdh_con' },
                    this.state.lxfs
                )
            );
        }
    }]);

    return Phone;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);



/***/ }),

/***/ 1159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Process; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_carousel_style__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_carousel_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_carousel_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_carousel__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_popover_style__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_popover_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_popover_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_popover__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_css__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components__ = __webpack_require__(10);











var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }








if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var Process = function (_React$Component) {
    _inherits(Process, _React$Component);

    function Process(props) {
        _classCallCheck(this, Process);

        var _this = _possibleConstructorReturn(this, (Process.__proto__ || __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_get_prototype_of___default()(Process)).call(this, props));

        _this.getBdlcList = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/bdlc/getBdlcList', 'GET').then(function (resData) {
                if (resData && resData.data) {
                    console.log('res.data', resData.data);
                    var bdlc = _this.state.bdlc;
                    for (var i = 0; i < resData.data.length; i++) {

                        var data = resData.data;
                        var obj = {};
                        obj.id = i;
                        obj.title = data[i]['BZMC'];
                        obj.img = data[i]['BZTP'];
                        obj.sub = data[i]['BZSM'];
                        bdlc.push(obj);
                    }
                    var size = _this.state.size;
                    var bdlcnew = _this.sliceArr(bdlc, size);
                    _this.setState({ bdlc: bdlcnew });
                }
            });
        };

        _this.sliceArr = function (array, size) {
            var result = [];
            var length = array.length;
            for (var x = 0; x < Math.ceil(array.length / size); x++) {
                var start = x * size;
                var end = start + size;
                var arr = array.slice(start, end);
                var fill = 0;
                if ((fill = size - arr.length) > 0) {
                    for (var i = 0; i < fill; i++) {
                        if (length > size) {
                            arr.push({});
                        }
                    }
                }
                result.push(arr);
            }
            return result;
        };

        _this.state = {
            bdlc: [], //办理流程
            size: 7 //跑马灯的数量
        };
        return _this;
    }

    _createClass(Process, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getBdlcList();
        }
    }, {
        key: 'render',
        value: function render() {
            var _boxTop = this.props._boxTop;

            var size = this.state.size;
            var settings = {
                dots: true,
                infinite: true,
                speed: 10000,
                slidesToShow: 1,
                slidesToScroll: 1
            };
            return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                'div',
                { className: 'w1180 mt-20' },
                __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(_boxTop, {
                    img: __webpack_require__(2187),
                    title: '\u62A5\u5230\u6D41\u7A0B',
                    sub: 'Registration Process'
                }),
                __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_carousel___default.a,
                    _extends({}, settings, { autoplay: true }),
                    this.state.bdlc.map(function (elem, index) {
                        console.log(elem);
                        return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                            'div',
                            { key: index },
                            __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_13__components__["a" /* Flex */],
                                { className: 'app__css__app-pages-index-__index__bdlc_con', align: 'start' },
                                elem.map(function (e, i) {
                                    var isEmpty = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(e) == "{}";
                                    return isEmpty ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components__["a" /* Flex */].Item, { key: index + i }) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_13__components__["a" /* Flex */].Item,
                                        { key: index + i, className: 'app__css__app-pages-index-__index__bdlc_item' },
                                        __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                                            'span',
                                            { className: 'app__css__app-pages-index-__index__bdlc_item_num' },
                                            index === 0 ? i + 1 : index * size + i + 1
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                                            'span',
                                            { className: 'app__css__app-pages-index-__index__bdlc_item_title' },
                                            e.title
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                                            'div',
                                            {
                                                className: 't-clamp-2 app__css__app-pages-index-__index__bdlc_item_sub'
                                            },
                                            e.sub && e.sub.length > 26 ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_7_antd_lib_popover___default.a,
                                                {
                                                    overlayStyle: { width: 300 },
                                                    content: e.sub
                                                },
                                                e.sub
                                            ) : e.sub
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
                                            'div',
                                            { className: 'app__css__app-pages-index-__index__bdlc_item_img' },
                                            __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('img', {
                                                src: 'anonymity/docrepo/download?attachmentId=' + e.img,
                                                alt: ''
                                            })
                                        )
                                    );
                                })
                            )
                        );
                    })
                )
            );
        }
    }]);

    return Process;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);



/***/ }),

/***/ 1160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_NHFormItem__ = __webpack_require__(43);









var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }




var FormItem = __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item;

var PasswordForm = function (_React$Component) {
    _inherits(PasswordForm, _React$Component);

    function PasswordForm(props) {
        _classCallCheck(this, PasswordForm);

        var _this = _possibleConstructorReturn(this, (PasswordForm.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(PasswordForm)).call(this, props));

        _this.state = {
            type: 'password'
        };
        return _this;
    }

    _createClass(PasswordForm, [{
        key: 'render',
        value: function render() {
            var form = this.props.form;
            var type = this.state.type;

            return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a,
                null,
                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_9__components_common_NHFormItem__["a" /* default */],
                    { id: 'oldPassWord', label: '旧密码', form: form, required: true },
                    __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input___default.a, { type: type, placeholder: '请输入旧密码' })
                ),
                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_9__components_common_NHFormItem__["a" /* default */],
                    { id: 'newPassWord', label: '新密码', form: form,
                        pattern: { pattern: /^[a-zA-Z0-9_]{0,16}$/, message: "请输入：a-zA-Z0-9_ 范围的值,不能超过16字符！" },
                        required: true },
                    __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input___default.a, { type: type, placeholder: '请输入新密码' })
                ),
                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_9__components_common_NHFormItem__["a" /* default */],
                    { id: 'verifyPassWord', label: '确认密码', form: form,
                        pattern: { pattern: /^[a-zA-Z0-9_]{0,16}$/, message: "请输入：a-zA-Z0-9_ 范围的值,不能超过16字符！" },
                        required: true },
                    __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input___default.a, { type: type, placeholder: '确认新密码' })
                )
            );
        }
    }]);

    return PasswordForm;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.create()(PasswordForm));

/***/ }),

/***/ 1161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Window; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);





var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }



var Window = function (_Component) {
  _inherits(Window, _Component);

  function Window(props) {
    _classCallCheck(this, Window);

    var _this = _possibleConstructorReturn(this, (Window.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Window)).call(this, props));

    _this.moveOut = function () {
      // console.log("移出");
      _this.setState({ CloseBtn: true }, function () {
        _this.interval = setInterval(function () {
          _this.ggRollGO();
        }, _this.state.speed);
      });
    };

    _this.moveOver = function () {
      // console.log("移入");
      _this.setState({ CloseBtn: false }, function () {
        clearInterval(_this.interval);
      });
    };

    _this.ggRollGO = function () {
      var _this$state = _this.state,
          speed = _this$state.speed,
          statusX = _this$state.statusX,
          statusY = _this$state.statusY,
          offsetX = _this$state.offsetX,
          offsetY = _this$state.offsetY,
          imgWidth = _this$state.imgWidth,
          imgHeight = _this$state.imgHeight,
          documentElementScrollHeight = _this$state.documentElementScrollHeight;

      var roll = document.getElementById('roll'); //获取飘窗属性
      //  //差值用来测算left属性值的极限
      var winW = document.documentElement.clientWidth - imgWidth - 10;
      var winH = documentElementScrollHeight - imgHeight;
      //如果statusX=1则每次减少1px,否则增加1px
      var newX = offsetX + (statusX == 1 ? -1 : 1);
      //如果left属性值小于0，也就是div要超出左边界了，就将statusX设置为0
      if (newX < 0) {
        _this.setState({
          statusX: 0
        });
      } else if (newX > winW - 50) {
        _this.setState({
          statusX: 1
        });
      }

      var newY = offsetY + (statusY == 1 ? -1 : 1);
      if (newY < 0) {
        _this.setState({
          statusY: 0
        });
      } else if (newY > winH) {
        _this.setState({
          statusY: 1
        });
      }
      _this.setState({
        offsetX: newX,
        offsetY: newY
      });
    };

    _this.jump = function () {
      var pcData = _this.props.pcData;

      if (pcData.ljdz.indexOf('http') != -1) {
        window.open(pcData.ljdz);
      } else {
        window.open('http://' + pcData.ljdz, '_blank');
      }
    };

    _this.closeWindows = function () {
      _this.setState({
        widowVisible: true
      });
      // 并且清除定时器
      clearInterval(_this.interval);
    };

    _this.state = {
      speed: 10, //飘动速度，即为定时器函数多长时间执行一次
      statusX: 1, //规定每执行一次函数，left属性值变化的幅度,用来判断x是否到头
      statusY: 1, //规定每执行一次函数，top属性值变化的幅度，用来判断y是否到头
      offsetX: Number(props.pcData.zcjl), //该飘窗的x轴偏移位置(初始位置--左侧距离)
      offsetY: Number(props.pcData.dbjl), //该飘窗的y轴偏移位置(初始位置--顶部距离)
      CloseBtn: true, //关闭按钮是否显示
      widowVisible: false, //控制飘窗是否关闭
      imgWidth: Number(props.pcData.kd), //飘窗图片的宽度
      imgHeight: Number(props.pcData.gd), //飘窗图片的高度
      pcsfkgb: props.pcData.pcsfkgb, //是否有关闭飘窗地功能（关闭按钮是否需要,1:需要，0:不需要）
      btsfxs: props.pcData.btsfxs, //飘窗标题是否显示
      tpbt: props.pcData.tpbt, //图片标题
      documentElementScrollHeight: 0 //保存固定的页面总高度，防止给飘窗设置定位引起获取的页面总高度变化问题
    };
    return _this;
  }

  _createClass(Window, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        // 使用定时器避免其他组件未挂在完导致获取的页面高度偏小问题
        _this2.setState({ documentElementScrollHeight: document.documentElement.scrollHeight });
      }, 500);
      // 定时器
      this.interval = setInterval(function () {
        _this2.ggRollGO();
      }, this.state.speed);
    }

    // 点击跳转


    // 关闭飘窗

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          offsetX = _state.offsetX,
          offsetY = _state.offsetY,
          CloseBtn = _state.CloseBtn,
          widowVisible = _state.widowVisible,
          pcsfkgb = _state.pcsfkgb,
          imgWidth = _state.imgWidth,
          imgHeight = _state.imgHeight,
          btsfxs = _state.btsfxs;
      var pcData = this.props.pcData;

      return (
        /* 实现飘窗效果 */
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'div',
          {
            id: 'roll',
            style: {
              position: 'absolute',
              top: offsetY,
              left: offsetX,
              zIndex: '999',
              display: widowVisible ? 'none' : ''
            },
            onMouseOver: function onMouseOver() {
              _this3.moveOver();
            },
            onMouseOut: function onMouseOut() {
              _this3.moveOut();
            }
          },
          pcsfkgb == '1' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'div',
            {
              style: {
                color: '#5e6868',
                position: 'absolute',
                top: '0px',
                right: '-5px',
                display: CloseBtn ? 'none' : '',
                cursor: 'pointer'
              },
              onClick: function onClick() {
                _this3.closeWindows();
              }
            },
            '\u5173\u95ED'
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img', {
            alt: pcData.tpbt,
            src: 'zuul/docrepo/download/file?attachmentId=' + pcData.tpdz,
            onClick: function onClick() {
              _this3.jump();
            },
            style: { width: imgWidth, height: imgHeight, cursor: 'pointer', margin: '20px 20px 0 20px' }
          }),
          btsfxs == '1' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'div',
            { style: { width: imgWidth, margin: '5px 20px 0 20px', textAlign: 'center', fontWeight: 'bold' } },
            this.state.tpbt
          )
        )
      );
    }
  }]);

  return Window;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);



/***/ }),

/***/ 1162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkDhlj; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_css__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_NHFetch__ = __webpack_require__(7);





var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }








if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var LinkDhlj = function (_React$Component) {
    _inherits(LinkDhlj, _React$Component);

    function LinkDhlj(props) {
        _classCallCheck(this, LinkDhlj);

        var _this = _possibleConstructorReturn(this, (LinkDhlj.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(LinkDhlj)).call(this, props));

        _this.getFlmid = function (pkid) {
            var params = {
                pkid: pkid
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_NHFetch__["a" /* default */])("/dhlm/getFlmid", "GET", params).then(function (resData) {
                if (resData && resData.data) {
                    if (resData.data == -1) {
                        _this.setState({ flmid: pkid });
                    } else {
                        _this.setState({ flmid: resData.data });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.state = {
            flmid: '' //父栏目id
        };
        return _this;
    }

    _createClass(LinkDhlj, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var pkid = this.getQueryString('pkid');
            this.getFlmid(pkid);
        }
    }, {
        key: 'render',
        value: function render() {
            var pkid = this.getQueryString('pkid');
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__pages_Assembly_siderMenu__["a" /* default */], { title: '\u5BFC\u822A\u94FE\u63A5', menuType: '\u5BFC\u822A\u94FE\u63A5', flmid: this.state.flmid, pkid: pkid }),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5__components__["a" /* Flex */].Item,
                        { className: 'app__css__app-pages-link-__index__con_r' },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__pages_Assembly_Breadcrumb__["a" /* default */], {
                            list: [{ name: '首页', url: '/index' }, { name: '导航链接' }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null)
                    )
                )
            );
        }
    }]);

    return LinkDhlj;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);



/***/ }),

/***/ 1163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__ = __webpack_require__(7);

















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }




var Item = __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item;

var Lqcx = function (_Component) {
  _inherits(Lqcx, _Component);

  function Lqcx() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, Lqcx);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Lqcx.__proto__ || __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of___default()(Lqcx)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      result_status: 0,
      data: null,
      xm: ''
    }, _this.handleSubmit = function (event) {
      // 阻止事件的默认行为:此处是阻止表单默认提交给服务器的行为;
      event.preventDefault();
      // 对所有表单字段进行检验
      _this.props.form.validateFields(function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          var params, url;
          return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!err) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt('return', false);

                case 2:
                  params = values;
                  url = '/newStudent/getStudentLqInfo ';

                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])(url, 'POST', params).then(function (res) {
                    if (res) {
                      console.log('后端数据:', res);
                      if (!res.data) {
                        // 录取失败
                        _this.setState({
                          result_status: -1,
                          xm: values.xm
                        });
                        // return message.info("暂无结果")
                        return false;
                      }
                      // 录取成功
                      // message.success("查询成功")
                      _this.setState({
                        result_status: 1,
                        data: res.data
                        // data: {
                        //   XH: res.data.XH,
                        //   KSH: res.data.KSH,
                        //   XM: res.data.XM,
                        //   BDSJ: res.data.BDSJ,
                        //   SFZJH: res.data.SFZJH,
                        //   ZYMC: res.data.ZYMC,
                        //   BJMC: res.data.BJMC,
                        //   EMSH: res.data.EMSH,
                        //   XB: res.data.XB,
                        //   RXXZ: res.data.RXXZ,
                        //   ZSDH: res.data.ZSDH,
                        //   KSLX: res.data.KSLX
                        // }
                      });
                    }
                  }).catch(function (res) {
                    console.log('测试:', res);
                    __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error('系统繁忙');
                  });

                case 5:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    }, _this.goBack = function () {
      _this.setState({ result_status: 0 });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  // 初始化state

  // 返回查询


  _createClass(Lqcx, [{
    key: 'render',
    value: function render() {
      // 得到具强大功能的form对象
      var form = this.props.form;
      var getFieldDecorator = form.getFieldDecorator; //用于和表单进行双向绑定

      var _state = this.state,
          result_status = _state.result_status,
          data = _state.data,
          xm = _state.xm;
      // console.log('测试111:', result_status, data)

      return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
        'div',
        { className: 'lq-page', style: { minHeight: '550px', backgroundColor: '#f8f8f9' } },
        result_status === 0 ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
          'section',
          {
            className: 'lq-content',
            style: {
              width: '500px',
              margin: '10px auto',
              padding: '20px 30px',
              border: '2px solid #eaeeed',
              boxShadow: '1px 1px 20px #999'
            }
          },
          __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
            'h2',
            { style: { textAlign: 'center' } },
            '\u65B0\u751F\u5F55\u53D6\u67E5\u8BE2'
          ),
          __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a,
            {
              onSubmit: this.handleSubmit,
              className: 'lq-form'
              // labelCol={{ span: 5 }}
              // wrapperCol={{ span: 19 }}
            },
            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
              Item,
              { label: '\u8003\u751F\u53F7:', style: { marginBottom: '6px' } },
              getFieldDecorator('ksh', {
                // 配置对象: 属性名是特定的一些名称，声明式验证: 直接使用别人定义好的验证规则进行验证
                rules: [{
                  required: true,
                  message: '请输入考生号'
                }],
                validateTrigger: 'onBlur', //失去焦点时触发验证
                // initialValue: "8888", // 初始值
                initialValue: '' // 初始值
              })(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'user', style: { color: 'rgba(0,0,0,.25)' } }), placeholder: '\u8003\u751F\u53F7' }))
            ),
            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
              Item,
              { label: '\u8EAB\u4EFD\u8BC1\u53F7:', style: { marginBottom: '6px' } },
              getFieldDecorator('sfzjh', {
                // 配置对象: 属性名是特定的一些名称，声明式验证: 直接使用别人定义好的验证规则进行验证
                rules: [{
                  required: true,
                  message: '请输入身份证号'
                }, { min: 18, message: '身份证号为18位' }, { max: 18, message: '身份证号为18位' }],
                validateTrigger: 'onBlur', //失去焦点时触发验证
                // initialValue: "430855122702169852", // 初始值
                initialValue: '' // 初始值
              })(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'user', style: { color: 'rgba(0,0,0,.25)' } }), placeholder: '\u8EAB\u4EFD\u8BC1\u53F7' }))
            ),
            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
              Item,
              { label: '\u59D3\u540D:', style: { marginBottom: '6px' } },
              getFieldDecorator('xm', {
                // 配置对象: 属性名是特定的一些名称，声明式验证: 直接使用别人定义好的验证规则进行验证
                rules: [{
                  required: true,
                  message: '请输入姓名'
                }],
                validateTrigger: 'onBlur', //失去焦点时触发验证
                // initialValue: "宁荣荣", // 初始值
                initialValue: '' // 初始值
              })(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a, { prefix: __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon___default.a, { type: 'user', style: { color: 'rgba(0,0,0,.25)' } }), placeholder: '\u59D3\u540D' }))
            ),
            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
              Item,
              { style: { marginBottom: '6px' } },
              __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,
                { type: 'primary', htmlType: 'submit', className: 'lq-form-button', style: { width: '100%' } },
                '\u67E5\u8BE2'
              )
            )
          )
        ) : null,
        result_status === 1 ?
        // <section
        // 旧录取结果
        //   className="jg-content"
        //   style={{
        //     width: "900px",
        //     minHeight: "500px",
        //     margin: "10px auto",
        //     padding: "20px 30px",
        //     border: "2px solid #eaeeed",
        //     boxShadow: "1px 1px 20px #999",
        //   }}
        // >
        //   <h2>录取结果:</h2>
        //   <hr />
        //   <h3 style={{ fontWeight: 700, fontSize: "18px", color: "#f0323b" }}>
        //     恭喜你被我校录取！请仔细核对以下录取信息！{data && data.XH ? `请牢记你的学号：${data.XH}` : ''}
        //   </h3>
        //   <div style={{ fontSize: "16px", color: "#0d1119" }}>
        //     <p>
        //       <span>考生号：{data && data.KSH ? data.KSH : ''}，</span>
        //       <span>姓名：{data && data.XM ? data.XM : ''}</span>
        //     </p>
        //     <p>
        //       <span>身份证号：{data && data.SFZJH ? data.SFZJH : ''}，</span>
        //       <span>性别：{data && data.XB ? data.XB : ''}</span>
        //     </p>
        //     <p>您在参加{data.KSLX}考试中，成绩符合录取规定，</p>
        //     <p>
        //       被我校正式录取，就读 <span>{data && data.ZYMC ? data.ZYMC : ''}</span> 专业，请于
        //   <span>{data && data.BDSJ ? data.BDSJ : ''}</span>到我校报到！
        // </p>
        //     <p>
        //       录取通知书已寄发，EMS编码为：
        //   <span style={{ color: "#f0323b" }}>{data && data.EMSH ? data.EMSH : ''}</span>
        //   ；您可以在
        //   <a
        //         href="https://www.ems.com.cn/"
        //         target="_blank"
        //         rel="noopener noreferrer"
        //       >
        //         邮政速递物流网
        //   </a>
        //   查询录取通知书状态！
        // </p>
        //     <p>如有疑问，您可以拨打招生办的电话咨询：{data && data.ZSDH ? data.ZSDH : ''}</p>
        //     <p style={{ display: 'none' }}>
        //       <a
        //         href={data && data.RXXZ ? data.RXXZ : '#'}
        //         target="_blank"
        //         rel="noopener noreferrer"
        //         style={{ fontWeight: 700, fontSize: "18px", color: "#f0323b" }}
        //       >
        //         入学须知
        // </a>
        //     </p>
        //     <Button type="link" style={{ width: "100%", fontSize: "18px" }} onClick={this.goBack}>返回查询</Button>
        //   </div>
        // </section>
        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
          'section',
          {
            className: 'jg-content',
            style: {
              width: '900px',
              minHeight: '500px',
              margin: '10px auto',
              padding: '20px 30px',
              border: '2px solid #eaeeed',
              boxShadow: '1px 1px 20px #999'
            }
          },
          __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
            'h2',
            null,
            '\u5F55\u53D6\u7ED3\u679C:'
          ),
          __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
            'h3',
            { style: { fontWeight: 700, fontSize: '18px', color: '#f0323b' } },
            '\u606D\u559C\u4F60\u88AB\u6211\u6821\u5F55\u53D6\uFF01\u8BF7\u4ED4\u7EC6\u6838\u5BF9\u4EE5\u4E0B\u5F55\u53D6\u4FE1\u606F\uFF01',
            data && data.XH ? '\u8BF7\u7262\u8BB0\u4F60\u7684\u5B66\u53F7\uFF1A' + data.XH : ''
          ),
          __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
            'div',
            { style: { fontSize: '16px', color: '#0d1119' } },
            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
              'p',
              null,
              __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                'span',
                null,
                '\u8003\u751F\u53F7\uFF1A',
                data && data.KSH ? data.KSH : '',
                '\uFF0C'
              ),
              __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                'span',
                null,
                '\u59D3\u540D\uFF1A',
                data && data.XM ? data.XM : ''
              )
            ),
            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
              'p',
              null,
              __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                'span',
                null,
                '\u8EAB\u4EFD\u8BC1\u53F7\uFF1A',
                data && data.SFZJH ? data.SFZJH : '',
                '\uFF0C'
              ),
              __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                'span',
                null,
                '\u6027\u522B\uFF1A',
                data && data.XB ? data.XB : ''
              )
            ),
            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
              'p',
              null,
              __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                'span',
                null,
                '\u5F55\u53D6\u4E13\u4E1A\uFF1A',
                data && data.ZYMC ? data.ZYMC : '',
                ' \u4E13\u4E1A'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
              'p',
              null,
              __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                'span',
                null,
                '\u5F00\u5B66\u65F6\u95F4\uFF1A',
                data && data.BDSJ ? data.BDSJ : '',
                '\uFF01'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
              'p',
              null,
              '\u5F55\u53D6\u901A\u77E5\u4E66\u9646\u7EED\u5BC4\u53D1\u4E2D\uFF0CEMS\u7F16\u7801\u4E3A\uFF1A',
              __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                'span',
                { style: { color: '#f0323b' } },
                data && data.EMSH ? data.EMSH : ''
              ),
              '\uFF1B\u60A8\u53EF\u4EE5\u5728',
              __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                'a',
                { href: 'https://www.ems.com.cn/', target: '_blank', rel: 'noopener noreferrer' },
                '\u90AE\u653F\u901F\u9012\u7269\u6D41\u7F51'
              ),
              '\u67E5\u8BE2\u5F55\u53D6\u901A\u77E5\u4E66\u72B6\u6001\uFF01'
            ),
            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
              'p',
              null,
              '\u5982\u6709\u7591\u95EE\uFF0C\u60A8\u53EF\u4EE5\u62E8\u6253\u62DB\u751F\u529E\u7684\u7535\u8BDD\u54A8\u8BE2\uFF1A',
              data && data.ZSDH ? data.ZSDH : ''
            ),
            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
              'p',
              { style: { display: 'none' } },
              __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                'a',
                { href: data && data.RXXZ ? data.RXXZ : '#', target: '_blank', rel: 'noopener noreferrer', style: { fontWeight: 700, fontSize: '18px', color: '#f0323b' } },
                '\u5165\u5B66\u987B\u77E5'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,
              { type: 'link', style: { width: '100%', fontSize: '18px' }, onClick: this.goBack },
              '\u8FD4\u56DE\u67E5\u8BE2'
            )
          )
        ) : null,
        result_status === -1 ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
          'section',
          {
            className: 'jg-content',
            style: {
              width: '900px',
              minHeight: '500px',
              margin: '10px auto',
              padding: '20px 30px',
              border: '2px solid #eaeeed',
              boxShadow: '1px 1px 20px #999'
            }
          },
          __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
            'h2',
            null,
            '\u672A\u88AB\u5F55\u53D6:'
          ),
          __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
            'h3',
            { style: { fontWeight: 700, fontSize: '18px', color: '#f0323b' } },
            xm ? xm : '',
            '\u540C\u5B66\uFF0C\u6682\u672A\u67E5\u8BE2\u5230\u60A8\u7684\u5F55\u53D6\u4FE1\u606F\uFF01'
          ),
          __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,
            { type: 'link', style: { width: '100%', marginTop: '100px', fontSize: '18px' }, onClick: this.goBack },
            '\u8FD4\u56DE\u67E5\u8BE2'
          )
        ) : null
      );
    }
  }]);

  return Lqcx;
}(__WEBPACK_IMPORTED_MODULE_16_react__["Component"]);
/*
包装Form组件生成一个新的组件: Form(Login)
新组件会向Form组件传递一个强大的对象属性: form
 */


var WrapLqcx = __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.create()(Lqcx);
/* harmony default export */ __webpack_exports__["a"] = (WrapLqcx);
/*  */

/***/ }),

/***/ 1164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Notice; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_pagination_style__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_pagination_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_pagination_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_pagination__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_css__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_history_createHashHistory__);









var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }











if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var hashHistory = __WEBPACK_IMPORTED_MODULE_15_history_createHashHistory___default()();

var Notice = function (_React$Component) {
    _inherits(Notice, _React$Component);

    function Notice(props) {
        _classCallCheck(this, Notice);

        var _this = _possibleConstructorReturn(this, (Notice.__proto__ || __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default()(Notice)).call(this, props));

        _this.setMenuList = function (menuList) {
            _this.setState({ menuList: menuList });
        };

        _this.reload = function () {
            var flbz = _this.getQueryString('flbz');
            if (_this.state.flbz != flbz) {
                _this.setState({
                    flbz: flbz
                }, function () {
                    _this.filterTableData();
                });
            }
        };

        _this.filterTableData = function () {
            _this.setState(function (prevState, props) {
                return {
                    pageData: {
                        total: _this.state.pageData.total,
                        pageSize: _this.state.pageData.pageSize,
                        page: 1
                    }
                };
            });
            _this.readTableData();
        };

        _this.readTableData = function () {
            var params = _this.getFilterParams();
            _this.setState({ loading: true });
            var url = _this.props.url ? _this.props.url : "/proData/gridList";
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_NHFetch__["a" /* default */])(url, "POST", params).then(function (res) {
                if (res) {
                    _this.setState({
                        data: res.data.list,
                        pageData: {
                            total: res.data.total,
                            pageSize: _this.state.pageData.pageSize,
                            page: _this.state.pageData.page
                        }
                    });
                }
                _this.setState({ loading: false });
            }).catch(function (res) {
                _this.setState({ loading: false });
                return res;
            });
        };

        _this.getFilterParams = function () {
            var pagination = _this.state.pageData; //分页的参数
            var filters = _this.state.filters; //多选过滤的数据
            var sorter = _this.state.sorter; //过滤的数据
            var searchTextMap = _this.state.searchTextMap; //字段上搜索栏的值
            var searchParams = _this.state.searchParams; //传递过来的查询参数
            var sqlParams = _this.state.sqlParams; //在sql语句中的参数
            var initParams = _this.state.initParams; //初始化参数
            var flbz = _this.getQueryString('flbz');
            sqlParams['flbz'] = flbz;
            var params = {
                pagination: pagination,
                filters: filters,
                sorter: sorter,
                searchTextMap: searchTextMap,
                searchParams: searchParams,
                sqlParams: sqlParams,
                initParams: initParams,
                sign: 'zhxg_yxwz_xxfb_tzgg_queryPage'
            };

            return params;
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.click = function (pkid) {
            hashHistory.push({
                pathname: '/notice/detail',
                search: 'pkid=' + pkid
            });
        };

        _this.onChange = function (pageNumber) {
            _this.setState(function (prevState, props) {
                return {
                    pageData: {
                        total: _this.state.pageData.total,
                        pageSize: _this.state.pageData.pageSize,
                        page: pageNumber
                    }
                };
            }, function () {
                this.readTableData();
            });
        };

        _this.state = {
            searchParams: {}, //自定义的搜索条件
            searchTextMap: {}, //下拉框查询的值,用作查询
            sqlParams: {}, //
            filters: {}, //多选方式过滤的值
            sorter: {}, //排序字段
            loading: false,
            data: [], //数据
            pageData: { //分页设置的是三个参数
                total: 0,
                pageSize: 10, //当前页默认多少条数据
                page: 1
            },
            flbz: '',
            menuList: []
        };
        return _this;
    }

    _createClass(Notice, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var flbz = this.getQueryString('flbz');
            this.setState({
                flbz: flbz
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var sqlParams = this.state.sqlParams;
            var flbz = this.getQueryString('flbz');
            sqlParams['flbz'] = flbz;
            this.filterTableData();
        }

        //重新加载数据数据的方法（从第一页开始）


        //在当前页刷新数据

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            this.reload();
            var flbt = '';
            if (this.state.menuList && this.state.menuList.length > 0 && this.state.flbz) {
                var bz = this.state.flbz;
                this.state.menuList.map(function (elem) {
                    if (elem['FLBZ'] == bz) {
                        flbt = elem['FLBT'];
                    }
                });
            }
            return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__pages_Assembly_siderMenu__["a" /* default */], {
                        title: '\u6D88\u606F\u53D1\u5E03',
                        setMenuList: this.setMenuList,
                        menuType: '\u901A\u77E5\u516C\u544A', flbz: this.state.flbz }),
                    __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10__components__["a" /* Flex */].Item,
                        { className: 'app__css__app-pages-notice-index-__index__con_r' },
                        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__pages_Assembly_Breadcrumb__["a" /* default */], {
                            list: [{ name: '首页', url: '/index' }, { name: '消息发布', url: '/notice' }, { name: flbt }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                            'div',
                            null,
                            this.state.data.map(function (elem, index) {
                                return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_10__components__["a" /* Flex */],
                                    { onClick: function onClick() {
                                            _this2.click(elem.PKID);
                                        }, className: 'app__css__app-pages-notice-index-__index__item', key: index },
                                    __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_icon___default.a, {
                                        type: 'caret-right',
                                        style: { fontSize: 12 }
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_10__components__["a" /* Flex */].Item,
                                        { className: 't-clamp-1 ml-10' },
                                        elem.TZBT
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-notice-index-__index__time' },
                                        elem.FBSJ
                                    )
                                );
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_10__components__["a" /* Flex */],
                            { className: 'mt-50', justify: 'center' },
                            __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                'span',
                                { className: 'mr-20' },
                                '\u603B\u5171\u6709 ',
                                this.state.pageData.total,
                                ' \u6761\u6570\u636E'
                            ),
                            __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_pagination___default.a, {
                                defaultCurrent: 1,
                                defaultPageSize: this.state.pageData.pageSize,
                                total: this.state.pageData.total,
                                onChange: this.onChange
                            })
                        )
                    )
                )
            );
        }
    }]);

    return Notice;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);



/***/ }),

/***/ 1165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoticeDetail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_NHFetch__ = __webpack_require__(7);





var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }









if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var NoticeDetail = function (_React$Component) {
    _inherits(NoticeDetail, _React$Component);

    function NoticeDetail(props) {
        _classCallCheck(this, NoticeDetail);

        var _this = _possibleConstructorReturn(this, (NoticeDetail.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(NoticeDetail)).call(this, props));

        _this.reload = function (pkid) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_NHFetch__["a" /* default */])("/xxfb/getXxfbnrDetail", "GET", { pkid: pkid }).then(function (res) {
                if (res && res.data) {
                    _this.setState({
                        data: res.data
                    });
                }
                _this.setState({ loading: false });
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.state = {
            data: {},
            loading: false,
            flbz: '',
            pkid: ''
        };
        return _this;
    }

    _createClass(NoticeDetail, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var pkid = this.getQueryString("pkid");
            this.setState({ pkid: pkid });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var pkid = this.getQueryString("pkid");
            this.setState({ loading: true });
            this.reload(pkid);
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            var _this2 = this;

            var pkid = this.getQueryString("pkid");
            if (pkid && pkid != this.state.pkid) {
                this.setState({ pkid: pkid }, function () {
                    _this2.reload(pkid);
                });
            }
            return true;
        }
    }, {
        key: 'render',
        value: function render() {
            var data = this.state.data;
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__pages_Assembly_siderMenu__["a" /* default */], { title: '\u6D88\u606F\u53D1\u5E03', menuType: '\u901A\u77E5\u516C\u544A', flbz: data.flbz }),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6__components__["a" /* Flex */].Item,
                        { className: 'app__css__app-pages-notice-noticeDetail-__index__con_r' },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__pages_Assembly_Breadcrumb__["a" /* default */], {
                            list: [{ name: '首页', url: '/index' }, { name: '消息发布', url: '/notice' }, { name: data.flbt, url: '/notice', value: { flbz: data.flbz } }, { name: data.tzbt }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-notice-noticeDetail-__index__top' },
                            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-notice-noticeDetail-__index__title' },
                                data.tzbt
                            ),
                            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-notice-noticeDetail-__index__sub' },
                                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                                    'span',
                                    null,
                                    '\u53D1\u5E03\u4EBA\uFF1A',
                                    data.yhbh
                                ),
                                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                                    'span',
                                    { className: 'ml-20' },
                                    '\u53D1\u5E03\u65F6\u95F4\uFF1A',
                                    data.fbsj
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-notice-noticeDetail-__index__con' },
                            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: data.tznr } })
                        )
                    )
                )
            );
        }
    }]);

    return NoticeDetail;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);



/***/ }),

/***/ 1166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Answer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_pagination_style__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_pagination_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_pagination_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_pagination__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__index_css__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_common_NHUeditor__ = __webpack_require__(995);

















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }









if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var Search = __WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a.Search;





var history = __WEBPACK_IMPORTED_MODULE_19_history_createHashHistory___default()();

var _Empty = function _Empty(props) {
    return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
        'div',
        { className: 'app__css__app-pages-onlineQAndA-index-__index__empty' },
        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('img', { src: __webpack_require__(2170), alt: '' }),
        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
            'div',
            { className: 'mt-10' },
            '\u6682\u65E0\u76F8\u5173\u95EE\u9898\u7684\u89E3\u7B54\uFF0C\u4F60\u53EF\u4EE5\uFF1A'
        ),
        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
            'div',
            null,
            '\u6362\u4E2A',
            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                'span',
                { className: 'text-blue' },
                '\u5173\u952E\u8BCD'
            ),
            '\u6216\u70B9\u51FB\u201C',
            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                'span',
                { className: 'text-blue' },
                '\u6211\u8981\u63D0\u95EE'
            ),
            '\u201D'
        )
    );
};

var Answer = function (_React$Component) {
    _inherits(Answer, _React$Component);

    function Answer(props) {
        _classCallCheck(this, Answer);

        var _this = _possibleConstructorReturn(this, (Answer.__proto__ || __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_get_prototype_of___default()(Answer)).call(this, props));

        _this.getWtfl = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])('/proData/selectDataList', 'GET', {
                sign: 'DMK_YXXT_WTFL'
            }).then(function (resData) {
                if (resData && resData.data) {
                    _this.setState({ wtfl: resData.data });
                }
            });
        };

        _this.filterTableData = function () {
            _this.setState(function (prevState, props) {
                return {
                    pageData: {
                        total: _this.state.pageData.total,
                        pageSize: _this.state.pageData.pageSize,
                        page: 1
                    }
                };
            });
            _this.readTableData();
        };

        _this.readTableData = function () {
            var params = _this.getFilterParams();
            _this.setState({ loading: true });
            var url = _this.props.url ? _this.props.url : "/proData/gridList";
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])(url, "POST", params).then(function (res) {
                if (res) {
                    _this.setState({
                        data: res.data.list,
                        pageData: {
                            total: res.data.total,
                            pageSize: _this.state.pageData.pageSize,
                            page: _this.state.pageData.page
                        }
                    });
                }
                _this.setState({ loading: false });
            }).catch(function (res) {
                _this.setState({ loading: false });
                return res;
            });
        };

        _this.getFilterParams = function () {
            var pagination = _this.state.pageData; //分页的参数
            var filters = _this.state.filters; //多选过滤的数据
            var sorter = _this.state.sorter; //过滤的数据
            var searchTextMap = _this.state.searchTextMap; //字段上搜索栏的值
            var searchParams = _this.state.searchParams; //传递过来的查询参数
            var sqlParams = _this.state.sqlParams; //在sql语句中的参数
            var initParams = _this.state.initParams; //初始化参数
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                xsid = 'null';
            }
            sqlParams['xsid'] = xsid;
            var params = {
                pagination: pagination,
                filters: filters,
                sorter: sorter,
                searchTextMap: searchTextMap,
                searchParams: searchParams,
                sqlParams: sqlParams,
                initParams: initParams,
                sign: 'zhxg_yxwz_cjwt_queryPage'
            };

            return params;
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.onChange = function (pageNumber) {
            _this.setState(function (prevState, props) {
                return {
                    pageData: {
                        total: _this.state.pageData.total,
                        pageSize: _this.state.pageData.pageSize,
                        page: pageNumber
                    }
                };
            }, function () {
                this.readTableData();
            });
        };

        _this.onSave = function () {

            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.warn("未获取登录信息");
                return false;
            }

            var content = _this.state.getContent();
            if (!content) {
                __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.warn("请填写信息后再提交。");
                return;
            }
            var params = {
                twr: xsid,
                wt: content
            };
            _this.setState({ loading: true });
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])("/cjwt/insert", "POST", params).then(function (res) {
                if (res && res.data == 1) {
                    __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.success('问题已提交，等待管理员处理。');
                    _this.setState({ isShow: false }, function () {
                        _this.readTableData();
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.warn("问题提交有误，请重试");
                }
                _this.setState({ loading: false });
            }).catch(function (res) {
                __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.warn("提交异常，请稍后再试。");
                _this.setState({ loading: false });
                return res;
            });
        };

        _this.onSearchRed = function (text, search) {
            //search有值时，做高亮匹配
            var _title = text;
            if (search && text) {
                var reg = new RegExp(search, 'gi');
                var match = _title && _title.match(reg) || [];

                _title = _title && _title.split(reg).map(function (item, index) {
                    return index > 0 ? ['<span class="text-red">' + match[0] + '</span>', item] : item;
                });
            }
            return _title;
        };

        _this.onSearch = function (value) {
            var searchParams = {};
            if (value) {
                searchParams = {
                    'multiField,WT,WTDA,WTFL': value
                };
            } else {
                searchParams = {};
            }

            _this.setState({
                search: value,
                searchParams: searchParams
            });

            _this.readTableData();
        };

        _this.operationDzStatus = function (pkid) {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.warn("未获取登录信息!!!");
                return false;
            }
            var params = {
                xsid: xsid,
                cjwtid: pkid
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_NHFetch__["a" /* default */])("/cjwt/operationDzStatus", "POST", params).then(function (res) {
                _this.readTableData();
            });
        };

        _this.getContent = function (getContent) {
            _this.setState({ getContent: getContent });
        };

        _this.show = function () {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHCore__["e" /* checkLogin */])(false)) {
                _this.setState({
                    isShow: true
                });
            }
        };

        _this.state = {
            data: [],
            isShow: false,
            search: '',
            wtfl: [], //问题分类
            searchParams: {}, //自定义的搜索条件
            searchTextMap: {}, //下拉框查询的值,用作查询
            sqlParams: {}, //
            filters: {}, //多选方式过滤的值
            sorter: {}, //排序字段
            loading: false,
            pageData: { //分页设置的是三个参数
                total: 0,
                pageSize: 4, //当前页默认多少条数据
                page: 1
            },
            getContent: undefined //获取富文本编辑器的值
        };
        return _this;
    }

    _createClass(Answer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.getWtfl();
            this.filterTableData();
        }

        //重新加载数据数据的方法（从第一页开始）


        //在当前页刷新数据

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                loading = _state.loading,
                data = _state.data,
                isShow = _state.isShow,
                search = _state.search;


            return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                'div',
                { className: 'app__css__app-pages-onlineQAndA-index-__index__qaa' },
                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                    'div',
                    { className: 'app__css__app-pages-onlineQAndA-index-__index__bread' },
                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                        'div',
                        { className: 'w1180' },
                        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/' }, { name: '在线问答' }]
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                    'div',
                    { className: 'w1180', style: { position: 'relative' } },
                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                        'div',
                        { className: 'app__css__app-pages-onlineQAndA-index-__index__con' },
                        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_18__components__["a" /* Flex */],
                            { className: 'mt-10 app__css__app-pages-onlineQAndA-index-__index__search_box' },
                            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-onlineQAndA-index-__index__text-sub app__css__app-pages-onlineQAndA-index-__index__label' },
                                '\u95EE\u9898\u54A8\u8BE2'
                            ),
                            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(Search, {
                                placeholder: '\u8BF7\u641C\u7D22\u95EE\u9898',
                                value: search,
                                onChange: function onChange(e) {
                                    _this2.setState({
                                        search: e.target.value
                                    });
                                },
                                onSearch: function onSearch(value) {
                                    _this2.onSearch(value);
                                },
                                style: { width: 300 }
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_18__components__["a" /* Flex */],
                            { className: 'mt-10', align: 'start' },
                            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-onlineQAndA-index-__index__text-sub app__css__app-pages-onlineQAndA-index-__index__label' },
                                '\u76F8\u5173\u641C\u7D22'
                            ),
                            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_18__components__["a" /* Flex */].Item,
                                { className: 'app__css__app-pages-onlineQAndA-index-__index__tab_list' },
                                this.state.wtfl.map(function (elem, index) {
                                    return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                        'div',
                                        {
                                            key: index,
                                            className: 'app__css__app-pages-onlineQAndA-index-__index__tab_item',
                                            onClick: function onClick() {
                                                _this2.onSearch(elem.LABEL);
                                            }
                                        },
                                        elem.LABEL
                                    );
                                })
                            )
                        ),
                        data[0] ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                            'div',
                            { className: 'mt-20 app__css__app-pages-onlineQAndA-index-__index__list' },
                            data.map(function (elem, index) {
                                var search = _this2.state.search;

                                var _title = _this2.onSearchRed(elem.WT, search);
                                return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                    'div',
                                    { key: index, className: 'app__css__app-pages-onlineQAndA-index-__index__item' },
                                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_18__components__["a" /* Flex */],
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_18__components__["a" /* Flex */].Item,
                                            { className: 'app__css__app-pages-onlineQAndA-index-__index__wt' },
                                            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: _title } })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                            'div',
                                            { className: 'app__css__app-pages-onlineQAndA-index-__index__text-sub app__css__app-pages-onlineQAndA-index-__index__time' },
                                            elem.TWSJ
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div', {
                                        className: 'app__css__app-pages-onlineQAndA-index-__index__nr',
                                        style: { paddingBottom: 0 },
                                        dangerouslySetInnerHTML: { __html: elem.WTDA }
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-onlineQAndA-index-__index__text-sub app__css__app-pages-onlineQAndA-index-__index__time app__css__app-pages-onlineQAndA-index-__index__time_2' },
                                        elem.HDSJ
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_18__components__["a" /* Flex */],
                                        null,
                                        elem.DZ && elem.DZ > 0 ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('img', {
                                            style: { marginTop: '5px' },
                                            className: 'app__css__app-pages-onlineQAndA-index-__index__zan',
                                            src: __webpack_require__(2192),
                                            alt: '',
                                            onClick: function onClick() {
                                                _this2.operationDzStatus(elem.PKID);
                                            }
                                        }) : __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('img', {
                                            style: { marginTop: '5px' },
                                            className: 'app__css__app-pages-onlineQAndA-index-__index__zan',
                                            src: __webpack_require__(2191),
                                            alt: '',
                                            onClick: function onClick() {
                                                _this2.operationDzStatus(elem.PKID);
                                            }
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                            'div',
                                            { className: 'app__css__app-pages-onlineQAndA-index-__index__text-sub', style: { marginTop: '5px' } },
                                            elem.DZCS > 0 ? elem.DZCS : ''
                                        )
                                    )
                                );
                            })
                        ) : __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(_Empty, null),
                        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_18__components__["a" /* Flex */],
                            { justify: 'between', className: 'app__css__app-pages-onlineQAndA-index-__index__page_box' },
                            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_18__components__["a" /* Flex */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                    'div',
                                    null,
                                    '\u95EE\u9898\u6CA1\u6709'
                                ),
                                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('img', { src: __webpack_require__(2185), alt: '' }),
                                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 'app__css__app-pages-onlineQAndA-index-__index__tw_btn',
                                        onClick: this.show
                                    },
                                    '\u6211\u8981\u63D0\u95EE!'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_pagination___default.a, {
                                defaultCurrent: 1,
                                defaultPageSize: this.state.pageData.pageSize,
                                total: this.state.pageData.total,
                                onChange: this.onChange
                            })
                        ),
                        isShow && __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-onlineQAndA-index-__index__tw_box' },
                                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_18__components__["a" /* Flex */],
                                    {
                                        className: 'app__css__app-pages-onlineQAndA-index-__index__tw_box_top',
                                        justify: 'between'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                        'div',
                                        null,
                                        '\u6211\u8981\u63D0\u95EE'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_icon___default.a, {
                                        type: 'close',
                                        onClick: function onClick() {
                                            _this2.setState({
                                                isShow: false
                                            });
                                        }
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_18__components__["a" /* Flex */],
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                        'div',
                                        { style: { width: '100%' } },
                                        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__components_common_NHUeditor__["a" /* default */], { id: 'content',
                                            getContent: this.getContent,
                                            width: '100%',
                                            height: '420px',
                                            autoFloatEnabled: false
                                        })
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_antd_lib_button___default.a,
                                {
                                    className: 'ml-20 mt-20',
                                    type: 'primary',
                                    loading: loading,
                                    onClick: function onClick() {
                                        return _this2.onSave();
                                    }
                                },
                                '\u63D0\u4EA4'
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                        'div',
                        { style: { width: '100%', position: 'absolute', textAlign: 'center', top: '300px', display: this.state.loading ? 'block' : 'none' } },
                        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_spin___default.a, { size: 'large' })
                    )
                )
            );
        }
    }]);

    return Answer;
}(__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);



/***/ }),

/***/ 1167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProvinceInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__index_css__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_NHCore__ = __webpack_require__(8);







var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }










//请求默认路径

if (false) {
  module.hot.accept('./index.css', function () {
    require('./index.css');
  });
}

var pathUrl = "api/zhxg-yxxt";

var ProvinceInfo = function (_React$Component) {
  _inherits(ProvinceInfo, _React$Component);

  function ProvinceInfo(props) {
    _classCallCheck(this, ProvinceInfo);

    var _this = _possibleConstructorReturn(this, (ProvinceInfo.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(ProvinceInfo)).call(this, props));

    _this.getProvinceInfo = function (xsid) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_NHFetch__["a" /* default */])(pathUrl + '/yxwz/gdlm/tsxs/getProvinceInfo', 'GET', { xsid: xsid }).then(function (res) {
        if (res && res.data) {
          _this.setState({
            provinceInfoList: res.data
          });
        }
      });
    };

    _this.state = {
      provinceInfoList: []
      // flmid:'',//父栏目id
    };
    return _this;
  }
  // 同省信息页面


  _createClass(ProvinceInfo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHCore__["b" /* getLoginUser */])().userId : '';
      if (xsid) {
        this.getProvinceInfo(xsid);
      }
    }

    //加载信息

  }, {
    key: 'render',
    value: function render() {
      var provinceInfoList = this.state.provinceInfoList;
      var columns = [{ title: '姓名', dataIndex: 'XM', key: 'XM' }, { title: '院系', dataIndex: 'BMMC', key: 'BMMC' }, { title: '专业', dataIndex: 'ZYMC', key: 'ZYMC' }, { title: '省份', dataIndex: 'JG', key: 'JG' }];

      // const provinceInfoList = [
      //   {
      //     key: '1',
      //     XM: '张伟',
      //     BMMC:'信科院',
      //     ZYMC:'通信工程',
      //     JG:'广东省'
      //   },
      // ];
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */],
          { className: 'w1180 mt-20', align: 'start' },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */].Item,
            { className: 'app__css__app-pages-provinceInfo-__index__con_r' },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__pages_Assembly_Breadcrumb__["a" /* default */], {
              list: [{ name: '首页', url: '/index' }, { name: '同省来源地学生', url: '/provinceInfo' }]
            }),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_table___default.a, { columns: columns, dataSource: provinceInfoList })
          )
        )
      );
    }
  }]);

  return ProvinceInfo;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);



/***/ }),

/***/ 1168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VideoColumn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_pagination_style__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_pagination_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_pagination_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_pagination__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_css__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);







var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }






// import { getFunctinoName } from "@/config/commonService";
// import { getHashParam } from "@/utils/utils";


if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var VideoColumn = function (_Component) {
    _inherits(VideoColumn, _Component);

    function VideoColumn(props) {
        _classCallCheck(this, VideoColumn);

        var _this = _possibleConstructorReturn(this, (VideoColumn.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(VideoColumn)).call(this, props));

        _this.commonVideo = function () {
            var _this$state = _this.state,
                pkid = _this$state.currentPkid,
                page = _this$state.page,
                size = _this$state.pageSize;

            console.log("调用公共函数,当前页是:", page, "当前pkid是:", pkid);
            var params = {
                page: page - 1,
                size: size
                // pkid:pkid,

                //请求,根据当前选择的导航信息以及当前页和当前每页大小请求获取相应的视频列表信息
            };__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_NHFetch__["a" /* default */])('api/zhxg-yxxt/yxwz/fwwgl/video/getVideoByPage?page=' + (page - 1) + '&size=' + size, 'post').then(function (res1) {
                if (res1 && res1.code == 200) {
                    var tip = res1.data.spjsm; //右边显示视频说明

                    var _res1$data = res1.data,
                        total = _res1$data.totalElements,
                        videoList = _res1$data.content; //totalElements:总数 content:视频列表信息

                    _this.setState({
                        total: total,
                        videoList: videoList
                    });
                }
            });
        };

        _this.generateVideoDiv = function (videoList) {
            console.log("videoList", videoList);
            var pre = 'zuul/docrepo/download/file?attachmentId=';
            var _this$state2 = _this.state,
                currentSlt = _this$state2.currentSlt,
                currentVideo = _this$state2.currentVideo,
                videoVisible = _this$state2.videoVisible,
                videoPath = _this$state2.videoPath,
                videoExplain = _this$state2.videoExplain;

            return videoList.map(function (item, index) {
                return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    'div',
                    {
                        className: __WEBPACK_IMPORTED_MODULE_8__index_css___default.a.video_display_div,
                        key: index,
                        onMouseOver: function onMouseOver() {
                            _this.setState({
                                currentSlt: index
                            });
                        },
                        onMouseOut: function onMouseOut() {
                            _this.setState({
                                currentSlt: -1
                            });
                        },
                        onClick: function onClick() {
                            _this.playVideo(index, item.spdz, item.spsm, item.splx);
                        }

                    },
                    item.videoFlag ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'video',
                        {
                            src: videoPath,
                            controls: true,
                            style: { width: "100%" }
                        },
                        '\u60A8\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301 video \u6807\u7B7E\u3002'
                    ) : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', { width: '100%', height: '100%', src: '' + pre + item.slt }),
                    item.videoFlag && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'div',
                        { className: __WEBPACK_IMPORTED_MODULE_8__index_css___default.a.video_explain },
                        videoExplain
                    ),
                    !item.videoFlag && currentSlt > -1 && index == currentSlt ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'div',
                        { className: __WEBPACK_IMPORTED_MODULE_8__index_css___default.a.video_title },
                        videoList[currentSlt].spmc
                    ) : null
                );
            });
        };

        _this.handleShowTitile = function (index) {
            console.log("鼠标悬浮", index);
            _this.setState({
                currentSlt: index
            });
        };

        _this.handleNotShowTitle = function () {
            console.log("鼠标移出", index);
            _this.setState({
                currentSlt: -1
            });
        };

        _this.playVideo = function (index, videoPath, videoExplain, splx) {
            var videoList = _this.state.videoList;

            videoList.map(function (item, index1) {
                if (index == index1) {
                    item.videoFlag = true;
                } else {
                    item.videoFlag = false;
                }
            });
            console.log(index);
            var videoIndex = splx == '1' ? videoPath : 'zuul/docrepo/download/file?attachmentId=' + videoPath;
            _this.setState({
                currentVideo: index,
                videoVisible: true,
                videoPath: videoIndex,
                videoExplain: videoExplain,
                videoList: videoList
            });
        };

        _this.handleCancel = function (e) {
            console.log("关闭");
            _this.setState({
                videoVisible: false
            });
        };

        _this.handlePageChange = function (page, pageSize) {
            console.log("处理当前页码改变page-pageSize", page, pageSize, "当前pkid", _this.state.currentPkid);
            _this.setState({
                page: page
            }, function () {
                _this.commonVideo();
            });
        };

        _this.handleShowSizeChange = function (current, size) {
            console.log("处理每页大小改变,current-size", current, size, "当前pkid", _this.state.currentPkid);
            _this.setState({
                pageSize: size
            }, function () {
                _this.commonVideo();
            });
        };

        _this.state = {
            navList: [], //视频中心侧边导航list
            currentIndex: -1, //目前点击的左边导航
            currentPkid: "", //目前点击的左边导航的pkid
            title: "", //右侧部分主要标题
            tip: "", //每个视频的介绍说明
            total: "", //视频中心每一个侧边标题下的视频总数目
            pageSize: 9, //默认每页大小
            page: 1, //当前页,默认当前为第一页
            videoList: [], //当前页需要展示的视频列表，包含缩略图，视频地址，视频类型等信息
            currentSlt: -1, //右侧目前鼠标正悬浮的视频封面图
            currentVideo: -1, //右侧目前鼠标点击的视频
            videoVisible: false, //播放视频的modal
            videoPath: "", //当前播放视频的地址
            videoExplain: "" //当前播放视频的视频说明
        };
        return _this;
    }

    //首次渲染需要将左边导航以及右边标题等信息展示，当Pagination发生变化时，这些信息不用重新设置


    _createClass(VideoColumn, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            var _this2 = this;

            //请求视频集
            var _state = this.state,
                page = _state.page,
                size = _state.pageSize;

            var params = {
                page: page - 1,
                size: size
                // pkid:pkid,
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_NHFetch__["a" /* default */])('api/zhxg-yxxt/yxwz/fwwgl/video/getVideoByPage?page=' + (page - 1) + '&size=' + size, 'post').then(function (res1) {

                if (res1 && res1.code == 200) {
                    var tip = res1.data.spjsm; //右边显示视频说明

                    // const { totalElements: total, content: videoList } = res1.data.page; //totalElements:总数 content:视频列表信息
                    console.log("视频集---------------", res1.data, res1.data.content);
                    _this2.setState({
                        // navList: res.data,
                        currentIndex: 0,
                        // title: res.data[0].spjmc,
                        tip: tip,
                        total: res1.data.totalElements,
                        videoList: res1.data.content
                    });
                }
            });
        }

        //公共函数,当当前页以及每页大小改变时使用，只需要改变右边视频区域的视频列表以及当前Pagination相关的total


        //动态生成显示图片部分

        //处理鼠标悬浮在图片上

        //处理鼠标移开某个图片

        //处理播放点击的视频


        //处理关闭modal


        //处理当前页码改变

        //处理每页大小改变

    }, {
        key: 'render',
        value: function render() {
            var _state2 = this.state,
                navList = _state2.navList,
                title = _state2.title,
                tip = _state2.tip,
                total = _state2.total,
                pageSize = _state2.pageSize,
                videoList = _state2.videoList,
                videoVisible = _state2.videoVisible,
                videoPath = _state2.videoPath,
                videoExplain = _state2.videoExplain,
                getFunctinoName = _state2.getFunctinoName,
                page = _state2.page;


            return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_8__index_css___default.a.body },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    'div',
                    { className: __WEBPACK_IMPORTED_MODULE_8__index_css___default.a.body },
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'div',
                        { className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__index_css___default.a.right_content, 'subConentRight') },
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__index_css___default.a.boxTitle, 'titleWarp') },
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'a',
                                { className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()('titleWord') },
                                title
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__pages_Assembly_Breadcrumb__["a" /* default */], {
                            list: [{ name: '首页', url: '/index' }, { name: '校园视频', url: '/xysp' }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: __WEBPACK_IMPORTED_MODULE_8__index_css___default.a.right_tip },
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'span',
                                null,
                                ' ',
                                tip
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: __WEBPACK_IMPORTED_MODULE_8__index_css___default.a.video_display },
                            this.generateVideoDiv(videoList)
                        ),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: __WEBPACK_IMPORTED_MODULE_8__index_css___default.a.right_pagination },
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: __WEBPACK_IMPORTED_MODULE_8__index_css___default.a.right_pageTip },
                                '\u6BCF\u9875',
                                pageSize,
                                '\u6761\u8BB0\u5F55\uFF0C\u5171',
                                total,
                                '\u6761\u8BB0\u5F55'
                            ),
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: __WEBPACK_IMPORTED_MODULE_8__index_css___default.a.right_pagenation_page },
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_pagination___default.a, {
                                    current: page,
                                    size: 'small',
                                    total: total,
                                    showSizeChanger: true,
                                    showQuickJumper: true,
                                    defaultPageSize: pageSize,
                                    onChange: this.handlePageChange,
                                    pageSizeOptions: ['3', '6', '9'],
                                    onShowSizeChange: this.handleShowSizeChange
                                })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return VideoColumn;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);



/***/ }),

/***/ 1169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Footer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_NHFetch__ = __webpack_require__(7);





var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }





var Footer = function (_React$Component) {
    _inherits(Footer, _React$Component);

    function Footer(props) {
        _classCallCheck(this, Footer);

        var _this = _possibleConstructorReturn(this, (Footer.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Footer)).call(this, props));

        _this.state = {
            copyright: ''
        };
        return _this;
    }

    _createClass(Footer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/getCopyrightInformation', 'GET').then(function (res) {
                if (res && res.data) {
                    _this2.setState({ copyright: res.data });
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var copyright = this.state.copyright;


            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                { style: { fontSize: '12px', minWidth: '1180px', color: '#fff', backgroundColor: '#05a4ff', textAlign: 'center', lineHeight: '50px' } },
                copyright
            );
        }
    }]);

    return Footer;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);



/***/ }),

/***/ 1170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Header; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_carousel_style__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_carousel_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_carousel_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_carousel__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_css__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_NHCore__ = __webpack_require__(8);









var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }






if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_10_history_createHashHistory___default()();



var baseUrl = 'api/zhxg-yxwz/';

var Header = function (_React$Component) {
    _inherits(Header, _React$Component);

    function Header(props) {
        _classCallCheck(this, Header);

        var _this = _possibleConstructorReturn(this, (Header.__proto__ || __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default()(Header)).call(this, props));

        _this.getYxwzLogo = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHFetch__["a" /* default */])("api/zhxg-yxwz/dhlm/getLogo", "GET").then(function (resData) {
                if (resData && resData.data) {
                    _this.setState({
                        logoUUID: resData.data
                    });
                }
            });
        };

        _this.getDhlmList = function () {
            var params = {};
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (xsid) {
                params = {
                    xsfs: 2
                };
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHFetch__["a" /* default */])("api/zhxg-yxwz/dhlm/getDhlmList", "GET", params).then(function (resData) {
                if (resData && resData.data) {
                    _this.setState({ dhlm: resData.data });
                }
            });
        };

        _this.getSytpList = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHFetch__["a" /* default */])("api/zhxg-yxwz/sytp/getSytpList", "GET").then(function (resData) {
                if (resData && resData.data) {
                    _this.setState({ sytp: resData.data });
                }
            });
        };

        _this.click = function (dhlm) {
            var lmlx = dhlm['lmlx'];
            var flbz = dhlm['flbz'];
            var mkbz = dhlm['mkbz'];
            var flmid = dhlm['flmid'];
            var lmlj = dhlm['lmlj'];
            var pkid = dhlm['pkid'];
            var count = dhlm['childCount'];

            if (lmlx == 3) {
                history.push({
                    pathname: '/' + mkbz
                });
            } else if (lmlx == 1) {
                history.push({
                    pathname: '/notice',
                    search: '/flbz=' + flbz
                });
            } else if (lmlx == 2) {
                if (count > 0) {
                    history.push({
                        pathname: '/link',
                        search: 'pkid=' + pkid
                    });
                } else {
                    window.open(lmlj);
                }
            }
        };

        _this.state = {
            sytp: [], //首页图片
            dhlm: [], //导航栏目
            settings: {},
            logoUUID: '' //LOGO图(对应文档库的UUID)
        };
        return _this;
    }

    _createClass(Header, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.getYxwzLogo();
            this.getSytpList();
            this.getDhlmList();
            setTimeout(function () {
                var settings = {
                    effect: 'fade',
                    dots: true,
                    speed: 10000
                };
                _this2.setState({
                    settings: settings
                });
            }, 2000);
        }

        //获取迎新网站LOGO

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var settings = this.state.settings;
            var logoUUID = this.state.logoUUID;

            var show = false;
            if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(settings) === "{}") {
                show = false;
            } else {
                show = true;
            }
            return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                    'div',
                    { className: 'app__css__plugins-header-__index__top' },
                    __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                        'div',
                        { className: 'app__css__plugins-header-__index__top_con' },
                        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('img', { src: logoUUID ? "anonymity/docrepo/download?attachmentId=" + logoUUID : '', alt: '' })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                    'div',
                    { className: 'app__css__plugins-header-__index__list' },
                    __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                        'div',
                        { className: 'w1180' },
                        this.state.dhlm.map(function (elem, index) {
                            return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                'span',
                                { key: index, className: 'app__css__plugins-header-__index__item', onClick: function onClick() {
                                        _this3.click(elem);
                                    } },
                                elem.lmmc,
                                elem.sfrdlm_dm == "1" && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('img', { src: __webpack_require__(2171), style: { position: "relative", top: "-8px" } })
                            );
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                    'div',
                    { className: '_bg app__css__plugins-header-__index__banner' },
                    show ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_antd_lib_carousel___default.a,
                        _extends({}, settings, { autoplay: true }),
                        this.state.sytp.map(function (elem, index) {
                            var pkid = elem['PKID'];
                            return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                'div',
                                { className: 'app__css__plugins-header-__index__banner', key: index },
                                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('img', { style: { width: '100%', height: '100%' }, src: "api/zhxg-yxwz/sytp/getPicture/" + pkid, alt: '' })
                            );
                        })
                    ) : this.state.sytp.length > 0 && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                        'div',
                        { className: 'app__css__plugins-header-__index__banner' },
                        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('img', { style: { width: '100%', height: '100%' }, src: "api/zhxg-yxwz/sytp/getPicture/" + this.state.sytp[0].PKID, alt: '' })
                    )
                )
            );
        }
    }]);

    return Header;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);



/***/ }),

/***/ 1171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__login__ = __webpack_require__(1172);





var rootReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
    routing: __WEBPACK_IMPORTED_MODULE_1_react_router_redux__["routerReducer"],
    login: __WEBPACK_IMPORTED_MODULE_2__login__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (rootReducer);

/***/ }),

/***/ 1172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_login__ = __webpack_require__(549);


var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initState = window.localStorage.getItem('access_user') ? { user: JSON.parse(window.localStorage.getItem('access_user')) } : {
    user: null
};

var login = function login() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions_login__["a" /* RECEIVE_USERINFO */]:
            return _extends({}, state, { loading: false, user: action.user });
        case __WEBPACK_IMPORTED_MODULE_1__actions_login__["b" /* CLEAR_USERINFO */]:
            return _extends({}, state, { loading: false, user: null });
        default:
            return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (login);

/***/ }),

/***/ 1173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_devtools_extension__ = __webpack_require__(2136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_devtools_extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_devtools_extension__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_thunk__ = __webpack_require__(2141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_logger__ = __webpack_require__(2140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_history_createBrowserHistory__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_index__ = __webpack_require__(1171);








var history = __WEBPACK_IMPORTED_MODULE_5_history_createBrowserHistory___default()();
var middleware = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["routerMiddleware"])(history);
var logger = __WEBPACK_IMPORTED_MODULE_3_redux_logger___default()({ collapsed: true });

var middlewares = [__WEBPACK_IMPORTED_MODULE_2_redux_thunk__["a" /* default */], middleware];

if (false) {
    middlewares.push(logger);
}
var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_6__reducers_index__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_devtools_extension__["composeWithDevTools"])(__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"].apply(undefined, middlewares)));

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 1174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TotalRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_transition_group_CSSTransitionGroup__ = __webpack_require__(2131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_transition_group_CSSTransitionGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_transition_group_CSSTransitionGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__redux_actions_login__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_custom_scrollbars__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_custom_scrollbars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_globalUtil__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__plugins_header__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__plugins_footer__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_index__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_notice_index__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_notice_noticeDetail__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_SelfHelp_education__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_viewVideo_myVideo_index__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_SelfHelp_route__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_SelfHelp_updateInfo__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_SelfHelp_infoGdnhgs__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_SelfHelp_updateInfoFg__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_SelfHelp_buy__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_SelfHelp_buyFa__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_SelfHelp_size__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_xfcm__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_SelfHelp_report__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_SelfHelp_reportGdnhgs__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_SelfHelp_reportCzxy__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_SelfHelp_reportWhrj__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_SelfHelp_channel__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_SelfHelp_channelCzxy__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_SelfHelp_channelFb__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_SelfHelp_sszychannel__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_SelfHelp_szjdChannel__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_SelfHelp_channelZtxy__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_SelfHelp_major__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_SelfHelp_majorFa__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__pages_SelfHelp_majorFb__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__pages_SelfHelp_majorFc__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__pages_SelfHelp_pay__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__pages_SelfHelp_nonTaxPay__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__pages_SelfHelp_sszyxfpay__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__pages_SelfHelp_sszyssfpay__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__pages_SelfHelp_print__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__pages_SelfHelp_dorm__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__pages_SelfHelp_checkDormitory__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__pages_SelfHelp_allotDormitory__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__pages_SelfHelp_sszydorm__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__pages_SelfHelp_customLink__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__pages_SelfHelp_choosePhoneNum__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__pages_SelfHelp_scjtChooseDor__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__pages_SelfHelp_cdzyjsxyChooseDor__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__pages_SelfHelp_whrjChooseDor__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__pages_SelfHelp_nxyszyxyChooseDor__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__pages_onlineQAndA_index__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__pages_index_IndexRoute__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__pages_link__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__utils_Router__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__pages_SelfHelp_info__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__pages_SelfHelp_payFxxy__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__pages_SelfHelp_wxChatPay__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__pages_lqcx__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__pages_SelfHelp_pInfo__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__pages_SelfHelp_newInfo__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__pages_SelfHelp_examination__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__pages_SelfHelp_commonInfo__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__pages_SelfHelp_infoHncs__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__pages_SelfHelp_reportHncs__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__pages_dormInfo__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__pages_provinceInfo__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__pages_SelfHelp_applyDorm__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__pages_SelfHelp_viewStudentId__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__pages_SelfHelp_channelTlxy__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__pages_SelfHelp_mentalHealthSurvey__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__pages_SelfHelp_anLv__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__pages_SelfHelp_antiepidemic__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__pages_SelfHelp_medicalInsurance__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__pages_SelfHelp_carePackage__ = __webpack_require__(1014);







var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }














/*公共模块*/


/*页面*/

/*公告*/


/*自助报到*/

//视频预览


// import Autobiography from '@pages/SelfHelp/autobiography'





































/*在线问答*/

/*默认页面*/

/*导航链接*/



/* 个人信息（简易） */

/*缴费环节，商联*/

/* 缴费环节，微信*/

/* 录取查询 */

/* 个人信息（微调版） */

/* 个人信息（新版）*/

/* 自助报到>入学考试 */

/* 个人信息深圳技大 */

// 个人信息湖南城市

// 报到湖南城市





// 铜陵学院绿色通道


/* 绿色通道-安徽工商 */

/* 武汉软件防疫登记 */

/* 是否缴纳医疗保险（湖南城市学院）*/

/* 武汉软件绿色通道关怀礼包*/


var Content = __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a.Content;


var history = __WEBPACK_IMPORTED_MODULE_10_history_createHashHistory___default()();

var TotalRoutes = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(function (store) {
    var login = store.login,
        dispatch = store.dispatch;

    return { login: login, dispatch: dispatch };
}), _dec(_class = function (_React$Component) {
    _inherits(TotalRoutes, _React$Component);

    function TotalRoutes(props) {
        _classCallCheck(this, TotalRoutes);

        var _this = _possibleConstructorReturn(this, (TotalRoutes.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(TotalRoutes)).call(this, props));

        _this.changeIcon = function () {
            var link = document.head.querySelector("link[rel=icon]");
            var href = window.location.href;

            link.href = href.substring(0, href.indexOf('/', 8)) + '/front/zhxg-unauth/xtglSchoolMng/downloadSchoolPictureByType?type=ico';
        };

        _this.doLogin = function () {
            if (!window.localStorage.getItem('access_user')) {
                history.push('/login');
            }
        };

        _this.state = {
            name: "admin",
            casLogoutUrl: ''
        };
        return _this;
    }

    _createClass(TotalRoutes, [{
        key: 'componentWillMount',
        value: function componentWillMount() {}
        // this.doLogin();


        //修改icon

    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            // this.setState({ clientHeight: getSize().windowH });
            // window.onresize =  () => {
            //     this.setState({
            //         clientHeight: getSize().windowH,
            //     })
            // }

            // let skin = window.localStorage.getItem("skin");
            // if(skin) {
            //     this.setState({skin})
            // }

            // if(window.localStorage.getItem('access_user')){
            //     let name=JSON.parse(window.localStorage.getItem('access_user')).userName;
            //     this.setState({
            //         name:name
            //     })
            // }
            //this.changeIcon();

        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            // this.doLogin();
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_router_dom__["a" /* Router */],
                { history: history },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */], { render: function render() {
                        return (
                            // 页面切换动画设置
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_11_react_transition_group_CSSTransitionGroup___default.a,
                                {
                                    transitionName: '',
                                    transitionEnter: true,
                                    transitionLeave: true,
                                    transitionEnterTimeout: 500,
                                    transitionLeaveTimeout: 500
                                },
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_8_react_router_dom__["c" /* Switch */],
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */], { render: function render() {
                                            return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_5_antd_lib_layout___default.a,
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__plugins_header__["a" /* default */], null),
                                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                                    Content,
                                                    null,
                                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                                        'div',
                                                        { className: 'content-box' },
                                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_8_react_router_dom__["c" /* Switch */],
                                                            null,
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */], { path: '/onlineQAndA', component: __WEBPACK_IMPORTED_MODULE_59__pages_onlineQAndA_index__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/education', component: __WEBPACK_IMPORTED_MODULE_20__pages_SelfHelp_education__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/examination', component: __WEBPACK_IMPORTED_MODULE_70__pages_SelfHelp_examination__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/onlinePayment', component: __WEBPACK_IMPORTED_MODULE_44__pages_SelfHelp_pay__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/sszywsjxf', component: __WEBPACK_IMPORTED_MODULE_46__pages_SelfHelp_sszyxfpay__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/ssxzywsjssf', component: __WEBPACK_IMPORTED_MODULE_47__pages_SelfHelp_sszyssfpay__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/major', component: __WEBPACK_IMPORTED_MODULE_40__pages_SelfHelp_major__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/majorFb', component: __WEBPACK_IMPORTED_MODULE_42__pages_SelfHelp_majorFb__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/majorFc', component: __WEBPACK_IMPORTED_MODULE_43__pages_SelfHelp_majorFc__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/ahGsLsTd', component: __WEBPACK_IMPORTED_MODULE_80__pages_SelfHelp_anLv__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/majorFa', component: __WEBPACK_IMPORTED_MODULE_41__pages_SelfHelp_majorFa__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/channel', component: __WEBPACK_IMPORTED_MODULE_34__pages_SelfHelp_channel__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/ChannelCzxy', component: __WEBPACK_IMPORTED_MODULE_35__pages_SelfHelp_channelCzxy__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/channelFb', component: __WEBPACK_IMPORTED_MODULE_36__pages_SelfHelp_channelFb__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/sszychannel', component: __WEBPACK_IMPORTED_MODULE_37__pages_SelfHelp_sszychannel__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/report', component: __WEBPACK_IMPORTED_MODULE_30__pages_SelfHelp_report__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/szjdChannel', component: __WEBPACK_IMPORTED_MODULE_38__pages_SelfHelp_szjdChannel__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/channelZtxy', component: __WEBPACK_IMPORTED_MODULE_39__pages_SelfHelp_channelZtxy__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/reportGdnhgs', component: __WEBPACK_IMPORTED_MODULE_31__pages_SelfHelp_reportGdnhgs__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/reportHncs', component: __WEBPACK_IMPORTED_MODULE_73__pages_SelfHelp_reportHncs__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/reportCzxy', component: __WEBPACK_IMPORTED_MODULE_32__pages_SelfHelp_reportCzxy__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/reportWhrj', component: __WEBPACK_IMPORTED_MODULE_33__pages_SelfHelp_reportWhrj__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/chooseDormitory', component: __WEBPACK_IMPORTED_MODULE_49__pages_SelfHelp_dorm__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/scjtChooseDor', component: __WEBPACK_IMPORTED_MODULE_55__pages_SelfHelp_scjtChooseDor__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/checkDormitory', component: __WEBPACK_IMPORTED_MODULE_50__pages_SelfHelp_checkDormitory__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/allotDormitory', component: __WEBPACK_IMPORTED_MODULE_51__pages_SelfHelp_allotDormitory__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/cdzyjsxyChooseDor', component: __WEBPACK_IMPORTED_MODULE_56__pages_SelfHelp_cdzyjsxyChooseDor__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/whrjChooseDor', component: __WEBPACK_IMPORTED_MODULE_57__pages_SelfHelp_whrjChooseDor__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/nxyszyxyChooseDor', component: __WEBPACK_IMPORTED_MODULE_58__pages_SelfHelp_nxyszyxyChooseDor__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/sszyssfp', component: __WEBPACK_IMPORTED_MODULE_52__pages_SelfHelp_sszydorm__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/clothingSize', component: __WEBPACK_IMPORTED_MODULE_28__pages_SelfHelp_size__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/schoolUniform', component: __WEBPACK_IMPORTED_MODULE_29__pages_SelfHelp_xfcm__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/buy', component: __WEBPACK_IMPORTED_MODULE_26__pages_SelfHelp_buy__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/buyFa', component: __WEBPACK_IMPORTED_MODULE_27__pages_SelfHelp_buyFa__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/nonTaxPay', component: __WEBPACK_IMPORTED_MODULE_45__pages_SelfHelp_nonTaxPay__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/choosePhoneNum', component: __WEBPACK_IMPORTED_MODULE_54__pages_SelfHelp_choosePhoneNum__["a" /* default */] }),
                                                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_63__utils_Router__["a" /* RouterComponents */])(),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/register', component: __WEBPACK_IMPORTED_MODULE_22__pages_SelfHelp_route__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/personalInformation', component: __WEBPACK_IMPORTED_MODULE_23__pages_SelfHelp_updateInfo__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/infoGdnhgs', component: __WEBPACK_IMPORTED_MODULE_24__pages_SelfHelp_infoGdnhgs__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/infoHncs', component: __WEBPACK_IMPORTED_MODULE_72__pages_SelfHelp_infoHncs__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/personalInformationFg', component: __WEBPACK_IMPORTED_MODULE_25__pages_SelfHelp_updateInfoFg__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/customLink', component: __WEBPACK_IMPORTED_MODULE_53__pages_SelfHelp_customLink__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/applyDorm', component: __WEBPACK_IMPORTED_MODULE_76__pages_SelfHelp_applyDorm__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/viewStudentId', component: __WEBPACK_IMPORTED_MODULE_77__pages_SelfHelp_viewStudentId__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/channelTlxy', component: __WEBPACK_IMPORTED_MODULE_78__pages_SelfHelp_channelTlxy__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/mentalHealthSurvey', component: __WEBPACK_IMPORTED_MODULE_79__pages_SelfHelp_mentalHealthSurvey__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/antiepidemic', component: __WEBPACK_IMPORTED_MODULE_81__pages_SelfHelp_antiepidemic__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/medicalInsurance', component: __WEBPACK_IMPORTED_MODULE_82__pages_SelfHelp_medicalInsurance__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/lstdghlb', component: __WEBPACK_IMPORTED_MODULE_83__pages_SelfHelp_carePackage__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */], { path: '/notice/detail', component: __WEBPACK_IMPORTED_MODULE_19__pages_notice_noticeDetail__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */], { path: '/notice', component: __WEBPACK_IMPORTED_MODULE_18__pages_notice_index__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */], { path: '/link', component: __WEBPACK_IMPORTED_MODULE_61__pages_link__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */], { path: '/info', component: __WEBPACK_IMPORTED_MODULE_64__pages_SelfHelp_info__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */], { path: '/pInfo', component: __WEBPACK_IMPORTED_MODULE_68__pages_SelfHelp_pInfo__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */], { path: '/newInfo', component: __WEBPACK_IMPORTED_MODULE_69__pages_SelfHelp_newInfo__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */], { path: '/szjdInfo', component: __WEBPACK_IMPORTED_MODULE_71__pages_SelfHelp_commonInfo__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/onlinePaymentFxxy', component: __WEBPACK_IMPORTED_MODULE_65__pages_SelfHelp_payFxxy__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__AuthorizedRoute__["a" /* default */], { path: '/wxChatPay', component: __WEBPACK_IMPORTED_MODULE_66__pages_SelfHelp_wxChatPay__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */], { path: '/dormInfo', component: __WEBPACK_IMPORTED_MODULE_74__pages_dormInfo__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */], { path: '/provinceInfo', component: __WEBPACK_IMPORTED_MODULE_75__pages_provinceInfo__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */], { path: '/xysp', component: __WEBPACK_IMPORTED_MODULE_21__pages_viewVideo_myVideo_index__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */], { path: '/lqcx', component: __WEBPACK_IMPORTED_MODULE_67__pages_lqcx__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */], { path: '/index', component: __WEBPACK_IMPORTED_MODULE_17__pages_index__["a" /* default */] }),
                                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */], { path: '/', component: __WEBPACK_IMPORTED_MODULE_60__pages_index_IndexRoute__["a" /* default */] })
                                                        )
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__plugins_footer__["a" /* default */], null)
                                            );
                                        } })
                                )
                            )
                        );
                    } })
            );
        }
    }]);

    return TotalRoutes;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component)) || _class);


/***/ }),

/***/ 1175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asyncImport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable__ = __webpack_require__(2098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_loadable__);



/**
 * @author qianzhiwei
 * @date 2020/09/25
 */
function asyncImport(loader) {
    function Loading(props) {
        if (props.error) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            'Error!'
        );else if (props.pastDelay) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            '\u52A0\u8F7D\u9875\u9762\u4E2D!'
        );else return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({
        loader: loader,
        loading: Loading
    });
}



/***/ }),

/***/ 1176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//获取UUID
var createUuid = function createUuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
};
/* harmony default export */ __webpack_exports__["a"] = (createUuid);

/***/ }),

/***/ 1177:
/***/ (function(module, exports) {

/*
 * @Description: 
 * @Version: 1.0
 * @Author: 琴时
 * @Date: 2021-08-30 17:02:41
 * @LastEditors: 琴时
 * @LastEditTime: 2021-08-30 17:56:37
 */

/**
 * @description: 变量类型判断
 * @param {*} type - 需要判断的类型
 * @param {*} value - 需要判断的值
 * @return {Boolean} - 是否该类型
 * @author: 琴时
 */
var IsType = function IsType(type, value) {
    return Object.prototype.toString.call(value) === "[object " + type + "]";
};

/**
 * @description: 深拷贝变量-递归算法(recursive algorithm)
 * 支持 String,Number,Boolean,null,undefined,Object,Array,Date,RegExp,Error,Function 类型
 * @param {*} params - 需要深拷贝的变量
 * @return {*}
 * @author: 琴时
 */
var deepCopy = function deepCopy(params) {
    var newValue = IsType("Object", params) // 判断是否是对象
    ? {} : IsType("Array", params) // 判断是否是数组
    ? [] : IsType("Date", params) // 判断是否是日期对象
    ? new params.constructor(+params) : IsType("RegExp", params) || IsType("Error", params) // 判断是否是正则对象或错误对象
    ? new params.constructor(params) : params;
    // 判断是否是数组或对象
    if (IsType("Object", params) || IsType("Array", params)) {
        // 循环遍历
        for (var key in params) {
            // 防止原型链的值
            Object.prototype.hasOwnProperty.call(params, key) && (newValue[key] = deepCopy(params[key]));
        }
    }
    // console.log('拷贝:',newValue)
    return newValue;
};
module.exports = {
    deepCopy: deepCopy
};

/***/ }),

/***/ 118:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"progress":"app__css__app-pages-SelfHelp-commonInfo-__index__progress","jbxx_icon":"app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_icon","upload-box":"app__css__app-pages-SelfHelp-commonInfo-__index__upload-box","upload-title":"app__css__app-pages-SelfHelp-commonInfo-__index__upload-title","jbxx_item":"app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item","jbxx_item2":"app__css__app-pages-SelfHelp-commonInfo-__index__jbxx_item2","item-label":"app__css__app-pages-SelfHelp-commonInfo-__index__item-label","item-name":"app__css__app-pages-SelfHelp-commonInfo-__index__item-name","kzxx_list":"app__css__app-pages-SelfHelp-commonInfo-__index__kzxx_list","kzxx_item":"app__css__app-pages-SelfHelp-commonInfo-__index__kzxx_item","kzxx_label":"app__css__app-pages-SelfHelp-commonInfo-__index__kzxx_label","kzxx_name":"app__css__app-pages-SelfHelp-commonInfo-__index__kzxx_name","kzxx_item_textarea":"app__css__app-pages-SelfHelp-commonInfo-__index__kzxx_item_textarea","kzxx_name_textarea":"app__css__app-pages-SelfHelp-commonInfo-__index__kzxx_name_textarea","btn_add":"app__css__app-pages-SelfHelp-commonInfo-__index__btn_add","title_top":"app__css__app-pages-SelfHelp-commonInfo-__index__title_top","title_top_name":"app__css__app-pages-SelfHelp-commonInfo-__index__title_top_name","line":"app__css__app-pages-SelfHelp-commonInfo-__index__line","detail_adrress":"app__css__app-pages-SelfHelp-commonInfo-__index__detail_adrress"};

/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _siderMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__index_css__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__index_css__);







var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }








if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var _siderMenu = (_temp2 = _class = function (_React$Component) {
    _inherits(_siderMenu, _React$Component);

    function _siderMenu() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, _siderMenu);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _siderMenu.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(_siderMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            edit: false
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(_siderMenu, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                className = _props.className,
                children = _props.children,
                apply = _props.apply,
                title = _props.title,
                extra = _props.extra,
                onEdit = _props.onEdit,
                onSave = _props.onSave,
                onClose = _props.onClose,
                onApplyClick = _props.onApplyClick;
            var edit = this.state.edit;


            return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9__components__["a" /* Flex */],
                { className: (className ? className + ' ' : '') + 'app__css__app-pages-Assembly-titleTop-__index__title_top', justify: 'between' },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    'div',
                    { className: 'app__css__app-pages-Assembly-titleTop-__index__title_top_name' },
                    title
                ),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components__["a" /* Flex */].Item, { className: 'app__css__app-pages-Assembly-titleTop-__index__line' }),
                extra && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                        {
                            className: 'ml-10',
                            type: 'primary',
                            ghost: true,
                            onClick: function onClick() {
                                // edit ? onSave(title) : onEdit(title);
                                // this.setState({
                                //     edit: !edit
                                // });
                                edit ? onSave(function (validate) {
                                    if (validate) {
                                        _this2.setState({
                                            edit: !edit
                                        });
                                    }
                                }) : onEdit(title);
                                if (edit === false) {
                                    _this2.setState({
                                        edit: true
                                    });
                                }
                            }
                        },
                        edit ? '保存' : '编辑'
                    ),
                    edit && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                        {
                            className: 'ml-10',
                            type: 'ghost',
                            onClick: function onClick() {
                                _this2.setState({
                                    edit: false
                                });
                                onClose(title);
                            }
                        },
                        '取消'
                    )
                ),
                apply && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                    {
                        className: 'ml-10',
                        type: 'primary',
                        ghost: true,
                        onClick: function onClick() {
                            onApplyClick();
                        }
                    },
                    '\u7533\u8BF7'
                ),
                children
            );
        }
    }]);

    return _siderMenu;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component), _class.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    extra: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    onEdit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onSave: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onClose: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onApplyClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
}, _class.defaultProps = {
    extra: true,
    onEdit: Function.prototype,
    onSave: Function.prototype,
    onClose: Function.prototype,
    onApplyClick: Function.prototype
}, _temp2);



/***/ }),

/***/ 141:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 142:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA25pVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDphNmQ2ZjNlZi0wNjAwLTE4NGMtYTNkNi00MjhiOTllNTEzZjMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OEU5Q0EyMUM4RjFCMTFFOEExNjE4NTE3QzYyODgxNDAiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OEU5Q0EyMUI4RjFCMTFFOEExNjE4NTE3QzYyODgxNDAiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6REU5RDc5N0YyNzVCMTFFOEJGQ0NGMzZFNEUxM0I4MjMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6REU5RDc5ODAyNzVCMTFFOEJGQ0NGMzZFNEUxM0I4MjMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6ZgiUWAAAB9klEQVR42rSWTygEURzHZ1m7VtioTXuxUlIuDlxxIX+TUA68cFEoOTmQvIuD4kA5IAfNlr04oIQLKTeSG5KDi1LCwb/8Gd83+ztsszOzb7bdV5/fzOy8976/3+/93pt1aZqmpLO5pAUYL4atAM/gTFH5r8wwt+Tk9bAHIIN+2QLdMkMzJCNtMfRtTU2KGG+AHQKNIM/w9oIiWUa6XpwJMO6HDYM2CSefQB9E9uUEGPfBnoBqB8XyDTogsiezBnMOJxctC6hwrshegPEQ7Iihz4ekSCEYTxRBL8g0/DbrIJJ+OOmyE6g1PD9QysKSAkFQaidQYniexsL94Dqge6co6/ouVpRPG5Fy8ypivAk2Avz0bgUMQ0Cz2CM+2htlYAo005tNPdU0LjYC0fGc7k/BKAhhoqCFpwXAi4lE3y7aD6LtUKriUiRScUf3C3SYHVNUZm0XROte5aLSbmJ2uMfssBMhvdH9EV3HwKuFwKRhfA64p2jmzdbArXuuKIPwKN/xwc/4LewX6MT46/gURatlEeSic2US3xYRwUbs5PFlqnKxBo+gByIeB94z2AA4lDmLrsAqmMFAr8Tk7bDvQKToUkZgm6JY0uub8TqLiQNgQj9JVS6+C2tmeybxN5nxGtgq8EeItcqm6opQiabgo5/2fxVJtn8BBgB6k5f4W9rzwQAAAABJRU5ErkJggg=="

/***/ }),

/***/ 143:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDphNmQ2ZjNlZi0wNjAwLTE4NGMtYTNkNi00MjhiOTllNTEzZjMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NUEyODk2QUU4RjFCMTFFODgwRkM4MDkwM0UzQzU1RjAiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NUEyODk2QUQ4RjFCMTFFODgwRkM4MDkwM0UzQzU1RjAiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6ZTk1MjQxZDUtMDNkZS1iNjQ0LWI5ODktNGQwOTFiOGM2NmNjIiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6YzU0YzFmNTktMjVkMi0xMWU4LWJmOWMtOWVjYWZkMWRjYTgyIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+9DnxbAAAAV1JREFUeNpi/P//PwMtASPdLWhsbATT4eHhKUCKDYinr1y5kihX1NfXY4ix4FF/D4j3AnEG0LINQPoBEPMA8QcgvgPEp4EW/yZkKT4LOKC0LhSjgzdAi6uAlszGZwETHrk0Ao4TAeJZQEuySbYAqIkXSHkSGY+NQPXspPrACBrBxABhIDYmOhXduHEDFPY3gFiehNT4EIg1NTQ0vhPjA3USDWeAqlcjNog+kZmnPhFlATDZ3QdS5UBMbBYHqSuF6iMukoGKu4DUQSItOAhU30NOPqgj0oJasjIa0FWHgVQuEP/FoQQkngNUd4TcnAyyZAqQ0schbQGUn0rIe0xEBAEuNX+ICT+chR0w+2sAqQogjsGh5BRQzTwg3Qb0ySNScrIAkAIFTRRInghHgorsWaCkDczJX4nxAchVgSRkMFYgBpWoAth8iy18fcnMyWHERiALmRawDo5Kn9oAIMAA1WJrTYcaso0AAAAASUVORK5CYII="

/***/ }),

/***/ 1549:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"avatar-uploader":"app__css__app-components-common-NHInputPicker-__style__avatar-uploader","ant-upload":"app__css__app-components-common-NHInputPicker-__style__ant-upload","ant-upload-list-item-card-actions":"app__css__app-components-common-NHInputPicker-__style__ant-upload-list-item-card-actions"};

/***/ }),

/***/ 1550:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"vertical-center-modal":"app__css__app-components-common-NHModal-__index__vertical-center-modal","ant-modal":"app__css__app-components-common-NHModal-__index__ant-modal"};

/***/ }),

/***/ 1551:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"edui-popup":"app__css__app-components-common-NHUeditor-ueditor-themes-default-css-__ueditor__edui-popup","edui-dialog":"app__css__app-components-common-NHUeditor-ueditor-themes-default-css-__ueditor__edui-dialog"};

/***/ }),

/***/ 1552:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sider_menu":"app__css__app-pages-Assembly-siderMenu-__index__sider_menu","sider_menu_title":"app__css__app-pages-Assembly-siderMenu-__index__sider_menu_title","sider_menu_item":"app__css__app-pages-Assembly-siderMenu-__index__sider_menu_item","active":"app__css__app-pages-Assembly-siderMenu-__index__active"};

/***/ }),

/***/ 1553:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title_top":"app__css__app-pages-Assembly-titleTop-__index__title_top","title_top_name":"app__css__app-pages-Assembly-titleTop-__index__title_top_name","line":"app__css__app-pages-Assembly-titleTop-__index__line"};

/***/ }),

/***/ 1554:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1555:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-index-__index__title","jbxx_icon":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-index-__index__jbxx_icon","jbxx_item":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-index-__index__jbxx_item","item-label":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-index-__index__item-label","item-name":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-index-__index__item-name","ssxx_list":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-index-__index__ssxx_list","ssxx_item":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-index-__index__ssxx_item","ssxx_label":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-index-__index__ssxx_label","ssxx_name":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-index-__index__ssxx_name","bz-item":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-index-__index__bz-item","bz-img":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-index-__index__bz-img"};

/***/ }),

/***/ 1556:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"repTop":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__repTop","repTopTitle":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__repTopTitle","repMain":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__repMain","LcTable":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__LcTable","bottom_copyright":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__bottom_copyright","bttom_barcode":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__bttom_barcode","title":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__title","jbxx_icon":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__jbxx_icon","jbxx_icon_bg":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__jbxx_icon_bg","jbxx_item":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__jbxx_item","item_label":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__item_label","item_name":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__item_name","item_name_t_clamp_1":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__item_name_t_clamp_1","kzxx_list":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__kzxx_list","kzxx_item":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__kzxx_item","kzxx_label":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__kzxx_label","kzxx_name":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__kzxx_name","kzxx_item_textarea":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__kzxx_item_textarea","kzxx_name_textarea":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__kzxx_name_textarea","ssxx_list":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__ssxx_list","ssxx_item":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__ssxx_item","ssxx_label":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__ssxx_label","ssxx_name":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__ssxx_name","bz_item":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__bz_item","bz_img":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__bz_img","ml_10":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__ml_10","ml_20":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__ml_20","mt_30":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__mt_30","_bg":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index___bg","p_sw_big":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__p_sw_big","p_sw_big_mt_30":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__p_sw_big_mt_30","text_title":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__text_title","jfxx_label":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__jfxx_label","ejxybd_label1":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__ejxybd_label1","ejxybd_label2":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__ejxybd_label2","singelWarp":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__singelWarp","singelWarp_label":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__singelWarp_label","singelWarp_Words":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__singelWarp_Words","ItemWarp":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__ItemWarp","itemWarp_label":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__itemWarp_label","itemWarp_Words":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__itemWarp_Words","bottom_png":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__bottom_png","bottom_pngItem":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__bottom_pngItem","jxfz_item":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__jxfz_item","jxfz_label":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__jxfz_label","jxfz_name":"app__css__app-pages-SelfHelp-Bdd-pages-gznyzyxy-print-__index__jxfz_name"};

/***/ }),

/***/ 1557:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"app__css__app-pages-SelfHelp-Bdd-pages-other-index-__index__title","jbxx_icon":"app__css__app-pages-SelfHelp-Bdd-pages-other-index-__index__jbxx_icon","jbxx_item":"app__css__app-pages-SelfHelp-Bdd-pages-other-index-__index__jbxx_item","item-label":"app__css__app-pages-SelfHelp-Bdd-pages-other-index-__index__item-label","item-name":"app__css__app-pages-SelfHelp-Bdd-pages-other-index-__index__item-name","ssxx_list":"app__css__app-pages-SelfHelp-Bdd-pages-other-index-__index__ssxx_list","ssxx_item":"app__css__app-pages-SelfHelp-Bdd-pages-other-index-__index__ssxx_item","ssxx_label":"app__css__app-pages-SelfHelp-Bdd-pages-other-index-__index__ssxx_label","ssxx_name":"app__css__app-pages-SelfHelp-Bdd-pages-other-index-__index__ssxx_name","bz-item":"app__css__app-pages-SelfHelp-Bdd-pages-other-index-__index__bz-item","bz-img":"app__css__app-pages-SelfHelp-Bdd-pages-other-index-__index__bz-img"};

/***/ }),

/***/ 1558:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__title","jbxx_icon":"app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__jbxx_icon","jbxx_item":"app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__jbxx_item","item-label":"app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__item-label","item-name":"app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__item-name","ssxx_list":"app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__ssxx_list","ssxx_item":"app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__ssxx_item","ssxx_label":"app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__ssxx_label","ssxx_name":"app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__ssxx_name","bz-item":"app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__bz-item","bz-img":"app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__bz-img"};

/***/ }),

/***/ 1559:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-index-__index__title","jbxx_icon":"app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-index-__index__jbxx_icon","jbxx_item":"app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-index-__index__jbxx_item","item-label":"app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-index-__index__item-label","item-name":"app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-index-__index__item-name","ssxx_list":"app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-index-__index__ssxx_list","ssxx_item":"app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-index-__index__ssxx_item","ssxx_label":"app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-index-__index__ssxx_label","ssxx_name":"app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-index-__index__ssxx_name","bz-item":"app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-index-__index__bz-item","bz-img":"app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-index-__index__bz-img"};

/***/ }),

/***/ 1560:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__title","jbxx_icon":"app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__jbxx_icon","jbxx_item":"app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__jbxx_item","item-label":"app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__item-label","item-name":"app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__item-name","ssxx_list":"app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__ssxx_list","ssxx_item":"app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__ssxx_item","ssxx_label":"app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__ssxx_label","ssxx_name":"app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__ssxx_name","bz-item":"app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__bz-item","bz-img":"app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__bz-img"};

/***/ }),

/***/ 1561:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1562:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"app__css__app-pages-SelfHelp-Bdd-pages-zszyjsxy-print-__index__title","jbxx_icon":"app__css__app-pages-SelfHelp-Bdd-pages-zszyjsxy-print-__index__jbxx_icon","jbxx_item":"app__css__app-pages-SelfHelp-Bdd-pages-zszyjsxy-print-__index__jbxx_item","item-label":"app__css__app-pages-SelfHelp-Bdd-pages-zszyjsxy-print-__index__item-label","item-name":"app__css__app-pages-SelfHelp-Bdd-pages-zszyjsxy-print-__index__item-name","ssxx_list":"app__css__app-pages-SelfHelp-Bdd-pages-zszyjsxy-print-__index__ssxx_list","ssxx_item":"app__css__app-pages-SelfHelp-Bdd-pages-zszyjsxy-print-__index__ssxx_item","ssxx_label":"app__css__app-pages-SelfHelp-Bdd-pages-zszyjsxy-print-__index__ssxx_label","ssxx_name":"app__css__app-pages-SelfHelp-Bdd-pages-zszyjsxy-print-__index__ssxx_name","bz-item":"app__css__app-pages-SelfHelp-Bdd-pages-zszyjsxy-print-__index__bz-item","bz-img":"app__css__app-pages-SelfHelp-Bdd-pages-zszyjsxy-print-__index__bz-img"};

/***/ }),

/***/ 1563:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tab_box":"app__css__app-pages-SelfHelp-allotDormitory-__index__tab_box","tip":"app__css__app-pages-SelfHelp-allotDormitory-__index__tip","item":"app__css__app-pages-SelfHelp-allotDormitory-__index__item","item_con":"app__css__app-pages-SelfHelp-allotDormitory-__index__item_con","round":"app__css__app-pages-SelfHelp-allotDormitory-__index__round","select_box":"app__css__app-pages-SelfHelp-allotDormitory-__index__select_box","select_list":"app__css__app-pages-SelfHelp-allotDormitory-__index__select_list","select_item":"app__css__app-pages-SelfHelp-allotDormitory-__index__select_item","select_item_b":"app__css__app-pages-SelfHelp-allotDormitory-__index__select_item_b","select_item_y":"app__css__app-pages-SelfHelp-allotDormitory-__index__select_item_y","item_btn_box":"app__css__app-pages-SelfHelp-allotDormitory-__index__item_btn_box","item_btn":"app__css__app-pages-SelfHelp-allotDormitory-__index__item_btn","modal_box":"app__css__app-pages-SelfHelp-allotDormitory-__index__modal_box","modal_list":"app__css__app-pages-SelfHelp-allotDormitory-__index__modal_list"};

/***/ }),

/***/ 1564:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"page_buy":"app__css__app-pages-SelfHelp-buy-__index__page_buy","step-input":"app__css__app-pages-SelfHelp-buy-__index__step-input","btn_icon":"app__css__app-pages-SelfHelp-buy-__index__btn_icon"};

/***/ }),

/***/ 1565:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"page_buy":"app__css__app-pages-SelfHelp-buyFa-__index__page_buy","step-input":"app__css__app-pages-SelfHelp-buyFa-__index__step-input","btn_icon":"app__css__app-pages-SelfHelp-buyFa-__index__btn_icon"};

/***/ }),

/***/ 1566:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"progress":"app__css__app-pages-SelfHelp-carePackage-__index__progress","jbxx_icon":"app__css__app-pages-SelfHelp-carePackage-__index__jbxx_icon","upload-box":"app__css__app-pages-SelfHelp-carePackage-__index__upload-box","upload-title":"app__css__app-pages-SelfHelp-carePackage-__index__upload-title","jbxx_item":"app__css__app-pages-SelfHelp-carePackage-__index__jbxx_item","jbxx_item2":"app__css__app-pages-SelfHelp-carePackage-__index__jbxx_item2","item-label":"app__css__app-pages-SelfHelp-carePackage-__index__item-label","item-name":"app__css__app-pages-SelfHelp-carePackage-__index__item-name","kzxx_list":"app__css__app-pages-SelfHelp-carePackage-__index__kzxx_list","kzxx_item":"app__css__app-pages-SelfHelp-carePackage-__index__kzxx_item","kzxx_label":"app__css__app-pages-SelfHelp-carePackage-__index__kzxx_label","kzxx_name":"app__css__app-pages-SelfHelp-carePackage-__index__kzxx_name","kzxx_item_textarea":"app__css__app-pages-SelfHelp-carePackage-__index__kzxx_item_textarea","kzxx_name_textarea":"app__css__app-pages-SelfHelp-carePackage-__index__kzxx_name_textarea","btn_add":"app__css__app-pages-SelfHelp-carePackage-__index__btn_add","title_top":"app__css__app-pages-SelfHelp-carePackage-__index__title_top","title_top_name":"app__css__app-pages-SelfHelp-carePackage-__index__title_top_name","line":"app__css__app-pages-SelfHelp-carePackage-__index__line","detail_adrress":"app__css__app-pages-SelfHelp-carePackage-__index__detail_adrress"};

/***/ }),

/***/ 1567:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tab_box":"app__css__app-pages-SelfHelp-checkDormitory-__index__tab_box","tip":"app__css__app-pages-SelfHelp-checkDormitory-__index__tip","item":"app__css__app-pages-SelfHelp-checkDormitory-__index__item","item_con":"app__css__app-pages-SelfHelp-checkDormitory-__index__item_con","round":"app__css__app-pages-SelfHelp-checkDormitory-__index__round","select_box":"app__css__app-pages-SelfHelp-checkDormitory-__index__select_box","select_list":"app__css__app-pages-SelfHelp-checkDormitory-__index__select_list","select_item":"app__css__app-pages-SelfHelp-checkDormitory-__index__select_item","select_item_b":"app__css__app-pages-SelfHelp-checkDormitory-__index__select_item_b","select_item_y":"app__css__app-pages-SelfHelp-checkDormitory-__index__select_item_y","item_btn_box":"app__css__app-pages-SelfHelp-checkDormitory-__index__item_btn_box","item_btn":"app__css__app-pages-SelfHelp-checkDormitory-__index__item_btn","modal_box":"app__css__app-pages-SelfHelp-checkDormitory-__index__modal_box","modal_list":"app__css__app-pages-SelfHelp-checkDormitory-__index__modal_list"};

/***/ }),

/***/ 1568:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"page_buy":"app__css__app-pages-SelfHelp-choosePhoneNum-__index__page_buy","step-input":"app__css__app-pages-SelfHelp-choosePhoneNum-__index__step-input","btn_icon":"app__css__app-pages-SelfHelp-choosePhoneNum-__index__btn_icon"};

/***/ }),

/***/ 1569:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"page_buy":"app__css__app-pages-SelfHelp-education-__index__page_buy"};

/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getSize = function getSize() {
	var windowW = void 0,
	    windowH = void 0,
	    contentH = void 0,
	    contentW = void 0,
	    scrollT = void 0;
	windowH = window.innerHeight;
	windowW = window.innerWidth;
	scrollT = document.documentElement.scrollTop || document.body.scrollTop;
	contentH = document.documentElement.scrollHeight > document.body.scrollHeight ? document.documentElement.scrollHeight : document.body.scrollHeight;
	contentW = document.documentElement.scrollWidth > document.body.scrollWidth ? document.documentElement.scrollWidth : document.body.scrollWidth;
	return { windowW: windowW, windowH: windowH, contentH: contentH, contentW: contentW, scrollT: scrollT };
};

/* harmony default export */ __webpack_exports__["a"] = (getSize);

/***/ }),

/***/ 1570:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"page_buy":"app__css__app-pages-SelfHelp-examination-__index__page_buy","page_pay":"app__css__app-pages-SelfHelp-examination-__index__page_pay"};

/***/ }),

/***/ 1571:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"page_pay":"app__css__app-pages-SelfHelp-payFxxy-__index__page_pay"};

/***/ }),

/***/ 1572:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"app__css__app-pages-SelfHelp-print-__index__title","jbxx_icon":"app__css__app-pages-SelfHelp-print-__index__jbxx_icon","jbxx_item":"app__css__app-pages-SelfHelp-print-__index__jbxx_item","item-label":"app__css__app-pages-SelfHelp-print-__index__item-label","item-name":"app__css__app-pages-SelfHelp-print-__index__item-name","ssxx_list":"app__css__app-pages-SelfHelp-print-__index__ssxx_list","ssxx_item":"app__css__app-pages-SelfHelp-print-__index__ssxx_item","ssxx_label":"app__css__app-pages-SelfHelp-print-__index__ssxx_label","ssxx_name":"app__css__app-pages-SelfHelp-print-__index__ssxx_name","bz-item":"app__css__app-pages-SelfHelp-print-__index__bz-item","bz-img":"app__css__app-pages-SelfHelp-print-__index__bz-img"};

/***/ }),

/***/ 1573:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"app__css__app-pages-SelfHelp-print-__print__title","jbxx_icon":"app__css__app-pages-SelfHelp-print-__print__jbxx_icon","jbxx_item":"app__css__app-pages-SelfHelp-print-__print__jbxx_item","item-label":"app__css__app-pages-SelfHelp-print-__print__item-label","item-name":"app__css__app-pages-SelfHelp-print-__print__item-name","ssxx_list":"app__css__app-pages-SelfHelp-print-__print__ssxx_list","ssxx_item":"app__css__app-pages-SelfHelp-print-__print__ssxx_item","ssxx_label":"app__css__app-pages-SelfHelp-print-__print__ssxx_label","ssxx_name":"app__css__app-pages-SelfHelp-print-__print__ssxx_name","bz-item":"app__css__app-pages-SelfHelp-print-__print__bz-item","bz-img":"app__css__app-pages-SelfHelp-print-__print__bz-img"};

/***/ }),

/***/ 1574:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"page_pay":"app__css__app-pages-SelfHelp-route-__index__page_pay"};

/***/ }),

/***/ 1575:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"page_pay":"app__css__app-pages-SelfHelp-sszyssfpay-__index__page_pay"};

/***/ }),

/***/ 1576:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"page_pay":"app__css__app-pages-SelfHelp-sszyxfpay-__index__page_pay"};

/***/ }),

/***/ 1577:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"banner":"app__css__app-pages-dormInfo-__index__banner","con_r":"app__css__app-pages-dormInfo-__index__con_r","top":"app__css__app-pages-dormInfo-__index__top","title":"app__css__app-pages-dormInfo-__index__title","sub":"app__css__app-pages-dormInfo-__index__sub","con":"app__css__app-pages-dormInfo-__index__con"};

/***/ }),

/***/ 1578:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"banner":"app__css__app-pages-link-__index__banner","con_r":"app__css__app-pages-link-__index__con_r","top":"app__css__app-pages-link-__index__top","title":"app__css__app-pages-link-__index__title","sub":"app__css__app-pages-link-__index__sub","con":"app__css__app-pages-link-__index__con"};

/***/ }),

/***/ 1579:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"banner":"app__css__app-pages-notice-index-__index__banner","con_r":"app__css__app-pages-notice-index-__index__con_r","item":"app__css__app-pages-notice-index-__index__item","time":"app__css__app-pages-notice-index-__index__time"};

/***/ }),

/***/ 1580:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"banner":"app__css__app-pages-notice-noticeDetail-__index__banner","con_r":"app__css__app-pages-notice-noticeDetail-__index__con_r","top":"app__css__app-pages-notice-noticeDetail-__index__top","title":"app__css__app-pages-notice-noticeDetail-__index__title","sub":"app__css__app-pages-notice-noticeDetail-__index__sub","con":"app__css__app-pages-notice-noticeDetail-__index__con"};

/***/ }),

/***/ 1581:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"qaa":"app__css__app-pages-onlineQAndA-index-__index__qaa","bread":"app__css__app-pages-onlineQAndA-index-__index__bread","con":"app__css__app-pages-onlineQAndA-index-__index__con","text-sub":"app__css__app-pages-onlineQAndA-index-__index__text-sub","label":"app__css__app-pages-onlineQAndA-index-__index__label","search_box":"app__css__app-pages-onlineQAndA-index-__index__search_box","tab_list":"app__css__app-pages-onlineQAndA-index-__index__tab_list","tab_item":"app__css__app-pages-onlineQAndA-index-__index__tab_item","list":"app__css__app-pages-onlineQAndA-index-__index__list","item":"app__css__app-pages-onlineQAndA-index-__index__item","wt":"app__css__app-pages-onlineQAndA-index-__index__wt","time":"app__css__app-pages-onlineQAndA-index-__index__time","time_2":"app__css__app-pages-onlineQAndA-index-__index__time_2","nr":"app__css__app-pages-onlineQAndA-index-__index__nr","zan":"app__css__app-pages-onlineQAndA-index-__index__zan","page_box":"app__css__app-pages-onlineQAndA-index-__index__page_box","tw_btn":"app__css__app-pages-onlineQAndA-index-__index__tw_btn","tw_box":"app__css__app-pages-onlineQAndA-index-__index__tw_box","tw_box_top":"app__css__app-pages-onlineQAndA-index-__index__tw_box_top","empty":"app__css__app-pages-onlineQAndA-index-__index__empty"};

/***/ }),

/***/ 1582:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"banner":"app__css__app-pages-provinceInfo-__index__banner","con_r":"app__css__app-pages-provinceInfo-__index__con_r","top":"app__css__app-pages-provinceInfo-__index__top","title":"app__css__app-pages-provinceInfo-__index__title","sub":"app__css__app-pages-provinceInfo-__index__sub","con":"app__css__app-pages-provinceInfo-__index__con"};

/***/ }),

/***/ 1583:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"body":"app__css__app-pages-viewVideo-myVideo-__index__body","left_nav":"app__css__app-pages-viewVideo-myVideo-__index__left_nav","head":"app__css__app-pages-viewVideo-myVideo-__index__head","head_title":"app__css__app-pages-viewVideo-myVideo-__index__head_title","content":"app__css__app-pages-viewVideo-myVideo-__index__content","right_content":"app__css__app-pages-viewVideo-myVideo-__index__right_content","boxTitle":"app__css__app-pages-viewVideo-myVideo-__index__boxTitle","right_tip":"app__css__app-pages-viewVideo-myVideo-__index__right_tip","video_display":"app__css__app-pages-viewVideo-myVideo-__index__video_display","video_display_div":"app__css__app-pages-viewVideo-myVideo-__index__video_display_div","video_title":"app__css__app-pages-viewVideo-myVideo-__index__video_title","right_pagination":"app__css__app-pages-viewVideo-myVideo-__index__right_pagination","right_pageTip":"app__css__app-pages-viewVideo-myVideo-__index__right_pageTip","right_pagenation_page":"app__css__app-pages-viewVideo-myVideo-__index__right_pagenation_page","video_explain":"app__css__app-pages-viewVideo-myVideo-__index__video_explain"};

/***/ }),

/***/ 1584:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"top":"app__css__plugins-header-__index__top","top_con":"app__css__plugins-header-__index__top_con","list":"app__css__plugins-header-__index__list","item":"app__css__plugins-header-__index__item","banner":"app__css__plugins-header-__index__banner"};

/***/ }),

/***/ 1585:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _Breadcrumb; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_breadcrumb_style__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_breadcrumb__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_history_createHashHistory__);









var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }






var hashHistory = __WEBPACK_IMPORTED_MODULE_11_history_createHashHistory___default()();

var _Breadcrumb = (_temp = _class = function (_React$Component) {
    _inherits(_Breadcrumb, _React$Component);

    function _Breadcrumb() {
        _classCallCheck(this, _Breadcrumb);

        return _possibleConstructorReturn(this, (_Breadcrumb.__proto__ || __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default()(_Breadcrumb)).apply(this, arguments));
    }

    _createClass(_Breadcrumb, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                list = _props.list,
                noLine = _props.noLine;


            return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                'div',
                {
                    className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('Breadcrumb', className, {
                        Breadcrumb_noLine: noLine
                    })
                },
                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                    'div',
                    { className: 'Breadcrumb_l' },
                    '\u5F53\u524D\u4F4D\u7F6E\uFF1A'
                ),
                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_breadcrumb___default.a,
                    { separator: '>' },
                    list && list[0] && list.map(function (elem, index) {
                        if (elem.url) {
                            var param = '';
                            var value = elem.value;
                            if (value) {
                                var _iteratorNormalCompletion = true;
                                var _didIteratorError = false;
                                var _iteratorError = undefined;

                                try {
                                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(value)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                        var key = _step.value;

                                        param += '&' + key + '=' + value[key];
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return) {
                                            _iterator.return();
                                        }
                                    } finally {
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                            return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_4_antd_lib_breadcrumb___default.a.Item,
                                { key: index },
                                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                    'a',
                                    { onClick: function onClick() {
                                            hashHistory.push({
                                                pathname: elem.url,
                                                search: param
                                            });
                                        } },
                                    elem.name
                                )
                            );
                        } else {
                            return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_4_antd_lib_breadcrumb___default.a.Item,
                                { key: index },
                                elem.name
                            );
                        }
                    })
                )
            );
        }
    }]);

    return _Breadcrumb;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component), _class.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string,
    list: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.array
}, _temp);



/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NHInputRender */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_number_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_time_picker_style__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_time_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_time_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_time_picker__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_time_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_time_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_json_stringify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_switch_style__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_switch__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_date_picker_style__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_date_picker__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_radio_style__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_radio__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_input_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_input__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__input_const__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__style_css__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__utils_createUuid__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__NHMultiSelect_index__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__NHUpload_index__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__NHImage_index__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__OldNHUpload_index__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__NHSelect_index__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__NHCascader_index__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_antd_lib_date_picker_locale_zh_CN__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_antd_lib_date_picker_locale_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_antd_lib_date_picker_locale_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_moment_locale_zh_cn__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_moment_locale_zh_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_moment_locale_zh_cn__);






























var _extends = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }

















if (false) {
    module.hot.accept("./style.css", function () {
        require("./style.css");
    });
}

var TextArea = __WEBPACK_IMPORTED_MODULE_28_antd_lib_input___default.a.TextArea;

var RadioGroup = __WEBPACK_IMPORTED_MODULE_26_antd_lib_radio___default.a.Group;
var FormItem = __WEBPACK_IMPORTED_MODULE_24_antd_lib_form___default.a.Item;
var RangePicker = __WEBPACK_IMPORTED_MODULE_22_antd_lib_date_picker___default.a.RangePicker,
    MonthPicker = __WEBPACK_IMPORTED_MODULE_22_antd_lib_date_picker___default.a.MonthPicker;

/**
 * 输入控件渲染器
 * 根据属性参数、可以渲染成普通输入控件或封装成FormItem类型输入控件配合表单校验
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-02-05 14:35:56
 * Version: 1.0
 * Modify log:
 * 2018-03-29: 1、增加readOnly属性，控制是否可编辑；
 * 2018-05-28: 1、修改:readOnly属性更为为是否是阅读模式；2、新增disabled属性，控制是否可编辑；
 * 2018-08-07: 1、增加文件上传控件类型，支持图片、文件两种类型的上传；
 * 2019-03-21: 1、修改：NHInputRender可做为受控组件使用，也可以直接渲染成表单项
 * 2019-04-09  1、增加日期控件
 * 2019-04-11  1、增加日期范围控件、增加文件上传控件
 * 2019-04-22  1、增加多选下拉框、级联下拉框、时间选择框，修改单选框配置，增加可以设置服务前缀baseUrl
 * 2019-10-30: 1、修复switch控件设置初始值无效问题；2、修复渲染成表单控件时，label为空，必填项没有显示*号标记问题
 * 2019-10-31: 1、表单项增加colon属性支持、增加hideLabel属性支持
 */

var NHInputRender = (_temp = _class = function (_React$Component) {
    _inherits(NHInputRender, _React$Component);

    function NHInputRender(props) {
        _classCallCheck(this, NHInputRender);

        var _this = _possibleConstructorReturn(this, (NHInputRender.__proto__ || __WEBPACK_IMPORTED_MODULE_20_babel_runtime_core_js_object_get_prototype_of___default()(NHInputRender)).call(this, props));

        _initialiseProps.call(_this);

        var value = props.value || '';

        _this.state = {
            value: value,
            feature: '',
            featureParams: {},
            loading: false,
            uploadFile: {},
            uploadFileList: []
        };
        return _this;
    }

    _createClass(NHInputRender, [{
        key: "componentWillMount",
        value: function componentWillMount() {
            var feature = this.props.feature;

            if (feature) {
                try {
                    //解析参数，如果不是正确的json格式，会抛出异常提示
                    var featureParams = JSON.parse(feature);
                    this.setState({ feature: feature, featureParams: featureParams });
                } catch (e) {
                    __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.error('解析控件配置参数出错！');
                }
            }
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            var featureParams = this.state.featureParams;
            // if (InputType.UPLOAD == featureParams.type) {
            //   let { id, value } = this.props;
            //   let { uploadFile } = this.state;
            //   uploadFile[id] = value;
            //   this.setState({
            //     uploadFile: uploadFile
            //   });

            //   if (this.props.form) {
            //     let ids = 'FILE_DOC_UUID' + id;
            //     let fieldsObj = {};
            //     let valueObj = {};
            //     valueObj.value = value || '';
            //     fieldsObj[id] = valueObj;
            //     this.props.form.setFieldsValue(fieldsObj);

            //     let fieldsObj2 = {};
            //     fieldsObj2[ids] = value || '';
            //     this.props.form.setFieldsValue(fieldsObj2);

            //     //附件类型
            //     if (featureParams.fileType === 'file') {
            //       if (value) {
            //         let fileJsonObject = JSON.parse(value);
            //         let valueObj = {};
            //         valueObj.value = value || '';
            //         fieldsObj[id] = valueObj;
            //         this.props.form.setFieldsValue(fieldsObj);

            //         let objArr = [];
            //         fileJsonObject.map((file, index) => {
            //           let obj = {};
            //           obj.key = index;
            //           obj.uid = createUuid();
            //           obj.name = file.name;
            //           obj.status = 'done';
            //           obj.response = '';
            //           obj.url = '/anonymity/docrepo/download/file?attachmentId=' + file.value;
            //           obj.docUUID = file.value;
            //           objArr.push(obj);
            //         });

            //         this.setState({
            //           uploadFileList: objArr
            //         })
            //       }
            //     }
            //   }
            // }
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {

            var feature = nextProps.feature;
            try {
                //解析参数，如果不是正确的json格式，会抛出异常提示
                var featureParams = JSON.parse(feature);
                this.setState({ feature: feature, featureParams: featureParams });
            } catch (e) {
                __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.error('解析控件配置参数出错！');
            }
            // Should be a controlled component.
            if ('value' in nextProps) {
                var value = nextProps.value;
                this.setState({ value: value });
            }
        }

        //提供组件的onChange方法


        //渲染成表单项


        //渲染单行输入控件类型


        //渲染多行输入控件类型


        //渲染单选框控件类型


        //渲染下拉选择器输入控件类型


        //渲染开关选择器输入控件类型


        //文件上传之前执行的方法(可以限制上传文件的格式，类型，大小等)


        //文件上传中、完成、失败都会执行的方法


        //渲染文件上传控件


        //移除文件执行的方法


        //渲染文件上传控件

        // 渲染日期控件

        // 渲染日期时间控件

        // 渲染日期范围控件


        //渲染月份选择器


        //渲染多选下拉选择器输入控件类型


        //渲染级联下拉选择器输入控件类型


        //渲染数字输入框控件类型

    }, {
        key: "render",
        value: function render() {

            var feature = this.state.feature;
            var featureParams = this.state.featureParams;
            var fileType = featureParams.fileType;
            //初步验证参数
            if (feature === undefined || feature === null || feature == '') {
                return null;
            }

            switch (featureParams.type) {
                case __WEBPACK_IMPORTED_MODULE_30__input_const__["a" /* InputType */].INPUT:
                    return this.renderInput(); //单行输入控件类型
                    break;
                case __WEBPACK_IMPORTED_MODULE_30__input_const__["a" /* InputType */].TEXTAREA:
                    return this.renderTextArea(); //多行输入控件类型
                    break;
                case __WEBPACK_IMPORTED_MODULE_30__input_const__["a" /* InputType */].RADIO:
                    return this.renderRadio(); //单选框控件类型
                    break;
                case __WEBPACK_IMPORTED_MODULE_30__input_const__["a" /* InputType */].SELECT:
                    return this.renderSelect(); //下拉选择器输入控件类型
                    break;
                case __WEBPACK_IMPORTED_MODULE_30__input_const__["a" /* InputType */].SWITCH:
                    return this.renderSwitch(); //开关输入控件类型
                    break;
                case __WEBPACK_IMPORTED_MODULE_30__input_const__["a" /* InputType */].UPLOAD:
                    // return fileType === 'image' ? this.renderImageUpload() : this.renderFileUpload(); //文件上传控件类型
                    return this.renderUpload();
                    break;
                case __WEBPACK_IMPORTED_MODULE_30__input_const__["a" /* InputType */].DATEPICKER:
                    return this.renderDatePicker(); // 日期控件
                    break;
                case __WEBPACK_IMPORTED_MODULE_30__input_const__["a" /* InputType */].RANGEPICKER:
                    return this.renderRangePicker(); // 日期范围控件
                    break;
                case __WEBPACK_IMPORTED_MODULE_30__input_const__["a" /* InputType */].TIMEPICKER:
                    return this.renderTimePicker(); // 时间控件
                case __WEBPACK_IMPORTED_MODULE_30__input_const__["a" /* InputType */].MULTISELECT:
                    return this.renderMultiSelect(); // 多选下拉框
                case __WEBPACK_IMPORTED_MODULE_30__input_const__["a" /* InputType */].NHCASCADER:
                    return this.renderNHCascader(); // 级联下拉框
                case __WEBPACK_IMPORTED_MODULE_30__input_const__["a" /* InputType */].DATETIMEPICKER:
                    return this.renderDateTimePicker(); //日期时间下拉框
                case __WEBPACK_IMPORTED_MODULE_30__input_const__["a" /* InputType */].INPUTNUMBER:
                    return this.renderInputNumber(); //数字输入框
                    break;
                case __WEBPACK_IMPORTED_MODULE_30__input_const__["a" /* InputType */].MONTHPICKER:
                    return this.renderMonthPicker(); //月份选择器
                case __WEBPACK_IMPORTED_MODULE_30__input_const__["a" /* InputType */].OLDUPLOAD:
                    return this.renderOldUpload(); //旧版附件上传
            }

            return null;
        }
    }]);

    return NHInputRender;
}(__WEBPACK_IMPORTED_MODULE_29_react___default.a.Component), _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.handleChange = function (e) {
        if (_this2.props.onChange) {
            _this2.props.onChange(e);
        }
    };

    this.renderFormItem = function (_ref) {
        var form = _ref.form,
            _ref$hasFeedback = _ref.hasFeedback,
            hasFeedback = _ref$hasFeedback === undefined ? false : _ref$hasFeedback,
            _ref$patternTag = _ref.patternTag,
            patternTag = _ref$patternTag === undefined ? '' : _ref$patternTag,
            _ref$pDefaultValue = _ref.pDefaultValue,
            pDefaultValue = _ref$pDefaultValue === undefined ? '' : _ref$pDefaultValue,
            _ref$pRequired = _ref.pRequired,
            pRequired = _ref$pRequired === undefined ? false : _ref$pRequired,
            component = _ref.component;
        var getFieldDecorator = form.getFieldDecorator;
        var _props = _this2.props,
            formLayout = _props.formLayout,
            formItemLayout = _props.formItemLayout,
            id = _props.id,
            value = _props.value,
            _props$label = _props.label,
            label = _props$label === undefined ? '' : _props$label,
            hideLabel = _props.hideLabel,
            colon = _props.colon,
            defaultValue = _props.defaultValue,
            required = _props.required,
            readOnly = _props.readOnly,
            format = _props.format;

        var featureParams = _this2.state.featureParams;
        var validationValueType = featureParams.validationValueType ? featureParams.validationValueType : 'string';
        var requiredRule = {};
        var fileType = _this2.state.featureParams.fileType;
        //构建必填校验规则
        if (required) {
            requiredRule.required = true;
            requiredRule.message = label + '不可为空';
            // 如果label为空，且为必填项，则显示*号，但不显示冒号
            if (label == '' || hideLabel) {
                label = '';
                colon = false;
            }
        } else {
            if (pRequired) {
                required = pRequired;
                requiredRule.required = true;
                requiredRule.message = label + '不可为空';
                // 如果label为空，且为必填项，则显示*号，但不显示冒号
                if (label == '' || hideLabel) {
                    label = '';
                    colon = false;
                }
            } else {
                if (hideLabel) {
                    label = '';
                    colon = false;
                }
            }
        }

        //处理特殊组件在封装成表单项时的“值”属性名称
        var inputType = featureParams.type;
        var valuePropName = 'value';
        var initialValue = void 0;
        initialValue = !value ? !defaultValue ? pDefaultValue : defaultValue : value;
        if (__WEBPACK_IMPORTED_MODULE_30__input_const__["a" /* InputType */].SWITCH == inputType) {
            valuePropName = 'checked';
            if (value) {
                initialValue = value == 'true' ? true : false;
            } else if (typeof defaultValue == 'boolean') {

                initialValue = defaultValue;
            } else if (typeof defaultValue == 'string') {

                initialValue = defaultValue == 'true' ? true : false;
            } else if (typeof pDefaultValue == 'boolean') {

                initialValue = pDefaultValue;
            } else if (typeof pDefaultValue == 'string') {

                initialValue = pDefaultValue == 'true' ? true : false;
            } else {
                initialValue = false;
            }
        }
        if (__WEBPACK_IMPORTED_MODULE_30__input_const__["a" /* InputType */].DATEPICKER == inputType || __WEBPACK_IMPORTED_MODULE_30__input_const__["a" /* InputType */].TIMEPICKER == inputType || __WEBPACK_IMPORTED_MODULE_30__input_const__["a" /* InputType */].DATETIMEPICKER == inputType || __WEBPACK_IMPORTED_MODULE_30__input_const__["a" /* InputType */].MONTHPICKER == inputType || __WEBPACK_IMPORTED_MODULE_30__input_const__["a" /* InputType */].RANGEPICKER == inputType) {
            if (initialValue && !__WEBPACK_IMPORTED_MODULE_40_moment___default.a.isMoment(initialValue)) {
                initialValue = __WEBPACK_IMPORTED_MODULE_40_moment___default()(initialValue, format);
            } else {}
        }
        // console.log(inputType,initialValue,this.props.value)
        //处理布局，只有水平布局时才应用表单项布局
        formItemLayout = formLayout == 'horizontal' ? formItemLayout : null;
        if (patternTag != '') {
            return fileType === 'file' ? __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                FormItem,
                _extends({}, formItemLayout, {
                    label: label,
                    colon: colon,
                    hasFeedback: hasFeedback
                }),
                getFieldDecorator(id, {
                    valuePropName: valuePropName,
                    rules: [_extends({}, requiredRule), _extends({}, __WEBPACK_IMPORTED_MODULE_30__input_const__["b" /* RegularExpression */][patternTag].rule)],
                    initialValue: _this2.props.value
                })(component)
            ) : readOnly ? __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                FormItem,
                _extends({}, formItemLayout, {
                    label: label,
                    colon: colon
                }),
                __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                    "span",
                    null,
                    initialValue
                )
            ) : __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                FormItem,
                _extends({}, formItemLayout, {
                    label: label,
                    colon: colon,
                    hasFeedback: hasFeedback
                }),
                getFieldDecorator(id, {
                    valuePropName: valuePropName,
                    rules: [_extends({}, requiredRule), _extends({}, __WEBPACK_IMPORTED_MODULE_30__input_const__["b" /* RegularExpression */][patternTag].rule)],
                    initialValue: initialValue
                })(component)
            );
        } else if (required) {
            return fileType === 'file' ? __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                FormItem,
                _extends({}, formItemLayout, {
                    label: label,
                    colon: colon,
                    hasFeedback: hasFeedback
                }),
                getFieldDecorator(id, {
                    valuePropName: valuePropName,
                    rules: [_extends({}, requiredRule)],
                    initialValue: _this2.props.value
                })(component)
            ) : readOnly ? __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                FormItem,
                _extends({}, formItemLayout, {
                    label: label,
                    colon: colon
                }),
                __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                    "span",
                    null,
                    initialValue
                )
            ) : __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                FormItem,
                _extends({}, formItemLayout, {
                    label: label,
                    colon: colon,
                    hasFeedback: hasFeedback
                }),
                getFieldDecorator(id, {
                    valuePropName: valuePropName,
                    rules: [_extends({}, requiredRule)],
                    initialValue: initialValue
                })(component)
            );
        } else {
            return fileType === 'file' ? __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                FormItem,
                _extends({}, formItemLayout, {
                    label: label,
                    colon: colon,
                    hasFeedback: hasFeedback
                }),
                getFieldDecorator(id, {
                    valuePropName: valuePropName,
                    initialValue: _this2.props.value
                })(component)
            ) : readOnly ? __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                FormItem,
                _extends({}, formItemLayout, {
                    label: label,
                    colon: colon
                }),
                __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                    "span",
                    null,
                    initialValue
                )
            ) : __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                FormItem,
                _extends({}, formItemLayout, {
                    label: label,
                    colon: colon,
                    hasFeedback: hasFeedback
                }),
                getFieldDecorator(id, {
                    valuePropName: valuePropName,
                    initialValue: initialValue
                })(component)
            );
        }
    };

    this.renderInput = function () {
        var _props2 = _this2.props,
            form = _props2.form,
            id = _props2.id,
            value = _props2.value,
            disabled = _props2.disabled,
            _onChange = _props2.onChange;
        var _state$featureParams = _this2.state.featureParams,
            widthType = _state$featureParams.widthType,
            widthStr = _state$featureParams.widthStr,
            patternTag = _state$featureParams.patternTag,
            placeholder = _state$featureParams.placeholder,
            required = _state$featureParams.required,
            defaultValue = _state$featureParams.defaultValue;


        var inputComponent = null;
        var otherParams = {}; //动态参数

        //如果是表单项类型，则将id,value,defaultValue交由FormItem处理
        if (!form && id !== undefined && id != '') {
            otherParams.id = id;
        }
        if (!form && value) {
            otherParams.value = _this2.state.value;
        }
        if (!form && defaultValue !== undefined && defaultValue != '') {
            otherParams.defaultValue = defaultValue;
        }

        if (widthType != __WEBPACK_IMPORTED_MODULE_30__input_const__["c" /* WidthType */].DEFAULT) {
            inputComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_input___default.a, _extends({}, otherParams, {
                disabled: disabled,
                placeholder: placeholder,
                style: { width: widthStr },
                onChange: function onChange(e) {

                    if (!('value' in _this2.props)) {
                        _this2.setState({ value: e.target.value });
                    }

                    if (typeof _onChange == 'function') {
                        _onChange(e.target.value, e.target.value);
                    }
                }
            }));
        } else {
            inputComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_input___default.a, _extends({}, otherParams, {
                disabled: disabled,
                placeholder: placeholder,
                onChange: function onChange(e) {

                    if (!('value' in _this2.props)) {
                        _this2.setState({ value: e.target.value });
                    }

                    if (typeof _onChange == 'function') {
                        _onChange(e.target.value, e.target.value);
                    }
                }
            }));
        }

        //是否是表单项
        if (form) {
            return _this2.renderFormItem({
                form: form, hasFeedback: true, patternTag: patternTag, pDefaultValue: defaultValue,
                pRequired: required, component: inputComponent
            });
        }

        return inputComponent;
    };

    this.renderTextArea = function () {
        var _props3 = _this2.props,
            form = _props3.form,
            id = _props3.id,
            value = _props3.value,
            disabled = _props3.disabled,
            _onChange2 = _props3.onChange,
            _props3$isEdit = _props3.isEdit,
            isEdit = _props3$isEdit === undefined ? true : _props3$isEdit;
        var _state$featureParams2 = _this2.state.featureParams,
            widthType = _state$featureParams2.widthType,
            widthStr = _state$featureParams2.widthStr,
            patternTag = _state$featureParams2.patternTag,
            placeholder = _state$featureParams2.placeholder,
            required = _state$featureParams2.required,
            defaultValue = _state$featureParams2.defaultValue,
            minRows = _state$featureParams2.minRows,
            maxRows = _state$featureParams2.maxRows,
            maxLength = _state$featureParams2.maxLength;

        var textareaComponent = null;
        var otherParams = {}; //其他参数

        if (!form && id !== undefined && id != '') {
            otherParams.id = id;
        }
        if (!form && value) {
            otherParams.value = _this2.state.value;
        }
        if (!form && defaultValue !== undefined && defaultValue != '') {
            otherParams.defaultValue = defaultValue;
        }

        if (widthType != __WEBPACK_IMPORTED_MODULE_30__input_const__["c" /* WidthType */].DEFAULT) {
            textareaComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(TextArea, _extends({}, otherParams, {
                readOnly: !isEdit,
                disabled: disabled,
                autosize: { minRows: minRows ? minRows : 2, maxRows: maxRows ? maxRows : 6 },
                placeholder: placeholder,
                maxLength: maxLength,
                style: { width: widthStr },
                onChange: function onChange(e) {

                    if (!('value' in _this2.props)) {
                        _this2.setState({ value: e.target.value });
                    }

                    if (typeof _onChange2 == 'function') {
                        _onChange2(e.target.value, e.target.value);
                    }
                }
            }));
        } else {
            textareaComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(TextArea, _extends({}, otherParams, {
                readOnly: !isEdit,
                disabled: disabled,
                autosize: { minRows: minRows ? minRows : 2, maxRows: maxRows ? maxRows : 6 },
                placeholder: placeholder,
                maxLength: maxLength,
                onChange: function onChange(e) {

                    if (!('value' in _this2.props)) {
                        _this2.setState({ value: e.target.value });
                    }

                    if (typeof _onChange2 == 'function') {
                        _onChange2(e.target.value, e.target.value);
                    }
                }
            }));
        }

        //是否是表单项
        if (form) {
            return _this2.renderFormItem({
                form: form, hasFeedback: true, patternTag: patternTag, pDefaultValue: defaultValue,
                pRequired: required, component: textareaComponent
            });
        }

        return textareaComponent;
    };

    this.renderRadio = function () {
        var _props4 = _this2.props,
            form = _props4.form,
            id = _props4.id,
            value = _props4.value,
            disabled = _props4.disabled,
            _onChange3 = _props4.onChange;
        var _state$featureParams3 = _this2.state.featureParams,
            options = _state$featureParams3.options,
            required = _state$featureParams3.required,
            defaultValue = _state$featureParams3.defaultValue;


        var otherParams = {}; //其他参数

        if (!form && id !== undefined && id != '') {
            otherParams.name = id;
        }
        if (!form && value) {
            otherParams.value = _this2.state.value;
        }
        if (!form && defaultValue !== undefined && defaultValue != '') {
            otherParams.defaultValue = defaultValue;
        }

        var radioComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(RadioGroup, _extends({}, otherParams, {
            disabled: disabled,
            options: options,
            onChange: function onChange(e) {
                var selectValue = e.target.value;
                if (!('value' in _this2.props)) {
                    _this2.setState({ value: selectValue });
                }

                var selectItem = options.filter(function (item) {

                    return item.value === selectValue;
                })[0];

                if (typeof _onChange3 == 'function') {
                    _onChange3(selectValue, selectItem.label, e);
                }
            }
        }));

        //是否是表单项
        if (form) {
            return _this2.renderFormItem({
                form: form,
                pDefaultValue: defaultValue,
                pRequired: required,
                component: radioComponent
            });
        }

        return radioComponent;
    };

    this.renderSelect = function () {
        var _props5 = _this2.props,
            form = _props5.form,
            id = _props5.id,
            value = _props5.value,
            disabled = _props5.disabled,
            _onChange4 = _props5.onChange,
            parentFieldId = _props5.parentFieldId,
            parentValue = _props5.parentValue;
        var _state$featureParams4 = _this2.state.featureParams,
            widthType = _state$featureParams4.widthType,
            widthStr = _state$featureParams4.widthStr,
            dataTag = _state$featureParams4.dataTag,
            required = _state$featureParams4.required,
            defaultValue = _state$featureParams4.defaultValue,
            baseUrl = _state$featureParams4.baseUrl;

        var selectComponent = null;
        var otherParams = {}; //其他参数

        if (!form && id !== undefined && id != '') {
            otherParams.id = id;
        }
        if (!form && value) {
            otherParams.value = _this2.state.value;
        }
        if (!form && defaultValue !== undefined && defaultValue != '') {
            otherParams.defaultValue = defaultValue;
        }

        if (baseUrl !== null && baseUrl !== undefined && baseUrl !== '') {
            otherParams.baseUrl = baseUrl;
        }

        if (form && 'parentValue' in _this2.props) {
            var getFieldValue = form.getFieldValue;

            otherParams.parentValue = parentValue;
        }

        if (widthType != __WEBPACK_IMPORTED_MODULE_30__input_const__["c" /* WidthType */].DEFAULT) {
            selectComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__NHSelect_index__["a" /* default */], _extends({}, otherParams, {
                disabled: disabled,
                sign: dataTag,
                style: { width: widthStr },
                onChange: function onChange(v, t, p) {
                    if (!('value' in _this2.props)) {
                        _this2.setState({ value: v });
                    }
                    if (typeof _onChange4 == 'function') {
                        _onChange4(v, t, p);
                    }
                }
            }));
        } else {
            selectComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__NHSelect_index__["a" /* default */], _extends({}, otherParams, {
                disabled: disabled,
                sign: dataTag,
                onChange: function onChange(v, t, p) {
                    if (!('value' in _this2.props)) {
                        _this2.setState({ value: v });
                    }
                    if (typeof _onChange4 == 'function') {
                        _onChange4(v, t, p);
                    }
                }
            }));
        }

        //是否是表单项
        if (form) {
            return _this2.renderFormItem({
                form: form,
                pDefaultValue: defaultValue,
                pRequired: required,
                component: selectComponent
            });
        }

        return selectComponent;
    };

    this.renderSwitch = function () {
        var _props6 = _this2.props,
            form = _props6.form,
            id = _props6.id,
            value = _props6.value,
            disabled = _props6.disabled,
            _onChange5 = _props6.onChange;
        var _state$featureParams5 = _this2.state.featureParams,
            checkedText = _state$featureParams5.checkedText,
            uncheckedText = _state$featureParams5.uncheckedText,
            defaultChecked = _state$featureParams5.defaultChecked;


        var switchComponent = null;
        var otherParams = {}; //其他参数

        if (!form && id !== undefined && id != '') {
            otherParams.id = id;
        }
        if (!form && value) {
            otherParams.checked = _this2.state.value == '1' ? true : false;
        }
        if (!form && defaultChecked !== undefined && defaultChecked != '') {
            otherParams.defaultChecked = defaultChecked;
        }

        switchComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_switch___default.a, _extends({}, otherParams, {
            disabled: disabled,
            checkedChildren: checkedText,
            unCheckedChildren: uncheckedText,
            onChange: function onChange(v) {
                if (!('value' in _this2.props)) {
                    _this2.setState({ value: v ? '1' : '0' });
                }
                if (typeof _onChange5 == 'function') {
                    _onChange5(v ? '1' : '0', v ? checkedText ? checkedText : 'true' : uncheckedText ? uncheckedText : 'false');
                }
            }
        }));

        //是否是表单项
        if (form) {
            return _this2.renderFormItem({ form: form, pDefaultValue: defaultChecked, component: switchComponent });
        }

        return switchComponent;
    };

    this.beforeUpload = function (file, size, fileType) {
        var uploadFileList = _this2.state.uploadFileList;
        _this2.setState({
            uploadFileList: [].concat(_toConsumableArray(uploadFileList), [file])
        });
        var fileSuffixName = file.name.substring(file.name.lastIndexOf('.'));
        var isAvailableSuffix = void 0;
        //判断是否支持该文件类型
        if (fileType === 'image') {
            //图片类型
            var availFileSuffix = __WEBPACK_IMPORTED_MODULE_30__input_const__["UploadFileNameSuffix"].imageFileType;
            isAvailableSuffix = availFileSuffix.includes(fileSuffixName);
            if (!isAvailableSuffix) {
                var msg = '抱歉，只支持上传【' + availFileSuffix.join(' || ') + '】格式的文件！';
                __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.error(msg);
            }
            return isAvailableSuffix;
        } else if (fileType === 'file') {
            //文件类型
            var _availFileSuffix = __WEBPACK_IMPORTED_MODULE_30__input_const__["UploadFileNameSuffix"].otherFileType;
            isAvailableSuffix = _availFileSuffix.includes(fileSuffixName);
            if (!isAvailableSuffix) {
                var _msg = '抱歉，只支持上传【' + _availFileSuffix.join(' || ') + '】格式的文件！';
                __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.error(_msg);
            }
            return isAvailableSuffix;
        }

        var availSize = size;
        var fileSize = file.size / 1024 / 1024;
        var isOverSize = fileSize > availSize;

        if (isOverSize) {
            var _msg2 = '抱歉，上传文件大小最大不能超过' + availSize + 'M！';
            __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.error(_msg2);
            return !isOverSize;
        }
        return true;
    };

    this.handleUploadChange = function (info) {
        //上传中
        if (info.file.status === 'uploading') {
            _this2.setState({ loading: true });
        }

        //上传成功
        if (info.file.status === 'done') {
            __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.success("\u6587\u4EF6\u4E0A\u4F20\u6210\u529F\uFF01");

            var fileType = _this2.state.featureParams.fileType;
            // 上传的附件类型(非图片类型)

            if (fileType === 'file') {
                var responseFileUUID = info.file.response.data.bh;
                var responseFileMC = info.file.response.data.fjmc;
                var ids = 'FILE_DOC_UUID' + _this2.props.id;
                var val = _this2.props.form.getFieldValue(ids);
                var arr = val ? JSON.parse(val) : [];
                var obj = {};
                obj.name = responseFileMC;
                obj.value = responseFileUUID;
                arr.push(obj);

                var fieldsObj2 = {};
                fieldsObj2[ids] = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_json_stringify___default()(arr);
                _this2.props.form.setFieldsValue(fieldsObj2);
            } else if (fileType === 'image') {
                //图片类型
                //上传成功返回的文档库对应的UUID,使用这个可以从文档库中下载此文件
                var _responseFileUUID = info.file.response.data.bh;
                var fieldsObj = {};
                var id = _this2.props.id;
                fieldsObj[id] = _responseFileUUID;
                _this2.props.form.setFieldsValue(fieldsObj);

                var _ids = 'FILE_DOC_UUID' + id;
                var _fieldsObj = {};
                _fieldsObj[_ids] = _responseFileUUID;
                _this2.props.form.setFieldsValue(_fieldsObj);

                var uploadFile = _this2.state.uploadFile;

                uploadFile[id] = _responseFileUUID;
                _this2.setState({
                    uploadFile: uploadFile,
                    loading: false
                });
            }
        } else if (info.file.status === 'error') {
            //上传失败
            __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.error(info.file.name + " \u6587\u4EF6\u7531\u4E8E\u672A\u77E5\u539F\u56E0\u5931\u8D25\uFF0C\u8BF7\u91CD\u65B0\u4E0A\u4F20\uFF01");
            _this2.setState({
                loading: false
            });
            return;
        }
    };

    this.renderImageUpload = function () {
        var _props7 = _this2.props,
            form = _props7.form,
            id = _props7.id;
        var _state$featureParams6 = _this2.state.featureParams,
            size = _state$featureParams6.size,
            required = _state$featureParams6.required,
            fileType = _state$featureParams6.fileType;


        var uploadButton = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_icon___default.a, { type: _this2.state.loading ? 'loading' : 'plus' }),
            __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                "div",
                { className: "ant-upload-text" },
                "\u70B9\u51FB\u4E0A\u4F20"
            )
        );

        var uploadImageProps = {
            action: 'anonymity/docrepo/upload',
            data: { uuid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_createUuid__["a" /* default */])(), type: '1' },
            listType: "picture-card",
            showUploadList: false
        };

        var uploadFile = _this2.state.uploadFile;

        var uploadFileUUID = uploadFile[id];

        var uploadComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_antd_lib_upload___default.a,
            _extends({}, uploadImageProps, {
                beforeUpload: function beforeUpload(file) {
                    return _this2.beforeUpload(file, size, fileType);
                },
                onChange: _this2.handleUploadChange,
                className: __WEBPACK_IMPORTED_MODULE_32__style_css___default.a["avatar-uploader"]
            }),
            uploadFileUUID ? __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("img", { src: "anonymity/docrepo/download?attachmentId=" + uploadFileUUID }) : uploadButton
        );

        //是否是表单项
        if (form) {
            _this2.props.form.getFieldDecorator('FILE_DOC_UUID' + id);
            return _this2.renderFormItem({
                form: form,
                pRequired: required,
                component: uploadComponent
            });
        }
        return uploadComponent;
    };

    this.onRemoveFile = function (file) {
        var id = _this2.props.id;
        var uploadFileList = _this2.state.uploadFileList;

        var uploadFilearr = [];
        uploadFileList.map(function (item) {
            if (item.status !== 'removed') {
                uploadFilearr.push(item);
            }
        });
        _this2.setState({
            uploadFileList: uploadFilearr
        });
        var fieldValue = _this2.props.form.getFieldValue(id).value;
        if (fieldValue) {
            var fieldValueArr = JSON.parse(fieldValue);
            fieldValueArr = fieldValueArr.filter(function (item) {
                return file.name !== item.name;
            });

            var fieldsObj = {};
            var valueObj = {};
            valueObj.value = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_json_stringify___default()(fieldValueArr) || '';
            fieldsObj[id] = valueObj;
            _this2.props.form.setFieldsValue(fieldsObj);

            var ids = 'FILE_DOC_UUID' + id;
            var val = _this2.props.form.getFieldValue(ids);
            var arr = JSON.parse(val);
            var tarArr = [];
            arr.map(function (item) {
                if (item.name !== file.name) {
                    tarArr.push(item);
                }
            });

            var fieldsObj2 = {};
            fieldsObj2[ids] = tarArr.length > 0 ? __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_json_stringify___default()(tarArr) : '';
            _this2.props.form.setFieldsValue(fieldsObj2);
        } else {
            var fileListVal = _this2.props.form.getFieldValue(id).fileList;
            var _tarArr = [];
            fileListVal.map(function (item) {
                if (item.status !== 'removed') {
                    _tarArr.push(item);
                }
            });

            var _ids2 = 'FILE_DOC_UUID' + id;
            var objArr = [];
            if (_tarArr.length > 0) {
                _tarArr.map(function (item) {
                    var obj = {};
                    obj.name = item.name;
                    obj.value = item.response.data.bh;
                    objArr.push(obj);
                });
            }
            var _fieldsObj2 = {};
            _fieldsObj2[_ids2] = objArr.length > 0 ? __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_json_stringify___default()(objArr) : '';
            _this2.props.form.setFieldsValue(_fieldsObj2);
        }
    };

    this.renderFileUpload = function () {
        var _props8 = _this2.props,
            form = _props8.form,
            id = _props8.id;
        var _state$featureParams7 = _this2.state.featureParams,
            size = _state$featureParams7.size,
            required = _state$featureParams7.required,
            fileType = _state$featureParams7.fileType;


        var uploadOtherFileTypeProps = {
            action: 'anonymity/docrepo/upload',
            data: { uuid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__utils_createUuid__["a" /* default */])(), type: '1' },
            fileList: _this2.state.uploadFileList,
            onRemove: _this2.onRemoveFile
        };

        var uploadOtherFileComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_antd_lib_upload___default.a,
            _extends({}, uploadOtherFileTypeProps, {
                beforeUpload: function beforeUpload(file) {
                    return _this2.beforeUpload(file, size, fileType);
                },
                onChange: _this2.handleUploadChange
            }),
            __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default.a,
                null,
                __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_icon___default.a, { type: "upload" }),
                " \u70B9\u51FB\u4E0A\u4F20"
            )
        );

        //是否是表单项
        if (form) {
            _this2.props.form.getFieldDecorator('FILE_DOC_UUID' + id);
            return _this2.renderFormItem({
                form: form,
                pRequired: required,
                component: uploadOtherFileComponent
            });
        }
        return uploadOtherFileComponent;
    };

    this.renderDatePicker = function () {
        __WEBPACK_IMPORTED_MODULE_40_moment___default.a.locale('zh-cn');
        var _props9 = _this2.props,
            form = _props9.form,
            id = _props9.id,
            value = _props9.value,
            disabled = _props9.disabled,
            _onChange6 = _props9.onChange;
        var _state$featureParams8 = _this2.state.featureParams,
            widthType = _state$featureParams8.widthType,
            widthStr = _state$featureParams8.widthStr,
            required = _state$featureParams8.required,
            defaultValue = _state$featureParams8.defaultValue,
            format = _state$featureParams8.format;


        var datePickerComponent = null;
        var otherParams = {}; //其他参数

        if (!form && id !== undefined && id != '') {
            otherParams.id = id;
        }
        if (!form && value) {
            otherParams.value = _this2.state.value === '' ? null : _this2.state.value;
        }
        if (!form && defaultValue !== undefined && defaultValue != '') {
            otherParams.defaultValue = __WEBPACK_IMPORTED_MODULE_40_moment___default()(defaultValue, format);
        }
        otherParams.format = format;
        console.log("==========DatePicker-otherParams==========");
        console.log(_extends({}, otherParams));
        console.log("==========DatePicker-locale==========");
        console.log(__WEBPACK_IMPORTED_MODULE_41_antd_lib_date_picker_locale_zh_CN___default.a);
        if (widthType != __WEBPACK_IMPORTED_MODULE_30__input_const__["c" /* WidthType */].DEFAULT) {
            datePickerComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_antd_lib_date_picker___default.a, _extends({}, otherParams, {
                disabled: disabled,
                style: { width: widthStr },
                locale: __WEBPACK_IMPORTED_MODULE_41_antd_lib_date_picker_locale_zh_CN___default.a,
                onChange: function onChange(date, dateString) {
                    if (!('value' in _this2.props)) {
                        _this2.setState({ value: date });
                    }
                    if (typeof _onChange6 == 'function') {
                        _onChange6(date, dateString);
                    }
                }
            }));
        } else {
            datePickerComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_antd_lib_date_picker___default.a, _extends({}, otherParams, {
                disabled: disabled,
                locale: __WEBPACK_IMPORTED_MODULE_41_antd_lib_date_picker_locale_zh_CN___default.a,
                onChange: function onChange(date, dateString) {
                    if (!('value' in _this2.props)) {
                        _this2.setState({ value: date });
                    }
                    if (typeof _onChange6 == 'function') {
                        _onChange6(date, dateString);
                    }
                }
            }));
        }
        //是否是表单项
        if (form) {
            return _this2.renderFormItem({
                form: form,
                pDefaultValue: defaultValue === '' ? null : __WEBPACK_IMPORTED_MODULE_40_moment___default()(defaultValue, format),
                pRequired: required,
                component: datePickerComponent
            });
        }

        return datePickerComponent;
    };

    this.renderDateTimePicker = function () {
        // moment.locale('zh-cn');
        var _props10 = _this2.props,
            form = _props10.form,
            id = _props10.id,
            value = _props10.value,
            disabled = _props10.disabled,
            _onChange7 = _props10.onChange;
        var _state$featureParams9 = _this2.state.featureParams,
            widthType = _state$featureParams9.widthType,
            widthStr = _state$featureParams9.widthStr,
            required = _state$featureParams9.required,
            defaultValue = _state$featureParams9.defaultValue,
            format = _state$featureParams9.format;


        var dateTimePickerComponent = null;
        var otherParams = {}; //其他参数

        if (!form && id !== undefined && id != '') {
            otherParams.id = id;
        }
        if (!form && value) {
            otherParams.value = _this2.state.value === '' ? null : _this2.state.value;
        }
        if (!form && defaultValue !== undefined && defaultValue != '') {
            otherParams.defaultValue = __WEBPACK_IMPORTED_MODULE_40_moment___default()(defaultValue, format);
        }
        otherParams.format = format;
        if (widthType != __WEBPACK_IMPORTED_MODULE_30__input_const__["c" /* WidthType */].DEFAULT) {
            dateTimePickerComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_antd_lib_date_picker___default.a, _extends({}, otherParams, {
                disabled: disabled,
                style: { width: widthStr },
                locale: __WEBPACK_IMPORTED_MODULE_41_antd_lib_date_picker_locale_zh_CN___default.a,
                showTime: true,
                onChange: function onChange(date, dateString) {
                    if (!('value' in _this2.props)) {
                        _this2.setState({ value: date });
                    }
                    if (typeof _onChange7 == 'function') {
                        _onChange7(date, dateString);
                    }
                }
            }));
        } else {
            dateTimePickerComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_antd_lib_date_picker___default.a, _extends({}, otherParams, {
                disabled: disabled,
                locale: __WEBPACK_IMPORTED_MODULE_41_antd_lib_date_picker_locale_zh_CN___default.a,
                placeholder: '请选择日期和时间',
                showTime: true,
                onChange: function onChange(date, dateString) {
                    if (!('value' in _this2.props)) {
                        _this2.setState({ value: date });
                    }
                    if (typeof _onChange7 == 'function') {
                        _onChange7(date, dateString);
                    }
                }
            }));
        }
        //是否是表单项
        if (form) {
            return _this2.renderFormItem({
                form: form,
                pDefaultValue: defaultValue === '' ? null : __WEBPACK_IMPORTED_MODULE_40_moment___default()(defaultValue, format),
                pRequired: required,
                component: dateTimePickerComponent
            });
        }

        return dateTimePickerComponent;
    };

    this.renderRangePicker = function () {
        __WEBPACK_IMPORTED_MODULE_40_moment___default.a.locale('zh-cn');
        var _props11 = _this2.props,
            form = _props11.form,
            id = _props11.id,
            value = _props11.value,
            disabled = _props11.disabled,
            onChange = _props11.onChange;
        var _state$featureParams10 = _this2.state.featureParams,
            widthType = _state$featureParams10.widthType,
            widthStr = _state$featureParams10.widthStr,
            required = _state$featureParams10.required,
            defaultValueStart = _state$featureParams10.defaultValueStart,
            defaultValueEnd = _state$featureParams10.defaultValueEnd,
            format = _state$featureParams10.format,
            showTime = _state$featureParams10.showTime;


        var rangePickerComponent = null;
        var otherParams = {}; //其他参数

        if (!form && id !== undefined && id != '') {
            otherParams.id = id;
        }
        if (!form && value) {
            otherParams.value = _this2.state.value === '' ? null : _this2.state.value;
        }
        if (!form && defaultValueStart !== undefined && defaultValueStart != '' && defaultValueEnd !== undefined && defaultValueEnd != '') {
            otherParams.defaultValue = [__WEBPACK_IMPORTED_MODULE_40_moment___default()(defaultValueStart, format), __WEBPACK_IMPORTED_MODULE_40_moment___default()(defaultValueEnd, format)];
        }
        otherParams.format = format;
        console.log("==========RangePicker-otherParams==========");
        console.log(_extends({}, otherParams));
        console.log("==========RangePicker-locale==========");
        console.log(__WEBPACK_IMPORTED_MODULE_41_antd_lib_date_picker_locale_zh_CN___default.a);
        if (widthType != __WEBPACK_IMPORTED_MODULE_30__input_const__["c" /* WidthType */].DEFAULT) {

            rangePickerComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(RangePicker
            //  {...otherParams}
            , { value: "[2020-03-21,2020-04-21]",
                format: 'YYYY-MM-DD'

            });
        } else {
            rangePickerComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(RangePicker
            // {...otherParams}
            , { value: "[2020-03-21,2020-04-21]",
                format: 'YYYY-MM-DD'

            });
        }
        //是否是表单项
        if (form) {
            return _this2.renderFormItem({
                form: form,
                pDefaultValue: [defaultValueStart === '' ? null : __WEBPACK_IMPORTED_MODULE_40_moment___default()(defaultValueStart, format), defaultValueEnd === '' ? null : __WEBPACK_IMPORTED_MODULE_40_moment___default()(defaultValueEnd, format)],
                pRequired: required,
                component: rangePickerComponent
            });
        }

        return rangePickerComponent;
    };

    this.renderUpload = function () {
        var _props12 = _this2.props,
            form = _props12.form,
            id = _props12.id,
            _onChange8 = _props12.onChange,
            disabled = _props12.disabled,
            value = _props12.value,
            isEdit = _props12.isEdit;
        var _state$featureParams11 = _this2.state.featureParams,
            size = _state$featureParams11.size,
            fileType = _state$featureParams11.fileType,
            required = _state$featureParams11.required,
            mode = _state$featureParams11.mode,
            numberLimit = _state$featureParams11.numberLimit,
            serviceMark = _state$featureParams11.serviceMark,
            moduleName = _state$featureParams11.moduleName,
            describe = _state$featureParams11.describe,
            fileMainName = _state$featureParams11.fileMainName,
            _state$featureParams12 = _state$featureParams11.templateList,
            templateList = _state$featureParams12 === undefined ? [] : _state$featureParams12,
            accept = _state$featureParams11.accept;

        var params = {};
        if (!form && id !== undefined && id !== '') {
            params.id = id;
        }

        var uploadComponent = null;
        if (fileType === 'image') {
            params.listType = 'picture-card';
            params.accept = 'image/*';
            params.image = true;
        }
        if (accept && accept.length > 0) {
            params.accept = accept;
        }
        uploadComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__NHUpload_index__["a" /* default */], _extends({}, params, { uploadType: mode, redisData: 30, disabled: disabled,
            fileCountLimit: numberLimit,
            isEdit: isEdit,
            serviceMark: serviceMark,
            moduleName: moduleName,
            value: value,
            describe: describe,
            fileMainName: fileMainName,
            templateList: templateList,
            multiple: numberLimit ? true : false,
            onChange: function onChange(value) {
                if (typeof _onChange8 === 'function') {
                    _onChange8(value);
                }
            }
        }));
        //是否是表单项
        if (form) {
            return _this2.renderFormItem({
                form: form,
                pDefaultValue: '',
                pRequired: required,
                component: uploadComponent
            });
        }

        return uploadComponent;
    };

    this.renderTimePicker = function () {
        __WEBPACK_IMPORTED_MODULE_40_moment___default.a.locale('zh-cn');
        var _props13 = _this2.props,
            form = _props13.form,
            id = _props13.id,
            value = _props13.value,
            disabled = _props13.disabled,
            _onChange9 = _props13.onChange;
        var _state$featureParams13 = _this2.state.featureParams,
            widthType = _state$featureParams13.widthType,
            widthStr = _state$featureParams13.widthStr,
            required = _state$featureParams13.required,
            defaultValue = _state$featureParams13.defaultValue,
            format = _state$featureParams13.format;


        var timePickerComponent = null;
        var otherParams = {}; //其他参数

        if (!form && id !== undefined && id != '') {
            otherParams.id = id;
        }
        if (!form && value) {
            otherParams.value = _this2.state.value === '' ? null : _this2.state.value;
        }
        if (!form && defaultValue !== undefined && defaultValue != '') {
            otherParams.defaultValue = __WEBPACK_IMPORTED_MODULE_40_moment___default()(defaultValue, format);
        }
        otherParams.format = format;
        if (widthType != __WEBPACK_IMPORTED_MODULE_30__input_const__["c" /* WidthType */].DEFAULT) {
            timePickerComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_time_picker___default.a, _extends({}, otherParams, {
                disabled: disabled,
                style: { width: widthStr },
                onChange: function onChange(time, timeString) {
                    if (!('value' in _this2.props)) {
                        _this2.setState({ value: time });
                    }
                    if (typeof _onChange9 == 'function') {
                        _onChange9(time, timeString);
                    }
                }
            }));
        } else {
            timePickerComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_time_picker___default.a, _extends({}, otherParams, {
                disabled: disabled,
                locale: __WEBPACK_IMPORTED_MODULE_41_antd_lib_date_picker_locale_zh_CN___default.a,
                onChange: function onChange(time, timeString) {
                    if (!('value' in _this2.props)) {
                        _this2.setState({ value: time });
                    }
                    if (typeof _onChange9 == 'function') {
                        _onChange9(time, timeString);
                    }
                }
            }));
        }
        //是否是表单项
        if (form) {
            return _this2.renderFormItem({
                form: form,
                pDefaultValue: defaultValue === '' || defaultValue == undefined ? null : __WEBPACK_IMPORTED_MODULE_40_moment___default()(defaultValue, format),
                pRequired: required,
                component: timePickerComponent
            });
        }

        return timePickerComponent;
    };

    this.renderMonthPicker = function () {
        __WEBPACK_IMPORTED_MODULE_40_moment___default.a.locale('zh-cn');
        var _props14 = _this2.props,
            form = _props14.form,
            id = _props14.id,
            value = _props14.value,
            disabled = _props14.disabled,
            _onChange10 = _props14.onChange;
        var _state$featureParams14 = _this2.state.featureParams,
            widthType = _state$featureParams14.widthType,
            widthStr = _state$featureParams14.widthStr,
            required = _state$featureParams14.required,
            defaultValue = _state$featureParams14.defaultValue,
            format = _state$featureParams14.format;


        var monthPickerComponent = null;
        var otherParams = {}; //其他参数

        if (!form && id !== undefined && id != '') {
            otherParams.id = id;
        }
        if (!form && value) {
            otherParams.value = _this2.state.value === '' ? null : _this2.state.value;
        }
        if (!form && defaultValue !== undefined && defaultValue != '') {
            otherParams.defaultValue = __WEBPACK_IMPORTED_MODULE_40_moment___default()(defaultValue, format);
        }

        otherParams.format = format;
        if (widthType != __WEBPACK_IMPORTED_MODULE_30__input_const__["c" /* WidthType */].DEFAULT) {
            monthPickerComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(MonthPicker, _extends({}, otherParams, {
                disabled: disabled,
                style: { width: widthStr },
                locale: __WEBPACK_IMPORTED_MODULE_41_antd_lib_date_picker_locale_zh_CN___default.a,
                onChange: function onChange(date, dateString) {
                    if (!('value' in _this2.props)) {
                        _this2.setState({ value: date });
                    }
                    if (typeof _onChange10 == 'function') {
                        _onChange10(date, dateString);
                    }
                }
            }));
        } else {
            monthPickerComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(MonthPicker, _extends({}, otherParams, {
                disabled: disabled,
                locale: __WEBPACK_IMPORTED_MODULE_41_antd_lib_date_picker_locale_zh_CN___default.a,
                onChange: function onChange(date, dateString) {
                    if (!('value' in _this2.props)) {
                        _this2.setState({ value: date });
                    }
                    if (typeof _onChange10 == 'function') {
                        _onChange10(date, dateString);
                    }
                }
            }));
        }
        //是否是表单项
        if (form) {
            return _this2.renderFormItem({
                form: form,
                pDefaultValue: defaultValue === '' ? null : __WEBPACK_IMPORTED_MODULE_40_moment___default()(defaultValue, format),
                pRequired: required,
                component: monthPickerComponent
            });
        }

        return monthPickerComponent;
    };

    this.renderMultiSelect = function () {
        var _props15 = _this2.props,
            form = _props15.form,
            id = _props15.id,
            value = _props15.value,
            disabled = _props15.disabled,
            _onChange11 = _props15.onChange;
        var _state$featureParams15 = _this2.state.featureParams,
            widthType = _state$featureParams15.widthType,
            widthStr = _state$featureParams15.widthStr,
            dataTag = _state$featureParams15.dataTag,
            required = _state$featureParams15.required,
            defaultValue = _state$featureParams15.defaultValue,
            baseUrl = _state$featureParams15.baseUrl;


        var multiselectComponent = null;
        var otherParams = {}; //其他参数

        if (!form && id !== undefined && id != '') {
            otherParams.id = id;
        }
        if (!form && value) {
            otherParams.value = _this2.state.value === '' ? [] : _this2.state.value;
        }
        if (!form && defaultValue !== undefined && defaultValue != '') {
            otherParams.defaultValue = defaultValue;
        }

        if (baseUrl !== null && baseUrl !== undefined && baseUrl !== '') {
            otherParams.baseUrl = baseUrl;
        }

        if (widthType != __WEBPACK_IMPORTED_MODULE_30__input_const__["c" /* WidthType */].DEFAULT) {
            multiselectComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__NHMultiSelect_index__["a" /* default */], _extends({}, otherParams, {
                disabled: disabled,
                sign: dataTag,
                style: { width: widthStr },
                onChange: function onChange(v) {
                    if (!('value' in _this2.props)) {
                        _this2.setState({ value: v });
                    }
                    if (typeof _onChange11 == 'function') {
                        _onChange11(v);
                    }
                }
            }));
        } else {
            multiselectComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__NHMultiSelect_index__["a" /* default */], _extends({}, otherParams, {
                disabled: disabled,
                sign: dataTag,
                onChange: function onChange(v) {
                    if (!('value' in _this2.props)) {
                        _this2.setState({ value: v });
                    }
                    if (typeof _onChange11 == 'function') {
                        _onChange11(v);
                    }
                }
            }));
        }

        //是否是表单项
        if (form) {
            return _this2.renderFormItem({
                form: form,
                pDefaultValue: defaultValue,
                pRequired: required,
                component: multiselectComponent
            });
        }

        return multiselectComponent;
    };

    this.renderNHCascader = function () {
        var _props16 = _this2.props,
            form = _props16.form,
            id = _props16.id,
            value = _props16.value,
            disabled = _props16.disabled,
            _onChange12 = _props16.onChange;
        var _state$featureParams16 = _this2.state.featureParams,
            widthType = _state$featureParams16.widthType,
            widthStr = _state$featureParams16.widthStr,
            dataTag = _state$featureParams16.dataTag,
            required = _state$featureParams16.required,
            defaultValue = _state$featureParams16.defaultValue,
            baseUrl = _state$featureParams16.baseUrl,
            changeOnSelect = _state$featureParams16.changeOnSelect;


        var nhcasecaderComponent = null;
        var otherParams = {}; //其他参数

        if (!form && id !== undefined && id != '') {
            otherParams.id = id;
        }
        if (!form && value) {
            otherParams.value = _this2.state.value === '' ? [] : _this2.state.value;
        }
        if (!form && defaultValue !== undefined && defaultValue != '') {
            otherParams.defaultValue = defaultValue;
        }

        if (baseUrl !== null && baseUrl !== undefined && baseUrl !== '') {
            otherParams.baseUrl = baseUrl;
        }

        // if (changeOnSelect !== null && changeOnSelect !== undefined && changeOnSelect !== '') {
        //   otherParams.changeOnSelect = changeOnSelect;
        // }
        if (widthType != __WEBPACK_IMPORTED_MODULE_30__input_const__["c" /* WidthType */].DEFAULT) {
            nhcasecaderComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__NHCascader_index__["a" /* default */], _extends({}, otherParams, {
                disabled: disabled,
                sign: dataTag,
                style: { width: widthStr },
                changeOnSelect: false,
                onChange: function onChange(v, o) {
                    if (!('value' in _this2.props)) {
                        _this2.setState({ value: v });
                    }
                    if (typeof _onChange12 == 'function') {
                        _onChange12(v, o);
                    }
                }
            }));
        } else {
            nhcasecaderComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__NHCascader_index__["a" /* default */], _extends({}, otherParams, {
                disabled: disabled,
                sign: dataTag,
                changeOnSelect: false,
                onChange: function onChange(v, o) {
                    if (!('value' in _this2.props)) {
                        _this2.setState({ value: v });
                    }
                    if (typeof _onChange12 == 'function') {
                        _onChange12(v, o);
                    }
                }
            }));
        }

        //是否是表单项
        if (form) {
            return _this2.renderFormItem({
                form: form,
                pDefaultValue: defaultValue,
                pRequired: required,
                component: nhcasecaderComponent
            });
        }

        return nhcasecaderComponent;
    };

    this.renderInputNumber = function () {
        var _props17 = _this2.props,
            form = _props17.form,
            id = _props17.id,
            value = _props17.value,
            disabled = _props17.disabled,
            _onChange13 = _props17.onChange;
        var _state$featureParams17 = _this2.state.featureParams,
            widthType = _state$featureParams17.widthType,
            widthStr = _state$featureParams17.widthStr,
            size = _state$featureParams17.size,
            step = _state$featureParams17.step,
            _state$featureParams18 = _state$featureParams17.max,
            max = _state$featureParams18 === undefined ? '' : _state$featureParams18,
            _state$featureParams19 = _state$featureParams17.min,
            min = _state$featureParams19 === undefined ? '' : _state$featureParams19,
            required = _state$featureParams17.required,
            _state$featureParams20 = _state$featureParams17.defaultValue,
            defaultValue = _state$featureParams20 === undefined ? '' : _state$featureParams20;

        var inputnumberComponent = null;
        var otherParams = {}; //动态参数

        if (!form && id !== undefined && id != '') {
            otherParams.id = id;
        }
        if (value) {
            otherParams.value = _this2.state.value;
        }
        if (defaultValue !== undefined && defaultValue != '') {
            otherParams.defaultValue = defaultValue;
        }
        if (size !== undefined && size != '') {
            otherParams.size = size;
        }
        if (step !== undefined && step != '') {
            otherParams.step = step;
        }
        if (max !== undefined && max != '') {
            otherParams.max = max;
        }
        if (min !== undefined && min != '') {
            otherParams.min = min;
        }
        console.log("otherParams", otherParams);
        try {
            if (max < min) {
                __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.info('最大值不得小于最小值!');
            } else if (widthType != __WEBPACK_IMPORTED_MODULE_30__input_const__["c" /* WidthType */].DEFAULT) {
                inputnumberComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number___default.a, _extends({}, otherParams, {
                    disabled: disabled,
                    style: { width: widthStr },
                    onChange: function onChange(value) {

                        if (!('value' in _this2.props)) {
                            _this2.setState({ value: value });
                        }

                        if (typeof _onChange13 == 'function') {
                            _onChange13(value, value);
                        }
                    }
                }));
            } else {
                inputnumberComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_number___default.a, _extends({}, otherParams, {
                    disabled: disabled,
                    onChange: function onChange(value) {

                        if (!('value' in _this2.props)) {
                            _this2.setState({ value: value });
                        }

                        if (typeof _onChange13 == 'function') {
                            _onChange13(value, value);
                        }
                    }
                }));
            }
        } catch (e) {
            console.log(e);
            __WEBPACK_IMPORTED_MODULE_19_antd_lib_message___default.a.error('组装控件配置参数出错！');
        }

        //是否是表单项
        if (form) {
            return _this2.renderFormItem({
                form: form, hasFeedback: true, size: size, step: step, max: max, min: min, pDefaultValue: defaultValue,
                pRequired: required, component: inputnumberComponent
            });
        }

        return inputnumberComponent;
    };

    this.renderOldUpload = function () {
        var _props18 = _this2.props,
            form = _props18.form,
            id = _props18.id,
            _onChange14 = _props18.onChange,
            disabled = _props18.disabled,
            value = _props18.value;
        var _state$featureParams21 = _this2.state.featureParams,
            size = _state$featureParams21.size,
            fileType = _state$featureParams21.fileType,
            required = _state$featureParams21.required,
            mode = _state$featureParams21.mode,
            numberLimit = _state$featureParams21.numberLimit;


        var params = {};
        if (!form && id !== undefined && id !== '') {
            params.id = id;
        }

        var uploadComponent = null;
        if (fileType === 'image') {
            uploadComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__NHImage_index__["a" /* default */], _extends({}, params, { numberOfSize: size, saveType: mode, disabled: disabled,
                numberOfLimit: numberLimit,
                imageList: value,
                onChange: function onChange(imageList) {
                    if (typeof _onChange14 === 'function') {
                        _onChange14(imageList);
                    }
                }
            }));
        } else {
            uploadComponent = __WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__OldNHUpload_index__["a" /* default */], _extends({}, params, { uploadType: mode, redisData: 30, disabled: disabled,
                fileCountLimit: numberLimit,
                multiple: numberLimit ? true : false,
                onChange: function onChange(file, fileList) {
                    if (typeof _onChange14 === 'function') {
                        _onChange14(file, fileList);
                    }
                }
            }));
        }

        //是否是表单项
        if (form) {
            return _this2.renderFormItem({
                form: form,
                pDefaultValue: '',
                pRequired: required,
                component: uploadComponent
            });
        }

        return uploadComponent;
    };
}, _temp);

NHInputRender.defaultProps = {
    formLayout: "horizontal", //默认水平布局
    formItemLayout: { //表单项布局
        labelCol: {
            xs: { span: 24 },
            sm: { span: 6 },
            md: { span: 7 }
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 12 },
            md: { span: 10 }
        }
    },
    colon: true,
    hideLabel: false,
    required: false,
    readOnly: false
};

NHInputRender.propTypes = {
    id: __WEBPACK_IMPORTED_MODULE_31_prop_types___default.a.string, //渲染成表单项时必填，的字段标识
    label: __WEBPACK_IMPORTED_MODULE_31_prop_types___default.a.string, //渲染成表单项时必填，的字段名称
    colon: __WEBPACK_IMPORTED_MODULE_31_prop_types___default.a.bool, //是否显示label后面的冒号
    hideLabel: __WEBPACK_IMPORTED_MODULE_31_prop_types___default.a.bool, //是否隐藏label
    checked: __WEBPACK_IMPORTED_MODULE_31_prop_types___default.a.bool, //渲染成表单项时可选，开关、多选控件类型选中属性
    defaultValue: __WEBPACK_IMPORTED_MODULE_31_prop_types___default.a.node, //渲染成表单项时可选，默认值
    value: __WEBPACK_IMPORTED_MODULE_31_prop_types___default.a.any, //渲染成受控组件时，可选初始值
    required: __WEBPACK_IMPORTED_MODULE_31_prop_types___default.a.bool, //渲染成表单项时可选，是否必填
    readOnly: __WEBPACK_IMPORTED_MODULE_31_prop_types___default.a.bool, //渲染成表单项时可选，是否只读
    disabled: __WEBPACK_IMPORTED_MODULE_31_prop_types___default.a.bool, //渲染成表单项时可选，是否禁用
    form: __WEBPACK_IMPORTED_MODULE_31_prop_types___default.a.object, //渲染成表单项时必填，表单对象
    feature: __WEBPACK_IMPORTED_MODULE_31_prop_types___default.a.string.isRequired, //必填，输入控件参数字符串
    formLayout: __WEBPACK_IMPORTED_MODULE_31_prop_types___default.a.string, //渲染成表单项时可选，表单布局
    formItemLayout: __WEBPACK_IMPORTED_MODULE_31_prop_types___default.a.object, //渲染成表单项时可选，表单项布局
    onChange: __WEBPACK_IMPORTED_MODULE_31_prop_types___default.a.func, //输入控件值onChange方法
    //当使用NHUpload时需要的参数
    serviceMark: __WEBPACK_IMPORTED_MODULE_31_prop_types___default.a.string, //服务标志，说明是属于哪个服务，必填
    moduleName: __WEBPACK_IMPORTED_MODULE_31_prop_types___default.a.string, //模块名称，说明是属于哪个服务的哪个模块，必填
    fjzbid: __WEBPACK_IMPORTED_MODULE_31_prop_types___default.a.string, //附件主表id，非必填
    ms: __WEBPACK_IMPORTED_MODULE_31_prop_types___default.a.string, //描述，对上传的附件的一个描述信息，非必填
    fjzbm: __WEBPACK_IMPORTED_MODULE_31_prop_types___default.a.string, //附件主表名，存储该附件对应的主表的名称，主要是为了以后进行追溯，非必填
    parentValue: __WEBPACK_IMPORTED_MODULE_31_prop_types___default.a.string // 下拉框级联时上一级选中的值
};

/* harmony default export */ __webpack_exports__["a"] = (NHInputRender);

/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _siderMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_plugin_react_css_modules_dist_browser_getClassName__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_plugin_react_css_modules_dist_browser_getClassName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_plugin_react_css_modules_dist_browser_getClassName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_css__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_common_NHCascader__ = __webpack_require__(108);








var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;


var _styleModuleImportMap = {
    './index.css': {
        'sider_menu': 'app__css__app-pages-Assembly-siderMenu-__index__sider_menu',
        'sider_menu_title': 'app__css__app-pages-Assembly-siderMenu-__index__sider_menu_title',
        'sider_menu_item': 'app__css__app-pages-Assembly-siderMenu-__index__sider_menu_item',
        'active': 'app__css__app-pages-Assembly-siderMenu-__index__active'
    }
};

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }












if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_11_history_createHashHistory___default()();

var menu = {
    tzgg: [], //通知通告
    zzbd: [], //自助报到
    dhlj: [] //导航链接
};

var _siderMenu = (_temp = _class = function (_React$Component) {
    _inherits(_siderMenu, _React$Component);

    function _siderMenu(props) {
        _classCallCheck(this, _siderMenu);

        var _this = _possibleConstructorReturn(this, (_siderMenu.__proto__ || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default()(_siderMenu)).call(this, props));

        _this.getLstdXcShzt = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_NHFetch__["a" /* default */])('/openapi/yxwz/getLstdXcShzt', 'GET').then(function (res) {
                if (res) {
                    if (res.data !== '0' && res.data !== null) {
                        _this.setState({ shzt: true });
                    }
                }
            });
        };

        _this.getBddCssz = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_NHFetch__["a" /* default */])('/zzbdCommon/getCssz', 'GET', { csbz: 'YXXT_BDD_SCHOOL' }).then(function (res) {
                if (res) {
                    if (res.data) {
                        console.log('res.data', res.data);
                        _this.setState({ bddSchool: res.data });
                    } else {
                        _this.setState({ bddSchool: 'lydx' });
                    }
                } else {
                    _this.setState({ bddSchool: 'lydx' });
                }
            });
        };

        _this.loadDhljList = function (menuList, flmid) {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            var xsfs = '';
            if (userId) {
                xsfs = 1;
            }
            var params = {
                flmid: flmid,
                xsfs: xsfs
            };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_NHFetch__["a" /* default */])('/dhlm/getDhljList', 'GET', params).then(function (resData) {
                if (resData && resData.data) {
                    var _menuList;

                    if (menuList.length > 0) {
                        menuList = [];
                    }
                    (_menuList = menuList).push.apply(_menuList, _toConsumableArray(resData.data));
                    _this.setState({ menuList: resData.data });
                }
            });
        };

        _this.reloadMenuList = function () {
            var zzbd = menu.zzbd;
            _this.loadMenuList(zzbd);
        };

        _this.loadMenuList = function (menuList) {
            //获取自助报到环节信息
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_NHFetch__["a" /* default */])('/zzbd/getZzbdInfoListOfWhrj', 'GET').then(function (resData) {
                if (resData && resData.data) {
                    if (menuList.length > 0) {
                        menuList.splice(0, menuList.length);
                    }
                    menuList.push.apply(menuList, _toConsumableArray(resData.data));
                    _this.setState({ menuList: resData.data }, function () {
                        if (_this.props.setMenuList) {
                            _this.props.setMenuList(resData.data);
                        }
                        //this.getLstdXcShzt();
                    });
                }
            });
        };

        _this.loadXxbfMenuList = function (menuList) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_NHFetch__["a" /* default */])('/xxfb/loadXxbfMenuList', 'GET').then(function (resData) {
                if (resData && resData.data) {
                    var _menuList2;

                    if (menuList.length > 0) {
                        menuList = [];
                    }
                    (_menuList2 = menuList).push.apply(_menuList2, _toConsumableArray(resData.data));
                    _this.setState({ menuList: resData.data }, function () {
                        if (_this.props.setMenuList) {
                            _this.props.setMenuList(resData.data);
                        }
                    });
                }
            });
        };

        _this.toLink_GD = function (hjdm, pkid) {
            if (pkid && _this.isLogin()) {
                //报到单环节 > 动态地址
                var bddSchool = _this.state.bddSchool;

                var hjPath = hjdm === 'GD009' ? '/' + bddSchool + 'Index' : __WEBPACK_IMPORTED_MODULE_15__menuObj__["a" /* mkbz */][hjdm];
                console.log('bddSchool', bddSchool);
                console.log('hjPath', hjPath);
                history.push({
                    pathname: hjPath,
                    search: 'pkid=' + pkid
                });
            }
        };

        _this.toLink_ZDY = function (hjdm, pkid, lx) {
            if (pkid && _this.isLogin()) {
                history.push({
                    pathname: '/customLink',
                    search: 'pkid=' + pkid + '&mkbz=' + hjdm + "&lx=" + lx
                });
            }
        };

        _this.isLogin = function () {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!userId) {
                __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.warning("未获取登录信息。");
                history.push({
                    pathname: '/index'
                });
                return false;
            }
            return true;
        };

        _this.state = {
            menuList: [], //菜单列表
            unShowBlzt: ['GD009'],
            BlztMc: {
                GD002: ['已购买', '未购买'],
                GD005: ['已审核', '已申请', '未申请', '未办理'],
                GD007: ['已审核', '已申请', '未申请', '申请被删除']
            }
            //bddSchool:'lydx',
            // shzt:false
        };
        return _this;
    }

    _createClass(_siderMenu, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var _props = this.props,
                menuType = _props.menuType,
                flmid = _props.flmid;

            var tzgg = menu.tzgg;
            var zzbd = menu.zzbd;
            var dhlj = menu.dhlj;
            if (menuType === '通知公告') {
                if (tzgg && tzgg.length == 0) {
                    this.loadXxbfMenuList(tzgg);
                } else {
                    this.setState({ menuList: tzgg }, function () {
                        if (_this2.props.setMenuList) {
                            _this2.props.setMenuList(tzgg);
                        }
                    });
                }
            }

            if (menuType === '自助报到') {
                this.getBddCssz();
                if (zzbd && zzbd.length == 0) {
                    this.loadMenuList(zzbd);
                } else {
                    this.setState({ menuList: zzbd }, function () {
                        if (_this2.props.setMenuList) {
                            _this2.props.setMenuList(zzbd);
                        }
                    });
                }
            }

            if (menuType === '导航链接') {
                if (dhlj && dhlj.length == 0 && flmid) {
                    this.loadDhljList(dhlj, flmid);
                } else {
                    this.setState({ menuList: dhlj });
                }
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _props2 = this.props,
                menuType = _props2.menuType,
                mkbz = _props2.mkbz;

            if (menuType === '导航链接' && !this.state.flmid && nextProps.flmid != '') {
                var dhlj = menu.dhlj;
                this.loadDhljList(dhlj, nextProps.flmid);
            }
        }

        //获取报到单学校模板参数设置

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props3 = this.props,
                className = _props3.className,
                title = _props3.title,
                menuType = _props3.menuType,
                active = _props3.active,
                url = _props3.url;

            var menuList = this.state.menuList;
            var unShowBlzt = this.state.unShowBlzt;
            var blztMc = this.state.BlztMc;
            if (menuType === '通知公告') {
                /* menuList = [
                     { title: '入学须知' },
                     { title: '交通路线' },
                     { title: '校园风景' },
                     { title: '视频简介' },
                     { title: '军训服装' }
                 ];*/
            }

            if (menuType === '自助报到') {
                /*   menuList = [
                       { title: '个人信息填写', url: '/update_info' },
                       { title: '物品购买', url: '/buy' },
                       { title: '军训服装尺码', url: '/size' },
                       { title: '报到情况填写', url: '/report' },
                       { title: '绿色通道申请', url: '/channel' },
                       { title: '自选宿舍', url: '/dorm' },
                       { title: '专业调整', url: '/major' },
                       { title: '网上缴费', url: '/pay' },
                       { title: '入学报到单打印', url: '/print' }
                   ];*/
            }

            return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                'div',
                { className: (className ? className + ' ' : '') + 'app__css__app-pages-Assembly-siderMenu-__index__sider_menu' },
                __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                    'div',
                    { className: 'app__css__app-pages-Assembly-siderMenu-__index__sider_menu_title' },
                    title
                ),
                menuList && title === '自助报到' && menuList.length > 0 && menuList.map(function (elem, index) {
                    var hjlx = elem.HJLX;
                    var showBlzt = true;
                    var i = unShowBlzt.indexOf(elem.HJDM);
                    if (i > 0 || i == 0) {
                        showBlzt = false;
                    }

                    var mcList = blztMc[elem.HJDM];
                    var ztmc = '';
                    if (mcList) {
                        if (elem.HJDM === 'GD005') {
                            console.log(elem);
                            ztmc = elem.shzt && elem.shzt !== '0' ? elem.shzt === '9' ? mcList[3] : mcList[0] : elem.BLZT && elem.BLZT == 1 ? mcList[1] : mcList[2];
                        } else if (elem.HJDM === 'GD007') {
                            ztmc = elem.shzt && elem.shzt !== '0' ? mcList[0] : elem.BLZT && elem.BLZT == 1 ? elem.shzt == '' ? mcList[3] : mcList[1] : mcList[2];
                        } else {
                            ztmc = elem.BLZT && elem.BLZT == 1 ? mcList[0] : mcList[1];
                        }
                    } else {
                        ztmc = elem.BLZT && elem.BLZT == 1 ? '已办理' : '未办理';
                    }

                    return hjlx == 1 ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                        'div',
                        {
                            key: index,

                            onClick: function onClick() {
                                _this3.toLink_GD(elem.HJDM, elem.PKID);
                            },
                            className: __WEBPACK_IMPORTED_MODULE_7_babel_plugin_react_css_modules_dist_browser_getClassName___default()(__WEBPACK_IMPORTED_MODULE_9_classnames___default()('sider_menu_item', {
                                active: elem.HJDM === _this3.props.mkbz
                            }), _styleModuleImportMap)
                        },
                        elem.HJMC,
                        showBlzt && elem.HJDM == 'GD006_2' ? '' : __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                            'span',
                            { className: elem.BLZT && elem.BLZT == 1 ? "" : "text-info-red" },
                            '(',
                            ztmc,
                            ')'
                        )
                    ) : __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                        'div',
                        {
                            key: index,

                            onClick: function onClick() {
                                _this3.toLink_ZDY(elem.HJDM, elem.PKID, elem.LX);
                            },
                            className: __WEBPACK_IMPORTED_MODULE_7_babel_plugin_react_css_modules_dist_browser_getClassName___default()(__WEBPACK_IMPORTED_MODULE_9_classnames___default()('sider_menu_item', {
                                active: elem.HJDM === _this3.props.mkbz
                            }), _styleModuleImportMap)
                        },
                        elem.HJMC,
                        showBlzt && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                            'span',
                            { className: elem.BLZT && elem.BLZT == 1 ? "" : "text-info-red" },
                            '(',
                            ztmc,
                            ')'
                        )
                    );
                }),
                menuList && title === '消息发布' && menuList.length > 0 && menuList.map(function (elem, index) {
                    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                        'div',
                        {
                            key: index,

                            onClick: function onClick() {
                                if (elem.FLBZ) {
                                    if (elem.SFNRWY == 1) {
                                        history.push({
                                            pathname: '/notice/detail',
                                            search: 'pkid=' + elem.PKID
                                        });
                                    } else {
                                        history.push({
                                            pathname: '/notice',
                                            search: 'flbz=' + elem.FLBZ
                                        });
                                    }
                                }
                            },
                            className: __WEBPACK_IMPORTED_MODULE_7_babel_plugin_react_css_modules_dist_browser_getClassName___default()(__WEBPACK_IMPORTED_MODULE_9_classnames___default()('sider_menu_item', {
                                active: elem.FLBZ === _this3.props.flbz
                            }), _styleModuleImportMap)
                        },
                        elem.FLBT
                    );
                }),
                menuList && title === '导航链接' && menuList.length > 0 && menuList.map(function (elem, index) {
                    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                        'div',
                        {
                            key: index,

                            onClick: function onClick() {
                                if (elem.lmlj) {
                                    history.push({
                                        pathname: '/link',
                                        search: 'pkid=' + elem.pkid
                                    });
                                    window.open(elem.lmlj);
                                }
                            },
                            className: __WEBPACK_IMPORTED_MODULE_7_babel_plugin_react_css_modules_dist_browser_getClassName___default()(__WEBPACK_IMPORTED_MODULE_9_classnames___default()('sider_menu_item', {
                                active: elem.pkid === _this3.props.pkid
                            }), _styleModuleImportMap)
                        },
                        elem.lmmc
                    );
                })
            );
        }
    }]);

    return _siderMenu;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component), _class.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string,
    menuType: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string
}, _temp);
//属性检查



_siderMenu.propTypes = {
    setMenuList: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func //选择完成后的回调
};

/***/ }),

/***/ 210:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"progress":"app__css__app-pages-SelfHelp-updateInfo-__index__progress","jbxx_icon":"app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_icon","upload-box":"app__css__app-pages-SelfHelp-updateInfo-__index__upload-box","upload-title":"app__css__app-pages-SelfHelp-updateInfo-__index__upload-title","jbxx_item":"app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_item","jbxx_item2":"app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_item2","item-label":"app__css__app-pages-SelfHelp-updateInfo-__index__item-label","item-name":"app__css__app-pages-SelfHelp-updateInfo-__index__item-name","kzxx_list":"app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_list","kzxx_item":"app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_item","kzxx_label":"app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_label","kzxx_name":"app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_name","kzxx_item_textarea":"app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_item_textarea","kzxx_name_textarea":"app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_name_textarea","btn_add":"app__css__app-pages-SelfHelp-updateInfo-__index__btn_add","title_top":"app__css__app-pages-SelfHelp-updateInfo-__index__title_top","title_top_name":"app__css__app-pages-SelfHelp-updateInfo-__index__title_top_name","line":"app__css__app-pages-SelfHelp-updateInfo-__index__line","detail_adrress":"app__css__app-pages-SelfHelp-updateInfo-__index__detail_adrress"};

/***/ }),

/***/ 211:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"banner":"app__css__app-pages-index-__index__banner","box_top":"app__css__app-pages-index-__index__box_top","box_top_l":"app__css__app-pages-index-__index__box_top_l","box_top_r":"app__css__app-pages-index-__index__box_top_r","line":"app__css__app-pages-index-__index__line","grxx":"app__css__app-pages-index-__index__grxx","grxx_con":"app__css__app-pages-index-__index__grxx_con","grxx_con_l":"app__css__app-pages-index-__index__grxx_con_l","grxx_con_r":"app__css__app-pages-index-__index__grxx_con_r","grxx_con_item":"app__css__app-pages-index-__index__grxx_con_item","tzgg":"app__css__app-pages-index-__index__tzgg","tzgg_list":"app__css__app-pages-index-__index__tzgg_list","tzgg_item":"app__css__app-pages-index-__index__tzgg_item","tzgg_line":"app__css__app-pages-index-__index__tzgg_line","tzgg_item_icon":"app__css__app-pages-index-__index__tzgg_item_icon","bdlc_con":"app__css__app-pages-index-__index__bdlc_con","bdlc_item":"app__css__app-pages-index-__index__bdlc_item","bdlc_item_img":"app__css__app-pages-index-__index__bdlc_item_img","bdlc_item_num":"app__css__app-pages-index-__index__bdlc_item_num","bdlc_item_title":"app__css__app-pages-index-__index__bdlc_item_title","bdlc_item_sub":"app__css__app-pages-index-__index__bdlc_item_sub","last":"app__css__app-pages-index-__index__last","ksdh":"app__css__app-pages-index-__index__ksdh","ksdh_con":"app__css__app-pages-index-__index__ksdh_con","cjyy":"app__css__app-pages-index-__index__cjyy","ksdh_item":"app__css__app-pages-index-__index__ksdh_item","ksdh_select":"app__css__app-pages-index-__index__ksdh_select","lxdh":"app__css__app-pages-index-__index__lxdh","lxdh_con":"app__css__app-pages-index-__index__lxdh_con","ant-carousel":"app__css__app-pages-index-__index__ant-carousel","slick-slide":"app__css__app-pages-index-__index__slick-slide"};

/***/ }),

/***/ 2168:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDozZDJhYmIyNS1jMzAyLTVmNDYtOWI2ZC0zNWFkNjBmMzgxN2QiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODI1OTEwN0Y3NUYxMTFFOEI3REE4NTI3NkI1QkE5QjUiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODI1OTEwN0U3NUYxMTFFOEI3REE4NTI3NkI1QkE5QjUiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NDk5NmUzM2YtNmJmNS1lNDQzLWIzOGYtYzRmZDM0NjA2MzJmIiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6YTQyMWI1N2YtNzUyMS0xMWU4LWFjNjctZDIyYWMwNTlhNjk1Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+83MNNgAAATBJREFUeNpi/P//PwM1ARMDlQELPkm2pQySQKoKiJOB+AcQTwLiCb+iGT7g0sOIzctAg0SAVAkQ5wMxB5r0R5ChuAxGMRBoEEhzBRAXADE/Ad+BDO4D4lagwX9xhWE6ENcTYRgDVE0jEOvhi5T5QDwRGl6EwHUgDgC67jw+A08AsTIQ++Ax+C4QxwFxLBCnAYPpCj4DNaGG7QZiYSC2hxr8BohvAXEmEHsCsQcQnwZiLyDWJiYdMgJxDBAfAWJQgMsBsSHUwqtAHAVVQ1o6BAJWIC6CxigbEOdRlLCRgNKAZT2aG/iRDDPe4DPQF4hvkGDYNVDixmkgMNUfBlK6QJwKxE/xGPQYiJNA2Q6o5yjB0gZaUHACqVwgLoMmbmZowu4G4qlAg74TXXwNqlgGCDAAmRZLmYkYEQYAAAAASUVORK5CYII="

/***/ }),

/***/ 2169:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDozZDJhYmIyNS1jMzAyLTVmNDYtOWI2ZC0zNWFkNjBmMzgxN2QiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OUY0OTA1MTc3NUYxMTFFODg4NEVFMzc5REYwMUU1OTUiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OUY0OTA1MTY3NUYxMTFFODg4NEVFMzc5REYwMUU1OTUiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NDk5NmUzM2YtNmJmNS1lNDQzLWIzOGYtYzRmZDM0NjA2MzJmIiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6YTQyMWI1N2YtNzUyMS0xMWU4LWFjNjctZDIyYWMwNTlhNjk1Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+vteI1AAAAQxJREFUeNpi/P//PwM1ARMDlQELModtKQMzkJoExKlAvAaIE35FM/yixIXTgDgLiFmBOBKI+0l1ISNyGAJd+BvN1SBJRaArH5Lrwp+EgoVUAw+h8cuBrrtLiYEL0PizKU0264D4OhK/gSIDgd77A6RykITygREVQVHCBhq6D0j1IgktAhrqR2lOqQTiXVA2KE2uARoahZYJNIBYAW86RNPADaRArjVDEp4CxI3QnNQGTaezgDgPlqMY8RUOQEO5oBHlTsCny4EGRhEsHICKvgEpXyDuImBgCNGlDdDQ30BcDmQ6AvFVHMpmkFx8AQ09AKT0gDgUiLcA8UeQMBBPB+JCgpEyaApYqhsIEGAAsrtLHI8Pi3YAAAAASUVORK5CYII="

/***/ }),

/***/ 2170:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/3-0EtlDh_C.png";

/***/ }),

/***/ 2171:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAPCAYAAAD+pA/bAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADISURBVDiNtZM9DsIwDIWfo56iPR1CHTp2hqEDDEhIjAwIcTpyCYrNkBKcVP0B0m9p/Oq8Z7UJAYDcSJAQWgn5tVzTmnvjtQvJ8FRqycDF9OuS+w5juiMHYDO0UcNQfVbBFTv9rVUcvlf0A6poqjZ6Tg0yGXBSk9ScIOARKUN1zfP6Ikh2ZplTtOUCgCUAkCZtCDVcdEtLSs91k2zMPdi095vmYgEgiwWP+ml0+Ez0ZUgQENJdQDr+bj6K1EbgPls+1fsPi5on4QUlYkfw/Z9poQAAAABJRU5ErkJggg=="

/***/ }),

/***/ 2172:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/3Tait9nbPH.png";

/***/ }),

/***/ 2173:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/11UOny6aGq.png";

/***/ }),

/***/ 2174:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 2175:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 2176:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/2_Ile1mHzC.png";

/***/ }),

/***/ 2177:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 2178:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/1FzdEx8ssl.png";

/***/ }),

/***/ 2179:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAABSCAYAAADHLIObAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDozZDJhYmIyNS1jMzAyLTVmNDYtOWI2ZC0zNWFkNjBmMzgxN2QiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OTM3NTMyQTI3NUYxMTFFODk4OEVENzIxOTlBOUNFNEQiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OTM3NTMyQTE3NUYxMTFFODk4OEVENzIxOTlBOUNFNEQiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NDk5NmUzM2YtNmJmNS1lNDQzLWIzOGYtYzRmZDM0NjA2MzJmIiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6YTQyMWI1N2YtNzUyMS0xMWU4LWFjNjctZDIyYWMwNTlhNjk1Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+eV/BjwAAFNlJREFUeNrsXQd4VUXafs+5vacXEgiJtBAgEEABAWUVCysgKqCsBfSxrYDIKs0VUPFHdNdesKDogoIiAkr7UXGR3lvokN7rza255Zz9Zu4lIIKAhBDwzuM84d4zc8/MO195v2/mHAVZlhEqF17EEAQhIBtVUZ76ha7tLWdqq6Y6kOoNVDtQbULVQIZBoL9Xin0QaDIe+ltO9RDVdVS/o3rkdI1d+1ac6HiqjTwDkOMEQRjtk6QEb5UNsDoAv596i1cOjMfnIQdFQ68BIi3Qakl+JPkL+mYy1aNnAlJ5lp9vQQDOkwShszuvBKj1ollGa3TPaIWUZjEw0k1kWcKV4K8YdoIowOuXUVhWjZ2Z2di8KRPunGIISfHDtDr1ENkvPUHNPjwn1T6ptBdEcZPX49X5jhYirWc7TBw1GAP6dIIpkmm1LtiMaYKbquKU7n62rMFbnKlNQxQ5CJMh+Nl2HLbfaSPR8EuxadthvPPZcsyZvQwug06pi4/8QPb62OSn/mYhzqDaZpLEfJ/XZ/ISiA+PGoQP/jUagjIm0Midh117s+Cq9aBLegt4CDOvpxaiEBicJMlQa7WQfB7sP5yLzu1ZGwFulxOiKDawpMkwRobReI9Bp1GhVbN42Gy2gFk6uY3FjH3H8lFTUolWLRIR0aQFXdFwIfh60VIMefQVwCdBlxAF2ecfQRdmn6zaZ5rVl35B4CA+OHoQPnxjMoEYTqtUjFffmomO/caj452T0b3naNz+1MfQWRKg0ZlpYSXe2aDTQKkQ0X/km+jabThGTJ0NjckMjaZhJVKWJBijmmDV6h3o2O3vSL1xLLZkHoMxIvJ4A0JRAUNUa3yyaDvSOj2G7kOmov1tE/HgyOdx4PAOLp2Dbx+EVV8/z9t7yEeQkH1KF+LORn8yyFb08+SWoHXvDpj1+hj+pd1agF53PItxT76KXav3APm1XL2t+ZuB0i+gkFyQ1BH8ZszWMDk/nFPCnf1n7y7C+vXboLVEN6g91TGH4Xdj9AzyFc4aSGVW2GsICIWKj1NW6CEpDRBc/4UnexF5D5pTpQKFO/Lx6btfIf36kVj68xr6JQdu7N0XUycPh7+wghstKv88m418yEsiDJ8fLz41mD4SOFIlBo16DWuX/ASEN0d6mgkP3xGLNtEa9GmjgZD3IxT+TFjaPwRYEmErK4ApOgHTx9yF+3Yfo1WwY/bidejRozvnF8ycmC1GwlgbsEf16jIkuKpq4PX6oDKG4Zc1m3Fg20GaqQ79ht2IPn260fVSmCxhdH8dpENfEdn5CY/dGo3ubW/C/nwnlm6sxpyVFfCUlOK2oVOwd/VbSGvbAc8+8ld8NH81CrIKoY0w30M3G/l7QHb31TgQ3SEFt3Zvxw3xdyvW4of5PxNIzdDzahrcu6kk2ASC3UeD8AI1cRAN5XBmzkNuxD1o08xCRrMag/6Sgbj2ySjesBcbdx+F31UOvVYBBQFYVlmDvOxDENQqCEL9wOjz+mE069AmJQF+u4vbuB83E4iVZBN1atxzy9X8OxXdv9KpQPWuRUjRbCAU4skUqpDenuq1Ztz9QBN0eTkLY94n9SnNwZS3vsaCma2h1MdjUN8ueGf6f0i+zOazSWQybE60S2kCY3QYGx5WbdhPNyLAjEpMfyCBQCSVyaTBKYIIRChRVR2FjiN/RsH+pfhi7kQM6X8DDOFKtGwaQ0ACBSVVKCutRlxSK6zbsAG33vcSbA6aLNnTekOScVtS33HP3osZkx7izCG3uDLADcNNSCZHwaZcXu3A9cOfw5H/7sSXr3fF4EGkHUXEKsqIXZSQeoer8CSBOfPnShwoNWLngTx4asqgNjdH6yRyuEol0yrX2YBUMAOnUirqWKrH5zt+BUYNmVXvSepIHhrxauzebEXuLvreW4AVv+zEkIEDqKsTCvGEJ/dLrJ8KVrsTtqN5wXhJU3+azcbiK0ZOQXlwahJ9FTTKxBYCjEGDQ0dycXDtdhqrBvM22jH4AZpY0UmxTS2N06SETidyDPz0u8Qh+b8VCgVvI58Dj8yDQdv2QG4pPNYaqC0R6Ebq+YEYAHDGt8X4si95vebEIytJSiNUXDLfW1lG0kWDkMJxXedWfAG8JNnZJImsxESaEUVVcuXjlp7p2LD5Qxw5mAcFSWS9qbbHB6NBixt7tIPTWga9JQaxdE9+g2o7Ckur+Lg6tG2O8NRkVO0twLqdNajZa4O5E5mjHBIyFbVN1mPFrHzs3GWn9k60aBoNTXgk186cogqunUT11GcDcofCYmibSzZt054s9OqZjKH9r8PkHouRt3YP5q1UQP33fRhLot+UVCCPvPc7cwvx1Q80yJpiNOvVAUNu681Xb/2uo8jeHYiq0ls1hcYcDUdFEXc23bqmUe18EZwNTddeAQczGxY/urdPIT5G9txZi+Ub9uHOAf0QFp2IMX+7EVOefg0lBSZ0ffIAXhmdhGtbGYjvyvh2QTHGflAAmZwkqRTGDr8lGFxUYfm6vSStBpwaGJ8OyK/UauXfXE43Xpq1FCt6XgudKQrfzxyHHn99Go6cbHw+z4HP11QiLFaDamZTCumGvjKYmidi6cxnqH0kJ7L/98kyAtdJ6qvG4L4ZQTVhAiLAVl55cdNapIKS24q+vToiiiSwfPshzJn/E14aOQCxCamYPGYotu3PwZJZC3FoczhuH2mHJUVPgYUM5zGaj7OaR2NT3voHbu3bi5uEBUvWYfcP26BszinkD2fjkUtkST6qTIrDyrk/4P3P5nG+2CGtHXasfhuD7rsNiCX884pRvYWoTX4x6a2Cf7+drrdr246v3idffIP//5o8PdGQNtd3xOCBfeB1lNWbGp9LcZBpMYTFY9KIm5neo7awHPeMeS8QrioisPjjCXjh1bGIToslu2iFdXsOnHtzSb3daNszFXO+mY6po4ZReyNKSw/jkXEzuXQH/Mevw8QzhYjpgkLc6WK0gajQrPf/gQfvHcIdBX2B3dt3Y+ueY6i2ORBm0iMjLQUdu6SzyJKqF7O/WIARo94ISCPRjq0/v4nOGemwlhSQpDRciMjmptProDIY0Ln/09j+/XquHXcOuwFffTQRojKW273SgoNYu2k/2b9yisgURJ/i0adnB6I7TbkWZeVkou9dz+IohcXalomMY79DF0adaxrtAUGpmO0qt5KhtuHBRwZi/OO3o1Xr1icF979afxw6eBAvv/ctPv3ke/pIKq8U8em8qRh+x21wlOeQNWxAcTzuyIkSWWLjUEGmpNNNY5C3g3ilQo20a9MwfeL96H9TF9LL2NP1hLsmD7MXrsG4abNhIyYQBJGhd+v55iOHkmTOcbs8SjmrCKqkWAzsezV6dm2NFPJkOo2aJy6y8svxy5YDWPzDZniP5nP+JsbFYe6H43B3/1vgrMqDjyIlQWh4ILlkEpjm2ESUllOkMmwqtqzaGPAVFP9f06czbiIHmdYyAZEWA6dphcRFd2RmY+nq7Ti6kZxLuBm6uAiWrJhNHUf80cQuS4P8m0jYADfZHJQEnYSRvBhFJZyoV5RxiQTIO0bEYkC/bpj+3HC0bZVKIObziEMQLw2Ip0omoYHnX/kCb3y6DNUHs4NpNTI3+mggzBgg9Q6yoW4i5+FGqKPCiN0JRwmn51gy50Iz5Kx0o3oXCyGpT6rfL4Wz1WNRQ7hJh9TkJuialozbb+qK3r2v4banprSEc7hLJYmnBdNiovWORkHuYcxbvBZrKA7fczgfBWXV8FHAwMZKpLtWFIUs6rKNKkNr7un2Af4okCcXWjrsdldYk69qk4R1/5mE2GYJQa5VC3dVOQmqj6Sw8e2tsfmyZTUxoi6yENgFv1fA2Bdm4q1/zYM2OR7BvaklZ/ut89lqOFOxcw7BEp16DWIpnobfA3tVRd2yNUYQAxFgQDtsjJGQWrO8qS68BWKjKbLx+I43y27I7VglxUnciTgp/GL7OZfj1o2Px9B2OCjywQlqFt6QQIbKOW5+nVPairF8fXgcD6FMeldwbVywlVUGdjfJgFuIPkBtqee4uj6LERFEfVgUdkmAFHVaWO0uLPxuFTQqJZxEGSSqLdskolNaKoVotVCSRy8qLsD6TWvhJ9DFRmg7deYIbMnMIt9jvDRAaiJMPGF759CXAslTxhWdxMFUeqxcNhk33dgJtRVF6HTPDJSs30AjDgMaCRX6taEkSYwi0k0Bh+zxNTyQTG1ZotMfG3biS7dMcb0PEdbvgMKtECsdaGmuRImZ4tZwJdAIcWRCIKoVLHK5NBJZW+3DVck6LBlP8bdagOyWIHlkJDfTwcCwzamEyqjCLzPa48AxF9haKxqhexPiNHj38wK8O7cImnjNJZBIrwS9RkRqR3ImWqbWUsDXOGlla6iqKGR0kcrrBbTJMDfeM0JJWqSsKIfski6JRMrM3vEw0UWgyQTkyQMxnXIYwOlHoy00bo9POpkM+hsSSD+zd37C0WMlpXWfAuRlVIRKLxy18oldUaC0IYBk2c6nqTbXhCmRU+ZBi1H7ghv/lyeZZozMRkKgaVJnH2dSfeNc4u0/CmQPQaFY5fV69b6cQrYjz5XAKftweRcmAWSKyHNzpY6P7qOLsPSRvb7X6dPY+gbSRPUnv8ej8VVU466HBqNL+9ZEf0RcCQf6hUBGA8UUkb03eyFcxeXQxUQ+Jfv9m+jK/PoE8n4CTOPJK8aY8Y/g9Smjrti4eWi/63B9/0dRa3NQbKGdcC5Ang+ra8dPSlB8/djwO67oBETX9FQkZ6TBX2VlH5vUd/ZnMz+uoVJh+pufXdFALlu9EYc37YIyimfTss7JNJxHhpwd0cin1tG1haXofWtvZKS15CHilWMjQTayCnMXLIfgl6CNCGMbZ/3oyvLT0s8L2GpoI4jiKlLxRA87GFBbG8wqW3HiHPblWPw8lQaNITCNJjHQmYwUe/sm0qeXz8jjL2Cr4YAsSW3IHozWJsZNpNUyqbVqpCRGQxREinIuT0KuIHNVUhY4diiqOSTfEIiv0t9N5yzRf3Dzi5VMd2l129SMlti7aBpEjRpelkK7DIvKlIApr76PFyZ9FDgEwM6InsO+TX1sfvH7H89C8GQtVYV4ue5ciIFNsRMy1QznuQF2YVsN7MAlSbTTVQu9JMPBDrOfHC/QNZY514QxLh88L15rh93m5AdAf2+/m/XVqlVQs31o/pgG2TG3HTbqy63xWfrqyOSoTKagj/RBdtpgZxv/zI6f0tVkcMPLcpEnDjGct7FXXoz15eaCHbiPieVOKHPnfuTkl0FD6t+xfTIi45JILypgrbHz43en9mWzMEezfSAPdm3dj4LiChj0OmSkXwVTdFP4HWWw252/7UuLqVAIMEQR9ZMc2LpxD0rLq2E2GdClU0vqm4haawncbk+9H+a6KECyg8GmmARs27sfk6Z+gh+3HIC/wkbGQIH4pBg8NOQveHHCvbBEqmCtqKoDhO9WkFQYI5vg503bMPnFz/DLziNAtYOEUoWk5Fg8dv8tmDB6KEwKJWxWWx0gbAEUSgUMEXH4/se1eHHGXGzek8WyEfxEXMurmuDJRwfgiRG3Q1BUw+V01ev+Ub0DyTy3JSYe23fuRZebnwJKKwjAKP6AJMtJFu0pxLRdb2HbkXws+3gidAYdatk5G+75JAIxAcsJiH4DxwdOtLFndyLDCBAvcrbnYuK2GdibU4w5/34SWo8bHo8/aOVkDuKchStx35DnAoxGS4SauCCqPUSwD2PkpqnIL7di+jMj4PcWweevTytbz0Wv18LrduLece8SiNVA0xSMfjgZ6z5Lx5L32yG1B3nF6GQs/3Qx3p61GGpjdF1fg8WIyrISDB37DtlSEs+kJDw76iqs+zwd899MQ7MuCQRMEua+Ng/fLF4NjTnmRN8wC3Kzj+G+f7zDM/Oqq5rhlQktsZ76zn4lFdEd6L7meLw8ZRbW/LIRuvDoenZX9U0ljCZs37EP+3cdI5WKwl29LHjzldbokWFG/7vjsfyfKVDr2YFVHeav3Eoi7IRKGVAMUWPGmo27YTtawKXp8X6RmPZyK/ToYMSQBxPxzTPJnGYx47Hwx+1BxhDwC4LKjKWrtwF5ZXwPfcKdMXhmSgt0b2fEA08kYfZosssaPdlmN75asZk7sPo83HUR+IqIGpcn4AG9Mjq30PO/yHICh5xIitGQs1GzmfOzlfC4oFSKddbV4fYGMq3kOLq1pEjD5gs8bXDYgbREDfQxKs68avgDSe5fgeF0U1v++IaMq9l9K+i3cl28f/tmxBosCt7Xye4Lb73GYRcBSDlwxloReCjezvZqPFIAWPrP4fJT/Bp4uFytUtZRqNP1rWF7QV65rq+VPgtSoG1Ain/9qLCKnNnxtryvT66jNFaHP/AcDl3k96138WmA3POv6c25b0mc2u7kvmfTyt/0veiU/k9S5FN5bgjIP5KVEOBj5oXttcOJSis73qkIAXnexe5DcnMdkluwUNOEm6/twM+SS/Uomco/BZA1PoSbReyZ0RyH1Y+j49W9Ya8safwhYqMr/KFODwztjegYfg3F5Cp4PV4oVaqQap/3LMM1+G5+CaZNm4XS0iLojKaQRJ53CVchJ9uFAVPzgZLlsEoCXp08ihxQYb158D+HRKpElLNXRqjYdKNRXGnnOcpGHtk0wsLeQ6QW+BlONmX2Op0Qj2zEZjhUQkCGgAwBGSohIENAhoAMARkqISBDQIaADJULBDKSvehMo1VDz9/VffyQqQwTe6kb21b1yzBq6RbK4JE5SebPLirZG/EkP39vEDvTI590QNWoD75Pkh3C0ikCT2MF+5rot0RV4K2l/J5Q8iMygVSYGLhv8OAwa1uX3mGv+NEFx0F9jXptsK8c3G5QBO4r1aXUzjurcSH5yEOCTpNWUlSZk11Y8XbzpnHsXTk0UqWUeaQwHjbn09BpcajYswwO/480CREaUc7KdonWat94Qjgyv6TyYFWp9SOLWQ+Pz81neSS3tBV8/kfZ3vaeXNd8uP2bCUwRWoW8r6BW467yTqIVMNA9N9S67AvUapXIXgPLnjDdf6yoM+E5jJ37ySxwzxogYR+BKUIlyAcLPeGwSxOhVYsHs4t/8tbalqrVSpEthOR3SfRdb6iVA4NzqzhfMITQ/z0kZCNDQIaADJUzlv8JMAC9LWtoy+ibvAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 2180:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/37YxXNgrvP.png";

/***/ }),

/***/ 2181:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/3RhclKdA23.png";

/***/ }),

/***/ 2182:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 2183:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 2184:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDozZDJhYmIyNS1jMzAyLTVmNDYtOWI2ZC0zNWFkNjBmMzgxN2QiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NEYwNzQyMzE3NUYxMTFFODk4QzdFNzVEMUNDOUMyRkMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NEYwNzQyMzA3NUYxMTFFODk4QzdFNzVEMUNDOUMyRkMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NDk5NmUzM2YtNmJmNS1lNDQzLWIzOGYtYzRmZDM0NjA2MzJmIiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6YTQyMWI1N2YtNzUyMS0xMWU4LWFjNjctZDIyYWMwNTlhNjk1Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+lSKEzwAAAOJJREFUeNpi/P//PwM1ARMDlQELPkm2pQwhQKoUiPWhQsuAuOFXNMMjXHoYcXkZaJgLkNqNReoPEPsDDd1GqpdT8fgqn5wwFCdHDp+BX/HIfSDHwKt45E6SY6AeHjktcgw8h0fuAsnJBpp0ngMpCTThJ8AkI0tuTpmERWwKJVlvOhaxmZQYyIFFjJ0sA4HhJw2k5mGRmg+UkyI6UoCKLYBUARAHATErDn2/gXgdEE8ARtAJrAYCDeICUnOAOJLEEmsJEKcDDf6G7uUJZBgGAjFA3I0tDKMpKFejiUrY5ACAAAMACqM5RZrTsSYAAAAASUVORK5CYII="

/***/ }),

/***/ 2185:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 2186:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDozZDJhYmIyNS1jMzAyLTVmNDYtOWI2ZC0zNWFkNjBmMzgxN2QiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTRBQ0Y1N0M3NUYxMTFFOEJFNERCODQxMkM3QzZBRTEiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTRBQ0Y1N0I3NUYxMTFFOEJFNERCODQxMkM3QzZBRTEiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NDk5NmUzM2YtNmJmNS1lNDQzLWIzOGYtYzRmZDM0NjA2MzJmIiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6YTQyMWI1N2YtNzUyMS0xMWU4LWFjNjctZDIyYWMwNTlhNjk1Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Rz8b6QAAANNJREFUeNpi/P//PwM1AQshBWxLGdiB1Dko1+BXNMNvfOqZCBjGCKScgVgLil2hYqQbCNRoCHXZViRhEPssUE4flz5GbGEINewAEPPh0PcJiO2B3r9A0ECol0AK9QgEL0iNEdDQ/4S8bEqEYeAIAmJjYsJQl4RUokOMgbwkGChAUrIhB4xAA1HSITANTgdSfkAsRaT+Z0C8AZgWs3G5MIYEwxigamPxlTZW2BIrAXCGYF5Gy4rxQMoRyt0L9N5iSiPlGqjYAmIXIL5BUqQMymQDEGAA0kg1ndP2iVIAAAAASUVORK5CYII="

/***/ }),

/***/ 2187:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDozZDJhYmIyNS1jMzAyLTVmNDYtOWI2ZC0zNWFkNjBmMzgxN2QiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RUQ4RTZFRjM3ODVDMTFFOEE2NUFDODM4NEMyNDczRjMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RUQ4RTZFRjI3ODVDMTFFOEE2NUFDODM4NEMyNDczRjMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NDk5NmUzM2YtNmJmNS1lNDQzLWIzOGYtYzRmZDM0NjA2MzJmIiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6YTQyMWI1N2YtNzUyMS0xMWU4LWFjNjctZDIyYWMwNTlhNjk1Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+/Kmm/gAAAXpJREFUeNqclM0rBVEUwOdNHhZYygYLpSyUsrdQ/gJEjXxL6iVLsrBQslGULDxR78PC0sp/oV7JAilbSbOTjzd+R/fpujN3zJtTv+7UO/fXPfecd50gCJykZEvBBPgwastpcBJGY9nxWArgQo8tz00he4Oz1EJDJlF695znVEJkU4ZM4iBujxsjW2EpGjlX4PHbkm1fho5NsnbDaa0UJTuKyJfcY2iBafLLUSfMwy48IcpDP9+d4Bu5N9AHbWpfQd1vSCjHr0IzLEIFBmEZtuBF5Z5AztgbkmZkGCM6WYtbVUETyMxuR1xDVS//R2gZDz3W1foJC6r0SOmvMEYqJe/AnvrehweYgxEt7wvG/wgt0k2YgV4tTRp2CBewKqOkeuCHylN3kdM2PhoyiVa4J7cC0sgu2JDrCJ3QGOx2GIJhWxNCg20TKukAy3VSWZLHYa0eWewJOV2H/HsgCx8wi+z8v9cp7oGd12RjyC6TvJ1xJd/Baz0yiW8BBgBoo7i9fqkb7QAAAABJRU5ErkJggg=="

/***/ }),

/***/ 2188:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/4y4nwo8uFe.png";

/***/ }),

/***/ 2189:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDozZDJhYmIyNS1jMzAyLTVmNDYtOWI2ZC0zNWFkNjBmMzgxN2QiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6N0M2NzEwRDY3NUYxMTFFOEEyMzRGODBGMzFBRjUxNjgiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6N0M2NzEwRDU3NUYxMTFFOEEyMzRGODBGMzFBRjUxNjgiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NDk5NmUzM2YtNmJmNS1lNDQzLWIzOGYtYzRmZDM0NjA2MzJmIiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6YTQyMWI1N2YtNzUyMS0xMWU4LWFjNjctZDIyYWMwNTlhNjk1Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+uDwL6gAAAQlJREFUeNpi/P//PwM1ARMDlQELpQawLWUwB1JFQOz0K5pBlIVMQ0D6AoG4EIgtocIrSHYh0CA+IJUCxHlALI8m3Ue0gUCDFKCGgAzjxaLkKNC7pwkaCDTICuotkPeY8Sjtwxkp0PAJhga0GREeuA/EGzAMBBrED6RSgTgXiOVICNoJQO/+w+bCO0AsQmKEfwTiebjSoQUQ6wCxChCrArEylC2HJwPMBrruC7IAI6GsBwwKNiDlAMQ70aT+ArEi0MDHJGU9oIZfQOogEKPbvBrdMKLzMlDjTyD1GFdSIbdwuIctIVNi4B1CriPVwFvYEjIlBt7FlpApMfAyED9DT8jogJHaVQBAgAEA28RDG/+RwMMAAAAASUVORK5CYII="

/***/ }),

/***/ 2190:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 2191:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDoxYWQ4ZTkyNi03MWI3LTFjNGUtYjE0Zi1lMzY3NmQ3Y2JhYTAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MDBDNUUxN0I4OTYwMTFFODg2MUJENTkwNjgzNEZGNkMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MDBDNUUxN0E4OTYwMTFFODg2MUJENTkwNjgzNEZGNkMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OWMzMmIyYmMtZDU5Yy1jOTQ4LWIzYTMtNDUzNTZhNTUxODkxIiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6ZWEwZDQ2NzYtNzUzNC0xMWU4LWFjNjctZDIyYWMwNTlhNjk1Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+P+5e5wAAARxJREFUeNpi/P//PwM1ARMDlQHVDWSBMXp7e/GpmwXE34C4AF2iuLiYZBcGArEoEAsAcRs1vGwGxLeAeBkQmxDtZRyAFYijgdgGiOWAmItSF84H4vVfvnx5BKSlgPgZKS4UA+IlQMwGxB+B+C0Q/wQalg+V1wNiCSA+AOW/BuJkIP6Ey8AsID4G1RAExHZAnACTBBpcw8PDY4fkKw+ong5cXv4CxDxAjSAD/2LzDlDuEEgeqkYEiN/gC0OQN/lJSMOGQHwen4EfoGmNIAB6nRNIaQHxWaoYCASuQLybULIhxUA3IL5AKNm8A2IhoHcCoPynoNgG8hWw6IsCYhVCBt6FegOUVH4CcTwQd0LTHzqYDXUABmAceQUsQIABAJR7SYduEBNuAAAAAElFTkSuQmCC"

/***/ }),

/***/ 2192:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABL0lEQVQ4T92UMU7DQBBF/yxBtJtUdBgpdu2G3jfgCm6xG3MD3wA3dtocwdzA3MC0cZEbmG1JkAeNpUiOg5FJIoHYcld68//82SGc+dCZefg94CxbLZlJM6EwgZ0MORulUC8qDwxXQAJu3i8j83hrvoKOA2ZVBEJpHuxillZxs5kkJwGnaZXzZuILRBTWgeMfbVmnK1+BrDq0Y4FMs6p4C2xvFFAv1haa7T2BrhvmC6XojhgvO5hAdFZFiqEBCYhdZo5M6JS7Ans9lOoMSgC2FNj9zloLf1pruvrIu4oPgPIoqaoGXlfZkMV+C/4WUAIT5SZ0loM9/Inl7jidDJSJULyN+8Ed3cP2xxCVJpjn3cD2gO0CAN2AWRPoWVKWFAFwP2Vieq3DeXRw/3/24Vgnn0DLuhWGAyq4AAAAAElFTkSuQmCC"

/***/ }),

/***/ 2193:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/1LwoN3yj3A.png";

/***/ }),

/***/ 2194:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/3DJz_BrBWs.png";

/***/ }),

/***/ 2195:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/1qATGy18ji.png";

/***/ }),

/***/ 2196:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/1zvRg1FY3w.png";

/***/ }),

/***/ 2200:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2201:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2202:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(818);
module.exports = __webpack_require__(817);


/***/ }),

/***/ 2235:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/b5x6hLKKa9.png";

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var FormRules = {
    //身份证号验证
    IDCAR_RULE: {
        pattern: /^([1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3})|([1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|(\d{3}[X])))$/,
        message: "请输入正确的身份证号"
    },
    NUMBER: { pattern: /^[0-9]*$/, message: "请输入数字" },
    CN_CHARACTERS: { pattern: /^[\u4e00-\u9fa5]{0,}$/, message: "请输入汉字" },
    EN_CHARACTERS: { pattern: /^[A-Za-z]+$/, message: "请输入英文" },
    EN_NUMBER_UNDERLINE: { pattern: /^\\w+$/, message: "请输入英文、数字或下划线" },
    EN_NUMBER: { pattern: /^[A-Za-z0-9]+$/, message: "请输入英文或数字" },
    EMAIL: { pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: "请输入正确的邮箱地址" },
    MOBILE_PHONE_NUMBER: {
        // pattern: /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/,
        pattern: /^1\d{10}$/,
        message: "请输入正确的手机号码"
    },
    PHONE_NUMBER: { pattern: /\d{3}-\d{8}|\d{4}-\d{7}/, message: "请输入正确的电话号码" },
    QQ: { pattern: /[1-9][0-9]{4,}/, message: "请输入正确的QQ号" },
    POSTAL_CODE: { pattern: /[1-9]\d{5}(?!\d)/, message: "请输入正确的邮政编码" }

};
/* unused harmony default export */ var _unused_webpack_default_export = (FormRules);

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export offset */
/* unused harmony export getSize */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getHashParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getQueryString; });
/* unused harmony export dateFormat */
/* unused harmony export maxSlice */
// 获取元素距离可视区域顶部、左部的距离
var offset = function offset(ele) {
    var top = ele.offsetTop;
    var left = ele.offsetLeft;
    while (ele.offsetParent) {
        ele = ele.offsetParent;
        if (window.navigator.userAgent.indexOf('MSTE 8') > -1) {
            top += ele.offsetTop;
            left += ele.offsetLeft;
        } else {
            top += ele.offsetTop + ele.clientTop;
            left += ele.offsetLeft + ele.clientLeft;
        }
    }
    return {
        left: left,
        top: top
    };
};

var getSize = function getSize() {
    var windowW = void 0,
        windowH = void 0,
        contentH = void 0,
        contentW = void 0,
        scrollT = void 0;
    windowH = window.innerHeight;
    windowW = window.innerWidth;
    scrollT = document.documentElement.scrollTop || document.body.scrollTop;
    contentH = document.documentElement.scrollHeight > document.body.scrollHeight ? document.documentElement.scrollHeight : document.body.scrollHeight;
    contentW = document.documentElement.scrollWidth > document.body.scrollWidth ? document.documentElement.scrollWidth : document.body.scrollWidth;
    return { windowW: windowW, windowH: windowH, contentH: contentH, contentW: contentW, scrollT: scrollT };
};

// 获取url参数
var getHashParam = function getHashParam(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"),
        queryString = window.location.hash.split('?')[1] || '',
        result = queryString.match(reg);
    return result ? decodeURIComponent(result[2]) : null;
};

// 获取url参数
var getQueryString = function getQueryString(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
};

// 时间格式化
var dateFormat = function dateFormat() {
    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm:ss';

    var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }
    return format;
};

// 超出截取,...显示
var maxSlice = function maxSlice(v, maxLength) {
    return v.length > maxLength ? v.slice(0, maxLength) + '...' : v;
};

/***/ }),

/***/ 234:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"progress":"app__css__app-pages-SelfHelp-infoGdnhgs-__index__progress","jbxx_icon":"app__css__app-pages-SelfHelp-infoGdnhgs-__index__jbxx_icon","upload-box":"app__css__app-pages-SelfHelp-infoGdnhgs-__index__upload-box","upload-title":"app__css__app-pages-SelfHelp-infoGdnhgs-__index__upload-title","jbxx_item":"app__css__app-pages-SelfHelp-infoGdnhgs-__index__jbxx_item","jbxx_item2":"app__css__app-pages-SelfHelp-infoGdnhgs-__index__jbxx_item2","item-label":"app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-label","item-name":"app__css__app-pages-SelfHelp-infoGdnhgs-__index__item-name","kzxx_list":"app__css__app-pages-SelfHelp-infoGdnhgs-__index__kzxx_list","kzxx_item":"app__css__app-pages-SelfHelp-infoGdnhgs-__index__kzxx_item","kzxx_label":"app__css__app-pages-SelfHelp-infoGdnhgs-__index__kzxx_label","kzxx_name":"app__css__app-pages-SelfHelp-infoGdnhgs-__index__kzxx_name","kzxx_item_textarea":"app__css__app-pages-SelfHelp-infoGdnhgs-__index__kzxx_item_textarea","kzxx_name_textarea":"app__css__app-pages-SelfHelp-infoGdnhgs-__index__kzxx_name_textarea","btn_add":"app__css__app-pages-SelfHelp-infoGdnhgs-__index__btn_add","title_top":"app__css__app-pages-SelfHelp-infoGdnhgs-__index__title_top","title_top_name":"app__css__app-pages-SelfHelp-infoGdnhgs-__index__title_top_name","line":"app__css__app-pages-SelfHelp-infoGdnhgs-__index__line","detail_adrress":"app__css__app-pages-SelfHelp-infoGdnhgs-__index__detail_adrress"};

/***/ }),

/***/ 235:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"progress":"app__css__app-pages-SelfHelp-infoHncs-__index__progress","jbxx_icon":"app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_icon","upload-box":"app__css__app-pages-SelfHelp-infoHncs-__index__upload-box","upload-title":"app__css__app-pages-SelfHelp-infoHncs-__index__upload-title","jbxx_item":"app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item","jbxx_item2":"app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item2","jbxx_item3":"app__css__app-pages-SelfHelp-infoHncs-__index__jbxx_item3","item-label":"app__css__app-pages-SelfHelp-infoHncs-__index__item-label","item-name":"app__css__app-pages-SelfHelp-infoHncs-__index__item-name","kzxx_list":"app__css__app-pages-SelfHelp-infoHncs-__index__kzxx_list","kzxx_item":"app__css__app-pages-SelfHelp-infoHncs-__index__kzxx_item","kzxx_label":"app__css__app-pages-SelfHelp-infoHncs-__index__kzxx_label","kzxx_name":"app__css__app-pages-SelfHelp-infoHncs-__index__kzxx_name","kzxx_item_textarea":"app__css__app-pages-SelfHelp-infoHncs-__index__kzxx_item_textarea","kzxx_name_textarea":"app__css__app-pages-SelfHelp-infoHncs-__index__kzxx_name_textarea","btn_add":"app__css__app-pages-SelfHelp-infoHncs-__index__btn_add","title_top":"app__css__app-pages-SelfHelp-infoHncs-__index__title_top","title_top_name":"app__css__app-pages-SelfHelp-infoHncs-__index__title_top_name","line":"app__css__app-pages-SelfHelp-infoHncs-__index__line","detail_adrress":"app__css__app-pages-SelfHelp-infoHncs-__index__detail_adrress"};

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"progress":"app__css__app-pages-SelfHelp-updateInfoFg-__index__progress","jbxx_icon":"app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_icon","upload-box":"app__css__app-pages-SelfHelp-updateInfoFg-__index__upload-box","upload-title":"app__css__app-pages-SelfHelp-updateInfoFg-__index__upload-title","jbxx_item":"app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_item","jbxx_item2":"app__css__app-pages-SelfHelp-updateInfoFg-__index__jbxx_item2","item-label":"app__css__app-pages-SelfHelp-updateInfoFg-__index__item-label","item-name":"app__css__app-pages-SelfHelp-updateInfoFg-__index__item-name","kzxx_list":"app__css__app-pages-SelfHelp-updateInfoFg-__index__kzxx_list","kzxx_item":"app__css__app-pages-SelfHelp-updateInfoFg-__index__kzxx_item","kzxx_label":"app__css__app-pages-SelfHelp-updateInfoFg-__index__kzxx_label","kzxx_name":"app__css__app-pages-SelfHelp-updateInfoFg-__index__kzxx_name","kzxx_item_textarea":"app__css__app-pages-SelfHelp-updateInfoFg-__index__kzxx_item_textarea","kzxx_name_textarea":"app__css__app-pages-SelfHelp-updateInfoFg-__index__kzxx_name_textarea","btn_add":"app__css__app-pages-SelfHelp-updateInfoFg-__index__btn_add","title_top":"app__css__app-pages-SelfHelp-updateInfoFg-__index__title_top","title_top_name":"app__css__app-pages-SelfHelp-updateInfoFg-__index__title_top_name","line":"app__css__app-pages-SelfHelp-updateInfoFg-__index__line","detail_adrress":"app__css__app-pages-SelfHelp-updateInfoFg-__index__detail_adrress"};

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_NHFetch__ = __webpack_require__(7);








var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }






var pathUrl = "/proData/selectDataList";
var Option = __WEBPACK_IMPORTED_MODULE_6_antd_lib_select___default.a.Option;

/**
 * 多选下拉选择器
 * 1、符合自定义表单组件规范，结合FormItem使用时不会出现警告信息
 * 2、代码结构优化
 * 3、使用sign属性时，后台对应sign标识的sql查询语句列必须以value、label作为别名
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-03-13 15:54:13
 * Version: 1.3
 * Modify log:
 * 2018-04-25
 *     1、新增filterData属性，该属性可以过滤（或保留）指定keys值项
 *     2、新增dataSource属性，允许使用固定的数据源构造下拉数据，数据源格式为[{value:'value',label:'label'},{},...]
 * 2018-06-04
 *     1、解决sign为空或空字符串的时候，请求后台数据源报错问题
 */
var NHMultiSelect = (_temp = _class = function (_React$Component) {
    _inherits(NHMultiSelect, _React$Component);

    function NHMultiSelect(props) {
        _classCallCheck(this, NHMultiSelect);

        var _this = _possibleConstructorReturn(this, (NHMultiSelect.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(NHMultiSelect)).call(this, props));

        _initialiseProps.call(_this);

        var value = _this.props.value || [];
        var mode = _this.props.mode ? _this.props.mode === 'default' ? '' : _this.props.mode : 'multiple';
        _this.state = {
            data: [],
            value: value || [],
            mode: mode
        };

        return _this;
    }

    _createClass(NHMultiSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                sign = _props.sign,
                dataSource = _props.dataSource;

            //如果是使用数据源标识，则优先加载远程数据

            if (sign && sign != '') {
                this.loadRemoteData(sign);
            } else {
                //如果没有使用远程数据，则加载本地数据
                this.loadLocalData();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // Should be a controlled component.
            if ('value' in nextProps) {
                var value = nextProps.value;
                this.setState({ value: value });
            }

            //为了防止在使用本地数据源的时候，在上级组件使用异步请求，导致在componentDidMount阶段未能获取到返回的dataSource
            if ('dataSource' in nextProps) {
                var dataSource = nextProps.dataSource;
                this.setState({ data: dataSource });
            }
        }

        //加载远程数据


        //加载本地数据


        //解析数据


        //下拉选项选中时回调


        //下拉选择器input value值变化时回调


        //取消选中时调用


        //提供onChange回调方法给Form表单，表明这是一个自定义表单受控组件

    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                style = _props2.style,
                placeholder = _props2.placeholder,
                disabled = _props2.disabled,
                defaultValue = _props2.defaultValue,
                filterData = _props2.filterData;
            var _state = this.state,
                value = _state.value,
                data = _state.data,
                mode = _state.mode;

            var options = [];

            //如果有过滤条件
            if (filterData) {
                var type = filterData.type,
                    _filterData$filterkey = filterData.filterkeys,
                    filterkeys = _filterData$filterkey === undefined ? [] : _filterData$filterkey;


                switch (type) {
                    //过滤掉指定key值
                    case 'remove':
                        {
                            var newData = data.filter(function (item) {
                                if (filterkeys.find(function (key) {
                                    return (item.VALUE || item.value) == key;
                                })) {
                                    return false;
                                } else {
                                    return true;
                                }
                            });
                            options = newData.map(function (option) {
                                return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                                    Option,
                                    { key: option.VALUE || option.value, value: option.VALUE || option.value },
                                    option.LABEL || option.label
                                );
                            });
                            break;
                        }
                    //保留指定key值
                    case 'save':
                        {
                            var _newData = data.filter(function (item) {
                                if (filterkeys.find(function (key) {
                                    return (item.VALUE || item.value) == key;
                                })) {
                                    return true;
                                } else {
                                    return false;
                                }
                            });
                            options = _newData.map(function (option) {
                                return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                                    Option,
                                    { key: option.VALUE || option.value, value: option.VALUE || option.value },
                                    option.LABEL || option.label
                                );
                            });
                            break;
                        }
                    //未找到指定过滤类型，则不做过滤
                    default:
                        {
                            options = data.map(function (option) {
                                return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                                    Option,
                                    { key: option.VALUE || option.value, value: option.VALUE || option.value },
                                    option.LABEL || option.label
                                );
                            });
                            break;
                        }
                }
            } else {

                options = data.map(function (option) {
                    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                        Option,
                        { key: option.VALUE || option.value, value: option.VALUE || option.value },
                        option.LABEL || option.label
                    );
                });
            }
            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_select___default.a,
                    {
                        allowClear: true,
                        style: style,
                        mode: mode,
                        defaultValue: defaultValue,
                        value: value,
                        onSelect: this.handleSelect,
                        onChange: this.handleChange,
                        onDeselect: this.handleDeselect,
                        placeholder: placeholder,
                        notFoundContent: "无数据",
                        filterOption: function filterOption(input, option) {
                            return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                        },
                        disabled: disabled
                    },
                    options
                )
            );
        }
    }]);

    return NHMultiSelect;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.loadRemoteData = function (sign) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_NHFetch__["a" /* default */])(pathUrl, 'GET', { sign: sign }).then(function (res) {
            if (res) {
                _this2.parseData(res.data);
            }
        });
    };

    this.loadLocalData = function () {
        if (_this2.props.dataSource) {
            _this2.setState({ data: _this2.props.dataSource });
        }
    };

    this.parseData = function (data) {
        if (data) {
            _this2.setState({ data: data });
        } else {
            //如果远程数据为空，则尝试加载本地数据源
            _this2.loadLocalData();
        }
    };

    this.handleSelect = function (value, option) {

        var label = option.props.children;

        var onSelect = _this2.props.onSelect;
        if (onSelect) {
            onSelect(value, label, option);
        }
    };

    this.handleChange = function (value, option) {

        if (!('value' in _this2.props)) {
            _this2.setState({
                value: value
            });
        }

        _this2.triggerChange(value);
    };

    this.handleDeselect = function (value) {

        var values = [].concat(_toConsumableArray(_this2.state.value));
        var target = values.filter(function (item) {
            return item != value;
        });

        if (!('value' in _this2.props)) {
            _this2.setState({
                value: target
            });
        }

        var onDeselect = _this2.props.onDeselect;

        if (onDeselect) {
            onDeselect(value);
        }
    };

    this.triggerChange = function (changedValue) {
        // Should provide an event to pass value to Form.
        var onChange = _this2.props.onChange;
        if (onChange) {
            onChange(changedValue);
        }
    };
}, _temp);

//属性默认值

NHMultiSelect.defaultProps = {
    placeholder: '请选择...',
    disabled: false

    //属性检查
};NHMultiSelect.propTypes = {
    sign: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, //数据源标识
    dataSource: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
        value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
        label: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node
    })), //本地数据源
    style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object, //样式
    placeholder: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, //下拉提示
    disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool, //是否禁用
    defaultValue: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string), //默认值
    value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string), //初始值
    filterData: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
        type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['remove', 'save']), //是保留还是过滤掉
        filterkeys: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array //保留或过滤的key值
    }), //要过滤掉的Key值
    onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func, //下拉选项选中时回调
    onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func, //多选框值变化时回调
    onDeselect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func //多选框值删除时回调
};

/* harmony default export */ __webpack_exports__["a"] = (NHMultiSelect);

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"progress":"app__css__app-pages-SelfHelp-pInfo-__index__progress","jbxx_icon":"app__css__app-pages-SelfHelp-pInfo-__index__jbxx_icon","upload-box":"app__css__app-pages-SelfHelp-pInfo-__index__upload-box","upload-title":"app__css__app-pages-SelfHelp-pInfo-__index__upload-title","jbxx_item":"app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item","jbxx_item2":"app__css__app-pages-SelfHelp-pInfo-__index__jbxx_item2","item-label":"app__css__app-pages-SelfHelp-pInfo-__index__item-label","item-name":"app__css__app-pages-SelfHelp-pInfo-__index__item-name","kzxx_list":"app__css__app-pages-SelfHelp-pInfo-__index__kzxx_list","kzxx_item":"app__css__app-pages-SelfHelp-pInfo-__index__kzxx_item","kzxx_label":"app__css__app-pages-SelfHelp-pInfo-__index__kzxx_label","kzxx_name":"app__css__app-pages-SelfHelp-pInfo-__index__kzxx_name","kzxx_item_textarea":"app__css__app-pages-SelfHelp-pInfo-__index__kzxx_item_textarea","kzxx_name_textarea":"app__css__app-pages-SelfHelp-pInfo-__index__kzxx_name_textarea","btn_add":"app__css__app-pages-SelfHelp-pInfo-__index__btn_add","title_top":"app__css__app-pages-SelfHelp-pInfo-__index__title_top","title_top_name":"app__css__app-pages-SelfHelp-pInfo-__index__title_top_name","line":"app__css__app-pages-SelfHelp-pInfo-__index__line","detail_adrress":"app__css__app-pages-SelfHelp-pInfo-__index__detail_adrress"};

/***/ }),

/***/ 280:
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAABkAAD/4QONaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjYtYzEzOCA3OS4xNTk4MjQsIDIwMTYvMDkvMTQtMDE6MDk6MDEgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6YTZkNmYzZWYtMDYwMC0xODRjLWEzZDYtNDI4Yjk5ZTUxM2YzIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjQzMTI0Q0RGMjM1QzExRTg4MURFRjIwRjk3MTQyRDAzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjQzMTI0Q0RFMjM1QzExRTg4MURFRjIwRjk3MTQyRDAzIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE3IChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOmMyYTgwMzQ0LTJlNWQtY2Q0Mi05MThiLTIwMDUyYWQ4ZDJhMCIgc3RSZWY6ZG9jdW1lbnRJRD0iYWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOmVkZTdjOGQ1LTIxMTktMTFlOC1iOGJlLWU1MTljOTk2MjU5NiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pv/uAA5BZG9iZQBkwAAAAAH/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQECAgICAgICAgICAgMDAwMDAwMDAwMBAQEBAQEBAgEBAgICAQICAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDA//AABEIABQAFAMBEQACEQEDEQH/xACQAAACAwEAAAAAAAAAAAAAAAAGCQUHCAoBAAMBAQAAAAAAAAAAAAAAAAUGCAQHEAAABAQFAwMBCQEAAAAAAAADBAUGAhUWBwESExQXABEIIiMYITFBM2ODJJVmRygRAAAEBAQEAQsFAAAAAAAAAAECAwQREhMFIhQGFgAhFRcxQTJigjNDkyRFBycjgzRkNf/aAAwDAQACEQMRAD8A6+bo3buaLeZ8Mhuvd8t4s1ZARQGjaq0jWuM4FsoYaaK53E83MpPHGImlkCSg5SiYXAAjA7x4wxY4CxCY4hUhpHRmlCaGt9/ubC3uVXlY6zm4XFwyRSMVwqgi1QI2xKHMRBRc5jgflEIkAoTz3qrV+qDa1fWK2vn7dJpSKk3YW9B4sqUW6a6zlc7jCQhTrJoEKUS84DA4mGWnPkO8Vdpq70YfkdddyoCTGpJkDwUPG+38Ntyj3Sy4uETNd6gTIJzgT8QnHAGkH4y8AeAJsbLAYh/FweO2djZXlCxai0vZmtxWAimWJe3meM1UMHzLYhjnRPFETOUgOIiZMsTJD5gpw/cW9OrQterFqS7uWCM5AcHszQGZXJCj8u4OUhFSfqyt1RIAAU5oFUDzwYLyGrcDcsSojPeIuQ5JrjS2bUbUkq3XbcbHeezqds+n9ft6mvbLPuJs2sp0/rWSqwCenmaFSXzZ5cUPCPLw4oXcbvYO7aRM/wBHzlKIyVMtWpzeMs2GPjDn48L/AEEBsuBQuL5E3S8dUO48boebnTwX+/7g2iT2Q2ma0nSpW+ZiGhoL0XyxZvdyCKDvDJktAoH1QcXOJiFgWBBpG4qXW2trX9stIancWsrRigcWbNncTul3LhuR46VVWaomMtjVNSIQ4ootyElLOKpzz2wTtdwcXL7j6r04hcjOnq5Adu3dvI2RbN1ztGySSTlYpUcCRahzkBVVc5pjSAkQkwYTbEXkTlpmoPiDaVzCCpQ4iiFbO6njynuhITjPchisFVZlOlPX0OMIYfCEM2CMFFANjD2iwi7dYUnX3D0M6Qvlx1teWhCrABBfW+8nbqHLjpGTdNzoqxAIimYpgEsYhCPG1RtoHWbZezMNHWh0cURE4Mn1oIumQcFQqjZciqUBGAKFMUQNCAxhwW8gvv4VyLameQKy+MenvWxNcvK/DmvNdajKso31brvK5x68mh7fQbbWnu/HUJy7byPXYyr0/wDP6nCnDNZfM8qft8thmqYuDG4b92SyEhtw53okJkKn8/p0Z45bMZfnP7DMYpaeHjStvPjFWz74u4grzMb5Eo6mp3nnpjfVLK/cz1Lq62t9d7nze5m65Xqbuz0C3bu63t2Bclma9KFEslCpyhQlll91LDDDjpmnO13XH+1ej9fibOZajVjVGatJzjWmmm95GOKPBy/+JqKcnJNE0DsQarqWVU9Lt8V0Jxuv2u1mGjl1PTq5fv7dL+m95dea7Wz+46g5ehUrTyGjSlxTSTRl5yx8nB3UG0eiOdy5HoFMK9anRkmLCpNhlnlhHlNDy8A//MPB/wDjnx6zf1bjLcVB/BzCq/15j+d0wflnf/1zuXD+xnoUfiyZf1KPocAvxbsX6N27/YyUavwp6/rVvT4//9k="

/***/ }),

/***/ 281:
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAABkAAD/4QONaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjYtYzEzOCA3OS4xNTk4MjQsIDIwMTYvMDkvMTQtMDE6MDk6MDEgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6YTZkNmYzZWYtMDYwMC0xODRjLWEzZDYtNDI4Yjk5ZTUxM2YzIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkFFRUFGRUZDMjM1QzExRThCMEVCREY4QTgxRkU3NUE1IiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkFFRUFGRUZCMjM1QzExRThCMEVCREY4QTgxRkU3NUE1IiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE3IChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOmMyYTgwMzQ0LTJlNWQtY2Q0Mi05MThiLTIwMDUyYWQ4ZDJhMCIgc3RSZWY6ZG9jdW1lbnRJRD0iYWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOmVkZTdjOGQ1LTIxMTktMTFlOC1iOGJlLWU1MTljOTk2MjU5NiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pv/uAA5BZG9iZQBkwAAAAAH/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQECAgICAgICAgICAgMDAwMDAwMDAwMBAQEBAQEBAgEBAgICAQICAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDA//AABEIABgAGAMBEQACEQEDEQH/xABfAAACAwEAAAAAAAAAAAAAAAAEBQECBgoBAQAAAAAAAAAAAAAAAAAAAAAQAAIDAAICAgIDAQAAAAAAAAIEAQMFEQYAEhMUIQcxQVEVEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwDu83+w6q2vbm57fXchVDMS0dDV7IV80Gem44mkmsFLaFdRRKByRnbPtJiIj/M+AsLsG8K4Nl3H9ZCrbcdFbJC3C9l9QidtIXT2L4zurAokhieYiYmfAe9Y3dDRc0c7StxnTVVzdJPVwTunOeQ1CeqrGK7r2iC9e/OPkhtMDEhmOJ5jwMo/iu9w7a+/mu0Z2ZhEjmm/cjRpXN7mZGmTNKajfKcKJU7U12W2Ac/ZGYCI9JLwCq/1szTqMbNXaWR0W161bjLA66a01Venp6JEh9eq2YrGCMYgiiOJnwK9Vy2+pdnczNRihsOxKSxjaKyopV3sINP6Gqi0lUR0qNj/ANT5aYq4qspA+IggmJANHppW6WtVrdORv+5q9gfo7HbrDbUYuOMt5kMZlFtDf4rsCs4GY49Znn+/AkP129zX8uf0OYia/l9MzsUTIe0fLFclvz6lI8+vPPE8c8+ASp1U1u2ZDOb1FfGz8nQ0bLtiNepg3k7cp1OkK0IKy6r5mWKzmC4kYD8/54H/2Q=="

/***/ }),

/***/ 282:
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Index */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_css__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_SelfHelp_common_commonAction__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_SelfHelp_common_hint__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_Print__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_Router__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_prop_types__);







var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }

















/**
 * @author qianzhiwei
 * @date 2020/09/27
 * @description 打印基础页
 */

if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var Index = (_temp = _class = function (_Component) {
    _inherits(Index, _Component);

    function Index(props) {
        _classCallCheck(this, Index);

        var _this = _possibleConstructorReturn(this, (Index.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(Index)).call(this, props));

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__pages_SelfHelp_common_commonAction__["a" /* getQztjAndYlhjInfo */])(xsid, function () {
                var kfsj = res.data['kfsj'];
                var ylhj = res.data['ylhj'];
                var qzhj = res.data['qzhj'];
                _this.setState({ nonOperationalData: res.data });
                if (kfsj['YXSJ'] != '1') {
                    _this.setState({ operable: false });
                }

                if (ylhj && ylhj.length > 0) {
                    _this.setState({ operable: false });
                }

                if (qzhj && qzhj.length > 0) {
                    _this.setState({ operable: false });
                }
            });
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_14__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.onPrint = function () {
            _this.refs.print.onPrint();
        };

        _this.state = {
            mkbz: 'GD009',
            hjmc: '',
            loading: false,
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            PrintComponent: __WEBPACK_IMPORTED_MODULE_18__utils_Router__["b" /* basePrintComponent */],
            schoolCode: _this.props.schoolCode == '' ? 'lydx' : _this.props.schoolCode
            //printInfoUrl: this.props.printInfoUrl == '' || this.props.printInfoUrl == undefined ? `/zdybl/getInfoForPrint` : this.props.printInfoUrl,
        };
        return _this;
    }

    _createClass(Index, [{
        key: 'componentDidMount',
        value: function componentDidMount() {

            this.queryQztjAndYlhj();
            var schoolCode = this.state.schoolCode;

            var printComponent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_Router__["c" /* getBddComponent */])(schoolCode, 'print');
            this.setState({ PrintComponent: printComponent });
        }

        //查询前置条件和依赖环节


        //打印

    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                loading = _state.loading,
                operable = _state.operable,
                mkbz = _state.mkbz,
                hjmc = _state.hjmc,
                PrintComponent = _state.PrintComponent;
            var _props = this.props,
                extraData = _props.extraData,
                children = _props.children;

            return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_9__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230',
                        unShowBlzt: "0"
                        /*      active={8}*/
                        , mkbz: mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_9__components__["a" /* Flex */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_17__utils_Print__["a" /* default */],
                                { ref: 'print', lazyRender: true, insertHead: true, winStyle: 'toolbar=yes,menubar=yes', isIframe: false },
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PrintComponent, { initFormDate: this.props.initFormDate })
                            ),
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                null,
                                children
                            ),
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: 'p-sw-big text-center mt-30' },
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                                    {
                                        type: 'primary',
                                        loading: loading,
                                        onClick: this.onPrint
                                    },
                                    '\u6253\u5370'
                                ),
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CommonTip, { hjmc: "入学报到单打印", key: 'GD009', mkbz: 'GD009', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return Index;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]), _class.propTypes = {}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (Index);

/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NextIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_NHFetch__ = __webpack_require__(7);









var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }






var history = __WEBPACK_IMPORTED_MODULE_9_history_createHashHistory___default()();

var NextIndex = function (_React$Component) {
    _inherits(NextIndex, _React$Component);

    function NextIndex(props) {
        _classCallCheck(this, NextIndex);

        var _this = _possibleConstructorReturn(this, (NextIndex.__proto__ || __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default()(NextIndex)).call(this, props));

        _this.isLogin = function () {
            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!userId) {
                __WEBPACK_IMPORTED_MODULE_6_antd_lib_message___default.a.warning("未获取登录信息。");
                history.push({
                    pathname: '/index'
                });
                return false;
            }
            return true;
        };

        _this.getBddCssz = function () {
            var _this$props = _this.props,
                nextUrl = _this$props.nextUrl,
                search = _this$props.search;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_NHFetch__["a" /* default */])('/zzbdCommon/getCssz', 'GET', { csbz: 'YXXT_BDD_SCHOOL' }).then(function (res) {
                if (res) {
                    if (res.data) {
                        console.log('res.data', res.data);
                        _this.setState({ bddSchool: res.data }, function () {
                            _this.next(nextUrl, search);
                        });
                    } else {
                        _this.setState({ bddSchool: 'lydx' }, function () {
                            _this.next(nextUrl, search);
                        });
                    }
                } else {
                    _this.setState({ bddSchool: 'lydx' }, function () {
                        _this.next(nextUrl, search);
                    });
                }
            });
        };

        _this.next = function (nextUrl, search) {
            var bddSchool = _this.state.bddSchool;
            if (_this.isLogin()) {
                history.push({
                    pathname: nextUrl == '/print' ? '/' + bddSchool + 'Index' : nextUrl,
                    search: search
                });
            }
        };

        _this.state = {
            bddSchool: ''
        };
        return _this;
    }

    //获取报到单学校模板参数设置


    _createClass(NextIndex, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                nextUrl = _props.nextUrl,
                search = _props.search;

            return nextUrl ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                { onClick: function onClick() {
                        nextUrl == '/print' ? _this2.getBddCssz() : _this2.next(nextUrl, search);
                    }, className: 'ml-20', type: 'primary' },
                '\u4E0B\u4E00\u6B65'
            ) : ""
            /* <Button className="ml-20" type="primary"> 完成  </Button>*/
            ;
        }
    }]);

    return NextIndex;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);



/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mkbz; });
var mkbz = {
    GD001: '/personalInformation',
    GD001_7: '/personalInformationFg',
    GD002: '/buy',
    GD002_1: '/buyFa',
    GD003: '/clothingSize',
    GD004: '/report',
    GD005: '/channel',
    GD005_1: '/szjdChannel',
    GD005_2: '/channelFb',
    GD006: '/chooseDormitory',
    GD006_1: '/scjtChooseDor',
    GD006_2: '/checkDormitory',
    GD006_3: '/cdzyjsxyChooseDor',
    GD006_5: '/allotDormitory',
    GD006_6: '/nxyszyxyChooseDor',
    GD007: '/major',
    GD007_1: '/majorFa',
    GD007_2: '/majorFb',
    GD007_3: '/majorFc',
    GD008: '/onlinePayment',
    GD009: '/print',
    GD010: '/sszychannel',
    GD011: '/sszywsjxf',
    GD012: '/sszyssfp',
    GD013: '/ssxzywsjssf',
    GD014: '/schoolUniform',
    GD021: '/education',
    GD023: '/examination',
    GD0081: 'nonTaxPay',
    // GD022:'/autobiography',
    GD001_1: '/info',
    GD008_1: '/onlinePaymentFxxy',
    GD008_3: '/wxChatPay',
    GD001_2: '/pInfo',
    GD004_1: '/reportGdnhgs',
    GD004_3: '/reportCzxy',
    GD001_5: '/infoGdnhgs',
    GD001_6: '/infoHncs',
    GD004_2: '/reportHncs',
    GD005_4: '/channelZtxy',
    GD005_5: '/channelTlxy',
    GD005_6: '/channelCzxy',
    GD027_1: '/choosePhoneNum',
    GD001_4: '/newInfo',
    GD001_3: '/szjdInfo',
    GD031: '/mentalHealthSurvey',
    GD032: '/applyDorm',
    GD033: '/viewStudentId',
    GD005_8: '/ahGsLsTd',
    GD034: '/antiepidemic',
    GD004_4: '/reportwhrj',
    GD006_4: '/whrjChooseDor',
    GD024_1: '/medicalInsurance',
    GD005_11: '/lstdghlb'
};

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_NHFetch__ = __webpack_require__(7);





var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }




var Hint = function (_React$Component) {
    _inherits(Hint, _React$Component);

    function Hint(props) {
        _classCallCheck(this, Hint);

        var _this = _possibleConstructorReturn(this, (Hint.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Hint)).call(this, props));

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.getHint = function () {
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_NHFetch__["a" /* default */])("/zzbd/getHint", 'GET', { zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    _this.setState({ hint: res.data });
                }
            });
        };

        _this.state = {
            hint: ''
        };
        return _this;
    }

    _createClass(Hint, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getHint();
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                { className: 'tip' },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.hint } })
            );
        }
    }]);

    return Hint;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);



/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommonTip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_card_style__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_card__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row_style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_row_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_row_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col_style__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_col_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_col_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_is__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Assembly_siderMenu_menuObj__ = __webpack_require__(34);














var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }












var history = __WEBPACK_IMPORTED_MODULE_21_history_createHashHistory___default()();

var CommonTip = function (_React$Component) {
    _inherits(CommonTip, _React$Component);

    function CommonTip(props) {
        _classCallCheck(this, CommonTip);

        var _this = _possibleConstructorReturn(this, (CommonTip.__proto__ || __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_get_prototype_of___default()(CommonTip)).call(this, props));

        _this.setMenuList = function (menuList) {
            _this.setState({ menuList: menuList });
            _this.setNext(menuList);
        };

        _this.setNext = function (menuList) {
            if (!menuList || menuList.length == 0) {
                return;
            }
            var nextCount = 0;
            var bz = _this.props.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_22__Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = '/customLink';
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.to_ylhj = function (elem) {
            var hjdm = elem.HJDM;
            if (hjdm.indexOf('GD') == 0) {
                var hashUrl = __WEBPACK_IMPORTED_MODULE_22__Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                history.push({
                    pathname: hashUrl,
                    search: 'pkid=' + elem.PKID
                });
            } else if (hjdm.indexOf('ZDY') == 0) {
                var _hashUrl = '/customLink';
                history.push({
                    pathname: _hashUrl,
                    search: 'pkid=' + elem.PKID + '&mkbz=' + hjdm + '&lx=' + elem.LX
                });
            }
        };

        _this.state = {
            nextUrl: '',
            search: '',
            menuList: []
        };
        return _this;
    }

    _createClass(CommonTip, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var nonOperationalData = this.props.nonOperationalData;
            var nextnonOperationalData = nextProps.nonOperationalData;
            var mkbz = this.props.mkbz;
            var nextMkbz = nextProps.mkbz;
            if (__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_is___default()(nonOperationalData, nextnonOperationalData) && __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_is___default()(mkbz, nextMkbz)) {
                this.setNext(this.state.menuList);
            }
        }

        //依赖环节跳转路径

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var data = this.props.nonOperationalData;
            return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                'div',
                { style: { position: 'relative' } },
                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_Assembly_siderMenu__["a" /* default */], {
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230',
                        mkbz: this.props.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230' }),
                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */].Item,
                        { className: 'page_con_r ' },
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.props.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                { className: 'tip' },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    { className: 'text-info-red' },
                                    '\u6E29\u99A8\u63D0\u793A\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'span',
                                    null,
                                    '\u4EE5\u4E0B\u539F\u56E0\u5BFC\u81F4\u8BE5\u73AF\u8282\u6682\u672A\u5F00\u653E'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_Assembly_titleTop__["a" /* default */], { title: '\u539F\u56E0\u63D0\u793A', extra: false }),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_16__components__["a" /* Flex */],
                                { align: 'start', wrap: 'wrap' },
                                data['nologin'] && __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_card___default.a,
                                    { style: { paddingLeft: 0, width: '100%' }, bordered: false },
                                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_row___default.a,
                                        { gutter: 24 },
                                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_10_antd_lib_col___default.a,
                                            { span: 24, style: { lineHeight: '22px', marginTop: '30px' } },
                                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                                'span',
                                                { className: 'text-info-red' },
                                                '\u767B\u5F55\u8D85\u65F6'
                                            )
                                        )
                                    )
                                ),
                                data['kfsj'] && data['kfsj']['YXSJ'] != '1' && __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_card___default.a,
                                    { style: { paddingLeft: 0, width: '100%' }, bordered: false },
                                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_row___default.a,
                                        { gutter: 24 },
                                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_10_antd_lib_col___default.a,
                                            { span: 24, style: { lineHeight: '22px', marginTop: '30px' } },
                                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                                'b',
                                                { style: { fontSize: '15px' } },
                                                '\u5F00\u653E\u65F6\u95F4'
                                            ),
                                            '\uFF1A',
                                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                                'span',
                                                { className: 'text-info-red' },
                                                data['kfsj']['KSSJ']
                                            ),
                                            '\u2003\u81F3\u2003',
                                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                                'span',
                                                { className: 'text-info-red' },
                                                data['kfsj']['JSSJ']
                                            )
                                        )
                                    )
                                ),
                                data['ylhj'] && data['ylhj'].length > 0 && __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'div',
                                    { style: { width: '100%', position: 'relative', marginTop: '30px', left: '21px', textAlign: 'left' } },
                                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                        'p',
                                        { style: { color: '#a49e9e', fontSize: '15px' } },
                                        '\u4EE5\u4E0B\u73AF\u8282\u672A\u529E\u7406\uFF0C\u8BF7\u5148\u529E\u7406\uFF01'
                                    ),
                                    data['ylhj'].map(function (elem, index) {
                                        return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                                            { type: 'primary', onClick: function onClick() {
                                                    _this2.to_ylhj(elem);
                                                }, style: { marginRight: '10px' }, ghost: true },
                                            elem.HJMC
                                        )
                                        // <Button onClick={()=>{this.to_ylhj(elem)}} type="primary" style={{marginRight:'10px'}}>{elem.HJMC}</Button>
                                        ;
                                    })
                                ),
                                data['qzhj'] && data['qzhj'].length > 0 && __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_card___default.a,
                                    { style: { paddingLeft: 0, width: '100%' }, bordered: false },
                                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_row___default.a,
                                        { gutter: 24 },
                                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_10_antd_lib_col___default.a,
                                            { span: 24, style: { lineHeight: '22px', marginTop: '30px' } },
                                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                                'p',
                                                { style: { color: '#a49e9e', fontSize: '15px' } },
                                                '\u4EE5\u4E0B\u8FCE\u65B0\u73B0\u573A\u73AF\u8282\u6216\u672A\u529E\u7406\uFF0C\u8BF7\u5148\u529E\u7406\uFF01'
                                            ),
                                            data['qzhj'].map(function (elem, index) {
                                                return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_4_antd_lib_button___default.a,
                                                    { type: 'primary', style: { marginRight: '10px' } },
                                                    elem.hjmc
                                                );
                                            })
                                        )
                                    )
                                ),
                                data['notAllowed'] && __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_card___default.a,
                                    { style: { paddingLeft: 0, width: '100%' }, bordered: false },
                                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_8_antd_lib_row___default.a,
                                        { gutter: 24 },
                                        __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_10_antd_lib_col___default.a,
                                            { span: 24, style: { lineHeight: '22px', marginTop: '30px' } },
                                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                                'span',
                                                { className: 'text-info-red' },
                                                data.notAllowedMsg
                                            )
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                    'div',
                                    { style: { textAlign: 'right', width: '100%' } },
                                    __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', { src: __webpack_require__(2188) })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
                                'div',
                                { className: 'text-center mt-50' },
                                __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return CommonTip;
}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);



/***/ }),

/***/ 371:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RECEIVE_USERINFO */
/* unused harmony export receiveUserInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return userLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return userLogout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tryLoginUserInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jsencrypt__ = __webpack_require__(1727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jsencrypt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jsencrypt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_NHCore__ = __webpack_require__(8);









//公钥
var pubKey = "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAPaJRiLeajOhWQhK1HdO/2JVofnwS1APB8R8R85HWtlsAoWMQgVPyJVtqbj3T1cCqenlIkgFv/MuchmvXxJpePkCAwEAAQ==";

var querystring = __webpack_require__(1887); //将POST请求参数转换请求字符串

var RECEIVE_USERINFO = 'RECEIVE_USERINFO';

var receiveUserInfo = function receiveUserInfo(user) {
    return {
        type: RECEIVE_USERINFO,
        data: user
    };
};

var userLogin = function userLogin(params, func) {
    var username = params.username;
    //公钥加密

    var encrypt = new __WEBPACK_IMPORTED_MODULE_6_jsencrypt__["JSEncrypt"]();
    encrypt.setPublicKey(pubKey);
    var encryptPassword = encrypt.encrypt(params.password); //password为需要加密的字段
    params.password = encryptPassword;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_NHFetch__["a" /* default */])('api/shiro/cache/' + username + '/delete', 'POST').then(function () {
        fetch("yx/yxwz/login", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "X-Requested-With": "XMLHttpRequest"
            },
            body: querystring.stringify(params)
        }).then(function (response) {
            return response.json();
        }).then(function (res) {
            if (res.meta && res.meta.statusCode == '200') {
                sessionStorage.setItem("userLogin", __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(res.data));
                sessionStorage.setItem('access_token', res.data.tokenId);
                sessionStorage.setItem('zh', username);
                if (window.casLogoutUrl && window.casLogoutUrl != '') {
                    window.location = window.casLogoutUrl;
                } else {
                    location.reload();
                }
            } else {
                if (func) {
                    func();
                }
                console.log(res);
                __WEBPACK_IMPORTED_MODULE_3_antd_lib_message___default.a.error(res.meta.message);
            }
            return res;
        }).catch(function (error) {
            if (func) {
                func();
            }
            // 网络请求失败返回执行该回调函数，得到错误信息
            __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.error({ title: '网络请求异常,请联系管理员', content: error });
            return error;
        });
    });
};

var userLogout = function userLogout() {
    var zh = sessionStorage.getItem("zh");
    fetch("logout", {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-Requested-With": "XMLHttpRequest"
        }
    }).then(function (response) {
        return response.json();
    }).then(function (res) {
        if (res.meta && res.meta.statusCode == '200') {
            sessionStorage.removeItem("userLogin");
            sessionStorage.removeItem("access_token");
            if (window.casLogoutUrl && window.casLogoutUrl != '') {
                window.location = window.casLogoutUrl;
            } else {
                location.reload();
            }
            if (zh) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_NHFetch__["a" /* default */])('api/shiro/cache/' + zh + '/delete', 'POST');
            }
        } else {
            __WEBPACK_IMPORTED_MODULE_3_antd_lib_message___default.a.error("退出登陆失败，请稍后再试一次！");
        }
        return res;
    }).catch(function (error) {
        // 网络请求失败返回执行该回调函数，得到错误信息
        __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.error({ title: '网络请求异常,请联系管理员', content: error });
        return error;
    });
};

/**
 * 获取已经登录的用户信息
 * @param func
 */
var tryLoginUserInfo = function tryLoginUserInfo(func) {
    //第一步，清空缓存
    sessionStorage.removeItem("userLogin");
    sessionStorage.removeItem("access_token");
    fetch("tryLoginUserInfo", {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-Requested-With": "XMLHttpRequest"
        }
    }).then(function (response) {
        return response.json();
    }).then(function (res) {
        if (res.meta && res.meta.statusCode == '200') {
            if (res.data) {
                sessionStorage.setItem("userLogin", __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(res.data));
                sessionStorage.setItem('access_token', res.data.tokenId);
            } else {
                sso(func);
            }
        }
        sso(func);
        return res;
    }).catch(function (error) {
        if (func) {
            func();
        }
        // 网络请求失败返回执行该回调函数，得到错误信息
        __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.error({ title: '网络请求异常,请联系管理员', content: error });
        return error;
    });
};

//单点登录验证
var sso = function sso(func) {

    var userLogin = sessionStorage.getItem("userLogin");
    if (userLogin) {
        if (func) {
            func();
        }
    } else {
        //是否启用单点登录
        if (window.casStatus) {
            var urlencode = __webpack_require__(490);
            //跳转至单点登录验证页面
            window.location = window.location.origin + window.location.pathname + 'auth?service=' + urlencode(window.location.origin + window.location.pathname);
        } else {
            if (func) {
                func();
            }
        }
    }
};

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);








var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }






var FormItem = __WEBPACK_IMPORTED_MODULE_6_antd_lib_form___default.a.Item;

/**
 * 封装FormItem
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-03-01 16:09:31
 * Version: 1.0
 * Modify log:
 *  2018-03-01：1、优化封装；2、添加自定义校验、支持多校验规则
 */

var NHFormItem = function (_React$Component) {
    _inherits(NHFormItem, _React$Component);

    function NHFormItem(props) {
        _classCallCheck(this, NHFormItem);

        var _this = _possibleConstructorReturn(this, (NHFormItem.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(NHFormItem)).call(this, props));

        _this.state = {};
        return _this;
    }

    _createClass(NHFormItem, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                label = _props.label,
                id = _props.id,
                required = _props.required,
                hasFeedback = _props.hasFeedback,
                form = _props.form,
                colon = _props.colon,
                extra = _props.extra,
                formItemLayout = _props.formItemLayout,
                pattern = _props.pattern,
                valuePropName = _props.valuePropName,
                validator = _props.validator,
                validateTrigger = _props.validateTrigger,
                initialValue = _props.initialValue,
                showFlag = _props.showFlag;
            var getFieldDecorator = form.getFieldDecorator;

            //校验规则数组

            var rules = [];

            //如果是必填项
            if (required) {
                rules.push({
                    required: required,
                    message: typeof label === "string" && label != '' ? label + '不能为空！' : '该项不能为空！'
                });
            }

            //正则校验
            if (pattern) {
                rules.push(pattern);
            }

            //自定义校验
            if (validator) {
                rules.push({
                    validator: validator
                });
            }

            //是否显示表单项，用于权限控制
            if (showFlag) {
                if (rules.length > 0) {
                    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                        FormItem,
                        _extends({}, formItemLayout, {
                            label: label,
                            hasFeedback: hasFeedback,
                            colon: colon,
                            extra: extra
                        }),
                        getFieldDecorator(id, {
                            valuePropName: valuePropName,
                            rules: rules,
                            initialValue: initialValue,
                            validateTrigger: validateTrigger
                        })(this.props.children)
                    );
                } else {
                    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                        FormItem,
                        _extends({}, formItemLayout, {
                            label: label,
                            hasFeedback: hasFeedback,
                            colon: colon,
                            extra: extra
                        }),
                        getFieldDecorator(id, {
                            valuePropName: valuePropName,
                            initialValue: initialValue,
                            validateTrigger: validateTrigger
                        })(this.props.children)
                    );
                }
            } else {
                return null;
            }
        }
    }]);

    return NHFormItem;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

NHFormItem.defaultProps = {
    label: '', //标签的文本
    id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHCore__["c" /* createUuid */])(), //输入控件唯一标志
    formItemLayout: {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 6 },
            md: { span: 7 }
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 12 },
            md: { span: 10 }
        }
    }, //表单项布局
    required: false, //是否必选
    valuePropName: 'value', //值属性名称
    hasFeedback: false, //展示校验状态图标
    colon: true, //配合 label 属性使用，表示是否显示 label 后面的冒号
    showFlag: true //是否显示表单项


    /**
     * 属性类型检查
     */
};NHFormItem.propTypes = {
    id: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired, //必填输入控件唯一标志，必需
    label: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, //字段标签，非必需
    required: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool, //是否必填，非必需
    hasFeedback: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool, //展示校验状态图标，非必需
    form: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object.isRequired, //this.props.form，必需
    colon: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool, //是否显示 label 后面的冒号，非必需
    extra: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.node]), //额外的提示信息,一般不需要，非必需
    formItemLayout: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object, //自定义的布局，非必需
    initialValue: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any, //初始值
    pattern: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object, //常用正则验证或额外验证，非必需
    valuePropName: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, //表单项值属性，非必需
    validator: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func, //自定义校验方法，非必需
    validateTrigger: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string)]), //表单项自定义校验时机，非必需
    showFlag: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool //是否显示表单项，非必需
};

/* harmony default export */ __webpack_exports__["a"] = (NHFormItem);

/***/ }),

/***/ 431:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tab_box":"app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__tab_box","tip":"app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__tip","item":"app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__item","item_con":"app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__item_con","round":"app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__round","select_box":"app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__select_box","select_list":"app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__select_list","select_item":"app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__select_item","select_item_b":"app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__select_item_b","select_item_y":"app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__select_item_y","item_btn_box":"app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__item_btn_box","item_btn":"app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__item_btn","modal_box":"app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__modal_box","modal_list":"app__css__app-pages-SelfHelp-cdzyjsxyChooseDor-__index__modal_list"};

/***/ }),

/***/ 432:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tab_box":"app__css__app-pages-SelfHelp-dorm-__index__tab_box","tip":"app__css__app-pages-SelfHelp-dorm-__index__tip","item":"app__css__app-pages-SelfHelp-dorm-__index__item","item_con":"app__css__app-pages-SelfHelp-dorm-__index__item_con","round":"app__css__app-pages-SelfHelp-dorm-__index__round","select_box":"app__css__app-pages-SelfHelp-dorm-__index__select_box","select_list":"app__css__app-pages-SelfHelp-dorm-__index__select_list","select_item":"app__css__app-pages-SelfHelp-dorm-__index__select_item","select_item_b":"app__css__app-pages-SelfHelp-dorm-__index__select_item_b","select_item_y":"app__css__app-pages-SelfHelp-dorm-__index__select_item_y","item_btn_box":"app__css__app-pages-SelfHelp-dorm-__index__item_btn_box","item_btn":"app__css__app-pages-SelfHelp-dorm-__index__item_btn","modal_box":"app__css__app-pages-SelfHelp-dorm-__index__modal_box","modal_list":"app__css__app-pages-SelfHelp-dorm-__index__modal_list"};

/***/ }),

/***/ 433:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tab_box":"app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__tab_box","tip":"app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__tip","item":"app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__item","item_con":"app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__item_con","round":"app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__round","select_box":"app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__select_box","select_list":"app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__select_list","select_item":"app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__select_item","select_item_b":"app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__select_item_b","select_item_y":"app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__select_item_y","item_btn_box":"app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__item_btn_box","item_btn":"app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__item_btn","modal_box":"app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__modal_box","modal_list":"app__css__app-pages-SelfHelp-nxyszyxyChooseDor-__index__modal_list"};

/***/ }),

/***/ 434:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tab_box":"app__css__app-pages-SelfHelp-scjtChooseDor-__index__tab_box","tip":"app__css__app-pages-SelfHelp-scjtChooseDor-__index__tip","item":"app__css__app-pages-SelfHelp-scjtChooseDor-__index__item","item_con":"app__css__app-pages-SelfHelp-scjtChooseDor-__index__item_con","round":"app__css__app-pages-SelfHelp-scjtChooseDor-__index__round","select_box":"app__css__app-pages-SelfHelp-scjtChooseDor-__index__select_box","select_list":"app__css__app-pages-SelfHelp-scjtChooseDor-__index__select_list","select_item":"app__css__app-pages-SelfHelp-scjtChooseDor-__index__select_item","select_item_b":"app__css__app-pages-SelfHelp-scjtChooseDor-__index__select_item_b","select_item_y":"app__css__app-pages-SelfHelp-scjtChooseDor-__index__select_item_y","item_btn_box":"app__css__app-pages-SelfHelp-scjtChooseDor-__index__item_btn_box","item_btn":"app__css__app-pages-SelfHelp-scjtChooseDor-__index__item_btn","modal_box":"app__css__app-pages-SelfHelp-scjtChooseDor-__index__modal_box","modal_list":"app__css__app-pages-SelfHelp-scjtChooseDor-__index__modal_list","dorPic":"app__css__app-pages-SelfHelp-scjtChooseDor-__index__dorPic"};

/***/ }),

/***/ 435:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tab_box":"app__css__app-pages-SelfHelp-sszydorm-__index__tab_box","tip":"app__css__app-pages-SelfHelp-sszydorm-__index__tip","item":"app__css__app-pages-SelfHelp-sszydorm-__index__item","item_con":"app__css__app-pages-SelfHelp-sszydorm-__index__item_con","round":"app__css__app-pages-SelfHelp-sszydorm-__index__round","select_box":"app__css__app-pages-SelfHelp-sszydorm-__index__select_box","select_list":"app__css__app-pages-SelfHelp-sszydorm-__index__select_list","select_item":"app__css__app-pages-SelfHelp-sszydorm-__index__select_item","select_item_b":"app__css__app-pages-SelfHelp-sszydorm-__index__select_item_b","select_item_y":"app__css__app-pages-SelfHelp-sszydorm-__index__select_item_y","item_btn_box":"app__css__app-pages-SelfHelp-sszydorm-__index__item_btn_box","item_btn":"app__css__app-pages-SelfHelp-sszydorm-__index__item_btn","modal_box":"app__css__app-pages-SelfHelp-sszydorm-__index__modal_box","modal_list":"app__css__app-pages-SelfHelp-sszydorm-__index__modal_list"};

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);



var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var prefixCls = 'c-flex';

var Flex = function Flex(props) {
    var _classNames;

    var direction = props.direction,
        wrap = props.wrap,
        justify = props.justify,
        _props$align = props.align,
        align = _props$align === undefined ? 'center' : _props$align,
        alignContent = props.alignContent,
        className = props.className,
        children = props.children,
        style = props.style,
        onclick = props.onclick,
        restProps = _objectWithoutProperties(props, ['direction', 'wrap', 'justify', 'align', 'alignContent', 'className', 'children', 'style', 'onclick']);

    var wrapCls = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, prefixCls + '-dir-row', direction === 'row'), _defineProperty(_classNames, prefixCls + '-dir-row-reverse', direction === 'row-reverse'), _defineProperty(_classNames, prefixCls + '-dir-column', direction === 'column'), _defineProperty(_classNames, prefixCls + '-dir-column-reverse', direction === 'column-reverse'), _defineProperty(_classNames, prefixCls + '-nowrap', wrap === 'nowrap'), _defineProperty(_classNames, prefixCls + '-wrap', wrap === 'wrap'), _defineProperty(_classNames, prefixCls + '-wrap-reverse', wrap === 'wrap-reverse'), _defineProperty(_classNames, prefixCls + '-justify-start', justify === 'start'), _defineProperty(_classNames, prefixCls + '-justify-end', justify === 'end'), _defineProperty(_classNames, prefixCls + '-justify-center', justify === 'center'), _defineProperty(_classNames, prefixCls + '-justify-between', justify === 'between'), _defineProperty(_classNames, prefixCls + '-justify-around', justify === 'around'), _defineProperty(_classNames, prefixCls + '-align-start', align === 'start'), _defineProperty(_classNames, prefixCls + '-align-center', align === 'center'), _defineProperty(_classNames, prefixCls + '-align-end', align === 'end'), _defineProperty(_classNames, prefixCls + '-align-baseline', align === 'baseline'), _defineProperty(_classNames, prefixCls + '-align-stretch', align === 'stretch'), _defineProperty(_classNames, prefixCls + '-align-content-start', alignContent === 'start'), _defineProperty(_classNames, prefixCls + '-align-content-end', alignContent === 'end'), _defineProperty(_classNames, prefixCls + '-align-content-center', alignContent === 'center'), _defineProperty(_classNames, prefixCls + '-align-content-between', alignContent === 'between'), _defineProperty(_classNames, prefixCls + '-align-content-around', alignContent === 'around'), _defineProperty(_classNames, prefixCls + '-align-content-stretch', alignContent === 'stretch'), _classNames));

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        _extends({ onClick: onclick, className: wrapCls, style: style }, restProps),
        children
    );
};

Flex.Item = function (props) {
    var children = props.children,
        className = props.className,
        style = props.style,
        onclick = props.onclick,
        restProps = _objectWithoutProperties(props, ['children', 'className', 'style', 'onclick']);

    var wrapCls = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(prefixCls + '-item', className);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        _extends({ className: wrapCls, style: style }, restProps),
        children
    );
};

/* harmony default export */ __webpack_exports__["a"] = (Flex);

/***/ }),

/***/ 537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio_style__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_NHFetch__ = __webpack_require__(7);








var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }






var RadioGroup = __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio___default.a.Group;

var pathUrl = "/proData/selectDataList";

/**
 * @Description: 单选按钮组控件
 * @author weishihuai
 * @date 2019/3/6 15:06
 * 更新日志：
 * 2019-05-23：增加RadioButton样式支持 by zengxiangkai
 * 使用说明:
 * 1. 使用sign标识从后台查询数据源时，以'DMK_'加上对应代码库标识,如: sign={'DMK_WJCF_WJLX'}
 * 2. 使用自定义数据源时,需注意格式. 如: [{"VALUE":"1","LABEL":"日常违纪"},{"VALUE":"2","LABEL":"考试违纪"},{"VALUE":"3","LABEL":"公寓违纪"}]
 * 3. 使用radioDisabledArr属性可动态配置需要禁用的按钮VALUE值,如: radioDisabledArr={['2','3']}
 * 4. 使用filterType集合filterData可以过滤指定按钮, 如: filterType={'save'} filterData={['2', '3', '4']}
 * 5. 使用示例:
 * <NHRadioGroup
 *      onChange={this.onWjlxChangeListener}
 *      radioStyle={radioStyle}
 *      sign={'DMK_WJCF_WJLX'}
 *      radioGroupDisabled={false}
 *      radioDisabledArr={['1', '2']}
 *      filterType={'save'}
 *      filterData={['2', '3', '4']}
 * />
 *
 */
var NHRadioGroup = (_temp = _class = function (_React$Component) {
    _inherits(NHRadioGroup, _React$Component);

    function NHRadioGroup(props) {
        _classCallCheck(this, NHRadioGroup);

        var _this = _possibleConstructorReturn(this, (NHRadioGroup.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(NHRadioGroup)).call(this, props));

        _initialiseProps.call(_this);

        var _this$props$value = _this.props.value,
            value = _this$props$value === undefined ? '' : _this$props$value;

        _this.state = {
            data: [],
            value: value,
            radioOptions: []
        };
        return _this;
    }

    _createClass(NHRadioGroup, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this._isMounted = true;
            var sign = this.props.sign;

            this.getDataSource(sign);
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this._isMounted = false;
        }
    }, {
        key: "UNSAFE_componentWillReceiveProps",
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
                var value = nextProps.value;
                this.setState({
                    value: value
                });
            }
            if ('dataSource' in nextProps) {
                var dataSource = nextProps.dataSource;
                this.setState({
                    data: dataSource
                });
            }
        }

        //根据数据源标识从后台查询DataSource


        //使用自定义的DataSource


        //选项变化时的回调函数


        //检查单选按钮是否需要禁用


        /**
         * * 组装Radio Options
         * @memberof NHRadioGroup
         */


        /**
         * * 组装Radio
         * @memberof NHRadioGroup
         */

    }, {
        key: "render",
        value: function render() {
            var _state = this.state,
                value = _state.value,
                radioOptions = _state.radioOptions;
            var _props = this.props,
                buttonStyle = _props.buttonStyle,
                radioGroupDisabled = _props.radioGroupDisabled,
                defaultValue = _props.defaultValue;


            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                RadioGroup,
                {
                    onChange: this.onRadioSelectChange,
                    disabled: radioGroupDisabled,
                    buttonStyle: buttonStyle,
                    value: value,
                    defaultValue: defaultValue
                },
                radioOptions
            );
        }
    }]);

    return NHRadioGroup;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.getDataSource = function (sign) {
        if (!sign) {
            _this2.getCustomDataSource();
        } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_NHFetch__["a" /* default */])(pathUrl, 'GET', { sign: sign, t: new Date().getTime() }).then(function (res) {
                if (res && _this2._isMounted) {
                    var data = res.data;
                    if (data) {
                        _this2.setState({ data: [].concat(_toConsumableArray(data)) }, function () {
                            _this2.buildRadio();
                        });
                    } else {
                        _this2.getCustomDataSource();
                    }
                }
            });
        }
    };

    this.getCustomDataSource = function () {
        var _props$dataSource = _this2.props.dataSource,
            dataSource = _props$dataSource === undefined ? [] : _props$dataSource;

        if (dataSource && dataSource.length > 0) {
            _this2.setState({ data: [].concat(_toConsumableArray(dataSource)) }, function () {
                _this2.buildRadio();
            });
        }
    };

    this.onRadioSelectChange = function (e) {
        _this2.setState({ value: e.target.value });
        var onChange = _this2.props.onChange;

        if (onChange && typeof onChange === 'function') {
            onChange(e.target.value);
        }
    };

    this.checkRadioIsDisable = function (radioDisabledArr, value) {
        if (radioDisabledArr && radioDisabledArr.length <= 0) {
            return false;
        }
        var val = radioDisabledArr.find(function (key) {
            return value === key || value === key;
        });
        return val !== undefined;
    };

    this.buildRadio = function () {
        var _state$data = _this2.state.data,
            data = _state$data === undefined ? [] : _state$data;
        var _props2 = _this2.props,
            _props2$radioDisabled = _props2.radioDisabledArr,
            radioDisabledArr = _props2$radioDisabled === undefined ? [] : _props2$radioDisabled,
            _props2$filterType = _props2.filterType,
            filterType = _props2$filterType === undefined ? '' : _props2$filterType,
            _props2$filterData = _props2.filterData,
            filterData = _props2$filterData === undefined ? [] : _props2$filterData;

        var radioOptions = [];

        //同时指定过滤类型和需要过滤的数据VALUE
        if (filterType && filterData) {
            switch (filterType) {
                case 'remove':
                    {
                        //过滤掉指定key的单选按钮
                        var filteredData = data.filter(function (item) {
                            var itemVal = item.VALUE || item.value;
                            var isExist = filterData.find(function (val) {
                                return val === itemVal;
                            });
                            return isExist === undefined;
                        });
                        if (filteredData && filteredData.length > 0) {
                            radioOptions = _this2.buildRadioOptions(filteredData, radioDisabledArr);
                        }
                        break;
                    }
                case 'save':
                    {
                        //保留指定key值的单选按钮
                        var _filteredData = data.filter(function (item) {
                            var itemVal = item.VALUE || item.value;
                            var isExist = filterData.find(function (val) {
                                return val === itemVal;
                            });
                            return isExist !== undefined;
                        });
                        if (_filteredData && _filteredData.length > 0) {
                            radioOptions = _this2.buildRadioOptions(_filteredData, radioDisabledArr);
                        }
                        break;
                    }
                default:
                    {
                        radioOptions = _this2.buildRadioOptions(data, radioDisabledArr);
                        break;
                    }
            }
        } else {
            //不进行数据过滤
            radioOptions = _this2.buildRadioOptions(data, radioDisabledArr);
        }

        _this2.setState({ radioOptions: radioOptions });
    };

    this.buildRadioOptions = function (filteredData, radioDisabledArr) {
        var _props3 = _this2.props,
            radioButton = _props3.radioButton,
            radioStyle = _props3.radioStyle;


        if (radioButton) {
            return filteredData.map(function (option) {
                return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio___default.a.Button,
                    {
                        style: radioStyle,
                        key: option.VALUE || option.value,
                        disabled: _this2.checkRadioIsDisable(radioDisabledArr, option.VALUE || option.value),
                        value: option.VALUE || option.value },
                    option.LABEL || option.label
                );
            });
        } else {
            return filteredData.map(function (option) {
                return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio___default.a,
                    { style: radioStyle,
                        key: option.VALUE || option.value,
                        disabled: _this2.checkRadioIsDisable(radioDisabledArr, option.VALUE || option.value),
                        value: option.VALUE || option.value },
                    option.LABEL || option.label
                );
            });
        }
    };
}, _temp);


NHRadioGroup.defaultProps = {
    radioGroupDisabled: false, //按钮组启用/禁用状态
    radioDisabledArr: [], //需要禁用的按钮集合
    radioStyle: {}, //按钮排列样式,可配置垂直排列,默认水平排列
    radioButton: false, //是否按钮样式
    buttonStyle: 'solid' //按钮样式              
};

NHRadioGroup.propTypes = {
    sign: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, //数据源标识
    dataSource: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf( //自定义数据源
    __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
        value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
        label: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node
    })),
    radioButton: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool, //是否是按钮样式
    buttonStyle: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['outline', 'solid']), //按钮样式（outline | solid）
    radioGroupDisabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool, //按钮组启用/禁用状态
    defaultValue: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, //默认值
    value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, //初始值
    onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func, //选项变化时的回调函数
    radioDisabledArr: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array, //需要禁用的按钮Value集合
    filterType: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['save', 'remove']), //过滤数据类型,save - 保留  remove - 移除
    filterData: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array //过滤数据, save - 保留指定的filterData remove - 移除指定的filterData
};

/* harmony default export */ __webpack_exports__["a"] = (NHRadioGroup);

/***/ }),

/***/ 538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrintTemplate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox_style__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_barcode__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_barcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_barcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_NHFetch__ = __webpack_require__(7);







var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }


// import Flex from '../../Flex';


// import TitleTop from '../../Assembly/titleTop';






if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var PrintTemplate = function (_React$Component) {
    _inherits(PrintTemplate, _React$Component);

    function PrintTemplate(props) {
        _classCallCheck(this, PrintTemplate);

        var _this = _possibleConstructorReturn(this, (PrintTemplate.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(PrintTemplate)).call(this, props));

        _this.getStudentPhotoBase64 = function (userId, callback) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/openapi/student/getStudentPhotoBase64', 'get', { xsid: userId, type: 10 }).then(function (res) {
                if (res && res.code == 200) {
                    callback(res.data);
                }
            });
        };

        _this.state = {
            xsxx: _this.props.initFormDate, //学生信息
            nr: [{
                key: 1,
                row_id: 1,
                nr: '交验录取通知书'
            }, {
                key: 2,
                row_id: 2,
                nr: '领取一卡通'
            }, {
                key: 3,
                row_id: 3,
                nr: '自愿购买保险'
            }, {
                key: 4,
                row_id: 4,
                nr: '自带床上用品检验'
            }, {
                key: 5,
                row_id: 5,
                nr: '领取宿舍钥匙'
            }, {
                key: 6,
                row_id: 6,
                nr: '参加体检'
            }],
            bzItems: [{ key: 1, bz: '新生拿到报到单后，请到指定地点完成报到流程。' }, { key: 2, bz: '未缴清费用的同学，需在报到期间缴清费用，如有特殊情况，请到班主任处登记。' }, { key: 3, bz: '报到单请务必保存好，报到结束后，交回班主任处。' }]
            // sfxmList:[],//缴费列表
        };
        return _this;
    }

    /* componentWillReceiveProps(nextProps) {
        this.loadSfxmList(nextProps);
    } */

    /*  loadSfxmList = (nextProps) =>  {
         const {xsxx} = nextProps.initFormDate;
         const {xsid, sfzjh, xh} = xsxx;
         NHFetch('api/zhxg-yxwz/openapi/yxxt/getJfxxList', 'GET', { xsid: xsid, sfzjh: sfzjh, xh: xh }).then(res => {
           if (res && res.data) {
             this.setState({
                 sfxmList: res.data,
             });
           }
         });
      } */

    _createClass(PrintTemplate, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                this.getStudentPhotoBase64(userId, function (data) {
                    if (!data) return;
                    _this2.setState({
                        xsid: userId,
                        imageUrl: 'data:image/jpeg;base64,' + data
                    });
                });
            }
        }

        // 获取学生头像

    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                bzItems = _state.bzItems,
                imageUrl = _state.imageUrl;
            var _props$initFormDate = this.props.initFormDate,
                xsxx = _props$initFormDate.xsxx,
                schoolName = _props$initFormDate.schoolName,
                year = _props$initFormDate.year,
                nr = _props$initFormDate.nr,
                account = _props$initFormDate.account,
                bddbz = _props$initFormDate.bddbz,
                headimg = _props$initFormDate.headimg,
                sfxmList = _props$initFormDate.sfxmList;

            var xqmc = xsxx.xqmc;
            var ldmc = xsxx.ldmc;
            var fjmc = xsxx.fjmc;
            var cwh = xsxx.cwh;
            var nrList = []; //内容list
            var bzList = []; //备注list
            if (nr && nr.length > 0) {
                nr.map(function (elem, index) {
                    nrList.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.ejxybd_label1 },
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'span',
                                null,
                                index + 1
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.ejxybd_label2 },
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'span',
                                null,
                                elem.nr
                            )
                        )
                    ));
                });
            }
            // 获取备注list
            if (bzItems && bzItems.length > 0) {
                bzItems.map(function (elem) {
                    bzList.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'div',
                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.bz_item, key: elem.key },
                        elem.key,
                        '.',
                        elem.bz
                    ));
                });
            }
            var payColumns = [{
                title: '序号',
                dataIndex: 'row_id'
            }, {
                title: '收费项目',
                dataIndex: 'sfxmmc'
            }, {
                title: '应收金额',
                dataIndex: 'ysje'
            }, {
                title: '已交金额',
                dataIndex: 'ssje',
                render: function render(text, record) {
                    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'span',
                        { className: 'text-primary' },
                        text
                    );
                }
            }];
            var Columns = [{
                title: '序号',
                dataIndex: 'row_id'
            }, {
                title: '主要内容',
                dataIndex: 'HJMC'
            }];
            return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                'div',
                { className: 'box', style: { width: '90%' } },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'div',
                        { style: { textAlign: 'center', position: 'relative' } },
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.title, style: { fontSize: '20px' } },
                            schoolName,
                            year,
                            '\u65B0\u751F\u5165\u5B66\u62A5\u5230\u5355'
                        ),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', { style: { position: 'absolute', width: '120px', right: '0px', top: '0px' }, src: __webpack_require__(2196) })
                    ),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__pages_Assembly_titleTop__["a" /* default */], { title: '\u57FA\u672C\u4FE1\u606F', extra: false, style: { margin: "10px 0px" } }),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */],
                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.p_sw_big },
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jbxx_icon_bg, src: imageUrl,
                            onError: function onError(e) {
                                e.target.src = stuDefault;
                            } }),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */].Item,
                            { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.ml_20, style: { marginLeft: '5%' } },
                            [{
                                label: '姓名',
                                name: xsxx.xm
                            }, {
                                label: '性别',
                                name: xsxx.xb
                            }, {
                                label: '学号',
                                name: xsxx.xh
                            }, {
                                label: '民族',
                                name: xsxx.mz
                            }, {
                                label: '政治面貌',
                                name: xsxx.zzmm
                            }, {
                                label: '籍贯',
                                name: xsxx.jg
                            }, {
                                label: '联系电话',
                                name: xsxx.sjhm
                            }, {
                                label: '身份证号',
                                name: xsxx.sfzjh
                            }, {
                                label: '考生类型',
                                name: xsxx.xslb
                            }, {
                                label: '学院',
                                name: xsxx.bmmc
                            }, {
                                label: '专业',
                                name: xsxx.zymc
                            }, {
                                label: '班级',
                                name: xsxx.bjmc
                            }].map(function (elem, index) {
                                return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jbxx_item, key: index },
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'span',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.item_label },
                                        elem.label,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.item_name_t_clamp_1 },
                                        elem.name
                                    )
                                );
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'div',
                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.singelWarp },
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.singelWarp_label, style: { width: '15%' } },
                            '\u73ED\u4E3B\u4EFB\uFF1A(\u7B7E\u540D)'
                        ),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.singelWarp_Words })
                    ),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'div',
                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.ItemWarp },
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.itemWarp_label },
                                '1\u3001 \u767B\u8BB0\u7F34\u7EB3\u5F55\u53D6\u901A\u77E5\u4E66\uFF1A',
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox___default.a, { checked: false })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { style: { marginTop: 20 } },
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.itemWarp_label },
                                '2\u3001 \u7F34\u7EB3\u6750\u6599\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.itemWarp_Words, style: { height: '60px' } })
                        ),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { style: { margin: "20px 0px" } },
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.itemWarp_label },
                                '3\u3001 \u7F34\u8D39\u91D1\u989D\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.itemWarp_Words },
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            '\u5E8F\u53F7'
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            '\u6536\u8D39\u9879\u76EE'
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            '\u5E94\u6536\u91D1\u989D'
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            '\u5DF2\u4EA4\u91D1\u989D'
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            sfxmList && sfxmList.length >= 1 ? '1' : ""
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            sfxmList && sfxmList.length >= 1 ? sfxmList[0].SFXMMC : ""
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            sfxmList && sfxmList.length >= 1 ? sfxmList[0].YSJE : ""
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            sfxmList && sfxmList.length >= 1 ? sfxmList[0].SSJE : ""
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            sfxmList && sfxmList.length >= 2 ? '2' : ""
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            sfxmList && sfxmList.length >= 2 ? sfxmList[1].SFXMMC : ""
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            sfxmList && sfxmList.length >= 2 ? sfxmList[1].YSJE : ""
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            sfxmList && sfxmList.length >= 2 ? sfxmList[1].SSJE : ""
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            sfxmList && sfxmList.length >= 3 ? '3' : ""
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            sfxmList && sfxmList.length >= 3 ? sfxmList[2].SFXMMC : ""
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            sfxmList && sfxmList.length >= 3 ? sfxmList[2].YSJE : ""
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            sfxmList && sfxmList.length >= 3 ? sfxmList[2].SSJE : ""
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            sfxmList && sfxmList.length >= 4 ? '4' : ""
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            sfxmList && sfxmList.length >= 4 ? sfxmList[3].SFXMMC : ""
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            sfxmList && sfxmList.length >= 4 ? sfxmList[3].YSJE : ""
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            sfxmList && sfxmList.length >= 4 ? sfxmList[3].SSJE : ""
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            sfxmList && sfxmList.length >= 5 ? '5' : ""
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            sfxmList && sfxmList.length >= 5 ? sfxmList[4].SFXMMC : ""
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            sfxmList && sfxmList.length >= 5 ? sfxmList[4].YSJE : ""
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jfxx_label },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'span',
                                            null,
                                            sfxmList && sfxmList.length >= 5 ? sfxmList[4].SSJE : ""
                                        )
                                    )
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { style: { display: "flex" } },
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { style: { width: "13%", padding: "32px 0px" } },
                                '4\u3001 \u5BBF\u820D\u4FE1\u606F\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.p_sw_big, style: { padding: '10px', fontSize: '14px', width: "87%" } },
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.ssxx_list, style: { border: '1px solid #eaeeed' } },
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.ssxx_item },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'div',
                                            { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.ssxx_label },
                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                                'span',
                                                null,
                                                '\u6821\u533A\uFF1A'
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'div',
                                            { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.ssxx_name },
                                            '\u6E05\u9547\u6821\u533A'
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.ssxx_item },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'div',
                                            { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.ssxx_label },
                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                                'span',
                                                null,
                                                '\u697C\u680B\uFF1A'
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'div',
                                            { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.ssxx_name },
                                            xsxx.ldmc
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.ssxx_list, style: { border: '1px solid #eaeeed' } },
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.ssxx_item },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'div',
                                            { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.ssxx_label },
                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                                'span',
                                                null,
                                                '\u623F\u95F4\uFF1A'
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'div',
                                            { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.ssxx_name },
                                            xsxx.fjmc
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.ssxx_item },
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'div',
                                            { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.ssxx_label },
                                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                                'span',
                                                null,
                                                '\u5E8A\u4F4D\uFF1A'
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                            'div',
                                            { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.ssxx_name },
                                            xsxx.cwh
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'div',
                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.singelWarp },
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.singelWarp_label },
                            '\u519B\u8BAD\u670D\u88C5\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.singelWarp_Words },
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jxfz_item },
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jxfz_label },
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'span',
                                        null,
                                        '\u8EAB\u9AD8\uFF1A'
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jxfz_name },
                                    xsxx.sg,
                                    'cm'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jxfz_item },
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jxfz_label },
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'span',
                                        null,
                                        '\u4F53\u91CD\uFF1A'
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jxfz_name },
                                    xsxx.tz,
                                    'kg'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jxfz_item },
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jxfz_label },
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'span',
                                        null,
                                        '\u670D\u88C5\u5C3A\u7801\uFF1A'
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jxfz_name },
                                    xsxx.fzcm
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jxfz_item },
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jxfz_label },
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'span',
                                        null,
                                        '\u978B\u7801\uFF1A'
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.jxfz_name },
                                    xsxx.shoesSize
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'div',
                        { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.p_sw_big },
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { style: { position: 'relative', margin: "20px 0px" } },
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.text_title, style: { color: '#000', fontSize: '14px' } },
                                '\u5907\u6CE8\uFF1A'
                            ),
                            bzList
                        ),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { style: { display: "flex" } },
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { style: { width: '34%', padding: "3% 0px" } },
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_barcode___default.a, {
                                    className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.bz_img,
                                    value: account,
                                    width: 2,
                                    height: 60,
                                    fontSize: 14
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.bottom_png },
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.bottom_pngItem },
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', { src: __webpack_require__(2193) }),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        null,
                                        '\u8D35\u5DDE\u519C\u4E1A\u804C\u4E1A\u5B66\u9662\u79FB\u52A8\u6821\u56EDAPP\u4E0B\u8F7D'
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.bottom_pngItem },
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', { src: __webpack_require__(2194) }),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        null,
                                        '\u4E00\u5361\u901A\u5B8C\u7F8E\u6821\u56EDAPP'
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: __WEBPACK_IMPORTED_MODULE_9__index_css___default.a.bottom_pngItem },
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', { src: __webpack_require__(2195) }),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        null,
                                        '\u7F34\u8D39\u516C\u4F17\u53F7'
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return PrintTemplate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);



/***/ }),

/***/ 539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LydxIndex", function() { return LydxIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_SelfHelp_print__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);





var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * @author qianzhiwei
 * @date 2020/09/25
 */
var LydxIndex = (_temp = _class = function (_Component) {
    _inherits(LydxIndex, _Component);

    function LydxIndex(props) {
        _classCallCheck(this, LydxIndex);

        var _this = _possibleConstructorReturn(this, (LydxIndex.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(LydxIndex)).call(this, props));

        _this.state = {};
        return _this;
    }

    _createClass(LydxIndex, [{
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__pages_SelfHelp_print__["a" /* default */], null);
        }
    }]);

    return LydxIndex;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]), _class.propTypes = {}, _temp);

/* harmony default export */ __webpack_exports__["default"] = (LydxIndex);

/***/ }),

/***/ 540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LydxPrint", function() { return LydxPrint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_SelfHelp_print_printTemplate__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);





var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }





var LydxPrint = (_temp = _class = function (_Component) {
    _inherits(LydxPrint, _Component);

    function LydxPrint(props) {
        _classCallCheck(this, LydxPrint);

        var _this = _possibleConstructorReturn(this, (LydxPrint.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(LydxPrint)).call(this, props));

        _this.state = {};
        return _this;
    }

    _createClass(LydxPrint, [{
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__pages_SelfHelp_print_printTemplate__["a" /* default */], null);
        }
    }]);

    return LydxPrint;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]), _class.propTypes = {}, _temp);

/* harmony default export */ __webpack_exports__["default"] = (LydxPrint);

/***/ }),

/***/ 541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OtherPrint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_barcode__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_barcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_barcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_css__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);







var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }











if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var OtherPrint = (_temp = _class = function (_Component) {
    _inherits(OtherPrint, _Component);

    function OtherPrint(props) {
        _classCallCheck(this, OtherPrint);

        var _this = _possibleConstructorReturn(this, (OtherPrint.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(OtherPrint)).call(this, props));

        _this.state = {};
        return _this;
    }

    _createClass(OtherPrint, [{
        key: 'render',
        value: function render() {
            var _props$initFormDate = this.props.initFormDate,
                xsxx = _props$initFormDate.xsxx,
                schoolName = _props$initFormDate.schoolName,
                year = _props$initFormDate.year,
                nr = _props$initFormDate.nr,
                account = _props$initFormDate.account,
                bddbz = _props$initFormDate.bddbz,
                headimg = _props$initFormDate.headimg;
            // if(initFormDate){
            //     xsxx = xsxx ? xsxx : initFormDate.xsxx;
            //     headimg = headimg ? headimg : initFormDate.headimg;
            //     schoolName = schoolName || schoolName == "" ? schoolName : initFormDate.schoolName;
            //     year = year ? year : initFormDate.year;
            //     nr = nr ? nr : initFormDate.nr;
            //     account = account ? account : initFormDate.account;
            //     bddbz = bddbz ? bddbz : initFormDate.bddbz;
            // }

            var sfxmList = xsxx.sfxmList;
            if (sfxmList) {
                for (var i = 0; i < sfxmList.length; i++) {
                    sfxmList[i].row_id = i + 1;
                }
            }
            var payColumns = [{
                title: '序号',
                dataIndex: 'row_id'
            }, {
                title: '收费项目',
                dataIndex: 'sfxmmc'
            }, {
                title: '应收金额',
                dataIndex: 'ysje'
            }, {
                title: '已交金额',
                dataIndex: 'ssje',
                render: function render(text, record) {
                    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'span',
                        { className: 'text-primary' },
                        text
                    );
                }
            }];
            var Columns = [{
                title: '序号',
                dataIndex: 'row_id'
            }, {
                title: '主要内容',
                dataIndex: 'nr'
            }];
            return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    'div',
                    { className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'div',
                        { className: 'app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__title' },
                        schoolName,
                        year,
                        '\u65B0\u751F\u5165\u5B66\u62A5\u5230\u5355'
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__pages_Assembly_titleTop__["a" /* default */], { title: '\u57FA\u672C\u4FE1\u606F', extra: false }),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */],
                    { className: 'p-sw-big' },
                    headimg,
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */].Item,
                        { className: 'ml-20' },
                        [{
                            label: '姓名',
                            name: xsxx.xm
                        }, {
                            label: '性别',
                            name: xsxx.xb
                        }, {
                            label: '考生号',
                            name: xsxx.ksh
                        }, {
                            label: '民族',
                            name: xsxx.mz
                        }, {
                            label: '政治面貌',
                            name: xsxx.zzmm
                        }, {
                            label: '籍贯',
                            name: xsxx.jg
                        }, {
                            label: '联系电话',
                            name: xsxx.sjhm
                        }, {
                            label: '身份证号',
                            name: xsxx.sfzjh
                        }, {
                            label: '考生类型',
                            name: xsxx.xslb
                        }, {
                            label: '学院',
                            name: xsxx.bmmc
                        }, {
                            label: '专业',
                            name: xsxx.zymc
                        }, {
                            label: '班级',
                            name: xsxx.bjmc
                        }].map(function (elem, index) {
                            return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { key: index, className: 'app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__jbxx_item' },
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'span',
                                    { className: 'app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__item-label' },
                                    elem.label,
                                    '\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 't-clamp-1 app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__item-name',

                                        style: { display: 'inline' }
                                    },
                                    elem.name
                                )
                            );
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__pages_Assembly_titleTop__["a" /* default */], { title: '\u5BBF\u820D\u4FE1\u606F', extra: false }),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    'div',
                    { className: 'p-sw-big' },
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'div',
                        { className: 'app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__ssxx_list' },
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__ssxx_item' },
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__ssxx_label' },
                                '\u6821\u533A\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__ssxx_name' },
                                xsxx.xqmc
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__ssxx_item' },
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__ssxx_label' },
                                '\u697C\u680B\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__ssxx_name' },
                                xsxx.ldmc
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'div',
                        { className: 'app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__ssxx_list' },
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__ssxx_item' },
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__ssxx_label' },
                                '\u623F\u95F4\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__ssxx_name' },
                                xsxx.fjmc
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__ssxx_item' },
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__ssxx_label' },
                                '\u5E8A\u4F4D\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__ssxx_name' },
                                xsxx.cwh
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__pages_Assembly_titleTop__["a" /* default */], { title: '\u7F34\u8D39\u4FE1\u606F', extra: false }),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    'div',
                    { className: 'p-sw-big' },
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_table___default.a, {
                        bordered: true,
                        size: 'middle',
                        pagination: false,
                        dataSource: xsxx.sfxmList,
                        columns: payColumns
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__pages_Assembly_titleTop__["a" /* default */], { title: '\u4E8C\u7EA7\u5B66\u9662\u62A5\u5230', extra: false }),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    'div',
                    { className: 'p-sw-big' },
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_table___default.a, {
                        bordered: true,
                        size: 'middle',
                        pagination: false,
                        dataSource: nr,
                        columns: Columns
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */],
                    { className: 'p-sw-big mt-30' },
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */].Item,
                        null,
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: 'text-title' },
                            '\u5907\u6CE8\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__bz-item' },
                            bddbz
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_barcode___default.a, { className: 'app__css__app-pages-SelfHelp-Bdd-pages-other-print-__index__bz-img',
                        value: account,
                        width: 2,
                        height: 60,
                        fontSize: 18
                    })
                )
            );
        }
    }]);

    return OtherPrint;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]), _class.propTypes = {}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (OtherPrint);

/***/ }),

/***/ 542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OtherPrint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_barcode__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_barcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_barcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_css__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);







var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }











if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var OtherPrint = (_temp = _class = function (_Component) {
    _inherits(OtherPrint, _Component);

    function OtherPrint(props) {
        _classCallCheck(this, OtherPrint);

        var _this = _possibleConstructorReturn(this, (OtherPrint.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(OtherPrint)).call(this, props));

        _this.state = {};
        return _this;
    }

    _createClass(OtherPrint, [{
        key: 'render',
        value: function render() {
            var _props$initFormDate = this.props.initFormDate,
                xsxx = _props$initFormDate.xsxx,
                schoolName = _props$initFormDate.schoolName,
                year = _props$initFormDate.year,
                nr = _props$initFormDate.nr,
                account = _props$initFormDate.account,
                bddbz = _props$initFormDate.bddbz,
                headimg = _props$initFormDate.headimg;
            // if(initFormDate){
            //     xsxx = xsxx ? xsxx : initFormDate.xsxx;
            //     headimg = headimg ? headimg : initFormDate.headimg;
            //     schoolName = schoolName || schoolName == "" ? schoolName : initFormDate.schoolName;
            //     year = year ? year : initFormDate.year;
            //     nr = nr ? nr : initFormDate.nr;
            //     account = account ? account : initFormDate.account;
            //     bddbz = bddbz ? bddbz : initFormDate.bddbz;
            // }

            var sfxmList = xsxx.sfxmList;
            if (sfxmList) {
                for (var i = 0; i < sfxmList.length; i++) {
                    sfxmList[i].row_id = i + 1;
                }
            }
            var payColumns = [{
                title: '序号',
                dataIndex: 'row_id'
            }, {
                title: '收费项目',
                dataIndex: 'sfxmmc'
            }, {
                title: '应收金额',
                dataIndex: 'ysje'
            }, {
                title: '已交金额',
                dataIndex: 'ssje',
                render: function render(text, record) {
                    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'span',
                        { className: 'text-primary' },
                        text
                    );
                }
            }];
            var Columns = [{
                title: '序号',
                dataIndex: 'row_id'
            }, {
                title: '主要内容',
                dataIndex: 'nr'
            }];
            return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    'div',
                    { className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'div',
                        { className: 'app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__title' },
                        schoolName,
                        year,
                        '\u65B0\u751F\u5165\u5B66\u62A5\u5230\u5355'
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__pages_Assembly_titleTop__["a" /* default */], { title: '\u57FA\u672C\u4FE1\u606F', extra: false }),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */],
                    { className: 'p-sw-big' },
                    headimg,
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */].Item,
                        { className: 'ml-20' },
                        [{
                            label: '姓名',
                            name: xsxx.xm
                        }, {
                            label: '性别',
                            name: xsxx.xb
                        }, {
                            label: '考生号',
                            name: xsxx.ksh
                        }, {
                            label: '民族',
                            name: xsxx.mz
                        }, {
                            label: '政治面貌',
                            name: xsxx.zzmm
                        }, {
                            label: '籍贯',
                            name: xsxx.jg
                        }, {
                            label: '联系电话',
                            name: xsxx.sjhm
                        }, {
                            label: '身份证号',
                            name: xsxx.sfzjh
                        }, {
                            label: '考生类型',
                            name: xsxx.xslb
                        }, {
                            label: '学院',
                            name: xsxx.bmmc
                        }, {
                            label: '专业',
                            name: xsxx.zymc
                        }, {
                            label: '班级',
                            name: xsxx.bjmc
                        }].map(function (elem, index) {
                            return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { key: index, className: 'app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__jbxx_item' },
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'span',
                                    { className: 'app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__item-label' },
                                    elem.label,
                                    '\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    {
                                        className: 't-clamp-1 app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__item-name',

                                        style: { display: 'inline' }
                                    },
                                    elem.name
                                )
                            );
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__pages_Assembly_titleTop__["a" /* default */], { title: '\u5BBF\u820D\u4FE1\u606F', extra: false }),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    'div',
                    { className: 'p-sw-big' },
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'div',
                        { className: 'app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__ssxx_list' },
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__ssxx_item' },
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__ssxx_label' },
                                '\u697C\u680B\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__ssxx_name' },
                                xsxx.ldmc
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'div',
                        { className: 'app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__ssxx_list' },
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__ssxx_item' },
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__ssxx_label' },
                                '\u623F\u95F4\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__ssxx_name' },
                                xsxx.fjmc
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__ssxx_item' },
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__ssxx_label' },
                                '\u5E8A\u4F4D\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__ssxx_name' },
                                xsxx.cwh
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__pages_Assembly_titleTop__["a" /* default */], { title: '\u7F34\u8D39\u4FE1\u606F', extra: false }),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    'div',
                    { className: 'p-sw-big' },
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_table___default.a, {
                        bordered: true,
                        size: 'middle',
                        pagination: false,
                        dataSource: xsxx.sfxmList,
                        columns: payColumns
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__pages_Assembly_titleTop__["a" /* default */], { title: '\u4E8C\u7EA7\u5B66\u9662\u62A5\u5230', extra: false }),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    'div',
                    { className: 'p-sw-big' },
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_table___default.a, {
                        bordered: true,
                        size: 'middle',
                        pagination: false,
                        dataSource: nr,
                        columns: Columns
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */],
                    { className: 'p-sw-big mt-30' },
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */].Item,
                        null,
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: 'text-title' },
                            '\u5907\u6CE8\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__bz-item' },
                            '1.\u62A5\u5230\u5355\u8BF7\u52A1\u5FC5\u4FDD\u5B58\u597D\uFF0C\u62A5\u5230\u7ED3\u675F\u540E\uFF0C\u7531\u5B66\u9662\u7EDF\u4E00\u6536\u56DE\u3002'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_barcode___default.a, { className: 'app__css__app-pages-SelfHelp-Bdd-pages-scjtzyxy-print-__index__bz-img',
                        value: account,
                        width: 2,
                        height: 60,
                        fontSize: 18
                    })
                )
            );
        }
    }]);

    return OtherPrint;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]), _class.propTypes = {}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (OtherPrint);

/***/ }),

/***/ 543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ZszyjsxyPrint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__ = __webpack_require__(7);





var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }







if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var schoolCode = 'zszyjsxy';
var printInfoUrl = '/zdybl/getInfoForPrint';
/**
 * @author qianzhiwei
 * @date 2020/09/27
 * @description 打印单
 */
var ZszyjsxyPrint = (_temp = _class = function (_Component) {
    _inherits(ZszyjsxyPrint, _Component);

    function ZszyjsxyPrint(props) {
        _classCallCheck(this, ZszyjsxyPrint);

        var _this = _possibleConstructorReturn(this, (ZszyjsxyPrint.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(ZszyjsxyPrint)).call(this, props));

        _this.getPrintInfo = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (xsid == '') {}
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_NHFetch__["a" /* default */])(printInfoUrl, 'GET', { xsid: xsid }).then(function (res) {
                if (res && res.data) {
                    _this.setState({ xsxx: res.data });
                }
            });
        };

        _this.state = {
            xsxx: [],
            extraData: {} //额外参数
        };
        return _this;
    }

    _createClass(ZszyjsxyPrint, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.getPrintInfo();
        }

        //获取打印信息

    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                null,
                '\u4E2D\u5C71\u804C\u4E1A\u6280\u672F\u5B66\u9662\u6253\u5370\u5355'
            );
        }
    }]);

    return ZszyjsxyPrint;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]), _class.propTypes = {}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (ZszyjsxyPrint);

/***/ }),

/***/ 544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return syscBtnFunc; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nxmzzyjsxy_js__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gdsxzyjsxy_js__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__zzsdjmglxy_js__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__wuhantielu_js__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ynjt_js__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scjtzyjsxy_js__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jhyszy_js__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tdtc_mmdl_js__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__axf_mmdl_js__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__payFxxy_tdtc_mmdl_js__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sm_mmdl__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__xzkj_mmdl_js__ = __webpack_require__(1101);













/**
 * 网上支付办理接口
 * @param {*} ddh 订单号
 * @param {*} csxx 配置参数信息，包含：pczflj(PC端支付路径),ydzflj(移动端支付路径)，zfts(支付提示),所有的自定义配置的参数信息
 * @param {*} xsxx 学生信息，包含：XSID(学生ID),XH(学号),XM(姓名),XBM(性别码),SFZJH(身份证件号),RXNF(入学年份),CSRQ(出生日期)
 * @param {*} jfxm 缴费信息，LIst<Map<String,Object>>对象,包含：sfxmid(收费项目ID),sfxmdm(收费项目代码),sfxmmc(收费项目名称)，je(金额)
 * @param {*} jyje 交易金额
 * @param {*} yjje 应缴金额
 * @param {*} ysje 已缴金额
 * @param {*} hjje 缓缴金额
 */
var handle = function handle(type, ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje) {
  if (type === 'nxmzzyjsxy') {
    //宁夏民族职业技术学院
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__nxmzzyjsxy_js__["a" /* handle */])(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje);
  } else if (type === 'gdsxzyjsxy') {
    //广东松山技术学院
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__gdsxzyjsxy_js__["a" /* handle */])(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje);
  } else if (type === 'zzsdjmglxy') {
    //郑州升达经贸管理学院
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__zzsdjmglxy_js__["a" /* handle */])(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje);
  } else if (type === 'wuhantieluanxinfu') {
    // 武汉铁路
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__wuhantielu_js__["a" /* handle */])(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje);
  } else if (type === 'ynjt') {
    //云南交通
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__ynjt_js__["a" /* handle */])(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje);
  } else if (type === 'scjtzyjsxy' || type === 'hzyyzx_scjtzyjsxy_cwcj_cwcjjk_mmdl') {
    //四川交通职业技术学院
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__scjtzyjsxy_js__["a" /* handle */])(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje);
  } else if (type === 'tdtc_mmdl' || type === 'tdtc_1_cwcj_zjk_mmdl') {
    //天大天财-免密登录
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tdtc_mmdl_js__["a" /* handle */])(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje);
  } else if (type === 'yjxc_jhyszy_cwcj_cwcjjk_mmdl') {
    //江汉艺术职业-免密登录
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__jhyszy_js__["a" /* handle */])(ddh, csxx, xsxx, jfxm, jyje, yjje, ysje, hjje);
  } else if (type === 'axf_1_cwcj_jk_mmdl') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__axf_mmdl_js__["a" /* handle */])(csxx, xsxx);
  } else if (type === 'tdtc_2_cwcj_jk_mmdl') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__payFxxy_tdtc_mmdl_js__["a" /* handle */])(csxx, xsxx);
  } else if (type === 'sm_1_cwcj_jk_mmdl') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__sm_mmdl__["a" /* handle */])(csxx, xsxx);
  } else if (type === 'xzkj_1_cwcj_cwcjjk_mmdl') {
    //学之科技-免密登录
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__xzkj_mmdl_js__["a" /* handle */])(ddh, csxx, xsxx);
  }
};

/**
 * 点击同步按钮触发时的操作
 * @param {*} ddh 订单号
 */
var syscBtnFunc = function syscBtnFunc(type, ddh) {
  if (type === 'nxmzzyjsxy') {
    //宁夏民族职业技术学院
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__nxmzzyjsxy_js__["b" /* syscBtnFunc */])(ddh);
  }
};

/***/ }),

/***/ 545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pagePrint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Assembly_siderMenu__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Assembly_Breadcrumb__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_SelfHelp_common_nextIndex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__index_css__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Assembly_siderMenu_menuObj__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_barcode__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_barcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react_barcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__updateInfo_KzxxFormc__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_Print__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__printTemplate__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_SelfHelp_common_hint__ = __webpack_require__(35);










var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }























// import PrintProvider, { Print, NoPrint } from 'react-easy-print';

if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_19_history_createHashHistory___default()();

var pagePrint = function (_React$Component) {
    _inherits(pagePrint, _React$Component);

    function pagePrint(props) {
        _classCallCheck(this, pagePrint);

        var _this = _possibleConstructorReturn(this, (pagePrint.__proto__ || __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_prototype_of___default()(pagePrint)).call(this, props));

        _this.getStudentPhotoBase64 = function (userId, callback) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/openapi/student/getStudentPhotoBase64', 'get', { xsid: userId, type: 10 }).then(function (res) {
                if (res && res.code == 200) {
                    callback(res.data);
                }
            });
        };

        _this.getCurrentSchool = function () {
            var params = {};
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])("/getCurrentXxmc", "GET", params).then(function (resData) {
                if (resData.data != null) {
                    _this.setState({ schoolName: resData.data });
                }
            });
        };

        _this.getCurrentYear = function () {
            var params = {};
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])("/zdybl/getCurrentYear", "GET", params).then(function (resData) {
                if (resData.data != null) {
                    _this.setState({ year: resData.data });
                }
            });
        };

        _this.getAccount = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (xsid == '') {}
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])("/zdybl/getAccount", "GET", { xsid: xsid }).then(function (resData) {
                if (resData.data != null) {
                    _this.setState({ account: resData.data });
                }
            });
        };

        _this.getPrintInfo = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (xsid == '') {}
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])("/zdybl/getInfoForPrint", 'GET', { xsid: xsid }).then(function (res) {
                if (res && res.data) {
                    var stuXxcj = res.data.stuXxcj;
                    _this.setState({ xsxx: res.data, kzxxInitData: _extends({}, stuXxcj), nr: res.data.xclcList });
                }
            });
        };

        _this.getBddBz = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])('/zzbdCommon/getCssz', 'GET', { csbz: 'YXXT_BDD_BZ' }).then(function (res) {
                if (res && res.data) {
                    _this.setState({ bddbz: res.data });
                }
            });
        };

        _this.queryQztjAndYlhj = function () {
            var xsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : '';
            if (!xsid) {
                _this.setState({
                    nonOperationalData: { nologin: true },
                    operable: false
                });
                return;
            }
            var zzbdhjid = _this.getQueryString('pkid');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_NHFetch__["a" /* default */])("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(function (res) {
                if (res && res.data) {
                    var kfsj = res.data['kfsj'];
                    var ylhj = res.data['ylhj'];
                    var qzhj = res.data['qzhj'];
                    _this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        _this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        _this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        _this.setState({ operable: false });
                    }
                }
            });
        };

        _this.getQueryString = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
        };

        _this.setMenuList = function (menuList) {
            var nextCount = 0;
            var bz = _this.state.mkbz;
            menuList.map(function (elem, index) {
                if (elem.HJDM == bz) {
                    var hjmc = elem.HJMC;
                    _this.setState({ hjmc: hjmc });
                    nextCount = index + 1;
                    return;
                }
            });
            var menu = menuList[nextCount];
            if (menu) {
                var hjdm = menu.HJDM;
                if (hjdm.indexOf('GD') == 0) {
                    var gdUrl = __WEBPACK_IMPORTED_MODULE_22__pages_Assembly_siderMenu_menuObj__["a" /* mkbz */][hjdm];
                    _this.setState({
                        nextUrl: gdUrl,
                        search: 'pkid=' + menu.PKID
                    });
                } else if (hjdm.indexOf('ZDY') == 0) {
                    var zdyUrl = "/customLink";
                    _this.setState({
                        nextUrl: zdyUrl,
                        search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                    });
                }
            } else {
                _this.setState({
                    nextUrl: '',
                    search: ''
                });
            }
        };

        _this.onPrint = function () {
            _this.refs.print.onPrint();
        };

        _this.reloadMenu = function () {
            _this.refs.siderMenu.reloadMenuList();
        };

        _this.state = {
            mkbz: 'GD009',
            hjmc: '',
            loading: false,
            xsxx: [], //学生信息
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            schoolName: '', //学校名称
            year: '', //当前年度
            account: '', //默认账号
            bddbz: '',
            kzxxInitData: {},
            nr: [
                // {
                //     key: 1,
                //     row_id:1,
                //     nr:'交验录取通知书'
                // },
                // {
                //     key: 2,
                //     row_id:2,
                //     nr:'领取缴费收据'
                // },
                // {
                //     key: 3,
                //     row_id:3,
                //     nr:'购买床上用品'
                // },
                // {
                //     key: 4,
                //     row_id:4,
                //     nr:'领取宿舍钥匙'
                // },
                // {
                //     key: 5,
                //     row_id:5,
                //     nr:'领取军训服'
                // },
            ]
        };
        return _this;
    }

    _createClass(pagePrint, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                this.getStudentPhotoBase64(userId, function (data) {
                    if (!data) return;
                    _this2.setState({
                        xsid: userId,
                        imageUrl: 'data:image/jpeg;base64,' + data
                    });
                });
            }
            this.queryQztjAndYlhj();
            this.getPrintInfo();
            this.getCurrentYear();
            this.getCurrentSchool();
            this.getAccount();
            this.getBddBz();
        }

        // 获取学生头像


        //获取当前学校


        //获取当前年度


        //获取当前年度


        //获取打印信息


        //获取报到单备注


        //查询前置条件和依赖环节


        // onPrint = () => {
        //     this.setState({ loading: true });
        //     setTimeout(() => {
        //         this.setState({
        //             loading: false
        //         });
        //         print();
        //     }, 500);
        // };

        //重新加载菜单

    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                loading = _state.loading,
                xsxx = _state.xsxx,
                schoolName = _state.schoolName,
                year = _state.year,
                nr = _state.nr,
                account = _state.account,
                bddbz = _state.bddbz,
                kzxxInitData = _state.kzxxInitData,
                imageUrl = _state.imageUrl;

            var sfxmList = xsxx.sfxmList;
            if (sfxmList) {
                for (var i = 0; i < sfxmList.length; i++) {
                    sfxmList[i].row_id = i + 1;
                }
            }
            if (nr) {
                for (var ic = 0; ic < nr.length; ic++) {
                    nr[ic].row_id = ic + 1;
                }
            }
            var payColumns = [{
                title: '序号',
                dataIndex: 'row_id'
            }, {
                title: '收费项目',
                dataIndex: 'sfxmmc'
            }, {
                title: '应收金额',
                dataIndex: 'ysje'
            }, {
                title: '已交金额',
                dataIndex: 'ssje',
                render: function render(text, record) {
                    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                        'span',
                        { className: 'text-primary' },
                        text
                    );
                }
            }];
            var Columns = [{
                title: '序号',
                dataIndex: 'row_id'
            }, {
                title: '主要内容',
                dataIndex: 'HJMC'
            }];

            return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                'div',
                null,
                this.state.operable ? __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_12__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__pages_Assembly_siderMenu__["a" /* default */], {
                        ref: "siderMenu",
                        setMenuList: this.setMenuList,
                        title: '\u81EA\u52A9\u62A5\u5230',
                        unShowBlzt: "0"
                        /*      active={8}*/
                        , mkbz: this.state.mkbz,
                        menuType: '\u81EA\u52A9\u62A5\u5230'
                    }),
                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_12__components__["a" /* Flex */].Item,
                        { className: 'page_con_r' },
                        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_Assembly_Breadcrumb__["a" /* default */], {
                            noLine: true,
                            list: [{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]
                        }),
                        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                            'div',
                            { className: 'box' },
                            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__pages_SelfHelp_common_hint__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_25__utils_Print__["a" /* default */],
                                { ref: 'print', lazyRender: true, insertHead: true, winStyle: 'toolbar=yes,menubar=yes', isIframe: false },
                                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__printTemplate__["a" /* default */], { kzxxInitData: kzxxInitData, nr: nr, initFormDate: xsxx, year: year, schoolName: schoolName, account: account, bddbz: bddbz })
                            ),
                            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                'div',
                                null,
                                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                    'div',
                                    { className: 'text-center' },
                                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-print-__index__title' },
                                        schoolName,
                                        year,
                                        '\u65B0\u751F\u5165\u5B66\u62A5\u5230\u5355'
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__pages_Assembly_titleTop__["a" /* default */], { title: '\u57FA\u672C\u4FE1\u606F', extra: false }),
                                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_12__components__["a" /* Flex */],
                                    { className: 'p-sw-big' },
                                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('img', { className: '_bg app__css__app-pages-SelfHelp-print-__index__jbxx_icon', src: imageUrl,
                                        onError: function onError(e) {
                                            e.target.src = stuDefault;
                                        }
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_12__components__["a" /* Flex */].Item,
                                        { className: 'ml-20' },
                                        [{
                                            label: '姓名',
                                            name: xsxx.xm
                                        }, {
                                            label: '性别',
                                            name: xsxx.xb
                                        }, {
                                            label: '考生号',
                                            name: xsxx.ksh
                                        }, {
                                            label: '民族',
                                            name: xsxx.mz
                                        }, {
                                            label: '政治面貌',
                                            name: xsxx.zzmm
                                        }, {
                                            label: '籍贯',
                                            name: xsxx.jg
                                        }, {
                                            label: '联系电话',
                                            name: xsxx.sjhm
                                        }, {
                                            label: '身份证号',
                                            name: xsxx.sfzjh
                                        }, {
                                            label: '考生类型',
                                            name: xsxx.xslb
                                        }, {
                                            label: '学院',
                                            name: xsxx.bmmc
                                        }, {
                                            label: '专业',
                                            name: xsxx.zymc
                                        }, {
                                            label: '班级',
                                            name: xsxx.bjmc
                                        }].map(function (elem, index) {
                                            return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                                'div',
                                                { key: index, className: 'app__css__app-pages-SelfHelp-print-__index__jbxx_item' },
                                                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                                    'span',
                                                    { className: 'app__css__app-pages-SelfHelp-print-__index__item-label' },
                                                    elem.label,
                                                    '\uFF1A'
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                                    'div',
                                                    {
                                                        className: 't-clamp-1 app__css__app-pages-SelfHelp-print-__index__item-name',

                                                        style: { display: 'inline' }
                                                    },
                                                    elem.name
                                                )
                                            );
                                        })
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__updateInfo_KzxxFormc__["a" /* default */], { ref: 'refKzxxFormc',
                                    initData: kzxxInitData
                                }),
                                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__pages_Assembly_titleTop__["a" /* default */], { title: '\u5BBF\u820D\u4FE1\u606F', extra: false }),
                                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                    'div',
                                    { className: 'p-sw-big' },
                                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-print-__index__ssxx_list' },
                                        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                            'div',
                                            { className: 'app__css__app-pages-SelfHelp-print-__index__ssxx_item' },
                                            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                                'div',
                                                { className: 'app__css__app-pages-SelfHelp-print-__index__ssxx_label' },
                                                '\u6821\u533A\uFF1A'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                                'div',
                                                { className: 'app__css__app-pages-SelfHelp-print-__index__ssxx_name' },
                                                xsxx.xqmc
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                            'div',
                                            { className: 'app__css__app-pages-SelfHelp-print-__index__ssxx_item' },
                                            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                                'div',
                                                { className: 'app__css__app-pages-SelfHelp-print-__index__ssxx_label' },
                                                '\u697C\u680B\uFF1A'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                                'div',
                                                { className: 'app__css__app-pages-SelfHelp-print-__index__ssxx_name' },
                                                xsxx.ldmc
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                        'div',
                                        { className: 'app__css__app-pages-SelfHelp-print-__index__ssxx_list' },
                                        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                            'div',
                                            { className: 'app__css__app-pages-SelfHelp-print-__index__ssxx_item' },
                                            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                                'div',
                                                { className: 'app__css__app-pages-SelfHelp-print-__index__ssxx_label' },
                                                '\u623F\u95F4\uFF1A'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                                'div',
                                                { className: 'app__css__app-pages-SelfHelp-print-__index__ssxx_name' },
                                                xsxx.fjmc
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                            'div',
                                            { className: 'app__css__app-pages-SelfHelp-print-__index__ssxx_item' },
                                            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                                'div',
                                                { className: 'app__css__app-pages-SelfHelp-print-__index__ssxx_label' },
                                                '\u5E8A\u4F4D\uFF1A'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                                'div',
                                                { className: 'app__css__app-pages-SelfHelp-print-__index__ssxx_name' },
                                                xsxx.cwh
                                            )
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__pages_Assembly_titleTop__["a" /* default */], { title: '\u7F34\u8D39\u4FE1\u606F', extra: false }),
                                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                    'div',
                                    { className: 'p-sw-big' },
                                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a, {
                                        bordered: true,
                                        size: 'middle',
                                        pagination: false,
                                        dataSource: xsxx.sfxmList,
                                        columns: payColumns
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__pages_Assembly_titleTop__["a" /* default */], { title: '\u4E8C\u7EA7\u5B66\u9662\u62A5\u5230', extra: false }),
                                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                    'div',
                                    { className: 'p-sw-big' },
                                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a, {
                                        bordered: true,
                                        size: 'middle',
                                        pagination: false,
                                        dataSource: nr,
                                        columns: Columns
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_12__components__["a" /* Flex */],
                                    { className: 'p-sw-big mt-30' },
                                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_12__components__["a" /* Flex */].Item,
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                            'div',
                                            { className: 'text-title' },
                                            '\u5907\u6CE8\uFF1A'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                            'div',
                                            { className: 'app__css__app-pages-SelfHelp-print-__index__bz-item' },
                                            bddbz
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_barcode___default.a, { className: 'app__css__app-pages-SelfHelp-print-__index__bz-img',
                                        value: this.state.account,
                                        width: 2,
                                        height: 60,
                                        fontSize: 18
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                'div',
                                { className: 'p-sw-big text-center mt-30' },
                                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_antd_lib_button___default.a,
                                    {
                                        type: 'primary',
                                        loading: loading,
                                        onClick: this.onPrint
                                    },
                                    '\u6253\u5370'
                                ),
                                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__pages_SelfHelp_common_nextIndex__["a" /* default */], { nextUrl: this.state.nextUrl, search: this.state.search })
                            )
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__common__["a" /* default */], { hjmc: "入学报到单打印", key: 'GD009', mkbz: 'GD009', nonOperationalData: this.state.nonOperationalData })
            );
        }
    }]);

    return pagePrint;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);



/***/ }),

/***/ 546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrintTemplate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_table__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Assembly_titleTop__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__print_css__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__print_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__print_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_barcode__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_barcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_barcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__updateInfo_KzxxFormc__ = __webpack_require__(547);







var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }











if (false) {
    module.hot.accept('./print.css', function () {
        require('./print.css');
    });
}

var history = __WEBPACK_IMPORTED_MODULE_11_history_createHashHistory___default()();

var PrintTemplate = function (_React$Component) {
    _inherits(PrintTemplate, _React$Component);

    function PrintTemplate(props) {
        _classCallCheck(this, PrintTemplate);

        var _this = _possibleConstructorReturn(this, (PrintTemplate.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(PrintTemplate)).call(this, props));

        _this.getStudentPhotoBase64 = function (userId, callback) {
            NHFetch('api/zhxg-yxwz/openapi/student/getStudentPhotoBase64', 'get', { xsid: userId, type: 10 }).then(function (res) {
                if (res && res.code == 200) {
                    callback(res.data);
                }
            });
        };

        _this.state = {
            xsxx: _this.props.initFormDate, //学生信息
            schoolName: _this.props.schoolName, //学校名称
            year: _this.props.year, //当前年度
            account: _this.props.account, //默认账号
            bddbz: _this.props.bddbz, //备注
            kzxxInitData: _this.props.kzxxInitData,
            nr: _this.props.nr
        };
        return _this;
    }

    _createClass(PrintTemplate, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var userId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_NHCore__["b" /* getLoginUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_NHCore__["b" /* getLoginUser */])().userId : undefined;
            if (userId) {
                this.getStudentPhotoBase64(userId, function (data) {
                    if (!data) return;
                    _this2.setState({
                        xsid: userId,
                        imageUrl: 'data:image/jpeg;base64,' + data
                    });
                });
            }
        }

        // 获取学生头像

    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                xsxx = _state.xsxx,
                schoolName = _state.schoolName,
                year = _state.year,
                nr = _state.nr,
                account = _state.account,
                bddbz = _state.bddbz,
                kzxxInitData = _state.kzxxInitData,
                imageUrl = _state.imageUrl;

            var sfxmList = [];
            sfxmList = xsxx.sfxmList;
            if (sfxmList) {
                for (var i = 0; i < sfxmList.length; i++) {
                    sfxmList[i].row_id = i + 1;
                }
            }
            var payColumns = [{
                title: '序号',
                dataIndex: 'row_id'
            }, {
                title: '收费项目',
                dataIndex: 'sfxmmc'
            }, {
                title: '应收金额',
                dataIndex: 'ysje'
            }, {
                title: '已交金额',
                dataIndex: 'ssje',
                render: function render(text, record) {
                    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'span',
                        { className: 'text-primary' },
                        text
                    );
                }
            }];
            var Columns = [{
                title: '序号',
                dataIndex: 'row_id'
            }, {
                title: '主要内容',
                dataIndex: 'HJMC'
            }];

            return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                'div',
                { className: 'box', style: { width: '95%' } },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'div',
                        { className: 'text-center' },
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-print-__print__title' },
                            schoolName,
                            year,
                            '\u65B0\u751F\u5165\u5B66\u62A5\u5230\u5355'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__pages_Assembly_titleTop__["a" /* default */], { title: '\u57FA\u672C\u4FE1\u606F', extra: false }),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */],
                        { className: 'p-sw-big' },
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', { className: '_bg app__css__app-pages-SelfHelp-print-__print__jbxx_icon', src: imageUrl,
                            onError: function onError(e) {
                                e.target.src = stuDefault;
                            }
                        }),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */].Item,
                            { className: 'ml-20' },
                            [{
                                label: '姓名',
                                name: xsxx.xm
                            }, {
                                label: '性别',
                                name: xsxx.xb
                            }, {
                                label: '考生号',
                                name: xsxx.ksh
                            }, {
                                label: '民族',
                                name: xsxx.mz
                            }, {
                                label: '政治面貌',
                                name: xsxx.zzmm
                            }, {
                                label: '籍贯',
                                name: xsxx.jg
                            }, {
                                label: '联系电话',
                                name: xsxx.sjhm
                            }, {
                                label: '身份证号',
                                name: xsxx.sfzjh
                            }, {
                                label: '考生类型',
                                name: xsxx.xslb
                            }, {
                                label: '学院',
                                name: xsxx.bmmc
                            }, {
                                label: '专业',
                                name: xsxx.zymc
                            }, {
                                label: '班级',
                                name: xsxx.bjmc
                            }].map(function (elem, index) {
                                return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: 'app__css__app-pages-SelfHelp-print-__print__jbxx_item', key: index },
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'span',
                                        { className: 'app__css__app-pages-SelfHelp-print-__print__item-label' },
                                        elem.label,
                                        '\uFF1A'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                        'div',
                                        {
                                            className: 't-clamp-1 app__css__app-pages-SelfHelp-print-__print__item-name',

                                            style: { display: 'inline' }
                                        },
                                        elem.name
                                    )
                                );
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__updateInfo_KzxxFormc__["a" /* default */], { ref: 'refKzxxFormc',
                        initData: kzxxInitData
                    }),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__pages_Assembly_titleTop__["a" /* default */], { title: '\u5BBF\u820D\u4FE1\u606F', extra: false }),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'div',
                        { className: 'p-sw-big' },
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-print-__print__ssxx_list' },
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-print-__print__ssxx_item' },
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: 'app__css__app-pages-SelfHelp-print-__print__ssxx_label' },
                                    '\u6821\u533A\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: 'app__css__app-pages-SelfHelp-print-__print__ssxx_name' },
                                    xsxx.xqmc
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-print-__print__ssxx_item' },
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: 'app__css__app-pages-SelfHelp-print-__print__ssxx_label' },
                                    '\u697C\u680B\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: 'app__css__app-pages-SelfHelp-print-__print__ssxx_name' },
                                    xsxx.ldmc
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: 'app__css__app-pages-SelfHelp-print-__print__ssxx_list' },
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-print-__print__ssxx_item' },
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: 'app__css__app-pages-SelfHelp-print-__print__ssxx_label' },
                                    '\u623F\u95F4\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: 'app__css__app-pages-SelfHelp-print-__print__ssxx_name' },
                                    xsxx.fjmc
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-print-__print__ssxx_item' },
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: 'app__css__app-pages-SelfHelp-print-__print__ssxx_label' },
                                    '\u5E8A\u4F4D\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                    'div',
                                    { className: 'app__css__app-pages-SelfHelp-print-__print__ssxx_name' },
                                    xsxx.cwh
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__pages_Assembly_titleTop__["a" /* default */], { title: '\u7F34\u8D39\u4FE1\u606F', extra: false }),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'div',
                        { className: 'p-sw-big' },
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_table___default.a, {
                            bordered: true,
                            size: 'middle',
                            pagination: false,
                            dataSource: sfxmList,
                            columns: payColumns
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__pages_Assembly_titleTop__["a" /* default */], { title: '\u4E8C\u7EA7\u5B66\u9662\u62A5\u5230', extra: false }),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'div',
                        { className: 'p-sw-big' },
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_table___default.a, {
                            bordered: true,
                            size: 'middle',
                            pagination: false,
                            dataSource: nr,
                            columns: Columns
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */],
                        { className: 'p-sw-big mt-30' },
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7__components__["a" /* Flex */].Item,
                            null,
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: 'text-title' },
                                '\u5907\u6CE8\uFF1A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-print-__print__bz-item' },
                                bddbz
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_barcode___default.a, { className: 'app__css__app-pages-SelfHelp-print-__print__bz-img',
                            value: account,
                            width: 3,
                            height: 60,
                            fontSize: 18
                        })
                    )
                )
            );
        }
    }]);

    return PrintTemplate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);



/***/ }),

/***/ 547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_number_parse_int__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_plugin_react_css_modules_dist_browser_getClassName__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_plugin_react_css_modules_dist_browser_getClassName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_plugin_react_css_modules_dist_browser_getClassName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Assembly_titleTop__ = __webpack_require__(14);
















var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();


var _styleModuleImportMap = {
    './index.css': {
        'progress': 'app__css__app-pages-SelfHelp-updateInfo-__index__progress',
        'jbxx_icon': 'app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_icon',
        'upload-box': 'app__css__app-pages-SelfHelp-updateInfo-__index__upload-box',
        'upload-title': 'app__css__app-pages-SelfHelp-updateInfo-__index__upload-title',
        'jbxx_item': 'app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_item',
        'jbxx_item2': 'app__css__app-pages-SelfHelp-updateInfo-__index__jbxx_item2',
        'item-label': 'app__css__app-pages-SelfHelp-updateInfo-__index__item-label',
        'item-name': 'app__css__app-pages-SelfHelp-updateInfo-__index__item-name',
        'kzxx_list': 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_list',
        'kzxx_item': 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_item',
        'kzxx_label': 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_label',
        'kzxx_name': 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_name',
        'kzxx_item_textarea': 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_item_textarea',
        'kzxx_name_textarea': 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_name_textarea',
        'btn_add': 'app__css__app-pages-SelfHelp-updateInfo-__index__btn_add',
        'title_top': 'app__css__app-pages-SelfHelp-updateInfo-__index__title_top',
        'title_top_name': 'app__css__app-pages-SelfHelp-updateInfo-__index__title_top_name',
        'line': 'app__css__app-pages-SelfHelp-updateInfo-__index__line',
        'detail_adrress': 'app__css__app-pages-SelfHelp-updateInfo-__index__detail_adrress'
    }
};

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }








if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var KzxxFormcComponent = function (_React$Component) {
    _inherits(KzxxFormcComponent, _React$Component);

    function KzxxFormcComponent(props) {
        _classCallCheck(this, KzxxFormcComponent);

        var _this = _possibleConstructorReturn(this, (KzxxFormcComponent.__proto__ || __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default()(KzxxFormcComponent)).call(this, props));

        _this.getDmkMc = function (dmbz, zdbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])("/proData/selectDataList", "GET", { sign: dmbz }).then(function (res) {
                if (res) {
                    if (res.data) {
                        var dmkmcList = _this.state.dmkmcList;
                        dmkmcList[zdbz] = res.data;
                        _this.setState({
                            dmkmcList: dmkmcList
                        });
                    }
                }
            });
        };

        _this.getCascaderDmkMc = function (level, sign, cascaderValue, zdbz) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHFetch__["a" /* default */])("/proData/selectCascaderList", "GET", { level: level, sign: sign, cascaderValue: cascaderValue }).then(function (res) {
                if (res) {
                    if (res.data) {
                        var dmkmcList = _this.state.dmkmcList;
                        dmkmcList[level + zdbz] = res.data;
                        _this.setState({
                            dmkmcList: dmkmcList
                        });
                    }
                }
            });
        };

        _this.handlePreview = function (fjmc, fjid) {

            if (fjmc === "isImage") {
                _this.showPreview('anonymity/docrepo/download/file?attachmentId=' + fjid);
            } else {
                window.open('anonymity/docrepo/download/file?attachmentId=' + fjid);
            }
        };

        _this.showPreview = function (url) {
            _this.setState({
                previewImage: url,
                previewVisible: true
            });
        };

        _this.closeModal = function () {
            return _this.setState({ previewVisible: false });
        };

        _this.fileLists = function (fileLists) {
            {
                var items = [];

                var _loop = function _loop(key) {
                    var fileList = typeof fileLists[key] == 'string' ? fileLists[key].split(";") : fileLists[key];
                    items.push(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                            'a',
                            { onClick: function onClick() {
                                    _this.handlePreview("file", fileList[0]);
                                } },
                            fileList[1]
                        )
                    ));
                };

                for (var key in fileLists) {
                    _loop(key);
                }
                return items;
            }
        };

        _this.imageLists = function (imageLists) {
            {
                var items = [];

                var _loop2 = function _loop2(key) {
                    var imageList = typeof imageLists[key] == 'string' ? imageLists[key].split(";") : imageLists[key];
                    items.push(__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                        'span',
                        null,
                        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('img', { style: { height: "80px", width: "80px" }, src: "anonymity/docrepo/download/file?attachmentId=" + imageList,
                            onClick: function onClick() {
                                _this.handlePreview("isImage", imageList[0]);
                            } })
                    ));
                };

                for (var key in imageLists) {
                    _loop2(key);
                }
                return items;
            }
        };

        _this.state = {
            dmkmcList: {},
            previewVisible: false
        };
        return _this;
    }

    //获取下拉列表value对应的名称

    //获取联级下拉列表value对应的名称

    // 点击文件链接或预览图标时的回调


    //打开图片弹窗

    // 关闭图片弹窗

    // 文件展示 

    //图片展示


    _createClass(KzxxFormcComponent, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                form = _props.form,
                initData = _props.initData;
            var _state = this.state,
                previewVisible = _state.previewVisible,
                previewImage = _state.previewImage;
            //提示信息

            var AlertParams = {
                description: '',
                type: 'info'
                //信息采集字段分类
            };var infoItems = [];
            var reactid = 0;

            if (initData) {
                //表单信息、表单字段信息
                var _initData$zdglVOs = initData.zdglVOs,
                    zdglVOs = _initData$zdglVOs === undefined ? [] : _initData$zdglVOs;

                if (zdglVOs != null) {
                    if (zdglVOs.length > 0) {
                        var array = [];
                        //循环过滤出多行文本框和附件的key，偶数在左，奇数在右，相应的同行的另一条文本也需要加宽
                        for (var key in zdglVOs) {
                            var kjcs = zdglVOs[key].kjcs;

                            var kjcsjson = JSON.parse(kjcs);
                            // debugger
                            if (kjcsjson.type === "textarea" || kjcsjson.type === "oldupload" || kjcsjson.type === "upload") {
                                if (key % 2 === 0) {
                                    array.push(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_number_parse_int___default()(key));
                                    array.push(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_number_parse_int___default()(key) + 1);
                                } else {
                                    array.push(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_number_parse_int___default()(key));
                                    array.push(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_number_parse_int___default()(key) - 1);
                                }
                            }
                        }
                        //显示表单字段信息

                        var _loop3 = function _loop3(_key) {
                            //字段状态、是否必填、默认值、字段标识、字段名称、控件参数、字段值
                            var _zdglVOs$_key = zdglVOs[_key],
                                zdbz = _zdglVOs$_key.zdbz,
                                zdmc = _zdglVOs$_key.zdmc,
                                kjcs = _zdglVOs$_key.kjcs,
                                zdz = _zdglVOs$_key.zdz,
                                zdzt = _zdglVOs$_key.zdzt; //表单字段

                            var zdzmc = '';
                            var kjcsjson = JSON.parse(kjcs);
                            if (kjcsjson.type === 'datepicker' || kjcsjson.type === 'datetimepicker' || kjcsjson.type === 'timepicker' || kjcsjson.type === 'monthpicker' || kjcsjson.type === 'rangepicker') {
                                //日期值展示阶段，从moment转为文字 
                                if (zdz) {
                                    zdzmc = __WEBPACK_IMPORTED_MODULE_18_moment___default()(zdz).format(kjcsjson.format);
                                }
                            } else if (kjcsjson.type === "select") {
                                if (kjcsjson.dataTag && !_this2.state.dmkmcList[zdbz]) {
                                    _this2.getDmkMc(kjcsjson.dataTag, zdbz);
                                }
                                var list = _this2.state.dmkmcList[zdbz];
                                list && list.map(function (item) {
                                    if (item.VALUE === zdz) {
                                        zdzmc = item.LABEL;
                                    }
                                });
                            } else if (kjcsjson.type === "multiselect") {
                                if (kjcsjson.dataTag && !_this2.state.dmkmcList[zdbz]) {
                                    _this2.getDmkMc(kjcsjson.dataTag, zdbz);
                                }
                                var _list = _this2.state.dmkmcList[zdbz];
                                if (zdz) {
                                    (function () {
                                        var multiselect = typeof zdz == 'string' ? zdz.split(",") : zdz;
                                        var multiselectList = [];

                                        var _loop4 = function _loop4(i) {
                                            _list && _list.map(function (item) {
                                                if (item.VALUE === multiselect[i]) {
                                                    multiselectList.push(item.LABEL);
                                                }
                                            });
                                        };

                                        for (var i in multiselect) {
                                            _loop4(i);
                                        }
                                        zdzmc = multiselectList.join(",");
                                    })();
                                }
                            } else if (kjcsjson.type === "switch") {
                                zdzmc = zdz === "1" || zdz === true ? kjcsjson.checkedText : kjcsjson.uncheckedText;
                            } else if (kjcsjson.type === "radio") {
                                kjcsjson.options && kjcsjson.options.map(function (item, key) {
                                    if (item.value === zdz) {
                                        zdzmc = item.label;
                                    }
                                });
                            } else if (kjcsjson.fileType === "file" && zdz) {
                                var fileLists = typeof zdz == 'string' ? zdz.split(",") : zdz;
                                zdzmc = _this2.fileLists(fileLists);
                            } else if (kjcsjson.fileType === "image" && zdz) {
                                if ((typeof zdz === 'undefined' ? 'undefined' : _typeof(zdz)) === 'object') {
                                    var _array = [];
                                    var _iteratorNormalCompletion = true;
                                    var _didIteratorError = false;
                                    var _iteratorError = undefined;

                                    try {
                                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_get_iterator___default()(zdz), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                            var item = _step.value;

                                            if (item.hasOwnProperty('uuid') && item['uuid']) {
                                                _array.push(item['uuid']);
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return) {
                                                _iterator.return();
                                            }
                                        } finally {
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }

                                    zdz = _array;
                                } else {
                                    zdz = zdz.split(",");
                                }
                                zdzmc = _this2.imageLists(zdz);
                            } else {
                                zdzmc = zdz;
                            }

                            var formItem = void 0;
                            formItem = kjcsjson.type === 'textarea' || kjcsjson.type === "oldupload" || kjcsjson.type === "upload" ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                'div',
                                { key: 'div' + reactid++,
                                    style: zdzt === "3" ? { display: "none" } : {},
                                    className: __WEBPACK_IMPORTED_MODULE_15_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item_textarea", _styleModuleImportMap)
                                },
                                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                    'div',
                                    { className: 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_label' },
                                    zdmc,
                                    '\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                    'div',
                                    { className: 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_name_textarea' },
                                    zdzmc
                                )
                            ) : __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                'div',
                                { key: 'div' + reactid++,
                                    style: zdzt === "3" ? { display: "none" } : {},
                                    className: __WEBPACK_IMPORTED_MODULE_15_babel_plugin_react_css_modules_dist_browser_getClassName___default()("kzxx_item", _styleModuleImportMap)
                                },
                                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                    'div',
                                    { className: 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_label' },
                                    zdmc,
                                    '\uFF1A'
                                ),
                                __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                    'div',
                                    { className: 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_name' },
                                    zdzmc
                                )
                            );
                            infoItems.push(formItem);
                        };

                        for (var _key in zdglVOs) {
                            _loop3(_key);
                        }
                    } else {
                        //未找到表单配置的采集字段信息
                        AlertParams['description'] = '当前未配置采集信息项';
                        AlertParams['type'] = 'warning';
                    }
                }
            }

            return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                'div',
                null,
                infoItems.length > 0 && __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pages_Assembly_titleTop__["a" /* default */], {
                        title: '\u6269\u5C55\u4FE1\u606F',
                        extra: false
                    }),
                    infoItems.length > 0 ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a,
                        null,
                        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                            'div',
                            { className: 'p-sw-big' },
                            __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                                'div',
                                { className: 'app__css__app-pages-SelfHelp-updateInfo-__index__kzxx_list' },
                                infoItems
                            )
                        )
                    ) : __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_alert___default.a, _extends({ style: { marginTop: 20 }
                    }, AlertParams, {
                        showIcon: true
                    })),
                    __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a,
                        {
                            visible: previewVisible,
                            footer: null,
                            onCancel: this.closeModal
                        },
                        __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('img', {
                            alt: 'example',
                            style: { width: '100%' },
                            src: previewImage
                        })
                    )
                )
            );
        }
    }]);

    return KzxxFormcComponent;
}(__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);

var KzxxFormc = __WEBPACK_IMPORTED_MODULE_11_antd_lib_form___default.a.create()(KzxxFormcComponent);
/* harmony default export */ __webpack_exports__["a"] = (KzxxFormc);

/***/ }),

/***/ 548:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Index; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loginForm_js__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loginStuInfo_js__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__navigation__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_css__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__phone__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__link__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__process__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__notice__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__window__ = __webpack_require__(1161);





var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }
















if (false) {
    module.hot.accept('./index.css', function () {
        require('./index.css');
    });
}

var _boxTop = function _boxTop(props) {
    var img = props.img,
        title = props.title,
        sub = props.sub,
        extra = props.extra;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__components__["a" /* Flex */],
        { justify: 'between', className: 'app__css__app-pages-index-__index__box_top' },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__components__["a" /* Flex */],
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                { className: 'app__css__app-pages-index-__index__box_top_l' },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img', { src: img, alt: '' }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    'span',
                    null,
                    title
                )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'app__css__app-pages-index-__index__line' }),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                { className: 'app__css__app-pages-index-__index__box_top_r' },
                sub
            )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'div',
            null,
            extra
        )
    );
};

var Index = function (_React$Component) {
    _inherits(Index, _React$Component);

    function Index(props) {
        _classCallCheck(this, Index);

        var _this = _possibleConstructorReturn(this, (Index.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Index)).call(this, props));

        _this.state = {
            pcList: [] //飘窗列表
        };
        return _this;
    }

    _createClass(Index, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_NHFetch__["a" /* default */])('api/zhxg-yxxt/yxwz/fwwgl/pcgl/getPcInfo', 'GET').then(function (resData) {
                if (resData && resData.data) {
                    _this2.setState({ pcList: resData.data });
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var xh = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_NHCore__["b" /* getLoginUser */])().userId;
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6__components__["a" /* Flex */],
                    { className: 'w1180 mt-20', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        'div',
                        { className: 'app__css__app-pages-index-__index__grxx' },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(_boxTop, {
                            img: __webpack_require__(2184),
                            title: xh ? "个人信息" : "个人登录",
                            sub: 'Personal Information'
                        }),
                        xh ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__loginStuInfo_js__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__loginForm_js__["a" /* default */], null)
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__notice__["a" /* default */], { _boxTop: _boxTop })
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__process__["a" /* default */], { _boxTop: _boxTop }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6__components__["a" /* Flex */],
                    { className: 'w1180 app__css__app-pages-index-__index__last', align: 'start' },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__phone__["a" /* default */], { _boxTop: _boxTop }),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__link__["a" /* default */], { _boxTop: _boxTop }),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__navigation__["a" /* default */], { _boxTop: _boxTop })
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    'div',
                    null,
                    this.state.pcList.length > 0 && this.state.pcList.map(function (item, index) {
                        if (item.qyzt == "1") {
                            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__window__["a" /* default */], { pcData: item });
                        } else {
                            return null;
                        }
                    })
                )
            );
        }
    }]);

    return Index;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);



/***/ }),

/***/ 549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REQUEST_USERINFO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECEIVE_USERINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLEAR_USERINFO; });
/* unused harmony export clearUserInfo */
/* unused harmony export receiveUserInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_globalUtil__ = __webpack_require__(225);



var hashHistory = __WEBPACK_IMPORTED_MODULE_0_history_createHashHistory___default()();

var REQUEST_USERINFO = 'REQUEST_USERINFO';
var RECEIVE_USERINFO = 'RECEIVE_USERINFO';
var CLEAR_USERINFO = 'CLEAR_USERINFO';

var requestUserInfo = function requestUserInfo() {
    return {
        type: REQUEST_USERINFO,
        data: null
    };
};

var clearUserInfo = function clearUserInfo() {
    return {
        type: CLEAR_USERINFO,
        user: null
    };
};

var receiveUserInfo = function receiveUserInfo(user) {
    return {
        type: RECEIVE_USERINFO,
        user: user
    };
};

// 退出
// export const userLogout = (dispatch) => {
//     reqLogout().then(res => {
//         let { meta,data }= res.data;
//         if(meta.success){
//             sessionStorage.removeItem("access_user");
//             sessionStorage.removeItem("bpmUrl");
//             sessionStorage.removeItem("menuList");
//             hashHistory.push('/login')
//             dispatch()
//         }else{
//             Modal.error({ title: '退出失败', content: meta.message});
//         }
//     })
// }

/***/ }),

/***/ 550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_NHCore__ = __webpack_require__(8);






var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * @author weishihuai
 * @date 2018/7/19
 * @time 14:34
 * @Description: 为路由提供登录过滤，访问某些页面时，如果没有登录则跳转到登录页
 */

var AuthorizedRoute = function (_React$Component) {
  _inherits(AuthorizedRoute, _React$Component);

  function AuthorizedRoute(props) {
    _classCallCheck(this, AuthorizedRoute);

    var _this = _possibleConstructorReturn(this, (AuthorizedRoute.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(AuthorizedRoute)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(AuthorizedRoute, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_NHCore__["e" /* checkLogin */])(true); //登录检查
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          Component = _props.component,
          rest = _objectWithoutProperties(_props, ['component']);

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["b" /* Route */], _extends({}, rest, { render: function render(props) {
          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, _extends({}, props, rest));
        }
      }));
    }
  }]);

  return AuthorizedRoute;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (AuthorizedRoute);

/***/ }),

/***/ 551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Print; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);





var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }





var SCRIPT_REGEX = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
var arrayLikeMap = function arrayLikeMap(arrayLike, fn) {
    for (var i = 0; i < arrayLike.length; i++) {
        fn(arrayLike[i], i);
    }
};

// 只会缓存iframe，window模式自动缓存在新建窗口
var singletonCacheData = {
    iframe: null,
    update: function update(iframe) {
        this.iframe = iframe;
    }
};

var Print = (_temp = _class = function (_React$Component) {
    _inherits(Print, _React$Component);

    function Print(props) {
        _classCallCheck(this, Print);

        var _this = _possibleConstructorReturn(this, (Print.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Print)).call(this, props));

        _this.getHead = function () {
            var _this$props = _this.props,
                insertHead = _this$props.insertHead,
                ignoreHeadJs = _this$props.ignoreHeadJs,
                title = _this$props.title,
                otherStyle = _this$props.otherStyle;

            var titleTemplate = title ? '<title>' + title + '</title>' : '';
            var otherStyleTemplate = otherStyle ? '<style>' + otherStyle + '</style>' : '';
            var headTagsTemplate = function () {
                if (insertHead) {
                    var innerHTML = document.head.innerHTML;
                    return ignoreHeadJs ? innerHTML.replace(SCRIPT_REGEX, '') : innerHTML;
                }
                return '';
            }();
            return '' + titleTemplate + headTagsTemplate + otherStyleTemplate;
        };

        _this.getBodyStyle = function () {
            var inlineStyle = '';
            var stylesDom = document.body.getElementsByTagName('style');
            arrayLikeMap(stylesDom, function (item) {
                inlineStyle += item.innerHTML;
            });
            return inlineStyle;
        };

        _this.writeTemplate = function (doc) {
            var _this$props2 = _this.props,
                bodyStyle = _this$props2.bodyStyle,
                lazyRender = _this$props2.lazyRender,
                isIframe = _this$props2.isIframe;

            var bodyAttrs = isIframe ? '' : 'onload="window.print()" '; // window时在body上植入事件
            if (lazyRender) {
                doc.write('<html><head></head><body ' + bodyAttrs + '><div></div></body></html>');
                doc.head.innerHTML = _this.getHead();
                __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.render(_this.renderChild(), doc.body.getElementsByTagName('div')[0]); // React的未来版本可能会异步地呈现组件
                if (bodyStyle) {
                    var styleTag = document.createElement('style');
                    styleTag.innerHTML = _this.getBodyStyle();
                    doc.body.appendChild(styleTag);
                }
            } else {
                var _dom = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(_this);
                var dom = _dom ? _dom.innerHTML : null;
                doc.write('<html>\n                <head>' + _this.getHead() + '</head>\n                <body ' + bodyAttrs + '>' + dom + (bodyStyle ? '<style>' + _this.getBodyStyle() + '</style>' : '') + '</body>\n            </html>');
            }
            doc.close();
        };

        _this.createIframe = function (iframeCache, callback) {
            var iframeStyle = _this.props.iframeStyle;

            var iframe = void 0;
            if (iframeCache) {
                iframe = iframeCache;
            } else {
                // 新建iframe节点并添加至页面
                iframe = document.createElement('IFRAME');
                iframe.setAttribute('style', iframeStyle);
                document.body.appendChild(iframe);
            }
            iframe.onload = function () {
                _this.iframePrint(iframe, callback);
            };
            _this.writeTemplate(iframe.contentWindow.document);
        };

        _this.iframePrint = function (iframe, callback) {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            callback && callback(iframe);

            // wait for a new change, iframe是在本页面，所以loading应该与本页共享
            _this.changed = false;
            _this.props.onEnd();
        };

        _this.winCreateAndPrint = function () {
            var win = window.open('', '', _this.props.winStyle);
            _this.writeTemplate(win.document);

            // wait for a new change
            _this.changed = false;
            _this.props.onEnd();
        };

        _this.renderChild = function () {
            var children = _this.props.children;

            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"])(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children));
        };

        _this.changed = true; // 不触发UI渲染
        _this.onPrint = function () {
            var _this$props3 = _this.props,
                isIframe = _this$props3.isIframe,
                clearIframeCache = _this$props3.clearIframeCache,
                singletonCache = _this$props3.singletonCache,
                onStart = _this$props3.onStart;

            onStart();

            if (isIframe) {
                if (clearIframeCache) {
                    // 清理缓存模式
                    _this.createIframe(null, function (iframe) {
                        // remove dom
                        document.body.removeChild(iframe);
                    });
                } else if (singletonCache) {
                    // 单例模式缓存模式
                    if (_this.changed || _this.iframe !== singletonCacheData.iframe) {
                        // 发生改变：1、数据改变；2、缓存对应的组件改变。
                        _this.createIframe(singletonCacheData.iframe, function (iframe) {
                            _this.iframe = iframe; // 保存本地用作对比
                            singletonCacheData.update(iframe);
                        });
                    } else {
                        _this.iframePrint(singletonCacheData.iframe);
                    }
                } else if (_this.changed) {
                    // 普通缓存模式发生改变
                    _this.createIframe(_this.iframe, function (iframe) {
                        _this.iframe = iframe;
                    });
                } else {
                    // 普通缓存模式未改变
                    _this.iframePrint(_this.iframe);
                }
            } else {
                _this.winCreateAndPrint();
            }

            // // lazyRender的遗留临时渲染节点不保留
            // if (this.box) {
            //     document.body.removeChild(this.box);
            //     this.box = null;
            // }
        };
        return _this;
    }

    _createClass(Print, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (this.props.preventDefault) {
                this.prevent = function (e) {
                    if (e.keyCode === 80 && (e.ctrlKey || e.metaKey)) {
                        e.preventDefault();
                        _this2.onPrint();
                    }
                };
                document.addEventListener('keydown', this.prevent);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps !== this.props) {
                // this.setState({changed: true});
                this.changed = true;
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (singletonCacheData.iframe === this.iframe) {
                singletonCacheData.update(null);
            }
            this.iframe && document.body.removeChild(this.iframe);
            // this.box && document.body.removeChild(this.box); // 移除懒加载隐藏节点
            this.prevent && document.removeEventListener('keydown', this.prevent);
        }
    }, {
        key: 'render',
        value: function render() {
            return !this.props.lazyRender ? this.renderChild() || null : null;
        }
    }]);

    return Print;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component), _class.propTypes = {
    insertHead: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, // 是否植入本页面的head标签
    ignoreHeadJs: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, // 当insertHead启用时是否屏蔽JS文件
    bodyStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, // 是否植入body标签中的style，插入body底部
    otherStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, // 附加的样式将直接插入head最底部
    isIframe: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, // 是否使用iframe插入，否则将使用新窗口
    iframeStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, // 将被应用到iframe或者new window
    winStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, // 将被应用到iframe或者new window
    title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, // iframe或者新窗口的标题，将会在打印页的页眉和新窗口的title
    preventDefault: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, // 是否替换Ctrl+P
    lazyRender: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, // 是否只渲染在iframe或者新窗口上
    clearIframeCache: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, // 是否清理dom缓存。否的情况下，如props为改变将保留并直接使用上次打印留下的dom
    singletonCache: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, // 当clearIframeCache关闭时生效。类单例模式，当界面有多个打印组件时，最多允许保留一个缓存
    onStart: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, // 组件开始打印渲染
    onEnd: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, // 组件打印渲染完成
    children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired
}, _class.defaultProps = {
    insertHead: true,
    ignoreHeadJs: true,
    bodyStyle: false,
    otherStyle: undefined,
    isIframe: true,
    iframeStyle: 'position:absolute;width:0px;height:0px;',
    winStyle: 'toolbar=no,menubar=no',
    title: undefined,
    preventDefault: false,
    lazyRender: false,
    clearIframeCache: false,
    singletonCache: true,
    onStart: function onStart() {},
    onEnd: function onEnd() {}
}, _temp);


/***/ }),

/***/ 552:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = RouterComponents;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBddComponent; });
/* unused harmony export baseIndexComponent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return basePrintComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_SelfHelp_Bdd_Config__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__route_AuthorizedRoute__ = __webpack_require__(550);



function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }


//import { Route , Switch , withRouter } from 'react-router-dom'



/**
 * @author qianzhiwei
 * @date 2020/09/25
 * @description 报到单动态路由
 */
function RouterComponents() {
    var routes = bddRouter();
    return routes.map(function (router) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__route_AuthorizedRoute__["a" /* default */], {
            path: router.path,
            key: router.path,
            component: router.component
        });
    });
}

function bddHistory(data, type) {
    return {
        path: '/' + data.dm + type.value.replace(type.value.substr(0, 1), type.value.substr(0, 1).toUpperCase()),
        meta: data.mc + type.name,
        role: '',
        component: type.value === 'index' ? data.indexComponent : data.printComponent
    };
}

//组合路由
var bddRouter = function bddRouter() {
    var routers = [];
    console.log('bdd_school', __WEBPACK_IMPORTED_MODULE_3__pages_SelfHelp_Bdd_Config__["a" /* bdd_school */]);
    __WEBPACK_IMPORTED_MODULE_3__pages_SelfHelp_Bdd_Config__["a" /* bdd_school */].map(function (school) {
        __WEBPACK_IMPORTED_MODULE_3__pages_SelfHelp_Bdd_Config__["b" /* types */].map(function (type) {
            routers.push(bddHistory(school, type));
        });
    });
    console.log('routers', routers);
    return routers;
};

//根据schoolcode获取相应的组件
var getBddComponent = function getBddComponent(school, type) {
    var res = undefined;
    var arr = [].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3__pages_SelfHelp_Bdd_Config__["a" /* bdd_school */]));
    arr = arr.filter(function (item) {
        return item.dm == school;
    });
    if (arr.length > 0) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names___default()(arr[0]).some(function (key) {
            if (key.includes(type)) {
                res = arr[0][key];
                return true;
            }
        });
    }
    return res;
};

var baseIndexComponent = __WEBPACK_IMPORTED_MODULE_3__pages_SelfHelp_Bdd_Config__["c" /* base_indexComponent */];
var basePrintComponent = __WEBPACK_IMPORTED_MODULE_3__pages_SelfHelp_Bdd_Config__["d" /* base_printComponent */];

// function bddComponent(school, type) {
//     return '@pages/SelfHelp/Bdd/pages/' + school + '/' + type;
// }

// @withRouter
// class RouterComponents extends React.Component{

//     render () {
//         return (
//             //     <Switch>
//             //     {routes.map(
//             //         router => {
//             //             return (
//             //                 <AuthorizedRoute 
//             //                     path={ router.path }
//             //                     key={ router.path }
//             //                     component={ 
//             //                         () => {
//             //                             return props.router.component
//             //                         } 
//             //                     } 
//             //                 /> 
//             //             )
//             //         }
//             // )}
//             // </Switch>
//         )
//     }
// }

/* unused harmony default export */ var _unused_webpack_default_export = (RouterComponents);

/***/ }),

/***/ 553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = query;
/* harmony export (immutable) */ __webpack_exports__["c"] = post;
/* unused harmony export postForm */
/* unused harmony export authLoginForm */
/* harmony export (immutable) */ __webpack_exports__["b"] = get;
/* unused harmony export insert */
/* unused harmony export update */
/* unused harmony export remove */
/* unused harmony export requestAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__(1882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);




var _extends = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*
 * @Description: 封装axios方法
 * @Author: admin
 * @Date: 2021-7-31 11:21:43
 * @LastEditors: piante
 * @LastEditTime: 2021-7-31 16:24:51
 */


window.flag = false; //弹出层标记
// 请求超时[config]:showTimeout    1.[true]:显示提示 2.["again"]:显示再次提示弹出框
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.timeout = 30000;
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.withCredentials = true;
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers['Access-Control-Allow-Origin'] = '*';
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers['Access-Control-Allow-Methods'] = 'GET, POST, PATCH, PUT, DELETE, OPTIONS';
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers['Access-Control-Allow-Headers'] = 'Origin, Content-Type, X-Auth-Token';
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.get['X-Requested-With'] = 'XMLHttpRequest'; //Ajax get请求标识
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest'; //Ajax post请求标识
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'; //POST请求参数获取不到的问题
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.post['Accept'] = 'application/json'; //POST请求参数获取不到的问题
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.put['X-Requested-With'] = 'XMLHttpRequest'; //Ajax put请求标识
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.delete['X-Requested-With'] = 'XMLHttpRequest'; //Ajax delete请求标识


__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.request.use(function (config) {
  var user = window.sessionStorage.getItem('userLogin');
  if (user) {
    user = JSON.parse(user);
    config.headers.post['loginUserOrgId'] = user.orgId;
    config.headers.post['loginUserId'] = user.userId;
    config.headers.get['loginUserId'] = user.userId;
    config.headers.get['loginUserOrgId'] = user.orgId;

    var Authorization = user.tokenId;
    if (Authorization != null && Authorization != '') {
      config.headers.delete['Authorization'] = Authorization;
      config.headers.get['Authorization'] = Authorization;
      config.headers.post['Authorization'] = Authorization;
      config.headers.put['Authorization'] = Authorization;
    }
  }
  //添加get请求参数
  if (config.method == 'get') {
    config.params = _extends({}, config.params, {
      _t: Date.parse(new Date()) / 1000
    });
  } else {
    config.params = _extends({}, config.params, {
      _t: Date.parse(new Date()) / 1000
    });
  }
  return config;
});

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_3_axios___default.a);
function query(url, params) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, _extends({ params: params }, config)).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err.data);
    });
  });
}
//post请求会有post参数也可能有get参数
function post(url, datas, params) {
  var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, datas, _extends({ params: params }, config)).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err.data);
    });
  });
}

function postForm(url, datas, params) {
  var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(datas), _extends({ params: params }, config)).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err.data);
    });
  });
}
// 使用Authorization统一验证登录
function authLoginForm(url, headers, params) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(params), { headers: headers }).then(function (res) {
      console.log(res);
      resolve(res.data);
    }).catch(function (err) {
      reject(err.data);
    });
  });
}
function get(url, params) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, _extends({ params: params }, config)).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err.data);
    });
  });
}
function insert(url, datas, params) {
  var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, datas, _extends({ params: params }, config)).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err.data);
    });
  });
}

function update(url, datas, params) {
  var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, datas, _extends({ params: params }, config)).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err.data);
    });
  });
}

function remove(url, datas, params) {
  var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, datas, _extends({ params: params }, config)).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err.data);
    });
  });
}

function requestAll() {
  for (var _len = arguments.length, paramsFun = Array(_len), _key = 0; _key < _len; _key++) {
    paramsFun[_key] = arguments[_key];
  }

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.all.apply(__WEBPACK_IMPORTED_MODULE_3_axios___default.a, paramsFun).then(__WEBPACK_IMPORTED_MODULE_3_axios___default.a.spread(function () {
      var responseList = [];

      for (var _len2 = arguments.length, response = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        response[_key2] = arguments[_key2];
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(response), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var res = _step.value;

          if (!res.status && res.response) {
            responseList.push(res.response.data);
          } else {
            responseList.push(res.data);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return responseList;
    })).then(function (res) {
      resolve(res);
    }).catch(function (err) {
      reject(err.data);
    });
  });
}

/***/ }),

/***/ 648:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ant-upload-select-picture-card":"app__css__app-components-common-NHPicturesWall-__NHPicturesWall__ant-upload-select-picture-card","ant-upload-text":"app__css__app-components-common-NHPicturesWall-__NHPicturesWall__ant-upload-text"};

/***/ }),

/***/ 649:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"progress":"app__css__app-pages-SelfHelp-customLink-__index__progress","row":"app__css__app-pages-SelfHelp-customLink-__index__row","jbxx_icon":"app__css__app-pages-SelfHelp-customLink-__index__jbxx_icon","upload-box":"app__css__app-pages-SelfHelp-customLink-__index__upload-box","upload-title":"app__css__app-pages-SelfHelp-customLink-__index__upload-title","jbxx_item":"app__css__app-pages-SelfHelp-customLink-__index__jbxx_item","item-label":"app__css__app-pages-SelfHelp-customLink-__index__item-label","item-name":"app__css__app-pages-SelfHelp-customLink-__index__item-name","kzxx_list":"app__css__app-pages-SelfHelp-customLink-__index__kzxx_list","kzxx_item":"app__css__app-pages-SelfHelp-customLink-__index__kzxx_item","kzxx_label":"app__css__app-pages-SelfHelp-customLink-__index__kzxx_label","kzxx_name":"app__css__app-pages-SelfHelp-customLink-__index__kzxx_name","kzxx_item_textarea":"app__css__app-pages-SelfHelp-customLink-__index__kzxx_item_textarea","kzxx_name_textarea":"app__css__app-pages-SelfHelp-customLink-__index__kzxx_name_textarea","btn_add":"app__css__app-pages-SelfHelp-customLink-__index__btn_add","personal":"app__css__app-pages-SelfHelp-customLink-__index__personal","ueditor":"app__css__app-pages-SelfHelp-customLink-__index__ueditor"};

/***/ }),

/***/ 650:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"progress":"app__css__app-pages-SelfHelp-info-__index__progress","jbxx_icon":"app__css__app-pages-SelfHelp-info-__index__jbxx_icon","upload-box":"app__css__app-pages-SelfHelp-info-__index__upload-box","upload-title":"app__css__app-pages-SelfHelp-info-__index__upload-title","jbxx_item":"app__css__app-pages-SelfHelp-info-__index__jbxx_item","jbxx_item2":"app__css__app-pages-SelfHelp-info-__index__jbxx_item2","item-label":"app__css__app-pages-SelfHelp-info-__index__item-label","item-name":"app__css__app-pages-SelfHelp-info-__index__item-name","kzxx_list":"app__css__app-pages-SelfHelp-info-__index__kzxx_list","kzxx_item":"app__css__app-pages-SelfHelp-info-__index__kzxx_item","kzxx_label":"app__css__app-pages-SelfHelp-info-__index__kzxx_label","kzxx_name":"app__css__app-pages-SelfHelp-info-__index__kzxx_name","kzxx_item_textarea":"app__css__app-pages-SelfHelp-info-__index__kzxx_item_textarea","kzxx_name_textarea":"app__css__app-pages-SelfHelp-info-__index__kzxx_name_textarea","btn_add":"app__css__app-pages-SelfHelp-info-__index__btn_add","title_top":"app__css__app-pages-SelfHelp-info-__index__title_top","title_top_name":"app__css__app-pages-SelfHelp-info-__index__title_top_name","line":"app__css__app-pages-SelfHelp-info-__index__line","detail_adrress":"app__css__app-pages-SelfHelp-info-__index__detail_adrress"};

/***/ }),

/***/ 651:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal_l":"app__css__app-pages-SelfHelp-major-__index__modal_l","modal_l_label":"app__css__app-pages-SelfHelp-major-__index__modal_l_label","modal_r":"app__css__app-pages-SelfHelp-major-__index__modal_r","line":"app__css__app-pages-SelfHelp-major-__index__line","line_con":"app__css__app-pages-SelfHelp-major-__index__line_con","line_l":"app__css__app-pages-SelfHelp-major-__index__line_l","line_r":"app__css__app-pages-SelfHelp-major-__index__line_r","text-label":"app__css__app-pages-SelfHelp-major-__index__text-label","text-name":"app__css__app-pages-SelfHelp-major-__index__text-name","coll_label":"app__css__app-pages-SelfHelp-major-__index__coll_label","coll_b":"app__css__app-pages-SelfHelp-major-__index__coll_b"};

/***/ }),

/***/ 652:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal_l":"app__css__app-pages-SelfHelp-majorFa-__index__modal_l","modal_l_label":"app__css__app-pages-SelfHelp-majorFa-__index__modal_l_label","modal_r":"app__css__app-pages-SelfHelp-majorFa-__index__modal_r","line":"app__css__app-pages-SelfHelp-majorFa-__index__line","line_con":"app__css__app-pages-SelfHelp-majorFa-__index__line_con","line_l":"app__css__app-pages-SelfHelp-majorFa-__index__line_l","line_r":"app__css__app-pages-SelfHelp-majorFa-__index__line_r","text-label":"app__css__app-pages-SelfHelp-majorFa-__index__text-label","text-name":"app__css__app-pages-SelfHelp-majorFa-__index__text-name","coll_label":"app__css__app-pages-SelfHelp-majorFa-__index__coll_label","coll_b":"app__css__app-pages-SelfHelp-majorFa-__index__coll_b","mojorList":"app__css__app-pages-SelfHelp-majorFa-__index__mojorList","col":"app__css__app-pages-SelfHelp-majorFa-__index__col","title":"app__css__app-pages-SelfHelp-majorFa-__index__title"};

/***/ }),

/***/ 653:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal_l":"app__css__app-pages-SelfHelp-majorFb-__index__modal_l","modal_l_label":"app__css__app-pages-SelfHelp-majorFb-__index__modal_l_label","modal_r":"app__css__app-pages-SelfHelp-majorFb-__index__modal_r","line":"app__css__app-pages-SelfHelp-majorFb-__index__line","line_con":"app__css__app-pages-SelfHelp-majorFb-__index__line_con","line_l":"app__css__app-pages-SelfHelp-majorFb-__index__line_l","line_r":"app__css__app-pages-SelfHelp-majorFb-__index__line_r","text-label":"app__css__app-pages-SelfHelp-majorFb-__index__text-label","text-name":"app__css__app-pages-SelfHelp-majorFb-__index__text-name","coll_label":"app__css__app-pages-SelfHelp-majorFb-__index__coll_label","coll_b":"app__css__app-pages-SelfHelp-majorFb-__index__coll_b"};

/***/ }),

/***/ 654:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal_l":"app__css__app-pages-SelfHelp-majorFc-__index__modal_l","modal_l_label":"app__css__app-pages-SelfHelp-majorFc-__index__modal_l_label","modal_r":"app__css__app-pages-SelfHelp-majorFc-__index__modal_r","line":"app__css__app-pages-SelfHelp-majorFc-__index__line","line_con":"app__css__app-pages-SelfHelp-majorFc-__index__line_con","line_l":"app__css__app-pages-SelfHelp-majorFc-__index__line_l","line_r":"app__css__app-pages-SelfHelp-majorFc-__index__line_r","text-label":"app__css__app-pages-SelfHelp-majorFc-__index__text-label","text-name":"app__css__app-pages-SelfHelp-majorFc-__index__text-name","coll_label":"app__css__app-pages-SelfHelp-majorFc-__index__coll_label","coll_b":"app__css__app-pages-SelfHelp-majorFc-__index__coll_b"};

/***/ }),

/***/ 655:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"progress":"app__css__app-pages-SelfHelp-newInfo-__index__progress","jbxx_icon":"app__css__app-pages-SelfHelp-newInfo-__index__jbxx_icon","upload-box":"app__css__app-pages-SelfHelp-newInfo-__index__upload-box","upload-title":"app__css__app-pages-SelfHelp-newInfo-__index__upload-title","jbxx_item":"app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item","jbxx_item2":"app__css__app-pages-SelfHelp-newInfo-__index__jbxx_item2","item-label":"app__css__app-pages-SelfHelp-newInfo-__index__item-label","item-name":"app__css__app-pages-SelfHelp-newInfo-__index__item-name","kzxx_list":"app__css__app-pages-SelfHelp-newInfo-__index__kzxx_list","kzxx_item":"app__css__app-pages-SelfHelp-newInfo-__index__kzxx_item","kzxx_label":"app__css__app-pages-SelfHelp-newInfo-__index__kzxx_label","kzxx_name":"app__css__app-pages-SelfHelp-newInfo-__index__kzxx_name","kzxx_item_textarea":"app__css__app-pages-SelfHelp-newInfo-__index__kzxx_item_textarea","kzxx_name_textarea":"app__css__app-pages-SelfHelp-newInfo-__index__kzxx_name_textarea","btn_add":"app__css__app-pages-SelfHelp-newInfo-__index__btn_add","title_top":"app__css__app-pages-SelfHelp-newInfo-__index__title_top","title_top_name":"app__css__app-pages-SelfHelp-newInfo-__index__title_top_name","line":"app__css__app-pages-SelfHelp-newInfo-__index__line","detail_adrress":"app__css__app-pages-SelfHelp-newInfo-__index__detail_adrress"};

/***/ }),

/***/ 656:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"page_pay":"app__css__app-pages-SelfHelp-pay-__index__page_pay"};

/***/ }),

/***/ 657:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tab_box":"app__css__app-pages-SelfHelp-whrjChooseDor-__index__tab_box","tip":"app__css__app-pages-SelfHelp-whrjChooseDor-__index__tip","item":"app__css__app-pages-SelfHelp-whrjChooseDor-__index__item","item_con":"app__css__app-pages-SelfHelp-whrjChooseDor-__index__item_con","round":"app__css__app-pages-SelfHelp-whrjChooseDor-__index__round","select_box":"app__css__app-pages-SelfHelp-whrjChooseDor-__index__select_box","select_list":"app__css__app-pages-SelfHelp-whrjChooseDor-__index__select_list","select_item":"app__css__app-pages-SelfHelp-whrjChooseDor-__index__select_item","select_item_b":"app__css__app-pages-SelfHelp-whrjChooseDor-__index__select_item_b","select_item_y":"app__css__app-pages-SelfHelp-whrjChooseDor-__index__select_item_y","item_btn_box":"app__css__app-pages-SelfHelp-whrjChooseDor-__index__item_btn_box","item_btn":"app__css__app-pages-SelfHelp-whrjChooseDor-__index__item_btn","modal_box":"app__css__app-pages-SelfHelp-whrjChooseDor-__index__modal_box","modal_list":"app__css__app-pages-SelfHelp-whrjChooseDor-__index__modal_list"};

/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_fetch__ = __webpack_require__(1688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NHCore__ = __webpack_require__(8);






var _typeof = typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };





//请求默认路径
var pathUrl = "api/zhxg-yxwz";

var hasClass = function hasClass(node, className) {
    var exist = false;
    if (node.getAttribute('class')) {
        // 存class属性
        // 式1
        if (node.getAttribute('class').indexOf(className) > -1) {
            exist = true;
        }
        // 式2
        if (node.className.indexOf(className) > -1) {
            exist = true;
        }
    }
    return exist;
};

var parents = function parents(obj, className) {
    if (obj.tagName === 'BODY') {
        return undefined;
    }
    if (hasClass(obj, className)) {
        return obj;
    } else {
        return parents(obj.parentNode, className);
    }
};

var getTitles = function getTitles(fields) {
    var errorInfo = "";
    for (var i = 0; i < fields.length; i++) {
        var obj = document.getElementById(fields[i]);
        if (obj) {
            //获取标签的上级第一个存在ant-form-item-control-wrapper类的标签
            var parentObj = parents(obj, 'ant-form-item-control-wrapper');
            if (parentObj) {
                var prevObj = parentObj.previousSibling;
                if (prevObj) {
                    var labelObj = prevObj.getElementsByTagName("label");
                    if (labelObj && labelObj.length > 0) {
                        var title = labelObj[0].attributes["title"].nodeValue;
                        if (title) {
                            errorInfo += "," + title;
                        }
                    }
                }
            }
        }
    }
    return errorInfo ? errorInfo.substring(1) : "";
};

/**
 * 唯一性约束错误提示
 */
var onlyDataErrorTip = function onlyDataErrorTip(res) {
    var fieldStr = res.message.substring(14, res.message.length - 1);
    var fields = fieldStr.split(",");
    var errorInfo = getTitles(fields);
    if (errorInfo) {
        __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.info(errorInfo + "已经存在！");
    } else {
        __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.info("存在数据违反了唯一性约束，请检查之后再提交！");
    }
};

/**
 * 数据太长错误提示
 */
var dataToLongErrorTip = function dataToLongErrorTip(res) {
    var fieldStr = res.message.substring(16, res.message.length - 1);
    var fields = fieldStr.split(",");
    var errorInfo = getTitles([fields[0]]);
    if (errorInfo) {
        __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.info(errorInfo + "数据太长(要求长度：" + fields[2] + "，实际长度：" + fields[1] + ")！");
    } else {
        __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.info("存在数据值太长，请检查之后再提交！");
    }
};

/**
 * 数据不能为空
 */
var columnNotNullTip = function columnNotNullTip(res) {
    var fieldStr = res.message.substring(14, res.message.length - 1);
    var fields = fieldStr.split(",");
    var errorInfo = getTitles(fields);
    if (errorInfo) {
        __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.info(errorInfo + "不能为空！");
    } else {
        __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.info("存在数据不能为空，请检查之后再提交！");
    }
};

var NHFetch = function NHFetch(pUrl, pMethod, params, errorFunc) {
    var opts = {};
    var tmpHeader = "";
    var url = pUrl;
    var method = "";

    if (!url.startsWith("api/") && !url.startsWith("front/")) {
        url = pathUrl + url;
    }

    //默认的请求方式是POST
    if (pMethod === undefined || pMethod === "") {
        method = "POST";
    } else {
        method = pMethod;
    }

    if (method.toLowerCase() === 'get') {
        //如果是get方式，则把参数拼凑到url路径上面
        if (params !== undefined && params !== "") {
            //如果params是Map对象，则需要先转换成字符串
            if (typeof params === 'string') {
                url = url + "?" + params;
            } else {
                //不是字符串就一定是map对象
                var paramsStr = "";
                for (var key in params) {
                    if (_typeof(params[key]) === 'object') {
                        var params2 = params[key];
                        for (var key2 in params2) {
                            paramsStr += "&" + key + "." + key2 + "=" + params2[key2];
                        }
                    } else {
                        paramsStr += "&" + key + "=" + params[key];
                    }
                }
                url = url + "?" + paramsStr;
            }
        }
        tmpHeader = "application/x-www-form-urlencoded;charset=UTF-8";
    } else {
        //除了get，所有方法改为post
        method = "POST";
        tmpHeader = "application/json;charset=UTF-8";
        if (params !== undefined && params !== "") {
            opts.body = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(params);
        }
    }
    opts.method = method;
    //  credentials: 'include',
    opts.headers = { "Content-Type": tmpHeader };

    var token = window.sessionStorage.getItem("access_token");
    if (token) {
        opts.headers.Authorization = token;
    }
    var nodeEnv = "production" || 'development';
    if (nodeEnv === 'development') {
        opts.headers.loginUserId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__NHCore__["b" /* getLoginUser */])().userId;
    }

    opts.credentials = 'include';
    return fetch(url, opts).then(function (response) {
        if (response.status === 200) {
            if (pMethod === 'nbpost' || pMethod === 'NBPOST') {
                return response.blob();
            } else {
                return response.json();
            }
        } else if (response.status === 302) {
            __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.error("未登录或登录已过期,请刷新页面重新登录！");
            sessionStorage.removeItem("userLogin");
            sessionStorage.removeItem("access_token");
        } else if (response.status === 401) {
            __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.error("您正在尝试访问未授权的功能!");
        } else {
            //如果存在错误的回调方法，则调用回调方法，否则提示网络请求异常
            if (errorFunc) {
                errorFunc();
            } else {
                __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.error('系统出现异常，请联系管理员！');
            }
        }
        return undefined;
    }).then(function (res) {
        if (res === undefined) {
            return undefined;
        } else if (res.meta && res.meta.statusCode === 401 || res.code === 302) {
            //判断是否没有权限
            __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.error("您正在尝试访问未授权的功能!");
            return undefined;
        } else if (res.meta && res.meta.statusCode === 500) {
            __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.error('系统出现异常，请联系管理员！');
            return undefined;
        } else if (res && res.code && res.code !== 200) {
            //判断出现的问题
            var msg = res.message;
            if (msg.startsWith("businessLogicError[")) {
                //自定义的提示（错误）
                //Modal.error({ title: '错误提示', content: res.message.substring(19,res.message.length-1),});
                __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.info(res.message.substring(19, res.message.length - 1));
            } else if (msg.startsWith("businessLogicWarm[")) {
                //自定义的提示（警告）
                //Modal.warning({ title: '警告提示', content: res.message.substring(19,res.message.length-1),});
                __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.info(res.message.substring(18, res.message.length - 1));
            } else if (msg.startsWith("businessLogicInfo[")) {
                //自定义的提示（消息）
                //Modal.info({ title: '消息提示', content: ,});
                __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.info(res.message.substring(19, res.message.length - 1));
            } else if (msg.startsWith("onlyDataError[")) {
                //数据唯一性异常
                onlyDataErrorTip(res);
            } else if (msg.startsWith("dataToLongError[")) {
                //数据太长
                dataToLongErrorTip(res);
            } else if (msg.startsWith("columnNotNull[")) {
                //数据不能为空异常
                columnNotNullTip(res);
            } else {
                __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.error('系统出现异常，请联系管理员！');
            }
            return undefined;
        } else if (res.status && res.status === 404) {
            __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.error('系统出现异常，请联系管理员！');
            return undefined;
        } else if (res && res.code && res.code === 200) {
            //返回的是正确的结果,公司通用放回格式
            return res;
        } else if (res && res.meta && res.meta.statusCode === 200) {
            //返回的是正确的结果，四部返回格式
            return res;
        } else if (res) {
            return res;
        } else {
            //剩下的情况都是有错误
            __WEBPACK_IMPORTED_MODULE_4_antd_lib_message___default.a.error('系统出现异常，请联系管理员！');
        }
        //在此处统一对后台抛出来的异常进行处理
        return undefined;
    }).catch(function (error) {
        // if((error+'').indexOf("NetworkError when attempting to fetch resource")>-1){
        //     //出现这种错误是因为登录过期了，系统自动跳转到统一登录界面，但是系统中统一登录不存在就出现当前错误
        //     sessionStorage.removeItem("userLogin");
        //     sessionStorage.removeItem("access_token");
        // }else if(error.status===302){
        //     message.error("未登录或登录已过期,请刷新页面重新登录！");
        //     sessionStorage.removeItem("userLogin");
        //     sessionStorage.removeItem("access_token");
        // }else{
        //     sessionStorage.removeItem("userLogin");
        //     sessionStorage.removeItem("access_token");

        //     Modal.error({ title: '错误提示', content: '网络请求异常,请联系管理员'});
        // }
        sessionStorage.removeItem("userLogin");
        sessionStorage.removeItem("access_token");
        return error;
    });
};

/* harmony default export */ __webpack_exports__["a"] = (NHFetch);

/***/ }),

/***/ 71:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_NHFetch__ = __webpack_require__(7);








var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }






var pathUrl = '/proData/selectDataList';
var Option = __WEBPACK_IMPORTED_MODULE_6_antd_lib_select___default.a.Option;

/**
 * 下拉选择器
 * 1、符合自定义表单组件规范，结合FormItem使用时不会出现警告信息
 * 2、使用sign属性时，后台对应sign标识的sql查询语句列必须以value、label作为别名
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-03-29 18:00:31
 * Version: 1.3
 * Modify log:
 * 2018-04-18
 *      1、新增filterData属性，该属性可以过滤（或保留）指定keys值项
 * 2018-04-20
 *      2、新增dataSource属性，允许使用固定的数据源构造下拉数据，数据源格式为[{value:'value',label:'label'},{},...]
 * 2018-06-04
 *      3、解决sign为空或空字符串的时候，请求后台数据源报错问题
 */
var NHSelect = (_temp = _class = function (_React$Component) {
  _inherits(NHSelect, _React$Component);

  function NHSelect(props) {
    _classCallCheck(this, NHSelect);

    var _this = _possibleConstructorReturn(this, (NHSelect.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(NHSelect)).call(this, props));

    _initialiseProps.call(_this);

    var value = _this.props.value || '';
    _this.state = {
      data: [],
      value: value || ''
    };
    return _this;
  }

  _createClass(NHSelect, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          sign = _props.sign,
          dataSource = _props.dataSource;

      //如果是使用数据源标识，则优先加载远程数据

      if (sign && sign != '') {
        this.loadRemoteData(sign);
      } else {
        //如果没有使用远程数据，则加载本地数据
        this.loadLocalData();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Should be a controlled component.
      if ('value' in nextProps) {
        var value = nextProps.value;
        this.setState({ value: value });
      }

      //为了防止在使用本地数据源的时候，在上级组件使用异步请求，导致在componentDidMount阶段未能获取到返回的dataSource
      if ('dataSource' in nextProps) {
        var dataSource = nextProps.dataSource;
        this.setState({ data: dataSource });
      }
    }

    //加载远程数据


    //加载本地数据


    //解析数据


    //下拉选项选中时回调


    //下拉选择器input value值变化时回调


    //提供onChange回调方法给Form表单，表明这是一个自定义表单受控组件

  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          style = _props2.style,
          placeholder = _props2.placeholder,
          disabled = _props2.disabled,
          defaultValue = _props2.defaultValue,
          filterData = _props2.filterData;
      var _state = this.state,
          value = _state.value,
          data = _state.data;

      var options = [];

      //如果有过滤条件
      if (filterData) {
        var type = filterData.type,
            _filterData$filterkey = filterData.filterkeys,
            filterkeys = _filterData$filterkey === undefined ? [] : _filterData$filterkey;

        switch (type) {
          //过滤掉指定key值
          case 'remove':
            {
              var newData = data.filter(function (item) {
                if (filterkeys.find(function (key) {
                  return (item.VALUE || item.value) == key;
                })) {
                  return false;
                } else {
                  return true;
                }
              });
              options = newData.map(function (option) {
                return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                  Option,
                  { key: option.VALUE || option.value, value: option.VALUE || option.value },
                  option.LABEL || option.label
                );
              });
              break;
            }
          //保留指定key值
          case 'save':
            {
              var _newData = data.filter(function (item) {
                if (filterkeys.find(function (key) {
                  return (item.VALUE || item.value) == key;
                })) {
                  return true;
                } else {
                  return false;
                }
              });
              options = _newData.map(function (option) {
                return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                  Option,
                  { key: option.VALUE || option.value, value: option.VALUE || option.value },
                  option.LABEL || option.label
                );
              });
              break;
            }
          //未找到指定过滤类型，则不做过滤
          default:
            {
              options = data.map(function (option) {
                return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                  Option,
                  { key: option.VALUE || option.value, value: option.VALUE || option.value },
                  option.LABEL || option.label
                );
              });
              break;
            }
        }
      } else {
        options = data.map(function (option) {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            Option,
            { key: option.VALUE || option.value, value: option.VALUE || option.value },
            option.LABEL || option.label
          );
        });
      }

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_antd_lib_select___default.a,
          {
            style: style,
            showSearch: true,
            defaultValue: defaultValue,
            value: value,
            onSelect: this.handleSelect,
            onChange: this.handleChange,
            placeholder: placeholder,
            notFoundContent: '无数据',
            disabled: disabled,
            filterOption: function filterOption(input, option) {
              return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
            }
          },
          options
        )
      );
    }
  }]);

  return NHSelect;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.loadRemoteData = function (sign) {
    var array = [];
    if (sign.startsWith('api/')) {
      array = sign.split('?');
    } else {
      array.push(pathUrl);
      array.push(sign);
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_NHFetch__["a" /* default */])(array[0], 'GET', { sign: array[1] }).then(function (res) {
      if (res) {
        _this2.parseData(res.data);
      }
    });
  };

  this.loadLocalData = function () {
    if (_this2.props.dataSource) {
      var nullOption = [{ value: '', label: '请选择...' }];
      _this2.setState({ data: [].concat(nullOption, _toConsumableArray(_this2.props.dataSource)) });
    }
  };

  this.parseData = function (data) {
    if (data) {
      var nullOption = [{ value: '', label: '请选择...' }];
      _this2.setState({ data: [].concat(nullOption, _toConsumableArray(data)) });
    } else {
      //如果远程数据为空，则尝试加载本地数据源
      _this2.loadLocalData();
    }
  };

  this.handleSelect = function (value, option) {
    var label = option.props.children;
    var onSelect = _this2.props.onSelect;
    if (onSelect) {
      onSelect(value, label, option);
    }
  };

  this.handleChange = function (value, option) {
    if (!('value' in _this2.props)) {
      _this2.setState({
        value: value
      });
    }

    _this2.triggerChange(value);
  };

  this.triggerChange = function (changedValue) {
    // Should provide an event to pass value to Form.
    var onChange = _this2.props.onChange;
    if (onChange) {
      onChange(changedValue);
    }
  };
}, _temp);

//属性默认值

NHSelect.defaultProps = {
  placeholder: '请选择...',
  disabled: false

  //属性检查
};NHSelect.propTypes = {
  sign: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, //远程数据源标识
  dataSource: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    label: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node
  })), //本地数据源
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object, //样式
  placeholder: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, //下拉提示
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool, //是否禁用
  defaultValue: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, //默认值
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, //初始值
  filterData: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['remove', 'save']), //是保留还是过滤掉
    filterkeys: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array //保留或过滤的key值
  }), //要过滤掉的Key值
  onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func, //下拉选项选中时回调
  onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func //下拉框值变化时回调
};

/* harmony default export */ __webpack_exports__["a"] = (NHSelect);

/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getSuitHeight */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createUuid; });
/* unused harmony export getStyle */
/* unused harmony export hasAuth */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLoginUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return checkLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getLoginUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return browserJudge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_NHFetch__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);





var history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()();
//获取高度
var getSuitHeight = function getSuitHeight(node) {
    var height = SuitHeight(node) - 2; //设置合适高度的时候减去两个边框的高度，可以保证紧密镶嵌式不会因为上下边框产生滚动条
    return height;
};
//设置高度
/*setSuitHeight=function(node,flag){
    var height=SuitHeight(node)-2;//设置合适高度的时候减去两个边框的高度，可以保证紧密镶嵌式不会因为上下边框产生滚动条
    node.outerHeight=height;
    if(flag!==false){
        height.style.display='auto';
    }
    //this.addClass("nh-needsuit")
}*/

function SuitHeight(node) {
    var parentObj = node.parentNode;
    //获得parentObj所有直接非grid子节点
    var childrenObj = parentObj.childNodes;
    var elseChildrenHeight = 0;
    for (var i = 0; i < childrenObj.length; i++) {
        if (childrenObj[i].nodeName == "#text" && !/\s/.test(childrenObj.nodeValue)) {
            continue;
        }
        if (childrenObj[i] != node && childrenObj[i].tagName != "SCRIPT" && childrenObj[i].tagName != "STYLE" && childrenObj[i].style.display != "none" && childrenObj[i].style.position != "absolute") {
            //吧script的高度也排除掉
            var marginTop = getDomStyle(childrenObj[i], "marginTop") ? parseInt(getDomStyle(childrenObj[i], "marginTop")) : 0;
            var marginBottom = getDomStyle(childrenObj[i], "marginBottom") ? parseInt(getDomStyle(childrenObj[i], "marginBottom")) : 0;
            if (childrenObj[i].offsetHeight && childrenObj[i].offsetHeight > 0) {
                //获得所有非本元素的其他父类子元素的margin的值
                elseChildrenHeight += childrenObj[i].offsetHeight + marginTop + marginBottom;
            }
        }
    }
    //父级对象的高度-其他对象的高度
    var gridSuitHeight = parentObj.clientHeight - elseChildrenHeight;
    return gridSuitHeight;
}

//获取UUID
var createUuid = function createUuid() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
};

var getStyle = function getStyle(element, attr) {
    return getDomStyle(element, attr);
};

function getDomStyle(curEle, attr) {
    if ("getComputedStyle" in window) {
        return window.getComputedStyle(curEle, null)[attr];
    } else {
        if (attr === "opacity") {
            var val = curEle.currentStyle["filter"];
            var reg = /^alpha\(opacity=(\d+(?:\.\d+)?)\)$/i;
            return reg.test(val) ? reg.exec(val)[1] / 100 : 1;
        } else {
            return curEle.currentStyle[attr];
        }
    }
}

//判断该用户是否存在该权限
var hasAuth = function hasAuth(auth) {
    var initState = sessionStorage.getItem('userLogin') ? JSON.parse(sessionStorage.getItem('userLogin')) : {};
    var auths = initState.authorization ? initState.authorization : {};
    return auths[auth] !== undefined;
};

//获取登陆用户信息
var getLoginUser = function getLoginUser(auth) {
    var loginUser = sessionStorage.getItem('userLogin') ? JSON.parse(sessionStorage.getItem('userLogin')) : { authorization: {}, menus: [] };
    return loginUser;
};

var checkLogin = function checkLogin(isLink, index) {
    var userId = getLoginUser() ? getLoginUser().userId : '';
    if (!userId) {

        if (window.casLogoutUrl && window.casLogoutUrl != '') {
            window.location = window.casLogoutUrl;
        }

        __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.warning("未获取登录信息。");
        if (isLink) {
            history.push({
                pathname: index ? index : '/index'
            });
        }
        return false;
    }
    return true;
};

/**
 * 根据学生ID获取学生信息
 * @author weishihuai
 * @date 2018/7/13
 * @time 11:43
 * @param xsid 学生ID
 * @param callback 回调方法
 */
var getLoginUserInfo = function getLoginUserInfo(xsid, callback) {
    if (!xsid) {
        return;
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_NHFetch__["a" /* default */])('api/zhxg-yxwz/newStudent/' + xsid + '/getUserInfoByXsid', 'GET').then(function (response) {
        if (response) {
            if (callback) {
                callback(response);
            }
        } else {
            __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.error("抱歉，未能查询到相关学生信息，请稍后重试！");
        }
    });
};

/**
 * 判断浏览器是否是IE内核，如果是IE内核就不让访问
 */
function isIE() {
    if (!!window.ActiveXObject || "ActiveXObject" in window) return true;else return false;
}
var browserJudge = function browserJudge(func) {
    if (isIE()) {
        var str = "<font size='5'>你的浏览器版本过低，无法完整的体验本系统的所有功能！</font>";
        var str2 = "推荐使用:<a href='https://www.baidu.com/s?ie=UTF-8&wd=%E8%B0%B7%E6%AD%8C%E6%B5%8F%E8%A7%88%E5%99%A8' target='_blank' style='color:#cc0;font-size:15px;font-weight:600;'>谷歌</a>," + "<a href='https://www.baidu.com/s?ie=UTF-8&wd=%E7%81%AB%E7%8B%90%E6%B5%8F%E8%A7%88%E5%99%A8' target='_blank' style='color:#cc0;font-size:15px;font-weight:600;'>火狐</a>," + "<a href='https://www.baidu.com/s?ie=UTF-8&wd=%E7%8C%8E%E8%B1%B9%E6%B5%8F%E8%A7%88%E5%99%A8' target='_blank' style='color:#cc0;font-size:15px;font-weight:600;'>猎豹</a>," + "<a href='https://www.baidu.com/s?ie=UTF-8&wd=360%E6%B5%8F%E8%A7%88%E5%99%A8%0A' target='_blank' style='color:#cc0;font-size:15px;font-weight:600;'>360浏览器</a>等双核急速模式";
        document.getElementById("root").innerHTML = "<table style='width:100%;height:100%;background-color:#fff;z-index:99999;position:absolute;'><tr><td align='center'>" + "<div style='text-align:center; width:800px;border:1px solid #0099CC;background-color:#99CCFF;top:0;left:0;z-index:1234;border-radius:5px;padding:2px;'>" + "<div align='left' style='padding:2px;padding: 8px;font-size: 15px;font-weight:700;border-radius: 5px 5px 0px 0px;color:#fff;'>Web项目体验性研究提示：</div>" + "<div style='background-color:#fff;height:300px;border-radius:0px 0px 5px 5px;border:1px solid #0099CC'><h2 style='padding-top:80px;margin:0'><strong>" + str + "<br/></strong></h2><p>" + str2 + "</p><h2 style='margin:0'><strong>如果你的使用的是双核浏览器,请切换到极速模式访问<br/></strong></h2></div></div></td></tr></table>";
    } else {
        func && func();
    }
};

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

/**
 * @description: 校验开头为1的11位手机号，正确返回true,错误返回false
 * @param {*} params:需要校验的值
 * @return {*} Boolean
 * @author: 琴时
 */
var regPhone = function regPhone(params) {
    var reg = /^1\d{10}$/;
    return reg.test(params);
};

/**
 * @description: 设置表单验证规则
 * @param {*}
 * @return {*}
 * @author: 琴时
 */
var FormRules = {
    MOBILE_PHONE_NUMBER: {
        pattern: /^1\d{10}$/, //校验开头为1的11位手机号
        message: "请输入正确的手机号码"
    }
};

module.exports = {
    regPhone: regPhone,
    FormRules: FormRules
};

/***/ }),

/***/ 815:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/3ZWfM3zTz1.png";

/***/ }),

/***/ 817:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_locale_provider_style__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_locale_provider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_locale_provider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_locale_provider__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_locale_provider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_locale_provider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_hot_loader__ = __webpack_require__(2088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(2122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(1843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_store_configureStore__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__route_globalRoute__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_css_global_css__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_css_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_css_global_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_locale_provider_zh_CN__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_locale_provider_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_locale_provider_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__app_actions_login__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_NHCore__ = __webpack_require__(8);


// import 'babel-polyfill';










// 由于 antd 组件的默认文案是英文，所以需要修改为中文




//解决移动端300毫秒延迟

if (false) {
    module.hot.accept('../assets/css/global.css', function () {
        require('../assets/css/global.css');
    });
}

var FastClick = __webpack_require__(1622);
FastClick.attach(document.body);

var render = function render(Component) {
    __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_hot_loader__["AppContainer"],
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_redux__["a" /* Provider */],
            { store: __WEBPACK_IMPORTED_MODULE_8__redux_store_configureStore__["a" /* default */] },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_antd_lib_locale_provider___default.a,
                { locale: __WEBPACK_IMPORTED_MODULE_11_antd_lib_locale_provider_zh_CN___default.a },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, null)
            )
        )
    ), document.getElementById('root'));
};
//首先判断浏览器内核版本，如果内核版本是IE，直接不让用户访问
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_NHCore__["a" /* browserJudge */])(function () {
    //先获取登录信息
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__app_actions_login__["a" /* tryLoginUserInfo */])(function () {
        render(__WEBPACK_IMPORTED_MODULE_9__route_globalRoute__["a" /* default */]);
        if (false) {
            module.hot.accept('./route/globalRoute', function () {
                render(GlobalRoute);
            });
        }
    });
});

/***/ }),

/***/ 819:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./01.png": 2172,
	"./02.png": 2173,
	"./03.png": 2174,
	"./04.png": 2175,
	"./05.png": 2176,
	"./06.png": 2177,
	"./banner.png": 2178,
	"./default.jpg": 489,
	"./fengjing.png": 2179,
	"./jiaotong.png": 2180,
	"./map.png": 2181,
	"./tongzhi.png": 2182,
	"./xydt.png": 2183
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 819;

/***/ }),

/***/ 993:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_json_stringify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__NHPicturesWall_NHPicturesWall_css__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__NHPicturesWall_NHPicturesWall_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__NHPicturesWall_NHPicturesWall_css__);
















var _typeof = typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }







if (false) {
    module.hot.accept('../NHPicturesWall/NHPicturesWall.css', function () {
        require('../NHPicturesWall/NHPicturesWall.css');
    });
}

var fileDocDownloadPath = 'anonymity/docrepo/download/file?attachmentId=';
var redisDownloadPath = window.baseUrl + '/proData/downloadRedisCacheImage?uuid=';

/**
 * @author weishihuai
 * @date 2018/9/12
 * @time 9:52
 * @Description: 图片墙上传组件
 *
 *   图片墙使用说明：
 *   onRemove: this.onImageRemove.bind(this), 非必须, 图片删除之后回传删除图片给父组件的方法
 *   onChange: this.onChange.bind(this), 非必须, 值改变时执行的方法
 *   numberOfLimit: 2, 必须, 图片墙允许上传的图片张数，超过numberOfLimit上传按钮自动隐藏
 *   numberOfSize: 5,  必须, 图片墙允许上传图片大小的最大值，超过numberOfSize的话直接不上传
 *   saveType: 'file', 必须, 图片墙图片保存的格式，默认为‘file’保存在文档库，‘redis’为缓存在redis,‘base64’保存在内存中，如果需要永久保存文件，建议保存在文档库
 *   cacheTime: 30,  非必须, Redis缓存时长，单位：分钟  超过30分钟redis会删除缓存的图片信息
 *   imageList: ['0264a687-baa4-490f-92f5-e988dcd8d976','0264a687-baa4-490f-92f5-e988dcd8d976'] 非必须, 如果是编辑模式下，需要回显已经保存的图片信息，注意一下需要构造如下类型数据才能显示出来：
 */
var NHPicturesWall = (_temp = _class = function (_React$Component) {
    _inherits(NHPicturesWall, _React$Component);

    function NHPicturesWall(props) {
        _classCallCheck(this, NHPicturesWall);

        var _this = _possibleConstructorReturn(this, (NHPicturesWall.__proto__ || __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_get_prototype_of___default()(NHPicturesWall)).call(this, props));

        _this.isnull = function (value) {
            if (__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_json_stringify___default()(value) === '[]' || value === null || typeof value === "undefined" || typeof value === 'string' && value.trim() === '') {
                return true;
            } else {
                return false;
            }
        };

        _this.handlePreview = function (file) {
            _this.setState({
                previewImageUrl: file.url || file.thumbUrl,
                previewImageName: file.name,
                previewImageVisible: true
            });
        };

        _this.handlePreviewCancel = function () {
            _this.setState({
                previewImageVisible: false
            });
        };

        _this.handleChange = function (e) {
            var saveType = _this.props.saveType || 'file';
            var fileList = e.fileList;
            var fileStatus = e.file.status;

            if (fileStatus === 'uploading') {//上传中
            } else if (fileStatus === 'done') {
                //上传成功
                var response = e.file.response;
                if (!response) {
                    __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error("抱歉，文件由于未知原因上传失败!");
                    return;
                }
                var responseMeta = response.meta;
                if (saveType === 'file') {
                    //上传到文档库
                    //上传成功(success为true并且响应码为200)
                    if (responseMeta && responseMeta.success && responseMeta.statusCode === 200) {
                        fileList = fileList.map(function (file) {
                            if (file.uid === e.file.uid) {
                                file.uuid = response.data.ssbh;
                                //file.uuid = response.data.bh;
                            }
                            return file;
                        });

                        _this.getUploadedImage(fileList, 'file');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error("抱歉，文件由于未知原因上传失败!");
                        //过滤上传失败的图片
                        fileList = _this.filterUploadFailFile(e.fileList, e.file);
                    }
                } else if (saveType === 'redis') {
                    //缓存Redis
                    //缓存成功(响应码为200)
                    if (response.code === 200) {
                        fileList = fileList.map(function (file) {
                            if (file.uid === e.file.uid) {
                                file.uuid = response.data;
                            }
                            return file;
                        });
                        _this.getUploadedImage(fileList, 'redis');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error("抱歉，文件由于未知原因上传失败!");
                        //过滤上传失败的图片
                        fileList = _this.filterUploadFailFile(e.fileList, e.file);
                    }
                } else if (saveType === 'base64') {
                    //用于保存数据库
                    _this.getImageBase64(e.file.originFileObj, function (imageUrl) {
                        //上传成功
                        if (response.code === 200) {
                            fileList = fileList.map(function (file) {
                                if (file.uid === e.file.uid) {
                                    file.uuid = imageUrl;
                                    file.base64Url = imageUrl;
                                } else {
                                    file.base64Url = file.thumbUrl || file.url;
                                }
                                return file;
                            });
                            _this.getUploadedImage(fileList, 'base64');
                        } else {
                            __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error("抱歉，文件由于未知原因上传失败!");
                            //过滤上传失败的图片
                            fileList = _this.filterUploadFailFile(e.fileList, e.file);
                        }
                    });
                }
            } else if (fileStatus === 'error') {
                //上传出错
                __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error("抱歉，文件由于未知原因上传失败!");
                //过滤上传失败的图片
                fileList = _this.filterUploadFailFile(e.fileList, e.file);
            }
            if (fileStatus) {
                _this.setState({
                    uploadedImageList: fileList
                });
            }
        };

        _this.getImageBase64 = function (img, callback) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                return callback(reader.result);
            });
            reader.readAsDataURL(img);
        };

        _this.filterUploadFailFile = function (list, failUploadedFile) {
            return list.filter(function (file) {
                return file.uid !== failUploadedFile.uid;
            });
        };

        _this.getUploadedImage = function (fileList, saveType) {
            if (saveType === 'base64') {
                var uploadedImageList = [];
                fileList.map(function (file) {
                    var obj = {
                        uuid: file.uuid,
                        base64Url: file.base64Url
                    };
                    uploadedImageList.push(obj);
                });

                //父组件回调方法，在父组件可以拿到已经上传成功的图片信息
                if (_this.props.onChange && typeof _this.props.onChange === "function") {
                    _this.props.onChange(uploadedImageList);
                }
            } else {
                var _uploadedImageList = [];
                fileList.map(function (file) {
                    var obj = {
                        uuid: file.uuid
                    };
                    _uploadedImageList.push(obj);
                });

                //父组件回调方法，在父组件可以拿到已经上传成功的图片信息
                if (_this.props.onChange && typeof _this.props.onChange === "function") {
                    _this.props.onChange(_uploadedImageList);
                }
            }
        };

        _this.handelBeforeUpload = function (file) {
            var fileType = file.type;
            var fileName = file.name;
            //判断是否支持该文件格式
            var isInvalidFileType = !fileType || fileType.length < 1;
            if (isInvalidFileType) {
                __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error('抱歉，不支持上传该格式的文件！');
                return !isInvalidFileType;
            }

            var availFileSuffix = ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.gif', '.GIF'];
            var fileSuffixName = fileName.substring(file.name.lastIndexOf('.'));
            var isAvailableSuffix = availFileSuffix.includes(fileSuffixName);
            if (!isAvailableSuffix) {
                var msg = '抱歉，只支持上传【' + availFileSuffix.join(' || ') + '】格式的文件！';
                __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error(msg);
                return isAvailableSuffix;
            }

            //限制上传文件大小(默认上传大小限制2MB)
            var availSize = _this.props.numberOfSize || 2;
            var fileSize = file.size / 1024 / 1024;
            var isOverSize = fileSize > availSize;

            if (isOverSize) {
                var _msg = '抱歉，上传文件大小最大不能超过' + availSize + 'M！';
                __WEBPACK_IMPORTED_MODULE_12_antd_lib_message___default.a.error(_msg);
                return !isOverSize;
            }
            return true;
        };

        _this.handleRemove = function (file) {
            var uploadedImageList = _this.state.uploadedImageList;
            for (var index = 0, len = uploadedImageList.length; index < len; index++) {
                if (uploadedImageList[index].uid === file.uid) {
                    uploadedImageList.splice(index, 1);
                    break;
                }
            }
            _this.setState({
                uploadedImageList: uploadedImageList
            });

            //组装数据返回给父组件，包含文档库的uuid以及文件名称
            var imageList = [];
            uploadedImageList.length > 0 && uploadedImageList.map(function (file) {
                var obj = { uuid: file.uuid };
                imageList.push(obj);
            });

            if (_this.props.onChange && typeof _this.props.onChange === 'function') {
                _this.props.onChange(imageList);
            }

            //如果有需要对删除的图片做删除文档库等操作，回传给父组件进行处理
            if (_this.props.onRemove && typeof _this.props.onRemove === 'function') {
                _this.props.onRemove(file.uuid);
            }
        };

        _this.state = {
            uploadedImageList: [], //已上传图片
            previewImageVisible: false, //是否预览图片标识
            previewImageUrl: '', //预览图片的URL
            previewImageName: '' //预览图片的名称
        };
        return _this;
    }

    //设置props默认值


    _createClass(NHPicturesWall, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('imageList' in nextProps) {
                var imageList = this.isnull(nextProps.imageList);
                var thisImageList = this.isnull(this.props.imageList);
                if (imageList && !thisImageList) {
                    this.setState({ uploadedImageList: [] });
                }
            }
        }
    }, {
        key: 'componentWillMount',


        //组件render之前组装已经上传成功的图片信息uploadedImageList,主要用于回显图片
        value: function componentWillMount() {
            var saveType = this.props.saveType || 'file';
            if (this.props.imageList != undefined) {
                if (saveType === 'base64') {
                    if (this.props.imageList.length > 0) {
                        var uploadedImageList = [];
                        this.props.imageList.map(function (base64Code) {
                            uploadedImageList.push({
                                uuid: base64Code,
                                uid: base64Code,
                                url: base64Code
                            });
                        });
                        this.setState({
                            uploadedImageList: uploadedImageList
                        });

                        var imageList = [];
                        uploadedImageList.map(function (file) {
                            var obj = {
                                uuid: file.uuid,
                                base64Url: file.url
                            };
                            imageList.push(obj);
                        });

                        if (this.props.onChange && typeof this.props.onChange === "function") {
                            this.props.onChange(imageList);
                        }
                    }
                } else {
                    if (this.props.imageList.length > 0) {
                        var _uploadedImageList2 = [];
                        this.props.imageList.map(function (uuid) {
                            if ((typeof uuid === 'undefined' ? 'undefined' : _typeof(uuid)) === 'object') {
                                uuid = uuid['uuid'];
                            }
                            _uploadedImageList2.push({
                                uuid: uuid,
                                uid: uuid,
                                url: saveType === 'file' ? fileDocDownloadPath + uuid : redisDownloadPath + uuid
                            });
                        });
                        this.setState({
                            uploadedImageList: _uploadedImageList2
                        });

                        var _imageList = [];
                        _uploadedImageList2.map(function (file) {
                            var obj = { uuid: file.uuid };
                            _imageList.push(obj);
                        });

                        if (this.props.onChange && typeof this.props.onChange === "function") {
                            this.props.onChange(_imageList);
                        }
                    }
                }
            }
        }

        //图片预览事件


        //取消图片预览事件


        //文件上传改变事件


        //获取图片Base64


        //过滤上传失败的图片


        //获取上传成功的图片


        //上传文件之前的钩子，参数为准备上传的文件，若返回 false 则停止上传
        //一般在beforeUpload方法内限制文件上传的格式以及大小


        //删除图片事件

    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                previewImageVisible = _state.previewImageVisible,
                previewImageUrl = _state.previewImageUrl,
                uploadedImageList = _state.uploadedImageList,
                previewImageName = _state.previewImageName;

            var numberOfLimit = this.props.numberOfLimit || 1; //默认最多上传一张图片
            var saveType = this.props.saveType || 'file'; //默认上传到文档库
            var redisCacheTime = this.props.cacheTime || 30; //Redis默认保存时长，单位：分钟

            var uploadButton = __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_icon___default.a, { type: 'plus' }),
                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    'div',
                    { className: 'xgui-picturewall-ant-upload-text' },
                    'Upload'
                )
            );

            //根据saveType构造上传的url
            var action = saveType === 'file' ? 'anonymity/docrepo/upload' : saveType === 'redis' ? window.baseUrl + '/proData/uploadRedis' : this.props.base64UploadUrl;
            //请求发送的数据
            var requestData = saveType === 'file' ? {
                uuid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_NHCore__["c" /* createUuid */])(),
                type: '1'
            } : saveType === 'redis' ? {
                'redisData': redisCacheTime
            } : {};

            var params = {
                name: 'file',
                action: action, //图片上传路径
                accept: 'image/*', //接受上传的文件类型,指定为image/**的话，弹出选择文件窗口的时候只会显示图片类型文件，过滤掉.txt、.xsl等非图片文件
                listType: 'picture-card', //图片墙样式
                multiple: false, //是否允许多选
                fileList: uploadedImageList, //已上传的图片
                data: requestData, //上传所需参数
                onRemove: this.handleRemove, //删除执行的方法
                beforeUpload: this.handelBeforeUpload, //图片上传前执行的方法
                onPreview: this.handlePreview, //预览图片执行的方法
                onChange: this.handleChange //值改变执行的方法
            };

            return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                'div',
                { className: 'clearfix' },
                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_antd_lib_upload___default.a,
                    params,
                    uploadedImageList.length >= numberOfLimit ? null : uploadButton
                ),
                __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal___default.a,
                    { visible: previewImageVisible, footer: null, onCancel: this.handlePreviewCancel },
                    __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('img', { alt: previewImageName, style: { width: '100%' }, src: previewImageUrl })
                )
            );
        }
    }]);

    return NHPicturesWall;
}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component), _class.defaultProps = {
    saveType: 'file', //保存的类型，默认为file文档库，可选的值: 'file'(上传文档库)、'base64'(保存数据库)、'redis'(缓存redis)
    imageList: [], //设置默认上传的图片 格式:imageList: [{ uid: '对应文档库uuid', name: '图片名称',status: 'done', url: '图片url'}]
    cacheTime: 30, //设置Redis缓存的时间，单位：分钟 表示Redis超过30分钟会删除缓存的信息
    numberOfLimit: 1, //最多允许上传多少张图片 默认为1张
    numberOfSize: 2, //默认上传大小限制2MB
    disabled: false, //是否禁用
    onRemove: function onRemove() {//删除成功回调
    },
    onChange: function onChange() {}, //值改变时的回调
    base64UploadUrl: '' //base64上传图片路径
}, _temp);

//属性检查

NHPicturesWall.PropTypes = {
    saveType: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.string, //保存的类型
    imageList: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.array, //初始化图片信息
    cacheTime: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.number, //Redis缓存时间
    numberOfLimit: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.number, //允许上传的图片张数
    numberOfSize: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.number, //允许上传的图片大小
    disabled: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.bool, //是否禁用
    base64UploadUrl: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.string, //base64图片上传路径
    onRemove: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.func, //删除成功回调
    onChange: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.func //值改变回调
};

/* harmony default export */ __webpack_exports__["a"] = (NHPicturesWall);

/***/ }),

/***/ 994:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WidthType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RegularExpression; });
/**
 * 输入控件常用常量
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-02-05 15:06:15
 * Version: 1.0
 * Modify log:
 */

//输入控件类型常量
var InputType = {
    INPUT: 'input', //单行文本输入控件类型
    INPUTNUMBER: 'inputnumber', //数字输入控件类型
    TEXTAREA: 'textarea', //多行文本输入控件类型
    SELECT: 'select', //下拉选择器类型
    RADIO: 'radio', //单选框类型
    CHECKBOX: 'checkbox', //多选框类型
    SWITCH: 'switch', //开关类型
    UPLOAD: 'upload', //上传控件类型
    DATEPICKER: 'datepicker', // 日期控件
    RANGEPICKER: 'rangepicker', // 日期范围控件
    TIMEPICKER: 'timepicker', // 时间控件
    MULTISELECT: 'multiselect', // 多选下拉框
    NHCASCADER: 'nhcascader', // 级联下拉框
    DATETIMEPICKER: 'datetimepicker', // 日期时间选择框
    MONTHPICKER: 'monthpicker', // 月份选择框
    OLDUPLOAD: 'oldupload' // 旧版附件上传，没有附件主表
};

//控件宽度类型
var WidthType = {
    DEFAULT: 'default', //默认，自适应
    RELATIVE: 'relative', //相对宽度，百分比
    FIXED: 'fixed' //固定宽度，像素


    //正则表达式常量
};var RegularExpression = {
    NUMBER: { describe: "数字", rule: { pattern: "^[0-9]*$", message: "请输入数字" } },
    CN_CHARACTERS: { describe: "汉字", rule: { pattern: '^[\\u4e00-\\u9fa5]{0,}$', message: "请输入汉字" } },
    EN_CHARACTERS: { describe: "英文", rule: { pattern: "^[A-Za-z]+$", message: "请输入英文" } },
    EN_NUMBER_UNDERLINE: { describe: "英文、数字或下划线", rule: { pattern: "^\\w+$", message: "请输入英文、数字或下划线" } },
    EN_NUMBER: { describe: "英文或数字", rule: { pattern: "^[A-Za-z0-9]+$", message: "请输入英文或数字" } },
    EMAIL: { describe: "邮箱地址", rule: { pattern: "\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$", message: "请输入正确的邮箱地址" } },
    MOBILE_PHONE_NUMBER: { describe: "手机号码", rule: { pattern: "^(13[0-9]|17[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\\d{8}$", message: "请输入正确的手机号码" } },
    PHONE_NUMBER: { describe: "电话号码", rule: { pattern: /^[0|8]\d{2,3}-?\d{7,8}$/, message: "请输入正确的电话号码" } },
    IDCARD: { describe: "身份证号码", rule: { pattern: "^([1-9]\\d{7}((0\\d)|(1[0-2]))(([0|1|2]\\d)|3[0-1])\\d{3})|([1-9]\\d{5}[1-9]\\d{3}((0\\d)|(1[0-2]))(([0|1|2]\\d)|3[0-1])((\\d{4})|(\\d{3}[X])))$", message: "请输入正确的身份证号" } },
    QQ: { describe: "QQ号码", rule: { pattern: "[1-9][0-9]{4,}", message: "请输入正确的QQ号" } },
    POSTAL_CODE: { describe: "邮政编码", rule: { pattern: "[1-9]\\d{5}(?!\\d)", message: "请输入正确的邮政编码" } }
};

/* unused harmony default export */ var _unused_webpack_default_export = (RegularExpression);

/***/ }),

/***/ 995:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);





var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }


__webpack_require__(998);
__webpack_require__(997);
__webpack_require__(996);
__webpack_require__(1551);



var NHUeditor = (_temp = _class = function (_React$Component) {
    _inherits(NHUeditor, _React$Component);

    function NHUeditor(props) {
        _classCallCheck(this, NHUeditor);

        var _this = _possibleConstructorReturn(this, (NHUeditor.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(NHUeditor)).call(this, props));

        _this.getContent = function () {
            return UE.getEditor(_this.props.id).getContent();
        };

        _this.state = {
            width: _this.props.width ? _this.props.width : '800px',
            height: _this.props.height ? _this.props.height : '400px',
            imgUploadUrl: '', //图片上传路径
            imgShowUrl: '', //图片展示路径
            fileUploadUrl: '', //附件上传路径
            fileDownloadUrl: '' //附件下载路径
        };
        return _this;
    }

    _createClass(NHUeditor, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var getContent = this.props.getContent;

            this.initEditor();
            if (getContent) {
                getContent(this.getContent);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // 组件卸载后，清除放入库的id 
            UE.delEditor(this.props.id);
        }
    }, {
        key: 'initEditor',
        value: function initEditor() {
            var config = {
                autoFloatEnabled: this.props.autoFloatEnabled === true ? true : false, //是否保持toolbar的位置不动,默认true
                autoHeightEnabled: this.props.autoHeightEnabled === false ? false : true, //是否自动长高,默认true
                serverUrl: 'jsp/controller.jsp' //粘贴时候图片的上传路径,这个暂时还没有实现
            };
            var _props = this.props,
                id = _props.id,
                Editor = _props.Editor;

            var ueEditor = UE.getEditor(this.props.id, config);
            var self = this;

            ueEditor.ready(function (ueditor) {
                if (!ueditor) {
                    UE.delEditor(id);
                    self.initEditor();
                }
                if (Editor) {
                    Editor(ueEditor);
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { id: this.props.id, name: 'content', type: 'text/plain', style: { width: this.state.width, height: this.state.height } })
            );
        }
    }]);

    return NHUeditor;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component), _class.defaultProps = {
    id: 'content',
    Content: '', //父类传进来的值
    getContent: undefined //通过该方法把 this.getContent传给父类
}, _temp);
//属性检查

NHUeditor.propTypes = {
    getContent: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func //父级获取富文本的获取内容方法
};

/* harmony default export */ __webpack_exports__["a"] = (NHUeditor);

/***/ }),

/***/ 996:
/***/ (function(module, exports) {

/**
 * Created with JetBrains PhpStorm.
 * User: taoqili
 * Date: 12-6-12
 * Time: 下午5:02
 * To change this template use File | Settings | File Templates.
 */
UE.I18N['zh-cn'] = {
    'labelMap': {
        'anchor': '锚点', 'undo': '撤销', 'redo': '重做', 'bold': '加粗', 'indent': '首行缩进', 'snapscreen': '截图',
        'italic': '斜体', 'underline': '下划线', 'strikethrough': '删除线', 'subscript': '下标', 'fontborder': '字符边框',
        'superscript': '上标', 'formatmatch': '格式刷', 'source': '源代码', 'blockquote': '引用',
        'pasteplain': '纯文本粘贴模式', 'selectall': '全选', 'print': '打印', 'preview': '预览',
        'horizontal': '分隔线', 'removeformat': '清除格式', 'time': '时间', 'date': '日期',
        'unlink': '取消链接', 'insertrow': '前插入行', 'insertcol': '前插入列', 'mergeright': '右合并单元格', 'mergedown': '下合并单元格',
        'deleterow': '删除行', 'deletecol': '删除列', 'splittorows': '拆分成行',
        'splittocols': '拆分成列', 'splittocells': '完全拆分单元格', 'deletecaption': '删除表格标题', 'inserttitle': '插入标题',
        'mergecells': '合并多个单元格', 'deletetable': '删除表格', 'cleardoc': '清空文档', 'insertparagraphbeforetable': "表格前插入行", 'insertcode': '代码语言',
        'fontfamily': '字体', 'fontsize': '字号', 'paragraph': '段落格式', 'simpleupload': '单图上传', 'insertimage': '多图上传', 'edittable': '表格属性', 'edittd': '单元格属性', 'link': '超链接',
        'emotion': '表情', 'spechars': '特殊字符', 'searchreplace': '查询替换', 'map': 'Baidu地图', 'gmap': 'Google地图',
        'insertvideo': '视频', 'help': '帮助', 'justifyleft': '居左对齐', 'justifyright': '居右对齐', 'justifycenter': '居中对齐',
        'justifyjustify': '两端对齐', 'forecolor': '字体颜色', 'backcolor': '背景色', 'insertorderedlist': '有序列表',
        'insertunorderedlist': '无序列表', 'fullscreen': '全屏', 'directionalityltr': '从左向右输入', 'directionalityrtl': '从右向左输入',
        'rowspacingtop': '段前距', 'rowspacingbottom': '段后距', 'pagebreak': '分页', 'insertframe': '插入Iframe', 'imagenone': '默认',
        'imageleft': '左浮动', 'imageright': '右浮动', 'attachment': '附件', 'imagecenter': '居中', 'wordimage': '图片转存',
        'lineheight': '行间距', 'edittip': '编辑提示', 'customstyle': '自定义标题', 'autotypeset': '自动排版',
        'webapp': '百度应用', 'touppercase': '字母大写', 'tolowercase': '字母小写', 'background': '背景', 'template': '模板', 'scrawl': '涂鸦',
        'music': '音乐', 'inserttable': '插入表格', 'drafts': '从草稿箱加载', 'charts': '图表'
    },
    'insertorderedlist': {
        'num': '1,2,3...',
        'num1': '1),2),3)...',
        'num2': '(1),(2),(3)...',
        'cn': '一,二,三....',
        'cn1': '一),二),三)....',
        'cn2': '(一),(二),(三)....',
        'decimal': '1,2,3...',
        'lower-alpha': 'a,b,c...',
        'lower-roman': 'i,ii,iii...',
        'upper-alpha': 'A,B,C...',
        'upper-roman': 'I,II,III...'
    },
    'insertunorderedlist': {
        'circle': '○ 大圆圈',
        'disc': '● 小黑点',
        'square': '■ 小方块 ',
        'dash': '— 破折号',
        'dot': ' 。 小圆圈'
    },
    'paragraph': { 'p': '段落', 'h1': '标题 1', 'h2': '标题 2', 'h3': '标题 3', 'h4': '标题 4', 'h5': '标题 5', 'h6': '标题 6' },
    'fontfamily': {
        'songti': '宋体',
        'kaiti': '楷体',
        'heiti': '黑体',
        'lishu': '隶书',
        'yahei': '微软雅黑',
        'andaleMono': 'andale mono',
        'arial': 'arial',
        'arialBlack': 'arial black',
        'comicSansMs': 'comic sans ms',
        'impact': 'impact',
        'timesNewRoman': 'times new roman'
    },
    'customstyle': {
        'tc': '标题居中',
        'tl': '标题居左',
        'im': '强调',
        'hi': '明显强调'
    },
    'autoupload': {
        'exceedSizeError': '文件大小超出限制',
        'exceedTypeError': '文件格式不允许',
        'jsonEncodeError': '服务器返回格式错误',
        'loading': "正在上传...",
        'loadError': "上传错误",
        'errorLoadConfig': '后端配置项没有正常加载，上传插件不能正常使用！'
    },
    'simpleupload': {
        'exceedSizeError': '文件大小超出限制',
        'exceedTypeError': '文件格式不允许',
        'jsonEncodeError': '服务器返回格式错误',
        'loading': "正在上传...",
        'loadError': "上传错误",
        'errorLoadConfig': '后端配置项没有正常加载，上传插件不能正常使用！'
    },
    'elementPathTip': "元素路径",
    'wordCountTip': "字数统计",
    'wordCountMsg': '当前已输入{#count}个字符, 您还可以输入{#leave}个字符。 ',
    'wordOverFlowMsg': '<span style="color:red;">字数超出最大允许值，服务器可能拒绝保存！</span>',
    'ok': "确认",
    'cancel': "取消",
    'closeDialog': "关闭对话框",
    'tableDrag': "表格拖动必须引入uiUtils.js文件！",
    'autofloatMsg': "工具栏浮动依赖编辑器UI，您首先需要引入UI文件!",
    'loadconfigError': '获取后台配置项请求出错，上传功能将不能正常使用！',
    'loadconfigFormatError': '后台配置项返回格式出错，上传功能将不能正常使用！',
    'loadconfigHttpError': '请求后台配置项http错误，上传功能将不能正常使用！',
    'snapScreen_plugin': {
        'browserMsg': "仅支持IE浏览器！",
        'callBackErrorMsg': "服务器返回数据有误，请检查配置项之后重试。",
        'uploadErrorMsg': "截图上传失败，请检查服务器端环境! "
    },
    'insertcode': {
        'as3': 'ActionScript 3',
        'bash': 'Bash/Shell',
        'cpp': 'C/C++',
        'css': 'CSS',
        'cf': 'ColdFusion',
        'c#': 'C#',
        'delphi': 'Delphi',
        'diff': 'Diff',
        'erlang': 'Erlang',
        'groovy': 'Groovy',
        'html': 'HTML',
        'java': 'Java',
        'jfx': 'JavaFX',
        'js': 'JavaScript',
        'pl': 'Perl',
        'php': 'PHP',
        'plain': 'Plain Text',
        'ps': 'PowerShell',
        'python': 'Python',
        'ruby': 'Ruby',
        'scala': 'Scala',
        'sql': 'SQL',
        'vb': 'Visual Basic',
        'xml': 'XML'
    },
    'confirmClear': "确定清空当前文档么？",
    'contextMenu': {
        'delete': "删除",
        'selectall': "全选",
        'deletecode': "删除代码",
        'cleardoc': "清空文档",
        'confirmclear': "确定清空当前文档么？",
        'unlink': "删除超链接",
        'paragraph': "段落格式",
        'edittable': "表格属性",
        'aligntd': "单元格对齐方式",
        'aligntable': '表格对齐方式',
        'tableleft': '左浮动',
        'tablecenter': '居中显示',
        'tableright': '右浮动',
        'edittd': "单元格属性",
        'setbordervisible': '设置表格边线可见',
        'justifyleft': '左对齐',
        'justifyright': '右对齐',
        'justifycenter': '居中对齐',
        'justifyjustify': '两端对齐',
        'table': "表格",
        'inserttable': '插入表格',
        'deletetable': "删除表格",
        'insertparagraphbefore': "前插入段落",
        'insertparagraphafter': '后插入段落',
        'deleterow': "删除当前行",
        'deletecol': "删除当前列",
        'insertrow': "前插入行",
        'insertcol': "左插入列",
        'insertrownext': '后插入行',
        'insertcolnext': '右插入列',
        'insertcaption': '插入表格名称',
        'deletecaption': '删除表格名称',
        'inserttitle': '插入表格标题行',
        'deletetitle': '删除表格标题行',
        'inserttitlecol': '插入表格标题列',
        'deletetitlecol': '删除表格标题列',
        'averageDiseRow': '平均分布各行',
        'averageDisCol': '平均分布各列',
        'mergeright': "向右合并",
        'mergeleft': "向左合并",
        'mergedown': "向下合并",
        'mergecells': "合并单元格",
        'splittocells': "完全拆分单元格",
        'splittocols': "拆分成列",
        'splittorows': "拆分成行",
        'tablesort': '表格排序',
        'enablesort': '设置表格可排序',
        'disablesort': '取消表格可排序',
        'reversecurrent': '逆序当前',
        'orderbyasc': '按ASCII字符升序',
        'reversebyasc': '按ASCII字符降序',
        'orderbynum': '按数值大小升序',
        'reversebynum': '按数值大小降序',
        'borderbk': '边框底纹',
        'setcolor': '表格隔行变色',
        'unsetcolor': '取消表格隔行变色',
        'setbackground': '选区背景隔行',
        'unsetbackground': '取消选区背景',
        'redandblue': '红蓝相间',
        'threecolorgradient': '三色渐变',
        'copy': "复制(Ctrl + c)",
        'copymsg': "浏览器不支持,请使用 'Ctrl + c'",
        'paste': "粘贴(Ctrl + v)",
        'pastemsg': "浏览器不支持,请使用 'Ctrl + v'"
    },
    'copymsg': "浏览器不支持,请使用 'Ctrl + c'",
    'pastemsg': "浏览器不支持,请使用 'Ctrl + v'",
    'anthorMsg': "链接",
    'clearColor': '清空颜色',
    'standardColor': '标准颜色',
    'themeColor': '主题颜色',
    'property': '属性',
    'default': '默认',
    'modify': '修改',
    'justifyleft': '左对齐',
    'justifyright': '右对齐',
    'justifycenter': '居中',
    'justify': '默认',
    'clear': '清除',
    'anchorMsg': '锚点',
    'delete': '删除',
    'clickToUpload': "点击上传",
    'unset': '尚未设置语言文件',
    't_row': '行',
    't_col': '列',
    'more': '更多',
    'pasteOpt': '粘贴选项',
    'pasteSourceFormat': "保留源格式",
    'tagFormat': '只保留标签',
    'pasteTextFormat': '只保留文本',
    'autoTypeSet': {
        'mergeLine': "合并空行",
        'delLine': "清除空行",
        'removeFormat': "清除格式",
        'indent': "首行缩进",
        'alignment': "对齐方式",
        'imageFloat': "图片浮动",
        'removeFontsize': "清除字号",
        'removeFontFamily': "清除字体",
        'removeHtml': "清除冗余HTML代码",
        'pasteFilter': "粘贴过滤",
        'run': "执行",
        'symbol': '符号转换',
        'bdc2sb': '全角转半角',
        'tobdc': '半角转全角'
    },

    'background': {
        'static': {
            'lang_background_normal': '背景设置',
            'lang_background_local': '在线图片',
            'lang_background_set': '选项',
            'lang_background_none': '无背景色',
            'lang_background_colored': '有背景色',
            'lang_background_color': '颜色设置',
            'lang_background_netimg': '网络图片',
            'lang_background_align': '对齐方式',
            'lang_background_position': '精确定位',
            'repeatType': { 'options': ["居中", "横向重复", "纵向重复", "平铺", "自定义"] }

        },
        'noUploadImage': "当前未上传过任何图片！",
        'toggleSelect': "单击可切换选中状态\n原图尺寸: "
    },
    //===============dialog i18N=======================
    'insertimage': {
        'static': {
            'lang_tab_remote': "插入图片", //节点
            'lang_tab_upload': "本地上传",
            'lang_tab_online': "在线管理",
            'lang_tab_search': "图片搜索",
            'lang_input_url': "地 址：",
            'lang_input_size': "大 小：",
            'lang_input_width': "宽度",
            'lang_input_height': "高度",
            'lang_input_border': "边 框：",
            'lang_input_vhspace': "边 距：",
            'lang_input_title': "描 述：",
            'lang_input_align': '图片浮动方式：',
            'lang_imgLoading': "　图片加载中……",
            'lang_start_upload': "开始上传",
            'lock': { 'title': "锁定宽高比例" }, //属性
            'searchType': { 'title': "图片类型", 'options': ["新闻", "壁纸", "表情", "头像"] }, //select的option
            'searchTxt': { 'value': "请输入搜索关键词" },
            'searchBtn': { 'value': "百度一下" },
            'searchReset': { 'value': "清空搜索" },
            'noneAlign': { 'title': '无浮动' },
            'leftAlign': { 'title': '左浮动' },
            'rightAlign': { 'title': '右浮动' },
            'centerAlign': { 'title': '居中独占一行' }
        },
        'uploadSelectFile': '点击选择图片',
        'uploadAddFile': '继续添加',
        'uploadStart': '开始上传',
        'uploadPause': '暂停上传',
        'uploadContinue': '继续上传',
        'uploadRetry': '重试上传',
        'uploadDelete': '删除',
        'uploadTurnLeft': '向左旋转',
        'uploadTurnRight': '向右旋转',
        'uploadPreview': '预览中',
        'uploadNoPreview': '不能预览',
        'updateStatusReady': '选中_张图片，共_KB。',
        'updateStatusConfirm': '已成功上传_张照片，_张照片上传失败',
        'updateStatusFinish': '共_张（_KB），_张上传成功',
        'updateStatusError': '，_张上传失败。',
        'errorNotSupport': 'WebUploader 不支持您的浏览器！如果你使用的是IE浏览器，请尝试升级 flash 播放器。',
        'errorLoadConfig': '后端配置项没有正常加载，上传插件不能正常使用！',
        'errorExceedSize': '文件大小超出',
        'errorFileType': '文件格式不允许',
        'errorInterrupt': '文件传输中断',
        'errorUploadRetry': '上传失败，请重试',
        'errorHttp': 'http请求错误',
        'errorServerUpload': '服务器返回出错',
        'remoteLockError': "宽高不正确,不能所定比例",
        'numError': "请输入正确的长度或者宽度值！例如：123，400",
        'imageUrlError': "不允许的图片格式或者图片域！",
        'imageLoadError': "图片加载失败！请检查链接地址或网络状态！",
        'searchRemind': "请输入搜索关键词",
        'searchLoading': "图片加载中，请稍后……",
        'searchRetry': " :( ，抱歉，没有找到图片！请重试一次！"
    },
    'attachment': {
        'static': {
            'lang_tab_upload': '上传附件',
            'lang_tab_online': '在线附件',
            'lang_start_upload': "开始上传",
            'lang_drop_remind': "可以将文件拖到这里，单次最多可选100个文件"
        },
        'uploadSelectFile': '点击选择文件',
        'uploadAddFile': '继续添加',
        'uploadStart': '开始上传',
        'uploadPause': '暂停上传',
        'uploadContinue': '继续上传',
        'uploadRetry': '重试上传',
        'uploadDelete': '删除',
        'uploadTurnLeft': '向左旋转',
        'uploadTurnRight': '向右旋转',
        'uploadPreview': '预览中',
        'updateStatusReady': '选中_个文件，共_KB。',
        'updateStatusConfirm': '已成功上传_个文件，_个文件上传失败',
        'updateStatusFinish': '共_个（_KB），_个上传成功',
        'updateStatusError': '，_张上传失败。',
        'errorNotSupport': 'WebUploader 不支持您的浏览器！如果你使用的是IE浏览器，请尝试升级 flash 播放器。',
        'errorLoadConfig': '后端配置项没有正常加载，上传插件不能正常使用！',
        'errorExceedSize': '文件大小超出',
        'errorFileType': '文件格式不允许',
        'errorInterrupt': '文件传输中断',
        'errorUploadRetry': '上传失败，请重试',
        'errorHttp': 'http请求错误',
        'errorServerUpload': '服务器返回出错'
    },
    'insertvideo': {
        'static': {
            'lang_tab_insertV': "插入视频",
            'lang_tab_searchV': "搜索视频",
            'lang_tab_uploadV': "上传视频",
            'lang_video_url': "视频网址",
            'lang_video_size': "视频尺寸",
            'lang_videoW': "宽度",
            'lang_videoH': "高度",
            'lang_alignment': "对齐方式",
            'videoSearchTxt': { 'value': "请输入搜索关键字！" },
            'videoType': { 'options': ["全部", "热门", "娱乐", "搞笑", "体育", "科技", "综艺"] },
            'videoSearchBtn': { 'value': "百度一下" },
            'videoSearchReset': { 'value': "清空结果" },

            'lang_input_fileStatus': ' 当前未上传文件',
            'startUpload': { 'style': "background:url(upload.png) no-repeat;" },

            'lang_upload_size': "视频尺寸",
            'lang_upload_width': "宽度",
            'lang_upload_height': "高度",
            'lang_upload_alignment': "对齐方式",
            'lang_format_advice': "建议使用mp4格式."

        },
        'numError': "请输入正确的数值，如123,400",
        'floatLeft': "左浮动",
        'floatRight': "右浮动",
        '"default"': "默认",
        'block': "独占一行",
        'urlError': "输入的视频地址有误，请检查后再试！",
        'loading': " &nbsp;视频加载中，请等待……",
        'clickToSelect': "点击选中",
        'goToSource': '访问源视频',
        'noVideo': " &nbsp; &nbsp;抱歉，找不到对应的视频，请重试！",

        'browseFiles': '浏览文件',
        'uploadSuccess': '上传成功!',
        'delSuccessFile': '从成功队列中移除',
        'delFailSaveFile': '移除保存失败文件',
        'statusPrompt': ' 个文件已上传！ ',
        'flashVersionError': '当前Flash版本过低，请更新FlashPlayer后重试！',
        'flashLoadingError': 'Flash加载失败!请检查路径或网络状态',
        'fileUploadReady': '等待上传……',
        'delUploadQueue': '从上传队列中移除',
        'limitPrompt1': '单次不能选择超过',
        'limitPrompt2': '个文件！请重新选择！',
        'delFailFile': '移除失败文件',
        'fileSizeLimit': '文件大小超出限制！',
        'emptyFile': '空文件无法上传！',
        'fileTypeError': '文件类型不允许！',
        'unknownError': '未知错误！',
        'fileUploading': '上传中，请等待……',
        'cancelUpload': '取消上传',
        'netError': '网络错误',
        'failUpload': '上传失败!',
        'serverIOError': '服务器IO错误！',
        'noAuthority': '无权限！',
        'fileNumLimit': '上传个数限制',
        'failCheck': '验证失败，本次上传被跳过！',
        'fileCanceling': '取消中，请等待……',
        'stopUploading': '上传已停止……',

        'uploadSelectFile': '点击选择文件',
        'uploadAddFile': '继续添加',
        'uploadStart': '开始上传',
        'uploadPause': '暂停上传',
        'uploadContinue': '继续上传',
        'uploadRetry': '重试上传',
        'uploadDelete': '删除',
        'uploadTurnLeft': '向左旋转',
        'uploadTurnRight': '向右旋转',
        'uploadPreview': '预览中',
        'updateStatusReady': '选中_个文件，共_KB。',
        'updateStatusConfirm': '成功上传_个，_个失败',
        'updateStatusFinish': '共_个(_KB)，_个成功上传',
        'updateStatusError': '，_张上传失败。',
        'errorNotSupport': 'WebUploader 不支持您的浏览器！如果你使用的是IE浏览器，请尝试升级 flash 播放器。',
        'errorLoadConfig': '后端配置项没有正常加载，上传插件不能正常使用！',
        'errorExceedSize': '文件大小超出',
        'errorFileType': '文件格式不允许',
        'errorInterrupt': '文件传输中断',
        'errorUploadRetry': '上传失败，请重试',
        'errorHttp': 'http请求错误',
        'errorServerUpload': '服务器返回出错'
    },
    'webapp': {
        'tip1': "本功能由百度APP提供，如看到此页面，请各位站长首先申请百度APPKey!",
        'tip2': "申请完成之后请至ueditor.config.js中配置获得的appkey! ",
        'applyFor': "点此申请",
        'anthorApi': "百度API"
    },
    'template': {
        'static': {
            'lang_template_bkcolor': '背景颜色',
            'lang_template_clear': '保留原有内容',
            'lang_template_select': '选择模板'
        },
        'blank': "空白文档",
        'blog': "博客文章",
        'resume': "个人简历",
        'richText': "图文混排",
        'sciPapers': "科技论文"

    },
    'scrawl': {
        'static': {
            'lang_input_previousStep': "上一步",
            'lang_input_nextsStep': "下一步",
            'lang_input_clear': '清空',
            'lang_input_addPic': '添加背景',
            'lang_input_ScalePic': '缩放背景',
            'lang_input_removePic': '删除背景',
            'J_imgTxt': { title: '添加背景图片' }
        },
        'noScarwl': "尚未作画，白纸一张~",
        'scrawlUpLoading': "涂鸦上传中,别急哦~",
        'continueBtn': "继续",
        'imageError': "糟糕，图片读取失败了！",
        'backgroundUploading': '背景图片上传中,别急哦~'
    },
    'music': {
        'static': {
            'lang_input_tips': "输入歌手/歌曲/专辑，搜索您感兴趣的音乐！",
            'J_searchBtn': { value: '搜索歌曲' }
        },
        'emptyTxt': '未搜索到相关音乐结果，请换一个关键词试试。',
        'chapter': '歌曲',
        'singer': '歌手',
        'special': '专辑',
        'listenTest': '试听'
    },
    'anchor': {
        'static': {
            'lang_input_anchorName': '锚点名字：'
        }
    },
    'charts': {
        'static': {
            'lang_data_source': '数据源：',
            'lang_chart_format': '图表格式：',
            'lang_data_align': '数据对齐方式',
            'lang_chart_align_same': '数据源与图表X轴Y轴一致',
            'lang_chart_align_reverse': '数据源与图表X轴Y轴相反',
            'lang_chart_title': '图表标题',
            'lang_chart_main_title': '主标题：',
            'lang_chart_sub_title': '子标题：',
            'lang_chart_x_title': 'X轴标题：',
            'lang_chart_y_title': 'Y轴标题：',
            'lang_chart_tip': '提示文字',
            'lang_cahrt_tip_prefix': '提示文字前缀：',
            'lang_cahrt_tip_description': '仅饼图有效， 当鼠标移动到饼图中相应的块上时，提示框内的文字的前缀',
            'lang_chart_data_unit': '数据单位',
            'lang_chart_data_unit_title': '单位：',
            'lang_chart_data_unit_description': '显示在每个数据点上的数据的单位， 比如： 温度的单位 ℃',
            'lang_chart_type': '图表类型：',
            'lang_prev_btn': '上一个',
            'lang_next_btn': '下一个'
        }
    },
    'emotion': {
        'static': {
            'lang_input_choice': '精选',
            'lang_input_Tuzki': '兔斯基',
            'lang_input_BOBO': 'BOBO',
            'lang_input_lvdouwa': '绿豆蛙',
            'lang_input_babyCat': 'baby猫',
            'lang_input_bubble': '泡泡',
            'lang_input_youa': '有啊'
        }
    },
    'gmap': {
        'static': {
            'lang_input_address': '地址',
            'lang_input_search': '搜索',
            'address': { value: "北京" }
        },
        searchError: '无法定位到该地址!'
    },
    'help': {
        'static': {
            'lang_input_about': '关于UEditor',
            'lang_input_shortcuts': '快捷键',
            'lang_input_introduction': 'UEditor是由百度web前端研发部开发的所见即所得富文本web编辑器，具有轻量，可定制，注重用户体验等特点。开源基于BSD协议，允许自由使用和修改代码。',
            'lang_Txt_shortcuts': '快捷键',
            'lang_Txt_func': '功能',
            'lang_Txt_bold': '给选中字设置为加粗',
            'lang_Txt_copy': '复制选中内容',
            'lang_Txt_cut': '剪切选中内容',
            'lang_Txt_Paste': '粘贴',
            'lang_Txt_undo': '重新执行上次操作',
            'lang_Txt_redo': '撤销上一次操作',
            'lang_Txt_italic': '给选中字设置为斜体',
            'lang_Txt_underline': '给选中字加下划线',
            'lang_Txt_selectAll': '全部选中',
            'lang_Txt_visualEnter': '软回车',
            'lang_Txt_fullscreen': '全屏'
        }
    },
    'insertframe': {
        'static': {
            'lang_input_address': '地址：',
            'lang_input_width': '宽度：',
            'lang_input_height': '高度：',
            'lang_input_isScroll': '允许滚动条：',
            'lang_input_frameborder': '显示框架边框：',
            'lang_input_alignMode': '对齐方式：',
            'align': { title: "对齐方式", options: ["默认", "左对齐", "右对齐", "居中"] }
        },
        'enterAddress': '请输入地址!'
    },
    'link': {
        'static': {
            'lang_input_text': '文本内容：',
            'lang_input_url': '链接地址：',
            'lang_input_title': '标题：',
            'lang_input_target': '是否在新窗口打开：'
        },
        'validLink': '只支持选中一个链接时生效',
        'httpPrompt': '您输入的超链接中不包含http等协议名称，默认将为您添加http://前缀'
    },
    'map': {
        'static': {
            lang_city: "城市",
            lang_address: "地址",
            city: { value: "北京" },
            lang_search: "搜索",
            lang_dynamicmap: "插入动态地图"
        },
        cityMsg: "请选择城市",
        errorMsg: "抱歉，找不到该位置！"
    },
    'searchreplace': {
        'static': {
            lang_tab_search: "查找",
            lang_tab_replace: "替换",
            lang_search1: "查找",
            lang_search2: "查找",
            lang_replace: "替换",
            lang_searchReg: '支持正则表达式，添加前后斜杠标示为正则表达式，例如“/表达式/”',
            lang_searchReg1: '支持正则表达式，添加前后斜杠标示为正则表达式，例如“/表达式/”',
            lang_case_sensitive1: "区分大小写",
            lang_case_sensitive2: "区分大小写",
            nextFindBtn: { value: "下一个" },
            preFindBtn: { value: "上一个" },
            nextReplaceBtn: { value: "下一个" },
            preReplaceBtn: { value: "上一个" },
            repalceBtn: { value: "替换" },
            repalceAllBtn: { value: "全部替换" }
        },
        getEnd: "已经搜索到文章末尾！",
        getStart: "已经搜索到文章头部",
        countMsg: "总共替换了{#count}处！"
    },
    'snapscreen': {
        'static': {
            lang_showMsg: "截图功能需要首先安装UEditor截图插件！ ",
            lang_download: "点此下载",
            lang_step1: "第一步，下载UEditor截图插件并运行安装。",
            lang_step2: "第二步，插件安装完成后即可使用，如不生效，请重启浏览器后再试！"
        }
    },
    'spechars': {
        'static': {},
        tsfh: "特殊字符",
        lmsz: "罗马字符",
        szfh: "数学字符",
        rwfh: "日文字符",
        xlzm: "希腊字母",
        ewzm: "俄文字符",
        pyzm: "拼音字母",
        yyyb: "英语音标",
        zyzf: "其他"
    },
    'edittable': {
        'static': {
            'lang_tableStyle': '表格样式',
            'lang_insertCaption': '添加表格名称行',
            'lang_insertTitle': '添加表格标题行',
            'lang_insertTitleCol': '添加表格标题列',
            'lang_orderbycontent': "使表格内容可排序",
            'lang_tableSize': '自动调整表格尺寸',
            'lang_autoSizeContent': '按表格文字自适应',
            'lang_autoSizePage': '按页面宽度自适应',
            'lang_example': '示例',
            'lang_borderStyle': '表格边框',
            'lang_color': '颜色:'
        },
        captionName: '表格名称',
        titleName: '标题',
        cellsName: '内容',
        errorMsg: '有合并单元格，不可排序'
    },
    'edittip': {
        'static': {
            lang_delRow: '删除整行',
            lang_delCol: '删除整列'
        }
    },
    'edittd': {
        'static': {
            lang_tdBkColor: '背景颜色:'
        }
    },
    'formula': {
        'static': {}
    },
    'wordimage': {
        'static': {
            lang_resave: "转存步骤",
            uploadBtn: { src: "upload.png", alt: "上传" },
            clipboard: { style: "background: url(copy.png) -153px -1px no-repeat;" },
            lang_step: "1、点击顶部复制按钮，将地址复制到剪贴板；2、点击添加照片按钮，在弹出的对话框中使用Ctrl+V粘贴地址；3、点击打开后选择图片上传流程。"
        },
        'fileType': "图片",
        'flashError': "FLASH初始化失败，请检查FLASH插件是否正确安装！",
        'netError': "网络连接错误，请重试！",
        'copySuccess': "图片地址已经复制！",
        'flashI18n': {} //留空默认中文
    },
    'autosave': {
        'saving': '保存中...',
        'success': '本地保存成功'
    }
};

/***/ }),

/***/ 997:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);




var _typeof = typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a === "function" && typeof __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol_iterator___default.a === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj; };

(function () {
  UEDITOR_CONFIG = window.UEDITOR_CONFIG || {};var baidu = window.baidu || {};window.baidu = baidu;window.UE = baidu.editor = window.UE || {};UE.plugins = {};UE.commands = {};UE.instants = {};UE.I18N = {};UE._customizeUI = {};UE.version = "1.4.3";var dom = UE.dom = {};var browser = UE.browser = function () {
    var agent = navigator.userAgent.toLowerCase(),
        opera = window.opera,
        browser = { ie: /(msie\s|trident.*rv:)([\w.]+)/.test(agent), opera: !!opera && opera.version, webkit: agent.indexOf(" applewebkit/") > -1, mac: agent.indexOf("macintosh") > -1, quirks: document.compatMode == "BackCompat" };browser.gecko = navigator.product == "Gecko" && !browser.webkit && !browser.opera && !browser.ie;var version = 0;if (browser.ie) {
      var v1 = agent.match(/(?:msie\s([\w.]+))/);var v2 = agent.match(/(?:trident.*rv:([\w.]+))/);if (v1 && v2 && v1[1] && v2[1]) {
        version = Math.max(v1[1] * 1, v2[1] * 1);
      } else {
        if (v1 && v1[1]) {
          version = v1[1] * 1;
        } else {
          if (v2 && v2[1]) {
            version = v2[1] * 1;
          } else {
            version = 0;
          }
        }
      }browser.ie11Compat = document.documentMode == 11;browser.ie9Compat = document.documentMode == 9;browser.ie8 = !!document.documentMode;browser.ie8Compat = document.documentMode == 8;browser.ie7Compat = version == 7 && !document.documentMode || document.documentMode == 7;browser.ie6Compat = version < 7 || browser.quirks;browser.ie9above = version > 8;browser.ie9below = version < 9;browser.ie11above = version > 10;browser.ie11below = version < 11;
    }if (browser.gecko) {
      var geckoRelease = agent.match(/rv:([\d\.]+)/);if (geckoRelease) {
        geckoRelease = geckoRelease[1].split(".");version = geckoRelease[0] * 10000 + (geckoRelease[1] || 0) * 100 + (geckoRelease[2] || 0) * 1;
      }
    }if (/chrome\/(\d+\.\d)/i.test(agent)) {
      browser.chrome = +RegExp["\x241"];
    }if (/(\d+\.\d)?(?:\.\d)?\s+safari\/?(\d+\.\d+)?/i.test(agent) && !/chrome/i.test(agent)) {
      browser.safari = +(RegExp["\x241"] || RegExp["\x242"]);
    }if (browser.opera) {
      version = parseFloat(opera.version());
    }if (browser.webkit) {
      version = parseFloat(agent.match(/ applewebkit\/(\d+)/)[1]);
    }browser.version = version;browser.isCompatible = !browser.mobile && (browser.ie && version >= 6 || browser.gecko && version >= 10801 || browser.opera && version >= 9.5 || browser.air && version >= 1 || browser.webkit && version >= 522 || false);return browser;
  }();var ie = browser.ie,
      webkit = browser.webkit,
      gecko = browser.gecko,
      opera = browser.opera;var utils = UE.utils = { each: function each(obj, iterator, context) {
      if (obj == null) {
        return;
      }if (obj.length === +obj.length) {
        for (var i = 0, l = obj.length; i < l; i++) {
          if (iterator.call(context, obj[i], i, obj) === false) {
            return false;
          }
        }
      } else {
        for (var key in obj) {
          if (obj.hasOwnProperty(key)) {
            if (iterator.call(context, obj[key], key, obj) === false) {
              return false;
            }
          }
        }
      }
    }, makeInstance: function makeInstance(obj) {
      var noop = new Function();noop.prototype = obj;obj = new noop();noop.prototype = null;return obj;
    }, extend: function extend(t, s, b) {
      if (s) {
        for (var k in s) {
          if (!b || !t.hasOwnProperty(k)) {
            t[k] = s[k];
          }
        }
      }return t;
    }, extend2: function extend2(t) {
      var a = arguments;for (var i = 1; i < a.length; i++) {
        var x = a[i];for (var k in x) {
          if (!t.hasOwnProperty(k)) {
            t[k] = x[k];
          }
        }
      }return t;
    }, inherits: function inherits(subClass, superClass) {
      var oldP = subClass.prototype,
          newP = utils.makeInstance(superClass.prototype);utils.extend(newP, oldP, true);subClass.prototype = newP;return newP.constructor = subClass;
    }, bind: function bind(fn, context) {
      return function () {
        return fn.apply(context, arguments);
      };
    }, defer: function defer(fn, delay, exclusion) {
      var timerID;return function () {
        if (exclusion) {
          clearTimeout(timerID);
        }timerID = setTimeout(fn, delay);
      };
    }, indexOf: function indexOf(array, item, start) {
      var index = -1;start = this.isNumber(start) ? start : 0;this.each(array, function (v, i) {
        if (i >= start && v === item) {
          index = i;return false;
        }
      });return index;
    }, removeItem: function removeItem(array, item) {
      for (var i = 0, l = array.length; i < l; i++) {
        if (array[i] === item) {
          array.splice(i, 1);i--;
        }
      }
    }, trim: function trim(str) {
      return str.replace(/(^[ \t\n\r]+)|([ \t\n\r]+$)/g, "");
    }, listToMap: function listToMap(list) {
      if (!list) {
        return {};
      }list = utils.isArray(list) ? list : list.split(",");for (var i = 0, ci, obj = {}; ci = list[i++];) {
        obj[ci.toUpperCase()] = obj[ci] = 1;
      }return obj;
    }, unhtml: function unhtml(str, reg) {
      return str ? str.replace(reg || /[&<">'](?:(amp|lt|quot|gt|#39|nbsp|#\d+);)?/g, function (a, b) {
        if (b) {
          return a;
        } else {
          return { "<": "&lt;", "&": "&amp;", '"': "&quot;", ">": "&gt;", "'": "&#39;" }[a];
        }
      }) : "";
    }, unhtmlForUrl: function unhtmlForUrl(str, reg) {
      return str ? str.replace(reg || /[<">']/g, function (a) {
        return { "<": "&lt;", "&": "&amp;", '"': "&quot;", ">": "&gt;", "'": "&#39;" }[a];
      }) : "";
    }, html: function html(str) {
      return str ? str.replace(/&((g|l|quo)t|amp|#39|nbsp);/g, function (m) {
        return { "&lt;": "<", "&amp;": "&", "&quot;": '"', "&gt;": ">", "&#39;": "'", "&nbsp;": " " }[m];
      }) : "";
    }, cssStyleToDomStyle: function () {
      var test = document.createElement("div").style,
          cache = { "float": test.cssFloat != undefined ? "cssFloat" : test.styleFloat != undefined ? "styleFloat" : "float" };return function (cssName) {
        return cache[cssName] || (cache[cssName] = cssName.toLowerCase().replace(/-./g, function (match) {
          return match.charAt(1).toUpperCase();
        }));
      };
    }(), loadFile: function () {
      var tmpList = [];function getItem(doc, obj) {
        try {
          for (var i = 0, ci; ci = tmpList[i++];) {
            if (ci.doc === doc && ci.url == (obj.src || obj.href)) {
              return ci;
            }
          }
        } catch (e) {
          return null;
        }
      }return function (doc, obj, fn) {
        var item = getItem(doc, obj);if (item) {
          if (item.ready) {
            fn && fn();
          } else {
            item.funs.push(fn);
          }return;
        }tmpList.push({ doc: doc, url: obj.src || obj.href, funs: [fn] });if (!doc.body) {
          var html = [];for (var p in obj) {
            if (p == "tag") {
              continue;
            }html.push(p + '="' + obj[p] + '"');
          }doc.write("<" + obj.tag + " " + html.join(" ") + " ></" + obj.tag + ">");return;
        }if (obj.id && doc.getElementById(obj.id)) {
          return;
        }var element = doc.createElement(obj.tag);delete obj.tag;for (var p in obj) {
          element.setAttribute(p, obj[p]);
        }element.onload = element.onreadystatechange = function () {
          if (!this.readyState || /loaded|complete/.test(this.readyState)) {
            item = getItem(doc, obj);if (item.funs.length > 0) {
              item.ready = 1;for (var fi; fi = item.funs.pop();) {
                fi();
              }
            }element.onload = element.onreadystatechange = null;
          }
        };element.onerror = function () {
          throw Error("The load " + (obj.href || obj.src) + " fails,check the url settings of file ueditor.config.js ");
        };doc.getElementsByTagName("head")[0].appendChild(element);
      };
    }(), isEmptyObject: function isEmptyObject(obj) {
      if (obj == null) {
        return true;
      }if (this.isArray(obj) || this.isString(obj)) {
        return obj.length === 0;
      }for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          return false;
        }
      }return true;
    }, fixColor: function fixColor(name, value) {
      if (/color/i.test(name) && /rgba?/.test(value)) {
        var array = value.split(",");if (array.length > 3) {
          return "";
        }value = "#";for (var i = 0, color; color = array[i++];) {
          color = parseInt(color.replace(/[^\d]/gi, ""), 10).toString(16);value += color.length == 1 ? "0" + color : color;
        }value = value.toUpperCase();
      }return value;
    }, optCss: function optCss(val) {
      var padding, margin, border;val = val.replace(/(padding|margin|border)\-([^:]+):([^;]+);?/gi, function (str, key, name, val) {
        if (val.split(" ").length == 1) {
          switch (key) {case "padding":
              !padding && (padding = {});padding[name] = val;return "";case "margin":
              !margin && (margin = {});margin[name] = val;return "";case "border":
              return val == "initial" ? "" : str;}
        }return str;
      });function opt(obj, name) {
        if (!obj) {
          return "";
        }var t = obj.top,
            b = obj.bottom,
            l = obj.left,
            r = obj.right,
            val = "";if (!t || !l || !b || !r) {
          for (var p in obj) {
            val += ";" + name + "-" + p + ":" + obj[p] + ";";
          }
        } else {
          val += ";" + name + ":" + (t == b && b == l && l == r ? t : t == b && l == r ? t + " " + l : l == r ? t + " " + l + " " + b : t + " " + r + " " + b + " " + l) + ";";
        }return val;
      }val += opt(padding, "padding") + opt(margin, "margin");return val.replace(/^[ \n\r\t;]*|[ \n\r\t]*$/, "").replace(/;([ \n\r\t]+)|\1;/g, ";").replace(/(&((l|g)t|quot|#39))?;{2,}/g, function (a, b) {
        return b ? b + ";;" : ";";
      });
    }, clone: function clone(source, target) {
      var tmp;target = target || {};for (var i in source) {
        if (source.hasOwnProperty(i)) {
          tmp = source[i];if ((typeof tmp === "undefined" ? "undefined" : _typeof(tmp)) == "object") {
            target[i] = utils.isArray(tmp) ? [] : {};utils.clone(source[i], target[i]);
          } else {
            target[i] = tmp;
          }
        }
      }return target;
    }, transUnitToPx: function transUnitToPx(val) {
      if (!/(pt|cm)/.test(val)) {
        return val;
      }var unit;val.replace(/([\d.]+)(\w+)/, function (str, v, u) {
        val = v;unit = u;
      });switch (unit) {case "cm":
          val = parseFloat(val) * 25;break;case "pt":
          val = Math.round(parseFloat(val) * 96 / 72);}return val + (val ? "px" : "");
    }, domReady: function () {
      var fnArr = [];function doReady(doc) {
        doc.isReady = true;for (var ci; ci = fnArr.pop(); ci()) {}
      }return function (onready, win) {
        var win = win || window;var doc = win.document;onready && fnArr.push(onready);if (doc.readyState === "complete") {
          doReady(doc);
        } else {
          doc.isReady && doReady(doc);if (browser.ie && browser.version != 11) {
            (function () {
              if (doc.isReady) {
                return;
              }try {
                doc.documentElement.doScroll("left");
              } catch (error) {
                setTimeout(arguments.callee, 0);return;
              }doReady(doc);
            })();win.attachEvent("onload", function () {
              doReady(doc);
            });
          } else {
            doc.addEventListener("DOMContentLoaded", function () {
              doc.removeEventListener("DOMContentLoaded", arguments.callee, false);doReady(doc);
            }, false);win.addEventListener("load", function () {
              doReady(doc);
            }, false);
          }
        }
      };
    }(), cssRule: browser.ie && browser.version != 11 ? function (key, style, doc) {
      var indexList, index;if (style === undefined || style && style.nodeType && style.nodeType == 9) {
        doc = style && style.nodeType && style.nodeType == 9 ? style : doc || document;indexList = doc.indexList || (doc.indexList = {});index = indexList[key];if (index !== undefined) {
          return doc.styleSheets[index].cssText;
        }return undefined;
      }doc = doc || document;indexList = doc.indexList || (doc.indexList = {});index = indexList[key];if (style === "") {
        if (index !== undefined) {
          doc.styleSheets[index].cssText = "";delete indexList[key];return true;
        }return false;
      }if (index !== undefined) {
        sheetStyle = doc.styleSheets[index];
      } else {
        sheetStyle = doc.createStyleSheet("", index = doc.styleSheets.length);indexList[key] = index;
      }sheetStyle.cssText = style;
    } : function (key, style, doc) {
      var head, node;if (style === undefined || style && style.nodeType && style.nodeType == 9) {
        doc = style && style.nodeType && style.nodeType == 9 ? style : doc || document;node = doc.getElementById(key);return node ? node.innerHTML : undefined;
      }doc = doc || document;node = doc.getElementById(key);if (style === "") {
        if (node) {
          node.parentNode.removeChild(node);return true;
        }return false;
      }if (node) {
        node.innerHTML = style;
      } else {
        node = doc.createElement("style");node.id = key;node.innerHTML = style;doc.getElementsByTagName("head")[0].appendChild(node);
      }
    }, sort: function sort(array, compareFn) {
      compareFn = compareFn || function (item1, item2) {
        return item1.localeCompare(item2);
      };for (var i = 0, len = array.length; i < len; i++) {
        for (var j = i, length = array.length; j < length; j++) {
          if (compareFn(array[i], array[j]) > 0) {
            var t = array[i];array[i] = array[j];array[j] = t;
          }
        }
      }return array;
    }, serializeParam: function serializeParam(json) {
      var strArr = [];for (var i in json) {
        if (i == "method" || i == "timeout" || i == "async") {
          continue;
        }if (!(_typeof(json[i]).toLowerCase() == "function" || _typeof(json[i]).toLowerCase() == "object")) {
          strArr.push(encodeURIComponent(i) + "=" + encodeURIComponent(json[i]));
        } else {
          if (utils.isArray(json[i])) {
            for (var j = 0; j < json[i].length; j++) {
              strArr.push(encodeURIComponent(i) + "[]=" + encodeURIComponent(json[i][j]));
            }
          }
        }
      }return strArr.join("&");
    }, formatUrl: function formatUrl(url) {
      var u = url.replace(/&&/g, "&");u = u.replace(/\?&/g, "?");u = u.replace(/&$/g, "");u = u.replace(/&#/g, "#");u = u.replace(/&+/g, "&");return u;
    }, isCrossDomainUrl: function isCrossDomainUrl(url) {
      var a = document.createElement("a");a.href = url;if (browser.ie) {
        a.href = a.href;
      }return !(a.protocol == location.protocol && a.hostname == location.hostname && (a.port == location.port || a.port == "80" && location.port == "" || a.port == "" && location.port == "80"));
    }, clearEmptyAttrs: function clearEmptyAttrs(obj) {
      for (var p in obj) {
        if (obj[p] === "") {
          delete obj[p];
        }
      }return obj;
    }, str2json: function str2json(s) {
      if (!utils.isString(s)) {
        return null;
      }if (window.JSON) {
        return JSON.parse(s);
      } else {
        return new Function("return " + utils.trim(s || ""))();
      }
    }, json2str: function () {
      if (window.JSON) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default.a;
      } else {
        var encodeString = function encodeString(source) {
          if (/["\\\x00-\x1f]/.test(source)) {
            source = source.replace(/["\\\x00-\x1f]/g, function (match) {
              var c = escapeMap[match];if (c) {
                return c;
              }c = match.charCodeAt();return "\\u00" + Math.floor(c / 16).toString(16) + (c % 16).toString(16);
            });
          }return '"' + source + '"';
        };

        var encodeArray = function encodeArray(source) {
          var result = ["["],
              l = source.length,
              preComma,
              i,
              item;for (i = 0; i < l; i++) {
            item = source[i];switch (typeof item === "undefined" ? "undefined" : _typeof(item)) {case "undefined":case "function":case "unknown":
                break;default:
                if (preComma) {
                  result.push(",");
                }result.push(utils.json2str(item));preComma = 1;}
          }result.push("]");return result.join("");
        };

        var pad = function pad(source) {
          return source < 10 ? "0" + source : source;
        };

        var encodeDate = function encodeDate(source) {
          return '"' + source.getFullYear() + "-" + pad(source.getMonth() + 1) + "-" + pad(source.getDate()) + "T" + pad(source.getHours()) + ":" + pad(source.getMinutes()) + ":" + pad(source.getSeconds()) + '"';
        };

        var escapeMap = { "\b": "\\b", "\t": "\\t", "\n": "\\n", "\f": "\\f", "\r": "\\r", '"': '\\"', "\\": "\\\\" };return function (value) {
          switch (typeof value === "undefined" ? "undefined" : _typeof(value)) {case "undefined":
              return "undefined";case "number":
              return isFinite(value) ? String(value) : "null";case "string":
              return encodeString(value);case "boolean":
              return String(value);default:
              if (value === null) {
                return "null";
              } else {
                if (utils.isArray(value)) {
                  return encodeArray(value);
                } else {
                  if (utils.isDate(value)) {
                    return encodeDate(value);
                  } else {
                    var result = ["{"],
                        encode = utils.json2str,
                        preComma,
                        item;for (var key in value) {
                      if (Object.prototype.hasOwnProperty.call(value, key)) {
                        item = value[key];switch (typeof item === "undefined" ? "undefined" : _typeof(item)) {case "undefined":case "unknown":case "function":
                            break;default:
                            if (preComma) {
                              result.push(",");
                            }preComma = 1;result.push(encode(key) + ":" + encode(item));}
                      }
                    }result.push("}");return result.join("");
                  }
                }
              }}
        };
      }
    }() };utils.each(["String", "Function", "Array", "Number", "RegExp", "Object", "Date"], function (v) {
    UE.utils["is" + v] = function (obj) {
      return Object.prototype.toString.apply(obj) == "[object " + v + "]";
    };
  });var EventBase = UE.EventBase = function () {};EventBase.prototype = { addListener: function addListener(types, listener) {
      types = utils.trim(types).split(/\s+/);for (var i = 0, ti; ti = types[i++];) {
        getListener(this, ti, true).push(listener);
      }
    }, on: function on(types, listener) {
      return this.addListener(types, listener);
    }, off: function off(types, listener) {
      return this.removeListener(types, listener);
    }, trigger: function trigger() {
      return this.fireEvent.apply(this, arguments);
    }, removeListener: function removeListener(types, listener) {
      types = utils.trim(types).split(/\s+/);for (var i = 0, ti; ti = types[i++];) {
        utils.removeItem(getListener(this, ti) || [], listener);
      }
    }, fireEvent: function fireEvent() {
      var types = arguments[0];types = utils.trim(types).split(" ");for (var i = 0, ti; ti = types[i++];) {
        var listeners = getListener(this, ti),
            r,
            t,
            k;if (listeners) {
          k = listeners.length;while (k--) {
            if (!listeners[k]) {
              continue;
            }t = listeners[k].apply(this, arguments);if (t === true) {
              return t;
            }if (t !== undefined) {
              r = t;
            }
          }
        }if (t = this["on" + ti.toLowerCase()]) {
          r = t.apply(this, arguments);
        }
      }return r;
    } };function getListener(obj, type, force) {
    var allListeners;type = type.toLowerCase();return (allListeners = obj.__allListeners || force && (obj.__allListeners = {})) && (allListeners[type] || force && (allListeners[type] = []));
  }var dtd = dom.dtd = function () {
    function _(s) {
      for (var k in s) {
        s[k.toUpperCase()] = s[k];
      }return s;
    }var X = utils.extend2;var A = _({ isindex: 1, fieldset: 1 }),
        B = _({ input: 1, button: 1, select: 1, textarea: 1, label: 1 }),
        C = X(_({ a: 1 }), B),
        D = X({ iframe: 1 }, C),
        E = _({ hr: 1, ul: 1, menu: 1, div: 1, blockquote: 1, noscript: 1, table: 1, center: 1, address: 1, dir: 1, pre: 1, h5: 1, dl: 1, h4: 1, noframes: 1, h6: 1, ol: 1, h1: 1, h3: 1, h2: 1 }),
        F = _({ ins: 1, del: 1, script: 1, style: 1 }),
        G = X(_({ b: 1, acronym: 1, bdo: 1, "var": 1, "#": 1, abbr: 1, code: 1, br: 1, i: 1, cite: 1, kbd: 1, u: 1, strike: 1, s: 1, tt: 1, strong: 1, q: 1, samp: 1, em: 1, dfn: 1, span: 1 }), F),
        H = X(_({ sub: 1, img: 1, embed: 1, object: 1, sup: 1, basefont: 1, map: 1, applet: 1, font: 1, big: 1, small: 1 }), G),
        I = X(_({ p: 1 }), H),
        J = X(_({ iframe: 1 }), H, B),
        K = _({ img: 1, embed: 1, noscript: 1, br: 1, kbd: 1, center: 1, button: 1, basefont: 1, h5: 1, h4: 1, samp: 1, h6: 1, ol: 1, h1: 1, h3: 1, h2: 1, form: 1, font: 1, "#": 1, select: 1, menu: 1, ins: 1, abbr: 1, label: 1, code: 1, table: 1, script: 1, cite: 1, input: 1, iframe: 1, strong: 1, textarea: 1, noframes: 1, big: 1, small: 1, span: 1, hr: 1, sub: 1, bdo: 1, "var": 1, div: 1, object: 1, sup: 1, strike: 1, dir: 1, map: 1, dl: 1, applet: 1, del: 1, isindex: 1, fieldset: 1, ul: 1, b: 1, acronym: 1, a: 1, blockquote: 1, i: 1, u: 1, s: 1, tt: 1, address: 1, q: 1, pre: 1, p: 1, em: 1, dfn: 1 }),
        L = X(_({ a: 0 }), J),
        M = _({ tr: 1 }),
        N = _({ "#": 1 }),
        O = X(_({ param: 1 }), K),
        P = X(_({ form: 1 }), A, D, E, I),
        Q = _({ li: 1, ol: 1, ul: 1 }),
        R = _({ style: 1, script: 1 }),
        S = _({ base: 1, link: 1, meta: 1, title: 1 }),
        T = X(S, R),
        U = _({ head: 1, body: 1 }),
        V = _({ html: 1 });var block = _({ address: 1, blockquote: 1, center: 1, dir: 1, div: 1, dl: 1, fieldset: 1, form: 1, h1: 1, h2: 1, h3: 1, h4: 1, h5: 1, h6: 1, hr: 1, isindex: 1, menu: 1, noframes: 1, ol: 1, p: 1, pre: 1, table: 1, ul: 1 }),
        empty = _({ area: 1, base: 1, basefont: 1, br: 1, col: 1, command: 1, dialog: 1, embed: 1, hr: 1, img: 1, input: 1, isindex: 1, keygen: 1, link: 1, meta: 1, param: 1, source: 1, track: 1, wbr: 1 });return _({ $nonBodyContent: X(V, U, S), $block: block, $inline: L, $inlineWithA: X(_({ a: 1 }), L), $body: X(_({ script: 1, style: 1 }), block), $cdata: _({ script: 1, style: 1 }), $empty: empty, $nonChild: _({ iframe: 1, textarea: 1 }), $listItem: _({ dd: 1, dt: 1, li: 1 }), $list: _({ ul: 1, ol: 1, dl: 1 }), $isNotEmpty: _({ table: 1, ul: 1, ol: 1, dl: 1, iframe: 1, area: 1, base: 1, col: 1, hr: 1, img: 1, embed: 1, input: 1, link: 1, meta: 1, param: 1, h1: 1, h2: 1, h3: 1, h4: 1, h5: 1, h6: 1 }), $removeEmpty: _({ a: 1, abbr: 1, acronym: 1, address: 1, b: 1, bdo: 1, big: 1, cite: 1, code: 1, del: 1, dfn: 1, em: 1, font: 1, i: 1, ins: 1, label: 1, kbd: 1, q: 1, s: 1, samp: 1, small: 1, span: 1, strike: 1, strong: 1, sub: 1, sup: 1, tt: 1, u: 1, "var": 1 }), $removeEmptyBlock: _({ "p": 1, "div": 1 }), $tableContent: _({ caption: 1, col: 1, colgroup: 1, tbody: 1, td: 1, tfoot: 1, th: 1, thead: 1, tr: 1, table: 1 }), $notTransContent: _({ pre: 1, script: 1, style: 1, textarea: 1 }), html: U, head: T, style: N, script: N, body: P, base: {}, link: {}, meta: {}, title: N, col: {}, tr: _({ td: 1, th: 1 }), img: {}, embed: {}, colgroup: _({ thead: 1, col: 1, tbody: 1, tr: 1, tfoot: 1 }), noscript: P, td: P, br: {}, th: P, center: P, kbd: L, button: X(I, E), basefont: {}, h5: L, h4: L, samp: L, h6: L, ol: Q, h1: L, h3: L, option: N, h2: L, form: X(A, D, E, I), select: _({ optgroup: 1, option: 1 }), font: L, ins: L, menu: Q, abbr: L, label: L, table: _({ thead: 1, col: 1, tbody: 1, tr: 1, colgroup: 1, caption: 1, tfoot: 1 }), code: L, tfoot: M, cite: L, li: P, input: {}, iframe: P, strong: L, textarea: N, noframes: P, big: L, small: L, span: _({ "#": 1, br: 1, b: 1, strong: 1, u: 1, i: 1, em: 1, sub: 1, sup: 1, strike: 1, span: 1 }), hr: L, dt: L, sub: L, optgroup: _({ option: 1 }), param: {}, bdo: L, "var": L, div: P, object: O, sup: L, dd: P, strike: L, area: {}, dir: Q, map: X(_({ area: 1, form: 1, p: 1 }), A, F, E), applet: O, dl: _({ dt: 1, dd: 1 }), del: L, isindex: {}, fieldset: X(_({ legend: 1 }), K), thead: M, ul: Q, acronym: L, b: L, a: X(_({ a: 1 }), J), blockquote: X(_({ td: 1, tr: 1, tbody: 1, li: 1 }), P), caption: L, i: L, u: L, tbody: M, s: L, address: X(D, I), tt: L, legend: L, q: L, pre: X(G, C), p: X(_({ "a": 1 }), L), em: L, dfn: L });
  }();function getDomNode(node, start, ltr, startFromChild, fn, guard) {
    var tmpNode = startFromChild && node[start],
        parent;!tmpNode && (tmpNode = node[ltr]);while (!tmpNode && (parent = (parent || node).parentNode)) {
      if (parent.tagName == "BODY" || guard && !guard(parent)) {
        return null;
      }tmpNode = parent[ltr];
    }if (tmpNode && fn && !fn(tmpNode)) {
      return getDomNode(tmpNode, start, ltr, false, fn);
    }return tmpNode;
  }var attrFix = ie && browser.version < 9 ? { tabindex: "tabIndex", readonly: "readOnly", "for": "htmlFor", "class": "className", maxlength: "maxLength", cellspacing: "cellSpacing", cellpadding: "cellPadding", rowspan: "rowSpan", colspan: "colSpan", usemap: "useMap", frameborder: "frameBorder" } : { tabindex: "tabIndex", readonly: "readOnly" },
      styleBlock = utils.listToMap(["-webkit-box", "-moz-box", "block", "list-item", "table", "table-row-group", "table-header-group", "table-footer-group", "table-row", "table-column-group", "table-column", "table-cell", "table-caption"]);var domUtils = dom.domUtils = { NODE_ELEMENT: 1, NODE_DOCUMENT: 9, NODE_TEXT: 3, NODE_COMMENT: 8, NODE_DOCUMENT_FRAGMENT: 11, POSITION_IDENTICAL: 0, POSITION_DISCONNECTED: 1, POSITION_FOLLOWING: 2, POSITION_PRECEDING: 4, POSITION_IS_CONTAINED: 8, POSITION_CONTAINS: 16, fillChar: ie && browser.version == "6" ? "\uFEFF" : "\u200B", keys: { 8: 1, 46: 1, 16: 1, 17: 1, 18: 1, 37: 1, 38: 1, 39: 1, 40: 1, 13: 1 }, getPosition: function getPosition(nodeA, nodeB) {
      if (nodeA === nodeB) {
        return 0;
      }var node,
          parentsA = [nodeA],
          parentsB = [nodeB];node = nodeA;while (node = node.parentNode) {
        if (node === nodeB) {
          return 10;
        }parentsA.push(node);
      }node = nodeB;while (node = node.parentNode) {
        if (node === nodeA) {
          return 20;
        }parentsB.push(node);
      }parentsA.reverse();parentsB.reverse();if (parentsA[0] !== parentsB[0]) {
        return 1;
      }var i = -1;while (i++, parentsA[i] === parentsB[i]) {}nodeA = parentsA[i];nodeB = parentsB[i];while (nodeA = nodeA.nextSibling) {
        if (nodeA === nodeB) {
          return 4;
        }
      }return 2;
    }, getNodeIndex: function getNodeIndex(node, ignoreTextNode) {
      var preNode = node,
          i = 0;while (preNode = preNode.previousSibling) {
        if (ignoreTextNode && preNode.nodeType == 3) {
          if (preNode.nodeType != preNode.nextSibling.nodeType) {
            i++;
          }continue;
        }i++;
      }return i;
    }, inDoc: function inDoc(node, doc) {
      return domUtils.getPosition(node, doc) == 10;
    }, findParent: function findParent(node, filterFn, includeSelf) {
      if (node && !domUtils.isBody(node)) {
        node = includeSelf ? node : node.parentNode;while (node) {
          if (!filterFn || filterFn(node) || domUtils.isBody(node)) {
            return filterFn && !filterFn(node) && domUtils.isBody(node) ? null : node;
          }node = node.parentNode;
        }
      }return null;
    }, findParentByTagName: function findParentByTagName(node, tagNames, includeSelf, excludeFn) {
      tagNames = utils.listToMap(utils.isArray(tagNames) ? tagNames : [tagNames]);return domUtils.findParent(node, function (node) {
        return tagNames[node.tagName] && !(excludeFn && excludeFn(node));
      }, includeSelf);
    }, findParents: function findParents(node, includeSelf, filterFn, closerFirst) {
      var parents = includeSelf && (filterFn && filterFn(node) || !filterFn) ? [node] : [];while (node = domUtils.findParent(node, filterFn)) {
        parents.push(node);
      }return closerFirst ? parents : parents.reverse();
    }, insertAfter: function insertAfter(node, newNode) {
      return node.nextSibling ? node.parentNode.insertBefore(newNode, node.nextSibling) : node.parentNode.appendChild(newNode);
    }, remove: function remove(node, keepChildren) {
      var parent = node.parentNode,
          child;if (parent) {
        if (keepChildren && node.hasChildNodes()) {
          while (child = node.firstChild) {
            parent.insertBefore(child, node);
          }
        }parent.removeChild(node);
      }return node;
    }, getNextDomNode: function getNextDomNode(node, startFromChild, filterFn, guard) {
      return getDomNode(node, "firstChild", "nextSibling", startFromChild, filterFn, guard);
    }, getPreDomNode: function getPreDomNode(node, startFromChild, filterFn, guard) {
      return getDomNode(node, "lastChild", "previousSibling", startFromChild, filterFn, guard);
    }, isBookmarkNode: function isBookmarkNode(node) {
      return node.nodeType == 1 && node.id && /^_baidu_bookmark_/i.test(node.id);
    }, getWindow: function getWindow(node) {
      var doc = node.ownerDocument || node;return doc.defaultView || doc.parentWindow;
    }, getCommonAncestor: function getCommonAncestor(nodeA, nodeB) {
      if (nodeA === nodeB) {
        return nodeA;
      }var parentsA = [nodeA],
          parentsB = [nodeB],
          parent = nodeA,
          i = -1;while (parent = parent.parentNode) {
        if (parent === nodeB) {
          return parent;
        }parentsA.push(parent);
      }parent = nodeB;while (parent = parent.parentNode) {
        if (parent === nodeA) {
          return parent;
        }parentsB.push(parent);
      }parentsA.reverse();parentsB.reverse();while (i++, parentsA[i] === parentsB[i]) {}return i == 0 ? null : parentsA[i - 1];
    }, clearEmptySibling: function clearEmptySibling(node, ignoreNext, ignorePre) {
      function clear(next, dir) {
        var tmpNode;while (next && !domUtils.isBookmarkNode(next) && (domUtils.isEmptyInlineElement(next) || !new RegExp("[^\t\n\r" + domUtils.fillChar + "]").test(next.nodeValue))) {
          tmpNode = next[dir];domUtils.remove(next);next = tmpNode;
        }
      }!ignoreNext && clear(node.nextSibling, "nextSibling");!ignorePre && clear(node.previousSibling, "previousSibling");
    }, split: function split(node, offset) {
      var doc = node.ownerDocument;if (browser.ie && offset == node.nodeValue.length) {
        var next = doc.createTextNode("");return domUtils.insertAfter(node, next);
      }var retval = node.splitText(offset);if (browser.ie8) {
        var tmpNode = doc.createTextNode("");domUtils.insertAfter(retval, tmpNode);domUtils.remove(tmpNode);
      }return retval;
    }, isWhitespace: function isWhitespace(node) {
      return !new RegExp("[^ \t\n\r" + domUtils.fillChar + "]").test(node.nodeValue);
    }, getXY: function getXY(element) {
      var x = 0,
          y = 0;while (element.offsetParent) {
        y += element.offsetTop;x += element.offsetLeft;element = element.offsetParent;
      }return { "x": x, "y": y };
    }, on: function on(element, type, handler) {
      var types = utils.isArray(type) ? type : utils.trim(type).split(/\s+/),
          k = types.length;if (k) {
        while (k--) {
          type = types[k];if (element.addEventListener) {
            element.addEventListener(type, handler, false);
          } else {
            if (!handler._d) {
              handler._d = { els: [] };
            }var key = type + handler.toString(),
                index = utils.indexOf(handler._d.els, element);if (!handler._d[key] || index == -1) {
              if (index == -1) {
                handler._d.els.push(element);
              }if (!handler._d[key]) {
                handler._d[key] = function (evt) {
                  return handler.call(evt.srcElement, evt || window.event);
                };
              }element.attachEvent("on" + type, handler._d[key]);
            }
          }
        }
      }element = null;
    }, un: function un(element, type, handler) {
      var types = utils.isArray(type) ? type : utils.trim(type).split(/\s+/),
          k = types.length;if (k) {
        while (k--) {
          type = types[k];if (element.removeEventListener) {
            element.removeEventListener(type, handler, false);
          } else {
            var key = type + handler.toString();try {
              element.detachEvent("on" + type, handler._d ? handler._d[key] : handler);
            } catch (e) {}if (handler._d && handler._d[key]) {
              var index = utils.indexOf(handler._d.els, element);if (index != -1) {
                handler._d.els.splice(index, 1);
              }handler._d.els.length == 0 && delete handler._d[key];
            }
          }
        }
      }
    }, isSameElement: function isSameElement(nodeA, nodeB) {
      if (nodeA.tagName != nodeB.tagName) {
        return false;
      }var thisAttrs = nodeA.attributes,
          otherAttrs = nodeB.attributes;if (!ie && thisAttrs.length != otherAttrs.length) {
        return false;
      }var attrA,
          attrB,
          al = 0,
          bl = 0;for (var i = 0; attrA = thisAttrs[i++];) {
        if (attrA.nodeName == "style") {
          if (attrA.specified) {
            al++;
          }if (domUtils.isSameStyle(nodeA, nodeB)) {
            continue;
          } else {
            return false;
          }
        }if (ie) {
          if (attrA.specified) {
            al++;attrB = otherAttrs.getNamedItem(attrA.nodeName);
          } else {
            continue;
          }
        } else {
          attrB = nodeB.attributes[attrA.nodeName];
        }if (!attrB.specified || attrA.nodeValue != attrB.nodeValue) {
          return false;
        }
      }if (ie) {
        for (i = 0; attrB = otherAttrs[i++];) {
          if (attrB.specified) {
            bl++;
          }
        }if (al != bl) {
          return false;
        }
      }return true;
    }, isSameStyle: function isSameStyle(nodeA, nodeB) {
      var styleA = nodeA.style.cssText.replace(/( ?; ?)/g, ";").replace(/( ?: ?)/g, ":"),
          styleB = nodeB.style.cssText.replace(/( ?; ?)/g, ";").replace(/( ?: ?)/g, ":");if (browser.opera) {
        styleA = nodeA.style;styleB = nodeB.style;if (styleA.length != styleB.length) {
          return false;
        }for (var p in styleA) {
          if (/^(\d+|csstext)$/i.test(p)) {
            continue;
          }if (styleA[p] != styleB[p]) {
            return false;
          }
        }return true;
      }if (!styleA || !styleB) {
        return styleA == styleB;
      }styleA = styleA.split(";");styleB = styleB.split(";");if (styleA.length != styleB.length) {
        return false;
      }for (var i = 0, ci; ci = styleA[i++];) {
        if (utils.indexOf(styleB, ci) == -1) {
          return false;
        }
      }return true;
    }, isBlockElm: function isBlockElm(node) {
      return node.nodeType == 1 && (dtd.$block[node.tagName] || styleBlock[domUtils.getComputedStyle(node, "display")]) && !dtd.$nonChild[node.tagName];
    }, isBody: function isBody(node) {
      return node && node.nodeType == 1 && node.tagName.toLowerCase() == "body";
    }, breakParent: function breakParent(node, parent) {
      var tmpNode,
          parentClone = node,
          clone = node,
          leftNodes,
          rightNodes;do {
        parentClone = parentClone.parentNode;if (leftNodes) {
          tmpNode = parentClone.cloneNode(false);tmpNode.appendChild(leftNodes);leftNodes = tmpNode;tmpNode = parentClone.cloneNode(false);tmpNode.appendChild(rightNodes);rightNodes = tmpNode;
        } else {
          leftNodes = parentClone.cloneNode(false);rightNodes = leftNodes.cloneNode(false);
        }while (tmpNode = clone.previousSibling) {
          leftNodes.insertBefore(tmpNode, leftNodes.firstChild);
        }while (tmpNode = clone.nextSibling) {
          rightNodes.appendChild(tmpNode);
        }clone = parentClone;
      } while (parent !== parentClone);tmpNode = parent.parentNode;tmpNode.insertBefore(leftNodes, parent);tmpNode.insertBefore(rightNodes, parent);tmpNode.insertBefore(node, rightNodes);domUtils.remove(parent);return node;
    }, isEmptyInlineElement: function isEmptyInlineElement(node) {
      if (node.nodeType != 1 || !dtd.$removeEmpty[node.tagName]) {
        return 0;
      }node = node.firstChild;while (node) {
        if (domUtils.isBookmarkNode(node)) {
          return 0;
        }if (node.nodeType == 1 && !domUtils.isEmptyInlineElement(node) || node.nodeType == 3 && !domUtils.isWhitespace(node)) {
          return 0;
        }node = node.nextSibling;
      }return 1;
    }, trimWhiteTextNode: function trimWhiteTextNode(node) {
      function remove(dir) {
        var child;while ((child = node[dir]) && child.nodeType == 3 && domUtils.isWhitespace(child)) {
          node.removeChild(child);
        }
      }remove("firstChild");remove("lastChild");
    }, mergeChild: function mergeChild(node, tagName, attrs) {
      var list = domUtils.getElementsByTagName(node, node.tagName.toLowerCase());for (var i = 0, ci; ci = list[i++];) {
        if (!ci.parentNode || domUtils.isBookmarkNode(ci)) {
          continue;
        }if (ci.tagName.toLowerCase() == "span") {
          if (node === ci.parentNode) {
            domUtils.trimWhiteTextNode(node);if (node.childNodes.length == 1) {
              node.style.cssText = ci.style.cssText + ";" + node.style.cssText;domUtils.remove(ci, true);continue;
            }
          }ci.style.cssText = node.style.cssText + ";" + ci.style.cssText;if (attrs) {
            var style = attrs.style;if (style) {
              style = style.split(";");for (var j = 0, s; s = style[j++];) {
                ci.style[utils.cssStyleToDomStyle(s.split(":")[0])] = s.split(":")[1];
              }
            }
          }if (domUtils.isSameStyle(ci, node)) {
            domUtils.remove(ci, true);
          }continue;
        }if (domUtils.isSameElement(node, ci)) {
          domUtils.remove(ci, true);
        }
      }
    }, getElementsByTagName: function getElementsByTagName(node, name, filter) {
      if (filter && utils.isString(filter)) {
        var className = filter;filter = function filter(node) {
          return domUtils.hasClass(node, className);
        };
      }name = utils.trim(name).replace(/[ ]{2,}/g, " ").split(" ");var arr = [];for (var n = 0, ni; ni = name[n++];) {
        var list = node.getElementsByTagName(ni);for (var i = 0, ci; ci = list[i++];) {
          if (!filter || filter(ci)) {
            arr.push(ci);
          }
        }
      }return arr;
    }, mergeToParent: function mergeToParent(node) {
      var parent = node.parentNode;while (parent && dtd.$removeEmpty[parent.tagName]) {
        if (parent.tagName == node.tagName || parent.tagName == "A") {
          domUtils.trimWhiteTextNode(parent);if (parent.tagName == "SPAN" && !domUtils.isSameStyle(parent, node) || parent.tagName == "A" && node.tagName == "SPAN") {
            if (parent.childNodes.length > 1 || parent !== node.parentNode) {
              node.style.cssText = parent.style.cssText + ";" + node.style.cssText;parent = parent.parentNode;continue;
            } else {
              parent.style.cssText += ";" + node.style.cssText;if (parent.tagName == "A") {
                parent.style.textDecoration = "underline";
              }
            }
          }if (parent.tagName != "A") {
            parent === node.parentNode && domUtils.remove(node, true);break;
          }
        }parent = parent.parentNode;
      }
    }, mergeSibling: function mergeSibling(node, ignorePre, ignoreNext) {
      function merge(rtl, start, node) {
        var next;if ((next = node[rtl]) && !domUtils.isBookmarkNode(next) && next.nodeType == 1 && domUtils.isSameElement(node, next)) {
          while (next.firstChild) {
            if (start == "firstChild") {
              node.insertBefore(next.lastChild, node.firstChild);
            } else {
              node.appendChild(next.firstChild);
            }
          }domUtils.remove(next);
        }
      }!ignorePre && merge("previousSibling", "firstChild", node);!ignoreNext && merge("nextSibling", "lastChild", node);
    }, unSelectable: ie && browser.ie9below || browser.opera ? function (node) {
      node.onselectstart = function () {
        return false;
      };node.onclick = node.onkeyup = node.onkeydown = function () {
        return false;
      };node.unselectable = "on";node.setAttribute("unselectable", "on");for (var i = 0, ci; ci = node.all[i++];) {
        switch (ci.tagName.toLowerCase()) {case "iframe":case "textarea":case "input":case "select":
            break;default:
            ci.unselectable = "on";node.setAttribute("unselectable", "on");}
      }
    } : function (node) {
      node.style.MozUserSelect = node.style.webkitUserSelect = node.style.msUserSelect = node.style.KhtmlUserSelect = "none";
    }, removeAttributes: function removeAttributes(node, attrNames) {
      attrNames = utils.isArray(attrNames) ? attrNames : utils.trim(attrNames).replace(/[ ]{2,}/g, " ").split(" ");for (var i = 0, ci; ci = attrNames[i++];) {
        ci = attrFix[ci] || ci;switch (ci) {case "className":
            node[ci] = "";break;case "style":
            node.style.cssText = "";var val = node.getAttributeNode("style");!browser.ie && val && node.removeAttributeNode(val);}node.removeAttribute(ci);
      }
    }, createElement: function createElement(doc, tag, attrs) {
      return domUtils.setAttributes(doc.createElement(tag), attrs);
    }, setAttributes: function setAttributes(node, attrs) {
      for (var attr in attrs) {
        if (attrs.hasOwnProperty(attr)) {
          var value = attrs[attr];switch (attr) {case "class":
              node.className = value;break;case "style":
              node.style.cssText = node.style.cssText + ";" + value;break;case "innerHTML":
              node[attr] = value;break;case "value":
              node.value = value;break;default:
              node.setAttribute(attrFix[attr] || attr, value);}
        }
      }return node;
    }, getComputedStyle: function getComputedStyle(element, styleName) {
      var pros = "width height top left";if (pros.indexOf(styleName) > -1) {
        return element["offset" + styleName.replace(/^\w/, function (s) {
          return s.toUpperCase();
        })] + "px";
      }if (element.nodeType == 3) {
        element = element.parentNode;
      }if (browser.ie && browser.version < 9 && styleName == "font-size" && !element.style.fontSize && !dtd.$empty[element.tagName] && !dtd.$nonChild[element.tagName]) {
        var span = element.ownerDocument.createElement("span");span.style.cssText = "padding:0;border:0;font-family:simsun;";span.innerHTML = ".";element.appendChild(span);var result = span.offsetHeight;element.removeChild(span);span = null;return result + "px";
      }try {
        var value = domUtils.getStyle(element, styleName) || (window.getComputedStyle ? domUtils.getWindow(element).getComputedStyle(element, "").getPropertyValue(styleName) : (element.currentStyle || element.style)[utils.cssStyleToDomStyle(styleName)]);
      } catch (e) {
        return "";
      }return utils.transUnitToPx(utils.fixColor(styleName, value));
    }, removeClasses: function removeClasses(elm, classNames) {
      classNames = utils.isArray(classNames) ? classNames : utils.trim(classNames).replace(/[ ]{2,}/g, " ").split(" ");for (var i = 0, ci, cls = elm.className; ci = classNames[i++];) {
        cls = cls.replace(new RegExp("\\b" + ci + "\\b"), "");
      }cls = utils.trim(cls).replace(/[ ]{2,}/g, " ");if (cls) {
        elm.className = cls;
      } else {
        domUtils.removeAttributes(elm, ["class"]);
      }
    }, addClass: function addClass(elm, classNames) {
      if (!elm) {
        return;
      }classNames = utils.trim(classNames).replace(/[ ]{2,}/g, " ").split(" ");for (var i = 0, ci, cls = elm.className; ci = classNames[i++];) {
        if (!new RegExp("\\b" + ci + "\\b").test(cls)) {
          cls += " " + ci;
        }
      }elm.className = utils.trim(cls);
    }, hasClass: function hasClass(element, className) {
      if (utils.isRegExp(className)) {
        return className.test(element.className);
      }className = utils.trim(className).replace(/[ ]{2,}/g, " ").split(" ");for (var i = 0, ci, cls = element.className; ci = className[i++];) {
        if (!new RegExp("\\b" + ci + "\\b", "i").test(cls)) {
          return false;
        }
      }return i - 1 == className.length;
    }, preventDefault: function preventDefault(evt) {
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
    }, removeStyle: function removeStyle(element, name) {
      if (browser.ie) {
        if (name == "color") {
          name = "(^|;)" + name;
        }element.style.cssText = element.style.cssText.replace(new RegExp(name + "[^:]*:[^;]+;?", "ig"), "");
      } else {
        if (element.style.removeProperty) {
          element.style.removeProperty(name);
        } else {
          element.style.removeAttribute(utils.cssStyleToDomStyle(name));
        }
      }if (!element.style.cssText) {
        domUtils.removeAttributes(element, ["style"]);
      }
    }, getStyle: function getStyle(element, name) {
      var value = element.style[utils.cssStyleToDomStyle(name)];return utils.fixColor(name, value);
    }, setStyle: function setStyle(element, name, value) {
      element.style[utils.cssStyleToDomStyle(name)] = value;if (!utils.trim(element.style.cssText)) {
        this.removeAttributes(element, "style");
      }
    }, setStyles: function setStyles(element, styles) {
      for (var name in styles) {
        if (styles.hasOwnProperty(name)) {
          domUtils.setStyle(element, name, styles[name]);
        }
      }
    }, removeDirtyAttr: function removeDirtyAttr(node) {
      for (var i = 0, ci, nodes = node.getElementsByTagName("*"); ci = nodes[i++];) {
        ci.removeAttribute("_moz_dirty");
      }node.removeAttribute("_moz_dirty");
    }, getChildCount: function getChildCount(node, fn) {
      var count = 0,
          first = node.firstChild;fn = fn || function () {
        return 1;
      };while (first) {
        if (fn(first)) {
          count++;
        }first = first.nextSibling;
      }return count;
    }, isEmptyNode: function isEmptyNode(node) {
      return !node.firstChild || domUtils.getChildCount(node, function (node) {
        return !domUtils.isBr(node) && !domUtils.isBookmarkNode(node) && !domUtils.isWhitespace(node);
      }) == 0;
    }, clearSelectedArr: function clearSelectedArr(nodes) {
      var node;while (node = nodes.pop()) {
        domUtils.removeAttributes(node, ["class"]);
      }
    }, scrollToView: function scrollToView(node, win, offsetTop) {
      var getViewPaneSize = function getViewPaneSize() {
        var doc = win.document,
            mode = doc.compatMode == "CSS1Compat";return { width: (mode ? doc.documentElement.clientWidth : doc.body.clientWidth) || 0, height: (mode ? doc.documentElement.clientHeight : doc.body.clientHeight) || 0 };
      },
          getScrollPosition = function getScrollPosition(win) {
        if ("pageXOffset" in win) {
          return { x: win.pageXOffset || 0, y: win.pageYOffset || 0 };
        } else {
          var doc = win.document;return { x: doc.documentElement.scrollLeft || doc.body.scrollLeft || 0, y: doc.documentElement.scrollTop || doc.body.scrollTop || 0 };
        }
      };var winHeight = getViewPaneSize().height,
          offset = winHeight * -1 + offsetTop;offset += node.offsetHeight || 0;var elementPosition = domUtils.getXY(node);offset += elementPosition.y;var currentScroll = getScrollPosition(win).y;if (offset > currentScroll || offset < currentScroll - winHeight) {
        win.scrollTo(0, offset + (offset < 0 ? -20 : 20));
      }
    }, isBr: function isBr(node) {
      return node.nodeType == 1 && node.tagName == "BR";
    }, isFillChar: function isFillChar(node, isInStart) {
      if (node.nodeType != 3) {
        return false;
      }var text = node.nodeValue;if (isInStart) {
        return new RegExp("^" + domUtils.fillChar).test(text);
      }return !text.replace(new RegExp(domUtils.fillChar, "g"), "").length;
    }, isStartInblock: function isStartInblock(range) {
      var tmpRange = range.cloneRange(),
          flag = 0,
          start = tmpRange.startContainer,
          tmp;if (start.nodeType == 1 && start.childNodes[tmpRange.startOffset]) {
        start = start.childNodes[tmpRange.startOffset];var pre = start.previousSibling;while (pre && domUtils.isFillChar(pre)) {
          start = pre;pre = pre.previousSibling;
        }
      }if (this.isFillChar(start, true) && tmpRange.startOffset == 1) {
        tmpRange.setStartBefore(start);start = tmpRange.startContainer;
      }while (start && domUtils.isFillChar(start)) {
        tmp = start;start = start.previousSibling;
      }if (tmp) {
        tmpRange.setStartBefore(tmp);start = tmpRange.startContainer;
      }if (start.nodeType == 1 && domUtils.isEmptyNode(start) && tmpRange.startOffset == 1) {
        tmpRange.setStart(start, 0).collapse(true);
      }while (!tmpRange.startOffset) {
        start = tmpRange.startContainer;if (domUtils.isBlockElm(start) || domUtils.isBody(start)) {
          flag = 1;break;
        }var pre = tmpRange.startContainer.previousSibling,
            tmpNode;if (!pre) {
          tmpRange.setStartBefore(tmpRange.startContainer);
        } else {
          while (pre && domUtils.isFillChar(pre)) {
            tmpNode = pre;pre = pre.previousSibling;
          }if (tmpNode) {
            tmpRange.setStartBefore(tmpNode);
          } else {
            tmpRange.setStartBefore(tmpRange.startContainer);
          }
        }
      }return flag && !domUtils.isBody(tmpRange.startContainer) ? 1 : 0;
    }, isEmptyBlock: function isEmptyBlock(node, reg) {
      if (node.nodeType != 1) {
        return 0;
      }reg = reg || new RegExp("[ \xa0\t\r\n" + domUtils.fillChar + "]", "g");if (node[browser.ie ? "innerText" : "textContent"].replace(reg, "").length > 0) {
        return 0;
      }for (var n in dtd.$isNotEmpty) {
        if (node.getElementsByTagName(n).length) {
          return 0;
        }
      }return 1;
    }, setViewportOffset: function setViewportOffset(element, offset) {
      var left = parseInt(element.style.left) | 0;var top = parseInt(element.style.top) | 0;var rect = element.getBoundingClientRect();var offsetLeft = offset.left - rect.left;var offsetTop = offset.top - rect.top;if (offsetLeft) {
        element.style.left = left + offsetLeft + "px";
      }if (offsetTop) {
        element.style.top = top + offsetTop + "px";
      }
    }, fillNode: function fillNode(doc, node) {
      var tmpNode = browser.ie ? doc.createTextNode(domUtils.fillChar) : doc.createElement("br");node.innerHTML = "";node.appendChild(tmpNode);
    }, moveChild: function moveChild(src, tag, dir) {
      while (src.firstChild) {
        if (dir && tag.firstChild) {
          tag.insertBefore(src.lastChild, tag.firstChild);
        } else {
          tag.appendChild(src.firstChild);
        }
      }
    }, hasNoAttributes: function hasNoAttributes(node) {
      return browser.ie ? /^<\w+\s*?>/.test(node.outerHTML) : node.attributes.length == 0;
    }, isCustomeNode: function isCustomeNode(node) {
      return node.nodeType == 1 && node.getAttribute("_ue_custom_node_");
    }, isTagNode: function isTagNode(node, tagNames) {
      return node.nodeType == 1 && new RegExp("\\b" + node.tagName + "\\b", "i").test(tagNames);
    }, filterNodeList: function filterNodeList(nodelist, filter, forAll) {
      var results = [];if (!utils.isFunction(filter)) {
        var str = filter;filter = function filter(n) {
          return utils.indexOf(utils.isArray(str) ? str : str.split(" "), n.tagName.toLowerCase()) != -1;
        };
      }utils.each(nodelist, function (n) {
        filter(n) && results.push(n);
      });return results.length == 0 ? null : results.length == 1 || !forAll ? results[0] : results;
    }, isInNodeEndBoundary: function isInNodeEndBoundary(rng, node) {
      var start = rng.startContainer;if (start.nodeType == 3 && rng.startOffset != start.nodeValue.length) {
        return 0;
      }if (start.nodeType == 1 && rng.startOffset != start.childNodes.length) {
        return 0;
      }while (start !== node) {
        if (start.nextSibling) {
          return 0;
        }start = start.parentNode;
      }return 1;
    }, isBoundaryNode: function isBoundaryNode(node, dir) {
      var tmp;while (!domUtils.isBody(node)) {
        tmp = node;node = node.parentNode;if (tmp !== node[dir]) {
          return false;
        }
      }return true;
    }, fillHtml: browser.ie11below ? "&nbsp;" : "<br/>" };var fillCharReg = new RegExp(domUtils.fillChar, "g");(function () {
    var guid = 0,
        fillChar = domUtils.fillChar,
        fillData;function updateCollapse(range) {
      range.collapsed = range.startContainer && range.endContainer && range.startContainer === range.endContainer && range.startOffset == range.endOffset;
    }function selectOneNode(rng) {
      return !rng.collapsed && rng.startContainer.nodeType == 1 && rng.startContainer === rng.endContainer && rng.endOffset - rng.startOffset == 1;
    }function setEndPoint(toStart, node, offset, range) {
      if (node.nodeType == 1 && (dtd.$empty[node.tagName] || dtd.$nonChild[node.tagName])) {
        offset = domUtils.getNodeIndex(node) + (toStart ? 0 : 1);node = node.parentNode;
      }if (toStart) {
        range.startContainer = node;range.startOffset = offset;if (!range.endContainer) {
          range.collapse(true);
        }
      } else {
        range.endContainer = node;range.endOffset = offset;if (!range.startContainer) {
          range.collapse(false);
        }
      }updateCollapse(range);return range;
    }function execContentsAction(range, action) {
      var start = range.startContainer,
          end = range.endContainer,
          startOffset = range.startOffset,
          endOffset = range.endOffset,
          doc = range.document,
          frag = doc.createDocumentFragment(),
          tmpStart,
          tmpEnd;if (start.nodeType == 1) {
        start = start.childNodes[startOffset] || (tmpStart = start.appendChild(doc.createTextNode("")));
      }if (end.nodeType == 1) {
        end = end.childNodes[endOffset] || (tmpEnd = end.appendChild(doc.createTextNode("")));
      }if (start === end && start.nodeType == 3) {
        frag.appendChild(doc.createTextNode(start.substringData(startOffset, endOffset - startOffset)));if (action) {
          start.deleteData(startOffset, endOffset - startOffset);range.collapse(true);
        }return frag;
      }var current,
          currentLevel,
          clone = frag,
          startParents = domUtils.findParents(start, true),
          endParents = domUtils.findParents(end, true);for (var i = 0; startParents[i] == endParents[i];) {
        i++;
      }for (var j = i, si; si = startParents[j]; j++) {
        current = si.nextSibling;if (si == start) {
          if (!tmpStart) {
            if (range.startContainer.nodeType == 3) {
              clone.appendChild(doc.createTextNode(start.nodeValue.slice(startOffset)));if (action) {
                start.deleteData(startOffset, start.nodeValue.length - startOffset);
              }
            } else {
              clone.appendChild(!action ? start.cloneNode(true) : start);
            }
          }
        } else {
          currentLevel = si.cloneNode(false);clone.appendChild(currentLevel);
        }while (current) {
          if (current === end || current === endParents[j]) {
            break;
          }si = current.nextSibling;clone.appendChild(!action ? current.cloneNode(true) : current);current = si;
        }clone = currentLevel;
      }clone = frag;if (!startParents[i]) {
        clone.appendChild(startParents[i - 1].cloneNode(false));clone = clone.firstChild;
      }for (var j = i, ei; ei = endParents[j]; j++) {
        current = ei.previousSibling;if (ei == end) {
          if (!tmpEnd && range.endContainer.nodeType == 3) {
            clone.appendChild(doc.createTextNode(end.substringData(0, endOffset)));if (action) {
              end.deleteData(0, endOffset);
            }
          }
        } else {
          currentLevel = ei.cloneNode(false);clone.appendChild(currentLevel);
        }if (j != i || !startParents[i]) {
          while (current) {
            if (current === start) {
              break;
            }ei = current.previousSibling;clone.insertBefore(!action ? current.cloneNode(true) : current, clone.firstChild);current = ei;
          }
        }clone = currentLevel;
      }if (action) {
        range.setStartBefore(!endParents[i] ? endParents[i - 1] : !startParents[i] ? startParents[i - 1] : endParents[i]).collapse(true);
      }tmpStart && domUtils.remove(tmpStart);tmpEnd && domUtils.remove(tmpEnd);return frag;
    }var Range = dom.Range = function (document) {
      var me = this;me.startContainer = me.startOffset = me.endContainer = me.endOffset = null;me.document = document;me.collapsed = true;
    };function removeFillData(doc, excludeNode) {
      try {
        if (fillData && domUtils.inDoc(fillData, doc)) {
          if (!fillData.nodeValue.replace(fillCharReg, "").length) {
            var tmpNode = fillData.parentNode;domUtils.remove(fillData);while (tmpNode && domUtils.isEmptyInlineElement(tmpNode) && (browser.safari ? !(domUtils.getPosition(tmpNode, excludeNode) & domUtils.POSITION_CONTAINS) : !tmpNode.contains(excludeNode))) {
              fillData = tmpNode.parentNode;domUtils.remove(tmpNode);tmpNode = fillData;
            }
          } else {
            fillData.nodeValue = fillData.nodeValue.replace(fillCharReg, "");
          }
        }
      } catch (e) {}
    }function mergeSibling(node, dir) {
      var tmpNode;node = node[dir];while (node && domUtils.isFillChar(node)) {
        tmpNode = node[dir];domUtils.remove(node);node = tmpNode;
      }
    }Range.prototype = { cloneContents: function cloneContents() {
        return this.collapsed ? null : execContentsAction(this, 0);
      }, deleteContents: function deleteContents() {
        var txt;if (!this.collapsed) {
          execContentsAction(this, 1);
        }if (browser.webkit) {
          txt = this.startContainer;if (txt.nodeType == 3 && !txt.nodeValue.length) {
            this.setStartBefore(txt).collapse(true);domUtils.remove(txt);
          }
        }return this;
      }, extractContents: function extractContents() {
        return this.collapsed ? null : execContentsAction(this, 2);
      }, setStart: function setStart(node, offset) {
        return setEndPoint(true, node, offset, this);
      }, setEnd: function setEnd(node, offset) {
        return setEndPoint(false, node, offset, this);
      }, setStartAfter: function setStartAfter(node) {
        return this.setStart(node.parentNode, domUtils.getNodeIndex(node) + 1);
      }, setStartBefore: function setStartBefore(node) {
        return this.setStart(node.parentNode, domUtils.getNodeIndex(node));
      }, setEndAfter: function setEndAfter(node) {
        return this.setEnd(node.parentNode, domUtils.getNodeIndex(node) + 1);
      }, setEndBefore: function setEndBefore(node) {
        return this.setEnd(node.parentNode, domUtils.getNodeIndex(node));
      }, setStartAtFirst: function setStartAtFirst(node) {
        return this.setStart(node, 0);
      }, setStartAtLast: function setStartAtLast(node) {
        return this.setStart(node, node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length);
      }, setEndAtFirst: function setEndAtFirst(node) {
        return this.setEnd(node, 0);
      }, setEndAtLast: function setEndAtLast(node) {
        return this.setEnd(node, node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length);
      }, selectNode: function selectNode(node) {
        return this.setStartBefore(node).setEndAfter(node);
      }, selectNodeContents: function selectNodeContents(node) {
        return this.setStart(node, 0).setEndAtLast(node);
      }, cloneRange: function cloneRange() {
        var me = this;return new Range(me.document).setStart(me.startContainer, me.startOffset).setEnd(me.endContainer, me.endOffset);
      }, collapse: function collapse(toStart) {
        var me = this;if (toStart) {
          me.endContainer = me.startContainer;me.endOffset = me.startOffset;
        } else {
          me.startContainer = me.endContainer;me.startOffset = me.endOffset;
        }me.collapsed = true;return me;
      }, shrinkBoundary: function shrinkBoundary(ignoreEnd) {
        var me = this,
            child,
            collapsed = me.collapsed;function check(node) {
          return node.nodeType == 1 && !domUtils.isBookmarkNode(node) && !dtd.$empty[node.tagName] && !dtd.$nonChild[node.tagName];
        }while (me.startContainer.nodeType == 1 && (child = me.startContainer.childNodes[me.startOffset]) && check(child)) {
          me.setStart(child, 0);
        }if (collapsed) {
          return me.collapse(true);
        }if (!ignoreEnd) {
          while (me.endContainer.nodeType == 1 && me.endOffset > 0 && (child = me.endContainer.childNodes[me.endOffset - 1]) && check(child)) {
            me.setEnd(child, child.childNodes.length);
          }
        }return me;
      }, getCommonAncestor: function getCommonAncestor(includeSelf, ignoreTextNode) {
        var me = this,
            start = me.startContainer,
            end = me.endContainer;if (start === end) {
          if (includeSelf && selectOneNode(this)) {
            start = start.childNodes[me.startOffset];if (start.nodeType == 1) {
              return start;
            }
          }return ignoreTextNode && start.nodeType == 3 ? start.parentNode : start;
        }return domUtils.getCommonAncestor(start, end);
      }, trimBoundary: function trimBoundary(ignoreEnd) {
        this.txtToElmBoundary();var start = this.startContainer,
            offset = this.startOffset,
            collapsed = this.collapsed,
            end = this.endContainer;if (start.nodeType == 3) {
          if (offset == 0) {
            this.setStartBefore(start);
          } else {
            if (offset >= start.nodeValue.length) {
              this.setStartAfter(start);
            } else {
              var textNode = domUtils.split(start, offset);if (start === end) {
                this.setEnd(textNode, this.endOffset - offset);
              } else {
                if (start.parentNode === end) {
                  this.endOffset += 1;
                }
              }this.setStartBefore(textNode);
            }
          }if (collapsed) {
            return this.collapse(true);
          }
        }if (!ignoreEnd) {
          offset = this.endOffset;end = this.endContainer;if (end.nodeType == 3) {
            if (offset == 0) {
              this.setEndBefore(end);
            } else {
              offset < end.nodeValue.length && domUtils.split(end, offset);this.setEndAfter(end);
            }
          }
        }return this;
      }, txtToElmBoundary: function txtToElmBoundary(ignoreCollapsed) {
        function adjust(r, c) {
          var container = r[c + "Container"],
              offset = r[c + "Offset"];if (container.nodeType == 3) {
            if (!offset) {
              r["set" + c.replace(/(\w)/, function (a) {
                return a.toUpperCase();
              }) + "Before"](container);
            } else {
              if (offset >= container.nodeValue.length) {
                r["set" + c.replace(/(\w)/, function (a) {
                  return a.toUpperCase();
                }) + "After"](container);
              }
            }
          }
        }if (ignoreCollapsed || !this.collapsed) {
          adjust(this, "start");adjust(this, "end");
        }return this;
      }, insertNode: function insertNode(node) {
        var first = node,
            length = 1;if (node.nodeType == 11) {
          first = node.firstChild;length = node.childNodes.length;
        }this.trimBoundary(true);var start = this.startContainer,
            offset = this.startOffset;var nextNode = start.childNodes[offset];if (nextNode) {
          start.insertBefore(node, nextNode);
        } else {
          start.appendChild(node);
        }if (first.parentNode === this.endContainer) {
          this.endOffset = this.endOffset + length;
        }return this.setStartBefore(first);
      }, setCursor: function setCursor(toEnd, noFillData) {
        return this.collapse(!toEnd).select(noFillData);
      }, createBookmark: function createBookmark(serialize, same) {
        var endNode,
            startNode = this.document.createElement("span");startNode.style.cssText = "display:none;line-height:0px;";startNode.appendChild(this.document.createTextNode("\u200D"));startNode.id = "_baidu_bookmark_start_" + (same ? "" : guid++);if (!this.collapsed) {
          endNode = startNode.cloneNode(true);endNode.id = "_baidu_bookmark_end_" + (same ? "" : guid++);
        }this.insertNode(startNode);if (endNode) {
          this.collapse().insertNode(endNode).setEndBefore(endNode);
        }this.setStartAfter(startNode);return { start: serialize ? startNode.id : startNode, end: endNode ? serialize ? endNode.id : endNode : null, id: serialize };
      }, moveToBookmark: function moveToBookmark(bookmark) {
        var start = bookmark.id ? this.document.getElementById(bookmark.start) : bookmark.start,
            end = bookmark.end && bookmark.id ? this.document.getElementById(bookmark.end) : bookmark.end;this.setStartBefore(start);domUtils.remove(start);if (end) {
          this.setEndBefore(end);domUtils.remove(end);
        } else {
          this.collapse(true);
        }return this;
      }, enlarge: function enlarge(toBlock, stopFn) {
        var isBody = domUtils.isBody,
            pre,
            node,
            tmp = this.document.createTextNode("");if (toBlock) {
          node = this.startContainer;if (node.nodeType == 1) {
            if (node.childNodes[this.startOffset]) {
              pre = node = node.childNodes[this.startOffset];
            } else {
              node.appendChild(tmp);pre = node = tmp;
            }
          } else {
            pre = node;
          }while (1) {
            if (domUtils.isBlockElm(node)) {
              node = pre;while ((pre = node.previousSibling) && !domUtils.isBlockElm(pre)) {
                node = pre;
              }this.setStartBefore(node);break;
            }pre = node;node = node.parentNode;
          }node = this.endContainer;if (node.nodeType == 1) {
            if (pre = node.childNodes[this.endOffset]) {
              node.insertBefore(tmp, pre);
            } else {
              node.appendChild(tmp);
            }pre = node = tmp;
          } else {
            pre = node;
          }while (1) {
            if (domUtils.isBlockElm(node)) {
              node = pre;while ((pre = node.nextSibling) && !domUtils.isBlockElm(pre)) {
                node = pre;
              }this.setEndAfter(node);break;
            }pre = node;node = node.parentNode;
          }if (tmp.parentNode === this.endContainer) {
            this.endOffset--;
          }domUtils.remove(tmp);
        }if (!this.collapsed) {
          while (this.startOffset == 0) {
            if (stopFn && stopFn(this.startContainer)) {
              break;
            }if (isBody(this.startContainer)) {
              break;
            }this.setStartBefore(this.startContainer);
          }while (this.endOffset == (this.endContainer.nodeType == 1 ? this.endContainer.childNodes.length : this.endContainer.nodeValue.length)) {
            if (stopFn && stopFn(this.endContainer)) {
              break;
            }if (isBody(this.endContainer)) {
              break;
            }this.setEndAfter(this.endContainer);
          }
        }return this;
      }, enlargeToBlockElm: function enlargeToBlockElm(ignoreEnd) {
        while (!domUtils.isBlockElm(this.startContainer)) {
          this.setStartBefore(this.startContainer);
        }if (!ignoreEnd) {
          while (!domUtils.isBlockElm(this.endContainer)) {
            this.setEndAfter(this.endContainer);
          }
        }return this;
      }, adjustmentBoundary: function adjustmentBoundary() {
        if (!this.collapsed) {
          while (!domUtils.isBody(this.startContainer) && this.startOffset == this.startContainer[this.startContainer.nodeType == 3 ? "nodeValue" : "childNodes"].length && this.startContainer[this.startContainer.nodeType == 3 ? "nodeValue" : "childNodes"].length) {
            this.setStartAfter(this.startContainer);
          }while (!domUtils.isBody(this.endContainer) && !this.endOffset && this.endContainer[this.endContainer.nodeType == 3 ? "nodeValue" : "childNodes"].length) {
            this.setEndBefore(this.endContainer);
          }
        }return this;
      }, applyInlineStyle: function applyInlineStyle(tagName, attrs, list) {
        if (this.collapsed) {
          return this;
        }this.trimBoundary().enlarge(false, function (node) {
          return node.nodeType == 1 && domUtils.isBlockElm(node);
        }).adjustmentBoundary();var bookmark = this.createBookmark(),
            end = bookmark.end,
            filterFn = function filterFn(node) {
          return node.nodeType == 1 ? node.tagName.toLowerCase() != "br" : !domUtils.isWhitespace(node);
        },
            current = domUtils.getNextDomNode(bookmark.start, false, filterFn),
            node,
            pre,
            range = this.cloneRange();while (current && domUtils.getPosition(current, end) & domUtils.POSITION_PRECEDING) {
          if (current.nodeType == 3 || dtd[tagName][current.tagName]) {
            range.setStartBefore(current);node = current;while (node && (node.nodeType == 3 || dtd[tagName][node.tagName]) && node !== end) {
              pre = node;node = domUtils.getNextDomNode(node, node.nodeType == 1, null, function (parent) {
                return dtd[tagName][parent.tagName];
              });
            }var frag = range.setEndAfter(pre).extractContents(),
                elm;if (list && list.length > 0) {
              var level, top;top = level = list[0].cloneNode(false);for (var i = 1, ci; ci = list[i++];) {
                level.appendChild(ci.cloneNode(false));level = level.firstChild;
              }elm = level;
            } else {
              elm = range.document.createElement(tagName);
            }if (attrs) {
              domUtils.setAttributes(elm, attrs);
            }elm.appendChild(frag);range.insertNode(list ? top : elm);var aNode;if (tagName == "span" && attrs.style && /text\-decoration/.test(attrs.style) && (aNode = domUtils.findParentByTagName(elm, "a", true))) {
              domUtils.setAttributes(aNode, attrs);domUtils.remove(elm, true);elm = aNode;
            } else {
              domUtils.mergeSibling(elm);domUtils.clearEmptySibling(elm);
            }domUtils.mergeChild(elm, attrs);current = domUtils.getNextDomNode(elm, false, filterFn);domUtils.mergeToParent(elm);if (node === end) {
              break;
            }
          } else {
            current = domUtils.getNextDomNode(current, true, filterFn);
          }
        }return this.moveToBookmark(bookmark);
      }, removeInlineStyle: function removeInlineStyle(tagNames) {
        if (this.collapsed) {
          return this;
        }tagNames = utils.isArray(tagNames) ? tagNames : [tagNames];this.shrinkBoundary().adjustmentBoundary();var start = this.startContainer,
            end = this.endContainer;while (1) {
          if (start.nodeType == 1) {
            if (utils.indexOf(tagNames, start.tagName.toLowerCase()) > -1) {
              break;
            }if (start.tagName.toLowerCase() == "body") {
              start = null;break;
            }
          }start = start.parentNode;
        }while (1) {
          if (end.nodeType == 1) {
            if (utils.indexOf(tagNames, end.tagName.toLowerCase()) > -1) {
              break;
            }if (end.tagName.toLowerCase() == "body") {
              end = null;break;
            }
          }end = end.parentNode;
        }var bookmark = this.createBookmark(),
            frag,
            tmpRange;if (start) {
          tmpRange = this.cloneRange().setEndBefore(bookmark.start).setStartBefore(start);frag = tmpRange.extractContents();tmpRange.insertNode(frag);domUtils.clearEmptySibling(start, true);start.parentNode.insertBefore(bookmark.start, start);
        }if (end) {
          tmpRange = this.cloneRange().setStartAfter(bookmark.end).setEndAfter(end);frag = tmpRange.extractContents();tmpRange.insertNode(frag);domUtils.clearEmptySibling(end, false, true);end.parentNode.insertBefore(bookmark.end, end.nextSibling);
        }var current = domUtils.getNextDomNode(bookmark.start, false, function (node) {
          return node.nodeType == 1;
        }),
            next;while (current && current !== bookmark.end) {
          next = domUtils.getNextDomNode(current, true, function (node) {
            return node.nodeType == 1;
          });if (utils.indexOf(tagNames, current.tagName.toLowerCase()) > -1) {
            domUtils.remove(current, true);
          }current = next;
        }return this.moveToBookmark(bookmark);
      }, getClosedNode: function getClosedNode() {
        var node;if (!this.collapsed) {
          var range = this.cloneRange().adjustmentBoundary().shrinkBoundary();if (selectOneNode(range)) {
            var child = range.startContainer.childNodes[range.startOffset];if (child && child.nodeType == 1 && (dtd.$empty[child.tagName] || dtd.$nonChild[child.tagName])) {
              node = child;
            }
          }
        }return node;
      }, select: browser.ie ? function (noFillData, textRange) {
        var nativeRange;if (!this.collapsed) {
          this.shrinkBoundary();
        }var node = this.getClosedNode();if (node && !textRange) {
          try {
            nativeRange = this.document.body.createControlRange();nativeRange.addElement(node);nativeRange.select();
          } catch (e) {}return this;
        }var bookmark = this.createBookmark(),
            start = bookmark.start,
            end;nativeRange = this.document.body.createTextRange();nativeRange.moveToElementText(start);nativeRange.moveStart("character", 1);if (!this.collapsed) {
          var nativeRangeEnd = this.document.body.createTextRange();end = bookmark.end;nativeRangeEnd.moveToElementText(end);nativeRange.setEndPoint("EndToEnd", nativeRangeEnd);
        } else {
          if (!noFillData && this.startContainer.nodeType != 3) {
            var tmpText = this.document.createTextNode(fillChar),
                tmp = this.document.createElement("span");tmp.appendChild(this.document.createTextNode(fillChar));start.parentNode.insertBefore(tmp, start);start.parentNode.insertBefore(tmpText, start);removeFillData(this.document, tmpText);fillData = tmpText;mergeSibling(tmp, "previousSibling");mergeSibling(start, "nextSibling");nativeRange.moveStart("character", -1);nativeRange.collapse(true);
          }
        }this.moveToBookmark(bookmark);tmp && domUtils.remove(tmp);try {
          nativeRange.select();
        } catch (e) {}return this;
      } : function (notInsertFillData) {
        function checkOffset(rng) {
          function check(node, offset, dir) {
            if (node.nodeType == 3 && node.nodeValue.length < offset) {
              rng[dir + "Offset"] = node.nodeValue.length;
            }
          }check(rng.startContainer, rng.startOffset, "start");check(rng.endContainer, rng.endOffset, "end");
        }var win = domUtils.getWindow(this.document),
            sel = win.getSelection(),
            txtNode;browser.gecko ? this.document.body.focus() : win.focus();if (sel) {
          sel.removeAllRanges();if (this.collapsed && !notInsertFillData) {
            var start = this.startContainer,
                child = start;if (start.nodeType == 1) {
              child = start.childNodes[this.startOffset];
            }if (!(start.nodeType == 3 && this.startOffset) && (child ? !child.previousSibling || child.previousSibling.nodeType != 3 : !start.lastChild || start.lastChild.nodeType != 3)) {
              txtNode = this.document.createTextNode(fillChar);this.insertNode(txtNode);removeFillData(this.document, txtNode);mergeSibling(txtNode, "previousSibling");mergeSibling(txtNode, "nextSibling");fillData = txtNode;this.setStart(txtNode, browser.webkit ? 1 : 0).collapse(true);
            }
          }var nativeRange = this.document.createRange();if (this.collapsed && browser.opera && this.startContainer.nodeType == 1) {
            var child = this.startContainer.childNodes[this.startOffset];if (!child) {
              child = this.startContainer.lastChild;if (child && domUtils.isBr(child)) {
                this.setStartBefore(child).collapse(true);
              }
            } else {
              while (child && domUtils.isBlockElm(child)) {
                if (child.nodeType == 1 && child.childNodes[0]) {
                  child = child.childNodes[0];
                } else {
                  break;
                }
              }child && this.setStartBefore(child).collapse(true);
            }
          }checkOffset(this);nativeRange.setStart(this.startContainer, this.startOffset);nativeRange.setEnd(this.endContainer, this.endOffset);sel.addRange(nativeRange);
        }return this;
      }, scrollToView: function scrollToView(win, offset) {
        win = win ? window : domUtils.getWindow(this.document);var me = this,
            span = me.document.createElement("span");span.innerHTML = "&nbsp;";me.cloneRange().insertNode(span);domUtils.scrollToView(span, win, offset);domUtils.remove(span);return me;
      }, inFillChar: function inFillChar() {
        var start = this.startContainer;if (this.collapsed && start.nodeType == 3 && start.nodeValue.replace(new RegExp("^" + domUtils.fillChar), "").length + 1 == start.nodeValue.length) {
          return true;
        }return false;
      }, createAddress: function createAddress(ignoreEnd, ignoreTxt) {
        var addr = {},
            me = this;function getAddress(isStart) {
          var node = isStart ? me.startContainer : me.endContainer;var parents = domUtils.findParents(node, true, function (node) {
            return !domUtils.isBody(node);
          }),
              addrs = [];for (var i = 0, ci; ci = parents[i++];) {
            addrs.push(domUtils.getNodeIndex(ci, ignoreTxt));
          }var firstIndex = 0;if (ignoreTxt) {
            if (node.nodeType == 3) {
              var tmpNode = node.previousSibling;while (tmpNode && tmpNode.nodeType == 3) {
                firstIndex += tmpNode.nodeValue.replace(fillCharReg, "").length;tmpNode = tmpNode.previousSibling;
              }firstIndex += isStart ? me.startOffset : me.endOffset;
            } else {
              node = node.childNodes[isStart ? me.startOffset : me.endOffset];if (node) {
                firstIndex = domUtils.getNodeIndex(node, ignoreTxt);
              } else {
                node = isStart ? me.startContainer : me.endContainer;var first = node.firstChild;while (first) {
                  if (domUtils.isFillChar(first)) {
                    first = first.nextSibling;continue;
                  }firstIndex++;if (first.nodeType == 3) {
                    while (first && first.nodeType == 3) {
                      first = first.nextSibling;
                    }
                  } else {
                    first = first.nextSibling;
                  }
                }
              }
            }
          } else {
            firstIndex = isStart ? domUtils.isFillChar(node) ? 0 : me.startOffset : me.endOffset;
          }if (firstIndex < 0) {
            firstIndex = 0;
          }addrs.push(firstIndex);return addrs;
        }addr.startAddress = getAddress(true);if (!ignoreEnd) {
          addr.endAddress = me.collapsed ? [].concat(addr.startAddress) : getAddress();
        }return addr;
      }, moveToAddress: function moveToAddress(addr, ignoreEnd) {
        var me = this;function getNode(address, isStart) {
          var tmpNode = me.document.body,
              parentNode,
              offset;for (var i = 0, ci, l = address.length; i < l; i++) {
            ci = address[i];parentNode = tmpNode;tmpNode = tmpNode.childNodes[ci];if (!tmpNode) {
              offset = ci;break;
            }
          }if (isStart) {
            if (tmpNode) {
              me.setStartBefore(tmpNode);
            } else {
              me.setStart(parentNode, offset);
            }
          } else {
            if (tmpNode) {
              me.setEndBefore(tmpNode);
            } else {
              me.setEnd(parentNode, offset);
            }
          }
        }getNode(addr.startAddress, true);!ignoreEnd && addr.endAddress && getNode(addr.endAddress);return me;
      }, equals: function equals(rng) {
        for (var p in this) {
          if (this.hasOwnProperty(p)) {
            if (this[p] !== rng[p]) {
              return false;
            }
          }
        }return true;
      }, traversal: function traversal(doFn, filterFn) {
        if (this.collapsed) {
          return this;
        }var bookmark = this.createBookmark(),
            end = bookmark.end,
            current = domUtils.getNextDomNode(bookmark.start, false, filterFn);while (current && current !== end && domUtils.getPosition(current, end) & domUtils.POSITION_PRECEDING) {
          var tmpNode = domUtils.getNextDomNode(current, false, filterFn);doFn(current);current = tmpNode;
        }return this.moveToBookmark(bookmark);
      } };
  })();(function () {
    function getBoundaryInformation(range, start) {
      var getIndex = domUtils.getNodeIndex;range = range.duplicate();range.collapse(start);var parent = range.parentElement();if (!parent.hasChildNodes()) {
        return { container: parent, offset: 0 };
      }var siblings = parent.children,
          child,
          testRange = range.duplicate(),
          startIndex = 0,
          endIndex = siblings.length - 1,
          index = -1,
          distance;while (startIndex <= endIndex) {
        index = Math.floor((startIndex + endIndex) / 2);child = siblings[index];testRange.moveToElementText(child);var position = testRange.compareEndPoints("StartToStart", range);if (position > 0) {
          endIndex = index - 1;
        } else {
          if (position < 0) {
            startIndex = index + 1;
          } else {
            return { container: parent, offset: getIndex(child) };
          }
        }
      }if (index == -1) {
        testRange.moveToElementText(parent);testRange.setEndPoint("StartToStart", range);distance = testRange.text.replace(/(\r\n|\r)/g, "\n").length;siblings = parent.childNodes;if (!distance) {
          child = siblings[siblings.length - 1];return { container: child, offset: child.nodeValue.length };
        }var i = siblings.length;while (distance > 0) {
          distance -= siblings[--i].nodeValue.length;
        }return { container: siblings[i], offset: -distance };
      }testRange.collapse(position > 0);testRange.setEndPoint(position > 0 ? "StartToStart" : "EndToStart", range);distance = testRange.text.replace(/(\r\n|\r)/g, "\n").length;if (!distance) {
        return dtd.$empty[child.tagName] || dtd.$nonChild[child.tagName] ? { container: parent, offset: getIndex(child) + (position > 0 ? 0 : 1) } : { container: child, offset: position > 0 ? 0 : child.childNodes.length };
      }while (distance > 0) {
        try {
          var pre = child;child = child[position > 0 ? "previousSibling" : "nextSibling"];distance -= child.nodeValue.length;
        } catch (e) {
          return { container: parent, offset: getIndex(pre) };
        }
      }return { container: child, offset: position > 0 ? -distance : child.nodeValue.length + distance };
    }function transformIERangeToRange(ieRange, range) {
      if (ieRange.item) {
        range.selectNode(ieRange.item(0));
      } else {
        var bi = getBoundaryInformation(ieRange, true);range.setStart(bi.container, bi.offset);if (ieRange.compareEndPoints("StartToEnd", ieRange) != 0) {
          bi = getBoundaryInformation(ieRange, false);range.setEnd(bi.container, bi.offset);
        }
      }return range;
    }function _getIERange(sel) {
      var ieRange;try {
        ieRange = sel.getNative().createRange();
      } catch (e) {
        return null;
      }var el = ieRange.item ? ieRange.item(0) : ieRange.parentElement();if ((el.ownerDocument || el) === sel.document) {
        return ieRange;
      }return null;
    }var Selection = dom.Selection = function (doc) {
      var me = this,
          iframe;me.document = doc;if (browser.ie9below) {
        iframe = domUtils.getWindow(doc).frameElement;domUtils.on(iframe, "beforedeactivate", function () {
          me._bakIERange = me.getIERange();
        });domUtils.on(iframe, "activate", function () {
          try {
            if (!_getIERange(me) && me._bakIERange) {
              me._bakIERange.select();
            }
          } catch (ex) {}me._bakIERange = null;
        });
      }iframe = doc = null;
    };Selection.prototype = { rangeInBody: function rangeInBody(rng, txtRange) {
        var node = browser.ie9below || txtRange ? rng.item ? rng.item() : rng.parentElement() : rng.startContainer;return node === this.document.body || domUtils.inDoc(node, this.document);
      }, getNative: function getNative() {
        var doc = this.document;try {
          return !doc ? null : browser.ie9below ? doc.selection : domUtils.getWindow(doc).getSelection();
        } catch (e) {
          return null;
        }
      }, getIERange: function getIERange() {
        var ieRange = _getIERange(this);if (!ieRange) {
          if (this._bakIERange) {
            return this._bakIERange;
          }
        }return ieRange;
      }, cache: function cache() {
        this.clear();this._cachedRange = this.getRange();this._cachedStartElement = this.getStart();this._cachedStartElementPath = this.getStartElementPath();
      }, getStartElementPath: function getStartElementPath() {
        if (this._cachedStartElementPath) {
          return this._cachedStartElementPath;
        }var start = this.getStart();if (start) {
          return domUtils.findParents(start, true, null, true);
        }return [];
      }, clear: function clear() {
        this._cachedStartElementPath = this._cachedRange = this._cachedStartElement = null;
      }, isFocus: function isFocus() {
        try {
          if (browser.ie9below) {
            var nativeRange = _getIERange(this);return !!(nativeRange && this.rangeInBody(nativeRange));
          } else {
            return !!this.getNative().rangeCount;
          }
        } catch (e) {
          return false;
        }
      }, getRange: function getRange() {
        var me = this;function optimze(range) {
          var child = me.document.body.firstChild,
              collapsed = range.collapsed;while (child && child.firstChild) {
            range.setStart(child, 0);child = child.firstChild;
          }if (!range.startContainer) {
            range.setStart(me.document.body, 0);
          }if (collapsed) {
            range.collapse(true);
          }
        }if (me._cachedRange != null) {
          return this._cachedRange;
        }var range = new baidu.editor.dom.Range(me.document);if (browser.ie9below) {
          var nativeRange = me.getIERange();if (nativeRange) {
            try {
              transformIERangeToRange(nativeRange, range);
            } catch (e) {
              optimze(range);
            }
          } else {
            optimze(range);
          }
        } else {
          var sel = me.getNative();if (sel && sel.rangeCount) {
            var firstRange = sel.getRangeAt(0);var lastRange = sel.getRangeAt(sel.rangeCount - 1);range.setStart(firstRange.startContainer, firstRange.startOffset).setEnd(lastRange.endContainer, lastRange.endOffset);if (range.collapsed && domUtils.isBody(range.startContainer) && !range.startOffset) {
              optimze(range);
            }
          } else {
            if (this._bakRange && domUtils.inDoc(this._bakRange.startContainer, this.document)) {
              return this._bakRange;
            }optimze(range);
          }
        }return this._bakRange = range;
      }, getStart: function getStart() {
        if (this._cachedStartElement) {
          return this._cachedStartElement;
        }var range = browser.ie9below ? this.getIERange() : this.getRange(),
            tmpRange,
            start,
            tmp,
            parent;if (browser.ie9below) {
          if (!range) {
            return this.document.body.firstChild;
          }if (range.item) {
            return range.item(0);
          }tmpRange = range.duplicate();tmpRange.text.length > 0 && tmpRange.moveStart("character", 1);tmpRange.collapse(1);start = tmpRange.parentElement();parent = tmp = range.parentElement();while (tmp = tmp.parentNode) {
            if (tmp == start) {
              start = parent;break;
            }
          }
        } else {
          range.shrinkBoundary();start = range.startContainer;if (start.nodeType == 1 && start.hasChildNodes()) {
            start = start.childNodes[Math.min(start.childNodes.length - 1, range.startOffset)];
          }if (start.nodeType == 3) {
            return start.parentNode;
          }
        }return start;
      }, getText: function getText() {
        var nativeSel, nativeRange;if (this.isFocus() && (nativeSel = this.getNative())) {
          nativeRange = browser.ie9below ? nativeSel.createRange() : nativeSel.getRangeAt(0);return browser.ie9below ? nativeRange.text : nativeRange.toString();
        }return "";
      }, clearRange: function clearRange() {
        this.getNative()[browser.ie9below ? "empty" : "removeAllRanges"]();
      } };
  })();(function () {
    var uid = 0,
        _selectionChangeTimer;function setValue(form, editor) {
      var textarea;if (editor.textarea) {
        if (utils.isString(editor.textarea)) {
          for (var i = 0, ti, tis = domUtils.getElementsByTagName(form, "textarea"); ti = tis[i++];) {
            if (ti.id == "ueditor_textarea_" + editor.options.textarea) {
              textarea = ti;break;
            }
          }
        } else {
          textarea = editor.textarea;
        }
      }if (!textarea) {
        form.appendChild(textarea = domUtils.createElement(document, "textarea", { "name": editor.options.textarea, "id": "ueditor_textarea_" + editor.options.textarea, "style": "display:none" }));editor.textarea = textarea;
      }!textarea.getAttribute("name") && textarea.setAttribute("name", editor.options.textarea);textarea.value = editor.hasContents() ? editor.options.allHtmlEnabled ? editor.getAllHtml() : editor.getContent(null, null, true) : "";
    }function loadPlugins(me) {
      for (var pi in UE.plugins) {
        UE.plugins[pi].call(me);
      }
    }function checkCurLang(I18N) {
      for (var lang in I18N) {
        return lang;
      }
    }function langReadied(me) {
      me.langIsReady = true;me.fireEvent("langReady");
    }var Editor = UE.Editor = function (options) {
      var me = this;me.uid = uid++;EventBase.call(me);me.commands = {};me.options = utils.extend(utils.clone(options || {}), UEDITOR_CONFIG, true);me.shortcutkeys = {};me.inputRules = [];me.outputRules = [];me.setOpt(Editor.defaultOptions(me));if (!utils.isEmptyObject(UE.I18N)) {
        me.options.lang = checkCurLang(UE.I18N);UE.plugin.load(me);langReadied(me);
      } else {
        UE.plugin.load(me);langReadied(me);
      }UE.instants["ueditorInstant" + me.uid] = me;
    };Editor.prototype = { registerCommand: function registerCommand(name, obj) {
        this.commands[name] = obj;
      }, ready: function ready(fn) {
        var me = this;if (fn) {
          me.isReady ? fn.apply(me) : me.addListener("ready", fn);
        }
      }, setOpt: function setOpt(key, val) {
        var obj = {};if (utils.isString(key)) {
          obj[key] = val;
        } else {
          obj = key;
        }utils.extend(this.options, obj, true);
      }, getOpt: function getOpt(key) {
        return this.options[key];
      }, destroy: function destroy() {
        var me = this;me.fireEvent("destroy");var container = me.container.parentNode;var textarea = me.textarea;if (!textarea) {
          textarea = document.createElement("textarea");container.parentNode.insertBefore(textarea, container);
        } else {
          textarea.style.display = "";
        }textarea.style.width = me.iframe.offsetWidth + "px";textarea.style.height = me.iframe.offsetHeight + "px";textarea.value = me.getContent();textarea.id = me.key;container.innerHTML = "";domUtils.remove(container);var key = me.key;for (var p in me) {
          if (me.hasOwnProperty(p)) {
            delete this[p];
          }
        }UE.delEditor(key);
      }, render: function render(container) {
        var me = this,
            options = me.options,
            getStyleValue = function getStyleValue(attr) {
          return parseInt(domUtils.getComputedStyle(container, attr));
        };if (utils.isString(container)) {
          container = document.getElementById(container);
        }if (container) {
          if (options.initialFrameWidth) {
            options.minFrameWidth = options.initialFrameWidth;
          } else {
            options.minFrameWidth = options.initialFrameWidth = container.offsetWidth;
          }if (options.initialFrameHeight) {
            options.minFrameHeight = options.initialFrameHeight;
          } else {
            options.initialFrameHeight = options.minFrameHeight = container.offsetHeight;
          }container.style.width = /%$/.test(options.initialFrameWidth) ? "100%" : options.initialFrameWidth - getStyleValue("padding-left") - getStyleValue("padding-right") + "px";container.style.height = /%$/.test(options.initialFrameHeight) ? "100%" : options.initialFrameHeight - getStyleValue("padding-top") - getStyleValue("padding-bottom") + "px";container.style.zIndex = options.zIndex;var html = (ie && browser.version < 9 ? "" : "<!DOCTYPE html>") + "<html xmlns='http://www.w3.org/1999/xhtml' class='view' ><head>" + "<style type='text/css'>" + ".view{padding:0;word-wrap:break-word;cursor:text;height:90%;}\n" + "body{margin:8px;font-family:sans-serif;font-size:16px;}" + "p{margin:5px 0;}</style>" + (options.iframeCssUrl ? "<link rel='stylesheet' type='text/css' href='" + utils.unhtml(options.iframeCssUrl) + "'/>" : "") + (options.initialStyle ? "<style>" + options.initialStyle + "</style>" : "") + "</head><body class='view' ></body>" + "<script type='text/javascript' " + (ie ? "defer='defer'" : "") + " id='_initialScript'>" + "setTimeout(function(){editor = window.parent.UE.instants['ueditorInstant" + me.uid + "'];editor._setup(document);},0);" + "var _tmpScript = document.getElementById('_initialScript');_tmpScript.parentNode.removeChild(_tmpScript);<\/script></html>";container.appendChild(domUtils.createElement(document, "iframe", { id: "ueditor_" + me.uid, width: "100%", height: "100%", frameborder: "0", src: "javascript:void(function(){document.open();" + (options.customDomain && document.domain != location.hostname ? 'document.domain="' + document.domain + '";' : "") + 'document.write("' + html + '");document.close();}())' }));container.style.overflow = "hidden";setTimeout(function () {
            if (/%$/.test(options.initialFrameWidth)) {
              options.minFrameWidth = options.initialFrameWidth = container.offsetWidth;
            }if (/%$/.test(options.initialFrameHeight)) {
              options.minFrameHeight = options.initialFrameHeight = container.offsetHeight;container.style.height = options.initialFrameHeight + "px";
            }
          });
        }
      }, _setup: function _setup(doc) {
        var me = this,
            options = me.options;if (ie) {
          doc.body.disabled = true;doc.body.contentEditable = true;doc.body.disabled = false;
        } else {
          doc.body.contentEditable = true;
        }doc.body.spellcheck = false;me.document = doc;me.window = doc.defaultView || doc.parentWindow;me.iframe = me.window.frameElement;me.body = doc.body;me.selection = new dom.Selection(doc);var geckoSel;if (browser.gecko && (geckoSel = this.selection.getNative())) {
          geckoSel.removeAllRanges();
        }this._initEvents();for (var form = this.iframe.parentNode; !domUtils.isBody(form); form = form.parentNode) {
          if (form.tagName == "FORM") {
            me.form = form;if (me.options.autoSyncData) {
              domUtils.on(me.window, "blur", function () {
                setValue(form, me);
              });
            } else {
              domUtils.on(form, "submit", function () {
                setValue(this, me);
              });
            }break;
          }
        }if (options.initialContent) {
          if (options.autoClearinitialContent) {
            var oldExecCommand = me.execCommand;me.execCommand = function () {
              me.fireEvent("firstBeforeExecCommand");return oldExecCommand.apply(me, arguments);
            };this._setDefaultContent(options.initialContent);
          } else {
            this.setContent(options.initialContent, false, true);
          }
        }if (domUtils.isEmptyNode(me.body)) {
          me.body.innerHTML = "<p>" + (browser.ie ? "" : "<br/>") + "</p>";
        }if (options.focus) {
          setTimeout(function () {
            me.focus(me.options.focusInEnd);!me.options.autoClearinitialContent && me._selectionChange();
          }, 0);
        }if (!me.container) {
          me.container = this.iframe.parentNode;
        }if (options.fullscreen && me.ui) {
          me.ui.setFullScreen(true);
        }try {
          me.document.execCommand("2D-position", false, false);
        } catch (e) {}try {
          me.document.execCommand("enableInlineTableEditing", false, false);
        } catch (e) {}try {
          me.document.execCommand("enableObjectResizing", false, false);
        } catch (e) {}me._bindshortcutKeys();me.isReady = 1;me.fireEvent("ready");options.onready && options.onready.call(me);if (!browser.ie9below) {
          domUtils.on(me.window, ["blur", "focus"], function (e) {
            if (e.type == "blur") {
              me._bakRange = me.selection.getRange();try {
                me._bakNativeRange = me.selection.getNative().getRangeAt(0);me.selection.getNative().removeAllRanges();
              } catch (e) {
                me._bakNativeRange = null;
              }
            } else {
              try {
                me._bakRange && me._bakRange.select();
              } catch (e) {}
            }
          });
        }if (browser.gecko && browser.version <= 10902) {
          me.body.contentEditable = false;setTimeout(function () {
            me.body.contentEditable = true;
          }, 100);setInterval(function () {
            me.body.style.height = me.iframe.offsetHeight - 20 + "px";
          }, 100);
        }!options.isShow && me.setHide();options.readonly && me.setDisabled();
      }, sync: function sync(formId) {
        var me = this,
            form = formId ? document.getElementById(formId) : domUtils.findParent(me.iframe.parentNode, function (node) {
          return node.tagName == "FORM";
        }, true);form && setValue(form, me);
      }, setHeight: function setHeight(height, notSetHeight) {
        if (height !== parseInt(this.iframe.parentNode.style.height)) {
          this.iframe.parentNode.style.height = height + "px";
        }!notSetHeight && (this.options.minFrameHeight = this.options.initialFrameHeight = height);this.body.style.height = height + "px";!notSetHeight && this.trigger("setHeight");
      }, addshortcutkey: function addshortcutkey(cmd, keys) {
        var obj = {};if (keys) {
          obj[cmd] = keys;
        } else {
          obj = cmd;
        }utils.extend(this.shortcutkeys, obj);
      }, _bindshortcutKeys: function _bindshortcutKeys() {
        var me = this,
            shortcutkeys = this.shortcutkeys;me.addListener("keydown", function (type, e) {
          var keyCode = e.keyCode || e.which;for (var i in shortcutkeys) {
            var tmp = shortcutkeys[i].split(",");for (var t = 0, ti; ti = tmp[t++];) {
              ti = ti.split(":");var key = ti[0],
                  param = ti[1];if (/^(ctrl)(\+shift)?\+(\d+)$/.test(key.toLowerCase()) || /^(\d+)$/.test(key)) {
                if ((RegExp.$1 == "ctrl" ? e.ctrlKey || e.metaKey : 0) && (RegExp.$2 != "" ? e[RegExp.$2.slice(1) + "Key"] : 1) && keyCode == RegExp.$3 || keyCode == RegExp.$1) {
                  if (me.queryCommandState(i, param) != -1) {
                    me.execCommand(i, param);
                  }domUtils.preventDefault(e);
                }
              }
            }
          }
        });
      }, getContent: function getContent(cmd, fn, notSetCursor, ignoreBlank, formatter) {
        var me = this;if (cmd && utils.isFunction(cmd)) {
          fn = cmd;cmd = "";
        }if (fn ? !fn() : !this.hasContents()) {
          return "";
        }me.fireEvent("beforegetcontent");var root = UE.htmlparser(me.body.innerHTML, ignoreBlank);me.filterOutputRule(root);me.fireEvent("aftergetcontent", cmd, root);return root.toHtml(formatter);
      }, getAllHtml: function getAllHtml() {
        var me = this,
            headHtml = [],
            html = "";me.fireEvent("getAllHtml", headHtml);if (browser.ie && browser.version > 8) {
          var headHtmlForIE9 = "";utils.each(me.document.styleSheets, function (si) {
            headHtmlForIE9 += si.href ? '<link rel="stylesheet" type="text/css" href="' + si.href + '" />' : "<style>" + si.cssText + "</style>";
          });utils.each(me.document.getElementsByTagName("script"), function (si) {
            headHtmlForIE9 += si.outerHTML;
          });
        }return "<html><head>" + (me.options.charset ? '<meta http-equiv="Content-Type" content="text/html; charset=' + me.options.charset + '"/>' : "") + (headHtmlForIE9 || me.document.getElementsByTagName("head")[0].innerHTML) + headHtml.join("\n") + "</head>" + "<body " + (ie && browser.version < 9 ? 'class="view"' : "") + ">" + me.getContent(null, null, true) + "</body></html>";
      }, getPlainTxt: function getPlainTxt() {
        var reg = new RegExp(domUtils.fillChar, "g"),
            html = this.body.innerHTML.replace(/[\n\r]/g, "");html = html.replace(/<(p|div)[^>]*>(<br\/?>|&nbsp;)<\/\1>/gi, "\n").replace(/<br\/?>/gi, "\n").replace(/<[^>/]+>/g, "").replace(/(\n)?<\/([^>]+)>/g, function (a, b, c) {
          return dtd.$block[c] ? "\n" : b ? b : "";
        });return html.replace(reg, "").replace(/\u00a0/g, " ").replace(/&nbsp;/g, " ");
      }, getContentTxt: function getContentTxt() {
        var reg = new RegExp(domUtils.fillChar, "g");return this.body[browser.ie ? "innerText" : "textContent"].replace(reg, "").replace(/\u00a0/g, " ");
      }, setContent: function setContent(html, isAppendTo, notFireSelectionchange) {
        var me = this;me.fireEvent("beforesetcontent", html);var root = UE.htmlparser(html);me.filterInputRule(root);html = root.toHtml();me.body.innerHTML = (isAppendTo ? me.body.innerHTML : "") + html;function isCdataDiv(node) {
          return node.tagName == "DIV" && node.getAttribute("cdata_tag");
        }if (me.options.enterTag == "p") {
          var child = this.body.firstChild,
              tmpNode;if (!child || child.nodeType == 1 && (dtd.$cdata[child.tagName] || isCdataDiv(child) || domUtils.isCustomeNode(child)) && child === this.body.lastChild) {
            this.body.innerHTML = "<p>" + (browser.ie ? "&nbsp;" : "<br/>") + "</p>" + this.body.innerHTML;
          } else {
            var p = me.document.createElement("p");while (child) {
              while (child && (child.nodeType == 3 || child.nodeType == 1 && dtd.p[child.tagName] && !dtd.$cdata[child.tagName])) {
                tmpNode = child.nextSibling;p.appendChild(child);child = tmpNode;
              }if (p.firstChild) {
                if (!child) {
                  me.body.appendChild(p);break;
                } else {
                  child.parentNode.insertBefore(p, child);p = me.document.createElement("p");
                }
              }child = child.nextSibling;
            }
          }
        }me.fireEvent("aftersetcontent");me.fireEvent("contentchange");!notFireSelectionchange && me._selectionChange();me._bakRange = me._bakIERange = me._bakNativeRange = null;var geckoSel;if (browser.gecko && (geckoSel = this.selection.getNative())) {
          geckoSel.removeAllRanges();
        }if (me.options.autoSyncData) {
          me.form && setValue(me.form, me);
        }
      }, focus: function focus(toEnd) {
        try {
          var me = this,
              rng = me.selection.getRange();if (toEnd) {
            var node = me.body.lastChild;if (node && node.nodeType == 1 && !dtd.$empty[node.tagName]) {
              if (domUtils.isEmptyBlock(node)) {
                rng.setStartAtFirst(node);
              } else {
                rng.setStartAtLast(node);
              }rng.collapse(true);
            }rng.setCursor(true);
          } else {
            if (!rng.collapsed && domUtils.isBody(rng.startContainer) && rng.startOffset == 0) {
              var node = me.body.firstChild;if (node && node.nodeType == 1 && !dtd.$empty[node.tagName]) {
                rng.setStartAtFirst(node).collapse(true);
              }
            }rng.select(true);
          }this.fireEvent("focus selectionchange");
        } catch (e) {}
      }, isFocus: function isFocus() {
        return this.selection.isFocus();
      }, blur: function blur() {
        var sel = this.selection.getNative();if (sel.empty && browser.ie) {
          var nativeRng = document.body.createTextRange();nativeRng.moveToElementText(document.body);nativeRng.collapse(true);nativeRng.select();sel.empty();
        } else {
          sel.removeAllRanges();
        }
      }, _initEvents: function _initEvents() {
        var me = this,
            doc = me.document,
            win = me.window;me._proxyDomEvent = utils.bind(me._proxyDomEvent, me);domUtils.on(doc, ["click", "contextmenu", "mousedown", "keydown", "keyup", "keypress", "mouseup", "mouseover", "mouseout", "selectstart"], me._proxyDomEvent);domUtils.on(win, ["focus", "blur"], me._proxyDomEvent);domUtils.on(me.body, "drop", function (e) {
          if (browser.gecko && e.stopPropagation) {
            e.stopPropagation();
          }me.fireEvent("contentchange");
        });domUtils.on(doc, ["mouseup", "keydown"], function (evt) {
          if (evt.type == "keydown" && (evt.ctrlKey || evt.metaKey || evt.shiftKey || evt.altKey)) {
            return;
          }if (evt.button == 2) {
            return;
          }me._selectionChange(250, evt);
        });
      }, _proxyDomEvent: function _proxyDomEvent(evt) {
        if (this.fireEvent("before" + evt.type.replace(/^on/, "").toLowerCase()) === false) {
          return false;
        }if (this.fireEvent(evt.type.replace(/^on/, ""), evt) === false) {
          return false;
        }return this.fireEvent("after" + evt.type.replace(/^on/, "").toLowerCase());
      }, _selectionChange: function _selectionChange(delay, evt) {
        var me = this;var hackForMouseUp = false;var mouseX, mouseY;if (browser.ie && browser.version < 9 && evt && evt.type == "mouseup") {
          var range = this.selection.getRange();if (!range.collapsed) {
            hackForMouseUp = true;mouseX = evt.clientX;mouseY = evt.clientY;
          }
        }clearTimeout(_selectionChangeTimer);_selectionChangeTimer = setTimeout(function () {
          if (!me.selection || !me.selection.getNative()) {
            return;
          }var ieRange;if (hackForMouseUp && me.selection.getNative().type == "None") {
            ieRange = me.document.body.createTextRange();try {
              ieRange.moveToPoint(mouseX, mouseY);
            } catch (ex) {
              ieRange = null;
            }
          }var bakGetIERange;if (ieRange) {
            bakGetIERange = me.selection.getIERange;me.selection.getIERange = function () {
              return ieRange;
            };
          }me.selection.cache();if (bakGetIERange) {
            me.selection.getIERange = bakGetIERange;
          }if (me.selection._cachedRange && me.selection._cachedStartElement) {
            me.fireEvent("beforeselectionchange");me.fireEvent("selectionchange", !!evt);me.fireEvent("afterselectionchange");me.selection.clear();
          }
        }, delay || 50);
      }, _callCmdFn: function _callCmdFn(fnName, args) {
        var cmdName = args[0].toLowerCase(),
            cmd,
            cmdFn;cmd = this.commands[cmdName] || UE.commands[cmdName];cmdFn = cmd && cmd[fnName];if ((!cmd || !cmdFn) && fnName == "queryCommandState") {
          return 0;
        } else {
          if (cmdFn) {
            return cmdFn.apply(this, args);
          }
        }
      }, execCommand: function execCommand(cmdName) {
        cmdName = cmdName.toLowerCase();var me = this,
            result,
            cmd = me.commands[cmdName] || UE.commands[cmdName];if (!cmd || !cmd.execCommand) {
          return null;
        }if (!cmd.notNeedUndo && !me.__hasEnterExecCommand) {
          me.__hasEnterExecCommand = true;if (me.queryCommandState.apply(me, arguments) != -1) {
            me.fireEvent("saveScene");me.fireEvent.apply(me, ["beforeexeccommand", cmdName].concat(arguments));result = this._callCmdFn("execCommand", arguments);me.fireEvent.apply(me, ["afterexeccommand", cmdName].concat(arguments));me.fireEvent("saveScene");
          }me.__hasEnterExecCommand = false;
        } else {
          result = this._callCmdFn("execCommand", arguments);!me.__hasEnterExecCommand && !cmd.ignoreContentChange && !me._ignoreContentChange && me.fireEvent("contentchange");
        }!me.__hasEnterExecCommand && !cmd.ignoreContentChange && !me._ignoreContentChange && me._selectionChange();return result;
      }, queryCommandState: function queryCommandState(cmdName) {
        return this._callCmdFn("queryCommandState", arguments);
      }, queryCommandValue: function queryCommandValue(cmdName) {
        return this._callCmdFn("queryCommandValue", arguments);
      }, hasContents: function hasContents(tags) {
        if (tags) {
          for (var i = 0, ci; ci = tags[i++];) {
            if (this.document.getElementsByTagName(ci).length > 0) {
              return true;
            }
          }
        }if (!domUtils.isEmptyBlock(this.body)) {
          return true;
        }tags = ["div"];for (i = 0; ci = tags[i++];) {
          var nodes = domUtils.getElementsByTagName(this.document, ci);for (var n = 0, cn; cn = nodes[n++];) {
            if (domUtils.isCustomeNode(cn)) {
              return true;
            }
          }
        }return false;
      }, reset: function reset() {
        this.fireEvent("reset");
      }, setEnabled: function setEnabled() {
        var me = this,
            range;if (me.body.contentEditable == "false") {
          me.body.contentEditable = true;range = me.selection.getRange();try {
            range.moveToBookmark(me.lastBk);delete me.lastBk;
          } catch (e) {
            range.setStartAtFirst(me.body).collapse(true);
          }range.select(true);if (me.bkqueryCommandState) {
            me.queryCommandState = me.bkqueryCommandState;delete me.bkqueryCommandState;
          }if (me.bkqueryCommandValue) {
            me.queryCommandValue = me.bkqueryCommandValue;delete me.bkqueryCommandValue;
          }me.fireEvent("selectionchange");
        }
      }, enable: function enable() {
        return this.setEnabled();
      }, setDisabled: function setDisabled(except) {
        var me = this;except = except ? utils.isArray(except) ? except : [except] : [];if (me.body.contentEditable == "true") {
          if (!me.lastBk) {
            me.lastBk = me.selection.getRange().createBookmark(true);
          }me.body.contentEditable = false;me.bkqueryCommandState = me.queryCommandState;me.bkqueryCommandValue = me.queryCommandValue;me.queryCommandState = function (type) {
            if (utils.indexOf(except, type) != -1) {
              return me.bkqueryCommandState.apply(me, arguments);
            }return -1;
          };me.queryCommandValue = function (type) {
            if (utils.indexOf(except, type) != -1) {
              return me.bkqueryCommandValue.apply(me, arguments);
            }return null;
          };me.fireEvent("selectionchange");
        }
      }, disable: function disable(except) {
        return this.setDisabled(except);
      }, _setDefaultContent: function () {
        function clear() {
          var me = this;if (me.document.getElementById("initContent")) {
            me.body.innerHTML = "<p>" + (ie ? "" : "<br/>") + "</p>";me.removeListener("firstBeforeExecCommand focus", clear);setTimeout(function () {
              me.focus();me._selectionChange();
            }, 0);
          }
        }return function (cont) {
          var me = this;me.body.innerHTML = '<p id="initContent">' + cont + "</p>";me.addListener("firstBeforeExecCommand focus", clear);
        };
      }(), setShow: function setShow() {
        var me = this,
            range = me.selection.getRange();if (me.container.style.display == "none") {
          try {
            range.moveToBookmark(me.lastBk);delete me.lastBk;
          } catch (e) {
            range.setStartAtFirst(me.body).collapse(true);
          }setTimeout(function () {
            range.select(true);
          }, 100);me.container.style.display = "";
        }
      }, show: function show() {
        return this.setShow();
      }, setHide: function setHide() {
        var me = this;if (!me.lastBk) {
          me.lastBk = me.selection.getRange().createBookmark(true);
        }me.container.style.display = "none";
      }, hide: function hide() {
        return this.setHide();
      }, getLang: function getLang(path) {
        var lang = UE.I18N[this.options.lang];if (!lang) {
          throw Error("not import language file");
        }path = (path || "").split(".");for (var i = 0, ci; ci = path[i++];) {
          lang = lang[ci];if (!lang) {
            break;
          }
        }return lang;
      }, getContentLength: function getContentLength(ingoneHtml, tagNames) {
        var count = this.getContent(false, false, true).length;if (ingoneHtml) {
          tagNames = (tagNames || []).concat(["hr", "img", "iframe"]);count = this.getContentTxt().replace(/[\t\r\n]+/g, "").length;for (var i = 0, ci; ci = tagNames[i++];) {
            count += this.document.getElementsByTagName(ci).length;
          }
        }return count;
      }, addInputRule: function addInputRule(rule) {
        this.inputRules.push(rule);
      }, filterInputRule: function filterInputRule(root) {
        for (var i = 0, ci; ci = this.inputRules[i++];) {
          ci.call(this, root);
        }
      }, addOutputRule: function addOutputRule(rule) {
        this.outputRules.push(rule);
      }, filterOutputRule: function filterOutputRule(root) {
        for (var i = 0, ci; ci = this.outputRules[i++];) {
          ci.call(this, root);
        }
      }, getActionUrl: function getActionUrl(action) {
        var actionName = this.getOpt(action) || action,
            imageUrl = this.getOpt("imageUrl"),
            serverUrl = this.getOpt("serverUrl");if (!serverUrl && imageUrl) {
          serverUrl = imageUrl.replace(/^(.*[\/]).+([\.].+)$/, "$1controller$2");
        }if (serverUrl) {
          serverUrl = serverUrl + (serverUrl.indexOf("?") == -1 ? "?" : "&") + "action=" + (actionName || "");return utils.formatUrl(serverUrl);
        } else {
          return "";
        }
      } };utils.inherits(Editor, EventBase);
  })();UE.Editor.defaultOptions = function (editor) {
    var _url = editor.options.UEDITOR_HOME_URL;return { isShow: true, initialContent: "", initialStyle: "", autoClearinitialContent: false, iframeCssUrl: _url + "themes/iframe.css", textarea: "editorValue", focus: false, focusInEnd: true, autoClearEmptyNode: true, fullscreen: false, readonly: false, zIndex: 999, imagePopup: true, enterTag: "p", customDomain: false, lang: "zh-cn", langPath: _url + "lang/", theme: "default", themePath: _url + "themes/", allHtmlEnabled: false, scaleEnabled: false, tableNativeEditInFF: false, autoSyncData: true, fileNameFormat: "{time}{rand:6}" };
  };(function () {
    UE.Editor.prototype.isServerConfigLoaded = function () {
      var me = this;return me._serverConfigLoaded || false;
    };UE.Editor.prototype.afterConfigReady = function (handler) {
      if (!handler || !utils.isFunction(handler)) {
        return;
      }var me = this;var readyHandler = function readyHandler() {
        handler.apply(me, arguments);me.removeListener("serverConfigLoaded", readyHandler);
      };if (me.isServerConfigLoaded()) {
        handler.call(me, "serverConfigLoaded");
      } else {
        me.addListener("serverConfigLoaded", readyHandler);
      }
    };
  })();UE.ajax = function () {
    var fnStr = "XMLHttpRequest()";try {
      new ActiveXObject("Msxml2.XMLHTTP");fnStr = "ActiveXObject('Msxml2.XMLHTTP')";
    } catch (e) {
      try {
        new ActiveXObject("Microsoft.XMLHTTP");fnStr = "ActiveXObject('Microsoft.XMLHTTP')";
      } catch (e) {}
    }var creatAjaxRequest = new Function("return new " + fnStr);function json2str(json) {
      var strArr = [];for (var i in json) {
        if (i == "method" || i == "timeout" || i == "async" || i == "dataType" || i == "callback") {
          continue;
        }if (json[i] == undefined || json[i] == null) {
          continue;
        }if (!(_typeof(json[i]).toLowerCase() == "function" || _typeof(json[i]).toLowerCase() == "object")) {
          strArr.push(encodeURIComponent(i) + "=" + encodeURIComponent(json[i]));
        } else {
          if (utils.isArray(json[i])) {
            for (var j = 0; j < json[i].length; j++) {
              strArr.push(encodeURIComponent(i) + "[]=" + encodeURIComponent(json[i][j]));
            }
          }
        }
      }return strArr.join("&");
    }function doAjax(url, ajaxOptions) {
      var xhr = creatAjaxRequest(),
          timeIsOut = false,
          defaultAjaxOptions = { method: "POST", timeout: 5000, async: true, data: {}, onsuccess: function onsuccess() {}, onerror: function onerror() {} };if ((typeof url === "undefined" ? "undefined" : _typeof(url)) === "object") {
        ajaxOptions = url;url = ajaxOptions.url;
      }if (!xhr || !url) {
        return;
      }var ajaxOpts = ajaxOptions ? utils.extend(defaultAjaxOptions, ajaxOptions) : defaultAjaxOptions;var submitStr = json2str(ajaxOpts);if (!utils.isEmptyObject(ajaxOpts.data)) {
        submitStr += (submitStr ? "&" : "") + json2str(ajaxOpts.data);
      }var timerID = setTimeout(function () {
        if (xhr.readyState != 4) {
          timeIsOut = true;xhr.abort();clearTimeout(timerID);
        }
      }, ajaxOpts.timeout);var method = ajaxOpts.method.toUpperCase();var str = url + (url.indexOf("?") == -1 ? "?" : "&") + (method == "POST" ? "" : submitStr + "&noCache=" + +new Date());xhr.open(method, str, ajaxOpts.async);xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (!timeIsOut && xhr.status == 200) {
            ajaxOpts.onsuccess(xhr);
          } else {
            ajaxOpts.onerror(xhr);
          }
        }
      };if (method == "POST") {
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");xhr.send(submitStr);
      } else {
        xhr.send(null);
      }
    }function doJsonp(url, opts) {
      var successhandler = opts.onsuccess || function () {},
          scr = document.createElement("SCRIPT"),
          options = opts || {},
          charset = options["charset"],
          callbackField = options["jsonp"] || "callback",
          callbackFnName,
          timeOut = options["timeOut"] || 0,
          timer,
          reg = new RegExp("(\\?|&)" + callbackField + "=([^&]*)"),
          matches;if (utils.isFunction(successhandler)) {
        callbackFnName = "bd__editor__" + Math.floor(Math.random() * 2147483648).toString(36);window[callbackFnName] = getCallBack(0);
      } else {
        if (utils.isString(successhandler)) {
          callbackFnName = successhandler;
        } else {
          if (matches = reg.exec(url)) {
            callbackFnName = matches[2];
          }
        }
      }url = url.replace(reg, "\x241" + callbackField + "=" + callbackFnName);if (url.search(reg) < 0) {
        url += (url.indexOf("?") < 0 ? "?" : "&") + callbackField + "=" + callbackFnName;
      }var queryStr = json2str(opts);if (!utils.isEmptyObject(opts.data)) {
        queryStr += (queryStr ? "&" : "") + json2str(opts.data);
      }if (queryStr) {
        url = url.replace(/\?/, "?" + queryStr + "&");
      }scr.onerror = getCallBack(1);if (timeOut) {
        timer = setTimeout(getCallBack(1), timeOut);
      }createScriptTag(scr, url, charset);function createScriptTag(scr, url, charset) {
        scr.setAttribute("type", "text/javascript");scr.setAttribute("defer", "defer");charset && scr.setAttribute("charset", charset);scr.setAttribute("src", url);document.getElementsByTagName("head")[0].appendChild(scr);
      }function getCallBack(onTimeOut) {
        return function () {
          try {
            if (onTimeOut) {
              options.onerror && options.onerror();
            } else {
              try {
                clearTimeout(timer);successhandler.apply(window, arguments);
              } catch (e) {}
            }
          } catch (exception) {
            options.onerror && options.onerror.call(window, exception);
          } finally {
            options.oncomplete && options.oncomplete.apply(window, arguments);scr.parentNode && scr.parentNode.removeChild(scr);window[callbackFnName] = null;try {
              delete window[callbackFnName];
            } catch (e) {}
          }
        };
      }
    }return { request: function request(url, opts) {
        if (opts && opts.dataType == "jsonp") {
          doJsonp(url, opts);
        } else {
          doAjax(url, opts);
        }
      }, getJSONP: function getJSONP(url, data, fn) {
        var opts = { "data": data, "oncomplete": fn };doJsonp(url, opts);
      } };
  }();var filterWord = UE.filterWord = function () {
    function isWordDocument(str) {
      return (/(class="?Mso|style="[^"]*\bmso\-|w:WordDocument|<(v|o):|lang=)/ig.test(str)
      );
    }function transUnit(v) {
      v = v.replace(/[\d.]+\w+/g, function (m) {
        return utils.transUnitToPx(m);
      });return v;
    }function filterPasteWord(str) {
      return str.replace(/[\t\r\n]+/g, " ").replace(/<!--[\s\S]*?-->/ig, "").replace(/<v:shape [^>]*>[\s\S]*?.<\/v:shape>/gi, function (str) {
        if (browser.opera) {
          return "";
        }try {
          if (/Bitmap/i.test(str)) {
            return "";
          }var width = str.match(/width:([ \d.]*p[tx])/i)[1],
              height = str.match(/height:([ \d.]*p[tx])/i)[1],
              src = str.match(/src=\s*"([^"]*)"/i)[1];return '<img width="' + transUnit(width) + '" height="' + transUnit(height) + '" src="' + src + '" />';
        } catch (e) {
          return "";
        }
      }).replace(/<\/?div[^>]*>/g, "").replace(/v:\w+=(["']?)[^'"]+\1/g, "").replace(/<(!|script[^>]*>.*?<\/script(?=[>\s])|\/?(\?xml(:\w+)?|xml|meta|link|style|\w+:\w+)(?=[\s\/>]))[^>]*>/gi, "").replace(/<p [^>]*class="?MsoHeading"?[^>]*>(.*?)<\/p>/gi, "<p><strong>$1</strong></p>").replace(/\s+(class|lang|align)\s*=\s*(['"]?)([\w-]+)\2/ig, function (str, name, marks, val) {
        return name == "class" && val == "MsoListParagraph" ? str : "";
      }).replace(/<(font|span)[^>]*>(\s*)<\/\1>/gi, function (a, b, c) {
        return c.replace(/[\t\r\n ]+/g, " ");
      }).replace(/(<[a-z][^>]*)\sstyle=(["'])([^\2]*?)\2/gi, function (str, tag, tmp, style) {
        var n = [],
            s = style.replace(/^\s+|\s+$/, "").replace(/&#39;/g, "'").replace(/&quot;/gi, "'").replace(/[\d.]+(cm|pt)/g, function (str) {
          return utils.transUnitToPx(str);
        }).split(/;\s*/g);for (var i = 0, v; v = s[i]; i++) {
          var name,
              value,
              parts = v.split(":");if (parts.length == 2) {
            name = parts[0].toLowerCase();value = parts[1].toLowerCase();if (/^(background)\w*/.test(name) && value.replace(/(initial|\s)/g, "").length == 0 || /^(margin)\w*/.test(name) && /^0\w+$/.test(value)) {
              continue;
            }switch (name) {case "mso-padding-alt":case "mso-padding-top-alt":case "mso-padding-right-alt":case "mso-padding-bottom-alt":case "mso-padding-left-alt":case "mso-margin-alt":case "mso-margin-top-alt":case "mso-margin-right-alt":case "mso-margin-bottom-alt":case "mso-margin-left-alt":case "mso-height":case "mso-width":case "mso-vertical-align-alt":
                if (!/<table/.test(tag)) {
                  n[i] = name.replace(/^mso-|-alt$/g, "") + ":" + transUnit(value);
                }continue;case "horiz-align":
                n[i] = "text-align:" + value;continue;case "vert-align":
                n[i] = "vertical-align:" + value;continue;case "font-color":case "mso-foreground":
                n[i] = "color:" + value;continue;case "mso-background":case "mso-highlight":
                n[i] = "background:" + value;continue;case "mso-default-height":
                n[i] = "min-height:" + transUnit(value);continue;case "mso-default-width":
                n[i] = "min-width:" + transUnit(value);continue;case "mso-padding-between-alt":
                n[i] = "border-collapse:separate;border-spacing:" + transUnit(value);continue;case "text-line-through":
                if (value == "single" || value == "double") {
                  n[i] = "text-decoration:line-through";
                }continue;case "mso-zero-height":
                if (value == "yes") {
                  n[i] = "display:none";
                }continue;case "margin":
                if (!/[1-9]/.test(value)) {
                  continue;
                }}if (/^(mso|column|font-emph|lang|layout|line-break|list-image|nav|panose|punct|row|ruby|sep|size|src|tab-|table-border|text-(?:decor|trans)|top-bar|version|vnd|word-break)/.test(name) || /text\-indent|padding|margin/.test(name) && /\-[\d.]+/.test(value)) {
              continue;
            }n[i] = name + ":" + parts[1];
          }
        }return tag + (n.length ? ' style="' + n.join(";").replace(/;{2,}/g, ";") + '"' : "");
      });
    }return function (html) {
      return isWordDocument(html) ? filterPasteWord(html) : html;
    };
  }();(function () {
    var uNode = UE.uNode = function (obj) {
      this.type = obj.type;this.data = obj.data;this.tagName = obj.tagName;this.parentNode = obj.parentNode;this.attrs = obj.attrs || {};this.children = obj.children;
    };var notTransAttrs = { "href": 1, "src": 1, "_src": 1, "_href": 1, "cdata_data": 1 };var notTransTagName = { style: 1, script: 1 };var indentChar = "    ",
        breakChar = "\n";function insertLine(arr, current, begin) {
      arr.push(breakChar);return current + (begin ? 1 : -1);
    }function insertIndent(arr, current) {
      for (var i = 0; i < current; i++) {
        arr.push(indentChar);
      }
    }uNode.createElement = function (html) {
      if (/[<>]/.test(html)) {
        return UE.htmlparser(html).children[0];
      } else {
        return new uNode({ type: "element", children: [], tagName: html });
      }
    };uNode.createText = function (data, noTrans) {
      return new UE.uNode({ type: "text", "data": noTrans ? data : utils.unhtml(data || "") });
    };function nodeToHtml(node, arr, formatter, current) {
      switch (node.type) {case "root":
          for (var i = 0, ci; ci = node.children[i++];) {
            if (formatter && ci.type == "element" && !dtd.$inlineWithA[ci.tagName] && i > 1) {
              insertLine(arr, current, true);insertIndent(arr, current);
            }nodeToHtml(ci, arr, formatter, current);
          }break;case "text":
          isText(node, arr);break;case "element":
          isElement(node, arr, formatter, current);break;case "comment":
          isComment(node, arr, formatter);}return arr;
    }function isText(node, arr) {
      if (node.parentNode.tagName == "pre") {
        arr.push(node.data);
      } else {
        arr.push(notTransTagName[node.parentNode.tagName] ? utils.html(node.data) : node.data.replace(/[ ]{2}/g, " &nbsp;"));
      }
    }function isElement(node, arr, formatter, current) {
      var attrhtml = "";if (node.attrs) {
        attrhtml = [];var attrs = node.attrs;for (var a in attrs) {
          attrhtml.push(a + (attrs[a] !== undefined ? '="' + (notTransAttrs[a] ? utils.html(attrs[a]).replace(/["]/g, function (a) {
            return "&quot;";
          }) : utils.unhtml(attrs[a])) + '"' : ""));
        }attrhtml = attrhtml.join(" ");
      }arr.push("<" + node.tagName + (attrhtml ? " " + attrhtml : "") + (dtd.$empty[node.tagName] ? "/" : "") + ">");if (formatter && !dtd.$inlineWithA[node.tagName] && node.tagName != "pre") {
        if (node.children && node.children.length) {
          current = insertLine(arr, current, true);insertIndent(arr, current);
        }
      }if (node.children && node.children.length) {
        for (var i = 0, ci; ci = node.children[i++];) {
          if (formatter && ci.type == "element" && !dtd.$inlineWithA[ci.tagName] && i > 1) {
            insertLine(arr, current);insertIndent(arr, current);
          }nodeToHtml(ci, arr, formatter, current);
        }
      }if (!dtd.$empty[node.tagName]) {
        if (formatter && !dtd.$inlineWithA[node.tagName] && node.tagName != "pre") {
          if (node.children && node.children.length) {
            current = insertLine(arr, current);insertIndent(arr, current);
          }
        }arr.push("</" + node.tagName + ">");
      }
    }function isComment(node, arr) {
      arr.push("<!--" + node.data + "-->");
    }function _getNodeById(root, id) {
      var node;if (root.type == "element" && root.getAttr("id") == id) {
        return root;
      }if (root.children && root.children.length) {
        for (var i = 0, ci; ci = root.children[i++];) {
          if (node = _getNodeById(ci, id)) {
            return node;
          }
        }
      }
    }function _getNodesByTagName(node, tagName, arr) {
      if (node.type == "element" && node.tagName == tagName) {
        arr.push(node);
      }if (node.children && node.children.length) {
        for (var i = 0, ci; ci = node.children[i++];) {
          _getNodesByTagName(ci, tagName, arr);
        }
      }
    }function nodeTraversal(root, fn) {
      if (root.children && root.children.length) {
        for (var i = 0, ci; ci = root.children[i];) {
          nodeTraversal(ci, fn);if (ci.parentNode) {
            if (ci.children && ci.children.length) {
              fn(ci);
            }if (ci.parentNode) {
              i++;
            }
          }
        }
      } else {
        fn(root);
      }
    }uNode.prototype = { toHtml: function toHtml(formatter) {
        var arr = [];nodeToHtml(this, arr, formatter, 0);return arr.join("");
      }, innerHTML: function innerHTML(htmlstr) {
        if (this.type != "element" || dtd.$empty[this.tagName]) {
          return this;
        }if (utils.isString(htmlstr)) {
          if (this.children) {
            for (var i = 0, ci; ci = this.children[i++];) {
              ci.parentNode = null;
            }
          }this.children = [];var tmpRoot = UE.htmlparser(htmlstr);for (var i = 0, ci; ci = tmpRoot.children[i++];) {
            this.children.push(ci);ci.parentNode = this;
          }return this;
        } else {
          var tmpRoot = new UE.uNode({ type: "root", children: this.children });return tmpRoot.toHtml();
        }
      }, innerText: function innerText(textStr, noTrans) {
        if (this.type != "element" || dtd.$empty[this.tagName]) {
          return this;
        }if (textStr) {
          if (this.children) {
            for (var i = 0, ci; ci = this.children[i++];) {
              ci.parentNode = null;
            }
          }this.children = [];this.appendChild(uNode.createText(textStr, noTrans));return this;
        } else {
          return this.toHtml().replace(/<[^>]+>/g, "");
        }
      }, getData: function getData() {
        if (this.type == "element") {
          return "";
        }return this.data;
      }, firstChild: function firstChild() {
        return this.children ? this.children[0] : null;
      }, lastChild: function lastChild() {
        return this.children ? this.children[this.children.length - 1] : null;
      }, previousSibling: function previousSibling() {
        var parent = this.parentNode;for (var i = 0, ci; ci = parent.children[i]; i++) {
          if (ci === this) {
            return i == 0 ? null : parent.children[i - 1];
          }
        }
      }, nextSibling: function nextSibling() {
        var parent = this.parentNode;for (var i = 0, ci; ci = parent.children[i++];) {
          if (ci === this) {
            return parent.children[i];
          }
        }
      }, replaceChild: function replaceChild(target, source) {
        if (this.children) {
          if (target.parentNode) {
            target.parentNode.removeChild(target);
          }for (var i = 0, ci; ci = this.children[i]; i++) {
            if (ci === source) {
              this.children.splice(i, 1, target);source.parentNode = null;target.parentNode = this;return target;
            }
          }
        }
      }, appendChild: function appendChild(node) {
        if (this.type == "root" || this.type == "element" && !dtd.$empty[this.tagName]) {
          if (!this.children) {
            this.children = [];
          }if (node.parentNode) {
            node.parentNode.removeChild(node);
          }for (var i = 0, ci; ci = this.children[i]; i++) {
            if (ci === node) {
              this.children.splice(i, 1);break;
            }
          }this.children.push(node);node.parentNode = this;return node;
        }
      }, insertBefore: function insertBefore(target, source) {
        if (this.children) {
          if (target.parentNode) {
            target.parentNode.removeChild(target);
          }for (var i = 0, ci; ci = this.children[i]; i++) {
            if (ci === source) {
              this.children.splice(i, 0, target);target.parentNode = this;return target;
            }
          }
        }
      }, insertAfter: function insertAfter(target, source) {
        if (this.children) {
          if (target.parentNode) {
            target.parentNode.removeChild(target);
          }for (var i = 0, ci; ci = this.children[i]; i++) {
            if (ci === source) {
              this.children.splice(i + 1, 0, target);target.parentNode = this;return target;
            }
          }
        }
      }, removeChild: function removeChild(node, keepChildren) {
        if (this.children) {
          for (var i = 0, ci; ci = this.children[i]; i++) {
            if (ci === node) {
              this.children.splice(i, 1);ci.parentNode = null;if (keepChildren && ci.children && ci.children.length) {
                for (var j = 0, cj; cj = ci.children[j]; j++) {
                  this.children.splice(i + j, 0, cj);cj.parentNode = this;
                }
              }return ci;
            }
          }
        }
      }, getAttr: function getAttr(attrName) {
        return this.attrs && this.attrs[attrName.toLowerCase()];
      }, setAttr: function setAttr(attrName, attrVal) {
        if (!attrName) {
          delete this.attrs;return;
        }if (!this.attrs) {
          this.attrs = {};
        }if (utils.isObject(attrName)) {
          for (var a in attrName) {
            if (!attrName[a]) {
              delete this.attrs[a];
            } else {
              this.attrs[a.toLowerCase()] = attrName[a];
            }
          }
        } else {
          if (!attrVal) {
            delete this.attrs[attrName];
          } else {
            this.attrs[attrName.toLowerCase()] = attrVal;
          }
        }
      }, getIndex: function getIndex() {
        var parent = this.parentNode;for (var i = 0, ci; ci = parent.children[i]; i++) {
          if (ci === this) {
            return i;
          }
        }return -1;
      }, getNodeById: function getNodeById(id) {
        var node;if (this.children && this.children.length) {
          for (var i = 0, ci; ci = this.children[i++];) {
            if (node = _getNodeById(ci, id)) {
              return node;
            }
          }
        }
      }, getNodesByTagName: function getNodesByTagName(tagNames) {
        tagNames = utils.trim(tagNames).replace(/[ ]{2,}/g, " ").split(" ");var arr = [],
            me = this;utils.each(tagNames, function (tagName) {
          if (me.children && me.children.length) {
            for (var i = 0, ci; ci = me.children[i++];) {
              _getNodesByTagName(ci, tagName, arr);
            }
          }
        });return arr;
      }, getStyle: function getStyle(name) {
        var cssStyle = this.getAttr("style");if (!cssStyle) {
          return "";
        }var reg = new RegExp("(^|;)\\s*" + name + ":([^;]+)", "i");var match = cssStyle.match(reg);if (match && match[0]) {
          return match[2];
        }return "";
      }, setStyle: function setStyle(name, val) {
        function exec(name, val) {
          var reg = new RegExp("(^|;)\\s*" + name + ":([^;]+;?)", "gi");cssStyle = cssStyle.replace(reg, "$1");if (val) {
            cssStyle = name + ":" + utils.unhtml(val) + ";" + cssStyle;
          }
        }var cssStyle = this.getAttr("style");if (!cssStyle) {
          cssStyle = "";
        }if (utils.isObject(name)) {
          for (var a in name) {
            exec(a, name[a]);
          }
        } else {
          exec(name, val);
        }this.setAttr("style", utils.trim(cssStyle));
      }, traversal: function traversal(fn) {
        if (this.children && this.children.length) {
          nodeTraversal(this, fn);
        }return this;
      } };
  })();var htmlparser = UE.htmlparser = function (htmlstr, ignoreBlank) {
    var re_tag = /<(?:(?:\/([^>]+)>)|(?:!--([\S|\s]*?)-->)|(?:([^\s\/<>]+)\s*((?:(?:"[^"]*")|(?:'[^']*')|[^"'<>])*)\/?>))/g,
        re_attr = /([\w\-:.]+)(?:(?:\s*=\s*(?:(?:"([^"]*)")|(?:'([^']*)')|([^\s>]+)))|(?=\s|$))/g;var allowEmptyTags = { b: 1, code: 1, i: 1, u: 1, strike: 1, s: 1, tt: 1, strong: 1, q: 1, samp: 1, em: 1, span: 1, sub: 1, img: 1, sup: 1, font: 1, big: 1, small: 1, iframe: 1, a: 1, br: 1, pre: 1 };htmlstr = htmlstr.replace(new RegExp(domUtils.fillChar, "g"), "");if (!ignoreBlank) {
      htmlstr = htmlstr.replace(new RegExp("[\\r\\t\\n" + (ignoreBlank ? "" : " ") + "]*</?(\\w+)\\s*(?:[^>]*)>[\\r\\t\\n" + (ignoreBlank ? "" : " ") + "]*", "g"), function (a, b) {
        if (b && allowEmptyTags[b.toLowerCase()]) {
          return a.replace(/(^[\n\r]+)|([\n\r]+$)/g, "");
        }return a.replace(new RegExp("^[\\r\\n" + (ignoreBlank ? "" : " ") + "]+"), "").replace(new RegExp("[\\r\\n" + (ignoreBlank ? "" : " ") + "]+$"), "");
      });
    }var notTransAttrs = { "href": 1, "src": 1 };var uNode = UE.uNode,
        needParentNode = { "td": "tr", "tr": ["tbody", "thead", "tfoot"], "tbody": "table", "th": "tr", "thead": "table", "tfoot": "table", "caption": "table", "li": ["ul", "ol"], "dt": "dl", "dd": "dl", "option": "select" },
        needChild = { "ol": "li", "ul": "li" };function text(parent, data) {
      if (needChild[parent.tagName]) {
        var tmpNode = uNode.createElement(needChild[parent.tagName]);parent.appendChild(tmpNode);tmpNode.appendChild(uNode.createText(data));parent = tmpNode;
      } else {
        parent.appendChild(uNode.createText(data));
      }
    }function element(parent, tagName, htmlattr) {
      var needParentTag;if (needParentTag = needParentNode[tagName]) {
        var tmpParent = parent,
            hasParent;while (tmpParent.type != "root") {
          if (utils.isArray(needParentTag) ? utils.indexOf(needParentTag, tmpParent.tagName) != -1 : needParentTag == tmpParent.tagName) {
            parent = tmpParent;hasParent = true;break;
          }tmpParent = tmpParent.parentNode;
        }if (!hasParent) {
          parent = element(parent, utils.isArray(needParentTag) ? needParentTag[0] : needParentTag);
        }
      }var elm = new uNode({ parentNode: parent, type: "element", tagName: tagName.toLowerCase(), children: dtd.$empty[tagName] ? null : [] });if (htmlattr) {
        var attrs = {},
            match;while (match = re_attr.exec(htmlattr)) {
          attrs[match[1].toLowerCase()] = notTransAttrs[match[1].toLowerCase()] ? match[2] || match[3] || match[4] : utils.unhtml(match[2] || match[3] || match[4]);
        }elm.attrs = attrs;
      }parent.children.push(elm);return dtd.$empty[tagName] ? parent : elm;
    }function comment(parent, data) {
      parent.children.push(new uNode({ type: "comment", data: data, parentNode: parent }));
    }var match,
        currentIndex = 0,
        nextIndex = 0;var root = new uNode({ type: "root", children: [] });var currentParent = root;while (match = re_tag.exec(htmlstr)) {
      currentIndex = match.index;try {
        if (currentIndex > nextIndex) {
          text(currentParent, htmlstr.slice(nextIndex, currentIndex));
        }if (match[3]) {
          if (dtd.$cdata[currentParent.tagName]) {
            text(currentParent, match[0]);
          } else {
            currentParent = element(currentParent, match[3].toLowerCase(), match[4]);
          }
        } else {
          if (match[1]) {
            if (currentParent.type != "root") {
              if (dtd.$cdata[currentParent.tagName] && !dtd.$cdata[match[1]]) {
                text(currentParent, match[0]);
              } else {
                var tmpParent = currentParent;while (currentParent.type == "element" && currentParent.tagName != match[1].toLowerCase()) {
                  currentParent = currentParent.parentNode;if (currentParent.type == "root") {
                    currentParent = tmpParent;throw "break";
                  }
                }currentParent = currentParent.parentNode;
              }
            }
          } else {
            if (match[2]) {
              comment(currentParent, match[2]);
            }
          }
        }
      } catch (e) {}nextIndex = re_tag.lastIndex;
    }if (nextIndex < htmlstr.length) {
      text(currentParent, htmlstr.slice(nextIndex));
    }return root;
  };var filterNode = UE.filterNode = function () {
    function filterNode(node, rules) {
      switch (node.type) {case "text":
          break;case "element":
          var val;if (val = rules[node.tagName]) {
            if (val === "-") {
              node.parentNode.removeChild(node);
            } else {
              if (utils.isFunction(val)) {
                var parentNode = node.parentNode,
                    index = node.getIndex();val(node);if (node.parentNode) {
                  if (node.children) {
                    for (var i = 0, ci; ci = node.children[i];) {
                      filterNode(ci, rules);if (ci.parentNode) {
                        i++;
                      }
                    }
                  }
                } else {
                  for (var i = index, ci; ci = parentNode.children[i];) {
                    filterNode(ci, rules);if (ci.parentNode) {
                      i++;
                    }
                  }
                }
              } else {
                var attrs = val["$"];if (attrs && node.attrs) {
                  var tmpAttrs = {},
                      tmpVal;for (var a in attrs) {
                    tmpVal = node.getAttr(a);if (a == "style" && utils.isArray(attrs[a])) {
                      var tmpCssStyle = [];utils.each(attrs[a], function (v) {
                        var tmp;if (tmp = node.getStyle(v)) {
                          tmpCssStyle.push(v + ":" + tmp);
                        }
                      });tmpVal = tmpCssStyle.join(";");
                    }if (tmpVal) {
                      tmpAttrs[a] = tmpVal;
                    }
                  }node.attrs = tmpAttrs;
                }if (node.children) {
                  for (var i = 0, ci; ci = node.children[i];) {
                    filterNode(ci, rules);if (ci.parentNode) {
                      i++;
                    }
                  }
                }
              }
            }
          } else {
            if (dtd.$cdata[node.tagName]) {
              node.parentNode.removeChild(node);
            } else {
              var parentNode = node.parentNode,
                  index = node.getIndex();node.parentNode.removeChild(node, true);for (var i = index, ci; ci = parentNode.children[i];) {
                filterNode(ci, rules);if (ci.parentNode) {
                  i++;
                }
              }
            }
          }break;case "comment":
          node.parentNode.removeChild(node);}
    }return function (root, rules) {
      if (utils.isEmptyObject(rules)) {
        return root;
      }var val;if (val = rules["-"]) {
        utils.each(val.split(" "), function (k) {
          rules[k] = "-";
        });
      }for (var i = 0, ci; ci = root.children[i];) {
        filterNode(ci, rules);if (ci.parentNode) {
          i++;
        }
      }return root;
    };
  }();UE.plugin = function () {
    var _plugins = {};return { register: function register(pluginName, fn, oldOptionName, afterDisabled) {
        if (oldOptionName && utils.isFunction(oldOptionName)) {
          afterDisabled = oldOptionName;oldOptionName = null;
        }_plugins[pluginName] = { optionName: oldOptionName || pluginName, execFn: fn, afterDisabled: afterDisabled };
      }, load: function load(editor) {
        utils.each(_plugins, function (plugin) {
          var _export = plugin.execFn.call(editor);if (editor.options[plugin.optionName] !== false) {
            if (_export) {
              utils.each(_export, function (v, k) {
                switch (k.toLowerCase()) {case "shortcutkey":
                    editor.addshortcutkey(v);break;case "bindevents":
                    utils.each(v, function (fn, eventName) {
                      editor.addListener(eventName, fn);
                    });break;case "bindmultievents":
                    utils.each(utils.isArray(v) ? v : [v], function (event) {
                      var types = utils.trim(event.type).split(/\s+/);utils.each(types, function (eventName) {
                        editor.addListener(eventName, event.handler);
                      });
                    });break;case "commands":
                    utils.each(v, function (execFn, execName) {
                      editor.commands[execName] = execFn;
                    });break;case "outputrule":
                    editor.addOutputRule(v);break;case "inputrule":
                    editor.addInputRule(v);break;case "defaultoptions":
                    editor.setOpt(v);}
              });
            }
          } else {
            if (plugin.afterDisabled) {
              plugin.afterDisabled.call(editor);
            }
          }
        });utils.each(UE.plugins, function (plugin) {
          plugin.call(editor);
        });
      }, run: function run(pluginName, editor) {
        var plugin = _plugins[pluginName];if (plugin) {
          plugin.exeFn.call(editor);
        }
      } };
  }();var keymap = UE.keymap = { "Backspace": 8, "Tab": 9, "Enter": 13, "Shift": 16, "Control": 17, "Alt": 18, "CapsLock": 20, "Esc": 27, "Spacebar": 32, "PageUp": 33, "PageDown": 34, "End": 35, "Home": 36, "Left": 37, "Up": 38, "Right": 39, "Down": 40, "Insert": 45, "Del": 46, "NumLock": 144, "Cmd": 91, "=": 187, "-": 189, "b": 66, "i": 73, "z": 90, "y": 89, "v": 86, "x": 88, "s": 83, "n": 78 };var LocalStorage = UE.LocalStorage = function () {
    var storage = window.localStorage || getUserData() || null,
        LOCAL_FILE = "localStorage";return { saveLocalData: function saveLocalData(key, data) {
        if (storage && data) {
          storage.setItem(key, data);return true;
        }return false;
      }, getLocalData: function getLocalData(key) {
        if (storage) {
          return storage.getItem(key);
        }return null;
      }, removeItem: function removeItem(key) {
        storage && storage.removeItem(key);
      } };function getUserData() {
      var container = document.createElement("div");container.style.display = "none";if (!container.addBehavior) {
        return null;
      }container.addBehavior("#default#userdata");return { getItem: function getItem(key) {
          var result = null;try {
            document.body.appendChild(container);container.load(LOCAL_FILE);result = container.getAttribute(key);document.body.removeChild(container);
          } catch (e) {}return result;
        }, setItem: function setItem(key, value) {
          document.body.appendChild(container);container.setAttribute(key, value);container.save(LOCAL_FILE);document.body.removeChild(container);
        }, removeItem: function removeItem(key) {
          document.body.appendChild(container);container.removeAttribute(key);container.save(LOCAL_FILE);document.body.removeChild(container);
        } };
    }
  }();(function () {
    var ROOTKEY = "ueditor_preference";UE.Editor.prototype.setPreferences = function (key, value) {
      var obj = {};if (utils.isString(key)) {
        obj[key] = value;
      } else {
        obj = key;
      }var data = LocalStorage.getLocalData(ROOTKEY);if (data && (data = utils.str2json(data))) {
        utils.extend(data, obj);
      } else {
        data = obj;
      }data && LocalStorage.saveLocalData(ROOTKEY, utils.json2str(data));
    };UE.Editor.prototype.getPreferences = function (key) {
      var data = LocalStorage.getLocalData(ROOTKEY);if (data && (data = utils.str2json(data))) {
        return key ? data[key] : data;
      }return null;
    };UE.Editor.prototype.removePreferences = function (key) {
      var data = LocalStorage.getLocalData(ROOTKEY);if (data && (data = utils.str2json(data))) {
        data[key] = undefined;delete data[key];
      }data && LocalStorage.saveLocalData(ROOTKEY, utils.json2str(data));
    };
  })();UE.plugins["defaultfilter"] = function () {
    var me = this;me.setOpt({ "allowDivTransToP": true, "disabledTableInTable": true });me.addInputRule(function (root) {
      var allowDivTransToP = this.options.allowDivTransToP;var val;function tdParent(node) {
        while (node && node.type == "element") {
          if (node.tagName == "td") {
            return true;
          }node = node.parentNode;
        }return false;
      }root.traversal(function (node) {
        if (node.type == "element") {
          if (!dtd.$cdata[node.tagName] && me.options.autoClearEmptyNode && dtd.$inline[node.tagName] && !dtd.$empty[node.tagName] && (!node.attrs || utils.isEmptyObject(node.attrs))) {
            if (!node.firstChild()) {
              node.parentNode.removeChild(node);
            } else {
              if (node.tagName == "span" && (!node.attrs || utils.isEmptyObject(node.attrs))) {
                node.parentNode.removeChild(node, true);
              }
            }return;
          }switch (node.tagName) {case "style":case "script":
              node.setAttr({ cdata_tag: node.tagName, cdata_data: node.innerHTML() || "", "_ue_custom_node_": "true" });node.tagName = "div";node.innerHTML("");break;case "a":
              if (val = node.getAttr("href")) {
                node.setAttr("_href", val);
              }break;case "img":
              if (val = node.getAttr("src")) {
                if (/^data:/.test(val)) {
                  node.parentNode.removeChild(node);break;
                }
              }node.setAttr("_src", node.getAttr("src"));break;case "span":
              if (browser.webkit && (val = node.getStyle("white-space"))) {
                if (/nowrap|normal/.test(val)) {
                  node.setStyle("white-space", "");if (me.options.autoClearEmptyNode && utils.isEmptyObject(node.attrs)) {
                    node.parentNode.removeChild(node, true);
                  }
                }
              }val = node.getAttr("id");if (val && /^_baidu_bookmark_/i.test(val)) {
                node.parentNode.removeChild(node);
              }break;case "p":
              if (val = node.getAttr("align")) {
                node.setAttr("align");node.setStyle("text-align", val);
              }utils.each(node.children, function (n) {
                if (n.type == "element" && n.tagName == "p") {
                  var next = n.nextSibling();node.parentNode.insertAfter(n, node);var last = n;while (next) {
                    var tmp = next.nextSibling();node.parentNode.insertAfter(next, last);last = next;next = tmp;
                  }return false;
                }
              });if (!node.firstChild()) {
                node.innerHTML(browser.ie ? "&nbsp;" : "<br/>");
              }break;case "div":
              if (node.getAttr("cdata_tag")) {
                break;
              }val = node.getAttr("class");if (val && /^line number\d+/.test(val)) {
                break;
              }if (!allowDivTransToP) {
                break;
              }var tmpNode,
                  p = UE.uNode.createElement("p");while (tmpNode = node.firstChild()) {
                if (tmpNode.type == "text" || !UE.dom.dtd.$block[tmpNode.tagName]) {
                  p.appendChild(tmpNode);
                } else {
                  if (p.firstChild()) {
                    node.parentNode.insertBefore(p, node);p = UE.uNode.createElement("p");
                  } else {
                    node.parentNode.insertBefore(tmpNode, node);
                  }
                }
              }if (p.firstChild()) {
                node.parentNode.insertBefore(p, node);
              }node.parentNode.removeChild(node);break;case "dl":
              node.tagName = "ul";break;case "dt":case "dd":
              node.tagName = "li";break;case "li":
              var className = node.getAttr("class");if (!className || !/list\-/.test(className)) {
                node.setAttr();
              }var tmpNodes = node.getNodesByTagName("ol ul");UE.utils.each(tmpNodes, function (n) {
                node.parentNode.insertAfter(n, node);
              });break;case "td":case "th":case "caption":
              if (!node.children || !node.children.length) {
                node.appendChild(browser.ie11below ? UE.uNode.createText(" ") : UE.uNode.createElement("br"));
              }break;case "table":
              if (me.options.disabledTableInTable && tdParent(node)) {
                node.parentNode.insertBefore(UE.uNode.createText(node.innerText()), node);node.parentNode.removeChild(node);
              }}
        }
      });
    });me.addOutputRule(function (root) {
      var val;root.traversal(function (node) {
        if (node.type == "element") {
          if (me.options.autoClearEmptyNode && dtd.$inline[node.tagName] && !dtd.$empty[node.tagName] && (!node.attrs || utils.isEmptyObject(node.attrs))) {
            if (!node.firstChild()) {
              node.parentNode.removeChild(node);
            } else {
              if (node.tagName == "span" && (!node.attrs || utils.isEmptyObject(node.attrs))) {
                node.parentNode.removeChild(node, true);
              }
            }return;
          }switch (node.tagName) {case "div":
              if (val = node.getAttr("cdata_tag")) {
                node.tagName = val;node.appendChild(UE.uNode.createText(node.getAttr("cdata_data")));node.setAttr({ cdata_tag: "", cdata_data: "", "_ue_custom_node_": "" });
              }break;case "a":
              if (val = node.getAttr("_href")) {
                node.setAttr({ "href": utils.html(val), "_href": "" });
              }break;break;case "span":
              val = node.getAttr("id");if (val && /^_baidu_bookmark_/i.test(val)) {
                node.parentNode.removeChild(node);
              }break;case "img":
              if (val = node.getAttr("_src")) {
                node.setAttr({ "src": node.getAttr("_src"), "_src": "" });
              }}
        }
      });
    });
  };UE.commands["inserthtml"] = { execCommand: function execCommand(command, html, notNeedFilter) {
      var me = this,
          range,
          div;if (!html) {
        return;
      }if (me.fireEvent("beforeinserthtml", html) === true) {
        return;
      }range = me.selection.getRange();div = range.document.createElement("div");div.style.display = "inline";if (!notNeedFilter) {
        var root = UE.htmlparser(html);if (me.options.filterRules) {
          UE.filterNode(root, me.options.filterRules);
        }me.filterInputRule(root);html = root.toHtml();
      }div.innerHTML = utils.trim(html);if (!range.collapsed) {
        var tmpNode = range.startContainer;if (domUtils.isFillChar(tmpNode)) {
          range.setStartBefore(tmpNode);
        }tmpNode = range.endContainer;if (domUtils.isFillChar(tmpNode)) {
          range.setEndAfter(tmpNode);
        }range.txtToElmBoundary();if (range.endContainer && range.endContainer.nodeType == 1) {
          tmpNode = range.endContainer.childNodes[range.endOffset];if (tmpNode && domUtils.isBr(tmpNode)) {
            range.setEndAfter(tmpNode);
          }
        }if (range.startOffset == 0) {
          tmpNode = range.startContainer;if (domUtils.isBoundaryNode(tmpNode, "firstChild")) {
            tmpNode = range.endContainer;if (range.endOffset == (tmpNode.nodeType == 3 ? tmpNode.nodeValue.length : tmpNode.childNodes.length) && domUtils.isBoundaryNode(tmpNode, "lastChild")) {
              me.body.innerHTML = "<p>" + (browser.ie ? "" : "<br/>") + "</p>";range.setStart(me.body.firstChild, 0).collapse(true);
            }
          }
        }!range.collapsed && range.deleteContents();if (range.startContainer.nodeType == 1) {
          var child = range.startContainer.childNodes[range.startOffset],
              pre;if (child && domUtils.isBlockElm(child) && (pre = child.previousSibling) && domUtils.isBlockElm(pre)) {
            range.setEnd(pre, pre.childNodes.length).collapse();while (child.firstChild) {
              pre.appendChild(child.firstChild);
            }domUtils.remove(child);
          }
        }
      }var child,
          parent,
          pre,
          tmp,
          hadBreak = 0,
          nextNode;if (range.inFillChar()) {
        child = range.startContainer;if (domUtils.isFillChar(child)) {
          range.setStartBefore(child).collapse(true);domUtils.remove(child);
        } else {
          if (domUtils.isFillChar(child, true)) {
            child.nodeValue = child.nodeValue.replace(fillCharReg, "");range.startOffset--;range.collapsed && range.collapse(true);
          }
        }
      }var li = domUtils.findParentByTagName(range.startContainer, "li", true);if (li) {
        var next, last;while (child = div.firstChild) {
          while (child && (child.nodeType == 3 || !domUtils.isBlockElm(child) || child.tagName == "HR")) {
            next = child.nextSibling;range.insertNode(child).collapse();last = child;child = next;
          }if (child) {
            if (/^(ol|ul)$/i.test(child.tagName)) {
              while (child.firstChild) {
                last = child.firstChild;domUtils.insertAfter(li, child.firstChild);li = li.nextSibling;
              }domUtils.remove(child);
            } else {
              var tmpLi;next = child.nextSibling;tmpLi = me.document.createElement("li");domUtils.insertAfter(li, tmpLi);tmpLi.appendChild(child);last = child;child = next;li = tmpLi;
            }
          }
        }li = domUtils.findParentByTagName(range.startContainer, "li", true);if (domUtils.isEmptyBlock(li)) {
          domUtils.remove(li);
        }if (last) {
          range.setStartAfter(last).collapse(true).select(true);
        }
      } else {
        while (child = div.firstChild) {
          if (hadBreak) {
            var p = me.document.createElement("p");while (child && (child.nodeType == 3 || !dtd.$block[child.tagName])) {
              nextNode = child.nextSibling;p.appendChild(child);child = nextNode;
            }if (p.firstChild) {
              child = p;
            }
          }range.insertNode(child);nextNode = child.nextSibling;if (!hadBreak && child.nodeType == domUtils.NODE_ELEMENT && domUtils.isBlockElm(child)) {
            parent = domUtils.findParent(child, function (node) {
              return domUtils.isBlockElm(node);
            });if (parent && parent.tagName.toLowerCase() != "body" && !(dtd[parent.tagName][child.nodeName] && child.parentNode === parent)) {
              if (!dtd[parent.tagName][child.nodeName]) {
                pre = parent;
              } else {
                tmp = child.parentNode;while (tmp !== parent) {
                  pre = tmp;tmp = tmp.parentNode;
                }
              }domUtils.breakParent(child, pre || tmp);var pre = child.previousSibling;domUtils.trimWhiteTextNode(pre);if (!pre.childNodes.length) {
                domUtils.remove(pre);
              }if (!browser.ie && (next = child.nextSibling) && domUtils.isBlockElm(next) && next.lastChild && !domUtils.isBr(next.lastChild)) {
                next.appendChild(me.document.createElement("br"));
              }hadBreak = 1;
            }
          }var next = child.nextSibling;if (!div.firstChild && next && domUtils.isBlockElm(next)) {
            range.setStart(next, 0).collapse(true);break;
          }range.setEndAfter(child).collapse();
        }child = range.startContainer;if (nextNode && domUtils.isBr(nextNode)) {
          domUtils.remove(nextNode);
        }if (domUtils.isBlockElm(child) && domUtils.isEmptyNode(child)) {
          if (nextNode = child.nextSibling) {
            domUtils.remove(child);if (nextNode.nodeType == 1 && dtd.$block[nextNode.tagName]) {
              range.setStart(nextNode, 0).collapse(true).shrinkBoundary();
            }
          } else {
            try {
              child.innerHTML = browser.ie ? domUtils.fillChar : "<br/>";
            } catch (e) {
              range.setStartBefore(child);domUtils.remove(child);
            }
          }
        }try {
          range.select(true);
        } catch (e) {}
      }setTimeout(function () {
        range = me.selection.getRange();range.scrollToView(me.autoHeightEnabled, me.autoHeightEnabled ? domUtils.getXY(me.iframe).y : 0);me.fireEvent("afterinserthtml", html);
      }, 200);
    } };UE.plugin.register("autosubmit", function () {
    return { shortcutkey: { "autosubmit": "ctrl+13" }, commands: { "autosubmit": { execCommand: function execCommand() {
            var me = this,
                form = domUtils.findParentByTagName(me.iframe, "form", false);if (form) {
              if (me.fireEvent("beforesubmit") === false) {
                return;
              }me.sync();form.submit();
            }
          } } } };
  });UE.plugin.register("background", function () {
    var me = this,
        cssRuleId = "editor_background",
        isSetColored,
        reg = new RegExp("body[\\s]*\\{(.+)\\}", "i");function stringToObj(str) {
      var obj = {},
          styles = str.split(";");utils.each(styles, function (v) {
        var index = v.indexOf(":"),
            key = utils.trim(v.substr(0, index)).toLowerCase();key && (obj[key] = utils.trim(v.substr(index + 1) || ""));
      });return obj;
    }function setBackground(obj) {
      if (obj) {
        var styles = [];for (var name in obj) {
          if (obj.hasOwnProperty(name)) {
            styles.push(name + ":" + obj[name] + "; ");
          }
        }utils.cssRule(cssRuleId, styles.length ? "body{" + styles.join("") + "}" : "", me.document);
      } else {
        utils.cssRule(cssRuleId, "", me.document);
      }
    }var orgFn = me.hasContents;me.hasContents = function () {
      if (me.queryCommandValue("background")) {
        return true;
      }return orgFn.apply(me, arguments);
    };return { bindEvents: { "getAllHtml": function getAllHtml(type, headHtml) {
          var body = this.body,
              su = domUtils.getComputedStyle(body, "background-image"),
              url = "";if (su.indexOf(me.options.imagePath) > 0) {
            url = su.substring(su.indexOf(me.options.imagePath), su.length - 1).replace(/"|\(|\)/ig, "");
          } else {
            url = su != "none" ? su.replace(/url\("?|"?\)/ig, "") : "";
          }var html = '<style type="text/css">body{';var bgObj = { "background-color": domUtils.getComputedStyle(body, "background-color") || "#ffffff", "background-image": url ? "url(" + url + ")" : "", "background-repeat": domUtils.getComputedStyle(body, "background-repeat") || "", "background-position": browser.ie ? domUtils.getComputedStyle(body, "background-position-x") + " " + domUtils.getComputedStyle(body, "background-position-y") : domUtils.getComputedStyle(body, "background-position"), "height": domUtils.getComputedStyle(body, "height") };for (var name in bgObj) {
            if (bgObj.hasOwnProperty(name)) {
              html += name + ":" + bgObj[name] + "; ";
            }
          }html += "}</style> ";headHtml.push(html);
        }, "aftersetcontent": function aftersetcontent() {
          if (isSetColored == false) {
            setBackground();
          }
        } }, inputRule: function inputRule(root) {
        isSetColored = false;utils.each(root.getNodesByTagName("p"), function (p) {
          var styles = p.getAttr("data-background");if (styles) {
            isSetColored = true;setBackground(stringToObj(styles));p.parentNode.removeChild(p);
          }
        });
      }, outputRule: function outputRule(root) {
        var me = this,
            styles = (utils.cssRule(cssRuleId, me.document) || "").replace(/[\n\r]+/g, "").match(reg);if (styles) {
          root.appendChild(UE.uNode.createElement('<p style="display:none;" data-background="' + utils.trim(styles[1].replace(/"/g, "").replace(/[\s]+/g, " ")) + '"><br/></p>'));
        }
      }, commands: { "background": { execCommand: function execCommand(cmd, obj) {
            setBackground(obj);
          }, queryCommandValue: function queryCommandValue() {
            var me = this,
                styles = (utils.cssRule(cssRuleId, me.document) || "").replace(/[\n\r]+/g, "").match(reg);return styles ? stringToObj(styles[1]) : null;
          }, notNeedUndo: true } } };
  });UE.commands["imagefloat"] = { execCommand: function execCommand(cmd, align) {
      var me = this,
          range = me.selection.getRange();if (!range.collapsed) {
        var img = range.getClosedNode();if (img && img.tagName == "IMG") {
          switch (align) {case "left":case "right":case "none":
              var pN = img.parentNode,
                  tmpNode,
                  pre,
                  next;while (dtd.$inline[pN.tagName] || pN.tagName == "A") {
                pN = pN.parentNode;
              }tmpNode = pN;if (tmpNode.tagName == "P" && domUtils.getStyle(tmpNode, "text-align") == "center") {
                if (!domUtils.isBody(tmpNode) && domUtils.getChildCount(tmpNode, function (node) {
                  return !domUtils.isBr(node) && !domUtils.isWhitespace(node);
                }) == 1) {
                  pre = tmpNode.previousSibling;next = tmpNode.nextSibling;if (pre && next && pre.nodeType == 1 && next.nodeType == 1 && pre.tagName == next.tagName && domUtils.isBlockElm(pre)) {
                    pre.appendChild(tmpNode.firstChild);while (next.firstChild) {
                      pre.appendChild(next.firstChild);
                    }domUtils.remove(tmpNode);domUtils.remove(next);
                  } else {
                    domUtils.setStyle(tmpNode, "text-align", "");
                  }
                }range.selectNode(img).select();
              }domUtils.setStyle(img, "float", align == "none" ? "" : align);if (align == "none") {
                domUtils.removeAttributes(img, "align");
              }break;case "center":
              if (me.queryCommandValue("imagefloat") != "center") {
                var pN = img.parentNode;domUtils.setStyle(img, "float", "");domUtils.removeAttributes(img, "align");var tmpNode = img;while (pN && domUtils.getChildCount(pN, function (node) {
                  return !domUtils.isBr(node) && !domUtils.isWhitespace(node);
                }) == 1 && (dtd.$inline[pN.tagName] || pN.tagName == "A")) {
                  tmpNode = pN;pN = pN.parentNode;
                }range.setStartBefore(tmpNode).setCursor(false);pN = me.document.createElement("div");pN.appendChild(tmpNode);domUtils.setStyle(tmpNode, "float", "");me.execCommand("insertHtml", '<p id="_img_parent_tmp" style="text-align:center">' + pN.innerHTML + "</p>");tmpNode = me.document.getElementById("_img_parent_tmp");if (tmpNode) {
                  tmpNode.removeAttribute("id");tmpNode = tmpNode.firstChild;range.selectNode(tmpNode).select();next = tmpNode.parentNode.nextSibling;if (next && domUtils.isEmptyNode(next)) {
                    domUtils.remove(next);
                  }
                }
              }break;}
        }
      }
    }, queryCommandValue: function queryCommandValue() {
      var range = this.selection.getRange(),
          startNode,
          floatStyle;if (range.collapsed) {
        return "none";
      }startNode = range.getClosedNode();if (startNode && startNode.nodeType == 1 && startNode.tagName == "IMG") {
        floatStyle = domUtils.getComputedStyle(startNode, "float") || startNode.getAttribute("align");if (floatStyle == "none") {
          floatStyle = domUtils.getComputedStyle(startNode.parentNode, "text-align") == "center" ? "center" : floatStyle;
        }return { left: 1, right: 1, center: 1 }[floatStyle] ? floatStyle : "none";
      }return "none";
    }, queryCommandState: function queryCommandState() {
      var range = this.selection.getRange(),
          startNode;if (range.collapsed) {
        return -1;
      }startNode = range.getClosedNode();if (startNode && startNode.nodeType == 1 && startNode.tagName == "IMG") {
        return 0;
      }return -1;
    } };UE.commands["insertimage"] = { execCommand: function execCommand(cmd, opt) {
      opt = utils.isArray(opt) ? opt : [opt];if (!opt.length) {
        return;
      }var me = this,
          range = me.selection.getRange(),
          img = range.getClosedNode();if (me.fireEvent("beforeinsertimage", opt) === true) {
        return;
      }function unhtmlData(imgCi) {
        utils.each("width,height,border,hspace,vspace".split(","), function (item) {
          if (imgCi[item]) {
            imgCi[item] = parseInt(imgCi[item], 10) || 0;
          }
        });utils.each("src,_src".split(","), function (item) {
          if (imgCi[item]) {
            imgCi[item] = utils.unhtmlForUrl(imgCi[item]);
          }
        });utils.each("title,alt".split(","), function (item) {
          if (imgCi[item]) {
            imgCi[item] = utils.unhtml(imgCi[item]);
          }
        });
      }if (img && /img/i.test(img.tagName) && (img.className != "edui-faked-video" || img.className.indexOf("edui-upload-video") != -1) && !img.getAttribute("word_img")) {
        var first = opt.shift();var floatStyle = first["floatStyle"];delete first["floatStyle"];domUtils.setAttributes(img, first);me.execCommand("imagefloat", floatStyle);if (opt.length > 0) {
          range.setStartAfter(img).setCursor(false, true);me.execCommand("insertimage", opt);
        }
      } else {
        var html = [],
            str = "",
            ci;ci = opt[0];if (opt.length == 1) {
          unhtmlData(ci);str = '<img src="' + ci.src + '" ' + (ci._src ? ' _src="' + ci._src + '" ' : "") + (ci.width ? 'width="' + ci.width + '" ' : "") + (ci.height ? ' height="' + ci.height + '" ' : "") + (ci["floatStyle"] == "left" || ci["floatStyle"] == "right" ? ' style="float:' + ci["floatStyle"] + ';"' : "") + (ci.title && ci.title != "" ? ' title="' + ci.title + '"' : "") + (ci.border && ci.border != "0" ? ' border="' + ci.border + '"' : "") + (ci.alt && ci.alt != "" ? ' alt="' + ci.alt + '"' : "") + (ci.hspace && ci.hspace != "0" ? ' hspace = "' + ci.hspace + '"' : "") + (ci.vspace && ci.vspace != "0" ? ' vspace = "' + ci.vspace + '"' : "") + "/>";if (ci["floatStyle"] == "center") {
            str = '<p style="text-align: center">' + str + "</p>";
          }html.push(str);
        } else {
          for (var i = 0; ci = opt[i++];) {
            unhtmlData(ci);str = "<p " + (ci["floatStyle"] == "center" ? 'style="text-align: center" ' : "") + '><img src="' + ci.src + '" ' + (ci.width ? 'width="' + ci.width + '" ' : "") + (ci._src ? ' _src="' + ci._src + '" ' : "") + (ci.height ? ' height="' + ci.height + '" ' : "") + ' style="' + (ci["floatStyle"] && ci["floatStyle"] != "center" ? "float:" + ci["floatStyle"] + ";" : "") + (ci.border || "") + '" ' + (ci.title ? ' title="' + ci.title + '"' : "") + " /></p>";html.push(str);
          }
        }me.execCommand("insertHtml", html.join(""));
      }me.fireEvent("afterinsertimage", opt);
    } };UE.plugins["justify"] = function () {
    var me = this,
        block = domUtils.isBlockElm,
        defaultValue = { left: 1, right: 1, center: 1, justify: 1 },
        doJustify = function doJustify(range, style) {
      var bookmark = range.createBookmark(),
          filterFn = function filterFn(node) {
        return node.nodeType == 1 ? node.tagName.toLowerCase() != "br" && !domUtils.isBookmarkNode(node) : !domUtils.isWhitespace(node);
      };range.enlarge(true);var bookmark2 = range.createBookmark(),
          current = domUtils.getNextDomNode(bookmark2.start, false, filterFn),
          tmpRange = range.cloneRange(),
          tmpNode;while (current && !(domUtils.getPosition(current, bookmark2.end) & domUtils.POSITION_FOLLOWING)) {
        if (current.nodeType == 3 || !block(current)) {
          tmpRange.setStartBefore(current);while (current && current !== bookmark2.end && !block(current)) {
            tmpNode = current;current = domUtils.getNextDomNode(current, false, null, function (node) {
              return !block(node);
            });
          }tmpRange.setEndAfter(tmpNode);var common = tmpRange.getCommonAncestor();if (!domUtils.isBody(common) && block(common)) {
            domUtils.setStyles(common, utils.isString(style) ? { "text-align": style } : style);current = common;
          } else {
            var p = range.document.createElement("p");domUtils.setStyles(p, utils.isString(style) ? { "text-align": style } : style);var frag = tmpRange.extractContents();p.appendChild(frag);tmpRange.insertNode(p);current = p;
          }current = domUtils.getNextDomNode(current, false, filterFn);
        } else {
          current = domUtils.getNextDomNode(current, true, filterFn);
        }
      }return range.moveToBookmark(bookmark2).moveToBookmark(bookmark);
    };UE.commands["justify"] = { execCommand: function execCommand(cmdName, align) {
        var range = this.selection.getRange(),
            txt;if (range.collapsed) {
          txt = this.document.createTextNode("p");range.insertNode(txt);
        }doJustify(range, align);if (txt) {
          range.setStartBefore(txt).collapse(true);domUtils.remove(txt);
        }range.select();return true;
      }, queryCommandValue: function queryCommandValue() {
        var startNode = this.selection.getStart(),
            value = domUtils.getComputedStyle(startNode, "text-align");return defaultValue[value] ? value : "left";
      }, queryCommandState: function queryCommandState() {
        var start = this.selection.getStart(),
            cell = start && domUtils.findParentByTagName(start, ["td", "th", "caption"], true);return cell ? -1 : 0;
      } };
  };UE.plugins["font"] = function () {
    var me = this,
        fonts = { "forecolor": "color", "backcolor": "background-color", "fontsize": "font-size", "fontfamily": "font-family", "underline": "text-decoration", "strikethrough": "text-decoration", "fontborder": "border" },
        needCmd = { "underline": 1, "strikethrough": 1, "fontborder": 1 },
        needSetChild = { "forecolor": "color", "backcolor": "background-color", "fontsize": "font-size", "fontfamily": "font-family" };me.setOpt({ "fontfamily": [{ name: "songti", val: "宋体,SimSun" }, { name: "yahei", val: "微软雅黑,Microsoft YaHei" }, { name: "kaiti", val: "楷体,楷体_GB2312, SimKai" }, { name: "heiti", val: "黑体, SimHei" }, { name: "lishu", val: "隶书, SimLi" }, { name: "andaleMono", val: "andale mono" }, { name: "arial", val: "arial, helvetica,sans-serif" }, { name: "arialBlack", val: "arial black,avant garde" }, { name: "comicSansMs", val: "comic sans ms" }, { name: "impact", val: "impact,chicago" }, { name: "timesNewRoman", val: "times new roman" }], "fontsize": [10, 11, 12, 14, 16, 18, 20, 24, 36] });function mergeWithParent(node) {
      var parent;while (parent = node.parentNode) {
        if (parent.tagName == "SPAN" && domUtils.getChildCount(parent, function (child) {
          return !domUtils.isBookmarkNode(child) && !domUtils.isBr(child);
        }) == 1) {
          parent.style.cssText += node.style.cssText;domUtils.remove(node, true);node = parent;
        } else {
          break;
        }
      }
    }function mergeChild(rng, cmdName, value) {
      if (needSetChild[cmdName]) {
        rng.adjustmentBoundary();if (!rng.collapsed && rng.startContainer.nodeType == 1) {
          var start = rng.startContainer.childNodes[rng.startOffset];if (start && domUtils.isTagNode(start, "span")) {
            var bk = rng.createBookmark();utils.each(domUtils.getElementsByTagName(start, "span"), function (span) {
              if (!span.parentNode || domUtils.isBookmarkNode(span)) {
                return;
              }if (cmdName == "backcolor" && domUtils.getComputedStyle(span, "background-color").toLowerCase() === value) {
                return;
              }domUtils.removeStyle(span, needSetChild[cmdName]);if (span.style.cssText.replace(/^\s+$/, "").length == 0) {
                domUtils.remove(span, true);
              }
            });rng.moveToBookmark(bk);
          }
        }
      }
    }function mergesibling(rng, cmdName, value) {
      var collapsed = rng.collapsed,
          bk = rng.createBookmark(),
          common;if (collapsed) {
        common = bk.start.parentNode;while (dtd.$inline[common.tagName]) {
          common = common.parentNode;
        }
      } else {
        common = domUtils.getCommonAncestor(bk.start, bk.end);
      }utils.each(domUtils.getElementsByTagName(common, "span"), function (span) {
        if (!span.parentNode || domUtils.isBookmarkNode(span)) {
          return;
        }if (/\s*border\s*:\s*none;?\s*/i.test(span.style.cssText)) {
          if (/^\s*border\s*:\s*none;?\s*$/.test(span.style.cssText)) {
            domUtils.remove(span, true);
          } else {
            domUtils.removeStyle(span, "border");
          }return;
        }if (/border/i.test(span.style.cssText) && span.parentNode.tagName == "SPAN" && /border/i.test(span.parentNode.style.cssText)) {
          span.style.cssText = span.style.cssText.replace(/border[^:]*:[^;]+;?/gi, "");
        }if (!(cmdName == "fontborder" && value == "none")) {
          var next = span.nextSibling;while (next && next.nodeType == 1 && next.tagName == "SPAN") {
            if (domUtils.isBookmarkNode(next) && cmdName == "fontborder") {
              span.appendChild(next);next = span.nextSibling;continue;
            }if (next.style.cssText == span.style.cssText) {
              domUtils.moveChild(next, span);domUtils.remove(next);
            }if (span.nextSibling === next) {
              break;
            }next = span.nextSibling;
          }
        }mergeWithParent(span);if (browser.ie && browser.version > 8) {
          var parent = domUtils.findParent(span, function (n) {
            return n.tagName == "SPAN" && /background-color/.test(n.style.cssText);
          });if (parent && !/background-color/.test(span.style.cssText)) {
            span.style.backgroundColor = parent.style.backgroundColor;
          }
        }
      });rng.moveToBookmark(bk);mergeChild(rng, cmdName, value);
    }me.addInputRule(function (root) {
      utils.each(root.getNodesByTagName("u s del font strike"), function (node) {
        if (node.tagName == "font") {
          var cssStyle = [];for (var p in node.attrs) {
            switch (p) {case "size":
                cssStyle.push("font-size:" + ({ "1": "10", "2": "12", "3": "16", "4": "18", "5": "24", "6": "32", "7": "48" }[node.attrs[p]] || node.attrs[p]) + "px");break;case "color":
                cssStyle.push("color:" + node.attrs[p]);break;case "face":
                cssStyle.push("font-family:" + node.attrs[p]);break;case "style":
                cssStyle.push(node.attrs[p]);}
          }node.attrs = { "style": cssStyle.join(";") };
        } else {
          var val = node.tagName == "u" ? "underline" : "line-through";node.attrs = { "style": (node.getAttr("style") || "") + "text-decoration:" + val + ";" };
        }node.tagName = "span";
      });
    });for (var p in fonts) {
      (function (cmd, style) {
        UE.commands[cmd] = { execCommand: function execCommand(cmdName, value) {
            value = value || (this.queryCommandState(cmdName) ? "none" : cmdName == "underline" ? "underline" : cmdName == "fontborder" ? "1px solid #000" : "line-through");var me = this,
                range = this.selection.getRange(),
                text;if (value == "default") {
              if (range.collapsed) {
                text = me.document.createTextNode("font");range.insertNode(text).select();
              }me.execCommand("removeFormat", "span,a", style);if (text) {
                range.setStartBefore(text).collapse(true);domUtils.remove(text);
              }mergesibling(range, cmdName, value);range.select();
            } else {
              if (!range.collapsed) {
                if (needCmd[cmd] && me.queryCommandValue(cmd)) {
                  me.execCommand("removeFormat", "span,a", style);
                }range = me.selection.getRange();range.applyInlineStyle("span", { "style": style + ":" + value });mergesibling(range, cmdName, value);range.select();
              } else {
                var span = domUtils.findParentByTagName(range.startContainer, "span", true);text = me.document.createTextNode("font");if (span && !span.children.length && !span[browser.ie ? "innerText" : "textContent"].replace(fillCharReg, "").length) {
                  range.insertNode(text);if (needCmd[cmd]) {
                    range.selectNode(text).select();me.execCommand("removeFormat", "span,a", style, null);span = domUtils.findParentByTagName(text, "span", true);range.setStartBefore(text);
                  }span && (span.style.cssText += ";" + style + ":" + value);range.collapse(true).select();
                } else {
                  range.insertNode(text);range.selectNode(text).select();span = range.document.createElement("span");if (needCmd[cmd]) {
                    if (domUtils.findParentByTagName(text, "a", true)) {
                      range.setStartBefore(text).setCursor();domUtils.remove(text);return;
                    }me.execCommand("removeFormat", "span,a", style);
                  }span.style.cssText = style + ":" + value;text.parentNode.insertBefore(span, text);if (!browser.ie || browser.ie && browser.version == 9) {
                    var spanParent = span.parentNode;while (!domUtils.isBlockElm(spanParent)) {
                      if (spanParent.tagName == "SPAN") {
                        span.style.cssText = spanParent.style.cssText + ";" + span.style.cssText;
                      }spanParent = spanParent.parentNode;
                    }
                  }if (opera) {
                    setTimeout(function () {
                      range.setStart(span, 0).collapse(true);mergesibling(range, cmdName, value);range.select();
                    });
                  } else {
                    range.setStart(span, 0).collapse(true);mergesibling(range, cmdName, value);range.select();
                  }
                }domUtils.remove(text);
              }
            }return true;
          }, queryCommandValue: function queryCommandValue(cmdName) {
            var startNode = this.selection.getStart();if (cmdName == "underline" || cmdName == "strikethrough") {
              var tmpNode = startNode,
                  value;while (tmpNode && !domUtils.isBlockElm(tmpNode) && !domUtils.isBody(tmpNode)) {
                if (tmpNode.nodeType == 1) {
                  value = domUtils.getComputedStyle(tmpNode, style);if (value != "none") {
                    return value;
                  }
                }tmpNode = tmpNode.parentNode;
              }return "none";
            }if (cmdName == "fontborder") {
              var tmp = startNode,
                  val;while (tmp && dtd.$inline[tmp.tagName]) {
                if (val = domUtils.getComputedStyle(tmp, "border")) {
                  if (/1px/.test(val) && /solid/.test(val)) {
                    return val;
                  }
                }tmp = tmp.parentNode;
              }return "";
            }if (cmdName == "FontSize") {
              var styleVal = domUtils.getComputedStyle(startNode, style),
                  tmp = /^([\d\.]+)(\w+)$/.exec(styleVal);if (tmp) {
                return Math.floor(tmp[1]) + tmp[2];
              }return styleVal;
            }return domUtils.getComputedStyle(startNode, style);
          }, queryCommandState: function queryCommandState(cmdName) {
            if (!needCmd[cmdName]) {
              return 0;
            }var val = this.queryCommandValue(cmdName);if (cmdName == "fontborder") {
              return (/1px/.test(val) && /solid/.test(val)
              );
            } else {
              return cmdName == "underline" ? /underline/.test(val) : /line\-through/.test(val);
            }
          } };
      })(p, fonts[p]);
    }
  };UE.plugins["link"] = function () {
    function optimize(range) {
      var start = range.startContainer,
          end = range.endContainer;if (start = domUtils.findParentByTagName(start, "a", true)) {
        range.setStartBefore(start);
      }if (end = domUtils.findParentByTagName(end, "a", true)) {
        range.setEndAfter(end);
      }
    }UE.commands["unlink"] = { execCommand: function execCommand() {
        var range = this.selection.getRange(),
            bookmark;if (range.collapsed && !domUtils.findParentByTagName(range.startContainer, "a", true)) {
          return;
        }bookmark = range.createBookmark();optimize(range);range.removeInlineStyle("a").moveToBookmark(bookmark).select();
      }, queryCommandState: function queryCommandState() {
        return !this.highlight && this.queryCommandValue("link") ? 0 : -1;
      } };function doLink(range, opt, me) {
      var rngClone = range.cloneRange(),
          link = me.queryCommandValue("link");optimize(range = range.adjustmentBoundary());var start = range.startContainer;if (start.nodeType == 1 && link) {
        start = start.childNodes[range.startOffset];if (start && start.nodeType == 1 && start.tagName == "A" && /^(?:https?|ftp|file)\s*:\s*\/\//.test(start[browser.ie ? "innerText" : "textContent"])) {
          start[browser.ie ? "innerText" : "textContent"] = utils.html(opt.textValue || opt.href);
        }
      }if (!rngClone.collapsed || link) {
        range.removeInlineStyle("a");rngClone = range.cloneRange();
      }if (rngClone.collapsed) {
        var a = range.document.createElement("a"),
            text = "";if (opt.textValue) {
          text = utils.html(opt.textValue);delete opt.textValue;
        } else {
          text = utils.html(opt.href);
        }domUtils.setAttributes(a, opt);start = domUtils.findParentByTagName(rngClone.startContainer, "a", true);if (start && domUtils.isInNodeEndBoundary(rngClone, start)) {
          range.setStartAfter(start).collapse(true);
        }a[browser.ie ? "innerText" : "textContent"] = text;range.insertNode(a).selectNode(a);
      } else {
        range.applyInlineStyle("a", opt);
      }
    }UE.commands["link"] = { execCommand: function execCommand(cmdName, opt) {
        var range;opt._href && (opt._href = utils.unhtml(opt._href, /[<">]/g));opt.href && (opt.href = utils.unhtml(opt.href, /[<">]/g));opt.textValue && (opt.textValue = utils.unhtml(opt.textValue, /[<">]/g));doLink(range = this.selection.getRange(), opt, this);range.collapse().select(true);
      }, queryCommandValue: function queryCommandValue() {
        var range = this.selection.getRange(),
            node;if (range.collapsed) {
          node = range.startContainer;node = node.nodeType == 1 ? node : node.parentNode;if (node && (node = domUtils.findParentByTagName(node, "a", true)) && !domUtils.isInNodeEndBoundary(range, node)) {
            return node;
          }
        } else {
          range.shrinkBoundary();var start = range.startContainer.nodeType == 3 || !range.startContainer.childNodes[range.startOffset] ? range.startContainer : range.startContainer.childNodes[range.startOffset],
              end = range.endContainer.nodeType == 3 || range.endOffset == 0 ? range.endContainer : range.endContainer.childNodes[range.endOffset - 1],
              common = range.getCommonAncestor();node = domUtils.findParentByTagName(common, "a", true);if (!node && common.nodeType == 1) {
            var as = common.getElementsByTagName("a"),
                ps,
                pe;for (var i = 0, ci; ci = as[i++];) {
              ps = domUtils.getPosition(ci, start), pe = domUtils.getPosition(ci, end);if ((ps & domUtils.POSITION_FOLLOWING || ps & domUtils.POSITION_CONTAINS) && (pe & domUtils.POSITION_PRECEDING || pe & domUtils.POSITION_CONTAINS)) {
                node = ci;break;
              }
            }
          }return node;
        }
      }, queryCommandState: function queryCommandState() {
        var img = this.selection.getRange().getClosedNode(),
            flag = img && (img.className == "edui-faked-video" || img.className.indexOf("edui-upload-video") != -1);return flag ? -1 : 0;
      } };
  };UE.plugins["insertframe"] = function () {
    var me = this;function deleteIframe() {
      me._iframe && delete me._iframe;
    }me.addListener("selectionchange", function () {
      deleteIframe();
    });
  };UE.commands["scrawl"] = { queryCommandState: function queryCommandState() {
      return browser.ie && browser.version <= 8 ? -1 : 0;
    } };UE.plugins["removeformat"] = function () {
    var me = this;me.setOpt({ "removeFormatTags": "b,big,code,del,dfn,em,font,i,ins,kbd,q,samp,small,span,strike,strong,sub,sup,tt,u,var", "removeFormatAttributes": "class,style,lang,width,height,align,hspace,valign" });me.commands["removeformat"] = { execCommand: function execCommand(cmdName, tags, style, attrs, notIncludeA) {
        var tagReg = new RegExp("^(?:" + (tags || this.options.removeFormatTags).replace(/,/g, "|") + ")$", "i"),
            removeFormatAttributes = style ? [] : (attrs || this.options.removeFormatAttributes).split(","),
            range = new dom.Range(this.document),
            bookmark,
            node,
            parent,
            filter = function filter(node) {
          return node.nodeType == 1;
        };function isRedundantSpan(node) {
          if (node.nodeType == 3 || node.tagName.toLowerCase() != "span") {
            return 0;
          }if (browser.ie) {
            var attrs = node.attributes;if (attrs.length) {
              for (var i = 0, l = attrs.length; i < l; i++) {
                if (attrs[i].specified) {
                  return 0;
                }
              }return 1;
            }
          }return !node.attributes.length;
        }function doRemove(range) {
          var bookmark1 = range.createBookmark();if (range.collapsed) {
            range.enlarge(true);
          }if (!notIncludeA) {
            var aNode = domUtils.findParentByTagName(range.startContainer, "a", true);if (aNode) {
              range.setStartBefore(aNode);
            }aNode = domUtils.findParentByTagName(range.endContainer, "a", true);if (aNode) {
              range.setEndAfter(aNode);
            }
          }bookmark = range.createBookmark();node = bookmark.start;while ((parent = node.parentNode) && !domUtils.isBlockElm(parent)) {
            domUtils.breakParent(node, parent);domUtils.clearEmptySibling(node);
          }if (bookmark.end) {
            node = bookmark.end;while ((parent = node.parentNode) && !domUtils.isBlockElm(parent)) {
              domUtils.breakParent(node, parent);domUtils.clearEmptySibling(node);
            }var current = domUtils.getNextDomNode(bookmark.start, false, filter),
                next;while (current) {
              if (current == bookmark.end) {
                break;
              }next = domUtils.getNextDomNode(current, true, filter);if (!dtd.$empty[current.tagName.toLowerCase()] && !domUtils.isBookmarkNode(current)) {
                if (tagReg.test(current.tagName)) {
                  if (style) {
                    domUtils.removeStyle(current, style);if (isRedundantSpan(current) && style != "text-decoration") {
                      domUtils.remove(current, true);
                    }
                  } else {
                    domUtils.remove(current, true);
                  }
                } else {
                  if (!dtd.$tableContent[current.tagName] && !dtd.$list[current.tagName]) {
                    domUtils.removeAttributes(current, removeFormatAttributes);if (isRedundantSpan(current)) {
                      domUtils.remove(current, true);
                    }
                  }
                }
              }current = next;
            }
          }var pN = bookmark.start.parentNode;if (domUtils.isBlockElm(pN) && !dtd.$tableContent[pN.tagName] && !dtd.$list[pN.tagName]) {
            domUtils.removeAttributes(pN, removeFormatAttributes);
          }pN = bookmark.end.parentNode;if (bookmark.end && domUtils.isBlockElm(pN) && !dtd.$tableContent[pN.tagName] && !dtd.$list[pN.tagName]) {
            domUtils.removeAttributes(pN, removeFormatAttributes);
          }range.moveToBookmark(bookmark).moveToBookmark(bookmark1);var node = range.startContainer,
              tmp,
              collapsed = range.collapsed;while (node.nodeType == 1 && domUtils.isEmptyNode(node) && dtd.$removeEmpty[node.tagName]) {
            tmp = node.parentNode;range.setStartBefore(node);if (range.startContainer === range.endContainer) {
              range.endOffset--;
            }domUtils.remove(node);node = tmp;
          }if (!collapsed) {
            node = range.endContainer;while (node.nodeType == 1 && domUtils.isEmptyNode(node) && dtd.$removeEmpty[node.tagName]) {
              tmp = node.parentNode;range.setEndBefore(node);domUtils.remove(node);node = tmp;
            }
          }
        }range = this.selection.getRange();doRemove(range);range.select();
      } };
  };UE.plugins["blockquote"] = function () {
    var me = this;function getObj(editor) {
      return domUtils.filterNodeList(editor.selection.getStartElementPath(), "blockquote");
    }me.commands["blockquote"] = { execCommand: function execCommand(cmdName, attrs) {
        var range = this.selection.getRange(),
            obj = getObj(this),
            blockquote = dtd.blockquote,
            bookmark = range.createBookmark();if (obj) {
          var start = range.startContainer,
              startBlock = domUtils.isBlockElm(start) ? start : domUtils.findParent(start, function (node) {
            return domUtils.isBlockElm(node);
          }),
              end = range.endContainer,
              endBlock = domUtils.isBlockElm(end) ? end : domUtils.findParent(end, function (node) {
            return domUtils.isBlockElm(node);
          });startBlock = domUtils.findParentByTagName(startBlock, "li", true) || startBlock;endBlock = domUtils.findParentByTagName(endBlock, "li", true) || endBlock;if (startBlock.tagName == "LI" || startBlock.tagName == "TD" || startBlock === obj || domUtils.isBody(startBlock)) {
            domUtils.remove(obj, true);
          } else {
            domUtils.breakParent(startBlock, obj);
          }if (startBlock !== endBlock) {
            obj = domUtils.findParentByTagName(endBlock, "blockquote");if (obj) {
              if (endBlock.tagName == "LI" || endBlock.tagName == "TD" || domUtils.isBody(endBlock)) {
                obj.parentNode && domUtils.remove(obj, true);
              } else {
                domUtils.breakParent(endBlock, obj);
              }
            }
          }var blockquotes = domUtils.getElementsByTagName(this.document, "blockquote");for (var i = 0, bi; bi = blockquotes[i++];) {
            if (!bi.childNodes.length) {
              domUtils.remove(bi);
            } else {
              if (domUtils.getPosition(bi, startBlock) & domUtils.POSITION_FOLLOWING && domUtils.getPosition(bi, endBlock) & domUtils.POSITION_PRECEDING) {
                domUtils.remove(bi, true);
              }
            }
          }
        } else {
          var tmpRange = range.cloneRange(),
              node = tmpRange.startContainer.nodeType == 1 ? tmpRange.startContainer : tmpRange.startContainer.parentNode,
              preNode = node,
              doEnd = 1;while (1) {
            if (domUtils.isBody(node)) {
              if (preNode !== node) {
                if (range.collapsed) {
                  tmpRange.selectNode(preNode);doEnd = 0;
                } else {
                  tmpRange.setStartBefore(preNode);
                }
              } else {
                tmpRange.setStart(node, 0);
              }break;
            }if (!blockquote[node.tagName]) {
              if (range.collapsed) {
                tmpRange.selectNode(preNode);
              } else {
                tmpRange.setStartBefore(preNode);
              }break;
            }preNode = node;node = node.parentNode;
          }if (doEnd) {
            preNode = node = node = tmpRange.endContainer.nodeType == 1 ? tmpRange.endContainer : tmpRange.endContainer.parentNode;while (1) {
              if (domUtils.isBody(node)) {
                if (preNode !== node) {
                  tmpRange.setEndAfter(preNode);
                } else {
                  tmpRange.setEnd(node, node.childNodes.length);
                }break;
              }if (!blockquote[node.tagName]) {
                tmpRange.setEndAfter(preNode);break;
              }preNode = node;node = node.parentNode;
            }
          }node = range.document.createElement("blockquote");domUtils.setAttributes(node, attrs);node.appendChild(tmpRange.extractContents());tmpRange.insertNode(node);var childs = domUtils.getElementsByTagName(node, "blockquote");for (var i = 0, ci; ci = childs[i++];) {
            if (ci.parentNode) {
              domUtils.remove(ci, true);
            }
          }
        }range.moveToBookmark(bookmark).select();
      }, queryCommandState: function queryCommandState() {
        return getObj(this) ? 1 : 0;
      } };
  };UE.commands["touppercase"] = UE.commands["tolowercase"] = { execCommand: function execCommand(cmd) {
      var me = this;var rng = me.selection.getRange();if (rng.collapsed) {
        return rng;
      }var bk = rng.createBookmark(),
          bkEnd = bk.end,
          filterFn = function filterFn(node) {
        return !domUtils.isBr(node) && !domUtils.isWhitespace(node);
      },
          curNode = domUtils.getNextDomNode(bk.start, false, filterFn);while (curNode && domUtils.getPosition(curNode, bkEnd) & domUtils.POSITION_PRECEDING) {
        if (curNode.nodeType == 3) {
          curNode.nodeValue = curNode.nodeValue[cmd == "touppercase" ? "toUpperCase" : "toLowerCase"]();
        }curNode = domUtils.getNextDomNode(curNode, true, filterFn);if (curNode === bkEnd) {
          break;
        }
      }rng.moveToBookmark(bk).select();
    } };UE.commands["indent"] = { execCommand: function execCommand() {
      var me = this,
          value = me.queryCommandState("indent") ? "0em" : me.options.indentValue || "2em";me.execCommand("Paragraph", "p", { style: "text-indent:" + value });
    }, queryCommandState: function queryCommandState() {
      var pN = domUtils.filterNodeList(this.selection.getStartElementPath(), "p h1 h2 h3 h4 h5 h6");return pN && pN.style.textIndent && parseInt(pN.style.textIndent) ? 1 : 0;
    } };UE.commands["print"] = { execCommand: function execCommand() {
      this.window.print();
    }, notNeedUndo: 1 };UE.commands["preview"] = { execCommand: function execCommand() {
      var w = window.open("", "_blank", ""),
          d = w.document;d.open();d.write('<!DOCTYPE html><html><head><meta charset="utf-8"/><script src="' + this.options.UEDITOR_HOME_URL + 'ueditor.parse.js"><\/script><script>' + "setTimeout(function(){uParse('div',{rootPath: '" + this.options.UEDITOR_HOME_URL + "'})},300)" + "<\/script></head><body><div>" + this.getContent(null, null, true) + "</div></body></html>");d.close();
    }, notNeedUndo: 1 };UE.plugins["selectall"] = function () {
    var me = this;me.commands["selectall"] = { execCommand: function execCommand() {
        var me = this,
            body = me.body,
            range = me.selection.getRange();range.selectNodeContents(body);if (domUtils.isEmptyBlock(body)) {
          if (browser.opera && body.firstChild && body.firstChild.nodeType == 1) {
            range.setStartAtFirst(body.firstChild);
          }range.collapse(true);
        }range.select(true);
      }, notNeedUndo: 1 };me.addshortcutkey({ "selectAll": "ctrl+65" });
  };UE.plugins["paragraph"] = function () {
    var me = this,
        block = domUtils.isBlockElm,
        notExchange = ["TD", "LI", "PRE"],
        doParagraph = function doParagraph(range, style, attrs, sourceCmdName) {
      var bookmark = range.createBookmark(),
          filterFn = function filterFn(node) {
        return node.nodeType == 1 ? node.tagName.toLowerCase() != "br" && !domUtils.isBookmarkNode(node) : !domUtils.isWhitespace(node);
      },
          para;range.enlarge(true);var bookmark2 = range.createBookmark(),
          current = domUtils.getNextDomNode(bookmark2.start, false, filterFn),
          tmpRange = range.cloneRange(),
          tmpNode;while (current && !(domUtils.getPosition(current, bookmark2.end) & domUtils.POSITION_FOLLOWING)) {
        if (current.nodeType == 3 || !block(current)) {
          tmpRange.setStartBefore(current);while (current && current !== bookmark2.end && !block(current)) {
            tmpNode = current;current = domUtils.getNextDomNode(current, false, null, function (node) {
              return !block(node);
            });
          }tmpRange.setEndAfter(tmpNode);para = range.document.createElement(style);if (attrs) {
            domUtils.setAttributes(para, attrs);if (sourceCmdName && sourceCmdName == "customstyle" && attrs.style) {
              para.style.cssText = attrs.style;
            }
          }para.appendChild(tmpRange.extractContents());if (domUtils.isEmptyNode(para)) {
            domUtils.fillChar(range.document, para);
          }tmpRange.insertNode(para);var parent = para.parentNode;if (block(parent) && !domUtils.isBody(para.parentNode) && utils.indexOf(notExchange, parent.tagName) == -1) {
            if (!(sourceCmdName && sourceCmdName == "customstyle")) {
              parent.getAttribute("dir") && para.setAttribute("dir", parent.getAttribute("dir"));parent.style.cssText && (para.style.cssText = parent.style.cssText + ";" + para.style.cssText);parent.style.textAlign && !para.style.textAlign && (para.style.textAlign = parent.style.textAlign);parent.style.textIndent && !para.style.textIndent && (para.style.textIndent = parent.style.textIndent);parent.style.padding && !para.style.padding && (para.style.padding = parent.style.padding);
            }if (attrs && /h\d/i.test(parent.tagName) && !/h\d/i.test(para.tagName)) {
              domUtils.setAttributes(parent, attrs);if (sourceCmdName && sourceCmdName == "customstyle" && attrs.style) {
                parent.style.cssText = attrs.style;
              }domUtils.remove(para, true);para = parent;
            } else {
              domUtils.remove(para.parentNode, true);
            }
          }if (utils.indexOf(notExchange, parent.tagName) != -1) {
            current = parent;
          } else {
            current = para;
          }current = domUtils.getNextDomNode(current, false, filterFn);
        } else {
          current = domUtils.getNextDomNode(current, true, filterFn);
        }
      }return range.moveToBookmark(bookmark2).moveToBookmark(bookmark);
    };me.setOpt("paragraph", { "p": "", "h1": "", "h2": "", "h3": "", "h4": "", "h5": "", "h6": "" });me.commands["paragraph"] = { execCommand: function execCommand(cmdName, style, attrs, sourceCmdName) {
        var range = this.selection.getRange();if (range.collapsed) {
          var txt = this.document.createTextNode("p");range.insertNode(txt);if (browser.ie) {
            var node = txt.previousSibling;if (node && domUtils.isWhitespace(node)) {
              domUtils.remove(node);
            }node = txt.nextSibling;if (node && domUtils.isWhitespace(node)) {
              domUtils.remove(node);
            }
          }
        }range = doParagraph(range, style, attrs, sourceCmdName);if (txt) {
          range.setStartBefore(txt).collapse(true);var pN = txt.parentNode;domUtils.remove(txt);if (domUtils.isBlockElm(pN) && domUtils.isEmptyNode(pN)) {
            domUtils.fillNode(this.document, pN);
          }
        }if (browser.gecko && range.collapsed && range.startContainer.nodeType == 1) {
          var child = range.startContainer.childNodes[range.startOffset];if (child && child.nodeType == 1 && child.tagName.toLowerCase() == style) {
            range.setStart(child, 0).collapse(true);
          }
        }range.select();return true;
      }, queryCommandValue: function queryCommandValue() {
        var node = domUtils.filterNodeList(this.selection.getStartElementPath(), "p h1 h2 h3 h4 h5 h6");return node ? node.tagName.toLowerCase() : "";
      } };
  };(function () {
    var block = domUtils.isBlockElm,
        getObj = function getObj(editor) {
      return domUtils.filterNodeList(editor.selection.getStartElementPath(), function (n) {
        return n && n.nodeType == 1 && n.getAttribute("dir");
      });
    },
        doDirectionality = function doDirectionality(range, editor, forward) {
      var bookmark,
          filterFn = function filterFn(node) {
        return node.nodeType == 1 ? !domUtils.isBookmarkNode(node) : !domUtils.isWhitespace(node);
      },
          obj = getObj(editor);if (obj && range.collapsed) {
        obj.setAttribute("dir", forward);return range;
      }bookmark = range.createBookmark();range.enlarge(true);var bookmark2 = range.createBookmark(),
          current = domUtils.getNextDomNode(bookmark2.start, false, filterFn),
          tmpRange = range.cloneRange(),
          tmpNode;while (current && !(domUtils.getPosition(current, bookmark2.end) & domUtils.POSITION_FOLLOWING)) {
        if (current.nodeType == 3 || !block(current)) {
          tmpRange.setStartBefore(current);while (current && current !== bookmark2.end && !block(current)) {
            tmpNode = current;current = domUtils.getNextDomNode(current, false, null, function (node) {
              return !block(node);
            });
          }tmpRange.setEndAfter(tmpNode);var common = tmpRange.getCommonAncestor();if (!domUtils.isBody(common) && block(common)) {
            common.setAttribute("dir", forward);current = common;
          } else {
            var p = range.document.createElement("p");p.setAttribute("dir", forward);var frag = tmpRange.extractContents();p.appendChild(frag);tmpRange.insertNode(p);current = p;
          }current = domUtils.getNextDomNode(current, false, filterFn);
        } else {
          current = domUtils.getNextDomNode(current, true, filterFn);
        }
      }return range.moveToBookmark(bookmark2).moveToBookmark(bookmark);
    };UE.commands["directionality"] = { execCommand: function execCommand(cmdName, forward) {
        var range = this.selection.getRange();if (range.collapsed) {
          var txt = this.document.createTextNode("d");range.insertNode(txt);
        }doDirectionality(range, this, forward);if (txt) {
          range.setStartBefore(txt).collapse(true);domUtils.remove(txt);
        }range.select();return true;
      }, queryCommandValue: function queryCommandValue() {
        var node = getObj(this);return node ? node.getAttribute("dir") : "ltr";
      } };
  })();UE.plugins["horizontal"] = function () {
    var me = this;me.commands["horizontal"] = { execCommand: function execCommand(cmdName) {
        var me = this;if (me.queryCommandState(cmdName) !== -1) {
          me.execCommand("insertHtml", "<hr>");var range = me.selection.getRange(),
              start = range.startContainer;if (start.nodeType == 1 && !start.childNodes[range.startOffset]) {
            var tmp;if (tmp = start.childNodes[range.startOffset - 1]) {
              if (tmp.nodeType == 1 && tmp.tagName == "HR") {
                if (me.options.enterTag == "p") {
                  tmp = me.document.createElement("p");range.insertNode(tmp);range.setStart(tmp, 0).setCursor();
                } else {
                  tmp = me.document.createElement("br");range.insertNode(tmp);range.setStartBefore(tmp).setCursor();
                }
              }
            }
          }return true;
        }
      }, queryCommandState: function queryCommandState() {
        return domUtils.filterNodeList(this.selection.getStartElementPath(), "table") ? -1 : 0;
      } };me.addListener("delkeydown", function (name, evt) {
      var rng = this.selection.getRange();rng.txtToElmBoundary(true);if (domUtils.isStartInblock(rng)) {
        var tmpNode = rng.startContainer;var pre = tmpNode.previousSibling;if (pre && domUtils.isTagNode(pre, "hr")) {
          domUtils.remove(pre);rng.select();domUtils.preventDefault(evt);return true;
        }
      }
    });
  };UE.commands["time"] = UE.commands["date"] = { execCommand: function execCommand(cmd, format) {
      var date = new Date();function formatTime(date, format) {
        var hh = ("0" + date.getHours()).slice(-2),
            ii = ("0" + date.getMinutes()).slice(-2),
            ss = ("0" + date.getSeconds()).slice(-2);format = format || "hh:ii:ss";return format.replace(/hh/ig, hh).replace(/ii/ig, ii).replace(/ss/ig, ss);
      }function formatDate(date, format) {
        var yyyy = ("000" + date.getFullYear()).slice(-4),
            yy = yyyy.slice(-2),
            mm = ("0" + (date.getMonth() + 1)).slice(-2),
            dd = ("0" + date.getDate()).slice(-2);format = format || "yyyy-mm-dd";return format.replace(/yyyy/ig, yyyy).replace(/yy/ig, yy).replace(/mm/ig, mm).replace(/dd/ig, dd);
      }this.execCommand("insertHtml", cmd == "time" ? formatTime(date, format) : formatDate(date, format));
    } };UE.plugins["rowspacing"] = function () {
    var me = this;me.setOpt({ "rowspacingtop": ["5", "10", "15", "20", "25"], "rowspacingbottom": ["5", "10", "15", "20", "25"] });me.commands["rowspacing"] = { execCommand: function execCommand(cmdName, value, dir) {
        this.execCommand("paragraph", "p", { style: "margin-" + dir + ":" + value + "px" });return true;
      }, queryCommandValue: function queryCommandValue(cmdName, dir) {
        var pN = domUtils.filterNodeList(this.selection.getStartElementPath(), function (node) {
          return domUtils.isBlockElm(node);
        }),
            value;if (pN) {
          value = domUtils.getComputedStyle(pN, "margin-" + dir).replace(/[^\d]/g, "");return !value ? 0 : value;
        }return 0;
      } };
  };UE.plugins["lineheight"] = function () {
    var me = this;me.setOpt({ "lineheight": ["1", "1.5", "1.75", "2", "3", "4", "5"] });me.commands["lineheight"] = { execCommand: function execCommand(cmdName, value) {
        this.execCommand("paragraph", "p", { style: "line-height:" + (value == "1" ? "normal" : value + "em") });return true;
      }, queryCommandValue: function queryCommandValue() {
        var pN = domUtils.filterNodeList(this.selection.getStartElementPath(), function (node) {
          return domUtils.isBlockElm(node);
        });if (pN) {
          var value = domUtils.getComputedStyle(pN, "line-height");return value == "normal" ? 1 : value.replace(/[^\d.]*/ig, "");
        }
      } };
  };UE.plugins["insertcode"] = function () {
    var me = this;me.ready(function () {
      utils.cssRule("pre", "pre{margin:.5em 0;padding:.4em .6em;border-radius:8px;background:#f8f8f8;}", me.document);
    });me.setOpt("insertcode", { "as3": "ActionScript3", "bash": "Bash/Shell", "cpp": "C/C++", "css": "Css", "cf": "CodeFunction", "c#": "C#", "delphi": "Delphi", "diff": "Diff", "erlang": "Erlang", "groovy": "Groovy", "html": "Html", "java": "Java", "jfx": "JavaFx", "js": "Javascript", "pl": "Perl", "php": "Php", "plain": "Plain Text", "ps": "PowerShell", "python": "Python", "ruby": "Ruby", "scala": "Scala", "sql": "Sql", "vb": "Vb", "xml": "Xml" });me.commands["insertcode"] = { execCommand: function execCommand(cmd, lang) {
        var me = this,
            rng = me.selection.getRange(),
            pre = domUtils.findParentByTagName(rng.startContainer, "pre", true);if (pre) {
          pre.className = "brush:" + lang + ";toolbar:false;";
        } else {
          var code = "";if (rng.collapsed) {
            code = browser.ie && browser.ie11below ? browser.version <= 8 ? "&nbsp;" : "" : "<br/>";
          } else {
            var frag = rng.extractContents();var div = me.document.createElement("div");div.appendChild(frag);utils.each(UE.filterNode(UE.htmlparser(div.innerHTML.replace(/[\r\t]/g, "")), me.options.filterTxtRules).children, function (node) {
              if (browser.ie && browser.ie11below && browser.version > 8) {
                if (node.type == "element") {
                  if (node.tagName == "br") {
                    code += "\n";
                  } else {
                    if (!dtd.$empty[node.tagName]) {
                      utils.each(node.children, function (cn) {
                        if (cn.type == "element") {
                          if (cn.tagName == "br") {
                            code += "\n";
                          } else {
                            if (!dtd.$empty[node.tagName]) {
                              code += cn.innerText();
                            }
                          }
                        } else {
                          code += cn.data;
                        }
                      });if (!/\n$/.test(code)) {
                        code += "\n";
                      }
                    }
                  }
                } else {
                  code += node.data + "\n";
                }if (!node.nextSibling() && /\n$/.test(code)) {
                  code = code.replace(/\n$/, "");
                }
              } else {
                if (browser.ie && browser.ie11below) {
                  if (node.type == "element") {
                    if (node.tagName == "br") {
                      code += "<br>";
                    } else {
                      if (!dtd.$empty[node.tagName]) {
                        utils.each(node.children, function (cn) {
                          if (cn.type == "element") {
                            if (cn.tagName == "br") {
                              code += "<br>";
                            } else {
                              if (!dtd.$empty[node.tagName]) {
                                code += cn.innerText();
                              }
                            }
                          } else {
                            code += cn.data;
                          }
                        });if (!/br>$/.test(code)) {
                          code += "<br>";
                        }
                      }
                    }
                  } else {
                    code += node.data + "<br>";
                  }if (!node.nextSibling() && /<br>$/.test(code)) {
                    code = code.replace(/<br>$/, "");
                  }
                } else {
                  code += node.type == "element" ? dtd.$empty[node.tagName] ? "" : node.innerText() : node.data;if (!/br\/?\s*>$/.test(code)) {
                    if (!node.nextSibling()) {
                      return;
                    }code += "<br>";
                  }
                }
              }
            });
          }me.execCommand("inserthtml", '<pre id="coder"class="brush:' + lang + ';toolbar:false">' + code + "</pre>", true);pre = me.document.getElementById("coder");domUtils.removeAttributes(pre, "id");var tmpNode = pre.previousSibling;if (tmpNode && (tmpNode.nodeType == 3 && tmpNode.nodeValue.length == 1 && browser.ie && browser.version == 6 || domUtils.isEmptyBlock(tmpNode))) {
            domUtils.remove(tmpNode);
          }var rng = me.selection.getRange();if (domUtils.isEmptyBlock(pre)) {
            rng.setStart(pre, 0).setCursor(false, true);
          } else {
            rng.selectNodeContents(pre).select();
          }
        }
      }, queryCommandValue: function queryCommandValue() {
        var path = this.selection.getStartElementPath();var lang = "";utils.each(path, function (node) {
          if (node.nodeName == "PRE") {
            var match = node.className.match(/brush:([^;]+)/);lang = match && match[1] ? match[1] : "";return false;
          }
        });return lang;
      } };me.addInputRule(function (root) {
      utils.each(root.getNodesByTagName("pre"), function (pre) {
        var brs = pre.getNodesByTagName("br");if (brs.length) {
          browser.ie && browser.ie11below && browser.version > 8 && utils.each(brs, function (br) {
            var txt = UE.uNode.createText("\n");br.parentNode.insertBefore(txt, br);br.parentNode.removeChild(br);
          });return;
        }if (browser.ie && browser.ie11below && browser.version > 8) {
          return;
        }var code = pre.innerText().split(/\n/);pre.innerHTML("");utils.each(code, function (c) {
          if (c.length) {
            pre.appendChild(UE.uNode.createText(c));
          }pre.appendChild(UE.uNode.createElement("br"));
        });
      });
    });me.addOutputRule(function (root) {
      utils.each(root.getNodesByTagName("pre"), function (pre) {
        var code = "";utils.each(pre.children, function (n) {
          if (n.type == "text") {
            code += n.data.replace(/[ ]/g, "&nbsp;").replace(/\n$/, "");
          } else {
            if (n.tagName == "br") {
              code += "\n";
            } else {
              code += !dtd.$empty[n.tagName] ? "" : n.innerText();
            }
          }
        });pre.innerText(code.replace(/(&nbsp;|\n)+$/, ""));
      });
    });me.notNeedCodeQuery = { help: 1, undo: 1, redo: 1, source: 1, print: 1, searchreplace: 1, fullscreen: 1, preview: 1, insertparagraph: 1, elementpath: 1, insertcode: 1, inserthtml: 1, selectall: 1 };var orgQuery = me.queryCommandState;me.queryCommandState = function (cmd) {
      var me = this;if (!me.notNeedCodeQuery[cmd.toLowerCase()] && me.selection && me.queryCommandValue("insertcode")) {
        return -1;
      }return UE.Editor.prototype.queryCommandState.apply(this, arguments);
    };me.addListener("beforeenterkeydown", function () {
      var rng = me.selection.getRange();var pre = domUtils.findParentByTagName(rng.startContainer, "pre", true);if (pre) {
        me.fireEvent("saveScene");if (!rng.collapsed) {
          rng.deleteContents();
        }if (!browser.ie || browser.ie9above) {
          var tmpNode = me.document.createElement("br"),
              pre;rng.insertNode(tmpNode).setStartAfter(tmpNode).collapse(true);var next = tmpNode.nextSibling;if (!next && (!browser.ie || browser.version > 10)) {
            rng.insertNode(tmpNode.cloneNode(false));
          } else {
            rng.setStartAfter(tmpNode);
          }pre = tmpNode.previousSibling;var tmp;while (pre) {
            tmp = pre;pre = pre.previousSibling;if (!pre || pre.nodeName == "BR") {
              pre = tmp;break;
            }
          }if (pre) {
            var str = "";while (pre && pre.nodeName != "BR" && new RegExp("^[\\s" + domUtils.fillChar + "]*$").test(pre.nodeValue)) {
              str += pre.nodeValue;pre = pre.nextSibling;
            }if (pre.nodeName != "BR") {
              var match = pre.nodeValue.match(new RegExp("^([\\s" + domUtils.fillChar + "]+)"));if (match && match[1]) {
                str += match[1];
              }
            }if (str) {
              str = me.document.createTextNode(str);rng.insertNode(str).setStartAfter(str);
            }
          }rng.collapse(true).select(true);
        } else {
          if (browser.version > 8) {
            var txt = me.document.createTextNode("\n");var start = rng.startContainer;if (rng.startOffset == 0) {
              var preNode = start.previousSibling;if (preNode) {
                rng.insertNode(txt);var fillchar = me.document.createTextNode(" ");rng.setStartAfter(txt).insertNode(fillchar).setStart(fillchar, 0).collapse(true).select(true);
              }
            } else {
              rng.insertNode(txt).setStartAfter(txt);var fillchar = me.document.createTextNode(" ");start = rng.startContainer.childNodes[rng.startOffset];if (start && !/^\n/.test(start.nodeValue)) {
                rng.setStartBefore(txt);
              }rng.insertNode(fillchar).setStart(fillchar, 0).collapse(true).select(true);
            }
          } else {
            var tmpNode = me.document.createElement("br");rng.insertNode(tmpNode);rng.insertNode(me.document.createTextNode(domUtils.fillChar));rng.setStartAfter(tmpNode);pre = tmpNode.previousSibling;var tmp;while (pre) {
              tmp = pre;pre = pre.previousSibling;if (!pre || pre.nodeName == "BR") {
                pre = tmp;break;
              }
            }if (pre) {
              var str = "";while (pre && pre.nodeName != "BR" && new RegExp("^[ " + domUtils.fillChar + "]*$").test(pre.nodeValue)) {
                str += pre.nodeValue;pre = pre.nextSibling;
              }if (pre.nodeName != "BR") {
                var match = pre.nodeValue.match(new RegExp("^([ " + domUtils.fillChar + "]+)"));if (match && match[1]) {
                  str += match[1];
                }
              }str = me.document.createTextNode(str);rng.insertNode(str).setStartAfter(str);
            }rng.collapse(true).select();
          }
        }me.fireEvent("saveScene");return true;
      }
    });me.addListener("tabkeydown", function (cmd, evt) {
      var rng = me.selection.getRange();var pre = domUtils.findParentByTagName(rng.startContainer, "pre", true);if (pre) {
        me.fireEvent("saveScene");if (evt.shiftKey) {} else {
          if (!rng.collapsed) {
            var bk = rng.createBookmark();var start = bk.start.previousSibling;while (start) {
              if (pre.firstChild === start && !domUtils.isBr(start)) {
                pre.insertBefore(me.document.createTextNode("    "), start);break;
              }if (domUtils.isBr(start)) {
                pre.insertBefore(me.document.createTextNode("    "), start.nextSibling);break;
              }start = start.previousSibling;
            }var end = bk.end;start = bk.start.nextSibling;if (pre.firstChild === bk.start) {
              pre.insertBefore(me.document.createTextNode("    "), start.nextSibling);
            }while (start && start !== end) {
              if (domUtils.isBr(start) && start.nextSibling) {
                if (start.nextSibling === end) {
                  break;
                }pre.insertBefore(me.document.createTextNode("    "), start.nextSibling);
              }start = start.nextSibling;
            }rng.moveToBookmark(bk).select();
          } else {
            var tmpNode = me.document.createTextNode("    ");rng.insertNode(tmpNode).setStartAfter(tmpNode).collapse(true).select(true);
          }
        }me.fireEvent("saveScene");return true;
      }
    });me.addListener("beforeinserthtml", function (evtName, html) {
      var me = this,
          rng = me.selection.getRange(),
          pre = domUtils.findParentByTagName(rng.startContainer, "pre", true);if (pre) {
        if (!rng.collapsed) {
          rng.deleteContents();
        }var htmlstr = "";if (browser.ie && browser.version > 8) {
          utils.each(UE.filterNode(UE.htmlparser(html), me.options.filterTxtRules).children, function (node) {
            if (node.type == "element") {
              if (node.tagName == "br") {
                htmlstr += "\n";
              } else {
                if (!dtd.$empty[node.tagName]) {
                  utils.each(node.children, function (cn) {
                    if (cn.type == "element") {
                      if (cn.tagName == "br") {
                        htmlstr += "\n";
                      } else {
                        if (!dtd.$empty[node.tagName]) {
                          htmlstr += cn.innerText();
                        }
                      }
                    } else {
                      htmlstr += cn.data;
                    }
                  });if (!/\n$/.test(htmlstr)) {
                    htmlstr += "\n";
                  }
                }
              }
            } else {
              htmlstr += node.data + "\n";
            }if (!node.nextSibling() && /\n$/.test(htmlstr)) {
              htmlstr = htmlstr.replace(/\n$/, "");
            }
          });var tmpNode = me.document.createTextNode(utils.html(htmlstr.replace(/&nbsp;/g, " ")));rng.insertNode(tmpNode).selectNode(tmpNode).select();
        } else {
          var frag = me.document.createDocumentFragment();utils.each(UE.filterNode(UE.htmlparser(html), me.options.filterTxtRules).children, function (node) {
            if (node.type == "element") {
              if (node.tagName == "br") {
                frag.appendChild(me.document.createElement("br"));
              } else {
                if (!dtd.$empty[node.tagName]) {
                  utils.each(node.children, function (cn) {
                    if (cn.type == "element") {
                      if (cn.tagName == "br") {
                        frag.appendChild(me.document.createElement("br"));
                      } else {
                        if (!dtd.$empty[node.tagName]) {
                          frag.appendChild(me.document.createTextNode(utils.html(cn.innerText().replace(/&nbsp;/g, " "))));
                        }
                      }
                    } else {
                      frag.appendChild(me.document.createTextNode(utils.html(cn.data.replace(/&nbsp;/g, " "))));
                    }
                  });if (frag.lastChild.nodeName != "BR") {
                    frag.appendChild(me.document.createElement("br"));
                  }
                }
              }
            } else {
              frag.appendChild(me.document.createTextNode(utils.html(node.data.replace(/&nbsp;/g, " "))));
            }if (!node.nextSibling() && frag.lastChild.nodeName == "BR") {
              frag.removeChild(frag.lastChild);
            }
          });rng.insertNode(frag).select();
        }return true;
      }
    });me.addListener("keydown", function (cmd, evt) {
      var me = this,
          keyCode = evt.keyCode || evt.which;if (keyCode == 40) {
        var rng = me.selection.getRange(),
            pre,
            start = rng.startContainer;if (rng.collapsed && (pre = domUtils.findParentByTagName(rng.startContainer, "pre", true)) && !pre.nextSibling) {
          var last = pre.lastChild;while (last && last.nodeName == "BR") {
            last = last.previousSibling;
          }if (last === start || rng.startContainer === pre && rng.startOffset == pre.childNodes.length) {
            me.execCommand("insertparagraph");domUtils.preventDefault(evt);
          }
        }
      }
    });me.addListener("delkeydown", function (type, evt) {
      var rng = this.selection.getRange();rng.txtToElmBoundary(true);var start = rng.startContainer;if (domUtils.isTagNode(start, "pre") && rng.collapsed && domUtils.isStartInblock(rng)) {
        var p = me.document.createElement("p");domUtils.fillNode(me.document, p);start.parentNode.insertBefore(p, start);domUtils.remove(start);rng.setStart(p, 0).setCursor(false, true);domUtils.preventDefault(evt);return true;
      }
    });
  };UE.commands["cleardoc"] = { execCommand: function execCommand(cmdName) {
      var me = this,
          enterTag = me.options.enterTag,
          range = me.selection.getRange();if (enterTag == "br") {
        me.body.innerHTML = "<br/>";range.setStart(me.body, 0).setCursor();
      } else {
        me.body.innerHTML = "<p>" + (ie ? "" : "<br/>") + "</p>";range.setStart(me.body.firstChild, 0).setCursor(false, true);
      }setTimeout(function () {
        me.fireEvent("clearDoc");
      }, 0);
    } };UE.plugin.register("anchor", function () {
    return { bindEvents: { "ready": function ready() {
          utils.cssRule("anchor", ".anchorclass{background: url('" + this.options.themePath + this.options.theme + "/images/anchor.gif') no-repeat scroll left center transparent;cursor: auto;display: inline-block;height: 16px;width: 15px;}", this.document);
        } }, outputRule: function outputRule(root) {
        utils.each(root.getNodesByTagName("img"), function (a) {
          var val;if (val = a.getAttr("anchorname")) {
            a.tagName = "a";a.setAttr({ anchorname: "", name: val, "class": "" });
          }
        });
      }, inputRule: function inputRule(root) {
        utils.each(root.getNodesByTagName("a"), function (a) {
          var val;if ((val = a.getAttr("name")) && !a.getAttr("href")) {
            a.tagName = "img";a.setAttr({ anchorname: a.getAttr("name"), "class": "anchorclass" });a.setAttr("name");
          }
        });
      }, commands: { "anchor": { execCommand: function execCommand(cmd, name) {
            var range = this.selection.getRange(),
                img = range.getClosedNode();if (img && img.getAttribute("anchorname")) {
              if (name) {
                img.setAttribute("anchorname", name);
              } else {
                range.setStartBefore(img).setCursor();domUtils.remove(img);
              }
            } else {
              if (name) {
                var anchor = this.document.createElement("img");range.collapse(true);domUtils.setAttributes(anchor, { "anchorname": name, "class": "anchorclass" });range.insertNode(anchor).setStartAfter(anchor).setCursor(false, true);
              }
            }
          } } } };
  });UE.plugins["wordcount"] = function () {
    var me = this;me.setOpt("wordCount", true);me.addListener("contentchange", function () {
      me.fireEvent("wordcount");
    });var timer;me.addListener("ready", function () {
      var me = this;domUtils.on(me.body, "keyup", function (evt) {
        var code = evt.keyCode || evt.which,
            ignores = { "16": 1, "18": 1, "20": 1, "37": 1, "38": 1, "39": 1, "40": 1 };if (code in ignores) {
          return;
        }clearTimeout(timer);timer = setTimeout(function () {
          me.fireEvent("wordcount");
        }, 200);
      });
    });
  };UE.plugins["pagebreak"] = function () {
    var me = this,
        notBreakTags = ["td"];me.setOpt("pageBreakTag", "_ueditor_page_break_tag_");function fillNode(node) {
      if (domUtils.isEmptyBlock(node)) {
        var firstChild = node.firstChild,
            tmpNode;while (firstChild && firstChild.nodeType == 1 && domUtils.isEmptyBlock(firstChild)) {
          tmpNode = firstChild;firstChild = firstChild.firstChild;
        }!tmpNode && (tmpNode = node);domUtils.fillNode(me.document, tmpNode);
      }
    }me.ready(function () {
      utils.cssRule("pagebreak", ".pagebreak{display:block;clear:both !important;cursor:default !important;width: 100% !important;margin:0;}", me.document);
    });function isHr(node) {
      return node && node.nodeType == 1 && node.tagName == "HR" && node.className == "pagebreak";
    }me.addInputRule(function (root) {
      root.traversal(function (node) {
        if (node.type == "text" && node.data == me.options.pageBreakTag) {
          var hr = UE.uNode.createElement('<hr class="pagebreak" noshade="noshade" size="5" style="-webkit-user-select: none;">');node.parentNode.insertBefore(hr, node);node.parentNode.removeChild(node);
        }
      });
    });me.addOutputRule(function (node) {
      utils.each(node.getNodesByTagName("hr"), function (n) {
        if (n.getAttr("class") == "pagebreak") {
          var txt = UE.uNode.createText(me.options.pageBreakTag);n.parentNode.insertBefore(txt, n);n.parentNode.removeChild(n);
        }
      });
    });me.commands["pagebreak"] = { execCommand: function execCommand() {
        var range = me.selection.getRange(),
            hr = me.document.createElement("hr");domUtils.setAttributes(hr, { "class": "pagebreak", noshade: "noshade", size: "5" });domUtils.unSelectable(hr);var node = domUtils.findParentByTagName(range.startContainer, notBreakTags, true),
            parents = [],
            pN;if (node) {
          switch (node.tagName) {case "TD":
              var pN = node.parentNode;if (!pN.previousSibling) {
                var table = domUtils.findParentByTagName(pN, "table");table.parentNode.insertBefore(hr, table);parents = domUtils.findParents(hr, true);
              } else {
                pN.parentNode.insertBefore(hr, pN);parents = domUtils.findParents(hr);
              }pN = parents[1];if (hr !== pN) {
                domUtils.breakParent(hr, pN);
              }me.fireEvent("afteradjusttable", me.document);}
        } else {
          if (!range.collapsed) {
            range.deleteContents();var start = range.startContainer;while (!domUtils.isBody(start) && domUtils.isBlockElm(start) && domUtils.isEmptyNode(start)) {
              range.setStartBefore(start).collapse(true);domUtils.remove(start);start = range.startContainer;
            }
          }range.insertNode(hr);var pN = hr.parentNode,
              nextNode;while (!domUtils.isBody(pN)) {
            domUtils.breakParent(hr, pN);nextNode = hr.nextSibling;if (nextNode && domUtils.isEmptyBlock(nextNode)) {
              domUtils.remove(nextNode);
            }pN = hr.parentNode;
          }nextNode = hr.nextSibling;var pre = hr.previousSibling;if (isHr(pre)) {
            domUtils.remove(pre);
          } else {
            pre && fillNode(pre);
          }if (!nextNode) {
            var p = me.document.createElement("p");hr.parentNode.appendChild(p);domUtils.fillNode(me.document, p);range.setStart(p, 0).collapse(true);
          } else {
            if (isHr(nextNode)) {
              domUtils.remove(nextNode);
            } else {
              fillNode(nextNode);
            }range.setEndAfter(hr).collapse(false);
          }range.select(true);
        }
      } };
  };UE.plugin.register("wordimage", function () {
    var me = this,
        images = [];return { commands: { "wordimage": { execCommand: function execCommand() {
            var images = domUtils.getElementsByTagName(me.body, "img");var urlList = [];for (var i = 0, ci; ci = images[i++];) {
              var url = ci.getAttribute("word_img");url && urlList.push(url);
            }return urlList;
          }, queryCommandState: function queryCommandState() {
            images = domUtils.getElementsByTagName(me.body, "img");for (var i = 0, ci; ci = images[i++];) {
              if (ci.getAttribute("word_img")) {
                return 1;
              }
            }return -1;
          }, notNeedUndo: true } }, inputRule: function inputRule(root) {
        utils.each(root.getNodesByTagName("img"), function (img) {
          var attrs = img.attrs,
              flag = parseInt(attrs.width) < 128 || parseInt(attrs.height) < 43,
              opt = me.options,
              src = opt.UEDITOR_HOME_URL + "themes/default/images/spacer.gif";if (attrs["src"] && /^(?:(file:\/+))/.test(attrs["src"])) {
            img.setAttr({ width: attrs.width, height: attrs.height, alt: attrs.alt, word_img: attrs.src, src: src, "style": "background:url(" + (flag ? opt.themePath + opt.theme + "/images/word.gif" : opt.langPath + opt.lang + "/images/localimage.png") + ") no-repeat center center;border:1px solid #ddd" });
          }
        });
      } };
  });UE.plugins["dragdrop"] = function () {
    var me = this;me.ready(function () {
      domUtils.on(this.body, "dragend", function () {
        var rng = me.selection.getRange();var node = rng.getClosedNode() || me.selection.getStart();if (node && node.tagName == "IMG") {
          var pre = node.previousSibling,
              next;while (next = node.nextSibling) {
            if (next.nodeType == 1 && next.tagName == "SPAN" && !next.firstChild) {
              domUtils.remove(next);
            } else {
              break;
            }
          }if ((pre && pre.nodeType == 1 && !domUtils.isEmptyBlock(pre) || !pre) && (!next || next && !domUtils.isEmptyBlock(next))) {
            if (pre && pre.tagName == "P" && !domUtils.isEmptyBlock(pre)) {
              pre.appendChild(node);domUtils.moveChild(next, pre);domUtils.remove(next);
            } else {
              if (next && next.tagName == "P" && !domUtils.isEmptyBlock(next)) {
                next.insertBefore(node, next.firstChild);
              }
            }if (pre && pre.tagName == "P" && domUtils.isEmptyBlock(pre)) {
              domUtils.remove(pre);
            }if (next && next.tagName == "P" && domUtils.isEmptyBlock(next)) {
              domUtils.remove(next);
            }rng.selectNode(node).select();me.fireEvent("saveScene");
          }
        }
      });
    });me.addListener("keyup", function (type, evt) {
      var keyCode = evt.keyCode || evt.which;if (keyCode == 13) {
        var rng = me.selection.getRange(),
            node;if (node = domUtils.findParentByTagName(rng.startContainer, "p", true)) {
          if (domUtils.getComputedStyle(node, "text-align") == "center") {
            domUtils.removeStyle(node, "text-align");
          }
        }
      }
    });
  };UE.plugins["undo"] = function () {
    var saveSceneTimer;var me = this,
        maxUndoCount = me.options.maxUndoCount || 20,
        maxInputCount = me.options.maxInputCount || 20,
        fillchar = new RegExp(domUtils.fillChar + "|</hr>", "gi");var noNeedFillCharTags = { ol: 1, ul: 1, table: 1, tbody: 1, tr: 1, body: 1 };var orgState = me.options.autoClearEmptyNode;function compareAddr(indexA, indexB) {
      if (indexA.length != indexB.length) {
        return 0;
      }for (var i = 0, l = indexA.length; i < l; i++) {
        if (indexA[i] != indexB[i]) {
          return 0;
        }
      }return 1;
    }function compareRangeAddress(rngAddrA, rngAddrB) {
      if (rngAddrA.collapsed != rngAddrB.collapsed) {
        return 0;
      }if (!compareAddr(rngAddrA.startAddress, rngAddrB.startAddress) || !compareAddr(rngAddrA.endAddress, rngAddrB.endAddress)) {
        return 0;
      }return 1;
    }function UndoManager() {
      this.list = [];this.index = 0;this.hasUndo = false;this.hasRedo = false;this.undo = function () {
        if (this.hasUndo) {
          if (!this.list[this.index - 1] && this.list.length == 1) {
            this.reset();return;
          }while (this.list[this.index].content == this.list[this.index - 1].content) {
            this.index--;if (this.index == 0) {
              return this.restore(0);
            }
          }this.restore(--this.index);
        }
      };this.redo = function () {
        if (this.hasRedo) {
          while (this.list[this.index].content == this.list[this.index + 1].content) {
            this.index++;if (this.index == this.list.length - 1) {
              return this.restore(this.index);
            }
          }this.restore(++this.index);
        }
      };this.restore = function () {
        var me = this.editor;var scene = this.list[this.index];var root = UE.htmlparser(scene.content.replace(fillchar, ""));me.options.autoClearEmptyNode = false;me.filterInputRule(root);me.options.autoClearEmptyNode = orgState;me.document.body.innerHTML = root.toHtml();me.fireEvent("afterscencerestore");if (browser.ie) {
          utils.each(domUtils.getElementsByTagName(me.document, "td th caption p"), function (node) {
            if (domUtils.isEmptyNode(node)) {
              domUtils.fillNode(me.document, node);
            }
          });
        }try {
          var rng = new dom.Range(me.document).moveToAddress(scene.address);rng.select(noNeedFillCharTags[rng.startContainer.nodeName.toLowerCase()]);
        } catch (e) {}this.update();this.clearKey();me.fireEvent("reset", true);
      };this.getScene = function () {
        var me = this.editor;var rng = me.selection.getRange(),
            rngAddress = rng.createAddress(false, true);me.fireEvent("beforegetscene");var root = UE.htmlparser(me.body.innerHTML);me.options.autoClearEmptyNode = false;me.filterOutputRule(root);me.options.autoClearEmptyNode = orgState;var cont = root.toHtml();me.fireEvent("aftergetscene");return { address: rngAddress, content: cont };
      };this.save = function (notCompareRange, notSetCursor) {
        clearTimeout(saveSceneTimer);var currentScene = this.getScene(notSetCursor),
            lastScene = this.list[this.index];if (lastScene && lastScene.content != currentScene.content) {
          me.trigger("contentchange");
        }if (lastScene && lastScene.content == currentScene.content && (notCompareRange ? 1 : compareRangeAddress(lastScene.address, currentScene.address))) {
          return;
        }this.list = this.list.slice(0, this.index + 1);this.list.push(currentScene);if (this.list.length > maxUndoCount) {
          this.list.shift();
        }this.index = this.list.length - 1;this.clearKey();this.update();
      };this.update = function () {
        this.hasRedo = !!this.list[this.index + 1];this.hasUndo = !!this.list[this.index - 1];
      };this.reset = function () {
        this.list = [];this.index = 0;this.hasUndo = false;this.hasRedo = false;this.clearKey();
      };this.clearKey = function () {
        keycont = 0;lastKeyCode = null;
      };
    }me.undoManger = new UndoManager();me.undoManger.editor = me;function saveScene() {
      this.undoManger.save();
    }me.addListener("saveScene", function () {
      var args = Array.prototype.splice.call(arguments, 1);this.undoManger.save.apply(this.undoManger, args);
    });me.addListener("reset", function (type, exclude) {
      if (!exclude) {
        this.undoManger.reset();
      }
    });me.commands["redo"] = me.commands["undo"] = { execCommand: function execCommand(cmdName) {
        if (this.undoManger[cmdName]) {
          this.undoManger[cmdName]();
        }
      }, queryCommandState: function queryCommandState(cmdName) {
        return this.undoManger["has" + (cmdName.toLowerCase() == "undo" ? "Undo" : "Redo")] ? 0 : -1;
      }, notNeedUndo: 1 };var keys = { 16: 1, 17: 1, 18: 1, 37: 1, 38: 1, 39: 1, 40: 1 },
        keycont = 0,
        lastKeyCode;var inputType = false;me.addListener("ready", function () {
      domUtils.on(this.body, "compositionstart", function () {
        inputType = true;
      });domUtils.on(this.body, "compositionend", function () {
        inputType = false;
      });
    });me.addshortcutkey({ "Undo": "ctrl+90", "Redo": "ctrl+89" });var isCollapsed = true;me.addListener("keydown", function (type, evt) {
      var me = this;var keyCode = evt.keyCode || evt.which;if (!keys[keyCode] && !evt.ctrlKey && !evt.metaKey && !evt.shiftKey && !evt.altKey) {
        var save = function save(cont) {
          cont.undoManger.save(false, true);cont.fireEvent("selectionchange");
        };

        if (inputType) {
          return;
        }if (!me.selection.getRange().collapsed) {
          me.undoManger.save(false, true);isCollapsed = false;return;
        }if (me.undoManger.list.length == 0) {
          me.undoManger.save(true);
        }clearTimeout(saveSceneTimer);saveSceneTimer = setTimeout(function () {
          if (inputType) {
            var interalTimer = setInterval(function () {
              if (!inputType) {
                save(me);clearInterval(interalTimer);
              }
            }, 300);return;
          }save(me);
        }, 200);lastKeyCode = keyCode;keycont++;if (keycont >= maxInputCount) {
          save(me);
        }
      }
    });me.addListener("keyup", function (type, evt) {
      var keyCode = evt.keyCode || evt.which;if (!keys[keyCode] && !evt.ctrlKey && !evt.metaKey && !evt.shiftKey && !evt.altKey) {
        if (inputType) {
          return;
        }if (!isCollapsed) {
          this.undoManger.save(false, true);isCollapsed = true;
        }
      }
    });me.stopCmdUndo = function () {
      me.__hasEnterExecCommand = true;
    };me.startCmdUndo = function () {
      me.__hasEnterExecCommand = false;
    };
  };UE.plugin.register("copy", function () {
    var me = this;function initZeroClipboard() {
      ZeroClipboard.config({ debug: false, swfPath: me.options.UEDITOR_HOME_URL + "third-party/zeroclipboard/ZeroClipboard.swf" });var client = me.zeroclipboard = new ZeroClipboard();client.on("copy", function (e) {
        var client = e.client,
            rng = me.selection.getRange(),
            div = document.createElement("div");div.appendChild(rng.cloneContents());client.setText(div.innerText || div.textContent);client.setHtml(div.innerHTML);rng.select();
      });client.on("mouseover mouseout", function (e) {
        var target = e.target;if (e.type == "mouseover") {
          domUtils.addClass(target, "edui-state-hover");
        } else {
          if (e.type == "mouseout") {
            domUtils.removeClasses(target, "edui-state-hover");
          }
        }
      });client.on("wrongflash noflash", function () {
        ZeroClipboard.destroy();
      });
    }return { bindEvents: { "ready": function ready() {
          if (!browser.ie) {}
        } }, commands: { "copy": { execCommand: function execCommand(cmd) {
            if (!me.document.execCommand("copy")) {
              alert(me.getLang("copymsg"));
            }
          } } } };
  });UE.plugins["paste"] = function () {
    function getClipboardData(callback) {
      var doc = this.document;if (doc.getElementById("baidu_pastebin")) {
        return;
      }var range = this.selection.getRange(),
          bk = range.createBookmark(),
          pastebin = doc.createElement("div");pastebin.id = "baidu_pastebin";browser.webkit && pastebin.appendChild(doc.createTextNode(domUtils.fillChar + domUtils.fillChar));doc.body.appendChild(pastebin);bk.start.style.display = "";pastebin.style.cssText = "position:absolute;width:1px;height:1px;overflow:hidden;left:-1000px;white-space:nowrap;top:" + domUtils.getXY(bk.start).y + "px";range.selectNodeContents(pastebin).select(true);setTimeout(function () {
        if (browser.webkit) {
          for (var i = 0, pastebins = doc.querySelectorAll("#baidu_pastebin"), pi; pi = pastebins[i++];) {
            if (domUtils.isEmptyNode(pi)) {
              domUtils.remove(pi);
            } else {
              pastebin = pi;break;
            }
          }
        }try {
          pastebin.parentNode.removeChild(pastebin);
        } catch (e) {}range.moveToBookmark(bk).select(true);callback(pastebin);
      }, 0);
    }var me = this;me.setOpt({ retainOnlyLabelPasted: false });var txtContent, htmlContent, address;function getPureHtml(html) {
      return html.replace(/<(\/?)([\w\-]+)([^>]*)>/gi, function (a, b, tagName, attrs) {
        tagName = tagName.toLowerCase();if ({ img: 1 }[tagName]) {
          return a;
        }attrs = attrs.replace(/([\w\-]*?)\s*=\s*(("([^"]*)")|('([^']*)')|([^\s>]+))/gi, function (str, atr, val) {
          if ({ "src": 1, "href": 1, "name": 1 }[atr.toLowerCase()]) {
            return atr + "=" + val + " ";
          }return "";
        });if ({ "span": 1, "div": 1 }[tagName]) {
          return "";
        } else {
          return "<" + b + tagName + " " + utils.trim(attrs) + ">";
        }
      });
    }function filter(div) {
      var html;if (div.firstChild) {
        var nodes = domUtils.getElementsByTagName(div, "span");for (var i = 0, ni; ni = nodes[i++];) {
          if (ni.id == "_baidu_cut_start" || ni.id == "_baidu_cut_end") {
            domUtils.remove(ni);
          }
        }if (browser.webkit) {
          var brs = div.querySelectorAll("div br");for (var i = 0, bi; bi = brs[i++];) {
            var pN = bi.parentNode;if (pN.tagName == "DIV" && pN.childNodes.length == 1) {
              pN.innerHTML = "<p><br/></p>";domUtils.remove(pN);
            }
          }var divs = div.querySelectorAll("#baidu_pastebin");for (var i = 0, di; di = divs[i++];) {
            var tmpP = me.document.createElement("p");di.parentNode.insertBefore(tmpP, di);while (di.firstChild) {
              tmpP.appendChild(di.firstChild);
            }domUtils.remove(di);
          }var metas = div.querySelectorAll("meta");for (var i = 0, ci; ci = metas[i++];) {
            domUtils.remove(ci);
          }var brs = div.querySelectorAll("br");for (i = 0; ci = brs[i++];) {
            if (/^apple-/i.test(ci.className)) {
              domUtils.remove(ci);
            }
          }
        }if (browser.gecko) {
          var dirtyNodes = div.querySelectorAll("[_moz_dirty]");for (i = 0; ci = dirtyNodes[i++];) {
            ci.removeAttribute("_moz_dirty");
          }
        }if (!browser.ie) {
          var spans = div.querySelectorAll("span.Apple-style-span");for (var i = 0, ci; ci = spans[i++];) {
            domUtils.remove(ci, true);
          }
        }html = div.innerHTML;html = UE.filterWord(html);var root = UE.htmlparser(html);if (me.options.filterRules) {
          UE.filterNode(root, me.options.filterRules);
        }me.filterInputRule(root);if (browser.webkit) {
          var br = root.lastChild();if (br && br.type == "element" && br.tagName == "br") {
            root.removeChild(br);
          }utils.each(me.body.querySelectorAll("div"), function (node) {
            if (domUtils.isEmptyBlock(node)) {
              domUtils.remove(node, true);
            }
          });
        }html = { "html": root.toHtml() };me.fireEvent("beforepaste", html, root);if (!html.html) {
          return;
        }root = UE.htmlparser(html.html, true);if (me.queryCommandState("pasteplain") === 1) {
          me.execCommand("insertHtml", UE.filterNode(root, me.options.filterTxtRules).toHtml(), true);
        } else {
          UE.filterNode(root, me.options.filterTxtRules);txtContent = root.toHtml();htmlContent = html.html;address = me.selection.getRange().createAddress(true);me.execCommand("insertHtml", me.getOpt("retainOnlyLabelPasted") === true ? getPureHtml(htmlContent) : htmlContent, true);
        }me.fireEvent("afterpaste", html);
      }
    }me.addListener("pasteTransfer", function (cmd, plainType) {
      if (address && txtContent && htmlContent && txtContent != htmlContent) {
        var range = me.selection.getRange();range.moveToAddress(address, true);if (!range.collapsed) {
          while (!domUtils.isBody(range.startContainer)) {
            var start = range.startContainer;if (start.nodeType == 1) {
              start = start.childNodes[range.startOffset];if (!start) {
                range.setStartBefore(range.startContainer);continue;
              }var pre = start.previousSibling;if (pre && pre.nodeType == 3 && new RegExp("^[\n\r\t " + domUtils.fillChar + "]*$").test(pre.nodeValue)) {
                range.setStartBefore(pre);
              }
            }if (range.startOffset == 0) {
              range.setStartBefore(range.startContainer);
            } else {
              break;
            }
          }while (!domUtils.isBody(range.endContainer)) {
            var end = range.endContainer;if (end.nodeType == 1) {
              end = end.childNodes[range.endOffset];if (!end) {
                range.setEndAfter(range.endContainer);continue;
              }var next = end.nextSibling;if (next && next.nodeType == 3 && new RegExp("^[\n\r\t" + domUtils.fillChar + "]*$").test(next.nodeValue)) {
                range.setEndAfter(next);
              }
            }if (range.endOffset == range.endContainer[range.endContainer.nodeType == 3 ? "nodeValue" : "childNodes"].length) {
              range.setEndAfter(range.endContainer);
            } else {
              break;
            }
          }
        }range.deleteContents();range.select(true);me.__hasEnterExecCommand = true;var html = htmlContent;if (plainType === 2) {
          html = getPureHtml(html);
        } else {
          if (plainType) {
            html = txtContent;
          }
        }me.execCommand("inserthtml", html, true);me.__hasEnterExecCommand = false;var rng = me.selection.getRange();while (!domUtils.isBody(rng.startContainer) && !rng.startOffset && rng.startContainer[rng.startContainer.nodeType == 3 ? "nodeValue" : "childNodes"].length) {
          rng.setStartBefore(rng.startContainer);
        }var tmpAddress = rng.createAddress(true);address.endAddress = tmpAddress.startAddress;
      }
    });me.addListener("ready", function () {
      domUtils.on(me.body, "cut", function () {
        var range = me.selection.getRange();if (!range.collapsed && me.undoManger) {
          me.undoManger.save();
        }
      });domUtils.on(me.body, browser.ie || browser.opera ? "keydown" : "paste", function (e) {
        if ((browser.ie || browser.opera) && (!e.ctrlKey && !e.metaKey || e.keyCode != "86")) {
          return;
        }getClipboardData.call(me, function (div) {
          filter(div);
        });
      });
    });me.commands["paste"] = { execCommand: function execCommand(cmd) {
        if (browser.ie) {
          getClipboardData.call(me, function (div) {
            filter(div);
          });me.document.execCommand("paste");
        } else {
          alert(me.getLang("pastemsg"));
        }
      } };
  };UE.plugins["pasteplain"] = function () {
    var me = this;me.setOpt({ "pasteplain": false, "filterTxtRules": function () {
        function transP(node) {
          node.tagName = "p";node.setStyle();
        }function removeNode(node) {
          node.parentNode.removeChild(node, true);
        }return { "-": "script style object iframe embed input select", "p": { $: {} }, "br": { $: {} }, div: function div(node) {
            var tmpNode,
                p = UE.uNode.createElement("p");while (tmpNode = node.firstChild()) {
              if (tmpNode.type == "text" || !UE.dom.dtd.$block[tmpNode.tagName]) {
                p.appendChild(tmpNode);
              } else {
                if (p.firstChild()) {
                  node.parentNode.insertBefore(p, node);p = UE.uNode.createElement("p");
                } else {
                  node.parentNode.insertBefore(tmpNode, node);
                }
              }
            }if (p.firstChild()) {
              node.parentNode.insertBefore(p, node);
            }node.parentNode.removeChild(node);
          }, ol: removeNode, ul: removeNode, dl: removeNode, dt: removeNode, dd: removeNode, "li": removeNode, "caption": transP, "th": transP, "tr": transP, "h1": transP, "h2": transP, "h3": transP, "h4": transP, "h5": transP, "h6": transP, "td": function td(node) {
            var txt = !!node.innerText();if (txt) {
              node.parentNode.insertAfter(UE.uNode.createText(" &nbsp; &nbsp;"), node);
            }node.parentNode.removeChild(node, node.innerText());
          } };
      }() });var pasteplain = me.options.pasteplain;me.commands["pasteplain"] = { queryCommandState: function queryCommandState() {
        return pasteplain ? 1 : 0;
      }, execCommand: function execCommand() {
        pasteplain = !pasteplain | 0;
      }, notNeedUndo: 1 };
  };UE.plugins["list"] = function () {
    var me = this,
        notExchange = { "TD": 1, "PRE": 1, "BLOCKQUOTE": 1 };var customStyle = { "cn": "cn-1-", "cn1": "cn-2-", "cn2": "cn-3-", "num": "num-1-", "num1": "num-2-", "num2": "num-3-", "dash": "dash", "dot": "dot" };me.setOpt({ "autoTransWordToList": false, "insertorderedlist": { "num": "", "num1": "", "num2": "", "cn": "", "cn1": "", "cn2": "", "decimal": "", "lower-alpha": "", "lower-roman": "", "upper-alpha": "", "upper-roman": "" }, "insertunorderedlist": { "circle": "", "disc": "", "square": "", "dash": "", "dot": "" }, listDefaultPaddingLeft: "30", listiconpath: "http://bs.baidu.com/listicon/", maxListLevel: -1, disablePInList: false });function listToArray(list) {
      var arr = [];for (var p in list) {
        arr.push(p);
      }return arr;
    }var listStyle = { "OL": listToArray(me.options.insertorderedlist), "UL": listToArray(me.options.insertunorderedlist) };var liiconpath = me.options.listiconpath;for (var s in customStyle) {
      if (!me.options.insertorderedlist.hasOwnProperty(s) && !me.options.insertunorderedlist.hasOwnProperty(s)) {
        delete customStyle[s];
      }
    }me.ready(function () {
      var customCss = [];for (var p in customStyle) {
        if (p == "dash" || p == "dot") {
          customCss.push("li.list-" + customStyle[p] + "{background-image:url(" + liiconpath + customStyle[p] + ".gif)}");customCss.push("ul.custom_" + p + "{list-style:none;}ul.custom_" + p + " li{background-position:0 3px;background-repeat:no-repeat}");
        } else {
          for (var i = 0; i < 99; i++) {
            customCss.push("li.list-" + customStyle[p] + i + "{background-image:url(" + liiconpath + "list-" + customStyle[p] + i + ".gif)}");
          }customCss.push("ol.custom_" + p + "{list-style:none;}ol.custom_" + p + " li{background-position:0 3px;background-repeat:no-repeat}");
        }switch (p) {case "cn":
            customCss.push("li.list-" + p + "-paddingleft-1{padding-left:25px}");customCss.push("li.list-" + p + "-paddingleft-2{padding-left:40px}");customCss.push("li.list-" + p + "-paddingleft-3{padding-left:55px}");break;case "cn1":
            customCss.push("li.list-" + p + "-paddingleft-1{padding-left:30px}");customCss.push("li.list-" + p + "-paddingleft-2{padding-left:40px}");customCss.push("li.list-" + p + "-paddingleft-3{padding-left:55px}");break;case "cn2":
            customCss.push("li.list-" + p + "-paddingleft-1{padding-left:40px}");customCss.push("li.list-" + p + "-paddingleft-2{padding-left:55px}");customCss.push("li.list-" + p + "-paddingleft-3{padding-left:68px}");break;case "num":case "num1":
            customCss.push("li.list-" + p + "-paddingleft-1{padding-left:25px}");break;case "num2":
            customCss.push("li.list-" + p + "-paddingleft-1{padding-left:35px}");customCss.push("li.list-" + p + "-paddingleft-2{padding-left:40px}");break;case "dash":
            customCss.push("li.list-" + p + "-paddingleft{padding-left:35px}");break;case "dot":
            customCss.push("li.list-" + p + "-paddingleft{padding-left:20px}");}
      }customCss.push(".list-paddingleft-1{padding-left:0}");customCss.push(".list-paddingleft-2{padding-left:" + me.options.listDefaultPaddingLeft + "px}");customCss.push(".list-paddingleft-3{padding-left:" + me.options.listDefaultPaddingLeft * 2 + "px}");utils.cssRule("list", "ol,ul{margin:0;pading:0;" + (browser.ie ? "" : "width:95%") + "}li{clear:both;}" + customCss.join("\n"), me.document);
    });me.ready(function () {
      domUtils.on(me.body, "cut", function () {
        setTimeout(function () {
          var rng = me.selection.getRange(),
              li;if (!rng.collapsed) {
            if (li = domUtils.findParentByTagName(rng.startContainer, "li", true)) {
              if (!li.nextSibling && domUtils.isEmptyBlock(li)) {
                var pn = li.parentNode,
                    node;if (node = pn.previousSibling) {
                  domUtils.remove(pn);rng.setStartAtLast(node).collapse(true);rng.select(true);
                } else {
                  if (node = pn.nextSibling) {
                    domUtils.remove(pn);rng.setStartAtFirst(node).collapse(true);rng.select(true);
                  } else {
                    var tmpNode = me.document.createElement("p");domUtils.fillNode(me.document, tmpNode);pn.parentNode.insertBefore(tmpNode, pn);domUtils.remove(pn);rng.setStart(tmpNode, 0).collapse(true);rng.select(true);
                  }
                }
              }
            }
          }
        });
      });
    });function getStyle(node) {
      var cls = node.className;if (domUtils.hasClass(node, /custom_/)) {
        return cls.match(/custom_(\w+)/)[1];
      }return domUtils.getStyle(node, "list-style-type");
    }me.addListener("beforepaste", function (type, html) {
      var me = this,
          rng = me.selection.getRange(),
          li;var root = UE.htmlparser(html.html, true);if (li = domUtils.findParentByTagName(rng.startContainer, "li", true)) {
        var list = li.parentNode,
            tagName = list.tagName == "OL" ? "ul" : "ol";utils.each(root.getNodesByTagName(tagName), function (n) {
          n.tagName = list.tagName;n.setAttr();if (n.parentNode === root) {
            type = getStyle(list) || (list.tagName == "OL" ? "decimal" : "disc");
          } else {
            var className = n.parentNode.getAttr("class");if (className && /custom_/.test(className)) {
              type = className.match(/custom_(\w+)/)[1];
            } else {
              type = n.parentNode.getStyle("list-style-type");
            }if (!type) {
              type = list.tagName == "OL" ? "decimal" : "disc";
            }
          }var index = utils.indexOf(listStyle[list.tagName], type);if (n.parentNode !== root) {
            index = index + 1 == listStyle[list.tagName].length ? 0 : index + 1;
          }var currentStyle = listStyle[list.tagName][index];if (customStyle[currentStyle]) {
            n.setAttr("class", "custom_" + currentStyle);
          } else {
            n.setStyle("list-style-type", currentStyle);
          }
        });
      }html.html = root.toHtml();
    });me.getOpt("disablePInList") === true && me.addOutputRule(function (root) {
      utils.each(root.getNodesByTagName("li"), function (li) {
        var newChildrens = [],
            index = 0;utils.each(li.children, function (n) {
          if (n.tagName == "p") {
            var tmpNode;while (tmpNode = n.children.pop()) {
              newChildrens.splice(index, 0, tmpNode);tmpNode.parentNode = li;lastNode = tmpNode;
            }tmpNode = newChildrens[newChildrens.length - 1];if (!tmpNode || tmpNode.type != "element" || tmpNode.tagName != "br") {
              var br = UE.uNode.createElement("br");br.parentNode = li;newChildrens.push(br);
            }index = newChildrens.length;
          }
        });if (newChildrens.length) {
          li.children = newChildrens;
        }
      });
    });me.addInputRule(function (root) {
      utils.each(root.getNodesByTagName("li"), function (li) {
        var tmpP = UE.uNode.createElement("p");for (var i = 0, ci; ci = li.children[i];) {
          if (ci.type == "text" || dtd.p[ci.tagName]) {
            tmpP.appendChild(ci);
          } else {
            if (tmpP.firstChild()) {
              li.insertBefore(tmpP, ci);tmpP = UE.uNode.createElement("p");i = i + 2;
            } else {
              i++;
            }
          }
        }if (tmpP.firstChild() && !tmpP.parentNode || !li.firstChild()) {
          li.appendChild(tmpP);
        }if (!tmpP.firstChild()) {
          tmpP.innerHTML(browser.ie ? "&nbsp;" : "<br/>");
        }var p = li.firstChild();var lastChild = p.lastChild();if (lastChild && lastChild.type == "text" && /^\s*$/.test(lastChild.data)) {
          p.removeChild(lastChild);
        }
      });if (me.options.autoTransWordToList) {
        var checkListType = function checkListType(content, container) {
          var span = container.firstChild();if (span && span.type == "element" && span.tagName == "span" && /Wingdings|Symbol/.test(span.getStyle("font-family"))) {
            for (var p in unorderlisttype) {
              if (unorderlisttype[p] == span.data) {
                return p;
              }
            }return "disc";
          }for (var p in orderlisttype) {
            if (orderlisttype[p].test(content)) {
              return p;
            }
          }
        };

        var orderlisttype = { "num1": /^\d+\)/, "decimal": /^\d+\./, "lower-alpha": /^[a-z]+\)/, "upper-alpha": /^[A-Z]+\./, "cn": /^[\u4E00\u4E8C\u4E09\u56DB\u516d\u4e94\u4e03\u516b\u4e5d]+[\u3001]/, "cn2": /^\([\u4E00\u4E8C\u4E09\u56DB\u516d\u4e94\u4e03\u516b\u4e5d]+\)/ },
            unorderlisttype = { "square": "n" };utils.each(root.getNodesByTagName("p"), function (node) {
          if (node.getAttr("class") != "MsoListParagraph") {
            return;
          }node.setStyle("margin", "");node.setStyle("margin-left", "");node.setAttr("class", "");function appendLi(list, p, type) {
            if (list.tagName == "ol") {
              if (browser.ie) {
                var first = p.firstChild();if (first.type == "element" && first.tagName == "span" && orderlisttype[type].test(first.innerText())) {
                  p.removeChild(first);
                }
              } else {
                p.innerHTML(p.innerHTML().replace(orderlisttype[type], ""));
              }
            } else {
              p.removeChild(p.firstChild());
            }var li = UE.uNode.createElement("li");li.appendChild(p);list.appendChild(li);
          }var tmp = node,
              type,
              cacheNode = node;if (node.parentNode.tagName != "li" && (type = checkListType(node.innerText(), node))) {
            var list = UE.uNode.createElement(me.options.insertorderedlist.hasOwnProperty(type) ? "ol" : "ul");if (customStyle[type]) {
              list.setAttr("class", "custom_" + type);
            } else {
              list.setStyle("list-style-type", type);
            }while (node && node.parentNode.tagName != "li" && checkListType(node.innerText(), node)) {
              tmp = node.nextSibling();if (!tmp) {
                node.parentNode.insertBefore(list, node);
              }appendLi(list, node, type);node = tmp;
            }if (!list.parentNode && node && node.parentNode) {
              node.parentNode.insertBefore(list, node);
            }
          }var span = cacheNode.firstChild();if (span && span.type == "element" && span.tagName == "span" && /^\s*(&nbsp;)+\s*$/.test(span.innerText())) {
            span.parentNode.removeChild(span);
          }
        });
      }
    });me.addListener("contentchange", function () {
      adjustListStyle(me.document);
    });function adjustListStyle(doc, ignore) {
      utils.each(domUtils.getElementsByTagName(doc, "ol ul"), function (node) {
        if (!domUtils.inDoc(node, doc)) {
          return;
        }var parent = node.parentNode;if (parent.tagName == node.tagName) {
          var nodeStyleType = getStyle(node) || (node.tagName == "OL" ? "decimal" : "disc"),
              parentStyleType = getStyle(parent) || (parent.tagName == "OL" ? "decimal" : "disc");if (nodeStyleType == parentStyleType) {
            var styleIndex = utils.indexOf(listStyle[node.tagName], nodeStyleType);styleIndex = styleIndex + 1 == listStyle[node.tagName].length ? 0 : styleIndex + 1;setListStyle(node, listStyle[node.tagName][styleIndex]);
          }
        }var index = 0,
            type = 2;if (domUtils.hasClass(node, /custom_/)) {
          if (!(/[ou]l/i.test(parent.tagName) && domUtils.hasClass(parent, /custom_/))) {
            type = 1;
          }
        } else {
          if (/[ou]l/i.test(parent.tagName) && domUtils.hasClass(parent, /custom_/)) {
            type = 3;
          }
        }var style = domUtils.getStyle(node, "list-style-type");style && (node.style.cssText = "list-style-type:" + style);node.className = utils.trim(node.className.replace(/list-paddingleft-\w+/, "")) + " list-paddingleft-" + type;utils.each(domUtils.getElementsByTagName(node, "li"), function (li) {
          li.style.cssText && (li.style.cssText = "");if (!li.firstChild) {
            domUtils.remove(li);return;
          }if (li.parentNode !== node) {
            return;
          }index++;if (domUtils.hasClass(node, /custom_/)) {
            var paddingLeft = 1,
                currentStyle = getStyle(node);if (node.tagName == "OL") {
              if (currentStyle) {
                switch (currentStyle) {case "cn":case "cn1":case "cn2":
                    if (index > 10 && (index % 10 == 0 || index > 10 && index < 20)) {
                      paddingLeft = 2;
                    } else {
                      if (index > 20) {
                        paddingLeft = 3;
                      }
                    }break;case "num2":
                    if (index > 9) {
                      paddingLeft = 2;
                    }}
              }li.className = "list-" + customStyle[currentStyle] + index + " " + "list-" + currentStyle + "-paddingleft-" + paddingLeft;
            } else {
              li.className = "list-" + customStyle[currentStyle] + " " + "list-" + currentStyle + "-paddingleft";
            }
          } else {
            li.className = li.className.replace(/list-[\w\-]+/gi, "");
          }var className = li.getAttribute("class");if (className !== null && !className.replace(/\s/g, "")) {
            domUtils.removeAttributes(li, "class");
          }
        });!ignore && adjustList(node, node.tagName.toLowerCase(), getStyle(node) || domUtils.getStyle(node, "list-style-type"), true);
      });
    }function adjustList(list, tag, style, ignoreEmpty) {
      var nextList = list.nextSibling;if (nextList && nextList.nodeType == 1 && nextList.tagName.toLowerCase() == tag && (getStyle(nextList) || domUtils.getStyle(nextList, "list-style-type") || (tag == "ol" ? "decimal" : "disc")) == style) {
        domUtils.moveChild(nextList, list);if (nextList.childNodes.length == 0) {
          domUtils.remove(nextList);
        }
      }if (nextList && domUtils.isFillChar(nextList)) {
        domUtils.remove(nextList);
      }var preList = list.previousSibling;if (preList && preList.nodeType == 1 && preList.tagName.toLowerCase() == tag && (getStyle(preList) || domUtils.getStyle(preList, "list-style-type") || (tag == "ol" ? "decimal" : "disc")) == style) {
        domUtils.moveChild(list, preList);
      }if (preList && domUtils.isFillChar(preList)) {
        domUtils.remove(preList);
      }!ignoreEmpty && domUtils.isEmptyBlock(list) && domUtils.remove(list);if (getStyle(list)) {
        adjustListStyle(list.ownerDocument, true);
      }
    }function setListStyle(list, style) {
      if (customStyle[style]) {
        list.className = "custom_" + style;
      }try {
        domUtils.setStyle(list, "list-style-type", style);
      } catch (e) {}
    }function clearEmptySibling(node) {
      var tmpNode = node.previousSibling;if (tmpNode && domUtils.isEmptyBlock(tmpNode)) {
        domUtils.remove(tmpNode);
      }tmpNode = node.nextSibling;if (tmpNode && domUtils.isEmptyBlock(tmpNode)) {
        domUtils.remove(tmpNode);
      }
    }me.addListener("keydown", function (type, evt) {
      function preventAndSave() {
        evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;me.fireEvent("contentchange");me.undoManger && me.undoManger.save();
      }function findList(node, filterFn) {
        while (node && !domUtils.isBody(node)) {
          if (filterFn(node)) {
            return null;
          }if (node.nodeType == 1 && /[ou]l/i.test(node.tagName)) {
            return node;
          }node = node.parentNode;
        }return null;
      }var keyCode = evt.keyCode || evt.which;if (keyCode == 13 && !evt.shiftKey) {
        var rng = me.selection.getRange(),
            parent = domUtils.findParent(rng.startContainer, function (node) {
          return domUtils.isBlockElm(node);
        }, true),
            li = domUtils.findParentByTagName(rng.startContainer, "li", true);if (parent && parent.tagName != "PRE" && !li) {
          var html = parent.innerHTML.replace(new RegExp(domUtils.fillChar, "g"), "");if (/^\s*1\s*\.[^\d]/.test(html)) {
            parent.innerHTML = html.replace(/^\s*1\s*\./, "");rng.setStartAtLast(parent).collapse(true).select();me.__hasEnterExecCommand = true;me.execCommand("insertorderedlist");me.__hasEnterExecCommand = false;
          }
        }var range = me.selection.getRange(),
            start = findList(range.startContainer, function (node) {
          return node.tagName == "TABLE";
        }),
            end = range.collapsed ? start : findList(range.endContainer, function (node) {
          return node.tagName == "TABLE";
        });if (start && end && start === end) {
          if (!range.collapsed) {
            start = domUtils.findParentByTagName(range.startContainer, "li", true);end = domUtils.findParentByTagName(range.endContainer, "li", true);if (start && end && start === end) {
              range.deleteContents();li = domUtils.findParentByTagName(range.startContainer, "li", true);if (li && domUtils.isEmptyBlock(li)) {
                pre = li.previousSibling;next = li.nextSibling;p = me.document.createElement("p");domUtils.fillNode(me.document, p);parentList = li.parentNode;if (pre && next) {
                  range.setStart(next, 0).collapse(true).select(true);domUtils.remove(li);
                } else {
                  if (!pre && !next || !pre) {
                    parentList.parentNode.insertBefore(p, parentList);
                  } else {
                    li.parentNode.parentNode.insertBefore(p, parentList.nextSibling);
                  }domUtils.remove(li);if (!parentList.firstChild) {
                    domUtils.remove(parentList);
                  }range.setStart(p, 0).setCursor();
                }preventAndSave();return;
              }
            } else {
              var tmpRange = range.cloneRange(),
                  bk = tmpRange.collapse(false).createBookmark();range.deleteContents();tmpRange.moveToBookmark(bk);var li = domUtils.findParentByTagName(tmpRange.startContainer, "li", true);clearEmptySibling(li);tmpRange.select();preventAndSave();return;
            }
          }li = domUtils.findParentByTagName(range.startContainer, "li", true);if (li) {
            if (domUtils.isEmptyBlock(li)) {
              bk = range.createBookmark();var parentList = li.parentNode;if (li !== parentList.lastChild) {
                domUtils.breakParent(li, parentList);clearEmptySibling(li);
              } else {
                parentList.parentNode.insertBefore(li, parentList.nextSibling);if (domUtils.isEmptyNode(parentList)) {
                  domUtils.remove(parentList);
                }
              }if (!dtd.$list[li.parentNode.tagName]) {
                if (!domUtils.isBlockElm(li.firstChild)) {
                  p = me.document.createElement("p");li.parentNode.insertBefore(p, li);while (li.firstChild) {
                    p.appendChild(li.firstChild);
                  }domUtils.remove(li);
                } else {
                  domUtils.remove(li, true);
                }
              }range.moveToBookmark(bk).select();
            } else {
              var first = li.firstChild;if (!first || !domUtils.isBlockElm(first)) {
                var p = me.document.createElement("p");!li.firstChild && domUtils.fillNode(me.document, p);while (li.firstChild) {
                  p.appendChild(li.firstChild);
                }li.appendChild(p);first = p;
              }var span = me.document.createElement("span");range.insertNode(span);domUtils.breakParent(span, li);var nextLi = span.nextSibling;first = nextLi.firstChild;if (!first) {
                p = me.document.createElement("p");domUtils.fillNode(me.document, p);nextLi.appendChild(p);first = p;
              }if (domUtils.isEmptyNode(first)) {
                first.innerHTML = "";domUtils.fillNode(me.document, first);
              }range.setStart(first, 0).collapse(true).shrinkBoundary().select();domUtils.remove(span);var pre = nextLi.previousSibling;if (pre && domUtils.isEmptyBlock(pre)) {
                pre.innerHTML = "<p></p>";domUtils.fillNode(me.document, pre.firstChild);
              }
            }preventAndSave();
          }
        }
      }if (keyCode == 8) {
        range = me.selection.getRange();if (range.collapsed && domUtils.isStartInblock(range)) {
          tmpRange = range.cloneRange().trimBoundary();li = domUtils.findParentByTagName(range.startContainer, "li", true);if (li && domUtils.isStartInblock(tmpRange)) {
            start = domUtils.findParentByTagName(range.startContainer, "p", true);if (start && start !== li.firstChild) {
              var parentList = domUtils.findParentByTagName(start, ["ol", "ul"]);domUtils.breakParent(start, parentList);clearEmptySibling(start);me.fireEvent("contentchange");range.setStart(start, 0).setCursor(false, true);me.fireEvent("saveScene");domUtils.preventDefault(evt);return;
            }if (li && (pre = li.previousSibling)) {
              if (keyCode == 46 && li.childNodes.length) {
                return;
              }if (dtd.$list[pre.tagName]) {
                pre = pre.lastChild;
              }me.undoManger && me.undoManger.save();first = li.firstChild;if (domUtils.isBlockElm(first)) {
                if (domUtils.isEmptyNode(first)) {
                  pre.appendChild(first);range.setStart(first, 0).setCursor(false, true);while (li.firstChild) {
                    pre.appendChild(li.firstChild);
                  }
                } else {
                  span = me.document.createElement("span");range.insertNode(span);if (domUtils.isEmptyBlock(pre)) {
                    pre.innerHTML = "";
                  }domUtils.moveChild(li, pre);range.setStartBefore(span).collapse(true).select(true);domUtils.remove(span);
                }
              } else {
                if (domUtils.isEmptyNode(li)) {
                  var p = me.document.createElement("p");pre.appendChild(p);range.setStart(p, 0).setCursor();
                } else {
                  range.setEnd(pre, pre.childNodes.length).collapse().select(true);while (li.firstChild) {
                    pre.appendChild(li.firstChild);
                  }
                }
              }domUtils.remove(li);me.fireEvent("contentchange");me.fireEvent("saveScene");domUtils.preventDefault(evt);return;
            }if (li && !li.previousSibling) {
              var parentList = li.parentNode;var bk = range.createBookmark();if (domUtils.isTagNode(parentList.parentNode, "ol ul")) {
                parentList.parentNode.insertBefore(li, parentList);if (domUtils.isEmptyNode(parentList)) {
                  domUtils.remove(parentList);
                }
              } else {
                while (li.firstChild) {
                  parentList.parentNode.insertBefore(li.firstChild, parentList);
                }domUtils.remove(li);if (domUtils.isEmptyNode(parentList)) {
                  domUtils.remove(parentList);
                }
              }range.moveToBookmark(bk).setCursor(false, true);me.fireEvent("contentchange");me.fireEvent("saveScene");domUtils.preventDefault(evt);return;
            }
          }
        }
      }
    });me.addListener("keyup", function (type, evt) {
      var keyCode = evt.keyCode || evt.which;if (keyCode == 8) {
        var rng = me.selection.getRange(),
            list;if (list = domUtils.findParentByTagName(rng.startContainer, ["ol", "ul"], true)) {
          adjustList(list, list.tagName.toLowerCase(), getStyle(list) || domUtils.getComputedStyle(list, "list-style-type"), true);
        }
      }
    });me.addListener("tabkeydown", function () {
      var range = me.selection.getRange();function checkLevel(li) {
        if (me.options.maxListLevel != -1) {
          var level = li.parentNode,
              levelNum = 0;while (/[ou]l/i.test(level.tagName)) {
            levelNum++;level = level.parentNode;
          }if (levelNum >= me.options.maxListLevel) {
            return true;
          }
        }
      }var li = domUtils.findParentByTagName(range.startContainer, "li", true);if (li) {
        var bk;if (range.collapsed) {
          if (checkLevel(li)) {
            return true;
          }var parentLi = li.parentNode,
              list = me.document.createElement(parentLi.tagName),
              index = utils.indexOf(listStyle[list.tagName], getStyle(parentLi) || domUtils.getComputedStyle(parentLi, "list-style-type"));index = index + 1 == listStyle[list.tagName].length ? 0 : index + 1;var currentStyle = listStyle[list.tagName][index];setListStyle(list, currentStyle);if (domUtils.isStartInblock(range)) {
            me.fireEvent("saveScene");bk = range.createBookmark();parentLi.insertBefore(list, li);list.appendChild(li);adjustList(list, list.tagName.toLowerCase(), currentStyle);me.fireEvent("contentchange");range.moveToBookmark(bk).select(true);return true;
          }
        } else {
          me.fireEvent("saveScene");bk = range.createBookmark();for (var i = 0, closeList, parents = domUtils.findParents(li), ci; ci = parents[i++];) {
            if (domUtils.isTagNode(ci, "ol ul")) {
              closeList = ci;break;
            }
          }var current = li;if (bk.end) {
            while (current && !(domUtils.getPosition(current, bk.end) & domUtils.POSITION_FOLLOWING)) {
              if (checkLevel(current)) {
                current = domUtils.getNextDomNode(current, false, null, function (node) {
                  return node !== closeList;
                });continue;
              }var parentLi = current.parentNode,
                  list = me.document.createElement(parentLi.tagName),
                  index = utils.indexOf(listStyle[list.tagName], getStyle(parentLi) || domUtils.getComputedStyle(parentLi, "list-style-type"));var currentIndex = index + 1 == listStyle[list.tagName].length ? 0 : index + 1;var currentStyle = listStyle[list.tagName][currentIndex];setListStyle(list, currentStyle);parentLi.insertBefore(list, current);while (current && !(domUtils.getPosition(current, bk.end) & domUtils.POSITION_FOLLOWING)) {
                li = current.nextSibling;list.appendChild(current);if (!li || domUtils.isTagNode(li, "ol ul")) {
                  if (li) {
                    while (li = li.firstChild) {
                      if (li.tagName == "LI") {
                        break;
                      }
                    }
                  } else {
                    li = domUtils.getNextDomNode(current, false, null, function (node) {
                      return node !== closeList;
                    });
                  }break;
                }current = li;
              }adjustList(list, list.tagName.toLowerCase(), currentStyle);current = li;
            }
          }me.fireEvent("contentchange");range.moveToBookmark(bk).select();return true;
        }
      }
    });function getLi(start) {
      while (start && !domUtils.isBody(start)) {
        if (start.nodeName == "TABLE") {
          return null;
        }if (start.nodeName == "LI") {
          return start;
        }start = start.parentNode;
      }
    }me.commands["insertorderedlist"] = me.commands["insertunorderedlist"] = { execCommand: function execCommand(command, style) {
        if (!style) {
          style = command.toLowerCase() == "insertorderedlist" ? "decimal" : "disc";
        }var me = this,
            range = this.selection.getRange(),
            filterFn = function filterFn(node) {
          return node.nodeType == 1 ? node.tagName.toLowerCase() != "br" : !domUtils.isWhitespace(node);
        },
            tag = command.toLowerCase() == "insertorderedlist" ? "ol" : "ul",
            frag = me.document.createDocumentFragment();range.adjustmentBoundary().shrinkBoundary();var bko = range.createBookmark(true),
            start = getLi(me.document.getElementById(bko.start)),
            modifyStart = 0,
            end = getLi(me.document.getElementById(bko.end)),
            modifyEnd = 0,
            startParent,
            endParent,
            list,
            tmp;if (start || end) {
          start && (startParent = start.parentNode);if (!bko.end) {
            end = start;
          }end && (endParent = end.parentNode);if (startParent === endParent) {
            while (start !== end) {
              tmp = start;start = start.nextSibling;if (!domUtils.isBlockElm(tmp.firstChild)) {
                var p = me.document.createElement("p");while (tmp.firstChild) {
                  p.appendChild(tmp.firstChild);
                }tmp.appendChild(p);
              }frag.appendChild(tmp);
            }tmp = me.document.createElement("span");startParent.insertBefore(tmp, end);if (!domUtils.isBlockElm(end.firstChild)) {
              p = me.document.createElement("p");while (end.firstChild) {
                p.appendChild(end.firstChild);
              }end.appendChild(p);
            }frag.appendChild(end);domUtils.breakParent(tmp, startParent);if (domUtils.isEmptyNode(tmp.previousSibling)) {
              domUtils.remove(tmp.previousSibling);
            }if (domUtils.isEmptyNode(tmp.nextSibling)) {
              domUtils.remove(tmp.nextSibling);
            }var nodeStyle = getStyle(startParent) || domUtils.getComputedStyle(startParent, "list-style-type") || (command.toLowerCase() == "insertorderedlist" ? "decimal" : "disc");if (startParent.tagName.toLowerCase() == tag && nodeStyle == style) {
              for (var i = 0, ci, tmpFrag = me.document.createDocumentFragment(); ci = frag.firstChild;) {
                if (domUtils.isTagNode(ci, "ol ul")) {
                  tmpFrag.appendChild(ci);
                } else {
                  while (ci.firstChild) {
                    tmpFrag.appendChild(ci.firstChild);domUtils.remove(ci);
                  }
                }
              }tmp.parentNode.insertBefore(tmpFrag, tmp);
            } else {
              list = me.document.createElement(tag);setListStyle(list, style);list.appendChild(frag);tmp.parentNode.insertBefore(list, tmp);
            }domUtils.remove(tmp);list && adjustList(list, tag, style);range.moveToBookmark(bko).select();return;
          }if (start) {
            while (start) {
              tmp = start.nextSibling;if (domUtils.isTagNode(start, "ol ul")) {
                frag.appendChild(start);
              } else {
                var tmpfrag = me.document.createDocumentFragment(),
                    hasBlock = 0;while (start.firstChild) {
                  if (domUtils.isBlockElm(start.firstChild)) {
                    hasBlock = 1;
                  }tmpfrag.appendChild(start.firstChild);
                }if (!hasBlock) {
                  var tmpP = me.document.createElement("p");tmpP.appendChild(tmpfrag);frag.appendChild(tmpP);
                } else {
                  frag.appendChild(tmpfrag);
                }domUtils.remove(start);
              }start = tmp;
            }startParent.parentNode.insertBefore(frag, startParent.nextSibling);if (domUtils.isEmptyNode(startParent)) {
              range.setStartBefore(startParent);domUtils.remove(startParent);
            } else {
              range.setStartAfter(startParent);
            }modifyStart = 1;
          }if (end && domUtils.inDoc(endParent, me.document)) {
            start = endParent.firstChild;while (start && start !== end) {
              tmp = start.nextSibling;if (domUtils.isTagNode(start, "ol ul")) {
                frag.appendChild(start);
              } else {
                tmpfrag = me.document.createDocumentFragment();hasBlock = 0;while (start.firstChild) {
                  if (domUtils.isBlockElm(start.firstChild)) {
                    hasBlock = 1;
                  }tmpfrag.appendChild(start.firstChild);
                }if (!hasBlock) {
                  tmpP = me.document.createElement("p");tmpP.appendChild(tmpfrag);frag.appendChild(tmpP);
                } else {
                  frag.appendChild(tmpfrag);
                }domUtils.remove(start);
              }start = tmp;
            }var tmpDiv = domUtils.createElement(me.document, "div", { "tmpDiv": 1 });domUtils.moveChild(end, tmpDiv);frag.appendChild(tmpDiv);domUtils.remove(end);endParent.parentNode.insertBefore(frag, endParent);range.setEndBefore(endParent);if (domUtils.isEmptyNode(endParent)) {
              domUtils.remove(endParent);
            }modifyEnd = 1;
          }
        }if (!modifyStart) {
          range.setStartBefore(me.document.getElementById(bko.start));
        }if (bko.end && !modifyEnd) {
          range.setEndAfter(me.document.getElementById(bko.end));
        }range.enlarge(true, function (node) {
          return notExchange[node.tagName];
        });frag = me.document.createDocumentFragment();var bk = range.createBookmark(),
            current = domUtils.getNextDomNode(bk.start, false, filterFn),
            tmpRange = range.cloneRange(),
            tmpNode,
            block = domUtils.isBlockElm;while (current && current !== bk.end && domUtils.getPosition(current, bk.end) & domUtils.POSITION_PRECEDING) {
          if (current.nodeType == 3 || dtd.li[current.tagName]) {
            if (current.nodeType == 1 && dtd.$list[current.tagName]) {
              while (current.firstChild) {
                frag.appendChild(current.firstChild);
              }tmpNode = domUtils.getNextDomNode(current, false, filterFn);domUtils.remove(current);current = tmpNode;continue;
            }tmpNode = current;tmpRange.setStartBefore(current);while (current && current !== bk.end && (!block(current) || domUtils.isBookmarkNode(current))) {
              tmpNode = current;current = domUtils.getNextDomNode(current, false, null, function (node) {
                return !notExchange[node.tagName];
              });
            }if (current && block(current)) {
              tmp = domUtils.getNextDomNode(tmpNode, false, filterFn);if (tmp && domUtils.isBookmarkNode(tmp)) {
                current = domUtils.getNextDomNode(tmp, false, filterFn);tmpNode = tmp;
              }
            }tmpRange.setEndAfter(tmpNode);current = domUtils.getNextDomNode(tmpNode, false, filterFn);var li = range.document.createElement("li");li.appendChild(tmpRange.extractContents());if (domUtils.isEmptyNode(li)) {
              var tmpNode = range.document.createElement("p");while (li.firstChild) {
                tmpNode.appendChild(li.firstChild);
              }li.appendChild(tmpNode);
            }frag.appendChild(li);
          } else {
            current = domUtils.getNextDomNode(current, true, filterFn);
          }
        }range.moveToBookmark(bk).collapse(true);list = me.document.createElement(tag);setListStyle(list, style);list.appendChild(frag);range.insertNode(list);adjustList(list, tag, style);for (var i = 0, ci, tmpDivs = domUtils.getElementsByTagName(list, "div"); ci = tmpDivs[i++];) {
          if (ci.getAttribute("tmpDiv")) {
            domUtils.remove(ci, true);
          }
        }range.moveToBookmark(bko).select();
      }, queryCommandState: function queryCommandState(command) {
        var tag = command.toLowerCase() == "insertorderedlist" ? "ol" : "ul";var path = this.selection.getStartElementPath();for (var i = 0, ci; ci = path[i++];) {
          if (ci.nodeName == "TABLE") {
            return 0;
          }if (tag == ci.nodeName.toLowerCase()) {
            return 1;
          }
        }return 0;
      }, queryCommandValue: function queryCommandValue(command) {
        var tag = command.toLowerCase() == "insertorderedlist" ? "ol" : "ul";var path = this.selection.getStartElementPath(),
            node;for (var i = 0, ci; ci = path[i++];) {
          if (ci.nodeName == "TABLE") {
            node = null;break;
          }if (tag == ci.nodeName.toLowerCase()) {
            node = ci;break;
          }
        }return node ? getStyle(node) || domUtils.getComputedStyle(node, "list-style-type") : null;
      } };
  };(function () {
    var sourceEditors = { textarea: function textarea(editor, holder) {
        var textarea = holder.ownerDocument.createElement("textarea");textarea.style.cssText = "position:absolute;resize:none;width:100%;height:100%;border:0;padding:0;margin:0;overflow-y:auto;";if (browser.ie && browser.version < 8) {
          textarea.style.width = holder.offsetWidth + "px";textarea.style.height = holder.offsetHeight + "px";holder.onresize = function () {
            textarea.style.width = holder.offsetWidth + "px";textarea.style.height = holder.offsetHeight + "px";
          };
        }holder.appendChild(textarea);return { setContent: function setContent(content) {
            textarea.value = content;
          }, getContent: function getContent() {
            return textarea.value;
          }, select: function select() {
            var range;if (browser.ie) {
              range = textarea.createTextRange();range.collapse(true);range.select();
            } else {
              textarea.setSelectionRange(0, 0);textarea.focus();
            }
          }, dispose: function dispose() {
            holder.removeChild(textarea);holder.onresize = null;textarea = null;holder = null;
          } };
      }, codemirror: function codemirror(editor, holder) {
        var codeEditor = window.CodeMirror(holder, { mode: "text/html", tabMode: "indent", lineNumbers: true, lineWrapping: true });var dom = codeEditor.getWrapperElement();dom.style.cssText = 'position:absolute;left:0;top:0;width:100%;height:100%;font-family:consolas,"Courier new",monospace;font-size:13px;';codeEditor.getScrollerElement().style.cssText = "position:absolute;left:0;top:0;width:100%;height:100%;";codeEditor.refresh();return { getCodeMirror: function getCodeMirror() {
            return codeEditor;
          }, setContent: function setContent(content) {
            codeEditor.setValue(content);
          }, getContent: function getContent() {
            return codeEditor.getValue();
          }, select: function select() {
            codeEditor.focus();
          }, dispose: function dispose() {
            holder.removeChild(dom);dom = null;codeEditor = null;
          } };
      } };UE.plugins["source"] = function () {
      var me = this;var opt = this.options;var sourceMode = false;var sourceEditor;var orgSetContent;opt.sourceEditor = browser.ie ? "textarea" : opt.sourceEditor || "codemirror";me.setOpt({ sourceEditorFirst: false });function createSourceEditor(holder) {
        return sourceEditors[opt.sourceEditor == "codemirror" && window.CodeMirror ? "codemirror" : "textarea"](me, holder);
      }var bakCssText;var oldGetContent, bakAddress;me.commands["source"] = { execCommand: function execCommand() {
          sourceMode = !sourceMode;if (sourceMode) {
            bakAddress = me.selection.getRange().createAddress(false, true);me.undoManger && me.undoManger.save(true);if (browser.gecko) {
              me.body.contentEditable = false;
            }bakCssText = me.iframe.style.cssText;me.iframe.style.cssText += "position:absolute;left:-32768px;top:-32768px;";me.fireEvent("beforegetcontent");var root = UE.htmlparser(me.body.innerHTML);me.filterOutputRule(root);root.traversal(function (node) {
              if (node.type == "element") {
                switch (node.tagName) {case "td":case "th":case "caption":
                    if (node.children && node.children.length == 1) {
                      if (node.firstChild().tagName == "br") {
                        node.removeChild(node.firstChild());
                      }
                    }break;case "pre":
                    node.innerText(node.innerText().replace(/&nbsp;/g, " "));}
              }
            });me.fireEvent("aftergetcontent");var content = root.toHtml(true);sourceEditor = createSourceEditor(me.iframe.parentNode);sourceEditor.setContent(content);orgSetContent = me.setContent;me.setContent = function (html) {
              var root = UE.htmlparser(html);me.filterInputRule(root);html = root.toHtml();sourceEditor.setContent(html);
            };setTimeout(function () {
              sourceEditor.select();me.addListener("fullscreenchanged", function () {
                try {
                  sourceEditor.getCodeMirror().refresh();
                } catch (e) {}
              });
            });oldGetContent = me.getContent;me.getContent = function () {
              return sourceEditor.getContent() || "<p>" + (browser.ie ? "" : "<br/>") + "</p>";
            };
          } else {
            me.iframe.style.cssText = bakCssText;var cont = sourceEditor.getContent() || "<p>" + (browser.ie ? "" : "<br/>") + "</p>";cont = cont.replace(new RegExp("[\\r\\t\\n ]*</?(\\w+)\\s*(?:[^>]*)>", "g"), function (a, b) {
              if (b && !dtd.$inlineWithA[b.toLowerCase()]) {
                return a.replace(/(^[\n\r\t ]*)|([\n\r\t ]*$)/g, "");
              }return a.replace(/(^[\n\r\t]*)|([\n\r\t]*$)/g, "");
            });me.setContent = orgSetContent;me.setContent(cont);sourceEditor.dispose();sourceEditor = null;me.getContent = oldGetContent;var first = me.body.firstChild;if (!first) {
              me.body.innerHTML = "<p>" + (browser.ie ? "" : "<br/>") + "</p>";first = me.body.firstChild;
            }me.undoManger && me.undoManger.save(true);if (browser.gecko) {
              var input = document.createElement("input");input.style.cssText = "position:absolute;left:0;top:-32768px";document.body.appendChild(input);me.body.contentEditable = false;setTimeout(function () {
                domUtils.setViewportOffset(input, { left: -32768, top: 0 });input.focus();setTimeout(function () {
                  me.body.contentEditable = true;me.selection.getRange().moveToAddress(bakAddress).select(true);domUtils.remove(input);
                });
              });
            } else {
              try {
                me.selection.getRange().moveToAddress(bakAddress).select(true);
              } catch (e) {}
            }
          }this.fireEvent("sourcemodechanged", sourceMode);
        }, queryCommandState: function queryCommandState() {
          return sourceMode | 0;
        }, notNeedUndo: 1 };var oldQueryCommandState = me.queryCommandState;me.queryCommandState = function (cmdName) {
        cmdName = cmdName.toLowerCase();if (sourceMode) {
          return cmdName in { "source": 1, "fullscreen": 1 } ? 1 : -1;
        }return oldQueryCommandState.apply(this, arguments);
      };if (opt.sourceEditor == "codemirror") {
        me.addListener("ready", function () {
          if (opt.sourceEditorFirst) {
            setTimeout(function () {
              me.execCommand("source");
            }, 0);
          }
        });
      }
    };
  })();UE.plugins["enterkey"] = function () {
    var hTag,
        me = this,
        tag = me.options.enterTag;me.addListener("keyup", function (type, evt) {
      var keyCode = evt.keyCode || evt.which;if (keyCode == 13) {
        var range = me.selection.getRange(),
            start = range.startContainer,
            doSave;if (!browser.ie) {
          if (/h\d/i.test(hTag)) {
            if (browser.gecko) {
              var h = domUtils.findParentByTagName(start, ["h1", "h2", "h3", "h4", "h5", "h6", "blockquote", "caption", "table"], true);if (!h) {
                me.document.execCommand("formatBlock", false, "<p>");doSave = 1;
              }
            } else {
              if (start.nodeType == 1) {
                var tmp = me.document.createTextNode(""),
                    div;range.insertNode(tmp);div = domUtils.findParentByTagName(tmp, "div", true);if (div) {
                  var p = me.document.createElement("p");while (div.firstChild) {
                    p.appendChild(div.firstChild);
                  }div.parentNode.insertBefore(p, div);domUtils.remove(div);range.setStartBefore(tmp).setCursor();doSave = 1;
                }domUtils.remove(tmp);
              }
            }if (me.undoManger && doSave) {
              me.undoManger.save();
            }
          }browser.opera && range.select();
        } else {
          me.fireEvent("saveScene", true, true);
        }
      }
    });me.addListener("keydown", function (type, evt) {
      var keyCode = evt.keyCode || evt.which;if (keyCode == 13) {
        if (me.fireEvent("beforeenterkeydown")) {
          domUtils.preventDefault(evt);return;
        }me.fireEvent("saveScene", true, true);hTag = "";var range = me.selection.getRange();if (!range.collapsed) {
          var start = range.startContainer,
              end = range.endContainer,
              startTd = domUtils.findParentByTagName(start, "td", true),
              endTd = domUtils.findParentByTagName(end, "td", true);if (startTd && endTd && startTd !== endTd || !startTd && endTd || startTd && !endTd) {
            evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;return;
          }
        }if (tag == "p") {
          if (!browser.ie) {
            start = domUtils.findParentByTagName(range.startContainer, ["ol", "ul", "p", "h1", "h2", "h3", "h4", "h5", "h6", "blockquote", "caption"], true);if (!start && !browser.opera) {
              me.document.execCommand("formatBlock", false, "<p>");if (browser.gecko) {
                range = me.selection.getRange();start = domUtils.findParentByTagName(range.startContainer, "p", true);start && domUtils.removeDirtyAttr(start);
              }
            } else {
              hTag = start.tagName;start.tagName.toLowerCase() == "p" && browser.gecko && domUtils.removeDirtyAttr(start);
            }
          }
        } else {
          evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;if (!range.collapsed) {
            range.deleteContents();start = range.startContainer;if (start.nodeType == 1 && (start = start.childNodes[range.startOffset])) {
              while (start.nodeType == 1) {
                if (dtd.$empty[start.tagName]) {
                  range.setStartBefore(start).setCursor();if (me.undoManger) {
                    me.undoManger.save();
                  }return false;
                }if (!start.firstChild) {
                  var br = range.document.createElement("br");start.appendChild(br);range.setStart(start, 0).setCursor();if (me.undoManger) {
                    me.undoManger.save();
                  }return false;
                }start = start.firstChild;
              }if (start === range.startContainer.childNodes[range.startOffset]) {
                br = range.document.createElement("br");range.insertNode(br).setCursor();
              } else {
                range.setStart(start, 0).setCursor();
              }
            } else {
              br = range.document.createElement("br");range.insertNode(br).setStartAfter(br).setCursor();
            }
          } else {
            br = range.document.createElement("br");range.insertNode(br);var parent = br.parentNode;if (parent.lastChild === br) {
              br.parentNode.insertBefore(br.cloneNode(true), br);range.setStartBefore(br);
            } else {
              range.setStartAfter(br);
            }range.setCursor();
          }
        }
      }
    });
  };UE.plugins["keystrokes"] = function () {
    var me = this;var collapsed = true;me.addListener("keydown", function (type, evt) {
      var keyCode = evt.keyCode || evt.which,
          rng = me.selection.getRange();if (!rng.collapsed && !(evt.ctrlKey || evt.shiftKey || evt.altKey || evt.metaKey) && (keyCode >= 65 && keyCode <= 90 || keyCode >= 48 && keyCode <= 57 || keyCode >= 96 && keyCode <= 111 || { 13: 1, 8: 1, 46: 1 }[keyCode])) {
        var tmpNode = rng.startContainer;if (domUtils.isFillChar(tmpNode)) {
          rng.setStartBefore(tmpNode);
        }tmpNode = rng.endContainer;if (domUtils.isFillChar(tmpNode)) {
          rng.setEndAfter(tmpNode);
        }rng.txtToElmBoundary();if (rng.endContainer && rng.endContainer.nodeType == 1) {
          tmpNode = rng.endContainer.childNodes[rng.endOffset];if (tmpNode && domUtils.isBr(tmpNode)) {
            rng.setEndAfter(tmpNode);
          }
        }if (rng.startOffset == 0) {
          tmpNode = rng.startContainer;if (domUtils.isBoundaryNode(tmpNode, "firstChild")) {
            tmpNode = rng.endContainer;if (rng.endOffset == (tmpNode.nodeType == 3 ? tmpNode.nodeValue.length : tmpNode.childNodes.length) && domUtils.isBoundaryNode(tmpNode, "lastChild")) {
              me.fireEvent("saveScene");me.body.innerHTML = "<p>" + (browser.ie ? "" : "<br/>") + "</p>";rng.setStart(me.body.firstChild, 0).setCursor(false, true);me._selectionChange();return;
            }
          }
        }
      }if (keyCode == keymap.Backspace) {
        rng = me.selection.getRange();collapsed = rng.collapsed;if (me.fireEvent("delkeydown", evt)) {
          return;
        }var start, end;if (rng.collapsed && rng.inFillChar()) {
          start = rng.startContainer;if (domUtils.isFillChar(start)) {
            rng.setStartBefore(start).shrinkBoundary(true).collapse(true);domUtils.remove(start);
          } else {
            start.nodeValue = start.nodeValue.replace(new RegExp("^" + domUtils.fillChar), "");rng.startOffset--;rng.collapse(true).select(true);
          }
        }if (start = rng.getClosedNode()) {
          me.fireEvent("saveScene");rng.setStartBefore(start);domUtils.remove(start);rng.setCursor();me.fireEvent("saveScene");domUtils.preventDefault(evt);return;
        }if (!browser.ie) {
          start = domUtils.findParentByTagName(rng.startContainer, "table", true);end = domUtils.findParentByTagName(rng.endContainer, "table", true);if (start && !end || !start && end || start !== end) {
            evt.preventDefault();return;
          }
        }
      }if (keyCode == keymap.Tab) {
        var excludeTagNameForTabKey = { "ol": 1, "ul": 1, "table": 1 };if (me.fireEvent("tabkeydown", evt)) {
          domUtils.preventDefault(evt);return;
        }var range = me.selection.getRange();me.fireEvent("saveScene");for (var i = 0, txt = "", tabSize = me.options.tabSize || 4, tabNode = me.options.tabNode || "&nbsp;"; i < tabSize; i++) {
          txt += tabNode;
        }var span = me.document.createElement("span");span.innerHTML = txt + domUtils.fillChar;if (range.collapsed) {
          range.insertNode(span.cloneNode(true).firstChild).setCursor(true);
        } else {
          var filterFn = function filterFn(node) {
            return domUtils.isBlockElm(node) && !excludeTagNameForTabKey[node.tagName.toLowerCase()];
          };start = domUtils.findParent(range.startContainer, filterFn, true);end = domUtils.findParent(range.endContainer, filterFn, true);if (start && end && start === end) {
            range.deleteContents();range.insertNode(span.cloneNode(true).firstChild).setCursor(true);
          } else {
            var bookmark = range.createBookmark();range.enlarge(true);var bookmark2 = range.createBookmark(),
                current = domUtils.getNextDomNode(bookmark2.start, false, filterFn);while (current && !(domUtils.getPosition(current, bookmark2.end) & domUtils.POSITION_FOLLOWING)) {
              current.insertBefore(span.cloneNode(true).firstChild, current.firstChild);current = domUtils.getNextDomNode(current, false, filterFn);
            }range.moveToBookmark(bookmark2).moveToBookmark(bookmark).select();
          }
        }domUtils.preventDefault(evt);
      }if (browser.gecko && keyCode == 46) {
        range = me.selection.getRange();if (range.collapsed) {
          start = range.startContainer;if (domUtils.isEmptyBlock(start)) {
            var parent = start.parentNode;while (domUtils.getChildCount(parent) == 1 && !domUtils.isBody(parent)) {
              start = parent;parent = parent.parentNode;
            }if (start === parent.lastChild) {
              evt.preventDefault();
            }return;
          }
        }
      }
    });me.addListener("keyup", function (type, evt) {
      var keyCode = evt.keyCode || evt.which,
          rng,
          me = this;if (keyCode == keymap.Backspace) {
        if (me.fireEvent("delkeyup")) {
          return;
        }rng = me.selection.getRange();if (rng.collapsed) {
          var tmpNode,
              autoClearTagName = ["h1", "h2", "h3", "h4", "h5", "h6"];if (tmpNode = domUtils.findParentByTagName(rng.startContainer, autoClearTagName, true)) {
            if (domUtils.isEmptyBlock(tmpNode)) {
              var pre = tmpNode.previousSibling;if (pre && pre.nodeName != "TABLE") {
                domUtils.remove(tmpNode);rng.setStartAtLast(pre).setCursor(false, true);return;
              } else {
                var next = tmpNode.nextSibling;if (next && next.nodeName != "TABLE") {
                  domUtils.remove(tmpNode);rng.setStartAtFirst(next).setCursor(false, true);return;
                }
              }
            }
          }if (domUtils.isBody(rng.startContainer)) {
            var tmpNode = domUtils.createElement(me.document, "p", { "innerHTML": browser.ie ? domUtils.fillChar : "<br/>" });rng.insertNode(tmpNode).setStart(tmpNode, 0).setCursor(false, true);
          }
        }if (!collapsed && (rng.startContainer.nodeType == 3 || rng.startContainer.nodeType == 1 && domUtils.isEmptyBlock(rng.startContainer))) {
          if (browser.ie) {
            var span = rng.document.createElement("span");rng.insertNode(span).setStartBefore(span).collapse(true);rng.select();domUtils.remove(span);
          } else {
            rng.select();
          }
        }
      }
    });
  };UE.plugins["fiximgclick"] = function () {
    var elementUpdated = false;function Scale() {
      this.editor = null;this.resizer = null;this.cover = null;this.doc = document;this.prePos = { x: 0, y: 0 };this.startPos = { x: 0, y: 0 };
    }(function () {
      var rect = [[0, 0, -1, -1], [0, 0, 0, -1], [0, 0, 1, -1], [0, 0, -1, 0], [0, 0, 1, 0], [0, 0, -1, 1], [0, 0, 0, 1], [0, 0, 1, 1]];Scale.prototype = { init: function init(editor) {
          var me = this;me.editor = editor;me.startPos = this.prePos = { x: 0, y: 0 };me.dragId = -1;var hands = [],
              cover = me.cover = document.createElement("div"),
              resizer = me.resizer = document.createElement("div");cover.id = me.editor.ui.id + "_imagescale_cover";cover.style.cssText = "position:absolute;display:none;z-index:" + me.editor.options.zIndex + ";filter:alpha(opacity=0); opacity:0;background:#CCC;";domUtils.on(cover, "mousedown click", function () {
            me.hide();
          });for (var i = 0; i < 8; i++) {
            hands.push('<span class="edui-editor-imagescale-hand' + i + '"></span>');
          }resizer.id = me.editor.ui.id + "_imagescale";resizer.className = "edui-editor-imagescale";resizer.innerHTML = hands.join("");resizer.style.cssText += ";display:none;border:1px solid #3b77ff;z-index:" + me.editor.options.zIndex + ";";me.editor.ui.getDom().appendChild(cover);me.editor.ui.getDom().appendChild(resizer);me.initStyle();me.initEvents();
        }, initStyle: function initStyle() {
          utils.cssRule("imagescale", ".edui-editor-imagescale{display:none;position:absolute;border:1px solid #38B2CE;cursor:hand;-webkit-box-sizing: content-box;-moz-box-sizing: content-box;box-sizing: content-box;}" + ".edui-editor-imagescale span{position:absolute;width:6px;height:6px;overflow:hidden;font-size:0px;display:block;background-color:#3C9DD0;}" + ".edui-editor-imagescale .edui-editor-imagescale-hand0{cursor:nw-resize;top:0;margin-top:-4px;left:0;margin-left:-4px;}" + ".edui-editor-imagescale .edui-editor-imagescale-hand1{cursor:n-resize;top:0;margin-top:-4px;left:50%;margin-left:-4px;}" + ".edui-editor-imagescale .edui-editor-imagescale-hand2{cursor:ne-resize;top:0;margin-top:-4px;left:100%;margin-left:-3px;}" + ".edui-editor-imagescale .edui-editor-imagescale-hand3{cursor:w-resize;top:50%;margin-top:-4px;left:0;margin-left:-4px;}" + ".edui-editor-imagescale .edui-editor-imagescale-hand4{cursor:e-resize;top:50%;margin-top:-4px;left:100%;margin-left:-3px;}" + ".edui-editor-imagescale .edui-editor-imagescale-hand5{cursor:sw-resize;top:100%;margin-top:-3px;left:0;margin-left:-4px;}" + ".edui-editor-imagescale .edui-editor-imagescale-hand6{cursor:s-resize;top:100%;margin-top:-3px;left:50%;margin-left:-4px;}" + ".edui-editor-imagescale .edui-editor-imagescale-hand7{cursor:se-resize;top:100%;margin-top:-3px;left:100%;margin-left:-3px;}");
        }, initEvents: function initEvents() {
          var me = this;me.startPos.x = me.startPos.y = 0;me.isDraging = false;
        }, _eventHandler: function _eventHandler(e) {
          var me = this;switch (e.type) {case "mousedown":
              var hand = e.target || e.srcElement,
                  hand;if (hand.className.indexOf("edui-editor-imagescale-hand") != -1 && me.dragId == -1) {
                me.dragId = hand.className.slice(-1);me.startPos.x = me.prePos.x = e.clientX;me.startPos.y = me.prePos.y = e.clientY;domUtils.on(me.doc, "mousemove", me.proxy(me._eventHandler, me));
              }break;case "mousemove":
              if (me.dragId != -1) {
                me.updateContainerStyle(me.dragId, { x: e.clientX - me.prePos.x, y: e.clientY - me.prePos.y });me.prePos.x = e.clientX;me.prePos.y = e.clientY;elementUpdated = true;me.updateTargetElement();
              }break;case "mouseup":
              if (me.dragId != -1) {
                me.updateContainerStyle(me.dragId, { x: e.clientX - me.prePos.x, y: e.clientY - me.prePos.y });me.updateTargetElement();if (me.target.parentNode) {
                  me.attachTo(me.target);
                }me.dragId = -1;
              }domUtils.un(me.doc, "mousemove", me.proxy(me._eventHandler, me));if (elementUpdated) {
                elementUpdated = false;me.editor.fireEvent("contentchange");
              }break;default:
              break;}
        }, updateTargetElement: function updateTargetElement() {
          var me = this;domUtils.setStyles(me.target, { "width": me.resizer.style.width, "height": me.resizer.style.height });me.target.width = parseInt(me.resizer.style.width);me.target.height = parseInt(me.resizer.style.height);me.attachTo(me.target);
        }, updateContainerStyle: function updateContainerStyle(dir, offset) {
          var me = this,
              dom = me.resizer,
              tmp;if (rect[dir][0] != 0) {
            tmp = parseInt(dom.style.left) + offset.x;dom.style.left = me._validScaledProp("left", tmp) + "px";
          }if (rect[dir][1] != 0) {
            tmp = parseInt(dom.style.top) + offset.y;dom.style.top = me._validScaledProp("top", tmp) + "px";
          }if (rect[dir][2] != 0) {
            tmp = dom.clientWidth + rect[dir][2] * offset.x;dom.style.width = me._validScaledProp("width", tmp) + "px";
          }if (rect[dir][3] != 0) {
            tmp = dom.clientHeight + rect[dir][3] * offset.y;dom.style.height = me._validScaledProp("height", tmp) + "px";
          }
        }, _validScaledProp: function _validScaledProp(prop, value) {
          var ele = this.resizer,
              wrap = document;value = isNaN(value) ? 0 : value;switch (prop) {case "left":
              return value < 0 ? 0 : value + ele.clientWidth > wrap.clientWidth ? wrap.clientWidth - ele.clientWidth : value;case "top":
              return value < 0 ? 0 : value + ele.clientHeight > wrap.clientHeight ? wrap.clientHeight - ele.clientHeight : value;case "width":
              return value <= 0 ? 1 : value + ele.offsetLeft > wrap.clientWidth ? wrap.clientWidth - ele.offsetLeft : value;case "height":
              return value <= 0 ? 1 : value + ele.offsetTop > wrap.clientHeight ? wrap.clientHeight - ele.offsetTop : value;}
        }, hideCover: function hideCover() {
          this.cover.style.display = "none";
        }, showCover: function showCover() {
          var me = this,
              editorPos = domUtils.getXY(me.editor.ui.getDom()),
              iframePos = domUtils.getXY(me.editor.iframe);domUtils.setStyles(me.cover, { "width": me.editor.iframe.offsetWidth + "px", "height": me.editor.iframe.offsetHeight + "px", "top": iframePos.y - editorPos.y + "px", "left": iframePos.x - editorPos.x + "px", "position": "absolute", "display": "" });
        }, show: function show(targetObj) {
          var me = this;me.resizer.style.display = "block";if (targetObj) {
            me.attachTo(targetObj);
          }domUtils.on(this.resizer, "mousedown", me.proxy(me._eventHandler, me));domUtils.on(me.doc, "mouseup", me.proxy(me._eventHandler, me));me.showCover();me.editor.fireEvent("afterscaleshow", me);me.editor.fireEvent("saveScene");
        }, hide: function hide() {
          var me = this;me.hideCover();me.resizer.style.display = "none";domUtils.un(me.resizer, "mousedown", me.proxy(me._eventHandler, me));domUtils.un(me.doc, "mouseup", me.proxy(me._eventHandler, me));me.editor.fireEvent("afterscalehide", me);
        }, proxy: function proxy(fn, context) {
          return function (e) {
            return fn.apply(context || this, arguments);
          };
        }, attachTo: function attachTo(targetObj) {
          var me = this,
              target = me.target = targetObj,
              resizer = this.resizer,
              imgPos = domUtils.getXY(target),
              iframePos = domUtils.getXY(me.editor.iframe),
              editorPos = domUtils.getXY(resizer.parentNode);domUtils.setStyles(resizer, { "width": target.width + "px", "height": target.height + "px", "left": iframePos.x + imgPos.x - me.editor.document.body.scrollLeft - editorPos.x - parseInt(resizer.style.borderLeftWidth) + "px", "top": iframePos.y + imgPos.y - me.editor.document.body.scrollTop - editorPos.y - parseInt(resizer.style.borderTopWidth) + "px" });
        } };
    })();return function () {
      var me = this,
          imageScale;me.setOpt("imageScaleEnabled", true);if (!browser.ie && me.options.imageScaleEnabled) {
        me.addListener("click", function (type, e) {
          var range = me.selection.getRange(),
              img = range.getClosedNode();if (img && img.tagName == "IMG" && me.body.contentEditable != "false") {
            if (img.className.indexOf("edui-faked-music") != -1 || img.getAttribute("anchorname") || domUtils.hasClass(img, "loadingclass") || domUtils.hasClass(img, "loaderrorclass")) {
              return;
            }if (!imageScale) {
              imageScale = new Scale();imageScale.init(me);me.ui.getDom().appendChild(imageScale.resizer);var _keyDownHandler = function _keyDownHandler(e) {
                imageScale.hide();if (imageScale.target) {
                  me.selection.getRange().selectNode(imageScale.target).select();
                }
              },
                  _mouseDownHandler = function _mouseDownHandler(e) {
                var ele = e.target || e.srcElement;if (ele && (ele.className === undefined || ele.className.indexOf("edui-editor-imagescale") == -1)) {
                  _keyDownHandler(e);
                }
              },
                  timer;me.addListener("afterscaleshow", function (e) {
                me.addListener("beforekeydown", _keyDownHandler);me.addListener("beforemousedown", _mouseDownHandler);domUtils.on(document, "keydown", _keyDownHandler);domUtils.on(document, "mousedown", _mouseDownHandler);me.selection.getNative().removeAllRanges();
              });me.addListener("afterscalehide", function (e) {
                me.removeListener("beforekeydown", _keyDownHandler);me.removeListener("beforemousedown", _mouseDownHandler);domUtils.un(document, "keydown", _keyDownHandler);domUtils.un(document, "mousedown", _mouseDownHandler);var target = imageScale.target;if (target.parentNode) {
                  me.selection.getRange().selectNode(target).select();
                }
              });domUtils.on(imageScale.resizer, "mousedown", function (e) {
                me.selection.getNative().removeAllRanges();var ele = e.target || e.srcElement;if (ele && ele.className.indexOf("edui-editor-imagescale-hand") == -1) {
                  timer = setTimeout(function () {
                    imageScale.hide();if (imageScale.target) {
                      me.selection.getRange().selectNode(ele).select();
                    }
                  }, 200);
                }
              });domUtils.on(imageScale.resizer, "mouseup", function (e) {
                var ele = e.target || e.srcElement;if (ele && ele.className.indexOf("edui-editor-imagescale-hand") == -1) {
                  clearTimeout(timer);
                }
              });
            }imageScale.show(img);
          } else {
            if (imageScale && imageScale.resizer.style.display != "none") {
              imageScale.hide();
            }
          }
        });
      }if (browser.webkit) {
        me.addListener("click", function (type, e) {
          if (e.target.tagName == "IMG" && me.body.contentEditable != "false") {
            var range = new dom.Range(me.document);range.selectNode(e.target).select();
          }
        });
      }
    };
  }();UE.plugin.register("autolink", function () {
    var cont = 0;return !browser.ie ? { bindEvents: { "reset": function reset() {
          cont = 0;
        }, "keydown": function keydown(type, evt) {
          var me = this;var keyCode = evt.keyCode || evt.which;if (keyCode == 32 || keyCode == 13) {
            var sel = me.selection.getNative(),
                range = sel.getRangeAt(0).cloneRange(),
                offset,
                charCode;var start = range.startContainer;while (start.nodeType == 1 && range.startOffset > 0) {
              start = range.startContainer.childNodes[range.startOffset - 1];if (!start) {
                break;
              }range.setStart(start, start.nodeType == 1 ? start.childNodes.length : start.nodeValue.length);range.collapse(true);start = range.startContainer;
            }do {
              if (range.startOffset == 0) {
                start = range.startContainer.previousSibling;while (start && start.nodeType == 1) {
                  start = start.lastChild;
                }if (!start || domUtils.isFillChar(start)) {
                  break;
                }offset = start.nodeValue.length;
              } else {
                start = range.startContainer;offset = range.startOffset;
              }range.setStart(start, offset - 1);charCode = range.toString().charCodeAt(0);
            } while (charCode != 160 && charCode != 32);if (range.toString().replace(new RegExp(domUtils.fillChar, "g"), "").match(/(?:https?:\/\/|ssh:\/\/|ftp:\/\/|file:\/|www\.)/i)) {
              while (range.toString().length) {
                if (/^(?:https?:\/\/|ssh:\/\/|ftp:\/\/|file:\/|www\.)/i.test(range.toString())) {
                  break;
                }try {
                  range.setStart(range.startContainer, range.startOffset + 1);
                } catch (e) {
                  var start = range.startContainer;while (!(next = start.nextSibling)) {
                    if (domUtils.isBody(start)) {
                      return;
                    }start = start.parentNode;
                  }range.setStart(next, 0);
                }
              }if (domUtils.findParentByTagName(range.startContainer, "a", true)) {
                return;
              }var a = me.document.createElement("a"),
                  text = me.document.createTextNode(" "),
                  href;me.undoManger && me.undoManger.save();a.appendChild(range.extractContents());a.href = a.innerHTML = a.innerHTML.replace(/<[^>]+>/g, "");href = a.getAttribute("href").replace(new RegExp(domUtils.fillChar, "g"), "");href = /^(?:https?:\/\/)/ig.test(href) ? href : "http://" + href;a.setAttribute("_src", utils.html(href));a.href = utils.html(href);range.insertNode(a);a.parentNode.insertBefore(text, a.nextSibling);range.setStart(text, 0);range.collapse(true);sel.removeAllRanges();sel.addRange(range);me.undoManger && me.undoManger.save();
            }
          }
        } } } : {};
  }, function () {
    var keyCodes = { 37: 1, 38: 1, 39: 1, 40: 1, 13: 1, 32: 1 };function checkIsCludeLink(node) {
      if (node.nodeType == 3) {
        return null;
      }if (node.nodeName == "A") {
        return node;
      }var lastChild = node.lastChild;while (lastChild) {
        if (lastChild.nodeName == "A") {
          return lastChild;
        }if (lastChild.nodeType == 3) {
          if (domUtils.isWhitespace(lastChild)) {
            lastChild = lastChild.previousSibling;continue;
          }return null;
        }lastChild = lastChild.lastChild;
      }
    }browser.ie && this.addListener("keyup", function (cmd, evt) {
      var me = this,
          keyCode = evt.keyCode;if (keyCodes[keyCode]) {
        var rng = me.selection.getRange();var start = rng.startContainer;if (keyCode == 13) {
          while (start && !domUtils.isBody(start) && !domUtils.isBlockElm(start)) {
            start = start.parentNode;
          }if (start && !domUtils.isBody(start) && start.nodeName == "P") {
            var pre = start.previousSibling;if (pre && pre.nodeType == 1) {
              var pre = checkIsCludeLink(pre);if (pre && !pre.getAttribute("_href")) {
                domUtils.remove(pre, true);
              }
            }
          }
        } else {
          if (keyCode == 32) {
            if (start.nodeType == 3 && /^\s$/.test(start.nodeValue)) {
              start = start.previousSibling;if (start && start.nodeName == "A" && !start.getAttribute("_href")) {
                domUtils.remove(start, true);
              }
            }
          } else {
            start = domUtils.findParentByTagName(start, "a", true);if (start && !start.getAttribute("_href")) {
              var bk = rng.createBookmark();domUtils.remove(start, true);rng.moveToBookmark(bk).select(true);
            }
          }
        }
      }
    });
  });UE.plugins["autoheight"] = function () {
    var me = this;me.autoHeightEnabled = me.options.autoHeightEnabled !== false;if (!me.autoHeightEnabled) {
      return;
    }var bakOverflow,
        lastHeight = 0,
        options = me.options,
        currentHeight,
        timer;function adjustHeight() {
      var me = this;clearTimeout(timer);if (isFullscreen) {
        return;
      }if (!me.queryCommandState || me.queryCommandState && me.queryCommandState("source") != 1) {
        timer = setTimeout(function () {
          var node = me.body.lastChild;while (node && node.nodeType != 1) {
            node = node.previousSibling;
          }if (node && node.nodeType == 1) {
            node.style.clear = "both";currentHeight = Math.max(domUtils.getXY(node).y + node.offsetHeight + 25, Math.max(options.minFrameHeight, options.initialFrameHeight));if (currentHeight != lastHeight) {
              if (currentHeight !== parseInt(me.iframe.parentNode.style.height)) {
                me.iframe.parentNode.style.height = currentHeight + "px";
              }me.body.style.height = currentHeight + "px";lastHeight = currentHeight;
            }domUtils.removeStyle(node, "clear");
          }
        }, 50);
      }
    }var isFullscreen;me.addListener("fullscreenchanged", function (cmd, f) {
      isFullscreen = f;
    });me.addListener("destroy", function () {
      me.removeListener("contentchange afterinserthtml keyup mouseup", adjustHeight);
    });me.enableAutoHeight = function () {
      var me = this;if (!me.autoHeightEnabled) {
        return;
      }var doc = me.document;me.autoHeightEnabled = true;bakOverflow = doc.body.style.overflowY;doc.body.style.overflowY = "hidden";me.addListener("contentchange afterinserthtml keyup mouseup", adjustHeight);setTimeout(function () {
        adjustHeight.call(me);
      }, browser.gecko ? 100 : 0);me.fireEvent("autoheightchanged", me.autoHeightEnabled);
    };me.disableAutoHeight = function () {
      me.body.style.overflowY = bakOverflow || "";me.removeListener("contentchange", adjustHeight);me.removeListener("keyup", adjustHeight);me.removeListener("mouseup", adjustHeight);me.autoHeightEnabled = false;me.fireEvent("autoheightchanged", me.autoHeightEnabled);
    };me.on("setHeight", function () {
      me.disableAutoHeight();
    });me.addListener("ready", function () {
      me.enableAutoHeight();var timer;domUtils.on(browser.ie ? me.body : me.document, browser.webkit ? "dragover" : "drop", function () {
        clearTimeout(timer);timer = setTimeout(function () {
          adjustHeight.call(me);
        }, 100);
      });var lastScrollY;window.onscroll = function () {
        if (lastScrollY === null) {
          lastScrollY = this.scrollY;
        } else {
          if (this.scrollY == 0 && lastScrollY != 0) {
            me.window.scrollTo(0, 0);lastScrollY = null;
          }
        }
      };
    });
  };UE.plugins["autofloat"] = function () {
    var me = this,
        lang = me.getLang();me.setOpt({ topOffset: 0 });var optsAutoFloatEnabled = me.options.autoFloatEnabled !== false,
        topOffset = me.options.topOffset;if (!optsAutoFloatEnabled) {
      return;
    }var uiUtils = UE.ui.uiUtils,
        LteIE6 = browser.ie && browser.version <= 6,
        quirks = browser.quirks;function checkHasUI() {
      if (!UE.ui) {
        alert(lang.autofloatMsg);return 0;
      }return 1;
    }function fixIE6FixedPos() {
      var docStyle = document.body.style;docStyle.backgroundImage = 'url("about:blank")';docStyle.backgroundAttachment = "fixed";
    }var bakCssText,
        placeHolder = document.createElement("div"),
        toolbarBox,
        orgTop,
        getPosition,
        flag = true;function setFloating() {
      var toobarBoxPos = domUtils.getXY(toolbarBox),
          origalFloat = domUtils.getComputedStyle(toolbarBox, "position"),
          origalLeft = domUtils.getComputedStyle(toolbarBox, "left");toolbarBox.style.width = toolbarBox.offsetWidth + "px";toolbarBox.style.zIndex = me.options.zIndex * 1 + 1;toolbarBox.parentNode.insertBefore(placeHolder, toolbarBox);if (LteIE6 || quirks && browser.ie) {
        if (toolbarBox.style.position != "absolute") {
          toolbarBox.style.position = "absolute";
        }toolbarBox.style.top = (document.body.scrollTop || document.documentElement.scrollTop) - orgTop + topOffset + "px";
      } else {
        if (browser.ie7Compat && flag) {
          flag = false;toolbarBox.style.left = domUtils.getXY(toolbarBox).x - document.documentElement.getBoundingClientRect().left + 2 + "px";
        }if (toolbarBox.style.position != "fixed") {
          toolbarBox.style.position = "fixed";toolbarBox.style.top = topOffset + "px";(origalFloat == "absolute" || origalFloat == "relative") && parseFloat(origalLeft) && (toolbarBox.style.left = toobarBoxPos.x + "px");
        }
      }
    }function unsetFloating() {
      flag = true;if (placeHolder.parentNode) {
        placeHolder.parentNode.removeChild(placeHolder);
      }toolbarBox.style.cssText = bakCssText;
    }function updateFloating() {
      var rect3 = getPosition(me.container);var offset = me.options.toolbarTopOffset || 0;if (rect3.top < 0 && rect3.bottom - toolbarBox.offsetHeight > offset) {
        setFloating();
      } else {
        unsetFloating();
      }
    }var defer_updateFloating = utils.defer(function () {
      updateFloating();
    }, browser.ie ? 200 : 100, true);me.addListener("destroy", function () {
      domUtils.un(window, ["scroll", "resize"], updateFloating);me.removeListener("keydown", defer_updateFloating);
    });me.addListener("ready", function () {
      if (checkHasUI(me)) {
        if (!me.ui) {
          return;
        }getPosition = uiUtils.getClientRect;toolbarBox = me.ui.getDom("toolbarbox");orgTop = getPosition(toolbarBox).top;bakCssText = toolbarBox.style.cssText;placeHolder.style.height = toolbarBox.offsetHeight + "px";if (LteIE6) {
          fixIE6FixedPos();
        }domUtils.on(window, ["scroll", "resize"], updateFloating);me.addListener("keydown", defer_updateFloating);me.addListener("beforefullscreenchange", function (t, enabled) {
          if (enabled) {
            unsetFloating();
          }
        });me.addListener("fullscreenchanged", function (t, enabled) {
          if (!enabled) {
            updateFloating();
          }
        });me.addListener("sourcemodechanged", function (t, enabled) {
          setTimeout(function () {
            updateFloating();
          }, 0);
        });me.addListener("clearDoc", function () {
          setTimeout(function () {
            updateFloating();
          }, 0);
        });
      }
    });
  };UE.plugins["video"] = function () {
    var me = this;function creatInsertStr(url, width, height, id, align, classname, type) {
      url = utils.unhtmlForUrl(url);align = utils.unhtml(align);classname = utils.unhtml(classname);width = parseInt(width, 10) || 0;height = parseInt(height, 10) || 0;var str;switch (type) {case "image":
          str = "<img " + (id ? 'id="' + id + '"' : "") + ' width="' + width + '" height="' + height + '" _url="' + url + '" class="' + classname.replace(/\bvideo-js\b/, "") + '"' + ' src="' + me.options.UEDITOR_HOME_URL + 'themes/default/images/spacer.gif" style="background:url(' + me.options.UEDITOR_HOME_URL + "themes/default/images/videologo.gif) no-repeat center center; border:1px solid gray;" + (align ? "float:" + align + ";" : "") + '" />';break;case "embed":
          str = '<embed type="application/x-shockwave-flash" class="' + classname + '" pluginspage="http://www.macromedia.com/go/getflashplayer"' + ' src="' + utils.html(url) + '" width="' + width + '" height="' + height + '"' + (align ? ' style="float:' + align + '"' : "") + ' wmode="transparent" play="true" loop="false" menu="false" allowscriptaccess="never" allowfullscreen="true" >';break;case "video":
          var ext = url.substr(url.lastIndexOf(".") + 1);if (ext == "ogv") {
            ext = "ogg";
          }str = "<video" + (id ? ' id="' + id + '"' : "") + ' class="' + classname + ' video-js" ' + (align ? ' style="float:' + align + '"' : "") + ' controls preload="none" width="' + width + '" height="' + height + '" src="' + url + '" data-setup="{}">' + '<source src="' + url + '" type="video/' + ext + '" /></video>';break;}return str;
    }function switchImgAndVideo(root, img2video) {
      utils.each(root.getNodesByTagName(img2video ? "img" : "embed video"), function (node) {
        var className = node.getAttr("class");if (className && className.indexOf("edui-faked-video") != -1) {
          var html = creatInsertStr(img2video ? node.getAttr("_url") : node.getAttr("src"), node.getAttr("width"), node.getAttr("height"), null, node.getStyle("float") || "", className, img2video ? "embed" : "image");node.parentNode.replaceChild(UE.uNode.createElement(html), node);
        }if (className && className.indexOf("edui-upload-video") != -1) {
          var html = creatInsertStr(img2video ? node.getAttr("_url") : node.getAttr("src"), node.getAttr("width"), node.getAttr("height"), null, node.getStyle("float") || "", className, img2video ? "video" : "image");node.parentNode.replaceChild(UE.uNode.createElement(html), node);
        }
      });
    }me.addOutputRule(function (root) {
      switchImgAndVideo(root, true);
    });me.addInputRule(function (root) {
      switchImgAndVideo(root);
    });me.commands["insertvideo"] = { execCommand: function execCommand(cmd, videoObjs, type) {
        videoObjs = utils.isArray(videoObjs) ? videoObjs : [videoObjs];var html = [],
            id = "tmpVedio",
            cl;for (var i = 0, vi, len = videoObjs.length; i < len; i++) {
          vi = videoObjs[i];cl = type == "upload" ? "edui-upload-video video-js vjs-default-skin" : "edui-faked-video";html.push(creatInsertStr(vi.url, vi.width || 420, vi.height || 280, id + i, null, cl, "image"));
        }me.execCommand("inserthtml", html.join(""), true);var rng = this.selection.getRange();for (var i = 0, len = videoObjs.length; i < len; i++) {
          var img = this.document.getElementById("tmpVedio" + i);domUtils.removeAttributes(img, "id");rng.selectNode(img).select();me.execCommand("imagefloat", videoObjs[i].align);
        }
      }, queryCommandState: function queryCommandState() {
        var img = me.selection.getRange().getClosedNode(),
            flag = img && (img.className == "edui-faked-video" || img.className.indexOf("edui-upload-video") != -1);return flag ? 1 : 0;
      } };
  };(function () {
    var UETable = UE.UETable = function (table) {
      this.table = table;this.indexTable = [];this.selectedTds = [];this.cellsRange = {};this.update(table);
    };UETable.removeSelectedClass = function (cells) {
      utils.each(cells, function (cell) {
        domUtils.removeClasses(cell, "selectTdClass");
      });
    };UETable.addSelectedClass = function (cells) {
      utils.each(cells, function (cell) {
        domUtils.addClass(cell, "selectTdClass");
      });
    };UETable.isEmptyBlock = function (node) {
      var reg = new RegExp(domUtils.fillChar, "g");if (node[browser.ie ? "innerText" : "textContent"].replace(/^\s*$/, "").replace(reg, "").length > 0) {
        return 0;
      }for (var i in dtd.$isNotEmpty) {
        if (dtd.$isNotEmpty.hasOwnProperty(i)) {
          if (node.getElementsByTagName(i).length) {
            return 0;
          }
        }
      }return 1;
    };UETable.getWidth = function (cell) {
      if (!cell) {
        return 0;
      }return parseInt(domUtils.getComputedStyle(cell, "width"), 10);
    };UETable.getTableCellAlignState = function (cells) {
      !utils.isArray(cells) && (cells = [cells]);var result = {},
          status = ["align", "valign"],
          tempStatus = null,
          isSame = true;utils.each(cells, function (cellNode) {
        utils.each(status, function (currentState) {
          tempStatus = cellNode.getAttribute(currentState);if (!result[currentState] && tempStatus) {
            result[currentState] = tempStatus;
          } else {
            if (!result[currentState] || tempStatus !== result[currentState]) {
              isSame = false;return false;
            }
          }
        });return isSame;
      });return isSame ? result : null;
    };UETable.getTableItemsByRange = function (editor) {
      var start = editor.selection.getStart();if (start && start.id && start.id.indexOf("_baidu_bookmark_start_") === 0 && start.nextSibling) {
        start = start.nextSibling;
      }var cell = start && domUtils.findParentByTagName(start, ["td", "th"], true),
          tr = cell && cell.parentNode,
          caption = start && domUtils.findParentByTagName(start, "caption", true),
          table = caption ? caption.parentNode : tr && tr.parentNode.parentNode;return { cell: cell, tr: tr, table: table, caption: caption };
    };UETable.getUETableBySelected = function (editor) {
      var table = UETable.getTableItemsByRange(editor).table;if (table && table.ueTable && table.ueTable.selectedTds.length) {
        return table.ueTable;
      }return null;
    };UETable.getDefaultValue = function (editor, table) {
      var borderMap = { thin: "0px", medium: "1px", thick: "2px" },
          tableBorder,
          tdPadding,
          tdBorder,
          tmpValue;if (!table) {
        table = editor.document.createElement("table");table.insertRow(0).insertCell(0).innerHTML = "xxx";editor.body.appendChild(table);var td = table.getElementsByTagName("td")[0];tmpValue = domUtils.getComputedStyle(table, "border-left-width");tableBorder = parseInt(borderMap[tmpValue] || tmpValue, 10);tmpValue = domUtils.getComputedStyle(td, "padding-left");tdPadding = parseInt(borderMap[tmpValue] || tmpValue, 10);tmpValue = domUtils.getComputedStyle(td, "border-left-width");tdBorder = parseInt(borderMap[tmpValue] || tmpValue, 10);domUtils.remove(table);return { tableBorder: tableBorder, tdPadding: tdPadding, tdBorder: tdBorder };
      } else {
        td = table.getElementsByTagName("td")[0];tmpValue = domUtils.getComputedStyle(table, "border-left-width");tableBorder = parseInt(borderMap[tmpValue] || tmpValue, 10);tmpValue = domUtils.getComputedStyle(td, "padding-left");tdPadding = parseInt(borderMap[tmpValue] || tmpValue, 10);tmpValue = domUtils.getComputedStyle(td, "border-left-width");tdBorder = parseInt(borderMap[tmpValue] || tmpValue, 10);return { tableBorder: tableBorder, tdPadding: tdPadding, tdBorder: tdBorder };
      }
    };UETable.getUETable = function (tdOrTable) {
      var tag = tdOrTable.tagName.toLowerCase();tdOrTable = tag == "td" || tag == "th" || tag == "caption" ? domUtils.findParentByTagName(tdOrTable, "table", true) : tdOrTable;if (!tdOrTable.ueTable) {
        tdOrTable.ueTable = new UETable(tdOrTable);
      }return tdOrTable.ueTable;
    };UETable.cloneCell = function (cell, ignoreMerge, keepPro) {
      if (!cell || utils.isString(cell)) {
        return this.table.ownerDocument.createElement(cell || "td");
      }var flag = domUtils.hasClass(cell, "selectTdClass");flag && domUtils.removeClasses(cell, "selectTdClass");var tmpCell = cell.cloneNode(true);if (ignoreMerge) {
        tmpCell.rowSpan = tmpCell.colSpan = 1;
      }!keepPro && domUtils.removeAttributes(tmpCell, "width height");!keepPro && domUtils.removeAttributes(tmpCell, "style");tmpCell.style.borderLeftStyle = "";tmpCell.style.borderTopStyle = "";tmpCell.style.borderLeftColor = cell.style.borderRightColor;tmpCell.style.borderLeftWidth = cell.style.borderRightWidth;tmpCell.style.borderTopColor = cell.style.borderBottomColor;tmpCell.style.borderTopWidth = cell.style.borderBottomWidth;flag && domUtils.addClass(cell, "selectTdClass");return tmpCell;
    };UETable.prototype = { getMaxRows: function getMaxRows() {
        var rows = this.table.rows,
            maxLen = 1;for (var i = 0, row; row = rows[i]; i++) {
          var currentMax = 1;for (var j = 0, cj; cj = row.cells[j++];) {
            currentMax = Math.max(cj.rowSpan || 1, currentMax);
          }maxLen = Math.max(currentMax + i, maxLen);
        }return maxLen;
      }, getMaxCols: function getMaxCols() {
        var rows = this.table.rows,
            maxLen = 0,
            cellRows = {};for (var i = 0, row; row = rows[i]; i++) {
          var cellsNum = 0;for (var j = 0, cj; cj = row.cells[j++];) {
            cellsNum += cj.colSpan || 1;if (cj.rowSpan && cj.rowSpan > 1) {
              for (var k = 1; k < cj.rowSpan; k++) {
                if (!cellRows["row_" + (i + k)]) {
                  cellRows["row_" + (i + k)] = cj.colSpan || 1;
                } else {
                  cellRows["row_" + (i + k)]++;
                }
              }
            }
          }cellsNum += cellRows["row_" + i] || 0;maxLen = Math.max(cellsNum, maxLen);
        }return maxLen;
      }, getCellColIndex: function getCellColIndex(cell) {}, getHSideCell: function getHSideCell(cell, right) {
        try {
          var cellInfo = this.getCellInfo(cell),
              previewRowIndex,
              previewColIndex;var len = this.selectedTds.length,
              range = this.cellsRange;if (!right && (!len ? !cellInfo.colIndex : !range.beginColIndex) || right && (!len ? cellInfo.colIndex == this.colsNum - 1 : range.endColIndex == this.colsNum - 1)) {
            return null;
          }previewRowIndex = !len ? cellInfo.rowIndex : range.beginRowIndex;previewColIndex = !right ? !len ? cellInfo.colIndex < 1 ? 0 : cellInfo.colIndex - 1 : range.beginColIndex - 1 : !len ? cellInfo.colIndex + 1 : range.endColIndex + 1;return this.getCell(this.indexTable[previewRowIndex][previewColIndex].rowIndex, this.indexTable[previewRowIndex][previewColIndex].cellIndex);
        } catch (e) {
          showError(e);
        }
      }, getTabNextCell: function getTabNextCell(cell, preRowIndex) {
        var cellInfo = this.getCellInfo(cell),
            rowIndex = preRowIndex || cellInfo.rowIndex,
            colIndex = cellInfo.colIndex + 1 + (cellInfo.colSpan - 1),
            nextCell;try {
          nextCell = this.getCell(this.indexTable[rowIndex][colIndex].rowIndex, this.indexTable[rowIndex][colIndex].cellIndex);
        } catch (e) {
          try {
            rowIndex = rowIndex * 1 + 1;colIndex = 0;nextCell = this.getCell(this.indexTable[rowIndex][colIndex].rowIndex, this.indexTable[rowIndex][colIndex].cellIndex);
          } catch (e) {}
        }return nextCell;
      }, getVSideCell: function getVSideCell(cell, bottom, ignoreRange) {
        try {
          var cellInfo = this.getCellInfo(cell),
              nextRowIndex,
              nextColIndex;var len = this.selectedTds.length && !ignoreRange,
              range = this.cellsRange;if (!bottom && cellInfo.rowIndex == 0 || bottom && (!len ? cellInfo.rowIndex + cellInfo.rowSpan > this.rowsNum - 1 : range.endRowIndex == this.rowsNum - 1)) {
            return null;
          }nextRowIndex = !bottom ? !len ? cellInfo.rowIndex - 1 : range.beginRowIndex - 1 : !len ? cellInfo.rowIndex + cellInfo.rowSpan : range.endRowIndex + 1;nextColIndex = !len ? cellInfo.colIndex : range.beginColIndex;return this.getCell(this.indexTable[nextRowIndex][nextColIndex].rowIndex, this.indexTable[nextRowIndex][nextColIndex].cellIndex);
        } catch (e) {
          showError(e);
        }
      }, getSameEndPosCells: function getSameEndPosCells(cell, xOrY) {
        try {
          var flag = xOrY.toLowerCase() === "x",
              end = domUtils.getXY(cell)[flag ? "x" : "y"] + cell["offset" + (flag ? "Width" : "Height")],
              rows = this.table.rows,
              cells = null,
              returns = [];for (var i = 0; i < this.rowsNum; i++) {
            cells = rows[i].cells;for (var j = 0, tmpCell; tmpCell = cells[j++];) {
              var tmpEnd = domUtils.getXY(tmpCell)[flag ? "x" : "y"] + tmpCell["offset" + (flag ? "Width" : "Height")];if (tmpEnd > end && flag) {
                break;
              }if (cell == tmpCell || end == tmpEnd) {
                if (tmpCell[flag ? "colSpan" : "rowSpan"] == 1) {
                  returns.push(tmpCell);
                }if (flag) {
                  break;
                }
              }
            }
          }return returns;
        } catch (e) {
          showError(e);
        }
      }, setCellContent: function setCellContent(cell, content) {
        cell.innerHTML = content || (browser.ie ? domUtils.fillChar : "<br />");
      }, cloneCell: UETable.cloneCell, getSameStartPosXCells: function getSameStartPosXCells(cell) {
        try {
          var start = domUtils.getXY(cell).x + cell.offsetWidth,
              rows = this.table.rows,
              cells,
              returns = [];for (var i = 0; i < this.rowsNum; i++) {
            cells = rows[i].cells;for (var j = 0, tmpCell; tmpCell = cells[j++];) {
              var tmpStart = domUtils.getXY(tmpCell).x;if (tmpStart > start) {
                break;
              }if (tmpStart == start && tmpCell.colSpan == 1) {
                returns.push(tmpCell);break;
              }
            }
          }return returns;
        } catch (e) {
          showError(e);
        }
      }, update: function update(table) {
        this.table = table || this.table;this.selectedTds = [];this.cellsRange = {};this.indexTable = [];var rows = this.table.rows,
            rowsNum = this.getMaxRows(),
            dNum = rowsNum - rows.length,
            colsNum = this.getMaxCols();while (dNum--) {
          this.table.insertRow(rows.length);
        }this.rowsNum = rowsNum;this.colsNum = colsNum;for (var i = 0, len = rows.length; i < len; i++) {
          this.indexTable[i] = new Array(colsNum);
        }for (var rowIndex = 0, row; row = rows[rowIndex]; rowIndex++) {
          for (var cellIndex = 0, cell, cells = row.cells; cell = cells[cellIndex]; cellIndex++) {
            if (cell.rowSpan > rowsNum) {
              cell.rowSpan = rowsNum;
            }var colIndex = cellIndex,
                rowSpan = cell.rowSpan || 1,
                colSpan = cell.colSpan || 1;while (this.indexTable[rowIndex][colIndex]) {
              colIndex++;
            }for (var j = 0; j < rowSpan; j++) {
              for (var k = 0; k < colSpan; k++) {
                this.indexTable[rowIndex + j][colIndex + k] = { rowIndex: rowIndex, cellIndex: cellIndex, colIndex: colIndex, rowSpan: rowSpan, colSpan: colSpan };
              }
            }
          }
        }for (j = 0; j < rowsNum; j++) {
          for (k = 0; k < colsNum; k++) {
            if (this.indexTable[j][k] === undefined) {
              row = rows[j];cell = row.cells[row.cells.length - 1];cell = cell ? cell.cloneNode(true) : this.table.ownerDocument.createElement("td");this.setCellContent(cell);if (cell.colSpan !== 1) {
                cell.colSpan = 1;
              }if (cell.rowSpan !== 1) {
                cell.rowSpan = 1;
              }row.appendChild(cell);this.indexTable[j][k] = { rowIndex: j, cellIndex: cell.cellIndex, colIndex: k, rowSpan: 1, colSpan: 1 };
            }
          }
        }var tds = domUtils.getElementsByTagName(this.table, "td"),
            selectTds = [];utils.each(tds, function (td) {
          if (domUtils.hasClass(td, "selectTdClass")) {
            selectTds.push(td);
          }
        });if (selectTds.length) {
          var start = selectTds[0],
              end = selectTds[selectTds.length - 1],
              startInfo = this.getCellInfo(start),
              endInfo = this.getCellInfo(end);this.selectedTds = selectTds;this.cellsRange = { beginRowIndex: startInfo.rowIndex, beginColIndex: startInfo.colIndex, endRowIndex: endInfo.rowIndex + endInfo.rowSpan - 1, endColIndex: endInfo.colIndex + endInfo.colSpan - 1 };
        }if (!domUtils.hasClass(this.table.rows[0], "firstRow")) {
          domUtils.addClass(this.table.rows[0], "firstRow");for (var i = 1; i < this.table.rows.length; i++) {
            domUtils.removeClasses(this.table.rows[i], "firstRow");
          }
        }
      }, getCellInfo: function getCellInfo(cell) {
        if (!cell) {
          return;
        }var cellIndex = cell.cellIndex,
            rowIndex = cell.parentNode.rowIndex,
            rowInfo = this.indexTable[rowIndex],
            numCols = this.colsNum;for (var colIndex = cellIndex; colIndex < numCols; colIndex++) {
          var cellInfo = rowInfo[colIndex];if (cellInfo.rowIndex === rowIndex && cellInfo.cellIndex === cellIndex) {
            return cellInfo;
          }
        }
      }, getCell: function getCell(rowIndex, cellIndex) {
        return rowIndex < this.rowsNum && this.table.rows[rowIndex].cells[cellIndex] || null;
      }, deleteCell: function deleteCell(cell, rowIndex) {
        rowIndex = typeof rowIndex == "number" ? rowIndex : cell.parentNode.rowIndex;var row = this.table.rows[rowIndex];row.deleteCell(cell.cellIndex);
      }, getCellsRange: function getCellsRange(cellA, cellB) {
        function checkRange(beginRowIndex, beginColIndex, endRowIndex, endColIndex) {
          var tmpBeginRowIndex = beginRowIndex,
              tmpBeginColIndex = beginColIndex,
              tmpEndRowIndex = endRowIndex,
              tmpEndColIndex = endColIndex,
              cellInfo,
              colIndex,
              rowIndex;if (beginRowIndex > 0) {
            for (colIndex = beginColIndex; colIndex < endColIndex; colIndex++) {
              cellInfo = me.indexTable[beginRowIndex][colIndex];rowIndex = cellInfo.rowIndex;if (rowIndex < beginRowIndex) {
                tmpBeginRowIndex = Math.min(rowIndex, tmpBeginRowIndex);
              }
            }
          }if (endColIndex < me.colsNum) {
            for (rowIndex = beginRowIndex; rowIndex < endRowIndex; rowIndex++) {
              cellInfo = me.indexTable[rowIndex][endColIndex];colIndex = cellInfo.colIndex + cellInfo.colSpan - 1;if (colIndex > endColIndex) {
                tmpEndColIndex = Math.max(colIndex, tmpEndColIndex);
              }
            }
          }if (endRowIndex < me.rowsNum) {
            for (colIndex = beginColIndex; colIndex < endColIndex; colIndex++) {
              cellInfo = me.indexTable[endRowIndex][colIndex];rowIndex = cellInfo.rowIndex + cellInfo.rowSpan - 1;if (rowIndex > endRowIndex) {
                tmpEndRowIndex = Math.max(rowIndex, tmpEndRowIndex);
              }
            }
          }if (beginColIndex > 0) {
            for (rowIndex = beginRowIndex; rowIndex < endRowIndex; rowIndex++) {
              cellInfo = me.indexTable[rowIndex][beginColIndex];colIndex = cellInfo.colIndex;if (colIndex < beginColIndex) {
                tmpBeginColIndex = Math.min(cellInfo.colIndex, tmpBeginColIndex);
              }
            }
          }if (tmpBeginRowIndex != beginRowIndex || tmpBeginColIndex != beginColIndex || tmpEndRowIndex != endRowIndex || tmpEndColIndex != endColIndex) {
            return checkRange(tmpBeginRowIndex, tmpBeginColIndex, tmpEndRowIndex, tmpEndColIndex);
          } else {
            return { beginRowIndex: beginRowIndex, beginColIndex: beginColIndex, endRowIndex: endRowIndex, endColIndex: endColIndex };
          }
        }try {
          var me = this,
              cellAInfo = me.getCellInfo(cellA);if (cellA === cellB) {
            return { beginRowIndex: cellAInfo.rowIndex, beginColIndex: cellAInfo.colIndex, endRowIndex: cellAInfo.rowIndex + cellAInfo.rowSpan - 1, endColIndex: cellAInfo.colIndex + cellAInfo.colSpan - 1 };
          }var cellBInfo = me.getCellInfo(cellB);var beginRowIndex = Math.min(cellAInfo.rowIndex, cellBInfo.rowIndex),
              beginColIndex = Math.min(cellAInfo.colIndex, cellBInfo.colIndex),
              endRowIndex = Math.max(cellAInfo.rowIndex + cellAInfo.rowSpan - 1, cellBInfo.rowIndex + cellBInfo.rowSpan - 1),
              endColIndex = Math.max(cellAInfo.colIndex + cellAInfo.colSpan - 1, cellBInfo.colIndex + cellBInfo.colSpan - 1);return checkRange(beginRowIndex, beginColIndex, endRowIndex, endColIndex);
        } catch (e) {}
      }, getCells: function getCells(range) {
        this.clearSelected();var beginRowIndex = range.beginRowIndex,
            beginColIndex = range.beginColIndex,
            endRowIndex = range.endRowIndex,
            endColIndex = range.endColIndex,
            cellInfo,
            rowIndex,
            colIndex,
            tdHash = {},
            returnTds = [];for (var i = beginRowIndex; i <= endRowIndex; i++) {
          for (var j = beginColIndex; j <= endColIndex; j++) {
            cellInfo = this.indexTable[i][j];rowIndex = cellInfo.rowIndex;colIndex = cellInfo.colIndex;var key = rowIndex + "|" + colIndex;if (tdHash[key]) {
              continue;
            }tdHash[key] = 1;if (rowIndex < i || colIndex < j || rowIndex + cellInfo.rowSpan - 1 > endRowIndex || colIndex + cellInfo.colSpan - 1 > endColIndex) {
              return null;
            }returnTds.push(this.getCell(rowIndex, cellInfo.cellIndex));
          }
        }return returnTds;
      }, clearSelected: function clearSelected() {
        UETable.removeSelectedClass(this.selectedTds);this.selectedTds = [];this.cellsRange = {};
      }, setSelected: function setSelected(range) {
        var cells = this.getCells(range);UETable.addSelectedClass(cells);this.selectedTds = cells;this.cellsRange = range;
      }, isFullRow: function isFullRow() {
        var range = this.cellsRange;return range.endColIndex - range.beginColIndex + 1 == this.colsNum;
      }, isFullCol: function isFullCol() {
        var range = this.cellsRange,
            table = this.table,
            ths = table.getElementsByTagName("th"),
            rows = range.endRowIndex - range.beginRowIndex + 1;return !ths.length ? rows == this.rowsNum : rows == this.rowsNum || rows == this.rowsNum - 1;
      }, getNextCell: function getNextCell(cell, bottom, ignoreRange) {
        try {
          var cellInfo = this.getCellInfo(cell),
              nextRowIndex,
              nextColIndex;var len = this.selectedTds.length && !ignoreRange,
              range = this.cellsRange;if (!bottom && cellInfo.rowIndex == 0 || bottom && (!len ? cellInfo.rowIndex + cellInfo.rowSpan > this.rowsNum - 1 : range.endRowIndex == this.rowsNum - 1)) {
            return null;
          }nextRowIndex = !bottom ? !len ? cellInfo.rowIndex - 1 : range.beginRowIndex - 1 : !len ? cellInfo.rowIndex + cellInfo.rowSpan : range.endRowIndex + 1;nextColIndex = !len ? cellInfo.colIndex : range.beginColIndex;return this.getCell(this.indexTable[nextRowIndex][nextColIndex].rowIndex, this.indexTable[nextRowIndex][nextColIndex].cellIndex);
        } catch (e) {
          showError(e);
        }
      }, getPreviewCell: function getPreviewCell(cell, top) {
        try {
          var cellInfo = this.getCellInfo(cell),
              previewRowIndex,
              previewColIndex;var len = this.selectedTds.length,
              range = this.cellsRange;if (!top && (!len ? !cellInfo.colIndex : !range.beginColIndex) || top && (!len ? cellInfo.rowIndex > this.colsNum - 1 : range.endColIndex == this.colsNum - 1)) {
            return null;
          }previewRowIndex = !top ? !len ? cellInfo.rowIndex : range.beginRowIndex : !len ? cellInfo.rowIndex < 1 ? 0 : cellInfo.rowIndex - 1 : range.beginRowIndex;previewColIndex = !top ? !len ? cellInfo.colIndex < 1 ? 0 : cellInfo.colIndex - 1 : range.beginColIndex - 1 : !len ? cellInfo.colIndex : range.endColIndex + 1;return this.getCell(this.indexTable[previewRowIndex][previewColIndex].rowIndex, this.indexTable[previewRowIndex][previewColIndex].cellIndex);
        } catch (e) {
          showError(e);
        }
      }, moveContent: function moveContent(cellTo, cellFrom) {
        if (UETable.isEmptyBlock(cellFrom)) {
          return;
        }if (UETable.isEmptyBlock(cellTo)) {
          cellTo.innerHTML = cellFrom.innerHTML;return;
        }var child = cellTo.lastChild;if (child.nodeType == 3 || !dtd.$block[child.tagName]) {
          cellTo.appendChild(cellTo.ownerDocument.createElement("br"));
        }while (child = cellFrom.firstChild) {
          cellTo.appendChild(child);
        }
      }, mergeRight: function mergeRight(cell) {
        var cellInfo = this.getCellInfo(cell),
            rightColIndex = cellInfo.colIndex + cellInfo.colSpan,
            rightCellInfo = this.indexTable[cellInfo.rowIndex][rightColIndex],
            rightCell = this.getCell(rightCellInfo.rowIndex, rightCellInfo.cellIndex);cell.colSpan = cellInfo.colSpan + rightCellInfo.colSpan;cell.removeAttribute("width");this.moveContent(cell, rightCell);this.deleteCell(rightCell, rightCellInfo.rowIndex);this.update();
      }, mergeDown: function mergeDown(cell) {
        var cellInfo = this.getCellInfo(cell),
            downRowIndex = cellInfo.rowIndex + cellInfo.rowSpan,
            downCellInfo = this.indexTable[downRowIndex][cellInfo.colIndex],
            downCell = this.getCell(downCellInfo.rowIndex, downCellInfo.cellIndex);cell.rowSpan = cellInfo.rowSpan + downCellInfo.rowSpan;cell.removeAttribute("height");this.moveContent(cell, downCell);this.deleteCell(downCell, downCellInfo.rowIndex);this.update();
      }, mergeRange: function mergeRange() {
        var range = this.cellsRange,
            leftTopCell = this.getCell(range.beginRowIndex, this.indexTable[range.beginRowIndex][range.beginColIndex].cellIndex);if (leftTopCell.tagName == "TH" && range.endRowIndex !== range.beginRowIndex) {
          var index = this.indexTable,
              info = this.getCellInfo(leftTopCell);leftTopCell = this.getCell(1, index[1][info.colIndex].cellIndex);range = this.getCellsRange(leftTopCell, this.getCell(index[this.rowsNum - 1][info.colIndex].rowIndex, index[this.rowsNum - 1][info.colIndex].cellIndex));
        }var cells = this.getCells(range);for (var i = 0, ci; ci = cells[i++];) {
          if (ci !== leftTopCell) {
            this.moveContent(leftTopCell, ci);this.deleteCell(ci);
          }
        }leftTopCell.rowSpan = range.endRowIndex - range.beginRowIndex + 1;leftTopCell.rowSpan > 1 && leftTopCell.removeAttribute("height");leftTopCell.colSpan = range.endColIndex - range.beginColIndex + 1;leftTopCell.colSpan > 1 && leftTopCell.removeAttribute("width");if (leftTopCell.rowSpan == this.rowsNum && leftTopCell.colSpan != 1) {
          leftTopCell.colSpan = 1;
        }if (leftTopCell.colSpan == this.colsNum && leftTopCell.rowSpan != 1) {
          var rowIndex = leftTopCell.parentNode.rowIndex;if (this.table.deleteRow) {
            for (var i = rowIndex + 1, curIndex = rowIndex + 1, len = leftTopCell.rowSpan; i < len; i++) {
              this.table.deleteRow(curIndex);
            }
          } else {
            for (var i = 0, len = leftTopCell.rowSpan - 1; i < len; i++) {
              var row = this.table.rows[rowIndex + 1];row.parentNode.removeChild(row);
            }
          }leftTopCell.rowSpan = 1;
        }this.update();
      }, insertRow: function insertRow(rowIndex, sourceCell) {
        var numCols = this.colsNum,
            table = this.table,
            row = table.insertRow(rowIndex),
            cell,
            isInsertTitle = typeof sourceCell == "string" && sourceCell.toUpperCase() == "TH";function replaceTdToTh(colIndex, cell, tableRow) {
          if (colIndex == 0) {
            var tr = tableRow.nextSibling || tableRow.previousSibling,
                th = tr.cells[colIndex];if (th.tagName == "TH") {
              th = cell.ownerDocument.createElement("th");th.appendChild(cell.firstChild);tableRow.insertBefore(th, cell);domUtils.remove(cell);
            }
          } else {
            if (cell.tagName == "TH") {
              var td = cell.ownerDocument.createElement("td");td.appendChild(cell.firstChild);tableRow.insertBefore(td, cell);domUtils.remove(cell);
            }
          }
        }if (rowIndex == 0 || rowIndex == this.rowsNum) {
          for (var colIndex = 0; colIndex < numCols; colIndex++) {
            cell = this.cloneCell(sourceCell, true);this.setCellContent(cell);cell.getAttribute("vAlign") && cell.setAttribute("vAlign", cell.getAttribute("vAlign"));row.appendChild(cell);if (!isInsertTitle) {
              replaceTdToTh(colIndex, cell, row);
            }
          }
        } else {
          var infoRow = this.indexTable[rowIndex],
              cellIndex = 0;for (colIndex = 0; colIndex < numCols; colIndex++) {
            var cellInfo = infoRow[colIndex];if (cellInfo.rowIndex < rowIndex) {
              cell = this.getCell(cellInfo.rowIndex, cellInfo.cellIndex);cell.rowSpan = cellInfo.rowSpan + 1;
            } else {
              cell = this.cloneCell(sourceCell, true);this.setCellContent(cell);row.appendChild(cell);
            }if (!isInsertTitle) {
              replaceTdToTh(colIndex, cell, row);
            }
          }
        }this.update();return row;
      }, deleteRow: function deleteRow(rowIndex) {
        var row = this.table.rows[rowIndex],
            infoRow = this.indexTable[rowIndex],
            colsNum = this.colsNum,
            count = 0;for (var colIndex = 0; colIndex < colsNum;) {
          var cellInfo = infoRow[colIndex],
              cell = this.getCell(cellInfo.rowIndex, cellInfo.cellIndex);if (cell.rowSpan > 1) {
            if (cellInfo.rowIndex == rowIndex) {
              var clone = cell.cloneNode(true);clone.rowSpan = cell.rowSpan - 1;clone.innerHTML = "";cell.rowSpan = 1;var nextRowIndex = rowIndex + 1,
                  nextRow = this.table.rows[nextRowIndex],
                  insertCellIndex,
                  preMerged = this.getPreviewMergedCellsNum(nextRowIndex, colIndex) - count;if (preMerged < colIndex) {
                insertCellIndex = colIndex - preMerged - 1;domUtils.insertAfter(nextRow.cells[insertCellIndex], clone);
              } else {
                if (nextRow.cells.length) {
                  nextRow.insertBefore(clone, nextRow.cells[0]);
                }
              }count += 1;
            }
          }colIndex += cell.colSpan || 1;
        }var deleteTds = [],
            cacheMap = {};for (colIndex = 0; colIndex < colsNum; colIndex++) {
          var tmpRowIndex = infoRow[colIndex].rowIndex,
              tmpCellIndex = infoRow[colIndex].cellIndex,
              key = tmpRowIndex + "_" + tmpCellIndex;if (cacheMap[key]) {
            continue;
          }cacheMap[key] = 1;cell = this.getCell(tmpRowIndex, tmpCellIndex);deleteTds.push(cell);
        }var mergeTds = [];utils.each(deleteTds, function (td) {
          if (td.rowSpan == 1) {
            td.parentNode.removeChild(td);
          } else {
            mergeTds.push(td);
          }
        });utils.each(mergeTds, function (td) {
          td.rowSpan--;
        });row.parentNode.removeChild(row);this.update();
      }, insertCol: function insertCol(colIndex, sourceCell, defaultValue) {
        var rowsNum = this.rowsNum,
            rowIndex = 0,
            tableRow,
            cell,
            backWidth = parseInt((this.table.offsetWidth - (this.colsNum + 1) * 20 - (this.colsNum + 1)) / (this.colsNum + 1), 10),
            isInsertTitleCol = typeof sourceCell == "string" && sourceCell.toUpperCase() == "TH";function replaceTdToTh(rowIndex, cell, tableRow) {
          if (rowIndex == 0) {
            var th = cell.nextSibling || cell.previousSibling;if (th.tagName == "TH") {
              th = cell.ownerDocument.createElement("th");th.appendChild(cell.firstChild);tableRow.insertBefore(th, cell);domUtils.remove(cell);
            }
          } else {
            if (cell.tagName == "TH") {
              var td = cell.ownerDocument.createElement("td");td.appendChild(cell.firstChild);tableRow.insertBefore(td, cell);domUtils.remove(cell);
            }
          }
        }var preCell;if (colIndex == 0 || colIndex == this.colsNum) {
          for (; rowIndex < rowsNum; rowIndex++) {
            tableRow = this.table.rows[rowIndex];preCell = tableRow.cells[colIndex == 0 ? colIndex : tableRow.cells.length];cell = this.cloneCell(sourceCell, true);this.setCellContent(cell);cell.setAttribute("vAlign", cell.getAttribute("vAlign"));preCell && cell.setAttribute("width", preCell.getAttribute("width"));if (!colIndex) {
              tableRow.insertBefore(cell, tableRow.cells[0]);
            } else {
              domUtils.insertAfter(tableRow.cells[tableRow.cells.length - 1], cell);
            }if (!isInsertTitleCol) {
              replaceTdToTh(rowIndex, cell, tableRow);
            }
          }
        } else {
          for (; rowIndex < rowsNum; rowIndex++) {
            var cellInfo = this.indexTable[rowIndex][colIndex];if (cellInfo.colIndex < colIndex) {
              cell = this.getCell(cellInfo.rowIndex, cellInfo.cellIndex);cell.colSpan = cellInfo.colSpan + 1;
            } else {
              tableRow = this.table.rows[rowIndex];preCell = tableRow.cells[cellInfo.cellIndex];cell = this.cloneCell(sourceCell, true);this.setCellContent(cell);cell.setAttribute("vAlign", cell.getAttribute("vAlign"));preCell && cell.setAttribute("width", preCell.getAttribute("width"));preCell ? tableRow.insertBefore(cell, preCell) : tableRow.appendChild(cell);
            }if (!isInsertTitleCol) {
              replaceTdToTh(rowIndex, cell, tableRow);
            }
          }
        }this.update();this.updateWidth(backWidth, defaultValue || { tdPadding: 10, tdBorder: 1 });
      }, updateWidth: function updateWidth(width, defaultValue) {
        var table = this.table,
            tmpWidth = UETable.getWidth(table) - defaultValue.tdPadding * 2 - defaultValue.tdBorder + width;if (tmpWidth < table.ownerDocument.body.offsetWidth) {
          table.setAttribute("width", tmpWidth);return;
        }var tds = domUtils.getElementsByTagName(this.table, "td th");utils.each(tds, function (td) {
          td.setAttribute("width", width);
        });
      }, deleteCol: function deleteCol(colIndex) {
        var indexTable = this.indexTable,
            tableRows = this.table.rows,
            backTableWidth = this.table.getAttribute("width"),
            backTdWidth = 0,
            rowsNum = this.rowsNum,
            cacheMap = {};for (var rowIndex = 0; rowIndex < rowsNum;) {
          var infoRow = indexTable[rowIndex],
              cellInfo = infoRow[colIndex],
              key = cellInfo.rowIndex + "_" + cellInfo.colIndex;if (cacheMap[key]) {
            continue;
          }cacheMap[key] = 1;var cell = this.getCell(cellInfo.rowIndex, cellInfo.cellIndex);if (!backTdWidth) {
            backTdWidth = cell && parseInt(cell.offsetWidth / cell.colSpan, 10).toFixed(0);
          }if (cell.colSpan > 1) {
            cell.colSpan--;
          } else {
            tableRows[rowIndex].deleteCell(cellInfo.cellIndex);
          }rowIndex += cellInfo.rowSpan || 1;
        }this.table.setAttribute("width", backTableWidth - backTdWidth);this.update();
      }, splitToCells: function splitToCells(cell) {
        var me = this,
            cells = this.splitToRows(cell);utils.each(cells, function (cell) {
          me.splitToCols(cell);
        });
      }, splitToRows: function splitToRows(cell) {
        var cellInfo = this.getCellInfo(cell),
            rowIndex = cellInfo.rowIndex,
            colIndex = cellInfo.colIndex,
            results = [];cell.rowSpan = 1;results.push(cell);for (var i = rowIndex, endRow = rowIndex + cellInfo.rowSpan; i < endRow; i++) {
          if (i == rowIndex) {
            continue;
          }var tableRow = this.table.rows[i],
              tmpCell = tableRow.insertCell(colIndex - this.getPreviewMergedCellsNum(i, colIndex));tmpCell.colSpan = cellInfo.colSpan;this.setCellContent(tmpCell);tmpCell.setAttribute("vAlign", cell.getAttribute("vAlign"));tmpCell.setAttribute("align", cell.getAttribute("align"));if (cell.style.cssText) {
            tmpCell.style.cssText = cell.style.cssText;
          }results.push(tmpCell);
        }this.update();return results;
      }, getPreviewMergedCellsNum: function getPreviewMergedCellsNum(rowIndex, colIndex) {
        var indexRow = this.indexTable[rowIndex],
            num = 0;for (var i = 0; i < colIndex;) {
          var colSpan = indexRow[i].colSpan,
              tmpRowIndex = indexRow[i].rowIndex;num += colSpan - (tmpRowIndex == rowIndex ? 1 : 0);i += colSpan;
        }return num;
      }, splitToCols: function splitToCols(cell) {
        var backWidth = (cell.offsetWidth / cell.colSpan - 22).toFixed(0),
            cellInfo = this.getCellInfo(cell),
            rowIndex = cellInfo.rowIndex,
            colIndex = cellInfo.colIndex,
            results = [];cell.colSpan = 1;cell.setAttribute("width", backWidth);results.push(cell);for (var j = colIndex, endCol = colIndex + cellInfo.colSpan; j < endCol; j++) {
          if (j == colIndex) {
            continue;
          }var tableRow = this.table.rows[rowIndex],
              tmpCell = tableRow.insertCell(this.indexTable[rowIndex][j].cellIndex + 1);tmpCell.rowSpan = cellInfo.rowSpan;this.setCellContent(tmpCell);tmpCell.setAttribute("vAlign", cell.getAttribute("vAlign"));tmpCell.setAttribute("align", cell.getAttribute("align"));tmpCell.setAttribute("width", backWidth);if (cell.style.cssText) {
            tmpCell.style.cssText = cell.style.cssText;
          }if (cell.tagName == "TH") {
            var th = cell.ownerDocument.createElement("th");th.appendChild(tmpCell.firstChild);th.setAttribute("vAlign", cell.getAttribute("vAlign"));th.rowSpan = tmpCell.rowSpan;tableRow.insertBefore(th, tmpCell);domUtils.remove(tmpCell);
          }results.push(tmpCell);
        }this.update();return results;
      }, isLastCell: function isLastCell(cell, rowsNum, colsNum) {
        rowsNum = rowsNum || this.rowsNum;colsNum = colsNum || this.colsNum;var cellInfo = this.getCellInfo(cell);return cellInfo.rowIndex + cellInfo.rowSpan == rowsNum && cellInfo.colIndex + cellInfo.colSpan == colsNum;
      }, getLastCell: function getLastCell(cells) {
        cells = cells || this.table.getElementsByTagName("td");var firstInfo = this.getCellInfo(cells[0]);var me = this,
            last = cells[0],
            tr = last.parentNode,
            cellsNum = 0,
            cols = 0,
            rows;utils.each(cells, function (cell) {
          if (cell.parentNode == tr) {
            cols += cell.colSpan || 1;
          }cellsNum += cell.rowSpan * cell.colSpan || 1;
        });rows = cellsNum / cols;utils.each(cells, function (cell) {
          if (me.isLastCell(cell, rows, cols)) {
            last = cell;return false;
          }
        });return last;
      }, selectRow: function selectRow(rowIndex) {
        var indexRow = this.indexTable[rowIndex],
            start = this.getCell(indexRow[0].rowIndex, indexRow[0].cellIndex),
            end = this.getCell(indexRow[this.colsNum - 1].rowIndex, indexRow[this.colsNum - 1].cellIndex),
            range = this.getCellsRange(start, end);this.setSelected(range);
      }, selectTable: function selectTable() {
        var tds = this.table.getElementsByTagName("td"),
            range = this.getCellsRange(tds[0], tds[tds.length - 1]);this.setSelected(range);
      }, setBackground: function setBackground(cells, value) {
        if (typeof value === "string") {
          utils.each(cells, function (cell) {
            cell.style.backgroundColor = value;
          });
        } else {
          if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
            value = utils.extend({ repeat: true, colorList: ["#ddd", "#fff"] }, value);var rowIndex = this.getCellInfo(cells[0]).rowIndex,
                count = 0,
                colors = value.colorList,
                getColor = function getColor(list, index, repeat) {
              return list[index] ? list[index] : repeat ? list[index % list.length] : "";
            };for (var i = 0, cell; cell = cells[i++];) {
              var cellInfo = this.getCellInfo(cell);cell.style.backgroundColor = getColor(colors, rowIndex + count == cellInfo.rowIndex ? count : ++count, value.repeat);
            }
          }
        }
      }, removeBackground: function removeBackground(cells) {
        utils.each(cells, function (cell) {
          cell.style.backgroundColor = "";
        });
      } };function showError(e) {}
  })();(function () {
    var UT = UE.UETable,
        getTableItemsByRange = function getTableItemsByRange(editor) {
      return UT.getTableItemsByRange(editor);
    },
        getUETableBySelected = function getUETableBySelected(editor) {
      return UT.getUETableBySelected(editor);
    },
        getDefaultValue = function getDefaultValue(editor, table) {
      return UT.getDefaultValue(editor, table);
    },
        getUETable = function getUETable(tdOrTable) {
      return UT.getUETable(tdOrTable);
    };UE.commands["inserttable"] = { queryCommandState: function queryCommandState() {
        return getTableItemsByRange(this).table ? -1 : 0;
      }, execCommand: function execCommand(cmd, opt) {
        function createTable(opt, tdWidth) {
          var html = [],
              rowsNum = opt.numRows,
              colsNum = opt.numCols;for (var r = 0; r < rowsNum; r++) {
            html.push("<tr" + (r == 0 ? ' class="firstRow"' : "") + ">");for (var c = 0; c < colsNum; c++) {
              html.push('<td width="' + tdWidth + '"  vAlign="' + opt.tdvalign + '" >' + (browser.ie && browser.version < 11 ? domUtils.fillChar : "<br/>") + "</td>");
            }html.push("</tr>");
          }return "<table><tbody>" + html.join("") + "</tbody></table>";
        }if (!opt) {
          opt = utils.extend({}, { numCols: this.options.defaultCols, numRows: this.options.defaultRows, tdvalign: this.options.tdvalign });
        }var me = this;var range = this.selection.getRange(),
            start = range.startContainer,
            firstParentBlock = domUtils.findParent(start, function (node) {
          return domUtils.isBlockElm(node);
        }, true) || me.body;var defaultValue = getDefaultValue(me),
            tableWidth = firstParentBlock.offsetWidth,
            tdWidth = Math.floor(tableWidth / opt.numCols - defaultValue.tdPadding * 2 - defaultValue.tdBorder);!opt.tdvalign && (opt.tdvalign = me.options.tdvalign);me.execCommand("inserthtml", createTable(opt, tdWidth));
      } };UE.commands["insertparagraphbeforetable"] = { queryCommandState: function queryCommandState() {
        return getTableItemsByRange(this).cell ? 0 : -1;
      }, execCommand: function execCommand() {
        var table = getTableItemsByRange(this).table;if (table) {
          var p = this.document.createElement("p");p.innerHTML = browser.ie ? "&nbsp;" : "<br />";table.parentNode.insertBefore(p, table);this.selection.getRange().setStart(p, 0).setCursor();
        }
      } };UE.commands["deletetable"] = { queryCommandState: function queryCommandState() {
        var rng = this.selection.getRange();return domUtils.findParentByTagName(rng.startContainer, "table", true) ? 0 : -1;
      }, execCommand: function execCommand(cmd, table) {
        var rng = this.selection.getRange();table = table || domUtils.findParentByTagName(rng.startContainer, "table", true);if (table) {
          var next = table.nextSibling;if (!next) {
            next = domUtils.createElement(this.document, "p", { "innerHTML": browser.ie ? domUtils.fillChar : "<br/>" });table.parentNode.insertBefore(next, table);
          }domUtils.remove(table);rng = this.selection.getRange();if (next.nodeType == 3) {
            rng.setStartBefore(next);
          } else {
            rng.setStart(next, 0);
          }rng.setCursor(false, true);this.fireEvent("tablehasdeleted");
        }
      } };UE.commands["cellalign"] = { queryCommandState: function queryCommandState() {
        return getSelectedArr(this).length ? 0 : -1;
      }, execCommand: function execCommand(cmd, align) {
        var selectedTds = getSelectedArr(this);if (selectedTds.length) {
          for (var i = 0, ci; ci = selectedTds[i++];) {
            ci.setAttribute("align", align);
          }
        }
      } };UE.commands["cellvalign"] = { queryCommandState: function queryCommandState() {
        return getSelectedArr(this).length ? 0 : -1;
      }, execCommand: function execCommand(cmd, valign) {
        var selectedTds = getSelectedArr(this);if (selectedTds.length) {
          for (var i = 0, ci; ci = selectedTds[i++];) {
            ci.setAttribute("vAlign", valign);
          }
        }
      } };UE.commands["insertcaption"] = { queryCommandState: function queryCommandState() {
        var table = getTableItemsByRange(this).table;if (table) {
          return table.getElementsByTagName("caption").length == 0 ? 1 : -1;
        }return -1;
      }, execCommand: function execCommand() {
        var table = getTableItemsByRange(this).table;if (table) {
          var caption = this.document.createElement("caption");caption.innerHTML = browser.ie ? domUtils.fillChar : "<br/>";table.insertBefore(caption, table.firstChild);var range = this.selection.getRange();range.setStart(caption, 0).setCursor();
        }
      } };UE.commands["deletecaption"] = { queryCommandState: function queryCommandState() {
        var rng = this.selection.getRange(),
            table = domUtils.findParentByTagName(rng.startContainer, "table");if (table) {
          return table.getElementsByTagName("caption").length == 0 ? -1 : 1;
        }return -1;
      }, execCommand: function execCommand() {
        var rng = this.selection.getRange(),
            table = domUtils.findParentByTagName(rng.startContainer, "table");if (table) {
          domUtils.remove(table.getElementsByTagName("caption")[0]);var range = this.selection.getRange();range.setStart(table.rows[0].cells[0], 0).setCursor();
        }
      } };UE.commands["inserttitle"] = { queryCommandState: function queryCommandState() {
        var table = getTableItemsByRange(this).table;if (table) {
          var firstRow = table.rows[0];return firstRow.cells[firstRow.cells.length - 1].tagName.toLowerCase() != "th" ? 0 : -1;
        }return -1;
      }, execCommand: function execCommand() {
        var table = getTableItemsByRange(this).table;if (table) {
          getUETable(table).insertRow(0, "th");
        }var th = table.getElementsByTagName("th")[0];this.selection.getRange().setStart(th, 0).setCursor(false, true);
      } };UE.commands["deletetitle"] = { queryCommandState: function queryCommandState() {
        var table = getTableItemsByRange(this).table;if (table) {
          var firstRow = table.rows[0];return firstRow.cells[firstRow.cells.length - 1].tagName.toLowerCase() == "th" ? 0 : -1;
        }return -1;
      }, execCommand: function execCommand() {
        var table = getTableItemsByRange(this).table;if (table) {
          domUtils.remove(table.rows[0]);
        }var td = table.getElementsByTagName("td")[0];this.selection.getRange().setStart(td, 0).setCursor(false, true);
      } };UE.commands["inserttitlecol"] = { queryCommandState: function queryCommandState() {
        var table = getTableItemsByRange(this).table;if (table) {
          var lastRow = table.rows[table.rows.length - 1];return lastRow.getElementsByTagName("th").length ? -1 : 0;
        }return -1;
      }, execCommand: function execCommand(cmd) {
        var table = getTableItemsByRange(this).table;if (table) {
          getUETable(table).insertCol(0, "th");
        }resetTdWidth(table, this);var th = table.getElementsByTagName("th")[0];this.selection.getRange().setStart(th, 0).setCursor(false, true);
      } };UE.commands["deletetitlecol"] = { queryCommandState: function queryCommandState() {
        var table = getTableItemsByRange(this).table;if (table) {
          var lastRow = table.rows[table.rows.length - 1];return lastRow.getElementsByTagName("th").length ? 0 : -1;
        }return -1;
      }, execCommand: function execCommand() {
        var table = getTableItemsByRange(this).table;if (table) {
          for (var i = 0; i < table.rows.length; i++) {
            domUtils.remove(table.rows[i].children[0]);
          }
        }resetTdWidth(table, this);var td = table.getElementsByTagName("td")[0];this.selection.getRange().setStart(td, 0).setCursor(false, true);
      } };UE.commands["mergeright"] = { queryCommandState: function queryCommandState(cmd) {
        var tableItems = getTableItemsByRange(this),
            table = tableItems.table,
            cell = tableItems.cell;if (!table || !cell) {
          return -1;
        }var ut = getUETable(table);if (ut.selectedTds.length) {
          return -1;
        }var cellInfo = ut.getCellInfo(cell),
            rightColIndex = cellInfo.colIndex + cellInfo.colSpan;if (rightColIndex >= ut.colsNum) {
          return -1;
        }var rightCellInfo = ut.indexTable[cellInfo.rowIndex][rightColIndex],
            rightCell = table.rows[rightCellInfo.rowIndex].cells[rightCellInfo.cellIndex];if (!rightCell || cell.tagName != rightCell.tagName) {
          return -1;
        }return rightCellInfo.rowIndex == cellInfo.rowIndex && rightCellInfo.rowSpan == cellInfo.rowSpan ? 0 : -1;
      }, execCommand: function execCommand(cmd) {
        var rng = this.selection.getRange(),
            bk = rng.createBookmark(true);var cell = getTableItemsByRange(this).cell,
            ut = getUETable(cell);ut.mergeRight(cell);rng.moveToBookmark(bk).select();
      } };UE.commands["mergedown"] = { queryCommandState: function queryCommandState(cmd) {
        var tableItems = getTableItemsByRange(this),
            table = tableItems.table,
            cell = tableItems.cell;if (!table || !cell) {
          return -1;
        }var ut = getUETable(table);if (ut.selectedTds.length) {
          return -1;
        }var cellInfo = ut.getCellInfo(cell),
            downRowIndex = cellInfo.rowIndex + cellInfo.rowSpan;if (downRowIndex >= ut.rowsNum) {
          return -1;
        }var downCellInfo = ut.indexTable[downRowIndex][cellInfo.colIndex],
            downCell = table.rows[downCellInfo.rowIndex].cells[downCellInfo.cellIndex];if (!downCell || cell.tagName != downCell.tagName) {
          return -1;
        }return downCellInfo.colIndex == cellInfo.colIndex && downCellInfo.colSpan == cellInfo.colSpan ? 0 : -1;
      }, execCommand: function execCommand() {
        var rng = this.selection.getRange(),
            bk = rng.createBookmark(true);var cell = getTableItemsByRange(this).cell,
            ut = getUETable(cell);ut.mergeDown(cell);rng.moveToBookmark(bk).select();
      } };UE.commands["mergecells"] = { queryCommandState: function queryCommandState() {
        return getUETableBySelected(this) ? 0 : -1;
      }, execCommand: function execCommand() {
        var ut = getUETableBySelected(this);if (ut && ut.selectedTds.length) {
          var cell = ut.selectedTds[0];ut.mergeRange();var rng = this.selection.getRange();if (domUtils.isEmptyBlock(cell)) {
            rng.setStart(cell, 0).collapse(true);
          } else {
            rng.selectNodeContents(cell);
          }rng.select();
        }
      } };UE.commands["insertrow"] = { queryCommandState: function queryCommandState() {
        var tableItems = getTableItemsByRange(this),
            cell = tableItems.cell;return cell && (cell.tagName == "TD" || cell.tagName == "TH" && tableItems.tr !== tableItems.table.rows[0]) && getUETable(tableItems.table).rowsNum < this.options.maxRowNum ? 0 : -1;
      }, execCommand: function execCommand() {
        var rng = this.selection.getRange(),
            bk = rng.createBookmark(true);var tableItems = getTableItemsByRange(this),
            cell = tableItems.cell,
            table = tableItems.table,
            ut = getUETable(table),
            cellInfo = ut.getCellInfo(cell);if (!ut.selectedTds.length) {
          ut.insertRow(cellInfo.rowIndex, cell);
        } else {
          var range = ut.cellsRange;for (var i = 0, len = range.endRowIndex - range.beginRowIndex + 1; i < len; i++) {
            ut.insertRow(range.beginRowIndex, cell);
          }
        }rng.moveToBookmark(bk).select();if (table.getAttribute("interlaced") === "enabled") {
          this.fireEvent("interlacetable", table);
        }
      } };UE.commands["insertrownext"] = { queryCommandState: function queryCommandState() {
        var tableItems = getTableItemsByRange(this),
            cell = tableItems.cell;return cell && cell.tagName == "TD" && getUETable(tableItems.table).rowsNum < this.options.maxRowNum ? 0 : -1;
      }, execCommand: function execCommand() {
        var rng = this.selection.getRange(),
            bk = rng.createBookmark(true);var tableItems = getTableItemsByRange(this),
            cell = tableItems.cell,
            table = tableItems.table,
            ut = getUETable(table),
            cellInfo = ut.getCellInfo(cell);if (!ut.selectedTds.length) {
          ut.insertRow(cellInfo.rowIndex + cellInfo.rowSpan, cell);
        } else {
          var range = ut.cellsRange;for (var i = 0, len = range.endRowIndex - range.beginRowIndex + 1; i < len; i++) {
            ut.insertRow(range.endRowIndex + 1, cell);
          }
        }rng.moveToBookmark(bk).select();if (table.getAttribute("interlaced") === "enabled") {
          this.fireEvent("interlacetable", table);
        }
      } };UE.commands["deleterow"] = { queryCommandState: function queryCommandState() {
        var tableItems = getTableItemsByRange(this);return tableItems.cell ? 0 : -1;
      }, execCommand: function execCommand() {
        var cell = getTableItemsByRange(this).cell,
            ut = getUETable(cell),
            cellsRange = ut.cellsRange,
            cellInfo = ut.getCellInfo(cell),
            preCell = ut.getVSideCell(cell),
            nextCell = ut.getVSideCell(cell, true),
            rng = this.selection.getRange();if (utils.isEmptyObject(cellsRange)) {
          ut.deleteRow(cellInfo.rowIndex);
        } else {
          for (var i = cellsRange.beginRowIndex; i < cellsRange.endRowIndex + 1; i++) {
            ut.deleteRow(cellsRange.beginRowIndex);
          }
        }var table = ut.table;if (!table.getElementsByTagName("td").length) {
          var nextSibling = table.nextSibling;domUtils.remove(table);if (nextSibling) {
            rng.setStart(nextSibling, 0).setCursor(false, true);
          }
        } else {
          if (cellInfo.rowSpan == 1 || cellInfo.rowSpan == cellsRange.endRowIndex - cellsRange.beginRowIndex + 1) {
            if (nextCell || preCell) {
              rng.selectNodeContents(nextCell || preCell).setCursor(false, true);
            }
          } else {
            var newCell = ut.getCell(cellInfo.rowIndex, ut.indexTable[cellInfo.rowIndex][cellInfo.colIndex].cellIndex);if (newCell) {
              rng.selectNodeContents(newCell).setCursor(false, true);
            }
          }
        }if (table.getAttribute("interlaced") === "enabled") {
          this.fireEvent("interlacetable", table);
        }
      } };UE.commands["insertcol"] = { queryCommandState: function queryCommandState(cmd) {
        var tableItems = getTableItemsByRange(this),
            cell = tableItems.cell;return cell && (cell.tagName == "TD" || cell.tagName == "TH" && cell !== tableItems.tr.cells[0]) && getUETable(tableItems.table).colsNum < this.options.maxColNum ? 0 : -1;
      }, execCommand: function execCommand(cmd) {
        var rng = this.selection.getRange(),
            bk = rng.createBookmark(true);if (this.queryCommandState(cmd) == -1) {
          return;
        }var cell = getTableItemsByRange(this).cell,
            ut = getUETable(cell),
            cellInfo = ut.getCellInfo(cell);if (!ut.selectedTds.length) {
          ut.insertCol(cellInfo.colIndex, cell);
        } else {
          var range = ut.cellsRange;for (var i = 0, len = range.endColIndex - range.beginColIndex + 1; i < len; i++) {
            ut.insertCol(range.beginColIndex, cell);
          }
        }rng.moveToBookmark(bk).select(true);
      } };UE.commands["insertcolnext"] = { queryCommandState: function queryCommandState() {
        var tableItems = getTableItemsByRange(this),
            cell = tableItems.cell;return cell && getUETable(tableItems.table).colsNum < this.options.maxColNum ? 0 : -1;
      }, execCommand: function execCommand() {
        var rng = this.selection.getRange(),
            bk = rng.createBookmark(true);var cell = getTableItemsByRange(this).cell,
            ut = getUETable(cell),
            cellInfo = ut.getCellInfo(cell);if (!ut.selectedTds.length) {
          ut.insertCol(cellInfo.colIndex + cellInfo.colSpan, cell);
        } else {
          var range = ut.cellsRange;for (var i = 0, len = range.endColIndex - range.beginColIndex + 1; i < len; i++) {
            ut.insertCol(range.endColIndex + 1, cell);
          }
        }rng.moveToBookmark(bk).select();
      } };UE.commands["deletecol"] = { queryCommandState: function queryCommandState() {
        var tableItems = getTableItemsByRange(this);return tableItems.cell ? 0 : -1;
      }, execCommand: function execCommand() {
        var cell = getTableItemsByRange(this).cell,
            ut = getUETable(cell),
            range = ut.cellsRange,
            cellInfo = ut.getCellInfo(cell),
            preCell = ut.getHSideCell(cell),
            nextCell = ut.getHSideCell(cell, true);if (utils.isEmptyObject(range)) {
          ut.deleteCol(cellInfo.colIndex);
        } else {
          for (var i = range.beginColIndex; i < range.endColIndex + 1; i++) {
            ut.deleteCol(range.beginColIndex);
          }
        }var table = ut.table,
            rng = this.selection.getRange();if (!table.getElementsByTagName("td").length) {
          var nextSibling = table.nextSibling;domUtils.remove(table);if (nextSibling) {
            rng.setStart(nextSibling, 0).setCursor(false, true);
          }
        } else {
          if (domUtils.inDoc(cell, this.document)) {
            rng.setStart(cell, 0).setCursor(false, true);
          } else {
            if (nextCell && domUtils.inDoc(nextCell, this.document)) {
              rng.selectNodeContents(nextCell).setCursor(false, true);
            } else {
              if (preCell && domUtils.inDoc(preCell, this.document)) {
                rng.selectNodeContents(preCell).setCursor(true, true);
              }
            }
          }
        }
      } };UE.commands["splittocells"] = { queryCommandState: function queryCommandState() {
        var tableItems = getTableItemsByRange(this),
            cell = tableItems.cell;if (!cell) {
          return -1;
        }var ut = getUETable(tableItems.table);if (ut.selectedTds.length > 0) {
          return -1;
        }return cell && (cell.colSpan > 1 || cell.rowSpan > 1) ? 0 : -1;
      }, execCommand: function execCommand() {
        var rng = this.selection.getRange(),
            bk = rng.createBookmark(true);var cell = getTableItemsByRange(this).cell,
            ut = getUETable(cell);ut.splitToCells(cell);rng.moveToBookmark(bk).select();
      } };UE.commands["splittorows"] = { queryCommandState: function queryCommandState() {
        var tableItems = getTableItemsByRange(this),
            cell = tableItems.cell;if (!cell) {
          return -1;
        }var ut = getUETable(tableItems.table);if (ut.selectedTds.length > 0) {
          return -1;
        }return cell && cell.rowSpan > 1 ? 0 : -1;
      }, execCommand: function execCommand() {
        var rng = this.selection.getRange(),
            bk = rng.createBookmark(true);var cell = getTableItemsByRange(this).cell,
            ut = getUETable(cell);ut.splitToRows(cell);rng.moveToBookmark(bk).select();
      } };UE.commands["splittocols"] = { queryCommandState: function queryCommandState() {
        var tableItems = getTableItemsByRange(this),
            cell = tableItems.cell;if (!cell) {
          return -1;
        }var ut = getUETable(tableItems.table);if (ut.selectedTds.length > 0) {
          return -1;
        }return cell && cell.colSpan > 1 ? 0 : -1;
      }, execCommand: function execCommand() {
        var rng = this.selection.getRange(),
            bk = rng.createBookmark(true);var cell = getTableItemsByRange(this).cell,
            ut = getUETable(cell);ut.splitToCols(cell);rng.moveToBookmark(bk).select();
      } };UE.commands["adaptbytext"] = UE.commands["adaptbywindow"] = { queryCommandState: function queryCommandState() {
        return getTableItemsByRange(this).table ? 0 : -1;
      }, execCommand: function execCommand(cmd) {
        var tableItems = getTableItemsByRange(this),
            table = tableItems.table;if (table) {
          if (cmd == "adaptbywindow") {
            resetTdWidth(table, this);
          } else {
            var cells = domUtils.getElementsByTagName(table, "td th");utils.each(cells, function (cell) {
              cell.removeAttribute("width");
            });table.removeAttribute("width");
          }
        }
      } };UE.commands["averagedistributecol"] = { queryCommandState: function queryCommandState() {
        var ut = getUETableBySelected(this);if (!ut) {
          return -1;
        }return ut.isFullRow() || ut.isFullCol() ? 0 : -1;
      }, execCommand: function execCommand(cmd) {
        var me = this,
            ut = getUETableBySelected(me);function getAverageWidth() {
          var tb = ut.table,
              averageWidth,
              sumWidth = 0,
              colsNum = 0,
              tbAttr = getDefaultValue(me, tb);if (ut.isFullRow()) {
            sumWidth = tb.offsetWidth;colsNum = ut.colsNum;
          } else {
            var begin = ut.cellsRange.beginColIndex,
                end = ut.cellsRange.endColIndex,
                node;for (var i = begin; i <= end;) {
              node = ut.selectedTds[i];sumWidth += node.offsetWidth;i += node.colSpan;colsNum += 1;
            }
          }averageWidth = Math.ceil(sumWidth / colsNum) - tbAttr.tdBorder * 2 - tbAttr.tdPadding * 2;return averageWidth;
        }function setAverageWidth(averageWidth) {
          utils.each(domUtils.getElementsByTagName(ut.table, "th"), function (node) {
            node.setAttribute("width", "");
          });var cells = ut.isFullRow() ? domUtils.getElementsByTagName(ut.table, "td") : ut.selectedTds;utils.each(cells, function (node) {
            if (node.colSpan == 1) {
              node.setAttribute("width", averageWidth);
            }
          });
        }if (ut && ut.selectedTds.length) {
          setAverageWidth(getAverageWidth());
        }
      } };UE.commands["averagedistributerow"] = { queryCommandState: function queryCommandState() {
        var ut = getUETableBySelected(this);if (!ut) {
          return -1;
        }if (ut.selectedTds && /th/ig.test(ut.selectedTds[0].tagName)) {
          return -1;
        }return ut.isFullRow() || ut.isFullCol() ? 0 : -1;
      }, execCommand: function execCommand(cmd) {
        var me = this,
            ut = getUETableBySelected(me);function getAverageHeight() {
          var averageHeight,
              rowNum,
              sumHeight = 0,
              tb = ut.table,
              tbAttr = getDefaultValue(me, tb),
              tdpadding = parseInt(domUtils.getComputedStyle(tb.getElementsByTagName("td")[0], "padding-top"));if (ut.isFullCol()) {
            var captionArr = domUtils.getElementsByTagName(tb, "caption"),
                thArr = domUtils.getElementsByTagName(tb, "th"),
                captionHeight,
                thHeight;if (captionArr.length > 0) {
              captionHeight = captionArr[0].offsetHeight;
            }if (thArr.length > 0) {
              thHeight = thArr[0].offsetHeight;
            }sumHeight = tb.offsetHeight - (captionHeight || 0) - (thHeight || 0);rowNum = thArr.length == 0 ? ut.rowsNum : ut.rowsNum - 1;
          } else {
            var begin = ut.cellsRange.beginRowIndex,
                end = ut.cellsRange.endRowIndex,
                count = 0,
                trs = domUtils.getElementsByTagName(tb, "tr");for (var i = begin; i <= end; i++) {
              sumHeight += trs[i].offsetHeight;count += 1;
            }rowNum = count;
          }if (browser.ie && browser.version < 9) {
            averageHeight = Math.ceil(sumHeight / rowNum);
          } else {
            averageHeight = Math.ceil(sumHeight / rowNum) - tbAttr.tdBorder * 2 - tdpadding * 2;
          }return averageHeight;
        }function setAverageHeight(averageHeight) {
          var cells = ut.isFullCol() ? domUtils.getElementsByTagName(ut.table, "td") : ut.selectedTds;utils.each(cells, function (node) {
            if (node.rowSpan == 1) {
              node.setAttribute("height", averageHeight);
            }
          });
        }if (ut && ut.selectedTds.length) {
          setAverageHeight(getAverageHeight());
        }
      } };UE.commands["cellalignment"] = { queryCommandState: function queryCommandState() {
        return getTableItemsByRange(this).table ? 0 : -1;
      }, execCommand: function execCommand(cmd, data) {
        var me = this,
            ut = getUETableBySelected(me);if (!ut) {
          var start = me.selection.getStart(),
              cell = start && domUtils.findParentByTagName(start, ["td", "th", "caption"], true);if (!/caption/ig.test(cell.tagName)) {
            domUtils.setAttributes(cell, data);
          } else {
            cell.style.textAlign = data.align;cell.style.verticalAlign = data.vAlign;
          }me.selection.getRange().setCursor(true);
        } else {
          utils.each(ut.selectedTds, function (cell) {
            domUtils.setAttributes(cell, data);
          });
        }
      }, queryCommandValue: function queryCommandValue(cmd) {
        var activeMenuCell = getTableItemsByRange(this).cell;if (!activeMenuCell) {
          activeMenuCell = getSelectedArr(this)[0];
        }if (!activeMenuCell) {
          return null;
        } else {
          var cells = UE.UETable.getUETable(activeMenuCell).selectedTds;!cells.length && (cells = activeMenuCell);return UE.UETable.getTableCellAlignState(cells);
        }
      } };UE.commands["tablealignment"] = { queryCommandState: function queryCommandState() {
        if (browser.ie && browser.version < 8) {
          return -1;
        }return getTableItemsByRange(this).table ? 0 : -1;
      }, execCommand: function execCommand(cmd, value) {
        var me = this,
            start = me.selection.getStart(),
            table = start && domUtils.findParentByTagName(start, ["table"], true);if (table) {
          table.setAttribute("align", value);
        }
      } };UE.commands["edittable"] = { queryCommandState: function queryCommandState() {
        return getTableItemsByRange(this).table ? 0 : -1;
      }, execCommand: function execCommand(cmd, color) {
        var rng = this.selection.getRange(),
            table = domUtils.findParentByTagName(rng.startContainer, "table");if (table) {
          var arr = domUtils.getElementsByTagName(table, "td").concat(domUtils.getElementsByTagName(table, "th"), domUtils.getElementsByTagName(table, "caption"));utils.each(arr, function (node) {
            node.style.borderColor = color;
          });
        }
      } };UE.commands["edittd"] = { queryCommandState: function queryCommandState() {
        return getTableItemsByRange(this).table ? 0 : -1;
      }, execCommand: function execCommand(cmd, bkColor) {
        var me = this,
            ut = getUETableBySelected(me);if (!ut) {
          var start = me.selection.getStart(),
              cell = start && domUtils.findParentByTagName(start, ["td", "th", "caption"], true);if (cell) {
            cell.style.backgroundColor = bkColor;
          }
        } else {
          utils.each(ut.selectedTds, function (cell) {
            cell.style.backgroundColor = bkColor;
          });
        }
      } };UE.commands["settablebackground"] = { queryCommandState: function queryCommandState() {
        return getSelectedArr(this).length > 1 ? 0 : -1;
      }, execCommand: function execCommand(cmd, value) {
        var cells, ut;cells = getSelectedArr(this);ut = getUETable(cells[0]);ut.setBackground(cells, value);
      } };UE.commands["cleartablebackground"] = { queryCommandState: function queryCommandState() {
        var cells = getSelectedArr(this);if (!cells.length) {
          return -1;
        }for (var i = 0, cell; cell = cells[i++];) {
          if (cell.style.backgroundColor !== "") {
            return 0;
          }
        }return -1;
      }, execCommand: function execCommand() {
        var cells = getSelectedArr(this),
            ut = getUETable(cells[0]);ut.removeBackground(cells);
      } };UE.commands["interlacetable"] = UE.commands["uninterlacetable"] = { queryCommandState: function queryCommandState(cmd) {
        var table = getTableItemsByRange(this).table;if (!table) {
          return -1;
        }var interlaced = table.getAttribute("interlaced");if (cmd == "interlacetable") {
          return interlaced === "enabled" ? -1 : 0;
        } else {
          return !interlaced || interlaced === "disabled" ? -1 : 0;
        }
      }, execCommand: function execCommand(cmd, classList) {
        var table = getTableItemsByRange(this).table;if (cmd == "interlacetable") {
          table.setAttribute("interlaced", "enabled");this.fireEvent("interlacetable", table, classList);
        } else {
          table.setAttribute("interlaced", "disabled");this.fireEvent("uninterlacetable", table);
        }
      } };UE.commands["setbordervisible"] = { queryCommandState: function queryCommandState(cmd) {
        var table = getTableItemsByRange(this).table;if (!table) {
          return -1;
        }return 0;
      }, execCommand: function execCommand() {
        var table = getTableItemsByRange(this).table;utils.each(domUtils.getElementsByTagName(table, "td"), function (td) {
          td.style.borderWidth = "1px";td.style.borderStyle = "solid";
        });
      } };function resetTdWidth(table, editor) {
      var tds = domUtils.getElementsByTagName(table, "td th");utils.each(tds, function (td) {
        td.removeAttribute("width");
      });table.setAttribute("width", getTableWidth(editor, true, getDefaultValue(editor, table)));var tdsWidths = [];setTimeout(function () {
        utils.each(tds, function (td) {
          td.colSpan == 1 && tdsWidths.push(td.offsetWidth);
        });utils.each(tds, function (td, i) {
          td.colSpan == 1 && td.setAttribute("width", tdsWidths[i] + "");
        });
      }, 0);
    }function getTableWidth(editor, needIEHack, defaultValue) {
      var body = editor.body;return body.offsetWidth - (needIEHack ? parseInt(domUtils.getComputedStyle(body, "margin-left"), 10) * 2 : 0) - defaultValue.tableBorder * 2 - (editor.options.offsetWidth || 0);
    }function getSelectedArr(editor) {
      var cell = getTableItemsByRange(editor).cell;if (cell) {
        var ut = getUETable(cell);return ut.selectedTds.length ? ut.selectedTds : [cell];
      } else {
        return [];
      }
    }
  })();UE.plugins["table"] = function () {
    var me = this,
        tabTimer = null,
        tableDragTimer = null,
        tableResizeTimer = null,
        cellMinWidth = 5,
        isInResizeBuffer = false,
        cellBorderWidth = 5,
        offsetOfTableCell = 10,
        singleClickState = 0,
        userActionStatus = null,
        dblclickTime = 360,
        UT = UE.UETable,
        getUETable = function getUETable(tdOrTable) {
      return UT.getUETable(tdOrTable);
    },
        getUETableBySelected = function getUETableBySelected(editor) {
      return UT.getUETableBySelected(editor);
    },
        getDefaultValue = function getDefaultValue(editor, table) {
      return UT.getDefaultValue(editor, table);
    },
        removeSelectedClass = function removeSelectedClass(cells) {
      return UT.removeSelectedClass(cells);
    };function showError(e) {}me.ready(function () {
      var me = this;var orgGetText = me.selection.getText;me.selection.getText = function () {
        var table = getUETableBySelected(me);if (table) {
          var str = "";utils.each(table.selectedTds, function (td) {
            str += td[browser.ie ? "innerText" : "textContent"];
          });return str;
        } else {
          return orgGetText.call(me.selection);
        }
      };
    });var startTd = null,
        currentTd = null,
        onDrag = "",
        onBorder = false,
        dragButton = null,
        dragOver = false,
        dragLine = null,
        dragTd = null;var mousedown = false,
        needIEHack = true;me.setOpt({ "maxColNum": 20, "maxRowNum": 100, "defaultCols": 5, "defaultRows": 5, "tdvalign": "top", "cursorpath": me.options.UEDITOR_HOME_URL + "themes/default/images/cursor_", "tableDragable": false, "classList": ["ue-table-interlace-color-single", "ue-table-interlace-color-double"] });me.getUETable = getUETable;var commands = { "deletetable": 1, "inserttable": 1, "cellvalign": 1, "insertcaption": 1, "deletecaption": 1, "inserttitle": 1, "deletetitle": 1, "mergeright": 1, "mergedown": 1, "mergecells": 1, "insertrow": 1, "insertrownext": 1, "deleterow": 1, "insertcol": 1, "insertcolnext": 1, "deletecol": 1, "splittocells": 1, "splittorows": 1, "splittocols": 1, "adaptbytext": 1, "adaptbywindow": 1, "adaptbycustomer": 1, "insertparagraph": 1, "insertparagraphbeforetable": 1, "averagedistributecol": 1, "averagedistributerow": 1 };me.ready(function () {
      utils.cssRule("table", ".selectTdClass{background-color:#edf5fa !important}" + "table.noBorderTable td,table.noBorderTable th,table.noBorderTable caption{border:1px dashed #ddd !important}" + "table{margin-bottom:10px;border-collapse:collapse;display:table;}" + "td,th{padding: 5px 10px;border: 1px solid #DDD;}" + "caption{border:1px dashed #DDD;border-bottom:0;padding:3px;text-align:center;}" + "th{border-top:1px solid #BBB;background-color:#F7F7F7;}" + "table tr.firstRow th{border-top-width:2px;}" + ".ue-table-interlace-color-single{ background-color: #fcfcfc; } .ue-table-interlace-color-double{ background-color: #f7faff; }" + "td p{margin:0;padding:0;}", me.document);var tableCopyList, isFullCol, isFullRow;me.addListener("keydown", function (cmd, evt) {
        var me = this;var keyCode = evt.keyCode || evt.which;if (keyCode == 8) {
          var ut = getUETableBySelected(me);if (ut && ut.selectedTds.length) {
            if (ut.isFullCol()) {
              me.execCommand("deletecol");
            } else {
              if (ut.isFullRow()) {
                me.execCommand("deleterow");
              } else {
                me.fireEvent("delcells");
              }
            }domUtils.preventDefault(evt);
          }var caption = domUtils.findParentByTagName(me.selection.getStart(), "caption", true),
              range = me.selection.getRange();if (range.collapsed && caption && isEmptyBlock(caption)) {
            me.fireEvent("saveScene");var table = caption.parentNode;domUtils.remove(caption);if (table) {
              range.setStart(table.rows[0].cells[0], 0).setCursor(false, true);
            }me.fireEvent("saveScene");
          }
        }if (keyCode == 46) {
          ut = getUETableBySelected(me);if (ut) {
            me.fireEvent("saveScene");for (var i = 0, ci; ci = ut.selectedTds[i++];) {
              domUtils.fillNode(me.document, ci);
            }me.fireEvent("saveScene");domUtils.preventDefault(evt);
          }
        }if (keyCode == 13) {
          var rng = me.selection.getRange(),
              caption = domUtils.findParentByTagName(rng.startContainer, "caption", true);if (caption) {
            var table = domUtils.findParentByTagName(caption, "table");if (!rng.collapsed) {
              rng.deleteContents();me.fireEvent("saveScene");
            } else {
              if (caption) {
                rng.setStart(table.rows[0].cells[0], 0).setCursor(false, true);
              }
            }domUtils.preventDefault(evt);return;
          }if (rng.collapsed) {
            var table = domUtils.findParentByTagName(rng.startContainer, "table");if (table) {
              var cell = table.rows[0].cells[0],
                  start = domUtils.findParentByTagName(me.selection.getStart(), ["td", "th"], true),
                  preNode = table.previousSibling;if (cell === start && (!preNode || preNode.nodeType == 1 && preNode.tagName == "TABLE") && domUtils.isStartInblock(rng)) {
                var first = domUtils.findParent(me.selection.getStart(), function (n) {
                  return domUtils.isBlockElm(n);
                }, true);if (first && (/t(h|d)/i.test(first.tagName) || first === start.firstChild)) {
                  me.execCommand("insertparagraphbeforetable");domUtils.preventDefault(evt);
                }
              }
            }
          }
        }if ((evt.ctrlKey || evt.metaKey) && evt.keyCode == "67") {
          tableCopyList = null;var ut = getUETableBySelected(me);if (ut) {
            var tds = ut.selectedTds;isFullCol = ut.isFullCol();isFullRow = ut.isFullRow();tableCopyList = [[ut.cloneCell(tds[0], null, true)]];for (var i = 1, ci; ci = tds[i]; i++) {
              if (ci.parentNode !== tds[i - 1].parentNode) {
                tableCopyList.push([ut.cloneCell(ci, null, true)]);
              } else {
                tableCopyList[tableCopyList.length - 1].push(ut.cloneCell(ci, null, true));
              }
            }
          }
        }
      });me.addListener("tablehasdeleted", function () {
        toggleDraggableState(this, false, "", null);if (dragButton) {
          domUtils.remove(dragButton);
        }
      });me.addListener("beforepaste", function (cmd, html) {
        var me = this;var rng = me.selection.getRange();if (domUtils.findParentByTagName(rng.startContainer, "caption", true)) {
          var div = me.document.createElement("div");div.innerHTML = html.html;html.html = div[browser.ie9below ? "innerText" : "textContent"];return;
        }var table = getUETableBySelected(me);if (tableCopyList) {
          me.fireEvent("saveScene");var rng = me.selection.getRange();var td = domUtils.findParentByTagName(rng.startContainer, ["td", "th"], true),
              tmpNode,
              preNode;if (td) {
            var ut = getUETable(td);if (isFullRow) {
              var rowIndex = ut.getCellInfo(td).rowIndex;if (td.tagName == "TH") {
                rowIndex++;
              }for (var i = 0, ci; ci = tableCopyList[i++];) {
                var tr = ut.insertRow(rowIndex++, "td");for (var j = 0, cj; cj = ci[j]; j++) {
                  var cell = tr.cells[j];if (!cell) {
                    cell = tr.insertCell(j);
                  }cell.innerHTML = cj.innerHTML;cj.getAttribute("width") && cell.setAttribute("width", cj.getAttribute("width"));cj.getAttribute("vAlign") && cell.setAttribute("vAlign", cj.getAttribute("vAlign"));cj.getAttribute("align") && cell.setAttribute("align", cj.getAttribute("align"));cj.style.cssText && (cell.style.cssText = cj.style.cssText);
                }for (var j = 0, cj; cj = tr.cells[j]; j++) {
                  if (!ci[j]) {
                    break;
                  }cj.innerHTML = ci[j].innerHTML;ci[j].getAttribute("width") && cj.setAttribute("width", ci[j].getAttribute("width"));ci[j].getAttribute("vAlign") && cj.setAttribute("vAlign", ci[j].getAttribute("vAlign"));ci[j].getAttribute("align") && cj.setAttribute("align", ci[j].getAttribute("align"));ci[j].style.cssText && (cj.style.cssText = ci[j].style.cssText);
                }
              }
            } else {
              if (isFullCol) {
                cellInfo = ut.getCellInfo(td);var maxColNum = 0;for (var j = 0, ci = tableCopyList[0], cj; cj = ci[j++];) {
                  maxColNum += cj.colSpan || 1;
                }me.__hasEnterExecCommand = true;for (i = 0; i < maxColNum; i++) {
                  me.execCommand("insertcol");
                }me.__hasEnterExecCommand = false;td = ut.table.rows[0].cells[cellInfo.cellIndex];if (td.tagName == "TH") {
                  td = ut.table.rows[1].cells[cellInfo.cellIndex];
                }
              }for (var i = 0, ci; ci = tableCopyList[i++];) {
                tmpNode = td;for (var j = 0, cj; cj = ci[j++];) {
                  if (td) {
                    td.innerHTML = cj.innerHTML;cj.getAttribute("width") && td.setAttribute("width", cj.getAttribute("width"));cj.getAttribute("vAlign") && td.setAttribute("vAlign", cj.getAttribute("vAlign"));cj.getAttribute("align") && td.setAttribute("align", cj.getAttribute("align"));cj.style.cssText && (td.style.cssText = cj.style.cssText);preNode = td;td = td.nextSibling;
                  } else {
                    var cloneTd = cj.cloneNode(true);domUtils.removeAttributes(cloneTd, ["class", "rowSpan", "colSpan"]);preNode.parentNode.appendChild(cloneTd);
                  }
                }td = ut.getNextCell(tmpNode, true, true);if (!tableCopyList[i]) {
                  break;
                }if (!td) {
                  var cellInfo = ut.getCellInfo(tmpNode);ut.table.insertRow(ut.table.rows.length);ut.update();td = ut.getVSideCell(tmpNode, true);
                }
              }
            }ut.update();
          } else {
            table = me.document.createElement("table");for (var i = 0, ci; ci = tableCopyList[i++];) {
              var tr = table.insertRow(table.rows.length);for (var j = 0, cj; cj = ci[j++];) {
                cloneTd = UT.cloneCell(cj, null, true);domUtils.removeAttributes(cloneTd, ["class"]);tr.appendChild(cloneTd);
              }if (j == 2 && cloneTd.rowSpan > 1) {
                cloneTd.rowSpan = 1;
              }
            }var defaultValue = getDefaultValue(me),
                width = me.body.offsetWidth - (needIEHack ? parseInt(domUtils.getComputedStyle(me.body, "margin-left"), 10) * 2 : 0) - defaultValue.tableBorder * 2 - (me.options.offsetWidth || 0);me.execCommand("insertHTML", "<table  " + (isFullCol && isFullRow ? 'width="' + width + '"' : "") + ">" + table.innerHTML.replace(/>\s*</g, "><").replace(/\bth\b/gi, "td") + "</table>");
          }me.fireEvent("contentchange");me.fireEvent("saveScene");html.html = "";return true;
        } else {
          var div = me.document.createElement("div"),
              tables;div.innerHTML = html.html;tables = div.getElementsByTagName("table");if (domUtils.findParentByTagName(me.selection.getStart(), "table")) {
            utils.each(tables, function (t) {
              domUtils.remove(t);
            });if (domUtils.findParentByTagName(me.selection.getStart(), "caption", true)) {
              div.innerHTML = div[browser.ie ? "innerText" : "textContent"];
            }
          } else {
            utils.each(tables, function (table) {
              removeStyleSize(table, true);domUtils.removeAttributes(table, ["style", "border"]);utils.each(domUtils.getElementsByTagName(table, "td"), function (td) {
                if (isEmptyBlock(td)) {
                  domUtils.fillNode(me.document, td);
                }removeStyleSize(td, true);
              });
            });
          }html.html = div.innerHTML;
        }
      });me.addListener("afterpaste", function () {
        utils.each(domUtils.getElementsByTagName(me.body, "table"), function (table) {
          if (table.offsetWidth > me.body.offsetWidth) {
            var defaultValue = getDefaultValue(me, table);table.style.width = me.body.offsetWidth - (needIEHack ? parseInt(domUtils.getComputedStyle(me.body, "margin-left"), 10) * 2 : 0) - defaultValue.tableBorder * 2 - (me.options.offsetWidth || 0) + "px";
          }
        });
      });me.addListener("blur", function () {
        tableCopyList = null;
      });var timer;me.addListener("keydown", function () {
        clearTimeout(timer);timer = setTimeout(function () {
          var rng = me.selection.getRange(),
              cell = domUtils.findParentByTagName(rng.startContainer, ["th", "td"], true);if (cell) {
            var table = cell.parentNode.parentNode.parentNode;if (table.offsetWidth > table.getAttribute("width")) {
              cell.style.wordBreak = "break-all";
            }
          }
        }, 100);
      });me.addListener("selectionchange", function () {
        toggleDraggableState(me, false, "", null);
      });me.addListener("contentchange", function () {
        var me = this;hideDragLine(me);if (getUETableBySelected(me)) {
          return;
        }var rng = me.selection.getRange();var start = rng.startContainer;start = domUtils.findParentByTagName(start, ["td", "th"], true);utils.each(domUtils.getElementsByTagName(me.document, "table"), function (table) {
          if (me.fireEvent("excludetable", table) === true) {
            return;
          }table.ueTable = new UT(table);table.onmouseover = function () {
            me.fireEvent("tablemouseover", table);
          };table.onmousemove = function () {
            me.fireEvent("tablemousemove", table);me.options.tableDragable && toggleDragButton(true, this, me);utils.defer(function () {
              me.fireEvent("contentchange", 50);
            }, true);
          };table.onmouseout = function () {
            me.fireEvent("tablemouseout", table);toggleDraggableState(me, false, "", null);hideDragLine(me);
          };table.onclick = function (evt) {
            evt = me.window.event || evt;var target = getParentTdOrTh(evt.target || evt.srcElement);if (!target) {
              return;
            }var ut = getUETable(target),
                table = ut.table,
                cellInfo = ut.getCellInfo(target),
                cellsRange,
                rng = me.selection.getRange();if (inTableSide(table, target, evt, true)) {
              var endTdCol = ut.getCell(ut.indexTable[ut.rowsNum - 1][cellInfo.colIndex].rowIndex, ut.indexTable[ut.rowsNum - 1][cellInfo.colIndex].cellIndex);if (evt.shiftKey && ut.selectedTds.length) {
                if (ut.selectedTds[0] !== endTdCol) {
                  cellsRange = ut.getCellsRange(ut.selectedTds[0], endTdCol);ut.setSelected(cellsRange);
                } else {
                  rng && rng.selectNodeContents(endTdCol).select();
                }
              } else {
                if (target !== endTdCol) {
                  cellsRange = ut.getCellsRange(target, endTdCol);ut.setSelected(cellsRange);
                } else {
                  rng && rng.selectNodeContents(endTdCol).select();
                }
              }return;
            }if (inTableSide(table, target, evt)) {
              var endTdRow = ut.getCell(ut.indexTable[cellInfo.rowIndex][ut.colsNum - 1].rowIndex, ut.indexTable[cellInfo.rowIndex][ut.colsNum - 1].cellIndex);if (evt.shiftKey && ut.selectedTds.length) {
                if (ut.selectedTds[0] !== endTdRow) {
                  cellsRange = ut.getCellsRange(ut.selectedTds[0], endTdRow);ut.setSelected(cellsRange);
                } else {
                  rng && rng.selectNodeContents(endTdRow).select();
                }
              } else {
                if (target !== endTdRow) {
                  cellsRange = ut.getCellsRange(target, endTdRow);ut.setSelected(cellsRange);
                } else {
                  rng && rng.selectNodeContents(endTdRow).select();
                }
              }
            }
          };
        });switchBorderColor(me, true);
      });domUtils.on(me.document, "mousemove", mouseMoveEvent);domUtils.on(me.document, "mouseout", function (evt) {
        var target = evt.target || evt.srcElement;if (target.tagName == "TABLE") {
          toggleDraggableState(me, false, "", null);
        }
      });me.addListener("interlacetable", function (type, table, classList) {
        if (!table) {
          return;
        }var me = this,
            rows = table.rows,
            len = rows.length,
            getClass = function getClass(list, index, repeat) {
          return list[index] ? list[index] : repeat ? list[index % list.length] : "";
        };for (var i = 0; i < len; i++) {
          rows[i].className = getClass(classList || me.options.classList, i, true);
        }
      });me.addListener("uninterlacetable", function (type, table) {
        if (!table) {
          return;
        }var me = this,
            rows = table.rows,
            classList = me.options.classList,
            len = rows.length;for (var i = 0; i < len; i++) {
          domUtils.removeClasses(rows[i], classList);
        }
      });me.addListener("mousedown", mouseDownEvent);me.addListener("mouseup", mouseUpEvent);domUtils.on(me.body, "dragstart", function (evt) {
        mouseUpEvent.call(me, "dragstart", evt);
      });me.addOutputRule(function (root) {
        utils.each(root.getNodesByTagName("div"), function (n) {
          if (n.getAttr("id") == "ue_tableDragLine") {
            n.parentNode.removeChild(n);
          }
        });
      });var currentRowIndex = 0;me.addListener("mousedown", function () {
        currentRowIndex = 0;
      });me.addListener("tabkeydown", function () {
        var range = this.selection.getRange(),
            common = range.getCommonAncestor(true, true),
            table = domUtils.findParentByTagName(common, "table");if (table) {
          if (domUtils.findParentByTagName(common, "caption", true)) {
            var cell = domUtils.getElementsByTagName(table, "th td");if (cell && cell.length) {
              range.setStart(cell[0], 0).setCursor(false, true);
            }
          } else {
            var cell = domUtils.findParentByTagName(common, ["td", "th"], true),
                ua = getUETable(cell);currentRowIndex = cell.rowSpan > 1 ? currentRowIndex : ua.getCellInfo(cell).rowIndex;var nextCell = ua.getTabNextCell(cell, currentRowIndex);if (nextCell) {
              if (isEmptyBlock(nextCell)) {
                range.setStart(nextCell, 0).setCursor(false, true);
              } else {
                range.selectNodeContents(nextCell).select();
              }
            } else {
              me.fireEvent("saveScene");me.__hasEnterExecCommand = true;this.execCommand("insertrownext");me.__hasEnterExecCommand = false;range = this.selection.getRange();range.setStart(table.rows[table.rows.length - 1].cells[0], 0).setCursor();me.fireEvent("saveScene");
            }
          }return true;
        }
      });browser.ie && me.addListener("selectionchange", function () {
        toggleDraggableState(this, false, "", null);
      });me.addListener("keydown", function (type, evt) {
        var me = this;var keyCode = evt.keyCode || evt.which;if (keyCode == 8 || keyCode == 46) {
          return;
        }var notCtrlKey = !evt.ctrlKey && !evt.metaKey && !evt.shiftKey && !evt.altKey;notCtrlKey && removeSelectedClass(domUtils.getElementsByTagName(me.body, "td"));var ut = getUETableBySelected(me);if (!ut) {
          return;
        }notCtrlKey && ut.clearSelected();
      });me.addListener("beforegetcontent", function () {
        switchBorderColor(this, false);browser.ie && utils.each(this.document.getElementsByTagName("caption"), function (ci) {
          if (domUtils.isEmptyNode(ci)) {
            ci.innerHTML = "&nbsp;";
          }
        });
      });me.addListener("aftergetcontent", function () {
        switchBorderColor(this, true);
      });me.addListener("getAllHtml", function () {
        removeSelectedClass(me.document.getElementsByTagName("td"));
      });me.addListener("fullscreenchanged", function (type, fullscreen) {
        if (!fullscreen) {
          var ratio = this.body.offsetWidth / document.body.offsetWidth,
              tables = domUtils.getElementsByTagName(this.body, "table");utils.each(tables, function (table) {
            if (table.offsetWidth < me.body.offsetWidth) {
              return false;
            }var tds = domUtils.getElementsByTagName(table, "td"),
                backWidths = [];utils.each(tds, function (td) {
              backWidths.push(td.offsetWidth);
            });for (var i = 0, td; td = tds[i]; i++) {
              td.setAttribute("width", Math.floor(backWidths[i] * ratio));
            }table.setAttribute("width", Math.floor(getTableWidth(me, needIEHack, getDefaultValue(me))));
          });
        }
      });var oldExecCommand = me.execCommand;me.execCommand = function (cmd, datatat) {
        var me = this,
            args = arguments;cmd = cmd.toLowerCase();var ut = getUETableBySelected(me),
            tds,
            range = new dom.Range(me.document),
            cmdFun = me.commands[cmd] || UE.commands[cmd],
            result;if (!cmdFun) {
          return;
        }if (ut && !commands[cmd] && !cmdFun.notNeedUndo && !me.__hasEnterExecCommand) {
          me.__hasEnterExecCommand = true;me.fireEvent("beforeexeccommand", cmd);tds = ut.selectedTds;var lastState = -2,
              lastValue = -2,
              value,
              state;for (var i = 0, td; td = tds[i]; i++) {
            if (isEmptyBlock(td)) {
              range.setStart(td, 0).setCursor(false, true);
            } else {
              range.selectNode(td).select(true);
            }state = me.queryCommandState(cmd);value = me.queryCommandValue(cmd);if (state != -1) {
              if (lastState !== state || lastValue !== value) {
                me._ignoreContentChange = true;result = oldExecCommand.apply(me, arguments);me._ignoreContentChange = false;
              }lastState = me.queryCommandState(cmd);lastValue = me.queryCommandValue(cmd);if (domUtils.isEmptyBlock(td)) {
                domUtils.fillNode(me.document, td);
              }
            }
          }range.setStart(tds[0], 0).shrinkBoundary(true).setCursor(false, true);me.fireEvent("contentchange");me.fireEvent("afterexeccommand", cmd);me.__hasEnterExecCommand = false;me._selectionChange();
        } else {
          result = oldExecCommand.apply(me, arguments);
        }return result;
      };
    });function removeStyleSize(obj, replaceToProperty) {
      removeStyle(obj, "width", true);removeStyle(obj, "height", true);
    }function removeStyle(obj, styleName, replaceToProperty) {
      if (obj.style[styleName]) {
        replaceToProperty && obj.setAttribute(styleName, parseInt(obj.style[styleName], 10));obj.style[styleName] = "";
      }
    }function getParentTdOrTh(ele) {
      if (ele.tagName == "TD" || ele.tagName == "TH") {
        return ele;
      }var td;if (td = domUtils.findParentByTagName(ele, "td", true) || domUtils.findParentByTagName(ele, "th", true)) {
        return td;
      }return null;
    }function isEmptyBlock(node) {
      var reg = new RegExp(domUtils.fillChar, "g");if (node[browser.ie ? "innerText" : "textContent"].replace(/^\s*$/, "").replace(reg, "").length > 0) {
        return 0;
      }for (var n in dtd.$isNotEmpty) {
        if (node.getElementsByTagName(n).length) {
          return 0;
        }
      }return 1;
    }function mouseCoords(evt) {
      if (evt.pageX || evt.pageY) {
        return { x: evt.pageX, y: evt.pageY };
      }return { x: evt.clientX + me.document.body.scrollLeft - me.document.body.clientLeft, y: evt.clientY + me.document.body.scrollTop - me.document.body.clientTop };
    }function mouseMoveEvent(evt) {
      if (isEditorDisabled()) {
        return;
      }try {
        var target = getParentTdOrTh(evt.target || evt.srcElement),
            pos;if (isInResizeBuffer) {
          me.body.style.webkitUserSelect = "none";if (Math.abs(userActionStatus.x - evt.clientX) > offsetOfTableCell || Math.abs(userActionStatus.y - evt.clientY) > offsetOfTableCell) {
            clearTableDragTimer();isInResizeBuffer = false;singleClickState = 0;tableBorderDrag(evt);
          }
        }if (onDrag && dragTd) {
          singleClickState = 0;me.body.style.webkitUserSelect = "none";me.selection.getNative()[browser.ie9below ? "empty" : "removeAllRanges"]();pos = mouseCoords(evt);toggleDraggableState(me, true, onDrag, pos, target);if (onDrag == "h") {
            dragLine.style.left = getPermissionX(dragTd, evt) + "px";
          } else {
            if (onDrag == "v") {
              dragLine.style.top = getPermissionY(dragTd, evt) + "px";
            }
          }return;
        }if (target) {
          if (me.fireEvent("excludetable", target) === true) {
            return;
          }pos = mouseCoords(evt);var state = getRelation(target, pos),
              table = domUtils.findParentByTagName(target, "table", true);if (inTableSide(table, target, evt, true)) {
            if (me.fireEvent("excludetable", table) === true) {
              return;
            }me.body.style.cursor = "url(" + me.options.cursorpath + "h.png),pointer";
          } else {
            if (inTableSide(table, target, evt)) {
              if (me.fireEvent("excludetable", table) === true) {
                return;
              }me.body.style.cursor = "url(" + me.options.cursorpath + "v.png),pointer";
            } else {
              me.body.style.cursor = "text";var curCell = target;if (/\d/.test(state)) {
                state = state.replace(/\d/, "");target = getUETable(target).getPreviewCell(target, state == "v");
              }toggleDraggableState(me, target ? !!state : false, target ? state : "", pos, target);
            }
          }
        } else {
          toggleDragButton(false, table, me);
        }
      } catch (e) {
        showError(e);
      }
    }var dragButtonTimer;function toggleDragButton(show, table, editor) {
      if (!show) {
        if (dragOver) {
          return;
        }dragButtonTimer = setTimeout(function () {
          !dragOver && dragButton && dragButton.parentNode && dragButton.parentNode.removeChild(dragButton);
        }, 2000);
      } else {
        createDragButton(table, editor);
      }
    }function createDragButton(table, editor) {
      var pos = domUtils.getXY(table),
          doc = table.ownerDocument;if (dragButton && dragButton.parentNode) {
        return dragButton;
      }dragButton = doc.createElement("div");dragButton.contentEditable = false;dragButton.innerHTML = "";dragButton.style.cssText = "width:15px;height:15px;background-image:url(" + editor.options.UEDITOR_HOME_URL + "dialogs/table/dragicon.png);position: absolute;cursor:move;top:" + (pos.y - 15) + "px;left:" + pos.x + "px;";domUtils.unSelectable(dragButton);dragButton.onmouseover = function (evt) {
        dragOver = true;
      };dragButton.onmouseout = function (evt) {
        dragOver = false;
      };domUtils.on(dragButton, "click", function (type, evt) {
        doClick(evt, this);
      });domUtils.on(dragButton, "dblclick", function (type, evt) {
        doDblClick(evt);
      });domUtils.on(dragButton, "dragstart", function (type, evt) {
        domUtils.preventDefault(evt);
      });var timer;function doClick(evt, button) {
        clearTimeout(timer);timer = setTimeout(function () {
          editor.fireEvent("tableClicked", table, button);
        }, 300);
      }function doDblClick(evt) {
        clearTimeout(timer);var ut = getUETable(table),
            start = table.rows[0].cells[0],
            end = ut.getLastCell(),
            range = ut.getCellsRange(start, end);editor.selection.getRange().setStart(start, 0).setCursor(false, true);ut.setSelected(range);
      }doc.body.appendChild(dragButton);
    }function inTableSide(table, cell, evt, top) {
      var pos = mouseCoords(evt),
          state = getRelation(cell, pos);if (top) {
        var caption = table.getElementsByTagName("caption")[0],
            capHeight = caption ? caption.offsetHeight : 0;return state == "v1" && pos.y - domUtils.getXY(table).y - capHeight < 8;
      } else {
        return state == "h1" && pos.x - domUtils.getXY(table).x < 8;
      }
    }function getPermissionX(dragTd, evt) {
      var ut = getUETable(dragTd);if (ut) {
        var preTd = ut.getSameEndPosCells(dragTd, "x")[0],
            nextTd = ut.getSameStartPosXCells(dragTd)[0],
            mouseX = mouseCoords(evt).x,
            left = (preTd ? domUtils.getXY(preTd).x : domUtils.getXY(ut.table).x) + 20,
            right = nextTd ? domUtils.getXY(nextTd).x + nextTd.offsetWidth - 20 : me.body.offsetWidth + 5 || parseInt(domUtils.getComputedStyle(me.body, "width"), 10);left += cellMinWidth;right -= cellMinWidth;return mouseX < left ? left : mouseX > right ? right : mouseX;
      }
    }function getPermissionY(dragTd, evt) {
      try {
        var top = domUtils.getXY(dragTd).y,
            mousePosY = mouseCoords(evt).y;return mousePosY < top ? top : mousePosY;
      } catch (e) {
        showError(e);
      }
    }function toggleDraggableState(editor, draggable, dir, mousePos, cell) {
      try {
        editor.body.style.cursor = dir == "h" ? "col-resize" : dir == "v" ? "row-resize" : "text";if (browser.ie) {
          if (dir && !mousedown && !getUETableBySelected(editor)) {
            getDragLine(editor, editor.document);showDragLineAt(dir, cell);
          } else {
            hideDragLine(editor);
          }
        }onBorder = draggable;
      } catch (e) {
        showError(e);
      }
    }function getResizeLineByUETable() {
      var lineId = "_UETableResizeLine",
          line = this.document.getElementById(lineId);if (!line) {
        line = this.document.createElement("div");line.id = lineId;line.contnetEditable = false;line.setAttribute("unselectable", "on");var styles = { width: 2 * cellBorderWidth + 1 + "px", position: "absolute", "z-index": 100000, cursor: "col-resize", background: "red", display: "none" };line.onmouseout = function () {
          this.style.display = "none";
        };utils.extend(line.style, styles);this.document.body.appendChild(line);
      }return line;
    }function updateResizeLine(cell, uetable) {
      var line = getResizeLineByUETable.call(this),
          table = uetable.table,
          styles = { top: domUtils.getXY(table).y + "px", left: domUtils.getXY(cell).x + cell.offsetWidth - cellBorderWidth + "px", display: "block", height: table.offsetHeight + "px" };utils.extend(line.style, styles);
    }function showResizeLine(cell) {
      var uetable = getUETable(cell);updateResizeLine.call(this, cell, uetable);
    }function getRelation(ele, mousePos) {
      var elePos = domUtils.getXY(ele);if (!elePos) {
        return "";
      }if (elePos.x + ele.offsetWidth - mousePos.x < cellBorderWidth) {
        return "h";
      }if (mousePos.x - elePos.x < cellBorderWidth) {
        return "h1";
      }if (elePos.y + ele.offsetHeight - mousePos.y < cellBorderWidth) {
        return "v";
      }if (mousePos.y - elePos.y < cellBorderWidth) {
        return "v1";
      }return "";
    }function mouseDownEvent(type, evt) {
      if (isEditorDisabled()) {
        return;
      }userActionStatus = { x: evt.clientX, y: evt.clientY };if (evt.button == 2) {
        var ut = getUETableBySelected(me),
            flag = false;if (ut) {
          var td = getTargetTd(me, evt);utils.each(ut.selectedTds, function (ti) {
            if (ti === td) {
              flag = true;
            }
          });if (!flag) {
            removeSelectedClass(domUtils.getElementsByTagName(me.body, "th td"));ut.clearSelected();
          } else {
            td = ut.selectedTds[0];setTimeout(function () {
              me.selection.getRange().setStart(td, 0).setCursor(false, true);
            }, 0);
          }
        }
      } else {
        tableClickHander(evt);
      }
    }function clearTableTimer() {
      tabTimer && clearTimeout(tabTimer);tabTimer = null;
    }function tableDbclickHandler(evt) {
      singleClickState = 0;evt = evt || me.window.event;var target = getParentTdOrTh(evt.target || evt.srcElement);if (target) {
        var h;if (h = getRelation(target, mouseCoords(evt))) {
          hideDragLine(me);if (h == "h1") {
            h = "h";if (inTableSide(domUtils.findParentByTagName(target, "table"), target, evt)) {
              me.execCommand("adaptbywindow");
            } else {
              target = getUETable(target).getPreviewCell(target);if (target) {
                var rng = me.selection.getRange();rng.selectNodeContents(target).setCursor(true, true);
              }
            }
          }if (h == "h") {
            var ut = getUETable(target),
                table = ut.table,
                cells = getCellsByMoveBorder(target, table, true);cells = extractArray(cells, "left");ut.width = ut.offsetWidth;var oldWidth = [],
                newWidth = [];utils.each(cells, function (cell) {
              oldWidth.push(cell.offsetWidth);
            });utils.each(cells, function (cell) {
              cell.removeAttribute("width");
            });window.setTimeout(function () {
              var changeable = true;utils.each(cells, function (cell, index) {
                var width = cell.offsetWidth;if (width > oldWidth[index]) {
                  changeable = false;return false;
                }newWidth.push(width);
              });var change = changeable ? newWidth : oldWidth;utils.each(cells, function (cell, index) {
                cell.width = change[index] - getTabcellSpace();
              });
            }, 0);
          }
        }
      }
    }function tableClickHander(evt) {
      removeSelectedClass(domUtils.getElementsByTagName(me.body, "td th"));utils.each(me.document.getElementsByTagName("table"), function (t) {
        t.ueTable = null;
      });startTd = getTargetTd(me, evt);if (!startTd) {
        return;
      }var table = domUtils.findParentByTagName(startTd, "table", true);var ut = getUETable(table);ut && ut.clearSelected();if (!onBorder) {
        me.document.body.style.webkitUserSelect = "";mousedown = true;me.addListener("mouseover", mouseOverEvent);
      } else {
        borderActionHandler(evt);
      }
    }function borderActionHandler(evt) {
      if (browser.ie) {
        evt = reconstruct(evt);
      }clearTableDragTimer();isInResizeBuffer = true;tableDragTimer = setTimeout(function () {
        tableBorderDrag(evt);
      }, dblclickTime);
    }function extractArray(originArr, key) {
      var result = [],
          tmp = null;for (var i = 0, len = originArr.length; i < len; i++) {
        tmp = originArr[i][key];if (tmp) {
          result.push(tmp);
        }
      }return result;
    }function clearTableDragTimer() {
      tableDragTimer && clearTimeout(tableDragTimer);tableDragTimer = null;
    }function reconstruct(obj) {
      var attrs = ["pageX", "pageY", "clientX", "clientY", "srcElement", "target"],
          newObj = {};if (obj) {
        for (var i = 0, key, val; key = attrs[i]; i++) {
          val = obj[key];val && (newObj[key] = val);
        }
      }return newObj;
    }function tableBorderDrag(evt) {
      isInResizeBuffer = false;startTd = evt.target || evt.srcElement;if (!startTd) {
        return;
      }var state = getRelation(startTd, mouseCoords(evt));if (/\d/.test(state)) {
        state = state.replace(/\d/, "");startTd = getUETable(startTd).getPreviewCell(startTd, state == "v");
      }hideDragLine(me);getDragLine(me, me.document);me.fireEvent("saveScene");showDragLineAt(state, startTd);mousedown = true;onDrag = state;dragTd = startTd;
    }function mouseUpEvent(type, evt) {
      if (isEditorDisabled()) {
        return;
      }clearTableDragTimer();isInResizeBuffer = false;if (onBorder) {
        singleClickState = ++singleClickState % 3;userActionStatus = { x: evt.clientX, y: evt.clientY };tableResizeTimer = setTimeout(function () {
          singleClickState > 0 && singleClickState--;
        }, dblclickTime);if (singleClickState === 2) {
          singleClickState = 0;tableDbclickHandler(evt);return;
        }
      }if (evt.button == 2) {
        return;
      }var me = this;var range = me.selection.getRange(),
          start = domUtils.findParentByTagName(range.startContainer, "table", true),
          end = domUtils.findParentByTagName(range.endContainer, "table", true);if (start || end) {
        if (start === end) {
          start = domUtils.findParentByTagName(range.startContainer, ["td", "th", "caption"], true);end = domUtils.findParentByTagName(range.endContainer, ["td", "th", "caption"], true);if (start !== end) {
            me.selection.clearRange();
          }
        } else {
          me.selection.clearRange();
        }
      }mousedown = false;me.document.body.style.webkitUserSelect = "";if (onDrag && dragTd) {
        me.selection.getNative()[browser.ie9below ? "empty" : "removeAllRanges"]();singleClickState = 0;dragLine = me.document.getElementById("ue_tableDragLine");if (dragLine) {
          var dragTdPos = domUtils.getXY(dragTd),
              dragLinePos = domUtils.getXY(dragLine);switch (onDrag) {case "h":
              changeColWidth(dragTd, dragLinePos.x - dragTdPos.x);break;case "v":
              changeRowHeight(dragTd, dragLinePos.y - dragTdPos.y - dragTd.offsetHeight);break;default:}onDrag = "";dragTd = null;hideDragLine(me);me.fireEvent("saveScene");return;
        }
      }if (!startTd) {
        var target = domUtils.findParentByTagName(evt.target || evt.srcElement, "td", true);if (!target) {
          target = domUtils.findParentByTagName(evt.target || evt.srcElement, "th", true);
        }if (target && (target.tagName == "TD" || target.tagName == "TH")) {
          if (me.fireEvent("excludetable", target) === true) {
            return;
          }range = new dom.Range(me.document);range.setStart(target, 0).setCursor(false, true);
        }
      } else {
        var ut = getUETable(startTd),
            cell = ut ? ut.selectedTds[0] : null;if (cell) {
          range = new dom.Range(me.document);if (domUtils.isEmptyBlock(cell)) {
            range.setStart(cell, 0).setCursor(false, true);
          } else {
            range.selectNodeContents(cell).shrinkBoundary().setCursor(false, true);
          }
        } else {
          range = me.selection.getRange().shrinkBoundary();if (!range.collapsed) {
            var start = domUtils.findParentByTagName(range.startContainer, ["td", "th"], true),
                end = domUtils.findParentByTagName(range.endContainer, ["td", "th"], true);if (start && !end || !start && end || start && end && start !== end) {
              range.setCursor(false, true);
            }
          }
        }startTd = null;me.removeListener("mouseover", mouseOverEvent);
      }me._selectionChange(250, evt);
    }function mouseOverEvent(type, evt) {
      if (isEditorDisabled()) {
        return;
      }var me = this,
          tar = evt.target || evt.srcElement;currentTd = domUtils.findParentByTagName(tar, "td", true) || domUtils.findParentByTagName(tar, "th", true);if (startTd && currentTd && (startTd.tagName == "TD" && currentTd.tagName == "TD" || startTd.tagName == "TH" && currentTd.tagName == "TH") && domUtils.findParentByTagName(startTd, "table") == domUtils.findParentByTagName(currentTd, "table")) {
        var ut = getUETable(currentTd);if (startTd != currentTd) {
          me.document.body.style.webkitUserSelect = "none";me.selection.getNative()[browser.ie9below ? "empty" : "removeAllRanges"]();var range = ut.getCellsRange(startTd, currentTd);ut.setSelected(range);
        } else {
          me.document.body.style.webkitUserSelect = "";ut.clearSelected();
        }
      }evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
    }function setCellHeight(cell, height, backHeight) {
      var lineHight = parseInt(domUtils.getComputedStyle(cell, "line-height"), 10),
          tmpHeight = backHeight + height;height = tmpHeight < lineHight ? lineHight : tmpHeight;if (cell.style.height) {
        cell.style.height = "";
      }cell.rowSpan == 1 ? cell.setAttribute("height", height) : cell.removeAttribute && cell.removeAttribute("height");
    }function getWidth(cell) {
      if (!cell) {
        return 0;
      }return parseInt(domUtils.getComputedStyle(cell, "width"), 10);
    }function changeColWidth(cell, changeValue) {
      var ut = getUETable(cell);if (ut) {
        var table = ut.table,
            cells = getCellsByMoveBorder(cell, table);table.style.width = "";table.removeAttribute("width");changeValue = correctChangeValue(changeValue, cell, cells);if (cell.nextSibling) {
          var i = 0;utils.each(cells, function (cellGroup) {
            cellGroup.left.width = +cellGroup.left.width + changeValue;cellGroup.right && (cellGroup.right.width = +cellGroup.right.width - changeValue);
          });
        } else {
          utils.each(cells, function (cellGroup) {
            cellGroup.left.width -= -changeValue;
          });
        }
      }
    }function isEditorDisabled() {
      return me.body.contentEditable === "false";
    }function changeRowHeight(td, changeValue) {
      if (Math.abs(changeValue) < 10) {
        return;
      }var ut = getUETable(td);if (ut) {
        var cells = ut.getSameEndPosCells(td, "y"),
            backHeight = cells[0] ? cells[0].offsetHeight : 0;for (var i = 0, cell; cell = cells[i++];) {
          setCellHeight(cell, changeValue, backHeight);
        }
      }
    }function getCellsByMoveBorder(cell, table, isContainMergeCell) {
      if (!table) {
        table = domUtils.findParentByTagName(cell, "table");
      }if (!table) {
        return null;
      }var index = domUtils.getNodeIndex(cell),
          temp = cell,
          rows = table.rows,
          colIndex = 0;while (temp) {
        if (temp.nodeType === 1) {
          colIndex += temp.colSpan || 1;
        }temp = temp.previousSibling;
      }temp = null;var borderCells = [];utils.each(rows, function (tabRow) {
        var cells = tabRow.cells,
            currIndex = 0;utils.each(cells, function (tabCell) {
          currIndex += tabCell.colSpan || 1;if (currIndex === colIndex) {
            borderCells.push({ left: tabCell, right: tabCell.nextSibling || null });return false;
          } else {
            if (currIndex > colIndex) {
              if (isContainMergeCell) {
                borderCells.push({ left: tabCell });
              }return false;
            }
          }
        });
      });return borderCells;
    }function getMinWidthByTableCells(cells) {
      var minWidth = Number.MAX_VALUE;for (var i = 0, curCell; curCell = cells[i]; i++) {
        minWidth = Math.min(minWidth, curCell.width || getTableCellWidth(curCell));
      }return minWidth;
    }function correctChangeValue(changeValue, relatedCell, cells) {
      changeValue -= getTabcellSpace();if (changeValue < 0) {
        return 0;
      }changeValue -= getTableCellWidth(relatedCell);var direction = changeValue < 0 ? "left" : "right";changeValue = Math.abs(changeValue);utils.each(cells, function (cellGroup) {
        var curCell = cellGroup[direction];if (curCell) {
          changeValue = Math.min(changeValue, getTableCellWidth(curCell) - cellMinWidth);
        }
      });changeValue = changeValue < 0 ? 0 : changeValue;return direction === "left" ? -changeValue : changeValue;
    }function getTableCellWidth(cell) {
      var width = 0,
          offset = 0,
          width = cell.offsetWidth - getTabcellSpace();if (!cell.nextSibling) {
        width -= getTableCellOffset(cell);
      }width = width < 0 ? 0 : width;try {
        cell.width = width;
      } catch (e) {}return width;
    }function getTableCellOffset(cell) {
      tab = domUtils.findParentByTagName(cell, "table", false);if (tab.offsetVal === undefined) {
        var prev = cell.previousSibling;if (prev) {
          tab.offsetVal = cell.offsetWidth - prev.offsetWidth === UT.borderWidth ? UT.borderWidth : 0;
        } else {
          tab.offsetVal = 0;
        }
      }return tab.offsetVal;
    }function getTabcellSpace() {
      if (UT.tabcellSpace === undefined) {
        var cell = null,
            tab = me.document.createElement("table"),
            tbody = me.document.createElement("tbody"),
            trow = me.document.createElement("tr"),
            tabcell = me.document.createElement("td"),
            mirror = null;tabcell.style.cssText = "border: 0;";tabcell.width = 1;trow.appendChild(tabcell);trow.appendChild(mirror = tabcell.cloneNode(false));tbody.appendChild(trow);tab.appendChild(tbody);tab.style.cssText = "visibility: hidden;";me.body.appendChild(tab);UT.paddingSpace = tabcell.offsetWidth - 1;var tmpTabWidth = tab.offsetWidth;tabcell.style.cssText = "";mirror.style.cssText = "";UT.borderWidth = (tab.offsetWidth - tmpTabWidth) / 3;UT.tabcellSpace = UT.paddingSpace + UT.borderWidth;me.body.removeChild(tab);
      }getTabcellSpace = function getTabcellSpace() {
        return UT.tabcellSpace;
      };return UT.tabcellSpace;
    }function getDragLine(editor, doc) {
      if (mousedown) {
        return;
      }dragLine = editor.document.createElement("div");domUtils.setAttributes(dragLine, { id: "ue_tableDragLine", unselectable: "on", contenteditable: false, "onresizestart": "return false", "ondragstart": "return false", "onselectstart": "return false", style: "background-color:blue;position:absolute;padding:0;margin:0;background-image:none;border:0px none;opacity:0;filter:alpha(opacity=0)" });editor.body.appendChild(dragLine);
    }function hideDragLine(editor) {
      if (mousedown) {
        return;
      }var line;while (line = editor.document.getElementById("ue_tableDragLine")) {
        domUtils.remove(line);
      }
    }function showDragLineAt(state, cell) {
      if (!cell) {
        return;
      }var table = domUtils.findParentByTagName(cell, "table"),
          caption = table.getElementsByTagName("caption"),
          width = table.offsetWidth,
          height = table.offsetHeight - (caption.length > 0 ? caption[0].offsetHeight : 0),
          tablePos = domUtils.getXY(table),
          cellPos = domUtils.getXY(cell),
          css;switch (state) {case "h":
          css = "height:" + height + "px;top:" + (tablePos.y + (caption.length > 0 ? caption[0].offsetHeight : 0)) + "px;left:" + (cellPos.x + cell.offsetWidth);dragLine.style.cssText = css + "px;position: absolute;display:block;background-color:blue;width:1px;border:0; color:blue;opacity:.3;filter:alpha(opacity=30)";break;case "v":
          css = "width:" + width + "px;left:" + tablePos.x + "px;top:" + (cellPos.y + cell.offsetHeight);dragLine.style.cssText = css + "px;overflow:hidden;position: absolute;display:block;background-color:blue;height:1px;border:0;color:blue;opacity:.2;filter:alpha(opacity=20)";break;default:}
    }function switchBorderColor(editor, flag) {
      var tableArr = domUtils.getElementsByTagName(editor.body, "table"),
          color;for (var i = 0, node; node = tableArr[i++];) {
        var td = domUtils.getElementsByTagName(node, "td");if (td[0]) {
          if (flag) {
            color = td[0].style.borderColor.replace(/\s/g, "");if (/(#ffffff)|(rgb\(255,255,255\))/ig.test(color)) {
              domUtils.addClass(node, "noBorderTable");
            }
          } else {
            domUtils.removeClasses(node, "noBorderTable");
          }
        }
      }
    }function getTableWidth(editor, needIEHack, defaultValue) {
      var body = editor.body;return body.offsetWidth - (needIEHack ? parseInt(domUtils.getComputedStyle(body, "margin-left"), 10) * 2 : 0) - defaultValue.tableBorder * 2 - (editor.options.offsetWidth || 0);
    }function getTargetTd(editor, evt) {
      var target = domUtils.findParentByTagName(evt.target || evt.srcElement, ["td", "th"], true),
          dir = null;if (!target) {
        return null;
      }dir = getRelation(target, mouseCoords(evt));if (!target) {
        return null;
      }if (dir === "h1" && target.previousSibling) {
        var position = domUtils.getXY(target),
            cellWidth = target.offsetWidth;if (Math.abs(position.x + cellWidth - evt.clientX) > cellWidth / 3) {
          target = target.previousSibling;
        }
      } else {
        if (dir === "v1" && target.parentNode.previousSibling) {
          var position = domUtils.getXY(target),
              cellHeight = target.offsetHeight;if (Math.abs(position.y + cellHeight - evt.clientY) > cellHeight / 3) {
            target = target.parentNode.previousSibling.firstChild;
          }
        }
      }return target && !(editor.fireEvent("excludetable", target) === true) ? target : null;
    }
  };UE.UETable.prototype.sortTable = function (sortByCellIndex, compareFn) {
    var table = this.table,
        rows = table.rows,
        trArray = [],
        flag = rows[0].cells[0].tagName === "TH",
        lastRowIndex = 0;if (this.selectedTds.length) {
      var range = this.cellsRange,
          len = range.endRowIndex + 1;for (var i = range.beginRowIndex; i < len; i++) {
        trArray[i] = rows[i];
      }trArray.splice(0, range.beginRowIndex);lastRowIndex = range.endRowIndex + 1 === this.rowsNum ? 0 : range.endRowIndex + 1;
    } else {
      for (var i = 0, len = rows.length; i < len; i++) {
        trArray[i] = rows[i];
      }
    }var Fn = { "reversecurrent": function reversecurrent(td1, td2) {
        return 1;
      }, "orderbyasc": function orderbyasc(td1, td2) {
        var value1 = td1.innerText || td1.textContent,
            value2 = td2.innerText || td2.textContent;return value1.localeCompare(value2);
      }, "reversebyasc": function reversebyasc(td1, td2) {
        var value1 = td1.innerHTML,
            value2 = td2.innerHTML;return value2.localeCompare(value1);
      }, "orderbynum": function orderbynum(td1, td2) {
        var value1 = td1[browser.ie ? "innerText" : "textContent"].match(/\d+/),
            value2 = td2[browser.ie ? "innerText" : "textContent"].match(/\d+/);if (value1) {
          value1 = +value1[0];
        }if (value2) {
          value2 = +value2[0];
        }return (value1 || 0) - (value2 || 0);
      }, "reversebynum": function reversebynum(td1, td2) {
        var value1 = td1[browser.ie ? "innerText" : "textContent"].match(/\d+/),
            value2 = td2[browser.ie ? "innerText" : "textContent"].match(/\d+/);if (value1) {
          value1 = +value1[0];
        }if (value2) {
          value2 = +value2[0];
        }return (value2 || 0) - (value1 || 0);
      } };table.setAttribute("data-sort-type", compareFn && typeof compareFn === "string" && Fn[compareFn] ? compareFn : "");flag && trArray.splice(0, 1);trArray = utils.sort(trArray, function (tr1, tr2) {
      var result;if (compareFn && typeof compareFn === "function") {
        result = compareFn.call(this, tr1.cells[sortByCellIndex], tr2.cells[sortByCellIndex]);
      } else {
        if (compareFn && typeof compareFn === "number") {
          result = 1;
        } else {
          if (compareFn && typeof compareFn === "string" && Fn[compareFn]) {
            result = Fn[compareFn].call(this, tr1.cells[sortByCellIndex], tr2.cells[sortByCellIndex]);
          } else {
            result = Fn["orderbyasc"].call(this, tr1.cells[sortByCellIndex], tr2.cells[sortByCellIndex]);
          }
        }
      }return result;
    });var fragment = table.ownerDocument.createDocumentFragment();for (var j = 0, len = trArray.length; j < len; j++) {
      fragment.appendChild(trArray[j]);
    }var tbody = table.getElementsByTagName("tbody")[0];if (!lastRowIndex) {
      tbody.appendChild(fragment);
    } else {
      tbody.insertBefore(fragment, rows[lastRowIndex - range.endRowIndex + range.beginRowIndex - 1]);
    }
  };UE.plugins["tablesort"] = function () {
    var me = this,
        UT = UE.UETable,
        getUETable = function getUETable(tdOrTable) {
      return UT.getUETable(tdOrTable);
    },
        getTableItemsByRange = function getTableItemsByRange(editor) {
      return UT.getTableItemsByRange(editor);
    };me.ready(function () {
      utils.cssRule("tablesort", "table.sortEnabled tr.firstRow th,table.sortEnabled tr.firstRow td{padding-right:20px;background-repeat: no-repeat;background-position: center right;" + "   background-image:url(" + me.options.themePath + me.options.theme + "/images/sortable.png);}", me.document);me.addListener("afterexeccommand", function (type, cmd) {
        if (cmd == "mergeright" || cmd == "mergedown" || cmd == "mergecells") {
          this.execCommand("disablesort");
        }
      });
    });UE.commands["sorttable"] = { queryCommandState: function queryCommandState() {
        var me = this,
            tableItems = getTableItemsByRange(me);if (!tableItems.cell) {
          return -1;
        }var table = tableItems.table,
            cells = table.getElementsByTagName("td");for (var i = 0, cell; cell = cells[i++];) {
          if (cell.rowSpan != 1 || cell.colSpan != 1) {
            return -1;
          }
        }return 0;
      }, execCommand: function execCommand(cmd, fn) {
        var me = this,
            range = me.selection.getRange(),
            bk = range.createBookmark(true),
            tableItems = getTableItemsByRange(me),
            cell = tableItems.cell,
            ut = getUETable(tableItems.table),
            cellInfo = ut.getCellInfo(cell);ut.sortTable(cellInfo.cellIndex, fn);range.moveToBookmark(bk);try {
          range.select();
        } catch (e) {}
      } };UE.commands["enablesort"] = UE.commands["disablesort"] = { queryCommandState: function queryCommandState(cmd) {
        var table = getTableItemsByRange(this).table;if (table && cmd == "enablesort") {
          var cells = domUtils.getElementsByTagName(table, "th td");for (var i = 0; i < cells.length; i++) {
            if (cells[i].getAttribute("colspan") > 1 || cells[i].getAttribute("rowspan") > 1) {
              return -1;
            }
          }
        }return !table ? -1 : cmd == "enablesort" ^ table.getAttribute("data-sort") != "sortEnabled" ? -1 : 0;
      }, execCommand: function execCommand(cmd) {
        var table = getTableItemsByRange(this).table;table.setAttribute("data-sort", cmd == "enablesort" ? "sortEnabled" : "sortDisabled");cmd == "enablesort" ? domUtils.addClass(table, "sortEnabled") : domUtils.removeClasses(table, "sortEnabled");
      } };
  };UE.plugins["contextmenu"] = function () {
    var me = this;me.setOpt("enableContextMenu", true);if (me.getOpt("enableContextMenu") === false) {
      return;
    }var lang = me.getLang("contextMenu"),
        menu,
        items = me.options.contextMenu || [{ label: lang["selectall"], cmdName: "selectall" }, { label: lang.cleardoc, cmdName: "cleardoc", exec: function exec() {
        if (confirm(lang.confirmclear)) {
          this.execCommand("cleardoc");
        }
      } }, "-", { label: lang.unlink, cmdName: "unlink" }, "-", { group: lang.paragraph, icon: "justifyjustify", subMenu: [{ label: lang.justifyleft, cmdName: "justify", value: "left" }, { label: lang.justifyright, cmdName: "justify", value: "right" }, { label: lang.justifycenter, cmdName: "justify", value: "center" }, { label: lang.justifyjustify, cmdName: "justify", value: "justify" }] }, "-", { group: lang.table, icon: "table", subMenu: [{ label: lang.inserttable, cmdName: "inserttable" }, { label: lang.deletetable, cmdName: "deletetable" }, "-", { label: lang.deleterow, cmdName: "deleterow" }, { label: lang.deletecol, cmdName: "deletecol" }, { label: lang.insertcol, cmdName: "insertcol" }, { label: lang.insertcolnext, cmdName: "insertcolnext" }, { label: lang.insertrow, cmdName: "insertrow" }, { label: lang.insertrownext, cmdName: "insertrownext" }, "-", { label: lang.insertcaption, cmdName: "insertcaption" }, { label: lang.deletecaption, cmdName: "deletecaption" }, { label: lang.inserttitle, cmdName: "inserttitle" }, { label: lang.deletetitle, cmdName: "deletetitle" }, { label: lang.inserttitlecol, cmdName: "inserttitlecol" }, { label: lang.deletetitlecol, cmdName: "deletetitlecol" }, "-", { label: lang.mergecells, cmdName: "mergecells" }, { label: lang.mergeright, cmdName: "mergeright" }, { label: lang.mergedown, cmdName: "mergedown" }, "-", { label: lang.splittorows, cmdName: "splittorows" }, { label: lang.splittocols, cmdName: "splittocols" }, { label: lang.splittocells, cmdName: "splittocells" }, "-", { label: lang.averageDiseRow, cmdName: "averagedistributerow" }, { label: lang.averageDisCol, cmdName: "averagedistributecol" }, "-", { label: lang.edittd, cmdName: "edittd", exec: function exec() {
          if (UE.ui["edittd"]) {
            new UE.ui["edittd"](this);
          }this.getDialog("edittd").open();
        } }, { label: lang.edittable, cmdName: "edittable", exec: function exec() {
          if (UE.ui["edittable"]) {
            new UE.ui["edittable"](this);
          }this.getDialog("edittable").open();
        } }, { label: lang.setbordervisible, cmdName: "setbordervisible" }] }, { group: lang.tablesort, icon: "tablesort", subMenu: [{ label: lang.enablesort, cmdName: "enablesort" }, { label: lang.disablesort, cmdName: "disablesort" }, "-", { label: lang.reversecurrent, cmdName: "sorttable", value: "reversecurrent" }, { label: lang.orderbyasc, cmdName: "sorttable", value: "orderbyasc" }, { label: lang.reversebyasc, cmdName: "sorttable", value: "reversebyasc" }, { label: lang.orderbynum, cmdName: "sorttable", value: "orderbynum" }, { label: lang.reversebynum, cmdName: "sorttable", value: "reversebynum" }] }, { group: lang.borderbk, icon: "borderBack", subMenu: [{ label: lang.setcolor, cmdName: "interlacetable", exec: function exec() {
          this.execCommand("interlacetable");
        } }, { label: lang.unsetcolor, cmdName: "uninterlacetable", exec: function exec() {
          this.execCommand("uninterlacetable");
        } }, { label: lang.setbackground, cmdName: "settablebackground", exec: function exec() {
          this.execCommand("settablebackground", { repeat: true, colorList: ["#bbb", "#ccc"] });
        } }, { label: lang.unsetbackground, cmdName: "cleartablebackground", exec: function exec() {
          this.execCommand("cleartablebackground");
        } }, { label: lang.redandblue, cmdName: "settablebackground", exec: function exec() {
          this.execCommand("settablebackground", { repeat: true, colorList: ["red", "blue"] });
        } }, { label: lang.threecolorgradient, cmdName: "settablebackground", exec: function exec() {
          this.execCommand("settablebackground", { repeat: true, colorList: ["#aaa", "#bbb", "#ccc"] });
        } }] }, { group: lang.aligntd, icon: "aligntd", subMenu: [{ cmdName: "cellalignment", value: { align: "left", vAlign: "top" } }, { cmdName: "cellalignment", value: { align: "center", vAlign: "top" } }, { cmdName: "cellalignment", value: { align: "right", vAlign: "top" } }, { cmdName: "cellalignment", value: { align: "left", vAlign: "middle" } }, { cmdName: "cellalignment", value: { align: "center", vAlign: "middle" } }, { cmdName: "cellalignment", value: { align: "right", vAlign: "middle" } }, { cmdName: "cellalignment", value: { align: "left", vAlign: "bottom" } }, { cmdName: "cellalignment", value: { align: "center", vAlign: "bottom" } }, { cmdName: "cellalignment", value: { align: "right", vAlign: "bottom" } }] }, { group: lang.aligntable, icon: "aligntable", subMenu: [{ cmdName: "tablealignment", className: "left", label: lang.tableleft, value: "left" }, { cmdName: "tablealignment", className: "center", label: lang.tablecenter, value: "center" }, { cmdName: "tablealignment", className: "right", label: lang.tableright, value: "right" }] }, "-", { label: lang.insertparagraphbefore, cmdName: "insertparagraph", value: true }, { label: lang.insertparagraphafter, cmdName: "insertparagraph" }, { label: lang["copy"], cmdName: "copy" }, { label: lang["paste"], cmdName: "paste" }];if (!items.length) {
      return;
    }var uiUtils = UE.ui.uiUtils;me.addListener("contextmenu", function (type, evt) {
      var offset = uiUtils.getViewportOffsetByEvent(evt);me.fireEvent("beforeselectionchange");if (menu) {
        menu.destroy();
      }for (var i = 0, ti, contextItems = []; ti = items[i]; i++) {
        var last;(function (item) {
          if (item == "-") {
            if ((last = contextItems[contextItems.length - 1]) && last !== "-") {
              contextItems.push("-");
            }
          } else {
            if (item.hasOwnProperty("group")) {
              for (var j = 0, cj, subMenu = []; cj = item.subMenu[j]; j++) {
                (function (subItem) {
                  if (subItem == "-") {
                    if ((last = subMenu[subMenu.length - 1]) && last !== "-") {
                      subMenu.push("-");
                    } else {
                      subMenu.splice(subMenu.length - 1);
                    }
                  } else {
                    if ((me.commands[subItem.cmdName] || UE.commands[subItem.cmdName] || subItem.query) && (subItem.query ? subItem.query() : me.queryCommandState(subItem.cmdName)) > -1) {
                      subMenu.push({ "label": subItem.label || me.getLang("contextMenu." + subItem.cmdName + (subItem.value || "")) || "", "className": "edui-for-" + subItem.cmdName + (subItem.className ? " edui-for-" + subItem.cmdName + "-" + subItem.className : ""), onclick: subItem.exec ? function () {
                          subItem.exec.call(me);
                        } : function () {
                          me.execCommand(subItem.cmdName, subItem.value);
                        } });
                    }
                  }
                })(cj);
              }if (subMenu.length) {
                var getLabel = function getLabel() {
                  switch (item.icon) {case "table":
                      return me.getLang("contextMenu.table");case "justifyjustify":
                      return me.getLang("contextMenu.paragraph");case "aligntd":
                      return me.getLang("contextMenu.aligntd");case "aligntable":
                      return me.getLang("contextMenu.aligntable");case "tablesort":
                      return lang.tablesort;case "borderBack":
                      return lang.borderbk;default:
                      return "";}
                };

                contextItems.push({ "label": getLabel(), className: "edui-for-" + item.icon, "subMenu": { items: subMenu, editor: me } });
              }
            } else {
              if ((me.commands[item.cmdName] || UE.commands[item.cmdName] || item.query) && (item.query ? item.query.call(me) : me.queryCommandState(item.cmdName)) > -1) {
                contextItems.push({ "label": item.label || me.getLang("contextMenu." + item.cmdName), className: "edui-for-" + (item.icon ? item.icon : item.cmdName + (item.value || "")), onclick: item.exec ? function () {
                    item.exec.call(me);
                  } : function () {
                    me.execCommand(item.cmdName, item.value);
                  } });
              }
            }
          }
        })(ti);
      }if (contextItems[contextItems.length - 1] == "-") {
        contextItems.pop();
      }menu = new UE.ui.Menu({ items: contextItems, className: "edui-contextmenu", editor: me });menu.render();menu.showAt(offset);me.fireEvent("aftershowcontextmenu", menu);domUtils.preventDefault(evt);if (browser.ie) {
        var ieRange;try {
          ieRange = me.selection.getNative().createRange();
        } catch (e) {
          return;
        }if (ieRange.item) {
          var range = new dom.Range(me.document);range.selectNode(ieRange.item(0)).select(true, true);
        }
      }
    });me.addListener("aftershowcontextmenu", function (type, menu) {
      if (me.zeroclipboard) {
        var items = menu.items;for (var key in items) {
          if (items[key].className == "edui-for-copy") {
            me.zeroclipboard.clip(items[key].getDom());
          }
        }
      }
    });
  };UE.plugins["shortcutmenu"] = function () {
    var me = this,
        menu,
        items = me.options.shortcutMenu || [];if (!items.length) {
      return;
    }me.addListener("contextmenu mouseup", function (type, e) {
      var me = this,
          customEvt = { type: type, target: e.target || e.srcElement, screenX: e.screenX, screenY: e.screenY, clientX: e.clientX, clientY: e.clientY };setTimeout(function () {
        var rng = me.selection.getRange();if (rng.collapsed === false || type == "contextmenu") {
          if (!menu) {
            menu = new baidu.editor.ui.ShortCutMenu({ editor: me, items: items, theme: me.options.theme, className: "edui-shortcutmenu" });menu.render();me.fireEvent("afterrendershortcutmenu", menu);
          }menu.show(customEvt, !!UE.plugins["contextmenu"]);
        }
      });if (type == "contextmenu") {
        domUtils.preventDefault(e);if (browser.ie9below) {
          var ieRange;try {
            ieRange = me.selection.getNative().createRange();
          } catch (e) {
            return;
          }if (ieRange.item) {
            var range = new dom.Range(me.document);range.selectNode(ieRange.item(0)).select(true, true);
          }
        }
      }
    });me.addListener("keydown", function (type) {
      if (type == "keydown") {
        menu && !menu.isHidden && menu.hide();
      }
    });
  };UE.plugins["basestyle"] = function () {
    var basestyles = { "bold": ["strong", "b"], "italic": ["em", "i"], "subscript": ["sub"], "superscript": ["sup"] },
        getObj = function getObj(editor, tagNames) {
      return domUtils.filterNodeList(editor.selection.getStartElementPath(), tagNames);
    },
        me = this;me.addshortcutkey({ "Bold": "ctrl+66", "Italic": "ctrl+73", "Underline": "ctrl+85" });me.addInputRule(function (root) {
      utils.each(root.getNodesByTagName("b i"), function (node) {
        switch (node.tagName) {case "b":
            node.tagName = "strong";break;case "i":
            node.tagName = "em";}
      });
    });for (var style in basestyles) {
      (function (cmd, tagNames) {
        me.commands[cmd] = { execCommand: function execCommand(cmdName) {
            var range = me.selection.getRange(),
                obj = getObj(this, tagNames);if (range.collapsed) {
              if (obj) {
                var tmpText = me.document.createTextNode("");range.insertNode(tmpText).removeInlineStyle(tagNames);range.setStartBefore(tmpText);domUtils.remove(tmpText);
              } else {
                var tmpNode = range.document.createElement(tagNames[0]);if (cmdName == "superscript" || cmdName == "subscript") {
                  tmpText = me.document.createTextNode("");range.insertNode(tmpText).removeInlineStyle(["sub", "sup"]).setStartBefore(tmpText).collapse(true);
                }range.insertNode(tmpNode).setStart(tmpNode, 0);
              }range.collapse(true);
            } else {
              if (cmdName == "superscript" || cmdName == "subscript") {
                if (!obj || obj.tagName.toLowerCase() != cmdName) {
                  range.removeInlineStyle(["sub", "sup"]);
                }
              }obj ? range.removeInlineStyle(tagNames) : range.applyInlineStyle(tagNames[0]);
            }range.select();
          }, queryCommandState: function queryCommandState() {
            return getObj(this, tagNames) ? 1 : 0;
          } };
      })(style, basestyles[style]);
    }
  };UE.plugins["elementpath"] = function () {
    var currentLevel,
        tagNames,
        me = this;me.setOpt("elementPathEnabled", true);if (!me.options.elementPathEnabled) {
      return;
    }me.commands["elementpath"] = { execCommand: function execCommand(cmdName, level) {
        var start = tagNames[level],
            range = me.selection.getRange();currentLevel = level * 1;range.selectNode(start).select();
      }, queryCommandValue: function queryCommandValue() {
        var parents = [].concat(this.selection.getStartElementPath()).reverse(),
            names = [];tagNames = parents;for (var i = 0, ci; ci = parents[i]; i++) {
          if (ci.nodeType == 3) {
            continue;
          }var name = ci.tagName.toLowerCase();if (name == "img" && ci.getAttribute("anchorname")) {
            name = "anchor";
          }names[i] = name;if (currentLevel == i) {
            currentLevel = -1;break;
          }
        }return names;
      } };
  };UE.plugins["formatmatch"] = function () {
    var me = this,
        list = [],
        img,
        flag = 0;me.addListener("reset", function () {
      list = [];flag = 0;
    });function addList(type, evt) {
      if (browser.webkit) {
        var target = evt.target.tagName == "IMG" ? evt.target : null;
      }function addFormat(range) {
        if (text) {
          range.selectNode(text);
        }return range.applyInlineStyle(list[list.length - 1].tagName, null, list);
      }me.undoManger && me.undoManger.save();var range = me.selection.getRange(),
          imgT = target || range.getClosedNode();if (img && imgT && imgT.tagName == "IMG") {
        imgT.style.cssText += ";float:" + (img.style.cssFloat || img.style.styleFloat || "none") + ";display:" + (img.style.display || "inline");img = null;
      } else {
        if (!img) {
          var collapsed = range.collapsed;if (collapsed) {
            var text = me.document.createTextNode("match");range.insertNode(text).select();
          }me.__hasEnterExecCommand = true;var removeFormatAttributes = me.options.removeFormatAttributes;me.options.removeFormatAttributes = "";me.execCommand("removeformat");me.options.removeFormatAttributes = removeFormatAttributes;me.__hasEnterExecCommand = false;range = me.selection.getRange();if (list.length) {
            addFormat(range);
          }if (text) {
            range.setStartBefore(text).collapse(true);
          }range.select();text && domUtils.remove(text);
        }
      }me.undoManger && me.undoManger.save();me.removeListener("mouseup", addList);flag = 0;
    }me.commands["formatmatch"] = { execCommand: function execCommand(cmdName) {
        if (flag) {
          flag = 0;list = [];me.removeListener("mouseup", addList);return;
        }var range = me.selection.getRange();img = range.getClosedNode();if (!img || img.tagName != "IMG") {
          range.collapse(true).shrinkBoundary();var start = range.startContainer;list = domUtils.findParents(start, true, function (node) {
            return !domUtils.isBlockElm(node) && node.nodeType == 1;
          });for (var i = 0, ci; ci = list[i]; i++) {
            if (ci.tagName == "A") {
              list.splice(i, 1);break;
            }
          }
        }me.addListener("mouseup", addList);flag = 1;
      }, queryCommandState: function queryCommandState() {
        return flag;
      }, notNeedUndo: 1 };
  };UE.plugin.register("searchreplace", function () {
    var me = this;var _blockElm = { "table": 1, "tbody": 1, "tr": 1, "ol": 1, "ul": 1 };function findTextInString(textContent, opt, currentIndex) {
      var str = opt.searchStr;if (opt.dir == -1) {
        textContent = textContent.split("").reverse().join("");str = str.split("").reverse().join("");currentIndex = textContent.length - currentIndex;
      }var reg = new RegExp(str, "g" + (opt.casesensitive ? "" : "i")),
          match;while (match = reg.exec(textContent)) {
        if (match.index >= currentIndex) {
          return opt.dir == -1 ? textContent.length - match.index - opt.searchStr.length : match.index;
        }
      }return -1;
    }function findTextBlockElm(node, currentIndex, opt) {
      var textContent,
          index,
          methodName = opt.all || opt.dir == 1 ? "getNextDomNode" : "getPreDomNode";if (domUtils.isBody(node)) {
        node = node.firstChild;
      }var first = 1;while (node) {
        textContent = node.nodeType == 3 ? node.nodeValue : node[browser.ie ? "innerText" : "textContent"];index = findTextInString(textContent, opt, currentIndex);first = 0;if (index != -1) {
          return { "node": node, "index": index };
        }node = domUtils[methodName](node);while (node && _blockElm[node.nodeName.toLowerCase()]) {
          node = domUtils[methodName](node, true);
        }if (node) {
          currentIndex = opt.dir == -1 ? (node.nodeType == 3 ? node.nodeValue : node[browser.ie ? "innerText" : "textContent"]).length : 0;
        }
      }
    }function findNTextInBlockElm(node, index, str) {
      var currentIndex = 0,
          currentNode = node.firstChild,
          currentNodeLength = 0,
          result;while (currentNode) {
        if (currentNode.nodeType == 3) {
          currentNodeLength = currentNode.nodeValue.replace(/(^[\t\r\n]+)|([\t\r\n]+$)/, "").length;currentIndex += currentNodeLength;if (currentIndex >= index) {
            return { "node": currentNode, "index": currentNodeLength - (currentIndex - index) };
          }
        } else {
          if (!dtd.$empty[currentNode.tagName]) {
            currentNodeLength = currentNode[browser.ie ? "innerText" : "textContent"].replace(/(^[\t\r\n]+)|([\t\r\n]+$)/, "").length;currentIndex += currentNodeLength;if (currentIndex >= index) {
              result = findNTextInBlockElm(currentNode, currentNodeLength - (currentIndex - index), str);if (result) {
                return result;
              }
            }
          }
        }currentNode = domUtils.getNextDomNode(currentNode);
      }
    }function searchReplace(me, opt) {
      var rng = me.selection.getRange(),
          startBlockNode,
          searchStr = opt.searchStr,
          span = me.document.createElement("span");span.innerHTML = "$$ueditor_searchreplace_key$$";rng.shrinkBoundary(true);if (!rng.collapsed) {
        rng.select();var rngText = me.selection.getText();if (new RegExp("^" + opt.searchStr + "$", opt.casesensitive ? "" : "i").test(rngText)) {
          if (opt.replaceStr != undefined) {
            replaceText(rng, opt.replaceStr);rng.select();return true;
          } else {
            rng.collapse(opt.dir == -1);
          }
        }
      }rng.insertNode(span);rng.enlargeToBlockElm(true);startBlockNode = rng.startContainer;var currentIndex = startBlockNode[browser.ie ? "innerText" : "textContent"].indexOf("$$ueditor_searchreplace_key$$");rng.setStartBefore(span);domUtils.remove(span);var result = findTextBlockElm(startBlockNode, currentIndex, opt);if (result) {
        var rngStart = findNTextInBlockElm(result.node, result.index, searchStr);var rngEnd = findNTextInBlockElm(result.node, result.index + searchStr.length, searchStr);rng.setStart(rngStart.node, rngStart.index).setEnd(rngEnd.node, rngEnd.index);if (opt.replaceStr !== undefined) {
          replaceText(rng, opt.replaceStr);
        }rng.select();return true;
      } else {
        rng.setCursor();
      }
    }function replaceText(rng, str) {
      str = me.document.createTextNode(str);rng.deleteContents().insertNode(str);
    }return { commands: { "searchreplace": { execCommand: function execCommand(cmdName, opt) {
            utils.extend(opt, { all: false, casesensitive: false, dir: 1 }, true);var num = 0;if (opt.all) {
              var rng = me.selection.getRange(),
                  first = me.body.firstChild;if (first && first.nodeType == 1) {
                rng.setStart(first, 0);rng.shrinkBoundary(true);
              } else {
                if (first.nodeType == 3) {
                  rng.setStartBefore(first);
                }
              }rng.collapse(true).select(true);if (opt.replaceStr !== undefined) {
                me.fireEvent("saveScene");
              }while (searchReplace(this, opt)) {
                num++;
              }if (num) {
                me.fireEvent("saveScene");
              }
            } else {
              if (opt.replaceStr !== undefined) {
                me.fireEvent("saveScene");
              }if (searchReplace(this, opt)) {
                num++;
              }if (num) {
                me.fireEvent("saveScene");
              }
            }return num;
          }, notNeedUndo: 1 } } };
  });UE.plugins["customstyle"] = function () {
    var me = this;me.setOpt({ "customstyle": [{ tag: "h1", name: "tc", style: "font-size:32px;font-weight:bold;border-bottom:#ccc 2px solid;padding:0 4px 0 0;text-align:center;margin:0 0 20px 0;" }, { tag: "h1", name: "tl", style: "font-size:32px;font-weight:bold;border-bottom:#ccc 2px solid;padding:0 4px 0 0;text-align:left;margin:0 0 10px 0;" }, { tag: "span", name: "im", style: "font-size:16px;font-style:italic;font-weight:bold;line-height:18px;" }, { tag: "span", name: "hi", style: "font-size:16px;font-style:italic;font-weight:bold;color:rgb(51, 153, 204);line-height:18px;" }] });me.commands["customstyle"] = { execCommand: function execCommand(cmdName, obj) {
        var me = this,
            tagName = obj.tag,
            node = domUtils.findParent(me.selection.getStart(), function (node) {
          return node.getAttribute("label");
        }, true),
            range,
            bk,
            tmpObj = {};for (var p in obj) {
          if (obj[p] !== undefined) {
            tmpObj[p] = obj[p];
          }
        }delete tmpObj.tag;if (node && node.getAttribute("label") == obj.label) {
          range = this.selection.getRange();bk = range.createBookmark();if (range.collapsed) {
            if (dtd.$block[node.tagName]) {
              var fillNode = me.document.createElement("p");domUtils.moveChild(node, fillNode);node.parentNode.insertBefore(fillNode, node);domUtils.remove(node);
            } else {
              domUtils.remove(node, true);
            }
          } else {
            var common = domUtils.getCommonAncestor(bk.start, bk.end),
                nodes = domUtils.getElementsByTagName(common, tagName);if (new RegExp(tagName, "i").test(common.tagName)) {
              nodes.push(common);
            }for (var i = 0, ni; ni = nodes[i++];) {
              if (ni.getAttribute("label") == obj.label) {
                var ps = domUtils.getPosition(ni, bk.start),
                    pe = domUtils.getPosition(ni, bk.end);if ((ps & domUtils.POSITION_FOLLOWING || ps & domUtils.POSITION_CONTAINS) && (pe & domUtils.POSITION_PRECEDING || pe & domUtils.POSITION_CONTAINS)) {
                  if (dtd.$block[tagName]) {
                    var fillNode = me.document.createElement("p");domUtils.moveChild(ni, fillNode);ni.parentNode.insertBefore(fillNode, ni);
                  }
                }domUtils.remove(ni, true);
              }
            }node = domUtils.findParent(common, function (node) {
              return node.getAttribute("label") == obj.label;
            }, true);if (node) {
              domUtils.remove(node, true);
            }
          }range.moveToBookmark(bk).select();
        } else {
          if (dtd.$block[tagName]) {
            this.execCommand("paragraph", tagName, tmpObj, "customstyle");range = me.selection.getRange();if (!range.collapsed) {
              range.collapse();node = domUtils.findParent(me.selection.getStart(), function (node) {
                return node.getAttribute("label") == obj.label;
              }, true);var pNode = me.document.createElement("p");domUtils.insertAfter(node, pNode);domUtils.fillNode(me.document, pNode);range.setStart(pNode, 0).setCursor();
            }
          } else {
            range = me.selection.getRange();if (range.collapsed) {
              node = me.document.createElement(tagName);domUtils.setAttributes(node, tmpObj);range.insertNode(node).setStart(node, 0).setCursor();return;
            }bk = range.createBookmark();range.applyInlineStyle(tagName, tmpObj).moveToBookmark(bk).select();
          }
        }
      }, queryCommandValue: function queryCommandValue() {
        var parent = domUtils.filterNodeList(this.selection.getStartElementPath(), function (node) {
          return node.getAttribute("label");
        });return parent ? parent.getAttribute("label") : "";
      } };me.addListener("keyup", function (type, evt) {
      var keyCode = evt.keyCode || evt.which;if (keyCode == 32 || keyCode == 13) {
        var range = me.selection.getRange();if (range.collapsed) {
          var node = domUtils.findParent(me.selection.getStart(), function (node) {
            return node.getAttribute("label");
          }, true);if (node && dtd.$block[node.tagName] && domUtils.isEmptyNode(node)) {
            var p = me.document.createElement("p");domUtils.insertAfter(node, p);domUtils.fillNode(me.document, p);domUtils.remove(node);range.setStart(p, 0).setCursor();
          }
        }
      }
    });
  };UE.plugins["catchremoteimage"] = function () {
    var me = this,
        ajax = UE.ajax;if (me.options.catchRemoteImageEnable === false) {
      return;
    }me.setOpt({ catchRemoteImageEnable: false });me.addListener("afterpaste", function () {
      me.fireEvent("catchRemoteImage");
    });me.addListener("catchRemoteImage", function () {
      var catcherLocalDomain = me.getOpt("catcherLocalDomain"),
          catcherActionUrl = me.getActionUrl(me.getOpt("catcherActionName")),
          catcherUrlPrefix = me.getOpt("catcherUrlPrefix"),
          catcherFieldName = me.getOpt("catcherFieldName");var remoteImages = [],
          imgs = domUtils.getElementsByTagName(me.document, "img"),
          test = function test(src, urls) {
        if (src.indexOf(location.host) != -1 || /(^\.)|(^\/)/.test(src)) {
          return true;
        }if (urls) {
          for (var j = 0, url; url = urls[j++];) {
            if (src.indexOf(url) !== -1) {
              return true;
            }
          }
        }return false;
      };for (var i = 0, ci; ci = imgs[i++];) {
        if (ci.getAttribute("word_img")) {
          continue;
        }var src = ci.getAttribute("_src") || ci.src || "";if (/^(https?|ftp):/i.test(src) && !test(src, catcherLocalDomain)) {
          remoteImages.push(src);
        }
      }if (remoteImages.length) {
        catchremoteimage(remoteImages, { success: function success(r) {
            try {
              var info = r.state !== undefined ? r : eval("(" + r.responseText + ")");
            } catch (e) {
              return;
            }var i,
                j,
                ci,
                cj,
                oldSrc,
                newSrc,
                list = info.list;for (i = 0; ci = imgs[i++];) {
              oldSrc = ci.getAttribute("_src") || ci.src || "";for (j = 0; cj = list[j++];) {
                if (oldSrc == cj.source && cj.state == "SUCCESS") {
                  newSrc = catcherUrlPrefix + cj.url;domUtils.setAttributes(ci, { "src": newSrc, "_src": newSrc });break;
                }
              }
            }me.fireEvent("catchremotesuccess");
          }, error: function error() {
            me.fireEvent("catchremoteerror");
          } });
      }function catchremoteimage(imgs, callbacks) {
        var params = utils.serializeParam(me.queryCommandValue("serverparam")) || "",
            url = utils.formatUrl(catcherActionUrl + (catcherActionUrl.indexOf("?") == -1 ? "?" : "&") + params),
            isJsonp = utils.isCrossDomainUrl(url),
            opt = { "method": "POST", "dataType": isJsonp ? "jsonp" : "", "timeout": 60000, "onsuccess": callbacks["success"], "onerror": callbacks["error"] };opt["imgUrls"] = imgs;console.info(url);ajax.request(url, opt);
      }
    });
  };UE.plugin.register("autosave", function () {
    var me = this,
        lastSaveTime = new Date(),
        MIN_TIME = 20,
        saveKey = null;function save(editor) {
      var saveData;if (new Date() - lastSaveTime < MIN_TIME) {
        return;
      }if (!editor.hasContents()) {
        saveKey && me.removePreferences(saveKey);return;
      }lastSaveTime = new Date();editor._saveFlag = null;saveData = me.body.innerHTML;if (editor.fireEvent("beforeautosave", { content: saveData }) === false) {
        return;
      }me.setPreferences(saveKey, saveData);editor.fireEvent("afterautosave", { content: saveData });
    }return { defaultOptions: { saveInterval: 500 }, bindEvents: { "ready": function ready() {
          var _suffix = "-drafts-data",
              key = null;if (me.key) {
            key = me.key + _suffix;
          } else {
            key = (me.container.parentNode.id || "ue-common") + _suffix;
          }saveKey = (location.protocol + location.host + location.pathname).replace(/[.:\/]/g, "_") + key;
        }, "contentchange": function contentchange() {
          if (!saveKey) {
            return;
          }if (me._saveFlag) {
            window.clearTimeout(me._saveFlag);
          }if (me.options.saveInterval > 0) {
            me._saveFlag = window.setTimeout(function () {
              save(me);
            }, me.options.saveInterval);
          } else {
            save(me);
          }
        } }, commands: { "clearlocaldata": { execCommand: function execCommand(cmd, name) {
            if (saveKey && me.getPreferences(saveKey)) {
              me.removePreferences(saveKey);
            }
          }, notNeedUndo: true, ignoreContentChange: true }, "getlocaldata": { execCommand: function execCommand(cmd, name) {
            return saveKey ? me.getPreferences(saveKey) || "" : "";
          }, notNeedUndo: true, ignoreContentChange: true }, "drafts": { execCommand: function execCommand(cmd, name) {
            if (saveKey) {
              me.body.innerHTML = me.getPreferences(saveKey) || "<p>" + domUtils.fillHtml + "</p>";me.focus(true);
            }
          }, queryCommandState: function queryCommandState() {
            return saveKey ? me.getPreferences(saveKey) === null ? -1 : 0 : -1;
          }, notNeedUndo: true, ignoreContentChange: true } } };
  });UE.plugin.register("section", function () {
    function Section(option) {
      this.tag = "";this.level = -1, this.dom = null;this.nextSection = null;this.previousSection = null;this.parentSection = null;this.startAddress = [];this.endAddress = [];this.children = [];
    }function getSection(option) {
      var section = new Section();return utils.extend(section, option);
    }function getNodeFromAddress(startAddress, root) {
      var current = root;for (var i = 0; i < startAddress.length; i++) {
        if (!current.childNodes) {
          return null;
        }current = current.childNodes[startAddress[i]];
      }return current;
    }var me = this;return { bindMultiEvents: { type: "aftersetcontent afterscencerestore", handler: function handler() {
          me.fireEvent("updateSections");
        } }, bindEvents: { "ready": function ready() {
          me.fireEvent("updateSections");domUtils.on(me.body, "drop paste", function () {
            me.fireEvent("updateSections");
          });
        }, "afterexeccommand": function afterexeccommand(type, cmd) {
          if (cmd == "paragraph") {
            me.fireEvent("updateSections");
          }
        }, "keyup": function keyup(type, e) {
          var me = this,
              range = me.selection.getRange();if (range.collapsed != true) {
            me.fireEvent("updateSections");
          } else {
            var keyCode = e.keyCode || e.which;if (keyCode == 13 || keyCode == 8 || keyCode == 46) {
              me.fireEvent("updateSections");
            }
          }
        } }, commands: { "getsections": { execCommand: function execCommand(cmd, levels) {
            var levelFn = levels || ["h1", "h2", "h3", "h4", "h5", "h6"];for (var i = 0; i < levelFn.length; i++) {
              if (typeof levelFn[i] == "string") {
                levelFn[i] = function (fn) {
                  return function (node) {
                    return node.tagName == fn.toUpperCase();
                  };
                }(levelFn[i]);
              } else {
                if (typeof levelFn[i] != "function") {
                  levelFn[i] = function (node) {
                    return null;
                  };
                }
              }
            }function getSectionLevel(node) {
              for (var i = 0; i < levelFn.length; i++) {
                if (levelFn[i](node)) {
                  return i;
                }
              }return -1;
            }var me = this,
                Directory = getSection({ "level": -1, "title": "root" }),
                previous = Directory;function traversal(node, Directory) {
              var level,
                  tmpSection = null,
                  parent,
                  child,
                  children = node.childNodes;for (var i = 0, len = children.length; i < len; i++) {
                child = children[i];level = getSectionLevel(child);if (level >= 0) {
                  var address = me.selection.getRange().selectNode(child).createAddress(true).startAddress,
                      current = getSection({ "tag": child.tagName, "title": child.innerText || child.textContent || "", "level": level, "dom": child, "startAddress": utils.clone(address, []), "endAddress": utils.clone(address, []), "children": [] });previous.nextSection = current;current.previousSection = previous;parent = previous;while (level <= parent.level) {
                    parent = parent.parentSection;
                  }current.parentSection = parent;parent.children.push(current);tmpSection = previous = current;
                } else {
                  child.nodeType === 1 && traversal(child, Directory);tmpSection && tmpSection.endAddress[tmpSection.endAddress.length - 1]++;
                }
              }
            }traversal(me.body, Directory);return Directory;
          }, notNeedUndo: true }, "movesection": { execCommand: function execCommand(cmd, sourceSection, targetSection, isAfter) {
            var me = this,
                targetAddress,
                target;if (!sourceSection || !targetSection || targetSection.level == -1) {
              return;
            }targetAddress = isAfter ? targetSection.endAddress : targetSection.startAddress;target = getNodeFromAddress(targetAddress, me.body);if (!targetAddress || !target || isContainsAddress(sourceSection.startAddress, sourceSection.endAddress, targetAddress)) {
              return;
            }var startNode = getNodeFromAddress(sourceSection.startAddress, me.body),
                endNode = getNodeFromAddress(sourceSection.endAddress, me.body),
                current,
                nextNode;if (isAfter) {
              current = endNode;while (current && !(domUtils.getPosition(startNode, current) & domUtils.POSITION_FOLLOWING)) {
                nextNode = current.previousSibling;domUtils.insertAfter(target, current);if (current == startNode) {
                  break;
                }current = nextNode;
              }
            } else {
              current = startNode;while (current && !(domUtils.getPosition(current, endNode) & domUtils.POSITION_FOLLOWING)) {
                nextNode = current.nextSibling;target.parentNode.insertBefore(current, target);if (current == endNode) {
                  break;
                }current = nextNode;
              }
            }me.fireEvent("updateSections");function isContainsAddress(startAddress, endAddress, addressTarget) {
              var isAfterStartAddress = false,
                  isBeforeEndAddress = false;for (var i = 0; i < startAddress.length; i++) {
                if (i >= addressTarget.length) {
                  break;
                }if (addressTarget[i] > startAddress[i]) {
                  isAfterStartAddress = true;break;
                } else {
                  if (addressTarget[i] < startAddress[i]) {
                    break;
                  }
                }
              }for (var i = 0; i < endAddress.length; i++) {
                if (i >= addressTarget.length) {
                  break;
                }if (addressTarget[i] < startAddress[i]) {
                  isBeforeEndAddress = true;break;
                } else {
                  if (addressTarget[i] > startAddress[i]) {
                    break;
                  }
                }
              }return isAfterStartAddress && isBeforeEndAddress;
            }
          } }, "deletesection": { execCommand: function execCommand(cmd, section, keepChildren) {
            var me = this;if (!section) {
              return;
            }function getNodeFromAddress(startAddress) {
              var current = me.body;for (var i = 0; i < startAddress.length; i++) {
                if (!current.childNodes) {
                  return null;
                }current = current.childNodes[startAddress[i]];
              }return current;
            }var startNode = getNodeFromAddress(section.startAddress),
                endNode = getNodeFromAddress(section.endAddress),
                current = startNode,
                nextNode;if (!keepChildren) {
              while (current && domUtils.inDoc(endNode, me.document) && !(domUtils.getPosition(current, endNode) & domUtils.POSITION_FOLLOWING)) {
                nextNode = current.nextSibling;domUtils.remove(current);current = nextNode;
              }
            } else {
              domUtils.remove(current);
            }me.fireEvent("updateSections");
          } }, "selectsection": { execCommand: function execCommand(cmd, section) {
            if (!section && !section.dom) {
              return false;
            }var me = this,
                range = me.selection.getRange(),
                address = { "startAddress": utils.clone(section.startAddress, []), "endAddress": utils.clone(section.endAddress, []) };address.endAddress[address.endAddress.length - 1]++;range.moveToAddress(address).select().scrollToView();return true;
          }, notNeedUndo: true }, "scrolltosection": { execCommand: function execCommand(cmd, section) {
            if (!section && !section.dom) {
              return false;
            }var me = this,
                range = me.selection.getRange(),
                address = { "startAddress": section.startAddress, "endAddress": section.endAddress };address.endAddress[address.endAddress.length - 1]++;range.moveToAddress(address).scrollToView();return true;
          }, notNeedUndo: true } } };
  });UE.plugin.register("serverparam", function () {
    var me = this,
        serverParam = {};return { commands: { "serverparam": { execCommand: function execCommand(cmd, key, value) {
            if (key === undefined || key === null) {
              serverParam = {};
            } else {
              if (utils.isString(key)) {
                if (value === undefined || value === null) {
                  delete serverParam[key];
                } else {
                  serverParam[key] = value;
                }
              } else {
                if (utils.isObject(key)) {
                  utils.extend(serverParam, key, true);
                } else {
                  if (utils.isFunction(key)) {
                    utils.extend(serverParam, key(), true);
                  }
                }
              }
            }
          }, queryCommandValue: function queryCommandValue() {
            return serverParam || {};
          } } } };
  });UE.plugins.xssFilter = function () {
    var config = UEDITOR_CONFIG;var whitList = config.whitList;function filter(node) {
      var tagName = node.tagName;var attrs = node.attrs;if (!whitList.hasOwnProperty(tagName)) {
        node.parentNode.removeChild(node);return false;
      }UE.utils.each(attrs, function (val, key) {
        if (whitList[tagName].indexOf(key) === -1) {
          node.setAttr(key);
        }
      });
    }if (whitList && config.xssFilterRules) {
      this.options.filterRules = function () {
        var result = {};UE.utils.each(whitList, function (val, key) {
          result[key] = function (node) {
            return filter(node);
          };
        });return result;
      }();
    }var tagList = [];UE.utils.each(whitList, function (val, key) {
      tagList.push(key);
    });if (whitList && config.inputXssFilter) {
      this.addInputRule(function (root) {
        root.traversal(function (node) {
          if (node.type !== "element") {
            return false;
          }filter(node);
        });
      });
    }if (whitList && config.outputXssFilter) {
      this.addOutputRule(function (root) {
        root.traversal(function (node) {
          if (node.type !== "element") {
            return false;
          }filter(node);
        });
      });
    }
  };var baidu = baidu || {};baidu.editor = baidu.editor || {};UE.ui = baidu.editor.ui = {};(function () {
    var browser = baidu.editor.browser,
        domUtils = baidu.editor.dom.domUtils;var magic = "$EDITORUI";var root = window[magic] = {};var uidMagic = "ID" + magic;var uidCount = 0;var uiUtils = baidu.editor.ui.uiUtils = { uid: function uid(obj) {
        return obj ? obj[uidMagic] || (obj[uidMagic] = ++uidCount) : ++uidCount;
      }, hook: function hook(fn, callback) {
        var _dg;if (fn && fn._callbacks) {
          _dg = fn;
        } else {
          _dg = function dg() {
            var q;if (fn) {
              q = fn.apply(this, arguments);
            }var callbacks = _dg._callbacks;var k = callbacks.length;while (k--) {
              var r = callbacks[k].apply(this, arguments);if (q === undefined) {
                q = r;
              }
            }return q;
          };_dg._callbacks = [];
        }_dg._callbacks.push(callback);return _dg;
      }, createElementByHtml: function createElementByHtml(html) {
        var el = document.createElement("div");el.innerHTML = html;el = el.firstChild;el.parentNode.removeChild(el);return el;
      }, getViewportElement: function getViewportElement() {
        return browser.ie && browser.quirks ? document.body : document.documentElement;
      }, getClientRect: function getClientRect(element) {
        var bcr;try {
          bcr = element.getBoundingClientRect();
        } catch (e) {
          bcr = { left: 0, top: 0, height: 0, width: 0 };
        }var rect = { left: Math.round(bcr.left), top: Math.round(bcr.top), height: Math.round(bcr.bottom - bcr.top), width: Math.round(bcr.right - bcr.left) };var doc;while ((doc = element.ownerDocument) !== document && (element = domUtils.getWindow(doc).frameElement)) {
          bcr = element.getBoundingClientRect();rect.left += bcr.left;rect.top += bcr.top;
        }rect.bottom = rect.top + rect.height;rect.right = rect.left + rect.width;return rect;
      }, getViewportRect: function getViewportRect() {
        var viewportEl = uiUtils.getViewportElement();var width = (window.innerWidth || viewportEl.clientWidth) | 0;var height = (window.innerHeight || viewportEl.clientHeight) | 0;return { left: 0, top: 0, height: height, width: width, bottom: height, right: width };
      }, setViewportOffset: function setViewportOffset(element, offset) {
        var rect;var fixedLayer = uiUtils.getFixedLayer();if (element.parentNode === fixedLayer) {
          element.style.left = offset.left + "px";element.style.top = offset.top + "px";
        } else {
          domUtils.setViewportOffset(element, offset);
        }
      }, getEventOffset: function getEventOffset(evt) {
        var el = evt.target || evt.srcElement;var rect = uiUtils.getClientRect(el);var offset = uiUtils.getViewportOffsetByEvent(evt);return { left: offset.left - rect.left, top: offset.top - rect.top };
      }, getViewportOffsetByEvent: function getViewportOffsetByEvent(evt) {
        var el = evt.target || evt.srcElement;var frameEl = domUtils.getWindow(el).frameElement;var offset = { left: evt.clientX, top: evt.clientY };if (frameEl && el.ownerDocument !== document) {
          var rect = uiUtils.getClientRect(frameEl);offset.left += rect.left;offset.top += rect.top;
        }return offset;
      }, setGlobal: function setGlobal(id, obj) {
        root[id] = obj;return magic + '["' + id + '"]';
      }, unsetGlobal: function unsetGlobal(id) {
        delete root[id];
      }, copyAttributes: function copyAttributes(tgt, src) {
        var attributes = src.attributes;var k = attributes.length;while (k--) {
          var attrNode = attributes[k];if (attrNode.nodeName != "style" && attrNode.nodeName != "class" && (!browser.ie || attrNode.specified)) {
            tgt.setAttribute(attrNode.nodeName, attrNode.nodeValue);
          }
        }if (src.className) {
          domUtils.addClass(tgt, src.className);
        }if (src.style.cssText) {
          tgt.style.cssText += ";" + src.style.cssText;
        }
      }, removeStyle: function removeStyle(el, styleName) {
        if (el.style.removeProperty) {
          el.style.removeProperty(styleName);
        } else {
          if (el.style.removeAttribute) {
            el.style.removeAttribute(styleName);
          } else {
            throw "";
          }
        }
      }, contains: function contains(elA, elB) {
        return elA && elB && (elA === elB ? false : elA.contains ? elA.contains(elB) : elA.compareDocumentPosition(elB) & 16);
      }, startDrag: function startDrag(evt, callbacks, doc) {
        var doc = doc || document;var startX = evt.clientX;var startY = evt.clientY;function handleMouseMove(evt) {
          var x = evt.clientX - startX;var y = evt.clientY - startY;callbacks.ondragmove(x, y, evt);if (evt.stopPropagation) {
            evt.stopPropagation();
          } else {
            evt.cancelBubble = true;
          }
        }if (doc.addEventListener) {
          var handleMouseUp = function handleMouseUp(evt) {
            doc.removeEventListener("mousemove", handleMouseMove, true);doc.removeEventListener("mouseup", handleMouseUp, true);window.removeEventListener("mouseup", handleMouseUp, true);callbacks.ondragstop();
          };

          doc.addEventListener("mousemove", handleMouseMove, true);doc.addEventListener("mouseup", handleMouseUp, true);window.addEventListener("mouseup", handleMouseUp, true);evt.preventDefault();
        } else {
          var releaseCaptrue = function releaseCaptrue() {
            elm.releaseCapture();elm.detachEvent("onmousemove", handleMouseMove);elm.detachEvent("onmouseup", releaseCaptrue);elm.detachEvent("onlosecaptrue", releaseCaptrue);callbacks.ondragstop();
          };

          var elm = evt.srcElement;elm.setCapture();elm.attachEvent("onmousemove", handleMouseMove);elm.attachEvent("onmouseup", releaseCaptrue);elm.attachEvent("onlosecaptrue", releaseCaptrue);evt.returnValue = false;
        }callbacks.ondragstart();
      }, getFixedLayer: function getFixedLayer() {
        var layer = document.getElementById("edui_fixedlayer");if (layer == null) {
          layer = document.createElement("div");layer.id = "edui_fixedlayer";document.body.appendChild(layer);if (browser.ie && browser.version <= 8) {
            layer.style.position = "absolute";bindFixedLayer();setTimeout(updateFixedOffset);
          } else {
            layer.style.position = "fixed";
          }layer.style.left = "0";layer.style.top = "0";layer.style.width = "0";layer.style.height = "0";
        }return layer;
      }, makeUnselectable: function makeUnselectable(element) {
        if (browser.opera || browser.ie && browser.version < 9) {
          element.unselectable = "on";if (element.hasChildNodes()) {
            for (var i = 0; i < element.childNodes.length; i++) {
              if (element.childNodes[i].nodeType == 1) {
                uiUtils.makeUnselectable(element.childNodes[i]);
              }
            }
          }
        } else {
          if (element.style.MozUserSelect !== undefined) {
            element.style.MozUserSelect = "none";
          } else {
            if (element.style.WebkitUserSelect !== undefined) {
              element.style.WebkitUserSelect = "none";
            } else {
              if (element.style.KhtmlUserSelect !== undefined) {
                element.style.KhtmlUserSelect = "none";
              }
            }
          }
        }
      } };function updateFixedOffset() {
      var layer = document.getElementById("edui_fixedlayer");uiUtils.setViewportOffset(layer, { left: 0, top: 0 });
    }function bindFixedLayer(adjOffset) {
      domUtils.on(window, "scroll", updateFixedOffset);domUtils.on(window, "resize", baidu.editor.utils.defer(updateFixedOffset, 0, true));
    }
  })();(function () {
    var utils = baidu.editor.utils,
        uiUtils = baidu.editor.ui.uiUtils,
        EventBase = baidu.editor.EventBase,
        UIBase = baidu.editor.ui.UIBase = function () {};UIBase.prototype = { className: "", uiName: "", initOptions: function initOptions(options) {
        var me = this;for (var k in options) {
          me[k] = options[k];
        }this.id = this.id || "edui" + uiUtils.uid();
      }, initUIBase: function initUIBase() {
        this._globalKey = utils.unhtml(uiUtils.setGlobal(this.id, this));
      }, render: function render(holder) {
        var html = this.renderHtml();var el = uiUtils.createElementByHtml(html);var list = domUtils.getElementsByTagName(el, "*");var theme = "edui-" + (this.theme || this.editor.options.theme);var layer = document.getElementById("edui_fixedlayer");for (var i = 0, node; node = list[i++];) {
          domUtils.addClass(node, theme);
        }domUtils.addClass(el, theme);if (layer) {
          layer.className = "";domUtils.addClass(layer, theme);
        }var seatEl = this.getDom();if (seatEl != null) {
          seatEl.parentNode.replaceChild(el, seatEl);uiUtils.copyAttributes(el, seatEl);
        } else {
          if (typeof holder == "string") {
            holder = document.getElementById(holder);
          }holder = holder || uiUtils.getFixedLayer();domUtils.addClass(holder, theme);holder.appendChild(el);
        }this.postRender();
      }, getDom: function getDom(name) {
        if (!name) {
          return document.getElementById(this.id);
        } else {
          return document.getElementById(this.id + "_" + name);
        }
      }, postRender: function postRender() {
        this.fireEvent("postrender");
      }, getHtmlTpl: function getHtmlTpl() {
        return "";
      }, formatHtml: function formatHtml(tpl) {
        var prefix = "edui-" + this.uiName;return tpl.replace(/##/g, this.id).replace(/%%-/g, this.uiName ? prefix + "-" : "").replace(/%%/g, (this.uiName ? prefix : "") + " " + this.className).replace(/\$\$/g, this._globalKey);
      }, renderHtml: function renderHtml() {
        return this.formatHtml(this.getHtmlTpl());
      }, dispose: function dispose() {
        var box = this.getDom();if (box) {
          baidu.editor.dom.domUtils.remove(box);
        }uiUtils.unsetGlobal(this.id);
      } };utils.inherits(UIBase, EventBase);
  })();(function () {
    var utils = baidu.editor.utils,
        UIBase = baidu.editor.ui.UIBase,
        Separator = baidu.editor.ui.Separator = function (options) {
      this.initOptions(options);this.initSeparator();
    };Separator.prototype = { uiName: "separator", initSeparator: function initSeparator() {
        this.initUIBase();
      }, getHtmlTpl: function getHtmlTpl() {
        return '<div id="##" class="edui-box %%"></div>';
      } };utils.inherits(Separator, UIBase);
  })();(function () {
    var utils = baidu.editor.utils,
        domUtils = baidu.editor.dom.domUtils,
        UIBase = baidu.editor.ui.UIBase,
        uiUtils = baidu.editor.ui.uiUtils;var Mask = baidu.editor.ui.Mask = function (options) {
      this.initOptions(options);this.initUIBase();
    };Mask.prototype = { getHtmlTpl: function getHtmlTpl() {
        return '<div id="##" class="edui-mask %%" onclick="return $$._onClick(event, this);" onmousedown="return $$._onMouseDown(event, this);"></div>';
      }, postRender: function postRender() {
        var me = this;domUtils.on(window, "resize", function () {
          setTimeout(function () {
            if (!me.isHidden()) {
              me._fill();
            }
          });
        });
      }, show: function show(zIndex) {
        this._fill();this.getDom().style.display = "";this.getDom().style.zIndex = zIndex;
      }, hide: function hide() {
        this.getDom().style.display = "none";this.getDom().style.zIndex = "";
      }, isHidden: function isHidden() {
        return this.getDom().style.display == "none";
      }, _onMouseDown: function _onMouseDown() {
        return false;
      }, _onClick: function _onClick(e, target) {
        this.fireEvent("click", e, target);
      }, _fill: function _fill() {
        var el = this.getDom();var vpRect = uiUtils.getViewportRect();el.style.width = vpRect.width + "px";el.style.height = vpRect.height + "px";
      } };utils.inherits(Mask, UIBase);
  })();(function () {
    var utils = baidu.editor.utils,
        uiUtils = baidu.editor.ui.uiUtils,
        domUtils = baidu.editor.dom.domUtils,
        UIBase = baidu.editor.ui.UIBase,
        Popup = baidu.editor.ui.Popup = function (options) {
      this.initOptions(options);this.initPopup();
    };var allPopups = [];function closeAllPopup(evt, el) {
      for (var i = 0; i < allPopups.length; i++) {
        var pop = allPopups[i];if (!pop.isHidden()) {
          if (pop.queryAutoHide(el) !== false) {
            if (evt && /scroll/ig.test(evt.type) && pop.className == "edui-wordpastepop") {
              return;
            }pop.hide();
          }
        }
      }if (allPopups.length) {
        pop.editor.fireEvent("afterhidepop");
      }
    }Popup.postHide = closeAllPopup;var ANCHOR_CLASSES = ["edui-anchor-topleft", "edui-anchor-topright", "edui-anchor-bottomleft", "edui-anchor-bottomright"];Popup.prototype = { SHADOW_RADIUS: 5, content: null, _hidden: false, autoRender: true, canSideLeft: true, canSideUp: true, initPopup: function initPopup() {
        this.initUIBase();allPopups.push(this);
      }, getHtmlTpl: function getHtmlTpl() {
        return '<div id="##" class="edui-popup %%" onmousedown="return false;">' + ' <div id="##_body" class="edui-popup-body">' + ' <iframe style="position:absolute;z-index:-1;left:0;top:0;background-color: transparent;" frameborder="0" width="100%" height="100%" src="about:blank"></iframe>' + ' <div class="edui-shadow"></div>' + ' <div id="##_content" class="edui-popup-content">' + this.getContentHtmlTpl() + "  </div>" + " </div>" + "</div>";
      }, getContentHtmlTpl: function getContentHtmlTpl() {
        if (this.content) {
          if (typeof this.content == "string") {
            return this.content;
          }return this.content.renderHtml();
        } else {
          return "";
        }
      }, _UIBase_postRender: UIBase.prototype.postRender, postRender: function postRender() {
        if (this.content instanceof UIBase) {
          this.content.postRender();
        }if (this.captureWheel && !this.captured) {
          this.captured = true;var winHeight = (document.documentElement.clientHeight || document.body.clientHeight) - 80,
              _height = this.getDom().offsetHeight,
              _top = uiUtils.getClientRect(this.combox.getDom()).top,
              content = this.getDom("content"),
              ifr = this.getDom("body").getElementsByTagName("iframe"),
              me = this;ifr.length && (ifr = ifr[0]);while (_top + _height > winHeight) {
            _height -= 30;
          }content.style.height = _height + "px";ifr && (ifr.style.height = _height + "px");if (window.XMLHttpRequest) {
            domUtils.on(content, "onmousewheel" in document.body ? "mousewheel" : "DOMMouseScroll", function (e) {
              if (e.preventDefault) {
                e.preventDefault();
              } else {
                e.returnValue = false;
              }if (e.wheelDelta) {
                content.scrollTop -= e.wheelDelta / 120 * 60;
              } else {
                content.scrollTop -= e.detail / -3 * 60;
              }
            });
          } else {
            domUtils.on(this.getDom(), "mousewheel", function (e) {
              e.returnValue = false;me.getDom("content").scrollTop -= e.wheelDelta / 120 * 60;
            });
          }
        }this.fireEvent("postRenderAfter");this.hide(true);this._UIBase_postRender();
      }, _doAutoRender: function _doAutoRender() {
        if (!this.getDom() && this.autoRender) {
          this.render();
        }
      }, mesureSize: function mesureSize() {
        var box = this.getDom("content");return uiUtils.getClientRect(box);
      }, fitSize: function fitSize() {
        if (this.captureWheel && this.sized) {
          return this.__size;
        }this.sized = true;var popBodyEl = this.getDom("body");popBodyEl.style.width = "";popBodyEl.style.height = "";var size = this.mesureSize();if (this.captureWheel) {
          popBodyEl.style.width = -(-20 - size.width) + "px";var height = parseInt(this.getDom("content").style.height, 10);!window.isNaN(height) && (size.height = height);
        } else {
          popBodyEl.style.width = size.width + "px";
        }popBodyEl.style.height = size.height + "px";this.__size = size;this.captureWheel && (this.getDom("content").style.overflow = "auto");return size;
      }, showAnchor: function showAnchor(element, hoz) {
        this.showAnchorRect(uiUtils.getClientRect(element), hoz);
      }, showAnchorRect: function showAnchorRect(rect, hoz, adj) {
        this._doAutoRender();var vpRect = uiUtils.getViewportRect();this.getDom().style.visibility = "hidden";this._show();var popSize = this.fitSize();var sideLeft, sideUp, left, top;if (hoz) {
          sideLeft = this.canSideLeft && rect.right + popSize.width > vpRect.right && rect.left > popSize.width;sideUp = this.canSideUp && rect.top + popSize.height > vpRect.bottom && rect.bottom > popSize.height;left = sideLeft ? rect.left - popSize.width : rect.right;top = sideUp ? rect.bottom - popSize.height : rect.top;
        } else {
          sideLeft = this.canSideLeft && rect.right + popSize.width > vpRect.right && rect.left > popSize.width;sideUp = this.canSideUp && rect.top + popSize.height > vpRect.bottom && rect.bottom > popSize.height;left = sideLeft ? rect.right - popSize.width : rect.left;top = sideUp ? rect.top - popSize.height : rect.bottom;
        }var popEl = this.getDom();uiUtils.setViewportOffset(popEl, { left: left, top: top });domUtils.removeClasses(popEl, ANCHOR_CLASSES);popEl.className += " " + ANCHOR_CLASSES[(sideUp ? 1 : 0) * 2 + (sideLeft ? 1 : 0)];if (this.editor) {
          popEl.style.zIndex = this.editor.container.style.zIndex * 1 + 10;baidu.editor.ui.uiUtils.getFixedLayer().style.zIndex = popEl.style.zIndex - 1;
        }this.getDom().style.visibility = "visible";
      }, showAt: function showAt(offset) {
        var left = offset.left;var top = offset.top;var rect = { left: left, top: top, right: left, bottom: top, height: 0, width: 0 };this.showAnchorRect(rect, false, true);
      }, _show: function _show() {
        if (this._hidden) {
          var box = this.getDom();box.style.display = "";this._hidden = false;this.fireEvent("show");
        }
      }, isHidden: function isHidden() {
        return this._hidden;
      }, show: function show() {
        this._doAutoRender();this._show();
      }, hide: function hide(notNofity) {
        if (!this._hidden && this.getDom()) {
          this.getDom().style.display = "none";this._hidden = true;if (!notNofity) {
            this.fireEvent("hide");
          }
        }
      }, queryAutoHide: function queryAutoHide(el) {
        return !el || !uiUtils.contains(this.getDom(), el);
      } };utils.inherits(Popup, UIBase);domUtils.on(document, "mousedown", function (evt) {
      var el = evt.target || evt.srcElement;closeAllPopup(evt, el);
    });domUtils.on(window, "scroll", function (evt, el) {
      closeAllPopup(evt, el);
    });
  })();(function () {
    var utils = baidu.editor.utils,
        UIBase = baidu.editor.ui.UIBase,
        ColorPicker = baidu.editor.ui.ColorPicker = function (options) {
      this.initOptions(options);this.noColorText = this.noColorText || this.editor.getLang("clearColor");this.initUIBase();
    };ColorPicker.prototype = { getHtmlTpl: function getHtmlTpl() {
        return genColorPicker(this.noColorText, this.editor);
      }, _onTableClick: function _onTableClick(evt) {
        var tgt = evt.target || evt.srcElement;var color = tgt.getAttribute("data-color");if (color) {
          this.fireEvent("pickcolor", color);
        }
      }, _onTableOver: function _onTableOver(evt) {
        var tgt = evt.target || evt.srcElement;var color = tgt.getAttribute("data-color");if (color) {
          this.getDom("preview").style.backgroundColor = color;
        }
      }, _onTableOut: function _onTableOut() {
        this.getDom("preview").style.backgroundColor = "";
      }, _onPickNoColor: function _onPickNoColor() {
        this.fireEvent("picknocolor");
      } };utils.inherits(ColorPicker, UIBase);var COLORS = ("ffffff,000000,eeece1,1f497d,4f81bd,c0504d,9bbb59,8064a2,4bacc6,f79646," + "f2f2f2,7f7f7f,ddd9c3,c6d9f0,dbe5f1,f2dcdb,ebf1dd,e5e0ec,dbeef3,fdeada," + "d8d8d8,595959,c4bd97,8db3e2,b8cce4,e5b9b7,d7e3bc,ccc1d9,b7dde8,fbd5b5," + "bfbfbf,3f3f3f,938953,548dd4,95b3d7,d99694,c3d69b,b2a2c7,92cddc,fac08f," + "a5a5a5,262626,494429,17365d,366092,953734,76923c,5f497a,31859b,e36c09," + "7f7f7f,0c0c0c,1d1b10,0f243e,244061,632423,4f6128,3f3151,205867,974806," + "c00000,ff0000,ffc000,ffff00,92d050,00b050,00b0f0,0070c0,002060,7030a0,").split(",");function genColorPicker(noColorText, editor) {
      var html = '<div id="##" class="edui-colorpicker %%">' + '<div class="edui-colorpicker-topbar edui-clearfix">' + '<div unselectable="on" id="##_preview" class="edui-colorpicker-preview"></div>' + '<div unselectable="on" class="edui-colorpicker-nocolor" onclick="$$._onPickNoColor(event, this);">' + noColorText + "</div>" + "</div>" + '<table  class="edui-box" style="border-collapse: collapse;" onmouseover="$$._onTableOver(event, this);" onmouseout="$$._onTableOut(event, this);" onclick="return $$._onTableClick(event, this);" cellspacing="0" cellpadding="0">' + '<tr style="border-bottom: 1px solid #ddd;font-size: 13px;line-height: 25px;color:#39C;padding-top: 2px"><td colspan="10">' + editor.getLang("themeColor") + "</td> </tr>" + '<tr class="edui-colorpicker-tablefirstrow" >';for (var i = 0; i < COLORS.length; i++) {
        if (i && i % 10 === 0) {
          html += "</tr>" + (i == 60 ? '<tr style="border-bottom: 1px solid #ddd;font-size: 13px;line-height: 25px;color:#39C;"><td colspan="10">' + editor.getLang("standardColor") + "</td></tr>" : "") + "<tr" + (i == 60 ? ' class="edui-colorpicker-tablefirstrow"' : "") + ">";
        }html += i < 70 ? '<td style="padding: 0 2px;"><a hidefocus title="' + COLORS[i] + '" onclick="return false;" href="javascript:" unselectable="on" class="edui-box edui-colorpicker-colorcell"' + ' data-color="#' + COLORS[i] + '"' + ' style="background-color:#' + COLORS[i] + ";border:solid #ccc;" + (i < 10 || i >= 60 ? "border-width:1px;" : i >= 10 && i < 20 ? "border-width:1px 1px 0 1px;" : "border-width:0 1px 0 1px;") + '"' + "></a></td>" : "";
      }html += "</tr></table></div>";return html;
    }
  })();(function () {
    var utils = baidu.editor.utils,
        uiUtils = baidu.editor.ui.uiUtils,
        UIBase = baidu.editor.ui.UIBase;var TablePicker = baidu.editor.ui.TablePicker = function (options) {
      this.initOptions(options);this.initTablePicker();
    };TablePicker.prototype = { defaultNumRows: 10, defaultNumCols: 10, maxNumRows: 20, maxNumCols: 20, numRows: 10, numCols: 10, lengthOfCellSide: 22, initTablePicker: function initTablePicker() {
        this.initUIBase();
      }, getHtmlTpl: function getHtmlTpl() {
        var me = this;return '<div id="##" class="edui-tablepicker %%">' + '<div class="edui-tablepicker-body">' + '<div class="edui-infoarea">' + '<span id="##_label" class="edui-label"></span>' + "</div>" + '<div class="edui-pickarea"' + ' onmousemove="$$._onMouseMove(event, this);"' + ' onmouseover="$$._onMouseOver(event, this);"' + ' onmouseout="$$._onMouseOut(event, this);"' + ' onclick="$$._onClick(event, this);"' + ">" + '<div id="##_overlay" class="edui-overlay"></div>' + "</div>" + "</div>" + "</div>";
      }, _UIBase_render: UIBase.prototype.render, render: function render(holder) {
        this._UIBase_render(holder);this.getDom("label").innerHTML = "0" + this.editor.getLang("t_row") + " x 0" + this.editor.getLang("t_col");
      }, _track: function _track(numCols, numRows) {
        var style = this.getDom("overlay").style;var sideLen = this.lengthOfCellSide;style.width = numCols * sideLen + "px";style.height = numRows * sideLen + "px";var label = this.getDom("label");label.innerHTML = numCols + this.editor.getLang("t_col") + " x " + numRows + this.editor.getLang("t_row");this.numCols = numCols;this.numRows = numRows;
      }, _onMouseOver: function _onMouseOver(evt, el) {
        var rel = evt.relatedTarget || evt.fromElement;if (!uiUtils.contains(el, rel) && el !== rel) {
          this.getDom("label").innerHTML = "0" + this.editor.getLang("t_col") + " x 0" + this.editor.getLang("t_row");this.getDom("overlay").style.visibility = "";
        }
      }, _onMouseOut: function _onMouseOut(evt, el) {
        var rel = evt.relatedTarget || evt.toElement;if (!uiUtils.contains(el, rel) && el !== rel) {
          this.getDom("label").innerHTML = "0" + this.editor.getLang("t_col") + " x 0" + this.editor.getLang("t_row");this.getDom("overlay").style.visibility = "hidden";
        }
      }, _onMouseMove: function _onMouseMove(evt, el) {
        var style = this.getDom("overlay").style;var offset = uiUtils.getEventOffset(evt);var sideLen = this.lengthOfCellSide;var numCols = Math.ceil(offset.left / sideLen);var numRows = Math.ceil(offset.top / sideLen);this._track(numCols, numRows);
      }, _onClick: function _onClick() {
        this.fireEvent("picktable", this.numCols, this.numRows);
      } };utils.inherits(TablePicker, UIBase);
  })();(function () {
    var browser = baidu.editor.browser,
        domUtils = baidu.editor.dom.domUtils,
        uiUtils = baidu.editor.ui.uiUtils;var TPL_STATEFUL = 'onmousedown="$$.Stateful_onMouseDown(event, this);"' + ' onmouseup="$$.Stateful_onMouseUp(event, this);"' + (browser.ie ? ' onmouseenter="$$.Stateful_onMouseEnter(event, this);"' + ' onmouseleave="$$.Stateful_onMouseLeave(event, this);"' : ' onmouseover="$$.Stateful_onMouseOver(event, this);"' + ' onmouseout="$$.Stateful_onMouseOut(event, this);"');baidu.editor.ui.Stateful = { alwalysHoverable: false, target: null, Stateful_init: function Stateful_init() {
        this._Stateful_dGetHtmlTpl = this.getHtmlTpl;this.getHtmlTpl = this.Stateful_getHtmlTpl;
      }, Stateful_getHtmlTpl: function Stateful_getHtmlTpl() {
        var tpl = this._Stateful_dGetHtmlTpl();return tpl.replace(/stateful/g, function () {
          return TPL_STATEFUL;
        });
      }, Stateful_onMouseEnter: function Stateful_onMouseEnter(evt, el) {
        this.target = el;if (!this.isDisabled() || this.alwalysHoverable) {
          this.addState("hover");this.fireEvent("over");
        }
      }, Stateful_onMouseLeave: function Stateful_onMouseLeave(evt, el) {
        if (!this.isDisabled() || this.alwalysHoverable) {
          this.removeState("hover");this.removeState("active");this.fireEvent("out");
        }
      }, Stateful_onMouseOver: function Stateful_onMouseOver(evt, el) {
        var rel = evt.relatedTarget;if (!uiUtils.contains(el, rel) && el !== rel) {
          this.Stateful_onMouseEnter(evt, el);
        }
      }, Stateful_onMouseOut: function Stateful_onMouseOut(evt, el) {
        var rel = evt.relatedTarget;if (!uiUtils.contains(el, rel) && el !== rel) {
          this.Stateful_onMouseLeave(evt, el);
        }
      }, Stateful_onMouseDown: function Stateful_onMouseDown(evt, el) {
        if (!this.isDisabled()) {
          this.addState("active");
        }
      }, Stateful_onMouseUp: function Stateful_onMouseUp(evt, el) {
        if (!this.isDisabled()) {
          this.removeState("active");
        }
      }, Stateful_postRender: function Stateful_postRender() {
        if (this.disabled && !this.hasState("disabled")) {
          this.addState("disabled");
        }
      }, hasState: function hasState(state) {
        return domUtils.hasClass(this.getStateDom(), "edui-state-" + state);
      }, addState: function addState(state) {
        if (!this.hasState(state)) {
          this.getStateDom().className += " edui-state-" + state;
        }
      }, removeState: function removeState(state) {
        if (this.hasState(state)) {
          domUtils.removeClasses(this.getStateDom(), ["edui-state-" + state]);
        }
      }, getStateDom: function getStateDom() {
        return this.getDom("state");
      }, isChecked: function isChecked() {
        return this.hasState("checked");
      }, setChecked: function setChecked(checked) {
        if (!this.isDisabled() && checked) {
          this.addState("checked");
        } else {
          this.removeState("checked");
        }
      }, isDisabled: function isDisabled() {
        return this.hasState("disabled");
      }, setDisabled: function setDisabled(disabled) {
        if (disabled) {
          this.removeState("hover");this.removeState("checked");this.removeState("active");this.addState("disabled");
        } else {
          this.removeState("disabled");
        }
      } };
  })();(function () {
    var utils = baidu.editor.utils,
        UIBase = baidu.editor.ui.UIBase,
        Stateful = baidu.editor.ui.Stateful,
        Button = baidu.editor.ui.Button = function (options) {
      if (options.name) {
        var btnName = options.name;var cssRules = options.cssRules;if (!options.className) {
          options.className = "edui-for-" + btnName;
        }options.cssRules = ".edui-default  .edui-for-" + btnName + " .edui-icon {" + cssRules + "}";
      }this.initOptions(options);this.initButton();
    };Button.prototype = { uiName: "button", label: "", title: "", showIcon: true, showText: true, cssRules: "", initButton: function initButton() {
        this.initUIBase();this.Stateful_init();if (this.cssRules) {
          utils.cssRule("edui-customize-" + this.name + "-style", this.cssRules);
        }
      }, getHtmlTpl: function getHtmlTpl() {
        return '<div id="##" class="edui-box %%">' + '<div id="##_state" stateful>' + '<div class="%%-wrap"><div id="##_body" unselectable="on" ' + (this.title ? 'title="' + this.title + '"' : "") + ' class="%%-body" onmousedown="return $$._onMouseDown(event, this);" onclick="return $$._onClick(event, this);">' + (this.showIcon ? '<div class="edui-box edui-icon"></div>' : "") + (this.showText ? '<div class="edui-box edui-label">' + this.label + "</div>" : "") + "</div>" + "</div>" + "</div></div>";
      }, postRender: function postRender() {
        this.Stateful_postRender();this.setDisabled(this.disabled);
      }, _onMouseDown: function _onMouseDown(e) {
        var target = e.target || e.srcElement,
            tagName = target && target.tagName && target.tagName.toLowerCase();if (tagName == "input" || tagName == "object" || tagName == "object") {
          return false;
        }
      }, _onClick: function _onClick() {
        if (!this.isDisabled()) {
          this.fireEvent("click");
        }
      }, setTitle: function setTitle(text) {
        var label = this.getDom("label");label.innerHTML = text;
      } };utils.inherits(Button, UIBase);utils.extend(Button.prototype, Stateful);
  })();(function () {
    var utils = baidu.editor.utils,
        uiUtils = baidu.editor.ui.uiUtils,
        domUtils = baidu.editor.dom.domUtils,
        UIBase = baidu.editor.ui.UIBase,
        Stateful = baidu.editor.ui.Stateful,
        SplitButton = baidu.editor.ui.SplitButton = function (options) {
      this.initOptions(options);this.initSplitButton();
    };SplitButton.prototype = { popup: null, uiName: "splitbutton", title: "", initSplitButton: function initSplitButton() {
        this.initUIBase();this.Stateful_init();var me = this;if (this.popup != null) {
          var popup = this.popup;this.popup = null;this.setPopup(popup);
        }
      }, _UIBase_postRender: UIBase.prototype.postRender, postRender: function postRender() {
        this.Stateful_postRender();this._UIBase_postRender();
      }, setPopup: function setPopup(popup) {
        if (this.popup === popup) {
          return;
        }if (this.popup != null) {
          this.popup.dispose();
        }popup.addListener("show", utils.bind(this._onPopupShow, this));popup.addListener("hide", utils.bind(this._onPopupHide, this));popup.addListener("postrender", utils.bind(function () {
          popup.getDom("body").appendChild(uiUtils.createElementByHtml('<div id="' + this.popup.id + '_bordereraser" class="edui-bordereraser edui-background" style="width:' + (uiUtils.getClientRect(this.getDom()).width + 20) + 'px"></div>'));popup.getDom().className += " " + this.className;
        }, this));this.popup = popup;
      }, _onPopupShow: function _onPopupShow() {
        this.addState("opened");
      }, _onPopupHide: function _onPopupHide() {
        this.removeState("opened");
      }, getHtmlTpl: function getHtmlTpl() {
        return '<div id="##" class="edui-box %%">' + "<div " + (this.title ? 'title="' + this.title + '"' : "") + ' id="##_state" stateful><div class="%%-body">' + '<div id="##_button_body" class="edui-box edui-button-body" onclick="$$._onButtonClick(event, this);">' + '<div class="edui-box edui-icon"></div>' + "</div>" + '<div class="edui-box edui-splitborder"></div>' + '<div class="edui-box edui-arrow" onclick="$$._onArrowClick();"></div>' + "</div></div></div>";
      }, showPopup: function showPopup() {
        var rect = uiUtils.getClientRect(this.getDom());rect.top -= this.popup.SHADOW_RADIUS;rect.height += this.popup.SHADOW_RADIUS;this.popup.showAnchorRect(rect);
      }, _onArrowClick: function _onArrowClick(event, el) {
        if (!this.isDisabled()) {
          this.showPopup();
        }
      }, _onButtonClick: function _onButtonClick() {
        if (!this.isDisabled()) {
          this.fireEvent("buttonclick");
        }
      } };utils.inherits(SplitButton, UIBase);utils.extend(SplitButton.prototype, Stateful, true);
  })();(function () {
    var utils = baidu.editor.utils,
        uiUtils = baidu.editor.ui.uiUtils,
        ColorPicker = baidu.editor.ui.ColorPicker,
        Popup = baidu.editor.ui.Popup,
        SplitButton = baidu.editor.ui.SplitButton,
        ColorButton = baidu.editor.ui.ColorButton = function (options) {
      this.initOptions(options);this.initColorButton();
    };ColorButton.prototype = { initColorButton: function initColorButton() {
        var me = this;this.popup = new Popup({ content: new ColorPicker({ noColorText: me.editor.getLang("clearColor"), editor: me.editor, onpickcolor: function onpickcolor(t, color) {
              me._onPickColor(color);
            }, onpicknocolor: function onpicknocolor(t, color) {
              me._onPickNoColor(color);
            } }), editor: me.editor });this.initSplitButton();
      }, _SplitButton_postRender: SplitButton.prototype.postRender, postRender: function postRender() {
        this._SplitButton_postRender();this.getDom("button_body").appendChild(uiUtils.createElementByHtml('<div id="' + this.id + '_colorlump" class="edui-colorlump"></div>'));this.getDom().className += " edui-colorbutton";
      }, setColor: function setColor(color) {
        this.getDom("colorlump").style.backgroundColor = color;this.color = color;
      }, _onPickColor: function _onPickColor(color) {
        if (this.fireEvent("pickcolor", color) !== false) {
          this.setColor(color);this.popup.hide();
        }
      }, _onPickNoColor: function _onPickNoColor(color) {
        if (this.fireEvent("picknocolor") !== false) {
          this.popup.hide();
        }
      } };utils.inherits(ColorButton, SplitButton);
  })();(function () {
    var utils = baidu.editor.utils,
        Popup = baidu.editor.ui.Popup,
        TablePicker = baidu.editor.ui.TablePicker,
        SplitButton = baidu.editor.ui.SplitButton,
        TableButton = baidu.editor.ui.TableButton = function (options) {
      this.initOptions(options);this.initTableButton();
    };TableButton.prototype = { initTableButton: function initTableButton() {
        var me = this;this.popup = new Popup({ content: new TablePicker({ editor: me.editor, onpicktable: function onpicktable(t, numCols, numRows) {
              me._onPickTable(numCols, numRows);
            } }), "editor": me.editor });this.initSplitButton();
      }, _onPickTable: function _onPickTable(numCols, numRows) {
        if (this.fireEvent("picktable", numCols, numRows) !== false) {
          this.popup.hide();
        }
      } };utils.inherits(TableButton, SplitButton);
  })();(function () {
    var utils = baidu.editor.utils,
        UIBase = baidu.editor.ui.UIBase;var AutoTypeSetPicker = baidu.editor.ui.AutoTypeSetPicker = function (options) {
      this.initOptions(options);this.initAutoTypeSetPicker();
    };AutoTypeSetPicker.prototype = { initAutoTypeSetPicker: function initAutoTypeSetPicker() {
        this.initUIBase();
      }, getHtmlTpl: function getHtmlTpl() {
        var me = this.editor,
            opt = me.options.autotypeset,
            lang = me.getLang("autoTypeSet");var textAlignInputName = "textAlignValue" + me.uid,
            imageBlockInputName = "imageBlockLineValue" + me.uid,
            symbolConverInputName = "symbolConverValue" + me.uid;return '<div id="##" class="edui-autotypesetpicker %%">' + '<div class="edui-autotypesetpicker-body">' + "<table >" + '<tr><td nowrap><input type="checkbox" name="mergeEmptyline" ' + (opt["mergeEmptyline"] ? "checked" : "") + ">" + lang.mergeLine + '</td><td colspan="2"><input type="checkbox" name="removeEmptyline" ' + (opt["removeEmptyline"] ? "checked" : "") + ">" + lang.delLine + "</td></tr>" + '<tr><td nowrap><input type="checkbox" name="removeClass" ' + (opt["removeClass"] ? "checked" : "") + ">" + lang.removeFormat + '</td><td colspan="2"><input type="checkbox" name="indent" ' + (opt["indent"] ? "checked" : "") + ">" + lang.indent + "</td></tr>" + "<tr>" + '<td nowrap><input type="checkbox" name="textAlign" ' + (opt["textAlign"] ? "checked" : "") + ">" + lang.alignment + "</td>" + '<td colspan="2" id="' + textAlignInputName + '">' + '<input type="radio" name="' + textAlignInputName + '" value="left" ' + (opt["textAlign"] && opt["textAlign"] == "left" ? "checked" : "") + ">" + me.getLang("justifyleft") + '<input type="radio" name="' + textAlignInputName + '" value="center" ' + (opt["textAlign"] && opt["textAlign"] == "center" ? "checked" : "") + ">" + me.getLang("justifycenter") + '<input type="radio" name="' + textAlignInputName + '" value="right" ' + (opt["textAlign"] && opt["textAlign"] == "right" ? "checked" : "") + ">" + me.getLang("justifyright") + "</td>" + "</tr>" + "<tr>" + '<td nowrap><input type="checkbox" name="imageBlockLine" ' + (opt["imageBlockLine"] ? "checked" : "") + ">" + lang.imageFloat + "</td>" + '<td nowrap id="' + imageBlockInputName + '">' + '<input type="radio" name="' + imageBlockInputName + '" value="none" ' + (opt["imageBlockLine"] && opt["imageBlockLine"] == "none" ? "checked" : "") + ">" + me.getLang("default") + '<input type="radio" name="' + imageBlockInputName + '" value="left" ' + (opt["imageBlockLine"] && opt["imageBlockLine"] == "left" ? "checked" : "") + ">" + me.getLang("justifyleft") + '<input type="radio" name="' + imageBlockInputName + '" value="center" ' + (opt["imageBlockLine"] && opt["imageBlockLine"] == "center" ? "checked" : "") + ">" + me.getLang("justifycenter") + '<input type="radio" name="' + imageBlockInputName + '" value="right" ' + (opt["imageBlockLine"] && opt["imageBlockLine"] == "right" ? "checked" : "") + ">" + me.getLang("justifyright") + "</td>" + "</tr>" + '<tr><td nowrap><input type="checkbox" name="clearFontSize" ' + (opt["clearFontSize"] ? "checked" : "") + ">" + lang.removeFontsize + '</td><td colspan="2"><input type="checkbox" name="clearFontFamily" ' + (opt["clearFontFamily"] ? "checked" : "") + ">" + lang.removeFontFamily + "</td></tr>" + '<tr><td nowrap colspan="3"><input type="checkbox" name="removeEmptyNode" ' + (opt["removeEmptyNode"] ? "checked" : "") + ">" + lang.removeHtml + "</td></tr>" + '<tr><td nowrap colspan="3"><input type="checkbox" name="pasteFilter" ' + (opt["pasteFilter"] ? "checked" : "") + ">" + lang.pasteFilter + "</td></tr>" + "<tr>" + '<td nowrap><input type="checkbox" name="symbolConver" ' + (opt["bdc2sb"] || opt["tobdc"] ? "checked" : "") + ">" + lang.symbol + "</td>" + '<td id="' + symbolConverInputName + '">' + '<input type="radio" name="bdc" value="bdc2sb" ' + (opt["bdc2sb"] ? "checked" : "") + ">" + lang.bdc2sb + '<input type="radio" name="bdc" value="tobdc" ' + (opt["tobdc"] ? "checked" : "") + ">" + lang.tobdc + "" + "</td>" + '<td nowrap align="right"><button >' + lang.run + "</button></td>" + "</tr>" + "</table>" + "</div>" + "</div>";
      }, _UIBase_render: UIBase.prototype.render };utils.inherits(AutoTypeSetPicker, UIBase);
  })();(function () {
    var utils = baidu.editor.utils,
        Popup = baidu.editor.ui.Popup,
        AutoTypeSetPicker = baidu.editor.ui.AutoTypeSetPicker,
        SplitButton = baidu.editor.ui.SplitButton,
        AutoTypeSetButton = baidu.editor.ui.AutoTypeSetButton = function (options) {
      this.initOptions(options);this.initAutoTypeSetButton();
    };function getPara(me) {
      var opt = {},
          cont = me.getDom(),
          editorId = me.editor.uid,
          inputType = null,
          attrName = null,
          ipts = domUtils.getElementsByTagName(cont, "input");for (var i = ipts.length - 1, ipt; ipt = ipts[i--];) {
        inputType = ipt.getAttribute("type");if (inputType == "checkbox") {
          attrName = ipt.getAttribute("name");opt[attrName] && delete opt[attrName];if (ipt.checked) {
            var attrValue = document.getElementById(attrName + "Value" + editorId);if (attrValue) {
              if (/input/ig.test(attrValue.tagName)) {
                opt[attrName] = attrValue.value;
              } else {
                var iptChilds = attrValue.getElementsByTagName("input");for (var j = iptChilds.length - 1, iptchild; iptchild = iptChilds[j--];) {
                  if (iptchild.checked) {
                    opt[attrName] = iptchild.value;break;
                  }
                }
              }
            } else {
              opt[attrName] = true;
            }
          } else {
            opt[attrName] = false;
          }
        } else {
          opt[ipt.getAttribute("value")] = ipt.checked;
        }
      }var selects = domUtils.getElementsByTagName(cont, "select");for (var i = 0, si; si = selects[i++];) {
        var attr = si.getAttribute("name");opt[attr] = opt[attr] ? si.value : "";
      }utils.extend(me.editor.options.autotypeset, opt);me.editor.setPreferences("autotypeset", opt);
    }AutoTypeSetButton.prototype = { initAutoTypeSetButton: function initAutoTypeSetButton() {
        var me = this;this.popup = new Popup({ content: new AutoTypeSetPicker({ editor: me.editor }), "editor": me.editor, hide: function hide() {
            if (!this._hidden && this.getDom()) {
              getPara(this);this.getDom().style.display = "none";this._hidden = true;this.fireEvent("hide");
            }
          } });var flag = 0;this.popup.addListener("postRenderAfter", function () {
          var popupUI = this;if (flag) {
            return;
          }var cont = this.getDom(),
              btn = cont.getElementsByTagName("button")[0];btn.onclick = function () {
            getPara(popupUI);me.editor.execCommand("autotypeset");popupUI.hide();
          };domUtils.on(cont, "click", function (e) {
            var target = e.target || e.srcElement,
                editorId = me.editor.uid;if (target && target.tagName == "INPUT") {
              if (target.name == "imageBlockLine" || target.name == "textAlign" || target.name == "symbolConver") {
                var checked = target.checked,
                    radioTd = document.getElementById(target.name + "Value" + editorId),
                    radios = radioTd.getElementsByTagName("input"),
                    defalutSelect = { "imageBlockLine": "none", "textAlign": "left", "symbolConver": "tobdc" };for (var i = 0; i < radios.length; i++) {
                  if (checked) {
                    if (radios[i].value == defalutSelect[target.name]) {
                      radios[i].checked = "checked";
                    }
                  } else {
                    radios[i].checked = false;
                  }
                }
              }if (target.name == "imageBlockLineValue" + editorId || target.name == "textAlignValue" + editorId || target.name == "bdc") {
                var checkboxs = target.parentNode.previousSibling.getElementsByTagName("input");checkboxs && (checkboxs[0].checked = true);
              }getPara(popupUI);
            }
          });flag = 1;
        });this.initSplitButton();
      } };utils.inherits(AutoTypeSetButton, SplitButton);
  })();(function () {
    var utils = baidu.editor.utils,
        Popup = baidu.editor.ui.Popup,
        Stateful = baidu.editor.ui.Stateful,
        UIBase = baidu.editor.ui.UIBase;var CellAlignPicker = baidu.editor.ui.CellAlignPicker = function (options) {
      this.initOptions(options);this.initSelected();this.initCellAlignPicker();
    };CellAlignPicker.prototype = { initSelected: function initSelected() {
        var status = { valign: { top: 0, middle: 1, bottom: 2 }, align: { left: 0, center: 1, right: 2 }, count: 3 },
            result = -1;if (this.selected) {
          this.selectedIndex = status.valign[this.selected.valign] * status.count + status.align[this.selected.align];
        }
      }, initCellAlignPicker: function initCellAlignPicker() {
        this.initUIBase();this.Stateful_init();
      }, getHtmlTpl: function getHtmlTpl() {
        var alignType = ["left", "center", "right"],
            COUNT = 9,
            tempClassName = null,
            tempIndex = -1,
            tmpl = [];for (var i = 0; i < COUNT; i++) {
          tempClassName = this.selectedIndex === i ? ' class="edui-cellalign-selected" ' : "";tempIndex = i % 3;tempIndex === 0 && tmpl.push("<tr>");tmpl.push('<td index="' + i + '" ' + tempClassName + ' stateful><div class="edui-icon edui-' + alignType[tempIndex] + '"></div></td>');tempIndex === 2 && tmpl.push("</tr>");
        }return '<div id="##" class="edui-cellalignpicker %%">' + '<div class="edui-cellalignpicker-body">' + '<table onclick="$$._onClick(event);">' + tmpl.join("") + "</table>" + "</div>" + "</div>";
      }, getStateDom: function getStateDom() {
        return this.target;
      }, _onClick: function _onClick(evt) {
        var target = evt.target || evt.srcElement;if (/icon/.test(target.className)) {
          this.items[target.parentNode.getAttribute("index")].onclick();Popup.postHide(evt);
        }
      }, _UIBase_render: UIBase.prototype.render };utils.inherits(CellAlignPicker, UIBase);utils.extend(CellAlignPicker.prototype, Stateful, true);
  })();(function () {
    var utils = baidu.editor.utils,
        Stateful = baidu.editor.ui.Stateful,
        uiUtils = baidu.editor.ui.uiUtils,
        UIBase = baidu.editor.ui.UIBase;var PastePicker = baidu.editor.ui.PastePicker = function (options) {
      this.initOptions(options);this.initPastePicker();
    };PastePicker.prototype = { initPastePicker: function initPastePicker() {
        this.initUIBase();this.Stateful_init();
      }, getHtmlTpl: function getHtmlTpl() {
        return '<div class="edui-pasteicon" onclick="$$._onClick(this)"></div>' + '<div class="edui-pastecontainer">' + '<div class="edui-title">' + this.editor.getLang("pasteOpt") + "</div>" + '<div class="edui-button">' + '<div title="' + this.editor.getLang("pasteSourceFormat") + '" onclick="$$.format(false)" stateful>' + '<div class="edui-richtxticon"></div></div>' + '<div title="' + this.editor.getLang("tagFormat") + '" onclick="$$.format(2)" stateful>' + '<div class="edui-tagicon"></div></div>' + '<div title="' + this.editor.getLang("pasteTextFormat") + '" onclick="$$.format(true)" stateful>' + '<div class="edui-plaintxticon"></div></div>' + "</div>" + "</div>" + "</div>";
      }, getStateDom: function getStateDom() {
        return this.target;
      }, format: function format(param) {
        this.editor.ui._isTransfer = true;this.editor.fireEvent("pasteTransfer", param);
      }, _onClick: function _onClick(cur) {
        var node = domUtils.getNextDomNode(cur),
            screenHt = uiUtils.getViewportRect().height,
            subPop = uiUtils.getClientRect(node);if (subPop.top + subPop.height > screenHt) {
          node.style.top = -subPop.height - cur.offsetHeight + "px";
        } else {
          node.style.top = "";
        }if (/hidden/ig.test(domUtils.getComputedStyle(node, "visibility"))) {
          node.style.visibility = "visible";domUtils.addClass(cur, "edui-state-opened");
        } else {
          node.style.visibility = "hidden";domUtils.removeClasses(cur, "edui-state-opened");
        }
      }, _UIBase_render: UIBase.prototype.render };utils.inherits(PastePicker, UIBase);utils.extend(PastePicker.prototype, Stateful, true);
  })();(function () {
    var utils = baidu.editor.utils,
        uiUtils = baidu.editor.ui.uiUtils,
        UIBase = baidu.editor.ui.UIBase,
        Toolbar = baidu.editor.ui.Toolbar = function (options) {
      this.initOptions(options);this.initToolbar();
    };Toolbar.prototype = { items: null, initToolbar: function initToolbar() {
        this.items = this.items || [];this.initUIBase();
      }, add: function add(item, index) {
        if (index === undefined) {
          this.items.push(item);
        } else {
          this.items.splice(index, 0, item);
        }
      }, getHtmlTpl: function getHtmlTpl() {
        var buff = [];for (var i = 0; i < this.items.length; i++) {
          buff[i] = this.items[i].renderHtml();
        }return '<div id="##" class="edui-toolbar %%" onselectstart="return false;" onmousedown="return $$._onMouseDown(event, this);">' + buff.join("") + "</div>";
      }, postRender: function postRender() {
        var box = this.getDom();for (var i = 0; i < this.items.length; i++) {
          this.items[i].postRender();
        }uiUtils.makeUnselectable(box);
      }, _onMouseDown: function _onMouseDown(e) {
        var target = e.target || e.srcElement,
            tagName = target && target.tagName && target.tagName.toLowerCase();if (tagName == "input" || tagName == "object" || tagName == "object") {
          return false;
        }
      } };utils.inherits(Toolbar, UIBase);
  })();(function () {
    var utils = baidu.editor.utils,
        domUtils = baidu.editor.dom.domUtils,
        uiUtils = baidu.editor.ui.uiUtils,
        UIBase = baidu.editor.ui.UIBase,
        Popup = baidu.editor.ui.Popup,
        Stateful = baidu.editor.ui.Stateful,
        CellAlignPicker = baidu.editor.ui.CellAlignPicker,
        Menu = baidu.editor.ui.Menu = function (options) {
      this.initOptions(options);this.initMenu();
    };var menuSeparator = { renderHtml: function renderHtml() {
        return '<div class="edui-menuitem edui-menuseparator"><div class="edui-menuseparator-inner"></div></div>';
      }, postRender: function postRender() {}, queryAutoHide: function queryAutoHide() {
        return true;
      } };Menu.prototype = { items: null, uiName: "menu", initMenu: function initMenu() {
        this.items = this.items || [];this.initPopup();this.initItems();
      }, initItems: function initItems() {
        for (var i = 0; i < this.items.length; i++) {
          var item = this.items[i];if (item == "-") {
            this.items[i] = this.getSeparator();
          } else {
            if (!(item instanceof MenuItem)) {
              item.editor = this.editor;item.theme = this.editor.options.theme;this.items[i] = this.createItem(item);
            }
          }
        }
      }, getSeparator: function getSeparator() {
        return menuSeparator;
      }, createItem: function createItem(item) {
        item.menu = this;return new MenuItem(item);
      }, _Popup_getContentHtmlTpl: Popup.prototype.getContentHtmlTpl, getContentHtmlTpl: function getContentHtmlTpl() {
        if (this.items.length == 0) {
          return this._Popup_getContentHtmlTpl();
        }var buff = [];for (var i = 0; i < this.items.length; i++) {
          var item = this.items[i];buff[i] = item.renderHtml();
        }return '<div class="%%-body">' + buff.join("") + "</div>";
      }, _Popup_postRender: Popup.prototype.postRender, postRender: function postRender() {
        var me = this;for (var i = 0; i < this.items.length; i++) {
          var item = this.items[i];item.ownerMenu = this;item.postRender();
        }domUtils.on(this.getDom(), "mouseover", function (evt) {
          evt = evt || event;var rel = evt.relatedTarget || evt.fromElement;var el = me.getDom();if (!uiUtils.contains(el, rel) && el !== rel) {
            me.fireEvent("over");
          }
        });this._Popup_postRender();
      }, queryAutoHide: function queryAutoHide(el) {
        if (el) {
          if (uiUtils.contains(this.getDom(), el)) {
            return false;
          }for (var i = 0; i < this.items.length; i++) {
            var item = this.items[i];if (item.queryAutoHide(el) === false) {
              return false;
            }
          }
        }
      }, clearItems: function clearItems() {
        for (var i = 0; i < this.items.length; i++) {
          var item = this.items[i];clearTimeout(item._showingTimer);clearTimeout(item._closingTimer);if (item.subMenu) {
            item.subMenu.destroy();
          }
        }this.items = [];
      }, destroy: function destroy() {
        if (this.getDom()) {
          domUtils.remove(this.getDom());
        }this.clearItems();
      }, dispose: function dispose() {
        this.destroy();
      } };utils.inherits(Menu, Popup);var MenuItem = baidu.editor.ui.MenuItem = function (options) {
      this.initOptions(options);this.initUIBase();this.Stateful_init();if (this.subMenu && !(this.subMenu instanceof Menu)) {
        if (options.className && options.className.indexOf("aligntd") != -1) {
          var me = this;this.subMenu.selected = this.editor.queryCommandValue("cellalignment");this.subMenu = new Popup({ content: new CellAlignPicker(this.subMenu), parentMenu: me, editor: me.editor, destroy: function destroy() {
              if (this.getDom()) {
                domUtils.remove(this.getDom());
              }
            } });this.subMenu.addListener("postRenderAfter", function () {
            domUtils.on(this.getDom(), "mouseover", function () {
              me.addState("opened");
            });
          });
        } else {
          this.subMenu = new Menu(this.subMenu);
        }
      }
    };MenuItem.prototype = { label: "", subMenu: null, ownerMenu: null, uiName: "menuitem", alwalysHoverable: true, getHtmlTpl: function getHtmlTpl() {
        return '<div id="##" class="%%" stateful onclick="$$._onClick(event, this);">' + '<div class="%%-body">' + this.renderLabelHtml() + "</div>" + "</div>";
      }, postRender: function postRender() {
        var me = this;this.addListener("over", function () {
          me.ownerMenu.fireEvent("submenuover", me);if (me.subMenu) {
            me.delayShowSubMenu();
          }
        });if (this.subMenu) {
          this.getDom().className += " edui-hassubmenu";this.subMenu.render();this.addListener("out", function () {
            me.delayHideSubMenu();
          });this.subMenu.addListener("over", function () {
            clearTimeout(me._closingTimer);me._closingTimer = null;me.addState("opened");
          });this.ownerMenu.addListener("hide", function () {
            me.hideSubMenu();
          });this.ownerMenu.addListener("submenuover", function (t, subMenu) {
            if (subMenu !== me) {
              me.delayHideSubMenu();
            }
          });this.subMenu._bakQueryAutoHide = this.subMenu.queryAutoHide;this.subMenu.queryAutoHide = function (el) {
            if (el && uiUtils.contains(me.getDom(), el)) {
              return false;
            }return this._bakQueryAutoHide(el);
          };
        }this.getDom().style.tabIndex = "-1";uiUtils.makeUnselectable(this.getDom());this.Stateful_postRender();
      }, delayShowSubMenu: function delayShowSubMenu() {
        var me = this;if (!me.isDisabled()) {
          me.addState("opened");clearTimeout(me._showingTimer);clearTimeout(me._closingTimer);me._closingTimer = null;me._showingTimer = setTimeout(function () {
            me.showSubMenu();
          }, 250);
        }
      }, delayHideSubMenu: function delayHideSubMenu() {
        var me = this;if (!me.isDisabled()) {
          me.removeState("opened");clearTimeout(me._showingTimer);if (!me._closingTimer) {
            me._closingTimer = setTimeout(function () {
              if (!me.hasState("opened")) {
                me.hideSubMenu();
              }me._closingTimer = null;
            }, 400);
          }
        }
      }, renderLabelHtml: function renderLabelHtml() {
        return '<div class="edui-arrow"></div>' + '<div class="edui-box edui-icon"></div>' + '<div class="edui-box edui-label %%-label">' + (this.label || "") + "</div>";
      }, getStateDom: function getStateDom() {
        return this.getDom();
      }, queryAutoHide: function queryAutoHide(el) {
        if (this.subMenu && this.hasState("opened")) {
          return this.subMenu.queryAutoHide(el);
        }
      }, _onClick: function _onClick(event, this_) {
        if (this.hasState("disabled")) {
          return;
        }if (this.fireEvent("click", event, this_) !== false) {
          if (this.subMenu) {
            this.showSubMenu();
          } else {
            Popup.postHide(event);
          }
        }
      }, showSubMenu: function showSubMenu() {
        var rect = uiUtils.getClientRect(this.getDom());rect.right -= 5;rect.left += 2;rect.width -= 7;rect.top -= 4;rect.bottom += 4;rect.height += 8;this.subMenu.showAnchorRect(rect, true, true);
      }, hideSubMenu: function hideSubMenu() {
        this.subMenu.hide();
      } };utils.inherits(MenuItem, UIBase);utils.extend(MenuItem.prototype, Stateful, true);
  })();(function () {
    var utils = baidu.editor.utils,
        uiUtils = baidu.editor.ui.uiUtils,
        Menu = baidu.editor.ui.Menu,
        SplitButton = baidu.editor.ui.SplitButton,
        Combox = baidu.editor.ui.Combox = function (options) {
      this.initOptions(options);this.initCombox();
    };Combox.prototype = { uiName: "combox", onbuttonclick: function onbuttonclick() {
        this.showPopup();
      }, initCombox: function initCombox() {
        var me = this;this.items = this.items || [];for (var i = 0; i < this.items.length; i++) {
          var item = this.items[i];item.uiName = "listitem";item.index = i;item.onclick = function () {
            me.selectByIndex(this.index);
          };
        }this.popup = new Menu({ items: this.items, uiName: "list", editor: this.editor, captureWheel: true, combox: this });this.initSplitButton();
      }, _SplitButton_postRender: SplitButton.prototype.postRender, postRender: function postRender() {
        this._SplitButton_postRender();this.setLabel(this.label || "");this.setValue(this.initValue || "");
      }, showPopup: function showPopup() {
        var rect = uiUtils.getClientRect(this.getDom());rect.top += 1;rect.bottom -= 1;rect.height -= 2;this.popup.showAnchorRect(rect);
      }, getValue: function getValue() {
        return this.value;
      }, setValue: function setValue(value) {
        var index = this.indexByValue(value);if (index != -1) {
          this.selectedIndex = index;this.setLabel(this.items[index].label);this.value = this.items[index].value;
        } else {
          this.selectedIndex = -1;this.setLabel(this.getLabelForUnknowValue(value));this.value = value;
        }
      }, setLabel: function setLabel(label) {
        this.getDom("button_body").innerHTML = label;this.label = label;
      }, getLabelForUnknowValue: function getLabelForUnknowValue(value) {
        return value;
      }, indexByValue: function indexByValue(value) {
        for (var i = 0; i < this.items.length; i++) {
          if (value == this.items[i].value) {
            return i;
          }
        }return -1;
      }, getItem: function getItem(index) {
        return this.items[index];
      }, selectByIndex: function selectByIndex(index) {
        if (index < this.items.length && this.fireEvent("select", index) !== false) {
          this.selectedIndex = index;this.value = this.items[index].value;this.setLabel(this.items[index].label);
        }
      } };utils.inherits(Combox, SplitButton);
  })();(function () {
    var utils = baidu.editor.utils,
        domUtils = baidu.editor.dom.domUtils,
        uiUtils = baidu.editor.ui.uiUtils,
        Mask = baidu.editor.ui.Mask,
        UIBase = baidu.editor.ui.UIBase,
        Button = baidu.editor.ui.Button,
        Dialog = baidu.editor.ui.Dialog = function (options) {
      if (options.name) {
        var name = options.name;var cssRules = options.cssRules;if (!options.className) {
          options.className = "edui-for-" + name;
        }if (cssRules) {
          options.cssRules = ".edui-default .edui-for-" + name + " .edui-dialog-content  {" + cssRules + "}";
        }
      }this.initOptions(utils.extend({ autoReset: true, draggable: true, onok: function onok() {}, oncancel: function oncancel() {}, onclose: function onclose(t, ok) {
          return ok ? this.onok() : this.oncancel();
        }, holdScroll: false }, options));this.initDialog();
    };var modalMask;var dragMask;var activeDialog;Dialog.prototype = { draggable: false, uiName: "dialog", initDialog: function initDialog() {
        var me = this,
            theme = this.editor.options.theme;if (this.cssRules) {
          utils.cssRule("edui-customize-" + this.name + "-style", this.cssRules);
        }this.initUIBase();this.modalMask = modalMask || (modalMask = new Mask({ className: "edui-dialog-modalmask", theme: theme, onclick: function onclick() {
            activeDialog && activeDialog.close(false);
          } }));this.dragMask = dragMask || (dragMask = new Mask({ className: "edui-dialog-dragmask", theme: theme }));this.closeButton = new Button({ className: "edui-dialog-closebutton", title: me.closeDialog, theme: theme, onclick: function onclick() {
            me.close(false);
          } });this.fullscreen && this.initResizeEvent();if (this.buttons) {
          for (var i = 0; i < this.buttons.length; i++) {
            if (!(this.buttons[i] instanceof Button)) {
              this.buttons[i] = new Button(utils.extend(this.buttons[i], { editor: this.editor }, true));
            }
          }
        }
      }, initResizeEvent: function initResizeEvent() {
        var me = this;domUtils.on(window, "resize", function () {
          if (me._hidden || me._hidden === undefined) {
            return;
          }if (me.__resizeTimer) {
            window.clearTimeout(me.__resizeTimer);
          }me.__resizeTimer = window.setTimeout(function () {
            me.__resizeTimer = null;var dialogWrapNode = me.getDom(),
                contentNode = me.getDom("content"),
                wrapRect = UE.ui.uiUtils.getClientRect(dialogWrapNode),
                contentRect = UE.ui.uiUtils.getClientRect(contentNode),
                vpRect = uiUtils.getViewportRect();contentNode.style.width = vpRect.width - wrapRect.width + contentRect.width + "px";contentNode.style.height = vpRect.height - wrapRect.height + contentRect.height + "px";dialogWrapNode.style.width = vpRect.width + "px";dialogWrapNode.style.height = vpRect.height + "px";me.fireEvent("resize");
          }, 100);
        });
      }, fitSize: function fitSize() {
        var popBodyEl = this.getDom("body");var size = this.mesureSize();popBodyEl.style.width = size.width + "px";popBodyEl.style.height = size.height + "px";return size;
      }, safeSetOffset: function safeSetOffset(offset) {
        var me = this;var el = me.getDom();var vpRect = uiUtils.getViewportRect();var rect = uiUtils.getClientRect(el);var left = offset.left;if (left + rect.width > vpRect.right) {
          left = vpRect.right - rect.width;
        }var top = offset.top;if (top + rect.height > vpRect.bottom) {
          top = vpRect.bottom - rect.height;
        }el.style.left = Math.max(left, 0) + "px";el.style.top = Math.max(top, 0) + "px";
      }, showAtCenter: function showAtCenter() {
        var vpRect = uiUtils.getViewportRect();if (!this.fullscreen) {
          this.getDom().style.display = "";var popSize = this.fitSize();var titleHeight = this.getDom("titlebar").offsetHeight | 0;var left = vpRect.width / 2 - popSize.width / 2;var top = vpRect.height / 2 - (popSize.height - titleHeight) / 2 - titleHeight;var popEl = this.getDom();this.safeSetOffset({ left: Math.max(left | 0, 0), top: Math.max(top | 0, 0) });if (!domUtils.hasClass(popEl, "edui-state-centered")) {
            popEl.className += " edui-state-centered";
          }
        } else {
          var dialogWrapNode = this.getDom(),
              contentNode = this.getDom("content");dialogWrapNode.style.display = "block";var wrapRect = UE.ui.uiUtils.getClientRect(dialogWrapNode),
              contentRect = UE.ui.uiUtils.getClientRect(contentNode);dialogWrapNode.style.left = "-100000px";contentNode.style.width = vpRect.width - wrapRect.width + contentRect.width + "px";contentNode.style.height = vpRect.height - wrapRect.height + contentRect.height + "px";dialogWrapNode.style.width = vpRect.width + "px";dialogWrapNode.style.height = vpRect.height + "px";dialogWrapNode.style.left = 0;this._originalContext = { html: { overflowX: document.documentElement.style.overflowX, overflowY: document.documentElement.style.overflowY }, body: { overflowX: document.body.style.overflowX, overflowY: document.body.style.overflowY } };document.documentElement.style.overflowX = "hidden";document.documentElement.style.overflowY = "hidden";document.body.style.overflowX = "hidden";document.body.style.overflowY = "hidden";
        }this._show();
      }, getContentHtml: function getContentHtml() {
        var contentHtml = "";if (typeof this.content == "string") {
          contentHtml = this.content;
        } else {
          if (this.iframeUrl) {
            contentHtml = '<span id="' + this.id + '_contmask" class="dialogcontmask"></span><iframe id="' + this.id + '_iframe" class="%%-iframe" height="100%" width="100%" frameborder="0" src="' + this.iframeUrl + '"></iframe>';
          }
        }return contentHtml;
      }, getHtmlTpl: function getHtmlTpl() {
        var footHtml = "";if (this.buttons) {
          var buff = [];for (var i = 0; i < this.buttons.length; i++) {
            buff[i] = this.buttons[i].renderHtml();
          }footHtml = '<div class="%%-foot">' + '<div id="##_buttons" class="%%-buttons">' + buff.join("") + "</div>" + "</div>";
        }return '<div id="##" class="%%"><div ' + (!this.fullscreen ? 'class="%%"' : 'class="%%-wrap edui-dialog-fullscreen-flag"') + '><div id="##_body" class="%%-body">' + '<div class="%%-shadow"></div>' + '<div id="##_titlebar" class="%%-titlebar">' + '<div class="%%-draghandle" onmousedown="$$._onTitlebarMouseDown(event, this);">' + '<span class="%%-caption">' + (this.title || "") + "</span>" + "</div>" + this.closeButton.renderHtml() + "</div>" + '<div id="##_content" class="%%-content">' + (this.autoReset ? "" : this.getContentHtml()) + "</div>" + footHtml + "</div></div></div>";
      }, postRender: function postRender() {
        if (!this.modalMask.getDom()) {
          this.modalMask.render();this.modalMask.hide();
        }if (!this.dragMask.getDom()) {
          this.dragMask.render();this.dragMask.hide();
        }var me = this;this.addListener("show", function () {
          me.modalMask.show(this.getDom().style.zIndex - 2);
        });this.addListener("hide", function () {
          me.modalMask.hide();
        });if (this.buttons) {
          for (var i = 0; i < this.buttons.length; i++) {
            this.buttons[i].postRender();
          }
        }domUtils.on(window, "resize", function () {
          setTimeout(function () {
            if (!me.isHidden()) {
              me.safeSetOffset(uiUtils.getClientRect(me.getDom()));
            }
          });
        });this._hide();
      }, mesureSize: function mesureSize() {
        var body = this.getDom("body");var width = uiUtils.getClientRect(this.getDom("content")).width;var dialogBodyStyle = body.style;dialogBodyStyle.width = width;return uiUtils.getClientRect(body);
      }, _onTitlebarMouseDown: function _onTitlebarMouseDown(evt, el) {
        if (this.draggable) {
          var rect;var vpRect = uiUtils.getViewportRect();var me = this;uiUtils.startDrag(evt, { ondragstart: function ondragstart() {
              rect = uiUtils.getClientRect(me.getDom());me.getDom("contmask").style.visibility = "visible";me.dragMask.show(me.getDom().style.zIndex - 1);
            }, ondragmove: function ondragmove(x, y) {
              var left = rect.left + x;var top = rect.top + y;me.safeSetOffset({ left: left, top: top });
            }, ondragstop: function ondragstop() {
              me.getDom("contmask").style.visibility = "hidden";domUtils.removeClasses(me.getDom(), ["edui-state-centered"]);me.dragMask.hide();
            } });
        }
      }, reset: function reset() {
        this.getDom("content").innerHTML = this.getContentHtml();this.fireEvent("dialogafterreset");
      }, _show: function _show() {
        if (this._hidden) {
          this.getDom().style.display = "";this.editor.container.style.zIndex && (this.getDom().style.zIndex = this.editor.container.style.zIndex * 1 + 10);this._hidden = false;this.fireEvent("show");baidu.editor.ui.uiUtils.getFixedLayer().style.zIndex = this.getDom().style.zIndex - 4;
        }
      }, isHidden: function isHidden() {
        return this._hidden;
      }, _hide: function _hide() {
        if (!this._hidden) {
          var wrapNode = this.getDom();wrapNode.style.display = "none";wrapNode.style.zIndex = "";wrapNode.style.width = "";wrapNode.style.height = "";this._hidden = true;this.fireEvent("hide");
        }
      }, open: function open() {
        if (this.autoReset) {
          try {
            this.reset();
          } catch (e) {
            this.render();this.open();
          }
        }this.showAtCenter();if (this.iframeUrl) {
          try {
            this.getDom("iframe").focus();
          } catch (ex) {}
        }activeDialog = this;
      }, _onCloseButtonClick: function _onCloseButtonClick(evt, el) {
        this.close(false);
      }, close: function close(ok) {
        if (this.fireEvent("close", ok) !== false) {
          if (this.fullscreen) {
            document.documentElement.style.overflowX = this._originalContext.html.overflowX;document.documentElement.style.overflowY = this._originalContext.html.overflowY;document.body.style.overflowX = this._originalContext.body.overflowX;document.body.style.overflowY = this._originalContext.body.overflowY;delete this._originalContext;
          }this._hide();var content = this.getDom("content");var iframe = this.getDom("iframe");if (content && iframe) {
            var doc = iframe.contentDocument || iframe.contentWindow.document;doc && (doc.body.innerHTML = "");domUtils.remove(content);
          }
        }
      } };utils.inherits(Dialog, UIBase);
  })();(function () {
    var utils = baidu.editor.utils,
        Menu = baidu.editor.ui.Menu,
        SplitButton = baidu.editor.ui.SplitButton,
        MenuButton = baidu.editor.ui.MenuButton = function (options) {
      this.initOptions(options);this.initMenuButton();
    };MenuButton.prototype = { initMenuButton: function initMenuButton() {
        var me = this;this.uiName = "menubutton";this.popup = new Menu({ items: me.items, className: me.className, editor: me.editor });this.popup.addListener("show", function () {
          var list = this;for (var i = 0; i < list.items.length; i++) {
            list.items[i].removeState("checked");if (list.items[i].value == me._value) {
              list.items[i].addState("checked");this.value = me._value;
            }
          }
        });this.initSplitButton();
      }, setValue: function setValue(value) {
        this._value = value;
      } };utils.inherits(MenuButton, SplitButton);
  })();(function () {
    var utils = baidu.editor.utils,
        Popup = baidu.editor.ui.Popup,
        SplitButton = baidu.editor.ui.SplitButton,
        MultiMenuPop = baidu.editor.ui.MultiMenuPop = function (options) {
      this.initOptions(options);this.initMultiMenu();
    };MultiMenuPop.prototype = { initMultiMenu: function initMultiMenu() {
        var me = this;this.popup = new Popup({ content: "", editor: me.editor, iframe_rendered: false, onshow: function onshow() {
            if (!this.iframe_rendered) {
              this.iframe_rendered = true;this.getDom("content").innerHTML = '<iframe id="' + me.id + '_iframe" src="' + me.iframeUrl + '" frameborder="0"></iframe>';me.editor.container.style.zIndex && (this.getDom().style.zIndex = me.editor.container.style.zIndex * 1 + 1);
            }
          } });this.onbuttonclick = function () {
          this.showPopup();
        };this.initSplitButton();
      } };utils.inherits(MultiMenuPop, SplitButton);
  })();(function () {
    var UI = baidu.editor.ui,
        UIBase = UI.UIBase,
        uiUtils = UI.uiUtils,
        utils = baidu.editor.utils,
        domUtils = baidu.editor.dom.domUtils;var allMenus = [],
        timeID,
        isSubMenuShow = false;var ShortCutMenu = UI.ShortCutMenu = function (options) {
      this.initOptions(options);this.initShortCutMenu();
    };ShortCutMenu.postHide = hideAllMenu;ShortCutMenu.prototype = { isHidden: true, SPACE: 5, initShortCutMenu: function initShortCutMenu() {
        this.items = this.items || [];this.initUIBase();this.initItems();this.initEvent();allMenus.push(this);
      }, initEvent: function initEvent() {
        var me = this,
            doc = me.editor.document;domUtils.on(doc, "mousemove", function (e) {
          if (me.isHidden === false) {
            if (me.getSubMenuMark() || me.eventType == "contextmenu") {
              return;
            }var flag = true,
                el = me.getDom(),
                wt = el.offsetWidth,
                ht = el.offsetHeight,
                distanceX = wt / 2 + me.SPACE,
                distanceY = ht / 2,
                x = Math.abs(e.screenX - me.left),
                y = Math.abs(e.screenY - me.top);clearTimeout(timeID);timeID = setTimeout(function () {
              if (y > 0 && y < distanceY) {
                me.setOpacity(el, "1");
              } else {
                if (y > distanceY && y < distanceY + 70) {
                  me.setOpacity(el, "0.5");flag = false;
                } else {
                  if (y > distanceY + 70 && y < distanceY + 140) {
                    me.hide();
                  }
                }
              }if (flag && x > 0 && x < distanceX) {
                me.setOpacity(el, "1");
              } else {
                if (x > distanceX && x < distanceX + 70) {
                  me.setOpacity(el, "0.5");
                } else {
                  if (x > distanceX + 70 && x < distanceX + 140) {
                    me.hide();
                  }
                }
              }
            });
          }
        });if (browser.chrome) {
          domUtils.on(doc, "mouseout", function (e) {
            var relatedTgt = e.relatedTarget || e.toElement;if (relatedTgt == null || relatedTgt.tagName == "HTML") {
              me.hide();
            }
          });
        }me.editor.addListener("afterhidepop", function () {
          if (!me.isHidden) {
            isSubMenuShow = true;
          }
        });
      }, initItems: function initItems() {
        if (utils.isArray(this.items)) {
          for (var i = 0, len = this.items.length; i < len; i++) {
            var item = this.items[i].toLowerCase();if (UI[item]) {
              this.items[i] = new UI[item](this.editor);this.items[i].className += " edui-shortcutsubmenu ";
            }
          }
        }
      }, setOpacity: function setOpacity(el, value) {
        if (browser.ie && browser.version < 9) {
          el.style.filter = "alpha(opacity = " + parseFloat(value) * 100 + ");";
        } else {
          el.style.opacity = value;
        }
      }, getSubMenuMark: function getSubMenuMark() {
        isSubMenuShow = false;var layerEle = uiUtils.getFixedLayer();var list = domUtils.getElementsByTagName(layerEle, "div", function (node) {
          return domUtils.hasClass(node, "edui-shortcutsubmenu edui-popup");
        });for (var i = 0, node; node = list[i++];) {
          if (node.style.display != "none") {
            isSubMenuShow = true;
          }
        }return isSubMenuShow;
      }, show: function show(e, hasContextmenu) {
        var me = this,
            offset = {},
            el = this.getDom(),
            fixedlayer = uiUtils.getFixedLayer();function setPos(offset) {
          if (offset.left < 0) {
            offset.left = 0;
          }if (offset.top < 0) {
            offset.top = 0;
          }el.style.cssText = "position:absolute;left:" + offset.left + "px;top:" + offset.top + "px;";
        }function setPosByCxtMenu(menu) {
          if (!menu.tagName) {
            menu = menu.getDom();
          }offset.left = parseInt(menu.style.left);offset.top = parseInt(menu.style.top);offset.top -= el.offsetHeight + 15;setPos(offset);
        }me.eventType = e.type;el.style.cssText = "display:block;left:-9999px";if (e.type == "contextmenu" && hasContextmenu) {
          var menu = domUtils.getElementsByTagName(fixedlayer, "div", "edui-contextmenu")[0];if (menu) {
            setPosByCxtMenu(menu);
          } else {
            me.editor.addListener("aftershowcontextmenu", function (type, menu) {
              setPosByCxtMenu(menu);
            });
          }
        } else {
          offset = uiUtils.getViewportOffsetByEvent(e);offset.top -= el.offsetHeight + me.SPACE;offset.left += me.SPACE + 20;setPos(offset);me.setOpacity(el, 0.2);
        }me.isHidden = false;me.left = e.screenX + el.offsetWidth / 2 - me.SPACE;me.top = e.screenY - el.offsetHeight / 2 - me.SPACE;if (me.editor) {
          el.style.zIndex = me.editor.container.style.zIndex * 1 + 10;fixedlayer.style.zIndex = el.style.zIndex - 1;
        }
      }, hide: function hide() {
        if (this.getDom()) {
          this.getDom().style.display = "none";
        }this.isHidden = true;
      }, postRender: function postRender() {
        if (utils.isArray(this.items)) {
          for (var i = 0, item; item = this.items[i++];) {
            item.postRender();
          }
        }
      }, getHtmlTpl: function getHtmlTpl() {
        var buff;if (utils.isArray(this.items)) {
          buff = [];for (var i = 0; i < this.items.length; i++) {
            buff[i] = this.items[i].renderHtml();
          }buff = buff.join("");
        } else {
          buff = this.items;
        }return '<div id="##" class="%% edui-toolbar" data-src="shortcutmenu" onmousedown="return false;" onselectstart="return false;" >' + buff + "</div>";
      } };utils.inherits(ShortCutMenu, UIBase);function hideAllMenu(e) {
      var tgt = e.target || e.srcElement,
          cur = domUtils.findParent(tgt, function (node) {
        return domUtils.hasClass(node, "edui-shortcutmenu") || domUtils.hasClass(node, "edui-popup");
      }, true);if (!cur) {
        for (var i = 0, menu; menu = allMenus[i++];) {
          menu.hide();
        }
      }
    }domUtils.on(document, "mousedown", function (e) {
      hideAllMenu(e);
    });domUtils.on(window, "scroll", function (e) {
      hideAllMenu(e);
    });
  })();(function () {
    var utils = baidu.editor.utils,
        UIBase = baidu.editor.ui.UIBase,
        Breakline = baidu.editor.ui.Breakline = function (options) {
      this.initOptions(options);this.initSeparator();
    };Breakline.prototype = { uiName: "Breakline", initSeparator: function initSeparator() {
        this.initUIBase();
      }, getHtmlTpl: function getHtmlTpl() {
        return "<br/>";
      } };utils.inherits(Breakline, UIBase);
  })();(function () {
    var utils = baidu.editor.utils,
        domUtils = baidu.editor.dom.domUtils,
        UIBase = baidu.editor.ui.UIBase,
        Message = baidu.editor.ui.Message = function (options) {
      this.initOptions(options);this.initMessage();
    };Message.prototype = { initMessage: function initMessage() {
        this.initUIBase();
      }, getHtmlTpl: function getHtmlTpl() {
        return '<div id="##" class="edui-message %%">' + ' <div id="##_closer" class="edui-message-closer">×</div>' + ' <div id="##_body" class="edui-message-body edui-message-type-info">' + ' <iframe style="position:absolute;z-index:-1;left:0;top:0;background-color: transparent;" frameborder="0" width="100%" height="100%" src="about:blank"></iframe>' + ' <div class="edui-shadow"></div>' + ' <div id="##_content" class="edui-message-content">' + "  </div>" + " </div>" + "</div>";
      }, reset: function reset(opt) {
        var me = this;if (!opt.keepshow) {
          clearTimeout(this.timer);me.timer = setTimeout(function () {
            me.hide();
          }, opt.timeout || 4000);
        }opt.content !== undefined && me.setContent(opt.content);opt.type !== undefined && me.setType(opt.type);me.show();
      }, postRender: function postRender() {
        var me = this,
            closer = this.getDom("closer");closer && domUtils.on(closer, "click", function () {
          me.hide();
        });
      }, setContent: function setContent(content) {
        this.getDom("content").innerHTML = content;
      }, setType: function setType(type) {
        type = type || "info";var body = this.getDom("body");body.className = body.className.replace(/edui-message-type-[\w-]+/, "edui-message-type-" + type);
      }, getContent: function getContent() {
        return this.getDom("content").innerHTML;
      }, getType: function getType() {
        var arr = this.getDom("body").match(/edui-message-type-([\w-]+)/);return arr ? arr[1] : "";
      }, show: function show() {
        this.getDom().style.display = "block";
      }, hide: function hide() {
        var dom = this.getDom();if (dom) {
          dom.style.display = "none";dom.parentNode && dom.parentNode.removeChild(dom);
        }
      } };utils.inherits(Message, UIBase);
  })();(function () {
    var utils = baidu.editor.utils;var editorui = baidu.editor.ui;var _Dialog = editorui.Dialog;editorui.buttons = {};editorui.Dialog = function (options) {
      var dialog = new _Dialog(options);dialog.addListener("hide", function () {
        if (dialog.editor) {
          var editor = dialog.editor;try {
            if (browser.gecko) {
              var y = editor.window.scrollY,
                  x = editor.window.scrollX;editor.body.focus();editor.window.scrollTo(x, y);
            } else {
              editor.focus();
            }
          } catch (ex) {}
        }
      });return dialog;
    };var iframeUrlMap = { "anchor": "~/dialogs/anchor/anchor.html", "insertimage": "~/dialogs/image/image.html", "link": "~/dialogs/link/link.html", "spechars": "~/dialogs/spechars/spechars.html", "searchreplace": "~/dialogs/searchreplace/searchreplace.html", "map": "~/dialogs/map/map.html", "gmap": "~/dialogs/gmap/gmap.html", "insertvideo": "~/dialogs/video/video.html", "help": "~/dialogs/help/help.html", "preview": "~/dialogs/preview/preview.html", "emotion": "~/dialogs/emotion/emotion.html", "wordimage": "~/dialogs/wordimage/wordimage.html", "attachment": "~/dialogs/attachment/attachment.html", "insertframe": "~/dialogs/insertframe/insertframe.html", "edittip": "~/dialogs/table/edittip.html", "edittable": "~/dialogs/table/edittable.html", "edittd": "~/dialogs/table/edittd.html", "webapp": "~/dialogs/webapp/webapp.html", "snapscreen": "~/dialogs/snapscreen/snapscreen.html", "scrawl": "~/dialogs/scrawl/scrawl.html", "music": "~/dialogs/music/music.html", "template": "~/dialogs/template/template.html", "background": "~/dialogs/background/background.html", "charts": "~/dialogs/charts/charts.html" };var btnCmds = ["undo", "redo", "formatmatch", "bold", "italic", "underline", "fontborder", "touppercase", "tolowercase", "strikethrough", "subscript", "superscript", "source", "indent", "outdent", "blockquote", "pasteplain", "pagebreak", "selectall", "print", "horizontal", "removeformat", "time", "date", "unlink", "insertparagraphbeforetable", "insertrow", "insertcol", "mergeright", "mergedown", "deleterow", "deletecol", "splittorows", "splittocols", "splittocells", "mergecells", "deletetable", "drafts"];for (var i = 0, ci; ci = btnCmds[i++];) {
      ci = ci.toLowerCase();editorui[ci] = function (cmd) {
        return function (editor) {
          var ui = new editorui.Button({ className: "edui-for-" + cmd, title: editor.options.labelMap[cmd] || editor.getLang("labelMap." + cmd) || "", onclick: function onclick() {
              editor.execCommand(cmd);
            }, theme: editor.options.theme, showText: false });editorui.buttons[cmd] = ui;editor.addListener("selectionchange", function (type, causeByUi, uiReady) {
            var state = editor.queryCommandState(cmd);if (state == -1) {
              ui.setDisabled(true);ui.setChecked(false);
            } else {
              if (!uiReady) {
                ui.setDisabled(false);ui.setChecked(state);
              }
            }
          });return ui;
        };
      }(ci);
    }editorui.cleardoc = function (editor) {
      var ui = new editorui.Button({ className: "edui-for-cleardoc", title: editor.options.labelMap.cleardoc || editor.getLang("labelMap.cleardoc") || "", theme: editor.options.theme, onclick: function onclick() {
          if (confirm(editor.getLang("confirmClear"))) {
            editor.execCommand("cleardoc");
          }
        } });editorui.buttons["cleardoc"] = ui;editor.addListener("selectionchange", function () {
        ui.setDisabled(editor.queryCommandState("cleardoc") == -1);
      });return ui;
    };var typeset = { "justify": ["left", "right", "center", "justify"], "imagefloat": ["none", "left", "center", "right"], "directionality": ["ltr", "rtl"] };for (var p in typeset) {
      (function (cmd, val) {
        for (var i = 0, ci; ci = val[i++];) {
          (function (cmd2) {
            editorui[cmd.replace("float", "") + cmd2] = function (editor) {
              var ui = new editorui.Button({ className: "edui-for-" + cmd.replace("float", "") + cmd2, title: editor.options.labelMap[cmd.replace("float", "") + cmd2] || editor.getLang("labelMap." + cmd.replace("float", "") + cmd2) || "", theme: editor.options.theme, onclick: function onclick() {
                  editor.execCommand(cmd, cmd2);
                } });editorui.buttons[cmd] = ui;editor.addListener("selectionchange", function (type, causeByUi, uiReady) {
                ui.setDisabled(editor.queryCommandState(cmd) == -1);ui.setChecked(editor.queryCommandValue(cmd) == cmd2 && !uiReady);
              });return ui;
            };
          })(ci);
        }
      })(p, typeset[p]);
    }for (var i = 0, ci; ci = ["backcolor", "forecolor"][i++];) {
      editorui[ci] = function (cmd) {
        return function (editor) {
          var ui = new editorui.ColorButton({ className: "edui-for-" + cmd, color: "default", title: editor.options.labelMap[cmd] || editor.getLang("labelMap." + cmd) || "", editor: editor, onpickcolor: function onpickcolor(t, color) {
              editor.execCommand(cmd, color);
            }, onpicknocolor: function onpicknocolor() {
              editor.execCommand(cmd, "default");this.setColor("transparent");this.color = "default";
            }, onbuttonclick: function onbuttonclick() {
              editor.execCommand(cmd, this.color);
            } });editorui.buttons[cmd] = ui;editor.addListener("selectionchange", function () {
            ui.setDisabled(editor.queryCommandState(cmd) == -1);
          });return ui;
        };
      }(ci);
    }var dialogBtns = { noOk: ["searchreplace", "help", "spechars", "webapp", "preview"], ok: ["attachment", "anchor", "link", "insertimage", "map", "gmap", "insertframe", "wordimage", "insertvideo", "insertframe", "edittip", "edittable", "edittd", "scrawl", "template", "music", "background", "charts"] };for (var p in dialogBtns) {
      (function (type, vals) {
        for (var i = 0, ci; ci = vals[i++];) {
          if (browser.opera && ci === "searchreplace") {
            continue;
          }(function (cmd) {
            editorui[cmd] = function (editor, iframeUrl, title) {
              iframeUrl = iframeUrl || (editor.options.iframeUrlMap || {})[cmd] || iframeUrlMap[cmd];title = editor.options.labelMap[cmd] || editor.getLang("labelMap." + cmd) || "";var dialog;if (iframeUrl) {
                dialog = new editorui.Dialog(utils.extend({ iframeUrl: editor.ui.mapUrl(iframeUrl), editor: editor, className: "edui-for-" + cmd, title: title, holdScroll: cmd === "insertimage", fullscreen: /charts|preview/.test(cmd), closeDialog: editor.getLang("closeDialog") }, type == "ok" ? { buttons: [{ className: "edui-okbutton", label: editor.getLang("ok"), editor: editor, onclick: function onclick() {
                      dialog.close(true);
                    } }, { className: "edui-cancelbutton", label: editor.getLang("cancel"), editor: editor, onclick: function onclick() {
                      dialog.close(false);
                    } }] } : {}));editor.ui._dialogs[cmd + "Dialog"] = dialog;
              }var ui = new editorui.Button({ className: "edui-for-" + cmd, title: title, onclick: function onclick() {
                  if (dialog) {
                    switch (cmd) {case "wordimage":
                        var images = editor.execCommand("wordimage");if (images && images.length) {
                          dialog.render();dialog.open();
                        }break;case "scrawl":
                        if (editor.queryCommandState("scrawl") != -1) {
                          dialog.render();dialog.open();
                        }break;default:
                        dialog.render();dialog.open();}
                  }
                }, theme: editor.options.theme, disabled: cmd == "scrawl" && editor.queryCommandState("scrawl") == -1 || cmd == "charts" });editorui.buttons[cmd] = ui;editor.addListener("selectionchange", function () {
                var unNeedCheckState = { "edittable": 1 };if (cmd in unNeedCheckState) {
                  return;
                }var state = editor.queryCommandState(cmd);if (ui.getDom()) {
                  ui.setDisabled(state == -1);ui.setChecked(state);
                }
              });return ui;
            };
          })(ci.toLowerCase());
        }
      })(p, dialogBtns[p]);
    }editorui.snapscreen = function (editor, iframeUrl, title) {
      title = editor.options.labelMap["snapscreen"] || editor.getLang("labelMap.snapscreen") || "";var ui = new editorui.Button({ className: "edui-for-snapscreen", title: title, onclick: function onclick() {
          editor.execCommand("snapscreen");
        }, theme: editor.options.theme });editorui.buttons["snapscreen"] = ui;iframeUrl = iframeUrl || (editor.options.iframeUrlMap || {})["snapscreen"] || iframeUrlMap["snapscreen"];if (iframeUrl) {
        var dialog = new editorui.Dialog({ iframeUrl: editor.ui.mapUrl(iframeUrl), editor: editor, className: "edui-for-snapscreen", title: title, buttons: [{ className: "edui-okbutton", label: editor.getLang("ok"), editor: editor, onclick: function onclick() {
              dialog.close(true);
            } }, { className: "edui-cancelbutton", label: editor.getLang("cancel"), editor: editor, onclick: function onclick() {
              dialog.close(false);
            } }] });dialog.render();editor.ui._dialogs["snapscreenDialog"] = dialog;
      }editor.addListener("selectionchange", function () {
        ui.setDisabled(editor.queryCommandState("snapscreen") == -1);
      });return ui;
    };editorui.insertcode = function (editor, list, title) {
      list = editor.options["insertcode"] || [];title = editor.options.labelMap["insertcode"] || editor.getLang("labelMap.insertcode") || "";var items = [];utils.each(list, function (key, val) {
        items.push({ label: key, value: val, theme: editor.options.theme, renderLabelHtml: function renderLabelHtml() {
            return '<div class="edui-label %%-label" >' + (this.label || "") + "</div>";
          } });
      });var ui = new editorui.Combox({ editor: editor, items: items, onselect: function onselect(t, index) {
          editor.execCommand("insertcode", this.items[index].value);
        }, onbuttonclick: function onbuttonclick() {
          this.showPopup();
        }, title: title, initValue: title, className: "edui-for-insertcode", indexByValue: function indexByValue(value) {
          if (value) {
            for (var i = 0, ci; ci = this.items[i]; i++) {
              if (ci.value.indexOf(value) != -1) {
                return i;
              }
            }
          }return -1;
        } });editorui.buttons["insertcode"] = ui;editor.addListener("selectionchange", function (type, causeByUi, uiReady) {
        if (!uiReady) {
          var state = editor.queryCommandState("insertcode");if (state == -1) {
            ui.setDisabled(true);
          } else {
            ui.setDisabled(false);var value = editor.queryCommandValue("insertcode");if (!value) {
              ui.setValue(title);return;
            }value && (value = value.replace(/['"]/g, "").split(",")[0]);ui.setValue(value);
          }
        }
      });return ui;
    };editorui.fontfamily = function (editor, list, title) {
      list = editor.options["fontfamily"] || [];title = editor.options.labelMap["fontfamily"] || editor.getLang("labelMap.fontfamily") || "";if (!list.length) {
        return;
      }for (var i = 0, ci, items = []; ci = list[i]; i++) {
        var langLabel = editor.getLang("fontfamily")[ci.name] || "";(function (key, val) {
          items.push({ label: key, value: val, theme: editor.options.theme, renderLabelHtml: function renderLabelHtml() {
              return '<div class="edui-label %%-label" style="font-family:' + utils.unhtml(this.value) + '">' + (this.label || "") + "</div>";
            } });
        })(ci.label || langLabel, ci.val);
      }var ui = new editorui.Combox({ editor: editor, items: items, onselect: function onselect(t, index) {
          editor.execCommand("FontFamily", this.items[index].value);
        }, onbuttonclick: function onbuttonclick() {
          this.showPopup();
        }, title: title, initValue: title, className: "edui-for-fontfamily", indexByValue: function indexByValue(value) {
          if (value) {
            for (var i = 0, ci; ci = this.items[i]; i++) {
              if (ci.value.indexOf(value) != -1) {
                return i;
              }
            }
          }return -1;
        } });editorui.buttons["fontfamily"] = ui;editor.addListener("selectionchange", function (type, causeByUi, uiReady) {
        if (!uiReady) {
          var state = editor.queryCommandState("FontFamily");if (state == -1) {
            ui.setDisabled(true);
          } else {
            ui.setDisabled(false);var value = editor.queryCommandValue("FontFamily");value && (value = value.replace(/['"]/g, "").split(",")[0]);ui.setValue(value);
          }
        }
      });return ui;
    };editorui.fontsize = function (editor, list, title) {
      title = editor.options.labelMap["fontsize"] || editor.getLang("labelMap.fontsize") || "";list = list || editor.options["fontsize"] || [];if (!list.length) {
        return;
      }var items = [];for (var i = 0; i < list.length; i++) {
        var size = list[i] + "px";items.push({ label: size, value: size, theme: editor.options.theme, renderLabelHtml: function renderLabelHtml() {
            return '<div class="edui-label %%-label" style="line-height:1;font-size:' + this.value + '">' + (this.label || "") + "</div>";
          } });
      }var ui = new editorui.Combox({ editor: editor, items: items, title: title, initValue: title, onselect: function onselect(t, index) {
          editor.execCommand("FontSize", this.items[index].value);
        }, onbuttonclick: function onbuttonclick() {
          this.showPopup();
        }, className: "edui-for-fontsize" });editorui.buttons["fontsize"] = ui;editor.addListener("selectionchange", function (type, causeByUi, uiReady) {
        if (!uiReady) {
          var state = editor.queryCommandState("FontSize");if (state == -1) {
            ui.setDisabled(true);
          } else {
            ui.setDisabled(false);ui.setValue(editor.queryCommandValue("FontSize"));
          }
        }
      });return ui;
    };editorui.paragraph = function (editor, list, title) {
      title = editor.options.labelMap["paragraph"] || editor.getLang("labelMap.paragraph") || "";list = editor.options["paragraph"] || [];if (utils.isEmptyObject(list)) {
        return;
      }var items = [];for (var i in list) {
        items.push({ value: i, label: list[i] || editor.getLang("paragraph")[i], theme: editor.options.theme, renderLabelHtml: function renderLabelHtml() {
            return '<div class="edui-label %%-label"><span class="edui-for-' + this.value + '">' + (this.label || "") + "</span></div>";
          } });
      }var ui = new editorui.Combox({ editor: editor, items: items, title: title, initValue: title, className: "edui-for-paragraph", onselect: function onselect(t, index) {
          editor.execCommand("Paragraph", this.items[index].value);
        }, onbuttonclick: function onbuttonclick() {
          this.showPopup();
        } });editorui.buttons["paragraph"] = ui;editor.addListener("selectionchange", function (type, causeByUi, uiReady) {
        if (!uiReady) {
          var state = editor.queryCommandState("Paragraph");if (state == -1) {
            ui.setDisabled(true);
          } else {
            ui.setDisabled(false);var value = editor.queryCommandValue("Paragraph");var index = ui.indexByValue(value);if (index != -1) {
              ui.setValue(value);
            } else {
              ui.setValue(ui.initValue);
            }
          }
        }
      });return ui;
    };editorui.customstyle = function (editor) {
      var list = editor.options["customstyle"] || [],
          title = editor.options.labelMap["customstyle"] || editor.getLang("labelMap.customstyle") || "";if (!list.length) {
        return;
      }var langCs = editor.getLang("customstyle");for (var i = 0, items = [], t; t = list[i++];) {
        (function (t) {
          var ck = {};ck.label = t.label ? t.label : langCs[t.name];ck.style = t.style;ck.className = t.className;ck.tag = t.tag;items.push({ label: ck.label, value: ck, theme: editor.options.theme, renderLabelHtml: function renderLabelHtml() {
              return '<div class="edui-label %%-label">' + "<" + ck.tag + " " + (ck.className ? ' class="' + ck.className + '"' : "") + (ck.style ? ' style="' + ck.style + '"' : "") + ">" + ck.label + "</" + ck.tag + ">" + "</div>";
            } });
        })(t);
      }var ui = new editorui.Combox({ editor: editor, items: items, title: title, initValue: title, className: "edui-for-customstyle", onselect: function onselect(t, index) {
          editor.execCommand("customstyle", this.items[index].value);
        }, onbuttonclick: function onbuttonclick() {
          this.showPopup();
        }, indexByValue: function indexByValue(value) {
          for (var i = 0, ti; ti = this.items[i++];) {
            if (ti.label == value) {
              return i - 1;
            }
          }return -1;
        } });editorui.buttons["customstyle"] = ui;editor.addListener("selectionchange", function (type, causeByUi, uiReady) {
        if (!uiReady) {
          var state = editor.queryCommandState("customstyle");if (state == -1) {
            ui.setDisabled(true);
          } else {
            ui.setDisabled(false);var value = editor.queryCommandValue("customstyle");var index = ui.indexByValue(value);if (index != -1) {
              ui.setValue(value);
            } else {
              ui.setValue(ui.initValue);
            }
          }
        }
      });return ui;
    };editorui.inserttable = function (editor, iframeUrl, title) {
      title = editor.options.labelMap["inserttable"] || editor.getLang("labelMap.inserttable") || "";var ui = new editorui.TableButton({ editor: editor, title: title, className: "edui-for-inserttable", onpicktable: function onpicktable(t, numCols, numRows) {
          editor.execCommand("InsertTable", { numRows: numRows, numCols: numCols, border: 1 });
        }, onbuttonclick: function onbuttonclick() {
          this.showPopup();
        } });editorui.buttons["inserttable"] = ui;editor.addListener("selectionchange", function () {
        ui.setDisabled(editor.queryCommandState("inserttable") == -1);
      });return ui;
    };editorui.lineheight = function (editor) {
      var val = editor.options.lineheight || [];if (!val.length) {
        return;
      }for (var i = 0, ci, items = []; ci = val[i++];) {
        items.push({ label: ci, value: ci, theme: editor.options.theme, onclick: function onclick() {
            editor.execCommand("lineheight", this.value);
          } });
      }var ui = new editorui.MenuButton({ editor: editor, className: "edui-for-lineheight", title: editor.options.labelMap["lineheight"] || editor.getLang("labelMap.lineheight") || "", items: items, onbuttonclick: function onbuttonclick() {
          var value = editor.queryCommandValue("LineHeight") || this.value;editor.execCommand("LineHeight", value);
        } });editorui.buttons["lineheight"] = ui;editor.addListener("selectionchange", function () {
        var state = editor.queryCommandState("LineHeight");if (state == -1) {
          ui.setDisabled(true);
        } else {
          ui.setDisabled(false);var value = editor.queryCommandValue("LineHeight");value && ui.setValue((value + "").replace(/cm/, ""));ui.setChecked(state);
        }
      });return ui;
    };var rowspacings = ["top", "bottom"];for (var r = 0, ri; ri = rowspacings[r++];) {
      (function (cmd) {
        editorui["rowspacing" + cmd] = function (editor) {
          var val = editor.options["rowspacing" + cmd] || [];if (!val.length) {
            return null;
          }for (var i = 0, ci, items = []; ci = val[i++];) {
            items.push({ label: ci, value: ci, theme: editor.options.theme, onclick: function onclick() {
                editor.execCommand("rowspacing", this.value, cmd);
              } });
          }var ui = new editorui.MenuButton({ editor: editor, className: "edui-for-rowspacing" + cmd, title: editor.options.labelMap["rowspacing" + cmd] || editor.getLang("labelMap.rowspacing" + cmd) || "", items: items, onbuttonclick: function onbuttonclick() {
              var value = editor.queryCommandValue("rowspacing", cmd) || this.value;editor.execCommand("rowspacing", value, cmd);
            } });editorui.buttons[cmd] = ui;editor.addListener("selectionchange", function () {
            var state = editor.queryCommandState("rowspacing", cmd);if (state == -1) {
              ui.setDisabled(true);
            } else {
              ui.setDisabled(false);var value = editor.queryCommandValue("rowspacing", cmd);value && ui.setValue((value + "").replace(/%/, ""));ui.setChecked(state);
            }
          });return ui;
        };
      })(ri);
    }var lists = ["insertorderedlist", "insertunorderedlist"];for (var l = 0, cl; cl = lists[l++];) {
      (function (cmd) {
        editorui[cmd] = function (editor) {
          var vals = editor.options[cmd],
              _onMenuClick = function _onMenuClick() {
            editor.execCommand(cmd, this.value);
          },
              items = [];for (var i in vals) {
            items.push({ label: vals[i] || editor.getLang()[cmd][i] || "", value: i, theme: editor.options.theme, onclick: _onMenuClick });
          }var ui = new editorui.MenuButton({ editor: editor, className: "edui-for-" + cmd, title: editor.getLang("labelMap." + cmd) || "", "items": items, onbuttonclick: function onbuttonclick() {
              var value = editor.queryCommandValue(cmd) || this.value;editor.execCommand(cmd, value);
            } });editorui.buttons[cmd] = ui;editor.addListener("selectionchange", function () {
            var state = editor.queryCommandState(cmd);if (state == -1) {
              ui.setDisabled(true);
            } else {
              ui.setDisabled(false);var value = editor.queryCommandValue(cmd);ui.setValue(value);ui.setChecked(state);
            }
          });return ui;
        };
      })(cl);
    }editorui.fullscreen = function (editor, title) {
      title = editor.options.labelMap["fullscreen"] || editor.getLang("labelMap.fullscreen") || "";var ui = new editorui.Button({ className: "edui-for-fullscreen", title: title, theme: editor.options.theme, onclick: function onclick() {
          if (editor.ui) {
            editor.ui.setFullScreen(!editor.ui.isFullScreen());
          }this.setChecked(editor.ui.isFullScreen());
        } });editorui.buttons["fullscreen"] = ui;editor.addListener("selectionchange", function () {
        var state = editor.queryCommandState("fullscreen");ui.setDisabled(state == -1);ui.setChecked(editor.ui.isFullScreen());
      });return ui;
    };editorui["emotion"] = function (editor, iframeUrl) {
      var cmd = "emotion";var ui = new editorui.MultiMenuPop({ title: editor.options.labelMap[cmd] || editor.getLang("labelMap." + cmd + "") || "", editor: editor, className: "edui-for-" + cmd, iframeUrl: editor.ui.mapUrl(iframeUrl || (editor.options.iframeUrlMap || {})[cmd] || iframeUrlMap[cmd]) });editorui.buttons[cmd] = ui;editor.addListener("selectionchange", function () {
        ui.setDisabled(editor.queryCommandState(cmd) == -1);
      });return ui;
    };editorui.autotypeset = function (editor) {
      var ui = new editorui.AutoTypeSetButton({ editor: editor, title: editor.options.labelMap["autotypeset"] || editor.getLang("labelMap.autotypeset") || "", className: "edui-for-autotypeset", onbuttonclick: function onbuttonclick() {
          editor.execCommand("autotypeset");
        } });editorui.buttons["autotypeset"] = ui;editor.addListener("selectionchange", function () {
        ui.setDisabled(editor.queryCommandState("autotypeset") == -1);
      });return ui;
    };editorui["simpleupload"] = function (editor) {
      var name = "simpleupload",
          ui = new editorui.Button({ className: "edui-for-" + name, title: editor.options.labelMap[name] || editor.getLang("labelMap." + name) || "", onclick: function onclick() {}, theme: editor.options.theme, showText: false });editorui.buttons[name] = ui;editor.addListener("ready", function () {
        var b = ui.getDom("body"),
            iconSpan = b.children[0];editor.fireEvent("simpleuploadbtnready", iconSpan);
      });editor.addListener("selectionchange", function (type, causeByUi, uiReady) {
        var state = editor.queryCommandState(name);if (state == -1) {
          ui.setDisabled(true);ui.setChecked(false);
        } else {
          if (!uiReady) {
            ui.setDisabled(false);ui.setChecked(state);
          }
        }
      });return ui;
    };
  })();(function () {
    var utils = baidu.editor.utils,
        uiUtils = baidu.editor.ui.uiUtils,
        UIBase = baidu.editor.ui.UIBase,
        domUtils = baidu.editor.dom.domUtils;var nodeStack = [];function EditorUI(options) {
      this.initOptions(options);this.initEditorUI();
    }EditorUI.prototype = { uiName: "editor", initEditorUI: function initEditorUI() {
        this.editor.ui = this;this._dialogs = {};this.initUIBase();this._initToolbars();var editor = this.editor,
            me = this;editor.addListener("ready", function () {
          editor.getDialog = function (name) {
            return editor.ui._dialogs[name + "Dialog"];
          };domUtils.on(editor.window, "scroll", function (evt) {
            baidu.editor.ui.Popup.postHide(evt);
          });editor.ui._actualFrameWidth = editor.options.initialFrameWidth;UE.browser.ie && UE.browser.version === 6 && editor.container.ownerDocument.execCommand("BackgroundImageCache", false, true);if (editor.options.elementPathEnabled) {
            editor.ui.getDom("elementpath").innerHTML = '<div class="edui-editor-breadcrumb">' + editor.getLang("elementPathTip") + ":</div>";
          }if (editor.options.wordCount) {
            var countFn = function countFn() {
              setCount(editor, me);domUtils.un(editor.document, "click", arguments.callee);
            };

            domUtils.on(editor.document, "click", countFn);editor.ui.getDom("wordcount").innerHTML = editor.getLang("wordCountTip");
          }editor.ui._scale();if (editor.options.scaleEnabled) {
            if (editor.autoHeightEnabled) {
              editor.disableAutoHeight();
            }me.enableScale();
          } else {
            me.disableScale();
          }if (!editor.options.elementPathEnabled && !editor.options.wordCount && !editor.options.scaleEnabled) {
            editor.ui.getDom("elementpath").style.display = "none";editor.ui.getDom("wordcount").style.display = "none";editor.ui.getDom("scale").style.display = "none";
          }if (!editor.selection.isFocus()) {
            return;
          }editor.fireEvent("selectionchange", false, true);
        });editor.addListener("mousedown", function (t, evt) {
          var el = evt.target || evt.srcElement;baidu.editor.ui.Popup.postHide(evt, el);baidu.editor.ui.ShortCutMenu.postHide(evt);
        });editor.addListener("delcells", function () {
          if (UE.ui["edittip"]) {
            new UE.ui["edittip"](editor);
          }editor.getDialog("edittip").open();
        });var pastePop,
            isPaste = false,
            timer;editor.addListener("afterpaste", function () {
          if (editor.queryCommandState("pasteplain")) {
            return;
          }if (baidu.editor.ui.PastePicker) {
            pastePop = new baidu.editor.ui.Popup({ content: new baidu.editor.ui.PastePicker({ editor: editor }), editor: editor, className: "edui-wordpastepop" });pastePop.render();
          }isPaste = true;
        });editor.addListener("afterinserthtml", function () {
          clearTimeout(timer);timer = setTimeout(function () {
            if (pastePop && (isPaste || editor.ui._isTransfer)) {
              if (pastePop.isHidden()) {
                var span = domUtils.createElement(editor.document, "span", { "style": "line-height:0px;", "innerHTML": "\uFEFF" }),
                    range = editor.selection.getRange();range.insertNode(span);var tmp = getDomNode(span, "firstChild", "previousSibling");tmp && pastePop.showAnchor(tmp.nodeType == 3 ? tmp.parentNode : tmp);domUtils.remove(span);
              } else {
                pastePop.show();
              }delete editor.ui._isTransfer;isPaste = false;
            }
          }, 200);
        });editor.addListener("contextmenu", function (t, evt) {
          baidu.editor.ui.Popup.postHide(evt);
        });editor.addListener("keydown", function (t, evt) {
          if (pastePop) {
            pastePop.dispose(evt);
          }var keyCode = evt.keyCode || evt.which;if (evt.altKey && keyCode == 90) {
            UE.ui.buttons["fullscreen"].onclick();
          }
        });editor.addListener("wordcount", function (type) {
          setCount(this, me);
        });function setCount(editor, ui) {
          editor.setOpt({ wordCount: true, maximumWords: 10000, wordCountMsg: editor.options.wordCountMsg || editor.getLang("wordCountMsg"), wordOverFlowMsg: editor.options.wordOverFlowMsg || editor.getLang("wordOverFlowMsg") });var opt = editor.options,
              max = opt.maximumWords,
              msg = opt.wordCountMsg,
              errMsg = opt.wordOverFlowMsg,
              countDom = ui.getDom("wordcount");if (!opt.wordCount) {
            return;
          }var count = editor.getContentLength(true);if (count > max) {
            countDom.innerHTML = errMsg;editor.fireEvent("wordcountoverflow");
          } else {
            countDom.innerHTML = msg.replace("{#leave}", max - count).replace("{#count}", count);
          }
        }editor.addListener("selectionchange", function () {
          if (editor.options.elementPathEnabled) {
            me[(editor.queryCommandState("elementpath") == -1 ? "dis" : "en") + "ableElementPath"]();
          }if (editor.options.scaleEnabled) {
            me[(editor.queryCommandState("scale") == -1 ? "dis" : "en") + "ableScale"]();
          }
        });var popup = new baidu.editor.ui.Popup({ editor: editor, content: "", className: "edui-bubble", _onEditButtonClick: function _onEditButtonClick() {
            this.hide();editor.ui._dialogs.linkDialog.open();
          }, _onImgEditButtonClick: function _onImgEditButtonClick(name) {
            this.hide();editor.ui._dialogs[name] && editor.ui._dialogs[name].open();
          }, _onImgSetFloat: function _onImgSetFloat(value) {
            this.hide();editor.execCommand("imagefloat", value);
          }, _setIframeAlign: function _setIframeAlign(value) {
            var frame = popup.anchorEl;var newFrame = frame.cloneNode(true);switch (value) {case -2:
                newFrame.setAttribute("align", "");break;case -1:
                newFrame.setAttribute("align", "left");break;case 1:
                newFrame.setAttribute("align", "right");break;}frame.parentNode.insertBefore(newFrame, frame);domUtils.remove(frame);popup.anchorEl = newFrame;popup.showAnchor(popup.anchorEl);
          }, _updateIframe: function _updateIframe() {
            var frame = editor._iframe = popup.anchorEl;if (domUtils.hasClass(frame, "ueditor_baidumap")) {
              editor.selection.getRange().selectNode(frame).select();editor.ui._dialogs.mapDialog.open();popup.hide();
            } else {
              editor.ui._dialogs.insertframeDialog.open();popup.hide();
            }
          }, _onRemoveButtonClick: function _onRemoveButtonClick(cmdName) {
            editor.execCommand(cmdName);this.hide();
          }, queryAutoHide: function queryAutoHide(el) {
            if (el && el.ownerDocument == editor.document) {
              if (el.tagName.toLowerCase() == "img" || domUtils.findParentByTagName(el, "a", true)) {
                return el !== popup.anchorEl;
              }
            }return baidu.editor.ui.Popup.prototype.queryAutoHide.call(this, el);
          } });popup.render();
      }, _initToolbars: function _initToolbars() {
        var editor = this.editor;var toolbars = this.toolbars || [];var toolbarUis = [];for (var i = 0; i < toolbars.length; i++) {
          var toolbar = toolbars[i];var toolbarUi = new baidu.editor.ui.Toolbar({ theme: editor.options.theme });for (var j = 0; j < toolbar.length; j++) {
            var toolbarItem = toolbar[j];var toolbarItemUi = null;if (typeof toolbarItem == "string") {
              toolbarItem = toolbarItem.toLowerCase();if (toolbarItem == "|") {
                toolbarItem = "Separator";
              }if (toolbarItem == "||") {
                toolbarItem = "Breakline";
              }if (baidu.editor.ui[toolbarItem]) {
                toolbarItemUi = new baidu.editor.ui[toolbarItem](editor);
              }if (toolbarItem == "fullscreen") {
                if (toolbarUis && toolbarUis[0]) {
                  toolbarUis[0].items.splice(0, 0, toolbarItemUi);
                } else {
                  toolbarItemUi && toolbarUi.items.splice(0, 0, toolbarItemUi);
                }continue;
              }
            } else {
              toolbarItemUi = toolbarItem;
            }if (toolbarItemUi && toolbarItemUi.id) {
              toolbarUi.add(toolbarItemUi);
            }
          }toolbarUis[i] = toolbarUi;
        }utils.each(UE._customizeUI, function (obj, key) {
          var itemUI, index;if (obj.id && obj.id != editor.key) {
            return false;
          }itemUI = obj.execFn.call(editor, editor, key);if (itemUI) {
            index = obj.index;if (index === undefined) {
              index = toolbarUi.items.length;
            }toolbarUi.add(itemUI, index);
          }
        });this.toolbars = toolbarUis;
      }, getHtmlTpl: function getHtmlTpl() {
        return '<div id="##" class="%%">' + '<div id="##_toolbarbox" class="%%-toolbarbox">' + (this.toolbars.length ? '<div id="##_toolbarboxouter" class="%%-toolbarboxouter"><div class="%%-toolbarboxinner">' + this.renderToolbarBoxHtml() + "</div></div>" : "") + '<div id="##_toolbarmsg" class="%%-toolbarmsg" style="display:none;">' + '<div id = "##_upload_dialog" class="%%-toolbarmsg-upload" onclick="$$.showWordImageDialog();">' + this.editor.getLang("clickToUpload") + "</div>" + '<div class="%%-toolbarmsg-close" onclick="$$.hideToolbarMsg();">x</div>' + '<div id="##_toolbarmsg_label" class="%%-toolbarmsg-label"></div>' + '<div style="height:0;overflow:hidden;clear:both;"></div>' + "</div>" + '<div id="##_message_holder" class="%%-messageholder"></div>' + "</div>" + '<div id="##_iframeholder" class="%%-iframeholder">' + "</div>" + '<div id="##_bottombar" class="%%-bottomContainer"><table><tr>' + '<td id="##_elementpath" class="%%-bottombar"></td>' + '<td id="##_wordcount" class="%%-wordcount"></td>' + '<td id="##_scale" class="%%-scale"><div class="%%-icon"></div></td>' + "</tr></table></div>" + '<div id="##_scalelayer"></div>' + "</div>";
      }, showWordImageDialog: function showWordImageDialog() {
        this._dialogs["wordimageDialog"].open();
      }, renderToolbarBoxHtml: function renderToolbarBoxHtml() {
        var buff = [];for (var i = 0; i < this.toolbars.length; i++) {
          buff.push(this.toolbars[i].renderHtml());
        }return buff.join("");
      }, setFullScreen: function setFullScreen(fullscreen) {
        var editor = this.editor,
            container = editor.container.parentNode.parentNode;if (this._fullscreen != fullscreen) {
          this._fullscreen = fullscreen;this.editor.fireEvent("beforefullscreenchange", fullscreen);if (baidu.editor.browser.gecko) {
            var bk = editor.selection.getRange().createBookmark();
          }if (fullscreen) {
            while (container.tagName != "BODY") {
              var position = baidu.editor.dom.domUtils.getComputedStyle(container, "position");nodeStack.push(position);container.style.position = "static";container = container.parentNode;
            }this._bakHtmlOverflow = document.documentElement.style.overflow;this._bakBodyOverflow = document.body.style.overflow;this._bakAutoHeight = this.editor.autoHeightEnabled;this._bakScrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);this._bakEditorContaninerWidth = editor.iframe.parentNode.offsetWidth;if (this._bakAutoHeight) {
              editor.autoHeightEnabled = false;this.editor.disableAutoHeight();
            }document.documentElement.style.overflow = "hidden";window.scrollTo(0, window.scrollY);this._bakCssText = this.getDom().style.cssText;this._bakCssText1 = this.getDom("iframeholder").style.cssText;editor.iframe.parentNode.style.width = "";this._updateFullScreen();
          } else {
            while (container.tagName != "BODY") {
              container.style.position = nodeStack.shift();container = container.parentNode;
            }this.getDom().style.cssText = this._bakCssText;this.getDom("iframeholder").style.cssText = this._bakCssText1;if (this._bakAutoHeight) {
              editor.autoHeightEnabled = true;this.editor.enableAutoHeight();
            }document.documentElement.style.overflow = this._bakHtmlOverflow;document.body.style.overflow = this._bakBodyOverflow;editor.iframe.parentNode.style.width = this._bakEditorContaninerWidth + "px";window.scrollTo(0, this._bakScrollTop);
          }if (browser.gecko && editor.body.contentEditable === "true") {
            var input = document.createElement("input");document.body.appendChild(input);editor.body.contentEditable = false;setTimeout(function () {
              input.focus();setTimeout(function () {
                editor.body.contentEditable = true;editor.fireEvent("fullscreenchanged", fullscreen);editor.selection.getRange().moveToBookmark(bk).select(true);baidu.editor.dom.domUtils.remove(input);fullscreen && window.scroll(0, 0);
              }, 0);
            }, 0);
          }if (editor.body.contentEditable === "true") {
            this.editor.fireEvent("fullscreenchanged", fullscreen);this.triggerLayout();
          }
        }
      }, _updateFullScreen: function _updateFullScreen() {
        if (this._fullscreen) {
          var vpRect = uiUtils.getViewportRect();this.getDom().style.cssText = "border:0;position:absolute;left:0;top:" + (this.editor.options.topOffset || 0) + "px;width:" + vpRect.width + "px;height:" + vpRect.height + "px;z-index:" + (this.getDom().style.zIndex * 1 + 100);uiUtils.setViewportOffset(this.getDom(), { left: 0, top: this.editor.options.topOffset || 0 });this.editor.setHeight(vpRect.height - this.getDom("toolbarbox").offsetHeight - this.getDom("bottombar").offsetHeight - (this.editor.options.topOffset || 0), true);if (browser.gecko) {
            try {
              window.onresize();
            } catch (e) {}
          }
        }
      }, _updateElementPath: function _updateElementPath() {
        var bottom = this.getDom("elementpath"),
            list;if (this.elementPathEnabled && (list = this.editor.queryCommandValue("elementpath"))) {
          var buff = [];for (var i = 0, ci; ci = list[i]; i++) {
            buff[i] = this.formatHtml('<span unselectable="on" onclick="$$.editor.execCommand(&quot;elementpath&quot;, &quot;' + i + '&quot;);">' + ci + "</span>");
          }bottom.innerHTML = '<div class="edui-editor-breadcrumb" onmousedown="return false;">' + this.editor.getLang("elementPathTip") + ": " + buff.join(" &gt; ") + "</div>";
        } else {
          bottom.style.display = "none";
        }
      }, disableElementPath: function disableElementPath() {
        var bottom = this.getDom("elementpath");bottom.innerHTML = "";bottom.style.display = "none";this.elementPathEnabled = false;
      }, enableElementPath: function enableElementPath() {
        var bottom = this.getDom("elementpath");bottom.style.display = "";this.elementPathEnabled = true;this._updateElementPath();
      }, _scale: function _scale() {
        var doc = document,
            editor = this.editor,
            editorHolder = editor.container,
            editorDocument = editor.document,
            toolbarBox = this.getDom("toolbarbox"),
            bottombar = this.getDom("bottombar"),
            scale = this.getDom("scale"),
            scalelayer = this.getDom("scalelayer");var isMouseMove = false,
            position = null,
            minEditorHeight = 0,
            minEditorWidth = editor.options.minFrameWidth,
            pageX = 0,
            pageY = 0,
            scaleWidth = 0,
            scaleHeight = 0;function down() {
          position = domUtils.getXY(editorHolder);if (!minEditorHeight) {
            minEditorHeight = editor.options.minFrameHeight + toolbarBox.offsetHeight + bottombar.offsetHeight;
          }scalelayer.style.cssText = "position:absolute;left:0;display:;top:0;background-color:#41ABFF;opacity:0.4;filter: Alpha(opacity=40);width:" + editorHolder.offsetWidth + "px;height:" + editorHolder.offsetHeight + "px;z-index:" + (editor.options.zIndex + 1);domUtils.on(doc, "mousemove", move);domUtils.on(editorDocument, "mouseup", up);domUtils.on(doc, "mouseup", up);
        }var me = this;this.editor.addListener("fullscreenchanged", function (e, fullScreen) {
          if (fullScreen) {
            me.disableScale();
          } else {
            if (me.editor.options.scaleEnabled) {
              me.enableScale();var tmpNode = me.editor.document.createElement("span");me.editor.body.appendChild(tmpNode);me.editor.body.style.height = Math.max(domUtils.getXY(tmpNode).y, me.editor.iframe.offsetHeight - 20) + "px";domUtils.remove(tmpNode);
            }
          }
        });function move(event) {
          clearSelection();var e = event || window.event;pageX = e.pageX || doc.documentElement.scrollLeft + e.clientX;pageY = e.pageY || doc.documentElement.scrollTop + e.clientY;scaleWidth = pageX - position.x;scaleHeight = pageY - position.y;if (scaleWidth >= minEditorWidth) {
            isMouseMove = true;scalelayer.style.width = scaleWidth + "px";
          }if (scaleHeight >= minEditorHeight) {
            isMouseMove = true;scalelayer.style.height = scaleHeight + "px";
          }
        }function up() {
          if (isMouseMove) {
            isMouseMove = false;editor.ui._actualFrameWidth = scalelayer.offsetWidth - 2;editorHolder.style.width = editor.ui._actualFrameWidth + "px";editor.setHeight(scalelayer.offsetHeight - bottombar.offsetHeight - toolbarBox.offsetHeight - 2, true);
          }if (scalelayer) {
            scalelayer.style.display = "none";
          }clearSelection();domUtils.un(doc, "mousemove", move);domUtils.un(editorDocument, "mouseup", up);domUtils.un(doc, "mouseup", up);
        }function clearSelection() {
          if (browser.ie) {
            doc.selection.clear();
          } else {
            window.getSelection().removeAllRanges();
          }
        }this.enableScale = function () {
          if (editor.queryCommandState("source") == 1) {
            return;
          }scale.style.display = "";this.scaleEnabled = true;domUtils.on(scale, "mousedown", down);
        };this.disableScale = function () {
          scale.style.display = "none";this.scaleEnabled = false;domUtils.un(scale, "mousedown", down);
        };
      }, isFullScreen: function isFullScreen() {
        return this._fullscreen;
      }, postRender: function postRender() {
        UIBase.prototype.postRender.call(this);for (var i = 0; i < this.toolbars.length; i++) {
          this.toolbars[i].postRender();
        }var me = this;var timerId,
            domUtils = baidu.editor.dom.domUtils,
            updateFullScreenTime = function updateFullScreenTime() {
          clearTimeout(timerId);timerId = setTimeout(function () {
            me._updateFullScreen();
          });
        };domUtils.on(window, "resize", updateFullScreenTime);me.addListener("destroy", function () {
          domUtils.un(window, "resize", updateFullScreenTime);clearTimeout(timerId);
        });
      }, showToolbarMsg: function showToolbarMsg(msg, flag) {
        this.getDom("toolbarmsg_label").innerHTML = msg;this.getDom("toolbarmsg").style.display = "";if (!flag) {
          var w = this.getDom("upload_dialog");w.style.display = "none";
        }
      }, hideToolbarMsg: function hideToolbarMsg() {
        this.getDom("toolbarmsg").style.display = "none";
      }, mapUrl: function mapUrl(url) {
        return url ? url.replace("~/", this.editor.options.UEDITOR_HOME_URL || "") : "";
      }, triggerLayout: function triggerLayout() {
        var dom = this.getDom();if (dom.style.zoom == "1") {
          dom.style.zoom = "100%";
        } else {
          dom.style.zoom = "1";
        }
      } };utils.inherits(EditorUI, baidu.editor.ui.UIBase);var instances = {};UE.ui.Editor = function (options) {
      var editor = new UE.Editor(options);editor.options.editor = editor;var oldRender = editor.render;editor.render = function (holder) {
        if (holder.constructor === String) {
          editor.key = holder;instances[holder] = editor;
        }utils.domReady(function () {
          editor.langIsReady ? renderUI() : editor.addListener("langReady", renderUI);function renderUI() {
            editor.setOpt({ labelMap: editor.options.labelMap || editor.getLang("labelMap") });new EditorUI(editor.options);if (holder) {
              if (holder.constructor === String) {
                holder = document.getElementById(holder);
              }holder && holder.getAttribute("name") && (editor.options.textarea = holder.getAttribute("name"));if (holder && /script|textarea/ig.test(holder.tagName)) {
                var newDiv = document.createElement("div");holder.parentNode.insertBefore(newDiv, holder);var cont = holder.value || holder.innerHTML;editor.options.initialContent = /^[\t\r\n ]*$/.test(cont) ? editor.options.initialContent : cont.replace(/>[\n\r\t]+([ ]{4})+/g, ">").replace(/[\n\r\t]+([ ]{4})+</g, "<").replace(/>[\n\r\t]+</g, "><");holder.className && (newDiv.className = holder.className);holder.style.cssText && (newDiv.style.cssText = holder.style.cssText);if (/textarea/i.test(holder.tagName)) {
                  editor.textarea = holder;editor.textarea.style.display = "none";
                } else {
                  holder.parentNode.removeChild(holder);
                }if (holder.id) {
                  newDiv.id = holder.id;domUtils.removeAttributes(holder, "id");
                }holder = newDiv;holder.innerHTML = "";
              }
            }domUtils.addClass(holder, "edui-" + editor.options.theme);editor.ui.render(holder);var opt = editor.options;editor.container = editor.ui.getDom();var parents = domUtils.findParents(holder, true);var displays = [];for (var i = 0, ci; ci = parents[i]; i++) {
              displays[i] = ci.style.display;ci.style.display = "block";
            }if (opt.initialFrameWidth) {
              opt.minFrameWidth = opt.initialFrameWidth;
            } else {
              opt.minFrameWidth = opt.initialFrameWidth = holder.offsetWidth;var styleWidth = holder.style.width;if (/%$/.test(styleWidth)) {
                opt.initialFrameWidth = styleWidth;
              }
            }if (opt.initialFrameHeight) {
              opt.minFrameHeight = opt.initialFrameHeight;
            } else {
              opt.initialFrameHeight = opt.minFrameHeight = holder.offsetHeight;
            }for (var i = 0, ci; ci = parents[i]; i++) {
              ci.style.display = displays[i];
            }if (holder.style.height) {
              holder.style.height = "";
            }editor.container.style.width = opt.initialFrameWidth + (/%$/.test(opt.initialFrameWidth) ? "" : "px");editor.container.style.zIndex = opt.zIndex;oldRender.call(editor, editor.ui.getDom("iframeholder"));editor.fireEvent("afteruiready");
          }
        });
      };return editor;
    };UE.getEditor = function (id, opt) {
      var editor = instances[id];if (!editor) {
        editor = instances[id] = new UE.ui.Editor(opt);editor.render(id);
      }return editor;
    };UE.delEditor = function (id) {
      var editor;if (editor = instances[id]) {
        editor.key && editor.destroy();delete instances[id];
      }
    };UE.registerUI = function (uiName, fn, index, editorId) {
      utils.each(uiName.split(/\s+/), function (name) {
        UE._customizeUI[name] = { id: editorId, execFn: fn, index: index };
      });
    };
  })();UE.registerUI("message", function (editor) {
    var editorui = baidu.editor.ui;var Message = editorui.Message;var holder;var _messageItems = [];var me = editor;me.addListener("ready", function () {
      holder = document.getElementById(me.ui.id + "_message_holder");updateHolderPos();setTimeout(function () {
        updateHolderPos();
      }, 500);
    });me.addListener("showmessage", function (type, opt) {
      opt = utils.isString(opt) ? { "content": opt } : opt;var message = new Message({ "timeout": opt.timeout, "type": opt.type, "content": opt.content, "keepshow": opt.keepshow, "editor": me }),
          mid = opt.id || "msg_" + (+new Date()).toString(36);message.render(holder);_messageItems[mid] = message;message.reset(opt);updateHolderPos();return mid;
    });me.addListener("updatemessage", function (type, id, opt) {
      opt = utils.isString(opt) ? { "content": opt } : opt;var message = _messageItems[id];message.render(holder);message && message.reset(opt);
    });me.addListener("hidemessage", function (type, id) {
      var message = _messageItems[id];message && message.hide();
    });function updateHolderPos() {
      var toolbarbox = me.ui.getDom("toolbarbox");if (toolbarbox) {
        holder.style.top = toolbarbox.offsetHeight + 3 + "px";
      }holder.style.zIndex = Math.max(me.options.zIndex, me.iframe.style.zIndex) + 1;
    }
  });UE.registerUI("autosave", function (editor) {
    var timer = null,
        uid = null;editor.on("afterautosave", function () {
      clearTimeout(timer);timer = setTimeout(function () {
        if (uid) {
          editor.trigger("hidemessage", uid);
        }uid = editor.trigger("showmessage", { content: editor.getLang("autosave.success"), timeout: 2000 });
      }, 2000);
    });
  });
})();

/***/ }),

/***/ 998:
/***/ (function(module, exports) {

/**
 * ueditor完整配置项
 * 可以在这里配置整个编辑器的特性
 */
/**************************提示********************************
 * 所有被注释的配置项均为UEditor默认值。
 * 修改默认配置请首先确保已经完全明确该参数的真实用途。
 * 主要有两种修改方案，一种是取消此处注释，然后修改成对应参数；另一种是在实例化编辑器时传入对应参数。
 * 当升级编辑器时，可直接使用旧版配置文件替换新版配置文件,不用担心旧版配置文件中因缺少新功能所需的参数而导致脚本报错。
 **************************提示********************************/

(function () {

    /**
     * 编辑器资源文件根路径。它所表示的含义是：以编辑器实例化页面为当前路径，指向编辑器资源文件（即dialog等文件夹）的路径。
     * 鉴于很多同学在使用编辑器的时候出现的种种路径问题，此处强烈建议大家使用"相对于网站根目录的相对路径"进行配置。
     * "相对于网站根目录的相对路径"也就是以斜杠开头的形如"/myProject/ueditor/"这样的路径。
     * 如果站点中有多个不在同一层级的页面需要实例化编辑器，且引用了同一UEditor的时候，此处的URL可能不适用于每个页面的编辑器。
     * 因此，UEditor提供了针对不同页面的编辑器可单独配置的根路径，具体来说，在需要实例化编辑器的页面最顶部写上如下代码即可。当然，需要令此处的URL等于对应的配置。
     * window.UEDITOR_HOME_URL = "/xxxx/xxxx/";
     */
    var URL = window.UEDITOR_HOME_URL || getUEBasePath();

    /**
     * 配置项主体。注意，此处所有涉及到路径的配置别遗漏URL变量。
     */
    window.UEDITOR_CONFIG = {

        //为编辑器实例添加一个路径，这个不能被注释
        UEDITOR_HOME_URL: URL
        // UEDITOR_HOME_URL: 'http://127.0.0.1:8080'
        // 服务器统一请求接口路径,改值在此处已基本没有用处，只有粘贴图片在里面的时候才会使用
        , serverUrl: URL + "jsp/controller.jsp"
        // ,serverUrl:'/programmer/test/index.do?get='

        //工具栏上的所有的功能按钮和下拉框，可以在new编辑器的实例时选择自己需要的重新定义
        //, toolbars: [[
        //    'fullscreen', 'source', '|', 'undo', 'redo', '|',
        //    'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', '|', 'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', '|',
        //    'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
        //    'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|',
        //    'directionalityltr', 'directionalityrtl', 'indent', '|',
        //    'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'touppercase', 'tolowercase', '|',
        //    'link', 'unlink', 'anchor', '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter', '|',
        //    'simpleupload', 'insertimage', 'emotion', 'scrawl', 'insertvideo', 'music', 'attachment', 'map', 'gmap', 'insertframe', 'insertcode', 'webapp', 'pagebreak', 'template', 'background', '|',
        //    'horizontal', 'date', 'time', 'spechars', 'snapscreen', 'wordimage', '|',
        //    'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow', 'deleterow', 'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts', '|',
        //   'print', 'preview', 'searchreplace', 'drafts', 'help'
        //]]
        , toolbars: [['fullscreen', //全屏 
        //'source',//HTML
        '|', 'undo', //撤销 
        'redo', //重做
        '|', 'bold', //加粗
        'italic', //斜体
        'underline', //下划线
        //'fontborder', //字符边框
        //'strikethrough', //删除线
        //'superscript', //上标
        //'subscript', //下标
        //'removeformat', //清除格式
        //'formatmatch', //格式刷
        // 'autotypeset', //自动排版
        //'blockquote', //引用
        //'pasteplain', //纯文本粘贴
        '|', 'forecolor', //字体颜色
        'backcolor', //背景色
        //'insertorderedlist', //有序列表
        //'insertunorderedlist', //无序列表
        //'selectall', //全选
        //'cleardoc', //清空文档
        //'|',
        //'rowspacingtop', //段前距
        //'rowspacingbottom', //断后距
        //'lineheight', //行间距
        //'|',
        //'customstyle', //自定义标题
        //'paragraph', //段落格式
        'fontfamily', //字体
        //'fontsize', //字号
        //'|',
        //'directionalityltr', //从左往右输入
        //'directionalityrtl', //从右往左输入
        //'indent', //首行缩进
        //'|',
        'justifyleft', //居左对齐
        'justifycenter', //居中对齐
        'justifyright', //居右对齐
        'justifyjustify']]
        //当鼠标放在工具栏上时显示的tooltip提示,留空支持自动多语言配置，否则以配置值为准
        //,labelMap:{
        //    'anchor':'', 'undo':''
        //}

        //语言配置项,默认是zh-cn。有需要的话也可以使用如下这样的方式来自动多语言切换，当然，前提条件是lang文件夹下存在对应的语言文件：
        //lang值也可以通过自动获取 (navigator.language||navigator.browserLanguage ||navigator.userLanguage).toLowerCase()
        //,lang:"zh-cn"
        //,langPath:URL +"lang/"

        //主题配置项,默认是default。有需要的话也可以使用如下这样的方式来自动多主题切换，当然，前提条件是themes文件夹下存在对应的主题文件：
        //现有如下皮肤:default
        //,theme:'default'
        //,themePath:URL +"themes/"

        //,zIndex : 900     //编辑器层级的基数,默认是900

        //针对getAllHtml方法，会在对应的head标签中增加该编码设置。
        //,charset:"utf-8"

        //若实例化编辑器的页面手动修改的domain，此处需要设置为true
        //,customDomain:false

        //常用配置项目
        //,isShow : true    //默认显示编辑器

        //,textarea:'editorValue' // 提交表单时，服务器获取编辑器提交内容的所用的参数，多实例时可以给容器name属性，会将name给定的值最为每个实例的键值，不用每次实例化的时候都设置这个值

        //,initialContent:'欢迎使用ueditor!'    //初始化编辑器的内容,也可以通过textarea/script给值，看官网例子

        //,autoClearinitialContent:true //是否自动清除编辑器初始内容，注意：如果focus属性设置为true,这个也为真，那么编辑器一上来就会触发导致初始化的内容看不到了

        //,focus:false //初始化时，是否让编辑器获得焦点true或false

        //如果自定义，最好给p标签如下的行高，要不输入中文时，会有跳动感
        //,initialStyle:'p{line-height:1em}'//编辑器层级的基数,可以用来改变字体等

        //,iframeCssUrl: URL + '/themes/iframe.css' //给编辑区域的iframe引入一个css文件

        //indentValue
        //首行缩进距离,默认是2em
        //,indentValue:'2em'

        //,initialFrameWidth:1000  //初始化编辑器宽度,默认1000
        //,initialFrameHeight:320  //初始化编辑器高度,默认320

        //,readonly : false //编辑器初始化结束后,编辑区域是否是只读的，默认是false

        //,autoClearEmptyNode : true //getContent时，是否删除空的inlineElement节点（包括嵌套的情况）

        //启用自动保存
        // ,enableAutoSave: false
        //自动保存间隔时间， 单位ms
        //,saveInterval: 500

        //,fullscreen : false //是否开启初始化时即全屏，默认关闭

        //,imagePopup:false      //图片操作的浮层开关，默认打开

        //,autoSyncData:false //自动同步编辑器要提交的数据
        //,emotionLocalization:false //是否开启表情本地化，默认关闭。若要开启请确保emotion文件夹下包含官网提供的images表情文件夹

        //粘贴只保留标签，去除标签所有属性
        //,retainOnlyLabelPasted: false

        //,pasteplain:false  //是否默认为纯文本粘贴。false为不使用纯文本粘贴，true为使用纯文本粘贴
        //纯文本粘贴模式下的过滤规则
        //'filterTxtRules' : function(){
        //    function transP(node){
        //        node.tagName = 'p';
        //        node.setStyle();
        //    }
        //    return {
        //        //直接删除及其字节点内容
        //        '-' : 'script style object iframe embed input select',
        //        'p': {$:{}},
        //        'br':{$:{}},
        //        'div':{'$':{}},
        //        'li':{'$':{}},
        //        'caption':transP,
        //        'th':transP,
        //        'tr':transP,
        //        'h1':transP,'h2':transP,'h3':transP,'h4':transP,'h5':transP,'h6':transP,
        //        'td':function(node){
        //            //没有内容的td直接删掉
        //            var txt = !!node.innerText();
        //            if(txt){
        //                node.parentNode.insertAfter(UE.uNode.createText(' &nbsp; &nbsp;'),node);
        //            }
        //            node.parentNode.removeChild(node,node.innerText())
        //        }
        //    }
        //}()

        //,allHtmlEnabled:false //提交到后台的数据是否包含整个html字符串

        //insertorderedlist
        //有序列表的下拉配置,值留空时支持多语言自动识别，若配置值，则以此值为准
        , 'insertorderedlist': {
            //自定的样式
            //    'num':'1,2,3...',
            //    'num1':'1),2),3)...',
            //    'num2':'(1),(2),(3)...',
            //    'cn':'一,二,三....',
            //    'cn1':'一),二),三)....',
            //    'cn2':'(一),(二),(三)....',
            //系统自带
            'decimal': '', //'1,2,3...'
            'lower-alpha': '', // 'a,b,c...'
            'lower-roman': '', //'i,ii,iii...'
            'upper-alpha': '', //'A,B,C'
            'upper-roman': '' //'I,II,III...'


            //insertunorderedlist
            //无序列表的下拉配置，值留空时支持多语言自动识别，若配置值，则以此值为准
            //,insertunorderedlist : { //自定的样式
            //    'dash' :'— 破折号', //-破折号
            //    'dot':' 。 小圆圈', //系统自带
            //    'circle' : '',  // '○ 小圆圈'
            //    'disc' : '',    // '● 小圆点'
            //    'square' : ''   //'■ 小方块'
            //}
            //,listDefaultPaddingLeft : '30'//默认的左边缩进的基数倍
            //,listiconpath : 'http://bs.baidu.com/listicon/'//自定义标号的路径
            //,maxListLevel : 3 //限制可以tab的级数, 设置-1为不限制

            //,autoTransWordToList:false  //禁止word中粘贴进来的列表自动变成列表标签

            //fontfamily
            //字体设置 label留空支持多语言自动切换，若配置，则以配置值为准
            //,'fontfamily':[
            //    { label:'',name:'songti',val:'宋体,SimSun'},
            //    { label:'',name:'kaiti',val:'楷体,楷体_GB2312, SimKai'},
            //    { label:'',name:'yahei',val:'微软雅黑,Microsoft YaHei'},
            //    { label:'',name:'heiti',val:'黑体, SimHei'},
            //    { label:'',name:'lishu',val:'隶书, SimLi'},
            //    { label:'',name:'andaleMono',val:'andale mono'},
            //    { label:'',name:'arial',val:'arial, helvetica,sans-serif'},
            //    { label:'',name:'arialBlack',val:'arial black,avant garde'},
            //    { label:'',name:'comicSansMs',val:'comic sans ms'},
            //    { label:'',name:'impact',val:'impact,chicago'},
            //    { label:'',name:'timesNewRoman',val:'times new roman'}
            //]

            //fontsize
            //字号
            //,'fontsize':[10, 11, 12, 14, 16, 18, 20, 24, 36]

            //paragraph
            //段落格式 值留空时支持多语言自动识别，若配置，则以配置值为准
            //,'paragraph':{'p':'', 'h1':'', 'h2':'', 'h3':'', 'h4':'', 'h5':'', 'h6':''}

            //rowspacingtop
            //段间距 值和显示的名字相同
            //,'rowspacingtop':['5', '10', '15', '20', '25']

            //rowspacingBottom
            //段间距 值和显示的名字相同
            //,'rowspacingbottom':['5', '10', '15', '20', '25']

            //lineheight
            //行内间距 值和显示的名字相同
            //,'lineheight':['1', '1.5','1.75','2', '3', '4', '5']

            //customstyle
            //自定义样式，不支持国际化，此处配置值即可最后显示值
            //block的元素是依据设置段落的逻辑设置的，inline的元素依据BIU的逻辑设置
            //尽量使用一些常用的标签
            //参数说明
            //tag 使用的标签名字
            //label 显示的名字也是用来标识不同类型的标识符，注意这个值每个要不同，
            //style 添加的样式
            //每一个对象就是一个自定义的样式
            //,'customstyle':[
            //    {tag:'h1', name:'tc', label:'', style:'border-bottom:#ccc 2px solid;padding:0 4px 0 0;text-align:center;margin:0 0 20px 0;'},
            //    {tag:'h1', name:'tl',label:'', style:'border-bottom:#ccc 2px solid;padding:0 4px 0 0;margin:0 0 10px 0;'},
            //    {tag:'span',name:'im', label:'', style:'font-style:italic;font-weight:bold'},
            //    {tag:'span',name:'hi', label:'', style:'font-style:italic;font-weight:bold;color:rgb(51, 153, 204)'}
            //]

            //打开右键菜单功能
            //,enableContextMenu: true
            //右键菜单的内容，可以参考plugins/contextmenu.js里边的默认菜单的例子，label留空支持国际化，否则以此配置为准
            //,contextMenu:[
            //    {
            //        label:'',       //显示的名称
            //        cmdName:'selectall',//执行的command命令，当点击这个右键菜单时
            //        //exec可选，有了exec就会在点击时执行这个function，优先级高于cmdName
            //        exec:function () {
            //            //this是当前编辑器的实例
            //            //this.ui._dialogs['inserttableDialog'].open();
            //        }
            //    }
            //]

            //快捷菜单
            //,shortcutMenu:["fontfamily", "fontsize", "bold", "italic", "underline", "forecolor", "backcolor", "insertorderedlist", "insertunorderedlist"]

            //elementPathEnabled
            //是否启用元素路径，默认是显示
            //,elementPathEnabled : true

            //wordCount
        }, wordCount: false //是否开启字数统计
        //,maximumWords:10000       //允许的最大字符数
        //字数统计提示，{#count}代表当前字数，{#leave}代表还可以输入多少字符数,留空支持多语言自动切换，否则按此配置显示
        //,wordCountMsg:''   //当前已输入 {#count} 个字符，您还可以输入{#leave} 个字符
        //超出字数限制提示  留空支持多语言自动切换，否则按此配置显示
        //,wordOverFlowMsg:''    //<span style="color:red;">你输入的字符个数已经超出最大允许值，服务器可能会拒绝保存！</span>

        //tab
        //点击tab键时移动的距离,tabSize倍数，tabNode什么字符做为单位
        //,tabSize:4
        //,tabNode:'&nbsp;'

        //removeFormat
        //清除格式时可以删除的标签和属性
        //removeForamtTags标签
        //,removeFormatTags:'b,big,code,del,dfn,em,font,i,ins,kbd,q,samp,small,span,strike,strong,sub,sup,tt,u,var'
        //removeFormatAttributes属性
        //,removeFormatAttributes:'class,style,lang,width,height,align,hspace,valign'

        //undo
        //可以最多回退的次数,默认20
        //,maxUndoCount:20
        //当输入的字符数超过该值时，保存一次现场
        //,maxInputCount:1

        //autoHeightEnabled
        // 是否自动长高,默认true
        //,autoHeightEnabled:true

        //scaleEnabled
        //是否可以拉伸长高,默认true(当开启时，自动长高失效)
        //,scaleEnabled:false
        //,minFrameWidth:800    //编辑器拖动时最小宽度,默认800
        //,minFrameHeight:220  //编辑器拖动时最小高度,默认220

        //autoFloatEnabled
        //是否保持toolbar的位置不动,默认true
        , autoFloatEnabled: false
        //浮动时工具栏距离浏览器顶部的高度，用于某些具有固定头部的页面
        //,topOffset:30
        //编辑器底部距离工具栏高度(如果参数大于等于编辑器高度，则设置无效)
        //,toolbarTopOffset:400

        //设置远程图片是否抓取到本地保存
        //,catchRemoteImageEnable: true //设置是否抓取远程图片

        //pageBreakTag
        //分页标识符,默认是_ueditor_page_break_tag_
        //,pageBreakTag:'_ueditor_page_break_tag_'

        //autotypeset
        //自动排版参数
        //,autotypeset: {
        //    mergeEmptyline: true,           //合并空行
        //    removeClass: true,              //去掉冗余的class
        //    removeEmptyline: false,         //去掉空行
        //    textAlign:"left",               //段落的排版方式，可以是 left,right,center,justify 去掉这个属性表示不执行排版
        //    imageBlockLine: 'center',       //图片的浮动方式，独占一行剧中,左右浮动，默认: center,left,right,none 去掉这个属性表示不执行排版
        //    pasteFilter: false,             //根据规则过滤没事粘贴进来的内容
        //    clearFontSize: false,           //去掉所有的内嵌字号，使用编辑器默认的字号
        //    clearFontFamily: false,         //去掉所有的内嵌字体，使用编辑器默认的字体
        //    removeEmptyNode: false,         // 去掉空节点
        //    //可以去掉的标签
        //    removeTagNames: {标签名字:1},
        //    indent: false,                  // 行首缩进
        //    indentValue : '2em',            //行首缩进的大小
        //    bdc2sb: false,
        //    tobdc: false
        //}

        //tableDragable
        //表格是否可以拖拽
        //,tableDragable: true


        //sourceEditor
        //源码的查看方式,codemirror 是代码高亮，textarea是文本框,默认是codemirror
        //注意默认codemirror只能在ie8+和非ie中使用
        //,sourceEditor:"codemirror"
        //如果sourceEditor是codemirror，还用配置一下两个参数
        //codeMirrorJsUrl js加载的路径，默认是 URL + "third-party/codemirror/codemirror.js"
        //,codeMirrorJsUrl:URL + "third-party/codemirror/codemirror.js"
        //codeMirrorCssUrl css加载的路径，默认是 URL + "third-party/codemirror/codemirror.css"
        //,codeMirrorCssUrl:URL + "third-party/codemirror/codemirror.css"
        //编辑器初始化完成后是否进入源码模式，默认为否。
        //,sourceEditorFirst:false

        //iframeUrlMap
        //dialog内容的路径 ～会被替换成URL,垓属性一旦打开，将覆盖所有的dialog的默认路径
        //,iframeUrlMap:{
        //    'anchor':'~/dialogs/anchor/anchor.html',
        //}

        //allowLinkProtocol 允许的链接地址，有这些前缀的链接地址不会自动添加http
        //, allowLinkProtocols: ['http:', 'https:', '#', '/', 'ftp:', 'mailto:', 'tel:', 'git:', 'svn:']

        //webAppKey 百度应用的APIkey，每个站长必须首先去百度官网注册一个key后方能正常使用app功能，注册介绍，http://app.baidu.com/static/cms/getapikey.html
        //, webAppKey: ""

        //默认过滤规则相关配置项目
        //,disabledTableInTable:true  //禁止表格嵌套
        //,allowDivTransToP:true      //允许进入编辑器的div标签自动变成p标签
        //,rgb2Hex:true               //默认产出的数据中的color自动从rgb格式变成16进制格式

        // xss 过滤是否开启,inserthtml等操作
        , xssFilterRules: true
        //input xss过滤
        , inputXssFilter: true
        //output xss过滤
        , outputXssFilter: true
        // xss过滤白名单 名单来源: https://raw.githubusercontent.com/leizongmin/js-xss/master/lib/default.js
        , whitList: {
            a: ['target', 'href', 'title', 'class', 'style'],
            abbr: ['title', 'class', 'style'],
            address: ['class', 'style'],
            area: ['shape', 'coords', 'href', 'alt'],
            article: [],
            aside: [],
            audio: ['autoplay', 'controls', 'loop', 'preload', 'src', 'class', 'style'],
            b: ['class', 'style'],
            bdi: ['dir'],
            bdo: ['dir'],
            big: [],
            blockquote: ['cite', 'class', 'style'],
            br: [],
            caption: ['class', 'style'],
            center: [],
            cite: [],
            code: ['class', 'style'],
            col: ['align', 'valign', 'span', 'width', 'class', 'style'],
            colgroup: ['align', 'valign', 'span', 'width', 'class', 'style'],
            dd: ['class', 'style'],
            del: ['datetime'],
            details: ['open'],
            div: ['class', 'style'],
            dl: ['class', 'style'],
            dt: ['class', 'style'],
            em: ['class', 'style'],
            font: ['color', 'size', 'face'],
            footer: [],
            h1: ['class', 'style'],
            h2: ['class', 'style'],
            h3: ['class', 'style'],
            h4: ['class', 'style'],
            h5: ['class', 'style'],
            h6: ['class', 'style'],
            header: [],
            hr: [],
            i: ['class', 'style'],
            img: ['src', 'alt', 'title', 'width', 'height', 'id', '_src', 'loadingclass', 'class', 'data-latex'],
            ins: ['datetime'],
            li: ['class', 'style'],
            mark: [],
            nav: [],
            ol: ['class', 'style'],
            p: ['class', 'style'],
            pre: ['class', 'style'],
            s: [],
            section: [],
            small: [],
            span: ['class', 'style'],
            sub: ['class', 'style'],
            sup: ['class', 'style'],
            strong: ['class', 'style'],
            table: ['width', 'border', 'align', 'valign', 'class', 'style'],
            tbody: ['align', 'valign', 'class', 'style'],
            td: ['width', 'rowspan', 'colspan', 'align', 'valign', 'class', 'style'],
            tfoot: ['align', 'valign', 'class', 'style'],
            th: ['width', 'rowspan', 'colspan', 'align', 'valign', 'class', 'style'],
            thead: ['align', 'valign', 'class', 'style'],
            tr: ['rowspan', 'align', 'valign', 'class', 'style'],
            tt: [],
            u: [],
            ul: ['class', 'style'],
            video: ['autoplay', 'controls', 'loop', 'preload', 'src', 'height', 'width', 'class', 'style']
        }
    };

    function getUEBasePath(docUrl, confUrl) {

        return getBasePath(docUrl || self.document.URL || self.location.href, confUrl || getConfigFilePath());
    }

    function getConfigFilePath() {

        var configPath = document.getElementsByTagName('script');

        return configPath[configPath.length - 1].src;
    }

    function getBasePath(docUrl, confUrl) {

        var basePath = confUrl;

        if (/^(\/|\\\\)/.test(confUrl)) {

            basePath = /^.+?\w(\/|\\\\)/.exec(docUrl)[0] + confUrl.replace(/^(\/|\\\\)/, '');
        } else if (!/^[a-z]+:/i.test(confUrl)) {

            docUrl = docUrl.split("#")[0].split("?")[0].replace(/[^\\\/]+$/, '');

            basePath = docUrl + "" + confUrl;
        }

        return optimizationPath(basePath);
    }

    function optimizationPath(path) {

        var protocol = /^[a-z]+:\/\//.exec(path)[0],
            tmp = null,
            res = [];

        path = path.replace(protocol, "").split("?")[0].split("#")[0];

        path = path.replace(/\\/g, '/').split(/\//);

        path[path.length - 1] = "";

        while (path.length) {

            if ((tmp = path.shift()) === "..") {
                res.pop();
            } else if (tmp !== ".") {
                res.push(tmp);
            }
        }

        return protocol + res.join("/");
    }

    window.UE = {
        getUEBasePath: getUEBasePath
    };
})();

/***/ }),

/***/ 999:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NHUpload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_spin_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_spin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_upload_style__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_upload__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_json_stringify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_NHCore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__ = __webpack_require__(7);





















var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(subClass, superClass) : subClass.__proto__ = superClass; }





var downloadPrefix = 'anonymity/docrepo/download/file';
// import {createUuid,NHFetch,getLoginUser} from 'xgui-for-react'

/**
 * 文件上传路径：
 * file模式：anonymity/docrepo/upload
 * redis模式：anonymity/zhxg-lxxt/proData/uploadRedis
 * 文件下载路径：
 * file模式：anonymity/docrepo/download/file?attachmentId={uuid}
 * redis模式：anonymity/zhxg-lxxt/proData/downloadRedis
 */

// function getBase64(file) {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.readAsDataURL(file);
//       reader.onload = () => resolve(reader.result);
//       reader.onerror = error => reject(error);
//     });
//   }
var NHUpload = (_temp = _class = function (_React$Component) {
    _inherits(NHUpload, _React$Component);

    function NHUpload(props) {
        _classCallCheck(this, NHUpload);

        // let fileList = props.value || props.defaultValue || props.fileList;
        var _this = _possibleConstructorReturn(this, (NHUpload.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(NHUpload)).call(this, props));

        _initialiseProps.call(_this);

        var value = props.value || props.defaultValue;
        _this.state = {
            fileList: [], //上传的文件
            value: value !== undefined && value !== null && value.trim() !== '' ? value : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHCore__["c" /* createUuid */])(), //传了附件主表id，查询附件明细
            // value:'',
            // previewVisible: false,
            // previewImage: '',
            fileName: '',
            spinLoading: false //加载中标识
        };
        return _this;
    }
    //设置可以传递参数的默认值


    _createClass(NHUpload, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (this.props.uploadType === 'file') {
                var _props = this.props,
                    serviceMark = _props.serviceMark,
                    moduleName = _props.moduleName;

                if (serviceMark && moduleName) {
                    if ('value' in nextProps) {
                        var value = nextProps.value;
                        if (__WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_json_stringify___default()(value) === '[]' || typeof value === "undefined" || typeof value === 'string' && value.trim() === '' || value === null) {} else {
                            if (value !== this.state.value) {
                                this.setState({ value: value });
                                this.setState({ fileList: [] });
                                var t = new Date().getTime();
                                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])('front/zhxg-unauth/dynamic/' + value + '/getDetailed', 'GET', t).then(function (res) {
                                    if (res && res.data && res.data.length > 0) {
                                        _this2.handleFileList(res.data);
                                    }
                                });
                            }
                        }
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("服务标志和模块名称不能为空");
                }
            }
        }

        //在组件挂载之前调用一次。如果在这个函数里面调用setState，本次的render函数可以看到更新后的state，并且只渲染一次。

    }, {
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            var _this3 = this;

            this.setState({ fileList: [] });
            if (this.props.uploadType === 'file') {
                var _props2 = this.props,
                    serviceMark = _props2.serviceMark,
                    moduleName = _props2.moduleName;

                if (serviceMark && moduleName) {
                    var value = this.state.value;
                    var t = new Date().getTime();
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])('front/zhxg-unauth/dynamic/' + value + '/getDetailed', 'GET', t).then(function (res) {
                        if (res && res.data && res.data.length > 0) {
                            _this3.handleFileList(res.data);
                        }
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("服务标志和模块名称不能为空");
                }
            }
        }

        //在组件挂载之后调用一次。

    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {}

        //处理fileList


        //判断文件是否满足要求文件格式的要求


        //判断文件是否是可执行文件


        //文件上传之前执行的方法


        //在上传之前转换文件


        //检查是否为图片类型


        //新增附件主表和明细

        //文件上传改变事件


        //发送请求的时候的数据

    }, {
        key: 'render',
        value: function render() {
            var action = this.props.uploadType === 'file' ? ' anonymity/docrepo/upload' : window.baseUrl + '/proData/uploadRedis?fileName=' + this.state.fileName;
            // const {fileList} = this.state;
            var _state = this.state,
                previewVisible = _state.previewVisible,
                previewImage = _state.previewImage,
                fileList = _state.fileList;

            var showUploadList = {
                showDownloadIcon: this.props.uploadType === 'file' ? true : false
            };
            var _props3 = this.props,
                _props3$templateList = _props3.templateList,
                templateList = _props3$templateList === undefined ? [] : _props3$templateList,
                _props3$accept = _props3.accept,
                accept = _props3$accept === undefined ? '*/*' : _props3$accept,
                image = _props3.image,
                _props3$fileCountLimi = _props3.fileCountLimit,
                fileCountLimit = _props3$fileCountLimi === undefined ? 1 : _props3$fileCountLimi;

            var uploadButton = image ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a, { type: 'plus' })
            ) : __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,
                { disabled: this.props.disabled },
                __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_icon___default.a, { type: 'upload' }),
                ' \u70B9\u51FB\u4E0A\u4F20'
            );
            if (fileList.length >= fileCountLimit) {
                uploadButton = null;
            }
            return __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                'div',
                null,
                this.props.isEdit === true ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_11_antd_lib_upload___default.a,
                        {
                            name: 'file',
                            accept: accept,
                            action: action,
                            beforeUpload: this.beforeUpload,
                            transformFile: this.transformFile,
                            listType: this.props.listType,
                            onChange: this.handleChange,
                            disabled: this.props.disabled,
                            data: this.requestData(),
                            fileList: fileList,
                            onPreview: this.handlePreview,
                            onDownload: this.handleDownload,
                            showUploadList: showUploadList
                        },
                        uploadButton
                    ),
                    templateList.map(function (item) {
                        return __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                            'a',
                            { key: item.uuid, href: downloadPrefix + '?attachmentId=' + item.uuid },
                            item.name
                        );
                    }),
                    this.state.spinLoading && __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_spin___default.a, null)
                ) : __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_upload___default.a, {
                    name: 'file',
                    accept: accept,
                    action: action,
                    beforeUpload: this.beforeUpload,
                    transformFile: this.transformFile,
                    listType: this.props.listType,
                    disabled: true,
                    data: this.requestData(),
                    fileList: fileList,
                    onPreview: this.handlePreview,
                    onDownload: this.handleDownload,
                    showUploadList: showUploadList
                }),
                __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a,
                    { visible: previewVisible, footer: null, onCancel: this.handleCancel },
                    __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('img', { alt: 'example', style: { width: '100%' }, src: previewImage })
                )
            );
        }
    }]);

    return NHUpload;
}(__WEBPACK_IMPORTED_MODULE_20_react___default.a.Component), _class.defaultProps = {
    multiple: false, //是否支持上传多个文件，默认false
    // fileList:[],//设置默认上传的内容，格式:[{uuid:'附件文档库的标志',name:'文件名称'}],只有uploadType为file(文档库)模式的时候才能使用此功能
    uploadType: 'file', //文件上传方式，file:文档库，redis:Redis缓存，如果是需要永久上传请使用文档库，如果只是暂存，建议使用redis缓存
    redisData: 30, //缓存时间,单位：分钟，设置缓存时间，意思是超过这个时间就会删除这个缓存信息
    fileCountLimit: undefined, //上传文件个数限制
    fileTypeLimit: undefined, //上传文件格式限制
    disabled: false, //是否禁用
    onChange: undefined, //值改变事件,参数：resultStr,resultList
    maxFileSize: 20, //默认上传最大大小限制20MB
    serviceMark: 'ly-zhxg-xtgl', //服务标志，说明是属于哪个服务
    moduleName: '系统管理', //模块名称，说明是属于哪个服务的哪个模块
    value: '', //附件主表id
    describe: '', //描述，对上传的附件的一个描述信息
    fileMainName: '', //附件主表名，存储该附件对应的主表的名称，主要是为了以后进行追溯
    isEdit: true, //是否可以编辑，默认为true，查看模式必须传value
    listType: 'picture', //上传列表的内建样式，支持两种基本样式 text, picture
    compressThreshold: 5, //压缩的阈值,图片大小超过5M,则需要进行压缩
    isPictureCompress: false, //是否开启图片压缩
    pictureQuality: 0.92, //指定压缩的图片质量,取值范围为0~1,quality值越小,图像越模糊,默认图片质量为0.92
    defaultEffective: false, //指定上传的附件是否默认在附件主表有效
    templateList: [], // 附件模板
    image: false
}, _initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.handleFileList = function (propsfileList) {
        var initFielList = propsfileList;
        if (typeof propsfileList === 'string') {
            initFielList = [];
            propsfileList.split(",").map(function (item) {
                initFielList.push({
                    uuid: item.split(";")[0],
                    name: item.split(";")[1]
                });
                return item;
            });
        }
        var fileList = _this4.state.fileList;
        var uuidList = [];
        if (fileList.length > 0) {
            fileList.map(function (item) {
                uuidList.push(item.uuid);
            });
        }
        var img = ['png', 'jpeg', 'jpg', 'gif', 'bmp'];
        initFielList.map(function (item, index) {
            if (uuidList.indexOf(item.uuid) === -1) {
                if (img.indexOf(item.name.split(".")[1]) === -1) {
                    fileList.push({
                        uuid: item.uuid,
                        uid: item.uuid,
                        name: item.name,
                        status: 'done',
                        reponse: 'Server Error 500' // custom error message to show
                        // url: 'anonymity/docrepo/download/file?attachmentId='+item.uuid,
                    });
                    return item;
                }
                fileList.push({
                    uuid: item.uuid,
                    uid: item.uuid,
                    name: item.name,
                    status: 'done',
                    reponse: 'Server Error 500', // custom error message to show
                    url: 'anonymity/docrepo/download/file?attachmentId=' + item.uuid
                });
                return item;
            }
        });
        _this4.setState({
            fileList: fileList
        });
    };

    this.checkTypeLimit = function (filename, fileTypeLimit) {
        for (var i = 0; i < fileTypeLimit.length; i++) {
            if (filename.toUpperCase().indexOf(fileTypeLimit[i].toUpperCase()) > -1) {
                return true;
            }
        }
        return false;
    };

    this.checkIsRun = function (filename, executable) {
        for (var i = 0; i < executable.length; i++) {
            if (filename.toUpperCase().indexOf(executable[i].toUpperCase()) > -1) {
                return true;
            }
        }
        return false;
    };

    this.beforeUpload = function (file, fileList) {
        var suffixMap = {
            'word': ['.doc', '.docx'],
            'exce': ['.xls', '.xlsx'],
            'img': ['.png', '.jpeg', '.jpg', '.gif', '.bmp']
        };
        var executable = ['.exe', '.sys', '.com', '.bat', '.jsp', '.asp', '.php', '.aspx', '.asa', '.asax', '.asmx', '.ashx', '.ascx', '.pif', '.acf', '.arj', '.swg', '.swf', '.svx', '.dos'];
        //文件格式的限制
        if (_this4.checkIsRun(file.name, executable)) {
            __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.info("不允许上传可执行的文件！");
            return false;
        } else {
            if (_this4.props.fileTypeLimit && _this4.props.fileTypeLimit.length > 0) {
                var fileTypeLimit = _this4.props.fileTypeLimit;
                for (var i = fileTypeLimit.length - 1; i >= 0; i--) {
                    var list = suffixMap[fileTypeLimit[i]];
                    if (list) {
                        fileTypeLimit.splice(i, 1);
                        for (var j = 0; j < list.length; j++) {
                            fileTypeLimit.push(list[j]);
                        }
                    }
                }
                if (!_this4.checkTypeLimit(file.name, fileTypeLimit)) {
                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.info("只能上传后缀为[" + fileTypeLimit.join(",") + "]格式的文件！");
                    return false;
                }
            }
        }
        if (_this4.props.image && !_this4.checkIsImage(file.name)) {
            __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.info("只能上传图片类型");
            return false;
        }
        //文件上传数量限制
        var fileCountLimit = _this4.props.multiple === false ? 1 : _this4.props.fileCountLimit;
        if (fileCountLimit && fileCountLimit <= _this4.state.fileList.length) {
            __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.info("最多只能上传" + fileCountLimit + "个文件！");
            return false;
        }

        //限制上传文件大小(默认上传大小限制20MB)
        var _props$maxFileSize = _this4.props.maxFileSize,
            maxFileSize = _props$maxFileSize === undefined ? 20 : _props$maxFileSize;

        var fileSize = file.size / 1024 / 1024;
        var isOverSize = fileSize > maxFileSize;

        if (isOverSize) {
            var msg = '抱歉，上传文件大小最大不能超过' + maxFileSize + 'M！';
            __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error(msg);
            return !isOverSize;
        }
        _this4.setState({ fileName: file.name });
        return true;
    };

    this.transformFile = function (file) {
        /**
         * 针对图片进行压缩,如果图片大小超过压缩阈值,则执行压缩,否则不压缩
         */
        //判断是否是图片类型
        if (_this4.checkIsImage(file.name)) {
            var _props4 = _this4.props,
                _props4$compressThres = _props4.compressThreshold,
                compressThreshold = _props4$compressThres === undefined ? 5 : _props4$compressThres,
                _props4$isPictureComp = _props4.isPictureCompress,
                isPictureCompress = _props4$isPictureComp === undefined ? false : _props4$isPictureComp,
                _props4$pictureQualit = _props4.pictureQuality,
                pictureQuality = _props4$pictureQualit === undefined ? 0.92 : _props4$pictureQualit;

            var fileSize = file.size / 1024 / 1024;
            // console.log('before compress, the file size is : ', fileSize + "M");
            //当开启图片压缩且图片大小大于等于压缩阈值,进行压缩
            if (fileSize >= compressThreshold && isPictureCompress) {
                //判断浏览器内核是否支持base64图片压缩
                if (typeof FileReader === 'undefined') {
                    return file;
                } else {
                    try {
                        _this4.setState({
                            spinLoading: true
                        });
                        return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
                            //声明FileReader文件读取对象
                            var reader = new FileReader();
                            reader.readAsDataURL(file);
                            reader.onload = function () {
                                // 生成canvas画布
                                var canvas = document.createElement('canvas');
                                // 生成img
                                var img = document.createElement('img');
                                img.src = reader.result;
                                img.onload = function () {
                                    var ctx = canvas.getContext('2d');
                                    //原始图片宽度、高度
                                    var originImageWidth = img.width,
                                        originImageHeight = img.height;
                                    //默认最大尺度的尺寸限制在（1920 * 1080）
                                    var maxWidth = 1920,
                                        maxHeight = 1080,
                                        ratio = maxWidth / maxHeight;
                                    //目标尺寸
                                    var targetWidth = originImageWidth,
                                        targetHeight = originImageHeight;
                                    //当图片的宽度或者高度大于指定的最大宽度或者最大高度时,进行缩放图片
                                    if (originImageWidth > maxWidth || originImageHeight > maxHeight) {
                                        //超过最大宽高比例
                                        if (originImageWidth / originImageHeight > ratio) {
                                            //宽度取最大宽度值maxWidth,缩放高度
                                            targetWidth = maxWidth;
                                            targetHeight = Math.round(maxWidth * (originImageHeight / originImageWidth));
                                        } else {
                                            //高度取最大高度值maxHeight,缩放宽度
                                            targetHeight = maxHeight;
                                            targetWidth = Math.round(maxHeight * (originImageWidth / originImageHeight));
                                        }
                                    }
                                    // canvas对图片进行缩放
                                    canvas.width = targetWidth;
                                    canvas.height = targetHeight;
                                    // 清除画布
                                    ctx.clearRect(0, 0, targetWidth, targetHeight);
                                    // 绘制图片
                                    ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
                                    // quality值越小,图像越模糊,默认图片质量为0.92
                                    var imageDataURL = canvas.toDataURL(file.type || 'image/jpeg', pictureQuality);
                                    // 去掉URL的头,并转换为byte
                                    var imageBytes = window.atob(imageDataURL.split(',')[1]);
                                    // 处理异常,将ascii码小于0的转换为大于0
                                    var arrayBuffer = new ArrayBuffer(imageBytes.length);
                                    var uint8Array = new Uint8Array(arrayBuffer);
                                    for (var i = 0; i < imageBytes.length; i++) {
                                        uint8Array[i] = imageBytes.charCodeAt(i);
                                    }
                                    var mimeType = imageDataURL.split(',')[0].match(/:(.*?);/)[1];
                                    var newFile = new File([uint8Array], file.name, { type: mimeType || 'image/jpeg' });
                                    // console.log('after compress, the file size is : ', (newFile.size / 1024 / 1024) + "M");
                                    resolve(newFile);
                                };
                            };
                            reader.onerror = function () {
                                _this4.setState({
                                    spinLoading: false
                                });
                                return file;
                            };
                        }).then(function (res) {
                            _this4.setState({
                                spinLoading: false
                            });
                            return res;
                        }).catch(function () {
                            _this4.setState({
                                spinLoading: false
                            });
                            return file;
                        });
                    } catch (e) {
                        _this4.setState({
                            spinLoading: false
                        });
                        //压缩出错,直接返回原file对象
                        return file;
                    }
                }
            } else {
                //不需要压缩，直接返回原file对象
                return file;
            }
        } else {
            //非图片文件,不进行压缩,直接返回原file对象
            return file;
        }
    };

    this.checkIsImage = function (fileName) {
        var flag = void 0;
        var imageTypeList = ['.jpg', '.png', '.jpeg', '.gif', '.GIF', '.JPG', '.PNG', '.JPEG'];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(imageTypeList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                flag = fileName.indexOf(item) !== -1;
                if (flag) {
                    return true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return flag;
    };

    this.handleMasterTable = function (e, fileList) {
        var value = _this4.state.value;
        var _props5 = _this4.props,
            serviceMark = _props5.serviceMark,
            moduleName = _props5.moduleName,
            describe = _props5.describe,
            fileMainName = _props5.fileMainName,
            defaultEffective = _props5.defaultEffective;

        var param = {
            fjzbid: value,
            fwbz: serviceMark,
            mkmc: moduleName,
            ms: describe,
            fjzbm: fileMainName,

            fjid: e.file.response.data.ssbh,
            fjmc: e.file.name,
            cjsid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHCore__["b" /* getLoginUser */])().userId
        };
        if (defaultEffective) {
            param.ztm = '1';
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])("front/zhxg-unauth/dynamic/insert", 'POST', param).then(function (res) {
            if (res && res.code === 200) {
                _this4.getResult(fileList);
            } else {
                fileList.map(function (item, key) {
                    if (e.file.uid = item.uid) {
                        fileList.splice(key, 1);
                    }
                });
                _this4.setState({ fileList: fileList });
                __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("附件上传失败！");
            }
        }).catch(function () {
            fileList.map(function (item, key) {
                if (e.file.uid = item.uid) {
                    fileList.splice(key, 1);
                }
            });
            _this4.setState({ fileList: fileList });
        });
    };

    this.handleChange = function (e) {
        var fileList = e.fileList;
        if (e.file.status === 'done') {
            //上传链接调用成功
            var response = e.file.response;
            if (_this4.props.uploadType === 'file') {
                //上传到文档库中
                if (response.meta && response.meta.statusCode === 200) {
                    //导出成功
                    fileList = fileList.map(function (file) {
                        if (file.uid === e.file.uid) {
                            file.uuid = response.data.ssbh;
                        }
                        return file;
                    });
                    _this4.handleMasterTable(e, fileList);
                } else {
                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("文件上传失败，请重新上传！");
                    fileList = _this4.filterCurrentFile(e.fileList, e.file);
                }
            } else {
                //上传到redis中缓存
                if (response.code === 200) {
                    fileList = fileList.map(function (file) {
                        if (file.uid === e.file.uid) {
                            file.uuid = e.file.response.data;
                        }
                        return file;
                    });
                    _this4.getResult(fileList);
                } else {
                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("文件上传失败，请重新上传！");
                    fileList = _this4.filterCurrentFile(e.fileList, e.file);
                }
            }
        } else if (e.file.status === 'uploading') {//上传中，此时不需要做处理

        } else if (e.file.status === 'error') {
            //上传错误
            __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("文件由于未知原因失败，请重新上传！");
            fileList = _this4.filterCurrentFile(e.fileList, e.file);
        } else if (e.file.status === 'removed') {
            //删除
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_NHFetch__["a" /* default */])("front/zhxg-unauth/dynamic/updateDel", 'POST', e.file.uid).then(function (res) {
                if (res && res.code === 200) {
                    _this4.getResult(fileList);
                } else {
                    __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error("附件上传失败！");
                    fileList = _this4.filterCurrentFile(e.fileList, e.file);
                }
            });
        }

        //beforeUpload返回false的时候，status状态值是undefined
        if (e.file.status) {
            if (e.file.response && e.file.response.meta && e.file.response.meta.statusCode === 200) {
                var img = ['png', 'jpeg', 'jpg', 'gif', 'bmp'];
                if (img.indexOf(e.file.name.split(".")[1]) === -1) {
                    fileList.push({
                        uuid: e.file.response.data.ssbh,
                        uid: e.file.response.data.ssbh,
                        name: e.file.name,
                        status: e.file.status,
                        reponse: 'Server Error 500' // custom error message to show
                        // url: 'anonymity/docrepo/download/file?attachmentId='+e.file.response.data.ssbh,
                    });
                } else {
                    fileList.push({
                        uuid: e.file.response.data.ssbh,
                        uid: e.file.response.data.ssbh,
                        name: e.file.name,
                        status: e.file.status,
                        reponse: 'Server Error 500', // custom error message to show
                        url: 'anonymity/docrepo/download/file?attachmentId=' + e.file.response.data.ssbh
                    });
                }
            }
            _this4.setState({ fileList: fileList });
        }
    };

    this.filterCurrentFile = function (list, currFile) {
        var fileList = [];
        list.map(function (file) {
            if (file.uid !== currFile.uid) {
                fileList.push(file);
            }
            return file;
        });
        return fileList;
    };

    this.requestData = function () {
        if (_this4.props.uploadType === 'file') {
            return { uuid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_NHCore__["c" /* createUuid */])(), type: '1' };
        } else {
            return { 'redisData': _this4.props.redisData };
        }
    };

    this.getResult = function (fileList) {
        if (_this4.props.uploadType === 'file') {
            var list = [];
            var listMap = [];
            fileList.map(function (item, index) {
                if (item.name) {
                    list.push(item.name);
                }
                if (item.size || item.size === 0) {
                    fileList.splice(index, 1);
                }
                if (item.uuid) {
                    var param = {};
                    param.uuid = item.uuid;
                    param.name = item.name;
                    listMap.push(param);
                }
            });
            _this4.setState({ fileList: fileList });
            var value = _this4.state.value;
            if (_this4.props.onChange) {
                if (fileList.length > 0) {
                    _this4.props.onChange(value, list, listMap);
                } else {
                    _this4.props.onChange(undefined);
                }
            }
        } else {
            var resultStr = '';
            var resultList = [];
            fileList.map(function (file) {
                resultList.push({
                    uuid: file.uuid,
                    name: file.name
                });
                resultStr += ',' + file.uuid + ';' + file.name;
                return file;
            });
            if (resultStr) {
                resultStr = resultStr.substring(1);
            }
            if (_this4.props.onChange) {
                _this4.props.onChange(resultStr, resultList);
            }
        }
    };

    this.handleDownload = function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(file) {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            window.open('anonymity/docrepo/download/file?attachmentId=' + file.uid);

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this4);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();

    this.handlePreview = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(file) {
            var name;
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (_this4.props.image) {
                                _context2.next = 2;
                                break;
                            }

                            return _context2.abrupt('return');

                        case 2:
                            if (!(!file.url && !file.preview)) {
                                _context2.next = 6;
                                break;
                            }

                            _context2.next = 5;
                            return getBase64(file.originFileObj);

                        case 5:
                            file.preview = _context2.sent;

                        case 6:
                            name = file.name.split(".")[1];

                            if (name === 'png' || name === 'jpeg' || name === 'jpg' || name === 'gif' || name === 'bmp') {
                                _this4.setState({
                                    previewImage: file.url || file.preview,
                                    previewVisible: true
                                });
                            } else {
                                _this4.setState({
                                    previewImage: file.url || file.preview,
                                    previewVisible: false
                                });
                            }

                        case 8:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this4);
        }));

        return function (_x2) {
            return _ref2.apply(this, arguments);
        };
    }();

    this.handleCancel = function () {
        return _this4.setState({ previewVisible: false });
    };
}, _temp);


/***/ })

},[2202]);


// WEBPACK FOOTER //
// assets/js/app.js